


  
  

  var faTurnUp = {
    prefix: 'fasds',
    iconName: 'turn-up',
    icon: [
      384,
      512,
      [10548,"level-up-alt"],
      'f3bf',
      
      ['M0 416l0 96 48 0 144 0 48 0 0-48 0-272-96 0 0 224-96 0L0 416z','M352 160L192 0 32 160l0 32 320 0 0-32z']
      
    ]
  };

  
    var faLevelUpAlt = faTurnUp;
  

  
  

  var faMessageText = {
    prefix: 'fasds',
    iconName: 'message-text',
    icon: [
      512,
      512,
      ["comment-alt-text"],
      'e1e6',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM144 112l0 48 24 0 64 0 0 136 0 24 48 0 0-24 0-136 64 0 24 0 0-48-24 0-88 0-88 0-24 0z','M144 112l24 0 88 0 88 0 24 0 0 48-24 0-64 0 0 136 0 24-48 0 0-24 0-136-64 0-24 0 0-48z']
      
    ]
  };

  
    var faCommentAltText = faMessageText;
  

  
  

  var faSquareZ = {
    prefix: 'fasds',
    iconName: 'square-z',
    icon: [
      448,
      512,
      [],
      'e288',
      
      ['M0 32L0 480l448 0 0-448L0 32zm112 96l24 0 176 0 24 0 0 32.8-5.7 6.7L187.7 336 312 336l24 0 0 48-24 0-176 0-24 0 0-32.8 5.7-6.7L260.3 176 136 176l-24 0 0-48z','M336 128l0 32.8-5.7 6.7L187.7 336 312 336l24 0 0 48-24 0-176 0-24 0 0-32.8 5.7-6.7L260.3 176 136 176l-24 0 0-48 24 0 176 0 24 0z']
      
    ]
  };

  

  
  

  var faPersonCircleCheck = {
    prefix: 'fasds',
    iconName: 'person-circle-check',
    icon: [
      576,
      512,
      [],
      'e53e',
      
      ['M.2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 2.3-1.4c8.4-21.4 20.8-40.7 36.3-57L238 142.8 228.6 128l-17.5 0-102.2 0-17.5 0-9.4 14.8L.2 270.8zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faHandHoldingMedical = {
    prefix: 'fasds',
    iconName: 'hand-holding-medical',
    icon: [
      576,
      512,
      [],
      'e05c',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M320 0L224 0l0 80-80 0 0 96 80 0 0 80 96 0 0-80 80 0 0-96-80 0 0-80z']
      
    ]
  };

  

  
  

  var faGraduationCap = {
    prefix: 'fasds',
    iconName: 'graduation-cap',
    icon: [
      640,
      512,
      [127891,"mortar-board"],
      'f19d',
      
      ['M0 464l80 16c27.8-64.8 15.4-108.2 0-133.2l0-106.9c16.5-6.2 33-12.4 49.5-18.6l196.1-73.5 15-5.6-11.2-30-15 5.6c-77.4 29-154.7 58-232 87c-8 3-16 6-24 9L48 217.7l0 11.1 0 138.3C32.5 417.5 0 464 0 464z','M640 176L320 288 129.5 221.3l196.1-73.5 15-5.6-11.2-30-15 5.6-232 87L0 176l0-32L320 32 640 144l0 32zM143.6 260.2l165.9 58.1 10.6 3.7 10.6-3.7 165.9-58.1L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.6-147.8z']
      
    ]
  };

  
    var faMortarBoard = faGraduationCap;
  

  
  

  var faMessageMiddle = {
    prefix: 'fasds',
    iconName: 'message-middle',
    icon: [
      512,
      512,
      ["comment-middle-alt"],
      'e1e1',
      
      ['M338.3 416L512 416 512 0 0 0 0 416l173.7 0L256 512l82.3-96z','']
      
    ]
  };

  
    var faCommentMiddleAlt = faMessageMiddle;
  

  
  

  var faVideo = {
    prefix: 'fasds',
    iconName: 'video',
    icon: [
      576,
      512,
      ["video-camera"],
      'f03d',
      
      ['M0 64l384 0 0 133L384 315l0 133L0 448 0 64z','M576 64V448L384 315V197L576 64z']
      
    ]
  };

  
    var faVideoCamera = faVideo;
  

  
  

  var faSquareSlidersVertical = {
    prefix: 'fasds',
    iconName: 'square-sliders-vertical',
    icon: [
      448,
      512,
      ["sliders-v-square"],
      'f3f2',
      
      ['M0 32l448 0 0 448L0 480 0 32zM64 160l0 64 32 0 16 0 0 160 0 32 64 0 0-32 0-160 16 0 32 0 0-64-32 0-16 0 0-32 0-32-64 0 0 32 0 32-16 0-32 0zM224 288l0 64 32 0 16 0 0 32 0 32 64 0 0-32 0-32 16 0 32 0 0-64-32 0-16 0 0-160 0-32-64 0 0 32 0 160-16 0-32 0z','M96 160l-32 0 0 64 32 0 96 0 32 0 0-64-32 0-96 0zM256 288l-32 0 0 64 32 0 96 0 32 0 0-64-32 0-96 0z']
      
    ]
  };

  
    var faSlidersVSquare = faSquareSlidersVertical;
  

  
  

  var faPlusMinus = {
    prefix: 'fasds',
    iconName: 'plus-minus',
    icon: [
      384,
      512,
      [],
      'e43c',
      
      ['M0 448l32 0 320 0 32 0 0 64-32 0L32 512 0 512l0-64z','M224 32l0-32L160 0l0 32 0 112L48 144l-32 0 0 64 32 0 112 0 0 112 0 32 64 0 0-32 0-112 112 0 32 0 0-64-32 0-112 0 0-112z']
      
    ]
  };

  

  
  

  var faBulldozer = {
    prefix: 'fasds',
    iconName: 'bulldozer',
    icon: [
      640,
      512,
      [],
      'e655',
      
      ['M0 400c0-30.5 12.2-58.2 32-78.4C52.3 300.9 80.7 288 112 288l256 0c44.7 0 83.2 26.2 101.2 64c6.9 14.5 10.8 30.8 10.8 48c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400zm64 0c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-256 0c-26.5 0-48 21.5-48 48z','M32 32l32 0 128 0 19.8 0 8.8 17.7L291.8 192l28.2 0 0-64 0-32 64 0 0 32 0 64 64 0 0 96 64 0 0-64 0-11.2 7-8.8 64-80 50 40-57 71.2 0 52.8 0 64 0 50.7 54.6 54.6-45.3 45.3-64-64-9.4-9.4 0-13.3 0-64-42.8 0c-18-37.8-56.5-64-101.2-64l-256 0c-31.3 0-59.7 12.9-80 33.6L32 256l0-64L32 64l0-32zM172.2 96L96 96l0 96 124.2 0-48-96zM96 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faBarcode = {
    prefix: 'fasds',
    iconName: 'barcode',
    icon: [
      512,
      512,
      [],
      'f02a',
      
      ['M0 32L0 480l64 0L64 32 0 32zm160 0l0 448 64 0 0-448-64 0zm288 0l0 448 64 0 0-448-64 0z','M96 32l32 0 0 448-32 0L96 32zm160 0l64 0 0 448-64 0 0-448zm160 0l0 448-32 0 0-448 32 0z']
      
    ]
  };

  

  
  

  var faFileMp4 = {
    prefix: 'fasds',
    iconName: 'file-mp4',
    icon: [
      512,
      512,
      [],
      'e649',
      
      ['M0 0L224 0l0 160 160 0 0 144L80 304l0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM256 368l0-16-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0 0 16 0 128 0 16 32 0 0-16 0-73 18 32.7 14.3 26 13.9-26.2L224 421.8l0 74.2 0 16 32 0 0-16 0-128zm48-16l-16 0 0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm80 16l16 0 48 0 0 48 0 16 32 0 0-16 0-64 0-64 0-16-32 0 0 16 0 48-32 0 0-48 0-16-32 0 0 16 0 64 0 16z']
      
    ]
  };

  

  
  

  var faShieldKeyhole = {
    prefix: 'fasds',
    iconName: 'shield-keyhole',
    icon: [
      512,
      512,
      [],
      'e248',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM200 208c0-30.9 25.1-56 56-56c15.5 0 29.5 6.3 39.6 16.4c5.1 5.1 9.2 11.1 12 17.8c1.4 3.3 2.5 6.9 3.3 10.5c.4 1.9 .7 3.8 .9 5.7c.1 .9 .2 1.9 .2 2.7c0 .9 .1 1.7 .1 2.9c0 .1 0 .3 0 .4c0 .5 0 1 0 1.6c0 0 0 .2 0 .4c0 .5-.1 1.1-.1 1.8c-.1 1.3-.3 2.7-.4 4.1c-.4 2.7-1 5.3-1.7 7.8c-1.5 5.1-3.7 9.9-6.6 14.2c-5.6 8.7-13.6 15.8-23.1 20.3c0 23.1 0 46.3 0 69.4c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-23.1 0-46.3 0-69.4c-18.9-9-32-28.3-32-50.6z','M280 258.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 69.4 0 24 48 0 0-24 0-69.4z']
      
    ]
  };

  

  
  

  var faReflectVertical = {
    prefix: 'fasds',
    iconName: 'reflect-vertical',
    icon: [
      512,
      512,
      [],
      'e665',
      
      ['M96 0l0 32L256 192 416 32l0-32L96 0zm0 480l0 32 320 0 0-32L256 320 96 480z','M0 232l24 0 464 0 24 0 0 48-24 0L24 280 0 280l0-48z']
      
    ]
  };

  

  
  

  var faSquareShareNodes = {
    prefix: 'fasds',
    iconName: 'square-share-nodes',
    icon: [
      448,
      512,
      ["share-alt-square"],
      'f1e1',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 256c0-35.3 28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64z','M320 224c35.3 0 64-28.7 64-64s-28.7-64-64-64s-64 28.7-64 64c0 2.5 .1 4.9 .4 7.3L174.5 212c-11.7-12.3-28.2-20-46.5-20c-35.3 0-64 28.7-64 64s28.7 64 64 64c18.3 0 34.8-7.7 46.5-20l81.9 44.7c-.3 2.4-.4 4.9-.4 7.3c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-15.4 0-29.5 5.4-40.6 14.5L194.1 256l85.3-46.5c11 9.1 25.2 14.5 40.6 14.5z']
      
    ]
  };

  
    var faShareAltSquare = faSquareShareNodes;
  

  
  

  var faComet = {
    prefix: 'fasds',
    iconName: 'comet',
    icon: [
      512,
      512,
      [],
      'e003',
      
      ['M0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L496 208l-59.9 4.6L512 0 299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309zm64-20.6l88.4-12.7 39.6-79 39.6 79L320 288.5 256 350l15.1 86.8-79.1-41-79.1 41L128 350 64 288.5z','M192 196.8l39.6 79L320 288.5 256 350l15.1 86.8-79.1-41-79.1 41L128 350 64 288.5l88.4-12.7 39.6-79z']
      
    ]
  };

  

  
  

  var faJetFighter = {
    prefix: 'fasds',
    iconName: 'jet-fighter',
    icon: [
      640,
      512,
      ["fighter-jet"],
      'f0fb',
      
      ['M192 48l0 144 192 0L272 48l-80 0zm0 272l0 144 80 0L384 320l-192 0z','M184 0L296 0l24 0 0 48-24 0L184 48l-24 0 0-48 24 0zm0 464l112 0 24 0 0 48-24 0-112 0-24 0 0-48 24 0zM32 224l0-96 64 0 64 64 32 0 320 0 128 48 0 32L512 320l-320 0-32 0L96 384l-64 0 0-96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm48 16l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z']
      
    ]
  };

  
    var faFighterJet = faJetFighter;
  

  
  

  var faPageCaretUp = {
    prefix: 'fasds',
    iconName: 'page-caret-up',
    icon: [
      384,
      512,
      ["file-caret-up"],
      'e42a',
      
      ['M0 0L0 512l384 0 0-400L272 0 0 0zM96 288l96-96 96 96 0 32L96 320l0-32z','M96 288v32H288V288l-96-96L96 288z']
      
    ]
  };

  
    var faFileCaretUp = faPageCaretUp;
  

  
  

  var faHandshakeSimple = {
    prefix: 'fasds',
    iconName: 'handshake-simple',
    icon: [
      640,
      512,
      [129309,"handshake-alt"],
      'f4c6',
      
      ['M189 180.8L244.8 259l39.1-27.9 57.2-40.8c4.4 4 8.8 8 13.1 12L496.4 332.6 517.6 352 640 352l0-224-64 0-65.5 0L426.6 72.1 414.5 64 400 64l-32 0-15.4 0-12.5 8.9c-7.6 5.4-15.2 10.8-22.7 16.2l-89.3 63.8L189 180.8z','M0 352l156.2 0 91.4 83.4 35.4 32.4 47.7-52.2 12.8 11.8 35.4 32.4 52.1-56.9 .5 .4 35.4 32.4 64.9-70.8L517.6 352l-21.1-19.4L354.2 202.3l-13.1-12-57.2 40.8L244.8 259 189 180.8l39.1-27.9 89.3-63.8L288 64l-64 0-96 64L0 128 0 352z']
      
    ]
  };

  
    var faHandshakeAlt = faHandshakeSimple;
  

  
  

  var faEyes = {
    prefix: 'fasds',
    iconName: 'eyes',
    icon: [
      640,
      512,
      [],
      'e367',
      
      ['M64 256c0 36.2 8.5 69 22.4 95.3c3.2 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c-.8 7.9-1.3 15.9-1.3 24.2zm288 0c0 36.2 8.5 69 22.4 95.3c3.2 .5 6.4 .7 9.6 .7c35.3 0 64-28.7 64-64s-28.7-64-64-64c-11.1 0-21.6 2.8-30.7 7.8c-.8 7.9-1.3 15.9-1.3 24.2z','M64 256c0-46.8 14.3-87.9 35.8-116.6C121.3 110.8 148.6 96 176 96s54.7 14.8 76.2 43.4C273.7 168.1 288 209.2 288 256s-14.3 87.9-35.8 116.6S203.4 416 176 416s-54.7-14.8-76.2-43.4S64 302.8 64 256zM320 126.7c-5-9.1-10.5-17.6-16.6-25.7C272.8 60.2 228.1 32 176 32s-96.8 28.2-127.4 69C18 141.8 0 196.7 0 256s18 114.2 48.6 155c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69c6-8 11.6-16.6 16.6-25.7c5 9.1 10.5 17.6 16.6 25.7c30.6 40.8 75.3 69 127.4 69s96.8-28.2 127.4-69C622 370.2 640 315.3 640 256s-18-114.2-48.6-155C560.8 60.2 516.1 32 464 32s-96.8 28.2-127.4 69c-6 8-11.6 16.6-16.6 25.7zM352 256c0-46.8 14.3-87.9 35.8-116.6C409.3 110.8 436.6 96 464 96s54.7 14.8 76.2 43.4C561.7 168.1 576 209.2 576 256s-14.3 87.9-35.8 116.6S491.4 416 464 416s-54.7-14.8-76.2-43.4S352 302.8 352 256z']
      
    ]
  };

  

  
  

  var faCircleJ = {
    prefix: 'fasds',
    iconName: 'circle-j',
    icon: [
      512,
      512,
      [],
      'e112',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 0l48 0 0 24 0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136 0-24 48 0 0 24 0 136c0 53-43 96-96 96s-96-43-96-96l0-8 0-24z','M336 128l0 24 0 136c0 53-43 96-96 96s-96-43-96-96l0-8 0-24 48 0 0 24 0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136 0-24 48 0z']
      
    ]
  };

  

  
  

  var faGalleryThumbnails = {
    prefix: 'fasds',
    iconName: 'gallery-thumbnails',
    icon: [
      576,
      512,
      [],
      'e3aa',
      
      ['M0 416l0 96 96 0 0-96L0 416zm160 0l0 96 96 0 0-96-96 0zm160 0l0 96 96 0 0-96-96 0zm160 0l0 96 96 0 0-96-96 0z','M512 64l0 224L64 288 64 64l448 0zM64 0L0 0 0 64 0 288l0 64 64 0 448 0 64 0 0-64 0-224 0-64L512 0 64 0z']
      
    ]
  };

  

  
  

  var faHandPointLeft = {
    prefix: 'fasds',
    iconName: 'hand-point-left',
    icon: [
      512,
      512,
      [],
      'f0a5',
      
      ['M0 96l0 64 240 0 0-64L0 96zM272 64l0 192 48 0 32 0 0-96 0-16 32 0 0 16 0 112 0 16-16 0-48 0 0 64 32 0 0 96c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-91 0z','M128 192l0 64 112 0 0-64-112 0zm32 96l0 64 128 0 0-64-128 0zm32 160l128 0 0-64-128 0 0 64z']
      
    ]
  };

  

  
  

  var faPineapple = {
    prefix: 'fasds',
    iconName: 'pineapple',
    icon: [
      512,
      512,
      [],
      'e31f',
      
      ['M0 256L0 384 128 512l128 0L448 320l0-128c-3-3-6.1-6.1-9.1-9.1c-36.6-36.6-73.1-73.1-109.7-109.7L320 64 192 64 0 256zm73.4 48c7.5-7.5 15.1-15.1 22.6-22.6l11.3 11.3c6.9 6.9 13.8 13.8 20.7 20.7c6.9-6.9 13.8-13.8 20.7-20.7c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-10.7 10.7-21.3 21.3-32 32c-3.8 3.8-7.5 7.5-11.3 11.3c-3.8-3.8-7.5-7.5-11.3-11.3c-10.7-10.7-21.3-21.3-32-32c-3.8-3.8-7.5-7.5-11.3-11.3zm80-80c7.5-7.5 15.1-15.1 22.6-22.6l11.3 11.3c6.9 6.9 13.8 13.8 20.7 20.7c6.9-6.9 13.8-13.8 20.7-20.7c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-10.7 10.7-21.3 21.3-32 32c-3.8 3.8-7.5 7.5-11.3 11.3c-3.8-3.8-7.5-7.5-11.3-11.3c-10.7-10.7-21.3-21.3-32-32c-3.8-3.8-7.5-7.5-11.3-11.3zm0 160c7.5-7.5 15.1-15.1 22.6-22.6l11.3 11.3c6.9 6.9 13.8 13.8 20.7 20.7c6.9-6.9 13.8-13.8 20.7-20.7c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-10.7 10.7-21.3 21.3-32 32c-3.8 3.8-7.5 7.5-11.3 11.3c-3.8-3.8-7.5-7.5-11.3-11.3c-10.7-10.7-21.3-21.3-32-32c-3.8-3.8-7.5-7.5-11.3-11.3zm80-80c7.5-7.5 15.1-15.1 22.6-22.6l11.3 11.3c6.9 6.9 13.8 13.8 20.7 20.7c6.9-6.9 13.8-13.8 20.7-20.7c3.8-3.8 7.5-7.5 11.3-11.3L342.6 304c-3.8 3.8-7.5 7.5-11.3 11.3c-10.7 10.7-21.3 21.3-32 32c-3.8 3.8-7.5 7.5-11.3 11.3c-3.8-3.8-7.5-7.5-11.3-11.3c-10.7-10.7-21.3-21.3-32-32c-3.8-3.8-7.5-7.5-11.3-11.3z','M472 136l40-40L482 86l14-70L426 30 416 0 376 40 352 16 329.1 73.1 438.9 182.9 496 160l-24-24zM187.3 212.7L176 201.4 153.4 224l11.3 11.3 32 32L208 278.6l11.3-11.3 32-32L262.6 224 240 201.4l-11.3 11.3L208 233.4l-20.7-20.7zm-80 80L96 281.4 73.4 304l11.3 11.3 32 32L128 358.6l11.3-11.3 32-32L182.6 304 160 281.4l-11.3 11.3L128 313.4l-20.7-20.7zm160 0L256 281.4 233.4 304l11.3 11.3 32 32L288 358.6l11.3-11.3 32-32L342.6 304 320 281.4l-11.3 11.3L288 313.4l-20.7-20.7zm-80 80L176 361.4 153.4 384l11.3 11.3 32 32L208 438.6l11.3-11.3 32-32L262.6 384 240 361.4l-11.3 11.3L208 393.4l-20.7-20.7z']
      
    ]
  };

  

  
  

  var faCloudQuestion = {
    prefix: 'fasds',
    iconName: 'cloud-question',
    icon: [
      640,
      512,
      [],
      'e492',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zM232 216c0-30.9 25.1-56 56-56l56.9 0c17.4 0 33.2 7.1 44.7 18.5c5.7 5.7 10.3 12.5 13.5 20.1c1.6 3.8 2.8 7.7 3.7 11.8c.4 2.1 .8 4.2 1 6.4c.1 1 .2 2.1 .2 3.1c0 1 .1 2 .1 3.2c0 1.4 0 2.8-.1 4.3c-.1 1.4-.2 2.7-.4 4.2c-.4 2.8-.9 5.5-1.6 8.1c-1.4 5.3-3.6 10.4-6.3 15.1c-5.5 9.5-13.4 17.5-23.2 23.1c-10.8 6.2-21.5 12.3-32.3 18.5c0 2.5 0 5 0 7.6c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-7.2 0-14.3 0-21.5c0-4.6 0-9.3 0-13.9l12.1-6.9 44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-1.9c.1-1 .1-1 .1-2l0-.3c0-.4 0-.8-.1-1.2c-.1-.5-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4L288 208c-4.4 0-8 3.6-8 8c0 2.2 0 4.4 0 6.5l-48 0c0-2.2 0-4.4 0-6.5zm64 152l48 0 0 48-48 0c0-16 0-32 0-48z','M288 160c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L296 268.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L288 160zm56 208l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faFaceWoozy = {
    prefix: 'fasds',
    iconName: 'face-woozy',
    icon: [
      512,
      512,
      [],
      'e3a2',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM89.8 356.4l17.8-26.6 13.3 8.9 11.5 7.7c18.5 12.3 41.8 14.7 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2c10.9 0 21.3-4.3 29-12l39.3-39.3L400 313.4 422.6 336l-11.3 11.3L372 386.6c-13.7 13.7-32.3 21.4-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1L267.4 388c-18.2-11.4-40.8-13.4-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7-13.3-8.9zm1.9-190.6c5.1-1.7 10.1-3.4 15.2-5.1c13.4-4.5 48.5-22.9 71.7-57.7c3-4.4 5.9-8.9 8.9-13.3l26.6 17.8c-3 4.4-5.9 8.9-8.9 13.3c-28 42-69.6 64.1-88.3 70.3c-5.1 1.7-10.1 3.4-15.2 5.1c-3.4-10.1-6.7-20.2-10.1-30.4zm32.8 62.5c5.2-1.3 10.3-2.6 15.5-3.9c21.3-5.3 42.7-10.7 64-16c5.2-1.3 10.3-2.6 15.5-3.9c2.6 10.3 5.2 20.7 7.8 31l-15.5 3.9c-21.3 5.3-42.7 10.7-64 16c-5.2 1.3-10.3 2.6-15.5 3.9c-2.6-10.3-5.2-20.7-7.8-31zm179.6-26.9c.1-2.1 .3-4.3 .5-6.3c.4-4.2 1.1-8.2 1.9-12c1.6-7.7 4-14.6 6.9-20.3c5.8-11.6 13.8-18.7 22.6-18.7c17.7 0 32 28.7 32 64s-14.3 64-32 64c-8.8 0-16.8-7.2-22.6-18.7c-2.9-5.8-5.2-12.7-6.9-20.3c-.8-3.8-1.4-7.8-1.9-12c-.2-2.1-.4-4.2-.5-6.4c-.1-1.1-.1-2.2-.1-3.2c0-1.1 0-2.2 0-3.3s0-2.2 0-3.3c0-1.1 .1-2.2 .1-3.2z','M205.3 120.9l8.9-13.3L187.6 89.8l-8.9 13.3c-23.2 34.8-58.4 53.2-71.7 57.7l-15.2 5.1 10.1 30.4 15.2-5.1c18.6-6.2 60.3-28.3 88.3-70.3zm22.1 114.8l-7.8-31-15.5 3.9-64 16-15.5 3.9 7.8 31 15.5-3.9 64-16 15.5-3.9zM336 272c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z']
      
    ]
  };

  

  
  

  var faKipSign = {
    prefix: 'fasds',
    iconName: 'kip-sign',
    icon: [
      384,
      512,
      [],
      'e1c4',
      
      ['M0 224l0 64 32 0 32 0 0-32 0-32-32 0L0 224zm147 32c13.2 10.7 26.5 21.3 39.7 32L352 288l32 0 0-64-32 0-165.3 0L147 256z','M64 256L64 64l0-32 64 0 0 32 0 125.1 195.9-158 40.2 49.8L147 256 364.1 431.1l-40.2 49.8L128 322.9 128 448l0 32-64 0 0-32 0-192z']
      
    ]
  };

  

  
  

  var faFileGif = {
    prefix: 'fasds',
    iconName: 'file-gif',
    icon: [
      512,
      512,
      [],
      'e645',
      
      ['M0 0L224 0l0 160 160 0 0 144-208 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM224 392l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24 0-16-16 0-16 0-16 0 0 32 16 0 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 32 0 0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm160-24l0-16-32 0 0 16 0 128 0 16 32 0 0-16 0-128zm48-16l-16 0 0 16 0 64 0 64 0 16 32 0 0-16 0-48 32 0 16 0 0-32-16 0-32 0 0-32 32 0 16 0 0-32-16 0-48 0z']
      
    ]
  };

  

  
  

  var faMasksTheater = {
    prefix: 'fasds',
    iconName: 'masks-theater',
    icon: [
      640,
      512,
      [127917,"theater-masks"],
      'f630',
      
      ['M0 97.1L27.7 286.7C64 426.6 240.9 448 240.9 448s18.4-9.6 42.7-26.8C258.9 389.4 240 349.3 240 301c0-2.3 0-4.6 .1-6.9l.3-2.3c-8.5-.5-17.1-.1-25.8 1.3c-30.5 4.7-56.8 19.9-75.9 41.6c-3.3-43.1 26.6-82.1 69.1-88.6c13.5-2.1 26.8-.6 38.9 3.7c7.1-48.4 14.2-96.9 21.3-145.3c0 0 .4-.5 1.2-1.5s2.1-2.3 3.9-4c3.5-3.4 9.1-7.9 17.3-12.5c16.3-9.4 42.9-19.3 84.2-21.8l-3.5-24.1s-27.8-40.5-126.1-40.5c-19.9 0-42.6 1.7-68.6 5.6C21.7 29.2 0 97.1 0 97.1zm97.8 61c11.4 6.2 24.8 8.8 38.5 6.7s25.8-8.6 34.9-18c1.8 3.7 3.1 7.7 3.7 12.1c3.2 21.8-11.5 42.1-32.9 45.4s-41.2-11.8-44.4-33.6c-.6-4.3-.6-8.6 .1-12.6z','M398.4 512s-163.6-73.4-158.2-217.9l27.8-189.6s40.3-58.5 195.3-34.9S640 161.1 640 161.1L612.2 350.7C593.7 477.1 398.4 512 398.4 512zm17.3-280c3.2-21.8-11.6-42.1-33-45.4s-41.4 11.8-44.6 33.6c-.6 4.3-.6 8.6 .1 12.6c11.4-6.2 24.8-8.8 38.6-6.7s25.9 8.6 35 18c1.8-3.7 3.1-7.7 3.7-12.1zm120.3 30.9c1.8-3.7 3.1-7.7 3.7-12.1c3.2-21.8-11.6-42.1-33-45.4s-41.4 11.8-44.6 33.6c-.6 4.3-.6 8.6 .1 12.6c11.4-6.2 24.8-8.8 38.6-6.7s25.9 8.6 35 18zM421.5 354c-41.1-6.3-76.6-26.8-102.5-56c-4.4 58 35.9 110.5 93.2 119.2s110.9-29.4 123.3-86.2c-33.1 20.2-72.9 29.3-114 23z']
      
    ]
  };

  
    var faTheaterMasks = faMasksTheater;
  

  
  

  var faStapler = {
    prefix: 'fasds',
    iconName: 'stapler',
    icon: [
      640,
      512,
      [],
      'e5af',
      
      ['M64 219.4L64 352l384 0 0-64c-128-22.9-256-45.7-384-68.6z','M640 304l0-64L256.6 48.3c-21.4-10.7-45-16.3-69-16.3C131.1 32 79.2 62.8 52.1 112.4L0 208l448 80 0 128L32 416l0 64 416 0 96 0 96 0 0-176z']
      
    ]
  };

  

  
  

  var faD = {
    prefix: 'fasds',
    iconName: 'd',
    icon: [
      384,
      512,
      [100],
      '44',
      
      ['M0 32l32 0 128 0c123.7 0 224 100.3 224 224s-100.3 224-224 224L32 480 0 480l0-32L0 64 0 32zM64 96l0 320 96 0c88.4 0 160-71.6 160-160s-71.6-160-160-160L64 96z','']
      
    ]
  };

  

  
  

  var faBedFront = {
    prefix: 'fasds',
    iconName: 'bed-front',
    icon: [
      512,
      512,
      ["bed-alt"],
      'f8f7',
      
      ['M0 224l32 0 48 0 160 0 32 0 160 0 48 0 32 0 0 32 0 64 0 32-32 0L32 352 0 352l0-32 0-64 0-32z','M480 32L32 32l0 192 48 0 0-96 160 0 0 96 32 0 0-96 160 0 0 96 48 0 0-192zM32 352L0 352l0 32 0 64 0 32 64 0 0-32 0-32 384 0 0 32 0 32 64 0 0-32 0-64 0-32-32 0L32 352z']
      
    ]
  };

  
    var faBedAlt = faBedFront;
  

  
  

  var faHorizontalRule = {
    prefix: 'fasds',
    iconName: 'horizontal-rule',
    icon: [
      640,
      512,
      [8213],
      'f86c',
      
      ['M0 224l32 0 576 0 32 0 0 64-32 0L32 288 0 288l0-64z','']
      
    ]
  };

  

  
  

  var faTrowel = {
    prefix: 'fasds',
    iconName: 'trowel',
    icon: [
      512,
      512,
      [],
      'e589',
      
      ['M0 512l280-72 40-40-81.4-81.4 112-112-45.3-45.3-112 112L112 192 72 232 0 512z','M376 232l-96-96L416 0l96 96L376 232z']
      
    ]
  };

  

  
  

  var faUmbrella = {
    prefix: 'fasds',
    iconName: 'umbrella',
    icon: [
      576,
      512,
      [],
      'f0e9',
      
      ['M149.1 433.7l14.3 28.6 2.3 4.7c13.8 27.6 42 45 72.8 45c45 0 81.4-36.5 81.4-81.4l0-151.9c-9.8-4.3-20.6-6.7-32-6.7c-1.4 0-2.8 0-4.2 .1s-2.8 .2-4.2 .3c-2.8 .3-5.5 .7-8.2 1.3c-5.4 1.1-10.5 2.8-15.4 4.9l0 151.9c0 9.6-7.8 17.4-17.4 17.4c-6.6 0-12.6-3.7-15.6-9.6l-2.3-4.7-14.3-28.6-57.2 28.6z','M320 32l0-32L256 0l0 32 0 17.7C124.2 63.4 18.3 161 2.1 285.9L-.2 304 18 304l6.5 0 7.2 0 4.8-5.3C51 282.3 72.3 272 96 272c44.2 0 80 35.8 80 80l16 0 16 0c0-44.2 35.8-80 80-80s80 35.8 80 80l16 0 16 0c0-44.2 35.8-80 80-80c23.7 0 45 10.3 59.6 26.7l4.8 5.3 7.2 0 6.5 0 18.2 0-2.3-18.1C557.7 161 451.8 63.4 320 49.7L320 32z']
      
    ]
  };

  

  
  

  var faCameraCctv = {
    prefix: 'fasds',
    iconName: 'camera-cctv',
    icon: [
      576,
      512,
      ["cctv"],
      'f8ac',
      
      ['M0 352l0 32 0 48 0 48 0 32 64 0 0-32 0-16 96 0 22.1 0 7.9-20.6 47.4-124.5-59.4-23.8L137.9 400 64 400l0-16 0-32L0 352zm352.7-22.5L520 400l56-136-81.8-31.8c-47.2 32.4-94.4 64.9-141.6 97.3z','M0 224L128 0 576 176 320 352 0 224z']
      
    ]
  };

  
    var faCctv = faCameraCctv;
  

  
  

  var faGrid2 = {
    prefix: 'fasds',
    iconName: 'grid-2',
    icon: [
      512,
      512,
      [],
      'e196',
      
      ['M32 288l0 192 192 0 0-192L32 288zM288 32l0 192 192 0 0-192L288 32z','M224 32L32 32l0 192 192 0 0-192zM480 288l-192 0 0 192 192 0 0-192z']
      
    ]
  };

  

  
  

  var faSack = {
    prefix: 'fasds',
    iconName: 'sack',
    icon: [
      512,
      512,
      [],
      'f81c',
      
      ['M0 416l0 96 512 0 0-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4l-128 0c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416zM128 0l64 96 128 0L384 0 128 0z','M176 96l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32z']
      
    ]
  };

  

  
  

  var faCircleT = {
    prefix: 'fasds',
    iconName: 'circle-t',
    icon: [
      512,
      512,
      [],
      'e124',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 144l24 0 104 0 104 0 24 0 0 48-24 0-80 0 0 168 0 24-48 0 0-24 0-168-80 0-24 0 0-48z','M128 144l24 0 104 0 104 0 24 0 0 48-24 0-80 0 0 168 0 24-48 0 0-24 0-168-80 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faBuildingColumns = {
    prefix: 'fasds',
    iconName: 'building-columns',
    icon: [
      512,
      512,
      ["bank","institution","museum","university"],
      'f19c',
      
      ['M0 464l0 48 512 0 0-48-64-48 0-224-64 0 0 224-40 0 0-224-64 0 0 224-48 0 0-224-64 0 0 224-40 0 0-224-64 0 0 224L0 464z','M0 144l0 48 512 0 0-48L256 0 0 144zM256 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  
    var faBank = faBuildingColumns;
  
    var faInstitution = faBuildingColumns;
  
    var faMuseum = faBuildingColumns;
  
    var faUniversity = faBuildingColumns;
  

  
  

  var faPersonMilitaryPointing = {
    prefix: 'fasds',
    iconName: 'person-military-pointing',
    icon: [
      576,
      512,
      [],
      'e54a',
      
      ['M224 393.4l0 54.6 192 0 0-32-169.4 0C307.3 355.3 368 294.6 428.7 233.9l-5.9-9.9L400 224l-6.6 0L224 393.4zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-11.4-2.4-22.2-6.7-32L246.7 80c-4.3 9.8-6.7 20.6-6.7 32z','M416 0l0 80L224 80l0-48L416 0zM393.4 224L224 393.4l0-89.4L72 304l-40 0 0-80 40 0 168 0 153.4 0zM224 448l192 0 0 64-192 0 0-64zm192-32l-169.4 0L428.7 233.9l5.7 9.7 104 176 20.4 34.4-68.9 40.7-20.3-34.4L416 369.7l0 46.3z']
      
    ]
  };

  

  
  

  var faUsersGear = {
    prefix: 'fasds',
    iconName: 'users-gear',
    icon: [
      640,
      512,
      ["users-cog"],
      'f509',
      
      ['M0 320l235.3 0c-26.6-23.5-43.3-57.8-43.3-96c0-11 1.4-21.8 4-32L48 192 0 320zM64 80a80 80 0 1 0 160 0A80 80 0 1 0 64 80zm64 432l273.1 0-11.7-20.3-32-55.4-16-27.7 27.7-16L384 384l-14.9-8.6-27.7-16 4.3-7.4L176 352 128 512zm96-288c0 53 43 96 96 96c19.9 0 38.3-6 53.7-16.4l15.8-27.3 16-27.7 6.3 3.7c2.7-8.9 4.2-18.4 4.2-28.2c0-53-43-96-96-96s-96 43-96 96zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80zm12 112c2.6 10.2 4 21 4 32l32 0 64 0 32 0 0 32 0 17.1c5-2.8 9.9-5.7 14.9-8.6l23.3-13.5L592 192l-148 0z','M480 256l64 0 0 37.5c11.2 4 21.5 10 30.4 17.6l32.5-18.7 32 55.4-32.5 18.7c1 5.7 1.6 11.6 1.6 17.6s-.6 11.9-1.6 17.5l32.5 18.7-32 55.4L574.4 457c-8.9 7.6-19.2 13.6-30.4 17.6l0 37.5-64 0 0-37.5c-11.2-4-21.5-10-30.4-17.6l-32.5 18.7-32-55.4 32.5-18.7c-1-5.7-1.6-11.6-1.6-17.5s.6-11.9 1.6-17.6l-32.5-18.7 32-55.4L449.6 311c8.9-7.6 19.1-13.6 30.4-17.6l0-37.5zm32 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z']
      
    ]
  };

  
    var faUsersCog = faUsersGear;
  

  
  

  var faMagnifyingGlassDollar = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-dollar',
    icon: [
      512,
      512,
      ["search-dollar"],
      'f688',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm134.7 72.7c4.2-12.6 8.4-25.3 12.6-38l19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-8.9-5.2-18.8-3.4-29c3.2-18.4 16.2-30.9 31.1-37.7c5-2.3 10.3-4 15.9-5.1l0-6 0-20.1c13.4 0 26.8 0 40.2 0l0 20.1 0 6.3c6.6 1.2 16.6 3.2 21 4.4l19.3 5.1c-3.4 12.9-6.9 25.8-10.3 38.7l-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6 4.1 15.3 7 30.3 11.6l.4 .1c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.5 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10 3.6-15.4 4.6l0 5.5 0 20.1-40.2 0 0-20.1 0-6.4c-9.5-2.2-21.9-6.4-29.8-9.1c-1.7-.6-3.2-1.1-4.4-1.5c-6.3-2.1-12.6-4.2-19-6.3z','M228.1 112l0-20.1-40.2 0 0 20.1 0 6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1l0 6.4 0 20.1 40.2 0 0-20.1 0-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.4-3.2-21-4.4l0-6.3zM441.4 486.6L464 509.3 509.3 464l-22.6-22.6L376 330.7C363.3 348 348 363.3 330.7 376L441.4 486.6z']
      
    ]
  };

  
    var faSearchDollar = faMagnifyingGlassDollar;
  

  
  

  var faX = {
    prefix: 'fasds',
    iconName: 'x',
    icon: [
      384,
      512,
      [120],
      '58',
      
      ['M306.2 32l77.5 0-1.4 2L230.7 256 382.3 478l1.4 2-77.5 0L192 312.8 77.8 480 .3 480l1.4-2L153.3 256 1.7 34 .3 32l77.5 0L192 199.2 306.2 32z','']
      
    ]
  };

  

  
  

  var faSkullCow = {
    prefix: 'fasds',
    iconName: 'skull-cow',
    icon: [
      640,
      512,
      [],
      'f8de',
      
      ['M0 95.5C0 61 19 26.2 40 0L64 16c-1 3.1-2.2 6.4-3.4 9.9C54.8 42.2 47.8 61.7 49.4 77.7C52.3 106.3 76.3 128 105 128c7.7 0 15.3 0 23 0l32 0 0 96c-10.7 0-21.3 0-32 0C57.2 224 0 166.1 0 95.5zM480 128c10.7 0 21.3 0 32 0l23 0c28.7 0 52.7-21.7 55.6-50.3c1.6-16-5.3-35.5-11.1-51.8c-1.2-3.4-2.4-6.7-3.4-9.9L600 0c21 26.2 40 61 40 95.5C640 166.1 582.8 224 512 224l-32 0 0-96z','M480 96L160 96l0 272 60 0 36 144 128 0 36-144 60 0 0-272zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faComputerSpeaker = {
    prefix: 'fasds',
    iconName: 'computer-speaker',
    icon: [
      640,
      512,
      [],
      'f8b2',
      
      ['M0 32L0 96 0 320l0 64 64 0 224 0 0-64L64 320 64 96l224 0 0-64L64 32 0 32zM96 416l0 64 32 0 160 0 0-64-160 0-32 0zM320 32l0 32 0 16 0 352 0 16 0 32 32 0 16 0 272 0 0-448L368 32l-16 0-32 0zM576 320a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zM512 128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M64 96l224 0 0 224L64 320 64 96zm384 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm80 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z']
      
    ]
  };

  

  
  

  var faFerrisWheel = {
    prefix: 'fasds',
    iconName: 'ferris-wheel',
    icon: [
      512,
      512,
      [],
      'e174',
      
      ['M128 480c5.3-10 10.7-20 16-30c10-18.8 20.1-37.7 30.1-56.5c17.6-33.1 35.3-66.1 52.9-99.2c-5.1-3.9-9.4-8.7-12.6-14.3c-4.1-7.1-6.4-15.3-6.4-24c0-23.2 16.5-42.5 38.3-47c3-.6 6.2-1 9.7-1c1.6 0 3.2 .1 4.7 .2c11.3 1.2 21.3 6.1 29 13.6c.2 .2 .3 .3 .5 .5c2.1 2.2 4.1 4.5 5.8 7s3.2 5.2 4.4 8.1c1.2 2.9 2.1 5.9 2.8 9c.3 1.6 .6 3.1 .7 4.8c.1 .8 .1 1.6 .2 2.4s.1 1.6 .1 2.5c0 8.7-2.3 16.9-6.4 24c-3.2 5.6-7.5 10.4-12.6 14.3c17.6 33.1 35.3 66.1 52.9 99.2L368 450c5.3 10 10.7 20 16 30l0 32-256 0 0-32z','M304 0L208 0l0 37.2c-24.2 5.3-46.9 14.5-67.4 26.8L64 64l0 48 0 28.6C51.6 161.1 42.4 183.8 37.2 208L0 208l0 48c0 22.7 15.7 41.7 36.9 46.7c5.2 24.7 14.5 47.8 27.1 68.7L64 400c0 26.5 21.5 48 48 48c7.5 0 14.6-1.7 20.9-4.8c3.6 2.4 7.3 4.7 11 6.8l30.1-56.5c-4.9-2.9-9.6-6.1-14.1-9.5l0-32-32 0c-15.5-20.7-26.2-45.3-30.2-72l116.6 0c-4.1-7.1-6.4-15.3-6.4-24c0-23.2 16.5-42.5 38.3-47c3-.6 6.2-1 9.4-1l.3 0c26.5 0 48 21.5 48 48c0 8.7-2.3 16.9-6.4 24l116.6 0c-4 26.7-14.7 51.3-30.2 72l-32 0 0 32c-4.5 3.4-9.2 6.6-14.1 9.5L368 450c3.8-2.2 7.4-4.4 11-6.8c6.3 3.1 13.4 4.8 20.9 4.8c26.5 0 48-21.5 48-48l0-28.6c12.6-20.9 21.9-44.1 27.1-68.7c21.1-5 36.9-24 36.9-46.7l0-48-37.2 0c-5.3-24.2-14.5-46.9-26.8-67.4L448 64l-76.6 0C350.9 51.6 328.2 42.4 304 37.2L304 0zM161.1 127.2c20.5-15.1 44.6-25.4 70.9-29.4l0 100.3-70.9-70.9zM280 97.8c26.3 4 50.4 14.3 70.9 29.4L280 198.1l0-100.3zm104.8 63.3c15.1 20.5 25.4 44.6 29.4 70.9l-100.3 0 70.9-70.9zM198.1 232L97.8 232c4-26.3 14.3-50.4 29.4-70.9L198.1 232z']
      
    ]
  };

  

  
  

  var faDollarSign = {
    prefix: 'fasds',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      ['M128 0l0 32 0 35.3c20.4-2.7 42.1-2.5 64 .3L192 32l0-32L128 0zm0 445.1l0 34.9 0 32 64 0 0-32 0-33.4c-10.2 1.2-20.7 1.6-31.4 1.3s-21.6-1.2-32.6-2.8z','M108.5 137.8c-19.4 7.7-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3c.9 .3 1.9 .5 2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-31.6 12.9-70.3 15.2-109.7 9.3l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3l-29.2-13 26-58.5 29.2 13c20.9 9.3 55.3 18.4 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3c-.9-.2-1.8-.5-2.8-.7C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c32.4-12.9 72.1-15.9 111.9-10c.4 .1 .7 .1 1.1 .2l48 8.8 31.5 5.8-11.5 63-31.5-5.8-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2z']
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faCircleWaveformLines = {
    prefix: 'fasds',
    iconName: 'circle-waveform-lines',
    icon: [
      512,
      512,
      ["waveform-circle"],
      'e12d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-96l32 0 0 16 0 160 0 16-32 0 0-16 0-160 0-16zm64 40l32 0 0 16 0 80 0 16-32 0 0-16 0-80 0-16zm64-72l32 0 0 16 0 224 0 16-32 0 0-16 0-224 0-16zm64 56l32 0 0 16 0 112 0 16-32 0 0-16 0-112 0-16zm64 40l32 0 0 16 0 32 0 16-32 0 0-16 0-32 0-16z','M288 128l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0zM160 160l0 16 0 160 0 16-32 0 0-16 0-160 0-16 32 0zm192 24l0 16 0 112 0 16-32 0 0-16 0-112 0-16 32 0zM224 200l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0zm192 24l0 16 0 32 0 16-32 0 0-16 0-32 0-16 32 0z']
      
    ]
  };

  
    var faWaveformCircle = faCircleWaveformLines;
  

  
  

  var faFaceNoseSteam = {
    prefix: 'fasds',
    iconName: 'face-nose-steam',
    icon: [
      576,
      512,
      [],
      'e382',
      
      ['M32 256c0 28.6 4.7 56.1 13.3 81.8c4.9-1.5 9.9-2.4 15-2.7c1.2-1.4 2.4-2.7 3.7-4c23.3-23.3 60.1-24.9 85.3-4.7l56.5-33.9L220 284l38.2 38.2-8.6 14.3L215.8 393c20.2 25.1 18.6 62-4.7 85.3c-1.3 1.3-2.6 2.5-4 3.7c-.3 5.4-1.3 10.8-3 16C230.4 507 258.6 512 288 512c28.7 0 56.3-4.7 82-13.4c-1.6-5.1-2.6-10.5-2.9-15.8c-1.4-1.2-2.7-2.4-4-3.7c-23.3-23.3-24.9-60.1-4.7-85.3l-33.9-56.5-8.2-13.7 38.4-38.4 13.7 8.2L425 327.3c25.1-20.2 62-18.6 85.3 4.7c1.3 1.3 2.5 2.6 3.7 4c5.5 .3 11 1.3 16.3 3.1c8.9-26.1 13.8-54 13.8-83.1C544 114.6 429.4 0 288 0S32 114.6 32 256zm96-32l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm11.8-85.9l10.1-30.4 15.2 5.1c41.3 13.8 74.2 39.9 86.3 51.9L262.6 176 240 198.6l-11.3-11.3c-9.3-9.3-38.2-32.3-73.7-44.1l-15.2-5.1zM313.4 176l11.3-11.3c12-12 45-38.1 86.3-51.9l15.2-5.1 5.1 15.2 5.1 15.2-15.2 5.1c-35.5 11.8-64.4 34.8-73.7 44.1L336 198.6c-3.8-3.8-7.5-7.5-11.3-11.3L313.4 176zm6.6 48l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm57.1 216.7c.6 2.9 1.7 5.7 3.1 8.4c.7 1.3 1.5 2.6 2.5 3.9c.5 .6 .9 1.2 1.5 1.8s1 1.2 1.6 1.7c-4.5-4.5-7.4-10-8.6-15.8zM433.8 370c1.3-5.6 4.2-10.9 8.5-15.3c-3.8 3.8-6.4 8.2-7.9 13c-.2 .8-.5 1.6-.6 2.4zm62.6 1.1c4.9-2.4 10.3-3.4 15.7-3.1c-1.7-.1-3.4-.1-5.1 .1c-1.8 .2-3.6 .5-5.4 1c-.9 .2-1.8 .5-2.6 .9s-1.7 .7-2.6 1.1z','M41.4 421.7c-12.5-12.5-12.5-32.8 0-45.3c9.9-9.9 24.6-11.9 36.5-6.2c1.2-6 4.1-11.7 8.8-16.4c12.5-12.5 32.8-12.5 45.3 0c4.4 4.4 7.2 9.7 8.5 15.3L222.2 320l-49.1 81.8c5.6 1.3 10.9 4.2 15.3 8.5c12.5 12.5 12.5 32.8 0 45.3c-4.7 4.7-10.4 7.6-16.4 8.8c5.7 11.9 3.6 26.6-6.2 36.5c-12.5 12.5-32.8 12.5-45.3 0c-2.1-2.1-3.8-4.3-5.2-6.7c-18.8 14.5-45.9 13.1-63.1-4.2s-18.6-44.3-4.2-63.1c-2.4-1.4-4.7-3.1-6.7-5.2zm491.5 .9c-2.1 2.1-4.3 3.8-6.7 5.2c14.5 18.8 13.1 45.9-4.2 63.1s-44.3 18.6-63.1 4.2c-1.4 2.4-3.1 4.7-5.2 6.7c-12.5 12.5-32.8 12.5-45.3 0c-9.9-9.9-11.9-24.6-6.2-36.5c-6-1.2-11.7-4.1-16.4-8.8c-12.5-12.5-12.5-32.8 0-45.3c4.4-4.4 9.7-7.2 15.3-8.5L352 320.9 433.8 370c1.3-5.6 4.2-10.9 8.5-15.3c12.5-12.5 32.8-12.5 45.3 0c4.7 4.7 7.6 10.4 8.8 16.4c11.9-5.7 26.6-3.6 36.5 6.2c12.5 12.5 12.5 32.8 0 45.3z']
      
    ]
  };

  

  
  

  var faTurkishLiraSign = {
    prefix: 'fasds',
    iconName: 'turkish-lira-sign',
    icon: [
      384,
      512,
      ["try","turkish-lira"],
      'e2bb',
      
      ['M.2 138.4l30.7-9.1L64 119.5l0 66.8-14.9 4.4-30.7 9.1L.2 138.4zm0 96l30.7-9.1L64 215.5l0 66.8-14.9 4.4-30.7 9.1L.2 234.4zM128 100.5L246.9 65.3l30.7-9.1 18.2 61.4-30.7 9.1L128 167.3c0-22.2 0-44.5 0-66.8zm0 96l118.9-35.2 30.7-9.1 18.2 61.4-30.7 9.1L128 263.3c0-22.2 0-44.5 0-66.8z','M128 32l0 32 0 352 64 0c70.7 0 128-57.3 128-128l0-32 64 0 0 32c0 106-86 192-192 192l-96 0-32 0 0-32L64 64l0-32 64 0z']
      
    ]
  };

  
    var faTry = faTurkishLiraSign;
  
    var faTurkishLira = faTurkishLiraSign;
  

  
  

  var faPrint = {
    prefix: 'fasds',
    iconName: 'print',
    icon: [
      512,
      512,
      [9113,128424,128438],
      'f02f',
      
      ['M64 0l0 192 384 0 0-128L384 0 64 0zM96 352l0 32 0 128 320 0 0-128 0-32L96 352z','M0 192l512 0 0 192-96 0 0-32L96 352l0 32L0 384 0 192zm408 56l0 48 48 0 0-48-48 0z']
      
    ]
  };

  

  
  

  var faCommentXmark = {
    prefix: 'fasds',
    iconName: 'comment-xmark',
    icon: [
      512,
      512,
      ["comment-times"],
      'f4b5',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm158.1-64L192 142.1l17 17 47 47 47-47 17-17L353.9 176l-17 17-47 47 47 47 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c-15.7 15.7-31.3 31.3-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9l17-17 47-47c-15.7-15.7-31.3-31.3-47-47c-5.7-5.7-11.3-11.3-17-17z','M337 193l17-17L320 142.1l-17 17-47 47-47-47-17-17L158.1 176l17 17 47 47-47 47-17 17L192 337.9l17-17 47-47 47 47 17 17L353.9 304l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faCommentTimes = faCommentXmark;
  

  
  

  var faFaceSmileRelaxed = {
    prefix: 'fasds',
    iconName: 'face-smile-relaxed',
    icon: [
      512,
      512,
      [],
      'e392',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm107.2-37.6c34.4-45.9 103.2-45.9 137.6 0c-8.6 6.4-17.1 12.8-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2zm22.5 108.8l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM267.2 218.4c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2z','M132.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zm160 0c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2z']
      
    ]
  };

  

  
  

  var faArrowsSpin = {
    prefix: 'fasds',
    iconName: 'arrows-spin',
    icon: [
      512,
      512,
      [],
      'e4bb',
      
      ['M32 256c0 10.9 .8 21.5 2.3 32l64.9 0c-2.1-10.3-3.2-21-3.2-32c0-40.1 14.8-76.8 39.1-104.9L176 192l16-16 0-128L64 48 48 64l41.8 41.8C53.9 145.5 32 198.2 32 256zm288 80l0 128 128 0 16-16-41.8-41.8C458.1 366.5 480 313.8 480 256c0-10.9-.8-21.5-2.3-32l-64.9 0c2.1 10.3 3.2 21 3.2 32c0 40.1-14.8 76.8-39.1 104.9L336 320l-16 16z','M256 96c-11 0-21.7 1.1-32 3.2l0-64.9c10.5-1.5 21.1-2.3 32-2.3c57.8 0 110.5 21.9 150.2 57.8L448 48l16 16 0 128-128 0-16-16 40.9-40.9C332.8 110.8 296.1 96 256 96zM105.8 422.2L64 464 48 448l0-128 128 0 16 16-40.9 40.9C179.2 401.2 215.9 416 256 416c11 0 21.7-1.1 32-3.2l0 64.9c-10.5 1.5-21.1 2.3-32 2.3c-57.8 0-110.5-21.9-150.2-57.8z']
      
    ]
  };

  

  
  

  var faExclamation = {
    prefix: 'fasds',
    iconName: 'exclamation',
    icon: [
      128,
      512,
      [10069,10071,61738],
      '21',
      
      ['M32 416l64 0 0 64-64 0 0-64z','M96 32l0 32 0 256 0 32-64 0 0-32L32 64l0-32 64 0z']
      
    ]
  };

  

  
  

  var faTentArrowsDown = {
    prefix: 'fasds',
    iconName: 'tent-arrows-down',
    icon: [
      576,
      512,
      [],
      'e581',
      
      ['M64 512l224 0 0-160 96 160 128 0L480 288 288 160 96 288 64 512z','M193 153l17-17L176 102.1l-17 17-23 23L136 24l0-24L88 0l0 24 0 118.1L65 119l-17-17L14.1 136l17 17 64 64 17 17 17-17 64-64zm352 0l17-17L528 102.1l-17 17-23 23L488 24l0-24L440 0l0 24 0 118.1-23-23-17-17L366.1 136l17 17 64 64 17 17 17-17 64-64z']
      
    ]
  };

  

  
  

  var faPlane = {
    prefix: 'fasds',
    iconName: 'plane',
    icon: [
      576,
      512,
      [],
      'f072',
      
      ['M160 0l54.9 192 150.9 0L256 0 160 0zm0 512l96 0L365.7 320l-150.9 0L160 512z','M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64L112 320 64 384 0 384 32 256 0 128l64 0 48 64 370.3 0z']
      
    ]
  };

  

  
  

  var faFaceSadTear = {
    prefix: 'fasds',
    iconName: 'face-sad-tear',
    icon: [
      512,
      512,
      [128546,"sad-tear"],
      'f5b4',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM112 368c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L160 288l-38.4 51.2c-6.2 8.3-9.6 18.4-9.6 28.8zm31.6-160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM240 320l0 32 16 0c34.9 0 67.2 15.8 92.3 42.9l10.9 11.8 23.5-21.7-10.9-11.7C341.6 340.5 301 320 256 320l-16 0zm63.6-112a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-246 131.2L160 288l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zm54-163.2a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  
    var faSadTear = faFaceSadTear;
  

  
  

  var faBlockBrickFire = {
    prefix: 'fasds',
    iconName: 'block-brick-fire',
    icon: [
      640,
      512,
      ["firewall"],
      'e3dc',
      
      ['M32 32l0 80 64 0 0-80L32 32zm0 112l0 96 208 0 0-96L32 144zm0 128l0 96 64 0 0-96-64 0zm0 128l0 80 208 0 0-80L32 400zM128 32l0 80 256 0 0-80L128 32zm0 240l0 96 160.7 0c-.4-5.3-.7-10.7-.7-16.2c0-28.7 7.1-55.5 18-79.8l-178 0zM272 144l0 96 51.2 0c6.2-9.8 12.9-19.1 19.7-27.7c23-28.8 49.5-52.3 71.4-68.3L272 144zm0 256l0 80 65 0c-20.2-22.5-35.1-49.8-42.9-80L272 400zM416 32l0 80 64 0 0-80-64 0zm61.4 112l2.6 2.6 0-2.6-2.6 0z','M320 352c0-89.6 85.3-165.3 128-192l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160zM480 464.2c35.3 0 64-28.7 64-64c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64z']
      
    ]
  };

  
    var faFirewall = faBlockBrickFire;
  

  
  

  var faUserInjured = {
    prefix: 'fasds',
    iconName: 'user-injured',
    icon: [
      448,
      512,
      [],
      'f728',
      
      ['M0 512l64 0 0-208L0 512zM96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11-1.4-21.8-4-32L222.6 96l-52.1 0L100 96c-2.6 10.2-4 21-4 32zm41.6 176l48 80L336 384l16 0 0 16 0 112 96 0L384 304l-246.4 0zm67.2 112c19.2 32 38.4 64 57.6 96l57.6 0 0-96-115.2 0z','M348 96c-6.7-25.9-21.3-48.7-41.1-65.5L222.6 96 348 96zM224 0C164.4 0 114.2 40.8 100 96l70.5 0L278.4 12.1C261.9 4.3 243.4 0 224 0zm38.4 512L137.6 304 64 304l0 208 198.4 0z']
      
    ]
  };

  

  
  

  var faTableCellsRowUnlock = {
    prefix: 'fasds',
    iconName: 'table-cells-row-unlock',
    icon: [
      640,
      512,
      [],
      'e691',
      
      ['M0 32L0 480l384 0 0-64-24 0 0-64 24 0 0-64-24 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 32 0 32zM64 224l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64zM208 224l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64z','M528 240c-17.7 0-32 14.3-32 32l0 48 32 0 32 0 48 0 32 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z']
      
    ]
  };

  

  
  

  var faBrainCircuit = {
    prefix: 'fasds',
    iconName: 'brain-circuit',
    icon: [
      512,
      512,
      [],
      'e0c6',
      
      ['M0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1l56 0 0-56 0-184-64 0 0 50.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7 0-16 16 0 80 0 0-80-34.7 0c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32l34.7 0 0-72 0-56L184 0c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304zM272 0l0 56 0 72 80 0 16 0 0 16 0 34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-18.7-64 0 0 192 34.7 0c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32L272 384l0 72 0 56 56 0c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0L272 0z','M240 456l0-184-64 0 0 50.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-66.7 0-16 16 0 80 0 0-80-34.7 0c-6.6 18.6-24.4 32-45.3 32c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.9 0 38.7 13.4 45.3 32l34.7 0 0-72 32 0 0 72 80 0 16 0 0 16 0 34.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-18.7-64 0 0 192 34.7 0c6.6-18.6 24.4-32 45.3-32c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.9 0-38.7-13.4-45.3-32L272 384l0 72-32 0zM160 128a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM144 368a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm192 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0-144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z']
      
    ]
  };

  

  
  

  var faSkiBootSki = {
    prefix: 'fasds',
    iconName: 'ski-boot-ski',
    icon: [
      640,
      512,
      [],
      'e3cd',
      
      ['M0 448l0 64 32 0 576 0 32 0 0-32 0-64 0-32-64 0 0 32 0 32L32 448 0 448zM116.7 240l112 0c14.4-69.3 28.9-138.7 43.3-208L160 32 116.7 240z','M80 416l36.7-176 112 0L272 32l73.3 0L352 0l64 0L389.3 128 336 128l-16 0 0 32 16 0 46.7 0-10 48L320 208l-16 0 0 32 16 0 46 0 114 48 0 128L80 416z']
      
    ]
  };

  

  
  

  var faKeyboardBrightnessLow = {
    prefix: 'fasds',
    iconName: 'keyboard-brightness-low',
    icon: [
      640,
      512,
      [],
      'e1c1',
      
      ['M64 352l0 64 64 0 0-64-64 0zm50.7-128L160 269.3 205.3 224 160 178.7 114.7 224zM288 128l0 64 64 0 0-64-64 0zm146.7 96L480 269.3 525.3 224 480 178.7 434.7 224zM512 352l0 64 64 0 0-64-64 0z','M192 352l32 0 192 0 32 0 0 64-32 0-192 0-32 0 0-64z']
      
    ]
  };

  

  
  

  var faBenchTree = {
    prefix: 'fasds',
    iconName: 'bench-tree',
    icon: [
      640,
      512,
      [],
      'e2e7',
      
      ['M384 176l0 80 96 0 0 224 0 32 64 0 0-32 0-224 96 0 0-80c0-26.7-13.1-50.3-33.2-64.9c.8-4.9 1.2-10 1.2-15.1c0-53-43-96-96-96s-96 43-96 96c0 5.1 .4 10.2 1.2 15.1C397.1 125.7 384 149.3 384 176z','M352 192l0 128L32 320l0-128 320 0zM0 352l32 0 64 0 192 0 64 0 32 0 0 64-32 0 0 64 0 32-64 0 0-32 0-64L96 416l0 64 0 32-64 0 0-32 0-64L0 416l0-64z']
      
    ]
  };

  

  
  

  var faCircle3 = {
    prefix: 'fasds',
    iconName: 'circle-3',
    icon: [
      512,
      512,
      [],
      'e0f0',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 128 0 24 0 0 34.6-7.8 7.1-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2l-25.2 0c-32.2 0-61.6-18.2-76-47c-1.4-2.8-2.8-5.5-4.2-8.3c14.3-7.2 28.6-14.3 42.9-21.5l4.2 8.3c6.3 12.5 19.1 20.4 33 20.4l25.2 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3-24.1 .1c0-11.6 0-23.1 0-34.7c2.6-2.4 5.2-4.8 7.8-7.1c16.8-15.4 33.7-30.9 50.5-46.3L184 176l-24 0c0-16 0-32 0-48z','M336 128l-24 0-128 0-24 0 0 48 24 0 66.3 0-50.5 46.3-7.8 7.1 0 34.7 24.1-.1 51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2l-25.2 0c-14 0-26.8-7.9-33-20.4l-4.2-8.3-42.9 21.5 4.2 8.3c14.4 28.8 43.8 47 76 47l25.2 0c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5 7.8-7.1 0-34.6z']
      
    ]
  };

  

  
  

  var faCardsBlank = {
    prefix: 'fasds',
    iconName: 'cards-blank',
    icon: [
      640,
      512,
      [],
      'e4df',
      
      ['M320 64l0 50.3 144.9 251C416.6 393.2 368.3 421.1 320 449l0 63 320 0 0-448L320 64z','M210.9 512l254-146.6L254 0 0 146.7 210.9 512z']
      
    ]
  };

  

  
  

  var faBone = {
    prefix: 'fasds',
    iconName: 'bone',
    icon: [
      576,
      512,
      [129460],
      'f5d7',
      
      ['M149.3 136C127.2 97.7 78.3 84.6 40 106.7S-11.4 177.7 10.7 216c8.9 15.4 22.1 26.7 37.3 33.3l0 13.3c-15.1 6.6-28.4 17.9-37.3 33.3c-22.1 38.3-9 87.2 29.3 109.3s87.2 9 109.3-29.3l23.1-40 231.2 0 23.1 40c22.1 38.3 71 51.4 109.3 29.3s51.4-71 29.3-109.3c-8.9-15.4-22.1-26.7-37.3-33.3l0-13.3c15.1-6.6 28.4-17.9 37.3-33.3c22.1-38.3 9-87.2-29.3-109.3s-87.2-9-109.3 29.3l-23.1 40-231.2 0-23.1-40z','']
      
    ]
  };

  

  
  

  var faFileCheck = {
    prefix: 'fasds',
    iconName: 'file-check',
    icon: [
      384,
      512,
      [],
      'f316',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM62.1 328c5.7 5.7 11.3 11.3 17 17c21.3 21.3 42.7 42.7 64 64c5.7 5.7 11.3 11.3 17 17c5.7-5.7 11.3-11.3 17-17c42.7-42.7 85.3-85.3 128-128c5.7-5.7 11.3-11.3 17-17L288 230.1c-5.7 5.7-11.3 11.3-17 17c-37 37-74 74-111 111l-47-47-17-17C84.7 305.4 73.4 316.7 62.1 328z','M384 160L224 0l0 160 160 0zM305 281l17-17L288 230.1l-17 17-111 111-47-47-17-17L62.1 328l17 17 64 64 17 17 17-17L305 281z']
      
    ]
  };

  

  
  

  var faArrowUpFromWaterPump = {
    prefix: 'fasds',
    iconName: 'arrow-up-from-water-pump',
    icon: [
      576,
      512,
      [],
      'e4b6',
      
      ['M0 256L0 415c13 0 27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5l1.1-.8L96 368l18.6 13.4 1.1 .8c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5l1.1-.8L288 368l19.7 14.2c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5L480 368l19.7 14.2c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3l0-159-96 0-64 0-128 0L288 0 64 0l0 256L0 256z','M470.6 25.4L448 2.7 425.4 25.4l-80 80L322.7 128 368 173.3l22.6-22.6L416 125.3 416 256l64 0 0-130.7 25.4 25.4L528 173.3 573.3 128l-22.6-22.6-80-80zM272.4 493.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z']
      
    ]
  };

  

  
  

  var faBoot = {
    prefix: 'fasds',
    iconName: 'boot',
    icon: [
      512,
      512,
      [129406],
      'f782',
      
      ['M0 96l320 0 0 64-48 0-16 0 0 32 16 0 48 0 0 32-48 0-16 0 0 32 16 0 48 0 192 48 0 144L0 448 0 96z','M352 0L0 0 0 96l352 0 0-96zM0 448l0 32 32 32 64 0 32-32 32 32 64 0 32-32 32 32 64 0 32-32 32 32 64 0 32-32 0-32L0 448z']
      
    ]
  };

  

  
  

  var faTruckContainer = {
    prefix: 'fasds',
    iconName: 'truck-container',
    icon: [
      640,
      512,
      [],
      'f4dc',
      
      ['M0 32L0 272l400 0 0-240L0 32zM32 416a64 64 0 1 0 128 0A64 64 0 1 0 32 416zM64 72l32 0 0 160-32 0L64 72zm80 0l32 0 0 160-32 0 0-160zm48 344a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM224 72l32 0 0 160-32 0 0-160zm80 0l32 0 0 160-32 0 0-160zM480 416a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M456 144l-24 0 0 24 0 88 0 32 0 16L0 304l0 80 5.5 0c13.2-37.3 48.7-64 90.5-64c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64l85.5 0 21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l5.5 0 0-96 0-32 0-8.6-5.4-6.6-72-88-7.2-8.8L544 144l-88 0zM585 256l-105 0 0-64 52.6 0L585 256z']
      
    ]
  };

  

  
  

  var faPenFancySlash = {
    prefix: 'fasds',
    iconName: 'pen-fancy-slash',
    icon: [
      640,
      512,
      [],
      'e210',
      
      ['M73.1 480.3L128 288l78.4-29.4 117.8 92.8L288 448 95.7 503l88-88c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3l-88 88zM290.6 202.9L480 0l96 96L383.9 275.3l-93.3-72.4z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faToggleLargeOff = {
    prefix: 'fasds',
    iconName: 'toggle-large-off',
    icon: [
      576,
      512,
      [],
      'e5b0',
      
      ['M0 64l0 64L0 384l0 64 64 0 448 0 64 0 0-64 0-256 0-64-64 0L64 64 0 64zm64 64l256 0 192 0 0 256-192 0L64 384l0-256z','M64 128h256v256H64V128z']
      
    ]
  };

  

  
  

  var faLightSwitchOff = {
    prefix: 'fasds',
    iconName: 'light-switch-off',
    icon: [
      384,
      512,
      [],
      'e018',
      
      ['M96 256l0 160 192 0 0-160L96 256z','M0 512l384 0L384 0 0 0 0 512zM96 96l192 0 0 320L96 416 96 96zm80 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0-416a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z']
      
    ]
  };

  

  
  

  var faCupcake = {
    prefix: 'fasds',
    iconName: 'cupcake',
    icon: [
      448,
      512,
      [129473],
      'e402',
      
      ['M0 229.2L0 320l64 0 59.9 0 32.2 0 135.8 0 32.2 0 59.9 0 64 0 0-90.8c0-41.3-26.4-78-65.6-91.1l-20.5-6.8c-3.2-1.1-6.5-1.9-9.9-2.4c0-.3 0-.6 0-.8C352 57.3 294.7 0 224 0l10.8 16.3c3.4 5 5.2 11 5.2 17c0 17-13.7 30.7-30.7 30.7L160 64c-35.3 0-64 28.7-64 64c0 .3 0 .6 0 .8c-3.3 .5-6.6 1.4-9.9 2.4l-20.5 6.8C26.4 151.2 0 187.9 0 229.2z','M180.1 512l87.8 0 24-192-135.8 0 24 192zM123.9 320L64 320 96 512l51.9 0-24-192zm200.2 0l-24 192 51.9 0 32-192-59.9 0z']
      
    ]
  };

  

  
  

  var faBugSlash = {
    prefix: 'fasds',
    iconName: 'bug-slash',
    icon: [
      640,
      512,
      [],
      'e490',
      
      ['M64 256l0 64 32 0 64 0c0 24.2 5.4 47.2 15 67.7l-53.6 53.6L98.7 464 144 509.3l22.6-22.6 47.1-47.1c24.5 21.8 55.8 36.2 90.3 39.6l0-143.7L160 222.1l0 33.9-64 0-32 0zM224 96l0 32 192 0 0-32c0-53-43-96-96-96s-96 43-96 96zm11.4 64L477.6 348c1.6-9.1 2.4-18.4 2.4-28l64 0 32 0 0-64-32 0-64 0 0-50.7 54.6-54.6L557.3 128 512 82.7l-22.6 22.6L434.7 160l-199.3 0zM336 360.7l0 118.5c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faFaceSadSweat = {
    prefix: 'fasds',
    iconName: 'face-sad-sweat',
    icon: [
      576,
      512,
      [],
      'e38a',
      
      ['M32 256l16-21.3 25.6 34.1L112 320c10.4 13.8 16 30.7 16 48c0 24.6-11.1 46.5-28.5 61.2C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256zm77.6-61.2l15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L216 137.4 238.6 160l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7c-.8 .1-1.7 .3-2.5 .4l-15.8 2.6-5.3-31.6zm130 77.2a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM193.4 401.2l10.7-11.9C220.2 371.4 248.3 352 288 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4zM399.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM337.4 160L360 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L337.4 160z','M238.6 160l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L216 137.4 238.6 160zm161 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM9.6 339.2L48 288l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zm198-99.2a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm141.1-68.7L337.4 160 360 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z']
      
    ]
  };

  

  
  

  var faLocationPinSlash = {
    prefix: 'fasds',
    iconName: 'location-pin-slash',
    icon: [
      640,
      512,
      ["map-marker-slash"],
      'f60c',
      
      ['M128.1 196.9C133.5 310 320 512 320 512s39.1-42.4 82.1-99.2L128.1 196.9zM154 95.4L341.5 242.4l116 90.1C488.3 282.6 512 231.4 512 192C512 86 426 0 320 0C249.2 0 187.3 38.4 154 95.4z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faMapMarkerSlash = faLocationPinSlash;
  

  
  

  var faWindWarning = {
    prefix: 'fasds',
    iconName: 'wind-warning',
    icon: [
      640,
      512,
      ["wind-circle-exclamation"],
      'f776',
      
      ['M0 256C0 379.7 100.3 480 224 480c95.5 0 177.1-59.8 209.3-144L384 336l-32 0 0-64 32 0 63.4 0c.4-5.3 .6-10.6 .6-16s-.2-10.7-.6-16c-1.6-22.4-6.5-43.9-14.1-64C401.1 91.8 319.5 32 224 32C100.3 32 0 132.3 0 256zM200 128l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M433.3 176c7.7 20.1 12.6 41.6 14.1 64l96.6 0c53 0 96-43 96-96s-43-96-96-96l-32 0-32 0 0 64 32 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-110.7 0zM472 464l32 0 32 0c53 0 96-43 96-96s-43-96-96-96l-152 0-32 0 0 64 32 0 152 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-32 0 0 64zM248 128l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM200 320l0 48 48 0 0-48-48 0z']
      
    ]
  };

  
    var faWindCircleExclamation = faWindWarning;
  

  
  

  var faPaperclipVertical = {
    prefix: 'fasds',
    iconName: 'paperclip-vertical',
    icon: [
      384,
      512,
      [],
      'e3c2',
      
      ['M32 128C32 57.3 89.3 0 160 0s128 57.3 128 128l0 192c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-160 0-32 64 0 0 32 0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 208c0 61.9 50.1 112 112 112s112-50.1 112-112l0-176 0-32 64 0 0 32 0 176c0 97.2-78.8 176-176 176s-176-78.8-176-176l0-208z','']
      
    ]
  };

  

  
  

  var faHundredPoints = {
    prefix: 'fasds',
    iconName: 'hundred-points',
    icon: [
      512,
      512,
      [128175,"100"],
      'e41c',
      
      ['M27.5 352.3l9.1 63.4 448-64-9.1-63.4-448 64zm224 64l9.1 63.4 224-32-9.1-63.4-224 32z','M163 101.8C168 61.9 201.9 32 242 32c47.9 0 85 42 79 89.5L309 218.2c-5 39.8-38.9 69.8-79 69.8c-47.9 0-85-42-79-89.5L163 101.8zM242 96c-7.9 0-14.5 5.9-15.5 13.7l-12.1 96.7c-1.2 9.3 6.1 17.6 15.5 17.6c7.9 0 14.5-5.9 15.5-13.7l12.1-96.7c1.2-9.3-6.1-17.6-15.5-17.6zm106.1 8.6C351.9 63.5 386.4 32 427.7 32c46.9 0 83.7 40.3 79.5 87l-7.3 80.4c-3.7 41.1-38.2 72.6-79.5 72.6c-46.9 0-83.7-40.3-79.5-87l7.3-80.4zM427.7 96c-8.2 0-15 6.2-15.7 14.4l-7.3 80.4c-.8 9.3 6.4 17.2 15.7 17.2c8.2 0 15-6.2 15.7-14.4l7.3-80.4c.8-9.3-6.4-17.2-15.7-17.2zM64.2 116.5l-3.7 1.6L31.2 131.2 6 72.8 35.4 59.7l56-24.9L135.7 68 101.2 309.5l-65.9 9.4 1-6.9L64.2 116.5z']
      
    ]
  };

  
    var fa100 = faHundredPoints;
  

  
  

  var faDown = {
    prefix: 'fasds',
    iconName: 'down',
    icon: [
      384,
      512,
      ["arrow-alt-down"],
      'f354',
      
      ['M128 32l0 224 128 0 0-224L128 32z','M0 256l0 32L192 480 384 288l0-32-128 0-128 0L0 256z']
      
    ]
  };

  
    var faArrowAltDown = faDown;
  

  
  

  var faNoteSticky = {
    prefix: 'fasds',
    iconName: 'note-sticky',
    icon: [
      448,
      512,
      [62026,"sticky-note"],
      'f249',
      
      ['M0 32L0 480l288 0 0-32 0-32 0-96 96 0 32 0 32 0 0-288L0 32z','M288 320l0 96 0 32 0 32 16 0 13.3 0 9.4-9.4 112-112 9.4-9.4 0-13.3 0-16-32 0-32 0-96 0z']
      
    ]
  };

  
    var faStickyNote = faNoteSticky;
  

  
  

  var faDiceD12 = {
    prefix: 'fasds',
    iconName: 'dice-d12',
    icon: [
      512,
      512,
      [],
      'f6ce',
      
      ['M6.6 176L64.1 76.4 240 139.3l0 106.8L131.2 300.5 6.6 176zM94.8 53.4L187.4 0 324.6 0l92.6 53.4L256 111 94.8 53.4zM272 139.3L447.9 76.4 505.4 176 380.8 300.5 272 246.1l0-106.8z','M398.1 328.5L512 214.6l0 110L443.4 443.4l-99.1 57.2 53.8-172.1zm-33.4-.3L307.2 512l-102.5 0L147.3 328.2 256 273.9l108.7 54.3zm-250.8 .3l53.8 172.1L68.6 443.4 0 324.6l0-110L113.9 328.5z']
      
    ]
  };

  

  
  

  var faGramophone = {
    prefix: 'fasds',
    iconName: 'gramophone',
    icon: [
      384,
      512,
      [],
      'f8bd',
      
      ['M29.2 303.4L72 314.1c57-40.3 108.6-59 151.1-66.6c21.2-3.8 40.1-4.8 56.2-4.4l1.3 0c11.9 .4 22.3 1.6 30.9 3c4.7 .8 9.3 3.7 12.4 8.6c2.6 4.9 4 10.3 4.1 15.6c-.2 18.7-15.3 33.7-34 33.7l-110 0-24 0 0 24 0 32 0 24 48 0 0-24 0-8 86.6 0c45 0 81.4-36.5 81.4-81.4l0-.6 0-24-3.7 0c-1.2-3.8-2.7-7.4-4.5-11c-8.5-17.5-22.9-31.7-40.1-40.4C257.9 159.3 213.4 114 186.4 77.8c-13.5-18.1-22.6-34-28.2-45.1c-2.8-5.6-4.8-9.9-6-12.8c-.6-1.4-1-2.5-1.3-3.2l-.3-.7c-.4-1.1-.8-2.2-1.2-3.3L108.8 2.6l-4 15.3-72 272-3.6 13.5z','M352 384L32 384l0 64L0 448l0 64 32 0 320 0 32 0 0-64-32 0 0-64z']
      
    ]
  };

  

  
  

  var faJar = {
    prefix: 'fasds',
    iconName: 'jar',
    icon: [
      320,
      512,
      [],
      'e516',
      
      ['M0 64l32 0 256 0 32 0 0 448L0 512 0 64zM64 192l0 192 192 0 0-192L64 192z','M288 0L32 0l0 64 256 0 0-64zM256 192L64 192l0 192 192 0 0-192z']
      
    ]
  };

  

  
  

  var faMagnet = {
    prefix: 'fasds',
    iconName: 'magnet',
    icon: [
      448,
      512,
      [129522],
      'f076',
      
      ['M0 32L0 160l128 0 0-128L0 32zm320 0l0 128 128 0 0-128L320 32z','M0 160l0 96C0 379.7 100.3 480 224 480s224-100.3 224-224l0-96-128 0 0 96c0 53-43 96-96 96s-96-43-96-96l0-96L0 160z']
      
    ]
  };

  

  
  

  var faCircle2 = {
    prefix: 'fasds',
    iconName: 'circle-2',
    icon: [
      512,
      512,
      [],
      'e0ef',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm158.4-98.6c6.4-4.8 12.7-9.7 19.1-14.5l16.2-12.3c15.8-12 35.2-18.4 55.1-18.1c1.1 0 2.3 0 3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1c-21.5 20.1-42.9 40.3-64.4 60.4c27.8 0 55.5 0 83.3 0c8 0 16 0 24 0l0 48c-8 0-16 0-24 0c-48 0-96 0-144 0c-8 0-16 0-24 0c0-11.5 0-22.9 0-34.4c2.5-2.4 5.1-4.7 7.6-7.1c36.2-34 72.4-67.9 108.7-101.9c3.7-3.5 6.7-7.7 8.7-12.3c1-2.3 1.8-4.7 2.3-7.2c.3-1.2 .5-2.5 .6-3.8c.1-.6 .1-1.3 .1-1.9s0-1.2 0-1.9c0-1.3 0-1.6 0-1.9c0-.6-.1-1.2-.1-1.8c-.1-1.2-.3-2.4-.6-3.6c-.5-2.4-1.2-4.7-2.1-6.9c-1.8-4.4-4.5-8.4-7.8-11.7c-6.6-6.7-15.7-10.9-25.9-11.1c-1.2 0-2.3 0-3.5-.1c-9.1-.1-18 2.8-25.3 8.3c-5.4 4.1-10.8 8.2-16.2 12.3c-6.4 4.9-12.7 9.7-19.1 14.5l-29.1-38.2z','M248.7 112.3c-19.9-.3-39.3 6.1-55.1 18.1l-16.2 12.3-19.1 14.5 29.1 38.2L206.5 181l16.2-12.3c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L167.6 326.5l-7.6 7.1 0 34.4 24 0 144 0 24 0 0-48-24 0-83.3 0 64.4-60.4C326.3 243.5 336 221 336 197.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1z']
      
    ]
  };

  

  
  

  var fa1 = {
    prefix: 'fasds',
    iconName: '1',
    icon: [
      256,
      512,
      [],
      '31',
      
      ['M104 32l8 0 16 0 32 0 0 32 0 352 64 0 32 0 0 64-32 0-96 0-96 0L0 480l0-64 32 0 64 0 0-307.2L7.1 156.2 0 160 0 87.5 96.9 35.8 104 32z','']
      
    ]
  };

  

  
  

  var faFalafel = {
    prefix: 'fasds',
    iconName: 'falafel',
    icon: [
      576,
      512,
      [129478],
      'e40a',
      
      ['M416 263.3c0 23.9 14.5 54.5 40.3 80.4c38.4 38.4 87.2 51.7 109.1 29.8c3.3-3.3 5.8-7.2 7.5-11.6c9.8-24.8-4.7-65-37.3-97.5c-22.5-22.5-48.6-36.4-70.8-39.6c-.8-.1-1.6-.2-2.4-.3c-2.4-.3-4.8-.4-7.1-.4c-9.9 0-18.6 2.5-25.4 7.6c-1.2 .9-2.3 1.9-3.4 3c-.4 .4-.9 .9-1.3 1.4s-.8 .9-1.2 1.4c-.8 1-1.5 2-2.2 3.1c-1.3 2.1-2.4 4.4-3.3 6.8c-1.7 4.8-2.6 10.3-2.6 16z','M174.8 113.8l-.6-33.8 26.2-20.6 13.8-30.8 32.3-7L272 0l32 8.1L336 0l25.4 21.6 32.3 7 13.8 30.8 26.2 20.6-.6 33.8L448 144l-14.8 30.2 .4 24.5-1.6 .4-40.2-10.2-31.9 27-40.3 8.7L302.4 263 288 274.4 273.6 263 263 239.4l-6.6-14.8-15.8-3.4L216.1 216l-19.3-16.4-9.8-8.3-12.1-17.1L160 144l14.8-30.2zm64.5 151.1l8.2 18.4 22.6 17.9 .1 3.3 .4 26.1-11.4 23.3L252.4 368l6.9 14.1 11.4 23.3-.4 26.1-.1 3.3-22.6 17.9-13.8 30.8-32.3 7L176 512l-32-8.1L112 512 86.5 490.4l-32.3-7L40.4 452.7 14.3 432.1l.6-33.8L0 368l14.8-30.2-.6-33.8 26.2-20.6 13.8-30.8 32.3-7L112 224l32 8.1 32-8.1 25.4 21.6 7.2 1.5 25.1 5.4 5.5 12.4zM240 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM456.3 343.7c38.4 38.4 87.2 51.7 109.1 29.8c3.3-3.3 5.8-7.2 7.5-11.6l3 6.1-14.8 30.2 .6 33.8-26.2 20.6-13.8 30.8-32.3 7L464 512l-32-8.1L400 512l-25.4-21.6-32.3-7-13.8-30.8-26.2-20.6 .6-33.8L288 368l14.8-30.2-.6-33.8 26.2-20.6 13.8-30.8 32.3-7L400 224l30 7.6c-1.2 .9-2.3 1.9-3.4 3c-21.9 21.9-8.6 70.8 29.8 109.1zm6.1-119.3l1.6-.4 .8 .7c-.8-.1-1.6-.2-2.4-.3zM384 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM80 384a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faPenSwirl = {
    prefix: 'fasds',
    iconName: 'pen-swirl',
    icon: [
      512,
      512,
      [],
      'e214',
      
      ['M0 256C0 397.4 114.6 512 256 512l32 0 0-64-32 0C150 448 64 362 64 256S150 64 256 64c14.1 0 27.8 1.5 41 4.4L347.8 17C319.3 6 288.4 0 256 0C114.6 0 0 114.6 0 256zm320 96l0 64 32 0c88.4 0 160-71.6 160-160c0-32.2-5.9-63-16.8-91.3l-51.4 51.4c2.7 12.9 4.2 26.2 4.2 39.9c0 53-43 96-96 96l-32 0z','M160 352l16-112L340.7 75.3l96 96L272 336 160 352zM459.3 148.7l-96-96L416 0l96 96-52.7 52.7z']
      
    ]
  };

  

  
  

  var faCommentExclamation = {
    prefix: 'fasds',
    iconName: 'comment-exclamation',
    icon: [
      512,
      512,
      [],
      'f4af',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zM232 112l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M280 136l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faGripDots = {
    prefix: 'fasds',
    iconName: 'grip-dots',
    icon: [
      448,
      512,
      [],
      'e410',
      
      ['M112 336a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M384 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM112 176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z']
      
    ]
  };

  

  
  

  var faSquareFull = {
    prefix: 'fasds',
    iconName: 'square-full',
    icon: [
      512,
      512,
      [11035,11036,128997,128998,128999,129000,129001,129002,129003],
      'f45c',
      
      ['M0 0H512V512H0V0z','']
      
    ]
  };

  

  
  

  var faStopwatch20 = {
    prefix: 'fasds',
    iconName: 'stopwatch-20',
    icon: [
      448,
      512,
      [],
      'e06f',
      
      ['M16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1L445.3 144 400 98.7l-22.6 22.6L355.7 143c-28.1-23-62.2-38.8-99.7-44.6L256 64l48 0 0-64L144 0l0 64 48 0 0 34.4C92.3 113.8 16 200 16 304zm86.1-56.9l6.4-12.9c9.3-18.5 28.2-30.2 48.8-30.2c30.3 0 54.6 24.7 54.6 54.7c0 13.4-4.9 26.4-13.8 36.4c-13 14.6-26 29.3-39 43.9c-6.2 7-10 15.7-10.9 24.9l43.8 0 20 0 0 40-20 0-64 0-20 0 0-20 0-15.7c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.9c0-8.2-6.6-14.7-14.6-14.7c-5.5 0-10.6 3.1-13.1 8.1c-2.1 4.3-4.3 8.6-6.4 12.9l-35.8-17.9zM236 256c0-28.7 23.3-52 52-52s52 23.3 52 52l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96zm40 0l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12z','M144.3 252.1c2.5-4.9 7.5-8.1 13.1-8.1c8 0 14.6 6.6 14.6 14.7c0 3.6-1.3 7.2-3.7 9.9l-39 43.9c-13.7 15.4-21.2 35.2-21.2 55.8l0 15.7 0 20 20 0 64 0 20 0 0-40-20 0-43.8 0c.9-9.2 4.7-17.9 10.9-24.9l39-43.9c8.9-10 13.8-23.1 13.8-36.4c0-30.1-24.4-54.7-54.6-54.7c-20.7 0-39.6 11.7-48.8 30.2l-6.4 12.9 35.8 17.9 6.4-12.9zM288 204c-28.7 0-52 23.3-52 52l0 96c0 28.7 23.3 52 52 52s52-23.3 52-52l0-96c0-28.7-23.3-52-52-52zm-12 52c0-6.6 5.4-12 12-12s12 5.4 12 12l0 96c0 6.6-5.4 12-12 12s-12-5.4-12-12l0-96z']
      
    ]
  };

  

  
  

  var faShieldExclamation = {
    prefix: 'fasds',
    iconName: 'shield-exclamation',
    icon: [
      512,
      512,
      [],
      'e247',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM232 128c16 0 32 0 48 0c0 8 0 16 0 24c0 37.3 0 74.7 0 112c0 8 0 16 0 24c-16 0-32 0-48 0c0-8 0-16 0-24c0-37.3 0-74.7 0-112c0-8 0-16 0-24zm0 192l48 0c0 16 0 32 0 48l-48 0c0-16 0-32 0-48z','M280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faCloudSun = {
    prefix: 'fasds',
    iconName: 'cloud-sun',
    icon: [
      640,
      512,
      [9925],
      'f6c4',
      
      ['M0 121.3L60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96s96 43 96 96c0 .4 0 .7 0 1.1c18.4-10.7 39.8-16.8 62.5-17.1L416 121.3 312 104 294.7 0 208 60.7 121.3 0 104 104 0 121.3zM144 208a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M559.9 511.9l80 0 0-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 242.6 402.8 224 368 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6l0 96 96 0 271.9 0z']
      
    ]
  };

  

  
  

  var faSyringe = {
    prefix: 'fasds',
    iconName: 'syringe',
    icon: [
      512,
      512,
      [128137],
      'f48e',
      
      ['M1.3 476.8l33.9 33.9 17-17L97.9 448 200 448l9.9 0 7-7 223-223c-.3-.3-.6-.6-1-1c-5.3-5.3-10.7-10.7-16-16c-18.7-18.7-37.3-37.3-56-56s-37.3-37.3-56-56c-5.3-5.3-10.7-10.7-16-16c-.3-.3-.6-.7-.9-1l-83.7 83.7 57 57c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3c-19-19-38-38-57-57c-13.8 13.8-27.6 27.6-41.4 41.4l57 57c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3c-19-19-38-38-57-57C106.1 259.9 88.6 277.5 71 295l-7 7 0 9.9 0 102.1L18.2 459.8l-17 17z','M452.2 18.2l-17-17L401.3 35.2l17 17 3.8 3.8L384 94.1 329 39l-17-17L278.1 56l17 17 72 72 72 72 17 17L489.9 200l-17-17-55-55L456 89.9l3.8 3.8 17 17 33.9-33.9-17-17L473 39 452.2 18.2zM180.7 299.3L192 310.6 214.6 288l-11.3-11.3-57-57-22.6 22.6 57 57zm64-64L256 246.6 278.6 224l-11.3-11.3-57-57-22.6 22.6 57 57z']
      
    ]
  };

  

  
  

  var faBoombox = {
    prefix: 'fasds',
    iconName: 'boombox',
    icon: [
      640,
      512,
      [128254],
      'f8a5',
      
      ['M0 160l32 0 48 0 112 0 64 0 32 0 64 0 32 0 64 0 112 0 48 0 32 0 0 352L0 512 0 160zM64 336a112 112 0 1 0 224 0A112 112 0 1 0 64 336zm288 0a112 112 0 1 0 224 0 112 112 0 1 0 -224 0z','M32 0L56 0 584 0l24 0 0 24 0 136-48 0 0-112L80 48l0 112-48 0L32 24 32 0zM256 160l-64 0 0-32 64 0 0 32zm96 0l-64 0 0-32 64 0 0 32zm96 0l-64 0 0-32 64 0 0 32zM176 416a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM544 336a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z']
      
    ]
  };

  

  
  

  var faUserNurse = {
    prefix: 'fasds',
    iconName: 'user-nurse',
    icon: [
      448,
      512,
      [],
      'f82f',
      
      ['M96 160l256 0c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M96 96l0-48L224 0 352 48l0 48 0 32 0 32L96 160l0-32 0-32zm30.1 224L224 424l97.9-104 62.1 0 64 192L0 512 64 320l62.1 0zM208 64l-24 0 0 32 24 0 0 24 32 0 0-24 24 0 0-32-24 0 0-24-32 0 0 24z']
      
    ]
  };

  

  
  

  var faTrashCheck = {
    prefix: 'fasds',
    iconName: 'trash-check',
    icon: [
      448,
      512,
      [],
      'e2af',
      
      ['M32 96L56 512l336 0L416 96 32 96zM94.1 288L128 254.1l17 17 47 47L303 207l17-17L353.9 224l-17 17L209 369l-17 17-17-17-64-64-17-17z','M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zM337 241l17-17L320 190.1l-17 17-111 111-47-47-17-17L94.1 288l17 17 64 64 17 17 17-17L337 241z']
      
    ]
  };

  

  
  

  var faBridgeSuspension = {
    prefix: 'fasds',
    iconName: 'bridge-suspension',
    icon: [
      640,
      512,
      [],
      'e4cd',
      
      ['M2.6 119.2l26.9 39.8C51.7 143.9 75 126.7 96 105.4L96 256l64 0 0-153.6c12.3 12 25.6 22.6 40 31.6L200 256l48 0 0-99.5c15.3 5.1 31.3 8.5 48 10.2l0 89.2c16 0 32 0 48 0l0-89.2c16.7-1.7 32.7-5.2 48-10.3l0 99.5c16 0 32 0 48 0l0-122.1c14.4-9 27.7-19.6 40-31.6L480 256l64 0 0-150.6c21 21.3 44.3 38.5 66.6 53.6l26.9-39.8c-39.2-26.5-74.9-55.7-96-97.9L534.8 8 520 8 504 8 490.1 8l-6.9 12.1C447.6 82.4 389.4 120 320 120s-127.6-37.6-163.2-99.9L149.9 8 136 8 120 8 105.2 8 98.5 21.3c-21.1 42.2-56.8 71.4-96 97.9z','M16 256L0 256l0 16 0 64 0 16 16 0 80 0 0 144 0 16 16 0 64 0 16 0 0-16 0-144 256 0 0 144 0 16 16 0 64 0 16 0 0-16 0-144 80 0 16 0 0-16 0-64 0-16-16 0L16 256z']
      
    ]
  };

  

  
  

  var faTrainTram = {
    prefix: 'fasds',
    iconName: 'train-tram',
    icon: [
      448,
      512,
      [128650],
      'e5b4',
      
      ['M8.6 45.6L39.4 82.4 80.7 48 200 48l0 48 48 0 0-48 119.3 0 41.3 34.4 30.7-36.9-48-40L384.7 0 376 0 72 0 63.3 0 56.6 5.6l-48 40zM40 512l80 0 64-64-80 0L40 512zm88-352c0 32 0 64 0 96l192 0c0-32 0-64 0-96l-192 0zM264 448l64 64 80 0-64-64-80 0z','M384 96L64 96l0 352 320 0 0-352zm-64 64l0 96-192 0 0-96 192 0zM128 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faStarshipFreighter = {
    prefix: 'fasds',
    iconName: 'starship-freighter',
    icon: [
      576,
      512,
      [],
      'e03a',
      
      ['M0 256C0 132.3 100.3 32 224 32c42.3 0 84.2 7.9 123.6 23.2L576 144l0 80-130.3 0L416 224l0 64 29.7 0L576 288l0 80-96 37.3 0-21.3-48 0-48.4 0L301.1 277.3c1.9-6.8 2.9-13.9 2.9-21.3c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80l1.2 0L322 461.4c.9 1.2 1.8 2.3 2.7 3.5C292.1 474.9 258.2 480 224 480C100.3 480 0 379.7 0 256zm64 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm32-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 192a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M128 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM301.1 277.3c1.9-6.8 2.9-13.9 2.9-21.3c0-44.2-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80l1.2 0L322 461.4 336.4 480l23.6 0 72 0 48 0 0-96-48 0-48.4 0L301.1 277.3zM192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faUserLarge = {
    prefix: 'fasds',
    iconName: 'user-large',
    icon: [
      512,
      512,
      ["user-alt"],
      'f406',
      
      ['M112 144a144 144 0 1 0 288 0 144 144 0 1 0 -288 0z','M80 320H432l80 192H0L80 320z']
      
    ]
  };

  
    var faUserAlt = faUserLarge;
  

  
  

  var faCirclesOverlap = {
    prefix: 'fasds',
    iconName: 'circles-overlap',
    icon: [
      640,
      512,
      [],
      'e600',
      
      ['M0 224C0 347.7 100.3 448 224 448c11.2 0 22.1-.8 32.8-2.4c40.6 41 96.9 66.4 159.2 66.4c123.7 0 224-100.3 224-224S539.7 64 416 64c-11.2 0-22.1 .8-32.8 2.4C342.6 25.4 286.3 0 224 0C100.3 0 0 100.3 0 224zm64 0c0-88.4 71.6-160 160-160c32.2 0 62.2 9.5 87.3 25.9c22-11.7 46.2-19.8 71.8-23.5c1.1 1.1 2.2 2.3 3.3 3.4s2.2 2.3 3.2 3.5c2.1 2.3 4.2 4.7 6.2 7.1c4.1 4.8 7.9 9.9 11.5 15c7.3 10.4 13.7 21.4 19.2 32.9C510 133.8 576 203.2 576 288c0 88.4-71.6 160-160 160c-32.2 0-62.2-9.5-87.3-25.9c-22.1 11.6-46.3 19.7-71.9 23.5c-1.1-1.1-2.2-2.2-3.3-3.4c-1.1-1.2-2.2-2.3-3.2-3.5c-2.1-2.3-4.2-4.7-6.2-7.1c-4.1-4.8-7.9-9.9-11.5-15c-7.3-10.4-13.7-21.4-19.2-32.9C130 378.2 64 308.8 64 224z','M256.8 445.6C365 429.7 448 336.6 448 224c0-61.5-24.8-117.1-64.8-157.6C275 82.3 192 175.4 192 288c0 61.5 24.8 117.1 64.8 157.6z']
      
    ]
  };

  

  
  

  var faRulerVertical = {
    prefix: 'fasds',
    iconName: 'ruler-vertical',
    icon: [
      256,
      512,
      [],
      'f548',
      
      ['M0 0L256 0l0 96-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 64-80 0-16 0 0 32 16 0 80 0 0 96L0 512 0 0z','M176 96l-16 0 0 32 16 0 80 0 0-32-80 0zm-16 96l0 32 16 0 80 0 0-32-80 0-16 0zm16 96l-16 0 0 32 16 0 80 0 0-32-80 0zm0 96l-16 0 0 32 16 0 80 0 0-32-80 0z']
      
    ]
  };

  

  
  

  var faRightLeftLarge = {
    prefix: 'fasds',
    iconName: 'right-left-large',
    icon: [
      640,
      512,
      [],
      'e5e1',
      
      ['M0 314.7l0 42.5L154.7 512 256 512l0-64 96 0 0-64-160 0 0 64-10.7 0L69.3 336l112-112 10.7 0 0 64 128 0 0-64-64 0 0-64-101.3 0L0 314.7z','M485.3 352H384V288H320V224H448v64h10.7l112-112L458.7 64H448v64H288V64h96V0H485.3L640 154.7v42.5L485.3 352z']
      
    ]
  };

  

  
  

  var faArrowDownFromArc = {
    prefix: 'fasds',
    iconName: 'arrow-down-from-arc',
    icon: [
      512,
      512,
      [],
      'e614',
      
      ['M0 258.7l0 32 64 0 0-32c0-106 86-192 192-192s192 86 192 192l0 32 64 0 0-32c0-141.4-114.6-256-256-256S0 117.4 0 258.7z','M98.7 354.7l22.6 22.6 112 112L256 512l22.6-22.6 112-112 22.6-22.6L368 309.5l-22.6 22.6L288 389.5l0-194.7 0-32-64 0 0 32 0 194.7-57.4-57.4L144 309.5 98.7 354.7z']
      
    ]
  };

  

  
  

  var faFlower = {
    prefix: 'fasds',
    iconName: 'flower',
    icon: [
      448,
      512,
      [10047,127804],
      'f7ff',
      
      ['M0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160zm128 96l96-96 96 96-96 96-96-96z','M128 256l96 96 96-96-96-96-96 96z']
      
    ]
  };

  

  
  

  var faMagnifyingGlassMinus = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-minus',
    icon: [
      512,
      512,
      ["search-minus"],
      'f010',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm112-24l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z','M136 184l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0zM441.4 486.6L330.7 376C348 363.3 363.3 348 376 330.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6z']
      
    ]
  };

  
    var faSearchMinus = faMagnifyingGlassMinus;
  

  
  

  var faCalendarHeart = {
    prefix: 'fasds',
    iconName: 'calendar-heart',
    icon: [
      448,
      512,
      [],
      'e0d3',
      
      ['M0 192L0 512l448 0 0-320L0 192zM112 315.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L224 448.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zM112 315.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L224 448.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z']
      
    ]
  };

  

  
  

  var faMask = {
    prefix: 'fasds',
    iconName: 'mask',
    icon: [
      576,
      512,
      [],
      'f6fa',
      
      ['M0 272C0 384 80 448 176 448l48 0 32-96 64 0 32 96 48 0c96 0 176-64 176-176s-64-208-288-208S0 160 0 272zm224-16A64 64 0 1 1 96 256a64 64 0 1 1 128 0zm256 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M160 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faTreeDecorated = {
    prefix: 'fasds',
    iconName: 'tree-decorated',
    icon: [
      448,
      512,
      [],
      'f7dc',
      
      ['M0 480l0 32 448 0 0-32L368 352l56 0 0-32L344 208l48 0 0-32L224 0 56 176l0 32 48 0L24 320l0 32 56 0L0 480zM184 288a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96-128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M256 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm32 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faBrush = {
    prefix: 'fasds',
    iconName: 'brush',
    icon: [
      384,
      512,
      [],
      'f55d',
      
      ['M0 0L0 288l384 0L384 0 224 0 192 64 160 0 128 0 96 64 64 0 0 0z','M0 288l384 0 0 96-128 0 0 128-128 0 0-128L0 384l0-96zM192 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faMugSaucer = {
    prefix: 'fasds',
    iconName: 'mug-saucer',
    icon: [
      640,
      512,
      ["coffee"],
      'f0f4',
      
      ['M0 416l32 0 512 0 32 0 0 64-32 0L32 480 0 480l0-64z','M448 32L96 32l0 352 384 0 0-96 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-32 0-32 0zm32 64l32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0-128z']
      
    ]
  };

  
    var faCoffee = faMugSaucer;
  

  
  

  var faGarlic = {
    prefix: 'fasds',
    iconName: 'garlic',
    icon: [
      512,
      512,
      [129476],
      'e40e',
      
      ['M0 299.7C0 368.4 55.6 424 124.3 424l5.1 0C90.8 400 64 358.8 64 304c0-27.8 4.3-48.7 11-66.5c5.9-15.6 13.6-28.6 20.7-40.5c.8-1.4 1.7-2.8 2.5-4.2c7.8-13.2 15.1-26.2 20.5-43.3c.6-1.9 1.2-3.9 1.8-5.9L46.6 202.7C17.2 226.3 0 262 0 299.7zM96 304c0 69.3 54.9 112 120 112s120-42.7 120-112c0-42.1-15-62.5-33.5-87.7c-1.1-1.6-2.3-3.1-3.5-4.7c-10.2-13.9-21.2-29.8-29.5-50.9C261.3 139.5 256 113.8 256 80l0-80L160 0l0 80 0 32-1.6 1.3c-1.8 17.8-5 32.8-9.2 46c-6.6 20.7-15.3 36.2-23.5 49.9l-2.5 4.2c-7.2 12.1-13.5 22.6-18.3 35.5c-5.3 13.9-9 31-9 55.2zM264 448l0 40 0 24 48 0 0-24 0-40-48 0zM288 0l0 80c0 30.2 4.7 51.9 11.4 69c6.7 17.1 15.7 30.3 25.5 43.8c1.2 1.6 2.4 3.3 3.6 5c19 25.8 39.4 53.6 39.4 106.3c0 54.8-26.8 96-65.3 120l85.1 0C456.4 424 512 368.4 512 299.7c0-37.8-17.2-73.5-46.6-97L352 112 352 0 288 0z','M136 488v24h48V488H136zm64 0v24h48V488H200zm64 0v24h48V488H264zm64 0v24h48V488H328zM136 448v40h48V448H136zm64 0v40h48V448H200zm64 0v40h48V448H264zm64 0v40h48V448H328z']
      
    ]
  };

  

  
  

  var faCommentArrowUp = {
    prefix: 'fasds',
    iconName: 'comment-arrow-up',
    icon: [
      512,
      512,
      [],
      'e144',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm150.1-16l17-17 72-72 17-17 17 17 72 72 17 17L328 257.9l-17-17-31-31L280 328l0 24-48 0 0-24 0-118.1-31 31-17 17L150.1 224z','M280 352l0-24 0-118.1 31 31 17 17L361.9 224l-17-17-72-72-17-17-17 17-72 72-17 17L184 257.9l17-17 31-31L232 328l0 24 48 0z']
      
    ]
  };

  

  
  

  var faRectangleWide = {
    prefix: 'fasds',
    iconName: 'rectangle-wide',
    icon: [
      640,
      512,
      [],
      'f2fc',
      
      ['M0 64H640V448H0V64z','']
      
    ]
  };

  

  
  

  var faWindowMinimize = {
    prefix: 'fasds',
    iconName: 'window-minimize',
    icon: [
      512,
      512,
      [128469],
      'f2d1',
      
      ['M512 416L0 416l0 64 512 0 0-64z','']
      
    ]
  };

  

  
  

  var faFileInvoice = {
    prefix: 'fasds',
    iconName: 'file-invoice',
    icon: [
      384,
      512,
      [],
      'f570',
      
      ['M0 0L0 512l384 0 0-352-160 0L224 0 0 0zM64 64l16 0 64 0 16 0 0 32-16 0L80 96 64 96l0-32zm0 64l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zm0 96l16 0 224 0 16 0 0 16 0 96 0 16-16 0L80 352l-16 0 0-16 0-96 0-16zM224 416l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32z','M384 160L224 0l0 160 160 0zM80 224l-16 0 0 16 0 96 0 16 16 0 224 0 16 0 0-16 0-96 0-16-16 0L80 224zm16 96l0-64 192 0 0 64L96 320zm144 96l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z']
      
    ]
  };

  

  
  

  var faHandDots = {
    prefix: 'fasds',
    iconName: 'hand-dots',
    icon: [
      512,
      512,
      ["allergies"],
      'f461',
      
      ['M.3 329.4l29 27.6 95.5 91c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208 0-32-64 0 0 32 0 128-32 0 0-192 0-32-64 0 0 32 0 192-32 0 0-224 0-32L224 0l0 32 0 224-32 0 0-192 0-32-64 0 0 32 0 272c0 1.5 0 3.1 .1 4.6L84.5 299.1l-29-27.6L.3 329.4zM208 400a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M304 368a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  
    var faAllergies = faHandDots;
  

  
  

  var faArrowDownToDottedLine = {
    prefix: 'fasds',
    iconName: 'arrow-down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e095',
      
      ['M0 416l0 64 64 0 0-64L0 416zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z','M224 365.3l22.6-22.6 128-128L397.3 192 352 146.7l-22.6 22.6L256 242.7l0-66.7 0-112 0-32-64 0 0 32 0 112 0 66.7-73.4-73.4L96 146.7 50.7 192l22.6 22.6 128 128L224 365.3z']
      
    ]
  };

  

  
  

  var faClockTwelveThirty = {
    prefix: 'fasds',
    iconName: 'clock-twelve-thirty',
    icon: [
      512,
      512,
      [],
      'e359',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 128l48 0 0 24 0 240 0 24-48 0 0-24 0-240 0-24z','M280 128l0 24 0 240 0 24-48 0 0-24 0-240 0-24 48 0z']
      
    ]
  };

  

  
  

  var faOnion = {
    prefix: 'fasds',
    iconName: 'onion',
    icon: [
      448,
      512,
      [129477],
      'e427',
      
      ['M0 288c0 80 57.5 134.7 130.9 160c15.1 5.2 30.9 9.2 47 11.8c7.3 1.2 14.7 2.2 22.1 2.9c8 .7 16 1.2 24 1.3c8-.1 16-.5 24-1.3c7.4-.7 14.8-1.6 22.1-2.9c16.1-2.7 31.9-6.6 47-11.8c73.4-25.3 131-80 131-160c0-84.5-49-124.3-95.3-162C311.2 92.3 272 60.4 272 0L240 0 224 32 208 0 176 0c0 60.4-39.2 92.3-80.7 126C49 163.7 0 203.5 0 288zm73 69.6c-13.9-37-6.6-81.3 2.6-114c4.7-16.7 10.2-31.4 14.5-41.8c2.2-5.2 4-9.4 5.4-12.3c.7-1.5 1.2-2.6 1.6-3.4l.5-.9 .2-.4L112 192c14.3 7.2 14.3 7.2 14.2 7.3l-.3 .7c-.3 .6-.8 1.6-1.4 2.9c-1.2 2.6-2.9 6.4-4.9 11.2c-4 9.6-9 23-13.3 38.2c-8.8 31.3-13.5 67.1-3.4 94L73 357.6zm103.8 31.4c-17.5-52.5-8.5-120.3 3.6-172.7c6.1-26.6 13.3-50.1 18.9-67c2.8-8.4 5.2-15.2 7-19.9c.9-2.4 1.6-4.2 2.1-5.4l.6-1.5 .2-.5L224 128c14.9 5.9 14.9 5.9 14.8 6l-.1 .3-.5 1.3c-.4 1.1-1.1 2.8-1.9 5c-1.6 4.4-4 10.9-6.6 18.9c-5.4 16.2-12.2 38.7-18.1 64c-11.9 51.7-18.9 111.9-4.4 155.3l-30.4 10.1zM291.3 167.8l14-7.8c14-7.8 14-7.8 14-7.7l.2 .3 .6 1.1c.5 .9 1.2 2.2 2.1 3.9c1.8 3.4 4.2 8.3 7.1 14.3c5.7 12.1 13.1 29.2 19.8 48.9c13.1 38.7 24.5 90.6 11.7 135.5l-30.8-8.7c10-35.1 1.4-79.2-11.2-116.5c-6.2-18.3-13.1-34.2-18.4-45.6c-2.7-5.7-4.9-10.2-6.5-13.2c-.8-1.5-1.4-2.7-1.8-3.5c-.2-.3-.3-.6-.6-1.1z','M130.9 448l-9.2 23.1-8.9 22.3 44.6 17.8 8.9-22.3 11.6-29.1c-16.1-2.7-31.9-6.6-47-11.8zM200 462.7l0 25.3 0 24 48 0 0-24 0-25.3c-8 .7-16 1.2-24 1.3c-8-.1-16-.5-24-1.3zm70.1-2.9l11.6 29.1 8.9 22.3 44.6-17.8-8.9-22.3L317 448c-15.1 5.2-30.9 9.2-47 11.8z']
      
    ]
  };

  

  
  

  var faUserClock = {
    prefix: 'fasds',
    iconName: 'user-clock',
    icon: [
      640,
      512,
      [],
      'f4fd',
      
      ['M0 512l394.8 0C349.5 480.1 320 427.5 320 368c0-22.6 4.3-44.2 12-64L64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0 0 16z']
      
    ]
  };

  

  
  

  var faCloudShowers = {
    prefix: 'fasds',
    iconName: 'cloud-showers',
    icon: [
      512,
      512,
      [],
      'f73f',
      
      ['M88 352l0 24 0 80 0 24 48 0 0-24 0-80 0-24-48 0zm96 32l0 24 0 80 0 24 48 0 0-24 0-80 0-24-48 0zm96-32l0 24 0 80 0 24 48 0 0-24 0-80 0-24-48 0zm96 32l0 24 0 80 0 24 48 0 0-24 0-80 0-24-48 0z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faThumbsUp = {
    prefix: 'fasds',
    iconName: 'thumbs-up',
    icon: [
      512,
      512,
      [61575,128077],
      'f164',
      
      ['M160 200.9l0 23.1 0 96 0 64 0 25.7 21.4 14.2 72 48 12.1 8.1 14.5 0 120 0 48 0 0-56 24 0 0-72 24 0 0-80 16 0 0-96-48 0-153.8 0C327 142.8 336 105.8 336 67.7L336 32l-96 0 0 35.7c0 43.7-19.9 85.1-54 112.4l-7.9 6.4-18 14.4z','M0 192H128V480H0V192z']
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm96-24l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M184 320l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0zM441.4 486.6L330.7 376C348 363.3 363.3 348 376 330.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6z']
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faIdCardClip = {
    prefix: 'fasds',
    iconName: 'id-card-clip',
    icon: [
      576,
      512,
      ["id-card-alt"],
      'f47f',
      
      ['M0 64l224 0 0 64-32 0 0 32 32 0 128 0 32 0 0-32-32 0 0-64 224 0 0 448L0 512 0 64zM176 448l224 0-32-64-160 0-32 64zm48-160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M352 0L224 0l0 128 128 0L352 0zm0 288a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm16 96l-160 0-32 64 224 0-32-64z']
      
    ]
  };

  
    var faIdCardAlt = faIdCardClip;
  

  
  

  var faEarthAsia = {
    prefix: 'fasds',
    iconName: 'earth-asia',
    icon: [
      512,
      512,
      [127759,"globe-asia"],
      'f57e',
      
      ['M2 288C17.7 414.3 125.5 512 256 512c54.3 0 104.7-16.9 146.2-45.8L352 416l-64 0 0-64 64-64 64 0 0 32 87.9 0c5.3-20.5 8.1-41.9 8.1-64C512 131 422.4 27 304 4.5L304 112l-32 32 0 80-48 0 0 96-64 0-32-32L2 288zm126 64l64 0 0 32-64 0 0-32zm128-96l32 0 0 64-32 0 0-64zm64-128l32 0 0 64-32 0 0-64z','M304 4.5L304 112l-32 32 0 80-48 0 0 96-64 0-32-32L2 288c-1.3-10.5-2-21.2-2-32C0 114.6 114.6 0 256 0c16.4 0 32.5 1.5 48 4.5zM503.9 320c-15.5 60.1-52.2 111.7-101.8 146.2L352 416l-64 0 0-64 64-64 64 0 0 32 87.9 0zM192 352l0 32-64 0 0-32 64 0zM320 128l32 0 0 64-32 0 0-64zM288 256l0 64-32 0 0-64 32 0z']
      
    ]
  };

  
    var faGlobeAsia = faEarthAsia;
  

  
  

  var faHotel = {
    prefix: 'fasds',
    iconName: 'hotel',
    icon: [
      512,
      512,
      [127976],
      'f594',
      
      ['M0 448l0 64 208 0 0-96 96 0 0 96 208 0 0-64-32 0 0-384L32 64l0 384L0 448zM96 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm64 192c0-53 43-96 96-96s96 43 96 96l-192 0zM224 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zM352 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M512 0L0 0 0 64l512 0 0-64zM160 96L96 96l0 64 64 0 0-64zm128 0l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zM160 192l-64 0 0 64 64 0 0-64zm64 0l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zM352 384c0-53-43-96-96-96s-96 43-96 96l192 0z']
      
    ]
  };

  

  
  

  var fa9 = {
    prefix: 'fasds',
    iconName: '9',
    icon: [
      320,
      512,
      [],
      '39',
      
      ['M160 96a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM67 480l96.5-128c-1.2 0-2.3 0-3.5 0C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 38.1-12.4 75.2-35.3 105.6L147.2 480 67 480z','']
      
    ]
  };

  

  
  

  var faAlbumCollection = {
    prefix: 'fasds',
    iconName: 'album-collection',
    icon: [
      512,
      512,
      [],
      'f8a0',
      
      ['M0 160L40 512l432 0 40-352L0 160zM72 344c0-75.1 82.4-136 184-136s184 60.9 184 136s-82.4 136-184 136S72 419.1 72 344z','M32 0L56 0 456 0l24 0 0 48-24 0L56 48 32 48 32 0zM16 80l24 0 432 0 24 0 0 48-24 0L40 128l-24 0 0-48zM440 344c0 75.1-82.4 136-184 136S72 419.1 72 344s82.4-136 184-136s184 60.9 184 136zm-152 8c0-13.3-14.3-24-32-24s-32 10.7-32 24s14.3 24 32 24s32-10.7 32-24z']
      
    ]
  };

  

  
  

  var faGifts = {
    prefix: 'fasds',
    iconName: 'gifts',
    icon: [
      640,
      512,
      [],
      'f79c',
      
      ['M22.5 69.3L41.9 83.4 59.2 96c56.5 0 113.1 0 169.6 0l17.3-12.6 19.4-14.1L237.3 30.5 217.9 44.6 192.4 63.1 200.6 40l8-22.6-45.2-16-8 22.6L144.7 54.2l-9.9-29.8L127.2 1.6 81.6 16.8l7.6 22.8 8.3 25-27.4-20L50.7 30.5 22.5 69.3zM224 224l0 128 192 0 0-80-16 0-56 0c-1 0-2 0-2.9-.1s-1.9-.1-2.9-.2c-1.9-.2-3.8-.4-5.7-.7c-3.7-.6-7.4-1.5-10.9-2.7c-7.1-2.3-13.6-5.7-19.6-9.9C290.2 250 281 238 276.1 224L224 224zm0 160l0 128 192 0 0-128-192 0zM448 272l0 80 192 0 0-128-52.1 0c-9.9 28-36.6 48-67.9 48l-72 0zm0 112l0 128 192 0 0-128-192 0z','M288 96L0 96 0 512l192 0 0-320 48.3 0c2.6-33.5 21-62.5 47.7-79.6L288 96zm75.5 89.5L393.1 224 344 224c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM344 272l56 0 16 0 0 80-192 0 0 32 192 0 0 128 32 0 0-128 192 0 0-32-192 0 0-80 72 0c39.8 0 72-32.2 72-72c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72c0 39.8 32.2 72 72 72zm175.8-96c13.4 0 24.2 10.9 24.2 24c0 13.3-10.7 24-24 24l-49.1 0 29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5z']
      
    ]
  };

  

  
  

  var faCircle4 = {
    prefix: 'fasds',
    iconName: 'circle-4',
    icon: [
      512,
      512,
      [],
      'e0f1',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4 64c2.8-10.1 5.6-20.3 8.5-30.4c15-53.9 29.9-107.7 44.9-161.6l49.8 0c-13.3 48-26.7 96-40 144l64.4 0c0-18.7 0-37.3 0-56c0-8 0-16 0-24l48 0 0 24 0 56 8 0 24 0 0 48-24 0-8 0 0 40 0 24-48 0c0-8 0-16 0-24c0-13.3 0-26.7 0-40l-96 0-31.6 0z','M152.9 289.6L197.8 128l49.8 0-40 144 64.4 0 0-56 0-24 48 0 0 24 0 56 8 0 24 0 0 48-24 0-8 0 0 40 0 24-48 0 0-24 0-40-96 0-31.6 0 8.5-30.4z']
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fasds',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm158.1-64c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.3-31.3 47-47c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c5.7 5.7 11.3 11.3 17 17L320 353.9l-17-17-47-47c-15.7 15.7-31.3 31.3-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-5.7-5.7-11.3-11.3-17-17z','M337 209l17-17L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faCalendarMinus = {
    prefix: 'fasds',
    iconName: 'calendar-minus',
    icon: [
      448,
      512,
      [],
      'f272',
      
      ['M0 192L0 512l448 0 0-320L0 192zM112 328l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zM312 376l24 0 0-48-24 0-176 0-24 0 0 48 24 0 176 0z']
      
    ]
  };

  

  
  

  var faBandage = {
    prefix: 'fasds',
    iconName: 'bandage',
    icon: [
      640,
      512,
      [129657,"band-aid"],
      'f462',
      
      ['M0 96L0 416l160 0 0-320L0 96zm192 0l0 320 256 0 0-320L192 96zM296 208a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96-96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM480 96l0 320 160 0 0-320L480 96z','M192 96l-32 0 0 320 32 0 0-320zm288 0l-32 0 0 320 32 0 0-320z']
      
    ]
  };

  
    var faBandAid = faBandage;
  

  
  

  var faClapperboardPlay = {
    prefix: 'fasds',
    iconName: 'clapperboard-play',
    icon: [
      512,
      512,
      [],
      'e132',
      
      ['M0 160l6.1 0 67.9 0 92.1 0 67.9 0 92.1 0 67.9 0L512 160l0 320L0 480 0 160zm208 72l0 176 136-88L208 232z','M361.9 32l-1 1-127 127 92.1 0 1-1 127-127-92.1 0zM512 160l0-118.1L393.9 160 512 160zM294.1 32l-92.1 0-1 1L73.9 160l92.1 0 1-1 127-127zM0 32L0 160l6.1 0 1-1 127-127L0 32zM344 320L208 232l0 176 136-88z']
      
    ]
  };

  

  
  

  var faSensorCloud = {
    prefix: 'fasds',
    iconName: 'sensor-cloud',
    icon: [
      640,
      512,
      ["sensor-smoke"],
      'e02c',
      
      ['M0 32l448 0 0 202.8c-14.5-6.9-30.8-10.8-48-10.8c-60.1 0-109.1 47.3-111.9 106.7C250.2 348.7 224 387.3 224 432l0 48L0 480 0 32zM64 96l0 24 0 144 0 24 48 0 0-24 0-144 0-24L64 96zm96 0l0 24 0 144 0 24 48 0 0-24 0-144 0-24-48 0z','M320 353.6c-36.5 7.4-64 39.7-64 78.4l0 80 80 0 16 0 192 0 16 0 80 0 0-80c0-38.7-27.5-71-64-78.4l0-9.6c0-30.9-25.1-56-56-56c-18.1 0-34.1 8.6-44.4 21.8C464.8 278.5 435 256 400 256c-44.2 0-80 35.8-80 80l0 17.6z']
      
    ]
  };

  
    var faSensorSmoke = faSensorCloud;
  

  
  

  var faBookUser = {
    prefix: 'fasds',
    iconName: 'book-user',
    icon: [
      448,
      512,
      [],
      'f7e7',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zm80 128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96-224 0 32-96 160 0z']
      
    ]
  };

  

  
  

  var faWatchSmart = {
    prefix: 'fasds',
    iconName: 'watch-smart',
    icon: [
      384,
      512,
      [],
      'e2cc',
      
      ['M0 64l64 0 256 0 64 0 0 384-64 0L64 448 0 448 0 64zm168 72l0 24 0 96 0 9.9 7 7 48 48 17 17L273.9 304l-17-17-41-41 0-86.1 0-24-24 0-24 0z','M64 0l0 64 256 0 0-64L64 0zm0 512l256 0 0-64L64 448l0 64zM216 160l0-24-48 0 0 24 0 96 0 9.9 7 7 48 48 17 17L273.9 304l-17-17-41-41 0-86.1z']
      
    ]
  };

  

  
  

  var faBrain = {
    prefix: 'fasds',
    iconName: 'brain',
    icon: [
      512,
      512,
      [129504],
      'f5dc',
      
      ['M0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1l56 0 0-56 0-400 0-56L184 0c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304zM272 0l0 56 0 400 0 56 56 0c28.9 0 52.7-21.9 55.7-50.1c5.2 1.4 10.7 2.1 16.3 2.1c35.3 0 64-28.7 64-64c0-7.4-1.3-14.6-3.6-21.2C490.6 367.4 512 338.2 512 304c0-31.9-18.7-59.5-45.8-72.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0L272 0z','M240 456l0-400 32 0 0 400-32 0z']
      
    ]
  };

  

  
  

  var faPompebled = {
    prefix: 'fasds',
    iconName: 'pompebled',
    icon: [
      512,
      512,
      [],
      'e43d',
      
      ['M295.2 216.3c48.2-58.4 118.9-77.5 165.1-44.3c59 41.8 68.8 131.8 22.6 200.2c-85.5 126.3-260.4 185.6-381.8 98.6C-20.8 383.8-28.6 196.7 56.9 70.4c46.2-68.9 131.7-91 190.7-49.3c46.7 32.2 54.5 106.6 17.7 173.5L254.7 210l30 21.6 10.6-15.3z','']
      
    ]
  };

  

  
  

  var faBowlingBall = {
    prefix: 'fasds',
    iconName: 'bowling-ball',
    icon: [
      512,
      512,
      [],
      'f436',
      
      ['M112 176a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faUnicorn = {
    prefix: 'fasds',
    iconName: 'unicorn',
    icon: [
      640,
      512,
      [129412],
      'f727',
      
      ['M0 256l0 56 0 24 48 0 0-24 0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256zM560 48l16 16 0 21.3L640 64l0-16-80 0z','M448 238.1l0-78.1 16 0 32 64 80-32 0-128L544 32l16 0 16 0 0-32L560 0 480 0 448 0C377.3 0 320 57.3 320 128l-64 0-52.8 0-54.4 0C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l42.4 63.6L94.1 350.1l-21 21 9.4 28.1L120.1 512l101.2 0L182.9 397l27-27L224 355.9l0-19.9 0-16 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8L320 512l96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faDice = {
    prefix: 'fasds',
    iconName: 'dice',
    icon: [
      640,
      512,
      [127922],
      'f522',
      
      ['M0 224L224 448 448 224 224 0 0 224zm120 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM248 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 128a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM376 224a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M224 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM96 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 80a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm128-80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM320 397.3L320 512l320 0 0-320-178.7 0 9.4 9.4L493.3 224l-22.6 22.6L320 397.3zM456 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z']
      
    ]
  };

  

  
  

  var faSquareEnvelope = {
    prefix: 'fasds',
    iconName: 'square-envelope',
    icon: [
      448,
      512,
      ["envelope-square"],
      'f199',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 144l320 0 0 33.4L224 277.1 64 177.4 64 144zm0 71.1l151.5 94.5 8.5 5.3 8.5-5.3L384 215.1 384 368 64 368l0-152.9z','M384 144L64 144l0 33.4 160 99.7 160-99.7 0-33.4zm0 71.1L232.5 309.6l-8.5 5.3-8.5-5.3L64 215.1 64 368l320 0 0-152.9z']
      
    ]
  };

  
    var faEnvelopeSquare = faSquareEnvelope;
  

  
  

  var faPersonWalkingArrowRight = {
    prefix: 'fasds',
    iconName: 'person-walking-arrow-right',
    icon: [
      640,
      512,
      [],
      'e552',
      
      ['M2.7 464L48 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6L68.7 398 25.4 441.4 2.7 464zM7.5 260.2l60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48L7.5 260.2zM160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M512 130.7l22.6 22.6 80 80L637.3 256l-22.6 22.6-80 80L512 381.3 466.7 336l22.6-22.6L514.7 288 384 288l-32 0 0-64 32 0 130.7 0-25.4-25.4L466.7 176 512 130.7z']
      
    ]
  };

  

  
  

  var faRectangleBarcode = {
    prefix: 'fasds',
    iconName: 'rectangle-barcode',
    icon: [
      576,
      512,
      ["barcode-alt"],
      'f463',
      
      ['M0 32L0 480l576 0 0-448L0 32zm96 96l48 0 0 256-48 0 0-256zm80 0l32 0 0 256-32 0 0-256zm64 0l48 0 0 256-48 0 0-256zm112 0l48 0 0 256-48 0 0-256zm96 0l32 0 0 256-32 0 0-256z','M96 128l48 0 0 256-48 0 0-256zm80 0l32 0 0 256-32 0 0-256zm112 0l0 256-48 0 0-256 48 0zm64 0l48 0 0 256-48 0 0-256zm128 0l0 256-32 0 0-256 32 0z']
      
    ]
  };

  
    var faBarcodeAlt = faRectangleBarcode;
  

  
  

  var faSquareS = {
    prefix: 'fasds',
    iconName: 'square-s',
    icon: [
      448,
      512,
      [],
      'e27d',
      
      ['M0 32L0 480l448 0 0-448L0 32zM121.8 359.5l14.7-45.7 22.9 7.3c13.9 4.5 37.8 11.5 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.8-26.4 23.1-43.4 45-52c13.7-5.4 29.3-7.8 45.5-7.8c8.9 0 18 .7 27.1 2.1c8.1 1.2 24.4 4.8 32 6.7c7.8 2 15.5 4 23.2 6c-4 15.5-7.9 31-11.9 46.5c-7.8-2-15.5-4-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c3.8 8.3 5.7 17.1 5.7 26.4c0 4.6-.4 9.2-1.3 13.9c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.7 5.7c-16.3-2.6-43.7-10.7-57.3-15.1c-7.6-2.4-15.2-4.9-22.9-7.3z','M191 180.4c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23.1 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1l-22.9-7.3 14.7-45.7 22.9 7.3c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7l23.2 6-11.9 46.5-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7l3.6-23.7-3.6 23.7c-20.3-3.1-36.8-1.4-47.8 2.9z']
      
    ]
  };

  

  
  

  var faTurnDown = {
    prefix: 'fasds',
    iconName: 'turn-down',
    icon: [
      384,
      512,
      [10549,"level-down-alt"],
      'f3be',
      
      ['M0 0L0 96l48 0 96 0 0 224 96 0 0-272 0-48L192 0 48 0 0 0z','M352 352L192 512 32 352l0-32 320 0 0 32z']
      
    ]
  };

  
    var faLevelDownAlt = faTurnDown;
  

  
  

  var faWheelchairMove = {
    prefix: 'fasds',
    iconName: 'wheelchair-move',
    icon: [
      448,
      512,
      ["wheelchair-alt"],
      'e2ce',
      
      ['M0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-22.8-4.8-44.4-13.3-64c-20.5-46.9-62.9-82.1-114.3-92.7C182 193.1 171.1 192 160 192C71.6 192 0 263.6 0 352zm256 0A96 96 0 1 1 64 352a96 96 0 1 1 192 0z','M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM198.2 42.8l16.9 9 120 64 34 18.1L345 164l-48 60 111 0 37.2 0-5.5 36.7-24 160-4.7 31.6-63.3-9.5 4.7-31.6L370.8 288l-64.2 0c-20.5-46.9-62.9-82.1-114.3-92.7l54.2-54.2-44.8-23.9-56.1 37.4-26.6 17.8L83.6 119.1l26.6-17.8 72-48 15.9-10.6z']
      
    ]
  };

  
    var faWheelchairAlt = faWheelchairMove;
  

  
  

  var faFaceGrimace = {
    prefix: 'fasds',
    iconName: 'face-grimace',
    icon: [
      512,
      512,
      [128556,"grimace"],
      'f57f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112 48l56 0 0 40-56 0 0-40zm0 56l56 0 0 40-56 0 0-40zm32.4-152c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM184 304l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-64 0 0-40zm80-56l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-64 0 0-40zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM344 304l56 0 0 40-56 0 0-40zm0 56l56 0 0 40-56 0 0-40z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faGrimace = faFaceGrimace;
  

  
  

  var faChessPawnPiece = {
    prefix: 'fasds',
    iconName: 'chess-pawn-piece',
    icon: [
      256,
      512,
      ["chess-pawn-alt"],
      'f444',
      
      ['M0 480l48-64 160 0 48 64 0 32L0 512l0-32z','M176 240c19.4-14.6 32-37.8 32-64c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.4 32 64l-8 0-24 0 0 48 24 0 4.4 0L48 416l160 0L179.6 288l4.4 0 24 0 0-48-24 0-8 0z']
      
    ]
  };

  
    var faChessPawnAlt = faChessPawnPiece;
  

  
  

  var faArrowsUpDown = {
    prefix: 'fasds',
    iconName: 'arrows-up-down',
    icon: [
      320,
      512,
      ["arrows-v"],
      'f07d',
      
      ['M18.7 367.9l22.6 22.6 96 96L160 509.1l22.6-22.6 96-96 22.6-22.6L256 322.6l-22.6 22.6L192 386.6 192 256c-21.3 0-42.7 0-64 0l0 130.6L86.6 345.2 64 322.6 18.7 367.9z','M182.6 25.4L160 2.7 137.4 25.4l-96 96L18.7 144 64 189.3l22.6-22.6L128 125.3 128 256l64 0 0-130.7 41.4 41.4L256 189.3 301.3 144l-22.6-22.6-96-96z']
      
    ]
  };

  
    var faArrowsV = faArrowsUpDown;
  

  
  

  var faWaterLadder = {
    prefix: 'fasds',
    iconName: 'water-ladder',
    icon: [
      576,
      512,
      ["ladder-water","swimming-pool"],
      'f5c5',
      
      ['M0 416l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2C38.6 409.9 19.3 416 0 416z','M224 32c-53 0-96 43-96 96l0 230.9c8.1 5.6 15.2 10 23.3 13.7c13.1 6 27.7 10.3 40.7 10.3l0-95 192 0 0 95c13 0 27.6-4.3 40.7-10.3c8.1-3.7 15.2-8.1 23.3-13.7L448 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 64 0 0-32c0-53-43-96-96-96s-96 43-96 96l0 96-192 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 64 0 0-32c0-53-43-96-96-96z']
      
    ]
  };

  
    var faLadderWater = faWaterLadder;
  
    var faSwimmingPool = faWaterLadder;
  

  
  

  var faCalendarDay = {
    prefix: 'fasds',
    iconName: 'calendar-day',
    icon: [
      448,
      512,
      [],
      'f783',
      
      ['M0 192L0 512l448 0 0-320L0 192zm64 64l128 0 0 128L64 384l0-128z','M96 0l64 0 0 64 128 0 0-64 64 0 0 64 96 0 0 128L0 192 0 64l96 0L96 0z']
      
    ]
  };

  

  
  

  var faBellRing = {
    prefix: 'fasds',
    iconName: 'bell-ring',
    icon: [
      512,
      512,
      [],
      'e62c',
      
      ['M32 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L288 0 224 0l0 51.2C151 66 96 130.6 96 208l0 88L32 368z','M112.6 49.4C72.8 87.3 48 140.7 48 200L0 200C0 127.1 30.5 61.2 79.4 14.6l33.1 34.8zM320 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0 64 0zM464 200c0-59.3-24.8-112.7-64.6-150.6l33.1-34.8C481.5 61.2 512 127.1 512 200l-48 0z']
      
    ]
  };

  

  
  

  var faAudioDescriptionSlash = {
    prefix: 'fasds',
    iconName: 'audio-description-slash',
    icon: [
      640,
      512,
      [],
      'e0a8',
      
      ['M32 121.2L32 480l455.4 0L320 348.1l1.7 3.9-52.2 0-10.3-24.2-70.4 0L178.5 352l-52.2 0 49.9-117.1L32 121.2zM70.5 32C159 100.7 247.5 169.4 336 238.1l0-54.1 0-24 24 0 56 0c53 0 96 43 96 96c0 35-18.7 65.7-46.8 82.4L608 449.3 608 32 70.5 32zM205.9 287.8l36.3 0-.7-1.6-26.1-20.6-9.5 22.2zM384 208l0 67.4c12.2 9.5 24.4 19 36.6 28.4C445 301.5 464 281 464 256c0-26.5-21.5-48-48-48l-32 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faFileSpreadsheet = {
    prefix: 'fasds',
    iconName: 'file-spreadsheet',
    icon: [
      384,
      512,
      [],
      'f65b',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM56 224l0 16 0 32 0 80 0 80 0 16 16 0 80 0 80 0 80 0 16 0 0-16 0-80 0-80 0-32 0-16-16 0L72 224l-16 0z','M384 160L224 0l0 160 160 0zM72 224l-16 0 0 16 0 32 0 80 0 80 0 16 16 0 80 0 80 0 80 0 16 0 0-16 0-80 0-80 0-32 0-16-16 0L72 224zM88 336l0-48 48 0 0 48-48 0zm80 0l0-48 48 0 0 48-48 0zm80 0l0-48 48 0 0 48-48 0zm0 32l48 0 0 48-48 0 0-48zm-32 0l0 48-48 0 0-48 48 0zm-80 0l0 48-48 0 0-48 48 0z']
      
    ]
  };

  

  
  

  var faWheat = {
    prefix: 'fasds',
    iconName: 'wheat',
    icon: [
      512,
      512,
      [],
      'f72d',
      
      ['M2.7 464L48 509.3l22.6-22.6 52.9-52.9c-3.5-3.5-6.9-6.9-10.4-10.4c-11.6-11.6-23.2-23.2-34.8-34.8L25.4 441.4 2.7 464zm142.9-95.9c1-.3 1.9-.5 2.9-.8c1-.3 2-.5 2.9-.7c2-.5 3.9-.9 5.9-1.2c4-.7 8-1.3 12-1.7c8-.7 16.1-.7 24.1 .1l31.9-31.9c-3.5-3.5-6.9-6.9-10.4-10.4c-11.6-11.6-23.1-23.1-34.8-34.8l-30.5 30.5c2.1 17 .8 34.4-4 51zM247.5 266.3c1.1-.3 2-.5 2.8-.8c1.1-.3 2-.5 3-.7c2-.5 4-.9 5.9-1.3c4-.7 8-1.3 12-1.7c8-.7 16.1-.7 24.1 .1l31.9-31.9c-3.5-3.5-6.9-6.9-10.4-10.4c-10.7-10.7-21.4-21.4-32.1-32.1l-2.7-2.7-30.5 30.5c2.1 17 .8 34.4-4 51z','M472 0c-48.6 0-88 39.4-88 88l0 40 40 0c48.6 0 88-39.4 88-88l0-40L472 0zM316.8 38.6L294.2 16 271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l45.3 45.3s0 0 0 0l22.6 22.6c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9zM192.3 117.8l-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8L215 321.5s0 0 0 0l22.6 22.6c37.5 37.5 98.3 37.5 135.8 0L396 321.5l-22.6-22.6c-34.1-34.1-82.6-44.9-125.9-32.5C259.9 223 249 174.5 215 140.5l-22.6-22.6zM113.1 242.3L90.5 219.6 67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l45.3 45.3s0 0 0 0l22.6 22.6c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9z']
      
    ]
  };

  

  
  

  var faTurnLeft = {
    prefix: 'fasds',
    iconName: 'turn-left',
    icon: [
      512,
      512,
      [],
      'e636',
      
      ['M192 176l0 96 224 0 0 208 96 0 0-304-320 0z','M160 64L0 224 160 384l32 0 0-320-32 0z']
      
    ]
  };

  

  
  

  var faCircleCaretRight = {
    prefix: 'fasds',
    iconName: 'circle-caret-right',
    icon: [
      512,
      512,
      ["caret-circle-right"],
      'f330',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM208 128l0 256 32 0L368 256 240 128l-32 0z','M208 128l32 0L368 256 240 384l-32 0 0-256z']
      
    ]
  };

  
    var faCaretCircleRight = faCircleCaretRight;
  

  
  

  var faHands = {
    prefix: 'fasds',
    iconName: 'hands',
    icon: [
      576,
      512,
      ["sign-language","signing"],
      'f2a7',
      
      ['M144 155.4l12 20.8L174.3 208l28.2 0 14.2-22.7-19.1-33.1-12-20.8-41.6 24zm46.4-63.7l12 20.8 28.7 49.8 19.6-31.4 9.2-14.7-16-27.7-12-20.8-41.6 24zM236.7 28l12 20.8 39 67.5 7.1 4.4 27.1 17 60.2 37.6C443 213.4 480 280.2 480 352l0 8c0 5-.2 9.9-.6 14.7c39.6-24.5 64.4-68 64.5-115.6L544 160l0-32-64-.1 0 32 0 49.3-57.1-98.9c-16.5-28.6-33-57.1-49.5-85.7L361.4 4 319.8 28l12 20.8 49.5 85.7-20.8 12L290.3 24.8 278.3 4 236.7 28z','M305 164.9l-27.1-17-33.9 54.3 27.1 17L317.2 248 224 248s0 0 0 0L88 248l-24 0 0 48 24 0 136 0 0 24L56 320l-24 0 0 48 24 0 168 0 0 24L88 392l-24 0 0 48 24 0 136 0 0 24-104 0-24 0 0 48 24 0 176 0c83.9 0 152-68.1 152-152c0 0 0 0 0 0l0-8s0 0 0 0c0-60.8-31.3-117.3-82.9-149.5L305 164.9z']
      
    ]
  };

  
    var faSignLanguage = faHands;
  
    var faSigning = faHands;
  

  
  

  var faLifeRing = {
    prefix: 'fasds',
    iconName: 'life-ring',
    icon: [
      512,
      512,
      [],
      'f1cd',
      
      ['M0 256C0 196.9 20.3 142.5 53.9 99.2c1.1 1.1 2.3 2.3 3.4 3.4c37.3 37.3 74.7 74.7 112 112c-5.9 12.6-9.4 26.6-9.4 41.4s3.5 28.8 9.4 41.4l-112 112c-1.1 1.1-2.3 2.3-3.4 3.4C20.3 369.5 0 315.1 0 256zM99.2 53.9C142.5 20.3 196.9 0 256 0s113.5 20.3 156.8 53.9c-1.1 1.1-2.3 2.3-3.4 3.4c-37.3 37.3-74.6 74.7-112 112c-12.6-5.9-26.6-9.4-41.4-9.4s-28.8 3.5-41.4 9.4C177.3 132 140 94.7 102.6 57.4c-1.1-1.1-2.3-2.3-3.4-3.4zm0 404.1c1.1-1.1 2.3-2.3 3.4-3.4c37.3-37.3 74.6-74.7 112-112c12.6 5.9 26.5 9.4 41.4 9.4s28.8-3.5 41.4-9.4c37.3 37.4 74.6 74.7 112 112c1.1 1.1 2.3 2.3 3.4 3.4C369.5 491.7 315.1 512 256 512s-113.5-20.3-156.8-53.9zM342.6 214.6l112-112c1.1-1.1 2.3-2.3 3.4-3.4C491.7 142.5 512 196.9 512 256s-20.3 113.5-53.9 156.8c-1.1-1.1-2.3-2.3-3.4-3.4c-37.3-37.3-74.7-74.7-112-112c5.9-12.6 9.4-26.6 9.4-41.4s-3.5-28.8-9.4-41.4z','M80 34.7L34.7 80l22.6 22.6 112 112c9.5-19.8 25.5-35.8 45.3-45.3l-112-112L80 34.7zm89.4 262.6l-112 112L34.7 432 80 477.3l22.6-22.6 112-112c-19.8-9.5-35.8-25.5-45.3-45.3zm128 45.3l112 112L432 477.3 477.3 432l-22.6-22.6-112-112c-9.5 19.8-25.5 35.8-45.3 45.3zm45.3-128l112-112L477.3 80 432 34.7 409.4 57.4l-112 112c19.8 9.5 35.8 25.5 45.3 45.3z']
      
    ]
  };

  

  
  

  var faMoneyBill1Wave = {
    prefix: 'fasds',
    iconName: 'money-bill-1-wave',
    icon: [
      576,
      512,
      ["money-bill-wave-alt"],
      'f53b',
      
      ['M64 208l0 144c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.1c4.7-1.2 9.4-2.3 14.2-3.6c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4l0-144c-33.9 0-61.6-26.4-63.9-59.7c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208zm144 48c0-53 35.8-96 80-96s80 43 80 96s-35.8 96-80 96s-80-43-80-96z','M0 448L0 64c96 48 192 24 288 0s192-48 288 0l0 384c-96-48-192-24-288 0s-192 48-288 0zM448.1 100.3c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6c0 0 0 0 0 0c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208l0 144c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.1c4.7-1.2 9.4-2.3 14.2-3.6c0 0 0 0 0 0c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4l0-144c-33.9 0-61.6-26.3-63.9-59.7zM272 188l16 0 20 0 0 20 0 68 4 0 20 0 0 40-20 0-4 0-40 0-4 0-20 0 0-40 20 0 4 0 0-48-16 0 0-40 20 0z']
      
    ]
  };

  
    var faMoneyBillWaveAlt = faMoneyBill1Wave;
  

  
  

  var faEngine = {
    prefix: 'fasds',
    iconName: 'engine',
    icon: [
      640,
      512,
      [],
      'e16e',
      
      ['M0 136l0 24L0 352l0 24 48 0 0-24 0-72 48 0 0-48-48 0 0-72 0-24L0 136zM184 64l0 48 24 0 72 0 0 32 48 0 0-32 72 0 24 0 0-48-24 0L208 64l-24 0zM544 192l0 256 96 0 0-256-96 0z','M96 144l64 0 48 0 224 0 80 64 0 240-288 0-51.2-64L96 384l0-240zm128 80l-64 0 0 64 64 0 0-64zm96 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0z']
      
    ]
  };

  

  
  

  var faTire = {
    prefix: 'fasds',
    iconName: 'tire',
    icon: [
      512,
      512,
      [],
      'f631',
      
      ['M96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm32 0c0-36.8 15.5-69.9 40.3-93.3l28.1 38.7 10.1 13.9c-9.1 11-14.5 25.2-14.5 40.6c0 1.4 0 2.7 .1 4l-61.8 20.1c-1.5-7.8-2.3-15.9-2.3-24.2zm12.2 54.6l61.9-20.1c8.6 13.4 22.1 23.4 37.9 27.5l0 65c-44.2-5.5-81.5-33.6-99.8-72.4zm54-166.7C212.5 133.8 233.6 128 256 128s43.5 5.8 61.8 15.9l-38.2 52.6c-7.3-2.9-15.3-4.5-23.6-4.5s-16.3 1.6-23.6 4.5l-10-13.8-28.1-38.8zM288 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-16.1 62c15.9-4.1 29.4-14.1 38-27.6l61.9 20.1c-18.3 38.8-55.6 66.9-99.8 72.4l0-65zm33.5-102.6l38.2-52.6C368.5 186.1 384 219.2 384 256c0 8.3-.8 16.3-2.3 24.2L319.9 260c.1-1.3 .1-2.7 .1-4c0-15.4-5.5-29.6-14.5-40.6z','M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm416 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faScannerGun = {
    prefix: 'fasds',
    iconName: 'scanner-gun',
    icon: [
      576,
      512,
      ["scanner"],
      'f488',
      
      ['M0 144c0 50.9 33.9 93.8 80.3 107.5L0 392l136 80L261.4 256l90.6 0 0-224L112 32C50.1 32 0 82.1 0 144z','M416 32h160v64H416V32zm0 160h160v64H416v-64zm0 224h160v64H416v-64zm0-288h160v32H416v-32zm0 160h160v32H416v-32zm0 64h160v32H416v-32z']
      
    ]
  };

  
    var faScanner = faScannerGun;
  

  
  

  var faAlignRight = {
    prefix: 'fasds',
    iconName: 'align-right',
    icon: [
      448,
      512,
      [],
      'f038',
      
      ['M160 32l0 64 288 0 0-64L160 32zm0 256l0 64 288 0 0-64-288 0z','M448 480L0 480l0-64 448 0 0 64zm0-256L0 224l0-64 448 0 0 64z']
      
    ]
  };

  

  
  

  var faWindowFlip = {
    prefix: 'fasds',
    iconName: 'window-flip',
    icon: [
      512,
      512,
      ["window-alt"],
      'f40f',
      
      ['M0 224l512 0 0 256L0 480 0 224zM288 96l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M0 32l512 0 0 192L0 224 0 32zM384 96l0 64 64 0 0-64-64 0zm-32 0l-64 0 0 64 64 0 0-64zM192 96l0 64 64 0 0-64-64 0z']
      
    ]
  };

  
    var faWindowAlt = faWindowFlip;
  

  
  

  var faInputText = {
    prefix: 'fasds',
    iconName: 'input-text',
    icon: [
      640,
      512,
      [],
      'e1bf',
      
      ['M0 64l0 64L0 384l0 64 64 0 512 0 64 0 0-64 0-256 0-64-64 0L64 64 0 64zm64 64l512 0 0 256L64 384l0-256z','M195.4 160l-38.9 0-2.8 7.1-72 180-2 4.9 51.7 0 9.6-24 69.9 0 9.6 24 51.7 0-2-4.9-72-180-2.8-7.1zm-3.7 120l-31.5 0L176 240.6 191.8 280zM288 160l0 24 0 8 0 64 0 64 0 8 0 24 24 0 68 0c33.1 0 60-26.9 60-60c0-18.6-8.5-35.3-21.8-46.3c3.7-7.8 5.8-16.5 5.8-25.7c0-33.1-26.9-60-60-60l-52 0-24 0zm88 60c0 6.6-5.4 12-12 12l-28 0 0-24 28 0c6.6 0 12 5.4 12 12zm4 84l-44 0 0-24 28 0 16 0c6.6 0 12 5.4 12 12s-5.4 12-12 12z']
      
    ]
  };

  

  
  

  var faHandHoldingBox = {
    prefix: 'fasds',
    iconName: 'hand-holding-box',
    icon: [
      576,
      512,
      [],
      'f47b',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M224 0l0 128 64-32 64 32L352 0 480 0l0 256L96 256 96 0 224 0z']
      
    ]
  };

  

  
  

  var faDungeon = {
    prefix: 'fasds',
    iconName: 'dungeon',
    icon: [
      512,
      512,
      [],
      'f6d9',
      
      ['M176 208l0 16 0 240 0 16 32 0 0-16 0-240 0-16-32 0zm64-32l0 16 0 272 0 16 32 0 0-16 0-272 0-16-32 0zm64 32l0 16 0 240 0 16 32 0 0-16 0-240 0-16-32 0z','M319.3 144.7L367.1 25.3c37.9 18.3 70.6 45.6 95.3 79.2L355.7 175.7c-10-12.4-22.4-23-36.3-30.9zM337.5 13.2L289.8 132.5C279 129.6 267.7 128 256 128s-23 1.6-33.8 4.5L174.5 13.2C200.1 4.7 227.5 0 256 0s55.9 4.7 81.5 13.2zM49.6 104.5C74.3 70.9 107 43.6 144.9 25.3l47.8 119.4c-14 8-26.3 18.5-36.3 30.9L49.6 104.5zm322.9 98.4l107.2-71.5C500.3 168.3 512 210.8 512 256l-128 0c0-18.9-4.1-36.9-11.5-53.1zM32.3 131.4l107.2 71.5C132.1 219.1 128 237.1 128 256L0 256c0-45.2 11.7-87.7 32.3-124.6zM128 288l0 96L0 384l0-96 128 0zm256 0l128 0 0 96-128 0 0-96zM0 416l128 0 0 96L0 512l0-96zm384 0l128 0 0 96-128 0 0-96z']
      
    ]
  };

  

  
  

  var faRoadCircleExclamation = {
    prefix: 'fasds',
    iconName: 'road-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e565',
      
      ['M32 480l256 0 0-64 0-32 32.7 0c-.5-5.3-.7-10.6-.7-16c0-16.6 2.3-32.7 6.6-48L288 320l0-32 0-64 0-32 64 0 0 32 0 42.8c31.9-45.2 84.5-74.8 144-74.8c10.4 0 20.6 .9 30.5 2.6L480 32 352 32l0 64 0 32-64 0 0-32 0-64L160 32 32 480z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faPaperPlane = {
    prefix: 'fasds',
    iconName: 'paper-plane',
    icon: [
      512,
      512,
      [61913],
      'f1d8',
      
      ['M0 288l160 64L384 160 225.9 381.3l61.6 27.4L448 480 512 0 0 288z','M384 160L160 352l0 32 0 32 0 80 48 16 79.5-103.3-61.6-27.4L384 160z']
      
    ]
  };

  

  
  

  var faColumns3 = {
    prefix: 'fasds',
    iconName: 'columns-3',
    icon: [
      640,
      512,
      [],
      'e361',
      
      ['M192 96l64 0 0 320-64 0 0-320zm192 0l64 0 0 320-64 0 0-320z','M640 32L0 32 0 480l640 0 0-448zM576 96l0 320L64 416 64 96l512 0z']
      
    ]
  };

  

  
  

  var faRightLeft = {
    prefix: 'fasds',
    iconName: 'right-left',
    icon: [
      512,
      512,
      ["exchange-alt"],
      'f362',
      
      ['M0 384L128 256l32 0 0 96 320 0 32 0 0 64-32 0-320 0 0 96-32 0L0 384z','M512 128L384 0 352 0l0 96L32 96 0 96l0 64 32 0 320 0 0 96 32 0L512 128z']
      
    ]
  };

  
    var faExchangeAlt = faRightLeft;
  

  
  

  var faMessageDollar = {
    prefix: 'fasds',
    iconName: 'message-dollar',
    icon: [
      512,
      512,
      ["comment-alt-dollar"],
      'f650',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM182.7 280.7l19 6.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c.6-3.5 .9-6.9 .9-10.2c0-6.7-1.2-13.1-3.9-19.2c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3 0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16c.7 .2 1.5 .4 2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.1c-6.3-2.1-12.6-4.2-19-6.3c-4.2 12.6-8.4 25.3-12.6 38z','M276 92l0 20 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0z']
      
    ]
  };

  
    var faCommentAltDollar = faMessageDollar;
  

  
  

  var faGridHorizontal = {
    prefix: 'fasds',
    iconName: 'grid-horizontal',
    icon: [
      448,
      512,
      [],
      'e307',
      
      ['M0 288l128 0 0 128L0 416 0 288zM160 128l128 0 0 128-128 0 0-128zM320 288l128 0 0 128-128 0 0-128z','M0 128l128 0 0 128L0 256 0 128zM160 288l128 0 0 128-128 0 0-128zM448 128l0 128-128 0 0-128 128 0z']
      
    ]
  };

  

  
  

  var faCircleO = {
    prefix: 'fasds',
    iconName: 'circle-o',
    icon: [
      512,
      512,
      [],
      'e119',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm384 0a128 128 0 1 1 -256 0 128 128 0 1 1 256 0zm-208 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M256 176a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm128 80a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z']
      
    ]
  };

  

  
  

  var faScannerKeyboard = {
    prefix: 'fasds',
    iconName: 'scanner-keyboard',
    icon: [
      512,
      512,
      [],
      'f489',
      
      ['M0 96L0 512l352 0 0-416L0 96zm64 64l224 0 0 64L64 224l0-64zm0 128l96 0 0 64-96 0 0-64zm0 96l96 0 0 64-96 0 0-64zm128-96l96 0 0 64-96 0 0-64zm0 96l96 0 0 64-96 0 0-64z','M192 0l0 64-64 0 0-64 64 0zM352 0l0 64-64 0 0-64 64 0zM224 0l32 0 0 64-32 0 0-64zM416 0l0 288-32 0L384 0l32 0zm32 0l64 0 0 288-64 0L448 0zM288 160l0 64L64 224l0-64 224 0z']
      
    ]
  };

  

  
  

  var faHillRockslide = {
    prefix: 'fasds',
    iconName: 'hill-rockslide',
    icon: [
      576,
      512,
      [],
      'e508',
      
      ['M128 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM248 96l36 64 72 0 36-64L356 32l-72 0L248 96zM352 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 44l0 72 64 36 64-36 0-72-64-36-64 36z','M480 512H0V32L480 512z']
      
    ]
  };

  

  
  

  var faMaskFace = {
    prefix: 'fasds',
    iconName: 'mask-face',
    icon: [
      640,
      512,
      [],
      'e1d7',
      
      ['M0 128l0 24L0 344l0 18.7 18.2 4.5 180.7 45.2c-26.6-17.1-49.3-39.7-66.5-66.1L48 325.3 48 176l48 0 0-16 0-32-72 0L0 128zM441.1 412.5l180.7-45.2 18.2-4.5 0-18.7 0-192 0-24-24 0-72 0 0 32 0 16 48 0 0 149.3-84.3 21.1c-17.3 26.4-40 49-66.5 66.1z','M304 64l-9.7 0-8.1 5.4L198.3 128 128 128l-32 0 0 32 0 64c0 123.7 100.3 224 224 224s224-100.3 224-224l0-64 0-32-32 0-70.3 0L353.8 69.4 345.7 64 336 64l-32 0zM422.3 192l9.7 0 16 0 0 32-16 0-224 0-16 0 0-32 16 0 9.7 0 204.6 0zM192 256l16 0 224 0 16 0 0 32-16 0-224 0-16 0 0-32zm32 64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32z']
      
    ]
  };

  

  
  

  var faBottleDroplet = {
    prefix: 'fasds',
    iconName: 'bottle-droplet',
    icon: [
      320,
      512,
      [],
      'e4c4',
      
      ['M32 256l0 256 256 0 0-256c0-50.6-29.4-94.4-72-115.1L216 48c-37.3 0-74.7 0-112 0l0 92.9C61.4 161.6 32 205.4 32 256zm80 80c0-32 48-80 48-80s48 48 48 80s-21.5 48-48 48s-48-21.5-48-48z','M96 0L72 0l0 48 24 0 128 0 24 0 0-48L224 0 96 0zm64 384c26.5 0 48-16 48-48s-48-80-48-80s-48 48-48 80c0 26.5 21.5 48 48 48z']
      
    ]
  };

  

  
  

  var faTurnDownRight = {
    prefix: 'fasds',
    iconName: 'turn-down-right',
    icon: [
      512,
      512,
      [],
      'e455',
      
      ['M0 32L0 80 0 288l0 48 48 0 272 0 0-96L96 240 96 80l0-48L0 32z','M352 448L512 288 352 128l-32 0 0 320 32 0z']
      
    ]
  };

  

  
  

  var faFaceThinking = {
    prefix: 'fasds',
    iconName: 'face-thinking',
    icon: [
      512,
      512,
      [],
      'e39b',
      
      ['M0 256c0 45 11.6 87.3 32 124l0-28 0-56 112 0 0 56 0 3 108.9-39.6 11.2-4.1L155.5 279.3l-15.4-4.5 9-30.7 15.3 4.5 136 40 8.8 2.6 2.2 8.9 10.2 40.6 22.1 60.7-52.6 19.1-35.8 13-21 57.7c-2.5 6.8-5.8 13.1-9.8 18.8c10.3 1.3 20.8 1.9 31.4 1.9c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM106.2 106l13.9-7.9 7.1-4c35.2-20.1 79.3-15.9 110.1 10.5c4.4 3.8 8.8 7.5 13.2 11.3l12.1 10.4c-6.9 8.1-13.9 16.2-20.8 24.3c-4-3.5-8.1-6.9-12.1-10.4l-13.2-11.3c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4L122 133.8 106.2 106zm102.2 70a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M216.4 128.8l13.2 11.3 12.1 10.4 20.8-24.3-12.1-10.4-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4L106.2 106 122 133.8l13.9-7.9 7.1-4c23.5-13.4 52.9-10.6 73.4 7zm-40 79.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 352l0-24-48 0 0 24 0 136 0 24 24 0 88 0 16.8 0 5.7-15.8 31.8-87.5 49.8-18.1 22.6-8.2-16.4-45.1-22.6 8.2L112 400.6l0-48.6z']
      
    ]
  };

  

  
  

  var faShare = {
    prefix: 'fasds',
    iconName: 'share',
    icon: [
      512,
      512,
      ["mail-forward"],
      'f064',
      
      ['M0 304C0 432 128 480 128 480s-32-32-32-80c0-61.9 50.1-112 112-112l80 0 0-160-112 0C78.8 128 0 206.8 0 304z','M320 384L512 208 320 32l-32 0 0 352 32 0z']
      
    ]
  };

  
    var faMailForward = faShare;
  

  
  

  var faDownLeft = {
    prefix: 'fasds',
    iconName: 'down-left',
    icon: [
      384,
      512,
      [],
      'e16a',
      
      ['M152 216L304 64l80 80L232 296l-80-80z','M16 432V144l32-32L336 400l-32 32H16z']
      
    ]
  };

  

  
  

  var faDatabase = {
    prefix: 'fasds',
    iconName: 'database',
    icon: [
      448,
      512,
      [],
      'f1c0',
      
      ['M0 80l0 32 0 16 0 16 128 80 192 0 128-80 0-16 0-16 0-32L320 0 128 0 0 80zM0 181.7L0 288l0 16 128 80 192 0 128-80 0-16 0-106.3L329.2 256l-210.4 0L0 181.7zm0 160L0 432l128 80 192 0 128-80 0-90.3L329.2 416l-210.4 0L0 341.7z','M448 341.7l0-37.7L320 384l-192 0L0 304l0 37.7L118.8 416l210.4 0L448 341.7zm0-160l0-37.7L320 224l-192 0L0 144l0 37.7L118.8 256l210.4 0L448 181.7z']
      
    ]
  };

  

  
  

  var faNoteMedical = {
    prefix: 'fasds',
    iconName: 'note-medical',
    icon: [
      448,
      512,
      [],
      'e200',
      
      ['M0 32l448 0 0 288-32 0-32 0-96 0 0 96 0 32 0 32L0 480 0 32zM128 192l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0z','M192 128l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64zm96 288l0-96 96 0 32 0 32 0 0 16 0 13.3-9.4 9.4-112 112-9.4 9.4L304 480l-16 0 0-32 0-32z']
      
    ]
  };

  

  
  

  var faTriangleExclamation = {
    prefix: 'fasds',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      ['M0 480l512 0L256 32 0 480zM232 192l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M280 216l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faSnake = {
    prefix: 'fasds',
    iconName: 'snake',
    icon: [
      512,
      512,
      [128013],
      'f716',
      
      ['M32 208c0-5.4 .3-10.7 .9-16L80 192l16 0 0 32-16 0-47.1 0c-.6-5.3-.9-10.6-.9-16zm31.5-89.9c6.7-8.4 14.3-15.9 22.6-22.6l21.2 21.2L118.6 128 96 150.6 84.7 139.3 63.5 118.1zm0 179.8l21.2-21.2L96 265.4 118.6 288l-11.3 11.3L86.1 320.5c-8.4-6.7-15.9-14.3-22.6-22.6zM64 432l32-16 0 48 0 16-32 0 0-16 0-32zM160 64.9c5.3-.6 10.6-.9 16-.9l16 0 0 48 0 16-32 0 0-16 0-47.1zM160 288l32 0 0 16 0 48-16 0c-5.4 0-10.7-.3-16-.9l0-47.1 0-16zm0 128l32 0 0 48 0 16-32 0 0-16 0-48zM256 64l32 0 0 48 0 16-32 0 0-16 0-48zm0 224l32 0 0 16 0 48-32 0 0-48 0-16zm0 128l32 0 0 48 0 16-32 0 0-16 0-48zm72.3-62.9l28.4-28.4L368 313.4 390.6 336l-11.3 11.3-28.4 28.4c-2.9-11-11.6-19.7-22.6-22.6zm0 61.8c11-2.9 19.7-11.6 22.6-22.6l28.4 28.4L390.6 432 368 454.6l-11.3-11.3-28.4-28.4z','M352 16L512 80l0 64L352 208l-64-48-112 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l144 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-144 0-.1 0L96 512 0 464l64-32 0 32 0 16 32 0 0-16 0-48 64 0 0 48 0 16 32 0 0-16 0-48 64 0 0 48 0 16 32 0 0-16 0-48 32 0c2.9 0 5.6-.4 8.3-1.1l28.4 28.4L368 454.6 390.6 432l-11.3-11.3-28.4-28.4c.7-2.6 1.1-5.4 1.1-8.3s-.4-5.6-1.1-8.3l28.4-28.4L390.6 336 368 313.4l-11.3 11.3-28.4 28.4c-2.6-.7-5.4-1.1-8.3-1.1l-32 0 0-48 0-16-32 0 0 16 0 48-64 0 0-48 0-16-32 0 0 16 0 47.1c-27.8-3.1-53.2-14-73.9-30.6l21.2-21.2L118.6 288 96 265.4 84.7 276.7 63.5 297.9C46.9 277.2 35.9 251.8 32.9 224L80 224l16 0 0-32-16 0-47.1 0c3.1-27.8 14-53.2 30.6-73.9l21.2 21.2L96 150.6 118.6 128l-11.3-11.3L86.1 95.5c20.7-16.6 46.1-27.5 73.9-30.6l0 47.1 0 16 32 0 0-16 0-48 64 0 0 48 0 16 32 0 0-16 0-48 64-48zm16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faHandcuffs = {
    prefix: 'fasds',
    iconName: 'handcuffs',
    icon: [
      640,
      512,
      [],
      'e4f8',
      
      ['M130.7 160L160 130.7 189.3 160l-58.5 0zm17-81.4l53.7-34.9 34.9 53.7-53.7 34.9L147.7 78.6zM234.9 14L298 2.9l11.1 63L246 77.1 234.9 14zm96 51.9L342 2.9l63 11.1L394 77.1 330.9 66zm72.8 31.5l34.9-53.7 53.7 34.9-34.9 53.7L403.7 97.4zm47 62.6L480 130.7 509.3 160l-58.5 0z','M96 160l128 0 0 45.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7L96 160zm64 288a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.8-32.7 44.5-58.8 78.4-73.6l0-45.3 128 0 0 45.3c56.5 24.7 96 81.1 96 146.7c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z']
      
    ]
  };

  

  
  

  var faInhaler = {
    prefix: 'fasds',
    iconName: 'inhaler',
    icon: [
      576,
      512,
      [],
      'f5f9',
      
      ['M0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 352zm0 96a32 32 0 1 0 64 0A32 32 0 1 0 0 448zM96 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM385.7 145.7c44.4 44.4 88.8 88.8 133.2 133.2L576 72 416 32 385.7 145.7z','M536.6 296.6L364.2 124.2 337.3 224 192 224l0 256 294.6 0 50-183.4z']
      
    ]
  };

  

  
  

  var faBookJournalWhills = {
    prefix: 'fasds',
    iconName: 'book-journal-whills',
    icon: [
      448,
      512,
      ["journal-whills"],
      'f66a',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zm37.1 160.4l21.2 21.3 11.2-11.3-26.4-26.5c10-20.8 26.3-38 46.4-49.2c-17 27.1-11 62.7 14 82.6c-14.1 14.7-19.1 35.9-13.1 55.2c5.9 19.4 22 34.1 41.9 38.2l1.4-32.7-9.6 7.1-5.8-5.4 7.9-14.2-18-3.8 0-7.9 18-3.8-8.6-14.2 5.8-5.4 12 8.1L236 84.2l8 0 4.8 116 14.1-9.6 5.6 5.4L260 210.1l18 3.8 0 7.9-18 3.6 8.5 14.4-5.6 5.4-12.6-8.6 1.4 34.2c19.9-4.1 36-18.9 41.9-38.2c6-19.4 1-40.6-13.1-55.2c25-19.9 31-55.5 14-82.6c20.2 11.2 36.4 28.5 46.4 49.2l-26.4 26.5 11.3 11.3 21.2-21.3c3 10.1 5.1 20.6 5.1 31.6c0 .3 0 .5-.1 .8s-.1 .5-.1 .8L314.8 226l10.5 12 23.6-20.6C337.3 267 293.1 304 240 304s-97.2-37-108.9-86.6L154.8 238l10.5-12-37.1-32.5c0-.2 0-.5-.1-.8s-.1-.5-.1-.8c0-11 2.1-21.5 5.1-31.6z']
      
    ]
  };

  
    var faJournalWhills = faBookJournalWhills;
  

  
  

  var faBookOpen = {
    prefix: 'fasds',
    iconName: 'book-open',
    icon: [
      576,
      512,
      [128214,128366],
      'f518',
      
      ['M288 72c16-16 80-40 144-40s122.7 21.3 144 32l0 416c-21.3-10.7-92.8-32-144-32s-144 32-144 32l0-408z','M288 72V480s-92.8-32-144-32S21.3 469.3 0 480V64C21.3 53.3 80 32 144 32s128 24 144 40z']
      
    ]
  };

  

  
  

  var faChevronsRight = {
    prefix: 'fasds',
    iconName: 'chevrons-right',
    icon: [
      512,
      512,
      ["chevron-double-right"],
      'f324',
      
      ['M18.7 64L41.4 86.6 210.7 256 41.4 425.4 18.7 448 64 493.3l22.6-22.6 192-192L301.3 256l-22.6-22.6-192-192L64 18.7 18.7 64z','M493.3 256l-22.6 22.6-192 192L256 493.3 210.7 448l22.6-22.6L402.7 256 233.4 86.6 210.7 64 256 18.7l22.6 22.6 192 192L493.3 256z']
      
    ]
  };

  
    var faChevronDoubleRight = faChevronsRight;
  

  
  

  var faCorner = {
    prefix: 'fasds',
    iconName: 'corner',
    icon: [
      448,
      512,
      [],
      'e3fe',
      
      ['M0 160l32 0 384 0 32 0 0 32 0 160 0 32-64 0 0-32 0-128L32 224 0 224l0-64z','']
      
    ]
  };

  

  
  

  var faBahtSign = {
    prefix: 'fasds',
    iconName: 'baht-sign',
    icon: [
      320,
      512,
      [],
      'e0ac',
      
      ['M112 0l0 64 64 0 0-64L112 0zm0 128l0 96 64 0 0-96-64 0zm0 160l0 96 64 0 0-96-64 0zm0 160l0 64 64 0 0-64-64 0z','M64 128l0 96 112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 128zM0 224l0-96L0 64l64 0 112 0c61.9 0 112 50.1 112 112c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112L64 448 0 448l0-64 0-96 0-64zm176 64L64 288l0 96 144 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z']
      
    ]
  };

  

  
  

  var faCowbell = {
    prefix: 'fasds',
    iconName: 'cowbell',
    icon: [
      448,
      512,
      [],
      'f8b3',
      
      ['M0 448l160 0 128 0 160 0L384 96l-64 0 0-72 0-24L296 0 152 0 128 0l0 24 0 72L64 96 0 448zM176 48l96 0 0 48-96 0 0-48z','M224 512c35.3 0 64-28.7 64-64H160c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faLightbulbDollar = {
    prefix: 'fasds',
    iconName: 'lightbulb-dollar',
    icon: [
      384,
      512,
      [],
      'f670',
      
      ['M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176zm102.7 88.7l12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3z','M112 384V512H272V384H112z']
      
    ]
  };

  

  
  

  var faTireRugged = {
    prefix: 'fasds',
    iconName: 'tire-rugged',
    icon: [
      512,
      512,
      [],
      'f634',
      
      ['M128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm82.3-14.8a24 24 0 1 1 -45.7-14.8 24 24 0 1 1 45.7 14.8zm22.7 87.2a24 24 0 1 1 -38.8-28.2 24 24 0 1 1 38.8 28.2zM280 184a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm37.7 116.1a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zm29.6-73.8a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8z','M192 0L320 0l0 41.3c14.9 4.4 29.1 10.4 42.6 17.6l29.2-29.2 90.5 90.5-29.2 29.2c7.3 13.4 13.2 27.7 17.6 42.6l41.3 0 0 128-41.3 0c-4.4 14.9-10.4 29.1-17.6 42.6l29.2 29.2-90.5 90.5-29.2-29.2c-13.4 7.3-27.7 13.2-42.6 17.6l0 41.3-128 0 0-41.3c-14.9-4.4-29.1-10.4-42.6-17.6l-29.2 29.2L29.7 391.8l29.2-29.2c-7.3-13.4-13.2-27.7-17.6-42.6L0 320 0 192l41.3 0c4.4-14.9 10.4-29.1 17.6-42.6L29.7 120.2l90.5-90.5 29.2 29.2c13.4-7.3 27.7-13.2 42.6-17.6L192 0zM384 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z']
      
    ]
  };

  

  
  

  var faRectangleXmark = {
    prefix: 'fasds',
    iconName: 'rectangle-xmark',
    icon: [
      512,
      512,
      [62164,"rectangle-times","times-rectangle","window-close"],
      'f410',
      
      ['M0 32L0 480l512 0 0-448L0 32zM158.1 192c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.3-31.3 47-47c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c5.7 5.7 11.3 11.3 17 17L320 353.9l-17-17-47-47c-15.7 15.7-31.3 31.3-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-5.7-5.7-11.3-11.3-17-17z','M337 209l17-17L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faRectangleTimes = faRectangleXmark;
  
    var faTimesRectangle = faRectangleXmark;
  
    var faWindowClose = faRectangleXmark;
  

  
  

  var faHandBackPointRibbon = {
    prefix: 'fasds',
    iconName: 'hand-back-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a0',
      
      ['M32 304l0 68c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L304 512c70.7 0 128-57.3 128-128l0-16 0-48 0-80-80 0 0-32-80 0 0-32-80 0 0-16-80 0 0 64 0 13.3 0 2.7 0 80 0 16-32 0 0-16 0-56L32 304zM112 0l0 32 80 0 0-32L112 0z','M208 128V32H32L75.6 80 32 128H208z']
      
    ]
  };

  

  
  

  var faCartFlatbedSuitcase = {
    prefix: 'fasds',
    iconName: 'cart-flatbed-suitcase',
    icon: [
      640,
      512,
      ["luggage-cart"],
      'f59d',
      
      ['M160 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48zM192 96l64 0 0 224-64 0 0-224zM288 0l24 0L456 0l24 0 0 24 0 72 0 224-192 0 0-224 0-72 0-24zm48 48l0 48 96 0 0-48-96 0zM448 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48zM512 96l64 0 0 224-64 0 0-224z','M32 0L0 0 0 64l32 0 32 0 0 352 0 32 32 0 512 0 32 0 0-64-32 0-480 0 0-352 0-32L96 0 32 0zM256 96l0 224 32 0 0-224-32 0zm224 0l0 224 32 0 0-224-32 0z']
      
    ]
  };

  
    var faLuggageCart = faCartFlatbedSuitcase;
  

  
  

  var faEarthEurope = {
    prefix: 'fasds',
    iconName: 'earth-europe',
    icon: [
      512,
      512,
      ["globe-europe"],
      'f7a2',
      
      ['M0 256C0 397.4 114.6 512 256 512c5.4 0 10.7-.2 16-.5l0-79.5-64 0-48-48 0-112c48 0 96 0 144 0c16 16 32 32 48 48c10.7 0 21.3 0 32 0c10.7 10.7 21.3 21.3 32 32l32 0 0 32-64 64 0 29.8c58.7-33.9 102.6-90.5 119.9-157.8c-24 0-48 0-71.9 0c-16-16-32-32-48-48l0-80c10.7 0 21.3 0 32 0l0-32c-21.3 0-42.7 0-64 0l0 48c-26.7 0-53.3 0-80 0c-5.3 0-10.7 0-16 0l0 32c-21.3 0-42.7 0-64 0l0-32c26.7-26.7 53.3-53.3 80-80l0-16c-16 0-32 0-48 0l0-32c25.4-25.4 50.8-50.8 76.2-76.2C285.8 1.3 271.1 0 256 0C114.6 0 0 114.6 0 256zM121.4 144c3.8-3.8 7.5-7.5 11.3-11.3c10.7-10.7 21.3-21.3 32-32c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-10.7 10.7-21.3 21.3-32 32c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6z','M352 160l64 0 0 32-32 0 0 80 48 48 71.9 0c5.3-20.5 8.1-41.9 8.1-64C512 129.7 420.5 24.7 300.2 3.8L224 80l0 32 48 0 0 16-80 80 0 32 64 0 0-32 16 0 80 0 0-48zm32 317.8l0-29.8 64-64 0-32-32 0-32-32-32 0-48-48-144 0 0 112 48 48 64 0 0 79.5c40.6-2.5 78.7-14.5 112-33.8zM198.6 112L176 89.4l-11.3 11.3-32 32L121.4 144 144 166.6l11.3-11.3 32-32L198.6 112z']
      
    ]
  };

  
    var faGlobeEurope = faEarthEurope;
  

  
  

  var faPrintSlash = {
    prefix: 'fasds',
    iconName: 'print-slash',
    icon: [
      640,
      512,
      [],
      'f686',
      
      ['M64 192l0 192 64 0 0 96 0 32 32 0 320 0 32 0 0-12.6L446.8 448 192 448l0-64 0-16 0-16 132.9 0L121.8 192 96 192l-32 0zM128 0l0 32 0 44.6 64 49.7L192 64l226.7 0L448 93.3l0 66.7 64 0 0-80 0-13.3-9.4-9.4-48-48L445.3 0 432 0 160 0 128 0zM276.6 192c82.4 64 164.9 128 247.3 192l52.1 0 0-192-299.4 0zM472 248l48 0 0 48-48 0 0-48z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faRug = {
    prefix: 'fasds',
    iconName: 'rug',
    icon: [
      640,
      512,
      [],
      'e569',
      
      ['M80 64l0 24 0 64 0 48 0 32 0 48 0 32 0 48 0 64 0 24 80 0 0-384L80 64zm112 0l0 384 256 0 0-384L192 64zm288 0l0 384 80 0 0-24 0-64 0-48 0-32 0-48 0-32 0-48 0-64 0-24-80 0z','M24 64L0 64l0 48 24 0 8 0 0 40-8 0L0 152l0 48 24 0 8 0 0 32-8 0L0 232l0 48 24 0 8 0 0 32-8 0L0 312l0 48 24 0 8 0 0 40-8 0L0 400l0 48 24 0 32 0 24 0 0-24 0-64 0-48 0-32 0-48 0-32 0-48 0-64 0-24L56 64 24 64zm592 0l-32 0-24 0 0 24 0 64 0 48 0 32 0 48 0 32 0 48 0 64 0 24 24 0 32 0 24 0 0-48-24 0-8 0 0-40 8 0 24 0 0-48-24 0-8 0 0-32 8 0 24 0 0-48-24 0-8 0 0-32 8 0 24 0 0-48-24 0-8 0 0-40 8 0 24 0 0-48-24 0zM160 64l0 384 32 0 0-384-32 0zm320 0l-32 0 0 384 32 0 0-384z']
      
    ]
  };

  

  
  

  var faUserTag = {
    prefix: 'fasds',
    iconName: 'user-tag',
    icon: [
      640,
      512,
      [],
      'f507',
      
      ['M0 512l448 0-8.3-27.1L320 365.3l0-61.3L64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M640 384L512 512 352 352l0-96 32-32 96 0L640 384zM432 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faImagePortrait = {
    prefix: 'fasds',
    iconName: 'image-portrait',
    icon: [
      384,
      512,
      ["portrait"],
      'f3e0',
      
      ['M0 0L0 512l384 0L384 0 0 0zM80 384l32-96 160 0 32 96L80 384zM256 192a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM304 384l-32-96-160 0L80 384l224 0z']
      
    ]
  };

  
    var faPortrait = faImagePortrait;
  

  
  

  var faPersonFalling = {
    prefix: 'fasds',
    iconName: 'person-falling',
    icon: [
      512,
      512,
      [],
      'e546',
      
      ['M64 80a48 48 0 1 0 96 0A48 48 0 1 0 64 80z','M320 32l0-32L256 0l0 32 0 76.2L113.7 179.4 96 188.2 96 208l0 144 0 32 64 0 0-32 0-109.8L317.1 484.9l17.4 26.9L388.2 477l-17.4-26.9L286.6 320l1.4 0 96 0 38.4 51.2 19.2 25.6 51.2-38.4-19.2-25.6-48-64L416 256l-16 0-95.5 0L252 181.8l50.3-25.2 17.7-8.8 0-19.8 0-96z']
      
    ]
  };

  

  
  

  var faBriefcase = {
    prefix: 'fasds',
    iconName: 'briefcase',
    icon: [
      512,
      512,
      [128188],
      'f0b1',
      
      ['M0 288L0 480l512 0 0-192-192 0 0 64-128 0 0-64L0 288z','M152 0L128 0l0 24 0 72L0 96 0 288l512 0 0-192L384 96l0-72 0-24L360 0 152 0zM336 96L176 96l0-48 160 0 0 48z']
      
    ]
  };

  

  
  

  var faPotFood = {
    prefix: 'fasds',
    iconName: 'pot-food',
    icon: [
      640,
      512,
      [127858],
      'e43f',
      
      ['M64 0l0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C117.5 129.3 128 141.5 128 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C122.5 62.7 112 50.5 112 24l0-24L64 0zM176 0l0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C229.5 129.3 240 141.5 240 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C234.5 62.7 224 50.5 224 24l0-24L176 0zM320 224l224 0c0-61.9-50.1-112-112-112s-112 50.1-112 112z','M64 224l512 0-1.9 32 17.9 0 32 0 0 64-32 0-24.4 0C552.9 387.5 507.9 443.2 448 472.9l0 39.1-256 0 0-39.1C132.1 443.2 87.1 387.5 72.4 320L48 320l-32 0 0-64 32 0 17.9 0L64 224z']
      
    ]
  };

  

  
  

  var faCloudMoon = {
    prefix: 'fasds',
    iconName: 'cloud-moon',
    icon: [
      640,
      512,
      [],
      'f6c3',
      
      ['M320 192.2c0 11.4 1.1 22.6 3.2 33.4c51 8.8 90.3 52.1 92.7 105.1c16.3 7.7 30.4 19.2 41.2 33.4c12.4 2.8 25.4 4.3 38.7 4.3c56.6 0 106.9-26.8 139.1-68.4c-14.6 5-30.3 7.7-46.7 7.7c-79.5 0-144-64.5-144-144c0-66.5 45-122.4 106.2-139C533.2 19 514.8 16 495.8 16C398.7 16 320 94.9 320 192.2z','M367.9 511.9l80 0 0-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 242.6 210.8 224 176 224c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6l0 96 96 0 271.9 0z']
      
    ]
  };

  

  
  

  var faLocationPen = {
    prefix: 'fasds',
    iconName: 'location-pen',
    icon: [
      384,
      512,
      ["map-marker-edit"],
      'f607',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm96 96.1l7.9-55.3c28.4-28.4 56.8-56.8 85.2-85.2c15.8 15.8 31.6 31.6 47.3 47.3c-28.4 28.4-56.8 56.8-85.2 85.2c-18.4 2.6-36.8 5.3-55.3 7.9zM211.7 125.1c9.7-9.7 19.4-19.4 29.1-29.1l47.3 47.3L259 172.4l-47.3-47.3z','M288.1 143.4L240.8 96l-29.1 29.1L259 172.4l29.1-29.1zM236.4 195l-47.3-47.3-85.2 85.2L96 288.1l55.3-7.9L236.4 195z']
      
    ]
  };

  
    var faMapMarkerEdit = faLocationPen;
  

  
  

  var faSlashForward = {
    prefix: 'fasds',
    iconName: 'slash-forward',
    icon: [
      320,
      512,
      [],
      '2f',
      
      ['M319.9 0L248.8 0 .1 512l71.2 0L319.9 0z','']
      
    ]
  };

  

  
  

  var faShieldQuartered = {
    prefix: 'fasds',
    iconName: 'shield-quartered',
    icon: [
      512,
      512,
      [],
      'e575',
      
      ['M17.3 113c-1.7 29.7 .3 68.6 9.1 111c76.6 0 153.1 0 229.7 0c0-74.6 0-149.1 0-223.7L245.1 4.5 37.6 85 18.5 92.5 17.3 113zM256.7 224c0 95.9 0 191.8 0 287.7l12-5.2c98.4-42.6 156.7-117.3 189.4-192.6c13.2-30.3 22.3-60.9 28.3-89.9c-76.6 0-153.1 0-229.7 0z','M256.7 0s0 0 0 0l11.6 4.5L475.8 85 495 92.5l1.2 20.5c1.7 29.7-.3 68.6-9 111l-230.4 0 0-224zM53.9 313.9C40.7 283.6 31.6 253 25.6 224L256 224l0 288s0 0 0 0l-12.7-5.5C144.9 463.9 86.5 389.2 53.9 313.9z']
      
    ]
  };

  

  
  

  var faHandFist = {
    prefix: 'fasds',
    iconName: 'hand-fist',
    icon: [
      448,
      512,
      [9994,"fist-raised"],
      'f6de',
      
      ['M32 176l0 77.7c0 42.4 16.9 83.1 46.9 113.1l2.3 2.3c13.7 13.7 29.6 24.6 46.9 32.5L128 512l224 0 0-128c38.9-29.2 64-75.7 64-128l-96 0 0-32-64 0 0 48 0 16-16 0-112 0-16 0 0-32 16 0 96 0 0-32 0-48L32 176z','M160 0l0 144 64 0L224 0 160 0zM128 32L64 32l0 112 64 0 0-112zm192 0l-64 0 0 160 64 0 0-160zm96 64l-64 0 0 128 64 0 0-128z']
      
    ]
  };

  
    var faFistRaised = faHandFist;
  

  
  

  var faAirplay = {
    prefix: 'fasds',
    iconName: 'airplay',
    icon: [
      576,
      512,
      [],
      'e089',
      
      ['M0 32L0 96 0 352l0 64 64 0 33.9 0 8.7-7.8L169 352 64 352 64 96l448 0 0 256-105 0 62.5 56.2 8.7 7.8 33.9 0 64 0 0-64 0-256 0-64-64 0L64 32 0 32z','M128 432L288 288 448 432v48H128V432z']
      
    ]
  };

  

  
  

  var faLamp = {
    prefix: 'fasds',
    iconName: 'lamp',
    icon: [
      448,
      512,
      [],
      'f4ca',
      
      ['M96 432c0 48 32 80 32 80l192 0s32-32 32-80c0-61.5-64-128-64-128l0-48-128 0 0 48s-64 66.5-64 128z','M0 256L96 0H352l96 256H0z']
      
    ]
  };

  

  
  

  var faArrowsSplitUpAndLeft = {
    prefix: 'fasds',
    iconName: 'arrows-split-up-and-left',
    icon: [
      512,
      512,
      [],
      'e4bc',
      
      ['M194.7 128L240 173.3l22.6-22.6L288 125.3 288 256l32 0c10.7 0 21.3 0 32 0l0-130.7 25.4 25.4L400 173.3 445.3 128l-22.6-22.6-80-80L320 2.7 297.4 25.4l-80 80L194.7 128z','M173.3 208l-22.6 22.6L125.3 256 320 256l32 0 0 32 0 160 128 0 32 0 0 64-32 0-160 0-32 0 0-32 0-160-162.7 0 25.4 25.4L173.3 368 128 413.3l-22.6-22.6-80-80L2.7 288l22.6-22.6 80-80L128 162.7 173.3 208z']
      
    ]
  };

  

  
  

  var faSquareW = {
    prefix: 'fasds',
    iconName: 'square-w',
    icon: [
      448,
      512,
      [],
      'e285',
      
      ['M0 32L0 480l448 0 0-448L0 32zM70.5 152l50 0 40.7 141.5 39.9-124.8 5.3-16.7 35 0 5.3 16.7 39.9 124.8L327.5 152l50 0L311.1 382.6l-5 17.4-35.6 0-5.3-16.7L224 254.7 182.9 383.3 177.5 400l-35.6 0-5-17.4L70.5 152z','M327.5 152l50 0L311.1 382.6l-5 17.4-35.6 0-5.3-16.7L224 254.7 182.9 383.3 177.5 400l-35.6 0-5-17.4L70.5 152l50 0 40.7 141.5 39.9-124.8 5.3-16.7 35 0 5.3 16.7 39.9 124.8L327.5 152z']
      
    ]
  };

  

  
  

  var faTruckArrowRight = {
    prefix: 'fasds',
    iconName: 'truck-arrow-right',
    icon: [
      640,
      512,
      [],
      'e58b',
      
      ['M72 152l0 48 24 0 166.1 0-39 39-17 17L240 289.9l17-17 80-80 17-17-17-17L257 79l-17-17L206.1 96l17 17 39 39L96 152l-24 0zM96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M0 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 64 32 0 0 64-32 0-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L0 416 0 0zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM257 79l-17-17L206.1 96l17 17 39 39L96 152l-24 0 0 48 24 0 166.1 0-39 39-17 17L240 289.9l17-17 80-80 17-17-17-17L257 79z']
      
    ]
  };

  

  
  

  var faDiagramSuccessor = {
    prefix: 'fasds',
    iconName: 'diagram-successor',
    icon: [
      512,
      512,
      [],
      'e47a',
      
      ['M0 32L0 224l288 0 0-128 96 0 0 32-64 0 0 32 96 96 96-96 0-32-64 0 0-64 0-32-32 0L288 32l-80 0L0 32z','M512 480l0-192L0 288 0 480l512 0z']
      
    ]
  };

  

  
  

  var faCartFlatbedBoxes = {
    prefix: 'fasds',
    iconName: 'cart-flatbed-boxes',
    icon: [
      640,
      512,
      ["dolly-flatbed-alt"],
      'f475',
      
      ['M160 464c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16zM192 32l0 288 192 0 0-288L192 32zm224 0l0 128 128 0 0-128L416 32zm0 160l0 128 192 0 0-128-192 0zm32 272c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16z','M0 0L32 0 96 0l32 0 0 32 0 352 480 0 32 0 0 64-32 0L96 448l-32 0 0-32L64 64 32 64 0 64 0 0z']
      
    ]
  };

  
    var faDollyFlatbedAlt = faCartFlatbedBoxes;
  

  
  

  var faAngleLeft = {
    prefix: 'fasds',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      ['M18.7 256l22.6-22.6 160-160L224 50.7 269.3 96l-22.6 22.6L109.3 256 246.6 393.4 269.3 416 224 461.3l-22.6-22.6-160-160L18.7 256z','']
      
    ]
  };

  

  
  

  var faBuildings = {
    prefix: 'fasds',
    iconName: 'buildings',
    icon: [
      512,
      512,
      [],
      'e0cc',
      
      ['M0 128L0 512l192 0 320 0 0-384L512 0 192 0l0 128L0 128zm64 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zM256 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zM384 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M256 64l64 0 0 64-64 0 0-64zM128 192l0 64-64 0 0-64 64 0zM320 320l-64 0 0-64 64 0 0 64zM128 288l0 64-64 0 0-64 64 0zm256 32l0-64 64 0 0 64-64 0zM448 64l0 64-64 0 0-64 64 0zM256 224l0-64 64 0 0 64-64 0zm192 0l-64 0 0-64 64 0 0 64z']
      
    ]
  };

  

  
  

  var faHouseCircleCheck = {
    prefix: 'fasds',
    iconName: 'house-circle-check',
    icon: [
      640,
      512,
      [],
      'e509',
      
      ['M0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 96.7 0c8.1-89.7 83.5-160 175.3-160c8.3 0 16.5 .6 24.5 1.7L288.4 0 0 240z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faSwordLaser = {
    prefix: 'fasds',
    iconName: 'sword-laser',
    icon: [
      512,
      512,
      [],
      'e03b',
      
      ['M206.3 247.7L480 0l32 32L264.3 305.7l-58.1-58.1z','M195.3 236.7l80 80L286.6 328 264 350.6 161.4 248 184 225.4l11.3 11.3zm46.1 113.9l-23.7 23.7-80-80 23.7-23.7 80 80zm-35 35l-20.7 20.7-80-80 20.7-20.7 80 80zM0 416l80-80 96 96L96 512l-48 0L32 496 0 464l0-48z']
      
    ]
  };

  

  
  

  var faTomato = {
    prefix: 'fasds',
    iconName: 'tomato',
    icon: [
      512,
      512,
      [],
      'e330',
      
      ['M0 304C0 434.9 114.6 512 256 512s256-77.1 256-208c0-77.8-40.5-136.7-103.2-171.6c-13.6 3.9-27.2 7.7-40.8 11.6c5.3 16 10.7 32 16 48c-42.7-16-85.3-32-128-48c-42.7 16-85.3 32-128 48c5.3-16 10.7-32 16-48c-13.6-3.9-27.2-7.7-40.8-11.6C40.5 167.3 0 226.2 0 304z','M250.6 20L235.4 1.4 198.2 31.8l15.1 18.5 .1 .2c.1 .2 .4 .5 .7 .9c.7 .9 1.7 2.3 3 4.2c2.6 3.7 6 9.2 9.5 15.9c1.6 3 3.1 6.2 4.5 9.6C147.8 88.1 87.5 128 87.5 128L144 144l-16 48 128-48s0 0 0 0l128 48-16-48 56.5-16s-59.6-39.5-142.4-46.8c-3.6-12.2-8.3-22.9-12.8-31.7c-4.5-8.8-9.1-16-12.5-21c-1.7-2.5-3.2-4.5-4.3-6c-.5-.7-1-1.3-1.3-1.7l-.4-.5-.1-.2c0 0 0 0-.1-.1c0 0 0 0 0 0s0 0 0 0L232 35.2 250.6 20z']
      
    ]
  };

  

  
  

  var faBatteryThreeQuarters = {
    prefix: 'fasds',
    iconName: 'battery-three-quarters',
    icon: [
      576,
      512,
      ["battery-4"],
      'f241',
      
      ['M0 96l64 0 416 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0L64 416 0 416l0-64L0 160 0 96zm64 64l0 192 416 0 0-192L64 160z','M96 192h256v128H96V192z']
      
    ]
  };

  
    var faBattery4 = faBatteryThreeQuarters;
  

  
  

  var faCheck = {
    prefix: 'fasds',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      ['M448.1 142l-23 22.2L186.7 394.6l-22.2 21.5-22.2-21.5L23 279.4 0 257.2l44.5-46 23 22.2 97 93.7L380.6 118.2l23-22.2 44.5 46z','']
      
    ]
  };

  

  
  

  var faIceSkate = {
    prefix: 'fasds',
    iconName: 'ice-skate',
    icon: [
      576,
      512,
      [9976],
      'f7ac',
      
      ['M0 464l0 48 24 0 96 0 288 0 144 0 24 0 0-24 0-56 0-24-48 0 0 24 0 32-96 0 0-56 0-24-48 0 0 24 0 56-240 0 0-56 0-24-48 0 0 24 0 56-72 0L0 464z','M32 96l0 288 480 0 0-144L320 192l-48 0-16 0 0-32 16 0 48 0 0-32-48 0-16 0 0-32 16 0 48 0 0-96L256 0l0 32L32 96z']
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fasds',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      ['M0 512l448 0L384 304 64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M504 312l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  

  
  

  var faBook = {
    prefix: 'fasds',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zm352 32l-224 0 0 32 224 0 0-32zM128 192l0 32 224 0 0-32-224 0z']
      
    ]
  };

  

  
  

  var faTurkey = {
    prefix: 'fasds',
    iconName: 'turkey',
    icon: [
      640,
      512,
      [],
      'f725',
      
      ['M0 384L0 512l288 0 288 0 0-128c0-63-27.3-121.1-67.3-168.4l-1.7 1.2c-21.9 15.5-35.2 41.7-52.5 77.9l-.4 .9c-8.4 17.6-17.8 37.4-29.7 55.4c-8 12.2-18 23.3-29.8 32.9c-61.8 50-152.5 40.5-202.5-21.4c-18-22.2-28.3-48.1-31.2-74.6l32.3 0c.2 1.4 .4 2.8 .7 4.2s.5 2.8 .8 4.1c3.2 14.6 9.5 28.8 18.8 41.6c1.1 1.5 2.3 3.1 3.5 4.6c38.9 48.1 109.4 55.5 157.5 16.6c9.2-7.5 17-16.1 23.2-25.6c10.6-16.2 19.3-34.3 28-52.5c16.1-33.8 32.3-67.7 61.2-89c.6-.4 1.2-.9 1.8-1.3l47.6-33.6C546 173.2 563.7 184 584 184c30.9 0 56-25.1 56-56s-25.1-56-56-56c-.8 0-1.6 0-2.3 0c1.5-5.1 2.3-10.5 2.3-16c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 14.7 5.6 28 14.8 38l-65.7 46.4C375.9 112.2 327.9 96 288 96C176 96 0 224 0 384z','M486.8 192c-28.8 21.3-45 55.2-61.2 89c-8.7 18.2-17.3 36.4-28 52.5c-6.2 9.4-13.9 18.1-23.2 25.6c-48.1 38.9-118.6 31.5-157.5-16.6c-13.2-16.3-21-35.1-23.8-54.5l-32.3 0c2.9 26.4 13.2 52.4 31.2 74.6c50 61.8 140.7 71.4 202.5 21.4c11.8-9.6 21.8-20.7 29.8-32.9c11.8-18 21.3-37.8 29.7-55.4l.4-.9c17.3-36.3 30.6-62.5 52.5-77.9l1.7-1.2c-7-8.2-14.3-16.1-21.9-23.7z']
      
    ]
  };

  

  
  

  var faClipboardListCheck = {
    prefix: 'fasds',
    iconName: 'clipboard-list-check',
    icon: [
      384,
      512,
      [],
      'f737',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-24 0-48 0-24 80 0 0 448L0 512 0 64zM57.4 272l11.3 11.3 32 32L112 326.6l11.3-11.3 64-64L198.6 240 176 217.4l-11.3 11.3L112 281.4 91.3 260.7 80 249.4 57.4 272zM72 400a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm88-16l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0zm32-96l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z','M270.4 64L304 64l0 96-112 0L80 160l0-96 33.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM198.6 240l-11.3 11.3-64 64L112 326.6l-11.3-11.3-32-32L57.4 272 80 249.4l11.3 11.3L112 281.4l52.7-52.7L176 217.4 198.6 240zM72 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z']
      
    ]
  };

  

  
  

  var faRectangle = {
    prefix: 'fasds',
    iconName: 'rectangle',
    icon: [
      512,
      512,
      [9644,"rectangle-landscape"],
      'f2fa',
      
      ['M0 64H512V448H0V64z','']
      
    ]
  };

  
    var faRectangleLandscape = faRectangle;
  

  
  

  var faCommentSms = {
    prefix: 'fasds',
    iconName: 'comment-sms',
    icon: [
      512,
      512,
      ["sms"],
      'f7cd',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm96.2-30.9c.1-1.2 .3-2.5 .6-3.7c.5-2.4 1.2-4.7 2.1-6.9c1.9-4.4 4.6-8.4 7.9-11.7c6.7-6.7 15.9-10.8 26.1-10.8l19.2 0c2.7 0 5.3 0 8 0s5.3 0 8 0c0 10.7 0 21.3 0 32l-16 0-19.2 0c-1.3 0-2.5 .5-3.4 1.4c-.4 .4-.8 1-1 1.5c-.1 .3-.2 .6-.3 .9c-.1 .3-.1 .6-.1 1c0 .2 0 .4 0 .5c0 .2 .1 .4 .1 .6c.1 .4 .2 .8 .4 1.1c.4 .7 .9 1.3 1.6 1.7c9.8 6.5 19.6 13.1 29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L112 304l-16 0c0-10.7 0-21.3 0-32l16 0 27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4c-9.8-6.5-19.6-13.1-29.4-19.6c-5.1-3.4-9.2-8-12-13.3c-1.4-2.6-2.5-5.4-3.2-8.4c-.4-1.5-.6-2.9-.8-4.5c-.1-.8-.2-1.5-.2-2.3s-.1-1.5-.1-2.5c0-.5 0-1.1 0-1.7s.1-1.2 .1-1.9zM192 176l24 0c1.6 2.1 3.2 4.3 4.8 6.4c11.7 15.6 23.5 31.3 35.2 46.9c11.7-15.6 23.5-31.3 35.2-46.9c1.6-2.1 3.2-4.3 4.8-6.4l24 0c0 5.3 0 10.7 0 16c0 32 0 64 0 96c0 5.3 0 10.7 0 16l-32 0c0-5.3 0-10.7 0-16c0-16 0-32 0-48c-6.4 8.5-12.8 17.1-19.2 25.6L256 282.7c-4.3-5.7-8.5-11.4-12.8-17.1L224 240c0 16 0 32 0 48c0 5.3 0 10.7 0 16l-32 0c0-5.3 0-10.7 0-16c0-32 0-64 0-96c0-5.3 0-10.7 0-16zm144 36.8c0-20.3 16.4-36.7 36.7-36.8c3.8 0 7.6 0 11.3 0l8 0 16 0 0 32-16 0-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L352 304l-16 0 0-32 16 0 27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7z','M160 176l-8 0-19.2 0C112.5 176 96 192.5 96 212.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 272l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-8 0s0 0 0 0zm32 0l0 16 0 96 0 16 32 0 0-16 0-48 19.2 25.6L256 282.7l12.8-17.1L288 240l0 48 0 16 32 0 0-16 0-96 0-16-24 0-4.8 6.4L256 229.3l-35.2-46.9L216 176l-24 0zm180.7 0c-20.3 .1-36.7 16.6-36.7 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 272l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-16 0-8 0s0 0 0 0l-11.3 0z']
      
    ]
  };

  
    var faSms = faCommentSms;
  

  
  

  var faBasketShoppingMinus = {
    prefix: 'fasds',
    iconName: 'basket-shopping-minus',
    icon: [
      576,
      512,
      [],
      'e652',
      
      ['M0 192l124.4 0 53.2 0 220.7 0 53.2 0L576 192l0 64-32 0L480 512 96 512 32 256 0 256l0-64zM184 328l0 48 24 0 160 0 24 0 0-48-24 0-160 0-24 0z','M245.6 50.4L256 28.7 212.7 8 202.4 29.6 124.4 192l53.2 0 68-141.6zm128-20.8L363.3 8 320 28.7l10.4 21.6 68 141.6 53.2 0L373.6 29.6zM208 328l-24 0 0 48 24 0 160 0 24 0 0-48-24 0-160 0z']
      
    ]
  };

  

  
  

  var faTableList = {
    prefix: 'fasds',
    iconName: 'table-list',
    icon: [
      512,
      512,
      ["th-list"],
      'f00b',
      
      ['M64 160l0 64 64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 256 0 0-64-256 0 0-64 256 0 0-64-256 0 0-64-64 0 0 64-64 0z','M512 32L0 32 0 480l512 0 0-448zM448 96l0 320L64 416 64 96l384 0z']
      
    ]
  };

  
    var faThList = faTableList;
  

  
  

  var faHandBackPointDown = {
    prefix: 'fasds',
    iconName: 'hand-back-point-down',
    icon: [
      448,
      512,
      [],
      'e19e',
      
      ['M176 512l-80 0 0-224 0-13.3 0-2.7 0-80 0-16-32 0 0 16 0 56L16 208l0-68c0-38 16.9-74 46.1-98.3l5.4-4.5C96.3 13.1 132.5 0 169.9 0L288 0c70.7 0 128 57.3 128 128l0 16 0 48 0 80-80 0 0 32-80 0 0 32-80 0 0 176z','']
      
    ]
  };

  

  
  

  var faH5 = {
    prefix: 'fasds',
    iconName: 'h5',
    icon: [
      640,
      512,
      [],
      'e412',
      
      ['M0 64L0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96l0-32L0 64z','M403.2 64L432 64l144 0 32 0 0 64-32 0-115.2 0-9.3 88 72.5 0c64.1 0 116 51.9 116 116s-51.9 116-116 116l-64.3 0c-40.4 0-75.6-27.5-85.4-66.7L369 359.8 431 344.2l5.4 21.6c2.7 10.7 12.3 18.2 23.3 18.2l64.3 0c28.7 0 52-23.3 52-52s-23.3-52-52-52l-108 0-35.5 0 3.7-35.3 16-152 3-28.7z']
      
    ]
  };

  

  
  

  var fa4 = {
    prefix: 'fasds',
    iconName: '4',
    icon: [
      384,
      512,
      [],
      '34',
      
      ['M209.8 32l-69.4 0L18.5 323.7-.1 368 48 368l208 0 0 80 0 32 64 0 0-32 0-80 32 0 32 0 0-64-32 0-32 0 0-144 0-32-64 0 0 32 0 144L96.1 304 205.5 42.3 209.8 32z','']
      
    ]
  };

  

  
  

  var faSoftServe = {
    prefix: 'fasds',
    iconName: 'soft-serve',
    icon: [
      384,
      512,
      [127846,"creemee"],
      'e400',
      
      ['M16 224l0 80 32 0 288 0 32 0 0-80c0-32.9-24.8-60-56.8-63.6c5.6-9.5 8.8-20.6 8.8-32.4C320 57.3 262.7 0 192 0l6.1 6.1c6.4 6.4 9.9 15 9.9 24C208 48.8 192.8 64 174.1 64L128 64c-35.3 0-64 28.7-64 64c0 11.8 3.2 22.9 8.8 32.4C40.8 164 16 191.1 16 224z','M336 304L48 304l0 80 33.8 0L96 512l192 0 14.2-128 33.8 0 0-80z']
      
    ]
  };

  
    var faCreemee = faSoftServe;
  

  
  

  var faFaceViewfinder = {
    prefix: 'fasds',
    iconName: 'face-viewfinder',
    icon: [
      512,
      512,
      [],
      'e2ff',
      
      ['M0 0L24 0 136 0l24 0 0 48-24 0L48 48l0 88 0 24L0 160l0-24L0 24 0 0zM0 352l48 0 0 24 0 88 88 0 24 0 0 48-24 0L24 512 0 512l0-24L0 376l0-24zM352 0l24 0L488 0l24 0 0 24 0 112 0 24-48 0 0-24 0-88-88 0-24 0 0-48zm0 464l24 0 88 0 0-88 0-24 48 0 0 24 0 112 0 24-24 0-112 0-24 0 0-48z','M256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM200 192a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm88 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 320c25 0 47.5-10.4 63.5-27.1l23.1 22.2C320.8 337.8 290 352 256 352s-64.8-14.2-86.6-36.9l23.1-22.2C208.5 309.6 231 320 256 320z']
      
    ]
  };

  

  
  

  var faGripDotsVertical = {
    prefix: 'fasds',
    iconName: 'grip-dots-vertical',
    icon: [
      256,
      512,
      [],
      'e411',
      
      ['M160 96a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M0 96a48 48 0 1 1 96 0A48 48 0 1 1 0 96zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faSpinnerScale = {
    prefix: 'fasds',
    iconName: 'spinner-scale',
    icon: [
      512,
      512,
      [],
      'e62a',
      
      ['M52.4 120.2l33.9 33.9c18.7 18.7 49.1 18.7 67.9 0s18.7-49.1 0-67.9L120.2 52.4 52.4 120.2zM75 391.8L120.2 437l22.6-22.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L75 391.8zM352.2 80.6c-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0L471 120.2 391.8 41 352.2 80.6zm17 288.5c-12.5 12.5-12.5 32.8 0 45.3L391.8 437 437 391.8l-22.6-22.6c-12.5-12.5-32.8-12.5-45.3 0z','M308 12L204 12l0 52c0 28.7 23.3 52 52 52s52-23.3 52-52l0-52zM256 416c-17.7 0-32 14.3-32 32l0 32 64 0 0-32c0-17.7-14.3-32-32-32zM480 288l0-64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0zM96 256c0-17.7-14.3-32-32-32l-32 0 0 64 32 0c17.7 0 32-14.3 32-32z']
      
    ]
  };

  

  
  

  var faM = {
    prefix: 'fasds',
    iconName: 'm',
    icon: [
      448,
      512,
      [109],
      '4d',
      
      ['M0 32L0 64 0 448l0 32 64 0 0-32 0-278.3L197.4 369.8 224 409.7l26.6-39.9L384 169.7 384 448l0 32 64 0 0-32 0-384 0-32-49.1 0-9.5 14.2L224 294.3 58.6 46.2 49.1 32 0 32z','']
      
    ]
  };

  

  
  

  var faDesktop = {
    prefix: 'fasds',
    iconName: 'desktop',
    icon: [
      576,
      512,
      [61704,128421,"desktop-alt"],
      'f390',
      
      ['M0 0L0 416l240 0 96 0 240 0L576 0 0 0zM64 64l448 0 0 224L64 288 64 64z','M512 64L64 64l0 224 448 0 0-224zM416 448l-69.3 0L336 416l-96 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0z']
      
    ]
  };

  
    var faDesktopAlt = faDesktop;
  

  
  

  var faDiceD8 = {
    prefix: 'fasds',
    iconName: 'dice-d8',
    icon: [
      512,
      512,
      [],
      'f6d2',
      
      ['M0 248l240 88L240 0 0 248zM272 0l0 336 240-88L272 0z','M240 368L32 291.7 240 512l0-144zm32 0l0 144L480 291.7 272 368z']
      
    ]
  };

  

  
  

  var faShower = {
    prefix: 'fasds',
    iconName: 'shower',
    icon: [
      512,
      512,
      [128703],
      'f2cc',
      
      ['M224 320a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32-160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M0 32l32 0 96 0 13.3 0 9.4 9.4 36.1 36.1c38.9-21 87.5-17.4 123 10.9L311 87l17-17L361.9 104l-17 17L185 281l-17 17L134.1 264l17-17 1.3-1.3c-28.3-35.5-31.9-84.2-10.9-123L114.7 96 64 96l0 352 0 32L0 480l0-32L0 64 0 32z']
      
    ]
  };

  

  
  

  var faDoNotEnter = {
    prefix: 'fasds',
    iconName: 'do-not-enter',
    icon: [
      512,
      512,
      [],
      'f5ec',
      
      ['M80 208l352 0 0 96L80 304l0-96z','M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM432 208l0 96L80 304l0-96 352 0z']
      
    ]
  };

  

  
  

  var faGaugeSimpleHigh = {
    prefix: 'fasds',
    iconName: 'gauge-simple-high',
    icon: [
      512,
      512,
      [61668,"tachometer","tachometer-fast"],
      'f62a',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM192 352c0 35.3 28.7 64 64 64c17.7 0 33.7-7.2 45.3-18.7c5.8-5.8 10.5-12.7 13.7-20.3c1.6-3.8 2.9-7.8 3.7-12c.4-2.1 .8-4.2 1-6.4c.1-1.1 .2-2.2 .2-3.2c.1-1.1 .1-2.2 .1-3.3c0-1.5 0-1.5-.1-3c0 0-.1-1.5-.2-2.9c-.2-1.9-.4-3.8-.8-5.7c-.7-3.8-1.7-7.4-3-10.9c-2.6-7-6.5-13.4-11.3-19c25.5-49.1 51.1-98.2 76.6-147.4c3.7-7.1 7.4-14.2 11.1-21.3c-14.2-7.4-28.4-14.8-42.6-22.1c-3.7 7.1-7.4 14.2-11.1 21.3c-25.5 49.1-51.1 98.2-76.6 147.4c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64z','M338.7 140.9l11.1-21.3 42.6 22.1-11.1 21.3L304.7 310.4c9.6 11.2 15.3 25.7 15.3 41.6c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c2.1 0 4.1 .1 6.1 .3l76.6-147.4z']
      
    ]
  };

  
    var faTachometer = faGaugeSimpleHigh;
  
    var faTachometerFast = faGaugeSimpleHigh;
  

  
  

  var faArrowDownBigSmall = {
    prefix: 'fasds',
    iconName: 'arrow-down-big-small',
    icon: [
      576,
      512,
      ["sort-size-down"],
      'f88c',
      
      ['M320 32l0 224 224 0 0-224L320 32zm0 288l0 160 160 0 0-160-160 0z','M160 480l23.7-26 80-88 21.5-23.7-47.4-43.1-21.5 23.7L192 349.7l0-285.2 0-32-64 0 0 32 0 285.2-24.3-26.8L82.2 299.2 34.8 342.3 56.3 366l80 88L160 480z']
      
    ]
  };

  
    var faSortSizeDown = faArrowDownBigSmall;
  

  
  

  var faCalendarLines = {
    prefix: 'fasds',
    iconName: 'calendar-lines',
    icon: [
      448,
      512,
      ["calendar-note"],
      'e0d5',
      
      ['M0 192l448 0 0 320L0 512 0 192zm96 80l0 48 256 0 0-48L96 272zm0 96l0 48 160 0 0-48L96 368z','M96 0l64 0 0 64 128 0 0-64 64 0 0 64 96 0 0 128L0 192 0 64l96 0L96 0zm0 272l256 0 0 48L96 320l0-48zm160 96l0 48L96 416l0-48 160 0z']
      
    ]
  };

  
    var faCalendarNote = faCalendarLines;
  

  
  

  var faScaleBalanced = {
    prefix: 'fasds',
    iconName: 'scale-balanced',
    icon: [
      640,
      512,
      [9878,"balance-scale"],
      'f24e',
      
      ['M96 32l0 64 32 0 113.6 0c5.2 25.8 22.9 47.1 46.4 57.3L288 448l-160 0-32 0 0 64 32 0 192 0 192 0 32 0 0-64-32 0-160 0 0-294.7c23.5-10.3 41.2-31.6 46.4-57.3L512 96l32 0 0-64-32 0L384 32C369.4 12.6 346.2 0 320 0s-49.4 12.6-64 32L128 32 96 32z','M97.5 128l14.5 0 32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0L64 416l-9.9 0-7-7L7 369l-7-7L0 352l0-32 0-5.9 2.7-5.2 88-168L97.5 128zm29 48L51.1 320l153.8 0L129.5 176l-3 0zm355-48l14.5 0 32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0-128 0-9.9 0-7-7-40-40-7-7 0-9.9 0-32 0-5.9 2.7-5.2 88-168 6.7-12.9zm29 48L435.1 320l153.8 0L513.5 176l-3 0z']
      
    ]
  };

  
    var faBalanceScale = faScaleBalanced;
  

  
  

  var faDrawPolygon = {
    prefix: 'fasds',
    iconName: 'draw-polygon',
    icon: [
      448,
      512,
      [],
      'f5ee',
      
      ['M32 151.4l0 209.1c9.4-5.4 20.3-8.6 32-8.6c.7 0 1.5 0 2.2 0s1.4 .1 2.2 .1c1.4 .1 2.9 .2 4.3 .4c2.8 .4 5.6 .9 8.2 1.7c5.4 1.5 10.5 3.6 15.2 6.3l0-209.1c-9.4 5.4-20.3 8.6-32 8.6c-.7 0-1.5 0-2.2 0s-1.4-.1-2.2-.1c-1.4-.1-2.9-.2-4.3-.4c-2.8-.4-5.6-.9-8.2-1.7c-5.4-1.5-10.5-3.6-15.2-6.3zM119.4 64c5.4 9.4 8.6 20.3 8.6 32c0 .7 0 1.5 0 2.2s-.1 1.4-.1 2.2c-.1 1.4-.2 2.9-.4 4.3c-.4 2.8-.9 5.6-1.7 8.2c-1.5 5.4-3.6 10.5-6.3 15.2l209.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-.7 0-1.5 0-2.2s.1-1.4 .1-2.2c.1-1.4 .2-2.9 .4-4.3c.4-2.8 .9-5.6 1.7-8.2c1.5-5.4 3.6-10.5 6.3-15.2L119.4 64zm0 320c5.4 9.4 8.6 20.3 8.6 32c0 .7 0 1.5 0 2.2s-.1 1.4-.1 2.2c-.1 1.4-.2 2.9-.4 4.3c-.4 2.8-.9 5.6-1.7 8.2c-1.5 5.4-3.6 10.5-6.3 15.2l209.1 0c-5.4-9.4-8.6-20.3-8.6-32c0-.7 0-1.5 0-2.2s.1-1.4 .1-2.2c.1-1.4 .2-2.9 .4-4.3c.4-2.8 .9-5.6 1.7-8.2c1.5-5.4 3.6-10.5 6.4-15.4c-69.8 .2-139.5 .2-209.2 .2zM292.2 192.1c23.5 1.5 43.5 15.7 53.3 35.7l2.3-4 32-56 4.5-7.9c-3.2 0-6.1-.2-9-.6c-5.7-.7-11.2-2.3-16.3-4.5c-2.5-1.1-4.9-2.3-7.2-3.6c-9.6-5.5-17.5-13.5-23.3-23.3c-1.4 2.9-2.8 5.5-4.3 8.1c-10.7 18.7-21.3 37.3-32 56zm0 127.7c10.7 18.7 21.3 37.3 32 56c1.5 2.6 3 5.2 4.5 7.9C339.8 364.8 360.4 352 384 352c-1.2-2.6-2.7-5.3-4.2-7.9l-32-56-2.3-4c-9.8 20.1-29.8 34.2-53.3 35.7z','M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zm320 0a64 64 0 1 1 128 0A64 64 0 1 1 320 96zM64 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM288 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z']
      
    ]
  };

  

  
  

  var faFaceMonocle = {
    prefix: 'fasds',
    iconName: 'face-monocle',
    icon: [
      512,
      512,
      [],
      'e380',
      
      ['M0 256C0 397.4 114.6 512 256 512c65.8 0 125.9-24.8 171.2-65.7c-7.3-16.2-11.2-34-11.2-52.4l0-91.5c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112l0 169.9c0 1.2 0 2.3 .1 3.5s.1 2.3 .2 3.4c.2 2.3 .4 4.6 .7 6.8c.6 4.5 1.6 8.9 2.9 13.2C489.4 376.2 512 318.7 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm112.4-64c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM144 336l16 0c17.7 0 45.3 3.5 72.2 13.9c26.8 10.4 54.9 28.5 70.1 59l-28.6 14.3c-10.3-20.7-30.3-34.6-53.1-43.4C197.9 370.9 174.3 368 160 368l-16 0 0-32zM249.5 93.5l12.5-10 23.2-18.6C298.9 54 315.9 48 333.5 48c15.2 0 30.1 4.5 42.8 13c2.9 1.9 5.7 3.8 8.6 5.7C379 75.6 373 84.4 367.1 93.3l-8.6-5.7c-7.4-5-16.2-7.6-25.1-7.6c-10.3 0-20.2 3.5-28.2 9.9c-7.7 6.2-15.5 12.4-23.2 18.6c-4.2 3.3-8.3 6.7-12.5 10c-6.7-8.3-13.3-16.7-20-25z','M333.5 80c-10.3 0-20.2 3.5-28.2 9.9L282 108.5l-12.5 10-20-25 12.5-10 23.2-18.6C298.9 54 315.9 48 333.5 48c15.2 0 30.1 4.5 42.8 13l8.6 5.7L367.1 93.3l-8.6-5.7c-7.4-5-16.2-7.6-25.1-7.6zM336 304a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm80 89.9l0-91.5c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112s112 50.1 112 112l0 169.9c0 33.1 17 63.9 45.1 81.4l11.4 7.1-17 27.1-11.4-7.1C438.7 479.1 416 438.1 416 393.9zM320.4 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-176-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faRss = {
    prefix: 'fasds',
    iconName: 'rss',
    icon: [
      448,
      512,
      ["feed"],
      'f09e',
      
      ['M0 32L0 96c212.1 0 384 171.9 384 384l64 0C448 232.6 247.4 32 0 32zM0 160l0 64c141.4 0 256 114.6 256 256l64 0C320 303.3 176.7 160 0 160z','M0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416z']
      
    ]
  };

  
    var faFeed = faRss;
  

  
  

  var faArrowTrendDown = {
    prefix: 'fasds',
    iconName: 'arrow-trend-down',
    icon: [
      576,
      512,
      [],
      'e097',
      
      ['M9.4 150.6l160 160L192 333.3l22.6-22.6L320 205.3 466.7 352l45.3 0 0-45.3L342.6 137.4 320 114.7l-22.6 22.6L192 242.7 54.6 105.4 9.4 150.6z','M352 416l32 0 160 0 32 0 0-32 0-160 0-32-64 0 0 32 0 128-128 0-32 0 0 64z']
      
    ]
  };

  

  
  

  var faCookieBite = {
    prefix: 'fasds',
    iconName: 'cookie-bite',
    icon: [
      512,
      512,
      [],
      'f564',
      
      ['M16 222.1L42 370.4 149.8 475l148.3 21 132.3-70.7L496 289.9l-6.1-34.7c-61.5-6.7-109.9-57.1-113.7-119.5C313.8 132 263.5 83.6 256.8 22.1L213.9 16 81.7 86.7 16 222.1zM144 336l32-32 32 32-32 32-32-32zm32-160l32-32 32 32-32 32-32-32zM336 304l32-32 32 32-32 32-32-32z','M176 176l32 32 32-32-32-32-32 32zM144 336l32 32 32-32-32-32-32 32zm224 0l32-32-32-32-32 32 32 32z']
      
    ]
  };

  

  
  

  var faPeopleSimple = {
    prefix: 'fasds',
    iconName: 'people-simple',
    icon: [
      512,
      512,
      [],
      'e21b',
      
      ['M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64z','M32 160l192 0 8 192-40 0 0 160L64 512l0-160-40 0 8-192zm288 0l128 0 64 224-64 0 0 128-128 0 0-128-64 0 64-224z']
      
    ]
  };

  

  
  

  var faFaceAngry = {
    prefix: 'fasds',
    iconName: 'face-angry',
    icon: [
      512,
      512,
      [128544,"angry"],
      'f556',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm107.8-53.9c3.4-10.1 6.7-20.2 10.1-30.4c5.1 1.7 10.1 3.4 15.2 5.1c32 10.7 64 21.3 96 32c5.1 1.7 10.1 3.4 15.2 5.1c-3.4 10.1-6.7 20.2-10.1 30.4l-15.2-5.1-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.8-.1-1.6-.1-1.6l0-1.7c0-.5 0-1.1 0-1.6s.1-1.1 .1-1.6c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1-4.1 1.9-6c1.6-3.8 3.9-7.3 6.8-10.2c-10.2-3.4-20.5-6.8-30.7-10.2c-5.1-1.7-10.1-3.4-15.2-5.1zm53.6 183.1l10.7-11.9C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4zM267.8 213.9c5.1-1.7 10.1-3.4 15.2-5.1c32-10.7 64-21.3 96-32c5.1-1.7 10.1-3.4 15.2-5.1c3.4 10.1 6.7 20.2 10.1 30.4c-5.1 1.7-10.1 3.4-15.2 5.1c-10.1 3.4-20.1 6.7-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.8-.1-1.6-.1-1.6l0-1.7c0-.8 0-1.5 .1-2.3s.1-1.6 .3-2.3c-3.9 1.3-7.8 2.6-11.7 3.9c-5.1 1.7-10.1 3.4-15.2 5.1l-10.1-30.4z','M133.1 176.8l-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32zm256 30.4l15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1z']
      
    ]
  };

  
    var faAngry = faFaceAngry;
  

  
  

  var faFunction = {
    prefix: 'fasds',
    iconName: 'function',
    icon: [
      640,
      512,
      [],
      'f661',
      
      ['M224 320c0 65.6 19.6 126.7 53.3 177.7l53.4-35.3C303.7 421.6 288 372.7 288 320s15.7-101.6 42.7-142.3l-53.4-35.3C243.6 193.3 224 254.4 224 320zM533.3 177.7c27 40.7 42.7 89.6 42.7 142.3s-15.7 101.6-42.7 142.3l53.4 35.3C620.4 446.7 640 385.6 640 320s-19.6-126.7-53.3-177.7l-53.4 35.3z','M96 0L64 0l0 32 0 160-32 0L0 192l0 64 32 0 32 0 0 160L0 416l0 64 96 0 32 0 0-32 0-192 32 0 32 0 0-64-32 0-32 0 0-128 64 0 32 0 0-64L192 0 96 0zM398.6 241.4L376 218.7 330.7 264l22.6 22.6L386.7 320l-33.4 33.4L330.7 376 376 421.3l22.6-22.6L432 365.3l33.4 33.4L488 421.3 533.3 376l-22.6-22.6L477.3 320l33.4-33.4L533.3 264 488 218.7l-22.6 22.6L432 274.7l-33.4-33.4z']
      
    ]
  };

  

  
  

  var faBorderAll = {
    prefix: 'fasds',
    iconName: 'border-all',
    icon: [
      448,
      512,
      [],
      'f84c',
      
      ['M64 224l0 64 128 0 0 128 64 0 0-128 128 0 0-64-128 0 0-128-64 0 0 128L64 224z','M384 96l0 320L64 416 64 96l320 0zM64 32L0 32 0 96 0 416l0 64 64 0 320 0 64 0 0-64 0-320 0-64-64 0L64 32z']
      
    ]
  };

  

  
  

  var faAnchor = {
    prefix: 'fasds',
    iconName: 'anchor',
    icon: [
      576,
      512,
      [9875],
      'f13d',
      
      ['M192 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 64 0 32 0 32 0 0-64-32 0-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M256 448l0-208 64 0 0 208 128 0 0-96-64 0 96-96 96 96-64 0 0 128 0 32-32 0-192 0L96 512l-32 0 0-32 0-128L0 352l96-96 96 96-64 0 0 96 128 0z']
      
    ]
  };

  

  
  

  var faCircleQuarter = {
    prefix: 'fasds',
    iconName: 'circle-quarter',
    icon: [
      512,
      512,
      [],
      'e11f',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0l0 256L0 256z','M0 256C0 114.6 114.6 0 256 0V256H0z']
      
    ]
  };

  

  
  

  var faBookQuran = {
    prefix: 'fasds',
    iconName: 'book-quran',
    icon: [
      448,
      512,
      ["quran"],
      'f687',
      
      ['M32 384l64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0 0-64z','M448 96c0-53-43-96-96-96L64 0 32 0 0 0 0 384l32 0 64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0L0 448l0 64 32 0 32 0 288 0c53 0 96-43 96-96l0-320zM301.7 90.3c-7-1.5-14.3-2.3-21.7-2.3c-57.4 0-104 46.6-104 104s46.6 104 104 104c7.4 0 14.7-.8 21.7-2.3C280.1 310.2 253.2 320 224 320c-70.7 0-128-57.3-128-128s57.3-128 128-128c29.2 0 56.1 9.8 77.7 26.3zm-6.9 81.3l38.4 3.1L304 199.8l8.9 37.5L280 217.2l-32.9 20.1 8.9-37.5-29.3-25.1 38.4-3.1L280 136l14.8 35.6z']
      
    ]
  };

  
    var faQuran = faBookQuran;
  

  
  

  var faDeleteRight = {
    prefix: 'fasds',
    iconName: 'delete-right',
    icon: [
      576,
      512,
      [],
      'e154',
      
      ['M0 64l400 0L576 256 400 448 0 448 0 64zM126.1 192c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.4 31.4 47 47c-15.7 15.7-31.4 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47l47 47 17 17c11.3-11.3 22.6-22.6 33.9-33.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c15.7-15.7 31.4-31.4 47-47c5.7-5.7 11.3-11.3 17-17c-11.3-11.3-22.6-22.6-33.9-33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.4 31.4-47 47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17c-11.3 11.3-22.6 22.6-33.9 33.9z','M305 209l17-17L288 158.1l-17 17-47 47-47-47-17-17L126.1 192l17 17 47 47-47 47-17 17L160 353.9l17-17 47-47 47 47 17 17L321.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  

  
  

  var faFileCirclePlus = {
    prefix: 'fasds',
    iconName: 'file-circle-plus',
    icon: [
      576,
      512,
      [58606],
      'e494',
      
      ['M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0z','M384 160L224 0l0 160 160 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0 16 0 0 32-16 0-48 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16z']
      
    ]
  };

  

  
  

  var faTornado = {
    prefix: 'fasds',
    iconName: 'tornado',
    icon: [
      448,
      512,
      [127786],
      'f76f',
      
      ['M0 0L416 0l0 32L370.8 77.2c-5.5 5.5-9.9 11.9-13 18.8L5 96C1.7 79.6 0 62.7 0 45.6L0 0zM13.6 128l338.6 0c1 12 5.4 23.5 12.6 33.1L412 224 72.4 224c-26.5-27.3-46.6-60.1-58.8-96zm96.6 128l323.1 0c9.6 19.1 14.7 40.3 14.7 61.9c0 11.6-1.5 23.1-4.3 34.1l-178.6 0c-6.7-6.6-14.3-12.4-22.5-17.3L126.2 266.2c-5.5-3.2-10.8-6.6-16-10.2zM288 384l143.1 0c-8.6 15.7-20.3 29.8-34.7 41.3L288 512l9.8-59c3.9-23.5 .5-47.5-9.9-69z','M13.6 128C10.1 117.6 7.2 106.9 5 96l352.8 0c-3.8 8.3-5.8 17.3-5.8 26.6c0 1.8 .1 3.6 .2 5.4L13.6 128zm96.6 128c-13.7-9.5-26.3-20.2-37.8-32L412 224l8.5 11.3c4.9 6.5 9.2 13.5 12.8 20.7l-323.1 0zM288 384c-.2-.5-.5-1-.7-1.5c-5.7-11.4-13.2-21.7-22.1-30.5l178.6 0c-2.9 11.2-7.1 21.9-12.6 32L288 384z']
      
    ]
  };

  

  
  

  var faFireFlameCurved = {
    prefix: 'fasds',
    iconName: 'fire-flame-curved',
    icon: [
      384,
      512,
      ["fire-alt"],
      'f7e4',
      
      ['M0 332.2C0 431.5 80.5 512 179.8 512l29.9 0C306 512 384 434 384 337.7c0-67.5-27.6-132-76.4-178.6L222.9 78.2C213.4 69.1 208 56.6 208 43.5L208 0 168.3 31.8C142.8 52.1 128 83 128 115.6c0 28.5 11.3 55.7 31.4 75.9l44.7 44.7c12.7 12.7 19.9 30 19.9 48l0 3.9c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-112L76.7 188.9C28.8 220.8 0 274.6 0 332.2zm76.9 53.1C99.2 404.5 128.3 416 160 416c70.7 0 128-57.3 128-128l0-3.9c0-31-10.9-60.9-30.7-84.6l6 5.8c36.2 34.5 56.6 82.3 56.6 132.3C320 398.6 270.6 448 209.7 448l-29.9 0c-44.8 0-83.6-25.4-102.9-62.7z','M76.9 385.3C96.1 422.6 135 448 179.8 448l29.9 0C270.6 448 320 398.6 320 337.7c0-50-20.5-97.8-56.6-132.3l-6-5.8c19.7 23.6 30.7 53.5 30.7 84.6l0 3.9c0 70.7-57.3 128-128 128c-31.7 0-60.8-11.5-83.1-30.7z']
      
    ]
  };

  
    var faFireAlt = faFireFlameCurved;
  

  
  

  var faArrowUpZA = {
    prefix: 'fasds',
    iconName: 'arrow-up-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-up-alt"],
      'f882',
      
      ['M292.8 480l70.4 0 14.7-32 76.3 0 14.7 32 70.4 0-6.1-13.3-88-192L436.5 256l-41.1 0-8.6 18.7-88 192L292.8 480zM320 32l0 64 32 0 52 0-73 63.9L320 169.5l0 14.5 0 8 0 32 32 0 128 0 32 0 0-64-32 0-52 0 73-63.9L512 86.5 512 72l0-8 0-32-32 0L352 32l-32 0zm79.9 368L416 364.8 432.1 400l-32.3 0z','M160 32.6l23.6 25.7 88 96L293.2 178 246 221.2l-21.6-23.6L192 162.3 192 448l0 32-64 0 0-32 0-285.7L95.6 197.6 74 221.2 26.8 178l21.6-23.6 88-96L160 32.6z']
      
    ]
  };

  
    var faSortAlphaUpAlt = faArrowUpZA;
  

  
  

  var faPersonWalkingArrowLoopLeft = {
    prefix: 'fasds',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
      640,
      512,
      [],
      'e551',
      
      ['M2.7 464L48 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6L68.7 398 25.4 441.4 2.7 464zM7.5 260.2l60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48L7.5 260.2zM160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M464 477.3l-22.6-22.6-80-80L338.7 352l22.6-22.6 80-80L464 226.7 509.3 272l-22.6 22.6L461.3 320 576 320l0-192-224 0-32 0 0-64 32 0 256 0 32 0 0 32 0 256 0 32-32 0-146.7 0 25.4 25.4L509.3 432 464 477.3z']
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'fasds',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      ['M0 160l0 64L0 448l0 64 64 0 224 0 64 0 0-64 0-96-64 0 0 96L64 448l0-224 96 0 0-64-96 0L0 160z','M160 352H512V0H160V352z']
      
    ]
  };

  

  
  

  var faLinkSlash = {
    prefix: 'fasds',
    iconName: 'link-slash',
    icon: [
      640,
      512,
      ["chain-broken","chain-slash","unlink"],
      'f127',
      
      ['M17.6 346.5c0 36.9 14.1 73.7 42.2 101.8c56.2 56.2 147.4 56.2 203.6 0L274.7 437l-45.3-45.3-11.3 11.3c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l62.2-62.2-50.6-39.9L59.8 244.7c-28.1 28.1-42.2 65-42.2 101.8zM184.9 120.8l53.3 41.4c30.1-15.4 67.9-10.6 93.1 14.6c20.1 20.1 27.3 48.4 21.5 74.3l53.3 41.4c23.8-53 14-117.4-29.5-160.9c-52.4-52.4-135.1-56-191.6-10.7zm36.6 149.7c-2.2 39.5 11.7 79.7 41.9 109.9c38.8 38.8 94.3 50.8 143.4 36.1l-185.3-146zM365.3 75l45.3 45.3 11.3-11.3c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-96 96 51 39.6 90.3-90.3c56.2-56.2 56.2-147.4 0-203.6c-28.1-28.1-65-42.2-101.8-42.2s-73.7 14.1-101.8 42.2L365.3 75z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faChainBroken = faLinkSlash;
  
    var faChainSlash = faLinkSlash;
  
    var faUnlink = faLinkSlash;
  

  
  

  var faPlugCircleExclamation = {
    prefix: 'fasds',
    iconName: 'plug-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e55d',
      
      ['M0 160l32 0 320 0 32 0 0 38.6C310.1 219.5 256 287.4 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 99.2-64 0 0-99.2C87 398 32 333.4 32 256l0-32L0 224l0-64zM64 0l64 0 0 32 0 96-64 0 0-96L64 0zM256 0l64 0 0 32 0 96-64 0 0-96 0-32z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faHandHolding = {
    prefix: 'fasds',
    iconName: 'hand-holding',
    icon: [
      576,
      512,
      [],
      'f4bd',
      
      ['M68.8 384L140 327l8.8-7 11.2 0 64 0 64 0 64 0 32 0 0 64-32 0-64 0-32 0 0 32 138.8 0 94.5-65 33-22.7 45.3 65.9-33 22.7-128 88-10.2 7L384 512l-160 0L32 512 0 512 0 384l68.8 0z','']
      
    ]
  };

  

  
  

  var faFaceGrinTongueWink = {
    prefix: 'fasds',
    iconName: 'face-grin-tongue-wink',
    icon: [
      512,
      512,
      [128540,"grin-tongue-wink"],
      'f58b',
      
      ['M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-31.9-23.3-55.2-57.8-64-97.9c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29c-8.8 40.2-32.3 75-64.5 98.3l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm91.2-37.6c34.4-45.9 103.2-45.9 137.6 0c-8.6 6.4-17.1 12.8-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2zM400 208a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM203.2 237.6c-21.6-28.8-64.8-28.8-86.4 0L91.2 218.4c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zM320 384l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64 48 0 0 24 32 0 0-24 48 0z']
      
    ]
  };

  
    var faGrinTongueWink = faFaceGrinTongueWink;
  

  
  

  var faCirclePlus = {
    prefix: 'fasds',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ["plus-circle"],
      'f055',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-24l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M232 344l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  
    var faPlusCircle = faCirclePlus;
  

  
  

  var faShoePrints = {
    prefix: 'fasds',
    iconName: 'shoe-prints',
    icon: [
      640,
      512,
      [],
      'f54b',
      
      ['M0 352l96 0 0 128L0 480 0 352zm128 0l64 0 128-64 192 48 0 112L320 512 128 480l0-128z','M256 160l64 0 128 64 192-48 0-112L448 0 256 32l0 128zM224 32l-96 0 0 128 96 0 0-128z']
      
    ]
  };

  

  
  

  var faDragon = {
    prefix: 'fasds',
    iconName: 'dragon',
    icon: [
      640,
      512,
      [128009],
      'f6d5',
      
      ['M0 256l176-16L96 320l256 0 0-16 0-29.4 0-26.6 0-36.8L160 96 0 256z','M448 160l0 61.4L617.4 327.3 640 341.4l0 26.6 0 96 0 48-48 0-96 0-64 0L32.3 512l-.7 0L0 512l0-31.7 0-.7L0 448l30.6 0L448 410.7l0-18.7-83.2-62.4L352 320l0-16 0-29.4 0-26.6 0-120-64-16 0-32 48-24L288 32l0-32 96 0 32 0 96 0 96 128 0 64-96 0-32-32-32 0zm62.7-80.3L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3z']
      
    ]
  };

  

  
  

  var faWifiWeak = {
    prefix: 'fasds',
    iconName: 'wifi-weak',
    icon: [
      640,
      512,
      ["wifi-1"],
      'f6aa',
      
      ['M9.8 156.7l44.3 46.2C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9l44.3-46.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7zM129.5 264l42.4 48c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56l42.4-48C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72z','M256 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z']
      
    ]
  };

  
    var faWifi1 = faWifiWeak;
  

  
  

  var faBorderBottom = {
    prefix: 'fasds',
    iconName: 'border-bottom',
    icon: [
      448,
      512,
      [],
      'f84d',
      
      ['M0 32L0 96l64 0 0-64L0 32zm0 96l0 64 64 0 0-64L0 128zm0 96l0 64 64 0 0-64L0 224zm0 96l0 64 64 0 0-64L0 320zM96 32l0 64 64 0 0-64L96 32zm0 192l0 64 64 0 0-64-64 0zM192 32l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zM288 32l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zM384 32l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M448 480L0 480l0-64 448 0 0 64z']
      
    ]
  };

  

  
  

  var faVolumeSlash = {
    prefix: 'fasds',
    iconName: 'volume-slash',
    icon: [
      640,
      512,
      [128263],
      'f2e2',
      
      ['M32 160l0 192 128 0L304 480l48 0 0-106.7L81.2 160 32 160zm163.2-31.3L352 250.5 352 32l-48 0L195.2 128.7zm217.6 88.9c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l5.9 7.9 30.7 23.9C468.3 308.7 480 283.7 480 256c0-31.4-15.1-59.3-38.4-76.8l-28.8 38.4zm57.6-76.8c35 26.3 57.6 68.1 57.6 115.2c0 38.8-15.3 74-40.3 99.9l38.1 29.6C557 351.3 576 305.9 576 256c0-62.8-30.2-118.6-76.8-153.6l-28.8 38.4z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faSdCard = {
    prefix: 'fasds',
    iconName: 'sd-card',
    icon: [
      384,
      512,
      [],
      'f7c2',
      
      ['M112 64l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm80 0l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm80 0l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0z','M384 0L352 0 128 0 114.7 0l-9.4 9.4-96 96L0 114.7 0 128 0 480l0 32 32 0 320 0 32 0 0-32 0-448 0-32zM160 88l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm80 0l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm80 0l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faAmpGuitar = {
    prefix: 'fasds',
    iconName: 'amp-guitar',
    icon: [
      512,
      512,
      [],
      'f8a1',
      
      ['M92.5 96l66.5 0c2.1-1.9 4.3-3.8 6.5-5.8C192.5 67.2 224.9 48 256 48s63.5 19.2 90.4 42.2c2.2 1.9 4.4 3.9 6.5 5.8l66.5 0c-1.7-2.1-3.7-4.4-6-6.9c-8.5-9.6-20.8-22.4-35.8-35.3C348.5 28.8 304.9 0 256 0s-92.5 28.8-121.6 53.8c-15 12.9-27.3 25.7-35.8 35.3c-2.3 2.6-4.3 4.9-6 6.9zM112 288l0 32 32 0 0-32-32 0zm0 96l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm0 96l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm0 96l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm0 96l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm32-48l0 32 32 0 0-32-32 0zm0 96l0 32 32 0 0-32-32 0z','M512 96L0 96 0 512l512 0 0-416zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 80l0 192L64 448l0-192 384 0z']
      
    ]
  };

  

  
  

  var faLighthouse = {
    prefix: 'fasds',
    iconName: 'lighthouse',
    icon: [
      640,
      512,
      [],
      'e612',
      
      ['M14.5 46.1L33.5 1.9l112 48 22.1 9.5-18.9 44.1-22.1-9.5-112-48zm0 163.9l112-48 22.1-9.5 18.9 44.1-22.1 9.5-112 48L14.5 209.9zM192 64l32-16L320 0l96 48 32 16 0 48-24 0-8 0 0 7.6c0 13.5 0 27 0 40.4l-64 0 0-48 0-24.4-32-16-32 16 0 24.4 0 48-64 0 0-40.4 0-7.6-8 0-24 0 0-48zm280.5-4.6l22.1-9.5 112-48 18.9 44.1-112 48-22.1 9.5L472.5 59.4zm0 137.2l18.9-44.1 22.1 9.5 112 48-18.9 44.1-112-48-22.1-9.5z','M212.4 224L171.6 448 160 448l-32 0 0 64 32 0 128 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 128 0s0 0 0 0l32 0 0-64-32 0-11.6 0L427.6 224l20.4 0 0-64-32 0-192 0s0 0 0 0l-32 0 0 64 20.4 0z']
      
    ]
  };

  

  
  

  var faBahai = {
    prefix: 'fasds',
    iconName: 'bahai',
    icon: [
      576,
      512,
      ["haykal"],
      'f666',
      
      ['M203.5 249.4c15.1 7.1 30.2 14.2 45.3 21.3c-11.9 11.9-23.8 23.8-35.6 35.7c16.3-4.1 32.5-8.3 48.8-12.4c-1.4 17.1-2.7 34.2-4.1 51.3L288 303.5c10.1 13.9 20.1 27.8 30.2 41.7c-1.4-17.1-2.7-34.2-4.1-51.3c16.3 4.1 32.5 8.3 48.8 12.4c-11.9-11.9-23.8-23.8-35.6-35.7l45.3-21.3c-16.6-1.6-33.2-3.1-49.8-4.7c7.1-15.4 14.3-30.9 21.4-46.3c-14.1 9.5-28.1 19-42.2 28.5c-4.7-16.6-9.3-33.1-14-49.7l-14 49.7c-14.1-9.5-28.1-19-42.2-28.5l21.4 46.3c-16.6 1.6-33.2 3.1-49.8 4.7z','M316.5 101.2l-3.5-12.6L288 0 263.1 88.6l-3.5 12.6-13.7 48.7-41.9-28.4-11.2-7.6L115.7 61.8l39.1 84.4 5 10.9 21.4 46.2L130.5 208 118 209.2l-94 8.9 85.5 40.1 10.9 5.1L166.6 285l-36 36.1-8.3 8.4L55.8 395.9l91-23.2 12.8-3.3L208.7 357l-4.1 50.6-1 12.4-7.4 92 54.1-74.8 7.9-10.9L288 385.4l29.6 40.9 7.9 10.9L379.7 512l-7.4-92-1-12.4L367.3 357l49.2 12.5 12.8 3.3 91 23.2-66.3-66.4-8.3-8.4-36-36.1 46.2-21.7 10.9-5.1L552 218.1l-94-8.9L445.5 208l-50.7-4.8 21.4-46.2 5-10.9 39.1-84.4-77.1 52.2-11.2 7.6-41.9 28.4-13.7-48.7zm27.7 97.2l-21.4 46.3 49.8 4.7-45.3 21.3 35.6 35.7-48.8-12.4 4.1 51.3L288 303.5l-30.2 41.7 4.1-51.3-48.8 12.4 35.6-35.7-45.3-21.3 49.8-4.7-21.4-46.3L274 226.9l14-49.7 14 49.7 42.2-28.5z']
      
    ]
  };

  
    var faHaykal = faBahai;
  

  
  

  var faUserDoctorMessage = {
    prefix: 'fasds',
    iconName: 'user-doctor-message',
    icon: [
      640,
      512,
      ["user-md-chat"],
      'f82e',
      
      ['M0 512l448 0L384 304l-64 0 0 58c27.6 7.1 48 32.2 48 62l0 40 0 16-16 0-16 0-16 0 0-32 16 0 0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24 16 0 0 32-16 0-16 0-16 0 0-16 0-40c0-29.8 20.4-54.9 48-62l0-58-128 0 0 66.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-66.3-64 0L0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm24 296a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M640 0L384 0l0 224 64 0 0 64 96-64 96 0L640 0z']
      
    ]
  };

  
    var faUserMdChat = faUserDoctorMessage;
  

  
  

  var faTrailer = {
    prefix: 'fasds',
    iconName: 'trailer',
    icon: [
      640,
      512,
      [],
      'e041',
      
      ['M64 96l0 16 0 152.2c9.8-8.1 20.6-15.2 32-21L96 112l0-16L64 96zM96 400a80 80 0 1 0 160 0A80 80 0 1 0 96 400zM160 96l0 16 0 112.7c5.3-.5 10.6-.7 16-.7s10.7 .2 16 .7L192 112l0-16-32 0zm96 0l0 16 0 131.2c11.4 5.9 22.2 12.9 32 21L288 112l0-16-32 0zm96 0l0 16 0 192 0 16 32 0 0-16 0-192 0-16-32 0zm96 0l0 16 0 192 0 16 8 0 24 0 0-16 0-192 0-16-32 0z','M544 32L0 32 0 384l65.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L456 384l32 0 56 0 64 0 32 0 0-64-32 0-64 0 0-288zM480 320l-24 0-8 0 0-16 0-192 0-16 32 0 0 16 0 192 0 16zM96 96l0 16 0 131.2c-11.4 5.9-22.2 12.9-32 21L64 112l0-16 32 0zm80 128c-5.4 0-10.7 .2-16 .7L160 112l0-16 32 0 0 16 0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112l0-16 32 0 0 16 0 152.2c-9.8-8.1-20.6-15.2-32-21zM384 96l0 16 0 192 0 16-32 0 0-16 0-192 0-16 32 0z']
      
    ]
  };

  

  
  

  var faBoxHeart = {
    prefix: 'fasds',
    iconName: 'box-heart',
    icon: [
      448,
      512,
      [],
      'f49d',
      
      ['M0 160l208 0 0-128L64 32 0 160zM240 32l0 128 208 0L384 32 240 32z','M448 160l-208 0 0-128-32 0 0 128L0 160 0 480l448 0 0-320zM224 408l-86.7-81.2c-21.3-20-21.9-53.6-1.2-74.2c20.2-20.2 52.9-20.2 73.1 0L224 267.4l14.9-14.9c20.2-20.2 52.9-20.2 73.1 0c20.6 20.6 20.1 54.3-1.2 74.2L224 408z']
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fasds',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      ['M0 192l448 0 0 320L0 512 0 192z','M160 32l0-32L96 0l0 32 0 32L0 64 0 192l448 0 0-128-96 0 0-32 0-32L288 0l0 32 0 32L160 64l0-32z']
      
    ]
  };

  

  
  

  var faBoothCurtain = {
    prefix: 'fasds',
    iconName: 'booth-curtain',
    icon: [
      512,
      512,
      [],
      'f734',
      
      ['M0 0L32 0 160 0l0 64L64 64l0 416 0 32L0 512l0-32L0 32 0 0zM448 0l32 0 32 0 0 32 0 448 0 32-64 0 0-32 0-80 0-336 0-32 0-32z','M160 0l96 0 96 0 96 0 0 400c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48c0 26.5-21.5 48-48 48s-48-21.5-48-48L160 0z']
      
    ]
  };

  

  
  

  var faCloudMoonRain = {
    prefix: 'fasds',
    iconName: 'cloud-moon-rain',
    icon: [
      576,
      512,
      [],
      'f73c',
      
      ['M0 512l56 0 64-96-56 0L0 512zm96 0l56 0 64-96-56 0L96 512zm96 0l56 0 64-96-56 0-64 96zm96 0l56 0 64-96-56 0-64 96zm50.7-410.5c43.2 14.1 74.8 53.8 77 101.2c23.3 11 42.2 29.9 53.3 53.2c46.4-2 86.3-28.9 106.9-67.7c-14.8 9.4-32.4 14.9-51.2 14.9c-52.8 0-95.6-43-95.6-96c0-50.1 38.2-91.3 87-95.6C500.2 4.1 482.3 0 463.5 0C402.1 0 350.9 43.5 338.7 101.5z','M367.9 383.9l80 0 0-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6l0 96 96 0 271.9 0z']
      
    ]
  };

  

  
  

  var faUpDown = {
    prefix: 'fasds',
    iconName: 'up-down',
    icon: [
      256,
      512,
      [8597,11021,"arrows-alt-v"],
      'f338',
      
      ['M0 352l0 32L128 512 256 384l0-32-80 0 0-96-96 0 0 96L0 352z','M128 0L0 128l0 32 80 0 0 96 96 0 0-96 80 0 0-32L128 0z']
      
    ]
  };

  
    var faArrowsAltV = faUpDown;
  

  
  

  var faPencilMechanical = {
    prefix: 'fasds',
    iconName: 'pencil-mechanical',
    icon: [
      512,
      512,
      [],
      'e5ca',
      
      ['M368 64L432 0l80 80-64 64c-6-6-12-12-17.9-17.9c-14.7-14.7-29.4-29.4-44.1-44.1C380 76 374 70 368 64z','M248 14.1l17 17 52 52 1.1-1.1L352 48l33.9 33.9 44.1 44.1L464 160l-33.9 33.9L176 448 64 480s0 0 0 0L32 512 0 480l32-32L64 336 283 117l-35-35L137 193l-17 17L86.1 176l17-17L231 31l17-17zM149.6 405.6l-43.2-43.2L89.1 422.9l60.5-17.3z']
      
    ]
  };

  

  
  

  var faTurtle = {
    prefix: 'fasds',
    iconName: 'turtle',
    icon: [
      576,
      512,
      [128034],
      'f726',
      
      ['M0 320l0 64 32 0 32 0 0 96 128 0 0-96 32 0 0 96 128 0 0-96 96 0 32 0 0-32 0-64 96 0 0-80c0-53-43-96-96-96l-64 0 0 80 0 32 0 96-64 0-128 0-32 0L64 320l-32 0L0 320zM512 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M384 288V208c0-97.2-78.8-176-176-176S32 110.8 32 208v80H384z']
      
    ]
  };

  

  
  

  var faCaravanSimple = {
    prefix: 'fasds',
    iconName: 'caravan-simple',
    icon: [
      640,
      512,
      ["caravan-alt"],
      'e000',
      
      ['M64 128l0 128 192 0 0-128L64 128zm48 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM320 128l0 128 128 0 0-128-128 0z','M416 32L0 32 0 416l81.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L576 416l32 0 32 0 0-64-32 0-32 0 0-160c0-88.4-71.6-160-160-160zM64 128l192 0 0 128L64 256l0-128zm384 0l0 128-128 0 0-128 128 0z']
      
    ]
  };

  
    var faCaravanAlt = faCaravanSimple;
  

  
  

  var faPersonWalkingLuggage = {
    prefix: 'fasds',
    iconName: 'person-walking-luggage',
    icon: [
      576,
      512,
      [],
      'e554',
      
      ['M32 447.9l110.9 64 23.1-40 5.6-9.5 98.2-166.3-27.6-16.3-29.8 50.5L128 281.6 32 447.9z','M480 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM366.3 128.6l-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-10.1 30.4 60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16zM292.7 398l-43.4 43.4L226.7 464 272 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6l-25 62.4z']
      
    ]
  };

  

  
  

  var faParagraphLeft = {
    prefix: 'fasds',
    iconName: 'paragraph-left',
    icon: [
      384,
      512,
      ["paragraph-rtl"],
      'f878',
      
      ['M32 112c0 61.9 50.1 112 112 112l16 0 0 64 0 32 64 0 0-32 0-224 32 0 0 224 0 32 64 0 0-32 0-224 32 0 0-64L320 0 160 0 144 0C82.1 0 32 50.1 32 112z','M128 384l0-64-32 0L0 416l96 96 32 0 0-64 224 0 32 0 0-64-32 0-224 0z']
      
    ]
  };

  
    var faParagraphRtl = faParagraphLeft;
  

  
  

  var faBagsShopping = {
    prefix: 'fasds',
    iconName: 'bags-shopping',
    icon: [
      576,
      512,
      [128717],
      'f847',
      
      ['M0 160l128 0 0-64c0-53 43-96 96-96s96 43 96 96l0 64 128 0 0 64-288 0 0 256L0 480 0 160zM176 96l0 64 96 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48zM288 320l32 0 0 16 0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16 0-16 32 0 0 16 0 16c0 53-43 96-96 96s-96-43-96-96l0-16 0-16z','M576 256l-384 0 0 256 384 0 0-256zM320 336l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16 0-16 32 0 0 16 0 16c0 53-43 96-96 96s-96-43-96-96l0-16 0-16 32 0 0 16z']
      
    ]
  };

  

  
  

  var faFan = {
    prefix: 'fasds',
    iconName: 'fan',
    icon: [
      512,
      512,
      [],
      'f863',
      
      ['M0 224c0 90.9 70.8 160.4 160 160c28-.1 55-7.4 78.8-20.3L224 512c90.9 0 160.4-70.8 160-160c-.1-28-7.4-55-20.3-78.8L512 288c0-90.9-70.8-160.4-160-160c-28 .1-55 7.4-78.8 20.3L288 0C197.1 0 127.6 70.8 128 160c.1 28 7.4 55 20.3 78.8L0 224zm288 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M256 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z']
      
    ]
  };

  

  
  

  var faBlockBrick = {
    prefix: 'fasds',
    iconName: 'block-brick',
    icon: [
      448,
      512,
      ["wall-brick"],
      'e3db',
      
      ['M0 32l0 80 64 0 0-80L0 32zM0 144l0 96 208 0 0-96L0 144zM0 272l0 96 64 0 0-96L0 272zM0 400l0 80 208 0 0-80L0 400zM96 32l0 80 256 0 0-80L96 32zm0 240l0 96 256 0 0-96L96 272zM240 144l0 96 208 0 0-96-208 0zm0 256l0 80 208 0 0-80-208 0zM384 32l0 80 64 0 0-80-64 0zm0 240l0 96 64 0 0-96-64 0z','M64 112L0 112l0 32 208 0 0 96L0 240l0 32 64 0 0 96L0 368l0 32 208 0 0 80 32 0 0-80 208 0 0-32-64 0 0-96 64 0 0-32-208 0 0-96 208 0 0-32-64 0 0-80-32 0 0 80L96 112l0-80L64 32l0 80zM352 368L96 368l0-96 256 0 0 96z']
      
    ]
  };

  
    var faWallBrick = faBlockBrick;
  

  
  

  var faVoicemail = {
    prefix: 'fasds',
    iconName: 'voicemail',
    icon: [
      640,
      512,
      [],
      'f897',
      
      ['M96 240a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144l352 0c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80l-112.5 0zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z']
      
    ]
  };

  

  
  

  var faPersonArrowDownToLine = {
    prefix: 'fasds',
    iconName: 'person-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e538',
      
      ['M32.2 270.8l53.9 34.4 33.8-53L120 448l64 0 0-96 16 0 0 96 64 0 0-195.8 33.8 53 53.9-34.4L270 142.8 260.6 128l-17.5 0-102.2 0-17.5 0-9.4 14.8-81.7 128zM144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M464 32l0 32 0 242.7-25.4-25.4L416 258.7 370.7 304l22.6 22.6 80 80L496 429.3l22.6-22.6 80-80L621.3 304 576 258.7l-22.6 22.6L528 306.7 528 64l0-32-64 0zM32 448L0 448l0 64 32 0 576 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  

  
  

  var faObjectIntersect = {
    prefix: 'fasds',
    iconName: 'object-intersect',
    icon: [
      512,
      512,
      [],
      'e49d',
      
      ['M64 64l224 0 0 96 64 0 0 64 96 0 0 224-224 0 0-96-64 0 0-64-96 0L64 64zm96 288l0 96 0 64 64 0 224 0 64 0 0-64 0-224 0-64-64 0-96 0 0-96 0-64L288 0 64 0 0 0 0 64 0 288l0 64 64 0 96 0z','M160 160H352V352H160V160z']
      
    ]
  };

  

  
  

  var faChimney = {
    prefix: 'fasds',
    iconName: 'chimney',
    icon: [
      448,
      512,
      [],
      'f78b',
      
      ['M32 192l0 128 96 0 0-128-96 0zm0 160l0 128 256 0 0-128L32 352zM160 192l0 128 256 0 0-128-256 0zM320 352l0 128 96 0 0-128-96 0z','M448 32L0 32 0 160l448 0 0-128z']
      
    ]
  };

  

  
  

  var faVialCircleCheck = {
    prefix: 'fasds',
    iconName: 'vial-circle-check',
    icon: [
      512,
      512,
      [],
      'e596',
      
      ['M0 32L0 96l32 0 0 288c0 53 43 96 96 96c32.6 0 61.5-16.3 78.8-41.2C197.3 417.1 192 393.2 192 368c0-37.7 11.8-72.6 32-101.2L224 96l32 0 0-64-32 0-64 0L96 32 32 32 0 32zM96 96l64 0 0 96-64 0 0-96z','M368 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L352 430.6l-11.3-11.3-40-40L289.4 368 312 345.4l11.3 11.3L352 385.4l60.7-60.7L424 313.4 446.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faInfinity = {
    prefix: 'fasds',
    iconName: 'infinity',
    icon: [
      640,
      512,
      [8734,9854],
      'f534',
      
      ['M0 96l205.3 0L320 210.7 434.7 96 640 96l0 320-205.3 0L320 301.3 205.3 416 0 416 0 96zM274.7 256l-96-96L64 160l0 192 114.7 0 96-96zm90.5 0l96 96L576 352l0-192-114.7 0-96 96z','']
      
    ]
  };

  

  
  

  var faCassetteVhs = {
    prefix: 'fasds',
    iconName: 'cassette-vhs',
    icon: [
      576,
      512,
      [128252,"vhs"],
      'f8ec',
      
      ['M0 128L0 480l576 0 0-352L0 128zM80 304c0-30.3 10.5-58.1 28.1-80l51.9 0 0 34.7 0 90.5 0 34.7-51.9 0C90.5 362.1 80 334.3 80 304zm144-80l128 0 0 160-128 0 0-160zm192 0l51.9 0c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80L416 384l0-34.7 0-90.5 0-34.7z','M0 32l576 0 0 96L0 128 0 32zM160 384l-51.9 0C90.5 362.1 80 334.3 80 304s10.5-58.1 28.1-80l51.9 0 0 34.7c-18.6 6.6-32 24.4-32 45.3s13.4 38.7 32 45.3l0 34.7zm307.9 0L416 384l0-34.7c18.6-6.6 32-24.4 32-45.3s-13.4-38.7-32-45.3l0-34.7 51.9 0c17.6 21.9 28.1 49.7 28.1 80s-10.5 58.1-28.1 80z']
      
    ]
  };

  
    var faVhs = faCassetteVhs;
  

  
  

  var faChartColumn = {
    prefix: 'fasds',
    iconName: 'chart-column',
    icon: [
      512,
      512,
      [],
      'e0e3',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M480 96l0-32-64 0 0 32 0 224 0 32 64 0 0-32 0-224zM288 160l0-32-64 0 0 32 0 160 0 32 64 0 0-32 0-160zm-96 96l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64zm192-64l-64 0 0 32 0 96 0 32 64 0 0-32 0-96 0-32z']
      
    ]
  };

  

  
  

  var faHippo = {
    prefix: 'fasds',
    iconName: 'hippo',
    icon: [
      640,
      512,
      [129435],
      'f6ed',
      
      ['M2.1 350.3l43.9 19.5L64 329.1 64 480l128 0 0-108c19.8 7.7 41.4 12 64 12s44.2-4.3 64-12l0 108 128 0 0-96-64 0 0-42.8c-37.8-18-64-56.5-64-101.2l0-16 32 0 0 16c0 24.9 11.3 47.1 29.1 61.7c.9 .8 1.9 1.5 2.9 2.3c9.3 7 20.2 12 32 14.4c5.1 1 10.4 1.6 16 1.6c42.7 0 85.3 0 128 0c18 0 34.6-6 48-16c19.4-14.6 32-37.8 32-64c0-38.7-27.5-71-64-78.4l0-17.6c0-15.4-4.4-29.9-12-42.1L577 89l17-17L560 38.1 543 55 527.6 70.5C517.9 66.3 507.2 64 496 64l-32 0c-2 0-3.9 .1-5.8 .2L441 47l-17-17L390.1 64l17 17 3.5 3.5c-5.2 4.7-9.8 10-13.6 15.8L288 64l-32 0-24 0-8 0C117.1 68.5 32 156.3 32 264l0 18.9L2.1 350.3zM480 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0-88a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm48 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M448 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM416 352l0-33.6c5.2 1 10.5 1.6 16 1.6l48 0 0 32-64 0zm128 0l0-32 16 0c18 0 34.6-6 48-16l0 48-64 0z']
      
    ]
  };

  

  
  

  var faTransformerBolt = {
    prefix: 'fasds',
    iconName: 'transformer-bolt',
    icon: [
      384,
      512,
      [],
      'e2a4',
      
      ['M48 32l0 32 16 0 24 0 48 0 24 0 16 0 0-32-16 0-24 0 0-8 0-24L88 0l0 24 0 8L64 32 48 32zm0 64l0 32 16 0 96 0 16 0 0-32-16 0L64 96 48 96zM96 352l70.5 5c-7.5 35.7-15 71.3-22.5 107L288 320l-70.5-5L240 208 96 352zM208 32l0 32 16 0 24 0 48 0 24 0 16 0 0-32-16 0-24 0 0-8 0-24L248 0l0 24 0 8-24 0-16 0zm0 64l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z','M0 160l32 0 320 0 32 0 0 64-32 0 0 224 32 0 0 64-32 0L32 512 0 512l0-64 32 0 0-224L0 224l0-64zm240 48L96 352l70.5 5L144 464 288 320l-70.5-5L240 208z']
      
    ]
  };

  

  
  

  var faT = {
    prefix: 'fasds',
    iconName: 't',
    icon: [
      384,
      512,
      [116],
      '54',
      
      ['M32 32L0 32 0 96l32 0 128 0 0 352 0 32 64 0 0-32 0-352 128 0 32 0 0-64-32 0L224 32l-32 0-32 0L32 32z','']
      
    ]
  };

  

  
  

  var faOilCan = {
    prefix: 'fasds',
    iconName: 'oil-can',
    icon: [
      640,
      512,
      [],
      'f613',
      
      ['M160 64l0 64 64 0 0 32 64 0 0-32 64 0 0-64L160 64z','M96 208l0 86.1L48 272.8 48 208l48 0zM0 304l96 42.7L96 416l288 0 48 0L640 192l-32-32L448 192l-64-32-240 0-48 0-48 0L0 160l0 48 0 96z']
      
    ]
  };

  

  
  

  var faUpRightAndDownLeftFromCenter = {
    prefix: 'fasds',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
      512,
      512,
      ["expand-alt"],
      'f424',
      
      ['M0 352L0 512l160 0 32-32-52-52L240 328l-56-56L84 372 32 320 0 352z','M480 192l32-32L512 0 352 0 320 32l52 52L272 184l56 56L428 140l52 52z']
      
    ]
  };

  
    var faExpandAlt = faUpRightAndDownLeftFromCenter;
  

  
  

  var faHashtag = {
    prefix: 'fasds',
    iconName: 'hashtag',
    icon: [
      448,
      512,
      [62098],
      '23',
      
      ['M74.2 480c5.3-32 10.7-64 16-96l10.7-64c7.1-42.7 14.2-85.3 21.3-128l64.9 0c-7.1 42.7-14.2 85.3-21.3 128l-10.7 64c-5.3 32-10.7 64-16 96l-64.9 0zm58.7-352l16-96 64.9 0-16 96-64.9 0zM234.2 480l16-96 64.9 0-16 96-64.9 0zm26.7-160c7.1-42.7 14.2-85.3 21.3-128c3.6-21.3 7.1-42.7 10.7-64c5.3-32 10.7-64 16-96l64.9 0c-5.3 32-10.7 64-16 96l-10.7 64c-7.1 42.7-14.2 85.3-21.3 128l-64.9 0z','M45.8 128l2.2 0 244.9 0-10.7 64L48 192l-12.9 0 10.7-64zM3.1 384l10.7-64 2.2 0 84.9 0L90.2 384 16 384 3.1 384zm399.1 0l-2.2 0-244.9 0 10.7-64L400 320l12.9 0-10.7 64zm42.7-256l-10.7 64-2.2 0-84.9 0 10.7-64 74.2 0 12.9 0z']
      
    ]
  };

  

  
  

  var faFaceExplode = {
    prefix: 'fasds',
    iconName: 'face-explode',
    icon: [
      512,
      512,
      ["exploding-head"],
      'e2fe',
      
      ['M0 253.5c0 .8 0 1.7 0 2.5C0 397.4 114.6 512 256 512s256-114.6 256-256c0-.8 0-1.7 0-2.5l-45.4 17.5-7.5 2.9-6.8-4.2-42.7-26.7-42.7 26.7-8.5 5.3-8.5-5.3-42.7-26.7-42.7 26.7-8.5 5.3-8.5-5.3-42.7-26.7-42.7 26.7-8.5 5.3-8.5-5.3-42.7-26.7L59.7 269.6l-6.8 4.2-7.5-2.9L0 253.5zM208.4 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM192 448c0-35.3 28.7-64 64-64s64 28.7 64 64l-128 0zM368.4 336a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M320 160l0 53.1-4.3-2.7-8.5-5.3-8.5 5.3L256 237.1l-42.7-26.7-8.5-5.3-8.5 5.3-4.3 2.7 0-53.1-32 0-40 0c-30.9 0-56-25.1-56-56s25.1-56 56-56c8.9 0 17.3 2.1 24.8 5.8C149.7 23.3 176.1 0 208 0c19.1 0 36.3 8.4 48 21.7C267.7 8.4 284.9 0 304 0c31.9 0 58.3 23.3 63.2 53.8c7.5-3.7 15.9-5.8 24.8-5.8c30.9 0 56 25.1 56 56s-25.1 56-56 56l-40 0-32 0zM144.4 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z']
      
    ]
  };

  
    var faExplodingHead = faFaceExplode;
  

  
  

  var faSquareXmark = {
    prefix: 'fasds',
    iconName: 'square-xmark',
    icon: [
      448,
      512,
      [10062,"times-square","xmark-square"],
      'f2d3',
      
      ['M0 32L0 480l448 0 0-448L0 32zM126.1 192c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.3-31.3 47-47c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9l-17-17-47-47c-15.7 15.7-31.3 31.3-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-5.7-5.7-11.3-11.3-17-17z','M305 209l17-17L288 158.1l-17 17-47 47-47-47-17-17L126.1 192l17 17 47 47-47 47-17 17L160 353.9l17-17 47-47 47 47 17 17L321.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faTimesSquare = faSquareXmark;
  
    var faXmarkSquare = faSquareXmark;
  

  
  

  var faFacePouting = {
    prefix: 'fasds',
    iconName: 'face-pouting',
    icon: [
      512,
      512,
      [],
      'e387',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm107.8-53.9c3.4-10.1 6.7-20.2 10.1-30.4c5.1 1.7 10.1 3.4 15.2 5.1c32 10.7 64 21.3 96 32c5.1 1.7 10.1 3.4 15.2 5.1c-3.4 10.1-6.7 20.2-10.1 30.4l-15.2-5.1-10.9-3.6c.2 1.5 .3 2.9 .3 4.4c0 17.7-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.8-.1-1.6-.1-1.6l0-1.7c0-.5 0-1.1 0-1.6s.1-1.1 .1-1.6c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1-4.1 1.9-6c1.6-3.8 3.9-7.3 6.8-10.2c-10.2-3.4-20.5-6.8-30.7-10.2c-5.1-1.7-10.1-3.4-15.2-5.1zM152 414.6c4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 395.4 294.3 384 255.6 384s-74.5 11.4-103.6 30.6zM267.8 213.9c5.1-1.7 10.1-3.4 15.2-5.1c32-10.7 64-21.3 96-32c5.1-1.7 10.1-3.4 15.2-5.1c3.4 10.1 6.7 20.2 10.1 30.4c-5.1 1.7-10.1 3.4-15.2 5.1c-10.1 3.4-20.1 6.7-30.2 10.1c5.9 5.8 9.5 13.9 9.5 22.8c0 17.7-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.8-.1-1.6-.1-1.6l0-1.7c0-.8 0-1.5 .1-2.3s.1-1.6 .3-2.3c-3.9 1.3-7.8 2.6-11.7 3.9c-5.1 1.7-10.1 3.4-15.2 5.1l-10.1-30.4z','M133.1 176.8l-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32zm256 30.4l15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1z']
      
    ]
  };

  

  
  

  var faContainerStorage = {
    prefix: 'fasds',
    iconName: 'container-storage',
    icon: [
      640,
      512,
      [],
      'f4b7',
      
      ['M32 96l0 320 576 0 0-320L32 96zm96 32l48 0 0 24 0 208 0 24-48 0 0-24 0-208 0-24zm112 0l48 0 0 24 0 208 0 24-48 0 0-24 0-208 0-24zm112 0l48 0 0 24 0 208 0 24-48 0 0-24 0-208 0-24zm112 0l48 0 0 24 0 208 0 24-48 0 0-24 0-208 0-24z','M32 32L0 32 0 96l32 0 576 0 32 0 0-64-32 0L32 32zm0 384L0 416l0 64 32 0 576 0 32 0 0-64-32 0L32 416z']
      
    ]
  };

  

  
  

  var faEarthOceania = {
    prefix: 'fasds',
    iconName: 'earth-oceania',
    icon: [
      512,
      512,
      ["globe-oceania"],
      'e47b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 32l64-64 32 0 0 32 32 0 0-32 32 0 64 64 0 96-96 0-32-32-96 0 0-64zm96-160l96 0 0 64-64 0-32-32 0-32zm32 288l64 0 0 32-64 0 0-32zm121.4-16l11.3-11.3 32-32L400 345.4 422.6 368l-11.3 11.3-32 32L368 422.6 345.4 400zM416 256l32 0 0 64-32 0 0-64z','M192 160l32 32 64 0 0-64-96 0 0 32zm256 96l-32 0 0 64 32 0 0-64zM422.6 368L400 345.4l-11.3 11.3-32 32L345.4 400 368 422.6l11.3-11.3 32-32L422.6 368zM224 448l64 0 0-32-64 0 0 32zM96 352l96 0 32 32 96 0 0-96-64-64-32 0 0 32-32 0 0-32-32 0L96 288l0 64z']
      
    ]
  };

  
    var faGlobeOceania = faEarthOceania;
  

  
  

  var faGopuram = {
    prefix: 'fasds',
    iconName: 'gopuram',
    icon: [
      512,
      512,
      [],
      'f664',
      
      ['M96 352l0 160 32 0 0-160-32 0zm32-128l0 128 32 0 0-128-32 0zm32-96l0 96 32 0 0-96-32 0zm160 0l0 96 32 0 0-96-32 0zm32 96l0 128 32 0 0-128-32 0zm32 128l0 160 32 0 0-160-32 0z','M144 0l0 24 0 8 40 0 0-8 0-24 48 0 0 24 0 8 48 0 0-8 0-24 48 0 0 24 0 8 40 0 0-8 0-24 48 0 0 24 0 8 0 32 0 24 0 40 32 0 0 96 32 0 0 128 32 0 0 160-96 0 0-160-32 0 0-128-32 0 0-96-32 0 0 96 32 0 0 128 32 0 0 160-80 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 48-80 0 0-160 32 0 0-128 32 0 0-96-32 0 0 96-32 0 0 128-32 0 0 160L0 512 0 352l32 0 0-128 32 0 0-96 32 0 0-40 0-24 0-32 0-8L96 0l48 0zM256 272c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zm-32-80l0 32 64 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32z']
      
    ]
  };

  

  
  

  var faMelon = {
    prefix: 'fasds',
    iconName: 'melon',
    icon: [
      512,
      512,
      [],
      'e310',
      
      ['M0 256c0 55.3 17.6 106.6 47.4 148.4l.2 .3c3.2-70.3 20.6-187.3 95.2-261.9C224.8 61 332 44.8 399.4 43.9C358.5 16.2 309.1 0 256 0C114.6 0 0 114.6 0 256zM79 429.8c0 2.6 0 5 0 7.3c.5 .1 .9 .1 1.4 .2c18.7 2.2 43.1 3.6 71.6 1c56.8-5.3 129.5-26.8 194.5-91.8s86.4-137.7 91.8-194.5c2.7-28.5 1.3-53-.8-70.1c-.2-1.7-.4-3.3-.6-4.8c-2.1-.2-4.4-.3-6.8-.5c-18.6-1.1-44.7-1.3-74.5 2.2c-59.9 7.1-132.4 29-190.1 86.7c-49 49-71.3 121.1-80.6 184.7c-4.6 31.3-5.8 59.4-5.9 79.6zm39.1 41.9C157.9 497.2 205.2 512 256 512c141.4 0 256-114.6 256-256c0-50.8-14.8-98.1-40.3-137.9c.4 65-16.1 164.5-102.6 251s-186 103-251 102.6z','M399.4 43.9c28.9 19.6 53.5 44.8 72.3 74.2c.4 65-16.1 164.5-102.6 251s-186 103-251 102.6c-27.6-17.6-51.5-40.4-70.5-67c3.2-70.3 20.6-187.3 95.2-261.9C224.8 61 332 44.8 399.4 43.9zM81.9 437.5c17.2 2.1 41.6 3.5 70.1 .8c56.9-5.3 129.5-26.8 194.5-91.8s86.4-137.7 91.8-194.5c2.7-28.5 1.3-53-.8-70.1c-.2-1.7-.4-3.3-.6-4.8c-2.1-.2-4.4-.3-6.8-.5c-18.6-1.1-44.7-1.3-74.5 2.2c-59.9 7.1-132.4 29-190.1 86.7c-49 49-71.3 121.1-80.6 184.7c-4.6 31.3-5.8 59.4-5.9 79.6c0 2.6 0 5 0 7.3c.9 .1 1.9 .2 2.9 .4z']
      
    ]
  };

  

  
  

  var faLightbulbCflOn = {
    prefix: 'fasds',
    iconName: 'lightbulb-cfl-on',
    icon: [
      640,
      512,
      [],
      'e5a7',
      
      ['M160 32l0 64L320 64l0-64L160 32zm0 96l0 64 320-64 0-64L160 128zm0 96l0 64 320-64 0-64L160 224zm96 77.4l0 82.6 48 0 0-92.2-48 9.6zm80-16.6l0 35.2 0 28.8 0 35.2 48 0 0-44.8L480 320l0-64L336 284.8z','M55.3 16l6 4 24 16 20 13.3L78.7 89.3 58.7 76l-24-16-6-4L8.7 42.7 35.3 2.7 55.3 16zM611.3 56l-6 4-24 16-20 13.3L534.7 49.3l20-13.3 24-16 6-4 20-13.3 26.6 39.9L611.3 56zM24 160l50 0 24 0 0 48-24 0-50 0L0 208l0-48 24 0zm542 0l50 0 24 0 0 48-24 0-50 0-24 0 0-48 24 0zM85.3 332l-24 16-6 4-20 13.3L8.7 325.3l20-13.3 6-4 24-16 20-13.3 26.6 39.9L85.3 332zm496-39.9l24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9 20 13.3zM224 384l192 0 0 96-64 0 0 32-64 0 0-32-64 0 0-96z']
      
    ]
  };

  

  
  

  var faCardHeart = {
    prefix: 'fasds',
    iconName: 'card-heart',
    icon: [
      384,
      512,
      [],
      'e3eb',
      
      ['M0 0L0 512l384 0L384 0 0 0zM80 219.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L192 352.1l-11.1-10.7L98.2 261.8C86.6 250.7 80 235.3 80 219.2z','M139.2 160C106.5 160 80 186.5 80 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L192 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z']
      
    ]
  };

  

  
  

  var faShieldHeart = {
    prefix: 'fasds',
    iconName: 'shield-heart',
    icon: [
      512,
      512,
      [],
      'e574',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zm352 86.3c0-.4 0-.3 0 0z','M203.2 160c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z']
      
    ]
  };

  

  
  

  var faVacuum = {
    prefix: 'fasds',
    iconName: 'vacuum',
    icon: [
      640,
      512,
      [],
      'e04d',
      
      ['M352 128l0 197.5c10-3.5 20.8-5.5 32-5.5c53 0 96 43 96 96s-43 96-96 96l224 0 0-192c0-54.8-23-104.2-59.8-139.2C513.8 148.1 467.2 128 416 128l-64 0z','M249.9 64L512 64c35.3 0 64 28.7 64 64c0 21.9-11 41.2-27.8 52.8c15.5 14.7 28.6 32 38.5 51.2C619 208.7 640 170.8 640 128C640 57.3 582.7 0 512 0L224 0 198.1 0l-5.4 25.3L150.1 224l65.5 0L249.9 64zM208.7 256l-65.5 0L109 416l-61 0L0 464l0 48 127.4 0c.4 0 .9 0 1.3 0l95.3 0 0-96-49.6 0 34.3-160zM384 512a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faBroom = {
    prefix: 'fasds',
    iconName: 'broom',
    icon: [
      576,
      512,
      [129529],
      'f51a',
      
      ['M328 200L528 0l48 48L376 248l-48-48z','M416 288L288 160l-32 0 0 51.7L364.3 320l51.7 0 0-32zm-74.9 65.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3C79.4 304.6 64 341.8 64 380.5l0 3.5 96-48L0 480l0 32 195.5 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z']
      
    ]
  };

  

  
  

  var faCoinBlank = {
    prefix: 'fasds',
    iconName: 'coin-blank',
    icon: [
      512,
      512,
      [],
      'e3fb',
      
      ['M0 208c0 79.5 114.6 144 256 144s256-64.5 256-144s-114.6-144-256-144S0 128.5 0 208z','M48 331c-18.3-11.5-34.8-25.2-48-40.9L0 320c0 27.9 17.8 53.6 48 74.6L48 331zm32 17.3L80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29zM256 448c-16.4 0-32.5-.8-48-2.2l0-64.1c15.7 1.6 31.7 2.4 48 2.4s32.3-.8 48-2.4l0 64.1c-15.5 1.5-31.6 2.2-48 2.2zm80-70.7l0 64.3c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29zM512 320c0 27.9-17.8 53.6-48 74.6l0-63.7c18.3-11.5 34.8-25.2 48-40.9l0 29.9z']
      
    ]
  };

  

  
  

  var faCircleArrowUpLeft = {
    prefix: 'fasds',
    iconName: 'circle-arrow-up-left',
    icon: [
      512,
      512,
      [],
      'e0fb',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144 144l24 0 152 0 24 0 0 48-24 0-94.1 0L361 327l17 17L344 377.9l-17-17-135-135L192 328l0 24-48 0 0-24 0-160 0-24z','M144 144l24 0 152 0 24 0 0 48-24 0-94.1 0L361 327l17 17L344 377.9l-17-17-135-135L192 328l0 24-48 0 0-24 0-160 0-24z']
      
    ]
  };

  

  
  

  var faCircleG = {
    prefix: 'fasds',
    iconName: 'circle-g',
    icon: [
      512,
      512,
      [],
      'e10f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C295.2 183.7 276.5 176 256 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L280 280l-24 0 0-48 24 0 80 0 24 0 0 24c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M256 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L280 280l-24 0 0-48 24 0 80 0 24 0 0 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C295.2 183.7 276.5 176 256 176z']
      
    ]
  };

  

  
  

  var faSkeleton = {
    prefix: 'fasds',
    iconName: 'skeleton',
    icon: [
      512,
      512,
      [],
      'f620',
      
      ['M0 160l0 64 32 0 192 0 0-64L32 160 0 160zM64 64l0 64 32 0 128 0 0-64L96 64 64 64zM96 256l0 64 32 0 96 0 0-64-96 0-32 0zM288 64l0 64 128 0 32 0 0-64-32 0L288 64zm0 96l0 64 192 0 32 0 0-64-32 0-192 0zm0 96l0 64 96 0 32 0 0-64-32 0-96 0z','M288 0l0 32 0 352 0 2.3L368 352l80 0 0 96-64 64-256 0L64 448l0-96 80 0 80 34.3 0-2.3 0-352 0-32 64 0zM184 440a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm192 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleCurrency = {
    prefix: 'fasds',
    iconName: 'display-chart-up-circle-currency',
    icon: [
      640,
      512,
      [],
      'e5e5',
      
      ['M0 0L0 416l240 0-10.7 32L160 448l-32 0 0 64 32 0 234.8 0C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16L64 352 64 64l448 0 0 128.7c22.9 2.1 44.5 8.5 64 18.5L576 0 0 0zM103 279L137 313l87-87 63 63 17 17 17-17 111-111 0 22.1 0 4c15.1-5.9 31.2-9.8 48-11.3l0-72.7 0-24-24 0-80 0-24 0 0 48 24 0 22.1 0L304 238.1l-63-63-17-17-17 17L103 279z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM460.7 426l-25.3 25.3-22.6-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-25.3-25.3 22.6-22.6L460.7 310c21.6-13.2 49.1-13.2 70.7 0l25.3-25.3 22.6 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l25.3 25.3-22.6 22.6L531.3 426c-21.6 13.2-49.1 13.2-70.7 0z']
      
    ]
  };

  

  
  

  var faPersonBiking = {
    prefix: 'fasds',
    iconName: 'person-biking',
    icon: [
      640,
      512,
      [128692,"biking"],
      'f84a',
      
      ['M0 384a128 128 0 1 0 256 0A128 128 0 1 0 0 384zm200 0A72 72 0 1 1 56 384a72 72 0 1 1 144 0zm184 0a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm200 0a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z','M400 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM336 88l91.2 72 84.8 0 0 64-107.2 0-49.5-39.6L295 232.9l57 38L352 448l-64 0 0-142.9-60.5-38.4c-32.8-20.8-35-67.9-4.3-91.6L336 88z']
      
    ]
  };

  
    var faBiking = faPersonBiking;
  

  
  

  var faTemperatureLow = {
    prefix: 'fasds',
    iconName: 'temperature-low',
    icon: [
      512,
      512,
      [],
      'f76b',
      
      ['M0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L256 64l0-64L192 0 96 0 32 0l0 64 0 213.5C12 302.2 0 333.7 0 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L96 300.2l0-22.7L96 64l96 0 0 213.5 0 22.7 14.2 17.6C217.4 331.5 224 348.9 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM160 256l-32 0 0 16 0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7 0-16z']
      
    ]
  };

  

  
  

  var faCodeCommit = {
    prefix: 'fasds',
    iconName: 'code-commit',
    icon: [
      640,
      512,
      [],
      'f386',
      
      ['M0 224l0 64 32 0 144 0 0-64L32 224 0 224zm464 0l0 64 144 0 32 0 0-64-32 0-144 0z','M384 192l0 128-128 0 0-128 128 0zM256 112l-80 0 0 80 0 128 0 80 80 0 128 0 80 0 0-80 0-128 0-80-80 0-128 0z']
      
    ]
  };

  

  
  

  var faFileMusic = {
    prefix: 'fasds',
    iconName: 'file-music',
    icon: [
      384,
      512,
      [],
      'f8b6',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM64 416c0 17.7 21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32 0-23.1L266.4 209l-128 48L128 260.9l0 11.1 0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32z','M384 160L224 0l0 160 160 0zm-96 64l0-23.1L266.4 209l-128 48L128 260.9l0 11.1 0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32z']
      
    ]
  };

  

  
  

  var faClockOne = {
    prefix: 'fasds',
    iconName: 'clock-one',
    icon: [
      512,
      512,
      [],
      'e34e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 96l48 0 0 24 0 56.7 20-30 13.3-20 39.9 26.6-13.3 20-64 96L232 256l0-136 0-24z','M280 96l0 24 0 56.7 20-30 13.3-20 39.9 26.6-13.3 20-64 96L232 256l0-136 0-24 48 0z']
      
    ]
  };

  

  
  

  var faCompassSlash = {
    prefix: 'fasds',
    iconName: 'compass-slash',
    icon: [
      640,
      512,
      [],
      'f5e9',
      
      ['M64 256c0-33.6 6.5-65.8 18.3-95.2L228.1 275.7 192 384l121.9-40.6L468.1 464.8C426.3 494.5 375.2 512 320 512C178.6 512 64 397.4 64 256zM133.4 80.8C180.1 31.1 246.4 0 320 0C461.4 0 576 114.6 576 256c0 50.6-14.7 97.7-40 137.4L395.8 284.5 448 128 270.4 187.2c-45.7-35.5-91.4-70.9-137.1-106.4z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faMusic = {
    prefix: 'fasds',
    iconName: 'music',
    icon: [
      512,
      512,
      [127925],
      'f001',
      
      ['M128 120.2l0 23.8 0 72 0 140.6c37.3 11 64 40.6 64 75.4l0-192.2L448 163l0 129.5c37.3 11 64 40.6 64 75.4l0-248 0-72 0-43L470.8 17.4l-320 96L128 120.2z','M416 448c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80zM96 512c53 0 96-35.8 96-80s-43-80-96-80s-96 35.8-96 80s43 80 96 80z']
      
    ]
  };

  

  
  

  var faYinYang = {
    prefix: 'fasds',
    iconName: 'yin-yang',
    icon: [
      512,
      512,
      [9775],
      'f6ad',
      
      ['M128 384c0 70.7 57.3 128 128 128c141.4 0 256-114.6 256-256C512 115.9 399.4 2 259.8 0C328.7 2.1 384 58.6 384 128c0 70.7-57.3 128-128 128s-128 57.3-128 128zm88-256l40 40 40-40L256 88l-40 40zm0 256l40-40 40 40-40 40-40-40z','M0 256C0 114.6 114.6 0 256 0c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128 57.3-128 128s57.3 128 128 128C114.6 512 0 397.4 0 256zM216 384l40-40 40 40-40 40-40-40zM256 88l-40 40 40 40 40-40L256 88z']
      
    ]
  };

  

  
  

  var faSendBackward = {
    prefix: 'fasds',
    iconName: 'send-backward',
    icon: [
      512,
      512,
      [],
      'f87f',
      
      ['M160 160l192 0 160 0 0 352-352 0 0-160 0-192zm64 64l0 224 224 0 0-224-224 0z','M352 0L0 0 0 352l160 0 0-192 192 0L352 0z']
      
    ]
  };

  

  
  

  var faCheese = {
    prefix: 'fasds',
    iconName: 'cheese',
    icon: [
      512,
      512,
      [],
      'f7ef',
      
      ['M0 256l512 0C512 132.3 411.7 32 288 32L0 256z','M0 256H512V480H0V256z']
      
    ]
  };

  

  
  

  var faSquareStar = {
    prefix: 'fasds',
    iconName: 'square-star',
    icon: [
      448,
      512,
      [],
      'e27f',
      
      ['M0 32L0 480l448 0 0-448L0 32zM71.8 206.6L177 191.3 224 96l47 95.3 105.1 15.3-76.1 74.2 18 104.7L224 336l-94 49.4 18-104.7L71.8 206.6z','M224 96l47 95.3 105.1 15.3-76.1 74.2 18 104.7L224 336l-94 49.4 18-104.7L71.8 206.6 177 191.3 224 96z']
      
    ]
  };

  

  
  

  var faWineGlassEmpty = {
    prefix: 'fasds',
    iconName: 'wine-glass-empty',
    icon: [
      320,
      512,
      ["wine-glass-alt"],
      'f5ce',
      
      ['M78.2 198.5C73.9 246.5 111.7 288 160 288s86.1-41.5 81.8-89.5L229.6 64 90.4 64 78.2 198.5zm-63.7-5.8L32 0 288 0l17.5 192.7C312.3 267.3 262 332.9 192 348.5l0 99.5 80 0 0 64-112 0L48 512l0-64 80 0 0-99.5C58 332.9 7.7 267.3 14.5 192.7z','']
      
    ]
  };

  
    var faWineGlassAlt = faWineGlassEmpty;
  

  
  

  var faPenSlash = {
    prefix: 'fasds',
    iconName: 'pen-slash',
    icon: [
      640,
      512,
      [],
      'e213',
      
      ['M64 512l160-32L340.1 363.9 196.9 251.1 96 352 64 512zM265 183c48 37.3 96.1 74.6 144.1 111.9l75.6-75.6-128-128L265 183zM379.3 68.7l128 128L576 128 448 0 379.3 68.7z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faMoon = {
    prefix: 'fasds',
    iconName: 'moon',
    icon: [
      384,
      512,
      [9214,127769],
      'f186',
      
      ['M287.6 41.2c-82.8 21.2-144 96.5-144 186c0 106 85.8 192 191.5 192c16.8 0 33.1-2.2 48.6-6.2c-40.6 41.4-97.2 67-159.8 67C100.3 480 0 379.7 0 256S100.3 32 224 32c22.1 0 43.5 3.2 63.6 9.2z','']
      
    ]
  };

  

  
  

  var faArrowUpFromLine = {
    prefix: 'fasds',
    iconName: 'arrow-up-from-line',
    icon: [
      384,
      512,
      [8613,"arrow-from-bottom"],
      'f342',
      
      ['M0 416l32 0 320 0 32 0 0 64-32 0L32 480 0 480l0-64z','M192 34.7l22.6 22.6 128 128L365.3 208 320 253.3l-22.6-22.6L224 157.3 224 320l0 32-64 0 0-32 0-162.7L86.6 230.6 64 253.3 18.7 208l22.6-22.6 128-128L192 34.7z']
      
    ]
  };

  
    var faArrowFromBottom = faArrowUpFromLine;
  

  
  

  var faCarrot = {
    prefix: 'fasds',
    iconName: 'carrot',
    icon: [
      512,
      512,
      [129365],
      'f787',
      
      ['M0 512L127.2 219.5c.6-1.3 1.2-2.6 1.8-4l51.7 51.7L192 278.6 214.6 256l-11.3-11.3-56.6-56.6C170.2 160.6 205 144 242.4 144C311.8 144 368 200.2 368 269.6c0 50-29.7 95.3-75.5 115.2l-98.3 42.7-54.9-54.9L128 361.4 105.4 384l11.3 11.3 46 46L0 512z','M320 80c0-40 40-80 40-80s40 32 40 80c0 32-8 40-8 40s8-8 40-8c48 0 80 40 80 40s-40 40-80 40s-55.3-7.3-80-32s-32-40-32-80z']
      
    ]
  };

  

  
  

  var faAmpersand = {
    prefix: 'fasds',
    iconName: 'ampersand',
    icon: [
      448,
      512,
      [],
      '26',
      
      ['M112 32L80 32l0 32 0 65c0 28 10.5 54.9 29.3 75.5l31.2 34.1L76.8 286.4C48.6 307.6 32 340.7 32 376l0 72 0 32 32 0 192 0 17.1 0 9.5-14.2 27.6-41.4L361 480l86.7 0-16.1-17.6-84.9-92.9 63.9-95.8 17.8-26.6-53.3-35.5-17.8 26.6-55.1 82.6-67-73.3 39.9-29.9C303.4 196.4 320 163.3 320 128l0-64 0-32-32 0L112 32zM236.8 166.4l-44.9 33.7-35.4-38.7c-8.1-8.8-12.6-20.4-12.6-32.4l0-33 112 0 0 32c0 15.1-7.1 29.3-19.2 38.4zM115.2 337.6l68.7-51.5 81.9 89.6L238.9 416 96 416l0-40c0-15.1 7.1-29.3 19.2-38.4z','']
      
    ]
  };

  

  
  

  var faAtomSimple = {
    prefix: 'fasds',
    iconName: 'atom-simple',
    icon: [
      512,
      512,
      ["atom-alt"],
      'f5d3',
      
      ['M55.7 55.7C16.5 94.9 27.6 173.9 76.8 256C27.6 338.1 16.5 417.1 55.7 456.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zm45.3 45.3c1.3-1.3 16.8-12.4 64 3.3c10.4 3.5 21.4 8 32.8 13.6c-14.2 11.6-28.3 24.3-41.9 38s-26.4 27.7-38 41.9c-5.6-11.4-10.2-22.4-13.6-32.8c-15.7-47.2-4.6-62.7-3.3-64zm0 310.1c-1.3-1.3-12.4-16.8 3.3-64c3.5-10.4 8-21.4 13.6-32.9c11.6 14.2 24.3 28.3 38 41.9s27.7 26.4 41.9 38c-11.4 5.6-22.4 10.2-32.8 13.6c-47.2 15.7-62.7 4.6-64 3.3zM153.7 256c13.5-18.3 29.3-36.8 47.4-54.9s36.6-33.9 54.9-47.4c18.3 13.5 36.8 29.3 54.9 47.4s33.9 36.6 47.4 54.9c-13.5 18.3-29.3 36.8-47.4 54.9s-36.6 33.9-54.9 47.4c-18.3-13.5-36.8-29.3-54.9-47.4s-33.9-36.6-47.4-54.9zM314.2 117.9c11.4-5.6 22.4-10.2 32.9-13.6c47.2-15.7 62.7-4.6 64-3.3s12.4 16.8-3.3 64c-3.5 10.4-8 21.4-13.6 32.8c-11.6-14.2-24.3-28.3-38-41.9s-27.7-26.4-41.9-38zm0 276.2c14.2-11.6 28.3-24.3 41.9-38s26.4-27.7 38-41.9c5.6 11.4 10.2 22.4 13.6 32.9c15.7 47.2 4.6 62.7 3.3 64s-16.8 12.4-64-3.3c-10.4-3.5-21.4-8-32.9-13.6z','M256 296l-40-40 40-40 40 40-40 40z']
      
    ]
  };

  
    var faAtomAlt = faAtomSimple;
  

  
  

  var faPenLine = {
    prefix: 'fasds',
    iconName: 'pen-line',
    icon: [
      576,
      512,
      [],
      'e212',
      
      ['M224 464l24 0 304 0 24 0 0 48-24 0-304 0-24 0 0-48zM288 96L384 0 512 128l-96 96L288 96z','M32 352L0 512l160-32L416 224 288 96 32 352z']
      
    ]
  };

  

  
  

  var faDog = {
    prefix: 'fasds',
    iconName: 'dog',
    icon: [
      576,
      512,
      [128021],
      'f6d3',
      
      ['M303.9 192c33 18.9 66.1 37.8 99.2 56.7c4.2 2.4 8.5 4.8 12.9 7.4c1.9-11.3 3.8-22.5 5.6-33.6l-112-64c-1.9 11.2-3.7 22.3-5.7 33.5z','M309.6 158.5L336 0l32 0 24 32 72 0 32 32 80 0 0 48c0 44.2-35.8 80-80 80l-32 0-16 0-21.3 0-5.1 30.5-112-64zM416 256.1L416 512l-96 0 0-147.2c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2L160 512l-96 0 0-264.9c-29.1-13.6-50.5-41.4-54.8-75.1l-1-7.9-4-31.8 63.5-7.9 4 31.8 1 7.9c2 16 15.6 28 31.8 28l39.5 0 16 0 16 0 127.8 0L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faWandMagic = {
    prefix: 'fasds',
    iconName: 'wand-magic',
    icon: [
      512,
      512,
      ["magic"],
      'f0d0',
      
      ['M280 120l80.4-80.4L400 0l39.6 39.6 32.8 32.8L512 112l-39.6 39.6L392 232l-39.6-39.6L432.8 112 400 79.2l-80.4 80.4L280 120z','M392 232L280 120 0 400 112 512 392 232z']
      
    ]
  };

  
    var faMagic = faWandMagic;
  

  
  

  var faTents = {
    prefix: 'fasds',
    iconName: 'tents',
    icon: [
      640,
      512,
      [],
      'e582',
      
      ['M228.8 124.8l12.9 8.6 192 128 11.9 7.9 2 14.2 9.8 68.5L640 352 608 128 416 0 228.8 124.8z','M32 288L0 512H224V352l96 160H448L416 288 224 160 32 288z']
      
    ]
  };

  

  
  

  var faCricketBatBall = {
    prefix: 'fasds',
    iconName: 'cricket-bat-ball',
    icon: [
      512,
      512,
      [127951,"cricket"],
      'f449',
      
      ['M.2 349.8C-.2 367.1 .6 384 3.8 401c4 21.4 13.1 51.4 35.2 71.9c20.6 22.1 50.6 31.2 71.9 35.2c17 3.2 34 4 51.2 3.6C226.1 447.8 290 383.9 353.9 320c-48.7 0-97.3 0-145.9 0c-5.3 0-10.7 0-16 0c0-5.3 0-10.7 0-16c0-48.7 0-97.3 0-145.9L.2 349.8zM224 126.1c0 54 0 108 0 161.9c54 0 108 0 161.9 0c13.3-13.3 26.7-26.7 40-40c-19.4-19.4-38.9-38.9-58.3-58.3c-15.1-15.1-30.2-30.2-45.3-45.3L264 86.1c-13.3 13.3-26.7 26.7-40 40z','M509.3 48L486.6 70.6l-119 119-45.3-45.3 119-119L464 2.7 509.3 48zM385.9 288l-32 32L208 320l-16 0 0-16 0-145.9 32-32L224 288l161.9 0zM352 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z']
      
    ]
  };

  
    var faCricket = faCricketBatBall;
  

  
  

  var faDiagramCells = {
    prefix: 'fasds',
    iconName: 'diagram-cells',
    icon: [
      512,
      512,
      [],
      'e475',
      
      ['M0 288L0 480l512 0 0-192L0 288z','M512 224V32L0 32 0 224l512 0z']
      
    ]
  };

  

  
  

  var faFaceDiagonalMouth = {
    prefix: 'fasds',
    iconName: 'face-diagonal-mouth',
    icon: [
      512,
      512,
      [129764],
      'e47e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM124.2 357l15.4-4.4 224-64 15.4-4.4 8.8 30.8-15.4 4.4-224 64L133 387.8 124.2 357zm20.2-149c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faTentArrowTurnLeft = {
    prefix: 'fasds',
    iconName: 'tent-arrow-turn-left',
    icon: [
      576,
      512,
      [],
      'e580',
      
      ['M64 512l224 0 0-160 96 160 128 0L480 288 288 160 96 288 64 512z','M126.7 35.2l-17 17L89.9 72 456 72c66.3 0 120 53.7 120 120l0 40 0 24-48 0 0-24 0-40c0-39.8-32.2-72-72-72L89.9 120l19.8 19.8 17 17L92.8 190.7l-17-17L15 113l-17-17L15 79 75.8 18.2l17-17 33.9 33.9z']
      
    ]
  };

  

  
  

  var faBanParking = {
    prefix: 'fasds',
    iconName: 'ban-parking',
    icon: [
      512,
      512,
      ["parking-circle-slash"],
      'f616',
      
      ['M168 261.3l0 26.7 0 64 0 32 64 0 0-32 0-26.7-64-64zM173.3 128l64 64 42.7 0c17.7 0 32 14.3 32 32c0 11.6-6.2 21.7-15.4 27.4L342.3 297c20.6-17.6 33.7-43.8 33.7-73c0-53-43-96-96-96l-80 0-26.7 0z','M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z']
      
    ]
  };

  
    var faParkingCircleSlash = faBanParking;
  

  
  

  var faPenNib = {
    prefix: 'fasds',
    iconName: 'pen-nib',
    icon: [
      512,
      512,
      [10001],
      'f5ad',
      
      ['M0 448l20.7 20.7 144-144c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7l-144 144L64 512l288-96 64-192L288 96 96 160 0 448z','M512 128l-96 96L288 96 384 0 512 128z']
      
    ]
  };

  

  
  

  var faScythe = {
    prefix: 'fasds',
    iconName: 'scythe',
    icon: [
      640,
      512,
      [],
      'f710',
      
      ['M0 192l532.3 0L573.4 0 352 0C80 0 0 192 0 192z','M637.4 0l-64 0L511.7 288 416 288l-32 0 0 64 32 0 82 0L463.7 512l64 0L637.4 0z']
      
    ]
  };

  

  
  

  var faHouseChimneyWindow = {
    prefix: 'fasds',
    iconName: 'house-chimney-window',
    icon: [
      576,
      512,
      [],
      'e00d',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272zm160-32l128 0 0 128-128 0 0-128z','M288 0L0 240l0 32 64 0L288 88 512 272l64 0 0-32-64-53.3L512 32l-96 0 0 74.7L288 0z']
      
    ]
  };

  

  
  

  var faCircleChevronLeft = {
    prefix: 'fasds',
    iconName: 'circle-chevron-left',
    icon: [
      512,
      512,
      ["chevron-circle-left"],
      'f137',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm150.1 0c5.7-5.7 11.3-11.3 17-17c34.7-34.7 69.3-69.3 104-104c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17l-87 87c29 29 58 58 87 87c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9l-17-17c-34.7-34.7-69.3-69.3-104-104l-17-17z','M150.1 256l17-17L271 135l17-17L321.9 152l-17 17-87 87 87 87 17 17L288 393.9l-17-17L167 273l-17-17z']
      
    ]
  };

  
    var faChevronCircleLeft = faCircleChevronLeft;
  

  
  

  var faGolfBallTee = {
    prefix: 'fasds',
    iconName: 'golf-ball-tee',
    icon: [
      384,
      512,
      ["golf-ball"],
      'f450',
      
      ['M0 192c0 66.8 34.1 125.6 85.8 160l212.3 0c51.7-34.4 85.8-93.2 85.8-160C384 86 298 0 192 0S0 86 0 192zm176 12.3c4.2 1.9 8.9 3 13.8 3c18.5 0 33.5-15 33.5-33.5c0-4.9-1.1-9.6-3-13.8c11.6 5.3 19.7 16.9 19.7 30.5c0 18.5-15 33.5-33.5 33.5c-13.6 0-25.3-8.1-30.5-19.7zm18.8 82.8c4.2 1.9 8.9 3 13.8 3c18.5 0 33.5-15 33.5-33.5c0-4.9-1.1-9.6-3-13.8c11.6 5.3 19.7 16.9 19.7 30.5c0 18.5-15 33.5-33.5 33.5c-13.6 0-25.3-8.1-30.5-19.7zM256 220.3c4.2 1.9 8.9 3 13.8 3c18.5 0 33.5-15 33.5-33.5c0-4.9-1.1-9.6-3-13.8c11.6 5.3 19.7 16.9 19.7 30.5c0 18.5-15 33.5-33.5 33.5c-13.6 0-25.3-8.1-30.5-19.7z','M288 384H96v64h64v64h64V448h64V384z']
      
    ]
  };

  
    var faGolfBall = faGolfBallTee;
  

  
  

  var faHouseMedical = {
    prefix: 'fasds',
    iconName: 'house-medical',
    icon: [
      576,
      512,
      [],
      'e3b2',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16L288 88C213.3 149.3 138.7 210.6 64 272zm128 16l64 0 0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64z','M288 0L0 240l0 32 64 0L288 88 512 272l64 0 0-32L288 0zM256 288l-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64z']
      
    ]
  };

  

  
  

  var faPersonSeat = {
    prefix: 'fasds',
    iconName: 'person-seat',
    icon: [
      384,
      512,
      [],
      'e21e',
      
      ['M0 128l0 32L0 416l0 32 32 0 160 0 32 0 0-64-32 0L64 384l0-224 0-32L0 128z','M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm0 80l32 0 32 0 32 0 0 32 64 0 32 0 0 64-32 0-64 0 0 32 96 0 28.2 0 3.5 28 12.5 100 19.8 0 32 0 0 64-32 0-48 0-28.2 0-3.5-28L259.8 352 160 352c-35.3 0-64-28.7-64-64l0-96 0-32z']
      
    ]
  };

  

  
  

  var faDitto = {
    prefix: 'fasds',
    iconName: 'ditto',
    icon: [
      320,
      512,
      [],
      '22',
      
      ['M0 32L32 288l64 0L128 32 0 32z','M224 288L192 32H320L288 288H224z']
      
    ]
  };

  

  
  

  var faPhonePlus = {
    prefix: 'fasds',
    iconName: 'phone-plus',
    icon: [
      576,
      512,
      [],
      'f4d2',
      
      ['M32 32L176 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L400 288l144 80L512 512l-32 0C232.6 512 32 311.4 32 64l0-32z','M424 200l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24L424 0l0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  

  
  

  var faGlassesRound = {
    prefix: 'fasds',
    iconName: 'glasses-round',
    icon: [
      576,
      512,
      [128083,"glasses-alt"],
      'f5f5',
      
      ['M48 344a88 88 0 1 0 176 0A88 88 0 1 0 48 344zm304 0a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z','M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6c0 0 0 0 0 0l-.3 1c-5.3 19-10.6 38-16.5 60.9C80.4 217 107.2 208 136 208c55.1 0 102.6 32.8 124 80l56.1 0c21.3-47.2 68.8-80 124-80c28.8 0 55.6 9 77.6 24.3c-5.9-22.9-11.1-41.9-16.5-60.9l-.3-1s0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7 0 2.8 0 48 0 24s0 0 0 0c0 75.1-60.9 136-136 136c-72.4 0-131.6-56.6-135.8-128l-32.5 0c-4.1 71.4-63.3 128-135.8 128C60.9 480 0 419.1 0 344c0 0 0 0 0 0l0-24 0-48 0-2.8 .6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM528 344a88 88 0 1 0 -176 0 88 88 0 1 0 176 0zM48 344a88 88 0 1 0 176 0A88 88 0 1 0 48 344z']
      
    ]
  };

  
    var faGlassesAlt = faGlassesRound;
  

  
  

  var faBinary = {
    prefix: 'fasds',
    iconName: 'binary',
    icon: [
      384,
      512,
      [],
      'e33b',
      
      ['M0 0L0 32 0 192l0 32 32 0 128 0 32 0 0-32 0-160 0-32L160 0 32 0 0 0zM64 64l64 0 0 96-64 0 0-96zM192 288l0 32 0 160 0 32 32 0 128 0 32 0 0-32 0-160 0-32-32 0-128 0-32 0zm64 64l64 0 0 96-64 0 0-96z','M256 0L224 0l0 64 32 0 16 0 0 96-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32L304 0 256 0zM32 288L0 288l0 64 32 0 16 0 0 96-16 0L0 448l0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32-32 0-48 0z']
      
    ]
  };

  

  
  

  var faAvocado = {
    prefix: 'fasds',
    iconName: 'avocado',
    icon: [
      512,
      512,
      [],
      'e0aa',
      
      ['M60.9 156.9c-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c41.7-41.7 62-96.7 60.9-151.4l53.9-53.9c56.2-56.2 56.2-147.4 0-203.6C441.7 14.1 404.9 0 368 0s-73.7 14.1-101.8 42.2L212.3 96c-54.7-1.1-109.7 19.2-151.4 60.9zm87.5 206.7c-32.7-32.7-25.3-93 16.4-134.8C189 204.6 219.4 192 247.1 192c20.1 0 38.7 6.7 52.5 20.4s20.4 32.4 20.4 52.5c0 27.7-12.6 58.1-36.8 82.3c-41.7 41.7-102.1 49.1-134.8 16.4z','M299.6 212.4c32.7 32.7 25.3 93-16.4 134.8s-102.1 49.1-134.8 16.4s-25.3-93 16.4-134.8s102.1-49.1 134.8-16.4z']
      
    ]
  };

  

  
  

  var faGunSlash = {
    prefix: 'fasds',
    iconName: 'gun-slash',
    icon: [
      640,
      512,
      [],
      'e19c',
      
      ['M32 121.2L32 240l92 0L64 480l160 0 32-128 68.9 0L32 121.2zM111.8 64c27.5 21.3 55 42.7 82.4 64L512 128l0 32-276.6 0c34.3 26.7 68.7 53.3 103 80l43.5 0-9.4 26.4c13.3 10.3 26.6 20.7 39.9 31L432.9 240l47.1 0 32-32 96 0 0-144-48 0 0-8 0-24-48 0 0 24 0 8L111.8 64z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faArrowsRepeat1 = {
    prefix: 'fasds',
    iconName: 'arrows-repeat-1',
    icon: [
      512,
      512,
      ["repeat-1-alt"],
      'f366',
      
      ['M0 96l0 32 0 96 0 32 64 0 0-32 0-64 352 0 32 0 0-45.3-9.4-9.4-80-80L336 2.7 290.7 48l22.6 22.6L338.7 96 32 96 0 96zM64 352l0 45.3 9.4 9.4 80 80L176 509.3 221.3 464l-22.6-22.6L173.3 416 480 416l32 0 0-32 0-96 0-32-64 0 0 32 0 64L96 352l-32 0z','M216 192l24 0 24 0 24 0 0 24 0 80 0 24-48 0 0-24 0-56-24 0 0-48z']
      
    ]
  };

  
    var faRepeat1Alt = faArrowsRepeat1;
  

  
  

  var faArrowUpShortWide = {
    prefix: 'fasds',
    iconName: 'arrow-up-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-up-alt"],
      'f885',
      
      ['M288 32l32 0 32 0 32 0 0 64-32 0-32 0-32 0 0-64zm0 128l32 0 96 0 32 0 0 64-32 0-96 0-32 0 0-64zm0 128l32 0 160 0 32 0 0 64-32 0-160 0-32 0 0-64zm0 128l32 0 224 0 32 0 0 64-32 0-224 0-32 0 0-64z','M128 32.4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L160 162.8 160 448l0 32-64 0 0-32 0-285.2L71.7 189.5 50.2 213.2 2.8 170.2l21.5-23.7 80-88 23.7-26z']
      
    ]
  };

  
    var faSortAmountUpAlt = faArrowUpShortWide;
  

  
  

  var faShield = {
    prefix: 'fasds',
    iconName: 'shield',
    icon: [
      512,
      512,
      [128737,"shield-blank"],
      'f132',
      
      ['M267.6 4.5L256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5z','']
      
    ]
  };

  
    var faShieldBlank = faShield;
  

  
  

  var faFileExport = {
    prefix: 'fasds',
    iconName: 'file-export',
    icon: [
      576,
      512,
      ["arrow-right-from-file"],
      'f56e',
      
      ['M0 0L224 0l0 160 160 0 0 128-168 0-24 0 0 48 24 0 168 0 0 176L0 512 0 0z','M384 160L224 0l0 160 160 0zm105 55l-17-17L438.1 232l17 17 39 39L216 288l-24 0 0 48 24 0 278.1 0-39 39-17 17L472 425.9l17-17 80-80 17-17-17-17-80-80z']
      
    ]
  };

  
    var faArrowRightFromFile = faFileExport;
  

  
  

  var faPhoneMissed = {
    prefix: 'fasds',
    iconName: 'phone-missed',
    icon: [
      640,
      512,
      [],
      'e226',
      
      ['M0 400c37.3-48 153.6-144 320-144s282.7 96 320 144L576 512 416 464l0-80c-62.3-20.8-129.7-20.8-192 0l0 80L64 512 0 400z','M96 0l0 128 32 32 47-47 88 88 7 7 9.9 0 80 0 9.9 0 7-7L521 57l17-17L504 6.1 487 23l-137 137-60.1 0L209 79l47-47L224 0 96 0z']
      
    ]
  };

  

  
  

  var faFireSmoke = {
    prefix: 'fasds',
    iconName: 'fire-smoke',
    icon: [
      640,
      512,
      [],
      'f74b',
      
      ['M160 192.1c0 36 11.9 69.2 31.9 95.9c14.3-19.1 32.8-34.9 54.1-46c-3.9-9.4-6-20.2-6-32.1c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c11.3 20.7 12.3 44.9 4.2 65.2c21.2 11.1 39.6 26.8 53.9 45.9c20.1-26.7 31.9-59.9 31.9-95.9c0-73.6-96-160-96-160s-13.9 12.5-31 32c-32.3-37.5-65-64-65-64s-128 103.6-128 192z','M112 512L0 512 0 400c0-61.9 50.1-112 112-112c37 0 69.9 18 90.3 45.7C221.8 288 267.2 256 320 256s98.2 32 117.7 77.7C458.1 306 491 288 528 288c61.9 0 112 50.1 112 112l0 112-112 0-208 0-208 0z']
      
    ]
  };

  

  
  

  var faFaceGrinBeamSweat = {
    prefix: 'fasds',
    iconName: 'face-grin-beam-sweat',
    icon: [
      512,
      512,
      [128517,"grin-beam-sweat"],
      'f583',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-43.4 0-80-34.6-80-79c0-12.6 5-24.6 8.8-32.6c1.1-2.2 2.2-4.4 3.4-6.6C356 15.4 307.8 0 256 0C114.6 0 0 114.6 0 256zm96 46.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zM120 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M512 81c0 26-21.5 47-48 47s-48-21-48-47c0-18.3 29.2-56.5 44.3-76.1c1.4-1.8 2.6-3.4 3.7-4.9c1.3 1.7 2.8 3.7 4.5 5.9C483.7 25.9 512 63 512 81zM176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm104 80c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z']
      
    ]
  };

  
    var faGrinBeamSweat = faFaceGrinBeamSweat;
  

  
  

  var faTrumpet = {
    prefix: 'fasds',
    iconName: 'trumpet',
    icon: [
      640,
      512,
      [127930],
      'f8e3',
      
      ['M64 320c0 70.7 57.3 128 128 128l96 0 96 0c70.7 0 128-57.3 128-128l0-34.5c-20-13.2-41.5-23.1-64-27.3l0 61.7c0 29.8-20.4 54.9-48 62l0-126-16 0-32 0 0 128-40 0 0-128-48 0 0 128-40 0 0-128L81.1 256C70.2 274.8 64 296.7 64 320zm64 0c0-29.8 20.4-54.9 48-62l0 124c-27.6-7.1-48-32.2-48-62zm48-184l0 24 0 32 48 0 0-32 0-24-48 0zm88 0l0 24 0 32 48 0 0-32 0-24-48 0zm88 0l0 24 0 32 32 0 16 0 0-32 0-24-48 0z','M424 256c75.6 0 142.3 68.3 184 128l32 0 0-320-32 0c-41.7 59.7-108.4 128-184 128l-40 0L48 192l0-16L0 176l0 24 0 48 0 24 48 0 0-16 336 0 40 0z']
      
    ]
  };

  

  
  

  var faClockRotateLeft = {
    prefix: 'fasds',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ["history"],
      'f1da',
      
      ['M0 16L0 192l176 0-63.5-63.5C147.7 88.9 198.9 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4l-36.6 52.5C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C181.2 0 113.9 32.1 67.2 83.2L0 16z','M280 128l0 24 0 94.1 57 57 17 17L320 353.9l-17-17-64-64-7-7 0-9.9 0-104 0-24 48 0z']
      
    ]
  };

  
    var faHistory = faClockRotateLeft;
  

  
  

  var faNestingDolls = {
    prefix: 'fasds',
    iconName: 'nesting-dolls',
    icon: [
      640,
      512,
      [],
      'e3ba',
      
      ['M80 112C80 50.1 130.1 0 192 0s112 50.1 112 112l0 144L80 256l0-144zm48-16.4c-.1 16.5 6.1 33.1 18.7 45.6c25 25 65.5 25 90.5 0c12.6-12.6 18.8-29.1 18.7-45.6c-28.2-2.8-52.1-20.3-64-44.7c-11.9 24.4-35.8 41.9-64 44.7zm256 256c2.6 .3 5.3 .4 8 .4c31.7 0 59-18.4 72-45.1c13 26.7 40.3 45.1 72 45.1c2.7 0 5.4-.1 8-.4l0 .4c0 10.2-2 20.5-5.9 30.1s-9.8 18.7-17.6 26.5C504.9 424.2 484.5 432 464 432s-40.9-7.8-56.6-23.4c-15.7-15.7-23.5-36.4-23.4-57z','M336 384c0 48-48 128-48 128l352 0s-48-80-48-128l0-32c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 32zm128-77.1c13 26.7 40.3 45.1 72 45.1c2.7 0 5.4-.1 8-.4c.1 20.6-7.7 41.2-23.4 57c-31.2 31.2-81.9 31.2-113.1 0c-15.7-15.7-23.5-36.4-23.4-57c2.6 .3 5.3 .4 8 .4c31.7 0 59-18.4 72-45.1zM260.6 495.5s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l.1-.1 .3-.6c.3-.5 .8-1.3 1.4-2.4c1.2-2.1 3-5.2 5.1-9.1c4.3-7.8 9.9-18.6 15.5-30.8C295 426.5 304 400.3 304 384l0-32c0-36 11.9-69.3 32-96L42.3 256c-1.4 2.8-2.9 5.7-4.3 8.6c0 0 0 0 0 0s0 0 0 0C20.2 299.6 0 339.6 0 384c0 80 48 128 48 128l202.7 0 9.9-16.5z']
      
    ]
  };

  

  
  

  var faMagnifyingGlassMusic = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-music',
    icon: [
      512,
      512,
      [],
      'e65f',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm112 64c0-26.5 28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-57.5 0-32 0-17.3 16.4-5.5 48-16L288 86.7l0 33.3 0 32 0 17.3-16.4 5.5L240 185.3l0 86.7c0 26.5-28.7 48-64 48s-64-21.5-64-48z','M288 86.7l0 33.3 0 32 0 17.3-16.4 5.5L240 185.3l0 86.7c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5l0-57.5 0-32 0-17.3 16.4-5.5 48-16L288 86.7zM441.4 486.6L330.7 376C348 363.3 363.3 348 376 330.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6z']
      
    ]
  };

  

  
  

  var faChairOffice = {
    prefix: 'fasds',
    iconName: 'chair-office',
    icon: [
      448,
      512,
      [],
      'f6c1',
      
      ['M96 0l0 288 256 0L352 0 96 0zm32 448l0 64 32 0 64 0 64 0 32 0 0-64-32 0-32 0 0-32 0-32-64 0 0 32 0 32-32 0-32 0z','M64 160l0 64 0 32L0 256l0-32 0-64 0-32 64 0 0 32zm384 0l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32zM32 384l0-32 32-64 320 0 32 64 0 32L32 384z']
      
    ]
  };

  

  
  

  var faFishCooked = {
    prefix: 'fasds',
    iconName: 'fish-cooked',
    icon: [
      576,
      512,
      [],
      'f7fe',
      
      ['M0 96l0 48L32 256 0 368l0 48 103.1-82.5C152.2 390.6 239.7 448 320 448c176 0 256-192 256-192s-80-192-256-192c-77.3 0-161.3 53.2-211.3 108.1L0 96zM217.4 224l11.3-11.3 64-64L304 137.4c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3l-64 64c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6zm16 112l11.3-11.3c53.3-53.3 106.7-106.7 160-160c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-53.3 53.3-106.7 106.7-160 160c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6zm112 16c3.8-3.8 7.5-7.5 11.3-11.3c21.3-21.3 42.7-42.7 64-64c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-21.3 21.3-42.7 42.7-64 64L368 374.6 345.4 352z','M326.6 160l-11.3 11.3-64 64L240 246.6 217.4 224l11.3-11.3 64-64L304 137.4 326.6 160zm112 16l-11.3 11.3-160 160L256 358.6 233.4 336l11.3-11.3 160-160L416 153.4 438.6 176zm16 112l-11.3 11.3-64 64L368 374.6 345.4 352l11.3-11.3 64-64L432 265.4 454.6 288z']
      
    ]
  };

  

  
  

  var faPenPaintbrush = {
    prefix: 'fasds',
    iconName: 'pen-paintbrush',
    icon: [
      576,
      512,
      ["pencil-paintbrush"],
      'f618',
      
      ['M.8 80L80 .8l39.6 39.6L226.3 147.1l-79.2 79.2L40.4 119.6 .8 80zM290.6 423.9L423.9 290.6c50.4 11 88.1 55.8 88.1 109.4l0 48 64 0 0 64-176 0c-53.6 0-98.5-37.7-109.4-88.1z','M32 512L64 352 324.7 91.3l128 128L192 480 32 512zM475.3 196.7l-128-128L416 0 544 128l-68.7 68.7z']
      
    ]
  };

  
    var faPencilPaintbrush = faPenPaintbrush;
  

  
  

  var faBrowser = {
    prefix: 'fasds',
    iconName: 'browser',
    icon: [
      512,
      512,
      [128468],
      'f37e',
      
      ['M0 224L0 480l512 0 0-256L0 224zM64 96l0 64 64 0 0-64L64 96z','M0 32l512 0 0 192L0 224 0 32zM64 96l0 64 64 0 0-64L64 96zm384 8l-288 0 0 48 288 0 0-48z']
      
    ]
  };

  

  
  

  var faFireplace = {
    prefix: 'fasds',
    iconName: 'fireplace',
    icon: [
      640,
      512,
      [],
      'f79a',
      
      ['M0 0L0 96l32 0 576 0 32 0 0-96L0 0zM207.9 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.7-13.4-67.2-67.2-112l-22.4 22.4-44.8-44.8c-29.9 18.7-89.6 71.7-89.6 134.4zm67.2 33.7c0-33.6 44.8-67.2 44.8-67.2s44.8 33.6 44.8 67.2c0 24.7-20.1 44.8-44.8 44.8s-44.8-20.1-44.8-44.8z','M608 96L32 96l0 416 128 0 0-160c0-88.4 71.6-160 160-160s160 71.6 160 160l0 160 128 0 0-416z']
      
    ]
  };

  

  
  

  var faDiceD10 = {
    prefix: 'fasds',
    iconName: 'dice-d10',
    icon: [
      512,
      512,
      [],
      'f6cd',
      
      ['M0 256l0 1.4 139.7-31L215.1 0 192 0 0 256zm171-22.3l85 58.9 85-58.9L263.1 0 248.9 0 171 233.7zM296.9 0l75.4 226.3 139.7 31 0-1.4L320 0 296.9 0z','M240 512L1.9 289.8l146.8-32.6L240 320.4 240 512zM510.1 289.8L272 512l0-191.6 91.4-63.2 146.8 32.6z']
      
    ]
  };

  

  
  

  var faQrcode = {
    prefix: 'fasds',
    iconName: 'qrcode',
    icon: [
      448,
      512,
      [],
      'f029',
      
      ['M0 32L0 224l192 0 0-192L0 32zM0 288L0 480l192 0 0-192L0 288zM64 96l64 0 0 64-64 0 0-64zm0 256l64 0 0 64-64 0 0-64zM256 32l0 192 192 0 0-192L256 32zm64 64l64 0 0 64-64 0 0-64z','M256 288l96 0 0 32 64 0 0-32 32 0 0 32 0 96-96 0 0-32-32 0 0 96-64 0 0-96 0-96zM384 448l0 32-32 0 0-32 32 0zm64 0l0 32-32 0 0-32 32 0z']
      
    ]
  };

  

  
  

  var faSubtitlesSlash = {
    prefix: 'fasds',
    iconName: 'subtitles-slash',
    icon: [
      640,
      512,
      [],
      'e610',
      
      ['M32 121.2L32 480l455.4 0L365.5 384 312 384l-24 0 0-48 16.6 0-60.9-48L152 288l-24 0 0-48 24 0 30.8 0L32 121.2zM70.5 32C175 113.1 279.5 194.2 384 275.4l0-35.4 24 0 80 0 24 0 0 48-24 0-80 0-7.7 0c20.6 16 41.2 32 61.8 48l25.9 0 24 0 0 38.7c32 24.8 64 49.7 96 74.5L608 32 70.5 32zM128 336l24 0 80 0 24 0 0 48-24 0-80 0-24 0 0-48z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faAlbumCircleUser = {
    prefix: 'fasds',
    iconName: 'album-circle-user',
    icon: [
      576,
      512,
      [],
      'e48d',
      
      ['M0 32L0 480l296.2 0c-16.2-19.7-28.3-42.9-34.8-68.4c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160c69.3 0 128.3 44 150.5 105.6c18-6.2 37.4-9.6 57.5-9.6c5.4 0 10.7 .2 16 .7L448 32 0 32zM192 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-31.7 0-60.3-13.2-80.7-34.3L376 416l112 0 24.7 29.7c-20.4 21.2-49 34.3-80.7 34.3zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faPancakes = {
    prefix: 'fasds',
    iconName: 'pancakes',
    icon: [
      512,
      512,
      [129374],
      'e42d',
      
      ['M0 160c0 20.3 24.2 38.8 64 52.9l0-48.1c0-.1-.1-.2-.2-.4c-.4-.5-1.2-1.3-2.4-1.8c-14.7-5.9-28.7-13.4-39.6-22.9c-2.3-2-4.6-4.3-6.8-6.8C5.3 141.4 0 150.5 0 160zm0 80c0 20.3 24.2 38.8 64 52.9L64 272l0-25.3c-21.5-6.8-41.1-15.2-56.8-25.6C2.5 227.2 0 233.5 0 240zm0 80c0 44.2 114.6 80 256 80s256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 342.8 329 352 256 352s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 307.2 0 313.5 0 320zm0 80c0 44.2 114.6 80 256 80s256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26C396.4 422.8 329 432 256 432s-140.4-9.2-190.6-24.9c-22-6.9-42.2-15.4-58.3-26C2.5 387.2 0 393.5 0 400zM192 288l0 29.5c20.5 1.6 41.9 2.5 64 2.5c141.4 0 256-35.8 256-80c0-6.5-2.5-12.8-7.2-18.9c-16.1 10.6-36.2 19.1-58.3 26c-42.7 13.4-97.9 22-158.5 24.3l0 16.6L192 288zm96.1-96.2c-.1 10.8-.1 21.5-.1 32.2l0 15.4c126.3-4.9 224-38.6 224-79.4c0-9.5-5.3-18.6-14.9-27c-4 4.5-8.5 8.4-12.7 11.5c-13.4 10-30.9 17.8-49.8 24C396.6 181 345.5 189 289.3 191.3c-.5 0-.9 .2-1.2 .5z','M480 96c0 35.3-100.3 64-224 64l0 64 0 32-64 0 0-32 0-66.7c-11-.9-21.7-2.1-32-3.5L160 272l0 32-64 0 0-32 0-131.2C56.4 129.2 32 113.4 32 96c0-35.3 100.3-64 224-64s224 28.7 224 64zM208 64l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0z']
      
    ]
  };

  

  
  

  var faCamcorder = {
    prefix: 'fasds',
    iconName: 'camcorder',
    icon: [
      576,
      512,
      [128249,"video-handheld"],
      'f8a8',
      
      ['M0 160L0 480l384 0 0-96 0-128 0-96L96 160l0-64 192 0 32 0 0-64-32 0L64 32 32 32l0 32 0 96L0 160zm64 64l16 0 224 0 16 0 0 32-16 0L80 256l-16 0 0-32z','M576 160l0 320L384 384l0-128 192-96zM80 224l224 0 16 0 0 32-16 0L80 256l-16 0 0-32 16 0z']
      
    ]
  };

  
    var faVideoHandheld = faCamcorder;
  

  
  

  var faAnglesLeft = {
    prefix: 'fasds',
    iconName: 'angles-left',
    icon: [
      512,
      512,
      [171,"angle-double-left"],
      'f100',
      
      ['M210.7 256l22.6-22.6 160-160L416 50.7 461.3 96l-22.6 22.6L301.3 256 438.6 393.4 461.3 416 416 461.3l-22.6-22.6-160-160L210.7 256z','M18.7 256l22.6 22.6 160 160L224 461.3 269.3 416l-22.6-22.6L109.3 256 246.6 118.6 269.3 96 224 50.7 201.4 73.4l-160 160L18.7 256z']
      
    ]
  };

  
    var faAngleDoubleLeft = faAnglesLeft;
  

  
  

  var faBuilding = {
    prefix: 'fasds',
    iconName: 'building',
    icon: [
      384,
      512,
      [61687,127970],
      'f1ad',
      
      ['M0 0L384 0l0 512-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M128 96L64 96l0 64 64 0 0-64zm0 128l-64 0 0 64 64 0 0-64zm96 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faTicketSimple = {
    prefix: 'fasds',
    iconName: 'ticket-simple',
    icon: [
      576,
      512,
      ["ticket-alt"],
      'f3ff',
      
      ['M0 64l576 0 0 144c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 144L0 448 0 304c26.5 0 48-21.5 48-48s-21.5-48-48-48L0 64z','']
      
    ]
  };

  
    var faTicketAlt = faTicketSimple;
  

  
  

  var faAward = {
    prefix: 'fasds',
    iconName: 'award',
    icon: [
      384,
      512,
      [],
      'f559',
      
      ['M0 456l75.8 0L128 512l56.1-133.2-35.8-23.6L96 358.3c-7.8-15.6-15.6-31.2-23.5-46.8c-3.2-1.6-6.4-3.2-9.6-4.8L0 456zm199.9-77.2L256 512l52.2-56 75.8 0L321.1 306.6c-3.2 1.6-6.4 3.2-9.6 4.8c-7.8 15.6-15.6 31.2-23.5 46.8l-52.3-3.1c-11.9 7.9-23.9 15.7-35.8 23.6z','M235.7 28.8L192 0 148.3 28.8 96 25.7 72.5 72.5 25.7 96l3.1 52.3L0 192l28.8 43.7L25.7 288l46.8 23.5L96 358.3l52.3-3.1L192 384l43.7-28.8 52.3 3.1 23.5-46.8L358.3 288l-3.1-52.3L384 192l-28.8-43.7L358.3 96 311.5 72.5 288 25.7l-52.3 3.1zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z']
      
    ]
  };

  

  
  

  var faUserGroupSimple = {
    prefix: 'fasds',
    iconName: 'user-group-simple',
    icon: [
      640,
      512,
      [],
      'e603',
      
      ['M320 288l64 192 192 0 64-192-320 0zm56-152a104 104 0 1 0 208 0 104 104 0 1 0 -208 0z','M160 240a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM320 480L256 288 64 288 0 480l320 0z']
      
    ]
  };

  

  
  

  var faConveyorBeltEmpty = {
    prefix: 'fasds',
    iconName: 'conveyor-belt-empty',
    icon: [
      640,
      512,
      [],
      'e150',
      
      ['M96 320c-53 0-96 43-96 96s43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z','']
      
    ]
  };

  

  
  

  var faFlagPennant = {
    prefix: 'fasds',
    iconName: 'flag-pennant',
    icon: [
      448,
      512,
      [128681,"pennant"],
      'f456',
      
      ['M64 32L448 192 64 352 64 32z','M64 0l0 32 0 448 0 32L0 512l0-32L0 32 0 0 64 0z']
      
    ]
  };

  
    var faPennant = faFlagPennant;
  

  
  

  var faPersonFallingBurst = {
    prefix: 'fasds',
    iconName: 'person-falling-burst',
    icon: [
      640,
      512,
      [],
      'e547',
      
      ['M292.4 215.2L388 236.6l-.3 67.1c4.8 6.4 9.6 12.8 14.4 19.2L464 273.2l76.4 61.4-.4-98 95.6-21.4-76.9-60.8 42.9-88.1L506.2 88.5 464 0 421.8 88.5 326.4 66.3l42.9 88.1-76.9 60.8z','M256 0l0 32 0 96 0 19.8-17.7 8.8L188 181.8 240.5 256l95.5 0 16 0 9.6 12.8 48 64 19.2 25.6-51.2 38.4-19.2-25.6L320 320l-96 0-1.4 0 84.2 130.1L324.2 477l-53.7 34.8-17.4-26.9L96 242.2 96 352l0 32-64 0 0-32 0-144 0-19.8 17.7-8.8L192 108.2 192 32l0-32 64 0zM48 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faArrowRightToLine = {
    prefix: 'fasds',
    iconName: 'arrow-right-to-line',
    icon: [
      448,
      512,
      [8677,"arrow-to-right"],
      'f340',
      
      ['M384 64l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M333.3 256l-22.6 22.6-128 128L160 429.3 114.7 384l22.6-22.6L210.7 288 32 288 0 288l0-64 32 0 178.7 0-73.4-73.4L114.7 128 160 82.7l22.6 22.6 128 128L333.3 256z']
      
    ]
  };

  
    var faArrowToRight = faArrowRightToLine;
  

  
  

  var faAnt = {
    prefix: 'fasds',
    iconName: 'ant',
    icon: [
      640,
      512,
      [],
      'e680',
      
      ['M46.7 512l2.1-3.7L128.9 368l47.1 0c2.8 0 5.6-.1 8.4-.3L101.9 512l-55.3 0zm80 0l2.2-3.8L212.4 362c10.2-3.5 19.7-8.4 28.4-14.6c4.3-3.1 8.4-6.4 12.2-10.1c1.9-1.8 3.8-3.7 5.6-5.6c.9-1 1.8-2 2.6-3s1.7-2 2.5-3.1c3.3 7.7 7.5 14.8 12.6 21.3L181.9 512l-55.3 0zm79.8 0l2.2-3.9 78.2-136.9 .3-.4 4.7-7.9c12.5 10.1 27.6 17 44.1 19.8l-7.5 12.6L261.7 512l-55.3 0zM390.2 376.1c15.1-6.6 28.2-16.9 38.1-29.8L473 391l3.6 3.6 1.8 4.8L521.1 512l-51.3 0-34.4-90.7-45.2-45.2zm44.1-38.7c4.3-7.2 7.7-15 10.1-23.2c1.2-4.1 2.1-8.4 2.7-12.7c.3-2.2 .5-4.4 .7-6.6c.1-1.1 .1-2.2 .2-3.3s.1-2.2 .1-3.4l5.9 4.3 112 80 6.5 4.7 2.4 7.7 40 127.2-50.3 0-33-105.1-97.2-69.4z','M512 0L498.4 0l-7 11.7L458.6 66.4C415.9 76.1 384 114.3 384 160c0 14.8 3.3 28.8 9.3 41.3c-12.5-6-26.5-9.3-41.3-9.3c-27 0-51.4 11.1-68.8 29.1C268 167.6 218.9 128 160.7 128C72 128 0 200 0 288.7L0 368l176 0c35.5 0 67.2-16.5 87.7-42.3C278.3 360 312.4 384 352 384c53 0 96-43 96-96c0-14.8-3.3-28.8-9.3-41.3c12.5 6 26.5 9.3 41.3 9.3l128 0 0-64c0-59.2-40.1-108.9-94.6-123.6L525.6 48 584 48l24 0 0-48L584 0 512 0zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faLineColumns = {
    prefix: 'fasds',
    iconName: 'line-columns',
    icon: [
      512,
      512,
      [],
      'f870',
      
      ['M288 32l0 64 224 0 0-64L288 32zm0 128l0 64 224 0 0-64-224 0zm0 128l0 64 224 0 0-64-224 0zm0 128l0 64 224 0 0-64-224 0z','M224 32L0 32 0 96l224 0 0-64zm0 128L0 160l0 64 224 0 0-64zM0 288l0 64 224 0 0-64L0 288zM224 416L0 416l0 64 224 0 0-64z']
      
    ]
  };

  

  
  

  var faCardSpade = {
    prefix: 'fasds',
    iconName: 'card-spade',
    icon: [
      384,
      512,
      [],
      'e3ec',
      
      ['M0 0L0 512l384 0L384 0 0 0zM72 264c0-14.3 5.5-28.7 16.4-39.6c21.3-21.3 42.7-42.7 64-64c13.2-13.2 26.4-26.4 39.6-39.6c13.2 13.2 26.4 26.4 39.6 39.6c21.3 21.3 42.7 42.7 64 64C306.5 235.3 312 249.7 312 264s-5.5 28.7-16.4 39.6c-21.9 21.9-57.3 21.9-79.2 0c-2.8-2.8-5.6-5.6-8.4-8.4l0 40.8 16 0 16 0 0 32-16 0-16 0-32 0-16 0-16 0 0-32 16 0 16 0 0-40.8c-2.8 2.8-5.6 5.6-8.4 8.4c-21.9 21.9-57.3 21.9-79.2 0C77.5 292.7 72 278.3 72 264z','M231.6 160.4L192 120.8l-39.6 39.6-64 64c-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0l8.4-8.4 0 40.8-16 0-16 0 0 32 16 0 16 0 32 0 16 0 16 0 0-32-16 0-16 0 0-40.8 8.4 8.4c21.9 21.9 57.3 21.9 79.2 0s21.9-57.3 0-79.2l-64-64z']
      
    ]
  };

  

  
  

  var faSpade = {
    prefix: 'fasds',
    iconName: 'spade',
    icon: [
      512,
      512,
      [9824],
      'f2f4',
      
      ['M0 302.9C0 365.3 50.7 416 113.1 416c30 0 58.8-11.9 80-33.1L224 352l0-96 0-32 64 0 0 32 0 96 30.9 30.9c21.2 21.2 50 33.1 80 33.1C461.3 416 512 365.3 512 302.9c0-30-11.9-58.8-33.1-80L416 160 256 0 96 160 33.1 222.9C11.9 244.1 0 272.9 0 302.9z','M288 224l0 32 0 192 32 0 32 0 0 64-32 0-32 0-64 0-32 0-32 0 0-64 32 0 32 0 0-192 0-32 64 0z']
      
    ]
  };

  

  
  

  var faArrowTurnDown = {
    prefix: 'fasds',
    iconName: 'arrow-turn-down',
    icon: [
      384,
      512,
      ["level-down"],
      'f149',
      
      ['M0 0L0 64l32 0 128 0 0 325.5 32 32 32-32L224 32l0-32L192 0 32 0 0 0z','M18.7 338.7l22.6 22.6 128 128L192 512l22.6-22.6 128-128 22.6-22.6L320 293.5l-22.6 22.6L192 421.5 86.6 316.1 64 293.5 18.7 338.7z']
      
    ]
  };

  
    var faLevelDown = faArrowTurnDown;
  

  
  

  var faBorderRight = {
    prefix: 'fasds',
    iconName: 'border-right',
    icon: [
      448,
      512,
      [],
      'f852',
      
      ['M0 32L0 96l64 0 0-64L0 32zm0 96l0 64 64 0 0-64L0 128zm0 96l0 64 64 0 0-64L0 224zm0 96l0 64 64 0 0-64L0 320zm0 96l0 64 64 0 0-64L0 416zM96 32l0 64 64 0 0-64L96 32zm0 192l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zM192 32l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zM288 32l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0z','M448 32l0 448-64 0 0-448 64 0z']
      
    ]
  };

  

  
  

  var faKnifeKitchen = {
    prefix: 'fasds',
    iconName: 'knife-kitchen',
    icon: [
      576,
      512,
      [128298],
      'f6f5',
      
      ['M0 480s48 32 112 32c160 0 296-152 296-152l-32-32L264 216 0 480z','M568 88L480 0 264 216 376 328l72-56 0-64L568 88zM416 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm72-72a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faUpFromBracket = {
    prefix: 'fasds',
    iconName: 'up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e590',
      
      ['M0 320l0 32L0 480l0 32 32 0 384 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448l0-96 0-32L0 320z','M224 0L64 160l0 32 96 0 0 160 128 0 0-160 96 0 0-32L224 0z']
      
    ]
  };

  

  
  

  var faMercury = {
    prefix: 'fasds',
    iconName: 'mercury',
    icon: [
      384,
      512,
      [9791],
      'f223',
      
      ['M112 224a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M39.3 0c9.8 31.3 29 58.4 54.2 78.1C46.7 109.7 16 163.3 16 224c0 89.1 66.2 162.7 152 174.4l0 25.6-32 0-24 0 0 48 24 0 32 0 0 16 0 24 48 0 0-24 0-16 32 0 24 0 0-48-24 0-32 0 0-25.6c85.8-11.7 152-85.3 152-174.4c0-60.7-30.7-114.3-77.5-145.9C315.7 58.4 334.9 31.3 344.7 0L275.2 0C258.6 28.7 227.5 48 192 48s-66.6-19.3-83.2-48L39.3 0zM304 224A112 112 0 1 1 80 224a112 112 0 1 1 224 0z']
      
    ]
  };

  

  
  

  var faTransgender = {
    prefix: 'fasds',
    iconName: 'transgender',
    icon: [
      512,
      512,
      [9895,"transgender-alt"],
      'f225',
      
      ['M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M0 112L0 0 112 0l16 16L89 55l23 23 7-7 17-17L169.9 88l-17 17-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2L423 55 384 16 400 0 512 0l0 112-16 16L457 89l-72.1 72.1C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2l0 17.8 16 0 24 0 0 48-24 0-16 0 0 8 0 24-48 0 0-24 0-8-16 0-24 0 0-48 24 0 16 0 0-17.8C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7-17 17L54.1 136l17-17 7-7L55 89 16 128 0 112zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z']
      
    ]
  };

  
    var faTransgenderAlt = faTransgender;
  

  
  

  var faSimCard = {
    prefix: 'fasds',
    iconName: 'sim-card',
    icon: [
      384,
      512,
      [],
      'f7c4',
      
      ['M0 0L32 0 256 0l13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 352 0 32-32 0L32 512 0 512l0-32L0 32 0 0zM64 192l0 64 0 32 0 64 0 32 0 64 64 0 32 0 64 0 32 0 64 0 0-64 0-32 0-64 0-32 0-64-64 0-32 0-64 0-32 0-64 0z','M128 192l-64 0 0 64 64 0 0-64zM64 288l0 64 80 0 96 0 80 0 0-64-80 0-96 0-80 0zm256-32l0-64-64 0 0 64 64 0zm-96-64l-64 0 0 64 64 0 0-64zm96 192l-64 0 0 64 64 0 0-64zm-96 64l0-64-64 0 0 64 64 0zm-96 0l0-64-64 0 0 64 64 0z']
      
    ]
  };

  

  
  

  var faDiceFour = {
    prefix: 'fasds',
    iconName: 'dice-four',
    icon: [
      448,
      512,
      [9859],
      'f524',
      
      ['M0 32l448 0 0 448L0 480 0 32zM96 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faMandolin = {
    prefix: 'fasds',
    iconName: 'mandolin',
    icon: [
      512,
      512,
      [],
      'f6f9',
      
      ['M0 336c0 97.2 78.8 176 176 176c135.5 0 147.7-189.6 146.2-276.9l-66.2 66.2c0 .9 .1 1.8 .1 2.7c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.9 0 1.8 0 2.7 .1c22.1-22.1 44.2-44.2 66.2-66.2C189.6 188.3 0 200.5 0 336z','M448 0L368 48l-25.4 76.1-132 132c24.4 1.3 43.9 20.9 45.3 45.3l132-132L464 144l48-80L448 0z']
      
    ]
  };

  

  
  

  var faMeter = {
    prefix: 'fasds',
    iconName: 'meter',
    icon: [
      512,
      512,
      [],
      'e1e8',
      
      ['','M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32zm96 0l0 32 0 32-64 0 0-32 0-32 0-32 64 0 0 32z']
      
    ]
  };

  

  
  

  var faFaceGrinHearts = {
    prefix: 'fasds',
    iconName: 'face-grin-hearts',
    icon: [
      512,
      512,
      [128525,"grin-hearts"],
      'f584',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 46.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zm1.1-114.8c4.8-17.8 23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6s28.4 23.1 23.6 40.8l-21.6 80.5-80.6-21.6c-17.8-4.8-28.4-23.1-23.6-40.8zm192-18.1c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6c.8 2.9 1.1 5.8 1.1 8.7c0 14.7-9.8 28.2-24.7 32.2l-80.6 21.6L289.1 170z','M158.4 152.7c4.8-17.8 23.1-28.4 40.8-23.6s28.4 23.1 23.6 40.8l-21.6 80.5-80.6-21.6c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1zm195.2 0l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-80.6 21.6L289.1 170c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z']
      
    ]
  };

  
    var faGrinHearts = faFaceGrinHearts;
  

  
  

  var faSplotch = {
    prefix: 'fasds',
    iconName: 'splotch',
    icon: [
      512,
      512,
      [],
      'f5bc',
      
      ['M256 0h80l30.9 103c10.8 35.9 37.7 64.7 72.8 77.9L512 208v64l-73.2 54.9c-34 25.5-52 67-47.3 109.3L400 512H304l-73.3-58.6c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L16 464V376l24.3-29.1c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L0 160V80L101.1 97.2c44 7.5 88.5-10.1 115.5-45.5L256 0z','']
      
    ]
  };

  

  
  

  var faSquareN = {
    prefix: 'fasds',
    iconName: 'square-n',
    icon: [
      448,
      512,
      [],
      'e277',
      
      ['M0 32L0 480l448 0 0-448L0 32zm112 96l35.1 0 7.2 8.5L288 294.5 288 152l0-24 48 0 0 24 0 208 0 24-35.1 0-7.2-8.5L160 217.5 160 360l0 24-48 0 0-24 0-208 0-24z','M336 128l-48 0 0 24 0 142.5-133.7-158-7.2-8.5L112 128l0 24 0 208 0 24 48 0 0-24 0-142.5 133.7 158 7.2 8.5 35.1 0 0-24 0-208 0-24z']
      
    ]
  };

  

  
  

  var faArrowUpRightDots = {
    prefix: 'fasds',
    iconName: 'arrow-up-right-dots',
    icon: [
      576,
      512,
      [],
      'e4b7',
      
      ['M96 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 336a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM352 208a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM480 80a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M128 0l32 0L288 0l32 0 0 32 0 128 0 32-64 0 0-32 0-50.7L70.6 294.6 48 317.3 2.7 272l22.6-22.6L210.7 64 160 64l-32 0 0-64z']
      
    ]
  };

  

  
  

  var faSquareFragile = {
    prefix: 'fasds',
    iconName: 'square-fragile',
    icon: [
      448,
      512,
      ["box-fragile","square-wine-glass-crack"],
      'f49b',
      
      ['M0 32L0 480l448 0 0-448L0 32zM128 96l48 0 64 0 80 0 0 112c0 47.6-34.6 87.1-80 94.7l0 81.3 64 0 0 32-160 0 0-32 64 0 0-81.3c-45.4-7.6-80-47.1-80-94.7l0-112z','M176 96l-48 0 0 112c0 47.6 34.6 87.1 80 94.7l0 81.3-64 0 0 32 160 0 0-32-64 0 0-81.3c45.4-7.6 80-47.1 80-94.7l0-112-80 0 32 64-48 32 32 64-80-64 32-32L176 96z']
      
    ]
  };

  
    var faBoxFragile = faSquareFragile;
  
    var faSquareWineGlassCrack = faSquareFragile;
  

  
  

  var faLockKeyholeOpen = {
    prefix: 'fasds',
    iconName: 'lock-keyhole-open',
    icon: [
      576,
      512,
      ["lock-open-alt"],
      'f3c2',
      
      ['M288 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 0 32 64 0 0-32 0-48C576 64.5 511.5 0 432 0S288 64.5 288 144z','M448 192L0 192 0 512l448 0 0-320zM256 384l-64 0-32 0 0-64 32 0 64 0 32 0 0 64-32 0z']
      
    ]
  };

  
    var faLockOpenAlt = faLockKeyholeOpen;
  

  
  

  var faConveyorBeltArm = {
    prefix: 'fasds',
    iconName: 'conveyor-belt-arm',
    icon: [
      640,
      512,
      [],
      'e5f8',
      
      ['M0 416c0 53 43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96l-32 0-96 0-64 0-96 0-64 0-96 0c-53 0-96 43-96 96zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M128 0l32 0L320 0l32 0 0 64-32 0-52.9 0-5.7 34c.8 1 1.5 2 2.3 3l204.5 27.3 11.8 1.6 0 64.6 0 13.6 0 16s0 0 0 0l-32 0 0-16 0-17.9L255.2 164.4c-8.4 7.2-19.3 11.6-31.2 11.6c-26.5 0-48-21.5-48-48c0-17.1 8.9-32 22.3-40.6L202.2 64 160 64l-32 0 0-64zm96 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 256l96 0 0 64-96 0 0-64zm256 0l0 64-96 0 0-64 96 0zm160 0l0 64-96 0 0-64 96 0z']
      
    ]
  };

  

  
  

  var faWarehouse = {
    prefix: 'fasds',
    iconName: 'warehouse',
    icon: [
      640,
      512,
      [],
      'f494',
      
      ['M128 224l0 80 384 0 0-80-384 0zm0 112l0 64 384 0 0-64-384 0zm0 96l0 80 384 0 0-80-384 0z','M0 128V512H96V192H544V512h96V128L320 0 0 128z']
      
    ]
  };

  

  
  

  var faSunBright = {
    prefix: 'fasds',
    iconName: 'sun-bright',
    icon: [
      512,
      512,
      ["sun-alt"],
      'e28f',
      
      ['M0 232l0 48 24 0 64 0 24 0 0-48-24 0-64 0L0 232zM58 92l17 17 45.3 45.3 17 17 33.9-33.9-17-17L108.9 75 92 58 58 92zM58 420L92 454l17-17 45.3-45.3 17-17-33.9-33.9-17 17L75 403.1 58 420zM232 0l0 24 0 64 0 24 48 0 0-24 0-64 0-24L232 0zm0 400l0 24 0 64 0 24 48 0 0-24 0-64 0-24-48 0zM340.9 137.2l33.9 33.9 17-17L437 108.9l17-17L420 58l-17 17-45.3 45.3-17 17zm0 237.6l17 17L403.1 437l17 17L454 420l-17-17-45.3-45.3-17-17-33.9 33.9zM400 232l0 48 24 0 64 0 24 0 0-48-24 0-64 0-24 0z','M256 144a112 112 0 1 0 0 224 112 112 0 1 0 0-224z']
      
    ]
  };

  
    var faSunAlt = faSunBright;
  

  
  

  var faGears = {
    prefix: 'fasds',
    iconName: 'gears',
    icon: [
      640,
      512,
      ["cogs"],
      'f085',
      
      ['M296 317.6l0 68.7 47.8 9.8c4.9 13.4 12 25.8 20.9 36.7l-15 44.8L410.3 512l30.9-34c7.4 1.3 15 2 22.7 2s15.4-.7 22.7-2l30.9 34 60.6-34.4-15-44.8c8.9-10.9 16-23.3 20.9-36.7l47.8-9.8 0-68.7-47.8-9.8c-4.9-13.4-12.1-25.8-20.9-36.7l15-44.8L517.7 192l-30.9 34c-7.4-1.3-15-2-22.7-2s-15.4 .7-22.7 2l-30.9-34-60.6 34.4 15 44.8c-8.9 10.9-16 23.3-20.9 36.7L296 317.6zM512 352a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M195 8L125 8 115 56.1c-13.8 5.2-26.5 12.7-37.5 22L34.4 64 0 123.4l33.9 30.3C32.7 160.9 32 168.4 32 176s.7 15.1 1.9 22.3L0 228.6 34.4 288l43.1-14.2c11.1 9.3 23.7 16.8 37.5 22L125 344l70 0 10-48.1c13.8-5.2 26.5-12.7 37.5-22L285.6 288 320 228.6l-33.9-30.3c1.3-7.3 1.9-14.7 1.9-22.3s-.7-15.1-1.9-22.3L320 123.4 285.6 64 242.5 78.2c-11.1-9.3-23.7-16.8-37.5-22L195 8zM160 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  
    var faCogs = faGears;
  

  
  

  var faPartyHorn = {
    prefix: 'fasds',
    iconName: 'party-horn',
    icon: [
      512,
      512,
      [],
      'e31b',
      
      ['M32 32a32 32 0 1 0 64 0A32 32 0 1 0 32 32zm6.5 349.1l92.4 92.4 32.6-12.7L51.1 348.5 38.5 381.1zm35.8-92.2c49.6 49.6 99.2 99.2 148.8 148.8L255.7 425C199.4 368.8 143.2 312.6 87 256.3c-4.2 10.9-8.4 21.7-12.7 32.6zm75.8-153.8l33 34.8c5.8-5.5 11.6-11 17.4-16.5l.3-.3 .6-.6c.5-.5 1.2-1.2 2-2c1.6-1.7 3.8-4.1 6.4-7.1c5.1-6.1 11.9-14.8 18.7-25.9C241.9 95.4 256 63 256 24l0-24L208 0l0 24c0 27.5-9.9 51.1-20.5 68.4c-5.2 8.6-10.5 15.3-14.3 19.9c-1.9 2.3-3.5 3.9-4.5 5c-.5 .5-.9 .9-1.1 1.1c-6 5.7-11.8 11.2-17.5 16.6zm96.1 62.1l31 36.6 18.3-15.5 10-8.5c5.8-4.9 13.2-7.5 20.7-7.3c42.5 1.1 78.3-31.7 80.8-74.2l1.8-30c1-16.6 15-29.4 31.6-29c19.4 .5 38.2-6.1 53-18.6l10-8.5-31-36.6-10 8.5c-5.8 4.9-13.2 7.5-20.7 7.3c-42.5-1.1-78.3 31.7-80.8 74.2l-1.8 30c-1 16.6-15 29.4-31.6 29c-19.4-.5-38.2 6.1-53 18.6l-10 8.5-18.3 15.5zm95.9 131.5l34.7 33.2 16.5-17.3c.4-.4 .8-.8 1.3-1.3c1.1-1 2.8-2.6 5.1-4.5c4.6-3.9 11.4-9.1 20-14.3C437.1 313.9 460.8 304 488 304l24 0 0-48-24 0c-38.8 0-71.1 14.1-93.2 27.5c-11.1 6.8-19.9 13.5-26 18.7c-3.1 2.6-5.5 4.8-7.2 6.4c-.8 .8-1.5 1.5-2 1.9l-.6 .6-.3 .3c-5.6 5.8-11.1 11.6-16.6 17.4zm16.6-17.4c5.7 5.6 11.5 11.1 17.3 16.6c-17.3-16.6-17.3-16.6-17.3-16.6zM448 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M0 480l32 32 98.9-38.5L38.5 381.1 0 480zM51.1 348.5L163.5 460.9l59.6-23.2L74.3 288.9 51.1 348.5zM87 256.3L255.7 425 320 400 112 192 87 256.3z']
      
    ]
  };

  

  
  

  var faPeace = {
    prefix: 'fasds',
    iconName: 'peace',
    icon: [
      512,
      512,
      [9774],
      'f67c',
      
      ['M89.2 351.1c10.7 18.7 24.4 35.4 40.6 49.5L224 323.5l0 121.8c10.4 1.7 21.1 2.7 32 2.7s21.6-.9 32-2.7l0-121.8 94.3 77.1c16.1-14.1 29.9-30.8 40.6-49.5L288 240.8l0-174.2c-10.4-1.7-21.1-2.7-32-2.7s-21.6 .9-32 2.7l0 174.2L89.2 351.1z','M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z']
      
    ]
  };

  

  
  

  var faRobot = {
    prefix: 'fasds',
    iconName: 'robot',
    icon: [
      640,
      512,
      [129302],
      'f544',
      
      ['M32 224l0 192 64 0 0-192-64 0zM192 384l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zM288 0l0 32 0 64 64 0 0-64 0-32L288 0zm0 384l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zm96 0l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zM544 224l0 192 64 0 0-192-64 0z','M544 96L96 96l0 416 448 0 0-416zM208 384l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0zm96 0l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0zm96 0l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0zM184 256a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm232-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z']
      
    ]
  };

  

  
  

  var faWhale = {
    prefix: 'fasds',
    iconName: 'whale',
    icon: [
      640,
      512,
      [128011],
      'f72c',
      
      ['M0 317.6C0 407.3 72.7 480 162.4 480L640 480l0-352-129.9 0c-91.7 0-180.3 32.8-249.9 92.4l-103.8 89c-8 6.8-18.1 10.6-28.6 10.6l-1.1 0c-18.3 0-34.5-11.7-40.3-29c-4-12-2.4-25.2 4.3-35.9l36.6-58.6L208 208l80-80L184 104 160 0 80 80l12 84L43.6 212.4C15.7 240.3 0 278.2 0 317.6zM424 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M400 280a24 24 0 1 0 0 48 24 24 0 1 0 0-48z']
      
    ]
  };

  

  
  

  var faArrowUpTriangleSquare = {
    prefix: 'fasds',
    iconName: 'arrow-up-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-up"],
      'f88a',
      
      ['M304 224L416 32 528 224l-224 0zm16 64l192 0 0 192-192 0 0-192z','M160 32.4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L192 162.8 192 448l0 32-64 0 0-32 0-285.2-24.3 26.8L82.2 213.2 34.8 170.2l21.5-23.7 80-88 23.7-26z']
      
    ]
  };

  
    var faSortShapesUp = faArrowUpTriangleSquare;
  

  
  

  var faTowerControl = {
    prefix: 'fasds',
    iconName: 'tower-control',
    icon: [
      448,
      512,
      [],
      'e2a2',
      
      ['M-1 128l41 0 88 0 192 0 88 0 41 0L439 167.8 401 320l31 0 0 64-32 0-32 0L80 384l-32 0-32 0 0-64 31 0L9 167.8-1 128zm82 64L111 312.2 113 320l15 0 0-128-47 0zm95 0l0 128 96 0 0-128-96 0zm144 0l0 128 15 0 1.9-7.8L367 192l-47 0z','M160 0l24 0 40 0 40 0 24 0 0 48-24 0-16 0 0 48 72 0 0 32-192 0 0-32 72 0 0-48-16 0-24 0 0-48zM368 384l0 128L80 512l0-128 288 0z']
      
    ]
  };

  

  
  

  var faSpinner = {
    prefix: 'fasds',
    iconName: 'spinner',
    icon: [
      512,
      512,
      [],
      'f110',
      
      ['M41 403.1l67.9-67.9 67.9 67.9L108.9 471 41 403.1zM208 416l96 0 0 96-96 0 0-96zM335.2 108.9L403.1 41 471 108.9l-67.9 67.9-67.9-67.9zm0 294.2l67.9-67.9L471 403.1 403.1 471l-67.9-67.9zM416 208l96 0 0 96-96 0 0-96z','M208 96l96 0 0-96L208 0l0 96zM0 208l0 96 96 0 0-96L0 208zm41-99.1l67.9 67.9 67.9-67.9L108.9 41 41 108.9z']
      
    ]
  };

  

  
  

  var faCircleQuarters = {
    prefix: 'fasds',
    iconName: 'circle-quarters',
    icon: [
      512,
      512,
      [],
      'e3f8',
      
      ['M120.2 120.2L256 256 391.8 120.2C357 85.5 309 64 256 64s-101 21.5-135.8 56.2zm0 271.5C155 426.5 203 448 256 448s101-21.5 135.8-56.2L256 256 120.2 391.8z','M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z']
      
    ]
  };

  

  
  

  var faRotate = {
    prefix: 'fasds',
    iconName: 'rotate',
    icon: [
      512,
      512,
      [128260,"sync-alt"],
      'f2f1',
      
      ['M16 288l0 160 24 24 57.6-57.6C141.4 458.1 198.7 480 256 480c57.3 0 114.7-21.9 158.4-65.6c24.4-24.4 42.1-53.1 52.9-83.7l-60.4-21.3c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0L200 312l-24-24L16 288z','M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0c0 0 0 0 0 0L312 200l24 24 160 0 0-160L472 40 414.4 97.6s0 0 0 0c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4l60.4 21.3z']
      
    ]
  };

  
    var faSyncAlt = faRotate;
  

  
  

  var faCircleTrash = {
    prefix: 'fasds',
    iconName: 'circle-trash',
    icon: [
      512,
      512,
      ["trash-circle"],
      'e126',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144 128l16 0 41.4 0 11.3-11.3 4.7-4.7 6.6 0 64 0 6.6 0 4.7 4.7L310.6 128l41.4 0 16 0 0 32-16 0-192 0-16 0 0-32zm16 64l192 0L336 384l-160 0L160 192z','M217.4 112l-4.7 4.7L201.4 128 160 128l-16 0 0 32 16 0 192 0 16 0 0-32-16 0-41.4 0-11.3-11.3-4.7-4.7-6.6 0-64 0-6.6 0zM160 192l16 192 160 0 16-192-192 0z']
      
    ]
  };

  
    var faTrashCircle = faCircleTrash;
  

  
  

  var faHandPeace = {
    prefix: 'fasds',
    iconName: 'hand-peace',
    icon: [
      512,
      512,
      [9996],
      'f25b',
      
      ['M30 66.1L42.8 95.4 106.1 240l69.9 0L101.5 69.8 88.6 40.5 30 66.1zM64 272l0 91c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l-96 0 0-32-64 0 0 48 0 16-16 0-112 0-16 0 0-32 16 0 96 0 0-32 0-48-66.1 0-69.9 0L64 272zM192 0l0 240 64 0L256 0 192 0z','M352 160l-64 0 0 128 64 0 0-128zm96 32l-64 0 0 128 64 0 0-128z']
      
    ]
  };

  

  
  

  var faDial = {
    prefix: 'fasds',
    iconName: 'dial',
    icon: [
      576,
      512,
      ["dial-med-high"],
      'e15b',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M383.2 158.5c-62.6-46.2-151.3-41-208 15.7c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c56.7-56.7 61.9-145.4 15.7-208L305.2 304.3l-17 17-33.9-33.9 17-17L383.2 158.5z']
      
    ]
  };

  
    var faDialMedHigh = faDial;
  

  
  

  var faAlt = {
    prefix: 'fasds',
    iconName: 'alt',
    icon: [
      640,
      512,
      [],
      'e08a',
      
      ['M416 384l32 0 160 0 32 0 0 64-32 0-160 0-32 0 0-64z','M432.6 64L448 64l160 0 32 0 0 64-32 0-144.6 0L217 436l-9.6 12L192 448 32 448 0 448l0-64 32 0 144.6 0L423 76l9.6-12z']
      
    ]
  };

  

  
  

  var faDiagramLeanCanvas = {
    prefix: 'fasds',
    iconName: 'diagram-lean-canvas',
    icon: [
      640,
      512,
      [],
      'e156',
      
      ['M64 96l0 208 64 0 0-208L64 96zm448 0l0 208 64 0 0-208-64 0z','M512 96l0 208 64 0 0-208-64 0zm-48 0l-64 0 0 80 64 0 0-80zM352 96l-64 0 0 208 64 0 0-208zM240 96l-64 0 0 80 64 0 0-80zM128 96L64 96l0 208 64 0 0-208zM64 352l0 64 232 0 0-64L64 352zm280 64l232 0 0-64-232 0 0 64zM0 32l64 0 512 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32zM240 304l0-80-64 0 0 80 64 0zm224-80l-64 0 0 80 64 0 0-80z']
      
    ]
  };

  

  
  

  var faMugTeaSaucer = {
    prefix: 'fasds',
    iconName: 'mug-tea-saucer',
    icon: [
      640,
      512,
      [],
      'e1f5',
      
      ['M0 416l0 64 32 0 512 0 32 0 0-64-32 0L32 416 0 416zM160 144l0 112 128 0 0-112L240 96l0-64-32 0 0 64-48 48z','M208 32l0 64-48 48 0 112 128 0 0-112L240 96l0-64 208 0 32 0 32 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 96L96 384 96 32l112 0zM480 224l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128z']
      
    ]
  };

  

  
  

  var faTtyAnswer = {
    prefix: 'fasds',
    iconName: 'tty-answer',
    icon: [
      640,
      512,
      ["teletype-answer"],
      'e2b9',
      
      ['M288 0l0 64 64 0 0-64L288 0zm0 192l0 64 64 0 0-64-64 0zm48-96l0 64 64 0 0-64-64 0zM384 0l0 64 64 0 0-64L384 0zm0 192l0 64 160 0 0-64-160 0zm48-96l0 64 64 0 0-64-64 0zM480 0l0 64 64 0 0-64L480 0zm48 96l0 64 64 0 0-64-64 0zM576 0l0 64 64 0 0-64L576 0zm0 192l0 64 64 0 0-64-64 0z','M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512H448C200.6 512 0 311.4 0 64L0 32z']
      
    ]
  };

  
    var faTeletypeAnswer = faTtyAnswer;
  

  
  

  var faSpeakers = {
    prefix: 'fasds',
    iconName: 'speakers',
    icon: [
      640,
      512,
      [],
      'f8e0',
      
      ['M0 0L0 512l256 0 0-97.6c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6L256 0 0 0zM224 112a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM288 0l0 512 352 0L640 0 288 0zM576 336a112 112 0 1 1 -224 0 112 112 0 1 1 224 0zM512 112a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M176 224c31.3 0 59.7 12.9 80 33.6l0 156.8c-20.3 20.7-48.7 33.6-80 33.6c-61.9 0-112-50.1-112-112s50.1-112 112-112zm0-160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm64 272a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM352 336a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm112 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faFaceVomit = {
    prefix: 'fasds',
    iconName: 'face-vomit',
    icon: [
      576,
      512,
      [],
      'e3a0',
      
      ['M32 256c0 72.5 30.1 137.9 78.5 184.5l16.7-5.6c11.9-4 21.5-12.3 27.2-22.9c-16.7-12.6-26.4-27.7-26.4-44c0-44.2 71.6-80 160-80s160 35.8 160 80c0 16.3-9.7 31.4-26.4 44c5.7 10.6 15.2 19 27.2 22.9l16.7 5.6C513.9 393.9 544 328.5 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256zM144 128l118.9 64L144 256l45.7-64L144 128zm169.1 64L432 128l-45.7 64L432 256 313.1 192z','M192 396.1l0-57.4c23.6-11.1 57.3-18.7 96-18.7s72.4 7.6 96 18.7l0 57.4c0 31 19.8 58.5 49.2 68.3L480 480l0 32L96 512l0-32 46.8-15.6c29.4-9.8 49.2-37.3 49.2-68.3zM304 384a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm256 16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480z']
      
    ]
  };

  

  
  

  var faHammer = {
    prefix: 'fasds',
    iconName: 'hammer',
    icon: [
      576,
      512,
      [128296],
      'f6e3',
      
      ['M0 416l96 96L352 224l-64-64L0 416z','M176 48l49.6-29.8C245.5 6.3 268.3 0 291.5 0L315 0c33.9 0 66.5 13.5 90.5 37.5L504 136l-24 24 24 24 24-24 48 48L456 328l-48-48 24-24-24-24-24 24L272 144l0-48L176 48z']
      
    ]
  };

  

  
  

  var faPersonPraying = {
    prefix: 'fasds',
    iconName: 'person-praying',
    icon: [
      448,
      512,
      [128720,"pray"],
      'f683',
      
      ['M224 64a64 64 0 1 0 128 0A64 64 0 1 0 224 64z','M176 144l-24.1 0-11.2 21.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432 72 432l-40 0 0 80 40 0 208 0 23.8-72.2L187.7 354l45-90 22.9 31.5 24.9 34.2L313.3 303l72.1-59 31-25.3-50.7-61.9-31 25.3-39.4 32.2-39.1-53.8-12-16.5L224 144l-48 0z']
      
    ]
  };

  
    var faPray = faPersonPraying;
  

  
  

  var faCloudsSun = {
    prefix: 'fasds',
    iconName: 'clouds-sun',
    icon: [
      640,
      512,
      [],
      'f746',
      
      ['M0 121.3L60.7 208 0 294.7 104 312l17.3 104 42-29.4c8.8-37.6 34.2-68.7 68-85.4c-7.5 1.9-15.3 2.9-23.4 2.9c-53 0-96-43-96-96s43-96 96-96c36.6 0 68.5 20.5 84.7 50.7c7.5-23.3 23.7-42.8 44.7-54.5L312 104 294.7 0 208 60.7 121.3 0 104 104 0 121.3zM144 208a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M495.9 224c-12.9 0-25.3 2.2-36.8 6.2C435.9 206.6 403.7 192 368 192c-16.7 0-32.6 3.2-47.3 9c-.4-2.9-.6-5.9-.6-8.9c0-35.3 28.6-64 64-64c7.4 0 14.6 1.3 21.2 3.6c11.5-30.1 40.6-51.6 74.8-51.6c38.9 0 71.3 27.8 78.5 64.6c3.1-.4 6.3-.6 9.5-.6c39.8 0 72 32.2 72 72l0 72-42.8 0c-18-37.9-56.5-64.1-101.3-64.1zm144 287.9l-80 0-271.9 0-96 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80z']
      
    ]
  };

  

  
  

  var faTrophy = {
    prefix: 'fasds',
    iconName: 'trophy',
    icon: [
      576,
      512,
      [127942],
      'f091',
      
      ['M0 64L0 88C0 222.5 70.4 295.7 140.5 334.1c34.5 18.9 68.8 29.3 94.3 35c5.8 1.3 11.3 2.4 16.2 3.3c-19.5-10.6-43.9-30.9-65.7-69.7c-7.2-3.2-14.4-6.7-21.7-10.7C109.8 262.6 56.4 209.9 48.9 112l84.4 0c-1.5-15.1-2.8-31.1-3.6-48L24 64 0 64zM325.1 372.3c4.9-.9 10.3-1.9 16.2-3.3c25.5-5.7 59.8-16.1 94.3-35C505.6 295.7 576 222.5 576 88l0-24-24 0L446.4 64c-.9 16.9-2.1 32.9-3.6 48l84.4 0c-7.5 97.9-60.9 150.6-114.6 179.9c-7.2 4-14.5 7.5-21.7 10.7c-21.9 38.8-46.2 59.1-65.7 69.7z','M256 374.9C209.3 352.3 128 273.7 128 0L448 0c0 273.7-81.3 352.3-128 374.9l0 73.1 72 0 24 0 0 24 0 16 0 24-24 0-208 0-24 0 0-24 0-16 0-24 24 0 72 0 0-73.1z']
      
    ]
  };

  

  
  

  var faWheatSlash = {
    prefix: 'fasds',
    iconName: 'wheat-slash',
    icon: [
      640,
      512,
      [],
      'e339',
      
      ['M66.7 464l22.6-22.6 52.9-52.9L131.9 378c-37.5-37.5-37.5-98.3 0-135.8l22.6-22.6 22.6 22.6c21 21 33.2 47.5 36.5 74.8l29.5-29.5 50.6 39.9-36.3 36.3c28.5 2.8 56.2 15.1 78.1 36.9l22.6 22.6-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-52.9 52.9L112 509.3 66.7 464zM224.3 151.4c2.8-3.8 6-7.5 9.4-10.9l22.6-22.6L279 140.5c21 21 33.2 47.5 36.5 74.8l30.5-30.5-10.4-10.4c-37.5-37.5-37.5-98.3 0-135.8L358.2 16l22.6 22.6c34.1 34.1 44.9 82.6 32.5 125.9c43.3-12.4 91.8-1.5 125.9 32.5l22.6 22.6-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-28.6 28.6c-46.1-35.8-92.2-71.6-138.3-107.3zM448 88c0-48.6 39.4-88 88-88l40 0 0 40c0 48.6-39.4 88-88 88l-40 0 0-40z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faThumbtack = {
    prefix: 'fasds',
    iconName: 'thumbtack',
    icon: [
      384,
      512,
      [128204,128392,"thumb-tack"],
      'f08d',
      
      ['M0 320l0 32 160 0 0-128 64 0 0 128 160 0 0-32c0-22.5-23.7-76.5-82.1-106.7L290.5 64 320 64l32 0 0-64L320 0 64 0 32 0l0 64 32 0 29.5 0L82.1 212.1C23.7 240.7 0 293 0 320z','M160 480l0-256 64 0 0 256 0 32-64 0 0-32z']
      
    ]
  };

  
    var faThumbTack = faThumbtack;
  

  
  

  var faSignatureSlash = {
    prefix: 'fasds',
    iconName: 'signature-slash',
    icon: [
      640,
      512,
      [],
      'e3cb',
      
      ['M0 368l0 48 24 0 40.3 0c-.2-2.8-.3-5.6-.3-8.5L64 368l-40 0L0 368zM96 264.2L96 288l0 160 0 32 32 0 64 0 18.6 0 9.2-16.1 25.5-44.7c17.5-30.5 31.9-62.7 43.1-95.9L181.1 238.7l-62.3 18.7L96 264.2zM138.3 84.6L192 126.3c.9-16.9 14.8-30.3 32-30.3c17.7 0 32 14.3 32 32l0 7.8c0 13-.5 26-1.6 39c33.7 26.1 67.3 52.3 101 78.4l42.7-12.8L386 276.9 441.5 320 544 320l32 0 0-64-32 0-83.6 0 18-53.9 19.5-58.5-59 17.7L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96c-37.4 0-69.8 21.4-85.7 52.6zM160 311.8l71.8-21.5c-10.4 33.8-24.5 66.4-42.1 97.2L173.4 416 160 416l0-104.2zM283.5 416l122.6 0-60.9-48-39.4 0c-6.7 16.3-14.2 32.3-22.3 48zm219.8-48c20.6 16 41.2 32 61.8 48l50.8 0 24 0 0-48-24 0-112.7 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faPhoneHangup = {
    prefix: 'fasds',
    iconName: 'phone-hangup',
    icon: [
      640,
      512,
      [],
      'e225',
      
      ['M20.2 285.5c75.5-34 139.6-51.8 203.8-59.8c0 10.8 0 21.5 0 32.3c-59.6 7.9-119.7 24.8-190.8 56.8c-4.3-9.7-8.7-19.5-13-29.2zM416 225.6c64.2 8 128.3 25.8 203.8 59.8c-4.3 9.7-8.7 19.5-13 29.2c-71.2-32.1-131.2-49-190.8-56.8l0-32.3z','M20.2 285.5L0 240C37.3 192 153.6 96 320 96s282.7 96 320 144l-20.2 45.4c-75.5-34-139.6-51.8-203.8-59.8l0-1.6c-62.3-20.8-129.7-20.8-192 0l0 1.6c-64.2 8-128.3 25.8-203.8 59.8zm13 29.2c71.2-32.1 131.2-49 190.8-56.8l0 94.1L64 384 33.2 314.7zM416 257.9c59.6 7.9 119.7 24.8 190.8 56.8L576 384 416 352l0-94.1z']
      
    ]
  };

  

  
  

  var faFaceSmile = {
    prefix: 'fasds',
    iconName: 'face-smile',
    icon: [
      512,
      512,
      [128578,"smile"],
      'f118',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm129.7 71.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faSmile = faFaceSmile;
  

  
  

  var faPersonSign = {
    prefix: 'fasds',
    iconName: 'person-sign',
    icon: [
      512,
      512,
      [],
      'f757',
      
      ['M256 148.4l78.2 29.1c-5.3 14.6-10.6 29.1-15.9 43.7l-21.9 60.1c-2.4 6.7-4.9 13.4-7.3 20.1L280.8 324l45.1 16.4 8.2-22.6 45-123.7 80 29.8L512 75.6 433 46.2l10-27.4L397.9 2.4 388 29.5 308.8 0 256 148.4z','M144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-40 32l-19.3 0-9 17L3.7 281 60.3 311 80 273.7 80 480l0 32 64 0 0-32 0-128 20.2 0L192 407.6l0 72.4 0 32 64 0 0-32 0-80 0-7.6-3.4-6.8L216 312.4l0-77.3 16.1 18.1 5.3 5.9 7.4 2.8 51.6 19.3 21.9-60.1-43.6-16.3-58.7-66.1L206.4 128 192 128l-88 0z']
      
    ]
  };

  

  
  

  var faDisplay = {
    prefix: 'fasds',
    iconName: 'display',
    icon: [
      576,
      512,
      [],
      'e163',
      
      ['M0 0L0 416l240 0 96 0 240 0L576 0 0 0zM64 64l448 0 0 288L64 352 64 64z','M512 64L64 64l0 288 448 0 0-288zM416 448l-69.3 0L336 416l-96 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0z']
      
    ]
  };

  

  
  

  var faCoinVertical = {
    prefix: 'fasds',
    iconName: 'coin-vertical',
    icon: [
      384,
      512,
      [],
      'e3fd',
      
      ['M0 256C0 397.4 64.5 512 144 512s144-114.6 144-256S223.5 0 144 0S0 114.6 0 256zm40 0c0-47.2 7.6-91.4 21-125c6.7-16.7 15.4-32.4 26.8-44.4C99.3 74.5 115.5 64 136 64s36.7 10.5 48.2 22.6c11.4 12 20.1 27.7 26.8 44.4c13.4 33.6 21 77.8 21 125s-7.6 91.4-21 125c-6.7 16.7-15.4 32.4-26.8 44.4C172.7 437.5 156.5 448 136 448s-36.7-10.5-48.2-22.6C76.5 413.4 67.7 397.7 61 381c-13.4-33.6-21-77.8-21-125zm32 0c0 88.4 28.7 160 64 160s64-71.6 64-160s-28.7-160-64-160s-64 71.6-64 160z','M330.6 48C309.6 17.8 283.8 0 256 0L226.1 0c15.6 13.2 29.3 29.7 40.9 48l63.7 0zM313.3 176l64.3 0c-6-36.2-15.9-68.9-28.7-96l-64.7 0c13.2 28.4 23 60.9 29 96zm68.4 128c1.5-15.5 2.2-31.6 2.2-48s-.8-32.5-2.2-48l-64.1 0c1.6 15.7 2.4 31.7 2.4 48s-.8 32.3-2.4 48l64.1 0zM284.3 432l64.7 0c12.8-27.1 22.7-59.8 28.7-96l-64.3 0c-6 35.1-15.9 67.6-29 96zM267 464c-11.5 18.3-25.2 34.8-40.9 48l29.9 0c27.9 0 53.6-17.8 74.6-48L267 464zM136 448c20.5 0 36.7-10.5 48.2-22.6c11.4-12 20.1-27.7 26.8-44.4c13.4-33.6 21-77.8 21-125s-7.6-91.4-21-125c-6.7-16.7-15.4-32.4-26.8-44.4C172.7 74.5 156.5 64 136 64s-36.7 10.5-48.2 22.6C76.5 98.6 67.7 114.3 61 131c-13.4 33.6-21 77.8-21 125s7.6 91.4 21 125c6.7 16.7 15.4 32.4 26.8 44.4C99.3 437.5 115.5 448 136 448zm64-192c0 88.4-28.7 160-64 160s-64-71.6-64-160s28.7-160 64-160s64 71.6 64 160z']
      
    ]
  };

  

  
  

  var faLocationCheck = {
    prefix: 'fasds',
    iconName: 'location-check',
    icon: [
      384,
      512,
      ["map-marker-check"],
      'f606',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm81.7 3.6c11.3-11.3 22.6-22.6 33.9-33.9l49.7 49.7c34.3-34.4 68.7-68.7 103-103c11.3 11.3 22.6 22.6 33.9 33.9l-120 120-17 17-17-17c-22.2-22.2-44.4-44.4-66.7-66.7z','M302.3 142.3l-120 120-17 17-17-17L81.7 195.6l33.9-33.9 49.7 49.7 103-103 33.9 33.9z']
      
    ]
  };

  
    var faMapMarkerCheck = faLocationCheck;
  

  
  

  var faConveyorBelt = {
    prefix: 'fasds',
    iconName: 'conveyor-belt',
    icon: [
      640,
      512,
      [],
      'f46e',
      
      ['M0 416c0-53 43-96 96-96l448 0c53 0 96 43 96 96s-43 96-96 96L96 512c-53 0-96-43-96-96zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 0L384 0l0 128L320 80l-64 48L256 0zm32 416a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm192 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M256 0L128 0l0 256 384 0L512 0 384 0l0 128L320 80l-64 48L256 0z']
      
    ]
  };

  

  
  

  var faGlassWaterDroplet = {
    prefix: 'fasds',
    iconName: 'glass-water-droplet',
    icon: [
      384,
      512,
      [],
      'e4f5',
      
      ['M0 0L5 64 40 512l304 0L379 64l5-64L319.8 0 64.2 0 0 0zM69.2 64l245.6 0c-6.1 78.6-12.3 157.2-18.4 235.8L284.8 448 99.2 448c-3.9-49.4-7.7-98.8-11.6-148.2C81.5 221.2 75.3 142.6 69.2 64z','M192 96l47.9 53.9c10.4 11.7 16.1 26.7 16.1 42.4c0 35.2-28.8 63.8-64 63.8s-64-28.5-64-63.8c0-15.6 5.7-30.7 16.1-42.4L192 96zM99.2 448L87.6 299.8 96 304c20.1 10.1 43.9 10.1 64 0s43.9-10.1 64 0s43.9 10.1 64 0l8.4-4.2L284.8 448 99.2 448z']
      
    ]
  };

  

  
  

  var faTruckMoving = {
    prefix: 'fasds',
    iconName: 'truck-moving',
    icon: [
      640,
      512,
      [],
      'f4df',
      
      ['M32 416a64 64 0 1 0 128 0A64 64 0 1 0 32 416zm160 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm288 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M480 32L0 32 0 384l5.5 0c13.2-37.3 48.7-64 90.5-64c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64l69.5 0 37.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l5.5 0 0-96 0-32 0-8.6-5.4-6.6-72-88-7.2-8.8L544 144l-64 0 0-112zM585 256l-105 0 0-64 52.6 0L585 256z']
      
    ]
  };

  

  
  

  var faPercent = {
    prefix: 'fasds',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      ['M2.7 400L48 445.3l22.6-22.6 288-288L381.3 112 336 66.7 313.4 89.4l-288 288L2.7 400z','M120 72L8 72 8 184l112 0 0-112zM376 328l-112 0 0 112 112 0 0-112z']
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faHandMiddleFinger = {
    prefix: 'fasds',
    iconName: 'hand-middle-finger',
    icon: [
      448,
      512,
      [128405],
      'f806',
      
      ['M272 0L192 0l0 192-80 0 0 32 0 13.3 0 2.7 0 80 0 16-32 0 0-16 0-56L32 304l0 57.5c0 44.7 19.8 87 54.1 115.6c27 22.5 61.1 34.9 96.3 34.9L304 512c70.7 0 128-57.3 128-128l0-16 0-48 0-80-80 0 0-32-80 0L272 0z','']
      
    ]
  };

  

  
  

  var faBrightnessLow = {
    prefix: 'fasds',
    iconName: 'brightness-low',
    icon: [
      512,
      512,
      [],
      'e0ca',
      
      ['M48 224l0 64 64 0 0-64-64 0zm34.7-96L128 173.3 173.3 128 128 82.7 82.7 128zm0 256L128 429.3 173.3 384 128 338.7 82.7 384zM224 48l0 64 64 0 0-64-64 0zm0 352l0 64 64 0 0-64-64 0zM338.7 128L384 173.3 429.3 128 384 82.7 338.7 128zm0 256L384 429.3 429.3 384 384 338.7 338.7 384zM400 224l0 64 64 0 0-64-64 0z','M160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z']
      
    ]
  };

  

  
  

  var faGaugeCircleMinus = {
    prefix: 'fasds',
    iconName: 'gauge-circle-minus',
    icon: [
      640,
      512,
      [],
      'e497',
      
      ['M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0-16 0 0-32 16 0 128 0 16 0 0 32-16 0z']
      
    ]
  };

  

  
  

  var faCarTilt = {
    prefix: 'fasds',
    iconName: 'car-tilt',
    icon: [
      640,
      512,
      [],
      'f5e5',
      
      ['M0 448l63.3 0 99.4 0L640 448l0 64L0 512l0-64z','M65.1 75.8l21.1-5.7L318.1 8l21.1-5.7L352.2 20 430.6 127l40.7-10.9L521 301.5l20.7 77.3-92.7 24.8-20.7-77.3L150 400.9 162.7 448l-99.4 0-6-22.2L7.6 240.3l40.7-10.9L62.7 97.6l2.4-21.8zm248.4-.3L124 126.3l-9.3 85.3 249.6-66.9L313.5 75.5zm-180 263.6a32 32 0 1 0 -16.6-61.8 32 32 0 1 0 16.6 61.8zM434.3 225.4a32 32 0 1 0 -61.8 16.6 32 32 0 1 0 61.8-16.6z']
      
    ]
  };

  

  
  

  var faVrCardboard = {
    prefix: 'fasds',
    iconName: 'vr-cardboard',
    icon: [
      640,
      512,
      [],
      'f729',
      
      ['M0 64L0 448l224 0 64-128 64 0 64 128 224 0 0-384L0 64zM224 240A64 64 0 1 1 96 240a64 64 0 1 1 128 0zm320 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M160 304a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm320 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faShieldMinus = {
    prefix: 'fasds',
    iconName: 'shield-minus',
    icon: [
      512,
      512,
      [],
      'e249',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM160 232c8 0 16 0 24 0c48 0 96 0 144 0c8 0 16 0 24 0c0 16 0 32 0 48c-8 0-16 0-24 0c-48 0-96 0-144 0c-8 0-16 0-24 0c0-16 0-32 0-48z','M160 232l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faThermometer = {
    prefix: 'fasds',
    iconName: 'thermometer',
    icon: [
      512,
      512,
      [],
      'f491',
      
      ['M1.3 476.8l33.9 33.9 17-17L129.9 416 232 416l9.9 0 7-7L481.8 176.2c19.4-19.4 30.2-45.6 30.2-73C512 46.2 465.8 0 408.8 0c-27.4 0-53.6 10.9-73 30.2L290.3 75.7l57 57c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-19-19-38-38-57-57c-13.8 13.8-27.6 27.6-41.4 41.4c19 19 38 38 57 57c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-57-57c-13.8 13.8-27.6 27.6-41.4 41.4c19 19 38 38 57 57c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-57-57c-12.2 12.2-24.5 24.5-36.7 36.7l-7 7 0 9.9 0 102.1L18.2 459.8l-17 17z','M139.7 226.3l57 57L208 294.6 230.6 272l-11.3-11.3-57-57-22.6 22.6zm64-64l57 57L272 230.6 294.6 208l-11.3-11.3-57-57-22.6 22.6zm64-64l57 57L336 166.6 358.6 144l-11.3-11.3-57-57L267.7 98.3z']
      
    ]
  };

  

  
  

  var faCloudMinus = {
    prefix: 'fasds',
    iconName: 'cloud-minus',
    icon: [
      640,
      512,
      [],
      'e35d',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zm224-72l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z','M224 264l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faTrafficLight = {
    prefix: 'fasds',
    iconName: 'traffic-light',
    icon: [
      320,
      512,
      [128678],
      'f637',
      
      ['M112 112a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM160 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z']
      
    ]
  };

  

  
  

  var faCloudMusic = {
    prefix: 'fasds',
    iconName: 'cloud-music',
    icon: [
      640,
      512,
      [],
      'f8ae',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zm192 40c0-17.7 21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48 21.6-8.1 0 23.1 0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L288 376c0 17.7-21.5 32-48 32s-48-14.3-48-32z','M416 160.9l0 23.1 0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L288 376c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48 21.6-8.1z']
      
    ]
  };

  

  
  

  var faDownToDottedLine = {
    prefix: 'fasds',
    iconName: 'down-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e408',
      
      ['M0 416l0 64 64 0 0-64L0 416zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z','M224 384L64 224l0-32 96 0 0-160 128 0 0 160 96 0 0 32L224 384z']
      
    ]
  };

  

  
  

  var faFaceExpressionless = {
    prefix: 'fasds',
    iconName: 'face-expressionless',
    icon: [
      512,
      512,
      [],
      'e373',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-64l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zm16 144l16 0 192 0 16 0 0 32-16 0-192 0-16 0 0-32zM288 192l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32z','M144 192l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zm160 0l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z']
      
    ]
  };

  

  
  

  var faBabyCarriage = {
    prefix: 'fasds',
    iconName: 'baby-carriage',
    icon: [
      512,
      512,
      ["carriage-baby"],
      'f77d',
      
      ['M.1 192L256 192 123 0C52.3 35.8 3.1 108 .1 192zM32 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm288 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M416 96l-32 0 0 32 0 96-160 0L0 224c0 25.2 5.8 50.2 17.1 73.5s27.8 44.5 48.6 62.3s45.5 32 72.7 41.6S194.6 416 224 416s58.5-5 85.7-14.6s51.9-23.8 72.7-41.6s37.3-39 48.6-62.3s17-48.3 17-73.5l0-64 32 0 32 0 0-64-32 0-64 0z']
      
    ]
  };

  
    var faCarriageBaby = faBabyCarriage;
  

  
  

  var faRadio = {
    prefix: 'fasds',
    iconName: 'radio',
    icon: [
      512,
      512,
      [128251],
      'f8d7',
      
      ['M0 128c63.3 0 126.5 0 189.8 0c107.4 0 214.8 0 322.2 0l0 384L0 512 0 128zM64 304l0 32 16 0 128 0 16 0 0-32-16 0L80 304l-16 0zm16-64l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm0 128l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm208-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M509 49.6l-23.3 5.7L189.8 128 0 128l0-2.8 18.3-4.5 456-112L497.6 3 509 49.6zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160z']
      
    ]
  };

  

  
  

  var faEllipsisStroke = {
    prefix: 'fasds',
    iconName: 'ellipsis-stroke',
    icon: [
      512,
      512,
      ["ellipsis-h-alt"],
      'f39b',
      
      ['M192 192l0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0-48 0zm48 48l32 0 0 32-32 0 0-32z','M80 272l32 0 0-32-32 0 0 32zM32 320l0-48 0-32 0-48 48 0 32 0 48 0 0 48 0 32 0 48-48 0-32 0-48 0zm368-48l32 0 0-32-32 0 0 32zm-48 48l0-48 0-32 0-48 48 0 32 0 48 0 0 48 0 32 0 48-48 0-32 0-48 0z']
      
    ]
  };

  
    var faEllipsisHAlt = faEllipsisStroke;
  

  
  

  var faBatteryQuarter = {
    prefix: 'fasds',
    iconName: 'battery-quarter',
    icon: [
      576,
      512,
      ["battery-2"],
      'f243',
      
      ['M0 96l64 0 416 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0L64 416 0 416l0-64L0 160 0 96zm64 64l0 192 416 0 0-192L64 160z','M96 192h96v128H96V192z']
      
    ]
  };

  
    var faBattery2 = faBatteryQuarter;
  

  
  

  var faVideoSlash = {
    prefix: 'fasds',
    iconName: 'video-slash',
    icon: [
      640,
      512,
      [],
      'f4e2',
      
      ['M32 121.2L416 423.8l0 24.2L32 448l0-326.8zM111.8 64L416 64l0 236.2L111.8 64zM448 174.9L608 64l0 384-15.1-10.5L448 325l0-150.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faFrame = {
    prefix: 'fasds',
    iconName: 'frame',
    icon: [
      448,
      512,
      [],
      'e495',
      
      ['M64 32l64 0 0 64 0 64 0 192-64 0 0-192 0-64 0-64zm0 384l64 0 0 64-64 0 0-64zM320 32l64 0 0 64-64 0 0-64zm0 128l64 0 0 192 0 64 0 64-64 0 0-64 0-64 0-192z','M448 96l0 64-320 0 0-64 320 0zM0 96l64 0 0 64L0 160 0 96zM0 416l0-64 320 0 0 64L0 416zm448 0l-64 0 0-64 64 0 0 64z']
      
    ]
  };

  

  
  

  var faComputerClassic = {
    prefix: 'fasds',
    iconName: 'computer-classic',
    icon: [
      448,
      512,
      [],
      'f8b1',
      
      ['M0 0L448 0l0 416L0 416 0 0zM32 448l384 0 0 64L32 512l0-64zM56 336a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM64 64l0 192 320 0 0-192L64 64zM224 320l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0z','M64 64H384V256H64V64z']
      
    ]
  };

  

  
  

  var faPumpSoap = {
    prefix: 'fasds',
    iconName: 'pump-soap',
    icon: [
      448,
      512,
      [],
      'e06b',
      
      ['M32 512L56 160l72 0 128 0 72 0 24 352L32 512zm96-152c0 35.3 28.7 56 64 56s64-20.7 64-56c0-40-64-120-64-120s-64 80-64 120z','M128 0L256 0l0 32 96 0 13.3 0 9.4 9.4 48 48L445.3 112 400 157.3l-22.6-22.6L338.7 96 256 96l0 64-128 0L128 0zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-40 64-120 64-120s64 80 64 120z']
      
    ]
  };

  

  
  

  var faCarRear = {
    prefix: 'fasds',
    iconName: 'car-rear',
    icon: [
      512,
      512,
      ["car-alt"],
      'f5de',
      
      ['M32 400l0 80 96 0 0-80-96 0zm77.1-208l293.8 0L369.3 96 142.7 96c-11.2 32-22.4 64-33.6 96zM384 400l0 80 96 0 0-80-96 0z','M97.3 32L120 32l272 0 22.7 0 7.5 21.4L470.7 192l41.3 0 0 208L0 400 0 192l41.3 0L89.8 53.4 97.3 32zm272 64L142.7 96l-33.6 96 293.8 0L369.3 96zM128 256l-80 0 0 48 80 0 0-48zm256 0l0 48 80 0 0-48-80 0zm-64 16l-128 0 0 64 128 0 0-64z']
      
    ]
  };

  
    var faCarAlt = faCarRear;
  

  
  

  var faRetweet = {
    prefix: 'fasds',
    iconName: 'retweet',
    icon: [
      576,
      512,
      [],
      'f079',
      
      ['M272 96l0 64 32 0 144 0 0 160-64 0 0 32 96 96 96-96 0-32-64 0 0-192 0-32-32 0L304 96l-32 0z','M96 64L0 160l0 32 64 0 0 192 0 32 32 0 176 0 32 0 0-64-32 0-144 0 0-160 64 0 0-32L96 64z']
      
    ]
  };

  

  
  

  var faClockFive = {
    prefix: 'fasds',
    iconName: 'clock-five',
    icon: [
      512,
      512,
      [],
      'e349',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 96l48 0 0 24 0 128.7 60 90 13.3 20-39.9 26.6-13.3-20-64-96-4-6 0-7.3 0-136 0-24z','M280 96l0 24 0 128.7 60 90 13.3 20-39.9 26.6-13.3-20-64-96-4-6 0-7.3 0-136 0-24 48 0z']
      
    ]
  };

  

  
  

  var faSignalWeak = {
    prefix: 'fasds',
    iconName: 'signal-weak',
    icon: [
      640,
      512,
      ["signal-1"],
      'f68c',
      
      ['M160 288l0 32 0 160 0 32 64 0 0-32 0-160 0-32-64 0zm128-96l0 32 0 256 0 32 64 0 0-32 0-256 0-32-64 0zM416 96l0 32 0 352 0 32 64 0 0-32 0-352 0-32-64 0zM544 0l0 32 0 448 0 32 64 0 0-32 0-448 0-32L544 0z','M96 384l0 32 0 64 0 32-64 0 0-32 0-64 0-32 64 0z']
      
    ]
  };

  
    var faSignal1 = faSignalWeak;
  

  
  

  var faChevronRight = {
    prefix: 'fasds',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      ['M317.3 256l-22.6 22.6-192 192L80 493.3 34.7 448l22.6-22.6L226.7 256 57.4 86.6 34.7 64 80 18.7l22.6 22.6 192 192L317.3 256z','']
      
    ]
  };

  

  
  

  var faGenderless = {
    prefix: 'fasds',
    iconName: 'genderless',
    icon: [
      384,
      512,
      [],
      'f22d',
      
      ['M112 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z']
      
    ]
  };

  

  
  

  var faBriefcaseMedical = {
    prefix: 'fasds',
    iconName: 'briefcase-medical',
    icon: [
      512,
      512,
      [],
      'f469',
      
      ['M128 0l24 0L360 0l24 0 0 24 0 72-48 0 0-48L176 48l0 48-48 0 0-72 0-24z','M512 96L0 96 0 480l512 0 0-384zM224 192l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faTurntable = {
    prefix: 'fasds',
    iconName: 'turntable',
    icon: [
      576,
      512,
      [],
      'f8e4',
      
      ['M0 32L0 480l576 0 0-448L0 32zM384 256A160 160 0 1 1 64 256a160 160 0 1 1 320 0zm21.1 134.3l14.3-28.6 24-48 14.3 7.2L480 276.2 480 112l0-16 32 0 0 16 0 168 0 3.8-1.7 3.4-24 48 14.3 7.2-24 48-14.3 28.6-57.2-28.6z','M64 256a160 160 0 1 1 320 0A160 160 0 1 1 64 256zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM512 96l0 16 0 168 0 3.8-1.7 3.4-24 48 14.3 7.2-24 48-14.3 28.6-57.2-28.6 14.3-28.6 24-48 14.3 7.2L480 276.2 480 112l0-16 32 0z']
      
    ]
  };

  

  
  

  var faPersonToDoor = {
    prefix: 'fasds',
    iconName: 'person-to-door',
    icon: [
      576,
      512,
      [58704],
      'e433',
      
      ['M384 0l0 224 16 0c0 21.3 0 42.7 0 64l-16 0 0 224 192 0L576 0 384 0z','M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 96l-13.3 0-9.4 9.4-48 48L34.7 176 80 221.3l22.6-22.6L141.3 160l27.7 0-31.3 94c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-9.4 32.8-16 56L213.6 512l66.6 0 6.6-23.2 16-56 16-56 6.6-23.2L305 340.9 238 299l29-77.4 24.3 48.6 8.8 17.7 19.8 0 48 0 32 0 0-64-32 0-28.2 0-39.2-78.3-5.4-10.9-11.3-4.5-80-32L198.2 96 192 96l-64 0zM109.5 310.7L91.2 352 32 352 0 352l0 64 32 0 80 0 20.8 0 8.4-19L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9z']
      
    ]
  };

  

  
  

  var faDisease = {
    prefix: 'fasds',
    iconName: 'disease',
    icon: [
      512,
      512,
      [],
      'f7fa',
      
      ['M.1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6l10 0c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1zM120 224l40-40 40 40-40 40-40-40zm128 96c13.3-13.3 26.7-26.7 40-40c13.3 13.3 26.7 26.7 40 40c-13.3 13.3-26.7 26.7-40 40l-40-40zm32-112c8-8 16-16 24-24c8 8 16 16 24 24l-24 24c-8-8-16-16-24-24z','M304 232l-24-24 24-24 24 24-24 24zM288 360l-40-40 40-40 40 40-40 40z']
      
    ]
  };

  

  
  

  var faNotdef = {
    prefix: 'fasds',
    iconName: 'notdef',
    icon: [
      384,
      512,
      [],
      'e1fe',
      
      ['M64 64l38.5 0L192 198.3 281.5 64 320 64l0 57.7L230.5 256 320 390.3l0 57.7-38.5 0L192 313.7 102.5 448 64 448l0-57.7L153.5 256 64 121.7c0-19.2 0-38.5 0-57.7z','M0 0L32 0 352 0l32 0 0 32 0 448 0 32-32 0L32 512 0 512l0-32L0 32 0 0zM64 64l0 384 256 0 0-384L64 64z']
      
    ]
  };

  

  
  

  var faTrashCanUndo = {
    prefix: 'fasds',
    iconName: 'trash-can-undo',
    icon: [
      448,
      512,
      ["trash-can-arrow-turn-left","trash-undo-alt"],
      'f896',
      
      ['M32 96l384 0 0 416L32 512 32 96zM94.1 256l17 17 64 64 17 17L225.9 320l-17-17-23-23 54.1 0c22.1 0 40 17.9 40 40l0 40 0 24 48 0 0-24 0-40c0-48.6-39.4-88-88-88l-54.1 0 23-23 17-17L192 158.1l-17 17-64 64-17 17z','M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zm65 209l17-17L192 158.1l-17 17-64 64-17 17 17 17 64 64 17 17L225.9 320l-17-17-23-23 54.1 0c22.1 0 40 17.9 40 40l0 40 0 24 48 0 0-24 0-40c0-48.6-39.4-88-88-88l-54.1 0 23-23z']
      
    ]
  };

  
    var faTrashCanArrowTurnLeft = faTrashCanUndo;
  
    var faTrashUndoAlt = faTrashCanUndo;
  

  
  

  var faFilterSlash = {
    prefix: 'fasds',
    iconName: 'filter-slash',
    icon: [
      640,
      512,
      [],
      'e17d',
      
      ['M70.5 32L576 32l0 64L407 293.2C294.8 206.1 182.7 119.1 70.5 32zM256 297.7L384 398.5 384 512 256 416l0-118.3z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faTablePivot = {
    prefix: 'fasds',
    iconName: 'table-pivot',
    icon: [
      512,
      512,
      [],
      'e291',
      
      ['M0 192l128 0 0 224 320 0 0-256-288 0 0-128 352 0 0 448L0 480 0 192z','M128 32L0 32 0 160l128 0 0-128zM368 192l-48 48 0 16 32 0 0 64-64 0 0-32-16 0-48 48 48 48 16 0 0-32 80 0 16 0 0-16 0-80 32 0 0-16-48-48z']
      
    ]
  };

  

  
  

  var faHandLizard = {
    prefix: 'fasds',
    iconName: 'hand-lizard',
    icon: [
      512,
      512,
      [],
      'f258',
      
      ['M0 64l48 0 112 0 80 0 80 0 25.1 0 14.3 20.7 144 208L512 305l0 15 0 32 0 16 0 80-160 0 0-45.8L273.9 352 240 352l-80 0-48 0-48 0 0-96 48 0 48 0 80 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-80 0L48 160 0 160 0 64z','']
      
    ]
  };

  

  
  

  var faMoneyBillSimple = {
    prefix: 'fasds',
    iconName: 'money-bill-simple',
    icon: [
      576,
      512,
      [],
      'e1f1',
      
      ['M192 256a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M576 64L0 64 0 448l576 0 0-384zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z']
      
    ]
  };

  

  
  

  var faClouds = {
    prefix: 'fasds',
    iconName: 'clouds',
    icon: [
      640,
      512,
      [],
      'f744',
      
      ['M0 192l0 96 96 0 64.9 0c8-72 69-128 143.1-128c41.7 0 79.3 17.8 105.6 46.1c11.7-6.5 24.6-11 38.4-13l0-33.1c0-53-43-96-96-96c-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0C151.6 0 104.9 41.7 97.1 96L96 96C43 96 0 139 0 192z','M128 512l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28c-18.7-35.7-56.1-60-99.2-60c-61.9 0-112 50.1-112 112l0 21.5c-37.3 13.2-64 48.7-64 90.5l0 96z']
      
    ]
  };

  

  
  

  var faBacteria = {
    prefix: 'fasds',
    iconName: 'bacteria',
    icon: [
      640,
      512,
      [],
      'e059',
      
      ['M3 289L15 323l17-6 2.2-.8c8 14.7 20.3 26.8 35.4 34.6L66.7 361l-4.9 17.3 34.6 9.9 4.9-17.3 3.1-11c17.8 .8 34.7-4.1 48.8-13.2l8 8L174 367.5 199.5 342l-12.7-12.7-8-8c6.8-10.6 11.3-22.9 12.7-36.2l.1-.6c.2-1.3 .7-3.8 1.7-7.4l.2-.6 9.4 4 16.5 7.1 14.2-33.1-16.5-7.1-8.5-3.6c7.5-11.1 18.7-23.7 36.5-34.5l1.6 5.6 4.9 17.3 34.6-9.9-4.9-17.3-3-10.6c5.2-1.7 10.7-3.2 16.6-4.6c9.7-2.2 18.5-6 26.4-11.1l8 8L342 199.5 367.4 174l-12.7-12.7-8-8c9.1-14.3 14-31.2 13.2-48.8l11-3.1 17.3-4.9-9.9-34.6L361 66.7l-10.3 2.9c-7.8-15.2-20-27.5-34.6-35.4L317 32l6-17L289 3l-6 17-1.5 4.2c-8-.5-16.2 .1-24.4 2c-9 2.1-17.8 4.4-26.2 7l-4.4-10.3L219.5 6.4 186.4 20.5l7.1 16.5 3.6 8.5c-16.5 7.1-31.5 15.1-45.2 23.9L147 62 137 47 107 67l10 15 5.8 8.7c-13.5 11.2-25.3 23.1-35.5 35.3l-10.1-8.1L63.2 106.7 40.7 134.8l14.1 11.2L66 155c-1.6 2.4-3.1 4.8-4.5 7.3c-7.1 11.8-12.8 23.2-17.4 34l-7.4-3L20 186.6 6.6 220l16.7 6.7 8.7 3.5c-.2 .8-.4 1.6-.7 2.3c-2.6 9.4-4.2 17.4-5.3 23.5c-.5 3.1-.9 5.7-1.2 7.7c-.1 1-.2 2-.3 2.7l-.1 1.1 0 .5c0 .3 0 .4 29.5 3.1c-9.9-.9-19.7-1.8-29.5-2.7c-.4 4.4-.5 8.8-.2 13.2L20 283 3 289zm93.1-68.3c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6zM224 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM384.2 380.7c0 .5-.1 .9-.1 1.4c0 .5 0 .9-.1 1.4c0 .2 0 .4 0 .5s0 .4 0 .5c0 .4 0 .7 0 1.1c0 .5 .1 1 .1 1.5c.1 1.1 .3 2.2 .5 3.3c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4c17.7 0 32-14.3 32-32s-14.3-32-32-32c-8.8 0-16.8 3.6-22.6 9.4c-2.9 2.9-5.2 6.3-6.9 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2z','M323 480l-6 17L351 509l6-17 1.5-4.2c8 .5 16.2-.1 24.4-2c9-2.1 17.8-4.4 26.2-7l4.4 10.3 7.1 16.5 33.1-14.2-7.1-16.5-3.6-8.5c16.5-7.1 31.5-15.1 45.2-23.9l5 7.4 10 15 30-20-10-15-5.8-8.7c13.5-11.2 25.3-23.1 35.5-35.3l10.1 8.1 14.1 11.2 22.5-28.1-14.1-11.2L574 357c1.6-2.4 3.1-4.8 4.5-7.3c7.1-11.8 12.8-23.2 17.4-34l7.4 3 16.7 6.7L633.4 292l-16.7-6.7-8.7-3.5c.2-.8 .4-1.6 .7-2.3c2.6-9.4 4.2-17.4 5.3-23.5c.5-3.1 .9-5.7 1.2-7.7c.1-1 .2-2 .3-2.7l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.5-2.8c0 0 0 0 0 0l29.5 2.7c.4-4.4 .5-8.8 .2-13.2L620 229l17-6L625 189l-17 6-2.2 .8c-8-14.7-20.3-26.8-35.4-34.6l2.9-10.3 4.9-17.3-34.6-9.9-4.9 17.3-3.1 11c-17.8-.8-34.7 4.1-48.8 13.2l-8-8L466 144.5 440.5 170l12.7 12.7 8 8c-6.8 10.6-11.3 22.9-12.7 36.2l-.1 .6c-.2 1.3-.7 3.8-1.7 7.4l-.2 .6-9.4-4-16.5-7.1-14.2 33.1 16.5 7.1 8.5 3.6c-7.5 11.1-18.7 23.7-36.5 34.5l-1.6-5.6-4.9-17.3-34.6 9.9 4.9 17.3 3 10.6c-5.2 1.7-10.7 3.2-16.6 4.6c-9.7 2.2-18.5 6-26.4 11.1l-8-8L298 312.5 272.5 338l12.7 12.7 8 8c-9.1 14.2-14 31.2-13.2 48.8l-11 3.1-17.3 4.9 9.9 34.6 17.3-4.9 10.3-2.9c7.8 15.2 20 27.5 34.6 35.4L323 480zM566.2 239.1s0 0 0 0l-32.4-3 32.4 2.9zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fasds',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      ['M2.7 256l22.6 22.6 192 192L240 493.3 285.3 448l-22.6-22.6L93.3 256 262.6 86.6 285.3 64 240 18.7 217.4 41.4l-192 192L2.7 256z','']
      
    ]
  };

  

  
  

  var faArrowLeftToArc = {
    prefix: 'fasds',
    iconName: 'arrow-left-to-arc',
    icon: [
      512,
      512,
      [],
      'e616',
      
      ['M0 256C0 397.4 114.6 512 256 512l0-64C150 448 64 362 64 256S150 64 256 64l0-64C114.6 0 0 114.6 0 256z','M304 98.7l-22.6 22.6-112 112L146.7 256l22.6 22.6 112 112L304 413.3 349.3 368l-22.6-22.6L269.3 288 480 288l32 0 0-64-32 0-210.7 0 57.4-57.4L349.3 144 304 98.7z']
      
    ]
  };

  

  
  

  var faNose = {
    prefix: 'fasds',
    iconName: 'nose',
    icon: [
      448,
      512,
      [],
      'e5bd',
      
      ['M0 401.9c1 61 50.8 110.1 112 110.1c0-10.7 0-21.3 0-32c0-35.3 28.7-64 64-64l32 0 108.8 96 35.2 0 96 0 0-144L176 0 64 0l0 268.1c10.7-3.8 21.9-6.3 33.7-7.5l44.7-4.5 15.9-1.6 3.2 31.8-15.9 1.6-44.7 4.5C44.3 298 1 345.3 0 401.9z','M208 416H176c-35.3 0-64 28.7-64 64v32H316.8L208 416z']
      
    ]
  };

  

  
  

  var faHollyBerry = {
    prefix: 'fasds',
    iconName: 'holly-berry',
    icon: [
      512,
      512,
      [],
      'f7aa',
      
      ['M16 353.8l96-10.7-14.6-94L176 260.8 256 224l-16 86.6 30.7 73.3-94.7 9 13.3 95.7-75.5-15.7L32 512l17.8-88.9L16 353.8zm257.2-46.7l12.7-68.7 48.8 22.5 78.6-11.7-14.6 94 96 10.7-33.8 69.3L478.7 512l-81.8-39.1-75.5 15.7 13.3-95.7-26.6-2.5-7.9-18.8-27-64.5z','M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-32 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm160 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z']
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fasds',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      ['M0 208c0 79.5 64.5 144 144 144l16 0 0-64-16 0c-44.2 0-80-35.8-80-80c0-18.3 6.1-35.1 16.5-48.6L30.2 119.8C11.3 144.2 0 174.8 0 208zM115.4 66.8L194.2 128 304 128c44.2 0 80 35.8 80 80c0 20-7.3 38.2-19.4 52.3c16.9 13.1 33.7 26.2 50.6 39.3C435.7 274.7 448 242.8 448 208c0-79.5-64.5-144-144-144L144 64c-9.8 0-19.3 1-28.6 2.8zM192 304c0 79.5 64.5 144 144 144l110.8 0-81.2-64L336 384c-44.2 0-80-35.8-80-80c0-2.1 .1-4.1 .2-6.1l-55.4-43.6c-5.7 15.5-8.8 32.3-8.8 49.8zM480 160l0 64 16 0c44.2 0 80 35.8 80 80c0 36-23.8 66.5-56.6 76.5c18.7 14.5 37.4 29 56.1 43.5C614.4 398.3 640 354.1 640 304c0-79.5-64.5-144-144-144l-16 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faDrumstickBite = {
    prefix: 'fasds',
    iconName: 'drumstick-bite',
    icon: [
      512,
      512,
      [],
      'f6d7',
      
      ['M0 380c0 33.1 26.9 60 60 60l12 0 0 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-16.2-6.4-30.9-16.8-41.7L233.5 352 208 352l-48-48 0-25.5-58.4 58.3C90.9 326.4 76.2 320 60 320c-33.1 0-60 26.9-60 60z','M160 304l0-128C160 78.8 238.8 0 336 0c95.4 0 173.1 76 175.9 170.7C497.4 163.9 481.1 160 464 160c-61.9 0-112 50.1-112 112c0 28.6 10.7 54.6 28.3 74.4c-14.1 3.7-29 5.6-44.3 5.6l-128 0-48-48z']
      
    ]
  };

  

  
  

  var faDinosaur = {
    prefix: 'fasds',
    iconName: 'dinosaur',
    icon: [
      640,
      512,
      [],
      'e5fe',
      
      ['M0 337.8L0 352 0 480l0 32 32 0 160 0 32 0 16 0 16 0 32 0 0-50.4L109.4 431.8 96 429.6 96 416l0-48 0-16 32 0 0 16 0 34.4 178.6 29.8 13.4 2.2 0 13.6 0 15.3c5.3 .4 10.6 .7 16 .7c16.6 0 32.7-2.1 48-6l0 54 128 0 0-87.9c76.5-35.9 128-113.5 128-201.5l0-30.6C640 86 554 0 448 0L424 0 408 32 368 48l0 80 80 0 32 0c35.3 0 64 28.7 64 64l0 64-53.3 0-66.1-49.6c-40.2-30.1-89-46.4-139.2-46.4c-57.7 0-113.4 21.5-156.1 60.3L10.5 328.3 0 337.8zM480 48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M448 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z']
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fasds',
    iconName: 'angle-up',
    icon: [
      448,
      512,
      [8963],
      'f106',
      
      ['M224 114.7l22.6 22.6 160 160L429.3 320 384 365.3l-22.6-22.6L224 205.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 160-160L224 114.7z','']
      
    ]
  };

  

  
  

  var faMessageMinus = {
    prefix: 'fasds',
    iconName: 'message-minus',
    icon: [
      512,
      512,
      ["comment-alt-minus"],
      'f4a7',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM160 184l0 48 24 0 144 0 24 0 0-48-24 0-144 0-24 0z','M160 184l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  
    var faCommentAltMinus = faMessageMinus;
  

  
  

  var faFill = {
    prefix: 'fasds',
    iconName: 'fill',
    icon: [
      512,
      512,
      [],
      'f575',
      
      ['M106.5 288L240 421.5 373.5 288l-267 0z','M0 272l45.3 45.3L194.7 466.7 240 512l45.3-45.3L466.7 285.3 512 240l-45.3-45.3L317.3 45.3 272 0 226.7 45.3l-60.1 60.1-80-80L64 2.7 18.7 48 41.4 70.6l80 80L45.3 226.7 0 272zm166.6-76.1l18.7 18.7L208 237.3 253.3 192l-22.6-22.6-18.7-18.7L272 90.5 421.5 240 240 421.5 90.5 272l76.1-76.1z']
      
    ]
  };

  

  
  

  var faGlassHalf = {
    prefix: 'fasds',
    iconName: 'glass-half',
    icon: [
      384,
      512,
      ["glass-half-empty","glass-half-full"],
      'e192',
      
      ['M0 0L5 64 40 512l304 0L379 64l5-64L319.8 0 64.2 0 0 0zM69.2 64l245.6 0c-4.2 53.3-8.3 106.7-12.5 160L284.8 448 99.2 448 81.7 224c-4.2-53.3-8.3-106.7-12.5-160z','M81.7 224L99.2 448l185.6 0 17.5-224L81.7 224z']
      
    ]
  };

  
    var faGlassHalfEmpty = faGlassHalf;
  
    var faGlassHalfFull = faGlassHalf;
  

  
  

  var faMessageCode = {
    prefix: 'fasds',
    iconName: 'message-code',
    icon: [
      512,
      512,
      [],
      'e1df',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM102.1 208l17 17 64 64 17 17L233.9 272l-17-17-47-47 47-47 17-17L200 110.1l-17 17-64 64-17 17zm176-64l17 17 47 47-47 47-17 17L312 305.9l17-17 64-64 17-17-17-17-64-64-17-17L278.1 144z','M233.9 144l-17 17-47 47 47 47 17 17L200 305.9l-17-17-64-64-17-17 17-17 64-64 17-17L233.9 144zM312 110.1l17 17 64 64 17 17-17 17-64 64-17 17L278.1 272l17-17 47-47-47-47-17-17L312 110.1z']
      
    ]
  };

  

  
  

  var faSchoolFlag = {
    prefix: 'fasds',
    iconName: 'school-flag',
    icon: [
      576,
      512,
      [],
      'e56e',
      
      ['M0 160l0 32L0 480l0 32 32 0 208 0 0-112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112 208 0 32 0 0-32 0-288 0-32-32 0-133.7 0L320.7 96l-.7 0c-21.3 0-42.7 0-64 0l-.7 0-89.6 64L32 160 0 160zm64 64c21.3 0 42.7 0 64 0l0 96c-21.3 0-42.7 0-64 0l0-96zm0 128l64 0 0 96-64 0 0-96zM336 240a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm112-16c21.3 0 42.7 0 64 0l0 96c-21.3 0-42.7 0-64 0l0-96zm0 128l64 0 0 96-64 0 0-96z','M320 96l-64 0 0-32 0-32 0-32 64 0 96 0 0 96-96 0zM64 224l64 0 0 96-64 0 0-96zm384 0l64 0 0 96-64 0 0-96zM128 352l0 96-64 0 0-96 64 0zm320 0l64 0 0 96-64 0 0-96z']
      
    ]
  };

  

  
  

  var faTablet = {
    prefix: 'fasds',
    iconName: 'tablet',
    icon: [
      448,
      512,
      ["tablet-android"],
      'f3fb',
      
      ['M0 384L0 512l448 0 0-128L0 384zm176 48l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32z','M0 0H448V384H0V0z']
      
    ]
  };

  
    var faTabletAndroid = faTablet;
  

  
  

  var faCommentQuote = {
    prefix: 'fasds',
    iconName: 'comment-quote',
    icon: [
      512,
      512,
      [],
      'e14c',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm128-96l112 0 0 40 0 24 0 48 0 56 0 24-24 0-48 0-24 0 0-48 24 0 24 0 0-32-64 0 0-112zm144 0l112 0 0 40 0 24 0 48 0 56 0 24-24 0-48 0-24 0 0-48 24 0 24 0 0-32-64 0 0-112z','M128 144l112 0 0 40 0 24 0 48 0 56 0 24-24 0-48 0-24 0 0-48 24 0 24 0 0-32-64 0 0-112zm144 0l112 0 0 40 0 24 0 48 0 56 0 24-24 0-48 0-24 0 0-48 24 0 24 0 0-32-64 0 0-112z']
      
    ]
  };

  

  
  

  var faCameraSlash = {
    prefix: 'fasds',
    iconName: 'camera-slash',
    icon: [
      640,
      512,
      [],
      'e0d9',
      
      ['M64 146.4L64 480l423.4 0L356.4 376.8c-11.2 4.6-23.5 7.2-36.4 7.2c-53 0-96-43-96-96c0-5 .4-9.9 1.1-14.6L64 146.4zM153 96L285.1 198.6c10.8-4.2 22.6-6.6 34.9-6.6c53 0 96 43 96 96c0 3.9-.2 7.8-.7 11.7c53.6 41.6 107.1 83.2 160.7 124.8L576 96 437.3 96 416 32 224 32 202.7 96 153 96z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faCloudBoltSun = {
    prefix: 'fasds',
    iconName: 'cloud-bolt-sun',
    icon: [
      640,
      512,
      ["thunderstorm-sun"],
      'f76e',
      
      ['M0 121.3L60.7 208 0 294.7 104 312l17.3 104L160 388.9l0-97.8c-28.7-16.6-48-47.6-48-83.2c0-53 43-96 96-96c18.4 0 35.6 5.2 50.2 14.1c11.9-19.9 29.1-36.2 49.6-47.2L294.7 0 208 60.7 121.3 0 104 104 0 121.3zM144 208c0 18.5 7.8 35.1 20.3 46.8c10.6-39.7 39.9-71.8 77.8-86.4c.8-4.3 1.8-8.5 3-12.6C234.7 148.4 221.8 144 208 144c-35.3 0-64 28.7-64 64zM288 360l0 24 88 0L336 512 512 376l0-24-88 0 40-128L288 360z','M639.9 383.9l-80 0-15.9 0 0-63.9-76.5 0 40-128-51 0L256 344.3l0 39.6-64 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80z']
      
    ]
  };

  
    var faThunderstormSun = faCloudBoltSun;
  

  
  

  var faBellSlash = {
    prefix: 'fasds',
    iconName: 'bell-slash',
    icon: [
      640,
      512,
      [61943,128277],
      'f1f6',
      
      ['M96 368l64-72 0-73.9L406.2 416 96 416l0-48zm89.5-246.7c23-35.5 59.6-61.4 102.5-70.1L288 0l64 0 0 51.2C425 66 480 130.6 480 208l0 88 64 72 0 31.6C424.5 306.8 305 214 185.5 121.3zM256 448l64 0 64 0c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faStoreLock = {
    prefix: 'fasds',
    iconName: 'store-lock',
    icon: [
      640,
      512,
      [],
      'e4a6',
      
      ['M48 146.5c0 36.5 24.7 71.4 64.2 76.7c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c19.4 0 37.1-6.3 51.5-16.7C456.8 178.7 490.2 160 528 160c21.4 0 41.3 6 58.3 16.4c8.9-22.7 7.7-49.8-6.7-72.6L512 0 128 0 60.3 103.8C51.9 117.1 48 131.9 48 146.5zM96 252.6L96 384l0 128 288 0 0-128-224 0 0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1c-4.2-.6-8.2-1.3-12.1-2.3z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faEyeDropperHalf = {
    prefix: 'fasds',
    iconName: 'eye-dropper-half',
    icon: [
      512,
      512,
      [],
      'e173',
      
      ['M0 472l40 40 5-4 22.7-18.1L80 480l88 0L333.4 314.6l-45.3-45.3c-16.9 16.9-33.8 33.8-50.6 50.6l-96 96L96 416l0-45.5c16.8-16.8 33.7-33.7 50.5-50.5c32-32 64.1-64.1 96.1-96.1l-45.3-45.3L32 344l0 88-9.9 12.3L4 467l-4 5z','M341.6 29.2L240.1 130.8l-9.4-9.4L208 98.7 162.7 144l22.6 22.6 160 160L368 349.3 413.3 304l-22.6-22.6-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM146.5 320L96 370.5 96 416l45.5 0 96-96-91 0z']
      
    ]
  };

  

  
  

  var faBezierCurve = {
    prefix: 'fasds',
    iconName: 'bezier-curve',
    icon: [
      640,
      512,
      [],
      'f55b',
      
      ['M0 112c0 35.3 28.7 64 64 64c25.3 0 47.2-14.7 57.6-36l66.9 0c-58.9 39.6-98.9 105-104 180l3.5 0 48 0 4.7 0c5.6-63.8 44.6-118.1 99.3-145.3l0-38.7 0-48 0-4L121.6 84C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112zM400 84l0 4 0 48 0 38.7c54.7 27.2 93.7 81.5 99.3 145.3l4.7 0 48 0 3.5 0c-5-75-45.1-140.4-104-180l66.9 0c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36L400 84z','M296 88l0 48 48 0 0-48-48 0zM240 32l56 0 48 0 56 0 0 56 0 48 0 56-56 0-48 0-56 0 0-56 0-48 0-56zM136 376l-48 0 0 48 48 0 0-48zM88 320l48 0 56 0 0 56 0 48 0 56-56 0-48 0-56 0 0-56 0-48 0-56 56 0zm464 56l-48 0 0 48 48 0 0-48zm-48-56l48 0 56 0 0 56 0 48 0 56-56 0-48 0-56 0 0-56 0-48 0-56 56 0z']
      
    ]
  };

  

  
  

  var faSignalStreamSlash = {
    prefix: 'fasds',
    iconName: 'signal-stream-slash',
    icon: [
      640,
      512,
      [],
      'e250',
      
      ['M0 256c0 67.4 23.2 129.4 61.9 178.5l50.2-39.7C82 356.6 64 308.5 64 256c0-33.4 7.3-65.1 20.4-93.5L33 122C11.9 162 0 207.7 0 256zm112 0c0 41.2 14.2 79.1 37.9 109.1l50.2-39.7C185 306.3 176 282.2 176 256c0-6.8 .6-13.5 1.8-19.9l-54.3-42.8C116.1 212.8 112 233.9 112 256zm175-56c18.5 14.4 37 28.8 55.6 43.1c-5.8-24.7-28-43.1-54.5-43.1l-1 0zm89-13.4C391 205.7 400 229.8 400 256c0 10-1.3 19.7-3.7 28.9l53.2 41.3c9.4-21.5 14.6-45.2 14.6-70.2c0-41.2-14.2-79.1-37.9-109.1l-50.2 39.7zm87.9-69.4C494 155.4 512 203.5 512 256c0 36.1-8.5 70.2-23.7 100.3c17.1 13.3 34.2 26.6 51.3 39.8C562.8 354.7 576 306.9 576 256c0-67.4-23.2-129.4-61.9-178.5l-50.2 39.7z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faFolderCheck = {
    prefix: 'fasds',
    iconName: 'folder-check',
    icon: [
      512,
      512,
      [],
      'e64e',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM127 289c11.3-11.3 22.6-22.6 33.9-33.9c21 21 42 42 63 63c42.3-42.3 84.7-84.7 127-127c11.3 11.3 22.6 22.6 33.9 33.9c-48 48-96 96-144 144c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-26.7-26.7-53.3-53.3-80-80z','M385 225L241 369l-17 17-17-17-80-80L161 255l63 63L351 191 385 225z']
      
    ]
  };

  

  
  

  var faSquareDivide = {
    prefix: 'fasds',
    iconName: 'square-divide',
    icon: [
      448,
      512,
      [],
      'e26a',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 232l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm80-104l64 0 0 64-64 0 0-64zm0 192l64 0 0 64-64 0 0-64z','M192 128l64 0 0 64-64 0 0-64zM112 232l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm144 88l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faSignHanging = {
    prefix: 'fasds',
    iconName: 'sign-hanging',
    icon: [
      512,
      512,
      ["sign"],
      'f4d9',
      
      ['M0 64l0 64 32 0 32 0 0 352 0 32 64 0 0-32 0-352 352 0 32 0 0-64-32 0L128 64l0-32 0-32L64 0l0 32 0 32L32 64 0 64z','M480 160l-320 0 0 224 320 0 0-224z']
      
    ]
  };

  
    var faSign = faSignHanging;
  

  
  

  var faVacuumRobot = {
    prefix: 'fasds',
    iconName: 'vacuum-robot',
    icon: [
      512,
      512,
      [],
      'e04e',
      
      ['M105.4 320c3.8 3.8 7.5 7.5 11.3 11.3c21.3 21.3 42.7 42.7 64 64c3.8 3.8 7.5 7.5 11.3 11.3c7.5-7.5 15.1-15.1 22.6-22.6l-11.3-11.3-64-64L128 297.4c-7.5 7.5-15.1 15.1-22.6 22.6zm16-80c3.8 3.8 7.5 7.5 11.3 11.3c42.7 42.7 85.3 85.3 128 128c3.8 3.8 7.5 7.5 11.3 11.3c7.5-7.5 15.1-15.1 22.6-22.6l-11.3-11.3-128-128L144 217.4c-7.5 7.5-15.1 15.1-22.6 22.6zm80-16c3.8 3.8 7.5 7.5 11.3 11.3c21.3 21.3 42.7 42.7 64 64c3.8 3.8 7.5 7.5 11.3 11.3c7.5-7.5 15.1-15.1 22.6-22.6l-11.3-11.3-64-64L224 201.4c-7.5 7.5-15.1 15.1-22.6 22.6z','M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM155.3 155.3c55.6-55.6 145.8-55.6 201.4 0s55.6 145.8 0 201.4l22.6 22.6c68.1-68.1 68.1-178.5 0-246.6s-178.5-68.1-246.6 0l22.6 22.6zm80 57.4L224 201.4 201.4 224l11.3 11.3 64 64L288 310.6 310.6 288l-11.3-11.3-64-64zm-80 16L144 217.4 121.4 240l11.3 11.3 128 128L272 390.6 294.6 368l-11.3-11.3-128-128zm-16 80L128 297.4 105.4 320l11.3 11.3 64 64L192 406.6 214.6 384l-11.3-11.3-64-64z']
      
    ]
  };

  

  
  

  var faAngle = {
    prefix: 'fasds',
    iconName: 'angle',
    icon: [
      448,
      512,
      [],
      'e08c',
      
      ['M215.9 216.1c22.5 17.9 42.3 38.9 58.8 62.5l40.8-25.3c-21.1-30.7-47.1-57.8-76.8-80.2l-22.8 43zm75.7 89.6c13.3 24.2 23.3 50.5 29.4 78.3l49 0c-7-37-19.8-71.9-37.6-103.7l-40.8 25.3z','M448 480L0 480l0-61.1L195.7 49l15-28.3 56.6 29.9L252.3 79 73.9 416 416 416l32 0 0 64z']
      
    ]
  };

  

  
  

  var faOliveBranch = {
    prefix: 'fasds',
    iconName: 'olive-branch',
    icon: [
      640,
      512,
      [],
      'e317',
      
      ['M192 320c0 106 64.5 192 144 192s144-86 144-192s-64.5-192-144-192s-144 86-144 192zM427.2 128.1c13.6 10.4 25.7 22.9 36.2 36.9C494 205.8 512 260.7 512 320c0 57.8-17.1 111.4-46.3 151.8c52.9 16.5 105.5 8.4 139.6-27c56.2-58.3 41-168.6-33.9-246.4c-42.9-44.5-96.1-68.7-144.2-70.3z','M128 0C48 0 0 64 0 64s31.2 36.4 85.2 50.5C34.5 141.4 0 194.6 0 256l0 16 0 16 16 0 16 0c86.6 0 157.1-68.7 159.9-154.6L373.4 48 616 48l24 0 0-48L616 0 368 0c-3.5 0-7 .8-10.2 2.3L247.4 54.2C230.3 36.3 188.2 0 128 0z']
      
    ]
  };

  

  
  

  var faPlugCircleMinus = {
    prefix: 'fasds',
    iconName: 'plug-circle-minus',
    icon: [
      576,
      512,
      [],
      'e55e',
      
      ['M0 160l32 0 320 0 32 0 0 38.6C310.1 219.5 256 287.4 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 99.2-64 0 0-99.2C87 398 32 333.4 32 256l0-32L0 224l0-64zM64 0l64 0 0 32 0 96-64 0 0-96L64 0zM256 0l64 0 0 32 0 96-64 0 0-96 0-32z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0-16 0 0-32 16 0 128 0 16 0 0 32-16 0z']
      
    ]
  };

  

  
  

  var faArrowTrendUp = {
    prefix: 'fasds',
    iconName: 'arrow-trend-up',
    icon: [
      576,
      512,
      [],
      'e098',
      
      ['M9.4 361.4l45.3 45.3L192 269.3 297.4 374.6 320 397.3l22.6-22.6L512 205.3l0-45.3-45.3 0L320 306.7 214.6 201.4 192 178.7l-22.6 22.6-160 160z','M352 96l32 0 160 0 32 0 0 32 0 160 0 32-64 0 0-32 0-128-128 0-32 0 0-64z']
      
    ]
  };

  

  
  

  var faStore = {
    prefix: 'fasds',
    iconName: 'store',
    icon: [
      576,
      512,
      [],
      'f54e',
      
      ['M64 219.1c2.5 1 5.2 1.8 7.9 2.5s5.5 1.2 8.4 1.6c4 .5 8.1 .8 12.1 .8c12.8 0 24.8-2.7 35.6-7.5L128 384l320 0 0-167.5c5.4 2.4 11.1 4.3 17 5.5c3 .6 6 1.1 9 1.4s6.2 .5 9.4 .5c4.1 0 8.1-.3 12.1-.8c5.8-.8 11.3-2.2 16.5-4.1L512 384l0 128L64 512l0-128 0-164.9z','M480 0l67.6 103.8c29.7 46.9 3.4 112-52.1 119.4c-4 .5-7.9 .8-12.1 .8c-26.1 0-49.2-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39 29-65.2 29c-26.1 0-49.3-11.4-65.2-29c-15.9 17.6-39.1 29-65.2 29c-4.1 0-8.2-.3-12.1-.8c-55.3-7.4-81.5-72.6-51.9-119.4L96 0 480 0z']
      
    ]
  };

  

  
  

  var faDisplayArrowDown = {
    prefix: 'fasds',
    iconName: 'display-arrow-down',
    icon: [
      576,
      512,
      [],
      'e164',
      
      ['M0 0L0 416l240 0 96 0 240 0L576 0 312 0l0 24 0 40 200 0 0 288L64 352 64 64l200 0 0-40 0-24L0 0z','M264 64L64 64l0 288 448 0 0-288L312 64l0 134.1 39-39 17-17L401.9 176l-17 17-80 80-17 17-17-17-80-80-17-17L208 142.1l17 17 39 39L264 64zm82.7 384L336 416l-96 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0-69.3 0z']
      
    ]
  };

  

  
  

  var faCircleGf = {
    prefix: 'fasds',
    iconName: 'circle-gf',
    icon: [
      512,
      512,
      [],
      'e67f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112-56c0-39.8 32.2-72 72-72s72 32.2 72 72l0 24-48 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8-24 0 0-48 24 0 24 0 24 0 0 24 0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112zm176-72l24 0 64 0 24 0 0 48-24 0-40 0 0 64 24 0 24 0 0 48-24 0-24 0 0 72 0 24-48 0 0-24 0-72 0-48 0-88 0-24z','M112 200c0-39.8 32.2-72 72-72s72 32.2 72 72l0 24-48 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8-24 0 0-48 24 0 24 0 24 0 0 24 0 32c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-112zm176-72l24 0 64 0 24 0 0 48-24 0-40 0 0 64 24 0 24 0 0 48-24 0-24 0 0 72 0 24-48 0 0-24 0-72 0-48 0-88 0-24z']
      
    ]
  };

  

  
  

  var faChartScatter = {
    prefix: 'fasds',
    iconName: 'chart-scatter',
    icon: [
      512,
      512,
      [],
      'f7ee',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M448 96l-64 0 0 64 64 0 0-64zM160 128l0 64 64 0 0-64-64 0zm32 160l-64 0 0 64 64 0 0-64zm128-64l-64 0 0 64 64 0 0-64zm32 128l64 0 0-64-64 0 0 64z']
      
    ]
  };

  

  
  

  var faFaceEyesXmarks = {
    prefix: 'fasds',
    iconName: 'face-eyes-xmarks',
    icon: [
      512,
      512,
      [],
      'e374',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM89.4 144c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c12.2 12.2 24.5 24.5 36.7 36.7c12.2-12.2 24.5-24.5 36.7-36.7c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-12.2 12.2-24.5 24.5-36.7 36.7c12.2 12.2 24.5 24.5 36.7 36.7c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3L160 214.6c-12.2 12.2-24.5 24.5-36.7 36.7c-3.8 3.8-7.5 7.5-11.3 11.3L89.4 240c3.8-3.8 7.5-7.5 11.3-11.3c12.2-12.2 24.5-24.5 36.7-36.7l-36.7-36.7L89.4 144zM176 384c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16-160 0 0-16zM281.4 144c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c12.2 12.2 24.5 24.5 36.7 36.7c12.2-12.2 24.5-24.5 36.7-36.7c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-12.2 12.2-24.5 24.5-36.7 36.7c12.2 12.2 24.5 24.5 36.7 36.7c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3c-12.2-12.2-24.5-24.5-36.7-36.7c-12.2 12.2-24.5 24.5-36.7 36.7c-3.8 3.8-7.5 7.5-11.3 11.3L281.4 240c3.8-3.8 7.5-7.5 11.3-11.3c12.2-12.2 24.5-24.5 36.7-36.7l-36.7-36.7L281.4 144z','M123.3 132.7L112 121.4 89.4 144l11.3 11.3L137.4 192l-36.7 36.7L89.4 240 112 262.6l11.3-11.3L160 214.6l36.7 36.7L208 262.6 230.6 240l-11.3-11.3L182.6 192l36.7-36.7L230.6 144 208 121.4l-11.3 11.3L160 169.4l-36.7-36.7zm192 0L304 121.4 281.4 144l11.3 11.3L329.4 192l-36.7 36.7L281.4 240 304 262.6l11.3-11.3L352 214.6l36.7 36.7L400 262.6 422.6 240l-11.3-11.3L374.6 192l36.7-36.7L422.6 144 400 121.4l-11.3 11.3L352 169.4l-36.7-36.7z']
      
    ]
  };

  

  
  

  var faPlanetMoon = {
    prefix: 'fasds',
    iconName: 'planet-moon',
    icon: [
      576,
      512,
      [],
      'e01f',
      
      ['M0 288C0 411.7 100.3 512 224 512s224-100.3 224-224c0-112.8-83.4-206.2-192-221.7c0 31.3 0 62.5 0 93.7c-26.7 32-53.3 64-80 96c10.7 10.7 21.3 21.3 32 32c37.3 0 74.7 0 112 0l0 64L264 456l-40 0c0-24 0-48 0-72l-32 0c0-21.3 0-42.7 0-64l-64-64c-26.7 0-53.3 0-80 0c-12.4-12.4-24.8-24.8-37.1-37.1C3.8 240.6 0 263.9 0 288z','M512 128A64 64 0 1 0 512 0a64 64 0 1 0 0 128zM224 64C124.4 64 40 129 10.9 218.9L48 256l80 0 64 64 0 64 32 0 0 72 40 0 56-104 0-64-112 0-32-32 80-96 0-93.7c-10.5-1.5-21.1-2.3-32-2.3z']
      
    ]
  };

  

  
  

  var faFolderMinus = {
    prefix: 'fasds',
    iconName: 'folder-minus',
    icon: [
      512,
      512,
      [],
      'f65d',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM160 272l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z','M160 272l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faFloppyDiskCircleArrowRight = {
    prefix: 'fasds',
    iconName: 'floppy-disk-circle-arrow-right',
    icon: [
      576,
      512,
      ["save-circle-arrow-right"],
      'e180',
      
      ['M0 32l32 0 288 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32.7c-5.3-.5-10.6-.7-16-.7c-75 0-139.1 47-164.4 113.1C256.1 294.5 240.8 288 224 288c-35.3 0-64 28.7-64 64s28.7 64 64 64c13.3 0 25.7-4.1 35.9-11c6 28.1 18.7 53.7 36.3 75L32 480 0 480l0-32L0 64 0 32zM64 96l0 128 256 0 0-128L64 96z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56L518.6 368l-11.3 11.3-56 56L440 446.6 417.4 424l11.3-11.3L457.4 384 368 384l-16 0 0-32 16 0 89.4 0-28.7-28.7L417.4 312 440 289.4l11.3 11.3z']
      
    ]
  };

  
    var faSaveCircleArrowRight = faFloppyDiskCircleArrowRight;
  

  
  

  var faPhotoFilm = {
    prefix: 'fasds',
    iconName: 'photo-film',
    icon: [
      640,
      512,
      ["photo-video"],
      'f87c',
      
      ['M192 0L640 0l0 352-128 0-160 0-160 0 0-160 0-64L192 0zm64 246.9c0 3 0 6.1 0 9.1c0 2.7 0 5.3 0 8c0 8 0 16 0 24l24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136L456 78.4l-19.6 27.8-57.3 81.2c-5.7-6.4-11.4-12.9-17.1-19.3L344 147.9c-6 6.7-12 13.4-17.9 20.2c-21.3 24-42.7 48-64 72l-6.1 6.8zM272 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M475.6 106.2l96 136 4.4 6.2 0 7.6 0 8 0 24-24 0-120 0-24 0-48 0-24 0-56 0-24 0 0-24 0-8 0-9.1 6.1-6.8 64-72L344 147.9l17.9 20.2 17.1 19.3 57.3-81.2L456 78.4l19.6 27.8zM0 128l192 0 0 64-32 0 0 256 192 0 0-96 160 0 0 160L0 512 0 128zm104 64l-48 0 0 48 48 0 0-48zm0 104l-48 0 0 48 48 0 0-48zm0 104l-48 0 0 48 48 0 0-48zm304 48l48 0 0-48-48 0 0 48z']
      
    ]
  };

  
    var faPhotoVideo = faPhotoFilm;
  

  
  

  var faVideoArrowDownLeft = {
    prefix: 'fasds',
    iconName: 'video-arrow-down-left',
    icon: [
      576,
      512,
      [],
      'e2c8',
      
      ['M0 64L0 448l384 0 0-133L384 197l0-133L0 64zM96 192l48 0 0 24 0 54.1L247 167l17-17L297.9 184l-17 17-103 103 54.1 0 24 0 0 48-24 0-112 0-24 0 0-24 0-112 0-24z','M576 448l0-384L384 197 384 315 576 448zM232 352l24 0 0-48-24 0-54.1 0L281 201l17-17L264 150.1l-17 17-103 103 0-54.1 0-24-48 0 0 24 0 112 0 24 24 0 112 0z']
      
    ]
  };

  

  
  

  var faCandleHolder = {
    prefix: 'fasds',
    iconName: 'candle-holder',
    icon: [
      448,
      512,
      [128367],
      'f6bc',
      
      ['M0 464l0 48 24 0 352 0c39.8 0 72-32.2 72-72s-32.2-72-72-72s-72 32.2-72 72c0 8.4 1.4 16.5 4.1 24L256 464 64 464l-40 0L0 464zM80 112c0 44.2 35.8 80 80 80s80-35.8 80-80C240 64 160 0 160 0s-80 64-80 112zM400 440a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M128 224l-64 0 0 240 192 0 0-240-96 0 0 48 0 16-32 0 0-16 0-48z']
      
    ]
  };

  

  
  

  var faClockTen = {
    prefix: 'fasds',
    iconName: 'clock-ten',
    icon: [
      512,
      512,
      [],
      'e354',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm126.7-57.3l26.6-39.9 20 13.3L232 211.2l0-91.2 0-24 48 0 0 24 0 136 0 44.8L242.7 276l-96-64-20-13.3z','M232 96l0 24 0 91.2L173.3 172l-20-13.3-26.6 39.9 20 13.3 96 64L280 300.8l0-44.8 0-136 0-24-48 0z']
      
    ]
  };

  

  
  

  var faSirenOn = {
    prefix: 'fasds',
    iconName: 'siren-on',
    icon: [
      640,
      512,
      [],
      'e02e',
      
      ['M144 352L176 96l288 0 32 256-261.9 0 21.8-174 2.2-18-32.2 0-1.8 14L201.9 352 144 352z','M69.3 36l-20-13.3L22.7 62.7 42.7 76l48 32 20 13.3 26.6-39.9L117.3 68l-48-32zM597.3 76l20-13.3L590.7 22.7 570.7 36l-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM24 192L0 192l0 48 24 0 64 0 24 0 0-48-24 0-64 0zm528 0l-24 0 0 48 24 0 64 0 24 0 0-48-24 0-64 0zm-8 160L96 352l0 128 448 0 0-128z']
      
    ]
  };

  

  
  

  var faRocket = {
    prefix: 'fasds',
    iconName: 'rocket',
    icon: [
      512,
      512,
      [],
      'f135',
      
      ['M0 287.6L80 128l120 0c-26.5 43.8-53.3 112.6-70.2 159.9L0 287.6zm224 93.1c47.7-16.5 116.3-42.5 160-68.8l0 120L224 512l0-131.2z','M170.1 398.4l-58.2-58.2s49.4-155.9 95.3-223.5C296.6-15.1 433.7-7.9 502.7 9.3c17.2 68.9 24.5 206-107.4 295.4c-67.9 46-225.2 93.7-225.2 93.7zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z']
      
    ]
  };

  

  
  

  var faClockEleven = {
    prefix: 'fasds',
    iconName: 'clock-eleven',
    icon: [
      512,
      512,
      [],
      'e347',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM158.7 153.3l39.9-26.6 13.3 20 20 30 0-56.7 0-24 48 0 0 24 0 136-44 13.3-64-96-13.3-20z','M232 96l0 24 0 56.7-20-30-13.3-20-39.9 26.6 13.3 20 64 96L280 256l0-136 0-24-48 0z']
      
    ]
  };

  

  
  

  var faLassoSparkles = {
    prefix: 'fasds',
    iconName: 'lasso-sparkles',
    icon: [
      576,
      512,
      [],
      'e1c9',
      
      ['M0 176c0 56 42.8 105.9 109.6 138.2c1.3 .9 2.7 1.7 4.1 2.5L160.5 340c19.3 9.7 31.5 29.4 31.5 51c0 31.5-25.5 57-57 57l-71 0-32 0 0 64 32 0 71 0c66.8 0 121-54.2 121-121c0-14.1-2.4-27.8-7-40.6c12.8 1.1 25.8 1.6 39 1.6c159.1 0 288-78.8 288-176C576 88.3 471.1 15.6 333.8 2.2l26.7 53.3 61.2 30.6c17.5 6.5 33 14.3 46 23l5.7 2.9-.9 .5C497.4 130.5 512 152.4 512 176c0 61.9-100.3 112-224 112S64 237.9 64 176c0-50 65.6-92.4 156.1-106.8l27.4-13.7L275.2 .2C122.1 4.3 0 81.4 0 176z','M304 32L277.3 85.3 224 112l53.3 26.7L304 192l26.7-53.3L384 112 330.7 85.3 304 32zM496 352l-26.7 53.3L416 432l53.3 26.7L496 512l26.7-53.3L576 432l-53.3-26.7L496 352z']
      
    ]
  };

  

  
  

  var faFaceDisappointed = {
    prefix: 'fasds',
    iconName: 'face-disappointed',
    icon: [
      512,
      512,
      [],
      'e36f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm93.6 34.8l15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c3.8-3.8 7.5-7.5 11.3-11.3L222.6 256c-3.8 3.8-7.5 7.5-11.3 11.3c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-5.3 .9-10.5 1.8-15.8 2.6c-1.8-10.5-3.5-21-5.3-31.6zm67.8 110.3l10.7-11.9C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4zM289.4 256L312 233.4c3.8 3.8 7.5 7.5 11.3 11.3c2.5 2.5 4.9 4.9 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7c.8 .1 1.7 .3 2.5 .4c5.3 .9 10.5 1.8 15.8 2.6l-5.3 31.6c-5.3-.9-10.5-1.8-15.8-2.6c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-3.8-3.8-7.5-7.5-11.3-11.3z','M211.3 267.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 233.4 222.6 256l-11.3 11.3zm89.4 0L289.4 256 312 233.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z']
      
    ]
  };

  

  
  

  var faFileCircleInfo = {
    prefix: 'fasds',
    iconName: 'file-circle-info',
    icon: [
      576,
      512,
      [58604],
      'e493',
      
      ['M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0z','M384 160L224 0l0 160 160 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm15.3-224l0 32-32 0 0-32 32 0zm1.2 64l0 16 0 64 15.5 0 0 32-15.5 0-.5 0-32 0-16 0 0-32 16 0 .5 0 0-48-.5 0-16 0 0-32 16 0 16.5 0 16 0z']
      
    ]
  };

  

  
  

  var faArrowLeftFromArc = {
    prefix: 'fasds',
    iconName: 'arrow-left-from-arc',
    icon: [
      512,
      512,
      [],
      'e615',
      
      ['M221.3 0l0 64 32 0c106 0 192 86 192 192s-86 192-192 192l-32 0 0 64 32 0c141.4 0 256-114.6 256-256s-114.6-256-256-256l-32 0z','M157.3 98.7l-22.6 22.6-112 112L0 256l22.6 22.6 112 112 22.6 22.6L202.5 368l-22.6-22.6L122.5 288l194.7 0 32 0 0-64-32 0-194.7 0 57.4-57.4L202.5 144 157.3 98.7z']
      
    ]
  };

  

  
  

  var faMap = {
    prefix: 'fasds',
    iconName: 'map',
    icon: [
      576,
      512,
      [62072,128506],
      'f279',
      
      ['M192 32l0 384 192 64 0-384L192 32z','M0 480L0 96 192 32l0 384L0 480zm384 0l0-384L576 32l0 384L384 480z']
      
    ]
  };

  

  
  

  var faUserHairLong = {
    prefix: 'fasds',
    iconName: 'user-hair-long',
    icon: [
      448,
      512,
      [],
      'e45b',
      
      ['M128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-11.2-1.9-22-5.5-32L256 96 240 80l-32 32-78.7 0c-.9 5.2-1.3 10.5-1.3 16z','M320 144c0 53-43 96-96 96s-96-43-96-96l0-16c0-5.5 .5-10.8 1.3-16l78.7 0 32-32 16 16 58.5 0c3.5 10 5.5 20.8 5.5 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16 0 48L48 240l0 32 176 0 176 0 0-32-48-48 0-48 0-16C352 57.3 294.7 0 224 0zM448 512L384 320 64 320 0 512l448 0z']
      
    ]
  };

  

  
  

  var faAxeBattle = {
    prefix: 'fasds',
    iconName: 'axe-battle',
    icon: [
      512,
      512,
      [],
      'f6b3',
      
      ['M0 192C0 320 88 384 88 384s33.2-106.3 136-125.2l0-133.7C121.2 106.3 88 0 88 0S0 64 0 192zm288-66.8l0 133.7C390.8 277.7 424 384 424 384s73.7-53.6 86.2-160.9L448 192l62.2-31.1C497.7 53.6 424 0 424 0s-33.2 106.3-136 125.2z','M288 64l0-32-64 0 0 32 0 416 0 32 64 0 0-32 0-416z']
      
    ]
  };

  

  
  

  var faCars = {
    prefix: 'fasds',
    iconName: 'cars',
    icon: [
      640,
      512,
      [],
      'f85b',
      
      ['M0 128L0 288c0 21.3 0 42.7 0 64l80 0 0-64 112 0 0-32 32 0 7.2 0 28.1-84.2 7.3-21.9 7.3-21.9L97.7 128l21.3-64 177.9 0 21.3 64 1.7 0 65.7 0L350.4 21.9 343.1 0 320 0 96 0 72.9 0 65.6 21.9 30.3 128 0 128zm104 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M320 160l-23.1 0-7.3 21.9L254.3 288 224 288l0 160s0 0 0 0l0 64 80 0 0-64 256 0 0 64 80 0 0-64s0 0 0 0l0-160-30.3 0L574.4 181.9 567.1 160 544 160l-224 0zM542.3 288l-220.5 0 21.3-64 177.9 0 21.3 64zM280 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faShekelSign = {
    prefix: 'fasds',
    iconName: 'shekel-sign',
    icon: [
      448,
      512,
      [8362,"ils","shekel","sheqel","sheqel-sign"],
      'f20b',
      
      ['M128 160l0 288 0 32 32 0 160 0c70.7 0 128-57.3 128-128l0-320-64 0 0 320c0 35.3-28.7 64-64 64l-128 0 0-256-64 0z','M0 32l32 0 160 0c70.7 0 128 57.3 128 128l0 192-64 0 0-192c0-35.3-28.7-64-64-64L64 96l0 384L0 480 0 64 0 32z']
      
    ]
  };

  
    var faIls = faShekelSign;
  
    var faShekel = faShekelSign;
  
    var faSheqel = faShekelSign;
  
    var faSheqelSign = faShekelSign;
  

  
  

  var faTally2 = {
    prefix: 'fasds',
    iconName: 'tally-2',
    icon: [
      640,
      512,
      [],
      'e295',
      
      ['M96 32l0 32 0 384 0 32 64 0 0-32 0-384 0-32L96 32z','M288 32l0 32 0 384 0 32-64 0 0-32 0-384 0-32 64 0z']
      
    ]
  };

  

  
  

  var faTeeth = {
    prefix: 'fasds',
    iconName: 'teeth',
    icon: [
      576,
      512,
      [],
      'f62e',
      
      ['M48 208l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 80l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0zM176 176l0 80 96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 112l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0zM304 176l0 80 96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 112l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0zm128-80l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 80l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0z','M0 32l576 0 0 448L0 480 0 32zM176 176l0 80 96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48l0 80 96 0 0-80c0-26.5-21.5-48-48-48zM48 208l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48l0-48-96 0 0 48c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0 0 48zm176 48c26.5 0 48-21.5 48-48l0-48-96 0 0 48c0 26.5 21.5 48 48 48zm80-176l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48l0-48-96 0 0 48c0 26.5 21.5 48 48 48z']
      
    ]
  };

  

  
  

  var faBlender = {
    prefix: 'fasds',
    iconName: 'blender',
    icon: [
      512,
      512,
      [],
      'f517',
      
      ['M0 0L0 32 0 224l0 32 32 0 117.3 0L160 384l256 0 24-96-104 0-16 0 0-32 16 0 112 0 16-64-128 0-16 0 0-32 16 0 136 0 16-64L336 96l-16 0 0-32 16 0 160 0L512 0 160 0 128 0 32 0 0 0zM64 64l69.3 0L144 192l-80 0L64 64z','M336 64l160 0-8 32L336 96l-16 0 0-32 16 0zm0 96l136 0-8 32-128 0-16 0 0-32 16 0zm0 96l112 0-8 32-104 0-16 0 0-32 16 0zM96 384l384 0 0 128L96 512l0-128zm224 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z']
      
    ]
  };

  

  
  

  var faWrenchSimple = {
    prefix: 'fasds',
    iconName: 'wrench-simple',
    icon: [
      384,
      512,
      [],
      'e2d1',
      
      ['M96 342.3c14.1 8.2 29.4 14.6 45.5 19c8 2.2 16.3 3.9 24.7 5c4.2 .6 8.5 1 12.8 1.3c2.1 .1 4.3 .3 6.5 .3s4.3 .1 6.5 .1c35 0 67.8-9.4 96-25.7L288 512 96 512l0-169.7z','M192 224l-64-64V0C53.4 26.4 0 92.4 0 176C0 282 86 368 192 368s192-86 192-192C384 92.4 330.6 26.4 256 0V160l-64 64z']
      
    ]
  };

  

  
  

  var faPeanut = {
    prefix: 'fasds',
    iconName: 'peanut',
    icon: [
      512,
      512,
      [],
      'e430',
      
      ['M0 364L0 512l148 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C495.6 225.4 512 188.6 512 148L512 0 364 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C245 57.8 234.4 74 227.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364zm146.8 55.9a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zm64-64a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zm0 64a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zM371.2 192a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm64-64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm0 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0z','M416 147.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0 64a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-64 0a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm-224 224a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM211.2 416a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0zm0-64a19.2 19.2 0 1 0 -38.4 0 19.2 19.2 0 1 0 38.4 0z']
      
    ]
  };

  

  
  

  var faBuildingMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'building-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e61c',
      
      ['M0 0L384 0l0 173.3c-25.5 11.1-47.5 28.7-64 50.7l-64 0 0 64 35.2 0c-2.1 10.3-3.2 21-3.2 32c0 65.6 39.5 122 96 146.7l0 45.3-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0z','M528 320.2a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM520 426c-20.5 14-45.3 22.1-72 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426z']
      
    ]
  };

  

  
  

  var faCakeSlice = {
    prefix: 'fasds',
    iconName: 'cake-slice',
    icon: [
      512,
      512,
      [127856,"shortcake"],
      'e3e5',
      
      ['M0 288l0 80 448 0 0-80L0 288zM0 400l0 80 448 0 0-80L0 400z','M284.9 32L296 32c44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256l0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .7 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .6 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .5 0 .4 0 .5 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .4 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .3 0 .2 0 .3 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .2 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1 0 .1c0 0 0 .1 0 .1l0 .1 0 .1c0 0 0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 .1 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1s0 0 0 .1l0 32-32 0-32 0 0-192L0 288l0-16 0-15.5 12.2-9.6 264-208 8.7-6.9z']
      
    ]
  };

  
    var faShortcake = faCakeSlice;
  

  
  

  var faEquals = {
    prefix: 'fasds',
    iconName: 'equals',
    icon: [
      448,
      512,
      [62764],
      '3d',
      
      ['M48 128l-32 0 0 64 32 0 352 0 32 0 0-64-32 0L48 128zm0 192l-32 0 0 64 32 0 352 0 32 0 0-64-32 0L48 320z','']
      
    ]
  };

  

  
  

  var faH2 = {
    prefix: 'fasds',
    iconName: 'h2',
    icon: [
      640,
      512,
      [],
      'f314',
      
      ['M0 64L0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 61.7 0 2.3-2.1 0-29.9 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96l0-32L0 64z','M449.9 143.4c11.6-9.9 26.4-15.4 41.7-15.4l4.5 0c35.3 0 64 28.7 64 64l0 5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4 368 401.9l0 46.1 32 0 208 0 32 0 0-64-32 0-125.7 0 100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4l0-5.8c0-70.7-57.3-128-128-128l-4.5 0c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9-24.3 20.8 41.6 48.6 24.3-20.8 29-24.9zM320 448l0-2.1-2.3 2.1 2.3 0z']
      
    ]
  };

  

  
  

  var faArrowRightFromLine = {
    prefix: 'fasds',
    iconName: 'arrow-right-from-line',
    icon: [
      448,
      512,
      [8614,"arrow-from-left"],
      'f343',
      
      ['M0 65.4l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M445.3 257.4L422.6 280l-128 128L272 430.6l-45.3-45.3 22.6-22.6 73.4-73.4-162.7 0-32 0 0-64 32 0 162.7 0L249.4 152l-22.6-22.6L272 84.1l22.6 22.6 128 128 22.6 22.6z']
      
    ]
  };

  
    var faArrowFromLeft = faArrowRightFromLine;
  

  
  

  var faIslandTropical = {
    prefix: 'fasds',
    iconName: 'island-tropical',
    icon: [
      512,
      512,
      [127965,"island-tree-palm"],
      'f811',
      
      ['M224 352l64 0c1 0 2 0 3 0s2 .1 3 .1c2 .1 3.9 .2 5.9 .4c3.9 .4 7.7 .9 11.5 1.6c11.3-55.9 18.2-146.2-9.9-226.1l-24.7 0c-10 10-20 20-30 30c6.6 43.1 6.9 114.7-22.8 194z','M62.2 96L112 96l32-32 30.6 30.6c-1.4 1.3-2.7 2.6-4.1 3.9c-63.4 63.4-48.1 132.9-22.6 158.4L276.8 128 384 128l32-32 32 32 64 0c0-36-38.4-96-128-96c-33.8 0-60.4 8.6-80.3 21.2C285.2 25.5 248.6 0 190.2 0c-89.6 0-128 60-128 96zM160 352C89.3 352 32 409.3 32 480l0 32 384 0 0-32c0-70.7-57.3-128-128-128l-128 0z']
      
    ]
  };

  
    var faIslandTreePalm = faIslandTropical;
  

  
  

  var faBracketSquare = {
    prefix: 'fasds',
    iconName: 'bracket-square',
    icon: [
      192,
      512,
      ["bracket","bracket-left"],
      '5b',
      
      ['M0 32l32 0 96 0 32 0 0 64-32 0L64 96l0 320 64 0 32 0 0 64-32 0-96 0L0 480l0-32L0 64 0 32z','']
      
    ]
  };

  
    var faBracket = faBracketSquare;
  
    var faBracketLeft = faBracketSquare;
  

  
  

  var faHighlighterLine = {
    prefix: 'fasds',
    iconName: 'highlighter-line',
    icon: [
      576,
      512,
      [],
      'e1af',
      
      ['M48 400c4.2 4.2 8.5 8.5 12.7 12.7l70.6 70.6c4.2 4.2 8.5 8.5 12.7 12.7l80-80 96 0 40.1-55.9L183.9 183.9 128 224l0 96c-26.7 26.7-53.3 53.3-80 80zm176 64l0 48 24 0 304 0 24 0 0-48-24 0-304 0-24 0z','M544 104L360.1 360.1 183.9 183.9 440 0 544 104zM4.7 468.7l56-56 70.6 70.6-24 24-4.7 4.7L96 512l-80 0L0 512l0-16 0-16 0-6.6 4.7-4.7z']
      
    ]
  };

  

  
  

  var faFlaskGear = {
    prefix: 'fasds',
    iconName: 'flask-gear',
    icon: [
      640,
      512,
      [],
      'e5f1',
      
      ['M0 422.9L0 432l0 48 0 32 32 0 328 0 0-18.2L289.9 372.5 325.5 352l-206.7 0 68.4-111.2 4.7-7.7 0-9.1 0-160 64 0 0 160 0 9.1 4.7 7.7 41.9 68.1 36.4-63-19-30.9L320 64l32 0 0-64L320 0 288 0 160 0 128 0 96 0l0 64 32 0 0 150.9L4.7 415.2 0 422.9z','M524.1 206.4l-88.1 0 0 42.2c-8 3.4-15.6 7.8-22.5 12.9l-34.9-20.2-44.9 77.8 34.9 20.2c-.4 4.1-.7 8.2-.7 12.4s.2 8.3 .7 12.4l-34.9 20.1 45 77.8 34.9-20.1c6.9 5.1 14.5 9.4 22.5 12.9l0 42.2 88.1 0 0-42.4c7.9-3.4 15.4-7.7 22.3-12.8l35 20.2 45-77.8L591.2 364c.4-4 .7-8.1 .7-12.3s-.2-8.2-.7-12.3l35.2-20.3-45-77.8-35 20.2c-6.9-5.1-14.3-9.4-22.3-12.8l0-42.4zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faCopyright = {
    prefix: 'fasds',
    iconName: 'copyright',
    icon: [
      512,
      512,
      [169],
      'f1f9',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-70.7 57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L324 213.8c-14.2-22.8-39.3-37.8-68-37.8c-44.2 0-80 35.8-80 80s35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C342.2 359.8 301.9 384 256 384c-70.7 0-128-57.3-128-128z','M256 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C342.2 359.8 301.9 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L324 213.8c-14.2-22.8-39.3-37.8-68-37.8z']
      
    ]
  };

  

  
  

  var faSymbols = {
    prefix: 'fasds',
    iconName: 'symbols',
    icon: [
      512,
      512,
      [128291,"icons-alt"],
      'f86e',
      
      ['M0 0L0 64l32 0 160 0 32 0 0-64L192 0 32 0 0 0zM0 96l0 64 32 0 48 0 0 32 0 32 64 0 0-32 0-32 48 0 32 0 0-64-32 0-48 0L80 96 32 96 0 96zM288 328a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm.2 138.6l45.3 45.3 22.6-22.6 128-128 22.6-22.6-45.3-45.3-22.6 22.6-128 128-22.6 22.6zM432 472a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M512 40l0-39L473.7 8.6l-160 32L288 45.8 288 72l0 88c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-109.8L448 79l0 49c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-136zM16 320c0 17.9 6.5 34.3 17.4 46.9L20.3 381.3C7.2 395.7 0 414.4 0 433.8l0 .9L0 480l0 32 32 0 80 0 14.2 0 9.5-10.6 15.5-17.2 4 4.2 21.9 23.3 46.6-43.9-21.9-23.3-7.5-8 16-17.7 21.4-23.7-47.5-42.9L162.8 376l-12.5 13.9-14.8-15.7C150.5 361 160 341.6 160 320l0-72-72 0-72 0 0 72zM67.7 424.3L81 409.7l26.2 27.9L97.8 448 64 448l0-13.3 0-.9c0-3.5 1.3-6.9 3.7-9.5zM88 336c-8.8 0-16-7.2-16-16l0-16 32 0 0 16c0 8.8-7.2 16-16 16z']
      
    ]
  };

  
    var faIconsAlt = faSymbols;
  

  
  

  var faRulerCombined = {
    prefix: 'fasds',
    iconName: 'ruler-combined',
    icon: [
      512,
      512,
      [],
      'f546',
      
      ['M0 0L0 320 0 512l192 0 320 0 0-192-96 0 0 80 0 16-32 0 0-16 0-80-64 0 0 80 0 16-32 0 0-16 0-80-64 0 0 80 0 16-32 0 0-16 0-80-80 0-16 0 0-32 16 0 80 0 0-64-80 0-16 0 0-32 16 0 80 0 0-64-80 0-16 0 0-32 16 0 80 0 0-96L0 0z','M112 96L96 96l0 32 16 0 80 0 0-32-80 0zm80 96l-80 0-16 0 0 32 16 0 80 0 0-32zm0 96l-80 0-16 0 0 32 16 0 80 0 0 80 0 16 32 0 0-16 0-80-32 0 0-32zm128 32l-32 0 0 80 0 16 32 0 0-16 0-80zm96 80l0-80-32 0 0 80 0 16 32 0 0-16z']
      
    ]
  };

  

  
  

  var faSquareQ = {
    prefix: 'fasds',
    iconName: 'square-q',
    icon: [
      448,
      512,
      [],
      'e27b',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 256c0-70.7 57.3-128 128-128s128 57.3 128 128c0 28.1-9 54-24.4 75.1L369.9 384l-61.5 0-15.9-19.9C272.7 376.7 249.2 384 224 384c-70.7 0-128-57.3-128-128zm48 0c0 44.2 35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L206.1 256l61.5 0 28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3c0-44.2-35.8-80-80-80s-80 35.8-80 80z','M144 256c0 44.2 35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L206.1 256l61.5 0 28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3c0-44.2-35.8-80-80-80s-80 35.8-80 80zM292.6 364.1C272.7 376.7 249.2 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 28.1-9 54-24.4 75.1L369.9 384l-61.5 0-15.9-19.9z']
      
    ]
  };

  

  
  

  var faLinesLeaning = {
    prefix: 'fasds',
    iconName: 'lines-leaning',
    icon: [
      384,
      512,
      [],
      'e51e',
      
      ['M-.1 469L61 488.1l9.5-30.5 120-384L200.1 43 139 23.9l-9.5 30.5-120 384L-.1 469zM320 32l0 32 0 384 0 32 64 0 0-32 0-384 0-32-64 0z','M292.8 37.7l-5.3 31.6-64 384-5.3 31.6-63.1-10.5 5.3-31.6 64-384 5.3-31.6 63.1 10.5z']
      
    ]
  };

  

  
  

  var faArrowDownToBracket = {
    prefix: 'fasds',
    iconName: 'arrow-down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e094',
      
      ['M0 320l0 32L0 480l0 32 32 0 384 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448l0-96 0-32L0 320z','M224 365.3l22.6-22.6 128-128L397.3 192 352 146.7l-22.6 22.6L256 242.7 256 32l0-32L192 0l0 32 0 210.7-73.4-73.4L96 146.7 50.7 192l22.6 22.6 128 128L224 365.3z']
      
    ]
  };

  

  
  

  var faArrowDownUpLock = {
    prefix: 'fasds',
    iconName: 'arrow-down-up-lock',
    icon: [
      640,
      512,
      [],
      'e4b0',
      
      ['M0 224l0 64 32 0 64 0 0 98.7L70.6 361.4 48 338.7 2.7 384l22.6 22.6 80 80L128 509.3l22.6-22.6 80-80L253.3 384 208 338.7l-22.6 22.6L160 386.7l0-98.7 224 0 32 0 0-16c0-17.2 3.9-33.5 10.8-48L352 224l0-98.7 25.4 25.4L400 173.3 445.3 128l-22.6-22.6-80-80L320 2.7 297.4 25.4l-80 80L194.7 128 240 173.3l22.6-22.6L288 125.3l0 98.7-128 0-64 0-64 0L0 224zM96 32l0 32 0 128 64 0 0-128 0-32L96 32zM288 320l0 128 0 32 64 0 0-32 0-128-64 0z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faTrashArrowUp = {
    prefix: 'fasds',
    iconName: 'trash-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore"],
      'f829',
      
      ['M32 96L56 512l336 0L416 96 32 96zm78.1 168l17-17 80-80 17-17 17 17 80 80 17 17L304 297.9l-17-17-39-39L248 376l0 24-48 0 0-24 0-134.1-39 39-17 17L110.1 264z','M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zm97 167l-17-17-17 17-80 80-17 17L144 297.9l17-17 39-39L200 376l0 24 48 0 0-24 0-134.1 39 39 17 17L337.9 264l-17-17-80-80z']
      
    ]
  };

  
    var faTrashRestore = faTrashArrowUp;
  

  
  

  var faKeySkeleton = {
    prefix: 'fasds',
    iconName: 'key-skeleton',
    icon: [
      448,
      512,
      [128477],
      'f6f3',
      
      ['M2.7 400l22.6 22.6 64 64L112 509.3 157.3 464l-22.6-22.6L93.3 400 112 381.3l41.4 41.4L176 445.3 221.3 400l-22.6-22.6L157.3 336l70.1-70.1c-18.3-11.5-33.8-27-45.3-45.3L25.4 377.4 2.7 400z','M304 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 224A144 144 0 1 0 304 0a144 144 0 1 0 0 288z']
      
    ]
  };

  

  
  

  var faDownFromBracket = {
    prefix: 'fasds',
    iconName: 'down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e66b',
      
      ['M0 0L0 32 0 160l0 32 64 0 0-32 0-96 320 0 0 96 0 32 64 0 0-32 0-128 0-32L416 0 32 0 0 0z','M224 512L384 352l0-32-96 0 0-160-128 0 0 160-96 0 0 32L224 512z']
      
    ]
  };

  

  
  

  var faTractor = {
    prefix: 'fasds',
    iconName: 'tractor',
    icon: [
      640,
      512,
      [128668],
      'f722',
      
      ['M0 288l0 96 40.2 0c1.7 4.8 3.7 9.5 5.8 14.1L17.6 426.5l67.9 67.9L113.9 466c4.6 2.2 9.3 4.1 14.1 5.8l0 40.2 96 0 0-40.2c4.8-1.7 9.5-3.7 14.1-5.8l28.4 28.4 67.9-67.9L306 398.1c2.2-4.6 4.1-9.3 5.8-14.1l40.2 0 0-32 0-64-40.2 0c-1.7-4.8-3.7-9.5-5.8-14.1l28.4-28.4-67.9-67.9L238.1 206c-4.6-2.2-9.3-4.1-14.1-5.8l0-40.2-64 0-32 0 0 40.2c-4.8 1.7-9.5 3.7-14.1 5.8L96 188.1 85.5 177.6 17.6 245.5 46 273.9c-2.2 4.6-4.1 9.3-5.8 14.1L0 288zm256 48A80 80 0 1 1 96 336a80 80 0 1 1 160 0zm184 88a88 88 0 1 0 176 0 88 88 0 1 0 -176 0zm112 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M128 0L96 0l0 32 0 128 0 28.1L113.9 206c4.6-2.2 9.3-4.1 14.1-5.8l0-40.2 32 0 0-96 106.3 0 38.4 96L224 160l0 40.2c4.8 1.7 9.5 3.7 14.1 5.8l28.4-28.4 67.9 67.9L306 273.9c2.2 4.6 4.1 9.3 5.8 14.1l40.2 0 0 64 80 0c21.9-29.1 56.7-48 96-48c16.3 0 31.9 3.3 46.1 9.2L640 272l0-112-96 0 0-56.4 12.6-25.2 14.3-28.6L513.7 21.1 499.4 49.7l-16 32L480 88.4l0 7.6 0 64-106.3 0-56-139.9L309.7 0 288 0 128 0z']
      
    ]
  };

  

  
  

  var faQuoteLeft = {
    prefix: 'fasds',
    iconName: 'quote-left',
    icon: [
      448,
      512,
      [8220,"quote-left-alt"],
      'f10d',
      
      ['M256 216l0 8 0 96 0 96 192 0 0-192-128 0 0-8c0-30.9 25.1-56 56-56l8 0 32 0 0-64-32 0-8 0c-66.3 0-120 53.7-120 120z','M120 96C53.7 96 0 149.7 0 216l0 8 0 96 0 96 192 0 0-192L64 224l0-8c0-30.9 25.1-56 56-56l8 0 32 0 0-64-32 0-8 0z']
      
    ]
  };

  
    var faQuoteLeftAlt = faQuoteLeft;
  

  
  

  var faUsersLine = {
    prefix: 'fasds',
    iconName: 'users-line',
    icon: [
      640,
      512,
      [],
      'e592',
      
      ['M32 288l135.4 0 28.2-75.2 7.8-20.8L64 192 32 288zM83.2 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm94.4 256l288 0-24-64-24-64-12.3 0-170.7 0-9.1 0-24 64-24 64zm64-240a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM435.2 96a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm4.6 96l7.8 20.8L475.8 288 608 288l-32-96-136.2 0z','M0 416l32 0 576 0 32 0 0 64-32 0L32 480 0 480l0-64z']
      
    ]
  };

  

  
  

  var faBaby = {
    prefix: 'fasds',
    iconName: 'baby',
    icon: [
      448,
      512,
      [],
      'f77c',
      
      ['M16.1 176.8l32.3 23.5L128 258.2l0 29.8 35.8 0 .9 0 118.5 0 .9 0 35.8 0 0-29.8 79.5-57.8 32.3-23.5-47.1-64.7-32.3 23.5L275 192l-102 0L95.5 135.7 63.2 112.1 16.1 176.8zM59 407.8l22.7 26.3 40 46.4 26.1 30.3 60.6-52.2-26.1-30.3L165 408.2l23.7-27.1c-20.1-17.6-40.1-35.1-60.2-52.7L81.9 381.7 59 407.8zM152 88a72 72 0 1 0 144 0A72 72 0 1 0 152 88zm87.6 370.6l60.6 52.2 26.1-30.3 40-46.4L389 407.8l-22.9-26.1-46.6-53.2c-20.1 17.6-40.1 35.1-60.2 52.7L283 408.2l-17.3 20.1-26.1 30.3z','M192 384l-64-56V288H320v40l-64 56H192z']
      
    ]
  };

  

  
  

  var faCirclePhoneFlip = {
    prefix: 'fasds',
    iconName: 'circle-phone-flip',
    icon: [
      512,
      512,
      ["phone-circle-alt"],
      'e11c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 56l72-40 33.5 41.9c34.2-18.1 62.3-46.2 80.4-80.4L272 200l40-72 72 16 0 16c0 123.7-100.3 224-224 224l-16 0-16-72z','M384 144l-72-16-40 72 41.9 33.5c-18.1 34.2-46.2 62.3-80.4 80.4L200 272l-72 40 16 72h16c123.7 0 224-100.3 224-224l0-16z']
      
    ]
  };

  
    var faPhoneCircleAlt = faCirclePhoneFlip;
  

  
  

  var faBuildingShield = {
    prefix: 'fasds',
    iconName: 'building-shield',
    icon: [
      576,
      512,
      [],
      'e4d8',
      
      ['M0 0L0 512l144 0 0-128 96 0 0 128 122.1 0c-68.5-48.9-102.9-131.4-105.9-205.3c-.1-.9-.2-1.7-.2-2.7l0-8 0-8 0-30.2 0-17.8 0-16 16 0 48 0 23.4 0L384 208.3 384 0 0 0zM64 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zM160 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64z','M432 275.5l0 184.9c56.5-26.3 90.2-87 95.3-148L432 275.5zM576 296c0 85.8-48 184-144 216c-96-32-144-130.2-144-216l0-16.2L432 224l144 55.8 0 16.2z']
      
    ]
  };

  

  
  

  var faCartCircleXmark = {
    prefix: 'fasds',
    iconName: 'cart-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e3f4',
      
      ['M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L525.2 194.4c-9.5-1.6-19.3-2.4-29.2-2.4c-68.4 0-127.7 39-156.8 96l-168.5 0 9.1 48 143 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L160 384l-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM224 464a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faFaceSmileTongue = {
    prefix: 'fasds',
    iconName: 'face-smile-tongue',
    icon: [
      512,
      512,
      [],
      'e394',
      
      ['M0 256C0 397.4 114.6 512 256 512c61.5 0 118-21.7 162.1-57.9c-2.8-1.2-5.5-2.7-8.2-4.2l-68.1-40.4C316.3 423.8 287.1 432 256 432c-84.1 0-154-59.7-175.5-139.9l30.9-8.3C129.5 351.5 187.9 400 256 400s126.5-48.5 144.5-116.1l5.4-20.2L424 274.1l65.7 37.9c5 2.9 9.6 6.2 13.7 10c5.6-21.1 8.6-43.2 8.6-66C512 114.6 397.4 0 256 0S0 114.6 0 256zm120-24c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M176 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm160 0c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm34.6 237.3c24-20.4 42.8-47.1 54.5-77.6l48.6 28.1c23 13.3 30.8 42.6 17.6 65.6c-13.2 22.8-42.4 30.4-65 17l-55.7-33.1z']
      
    ]
  };

  

  
  

  var faPesoSign = {
    prefix: 'fasds',
    iconName: 'peso-sign',
    icon: [
      384,
      512,
      [],
      'e222',
      
      ['M0 128l32 0 0 64L0 192l0-64zm0 96l32 0 0 64L0 288l0-64zm96-96l158.4 0c17.1 16.8 28.9 39.1 32.5 64L96 192l0-64zm0 96l190.9 0c-3.6 24.9-15.3 47.2-32.5 64L96 288l0-64zm236.8-96l51.2 0 0 64-32.7 0c-2.1-22.9-8.5-44.5-18.5-64zm0 160c10-19.5 16.4-41.1 18.5-64l32.7 0 0 64-51.2 0z','M32 32l32 0 112 0c97.2 0 176 78.8 176 176s-78.8 176-176 176l-80 0 0 64 0 32-64 0 0-32 0-96L32 64l0-32zM96 320l80 0c61.9 0 112-50.1 112-112s-50.1-112-112-112L96 96l0 224z']
      
    ]
  };

  

  
  

  var faClawMarks = {
    prefix: 'fasds',
    iconName: 'claw-marks',
    icon: [
      576,
      512,
      [],
      'f6c2',
      
      ['M33.4 270.6l45.3-45.3 72 72 96 96 72 72-45.3 45.3L210.7 448 128 448l-32 0 0-32 0-82.7L33.4 270.6zm224-224L302.6 1.4l40 40 64 64 64 64 64 64 40 40-45.3 45.3L498.7 288 448 288l-32 0 0-32 0-50.7L370.7 160 320 160l-32 0 0-32 0-50.7L257.4 46.6z','M128 141.3L33.4 46.6 78.6 1.4l104 104 64 64 160 160 64 64 72 72-45.3 45.3L434.7 448 384 448l-32 0 0-32 0-50.7L210.7 224 160 224l-32 0 0-32 0-50.7z']
      
    ]
  };

  

  
  

  var faRhombus = {
    prefix: 'fasds',
    iconName: 'rhombus',
    icon: [
      448,
      512,
      [],
      'e23b',
      
      ['M0 256L224 512 448 256 224 0 0 256z','']
      
    ]
  };

  

  
  

  var faChalkboardUser = {
    prefix: 'fasds',
    iconName: 'chalkboard-user',
    icon: [
      640,
      512,
      ["chalkboard-teacher"],
      'f51c',
      
      ['M160 0l0 32 0 64c23.3 0 45.2 6.2 64 17.1L224 64l352 0 0 288-64 0-128 0-78.6 0 19.2 64L608 416l32 0 0-32 0-352 0-32L608 0 192 0 160 0z','M64 224a96 96 0 1 1 192 0A96 96 0 1 1 64 224zM272 352l48 160L0 512 48 352l224 0zm240-64l0 64-128 0 0-64 128 0z']
      
    ]
  };

  
    var faChalkboardTeacher = faChalkboardUser;
  

  
  

  var faArrowsUpDownLeftRight = {
    prefix: 'fasds',
    iconName: 'arrows-up-down-left-right',
    icon: [
      512,
      512,
      ["arrows"],
      'f047',
      
      ['M154.7 104L200 149.3l22.6-22.6 1.4-1.4 0 98.7 32 0 32 0 0-98.7 1.4 1.4L312 149.3 357.3 104 334.6 81.4l-56-56L256 2.7 233.4 25.4l-56 56L154.7 104zm0 304l22.6 22.6 56 56L256 509.3l22.6-22.6 56-56L357.3 408 312 362.7l-22.6 22.6-1.4 1.4 0-98.7-32 0-32 0 0 98.7-1.4-1.4L200 362.7 154.7 408z','M149.3 200l-22.6 22.6-1.4 1.4L256 224l130.7 0-1.4-1.4L362.7 200 408 154.7l22.6 22.6 56 56L509.3 256l-22.6 22.6-56 56L408 357.3 362.7 312l22.6-22.6 1.4-1.4L256 288l-130.7 0 1.4 1.4L149.3 312 104 357.3 81.4 334.6l-56-56L2.7 256l22.6-22.6 56-56L104 154.7 149.3 200z']
      
    ]
  };

  
    var faArrows = faArrowsUpDownLeftRight;
  

  
  

  var faFaceSmirking = {
    prefix: 'fasds',
    iconName: 'face-smirking',
    icon: [
      512,
      512,
      [],
      'e397',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-64l16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0-16 0 0-32zm80 176l16 0 112.6 0c19.6 0 36.2-14.1 39.5-33.4l.2-1.2 2.6-15.8 31.6 5.3-2.6 15.8-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2L192 400l-16 0 0-32zM288 192l16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0-16 0 0-32z','M112 192l-16 0 0 32 16 0 32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0zm192 0l-16 0 0 32 16 0 32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0z']
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fasds',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      ['M281.4 390.6L304 413.3 349.3 368l-22.6-22.6L237.3 256l89.4-89.4L349.3 144 304 98.7l-22.6 22.6L192 210.7l-89.4-89.4L80 98.7 34.7 144l22.6 22.6L146.7 256 57.4 345.4 34.7 368 80 413.3l22.6-22.6L192 301.3l89.4 89.4z','']
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faCloudCheck = {
    prefix: 'fasds',
    iconName: 'cloud-check',
    icon: [
      640,
      512,
      [],
      'e35c',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zm190.1-48L224 254.1c.3 .3 .6 .6 1 1c5.3 5.3 10.7 10.7 16 16c15.7 15.7 31.4 31.4 47 47c37-37 74-74 111-111c5.3-5.3 10.7-10.7 16-16c.3-.3 .6-.6 1-1L449.9 224l-1 1c-5.3 5.3-10.7 10.7-16 16L305 369l-17 17-17-17-64-64c-5.3-5.3-10.7-10.7-16-16c-.3-.3-.6-.6-1-1z','M449 225L305 369l-17 17-17-17-80-80L225 255l63 63L415 191 449 225z']
      
    ]
  };

  

  
  

  var faFort = {
    prefix: 'fasds',
    iconName: 'fort',
    icon: [
      640,
      512,
      [],
      'e486',
      
      ['M0 0L64 0l0 64 32 0L96 0l64 0 0 64 32 0 0-64 64 0 0 64 0 64 0 32 0 32-32 32L32 224 0 192l0-64L0 64 0 0zM384 0l64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 0 64 0 64-32 32-192 0-32-32 0-32 0-32 0-64 0-64z','M384 160l-128 0 0 32-32 32L32 224l0 288 224 0 0-128c0-35.3 28.7-64 64-64s64 28.7 64 64l0 128 224 0 0-288-192 0-32-32 0-32z']
      
    ]
  };

  

  
  

  var faComputer = {
    prefix: 'fasds',
    iconName: 'computer',
    icon: [
      640,
      512,
      [],
      'e4e5',
      
      ['M480 32l0 448 160 0 0-448L480 32zm48 64l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32zm0 64l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32zm64 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M384 96l0 224L64 320 64 96l320 0zM64 32L0 32 0 96 0 320l0 64 64 0 117.3 0-10.7 32L64 416l0 64 320 0 0-64-106.7 0-10.7-32L384 384l64 0 0-64 0-224 0-64-64 0L64 32z']
      
    ]
  };

  

  
  

  var faExpand = {
    prefix: 'fasds',
    iconName: 'expand',
    icon: [
      448,
      512,
      [],
      'f065',
      
      ['M0 320l64 0 0 32 0 64 64 0 32 0 0 64-32 0-96 0L0 480l0-32 0-96 0-32zM288 32l32 0 96 0 32 0 0 32 0 96 0 32-64 0 0-32 0-64-64 0-32 0 0-64z','M0 32l32 0 96 0 32 0 0 64-32 0L64 96l0 64 0 32L0 192l0-32L0 64 0 32zM448 320l0 32 0 96 0 32-32 0-96 0-32 0 0-64 32 0 64 0 0-64 0-32 64 0z']
      
    ]
  };

  

  
  

  var faPlus = {
    prefix: 'fasds',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      ['M256 80l0-32-64 0 0 32 0 144L48 224l-32 0 0 64 32 0 144 0 0 144 0 32 64 0 0-32 0-144 144 0 32 0 0-64-32 0-144 0 0-144z','']
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faHatBeach = {
    prefix: 'fasds',
    iconName: 'hat-beach',
    icon: [
      640,
      512,
      [],
      'e606',
      
      ['M160 224c0 35.3 71.6 64 160 64c23 0 44.9-1.9 64.7-5.4c3.7 21.3 22.3 37.4 44.6 37.4c12 0 23.5-4.8 32-13.3L464 304l2.7 2.7c8.5 8.5 20 13.3 32 13.3c25 0 45.3-20.3 45.3-45.3c0-10.9-3.9-21.3-11-29.5c-.7-.9-1.5-1.7-2.3-2.5L528 240l2.7-2.7c8.5-8.5 13.3-20 13.3-32c0-25-20.3-45.3-45.3-45.3c-10.3 0-20.2 3.5-28.2 9.8c-1.3 1.1-2.6 2.2-3.8 3.4L464 176l-2.7-2.7c-8.5-8.5-20-13.3-32-13.3c-25 0-45.3 20.3-45.3 45.3c0 4.5 .7 9 2 13.2c-20 3.5-42.3 5.5-66 5.5c-79.9 0-145.3-22.7-151.5-51.5C163 188.6 160 206 160 224zm272 16l32-32 32 32-32 32-32-32z','M320 448c176.7 0 320-57.3 320-128l0-32L533 245.2c7 8.2 11 18.7 11 29.5c0 25-20.3 45.3-45.3 45.3c-12 0-23.5-4.8-32-13.3L464 304l-2.7 2.7c-8.5 8.5-20 13.3-32 13.3c-22.3 0-40.9-16.2-44.6-37.4C364.9 286.1 343 288 320 288c-88.4 0-160-28.7-160-64L0 288l0 32c0 70.7 143.3 128 320 128zM470.6 169.8C448.4 108.1 389.3 64 320 64c-70.3 0-130.1 45.4-151.5 108.5C174.7 201.3 240.1 224 320 224c23.6 0 46-2 66-5.5c-1.3-4.2-2-8.7-2-13.2c0-25 20.3-45.3 45.3-45.3c12 0 23.5 4.8 32 13.3L464 176l2.7-2.7c1.2-1.2 2.5-2.4 3.8-3.4z']
      
    ]
  };

  

  
  

  var faSquarePhone = {
    prefix: 'fasds',
    iconName: 'square-phone',
    icon: [
      448,
      512,
      ["phone-square"],
      'f098',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 144l72-16c13.3 24 26.7 48 40 72l-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L280 272c24 13.3 48 26.7 72 40l-16 72-16 0C196.3 384 96 283.7 96 160c0-5.3 0-10.7 0-16z','M96 144l72-16 40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L280 272l72 40-16 72H320C196.3 384 96 283.7 96 160l0-16z']
      
    ]
  };

  
    var faPhoneSquare = faSquarePhone;
  

  
  

  var fa2 = {
    prefix: 'fasds',
    iconName: '2',
    icon: [
      320,
      512,
      [],
      '32',
      
      ['M142.9 32C104.4 32 67.5 47.3 40.2 74.5L25.4 89.4 2.7 112 48 157.3l22.6-22.6 14.9-14.9C100.7 104.5 121.3 96 142.9 96c44.8 0 81.1 36.3 81.1 81.1c0 21.5-8.5 42.2-23.8 57.4L9.4 425.4 0 434.7 0 480l32 0 256 0 32 0 0-64-32 0-178.7 0L245.5 279.8c27.2-27.2 42.5-64.1 42.5-102.6C288 97 223 32 142.9 32z','']
      
    ]
  };

  

  
  

  var faGun = {
    prefix: 'fasds',
    iconName: 'gun',
    icon: [
      576,
      512,
      [],
      'e19b',
      
      ['M64 128l0 32 416 0 0-32L64 128zM224 352l120 0 16.9 0 5.7-15.9L400.9 240l-51 0-22.9 64L236 304l-12 48z','M528 56l0-24-48 0 0 24 0 8L0 64 0 240l92 0L32 480l160 0 60-240 196 0 32-32 96 0 0-144-48 0 0-8zm-48 72l0 32L64 160l0-32 416 0z']
      
    ]
  };

  

  
  

  var faChildCombatant = {
    prefix: 'fasds',
    iconName: 'child-combatant',
    icon: [
      576,
      512,
      ["child-rifle"],
      'e4e0',
      
      ['M16 294.4l51.2 38.4 19.2-25.6L96 294.4 96 480l0 32 64 0 0-32 0-96 32 0 0 96 0 32 64 0 0-32 0-185.6 9.6 12.8 19.2 25.6L336 294.4l-19.2-25.6-72.1-96L235.1 160l-16 0-86.2 0-16 0-9.6 12.8-72.1 96L16 294.4zM112 64a64 64 0 1 0 128 0A64 64 0 1 0 112 64z','M448 0l16 0 0 128 16 0 0 141.3 16-5.3 0-72 48 0 0 112-64 21.3 0 26.7 64 0 0 48-60 0 28 112-96 0 0-112-48 0 0-208 32 0 0-64 16 0 0-96-16 0 0-32 16 0 32 0z']
      
    ]
  };

  
    var faChildRifle = faChildCombatant;
  

  
  

  var faKeynote = {
    prefix: 'fasds',
    iconName: 'keynote',
    icon: [
      512,
      512,
      [],
      'f66c',
      
      ['M96 112l0 48 48 0 0-48c0-22.1 17.9-40 40-40l24 0 0 24 96 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L208 0l0 24-24 0c-48.6 0-88 39.4-88 88zm32 336l0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-96-64 0 0 96-64 0-32 0z','M512 352H0V288L64 160H448l64 128v64z']
      
    ]
  };

  

  
  

  var faShareFromSquare = {
    prefix: 'fasds',
    iconName: 'share-from-square',
    icon: [
      576,
      512,
      [61509,"share-square"],
      'f14d',
      
      ['M0 32l32 0 96 0 32 0 0 64-32 0L64 96l0 352 352 0 0-32 0-32 64 0 0 32 0 64 0 32-32 0L32 512 0 512l0-32L0 64 0 32z','M576 160L416 320l-32 0 0-96-16 0-17.5 0c-52.2 0-94.5 42.3-94.5 94.5c0 39.3 32 65.5 32 65.5s-128-39.3-128-144c0-79.5 64.5-144 144-144l80 0 0-96 32 0L576 160z']
      
    ]
  };

  
    var faShareSquare = faShareFromSquare;
  

  
  

  var faGrip = {
    prefix: 'fasds',
    iconName: 'grip',
    icon: [
      448,
      512,
      ["grip-horizontal"],
      'f58d',
      
      ['M0 288l128 0 0 128L0 416 0 288zm160 0l128 0 0 128-128 0 0-128zm160 0l128 0 0 128-128 0 0-128z','M0 96l128 0 0 128L0 224 0 96zm160 0l128 0 0 128-128 0 0-128zm288 0l0 128-128 0 0-128 128 0z']
      
    ]
  };

  
    var faGripHorizontal = faGrip;
  

  
  

  var faJackOLantern = {
    prefix: 'fasds',
    iconName: 'jack-o-lantern',
    icon: [
      576,
      512,
      [127875],
      'f30e',
      
      ['M0 320C0 426 68.1 512 152 512c24.4 0 47.5-7.3 68-20.2c20.5 12.9 43.6 20.2 68 20.2s47.5-7.3 68-20.2c20.5 12.9 43.6 20.2 68 20.2c83.9 0 152-86 152-192s-68.1-192-152-192c-10.2 0-20.1 1.3-29.8 3.7c15.4 11.7 28.9 25.9 39.8 42C392.6 144.9 342.3 128 288 128s-104.6 16.9-146 45.7c10.9-16.1 24.3-30.3 39.8-42c-9.6-2.4-19.6-3.7-29.8-3.7C68.1 128 0 214 0 320zm96 0s14.5 8.7 39.7 18.6s61.2 21.2 104.3 26.4l0 34.9 48 0 0-32c112 0 192-48 192-48s-10.2 54.6-64 92.4l0-12.4-48 0 0 36.2c-22.1 7.3-48.5 11.8-80 11.8s-57.9-4.5-80-11.8l0-36.2-48 0 0 12.4C106.2 374.6 96 320 96 320zm64-32l48-80 48 80-96 0zm160 0l48-80 48 80-96 0z','M236.1 103.8C252.5 98.7 269.9 96 288 96c22.6 0 44.2 4.3 64 12l0-76L288 0 236.1 103.8zM160 288l96 0-48-80-48 80zm160 0l96 0-48-80-48 80zm96 124.4c53.8-37.9 64-92.4 64-92.4s-80 48-192 48l0 32-48 0 0-34.9C153.8 354.7 96 320 96 320s10.2 54.6 64 92.4l0-12.4 48 0 0 36.2c22.1 7.3 48.5 11.8 80 11.8s57.9-4.5 80-11.8l0-36.2 48 0 0 12.4z']
      
    ]
  };

  

  
  

  var faUserVneckHair = {
    prefix: 'fasds',
    iconName: 'user-vneck-hair',
    icon: [
      448,
      512,
      [],
      'e462',
      
      ['M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11.1-1.4-21.8-4-32l-60 0L256 64l-48 48L97 112c-.7 5.2-1 10.6-1 16z','M208 112l48-48 32 32 60 0C333.8 40.8 283.6 0 224 0C158.7 0 104.9 48.9 97 112l111 0zM384 304L64 304 0 512l448 0L384 304z']
      
    ]
  };

  

  
  

  var faPartyBell = {
    prefix: 'fasds',
    iconName: 'party-bell',
    icon: [
      512,
      512,
      [],
      'e31a',
      
      ['M32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM150.1 376l17 17 8.3 8.3c16.7 16.7 27.2 38.6 29.8 62.1l3 27.4 47.7-5.3-3-27.4c-3.8-34.3-19.2-66.3-43.6-90.7L201 359l-17-17L150.1 376zm128.1-98.8l15.5 18.3 8.5 10c4.9 5.8 7.5 13.2 7.3 20.7c-1.1 42.5 31.7 78.3 74.2 80.8l30 1.8c16.6 1 29.4 15 29 31.6c-.5 19.4 6.1 38.2 18.6 53l8.5 10 36.6-31-8.5-10c-4.9-5.8-7.5-13.2-7.3-20.7c1.1-42.5-31.7-78.3-74.2-80.8l-30-1.8c-16.6-1-29.4-15-29-31.6c.5-19.4-6.1-38.2-18.6-53l-8.5-10-15.5-18.3-36.6 31zM320 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm22.1-296l17 17 8.2 8.3c24.4 24.4 56.4 39.8 90.7 43.6l27.4 3 5.3-47.7-27.4-3c-23.5-2.6-45.4-13.1-62.1-29.8L393 167l-17-17L342.1 184zM448 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M65.6 65.6c-87.5 87.5-87.5 229.3 0 316.8L382.4 65.6c-87.5-87.5-229.3-87.5-316.8 0z']
      
    ]
  };

  

  
  

  var faPaintbrushPencil = {
    prefix: 'fasds',
    iconName: 'paintbrush-pencil',
    icon: [
      576,
      512,
      [],
      'e206',
      
      ['M32 112L176 256c6.2 0 12.4 .4 18.4 1.2L297.8 153.8 224 80 144 0 32 112zM318.8 381.6c.8 6 1.2 12.2 1.2 18.4l80 80 144 32L512 368l-89.8-89.8L318.8 381.6z','M575.2 80l-39.6 39.6L306.9 348.3l-79.2-79.2L456.4 40.4 496 .8 575.2 80zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112L0 512l0-64 64 0 0-48c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z']
      
    ]
  };

  

  
  

  var faBarsFilter = {
    prefix: 'fasds',
    iconName: 'bars-filter',
    icon: [
      448,
      512,
      [],
      'e0ad',
      
      ['M64 224l320 0 0 64L64 288l0-64z','M448 64L0 64l0 64 448 0 0-64zM288 384l-128 0 0 64 128 0 0-64z']
      
    ]
  };

  

  
  

  var faHandSparkles = {
    prefix: 'fasds',
    iconName: 'hand-sparkles',
    icon: [
      640,
      512,
      [],
      'e05d',
      
      ['M64.3 329.4l29 27.6 95.5 91c43.1 41.1 100.4 64 160 64l19.2 0c44.4 0 84.9-16.4 115.9-43.5L448 453.1l0-42.2 63.6-27.3L544 308.1 544 128l0-32-64 0 0 32 0 128-32 0 0-192 0-32-64 0 0 32 0 192-32 0 0-224 0-32L288 0l0 32 0 224-32 0 0-192 0-32-64 0 0 32 0 272c0 1.5 0 3.1 .1 4.6l-43.6-41.5-29-27.6L64.3 329.4zM256 368l32-16 16-32 16 32 32 16-32 16-16 32-16-32-32-16z','M80 64L56 120 0 144l56 24 24 56 24-56 56-24-56-24L80 64zM560 352l-24 56-56 24 56 24 24 56 24-56 56-24-56-24-24-56z']
      
    ]
  };

  

  
  

  var faVolumeXmark = {
    prefix: 'fasds',
    iconName: 'volume-xmark',
    icon: [
      576,
      512,
      ["volume-mute","volume-times"],
      'f6a9',
      
      ['M390.1 200l17 17 39 39-39 39-17 17L424 345.9l17-17 39-39 39 39 17 17L569.9 312l-17-17-39-39 39-39 17-17L536 166.1l-17 17-39 39-39-39-17-17L390.1 200z','M0 352V160H128L272 32h48V480H272L128 352H0z']
      
    ]
  };

  
    var faVolumeMute = faVolumeXmark;
  
    var faVolumeTimes = faVolumeXmark;
  

  
  

  var faBurgerGlass = {
    prefix: 'fasds',
    iconName: 'burger-glass',
    icon: [
      640,
      512,
      [],
      'e0ce',
      
      ['M0 0L5 64 40 512l216 0 0-229.4c3-9.1 6.7-17.5 11.6-25.9c6.6-11.3 17-25.9 32.7-40.4c17.2-15.9 40.1-31 70.1-41.6L379 64l5-64L319.8 0 64.2 0 0 0zM69.2 64l245.6 0-7.5 96L76.7 160 69.2 64z','M640 319.8l0-32s-32-96-176-96s-176 96-176 96l0 32 352 0zm-272-64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 160l352 0 0-64-352 0 0 64zm0 96l352 0 0-64-352 0 0 64z']
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'fasds',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      ['M0 128l0 64L0 448l0 64 64 0 192 0 64 0 0-64 0-32-64 0 0 32L64 448l0-256 64 0 0-64-64 0L0 128z','M160 0H352l96 96V384H160V0z']
      
    ]
  };

  

  
  

  var faSnowmanHead = {
    prefix: 'fasds',
    iconName: 'snowman-head',
    icon: [
      448,
      512,
      ["frosty-head"],
      'f79b',
      
      ['M32 352c0 66.8 34.1 125.6 85.8 160l212.3 0c51.7-34.4 85.8-93.2 85.8-160c0-35-9.4-67.8-25.7-96L57.7 256C41.3 284.2 32 317 32 352zm144-40a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm16 71.6c0-17.5 14.2-31.6 31.6-31.6l.8 0c17.5 0 31.6 14.2 31.6 31.6c0 5.5-1.4 10.9-4.2 15.7L224 448l-27.8-48.7c-2.7-4.8-4.2-10.2-4.2-15.7zM320 312a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M64 0L384 0l0 160L64 160 64 0zm88 288a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm144 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 192l384 0 32 0 0 64-32 0L32 256 0 256l0-64 32 0z']
      
    ]
  };

  
    var faFrostyHead = faSnowmanHead;
  

  
  

  var faSidebar = {
    prefix: 'fasds',
    iconName: 'sidebar',
    icon: [
      512,
      512,
      [],
      'e24e',
      
      ['M224 32l0 448 288 0 0-448L224 32z','M224 32L0 32 0 480l224 0 0-448zM160 96l0 48-96 0 0-48 96 0zM64 192l96 0 0 48-96 0 0-48zm96 96l0 48-96 0 0-48 96 0z']
      
    ]
  };

  

  
  

  var faChartPyramid = {
    prefix: 'fasds',
    iconName: 'chart-pyramid',
    icon: [
      512,
      512,
      [],
      'e0e6',
      
      ['M73.1 352c30.5-53.3 61-106.7 91.4-160l182.9 0 91.4 160L73.1 352z','M73.1 352L0 480l512 0L438.9 352 73.1 352zm91.4-160l182.9 0L256 32 164.6 192z']
      
    ]
  };

  

  
  

  var faPedestal = {
    prefix: 'fasds',
    iconName: 'pedestal',
    icon: [
      448,
      512,
      [],
      'e20d',
      
      ['M32 0L416 0l0 448L32 448 32 0zM96 88a24 24 0 1 0 48 0A24 24 0 1 0 96 88zm208 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M144 88A24 24 0 1 0 96 88a24 24 0 1 0 48 0zm208 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM32 448L0 448l0 64 32 0 384 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  

  
  

  var faDiagramProject = {
    prefix: 'fasds',
    iconName: 'diagram-project',
    icon: [
      576,
      512,
      ["project-diagram"],
      'f542',
      
      ['M144 224l48 0 0-42.7L272 288l-48 0 0 42.7L144 224zM192 96l192 0 0 64-192 0 0-64z','M0 32l192 0 0 192L0 224 0 32zM224 288l192 0 0 192-192 0 0-192zM576 32l0 192-192 0 0-192 192 0z']
      
    ]
  };

  
    var faProjectDiagram = faDiagramProject;
  

  
  

  var faJetFighterUp = {
    prefix: 'fasds',
    iconName: 'jet-fighter-up',
    icon: [
      512,
      512,
      [],
      'e518',
      
      ['M48 296l144-80 0 168L48 384l0-88zm272-80l144 80 0 88-144 0 0-168z','M192 416l0-16 0-16 0-256L240 0l32 0 48 128 0 256 0 16 0 16 64 64 0 32-112 0 0-48 0-16-32 0 0 16 0 48-112 0 0-32 64-64zM0 416l0-24L0 280l0-24 48 0 0 24 0 112 0 24L0 416zm464-24l0-112 0-24 48 0 0 24 0 112 0 24-48 0 0-24z']
      
    ]
  };

  

  
  

  var faAwardSimple = {
    prefix: 'fasds',
    iconName: 'award-simple',
    icon: [
      384,
      512,
      [],
      'e0ab',
      
      ['M64 512l128-32 128 32L284.5 358.2c-16.1-.4-32.2-.8-48.3-1.1c-14.7 9-29.5 18-44.2 26.9c-14.7-9-29.5-18-44.2-26.9c-13.1 .3-26.2 .6-39.2 .9c-3 .1-6 .1-9 .2L64 512z','M236.2 26.9L192 0 147.8 26.9 96 25.7 71.2 71.2 25.7 96l1.2 51.8L0 192l26.9 44.2L25.7 288l45.4 24.8L96 358.3l51.8-1.2L192 384l44.2-26.9 51.8 1.2 24.8-45.4L358.3 288l-1.2-51.8L384 192l-26.9-44.2L358.3 96 312.8 71.2 288 25.7l-51.8 1.2zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z']
      
    ]
  };

  

  
  

  var faCircleP = {
    prefix: 'fasds',
    iconName: 'circle-p',
    icon: [
      512,
      512,
      [],
      'e11a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48 0 24-48 0 0-24 0-72 0-136 0-24zm48 48l0 88 68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0z','M160 128l24 0 92 0c50.8 0 92 41.2 92 92s-41.2 92-92 92l-68 0 0 48 0 24-48 0 0-24 0-72 0-136 0-24zm48 136l68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88z']
      
    ]
  };

  

  
  

  var faBaseball = {
    prefix: 'fasds',
    iconName: 'baseball',
    icon: [
      512,
      512,
      [9918,129358,"baseball-ball"],
      'f433',
      
      ['M.1 250.4C15.5 254.1 31.5 256 48 256c11.8 0 23.4-1 34.6-2.9c-1.8-10.5-3.5-21-5.3-31.6C67.8 223.2 58 224 48 224c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 10-.8 19.8-2.4 29.4c10.5 1.8 21 3.5 31.6 5.3C255 71.4 256 59.8 256 48c0-16.5-1.9-32.5-5.6-47.9c1.8 0 3.7-.1 5.5-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-11.8 0-23.4 1-34.6 2.9c1.8 10.5 3.5 21 5.3 31.6c9.5-1.6 19.3-2.4 29.4-2.4c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2c-1.9-7.2-3.4-14.6-4.4-22.3c-.2-1.9-.4-3.7-.7-5.7c-.2-1.7-.3-3.5-.4-5.1l0-.7c-.1-1.7-.2-3.4-.3-5.2l0-.5c-.1-1.9-.1-3.6-.1-5.4c0-.1 0-.3 0-.4c0-.2 0-.5 0-.7c0-1 0-1.9 0-2.9c0-.1 0-.4 0-.8c0-.9 0-1.8 .1-2.7c.1-2.5 .3-5.1 .5-7.8c.4-4.9 1-9.8 1.8-14.6l-31.6-5.3c-.9 5.7-1.7 11.4-2.1 17.1l0 .6c-.1 1.2-.2 2.3-.2 3.4c0 .3 0 .5 0 .8c-.1 1.2-.1 2.3-.2 3.4c0 .4 0 .7 0 1.1c0 1.2-.1 2.4-.1 3.3c0 .2 0 .5 0 .7c0 1.3 0 2.4 0 3.6c0 .2 0 .5 0 .7c0 6.2 .3 12.3 .8 18.4c.2 1.9 .4 3.9 .6 5.8c.9 8 2.3 16 4.2 23.7c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6zm109.8-37.6l11.3 30c57.3-21.5 102.6-67.6 123-125.4c-10.1-3.6-20.1-7.1-30.2-10.7c-17.3 48.9-55.6 87.9-104.1 106.1zm158 181.9L298 405.3c17.3-48.9 55.6-87.9 104.1-106.1c-3.7-10-7.5-20-11.3-30c-57.3 21.5-102.6 67.6-123 125.4z','M48 224c10 0 19.8-.8 29.4-2.4l5.3 31.6C71.4 255 59.8 256 48 256c-16.5 0-32.6-1.9-47.9-5.6c.2-11 1.2-21.7 2.7-32.3C17.2 222 32.4 224 48 224zM250.5 .1C254.1 15.4 256 31.5 256 48c0 11.8-1 23.4-2.9 34.6l-31.6-5.3C223.2 67.8 224 58 224 48c0-15.6-2-30.8-5.9-45.2c10.6-1.6 21.4-2.5 32.3-2.7zM511.9 261.6c-.2 11-1.2 21.7-2.7 32.3C494.8 290 479.6 288 464 288c-10 0-19.8 .8-29.4 2.4l-5.3-31.6c11.3-1.9 22.9-2.9 34.6-2.9c16.5 0 32.6 1.9 47.9 5.6zM293.9 509.2c-10.6 1.6-21.4 2.5-32.3 2.7c-3.6-15.4-5.6-31.4-5.6-47.9c0-11.8 1-23.4 2.9-34.6l31.6 5.3c-1.6 9.5-2.4 19.3-2.4 29.4c0 15.6 2 30.8 5.9 45.2zm-184-296.4c48.5-18.2 86.8-57.2 104.1-106.1l30.2 10.7c-20.4 57.8-65.7 103.9-123 125.4l-11.3-30zm292.2 86.4c-48.5 18.2-86.8 57.2-104.1 106.1l-30.2-10.7c20.4-57.8 65.7-103.9 123-125.4l11.3 30z']
      
    ]
  };

  
    var faBaseballBall = faBaseball;
  

  
  

  var faGlobeStand = {
    prefix: 'fasds',
    iconName: 'globe-stand',
    icon: [
      448,
      512,
      [],
      'f5f6',
      
      ['M64 208a144 144 0 1 0 288 0A144 144 0 1 0 64 208z','M23 359l-17 17L40 409.9l17-17 10.5-10.5c34.3 27.7 74.9 43.8 116.5 48.3l0 33.3L64 464l0 48 288 0 0-48-120 0 0-33.3c49.1-5.3 96.8-26.7 134.4-64.3c81.7-81.7 87.1-211 16.1-298.9L393 57l17-17L376 6.1 359 23 332.5 49.6l-17 17 17 17c68.7 68.7 68.7 180.2 0 248.9s-180.2 68.7-248.9 0l-17-17-17 17L23 359z']
      
    ]
  };

  

  
  

  var faFaceTongueSweat = {
    prefix: 'fasds',
    iconName: 'face-tongue-sweat',
    icon: [
      576,
      512,
      [],
      'e39e',
      
      ['M32 256l16-21.3 25.6 34.1L112 320c10.4 13.8 16 30.7 16 48c0 24.6-11.1 46.5-28.5 61.2c28.9 31.4 65.6 55.6 107 69.5C197.3 484 192 466.6 192 448l0-31.3c-10.2-7.2-16-15.7-16-24.7c0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7l0 31.3c0 18.6-5.3 36-14.5 50.8C470.9 464.7 544 368.9 544 256C544 114.6 429.4 0 288 0S32 114.6 32 256zm77.6-61.2l15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L216 137.4 238.6 160l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7c-.8 .1-1.7 .3-2.5 .4l-15.8 2.6-5.3-31.6zm130 77.2a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM337.4 160L360 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L337.4 160z','M238.6 160L216 137.4l-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4L238.6 160zm-63 112a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm192 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 512c35.3 0 64-28.7 64-64l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64zM48 288L9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L48 288zM348.7 171.3l7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4L360 137.4 337.4 160l11.3 11.3z']
      
    ]
  };

  

  
  

  var faCircleRadiation = {
    prefix: 'fasds',
    iconName: 'circle-radiation',
    icon: [
      512,
      512,
      [9762,"radiation-alt"],
      'f7ba',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm448 0A192 192 0 1 1 64 256a192 192 0 1 1 384 0zm-224 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M200 256c0-20.7 11.3-38.8 28-48.5l-52-90.1C128.2 145.1 96 196.8 96 256l104 0zm28 48.5l-52 90.1c23.5 13.6 50.9 21.4 80 21.4s56.5-7.8 80-21.4l-52-90.1c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l104 0c0-59.2-32.2-110.9-80-138.6l-52 90.1c16.7 9.7 28 27.8 28 48.5z']
      
    ]
  };

  
    var faRadiationAlt = faCircleRadiation;
  

  
  

  var faMusicNoteSlash = {
    prefix: 'fasds',
    iconName: 'music-note-slash',
    icon: [
      640,
      512,
      ["music-alt-slash"],
      'f8d0',
      
      ['M160 432c0 44.2 50.1 80 112 80s112-35.8 112-80l0-33.5-64-50.4 0 11.6c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80zM320 51.8l0 25 0 64 0 84.9 64 49.7 0-109.6 103.8-25.9 24.2-6.1 0-25 0-64 0-41-39.8 9.9-128 32L320 51.8z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faMusicAltSlash = faMusicNoteSlash;
  

  
  

  var faMango = {
    prefix: 'fasds',
    iconName: 'mango',
    icon: [
      512,
      512,
      [],
      'e30f',
      
      ['M0 384l0 64 43.9 20.7s100.1 43.3 244.1 43.3c166.5 0 224-147.4 224-224c0-49.1-18.7-98.3-56.2-135.8c-25.2-25.2-55.6-41.9-87.8-50.2l0 25.9 0 24-48 0 0-24 0-32c-49.1 0-98.3 18.7-135.8 56.2c-45.8 37.3-67.9 78.9-88.4 117.9c-19 36-36.8 69.7-71.1 95.4L0 384zm288 16c61.9 0 112-50.1 112-112l32 0c0 79.5-64.5 144-144 144l0-32z','M368 128l0-74.9C385.2 79 414.6 96 448 96l40 0 24 0 0-24c0-39.8-32.2-72-72-72L376 0l-8 0L352 0 320 0l0 24 0 104 0 24 48 0 0-24z']
      
    ]
  };

  

  
  

  var faLinkHorizontal = {
    prefix: 'fasds',
    iconName: 'link-horizontal',
    icon: [
      640,
      512,
      ["chain-horizontal"],
      'e1cb',
      
      ['M192 304c0 79.5 64.5 144 144 144l160 0c79.5 0 144-64.5 144-144s-64.5-144-144-144l-16 0 0 64 16 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-160 0c-44.2 0-80-35.8-80-80c0-36.2 24.1-66.8 57.1-76.7c3.7-1.1 7.5-1.9 11.4-2.5l-9.1-63.4c-7 1-13.9 2.5-20.6 4.5C235.4 183.7 192 238.7 192 304z','M0 208C0 128.5 64.5 64 144 64l160 0c79.5 0 144 64.5 144 144c0 65.3-43.4 120.3-102.9 138c-6.7 2-13.6 3.5-20.6 4.5l-9.1-63.4c3.9-.6 7.7-1.4 11.4-2.5c33.1-9.8 57.1-40.5 57.1-76.7c0-44.2-35.8-80-80-80l-160 0c-44.2 0-80 35.8-80 80s35.8 80 80 80l16 0 0 64-16 0C64.5 352 0 287.5 0 208z']
      
    ]
  };

  
    var faChainHorizontal = faLinkHorizontal;
  

  
  

  var faPhoneIntercom = {
    prefix: 'fasds',
    iconName: 'phone-intercom',
    icon: [
      512,
      512,
      [],
      'e434',
      
      ['M160 32l0 448 352 0 0-448L160 32zm64 64l224 0 0 160-224 0 0-160zm96 272a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm32-48l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zm0 64l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32z','M128 32L0 32 0 480l128 0 0-448zM368 320l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zm0 64l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z']
      
    ]
  };

  

  
  

  var faSquareChevronLeft = {
    prefix: 'fasds',
    iconName: 'square-chevron-left',
    icon: [
      448,
      512,
      ["chevron-square-left"],
      'f32a',
      
      ['M0 32l448 0 0 448L0 480 0 32zM118.1 256l17 17L239 377l17 17c11.3-11.3 22.6-22.6 33.9-33.9c-5.7-5.7-11.3-11.3-17-17c-29-29-58-58-87-87l87-87c5.7-5.7 11.3-11.3 17-17L256 118.1c-5.7 5.7-11.3 11.3-17 17c-34.7 34.7-69.3 69.3-104 104c-5.7 5.7-11.3 11.3-17 17z','M118.1 256l17-17L239 135l17-17L289.9 152l-17 17-87 87 87 87 17 17L256 393.9l-17-17L135 273l-17-17z']
      
    ]
  };

  
    var faChevronSquareLeft = faSquareChevronLeft;
  

  
  

  var faClapperboard = {
    prefix: 'fasds',
    iconName: 'clapperboard',
    icon: [
      512,
      512,
      [],
      'e131',
      
      ['M0 160l6.1 0 67.9 0 92.1 0 67.9 0 92.1 0 67.9 0L512 160l0 320L0 480 0 160z','M454.1 32L327 159l-1 1-92.1 0L361 33l1-1 92.1 0zM393.9 160L512 41.9 512 160l-118.1 0zM201.9 32l92.1 0L167 159l-1 1-92.1 0L201 33l1-1zm-67.9 0L7 159l-1 1L0 160 0 32l134.1 0z']
      
    ]
  };

  

  
  

  var faDiamondHalfStroke = {
    prefix: 'fasds',
    iconName: 'diamond-half-stroke',
    icon: [
      512,
      512,
      [],
      'e5b8',
      
      ['M256 0l0 90.5L421.5 256 256 421.5l0 90.5 45.3-45.3L466.7 301.3 512 256l-45.3-45.3L301.3 45.3 256 0z','M256 0L0 256 256 512 256 0z']
      
    ]
  };

  

  
  

  var faSquareArrowDown = {
    prefix: 'fasds',
    iconName: 'square-arrow-down',
    icon: [
      448,
      512,
      ["arrow-square-down"],
      'f339',
      
      ['M0 32L0 480l448 0 0-448L0 32zM78.1 264L112 230.1l17 17c23.7 23.7 47.3 47.3 71 71c0-60.7 0-121.4 0-182.1c0-8 0-16 0-24c16 0 32 0 48 0c0 8 0 16 0 24c0 60.7 0 121.4 0 182.1c23.7-23.7 47.3-47.3 71-71c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-37.3 37.3-74.7 74.7-112 112c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-37.3-37.3-74.7-74.7-112-112c-5.7-5.7-11.3-11.3-17-17z','M224 409.9l17-17L353 281l17-17L336 230.1l-17 17-71 71L248 136l0-24-48 0 0 24 0 182.1-71-71-17-17L78.1 264l17 17L207 393l17 17z']
      
    ]
  };

  
    var faArrowSquareDown = faSquareArrowDown;
  

  
  

  var faArrowRightLongToLine = {
    prefix: 'fasds',
    iconName: 'arrow-right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d5',
      
      ['M576 64l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M489.4 233.4L512 256l-22.6 22.6-128 128-22.6 22.6L293.5 384l22.6-22.6L389.5 288 32 288 0 288l0-64 32 0 357.5 0-73.4-73.4L293.5 128l45.3-45.3 22.6 22.6 128 128z']
      
    ]
  };

  

  
  

  var faCircleHalfStroke = {
    prefix: 'fasds',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680,"adjust"],
      'f042',
      
      ['M256 0l0 64c106 0 192 86 192 192s-86 192-192 192l0 64c141.4 0 256-114.6 256-256S397.4 0 256 0z','M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512L256 0z']
      
    ]
  };

  
    var faAdjust = faCircleHalfStroke;
  

  
  

  var faStarfighter = {
    prefix: 'fasds',
    iconName: 'starfighter',
    icon: [
      640,
      512,
      [],
      'e037',
      
      ['M0 120l0 48 24 0 0 280 0 24 48 0 0-24 0-4 0-92 0-184 24 0 0-48-24 0 0-24 0-24L24 72l0 24 0 24L0 120zM128 288l0 64 0 80 96 0 0-80 0-64-96 0zm160-32l0 64 64 0 0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm128 32l0 64 0 80 96 0 0-80 0-64-96 0zM544 120l0 48 24 0 0 184 0 92 0 4 0 24 48 0 0-24 0-280 24 0 0-48-24 0 0-24 0-24-48 0 0 24 0 24-24 0z','M352 0L288 0 256 256l0 96-32 0 0 80-96 0 0-80-56 0 0 92 88 26.4 0 9.6 0 32 64 0 0-32 32 0 128 0 32 0 0 32 64 0 0-32 0-9.6L568 444l0-92-56 0 0 80-96 0 0-80-32 0 0-96L352 0zM288 256c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64-64 0 0-64z']
      
    ]
  };

  

  
  

  var faUserGraduate = {
    prefix: 'fasds',
    iconName: 'user-graduate',
    icon: [
      448,
      512,
      [],
      'f501',
      
      ['M96 144l256 0 0 16c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-16z','M448 48L224 0 0 48 0 80l16 3.4L16 168 0 256l64 0L48 168l0-77.7 48 10.3L96 144l256 0 0-43.4L448 80l0-32zM126.1 320L64 320 0 512l448 0L384 320l-62.1 0L224 424 126.1 320z']
      
    ]
  };

  

  
  

  var faObjectUnion = {
    prefix: 'fasds',
    iconName: 'object-union',
    icon: [
      512,
      512,
      [],
      'e49f',
      
      ['','M352 0L0 0 0 352l160 0 0 160 352 0 0-352-160 0L352 0z']
      
    ]
  };

  

  
  

  var faCartShoppingFast = {
    prefix: 'fasds',
    iconName: 'cart-shopping-fast',
    icon: [
      640,
      512,
      [],
      'e0dc',
      
      ['M0 96l0 48 112 0 0-48L0 96zm0 80l0 48 128 0 0-48L0 176zm0 80l0 48 144 0 0-48L0 256zM186 32c16.3 85.3 32.5 170.7 48.8 256L560 288 640 32 186 32z','M64 0L88 0l72 0 19.9 0 3.7 19.5L243.9 336 552 336l24 0 0 48-24 0-328 0-19.9 0-3.7-19.5L140.1 48 88 48 64 48 64 0zM192 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faHexagonExclamation = {
    prefix: 'fasds',
    iconName: 'hexagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e417',
      
      ['M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zM232 128l0 24 0 112 0 24 48 0 0-24 0-112 0-24-48 0zm0 192l0 48 48 0 0-48-48 0z','M280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faMusicNote = {
    prefix: 'fasds',
    iconName: 'music-note',
    icon: [
      384,
      512,
      ["music-alt"],
      'f8cf',
      
      ['M192 51.8l0 25 0 64 0 218.9c37.8 12.8 64 40.4 64 72.3l0-266.2 103.8-25.9 24.2-6.1 0-25 0-64 0-41-39.8 9.9-128 32L192 51.8z','M144 352a112 80 0 1 0 0 160 112 80 0 1 0 0-160z']
      
    ]
  };

  
    var faMusicAlt = faMusicNote;
  

  
  

  var faWaffle = {
    prefix: 'fasds',
    iconName: 'waffle',
    icon: [
      512,
      512,
      [129479],
      'e466',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm48-16l16 0 80 0 0-64-48 0-16 0 0-32 16 0 48 0 0-48 0-16 32 0 0 16 0 48 64 0 0-80 0-16 32 0 0 16 0 80 64 0 0-48 0-16 32 0 0 16 0 48 48 0 16 0 0 32-16 0-48 0 0 64 80 0 16 0 0 32-16 0-80 0 0 64 48 0 16 0 0 32-16 0-48 0 0 48 0 16-32 0 0-16 0-48-64 0 0 80 0 16-32 0 0-16 0-80-64 0 0 48 0 16-32 0 0-16 0-48-48 0-16 0 0-32 16 0 48 0 0-64-80 0-16 0 0-32zm128-64l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm96-96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M272 64l0-16-32 0 0 16 0 80-64 0 0-48 0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 64-80 0-16 0 0 32 16 0 80 0 0 64-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 64 0 0 80 0 16 32 0 0-16 0-80 64 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-64 80 0 16 0 0-32-16 0-80 0 0-64 48 0 16 0 0-32-16 0-48 0 0-48 0-16-32 0 0 16 0 48-64 0 0-80zm64 272l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zm0-96l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64z']
      
    ]
  };

  

  
  

  var faCloudFog = {
    prefix: 'fasds',
    iconName: 'cloud-fog',
    icon: [
      640,
      512,
      [127787,"fog"],
      'f74e',
      
      ['M0 368l0 48 24 0 528 0 24 0 0-48-24 0L24 368 0 368zm64 96l0 48 24 0 112 0 24 0 0-48-24 0L88 464l-24 0zm208 0l0 48 24 0 320 0 24 0 0-48-24 0-320 0-24 0z','M64 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C320.5 24.3 283.1 0 240 0C178.1 0 128 50.1 128 112l0 21.5C90.7 146.6 64 182.2 64 224l0 96z']
      
    ]
  };

  
    var faFog = faCloudFog;
  

  
  

  var faFish = {
    prefix: 'fasds',
    iconName: 'fish',
    icon: [
      576,
      512,
      [128031],
      'f578',
      
      ['M0 160l48 96L0 352l32 32 110.8-55.4C182.2 377.1 246.6 432 336 432c160 0 240-176 240-176s-80-176-240-176c-89.4 0-153.8 54.9-193.2 103.4L32 128 0 160zm448 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M416 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64z']
      
    ]
  };

  

  
  

  var faCircleStar = {
    prefix: 'fasds',
    iconName: 'circle-star',
    icon: [
      512,
      512,
      ["star-circle"],
      'e123',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm103.8-49.4L209 191.3 256 96l47 95.3 105.1 15.3-76.1 74.2 18 104.7L256 336l-94 49.4 18-104.7-76.1-74.2z','M256 96l47 95.3 105.1 15.3-76.1 74.2 18 104.7L256 336l-94 49.4 18-104.7-76.1-74.2L209 191.3 256 96z']
      
    ]
  };

  
    var faStarCircle = faCircleStar;
  

  
  

  var faCircle1 = {
    prefix: 'fasds',
    iconName: 'circle-1',
    icon: [
      512,
      512,
      [],
      'e0ee',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm176-91.5L236.3 131l5.4-3 6.2 0 8 0 24 0 0 24 0 184 32 0 24 0 0 48-24 0-56 0-56 0-24 0 0-48 24 0 32 0 0-147.7L187.7 213 176 219.5l0-54.9z','M241.8 128l6.2 0 8 0 24 0 0 24 0 184 32 0 24 0 0 48-24 0-56 0-56 0-24 0 0-48 24 0 32 0 0-147.7L187.7 213 176 219.5l0-54.9L236.3 131l5.4-3z']
      
    ]
  };

  

  
  

  var faCommentHeart = {
    prefix: 'fasds',
    iconName: 'comment-heart',
    icon: [
      512,
      512,
      [],
      'e5c8',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm144-36.8c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7c-27.6 26.5-55.2 53.1-82.8 79.6c-3.7 3.6-7.4 7.1-11.1 10.7c-3.7-3.6-7.4-7.1-11.1-10.7c-27.6-26.5-55.2-53.1-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z','M203.2 144c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 336.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z']
      
    ]
  };

  

  
  

  var faStarSharp = {
    prefix: 'fasds',
    iconName: 'star-sharp',
    icon: [
      576,
      512,
      [],
      'e28b',
      
      ['M288.1 0l63.5 195.6H557.2L390.9 316.4 454.4 512 288.1 391.1 121.7 512l63.5-195.6L18.9 195.6H224.5L288.1 0z','']
      
    ]
  };

  

  
  

  var faUserMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'user-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e5c5',
      
      ['M0 512l448 0-9.9-32.3C354.3 474.6 288 405 288 320c0-5.4 .3-10.7 .8-16L64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M528 320.1a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM520 426c-20.5 14-45.3 22.1-72 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426z']
      
    ]
  };

  

  
  

  var faTruckFast = {
    prefix: 'fasds',
    iconName: 'truck-fast',
    icon: [
      640,
      512,
      ["shipping-fast"],
      'f48b',
      
      ['M0 96l0 32 64 0 224 0 0-32L64 96 0 96zM0 224l0 32 64 0 160 0 0-32L64 224 0 224zm32-64l0 32 32 0 192 0 0-32L64 160l-32 0zM96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M64 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 64 32 0 0 64-32 0-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L64 416l0-160 160 0 0-32L64 224l0-32 192 0 0-32L64 160l0-32 224 0 0-32L64 96 64 0zM416 256l128 0 0-18.7L466.7 160 416 160l0 96z']
      
    ]
  };

  
    var faShippingFast = faTruckFast;
  

  
  

  var faLacrosseStickBall = {
    prefix: 'fasds',
    iconName: 'lacrosse-stick-ball',
    icon: [
      576,
      512,
      [],
      'e3b6',
      
      ['M2.7 464L48 509.3l22.6-22.6 120-120c-18.7-11-34.3-26.6-45.3-45.3l-120 120L2.7 464zM416 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M264.8 117.7l-10 35.1L253 159l-4 5-43.2 54c-8.9 11.1-13.8 25-13.8 39.2c0 34.7 28.1 62.8 62.8 62.8c14.3 0 28.1-4.9 39.2-13.8L348 263l5-4 6.2-1.8 35.1-10c31.8-9.1 53.7-38.1 53.7-71.2c0 0 0 0 0 0l0-.3c0-19.9-13.6-48.1-38.6-73.1s-53.2-38.6-73.1-38.6l-.3 0s0 0 0 0c-33.1 0-62.1 21.9-71.2 53.7zM512 176.1c0 61.6-40.9 115.7-100.1 132.7L383 317l-49 39.2c-22.5 18-50.4 27.8-79.2 27.8c-70 0-126.8-56.8-126.8-126.8c0-28.8 9.8-56.7 27.8-79.2L195 129l8.3-28.9C220.2 40.9 274.4 0 336 0c0 0 0 0 0 0l.3 0c43.8 0 87.4 26.4 118.4 57.3s57.3 74.5 57.3 118.4c0 .1 0 .3 0 .4z']
      
    ]
  };

  

  
  

  var faSquareChevronRight = {
    prefix: 'fasds',
    iconName: 'square-chevron-right',
    icon: [
      448,
      512,
      ["chevron-square-right"],
      'f32b',
      
      ['M0 32L0 480l448 0 0-448L0 32zM158.1 152L192 118.1c5.7 5.7 11.3 11.3 17 17c34.7 34.7 69.3 69.3 104 104c5.7 5.7 11.3 11.3 17 17l-17 17c-34.7 34.7-69.3 69.3-104 104c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c29-29 58-58 87-87c-29-29-58-58-87-87c-5.7-5.7-11.3-11.3-17-17z','M329.9 256l-17 17L209 377l-17 17L158.1 360l17-17 87-87-87-87-17-17L192 118.1l17 17L313 239l17 17z']
      
    ]
  };

  
    var faChevronSquareRight = faSquareChevronRight;
  

  
  

  var faPersonSnowboarding = {
    prefix: 'fasds',
    iconName: 'person-snowboarding',
    icon: [
      512,
      512,
      [127938,"snowboarding"],
      'f7ce',
      
      ['M-9.9 312L7 329l32 32 3.6 3.6 4.8 1.8 376 144 4.1 1.6 4.4 0 40 0 24 0 0-48-24 0-35.6 0c-27.7-10.6-55.4-21.2-83-31.8c-20.1-7.7-40.2-15.4-60.3-23.1c-51.4-19.7-102.7-39.3-154.1-59c-13.2-5.1-26.5-10.1-39.7-15.2c-10-3.8-19.9-7.6-29.9-11.4L41 295l-17-17L-9.9 312z','M432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM227.4 110.3l-40-80L244.6 1.7l33 66 64.7 12.9 7.4 1.5 6 4.6 144 112 25.3 19.6-39.3 50.5-25.3-19.6-72.1-56.1-71.5 31.8 55.8 46.5L387.6 284l-4.4 19.2-24 104-5.8 25-60.3-23.1 3.8-16.3L316.4 308 256 257.7l0 30.3 0 23.1-21.9 7.3L139 350.1 99.2 334.9 87.5 299.8l30.4-10.1L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-22.8-4.6-15.3-3.1-7-14z']
      
    ]
  };

  
    var faSnowboarding = faPersonSnowboarding;
  

  
  

  var faArrowsRetweet = {
    prefix: 'fasds',
    iconName: 'arrows-retweet',
    icon: [
      640,
      512,
      ["retweet-alt"],
      'f361',
      
      ['M304 96l32 0 176 0 32 0 0 32 0 210.7 25.4-25.4L592 290.7 637.3 336l-22.6 22.6-80 80L512 461.3l-22.6-22.6-80-80L386.7 336 432 290.7l22.6 22.6L480 338.7 480 160l-144 0-32 0 0-64z','M128 50.7l22.6 22.6 80 80L253.3 176 208 221.3l-22.6-22.6L160 173.3 160 352l144 0 32 0 0 64-32 0-176 0-32 0 0-32 0-210.7L70.6 198.6 48 221.3 2.7 176l22.6-22.6 80-80L128 50.7z']
      
    ]
  };

  
    var faRetweetAlt = faArrowsRetweet;
  

  
  

  var faUserHeadset = {
    prefix: 'fasds',
    iconName: 'user-headset',
    icon: [
      448,
      512,
      [],
      'f82d',
      
      ['M96 192c0-70.7 57.3-128 128-128s128 57.3 128 128c0 23.3-6.2 45.2-17.1 64L304 256l0-32-32 0-96 0-32 0 0 32 0 35.9c-29.3-23.5-48-59.5-48-99.9z','M224 32C135.6 32 64 103.6 64 192l0 32-32 0 0-32C32 86 118 0 224 0S416 86 416 192l0 112 0 16-16 0-128 0-48 0-48 0 0-64 96 0 0 32 112 0 0-96c0-88.4-71.6-160-160-160zM448 512L0 512 48 352l352 0 48 160z']
      
    ]
  };

  

  
  

  var faY = {
    prefix: 'fasds',
    iconName: 'y',
    icon: [
      384,
      512,
      [121],
      '59',
      
      ['M1.1 32L160 296.9 160 448l0 32 64 0 0-32 0-151.1L382.9 32l-74.6 0L192 225.8 75.7 32 1.1 32z','']
      
    ]
  };

  

  
  

  var faCarBurst = {
    prefix: 'fasds',
    iconName: 'car-burst',
    icon: [
      640,
      512,
      ["car-crash"],
      'f5e1',
      
      ['M4.4 215.2L100 236.6l-.4 98 58.4-47 4.2-15.5 24.8-92.7 8.3-30.9 30.9 8.3 14.4 3.9 60-76.3 10.8-13.7 2.1-4.4L218.2 88.5 176 0 133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2z','M359.3 93l-20.4-5.5-13 16.6L252.8 197 218 187.6l-24.8 92.7-16.6 61.8L160 404l77.3 20.7 16.6-61.8 247.3 66.3L484.6 491l77.3 20.7 16.6-61.8L595 388l24.8-92.7L585 286 568.1 169l-3-20.9-20.4-5.5L359.3 93zM517.7 268L320 215l43.1-54.7L507.8 199l9.9 68.9zM251.4 279.4a24 24 0 1 1 46.4 12.4 24 24 0 1 1 -46.4-12.4zM528 328.7a24 24 0 1 1 -12.4 46.4A24 24 0 1 1 528 328.7z']
      
    ]
  };

  
    var faCarCrash = faCarBurst;
  

  
  

  var faBoxDollar = {
    prefix: 'fasds',
    iconName: 'box-dollar',
    icon: [
      448,
      512,
      ["box-usd"],
      'f4a0',
      
      ['M0 160l208 0 0-128L64 32 0 160zM240 32l0 128 208 0L384 32 240 32z','M240 160l208 0 0 320L0 480 0 160l208 0 0-128 32 0 0 128z']
      
    ]
  };

  
    var faBoxUsd = faBoxDollar;
  

  
  

  var faWind = {
    prefix: 'fasds',
    iconName: 'wind',
    icon: [
      512,
      512,
      [],
      'f72e',
      
      ['M0 224l0 64 32 0 384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-32 0 0 64 32 0 32 0c53 0 96-43 96-96s-43-96-96-96L32 224 0 224z','M320 0L288 0l0 64 32 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128 0 128l0 64 32 0 320 0c53 0 96-43 96-96s-43-96-96-96L320 0zM128 512l32 0c53 0 96-43 96-96s-43-96-96-96L32 320 0 320l0 64 32 0 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0-32 0 0 64 32 0z']
      
    ]
  };

  

  
  

  var faCircleExclamationCheck = {
    prefix: 'fasds',
    iconName: 'circle-exclamation-check',
    icon: [
      640,
      512,
      [],
      'e10d',
      
      ['M0 256C0 397.4 114.6 512 256 512c86.4 0 162.8-42.8 209.1-108.3l-38.4-38.4-64-64L317.5 256 408 165.5l45.3 45.3L472 229.5l33-33C478.2 83.8 376.9 0 256 0C114.6 0 0 114.6 0 256zM232 128l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M280 128l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 320l0 48 48 0 0-48-48 0zM617 209l17-17L600 158.1l-17 17-111 111-47-47-17-17L374.1 256l17 17 64 64 17 17 17-17L617 209z']
      
    ]
  };

  

  
  

  var faWreathLaurel = {
    prefix: 'fasds',
    iconName: 'wreath-laurel',
    icon: [
      640,
      512,
      [],
      'e5d2',
      
      ['M173.3 466.5l21.5 42.9L253.7 480l66.3 0c-1.3 0-2.6 0-3.8 0s-2.6-.1-3.8-.1c-2.6-.1-5.1-.2-7.6-.4c-5.1-.3-10.1-.8-15-1.5c-9.9-1.3-19.6-3.3-29.1-5.9c-18.9-5.2-36.8-12.8-53.4-22.5l-33.9 17zM320 432l72 0 5.7 0c1.7 .8 3.4 1.7 5.1 2.5l30.1 15c5.1-3 10.1-6.1 14.9-9.5c59.6 28.2 131.9 6.3 165.4-51.8l16-27.7-13.9-8c-13.8-8-28.4-13.1-43.3-15.5c40.4-21.5 68-64.1 68-113.1l0-32-16 0c-15.9 0-31.1 2.9-45.2 8.2c24.3-38.8 26.8-89.5 2.3-131.9l-16-27.7-13.9 8C525 63.7 506.2 86.8 496 113l0-1C496 50.1 445.9 0 384 0L352 0l0 32c0 60.2 47.5 109.3 107 111.9c23.9 32.2 37 71.5 37 112.1c0 97.2-78.8 176-176 176z','M144 112C144 50.1 194.1 0 256 0l32 0 0 32c0 60.2-47.5 109.3-107 111.9c-23.9 32.2-37 71.5-37 112.1c0 97.2 78.8 176 176 176l72 0 5.7 0 5.1 2.5 64 32-21.5 42.9L386.3 480 320 480c-47.5 0-91.5-14.8-127.7-39.9c-59.6 28.2-131.9 6.3-165.4-51.8l-16-27.7 13.9-8c13.8-8 28.4-13.1 43.3-15.5C27.5 315.6 0 273 0 224l0-32 16 0c15.9 0 31.1 2.9 45.2 8.2c-24.3-38.8-26.8-89.5-2.3-131.9l16-27.7 13.9 8C115 63.7 133.8 86.8 144 113l0-1z']
      
    ]
  };

  

  
  

  var faMegaphone = {
    prefix: 'fasds',
    iconName: 'megaphone',
    icon: [
      576,
      512,
      [128227],
      'f675',
      
      ['M0 160l0 32L0 320l0 32 64 0 0-30.9c34.1 9.7 68.1 19.3 102.2 29c15.5 4.4 31 8.8 46.5 13.2c30.3 8.6 60.7 17.2 91 25.8c15.5 4.4 31 8.8 46.5 13.2L512 448l0-384L64 190.9 64 160 0 160z','M576 32l-64 0 0 448 64 0 0-448zM160 384c0 53 43 96 96 96c46.8 0 85.8-33.5 94.3-77.8L303.7 389c-2.5 24.2-22.9 43-47.7 43c-26.5 0-48-21.5-48-48c0-7.4 1.7-14.5 4.7-20.8L166.2 350c-4 10.6-6.2 22-6.2 34z']
      
    ]
  };

  

  
  

  var faUserShield = {
    prefix: 'fasds',
    iconName: 'user-shield',
    icon: [
      640,
      512,
      [],
      'f505',
      
      ['M0 512l426.1 0c-69.3-49.5-103.7-133.3-106-208L64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M496 275.5l0 184.9c56.5-26.3 90.2-87 95.3-148L496 275.5zM640 296c0 85.8-48 184-144 216c-96-32-144-130.2-144-216l0-16.2L496 224l144 55.8 0 16.2z']
      
    ]
  };

  

  
  

  var faMushroom = {
    prefix: 'fasds',
    iconName: 'mushroom',
    icon: [
      512,
      512,
      [127812],
      'e425',
      
      ['M96 224a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM144 96c0 44.2 35.8 80 80 80s80-35.8 80-80c0-25.8-12.2-48.8-31.2-63.4c-.2-.1-.3-.2-.5-.4c-3.5-.2-6.9-.2-10.4-.2l-11.8 0c-33.1 0-64.5 7.1-92.9 19.9c-.7 1-1.3 2-1.9 3C148.1 66.9 144 81 144 96zm16 384l192 0L312 320l-112 0L160 480zM368 176c0 35.3 28.7 64 64 64c20.7 0 39.1-9.8 50.8-25.1c.3-.4 .6-.8 .9-1.1c-7.6-38.3-24.9-73.1-49.2-101.7c-.8 0-1.7 0-2.5 0c-.2 0-.5 0-.7 0c-35 .4-63.3 28.9-63.3 64z','M224 176c44.2 0 80-35.8 80-80c0-25.8-12.2-48.8-31.2-63.4C336 37.1 392.2 66.9 431.3 112c-35 .4-63.3 28.9-63.3 64c0 35.3 28.7 64 64 64c20.7 0 39.1-9.8 50.8-25.1c3.4 15.8 5.2 32.2 5.2 49.1l0 32 0 24-24 0L48 320l-24 0 0-24 0-32C24 171.9 77.6 92.4 155.3 54.9C148.1 66.9 144 81 144 96c0 44.2 35.8 80 80 80zm-96 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faPlanetRinged = {
    prefix: 'fasds',
    iconName: 'planet-ringed',
    icon: [
      512,
      512,
      [129680],
      'e020',
      
      ['M8.1 503.9s-4-58.2 59.2-158.8c.1-.2 .3-.4 .5-.4c2.2 4.7 4.6 9.3 7.2 13.9c2.6 4.6 5.4 9 8.5 13.7c3 4.4 6.2 8.8 9.7 13.2c1.7 2.1 3.4 4.2 5.3 6.4c.9 1 1.7 2 2.8 3.2c.8 .9 1.7 1.8 2.6 2.8c-5.7 8.8-11.1 17.8-16.3 26.9c9.1-5.2 18-10.6 26.9-16.3c58.5-37.6 111.3-85 160.1-133.8s96.3-101.7 133.8-160.1c5.7-8.8 11.1-17.8 16.3-26.9c-9.1 5.2-18 10.6-26.9 16.3c-2.1-1.9-4.1-3.7-6.2-5.5c-2.2-1.9-4.3-3.7-6.6-5.4c-2-1.6-4-3.1-6-4.6c-2.4-1.8-4.9-3.5-7.4-5.2c-2.1-1.4-4.2-2.7-6.3-4.1c-2.3-1.4-4.7-2.8-7-4.2c-2.2-1.2-4.4-2.4-6.7-3.6c-2.4-1.2-4.7-2.4-6.2-4.1c89.2-55.9 145-59 156.4-59c1.4 0 2.1 0 2.1 0s4 58.4-59.6 159.4c-27.2 43.3-66.9 94.4-124.6 152.1S210.9 417.1 167.5 444.3C66.5 507.9 8.1 503.9 8.1 503.9z','M408.3 114.3C370.3 73.5 316.1 48 256 48C141.1 48 48 141.1 48 256c0 60.1 25.5 114.3 66.3 152.3c58.5-37.6 111.3-85 160.1-133.8s96.3-101.7 133.8-160.1zm36 53.2c-27.2 43.3-66.9 94.4-124.6 152.1S210.9 417.1 167.5 444.3C194.4 456.9 224.4 464 256 464c114.9 0 208-93.1 208-208c0-31.6-7.1-61.6-19.7-88.5z']
      
    ]
  };

  

  
  

  var faUserDoctorHair = {
    prefix: 'fasds',
    iconName: 'user-doctor-hair',
    icon: [
      448,
      512,
      [],
      'e458',
      
      ['M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11.1-1.4-21.8-4-32l-60 0L256 64l-48 48L97 112c-.7 5.2-1 10.6-1 16z','M208 112L97 112C104.9 48.9 158.7 0 224 0c59.6 0 109.8 40.8 124 96l-60 0L256 64l-48 48zM160 370.3l0-66.3 128 0 0 58c-27.6 7.1-48 32.2-48 62l0 40 0 16 16 0 16 0 16 0 0-32-16 0 0-24c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24-16 0 0 32 16 0 16 0 16 0 0-16 0-40c0-29.8-20.4-54.9-48-62l0-58 64 0 64 208L0 512 64 304l64 0 0 66.3c-23.1 6.9-40 28.3-40 53.7c0 30.9 25.1 56 56 56s56-25.1 56-56c0-25.4-16.9-46.8-40-53.7zM120 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z']
      
    ]
  };

  

  
  

  var faSquareY = {
    prefix: 'fasds',
    iconName: 'square-y',
    icon: [
      448,
      512,
      [],
      'e287',
      
      ['M0 32L0 480l448 0 0-448L0 32zM88.6 144l59.5 0L224 247.4 299.8 144l59.5 0L248 295.9l0 80.1 0 24-48 0 0-24 0-80.1L88.6 144z','M88.6 144L200 295.9l0 80.1 0 24 48 0 0-24 0-80.1L359.4 144l-59.5 0L224 247.4 148.2 144l-59.5 0z']
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fasds',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM120.1 391.6L144 320l224 0 23.9 71.6C357.1 426.5 309.1 448 256 448s-101.1-21.5-135.9-56.4zM328 200a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z','M256 448c53.1 0 101.1-21.5 135.9-56.4L368 320l-224 0-23.9 71.6C154.9 426.5 202.9 448 256 448zm0-176a72 72 0 1 0 0-144 72 72 0 1 0 0 144z']
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faJugDetergent = {
    prefix: 'fasds',
    iconName: 'jug-detergent',
    icon: [
      384,
      512,
      [],
      'e519',
      
      ['M64 48l0 48 192 0 0-48-32 0 0-48L96 0l0 48L64 48z','M128 128C57.3 128 0 185.3 0 256L0 512l384 0 0-384-256 0zm192 96l0 160-64 0 0-160 64 0z']
      
    ]
  };

  

  
  

  var faDiagramSubtask = {
    prefix: 'fasds',
    iconName: 'diagram-subtask',
    icon: [
      512,
      512,
      [],
      'e479',
      
      ['M96 224l0 160 0 32 32 0 96 0 0-64-64 0 0-128-64 0z','M512 32L0 32 0 224l512 0 0-192zm0 256l-288 0 0 192 288 0 0-192z']
      
    ]
  };

  

  
  

  var faListCheck = {
    prefix: 'fasds',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      ['M160 384l0 64 32 0 288 0 32 0 0-64-32 0-288 0-32 0zM224 64l0 64 32 0 224 0 32 0 0-64-32 0L256 64l-32 0zm0 160l0 64 32 0 224 0 32 0 0-64-32 0-224 0-32 0z','M153.8 72.1l16.1-17.8L134.2 22.1 118.2 39.9 63.1 101.1 41 79l-17-17L-9.9 96 7 113l40 40 17.9 17.9 16.9-18.8 72-80zm0 160l16.1-17.8-35.7-32.1-16.1 17.8L63.1 261.1 41 239l-17-17L-9.9 256 7 273l40 40 17.9 17.9 16.9-18.8 72-80zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z']
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faShrimp = {
    prefix: 'fasds',
    iconName: 'shrimp',
    icon: [
      512,
      512,
      [129424],
      'e448',
      
      ['M0 32l16 0 448 0 16 0 0 32-16 0L32 64l0 64 32 0c0 7.9 0 15.9 0 24.3l0-.4c0 1.5 0 2.7 0 3.8c0 .3 0 .5 0 .6c0 1.2 .1 2.3 .1 3.7L16 160 0 160l0-16L0 48 0 32zm288 96l32 0c0 64 0 128 0 192l-32 0c0-64 0-128 0-192zm32 279.8c1.1 .4 2.1 .7 3.2 1.1c9.9 3.4 19.9 3.3 28.8 .5l0 69.9c-5.3 .5-10.6 .7-16 .7l-16 0c0-24.1 0-48.2 0-72.2zm41.6-2.7c9.7-5.7 17.2-15 20.5-26.2L472.6 415c-7.3 9-15.5 17.3-24.5 24.7c-28.8-11.5-57.7-23.1-86.5-34.6zm3.3-76.5c44.5-30.8 89-61.6 133.5-92.4c4.3 10.2 7.6 20.9 9.9 32.1c-41.9 29-83.7 58-125.6 86.9c-2.6-10.9-9.1-20.2-17.9-26.5z','M64 128l0 23.9C63.5 244.6 139.3 320 232 320l56 0 0-192L88.8 128 64 128zM338.3 320c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128l-16 0 0 192 18.3 0zm170.1-51.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9zM352 409.4l0 69.9c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3zM320 480l0-72.2-96-33.6L224 480l96 0zM192 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faCircleDivide = {
    prefix: 'fasds',
    iconName: 'circle-divide',
    icon: [
      512,
      512,
      [],
      'e106',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-24l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm80-104l64 0 0 64-64 0 0-64zm0 192l64 0 0 64-64 0 0-64z','M224 128l64 0 0 64-64 0 0-64zM144 232l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm144 88l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faBorderLeft = {
    prefix: 'fasds',
    iconName: 'border-left',
    icon: [
      448,
      512,
      [],
      'f84f',
      
      ['M96 32l64 0 0 64L96 96l0-64zm0 192l64 0 0 64-64 0 0-64zm0 192l64 0 0 64-64 0 0-64zM192 32l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zM288 32l64 0 0 64-64 0 0-64zm0 192l64 0 0 64-64 0 0-64zm0 192l64 0 0 64-64 0 0-64zM384 32l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M0 480L0 32l64 0 0 448L0 480z']
      
    ]
  };

  

  
  

  var faTv = {
    prefix: 'fasds',
    iconName: 'tv',
    icon: [
      640,
      512,
      [63717,"television","tv-alt"],
      'f26c',
      
      ['M0 0L64 0 576 0l64 0 0 64 0 288 0 64-64 0L64 416 0 416l0-64L0 64 0 0zM64 64l0 288 512 0 0-288L64 64zM96 448l32 0 384 0 32 0 0 64-32 0-384 0-32 0 0-64z','M64 64H576V352H64V64z']
      
    ]
  };

  
    var faTelevision = faTv;
  
    var faTvAlt = faTv;
  

  
  

  var faDownFromDottedLine = {
    prefix: 'fasds',
    iconName: 'down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e407',
      
      ['M0 32L0 96l64 0 0-64L0 32zm96 0l0 64 64 0 0-64L96 32zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z','M224 480L64 320l0-32 96 0 0-160 128 0 0 160 96 0 0 32L224 480z']
      
    ]
  };

  

  
  

  var faArrowUp = {
    prefix: 'fasds',
    iconName: 'arrow-up',
    icon: [
      384,
      512,
      [8593],
      'f062',
      
      ['M160 157.3c10.7-10.7 21.3-21.3 32-32c10.7 10.7 21.3 21.3 32 32L224 448l0 32-64 0 0-32 0-290.7z','M192 34.8l22.6 22.6 144 144L381.3 224 336 269.3l-22.6-22.6L192 125.3 70.6 246.6 48 269.3 2.7 224l22.6-22.6 144-144L192 34.8z']
      
    ]
  };

  

  
  

  var faBoneBreak = {
    prefix: 'fasds',
    iconName: 'bone-break',
    icon: [
      640,
      512,
      [],
      'f5d8',
      
      ['M0 272c0 38.6 27.3 70.8 63.7 78.3L66.8 366C45.8 380.4 32 404.6 32 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-7.6-1-14.9-3-21.8L320 384 288 224 157 250.2c-9.5-33.6-40.4-58.2-77-58.2c-44.2 0-80 35.8-80 80zM320 384l131 26.2c-2 6.9-3 14.2-3 21.8c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.4-13.8-51.6-34.8-66l3.1-15.7c36.3-7.5 63.7-39.7 63.7-78.3c0-44.2-35.8-80-80-80c-36.6 0-67.5 24.6-77 58.2L352 224 320 384z','M344 8l0 24 0 72 0 24-48 0 0-24 0-72 0-24 48 0zM184 54.1l17 17 48 48 17 17L232 169.9l-17-17-48-48-17-17L184 54.1zM489.9 88l-17 17-48 48-17 17L374.1 136l17-17 48-48 17-17L489.9 88z']
      
    ]
  };

  

  
  

  var faLandmarkDome = {
    prefix: 'fasds',
    iconName: 'landmark-dome',
    icon: [
      512,
      512,
      ["landmark-alt"],
      'f752',
      
      ['M0 464l0 48 512 0 0-48-64-48 0-160-64 0 0 160-40 0 0-160-64 0 0 160-48 0 0-160-64 0 0 160-40 0 0-160-64 0 0 160L0 464z','M288 0L224 0l0 34.7C143.6 48.1 80.1 111.6 66.7 192L64 192l-32 0 0 64 32 0 384 0 32 0 0-64-32 0-2.7 0C431.9 111.6 368.4 48.1 288 34.7L288 0z']
      
    ]
  };

  
    var faLandmarkAlt = faLandmarkDome;
  

  
  

  var faBrazilianRealSign = {
    prefix: 'fasds',
    iconName: 'brazilian-real-sign',
    icon: [
      512,
      512,
      [],
      'e46c',
      
      ['M288 165.9c0 48.2 29.3 91.5 74.1 109.4l52 20.8c20.4 8.2 33.9 28 33.9 50l0 3.4c0 27.9-22.6 50.5-50.5 50.5c-12.9 0-25.6-3.8-36.3-11l-23.4-15.6-35.5 53.3 23.4 15.6c13 8.6 27.3 14.8 42.3 18.3l0 19.4 0 32 64 0 0-32 0-21.3c46.4-14.6 80-58 80-109.2l0-3.4c0-48.2-29.3-91.5-74.1-109.4l-52-20.8c-20.4-8.2-33.9-28-33.9-50c0-29.7 24.1-53.9 53.9-53.9l1.7 0c11.1 0 22 2.6 32 7.5l10.2 5.1 28.6-57.2-10.1-5.1c-11.5-5.7-23.6-9.8-36.2-12.1L432 32l0-32L368 0l0 32 0 22.2C321.5 70 288 114 288 165.9z','M32 32L0 32 0 64 0 288 0 480l64 0 0-160 40.6 0 51.2 160 67.2 0-.6-1.8L168.2 308.6c51.6-21.9 87.8-73 87.8-132.6c0-79.5-64.5-144-144-144L32 32zm80 224l-48 0L64 96l48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z']
      
    ]
  };

  

  
  

  var faHatWinter = {
    prefix: 'fasds',
    iconName: 'hat-winter',
    icon: [
      512,
      512,
      [],
      'f7a8',
      
      ['M0 416l32 0 448 0 32 0 0 96L0 512l0-96zM160 96l28.6-27.9-.5-40 40 .5L256 0l27.9 28.6 40-.5-.5 40L352 96l-28.6 27.9c.1 10.5 .2 20.9 .4 31.2c0 3 .1 5.9 .1 8.8c-13.3-.2-26.6-.3-40-.5c-9.3 9.5-18.6 19.1-27.9 28.6c-9.3-9.5-18.6-19.1-27.9-28.6c-13.3 .2-26.6 .3-40 .5l.1-8.8c.1-10.4 .2-20.8 .4-31.2L160 96z','M188.2 155.1c-67 23.8-105.5 82-127.5 137.4l18.7 9.4 48.6-27.8 7.9-4.5 7.9 4.5 48.6 27.8 56.3-28.2 7.2-3.6 7.2 3.6 56.3 28.2 48.6-27.8 7.9-4.5 7.9 4.5 48.6 27.8 18.7-9.4c-22-55.4-60.5-113.6-127.5-137.4l.1 8.8-40-.5L256 192l-27.9-28.6-40 .5 .1-8.8zM32 416l448 0s-2.5-42-18.1-93.1l-22.7 11.4-7.7 3.8-7.4-4.2L376 306.4l-48.1 27.5-7.4 4.2-7.7-3.8L256 305.9l-56.8 28.4-7.7 3.8-7.4-4.2L136 306.4 87.9 333.9l-7.4 4.2-7.7-3.8L50.1 322.9C34.5 374 32 416 32 416z']
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlay = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-play',
    icon: [
      512,
      512,
      [],
      'e660',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm145.8-91.8L303.9 208 145.8 299.8l0-183.6z','M303.9 208L145.8 299.8l0-183.6L303.9 208zM441.4 486.6L330.7 376C348 363.3 363.3 348 376 330.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6z']
      
    ]
  };

  

  
  

  var faPersonHarassing = {
    prefix: 'fasds',
    iconName: 'person-harassing',
    icon: [
      576,
      512,
      [],
      'e549',
      
      ['M307.9 471l54.3 33.9 17-27.1 26.7-42.7 57.6 57.6c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L576 320l0-32-32 0-32 0-13.3 0-9.4 9.4-16 16-9.4 9.4 0 13.3 0 66.7-41.4-41.4L372.9 367l-48 76.8-17 27.1zM384 240a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM88 256.9L59.4 304.5l-54.9-33 76.9-128L90.8 128l18.1 0 102.2 0 15.1 0 9.6 11.6 105.7 128-49.3 40.8L232 235.6 232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-223.1zM288 32l16 0 56 0 16 0 0 32-16 0-56 0-16 0 0-32zm-.8 65.7l48 24 14.3 7.2-14.3 28.6-14.3-7.2-48-24-14.3-7.2 14.3-28.6 14.3 7.2z']
      
    ]
  };

  

  
  

  var faNfcPen = {
    prefix: 'fasds',
    iconName: 'nfc-pen',
    icon: [
      576,
      512,
      [],
      'e1fa',
      
      ['M0 32L0 480l258 0 9-62.6 1.4-1.4L80 416l-16 0 0-16 0-288 0-16 16 0 64 0 16 0 0 32-16 0-48 0 0 256 204.4 0L352 332.4 352 128l-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-98.7 0-16 16 0 144 0 16 0 0 16 0 188.4 64-64L448 32 0 32z','M576 294.8l-71-71-41.3 41.3 71 71L576 294.8zm-63.9 63.9l-71-71L299.9 429 288 511.9 370.9 500 512.1 358.7z']
      
    ]
  };

  

  
  

  var faChessKing = {
    prefix: 'fasds',
    iconName: 'chess-king',
    icon: [
      448,
      512,
      [9818],
      'f43f',
      
      ['M32 480l48-48 288 0 48 48 0 32L32 512l0-32z','M256 32l0-32L192 0l0 32 0 16-16 0-32 0 0 64 32 0 16 0 0 48L0 160l0 48L80 432l288 0 80-224 0-48-192 0 0-48 16 0 32 0 0-64-32 0-16 0 0-16z']
      
    ]
  };

  

  
  

  var faRankingStar = {
    prefix: 'fasds',
    iconName: 'ranking-star',
    icon: [
      640,
      512,
      [],
      'e561',
      
      ['M0 320l192 0 0 192L0 512 0 320zm224-64l192 0 0 256-192 0 0-256zM448 384l192 0 0 128-192 0 0-128z','M320 0l31.8 62.3 69 11-49.4 49.5L382.3 192 320 160.3 257.7 192l10.9-69.1L219.2 73.3l69-11L320 0z']
      
    ]
  };

  

  
  

  var faPhoneOffice = {
    prefix: 'fasds',
    iconName: 'phone-office',
    icon: [
      576,
      512,
      [],
      'f67d',
      
      ['M96 0l0 32 0 384 128 0 0-384 0-32L96 0zM320 256l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM448 256l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M0 32l96 0 0 384 128 0 0-384 352 0 0 480L0 512 0 32zM512 96L320 96l0 96 192 0 0-96zM320 256l0 64 64 0 0-64-64 0zm192 0l-64 0 0 64 64 0 0-64zM448 384l0 64 64 0 0-64-64 0zm-64 0l-64 0 0 64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faEnvelopes = {
    prefix: 'fasds',
    iconName: 'envelopes',
    icon: [
      576,
      512,
      [],
      'e170',
      
      ['M96 32l0 56.9c2.2 1.6 4.5 3.2 6.7 4.8C180.5 149.2 258.2 204.8 336 260.3c77.8-55.6 155.5-111.1 233.3-166.6c2.2-1.6 4.5-3.2 6.7-4.8L576 32 96 32zm0 96.2L96 384l480 0 0-255.8C499.1 183.2 422.2 238.1 345.3 293c-3.1 2.2-6.2 4.4-9.3 6.6c-3.1-2.2-6.2-4.4-9.3-6.6C249.8 238.1 172.9 183.2 96 128.2z','M336 299.7l9.3-6.6L576 128.2l0-39.3-6.7 4.8L336 260.3 102.7 93.7 96 88.9l0 39.3L326.7 293l9.3 6.6zM48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312z']
      
    ]
  };

  

  
  

  var faDownLong = {
    prefix: 'fasds',
    iconName: 'down-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-down"],
      'f309',
      
      ['M96 0l0 320 128 0c0-42.7 0-85.3 0-128c0-64 0-128 0-192L96 0z','M0 352L160 512 320 352l0-32s0 0 0 0l-96 0L96 320 0 320l0 32z']
      
    ]
  };

  
    var faLongArrowAltDown = faDownLong;
  

  
  

  var faJugBottle = {
    prefix: 'fasds',
    iconName: 'jug-bottle',
    icon: [
      640,
      512,
      [],
      'e5fb',
      
      ['M416 175.2l0 216.2c.3 .2 .7 .4 1 .6c-.3 .2-.7 .4-1 .6L416 512l224 0 0-64c0-24.1-13.3-45.1-33-56c19.7-10.9 33-31.9 33-56c0-23.5-12.6-44-31.5-55.1c18.7-10.1 31.5-29.9 31.5-52.7c0-23.2-13.4-44.3-34.4-54.2l-29.8-14-127.5 0-29.8 14c-.8 .4-1.6 .8-2.4 1.2zM448 64l0 64 128 0 0-64L448 64z','M96 0L224 0l0 48 32 0 0 48L64 96l0-48 32 0L96 0zM0 256c0-70.7 57.3-128 128-128l256 0 0 384L0 512 0 256zm256-32l0 160 64 0 0-160-64 0z']
      
    ]
  };

  

  
  

  var faSdCards = {
    prefix: 'fasds',
    iconName: 'sd-cards',
    icon: [
      448,
      512,
      [],
      'e240',
      
      ['M0 96l0 24L0 488l0 24 24 0 336 0 24 0 0-48-24 0L48 464l0-344 0-24L0 96zM256 64l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm80 0l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0z','M448 0L416 0 224 0 210.7 0l-9.4 9.4-96 96L96 114.7 96 128l0 256 0 32 32 0 288 0 32 0 0-32 0-352 0-32zM304 88l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zm80 0l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faTowerCell = {
    prefix: 'fasds',
    iconName: 'tower-cell',
    icon: [
      576,
      512,
      [],
      'e585',
      
      ['M0 128c0 34.7 6.1 68 17.4 98.8L32 256l55.6-27.8C72.5 198 64 164 64 128s8.5-70 23.6-100.2L32 0 17.4 29.2C6.1 60 0 93.3 0 128zm112 0c0 28.3 6.7 55 18.5 78.7l42.9-21.5C164.9 168 160 148.6 160 128s4.9-40 13.5-57.3L130.5 49.3C118.7 73 112 99.7 112 128zM402.5 70.7C411.1 88 416 107.4 416 128s-4.9 40-13.5 57.3l42.9 21.5C457.3 183 464 156.3 464 128s-6.7-55-18.5-78.7L402.5 70.7zm85.9-42.9C503.5 58 512 92 512 128s-8.5 70-23.6 100.2L544 256l14.6-29.2C569.9 196 576 162.7 576 128s-6.1-68-17.4-98.8L544 0 488.4 27.8z','M336.9 169.3L496 512l-70.6 0-29.7-64-215.4 0-29.7 64L80 512 239.1 169.3C229.7 158.2 224 143.7 224 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15.7-5.7 30.2-15.1 41.3zM210 384l156 0-14.9-32-126.3 0L210 384zm111.4-96L288 216l-33.4 72 66.9 0z']
      
    ]
  };

  

  
  

  var faSchoolLock = {
    prefix: 'fasds',
    iconName: 'school-lock',
    icon: [
      640,
      512,
      [],
      'e56f',
      
      ['M0 96L0 512l256 0 0-96c0-35.3 28.7-64 64-64l64 0 0-64 32 0 0-16c0-61.9 50.1-112 112-112s112 50.1 112 112l0-176L480 96 320 0 160 96 0 96zm80 96l64 0 0 96-64 0 0-96zm0 128l64 0 0 96-64 0 0-96zM408 176a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zM304 128l0 16 0 32 0 16 16 0 32 0 16 0 0-32-16 0-16 0 0-16 0-16-32 0z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faCircleEllipsis = {
    prefix: 'fasds',
    iconName: 'circle-ellipsis',
    icon: [
      512,
      512,
      [],
      'e10a',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM128 224l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z','M128 288l64 0 0-64-64 0 0 64zm160 0l0-64-64 0 0 64 64 0zm96 0l0-64-64 0 0 64 64 0z']
      
    ]
  };

  

  
  

  var faWatermelonSlice = {
    prefix: 'fasds',
    iconName: 'watermelon-slice',
    icon: [
      512,
      512,
      [],
      'e337',
      
      ['M34.6 384.6L41 391c72.9 72.9 179.6 91.1 269.2 54.5c3.6-1.5 7.2-3.1 10.8-4.7c3.6-1.7 7.1-3.4 10.7-5.3c3.5-1.8 7-3.8 10.5-5.8c10.9-6.4 21.4-13.8 31.4-22c1.4-1.1 2.7-2.2 4.1-3.4c.5-.4 1-.9 1.5-1.3c.7-.7 1.5-1.3 2.2-2c.4-.4 .9-.8 1.3-1.2c1.4-1.3 2.8-2.6 4.2-3.9c.2-.2 .4-.3 .5-.5c1.2-1.2 2.4-2.3 3.6-3.5c.1-.1 .3-.3 .5-.5c3-3 5.9-6 8.7-9.1c2.8-3.1 5.5-6.3 8.2-9.5c.1-.1 .3-.3 .4-.5c2.5-3.1 5-6.3 7.3-9.5c2.6-3.5 5-7 7.4-10.7c2.2-3.3 4.2-6.6 6.2-10c.2-.3 .3-.5 .5-.8c.9-1.5 1.8-3 2.6-4.6c.3-.4 .5-.9 .8-1.4c.6-1.1 1.2-2.2 1.8-3.3c.1-.1 .1-.2 .2-.4c1.8-3.5 3.6-7 5.2-10.5c42.8-91.7 26.1-204.2-49.7-280c-2.1-2.1-4.3-4.3-6.2-6.6C268 151.2 151.3 267.9 34.6 384.6zM153.4 336c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c5.3 5.3 10.7 10.7 16 16c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-16-16L153.4 336zm80-80c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c5.3 5.3 10.7 10.7 16 16c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-16-16c-3.8-3.8-7.5-7.5-11.3-11.3zm8 88c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c5.3 5.3 10.7 10.7 16 16c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-16-16c-3.8-3.8-7.5-7.5-11.3-11.3zm72-168c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c5.3 5.3 10.7 10.7 16 16c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-5.3-5.3-10.7-10.7-16-16c-3.8-3.8-7.5-7.5-11.3-11.3zm8 88c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c5.3 5.3 10.7 10.7 16 16c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-5.3-5.3-10.7-10.7-16-16c-3.8-3.8-7.5-7.5-11.3-11.3z','M41 391l-6.4-6.4L.6 418.6 7 425s0 0 0 0c115.6 115.6 302.6 116 418.3 .3S540.5 122.6 425 7L418.6 .6 384.6 34.6 391 41c96.9 96.9 97.1 253.6 .3 350.4S137.9 487.9 41 391c0 0 0 0 0 0zM347.3 164.7L336 153.4 313.4 176l11.3 11.3 16 16L352 214.6 374.6 192l-11.3-11.3-16-16zm-80 80L256 233.4 233.4 256l11.3 11.3 16 16L272 294.6 294.6 272l-11.3-11.3-16-16zm88 8L344 241.4 321.4 264l11.3 11.3 16 16L360 302.6 382.6 280l-11.3-11.3-16-16zm-168 72L176 313.4 153.4 336l11.3 11.3 16 16L192 374.6 214.6 352l-11.3-11.3-16-16zm88 8L264 321.4 241.4 344l11.3 11.3 16 16L280 382.6 302.6 360l-11.3-11.3-16-16z']
      
    ]
  };

  

  
  

  var faHandHoldingMagic = {
    prefix: 'fasds',
    iconName: 'hand-holding-magic',
    icon: [
      576,
      512,
      [],
      'f6e5',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 32 0 0 64-32 0-80 0c-44.2 0-80-35.8-80-80s35.8-80 80-80L320 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 32-64 0 0-32 0-32 0-32 32 0 64 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L208 64z']
      
    ]
  };

  

  
  

  var faListUl = {
    prefix: 'fasds',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      ['M160 64l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zm0 160l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zm0 160l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64z','M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z']
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faCodeCompare = {
    prefix: 'fasds',
    iconName: 'code-compare',
    icon: [
      512,
      512,
      [],
      'e13a',
      
      ['M48 192c0-70.7 57.3-128 128-128l16 0 0-64 32 0 96 96-96 96-32 0 0-64-16 0c-35.3 0-64 28.7-64 64l0 160-8 0-48 0-8 0 0-160zM192 416l96-96 32 0 0 64 16 0c35.3 0 64-28.7 64-64l0-160c2.7 0 5.3 0 8 0l48 0 8 0 0 160c0 70.7-57.3 128-128 128l-16 0 0 64-32 0-96-96z','M408 56l0 48 48 0 0-48-48 0zM352 0l56 0 48 0 56 0 0 56 0 48 0 56-56 0-48 0-56 0 0-56 0-48 0-56zM56 408l0 48 48 0 0-48-48 0zM0 352l56 0 48 0 56 0 0 56 0 48 0 56-56 0-48 0L0 512l0-56 0-48 0-56z']
      
    ]
  };

  

  
  

  var faDropletDegree = {
    prefix: 'fasds',
    iconName: 'droplet-degree',
    icon: [
      512,
      512,
      ["dewpoint"],
      'f748',
      
      ['M352 112a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm112 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M384 320c0 106-86 192-192 192S0 426 0 320S192 0 192 0s192 214 192 320z']
      
    ]
  };

  
    var faDewpoint = faDropletDegree;
  

  
  

  var faSkullCrossbones = {
    prefix: 'fasds',
    iconName: 'skull-crossbones',
    icon: [
      448,
      512,
      [9760,128369],
      'f714',
      
      ['M-10.6 303.3l29 13.6 130.5 61.4L18.4 439.8l-29 13.6 27.3 57.9 29-13.6 178.4-84 178.4 84 29 13.6 27.3-57.9-29-13.6L299.1 378.4 429.6 317l29-13.6-27.3-57.9-29 13.6L224 343 45.6 259l-29-13.6-27.3 57.9z','M304 234.4c38.6-23 64-62.1 64-106.4C368 57.3 303.5 0 224 0S80 57.3 80 128c0 44.4 25.4 83.5 64 106.4l0 53.6 160 0 0-53.6zM136 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm144-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faClub = {
    prefix: 'fasds',
    iconName: 'club',
    icon: [
      512,
      512,
      [9827],
      'f327',
      
      ['M0 288c0 70.7 57.3 128 128 128c38.2 0 72.5-16.8 96-43.3L224 256l0-32 64 0 0 32 0 116.7c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128s-57.3-128-128-128c-1.4 0-2.7 0-4 .1c2.6-10.2 4-21 4-32.1C384 57.3 326.7 0 256 0S128 57.3 128 128c0 11.1 1.4 21.8 4 32.1c-1.3 0-2.7-.1-4-.1C57.3 160 0 217.3 0 288z','M288 224l0 32 0 192 32 0 32 0 0 64-32 0-32 0-64 0-32 0-32 0 0-64 32 0 32 0 0-192 0-32 64 0z']
      
    ]
  };

  

  
  

  var faHospitals = {
    prefix: 'fasds',
    iconName: 'hospitals',
    icon: [
      576,
      512,
      [],
      'f80e',
      
      ['M256 0L576 0l0 256-112 0-16 0 0 32 16 0 112 0 0 64-112 0-16 0 0 32 16 0 112 0 0 128-256 0 0-448-64 0 0-64zM368 120l0 48 40 0 0 40 48 0 0-40 40 0 0-48-40 0 0-40-48 0 0 40-40 0z','M408 80l0 40-40 0 0 48 40 0 0 40 48 0 0-40 40 0 0-48-40 0 0-40-48 0zM288 96L0 96 0 384l144 0 16 0 0 32-16 0L0 416l0 96 288 0 0-416zM168 176l0 40 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0z']
      
    ]
  };

  

  
  

  var faBookArrowRight = {
    prefix: 'fasds',
    iconName: 'book-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0b9',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32zM224 184c8 0 16 0 24 0l200 0c31.4 0 62.7 0 94.1 0l-39-39-17-17L520 94.1l17 17 80 80 17 17-17 17-80 80-17 17L486.1 288l17-17 39-39c-106 0-212 0-318.1 0l0-48z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0 0-152-200 0-24 0 0-48 24 0 200 0L448 0 416 0 384 0 96 0z']
      
    ]
  };

  

  
  

  var faBellPlus = {
    prefix: 'fasds',
    iconName: 'bell-plus',
    icon: [
      448,
      512,
      [],
      'f849',
      
      ['M0 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L256 0 192 0l0 51.2C119 66 64 130.6 64 208l0 88L0 368zM136 216l24 0 40 0 0-40 0-24 48 0 0 24 0 40 40 0 24 0 0 48-24 0-40 0 0 40 0 24-48 0 0-24 0-40-40 0-24 0 0-48z','M248 152l0 24 0 40 40 0 24 0 0 48-24 0-40 0 0 40 0 24-48 0 0-24 0-40-40 0-24 0 0-48 24 0 40 0 0-40 0-24 48 0zm40 296c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0 64 0z']
      
    ]
  };

  

  
  

  var faBatteryFull = {
    prefix: 'fasds',
    iconName: 'battery-full',
    icon: [
      576,
      512,
      [128267,"battery","battery-5"],
      'f240',
      
      ['M0 96l64 0 416 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0L64 416 0 416l0-64L0 160 0 96zm64 64l0 192 416 0 0-192L64 160z','M96 192h352v128H96V192z']
      
    ]
  };

  
    var faBattery = faBatteryFull;
  
    var faBattery5 = faBatteryFull;
  

  
  

  var faChevronDown = {
    prefix: 'fasds',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      ['M256 429.3l-22.6-22.6-192-192L18.7 192 64 146.7l22.6 22.6L256 338.7 425.4 169.4 448 146.7 493.3 192l-22.6 22.6-192 192L256 429.3z','']
      
    ]
  };

  

  
  

  var faMoneyBillSimpleWave = {
    prefix: 'fasds',
    iconName: 'money-bill-simple-wave',
    icon: [
      576,
      512,
      [],
      'e1f2',
      
      ['M208 256c0 53 35.8 96 80 96s80-43 80-96s-35.8-96-80-96s-80 43-80 96z','M0 60.3L0 451.7c96 48.9 192 24.5 288 0s192-48.9 288 0l0-391.5c-96-48.9-192-24.5-288 0s-192 48.9-288 0zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z']
      
    ]
  };

  

  
  

  var faHandsHoldingDiamond = {
    prefix: 'fasds',
    iconName: 'hands-holding-diamond',
    icon: [
      640,
      512,
      ["hand-receiving"],
      'f47c',
      
      ['M0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40L0 64zM352 338.7l0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0 0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4z','M192 128L320 256 448 128 320 0 192 128z']
      
    ]
  };

  
    var faHandReceiving = faHandsHoldingDiamond;
  

  
  

  var faUserHoodie = {
    prefix: 'fasds',
    iconName: 'user-hoodie',
    icon: [
      448,
      512,
      [],
      'e68a',
      
      ['M128 157.3C128 232 224 288 224 288s96-56 96-130.7c0-51.5-43-93.3-96-93.3s-96 41.8-96 93.3z','M327.3 282.2C362 252.9 384 209 384 160C384 71.6 312.4 0 224 0S64 71.6 64 160c0 49 22 92.9 56.7 122.2L118 304l-54 0L0 512l448 0L384 304l-54 0-2.7-21.8zM160 384l0 16 0 64 0 16-32 0 0-16 0-64 0-16 32 0zm160 0l0 16 0 64 0 16-32 0 0-16 0-64 0-16 32 0zM128 157.3c0-51.5 43-93.3 96-93.3s96 41.8 96 93.3C320 232 224 288 224 288s-96-56-96-130.7z']
      
    ]
  };

  

  
  

  var faTransporter2 = {
    prefix: 'fasds',
    iconName: 'transporter-2',
    icon: [
      512,
      512,
      [],
      'e044',
      
      ['M0 48L32 32 48 0 64 32 96 48 64 64 48 96 32 64 0 48zM96 255.5c0 .2 0 .3 0 .5c5.3 0 10.7 0 16 0l288 0 16 0 0 32-16 0-288 0-16 0 0-31.5 0-1zM160 320l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm256-16l32-16 16-32 16 32 32 16-32 16-16 32-16-32-32-16z','M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-18.4 80l15.4 0 102.2 0 15.4 0 9.6 12 67.3 84-286.7 0 67.3-84 9.6-12zM296 512l-80 0L96 512l0-64 320 0 0 64-120 0zM96 256.5c0-.3 0-.7 0-1l0 1z']
      
    ]
  };

  

  
  

  var faPersonCircleExclamation = {
    prefix: 'fasds',
    iconName: 'person-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e53f',
      
      ['M.2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 2.3-1.4c8.4-21.4 20.8-40.7 36.3-57L238 142.8 228.6 128l-17.5 0-102.2 0-17.5 0-9.4 14.8L.2 270.8zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faSuitcaseRolling = {
    prefix: 'fasds',
    iconName: 'suitcase-rolling',
    icon: [
      384,
      512,
      [],
      'f5c1',
      
      ['M64 480l0 32 64 0 0-32-64 0zM96 0l0 24 0 80 0 24 48 0 0-24 0-56 96 0 0 56 0 24 48 0 0-24 0-80 0-24L264 0 120 0 96 0zM256 480l0 32 64 0 0-32-64 0z','M384 128L0 128 0 480l384 0 0-352zM112 224l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 128l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faDisplaySlash = {
    prefix: 'fasds',
    iconName: 'display-slash',
    icon: [
      640,
      512,
      ["desktop-slash"],
      'e2fa',
      
      ['M32 0l0 2.1c5.5 4.2 10.9 8.5 16.4 12.7C69.5 31.2 90.6 47.6 111.8 64L544 64l0 288-61.3 0c27.5 21.3 55 42.7 82.4 64l42.8 0L608 0 32 0zm0 121.2L32 416l240 0-10.7 32L192 448l-32 0 0 64 32 0 256 0 32 0 0-37.8L446.8 448l-68.1 0L368 416l38.2 0-81.2-64L96 352l0-180.4L32 121.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faDesktopSlash = faDisplaySlash;
  

  
  

  var faCircleMicrophoneLines = {
    prefix: 'fasds',
    iconName: 'circle-microphone-lines',
    icon: [
      512,
      512,
      ["microphone-circle-alt"],
      'e117',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-32l32 0 0 16 0 16c0 53 43 96 96 96s96-43 96-96l0-16 0-16 32 0 0 16 0 16c0 65.3-48.9 119.1-112 127l0 17 0 16-32 0 0-16 0-17c-63.1-7.9-112-61.7-112-127l0-16 0-16zM208 96l96 0 0 48-32 0-16 0 0 32 16 0 32 0 0 32-32 0-16 0 0 32 16 0 32 0 0 16c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160z','M208 96l96 0 0 48-32 0-16 0 0 32 16 0 32 0 0 32-32 0-16 0 0 32 16 0 32 0 0 16c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160zM160 224l0 16 0 16c0 53 43 96 96 96s96-43 96-96l0-16 0-16 32 0 0 16 0 16c0 65.3-48.9 119.1-112 127l0 17 0 16-32 0 0-16 0-17c-63.1-7.9-112-61.7-112-127l0-16 0-16 32 0z']
      
    ]
  };

  
    var faMicrophoneCircleAlt = faCircleMicrophoneLines;
  

  
  

  var faSquarePen = {
    prefix: 'fasds',
    iconName: 'square-pen',
    icon: [
      448,
      512,
      ["pen-square","pencil-square"],
      'f14b',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 384l16-96L220.7 179.3l80 80L192 368 96 384zM243.3 156.7L288 112l80 80-44.7 44.7-80-80z','M96 384l16-96L220.7 179.3l80 80L192 368 96 384zM323.3 236.7l-80-80L288 112l80 80-44.7 44.7z']
      
    ]
  };

  
    var faPenSquare = faSquarePen;
  
    var faPencilSquare = faSquarePen;
  

  
  

  var faTablePicnic = {
    prefix: 'fasds',
    iconName: 'table-picnic',
    icon: [
      512,
      512,
      [],
      'e32d',
      
      ['M16.7 448l17.6-43.9 32-80L80.7 288l68.9 0-24 59.9-32 80-8 20.1-68.9 0zm89.6-224l38.4-96 68.9 0-38.4 96-68.9 0zm192-96l68.9 0 38.4 96-68.9 0-38.4-96zm64 160l68.9 0 46.4 116.1L495.3 448l-68.9 0-8-20.1L362.3 288z','M96 64L64 64l0 64 32 0 320 0 32 0 0-64-32 0L96 64zM32 224L0 224l0 64 32 0 448 0 32 0 0-64-32 0L32 224z']
      
    ]
  };

  

  
  

  var faReceipt = {
    prefix: 'fasds',
    iconName: 'receipt',
    icon: [
      384,
      512,
      [129534],
      'f543',
      
      ['M0 0L64 48 128 0l64 48L256 0l64 48L384 0l0 512-64-48-64 48-64-48-64 48L64 464 0 512 0 0zM80 144l0 32 16 0 192 0 16 0 0-32-16 0L96 144l-16 0zm0 96l0 32 16 0 192 0 16 0 0-32-16 0L96 240l-16 0zm0 96l0 32 16 0 192 0 16 0 0-32-16 0L96 336l-16 0z','M80 144l16 0 192 0 16 0 0 32-16 0L96 176l-16 0 0-32zm0 192l16 0 192 0 16 0 0 32-16 0L96 368l-16 0 0-32zm16-96l192 0 16 0 0 32-16 0L96 272l-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faFilePen = {
    prefix: 'fasds',
    iconName: 'file-pen',
    icon: [
      576,
      512,
      [128221,"file-edit"],
      'f31c',
      
      ['M0 0L224 0l0 160 160 0 0 140.3-117 117L253.4 512 0 512 0 0z','M384 160l-160 0L224 0 384 160zm121.2 63.8l71 71-41.3 41.3-71-71 41.3-41.3zm-63.9 63.9l71 71L370.9 500.1 288 512l11.9-82.9L441.2 287.8z']
      
    ]
  };

  
    var faFileEdit = faFilePen;
  

  
  

  var faWalkieTalkie = {
    prefix: 'fasds',
    iconName: 'walkie-talkie',
    icon: [
      384,
      512,
      [],
      'f8ef',
      
      ['M0 96l64 0 48 0 48 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 64 0 0 224-32 32 0 160L32 512l0-160L0 320 0 96zm96 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zm0 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zm0 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0z','M112 24l0-24L64 0l0 24 0 48 0 24 48 0 0-24 0-48zm0 136l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z']
      
    ]
  };

  

  
  

  var faWand = {
    prefix: 'fasds',
    iconName: 'wand',
    icon: [
      512,
      512,
      [],
      'f72a',
      
      ['','M80 512L0 432 128 316.8l0-60.8 67.6 0L480 0l32 32L416 138.7l0 53.3-48 0L80 512z']
      
    ]
  };

  

  
  

  var faCartArrowDown = {
    prefix: 'fasds',
    iconName: 'cart-arrow-down',
    icon: [
      576,
      512,
      [],
      'f218',
      
      ['M122 32l48.8 256L496 288 576 32 360 32c0 36.7 0 73.4 0 110.1c7.7-7.7 15.4-15.4 23-23c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9l-17 17-64 64c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17l-64-64c-5.7-5.7-11.3-11.3-17-17L272 102.1l17 17c7.7 7.7 15.4 15.4 23 23c0-36.7 0-73.4 0-110.1L122 32z','M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0L119.6 19.5 115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM360 142.1L360 32l-48 0 0 110.1-23-23-17-17L238.1 136l17 17 64 64 17 17 17-17 64-64 17-17L400 102.1l-17 17-23 23z']
      
    ]
  };

  

  
  

  var faColon = {
    prefix: 'fasds',
    iconName: 'colon',
    icon: [
      192,
      512,
      [],
      '3a',
      
      ['M32 320l128 0 0 128L32 448l0-128z','M32 64H160V192H32V64z']
      
    ]
  };

  

  
  

  var faCartFlatbedEmpty = {
    prefix: 'fasds',
    iconName: 'cart-flatbed-empty',
    icon: [
      640,
      512,
      ["dolly-flatbed-empty"],
      'f476',
      
      ['M160 464c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16zm288 0c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l-90.5 0c-1.8 5-2.7 10.4-2.7 16z','M0 0L32 0 96 0l32 0 0 32 0 352 480 0 32 0 0 64-32 0L96 448l-32 0 0-32L64 64 32 64 0 64 0 0z']
      
    ]
  };

  
    var faDollyFlatbedEmpty = faCartFlatbedEmpty;
  

  
  

  var faLobster = {
    prefix: 'fasds',
    iconName: 'lobster',
    icon: [
      512,
      512,
      [129438],
      'e421',
      
      ['M43.8 314.1l15.2 5.1 48 16 2.5 .8 2.6 0 80 0 0-32-77.4 0L69.1 288.8l-15.2-5.1L43.8 314.1zm14.8-59l14.3 7.2 48 24 3.4 1.7 3.8 0 64 0 0-32-60.2 0L87.2 233.7l-14.3-7.2L58.5 255.2zm48 121.7l14.3 28.6 14.3-7.2L163.8 384l28.2 0 0-32-32 0-3.8 0-3.4 1.7-32 16-14.3 7.2zM157.6 45.2l15.8 2.6L208 53.6l0 118.2c9.3-14.4 21.2-25.8 32-33.7l0-98 0-13.6-13.4-2.2-48-8-15.8-2.6-5.3 31.6zM272 26.4L272 40l0 98c10.8 8 22.7 19.4 32 33.7l0-118.2 34.6-5.8 15.8-2.6-5.3-31.6-15.8 2.6-48 8L272 26.4zM320 256l0 32 64 0 3.8 0 3.4-1.7 48-24 14.3-7.2-14.3-28.6-14.3 7.2L380.2 256 320 256zm0 48l0 32 80 0 2.6 0 2.5-.8 48-16 15.2-5.1-10.1-30.4-15.2 5.1L397.4 304 320 304zm0 48c0 10.7 0 21.3 0 32l28.2 0 28.6 14.3 14.3 7.2 14.3-28.6-14.3-7.2-32-16-3.4-1.7-3.8 0-32 0z','M80 2l0 94 42.9-57.2c3.3 7.7 5.1 16.2 5.1 25.2l0 64c0 14.9-5.1 28.6-13.6 39.4L151.3 192l46.5 0c12.4-33.4 41.7-55.7 58.2-64c16.5 8.3 45.8 30.6 58.2 64l46.5 0 36.9-24.6C389.1 156.6 384 142.9 384 128l0-64c0-8.9 1.8-17.4 5.1-25.2L432 96l0-94c5.1-1.3 10.5-2 16-2c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-.7 0-66 44-6 4-7.3 0-48 0 0 144-21.6 64.8c30.4 5 53.6 31.4 53.6 63.2l-192 0c0-31.8 23.2-58.2 53.6-63.2L192 384l0-144-48 0-7.3 0-6-4-66-44-.7 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0c5.5 0 10.9 .7 16 2z']
      
    ]
  };

  

  
  

  var faBracketCurly = {
    prefix: 'fasds',
    iconName: 'bracket-curly',
    icon: [
      256,
      512,
      ["bracket-curly-left"],
      '7b',
      
      ['M96 32L64 32l0 32 0 114.7L9.4 233.4 0 242.7l0 26.5 9.4 9.4L64 333.3 64 448l0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-96 0-13.3-9.4-9.4L77.3 256l41.4-41.4 9.4-9.4 0-13.3 0-96 64 0 32 0 0-64-32 0L96 32z','']
      
    ]
  };

  
    var faBracketCurlyLeft = faBracketCurly;
  

  
  

  var faTaxiBus = {
    prefix: 'fasds',
    iconName: 'taxi-bus',
    icon: [
      640,
      512,
      [],
      'e298',
      
      ['M0 38.4L0 96C0 202.7 0 309.3 0 416l48 0 0 64 80 0 0-64 64 0 0-160 39.2 0 10.7-32L208 224l0-128 112 0 64 0 0-32 0-25.6S299 0 192 0S0 38.4 0 38.4zM104 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM64 96l112 0 0 128L64 224 64 96z','M496 128l-128 0 0 32-48 0-23.1 0-7.3 21.9L254.3 288 224 288l0 160s0 0 0 0l0 64 80 0 0-64 256 0 0 64 80 0 0-64s0 0 0 0l0-160-30.3 0L574.4 181.9 567.1 160 544 160l-48 0 0-32zm24.9 96l21.3 64-220.5 0 21.3-64 177.9 0zM280 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faPeach = {
    prefix: 'fasds',
    iconName: 'peach',
    icon: [
      512,
      512,
      [],
      'e20b',
      
      ['M0 280C0 432 256 512 256 512s256-80 256-232c0-92.8-75.2-168-168-168c-19.1 0-37.5 3.2-54.6 9.1C337.2 157.6 368 215.2 368 280l-32 0c0-60.5-32-113.6-80-143.1c-.3-.2-.6-.4-.9-.5C229.7 120.9 199.9 112 168 112C75.2 112 0 187.2 0 280z','M373.6 82.2C363.9 80.7 354 80 344 80c-31.5 0-61.4 7.3-88 20.4C229.4 87.3 199.5 80 168 80c-10 0-19.9 .7-29.6 2.2C122.1 64.9 112 41.6 112 16l0-16 16 0 32 0c53 0 96 43 96 96c0-53 43-96 96-96l32 0 16 0 0 16c0 25.6-10.1 48.9-26.4 66.2z']
      
    ]
  };

  

  
  

  var faNairaSign = {
    prefix: 'fasds',
    iconName: 'naira-sign',
    icon: [
      448,
      512,
      [],
      'e1f6',
      
      ['M0 256l0 64 32 0 32 0 0-64-32 0L0 256zm128 0l0 64 98.9 0c-13.6-21.3-27.3-42.7-40.9-64l-58 0zm134 0l40.9 64 17.1 0 0-64-58 0zm122 0l0 64 32 0 32 0 0-64-32 0-32 0z','M64 32l32 0 5.3 0 17.5 0 9.4 14.8L320 346.8 320 64l0-32 64 0 0 32 0 384 0 32-32 0-5.3 0-17.5 0-9.4-14.8L128 165.2 128 448l0 32-64 0 0-32L64 64l0-32z']
      
    ]
  };

  

  
  

  var faFloppyDiskCircleXmark = {
    prefix: 'fasds',
    iconName: 'floppy-disk-circle-xmark',
    icon: [
      576,
      512,
      ["floppy-disk-times","save-circle-xmark","save-times"],
      'e181',
      
      ['M0 32l32 0 288 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32.7c-5.3-.5-10.6-.7-16-.7c-75 0-139.1 47-164.4 113.1C256.1 294.5 240.8 288 224 288c-35.3 0-64 28.7-64 64s28.7 64 64 64c13.3 0 25.7-4.1 35.9-11c6 28.1 18.7 53.7 36.3 75L32 480 0 480l0-32L0 64 0 32zM64 96l0 128 256 0 0-128L64 96z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7L502.6 320z']
      
    ]
  };

  
    var faFloppyDiskTimes = faFloppyDiskCircleXmark;
  
    var faSaveCircleXmark = faFloppyDiskCircleXmark;
  
    var faSaveTimes = faFloppyDiskCircleXmark;
  

  
  

  var faLocationQuestion = {
    prefix: 'fasds',
    iconName: 'location-question',
    icon: [
      384,
      512,
      ["map-marker-question"],
      'f60b',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm104.3-45.7c.2-1.9 .5-3.7 .8-5.5c.7-3.6 1.8-7.2 3.3-10.5c2.8-6.7 6.9-12.7 12-17.8C130.5 102.3 144.5 96 160 96l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8c-10.8 6.2-21.5 12.3-32.3 18.5c0 2.5 0 5 0 7.6c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-7.2 0-14.3 0-21.5c0-4.6 0-9.3 0-13.9c4-2.3 8-4.6 12.1-6.9c14.8-8.5 29.6-17 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L160 144c-2.2 0-4.2 .9-5.7 2.3c-.7 .7-1.3 1.6-1.7 2.5c-.2 .5-.4 1-.5 1.5c-.1 .3-.1 .5-.1 .8c0 .2 0 .4 0 .8c0 2.2 0 4.4 0 6.5l-48 0c0-2.2 0-4.4 0-6.5l0-.4c0-.6 0-1.6 .1-2.5s.1-1.9 .2-2.8zM168 304l48 0c0 16 0 32 0 48l-48 0c0-16 0-32 0-48z','M160 96c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L168 204.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L160 96zm56 208l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faMapMarkerQuestion = faLocationQuestion;
  

  
  

  var faSignalGood = {
    prefix: 'fasds',
    iconName: 'signal-good',
    icon: [
      640,
      512,
      ["signal-3"],
      'f68e',
      
      ['M416 96l0 32 0 352 0 32 64 0 0-32 0-352 0-32-64 0zM544 0l0 32 0 448 0 32 64 0 0-32 0-448 0-32L544 0z','M352 192l0 32 0 256 0 32-64 0 0-32 0-256 0-32 64 0zM224 288l0 32 0 160 0 32-64 0 0-32 0-160 0-32 64 0zM96 416l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z']
      
    ]
  };

  
    var faSignal3 = faSignalGood;
  

  
  

  var faTrashCanArrowUp = {
    prefix: 'fasds',
    iconName: 'trash-can-arrow-up',
    icon: [
      448,
      512,
      ["trash-restore-alt"],
      'f82a',
      
      ['M32 96l0 416 384 0 0-416L32 96zm78.1 184l17-17 80-80 17-17 17 17 80 80 17 17L304 313.9l-17-17-39-39L248 392l0 24-48 0 0-24 0-134.1-39 39-17 17L110.1 280z','M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zm97 183l-17-17-17 17-80 80-17 17L144 313.9l17-17 39-39L200 392l0 24 48 0 0-24 0-134.1 39 39 17 17L337.9 280l-17-17-80-80z']
      
    ]
  };

  
    var faTrashRestoreAlt = faTrashCanArrowUp;
  

  
  

  var faChevronsDown = {
    prefix: 'fasds',
    iconName: 'chevrons-down',
    icon: [
      512,
      512,
      ["chevron-double-down"],
      'f322',
      
      ['M18.7 64L41.4 86.6l192 192L256 301.3l22.6-22.6 192-192L493.3 64 448 18.7 425.4 41.4 256 210.7 86.6 41.4 64 18.7 18.7 64z','M256 493.3l-22.6-22.6-192-192L18.7 256 64 210.7l22.6 22.6L256 402.7 425.4 233.4 448 210.7 493.3 256l-22.6 22.6-192 192L256 493.3z']
      
    ]
  };

  
    var faChevronDoubleDown = faChevronsDown;
  

  
  

  var faPersonDotsFromLine = {
    prefix: 'fasds',
    iconName: 'person-dots-from-line',
    icon: [
      576,
      512,
      ["diagnoses"],
      'f470',
      
      ['M.4 304.9l39.7 87.4 43.7-19.9L176 330.5 176 432l224 0 0-101.5 92.1 41.9 43.7 19.9 39.7-87.4L531.9 285l-31.1-14.1c-8.8 10.5-22 17.1-36.7 17.1c-26.5 0-48-21.5-48-48c0-2.5 .2-5 .6-7.4l-44.7-20.3-9.5-4.3L352 208l-128 0-10.4 0-9.5 4.3-76.7 34.8C124 270.3 104.1 288 80 288c-9.5 0-18.4-2.8-25.8-7.5l-10 4.6L.4 304.9zM200 88a88 88 0 1 0 176 0A88 88 0 1 0 200 88zm72 192a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M64 240a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM0 464l24 0 528 0 24 0 0 48-24 0L24 512 0 512l0-48zM464 224a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  
    var faDiagnoses = faPersonDotsFromLine;
  

  
  

  var faTableTennisPaddleBall = {
    prefix: 'fasds',
    iconName: 'table-tennis-paddle-ball',
    icon: [
      512,
      512,
      [127955,"ping-pong-paddle-ball","table-tennis"],
      'f45d',
      
      ['M320 416a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M301.4 358.8c21-42 64.4-70.8 114.6-70.8c29 0 55.8 9.6 77.2 25.9c35.9-82 20.3-181.2-46.8-248.3c-87.5-87.5-229.3-87.5-316.8 0L68.9 126.3 301.4 358.8zm-11.3 33.9L46.3 148.9 32 163.2 32 272l75.4 75.4L0 448l64 64L164.6 404.6 240 480l65.1 0c-10.9-18.8-17.1-40.7-17.1-64c0-7.9 .7-15.7 2.1-23.3z']
      
    ]
  };

  
    var faPingPongPaddleBall = faTableTennisPaddleBall;
  
    var faTableTennis = faTableTennisPaddleBall;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm352 0A144 144 0 1 1 64 208a144 144 0 1 1 288 0z','M330.7 376L441.4 486.6 464 509.3 509.3 464l-22.6-22.6L376 330.7C363.3 348 348 363.3 330.7 376z']
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faRupiahSign = {
    prefix: 'fasds',
    iconName: 'rupiah-sign',
    icon: [
      512,
      512,
      [],
      'e23d',
      
      ['M288 160l32 0 80 0c61.9 0 112 50.1 112 112s-50.1 112-112 112l-48 0 0 128-64 0 0-160 0-160 0-32zm64 64l0 96 48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48 0z','M32 32L0 32 0 64 0 288 0 480l64 0 0-160 40.6 0 51.2 160 67.2 0-.6-1.8L168.2 308.6c51.6-21.9 87.8-73 87.8-132.6c0-79.5-64.5-144-144-144L32 32zm80 224l-48 0L64 96l48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z']
      
    ]
  };

  

  
  

  var faTableCellsRowLock = {
    prefix: 'fasds',
    iconName: 'table-cells-row-lock',
    icon: [
      640,
      512,
      [],
      'e67a',
      
      ['M0 32L0 480l384 0 0-64-24 0 0-64 24 0 0-64-24 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 32 0 32zM64 224l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64zM208 224l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faBurgerLettuce = {
    prefix: 'fasds',
    iconName: 'burger-lettuce',
    icon: [
      512,
      512,
      [],
      'e3e3',
      
      ['M32 192l0 32 448 0 0-32s0-160-224-160S32 192 32 192zm0 192l0 96 448 0 0-96L32 384zM144 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM272 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M168 253.9l10.9 4 77.1 28 77.1-28 10.9-4 10.9 4 76.9 28L484.8 266 507.2 326l-64 24-11.1 4.2-11.1-4L344 322l-77.1 28L256 354l-10.9-4L168 322l-77.1 28-11.1 4L68.8 350l-64-24L27.2 266l52.9 19.9 76.9-28 10.9-4z']
      
    ]
  };

  

  
  

  var faSquareDownLeft = {
    prefix: 'fasds',
    iconName: 'square-down-left',
    icon: [
      448,
      512,
      [],
      'e26b',
      
      ['M0 32L0 480l448 0 0-448L0 32zM128 192l24-24 52 52 76-76 56 56-76 76 52 52-24 24-160 0 0-160z','M152 168l-24 24 0 160 160 0 24-24-52-52 76-76-56-56-76 76-52-52z']
      
    ]
  };

  

  
  

  var faCupTogo = {
    prefix: 'fasds',
    iconName: 'cup-togo',
    icon: [
      448,
      512,
      ["coffee-togo"],
      'f6c5',
      
      ['M48 128l352 0-8.7 104L56.7 232 48 128zM70 392l308 0L368 512 80 512c-3.3-40-6.7-80-10-120z','M64 0L32 64 0 64l0 64 32 0 384 0 32 0 0-64-32 0L384 0 64 0zM378 392l13.3-160L56.7 232 70 392l308 0z']
      
    ]
  };

  
    var faCoffeeTogo = faCupTogo;
  

  
  

  var faFont = {
    prefix: 'fasds',
    iconName: 'font',
    icon: [
      448,
      512,
      [],
      'f031',
      
      ['M194 52.8L201.8 32l44.4 0L254 52.8 390.2 416l25.8 0 32 0 0 64-32 0-96 0-32 0 0-64 32 0 1.8 0-18-48-159.6 0-18 48 1.8 0 32 0 0 64-32 0-96 0L0 480l0-64 32 0 25.8 0L194 52.8zM168.2 304l111.6 0L224 155.1 168.2 304z','']
      
    ]
  };

  

  
  

  var faPlay = {
    prefix: 'fasds',
    iconName: 'play',
    icon: [
      384,
      512,
      [9654],
      'f04b',
      
      ['','M384 256L0 32V480L384 256z']
      
    ]
  };

  

  
  

  var faTreeCity = {
    prefix: 'fasds',
    iconName: 'tree-city',
    icon: [
      640,
      512,
      [],
      'e587',
      
      ['M288 0l0 512 96 0 96 0 160 0 0-320-72 0 0-72 0-24-48 0 0 24 0 72-40 0L480 0 288 0zm64 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm160 0l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M222 176c1-5 2-10 2-16c0-53-43-96-96-96c-54 0-96 43-96 96c0 6 0 11 1 16C13 190 0 214 0 240l0 80 96 0 0 160 0 32 32 0 32 0 0-32 0-160 96 0 0-80c0-26-14-50-34-64z']
      
    ]
  };

  

  
  

  var faFileMinus = {
    prefix: 'fasds',
    iconName: 'file-minus',
    icon: [
      384,
      512,
      [],
      'f318',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM96 304l0 48 24 0 144 0 24 0 0-48-24 0-144 0-24 0z','M384 160L224 0l0 160 160 0zM120 304l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z']
      
    ]
  };

  

  
  

  var faEarListen = {
    prefix: 'fasds',
    iconName: 'ear-listen',
    icon: [
      512,
      512,
      ["assistive-listening-systems"],
      'f2a2',
      
      ['M0 480a32 32 0 1 0 64 0A32 32 0 1 0 0 480zm18.7-96l22.6 22.6 64 64L128 493.3 173.3 448l-22.6-22.6-64-64L64 338.7 18.7 384zM128 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM369.7 60.6c.6 .3 1.4 .7 2.3 1.3c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192l64 0c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2c-.3-.1-.3-.1-14.6 28.5L369.7 60.6z','M128 240c0-61.9 50.1-112 112-112s112 50.1 112 112c0 38.8-19.7 73-49.8 93.2L288 342.7l0 17.1 0 40.2c0 26.5-21.5 48-48 48l-32 0 0 64 32 0c61.9 0 112-50.1 112-112l0-24.2c39-32.2 64-81.1 64-135.8c0-97.2-78.8-176-176-176S64 142.8 64 240l64 0zm80 0c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l48 0z']
      
    ]
  };

  
    var faAssistiveListeningSystems = faEarListen;
  

  
  

  var faLink = {
    prefix: 'fasds',
    iconName: 'link',
    icon: [
      640,
      512,
      [128279,"chain"],
      'f0c1',
      
      ['M238.6 210.1c-29.5 54.6-21.3 124.2 24.9 170.3c28.1 28.1 65 42.2 101.8 42.2s73.7-14.1 101.8-42.2L580.2 267.3c56.2-56.2 56.2-147.4 0-203.6c-28.1-28.1-65-42.2-101.8-42.2s-73.7 14.1-101.8 42.2L365.3 75l45.3 45.3 11.3-11.3c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1L421.8 335.2c-31.2 31.2-81.9 31.2-113.1 0c-25.6-25.6-30.3-64.3-13.8-94.6c1.8-3.4 3.9-6.7 6.3-9.8l-51.2-38.4c-4.3 5.7-8.1 11.6-11.4 17.8z','M59.8 448.3c-56.2-56.2-56.2-147.4 0-203.6L172.9 131.5c56.2-56.2 147.4-56.2 203.6 0c46.2 46.2 54.4 115.8 24.9 170.3c-3.3 6.1-7.1 12.1-11.4 17.8l-51.2-38.4c2.4-3.2 4.5-6.4 6.3-9.8c16.4-30.3 11.8-69-13.8-94.6c-31.2-31.2-81.9-31.2-113.1 0L105 289.9c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l11.3-11.3L274.7 437l-11.3 11.3c-56.2 56.2-147.4 56.2-203.6 0z']
      
    ]
  };

  
    var faChain = faLink;
  

  
  

  var faBallotCheck = {
    prefix: 'fasds',
    iconName: 'ballot-check',
    icon: [
      448,
      512,
      [],
      'f733',
      
      ['M0 0L0 512l448 0L448 0 0 0zM49.4 248L72 225.4l11.3 11.3L96 249.4l36.7-36.7L144 201.4 166.6 224l-11.3 11.3-48 48L96 294.6 84.7 283.3l-24-24L49.4 248zM64 96l64 0 0 64-64 0 0-64zm0 256l64 0 0 64-64 0 0-64zM192 112l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 128l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 128l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32z','M64 96l0 64 64 0 0-64L64 96zm0 320l64 0 0-64-64 0 0 64zm91.3-180.7L166.6 224 144 201.4l-11.3 11.3L96 249.4 83.3 236.7 72 225.4 49.4 248l11.3 11.3 24 24L96 294.6l11.3-11.3 48-48z']
      
    ]
  };

  

  
  

  var faGrillHot = {
    prefix: 'fasds',
    iconName: 'grill-hot',
    icon: [
      448,
      512,
      [],
      'e5a5',
      
      ['M96 0l0 24 0 2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6 0 24 48 0 0-24 0-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6 0-24L96 0zM208 0l0 24 0 2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3l0 2.6 0 24 48 0 0-24 0-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3l0-2.6 0-24L208 0z','M448 160c0 85.3-47.7 159.5-117.9 197.3l44 102.6 4 9.3 9.5 22.1-44.1 18.9-9.5-22.1-4-9.3L327 472l-171.7 0c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l11.8-27.5C47.7 319.5 0 245.3 0 160l448 0zM155.3 424l151.1 0-20.8-48.6C266.1 381 245.4 384 224 384s-42.1-3-61.6-8.6L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faLandmarkMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'landmark-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e622',
      
      ['M0 144l0 48 301.3 0c-8.6-19.6-13.3-41.2-13.3-64c0-34.8 11.1-66.9 29.9-93.2L256 0 0 144zM0 464l0 48 512 0 0-48-64-48 0-128c-22.8 0-44.4-4.8-64-13.3L384 416l-40 0 0-166.4c-8.9-7.6-17-16.2-24-25.6l-40 0 0 192-48 0 0-192-64 0 0 192-40 0 0-192-64 0 0 192L0 464z','M528 128.2a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM520 234c-20.5 14-45.3 22.1-72 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 234z']
      
    ]
  };

  

  
  

  var faBoxesStacked = {
    prefix: 'fasds',
    iconName: 'boxes-stacked',
    icon: [
      576,
      512,
      [62625,"boxes","boxes-alt"],
      'f468',
      
      ['M104 256l80 0 0 96-80 0 0-96zM248 0l80 0 0 96-80 0 0-96zM392 256l80 0 0 96-80 0 0-96z','M248 0L160 0l0 224 256 0L416 0 328 0l0 96-80 0 0-96zM104 256L0 256 0 512l288 0 0-256-104 0 0 96-80 0 0-96zM576 512l0-256-104 0 0 96-80 0 0-96-72 0 0 256 256 0z']
      
    ]
  };

  
    var faBoxes = faBoxesStacked;
  
    var faBoxesAlt = faBoxesStacked;
  

  
  

  var faTimer = {
    prefix: 'fasds',
    iconName: 'timer',
    icon: [
      512,
      512,
      [],
      'e29e',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0L224 0l0 32 0 64 0 32 64 0 0-32 0-29.3C378.8 81.9 448 160.9 448 256c0 106-86 192-192 192S64 362 64 256c0-53.7 22-102.3 57.6-137.1L76.8 73.1C29.5 119.6 0 184.4 0 256z','M176 142.1l17 17 80 80 17 17L256 289.9l-17-17-80-80-17-17L176 142.1z']
      
    ]
  };

  

  
  

  var faSpeaker = {
    prefix: 'fasds',
    iconName: 'speaker',
    icon: [
      384,
      512,
      [],
      'f8df',
      
      ['M0 0L384 0l0 512L0 512 0 0zM80 336a112 112 0 1 0 224 0A112 112 0 1 0 80 336zm64-224a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M192 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM128 336a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z']
      
    ]
  };

  

  
  

  var faCarBus = {
    prefix: 'fasds',
    iconName: 'car-bus',
    icon: [
      640,
      512,
      [],
      'f85a',
      
      ['M0 38.4L0 96C0 202.7 0 309.3 0 416l48 0 0 64 80 0 0-64 64 0 0-160 39.2 0 10.7-32L208 224l0-128 112 0 0 32 64 0 0-64 0-25.6S299 0 192 0S0 38.4 0 38.4zM104 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM64 96l112 0 0 128L64 224 64 96z','M320 160l-23.1 0-7.3 21.9L254.3 288 224 288l0 160s0 0 0 0l0 64 80 0 0-64 256 0 0 64 80 0 0-64s0 0 0 0l0-160-30.3 0L574.4 181.9 567.1 160 544 160l-224 0zM542.3 288l-220.5 0 21.3-64 177.9 0 21.3 64zM280 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faStarHalf = {
    prefix: 'fasds',
    iconName: 'star-half',
    icon: [
      576,
      512,
      [61731],
      'f089',
      
      ['M288 .1l0 430.1L454.3 512 427.9 328.5 557.1 195.6 374.5 164 288 .1z','M121.7 512L288 430.2 288 .1 201.5 164 18.9 195.6 148.1 328.5 121.7 512z']
      
    ]
  };

  

  
  

  var faMoneyFromBracket = {
    prefix: 'fasds',
    iconName: 'money-from-bracket',
    icon: [
      640,
      512,
      [],
      'e312',
      
      ['M128 96l0 416 384 0 0-416L128 96zm64 288c35.3 0 64 28.7 64 64l-64 0 0-64zm32-112c0-44.2 43-80 96-80s96 35.8 96 80s-43 80-96 80s-96-35.8-96-80zM384 448c0-35.3 28.7-64 64-64l0 64-64 0z','M0 0L32 0 608 0l32 0 0 32 0 128 0 32-64 0 0-32 0-96L64 64l0 96 0 32L0 192l0-32L0 32 0 0z']
      
    ]
  };

  

  
  

  var faCheckToSlot = {
    prefix: 'fasds',
    iconName: 'check-to-slot',
    icon: [
      576,
      512,
      ["vote-yea"],
      'f772',
      
      ['M96 32l0 256 0 80 0 32 384 0 0-32 0-80 0-256L96 32zm70.1 176c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.4 31.4 47 47c37-37 74-74 111-111c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-42.7 42.7-85.3 85.3-128 128c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-21.3-21.3-42.7-42.7-64-64c-5.7-5.7-11.3-11.3-17-17z','M409 161L281 289l-17 17-17-17-64-64-17-17L200 174.1l17 17 47 47L375 127l17-17L425.9 144l-17 17zM0 288l96 0 0 80-32 0 0 32 448 0 0-32-32 0 0-80 96 0 0 192L0 480 0 288z']
      
    ]
  };

  
    var faVoteYea = faCheckToSlot;
  

  
  

  var faCloudHail = {
    prefix: 'fasds',
    iconName: 'cloud-hail',
    icon: [
      512,
      512,
      [],
      'f739',
      
      ['M32 480a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faMeterFire = {
    prefix: 'fasds',
    iconName: 'meter-fire',
    icon: [
      640,
      512,
      [],
      'e1eb',
      
      ['M0 256C0 397.4 114.6 512 256 512c33.5 0 65.5-6.4 94.8-18.1c-38.6-35.1-62.8-85.7-62.8-142c0-49.2 20.9-93.1 46.1-127.8L320 224l0-32 0-32 0-32 64 0 0 32 0 8.8c17.1-15.5 33.7-27.8 47-36.1l21.6-13.5L493.4 160C455.4 66.2 363.4 0 256 0C114.6 0 0 114.6 0 256zM128 128l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32zm96 0l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32zM400 369.8c0 49 36 78 81 78c18 0 34-5 49-15c19.3-13.5 29.5-35.8 29.5-58.7c0-12.7-3.1-25.6-9.5-37.3c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82z','M448 160s32.6 26.4 65 64c17.2-19.5 31-32 31-32s96 86.4 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160s128-192 128-192zm33 287.8c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z']
      
    ]
  };

  

  
  

  var faSquareE = {
    prefix: 'fasds',
    iconName: 'square-e',
    icon: [
      448,
      512,
      [],
      'e26d',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 144 0 24 0 0 48-24 0-120 0 0 56 88 0 24 0 0 48-24 0-88 0 0 56 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-104 0-104 0-24z','M128 128l24 0 144 0 24 0 0 48-24 0-120 0 0 56 88 0 24 0 0 48-24 0-88 0 0 56 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-104 0-104 0-24z']
      
    ]
  };

  

  
  

  var faHeadSideHeart = {
    prefix: 'fasds',
    iconName: 'head-side-heart',
    icon: [
      512,
      512,
      [],
      'e1aa',
      
      ['M0 224.2C0 100.6 100.2 0 224 0l32 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8c-41-41.9-64-98.3-64-157zm128-37c0 16.1 6.6 31.5 18.2 42.7c27.6 26.5 55.2 53.1 82.8 79.6c3.7 3.6 7.4 7.1 11.1 10.7c3.7-3.6 7.4-7.1 11.1-10.7c27.6-26.5 55.2-53.1 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2c-.8 0-1.6 0-2.4 0c-15.9 0-31.2 6.2-42.7 17.2c-2.6 2.5-5.1 4.9-7.7 7.4c-2.6-2.5-5.1-4.9-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2c-.8 0-1.6 0-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z','M187.2 128c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L240 320.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z']
      
    ]
  };

  

  
  

  var faParagraph = {
    prefix: 'fasds',
    iconName: 'paragraph',
    icon: [
      448,
      512,
      [182],
      'f1dd',
      
      ['M320 96l0 352 0 32 64 0 0-32 0-352-64 0z','M192 32l64 0 160 0 32 0 0 64-32 0L288 96l0 352 0 32-64 0 0-32 0-96-32 0c-88.4 0-160-71.6-160-160s71.6-160 160-160z']
      
    ]
  };

  

  
  

  var faFax = {
    prefix: 'fasds',
    iconName: 'fax',
    icon: [
      512,
      512,
      [128224,128439],
      'f1ac',
      
      ['M128 0l0 192 352 0 0-128L416 0 128 0zm96 256l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM352 256l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M96 128L0 128 0 512l96 0 0-384zm416 64l-384 0 0 320 384 0 0-320zM288 256l0 64-64 0 0-64 64 0zM224 384l64 0 0 64-64 0 0-64zM416 256l0 64-64 0 0-64 64 0zM352 384l64 0 0 64-64 0 0-64z']
      
    ]
  };

  

  
  

  var faDeerRudolph = {
    prefix: 'fasds',
    iconName: 'deer-rudolph',
    icon: [
      576,
      512,
      [],
      'f78f',
      
      ['M224 0l0 16 0 24c0 30.9 25.1 56 56 56l16 0 24 0 7 0 25 0 16 0 0-31.2 0-.8-16 0-5.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24 0-16L320 0l0 16 0 24c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24 0-16L224 0zM377.2 64c1.5 0 3 0 4.5 .1s3 .2 4.5 .3c3 .3 5.9 .7 8.8 1.3c5.8 1.1 11.5 2.8 17 5c10.9 4.4 21.1 10.8 29.7 19.1C459.7 80.4 472 61.7 472 40l0-24 0-16L440 0l0 16 0 24c0 13.3-10.7 24-24 24l-24 0-14.8 0zM480 136a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M256 112l64-16 7 0 25 0 16 0 0-31.2c3-.5 6.1-.8 9.2-.8c24.8 0 48.6 9.9 66.2 27.4l37.3 37.3c-.4 2.4-.7 4.8-.7 7.3c0 19.4 13.7 35.5 32 39.2l0 48.8-96 0-5.3 0L384 304l0 64 0 144-96 0 0-144-48 0-64-27.4 0 3.4 0 19.9-14.1 14.1-26.6 26.6L173.3 512 71.5 512 34.7 408 24.7 379.4l21.4-21.4L72.1 332 56 315.9c-2.4-2.4-4.6-4.9-6.6-7.5l-1.3 21-47.9-3 1.5-24 1.8-28.9C6.8 218.8 52.3 176 107.2 176l6.7 0 14.1 0 96 0 78.4 0 9.6-32-56 0 0-32zm144 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faFishBones = {
    prefix: 'fasds',
    iconName: 'fish-bones',
    icon: [
      576,
      512,
      [],
      'e304',
      
      ['M0 128L64 256 0 384l32 32 64-64 0-48 0-24 0-48 0-24 0-48L32 96 0 128zm416-16l0 120 64 0 0 48-64 0 0 120 32 0L576 256 448 112l-32 0z','M184 160l0-24-48 0 0 24 0 72-40 0 0 48 40 0 0 72 0 24 48 0 0-24 0-72 48 0 0 72 0 24 48 0 0-24 0-72 48 0 0 72 0 24 48 0 0-24 0-72 104 0 0-48-104 0 0-72 0-24-48 0 0 24 0 72-48 0 0-72 0-24-48 0 0 24 0 72-48 0 0-72z']
      
    ]
  };

  

  
  

  var faHeartCircleBolt = {
    prefix: 'fasds',
    iconName: 'heart-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e4fc',
      
      ['M0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480l23.7-23.7c-15.1-26-23.7-56.1-23.7-88.3c0-97.2 78.8-176 176-176c26.4 0 51.4 5.8 73.8 16.2c4-13 6.2-26.6 6.2-40.4C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm64 16l66.7 0L408 448l104-96-66.7 0L456 288 352 384z']
      
    ]
  };

  

  
  

  var faIceCream = {
    prefix: 'fasds',
    iconName: 'ice-cream',
    icon: [
      448,
      512,
      [127848],
      'f810',
      
      ['M32 208l0 48 48 0 53.5 0 181 0 53.5 0 48 0 0-48c0-26.5-21.5-48-48-48l-.9 0c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16l-.9 0c-26.5 0-48 21.5-48 48z','M224 512L80 256H368L224 512z']
      
    ]
  };

  

  
  

  var faScrubber = {
    prefix: 'fasds',
    iconName: 'scrubber',
    icon: [
      512,
      512,
      [],
      'f2f8',
      
      ['M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z']
      
    ]
  };

  

  
  

  var faDrum = {
    prefix: 'fasds',
    iconName: 'drum',
    icon: [
      512,
      512,
      [129345],
      'f569',
      
      ['M72 318.7l0 9.3 0 118.7c14.3 6.4 30.5 12 48 16.7l0-128c-17.5-4.7-33.7-10.3-48-16.7zM222.8 201.1l26.3 40.2 20.1-13.2c37-24.3 74.1-48.5 111.1-72.8l53-34.7c16.7-11 33.4-21.9 50.2-32.9l20.1-13.2L477.2 34.4 457.1 47.6c-29 19-57.9 38-86.9 56.9c-20.9 13.7-41.9 27.4-62.8 41.1l-64.6 42.3-20.1 13.2zM232 351.5l0 128c7.9 .3 15.9 .5 24 .5s16.1-.2 24-.5l0-128c-7.9 .3-15.9 .5-24 .5s-16.1-.2-24-.5zm160-16.1l0 128c17.5-4.7 33.7-10.3 48-16.7L440 328l0-9.3c-14.3 6.4-30.5 12-48 16.7z','M256 96c41 0 79.8 2.7 114.2 8.5l-62.8 41.1C291.1 144.5 274 144 256 144c-68.2 0-125.4 7.9-163.6 22.7C53.6 181.8 48 197.4 48 208c0 .8 2.7 17.2 46 35.9c38.9 16.8 96 28.1 162 28.1s123.1-11.3 162-28.1c43.3-18.7 46-35.1 46-35.9c0-10.6-5.6-26.2-44.4-41.3c-11.5-4.5-24.7-8.3-39.4-11.5l53-34.7C481.8 138.5 512 166.9 512 208l0 32 0 128c0 31.3-27.4 58.8-72 78.7L440 328l0-9.3c-14.3 6.4-30.5 12-48 16.7l0 128c-33 8.9-71.1 14.5-112 16.1l0-128c-7.9 .3-15.9 .5-24 .5s-16.1-.2-24-.5l0 128c-40.9-1.6-79-7.2-112-16.1l0-128c-17.5-4.7-33.7-10.3-48-16.7l0 9.3 0 118.7C27.4 426.8 0 399.3 0 368L0 240l0-32C0 128 114.6 96 256 96z']
      
    ]
  };

  

  
  

  var faKite = {
    prefix: 'fasds',
    iconName: 'kite',
    icon: [
      640,
      512,
      [129665],
      'f6f4',
      
      ['M0 128l0 48 24 0 48 0 0 110 24 10 24-10 0-134 0-24-24 0-72 0L0 128zM72 322l0 166 0 24 24 0 56 0 9.9 0 7-7 96-96 .4-.4L640 321.4l0-1.4c-53.3-53.3-106.7-106.7-160-160c-86.3 86.3-172.5 172.5-258.8 258.8c3.4-14.7 6.9-29.5 10.3-44.2l-.4 .4-89 89L120 464l0-142L96 312 72 322zM320 0c53.3 53.3 106.7 106.7 160 160C533.3 106.7 586.7 53.3 640 0C533.3 0 426.7 0 320 0z','M480 160L221.2 418.8s0 0 0 0L318.6 0 320 0 480 160zM640 0l0 320L480 160 640 0zm0 0s0 0 0 0s0 0 0 0s0 0 0 0zM0 256l96 40 96-40 0 96L96 312 0 352l0-96z']
      
    ]
  };

  

  
  

  var faRectangleTerminal = {
    prefix: 'fasds',
    iconName: 'rectangle-terminal',
    icon: [
      512,
      512,
      [],
      'e236',
      
      ['M0 32l512 0 0 448L0 480 0 32zM94.1 176l17 17 63 63-63 63-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c26.7-26.7 53.3-53.3 80-80c5.7-5.7 11.3-11.3 17-17l-17-17-80-80-17-17c-11.3 11.3-22.6 22.6-33.9 33.9zM224 336c0 16 0 32 0 48l24 0 144 0 24 0 0-48-24 0-144 0-24 0z','M111 193l-17-17L128 142.1l17 17 80 80 17 17-17 17-80 80-17 17L94.1 336l17-17 63-63-63-63zM248 336l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z']
      
    ]
  };

  

  
  

  var faAngle90 = {
    prefix: 'fasds',
    iconName: 'angle-90',
    icon: [
      448,
      512,
      [],
      'e08d',
      
      ['M96 97.6l0 48.3c36.9 4.3 71.6 16 102.4 33.6l27.4-39.6C187 117.1 143 102.2 96 97.6zm129.3 99.4c29.4 21.6 54.2 49.1 72.9 80.5l41.7-23.8c-22.2-37.7-52-70.5-87.2-96.2l-27.3 39.5zm87.6 109c10.8 24.3 18.1 50.6 21.3 78l48.3 0c-3.6-36.1-13.2-70.4-27.7-102L312.8 306z','M64 32l0 32 0 352 352 0 32 0 0 64-32 0L32 480 0 480l0-32L0 64 0 32l64 0z']
      
    ]
  };

  

  
  

  var faPersonWalkingWithCane = {
    prefix: 'fasds',
    iconName: 'person-walking-with-cane',
    icon: [
      512,
      512,
      ["blind"],
      'f29d',
      
      ['M334.5 337.1l25.6-19.2L472.8 480.6l9.1 13.2L455.6 512l-9.1-13.2-112-161.7z','M128 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-19.8 80l19.8 0 96 0 16 0 9.6 12.8 96 128 19.2 25.6-51.2 38.4-19.2-25.6L224 213.3l0 74.7 0 18.7 54.6 54.6 9.4 9.4 0 13.3 0 96 0 32-64 0 0-32 0-82.7L146.7 320c-12-12-18.7-28.3-18.7-45.3l0-43.2L92.6 302.3 78.3 330.9 21.1 302.3l14.3-28.6 64-128 8.8-17.7zm20.1 218.8l52.8 52.8-10 40.2-6 24-6 24-6 24-.1 .2-66 0L91 496.2l6-24 6-24 6-24 12-48 7.4-29.4z']
      
    ]
  };

  
    var faBlind = faPersonWalkingWithCane;
  

  
  

  var faTransporterEmpty = {
    prefix: 'fasds',
    iconName: 'transporter-empty',
    icon: [
      512,
      512,
      [],
      'e046',
      
      ['','M96 448H416v64H96V448z']
      
    ]
  };

  

  
  

  var faHotdog = {
    prefix: 'fasds',
    iconName: 'hotdog',
    icon: [
      512,
      512,
      [127789],
      'f80f',
      
      ['M23.4 375.4c16-16 32-32 48-48c85.3-85.3 170.7-170.7 256-256c16-16 32-32 48-48c31.2-31.2 81.9-31.2 113.1 0s31.2 81.9 0 113.1l-48 48-256 256-48 48c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1zm43.4 16.6l13.2 29.1 14.6-6.6 88-40 5.5-2.5 2.5-5.5 37.5-82.5 82.5-37.5 5.5-2.5 2.5-5.5 37.5-82.5 82.5-37.5 14.6-6.6L439.9 82.8l-14.6 6.6-88 40-5.5 2.5-2.5 5.5-37.5 82.5-82.5 37.5-5.5 2.5-2.5 5.5-37.5 82.5L81.4 385.4l-14.6 6.6z','M256 512L512 256l-71.4-71.4-256 256L256 512zM0 256l71.4 71.4 256-256L256 0 0 256zM438.6 118.6l14.6-6.6L439.9 82.8l-14.6 6.6-88 40-5.5 2.5-2.5 5.5-37.5 82.5-82.5 37.5-5.5 2.5-2.5 5.5-37.5 82.5L81.4 385.4l-14.6 6.6 13.2 29.1 14.6-6.6 88-40 5.5-2.5 2.5-5.5 37.5-82.5 82.5-37.5 5.5-2.5 2.5-5.5 37.5-82.5 82.5-37.5z']
      
    ]
  };

  

  
  

  var faEarMuffs = {
    prefix: 'fasds',
    iconName: 'ear-muffs',
    icon: [
      640,
      512,
      [],
      'f795',
      
      ['M96 0l0 32 0 226.7c.6 .2 1.1 .4 1.7 .6C103.2 239 121.9 224 144 224c.7 0 1.4 0 2.1 0s1.4 .1 2.1 .1c1.4 .1 2.7 .3 4.1 .5c2.7 .5 5.3 1.1 7.8 2L160 64l320 0 0 162.7c5-1.8 10.4-2.7 16-2.7c22.1 0 40.8 15 46.3 35.4c.5-.2 1.1-.4 1.7-.6L544 32l0-32L512 0 128 0 96 0z','M179.8 304c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48c-22.1 0-40.8 15-46.3 35.4C92.2 257.2 86.2 256 80 256c-26.5 0-48 21.5-48 48c0 6.2 1.2 12.2 3.4 17.7C15 327.2 0 345.9 0 368s15 40.8 35.4 46.3C33.2 419.8 32 425.8 32 432c0 26.5 21.5 48 48 48c6.2 0 12.2-1.2 17.7-3.4C103.2 497 121.9 512 144 512c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32zm280.4 0c-7.6-8.5-12.2-19.7-12.2-32c0-26.5 21.5-48 48-48c22.1 0 40.8 15 46.3 35.4c5.5-2.2 11.4-3.4 17.7-3.4c26.5 0 48 21.5 48 48c0 6.2-1.2 12.2-3.4 17.7C625 327.2 640 345.9 640 368s-15 40.8-35.4 46.3c2.2 5.5 3.4 11.4 3.4 17.7c0 26.5-21.5 48-48 48c-6.2 0-12.2-1.2-17.7-3.4C536.8 497 518.1 512 496 512c-26.5 0-48-21.5-48-48c0-12.3 4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32c-7.6-8.5-12.2-19.7-12.2-32s4.6-23.5 12.2-32z']
      
    ]
  };

  

  
  

  var faRouteInterstate = {
    prefix: 'fasds',
    iconName: 'route-interstate',
    icon: [
      512,
      512,
      [],
      'f61b',
      
      ['M21.2 192l469.1 0c-.3 51.6-8.2 97.4-26.8 138.7c-33 73-96.8 125.4-194.1 170.4l-12.7 5.9-12.9-5.4c-100.1-41.4-164.4-94-196.9-168.5c-18.2-41.6-25.6-88-25.6-139.8c0-.4 0-.8 0-1.3z','M256 2.3l17 10.6c29.7 18.6 53.7 28.5 78.3 32.6c24.8 4.1 52.6 2.8 90.5-4.8l32.8-6.6 5.1 33.1c6.9 44.7 10.9 86.3 10.7 124.9L21.2 192c.2-38.9 4.3-80.5 11.1-124.9l5.1-33.1 32.8 6.6c37.9 7.6 65.7 8.9 90.5 4.8c24.6-4.1 48.6-14 78.3-32.6L256 2.3z']
      
    ]
  };

  

  
  

  var faBroccoli = {
    prefix: 'fasds',
    iconName: 'broccoli',
    icon: [
      512,
      512,
      [129382],
      'e3e2',
      
      ['M112 352l104 0 40 80 40-80 104 0s-56 64-88 160l-112 0c-32-96-88-160-88-160z','M416 352L96 352 0 352l0-96c0-45.5 31.6-83.6 74.1-93.5C67.7 152.6 64 140.7 64 128c0-35.3 28.7-64 64-64c12.7 0 24.6 3.7 34.5 10.1C172.4 31.6 210.5 0 256 0s83.6 31.6 93.5 74.1C359.4 67.7 371.3 64 384 64c35.3 0 64 28.7 64 64c0 12.7-3.7 24.6-10.1 34.5c42.5 9.9 74.1 48 74.1 93.5l0 96-96 0z']
      
    ]
  };

  

  
  

  var faFaceSmilingHands = {
    prefix: 'fasds',
    iconName: 'face-smiling-hands',
    icon: [
      640,
      512,
      [],
      'e396',
      
      ['M64 252.1l1.3-1.3L88 228.1l22.6 22.6 51.7 51.7 21.7 0 40 0 32 0 0 32 0 15.2c16.8 10.6 38.1 18.4 64 18.4s47.2-7.7 64-18.4l0-15.2 0-32 32 0 40 0 21.7 0 51.7-51.7L552 228.1l22.6 22.6 1.3 1.3C573.9 112.5 460.1 0 320 0S66.1 112.5 64 252.1zM184 232c0-40 28-80 56-80c14 0 28 10 38.5 25c5.2 7.5 9.6 16.3 12.7 25.6c1.5 4.7 2.7 9.5 3.6 14.5c.4 2.5 .7 4.9 .9 7.4c.1 1.2 .2 2.5 .2 3.7c.1 1.3 .1 2.5 .1 3.8c0 0-.4-.5-1.3-1.4s-2-2.1-3.5-3.6c-3.1-3-7.4-7-12.7-11C268 208 254 200 240 200c-28 0-56 32-56 32zm44.9 263.3c28.3 10.8 59 16.7 91.1 16.7s62.8-5.9 91.1-16.7c-17-21.6-27.1-48.9-27.1-78.5l0-30.8c-18.1 8.4-39.4 14-64 14s-45.9-5.6-64-14l0 30.8c0 29.6-10.1 56.9-27.1 78.5zM344 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M240 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm160 0c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zM76.7 307.3L65.4 296 88 273.4l11.3 11.3L184 369.4l0-15 0-20 40 0 0 20 0 29.6 0 20 0 12.8c0 52.6-42.6 95.2-95.2 95.2c-25.2 0-49.5-10-67.3-27.9L12.7 435.3 1.4 424 24 401.4l11.3 11.3 24 24 9.4-9.4-56-56L1.4 360 24 337.4l11.3 11.3 56 56 9.4-9.4-72-72L17.4 312 40 289.4l11.3 11.3 72 72 9.4-9.4-56-56zm486.6 0l-56 56 9.4 9.4 72-72L600 289.4 622.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L616 337.4 638.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L616 401.4 638.6 424l-11.3 11.3-48.8 48.8C560.7 502 536.4 512 511.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-12.8 0-20 0-29.6 0-20 40 0 0 20 0 15 84.7-84.7L552 273.4 574.6 296l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faOilCanDrip = {
    prefix: 'fasds',
    iconName: 'oil-can-drip',
    icon: [
      640,
      512,
      [],
      'e205',
      
      ['M160 64l0 64 64 0 0 32 64 0 0-32 64 0 0-64L160 64zM544 400c0 26.5 21.5 48 48 48s48-16 48-48s-48-96-48-96s-48 64-48 96z','M96 208l0 86.1L48 272.8 48 208l48 0zM0 304l96 42.7L96 416l288 0 48 0L640 192l-32-32L448 192l-64-32-240 0-48 0-48 0L0 160l0 48 0 96z']
      
    ]
  };

  

  
  

  var faObjectsAlignLeft = {
    prefix: 'fasds',
    iconName: 'objects-align-left',
    icon: [
      512,
      512,
      [],
      'e3be',
      
      ['M128 64l0 160 384 0 0-160L128 64zm0 224l0 160 256 0 0-160-256 0z','M0 0L0 512l48 0L48 0 0 0z']
      
    ]
  };

  

  
  

  var faDharmachakra = {
    prefix: 'fasds',
    iconName: 'dharmachakra',
    icon: [
      512,
      512,
      [9784],
      'f655',
      
      ['M0 224l33.9 2.6c-.6 4.8-1.1 9.7-1.4 14.6c-.2 2.5-.3 4.9-.4 7.4s-.1 5-.1 7.4c0 10 .7 19.8 1.9 29.4L0 288l0-64zM52.4 97.6L97.6 52.4l22.1 25.8c-15.6 12-29.6 26-41.6 41.6L52.4 97.6zm0 316.8l25.8-22.1c12 15.6 26 29.6 41.6 41.6L97.6 459.6 52.4 414.4zM96 256c0-8.3 .6-16.5 1.9-24.5l64.1 4.9c-.7 3.2-1.1 6.4-1.5 9.6c-.2 1.6-.3 3.3-.4 4.9c0 .8-.1 1.7-.1 2.5s0 1.7 0 2.5c0 6.7 .7 13.2 2 19.5l-64.1 4.9c-1.2-8-1.9-16.2-1.9-24.5zm30.9-94.5c9.7-13.2 21.4-24.9 34.6-34.6l41.9 48.8c-11 7.2-20.4 16.6-27.6 27.6l-48.8-41.9zm0 189l48.8-41.9c7.2 11 16.6 20.4 27.6 27.6l-41.9 48.8c-13.2-9.7-24.9-21.4-34.6-34.6zM224 0l64 0-2.6 33.9c-4.8-.6-9.7-1.1-14.6-1.4c-2.5-.2-4.9-.3-7.4-.4s-5-.1-7.4-.1c-10 0-19.8 .7-29.4 1.9L224 0zm0 512l2.6-33.9c4.8 .6 9.7 1.1 14.6 1.4c2.4 .2 4.9 .3 7.4 .4s4.9 .1 7.4 .1c10 0 19.8-.7 29.4-1.9L288 512l-64 0zm7.5-414.1c8-1.2 16.2-1.9 24.5-1.9s16.5 .6 24.5 1.9L275.5 162c-3.2-.7-6.4-1.1-9.6-1.5c-1.6-.2-3.3-.3-4.9-.4c-.8 0-1.7-.1-2.5-.1s-1.7 0-2.5 0c-6.7 0-13.2 .7-19.5 2l-4.9-64.1zm0 316.3l4.9-64.1c3.2 .7 6.4 1.2 9.6 1.5c1.6 .2 3.3 .3 4.9 .4c.8 0 1.7 .1 2.5 .1s1.7 0 2.5 0c6.7 0 13.2-.7 19.5-2l4.9 64.1c-8 1.2-16.2 1.9-24.5 1.9s-16.5-.6-24.5-1.9zm77.1-238.4l41.9-48.8c13.2 9.7 24.9 21.4 34.6 34.6l-48.8 41.9c-7.2-11-16.6-20.4-27.6-27.6zm0 160.6c11-7.2 20.4-16.6 27.6-27.6l48.8 41.9c-9.7 13.2-21.4 24.9-34.6 34.6l-41.9-48.8zM350 236.5l64.1-4.9c1.2 8 1.9 16.2 1.9 24.5s-.6 16.5-1.9 24.5L350 275.5c.7-3.2 1.2-6.4 1.5-9.6c.2-1.6 .3-3.3 .4-4.9c0-.8 .1-1.7 .1-2.5s0-1.7 0-2.5c0-6.7-.7-13.2-2-19.5zM392.2 78.2l22.1-25.8 45.3 45.3-25.8 22.1c-12-15.6-26-29.6-41.6-41.6zm0 355.6c15.6-12 29.6-26 41.6-41.6l25.8 22.1-45.3 45.3-22.1-25.8zm85.8-207.2L512 224l0 64-33.9-2.6c.6-4.8 1.1-9.7 1.4-14.6c.2-2.4 .3-4.9 .4-7.4s.1-4.9 .1-7.4c0-10-.7-19.8-1.9-29.4z','M256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 384a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm96-224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faCircleUpLeft = {
    prefix: 'fasds',
    iconName: 'circle-up-left',
    icon: [
      512,
      512,
      [],
      'e128',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-96l160 0 24 24-52 52 76 76-56 56-76-76-52 52-24-24 0-160z','M184 344l-24-24 0-160 160 0 24 24-52 52 76 76-56 56-76-76-52 52z']
      
    ]
  };

  

  
  

  var faCloudHailMixed = {
    prefix: 'fasds',
    iconName: 'cloud-hail-mixed',
    icon: [
      512,
      512,
      [],
      'f73a',
      
      ['M0 480a32 32 0 1 0 64 0A32 32 0 1 0 0 480zm19.2-64l56 0L104 352l-56 0L19.2 416zM96 512l56 0 72-160-56 0L96 512zm128-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm27.2-64l56 0L336 352l-56 0-28.8 64zM328 512l56 0 72-160-56 0L328 512z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faDiagramSankey = {
    prefix: 'fasds',
    iconName: 'diagram-sankey',
    icon: [
      576,
      512,
      [],
      'e158',
      
      ['M0 256l0 64 32 0 109.9 0 86.7 144.5 9.3 15.5 18.1 0 288 0 32 0 0-64-32 0-269.9 0-57.6-96L544 320l32 0 0-64-32 0L32 256 0 256z','M304 32l16 0 224 0 32 0 0 64-32 0L336 96 249.6 211.2 240 224l-16 0L32 224 0 224l0-64 32 0 176 0L294.4 44.8 304 32z']
      
    ]
  };

  

  
  

  var faBarsStaggered = {
    prefix: 'fasds',
    iconName: 'bars-staggered',
    icon: [
      512,
      512,
      ["reorder","stream"],
      'f550',
      
      ['M64 224l448 0 0 64L64 288l0-64z','M448 64L0 64l0 64 448 0 0-64zm0 320L0 384l0 64 448 0 0-64z']
      
    ]
  };

  
    var faReorder = faBarsStaggered;
  
    var faStream = faBarsStaggered;
  

  
  

  var faUserBountyHunter = {
    prefix: 'fasds',
    iconName: 'user-bounty-hunter',
    icon: [
      448,
      512,
      [],
      'e2bf',
      
      ['M64 0l0 16 0 240 0 15.2 0-.8 8.3-128.2c.1-1.7 .2-3.3 .4-5s.3-3.3 .6-4.9c.4-3.3 .9-6.5 1.6-9.7c1.2-6.4 2.9-12.6 4.9-18.6c4-12.1 9.5-23.5 16.3-34l0-38 16 0 0-32L96 0 80 0 64 0zm49.3 252.1l76.8 13.5c-8.4-48.3-43-79.4-71.5-95.4c-1.8 27.3-3.5 54.6-5.3 81.9zM160 464l0 48 128 0 0-48-64-48-64 48zm97.9-198.4l76.8-13.5-5.3-81.9c-28.5 16-63.1 47.1-71.5 95.4z','M224 48c46 0 85.4 30 99 72L125 120c13.6-42 52.9-72 99-72zm24 123.5l80.5-15.1 6.2 95.7L248 267.4l0-95.9zm-48 0l0 95.9-86.7-15.3 6.2-95.7L200 171.5zM224 0C143.9 0 77.5 62.2 72.3 142.2L64 270.5l-1.4 21.4 21.2 3.7 136 24c2.8 .5 5.6 .5 8.3 0l136-24 21.2-3.7-1.4-21.4-8.3-128.2C370.5 62.2 304.1 0 224 0zM448 512L400 352 48 352 0 512l160 0 0-48 64-48 64 48 0 48 160 0z']
      
    ]
  };

  

  
  

  var faChessRook = {
    prefix: 'fasds',
    iconName: 'chess-rook',
    icon: [
      448,
      512,
      [9820],
      'f447',
      
      ['M32 480l48-48 288 0 48 48 0 32L32 512l0-32z','M32 32l0 176 64 48L80 432l288 0L352 256l64-48 0-176-96 0 0 64-48 0 0-64-96 0 0 64-48 0 0-64L32 32zM224 192c17.7 0 32 14.3 32 32l0 64-64 0 0-64c0-17.7 14.3-32 32-32z']
      
    ]
  };

  

  
  

  var faWineBottle = {
    prefix: 'fasds',
    iconName: 'wine-bottle',
    icon: [
      512,
      512,
      [],
      'f72f',
      
      ['M54.7 278.7C89.8 313.8 124.9 348.9 160 384L288 256c-35.1-35.1-70.1-70.1-105.2-105.2c-.9 .8-1.7 1.6-2.5 2.5L54.7 278.7zm301-179l56.6 56.6 32-32 9.4-9.4 11.9 11.9 45.3-45.3L488.2 59 453 23.8 430.4 1.1 385.1 46.4l11.9 11.9-9.4 9.4-32 32z','M412.3 156.3L355.7 99.7l-29.8 29.8c-46.3-23.1-103.7-16-143.1 21.2L288 256 160 384 54.7 278.7 0 333.5 178.5 512 358.7 331.8c39.4-39.4 47.3-98.4 23.7-145.7l29.8-29.8z']
      
    ]
  };

  

  
  

  var faWhiskeyGlassIce = {
    prefix: 'fasds',
    iconName: 'whiskey-glass-ice',
    icon: [
      512,
      512,
      ["glass-whiskey-rocks"],
      'f7a1',
      
      ['M0 32L9.1 96 64 480l384 0L502.9 96 512 32l-64.6 0L64.6 32 0 32zM73.8 96l364.4 0c-4.6 32-9.1 64-13.7 96l-32 224-273 0-32-224c-4.6-32-9.1-64-13.7-96z','M87.5 192l32 224 273 0 32-224-337 0zM256 320l64-64 64 64-64 64-64-64zm0-96l0 50.7-22.6 22.6L210.7 320l16 16L144 336l0-112 112 0z']
      
    ]
  };

  
    var faGlassWhiskeyRocks = faWhiskeyGlassIce;
  

  
  

  var faPollPeople = {
    prefix: 'fasds',
    iconName: 'poll-people',
    icon: [
      640,
      512,
      [],
      'f759',
      
      ['M384 320l0 64 192 0 0 32-192 0 0 64 192 0 64 0 0-64 0-32 0-64-64 0-192 0zM480 32l0 64 96 0 0 32-96 0 0 64 96 0 64 0 0-64 0-32 0-64-64 0-96 0z','M128 48A48 48 0 1 0 32 48a48 48 0 1 0 96 0zM480 32L224 32l0 160 256 0 0-160zM384 320l-160 0 0 160 160 0 0-160zM160 224l-32-96-96 0L0 224l160 0zM128 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm32 176l-32-96-96 0L0 512l160 0z']
      
    ]
  };

  

  
  

  var faHospital = {
    prefix: 'fasds',
    iconName: 'hospital',
    icon: [
      640,
      512,
      [62589,127973,"hospital-alt","hospital-wide"],
      'f0f8',
      
      ['M0 96l0 96 80 0 16 0 0 32-16 0L0 224l0 64 80 0 16 0 0 32-16 0L0 320 0 512l160 0 0-416L0 96zm480 0l0 416 160 0 0-192-80 0-16 0 0-32 16 0 80 0 0-64-80 0-16 0 0-32 16 0 80 0 0-96L480 96z','M480 0L160 0l0 512 112 0 0-128 96 0 0 128 112 0L480 0zM344 64l0 40 40 0 0 48-40 0 0 40-48 0 0-40-40 0 0-48 40 0 0-40 48 0zM560 224l80 0 0-32-80 0-16 0 0 32 16 0zm0 96l80 0 0-32-80 0-16 0 0 32 16 0zM0 224l80 0 16 0 0-32-16 0L0 192l0 32zm0 96l80 0 16 0 0-32-16 0L0 288l0 32z']
      
    ]
  };

  
    var faHospitalAlt = faHospital;
  
    var faHospitalWide = faHospital;
  

  
  

  var faLampDesk = {
    prefix: 'fasds',
    iconName: 'lamp-desk',
    icon: [
      512,
      512,
      [],
      'e014',
      
      ['M92.6 246.2L97 263.8 143 448l66 0L163.4 265.8 256 173.3c0-5.3 0-10.7 0-16c-12.4-12.4-24.8-24.8-37.3-37.3L105.4 233.4 92.6 246.2zm275.8 9.4C378.5 265.7 392.5 272 408 272c30.9 0 56-25.1 56-56c0-15.5-6.3-29.5-16.4-39.6l-79.2 79.2z','M257.9 0C221.5 0 192 29.5 192 65.9c0 17.5 6.9 34.3 19.3 46.6L256 157.3 256 272l48 48L512 112 464 64 349.3 64 304.6 19.3C292.2 6.9 275.4 0 257.9 0zM32 448L0 448l0 64 32 0 320 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  

  
  

  var faEnvelopeOpenText = {
    prefix: 'fasds',
    iconName: 'envelope-open-text',
    icon: [
      512,
      512,
      [],
      'f658',
      
      ['M64 32l149.3 0 85.3 0L448 32l0 112 0 80 0 27.2L256 388.3 64 251.2 64 224l0-80L64 32zm96 96l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zm0 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0z','M489.3 221.7L448 251.2l0-27.2 0-80 64 48 0 13.5-22.7 16.2zm18.6 26l4.1-2.9L512 448l0 64-64 0L64 512 0 512l0-64L0 244.8l4.1 2.9L246.7 421l9.3 6.6 9.3-6.6L507.9 247.7zm-485.2-26L0 205.5 0 192l64-48 0 80 0 27.2L22.7 221.7zM256 0l42.7 32-85.3 0L256 0zM176 128l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faSquareAmpersand = {
    prefix: 'fasds',
    iconName: 'square-ampersand',
    icon: [
      448,
      512,
      [],
      'e260',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 320.3c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8l0-36.7 0-24 24 0 96 0 24 0 0 24 0 35.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9 27.7-40.1 13.7-19.7 39.5 27.3-13.7 19.7-33.3 48.1 60.9 63.6c.8 .8 1.5 1.7 2.2 2.6l-66.1 0-24.8-25.9-10.8 15.6L252.6 384 240 384l-16 0-88 0-24 0 0-24 0-39.7zm48 0l0 15.7 67.4 0 9.2-13.3-39.8-41.5-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4zM184 176l0 12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2 23.1-16.9c4.1-3 6.5-7.8 6.5-12.9l0-11.7-48 0z','M160 128l-24 0 0 24 0 36.7c0 18.6 7.2 36.4 20 49.8l7.3 7.7-21.9 16.1c-18.5 13.6-29.4 35.1-29.4 58.1l0 39.7 0 24 24 0 88 0 16 0 12.6 0 7.2-10.3 10.8-15.6L295.4 384l66.1 0c-.7-.9-1.4-1.8-2.2-2.6l-60.9-63.6 33.3-48.1 13.7-19.7-39.5-27.3-13.7 19.7-27.7 40.1-28.6-29.9 18-13.2c16.4-12.1 26.2-31.2 26.2-51.6l0-35.7 0-24-24 0-96 0zm65.5 72.6l-23.1 16.9-11.7-12.2c-4.3-4.5-6.7-10.4-6.7-16.6l0-12.7 48 0 0 11.7c0 5.1-2.4 9.9-6.5 12.9zM169.8 301l27-19.8 39.8 41.5L227.4 336 160 336l0-15.7c0-7.6 3.6-14.8 9.8-19.4z']
      
    ]
  };

  

  
  

  var faGaugeHigh = {
    prefix: 'fasds',
    iconName: 'gauge-high',
    icon: [
      512,
      512,
      [62461,"tachometer-alt","tachometer-alt-fast"],
      'f625',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-35.3 28.7-64 64-64c.6 0 1.3 0 1.9 0c21.4-48.6 42.7-97.1 64.1-145.7c3.2-7.3 6.4-14.7 9.7-22l43.9 19.3c-3.2 7.3-6.4 14.6-9.7 22c-21.4 48.6-42.7 97.1-64.1 145.7c5.6 5.8 10.1 12.6 13.3 20.1c1.6 3.8 2.8 7.8 3.6 11.9c.2 1.1 .4 2.1 .5 3.2c.1 .8 .2 1.6 .3 2.4c0 .3 .1 .6 .1 .8c.1 .9 .1 1.7 .2 2.4c0 .3 0 .5 0 .6c0 1 .1 1.8 .1 2.6c0 .2 0 .4 0 .6s0 .4 0 .6c0 .9 0 1.7-.1 2.7c0 .1 0 .3 0 .6c0 .7-.1 1.6-.2 2.5c0 .2-.1 .5-.1 .8c-.1 .8-.2 1.8-.4 2.7c-.2 1-.4 2.1-.6 3.2c-.9 4.1-2.1 8.1-3.7 12c-3.2 7.6-7.9 14.5-13.7 20.3C289.7 408.8 273.7 416 256 416c-35.3 0-64-28.7-64-64zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM448 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M322 142.3l9.7-22 43.9 19.3-9.7 22L301.9 307.4C313.1 318.9 320 334.6 320 352c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c.6 0 1.3 0 1.9 0L322 142.3z']
      
    ]
  };

  
    var faTachometerAlt = faGaugeHigh;
  
    var faTachometerAltFast = faGaugeHigh;
  

  
  

  var faSquareThisWayUp = {
    prefix: 'fasds',
    iconName: 'square-this-way-up',
    icon: [
      448,
      512,
      ["box-up"],
      'f49f',
      
      ['M0 32L0 480l448 0 0-448L0 32zM56 168l72-72 72 72 0 24-40 0 0 128-64 0 0-128-40 0 0-24zm8 216l320 0 0 32L64 416l0-32zM248 168l72-72 72 72 0 24-40 0 0 128-64 0 0-128-40 0 0-24z','M56 168l0 24 40 0 0 128 64 0 0-128 40 0 0-24L128 96 56 168zm192 24l40 0 0 128 64 0 0-128 40 0 0-24L320 96l-72 72 0 24z']
      
    ]
  };

  
    var faBoxUp = faSquareThisWayUp;
  

  
  

  var faSection = {
    prefix: 'fasds',
    iconName: 'section',
    icon: [
      256,
      512,
      [],
      'e447',
      
      ['M-8.5 476.2l30.4 10.1c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6c12 1.9 23.8 2.9 35.4 2.9c22.1 0 43.4-3.6 62-11.6c29.4-12.6 52.5-36.5 58.5-71.4c1.1-6.6 1.7-13.1 1.7-19.4c0-12.1-2.2-23.7-6.8-34.6c-6.3-15-16.4-26.4-27.6-35.2c-1-.8-2-1.6-3.1-2.3c-22.1-16.2-51.6-25.3-75.3-32.4c-.7-.2-1.5-.4-2.2-.7l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.8-9.1 7-16 17.3-21.2c11.5-5.9 29.3-9.3 52.5-7.4l24.6 2c-10.5-4.5-23.2-8.7-38.4-13.4c-1.2-.4-2.5-.8-3.7-1.2c-5.9-1.9-11.9-3.8-18.1-5.8s-12.6-4.3-18.9-6.9c-12.8-5.1-25.5-11.1-36.6-18.7C22.1 194.2 6.5 215.3 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31c1.2 .4 2.5 .7 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2c-4.3-1.5-8.5-2.9-12.3-4.2L11.7 415.5-8.5 476.2z','M86 70.6C73.7 76.2 67.1 84.4 64.9 96c-.9 9.2 .6 14.8 2.3 18.5c1.9 4 5.3 8.1 11.4 12.4c13.7 9.8 34.1 16.4 61.5 25l1.4 .5c24.1 7.6 54.9 17.3 77.7 35c12.4 9.6 23.5 22.2 30.2 39c6.7 16.8 8.1 35.3 4.8 55.1c-4.1 24.9-16.1 44.3-32.7 58.2c-1-.8-2-1.6-3.1-2.3c-22.1-16.2-51.6-25.3-75.3-32.4l15.5-3.9c20.8-5.2 30.1-15.9 32.4-30c1.7-10.6 .5-16.9-1.1-20.9c-1.6-4-4.5-8-10-12.2c-12.5-9.7-32-16.4-59.2-25l-3.7-1.2s0 0 0 0c-23.6-7.4-53.1-16.7-75.6-32.8c-12.6-9-24.3-20.9-32-36.9C1.8 126-.8 107.8 1.4 88.1c.1-.5 .1-1.1 .2-1.6c5.8-35.5 28.2-60.7 58-74.1C88.3-.6 123-2.7 157.7 3c9.9 1.6 39.8 7.7 50.9 10.8l30.8 8.7L222.1 84.1l-30.8-8.7c-8-2.2-35.3-7.9-44.1-9.3c-26.4-4.4-47.5-1.7-61.2 4.5z']
      
    ]
  };

  

  
  

  var faSquare0 = {
    prefix: 'fasds',
    iconName: 'square-0',
    icon: [
      448,
      512,
      [],
      'e255',
      
      ['M0 32L0 480l448 0 0-448L0 32zM128 224c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm48 0l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z','M128 224c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm96-48c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48z']
      
    ]
  };

  

  
  

  var faInbox = {
    prefix: 'fasds',
    iconName: 'inbox',
    icon: [
      512,
      512,
      [],
      'f01c',
      
      ['M73 288l71 0c10.7 21.3 21.3 42.7 32 64l160 0 32-64 71 0L391 96 121 96c-16 64-32 128-48 192z','M96 32L71 32 65 56.2 1 312.2l-1 3.8L0 320 0 448l0 32 32 0 448 0 32 0 0-32 0-128 0-3.9-1-3.8-64-256L441 32l-25 0L96 32zM73 288L121 96l270 0 48 192-71 0-32 64-160 0-32-64-71 0z']
      
    ]
  };

  

  
  

  var faFaceSunglasses = {
    prefix: 'fasds',
    iconName: 'face-sunglasses',
    icon: [
      512,
      512,
      [],
      'e398',
      
      ['M0 256c0-22.1 2.8-43.5 8.1-64l7.9 0 41.1 0c7.6 26.7 15.2 53.3 22.9 80l128 0 27.4-96 41.1 0L304 272l128 0 22.9-80 41.1 0 7.9 0c5.3 20.5 8.1 41.9 8.1 64c0 141.4-114.6 256-256 256S0 397.4 0 256zm18.6-96C56.6 66.2 148.6 0 256 0S455.4 66.2 493.4 160L464 160l0-32-192 0c0 5.3 0 10.7 0 16l-32 0c0-5.3 0-10.7 0-16L48 128c0 10.7 0 21.3 0 32l-29.4 0zM129.7 343.2C142.3 368.3 184.4 416 256 416s113.7-47.7 126.3-72.8l-28.6-14.3C344.9 346.3 312.4 384 256 384s-88.9-37.7-97.7-55.2l-28.6 14.3z','M208 272L80 272 57.1 192 16 192 0 192l0-32 16 0 32 0 0-32 192 0 0 16 32 0 0-16 192 0 0 32 32 0 16 0 0 32-16 0-41.1 0L432 272l-128 0-27.4-96-41.1 0L208 272z']
      
    ]
  };

  

  
  

  var faSocks = {
    prefix: 'fasds',
    iconName: 'socks',
    icon: [
      512,
      512,
      [129510],
      'f696',
      
      ['M0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4L288 256l0-96-160 0 0 112L38.4 339.2C14.2 357.3 0 385.8 0 416zM128 0l0 64 160 0 0-64L128 0zm0 96l0 32 160 0 0-32L128 96zM320 64l0 32 192 0 0-32L320 64zm0 64l0 32 192 0 0-32-192 0z','M320 128l192 0 0-32L320 96l0 32zm0 32l0 112-89.6 67.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2L512 368l0-208-192 0zM512 64l0-64L320 0l0 64 192 0zM128 64l0 32 160 0 0-32L128 64zm160 64l-160 0 0 32 160 0 0-32z']
      
    ]
  };

  

  
  

  var faGrid4 = {
    prefix: 'fasds',
    iconName: 'grid-4',
    icon: [
      448,
      512,
      [],
      'e198',
      
      ['M0 151.5l0 89.6 89.6 0 0-89.6L0 151.5zM0 390.4L0 480l89.6 0 0-89.6L0 390.4zM119.5 32l0 89.6 89.6 0 0-89.6-89.6 0zm0 238.9l0 89.6 89.6 0 0-89.6-89.6 0zM238.9 151.5l0 89.6 89.6 0 0-89.6-89.6 0zm0 238.9l0 89.6 89.6 0 0-89.6-89.6 0zM358.4 32l0 89.6 89.6 0L448 32l-89.6 0zm0 238.9l0 89.6 89.6 0 0-89.6-89.6 0z','M89.6 32L0 32l0 89.6 89.6 0 0-89.6zm0 238.9L0 270.9l0 89.6 89.6 0 0-89.6zm29.9-119.5l0 89.6 89.6 0 0-89.6-89.6 0zm89.6 238.9l-89.6 0 0 89.6 89.6 0 0-89.6zM238.9 32l0 89.6 89.6 0 0-89.6-89.6 0zm89.6 238.9l-89.6 0 0 89.6 89.6 0 0-89.6zm29.9-119.5l0 89.6 89.6 0 0-89.6-89.6 0zM448 390.4l-89.6 0 0 89.6 89.6 0 0-89.6z']
      
    ]
  };

  

  
  

  var faBatteryEmpty = {
    prefix: 'fasds',
    iconName: 'battery-empty',
    icon: [
      576,
      512,
      ["battery-0"],
      'f244',
      
      ['M64 160l0 192 416 0 0-192L64 160zM0 96l64 0 416 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0L64 416 0 416l0-64L0 160 0 96z','']
      
    ]
  };

  
    var faBattery0 = faBatteryEmpty;
  

  
  

  var faSnowflakeDroplets = {
    prefix: 'fasds',
    iconName: 'snowflake-droplets',
    icon: [
      640,
      512,
      [],
      'e5c1',
      
      ['M96.2 163.7l27.7 16 12.2 7-11.8 3.2-23.2 6.2 12.4 46.4 23.2-6.2 58.2-15.6L256 256l-61.2 35.3-58.2-15.6-23.2-6.2-11.3 42.3 2.6 5.1 19.5 5.2 11.8 3.2-12.2 7-8.6 5 29.3 57 11.3-6.5 12.2-7-3.2 11.8-6.2 23.2L205 428.1l6.2-23.2 15.6-58.2L288 311.4l0 70.6-42.6 42.6-17 17 33.9 33.9 17-17 8.6-8.6 0 30.1 0 32 64 0 0-32 0-30.1 8.6 8.6 17 17 33.9-33.9-17-17L352 382.1l0-70.6 61.2 35.3 15.6 58.2 6.2 23.2 46.4-12.4-6.2-23.2L472 380.7l12.2 7 11.3 6.5 29.3-57-8.6-5-12.2-7 11.8-3.2 19.5-5.2 2.6-5.1-11.3-42.3-23.2 6.2-58.2 15.6L384 256l61.2-35.3 58.2 15.6 23.2 6.2 12.4-46.4-23.2-6.2L504 186.7l12.2-7 27.7-16-32-55.4-27.7 16-12.2 7 3.2-11.8 6.2-23.2L435 83.9l-6.2 23.2-15.6 58.2L352 200.6l0-70.6 42.6-42.6 17-17L377.6 36.5l-17 17L352 62.1 352 32l0-32L288 0l0 32 0 30.1-8.6-8.6-17-17L228.5 70.4l17 17L288 129.9l0 70.6-61.2-35.3-15.6-58.2L205 83.9 158.7 96.3l6.2 23.2 3.2 11.8-12.2-7-27.7-16-32 55.4z','M64 320L8.3 417.4C2.9 427 0 437.8 0 448.8C0 483.7 28.3 512 63.2 512l1.6 0c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L64 320zm512 0l-55.7 97.4c-5.5 9.6-8.3 20.4-8.3 31.4c0 34.9 28.3 63.2 63.2 63.2l1.6 0c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L576 320z']
      
    ]
  };

  

  
  

  var faDove = {
    prefix: 'fasds',
    iconName: 'dove',
    icon: [
      512,
      512,
      [128330],
      'f4ba',
      
      ['M0 432l80 64 80 16 76.8-64 83.2 0c88.4 0 160-71.6 160-160l0-168 32-56L400 64c-44.2 0-80 35.8-80 80l0 30.5 0 33.5c-43.1-3.6-118.1-24.1-170.3-76.2C124.3 106.5 104.4 73.8 96 32c-1.7 2.6-4.5 6.1-8.1 10.4C69.6 65.1 32 111.5 32 176c0 120.6 85.2 184.4 121.8 204.7L0 432zM416 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M236.8 2.8c-18.1 15.6-68.3 58.8-86.9 128.3l-.2 .7C201.9 183.9 276.9 204.4 320 208l0-33.5C274.3 133.1 235.2 73.9 240 0c-.9 .8-2 1.7-3.2 2.8z']
      
    ]
  };

  

  
  

  var faHandBackPointRight = {
    prefix: 'fasds',
    iconName: 'hand-back-point-right',
    icon: [
      512,
      512,
      [],
      'e1a1',
      
      ['M512 208l0-80-224 0-13.3 0-2.7 0-80 0-16 0 0-32 16 0 56 0L208 48l-68 0c-38 0-74 16.9-98.3 46.1l-4.5 5.4C13.1 128.3 0 164.5 0 201.9L0 320c0 70.7 57.3 128 128 128l16 0 48 0 80 0 0-80 32 0 0-80 32 0 0-80 176 0z','']
      
    ]
  };

  

  
  

  var faHatChef = {
    prefix: 'fasds',
    iconName: 'hat-chef',
    icon: [
      512,
      512,
      [],
      'f86b',
      
      ['M0 127.2c0 11.1 1.9 22.1 5.7 32.5L64 320l74.2 0-26-149.3L109.5 155l31.5-5.5 2.7 15.8L170.7 320l69.3 0 0-160 0-16 32 0 0 16 0 160 69.3 0 26.9-154.7 2.7-15.8 31.5 5.5-2.7 15.8L373.8 320l74.2 0 58.3-160.2c3.8-10.4 5.7-21.4 5.7-32.5C512 74.6 469 32 416.4 32c-21.7 0-41.8 7.2-57.9 19.3C335.1 20.2 297.9 0 256 0s-79.1 20.2-102.5 51.3C137.4 39.2 117.3 32 95.6 32C43 32 0 74.6 0 127.2z','M64 320H448V512H64V320z']
      
    ]
  };

  

  
  

  var faGameBoard = {
    prefix: 'fasds',
    iconName: 'game-board',
    icon: [
      448,
      512,
      [],
      'f867',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 96l80 0 80 0 80 0 80 0 0 80 0 80 0 80 0 80-80 0-80 0-80 0-80 0 0-80 0-80 0-80 0-80z','M64 256l0 80h80V256H64zM384 416l0-80H304v80h80zm-240 0h80V336H144v80zM64 96l0 80h80V96H64zm160 80H144v80h80V176zm0 80v80h80V256H224zm160 0V176H304v80h80zM304 96H224v80h80V96z']
      
    ]
  };

  

  
  

  var faPersonBurst = {
    prefix: 'fasds',
    iconName: 'person-burst',
    icon: [
      640,
      512,
      [],
      'e53b',
      
      ['M4.4 215.2L100 236.6l-.4 98L176 273.2l76.4 61.4-.4-98 95.6-21.4-76.9-60.8 42.9-88.1L218.2 88.5 176 0 133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2z','M432 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-20.6 80l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-33.8-53L552 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53-53.9-34.4 81.7-128 9.4-14.8z']
      
    ]
  };

  

  
  

  var faCrateApple = {
    prefix: 'fasds',
    iconName: 'crate-apple',
    icon: [
      512,
      512,
      ["apple-crate"],
      'f6b1',
      
      ['M0 224l40.4 0 239.2 0 33.4 0 158.6 0 40.4 0 0 128L0 352 0 224zM0 384l512 0 0 128L0 512 0 384zm48-96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 160a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM432 288a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 160a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M160 54.9l0 9.1 9.1 0C199.4 64 224 39.4 224 9.1L224 0l-9.1 0C184.6 0 160 24.6 160 54.9zm192 0l0 9.1 9.1 0C391.4 64 416 39.4 416 9.1L416 0l-9.1 0C376.6 0 352 24.6 352 54.9zM96 80c-43.6 0-64 47.8-64 91.4c0 19 3.1 36.7 8.4 52.6l239.2 0c5.4-15.9 8.4-33.6 8.4-52.6c0-43.6-20.4-91.4-64-91.4c-27.4 0-64 18.3-64 18.3s-36.6-18.3-64-18.3zm384 91.4c0-43.6-20.4-91.4-64-91.4c-27.4 0-64 18.3-64 18.3s-34.3-17.1-61.3-18.2c3.4 4 6.4 8.3 9 12.7C314 116.4 320 145.3 320 171.4c0 18.5-2.5 36.1-7 52.6l158.6 0c5.3-15.9 8.4-33.6 8.4-52.6zM80 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 160a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  
    var faAppleCrate = faCrateApple;
  

  
  

  var faFileSvg = {
    prefix: 'fasds',
    iconName: 'file-svg',
    icon: [
      512,
      512,
      [],
      'e64b',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM205.7 352c-25.2 0-45.7 20.4-45.7 45.7c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7L176 480l-16 0 0 32 16 0 34.3 0c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7l26.3 0 16 0 0-32-16 0-26.3 0zM320 368l0-16-32 0 0 16 0 35c0 21.1 3.8 42 11.2 61.8L313 501.6l3.9 10.4 11.1 0 16 0 11.1 0 3.9-10.4 13.8-36.8C380.2 445 384 424.1 384 403l0-35 0-16-32 0 0 16 0 35c0 17.3-3.1 34.4-9.2 50.6L336 471.8l-6.8-18.2c-6.1-16.2-9.2-33.3-9.2-50.6l0-35zm96 24l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24 0-16-16 0-16 0-16 0 0 32 16 0 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 32 0 0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40z']
      
    ]
  };

  

  
  

  var faEarthAmericas = {
    prefix: 'fasds',
    iconName: 'earth-americas',
    icon: [
      512,
      512,
      [127758,"earth","earth-america","globe-americas"],
      'f57d',
      
      ['M0 256C0 397.4 114.6 512 256 512c136 0 247.2-106.1 255.5-240c-37.2 0-74.3 0-111.5 0c0-26.7 0-53.3 0-80c24.2-24.2 48.4-48.4 72.6-72.6C429.9 51.9 356.5 5.7 272 .5c0 26.5 0 53 0 79.5c-10.7 10.7-21.3 21.3-32 32c0 5.3 0 10.7 0 16c10.7 10.7 21.3 21.3 32 32c0 10.7 0 21.3 0 32c-26.7 0-53.3 0-80 0c0 10.7 0 21.3 0 32c10.7 10.7 21.3 21.3 32 32c42.7 0 85.3 0 128 0c0 26.7 0 53.3 0 80c-21.3 21.3-42.7 42.7-64 64c0 16 0 32 0 48l-64 0c0-21.3 0-42.7 0-64c-10.7-10.7-21.3-21.3-32-32c0-21.3 0-42.7 0-64c-16-16-32-32-48-48c-16 0-32 0-48 0c-28.5-19-57-38-85.5-57C3.7 206.2 0 230.6 0 256z','M192 352l0-64-48-48-48 0L10.6 183C42 77.2 140 0 256 0c5.4 0 10.7 .2 16 .5L272 80l-32 32 0 16 32 32 0 32-80 0 0 32 32 32 128 0 0 80-64 64 0 48-64 0 0-64-32-32zM472.6 119.4C497.5 159 512 205.8 512 256c0 5.4-.2 10.7-.5 16L400 272l0-80 72.6-72.6z']
      
    ]
  };

  
    var faEarth = faEarthAmericas;
  
    var faEarthAmerica = faEarthAmericas;
  
    var faGlobeAmericas = faEarthAmericas;
  

  
  

  var faHexagonImage = {
    prefix: 'fasds',
    iconName: 'hexagon-image',
    icon: [
      512,
      512,
      [],
      'e504',
      
      ['M0 256L128 480l256 0L512 256 384 32 128 32 0 256zm107.1 79.9c17.1-18.7 34.1-37.4 51.2-56.1c5.8-6.3 11.5-12.6 17.3-19c5.9 6.2 11.8 12.4 17.8 18.6c13 13.5 25.9 27.1 38.9 40.6l71.6-86.2c6.2-7.4 12.3-14.8 18.5-22.2c6.2 7.4 12.3 14.8 18.5 22.2l72.6 87.4L353.5 424.9l-195 0-51.4-89zM232 160a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z','M107.1 335.9l51.4 89 195 0 59.9-103.7L322.3 211.6 232.2 320l-56.6-59.2-68.5 75z']
      
    ]
  };

  

  
  

  var faEraser = {
    prefix: 'fasds',
    iconName: 'eraser',
    icon: [
      576,
      512,
      [],
      'f12d',
      
      ['M16 336l45.3 45.3L160 480l160 0 192 0 32 0 0-64-32 0-128 0 24-24-45.3-45.3L293.5 416l-5.5 0-101.5 0-80-80L229.3 213.3c-15.1-15.1-30.2-30.2-45.3-45.3c-40.9 40.9-81.8 81.8-122.7 122.7L16 336z','M184 168L336 16 560 240 408 392 184 168z']
      
    ]
  };

  

  
  

  var faBullseyePointer = {
    prefix: 'fasds',
    iconName: 'bullseye-pointer',
    icon: [
      512,
      512,
      [],
      'f649',
      
      ['M0 256c0 10.2 .6 20.2 1.8 30.1l62.6-18.4c-.2-3.9-.4-7.8-.4-11.7C64 150 150 64 256 64s192 86 192 192s-86 192-192 192c-3.9 0-7.8-.1-11.7-.4l-18.4 62.6c9.9 1.2 19.9 1.8 30.1 1.8c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zm112-2.3L179.1 234c9.6-33.5 40.4-58 76.9-58c44.2 0 80 35.8 80 80c0 36.5-24.5 67.4-58 76.9l-19.7 67C336.8 398.8 400 334.8 400 256c0-79.5-64.5-144-144-144c-78.8 0-142.8 63.2-144 141.7z','M272 240L0 320l96 48 1.4 1.4-96 96 45.3 45.3 96-96L144 416l48 96 80-272z']
      
    ]
  };

  

  
  

  var faDroplet = {
    prefix: 'fasds',
    iconName: 'droplet',
    icon: [
      384,
      512,
      [128167,"tint"],
      'f043',
      
      ['M0 320C0 426 86 512 192 512s192-86 192-192S192 0 192 0S0 214 0 320zm64 0l32 0 0 16c0 44.2 35.8 80 80 80l16 0 0 32-16 0c-61.9 0-112-50.1-112-112l0-16z','M96 320l0 16c0 44.2 35.8 80 80 80l16 0 0 32-16 0c-61.9 0-112-50.1-112-112l0-16 32 0z']
      
    ]
  };

  
    var faTint = faDroplet;
  

  
  

  var faCircleWifi = {
    prefix: 'fasds',
    iconName: 'circle-wifi',
    icon: [
      512,
      512,
      [],
      'e67d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm78.5-33.5C122.4 174.3 185.7 144 256 144s133.6 30.3 177.5 78.5l-34 34C364.4 216.9 313.1 192 256 192s-108.4 24.9-143.5 64.5l-34-34zm70.1 70.1c24.9-32 63.7-52.6 107.4-52.6s82.5 20.6 107.4 52.6l-34.4 34.4C313.3 303.5 286.4 288 256 288s-57.3 15.5-73.1 38.9l-34.4-34.4zM288 368a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M433.5 222.5l-34 34C364.4 216.9 313.1 192 256 192s-108.4 24.9-143.5 64.5l-34-34C122.4 174.3 185.7 144 256 144s133.6 30.3 177.5 78.5zM256 240c43.7 0 82.5 20.6 107.4 52.6l-34.4 34.4C313.3 303.5 286.4 288 256 288s-57.3 15.5-73.1 38.9l-34.4-34.4c24.9-32 63.7-52.6 107.4-52.6zm0 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faNotebook = {
    prefix: 'fasds',
    iconName: 'notebook',
    icon: [
      512,
      512,
      [],
      'e201',
      
      ['M192 0L480 0l0 512-288 0L192 0z','M192 0L64 0l0 104-40 0L0 104l0 48 24 0 40 0 0 80-40 0L0 232l0 48 24 0 40 0 0 80-40 0L0 360l0 48 24 0 40 0 0 104 128 0L192 0z']
      
    ]
  };

  

  
  

  var faFolderMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'folder-magnifying-glass',
    icon: [
      512,
      512,
      ["folder-search"],
      'e18b',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM144 272c0-53 43-96 96-96s96 43 96 96c0 17.8-4.9 34.5-13.3 48.9L361 359.2l17 17L344 410.1l-17-17-38.4-38.4C274.4 363.2 257.8 368 240 368c-53 0-96-43-96-96zm48 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M322.7 320.9c8.5-14.3 13.3-31 13.3-48.9c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L327 393.1l17 17 33.9-33.9-17-17-38.3-38.3zM192 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z']
      
    ]
  };

  
    var faFolderSearch = faFolderMagnifyingGlass;
  

  
  

  var faCandyCorn = {
    prefix: 'fasds',
    iconName: 'candy-corn',
    icon: [
      640,
      512,
      [],
      'f6bd',
      
      ['M0 334.2s0-44.4 88.9-133.3S222.2 112 222.2 112l54.9 54.9c-23.8 13.8-70 44.1-124.1 98.2c-54 54-84.3 100.1-98.1 123.9L0 334.2zM216.6 458.6c15.6-20.3 35.7-43.8 60.8-69c25.3-25.3 48.8-45.3 69.1-61c17.8 46.3 35.6 92.6 53.4 138.9L355.6 512c-46.3-17.8-92.6-35.6-139-53.4zM320 32s32-32 160-32S640 32 640 32l0 83c-25.5-7-80.7-19-160-19s-134.5 12-160 19l0-83zm66.6 245.9c25.7-3.4 57-5.9 93.4-5.9s67.7 2.5 93.4 5.9L512 416l-64 0L386.6 277.9z','M327.6 145c28-7.1 80.3-17 152.4-17s124.4 10 152.4 17L573.4 277.9c-25.7-3.4-57-5.9-93.4-5.9s-67.7 2.5-93.4 5.9L327.6 145zM80.7 406.3c15.1-25.1 44.8-68.4 94.9-118.5c50.2-50.2 93.6-80 118.7-95l52.3 135.9c-20.3 15.6-43.9 35.7-69.1 61c-25.2 25.2-45.2 48.7-60.8 69L80.7 406.3z']
      
    ]
  };

  

  
  

  var faMessageQuote = {
    prefix: 'fasds',
    iconName: 'message-quote',
    icon: [
      512,
      512,
      ["comment-alt-quote"],
      'e1e4',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM128 112l0 112 64 0 0 32-24 0-24 0 0 48 24 0 48 0 24 0 0-24 0-56 0-48 0-24 0-40-112 0zm144 0l0 112 64 0 0 32-24 0-24 0 0 48 24 0 48 0 24 0 0-24 0-56 0-48 0-24 0-40-112 0z','M128 112l112 0 0 40 0 24 0 48 0 56 0 24-24 0-48 0-24 0 0-48 24 0 24 0 0-32-64 0 0-112zm144 0l112 0 0 40 0 24 0 48 0 56 0 24-24 0-48 0-24 0 0-48 24 0 24 0 0-32-64 0 0-112z']
      
    ]
  };

  
    var faCommentAltQuote = faMessageQuote;
  

  
  

  var faUserRobotXmarks = {
    prefix: 'fasds',
    iconName: 'user-robot-xmarks',
    icon: [
      448,
      512,
      [],
      'e4a7',
      
      ['M32 128l0 128 48 0 0-128-48 0zM144 448l0 16 0 48 32 0 0-48 0-16-32 0zM208 0l0 16 0 48 32 0 0-48 0-16L208 0zm0 448l0 16 0 48 32 0 0-48 0-16-32 0zm64 0l0 16 0 48 32 0 0-48 0-16-32 0zm96-320l0 128 48 0 0-128-48 0z','M80 64l288 0 0 256L80 320 80 64zm96 176l-32 0 0 32 32 0 0-32zm32 0l0 32 32 0 0-32-32 0zm96 32l0-32-32 0 0 32 32 0zM48 352l352 0 48 160-96 0 0-96L96 416l0 96L0 512 48 352zm80-241l-17 17 8.5 8.5L143 160l-23.5 23.5L111 192l17 17 8.5-8.5L160 177l23.5 23.5L192 209l17-17-8.5-8.5L177 160l23.5-23.5L209 128l-17-17-8.5 8.5L160 143l-23.5-23.5L128 111zm136.5 8.5L256 111l-17 17 8.5 8.5L271 160l-23.5 23.5L239 192l17 17 8.5-8.5L288 177l23.5 23.5L320 209l17-17-8.5-8.5L305 160l23.5-23.5L337 128l-17-17-8.5 8.5L288 143l-23.5-23.5z']
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fasds',
    iconName: 'arrow-down',
    icon: [
      384,
      512,
      [8595],
      'f063',
      
      ['M160 32l0 32 0 290.7 32 32 32-32L224 64l0-32-64 0z','M192 477.3l22.6-22.6 144-144L381.3 288 336 242.7l-22.6 22.6L192 386.7 70.6 265.4 48 242.7 2.7 288l22.6 22.6 144 144L192 477.3z']
      
    ]
  };

  

  
  

  var faPersonSwimming = {
    prefix: 'fasds',
    iconName: 'person-swimming',
    icon: [
      576,
      512,
      [127946,"swimmer"],
      'f5c4',
      
      ['M0 352l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2C38.6 345.9 19.3 352 0 352z','M446.6 295.9l-134.2-115L333.3 160 448 160l32 0 0-64-32 0L320 96l-13.3 0-9.4 9.4-128 128-9.4 9.4 0 13.3 0 56.3c10.7 4 21.8 6.7 32 6.7c13 0 27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5l1.1-.8L288 272l19.7 14.2c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c7.6-3.5 14.4-7.6 21.9-12.7zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128z']
      
    ]
  };

  
    var faSwimmer = faPersonSwimming;
  

  
  

  var faTRex = {
    prefix: 'fasds',
    iconName: 't-rex',
    icon: [
      640,
      512,
      [],
      'e629',
      
      ['M0 286.4C0 358 58 416 129.6 416l54.4 0 72 96 128 0 0-16c0-26.5-21.5-48-48-48l-18.6-49.6 41.9-37.7L368 352l0-32c0-35.3-28.7-64-64-64l-16 0-16 0 0-32 16 0 16 0c34.8 0 65.3 18.5 82.1 46.3L432 300.8l0 19.2 0 24 48 0 0-24 0-32 0-12.8L469.3 268l-44.4-29.6L464 208l112 0 21.3-32L552 176l-3.3 0-2.3-2.3L516.7 144 488 144l-8 0 0-16 8 0 32 0 3.3 0 2.3 2.3L555.3 160l52.7 0 24 0 8 0 0-48c0-44.2-35.8-80-80-80l-16 0L528 0 440.3 0 440 0c-33.5 .1-63.2 21.6-73.8 53.4L352 96l-32 32-41 0c-70.7 0-132.9 46.3-153.3 114L112 288l-32 0L48 192l-16 0-6.3 9.4C9 226.6 0 256.1 0 286.4zM512 56a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M480 56a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z']
      
    ]
  };

  

  
  

  var faPretzel = {
    prefix: 'fasds',
    iconName: 'pretzel',
    icon: [
      512,
      512,
      [129384],
      'e441',
      
      ['M0 170.6C0 94.1 62.1 32 138.6 32l9.4 0c42.6 0 81 18 108 46.8C283 50 321.4 32 364 32l9.4 0C449.9 32 512 94.1 512 170.6c0 82.7-40.9 155.9-103.7 200.4l21.1 30 23 32.7-65.4 46L364 447l-28.7-40.7c-21.8 6.4-44.9 9.8-68.7 9.8L256 416l-10.6 0c-23.9 0-46.9-3.4-68.7-9.8L148 447l-23 32.7-65.4-46 23-32.7 21.1-30C40.9 326.5 0 253.3 0 170.6zM25.4 208L48 230.6c7.5-7.5 15.1-15.1 22.6-22.6c-7.5-7.5-15.1-15.1-22.6-22.6c-7.5 7.5-15.1 15.1-22.6 22.6zM80 170.6c0 55.7 27.5 105 69.7 134.9l52.5-74.7c8.9-12.7 13.7-27.9 13.7-43.4l0-7.4c0-37.6-30.4-68-68-68l-9.4 0C106.2 112 80 138.2 80 170.6zM89.4 80L112 102.6c7.5-7.5 15.1-15.1 22.6-22.6c-7.5-7.5-15.1-15.1-22.6-22.6C104.5 64.9 96.9 72.5 89.4 80zm64 288L176 390.6 198.6 368c-7.5-7.5-15.1-15.1-22.6-22.6c-7.5 7.5-15.1 15.1-22.6 22.6zm73.5-33c6.1 .7 12.3 1 18.6 1l10.6 0 10.6 0c6.3 0 12.5-.3 18.6-1L256 293.5 226.8 335zm22.5-191a22.6 22.6 0 1 0 45.3 0 22.6 22.6 0 1 0 -45.3 0zM296 180l0 7.4c0 15.5 4.8 30.7 13.7 43.4l52.5 74.7c42.2-30 69.7-79.2 69.7-134.9c0-32.4-26.2-58.6-58.6-58.6l-9.4 0c-37.6 0-68 30.4-68 68zm81.4 252L400 454.6 422.6 432c-7.5-7.5-15.1-15.1-22.6-22.6c-7.5 7.5-15.1 15.1-22.6 22.6zm32-128L432 326.6c7.5-7.5 15.1-15.1 22.6-22.6c-7.5-7.5-15.1-15.1-22.6-22.6c-7.5 7.5-15.1 15.1-22.6 22.6zm32-192L464 134.6c7.5-7.5 15.1-15.1 22.6-22.6c-7.5-7.5-15.1-15.1-22.6-22.6c-7.5 7.5-15.1 15.1-22.6 22.6z','M89.4 80L112 57.4 134.6 80 112 102.6 89.4 80zm-64 128L48 185.4 70.6 208 48 230.6 25.4 208zM272 121.4L294.6 144 272 166.6 249.4 144 272 121.4zM441.4 112L464 89.4 486.6 112 464 134.6 441.4 112zM432 281.4L454.6 304 432 326.6 409.4 304 432 281.4zM153.4 368L176 345.4 198.6 368 176 390.6 153.4 368zM400 409.4L422.6 432 400 454.6 377.4 432 400 409.4z']
      
    ]
  };

  

  
  

  var faQuotes = {
    prefix: 'fasds',
    iconName: 'quotes',
    icon: [
      576,
      512,
      [],
      'e234',
      
      ['M256 272l0 144 80 0 0 8c0 13.3-10.7 24-24 24l-8 0-32 0 0 64 32 0 8 0c48.6 0 88-39.4 88-88l0-8 0-72 0-72-144 0zm176 0l0 144 80 0 0 8c0 13.3-10.7 24-24 24l-8 0-32 0 0 64 32 0 8 0c48.6 0 88-39.4 88-88l0-8 0-72 0-72-144 0z','M0 88C0 39.4 39.4 0 88 0l8 0 32 0 0 64L96 64l-8 0C74.7 64 64 74.7 64 88l0 8 80 0 0 144L0 240l0-72L0 96l0-8zm176 0c0-48.6 39.4-88 88-88l8 0 32 0 0 64-32 0-8 0c-13.3 0-24 10.7-24 24l0 8 80 0 0 144-144 0 0-72 0-72 0-8z']
      
    ]
  };

  

  
  

  var faGreaterThan = {
    prefix: 'fasds',
    iconName: 'greater-than',
    icon: [
      384,
      512,
      [62769],
      '3e',
      
      ['M0 64.5l5 2.2 360 160 19 8.4 0 41.6-19 8.4L5 445.2l-5 2.2 0-70L273.2 256 0 134.6l0-70z','']
      
    ]
  };

  

  
  

  var faFile = {
    prefix: 'fasds',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      ['M0 0L0 512l384 0 0-352-160 0L224 0 0 0z','M224 0L384 160H224V0z']
      
    ]
  };

  

  
  

  var faBoxOpenFull = {
    prefix: 'fasds',
    iconName: 'box-open-full',
    icon: [
      640,
      512,
      ["box-full"],
      'f49c',
      
      ['M0 288L64 160l256 32L224 352 64 306.3C42.7 300.2 21.3 294.1 0 288zm320-96l256-32 64 128c-21.3 6.1-42.7 12.2-64 18.3c-53.3 15.2-106.7 30.5-160 45.7c-32-53.3-64-106.7-96-160z','M312.8 157.6c4.6-8.8 7.2-18.9 7.2-29.6c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.1 .6 10 1.7 14.7l-65.5-8.2c-.1-2.2-.2-4.3-.2-6.5C128 57.3 185.3 0 256 0s128 57.3 128 128c0 1.2 0 2.4 0 3.5L444.6 3.5l86.8 41.1-44.1 93L320 158.5l-7.2-.9zM224 352l96-160 96 160 160-45.7L576 448 320 512 64 448l0-141.7L224 352z']
      
    ]
  };

  
    var faBoxFull = faBoxOpenFull;
  

  
  

  var faCrab = {
    prefix: 'fasds',
    iconName: 'crab',
    icon: [
      512,
      512,
      [129408],
      'e3ff',
      
      ['M1.8 276.4l17.8-26.6 13.3 8.9 20 13.3 36.5 0c-4.1 10.1-6.9 20.8-8.3 32l-33 0-4.8 0-4-2.7-24-16L1.8 276.4zM9.4 384l11.3-11.3 32-32 2.7-2.7 3.6-1.2 21.1-7c0 2.1 0 4.1 0 6.2c6.9 6.9 13.8 13.8 20.6 20.6l-28 9.3L43.3 395.3 32 406.6 9.4 384zm32 64l11.3-11.3 32-32 2.7-2.7 3.6-1.2 40.4-13.5c8.4 8.4 16.9 16.9 25.3 25.3l-52 17.3L75.3 459.3 64 470.6 41.4 448zm86.6 6.9l7.8-4.7 36.6-21.9c1.6 1.6 3.3 3.3 4.9 4.9L192 448l9.8 0L160 473.1l0 22.9 0 16-32 0 0-16 0-32 0-9.1zM192 128l32 0 0 16 0 48-16 0c-5.4 0-10.8 .3-16 1l0-49 0-16zm96 0l32 0 0 16 0 49c-2.6-.3-5.3-.6-7.9-.7c-1.3-.1-2.7-.1-4-.2s-2.7-.1-4-.1l-16 0 0-48 0-16zm22.2 320l9.8 0 19.7-19.7 36.6 21.9 7.8 4.7 0 9.1 0 32 0 16-32 0 0-16 0-22.9L310.2 448zm45.1-35.4l25.3-25.3 40.4 13.5 3.6 1.2 2.7 2.7 32 32L470.6 448 448 470.6l-11.3-11.3L407.4 430l-52-17.3zm56-56L432 336l0-6.2 21.1 7 3.6 1.2 2.7 2.7 32 32L502.6 384 480 406.6l-11.3-11.3L439.4 366l-28-9.3zM422.7 272l36.5 0 20-13.3 13.3-8.9 17.8 26.6-13.3 8.9-24 16-4 2.7-4.8 0-33 0c-1.4-11.2-4.2-21.9-8.3-32z','M0 128C0 57.3 57.3 0 128 0l64 0L128 64l64 0c0 35.3-28.7 64-64 64l-80 0 0 48.6L133.3 216c21-15.1 46.8-24 74.7-24l96 0c27.9 0 53.7 8.9 74.7 24L464 176.6l0-48.6-80 0c-35.3 0-64-28.7-64-64l64 0L320 0l64 0c70.7 0 128 57.3 128 128l0 64 0 15.4-13.9 6.4-85 39.2c12 19.5 18.9 42.4 18.9 67l0 16L320 448l-128 0L80 336l0-16c0-24.6 6.9-47.5 18.9-67l-85-39.2L0 207.4 0 192l0-64z']
      
    ]
  };

  

  
  

  var faLocationDot = {
    prefix: 'fasds',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm272 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z']
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faDialMedLow = {
    prefix: 'fasds',
    iconName: 'dial-med-low',
    icon: [
      576,
      512,
      [],
      'e160',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M158.9 192.4c-46.2 62.6-41 151.3 15.7 208c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-56.7-56.7-145.4-62-208-15.7L304.7 270.4l17 17-33.9 33.9-17-17L158.9 192.4z']
      
    ]
  };

  

  
  

  var faCircle0 = {
    prefix: 'fasds',
    iconName: 'circle-0',
    icon: [
      512,
      512,
      [],
      'e0ed',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-32c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm48 0l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48z','M160 224c0-53 43-96 96-96s96 43 96 96l0 64c0 53-43 96-96 96s-96-43-96-96l0-64zm96-48c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64c0-26.5-21.5-48-48-48z']
      
    ]
  };

  

  
  

  var faHandshakeAngle = {
    prefix: 'fasds',
    iconName: 'handshake-angle',
    icon: [
      640,
      512,
      ["hands-helping"],
      'f4c4',
      
      ['M224 64l0 64 0 96c0 26.7 0 53.3 0 80l96 0 0-112 192 0 0 112 0-32 32-32 96-96L496 0 432 64 224 64z','M224 128L96 128l0 144L0 368 144 512l64-64 224 0 0-64 48 0 0-80 32 0 0-112-192 0 0 112-96 0 0-176z']
      
    ]
  };

  
    var faHandsHelping = faHandshakeAngle;
  

  
  

  var faAccentGrave = {
    prefix: 'fasds',
    iconName: 'accent-grave',
    icon: [
      192,
      512,
      [],
      '60',
      
      ['M144 0l32 224H112L32 0H144z','']
      
    ]
  };

  

  
  

  var faPaintRoller = {
    prefix: 'fasds',
    iconName: 'paint-roller',
    icon: [
      512,
      512,
      [],
      'f5aa',
      
      ['M160 320l0 192 128 0 0-192-32 0 0-32 224 0 32 0 0-32 0-160 0-32-32 0-64 0 0 64 32 0 0 96-224 0-32 0 0 32 0 64-32 0z','M416 0L0 0 0 192l416 0L416 0z']
      
    ]
  };

  

  
  

  var faTrafficLightStop = {
    prefix: 'fasds',
    iconName: 'traffic-light-stop',
    icon: [
      320,
      512,
      [],
      'f63a',
      
      ['M112 112a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM160 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z']
      
    ]
  };

  

  
  

  var faPhoneSlash = {
    prefix: 'fasds',
    iconName: 'phone-slash',
    icon: [
      640,
      512,
      [],
      'f3dd',
      
      ['M63.8 32l144-32 80 144-83.8 67c13 24.6 28.5 47.5 46.3 68.6c-28.7 22.3-57.5 44.6-86.2 66.9C101.5 269.5 63.9 171.1 63.9 64l0-32zM234.3 415.7L322.7 346c13.4 9.5 27.5 18.1 42.1 25.8l67-83.8 144 80-32 144-32 0c-104.8 0-201.3-36-277.6-96.3z','M610.4 .1l-19 14.7L19 459.3 0 474l29.4 37.9 19-14.7L620.9 52.7l19-14.7L610.4 .1z']
      
    ]
  };

  

  
  

  var faStarOfLife = {
    prefix: 'fasds',
    iconName: 'star-of-life',
    icon: [
      512,
      512,
      [],
      'f621',
      
      ['M208 0l96 0 0 172.9L453.7 86.4l48 83.1L352 256l149.7 86.4-48 83.1L304 339.1 304 512l-96 0 0-172.9L58.3 425.6l-48-83.1L160 256 10.3 169.6l48-83.1L208 172.9 208 0z','']
      
    ]
  };

  

  
  

  var faPlugCircleXmark = {
    prefix: 'fasds',
    iconName: 'plug-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e560',
      
      ['M0 160l32 0 320 0 32 0 0 38.6C310.1 219.5 256 287.4 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 99.2-64 0 0-99.2C87 398 32 333.4 32 256l0-32L0 224l0-64zM64 0l64 0 0 32 0 96-64 0 0-96L64 0zM256 0l64 0 0 32 0 96-64 0 0-96 0-32z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7L502.6 320z']
      
    ]
  };

  

  
  

  var faHexagonCheck = {
    prefix: 'fasds',
    iconName: 'hexagon-check',
    icon: [
      512,
      512,
      [],
      'e416',
      
      ['M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm126.1 0l1 1c5.3 5.3 10.7 10.7 16 16c21.3 21.3 42.7 42.7 64 64l17 17 17-17L369 209l16-16c.3-.3 .6-.6 1-1L352 158.1c-.3 .3-.6 .6-1 1c-5.3 5.3-10.7 10.7-16 16l-111 111-47-47-16-16-1-1L126.1 256z','M385 193L241 337l-17 17-17-17-80-80L161 223l63 63L351 159 385 193z']
      
    ]
  };

  

  
  

  var faBowlSpoon = {
    prefix: 'fasds',
    iconName: 'bowl-spoon',
    icon: [
      512,
      512,
      [129379],
      'e3e0',
      
      ['M0 96c0 53 50.1 96 112 96l112 0 0-64 256 0 32 0 0-64-32 0L224 64l0-64L112 0C50.1 0 0 43 0 96z','M512 224L0 224l3.6 61.2C8.5 368.1 58 438.2 128 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7L512 224z']
      
    ]
  };

  

  
  

  var faSuperscript = {
    prefix: 'fasds',
    iconName: 'superscript',
    icon: [
      512,
      512,
      [],
      'f12b',
      
      ['M0 64l32 0 32 0 16.7 0 9.6 13.6L176 200.2 261.8 77.6 271.3 64 288 64l32 0 32 0 0 64-32 0-15.3 0L215.1 256l89.6 128 15.3 0 32 0 0 64-32 0-32 0-16.7 0-9.6-13.6L176 311.8 90.2 434.4 80.7 448 64 448l-32 0L0 448l0-64 32 0 15.3 0 89.6-128L47.3 128 32 128 0 128 0 64z','M416 0L384 0l0 64 32 0 0 96-32 0 0 64 32 0 64 0 32 0 0-64-32 0 0-128 0-32L448 0 416 0z']
      
    ]
  };

  

  
  

  var faArrowsFromLine = {
    prefix: 'fasds',
    iconName: 'arrows-from-line',
    icon: [
      448,
      512,
      [],
      'e0a4',
      
      ['M0 224l32 0 384 0 32 0 0 64-32 0L32 288 0 288l0-64z','M128 96L224 0l96 96 0 32-64 0 0 32 0 32-64 0 0-32 0-32-64 0 0-32zM256 320l0 32 0 16 0 16 64 0 0 32-96 96-96-96 0-32 64 0 0-16 0-16 0-32 64 0z']
      
    ]
  };

  

  
  

  var faFilePpt = {
    prefix: 'fasds',
    iconName: 'file-ppt',
    icon: [
      512,
      512,
      [],
      'e64a',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM288 352l0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0-16 0zm32 80l0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0zM160 352l0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0-16 0zm32 80l0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0zm224-80l0 32 16 0 16 0 0 112 0 16 32 0 0-16 0-112 16 0 16 0 0-32-16 0-32 0-32 0-16 0z']
      
    ]
  };

  

  
  

  var faPinata = {
    prefix: 'fasds',
    iconName: 'pinata',
    icon: [
      512,
      512,
      [],
      'e3c3',
      
      ['M112 218.7c15.8 6.6 31.6 13.2 47.4 19.7L240 198.1l0 25.9 19.8 0c-30.9 15.4-61.7 30.9-92.6 46.3c-2.2 1.1-4.4 2.2-6.6 3.3c-2.3-.9-4.5-1.9-6.8-2.8C139.9 265 126 259.1 112 253.3l0-34.7zm0 99.4l16.7 8.4 33.3-13.3c2.2-.9 4.4-1.8 6.7-2.7c2.1 1.1 4.3 2.1 6.4 3.2l25.6 12.8c11.1-4.4 22.2-8.9 33.3-13.3c2.2-.9 4.4-1.8 6.7-2.7c2.1 1.1 4.3 2.1 6.4 3.2l25.6 12.8 33.3-13.3c2.2-.9 4.4-1.8 6.7-2.7c2.1 1.1 4.3 2.1 6.4 3.2l25.6 12.8c11.1-4.4 22.2-8.9 33.3-13.3c2.2-.9 4.4-1.8 6.7-2.7c2.1 1.1 4.3 2.1 6.4 3.2c8.5 4.3 17 8.5 25.6 12.8c11.1-4.4 22.2-8.9 33.3-13.3c2.2-.9 4.4-1.8 6.7-2.7c2.1 1.1 4.3 2.1 6.4 3.2c8.5 4.3 17 8.5 25.6 12.8l23.3-9.3 0 34.5-18.1 7.2-6.7 2.7-6.4-3.2-25.6-12.8-33.3 13.3-6.7 2.7-6.4-3.2-25.6-12.8-33.3 13.3-6.7 2.7-6.4-3.2-25.6-12.8-33.3 13.3c-2.2 .9-4.4 1.8-6.7 2.7c-2.1-1.1-4.3-2.1-6.4-3.2l-25.6-12.8-33.3 13.3c-2.2 .9-4.4 1.8-6.7 2.7c-2.1-1.1-4.3-2.1-6.4-3.2c-8.5-4.3-17-8.5-25.6-12.8c-11.1 4.4-22.2 8.9-33.3 13.3c-2.2 .9-4.4 1.8-6.7 2.7c-2.1-1.1-4.3-2.1-6.4-3.2l-8.8-4.4 0-35.8zm0 84l24 12 24.8-12.4c2.4-1.2 4.8-2.4 7.2-3.6l7.2 3.6c7.9 3.9 15.8 7.9 23.7 11.8c5.4-3.6 10.8-7.2 16.3-10.8l4-2.7 4.8 0 0 35.2-15.1 10.1c-2.6 1.7-5.1 3.4-7.7 5.2l-8.3-4.2L168 433.9l-24.8 12.4c-2.4 1.2-4.8 2.4-7.2 3.6c-2.4-1.2-4.8-2.4-7.2-3.6L112 437.9l0-35.8zM400 400l4.8 0c1.3 .9 2.7 1.8 4 2.7c5.4 3.6 10.8 7.2 16.3 10.8l23.7-11.8 7.2-3.6 7.2 3.6L488 414.1l24-12 0 35.8-16.8 8.4-7.2 3.6-7.2-3.6L456 433.9l-24.8 12.4-8.3 4.2-7.7-5.2L400 435.2l0-35.2z','M112 318.1l0-64.8 41.8 17.4 6.8 2.8 6.5-3.3L259.8 224l28.2 0 224 0 0 93.2-23.3 9.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3-25.6-12.8-6.4-3.2-6.7 2.7-33.3 13.3L112 318.1zm0 35.8l8.8 4.4 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 33.3-13.3 25.6 12.8 6.4 3.2 6.7-2.7 18.1-7.2 0 50.5-24 12-24.8-12.4-7.2-3.6-7.2 3.6-23.7 11.8-16.3-10.8-4-2.7-4.8 0-176 0-4.8 0-4 2.7-16.3 10.8-23.7-11.8-7.2-3.6-7.2 3.6L136 414.1l-24-12 0-48.2zm47.4-115.5L0 172 0 64l176 0 0-64 64 0 0 198.1-80.6 40.3zM112 437.9l16.8 8.4 7.2 3.6 7.2-3.6L168 433.9l24.8 12.4 8.3 4.2 7.7-5.2L224 435.2l0 76.8-112 0 0-74.1zm288-2.7l15.1 10.1 7.7 5.2 8.3-4.2L456 433.9l24.8 12.4 7.2 3.6 7.2-3.6 16.8-8.4 0 74.1-112 0 0-76.8zM200 144a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  

  
  

  var faXmarkLarge = {
    prefix: 'fasds',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      ['M70.6 57.4L48 34.7 2.7 80l22.6 22.6L178.7 256 25.4 409.4 2.7 432 48 477.3l22.6-22.6L224 301.3 377.4 454.6 400 477.3 445.3 432l-22.6-22.6L269.3 256 422.6 102.6 445.3 80 400 34.7 377.4 57.4 224 210.7 70.6 57.4z','']
      
    ]
  };

  

  
  

  var faCandyBar = {
    prefix: 'fasds',
    iconName: 'candy-bar',
    icon: [
      640,
      512,
      [127851,"chocolate-bar"],
      'e3e8',
      
      ['M288 64l352 0 0 384-352 0 0-96 0-32 0-96 0-32 0-128z','M0 224l0 96 128 0 0-96L0 224zM0 352l0 96 128 0 0-96L0 352zm160 96l128 0 0-96-128 0 0 96zM288 320l0-96-128 0 0 96 128 0zm0-128l0-128L160 64l0 128 128 0zM33.1 192l94.9 0s0 0 0 0l0-32s0 0 0 0l0-62.9C113.6 111.3 93.8 120 72 120c-6.2 0-12.2-.7-18-2c1.3 5.8 2 11.8 2 18c0 21.8-8.7 41.6-22.9 56z']
      
    ]
  };

  
    var faChocolateBar = faCandyBar;
  

  
  

  var faBell = {
    prefix: 'fasds',
    iconName: 'bell',
    icon: [
      448,
      512,
      [61602,128276],
      'f0f3',
      
      ['M0 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L256 0 192 0l0 51.2C119 66 64 130.6 64 208l0 88L0 368z','M288 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0h64z']
      
    ]
  };

  

  
  

  var faTemperatureFull = {
    prefix: 'fasds',
    iconName: 'temperature-full',
    icon: [
      320,
      512,
      ["temperature-4","thermometer-4","thermometer-full"],
      'f2c7',
      
      ['M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L272 64l0-64L208 0 112 0 48 0l0 64 0 213.5C28 302.2 16 333.7 16 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L112 300.2l0-22.7L112 64l96 0 0 213.5 0 22.7 14.2 17.6C233.4 331.5 240 348.9 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M176 112l0-16-32 0 0 16 0 210.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L176 112z']
      
    ]
  };

  
    var faTemperature4 = faTemperatureFull;
  
    var faThermometer4 = faTemperatureFull;
  
    var faThermometerFull = faTemperatureFull;
  

  
  

  var faBee = {
    prefix: 'fasds',
    iconName: 'bee',
    icon: [
      576,
      512,
      [],
      'e0b2',
      
      ['M0 208C0 146.1 57.3 96 128 96c30.5 0 58.5 9.3 80.5 24.9c1.1 9.8 3.9 19 8.2 27.4c2.1 4.2 4.6 8.2 7.5 11.9c1.4 1.9 2.9 3.7 4.5 5.4c.8 .9 1.6 1.7 2.4 2.5s1.7 1.6 2.5 2.4c-37.9 15.5-67.7 46.6-81.4 85.4c-3.6 10.2-6.1 20.9-7.3 32c-.6 5.3-.9 10.6-.9 16c0 1 0 2.1 .1 3.2l0 .5c0 .7 .1 1.4 .1 2.3c.2 3 .5 6 .9 9c-5.6 .6-11.3 1-17.1 1C57.3 320 0 269.9 0 208zm342.4-37.4c13.7-12.7 22.9-30.2 25.1-49.7c22-15.6 50-24.9 80.5-24.9c70.7 0 128 50.1 128 112s-57.3 112-128 112c-5.8 0-11.5-.3-17.1-1c.2-1.4 .4-2.8 .5-4.2c.1-.9 .1-1.5 .2-1.9c.1-1.2 .1-2.1 .2-2.8c0-.9 .1-1.7 .1-2.4l0-.4c0-1.1 .1-2.2 .1-3.3c0-5.4-.3-10.7-.9-16c-1.2-11.1-3.7-21.8-7.3-32c-13.7-38.8-43.5-69.9-81.4-85.4z','M227.3 12.7L216 1.4 193.4 24l11.3 11.3 23.5 23.5C215.6 73 208 91.6 208 112c0 23.2 9.8 44 25.6 58.6c-37.9 15.5-67.7 46.6-81.4 85.4l271.6 0c-13.7-38.8-43.5-69.9-81.4-85.4C358.2 156 368 135.2 368 112c0-20.4-7.6-39-20.2-53.2l23.5-23.5L382.6 24 360 1.4 348.7 12.7 321.9 39.5C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L227.3 12.7zM431.1 288l-286.2 0c-.6 5.3-.9 10.6-.9 16c0 10.5 1.7 21.3 4.8 32l278.4 0c3.1-10.7 4.8-21.5 4.8-32c0-5.4-.3-10.7-.9-16zm-16.8 80l-252.6 0c8.4 16.6 19.2 32.8 30.9 48l190.8 0c11.7-15.2 22.5-31.4 30.9-48zm-58 80l-136.7 0c34.7 37.9 68.4 64 68.4 64s33.6-26.1 68.4-64z']
      
    ]
  };

  

  
  

  var faPodcast = {
    prefix: 'fasds',
    iconName: 'podcast',
    icon: [
      448,
      512,
      [],
      'f2ce',
      
      ['M0 224c0 94.1 58 174.6 140.2 207.8L132 374c-50.4-31-84-86.6-84-150c0-97.2 78.8-176 176-176s176 78.8 176 176c0 63.5-33.6 119.1-84 150l-8.3 57.8C390 398.6 448 318.1 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224zm80 0c0 43 18.8 81.5 48.7 107.9L135 324l23.7-29.6C139.8 276.9 128 251.8 128 224c0-53 43-96 96-96s96 43 96 96c0 27.8-11.8 52.9-30.7 70.4L313 324l6.3 7.9C349.2 305.5 368 267 368 224c0-79.5-64.5-144-144-144S80 144.5 80 224z','M224 168a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM184 512L160 344l32-40 64 0 32 40L264 512l-80 0z']
      
    ]
  };

  

  
  

  var faCalendarUsers = {
    prefix: 'fasds',
    iconName: 'calendar-users',
    icon: [
      640,
      512,
      [],
      'e5e2',
      
      ['M96 64l96 0 0-64 64 0 0 64 128 0 0-64 64 0 0 64 96 0 0 96L96 160l0-96zm32 128l384 0 0 1.1c-54.3 7.8-96 54.4-96 110.9c0 31.3 12.9 59.7 33.6 80L424 384 379.2 512l-118.4 0L216 384l-25.6 0c20.7-20.3 33.6-48.7 33.6-80c0-56.4-41.7-103.1-96-110.9l0-1.1z','M32 304a80 80 0 1 1 160 0A80 80 0 1 1 32 304zM192 416l32 96L0 512l32-96 160 0zM448 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM608 416l32 96-224 0 32-96 160 0z']
      
    ]
  };

  

  
  

  var faSquareEllipsisVertical = {
    prefix: 'fasds',
    iconName: 'square-ellipsis-vertical',
    icon: [
      448,
      512,
      [],
      'e26f',
      
      ['M0 32L0 480l448 0 0-448L0 32zm192 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M256 128l0 64-64 0 0-64 64 0zm0 96l0 64-64 0 0-64 64 0zm0 160l-64 0 0-64 64 0 0 64z']
      
    ]
  };

  

  
  

  var faClockTwo = {
    prefix: 'fasds',
    iconName: 'clock-two',
    icon: [
      512,
      512,
      [],
      'e35a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 96l48 0 0 24 0 91.2L338.7 172l20-13.3 26.6 39.9-20 13.3-96 64L232 300.8l0-44.8 0-136 0-24z','M280 96l0 24 0 91.2L338.7 172l20-13.3 26.6 39.9-20 13.3-96 64L232 300.8l0-44.8 0-136 0-24 48 0z']
      
    ]
  };

  

  
  

  var faSquareC = {
    prefix: 'fasds',
    iconName: 'square-c',
    icon: [
      448,
      512,
      [],
      'e266',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 256c0-70.7 57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L292 213.8c-14.2-22.8-39.3-37.8-68-37.8c-44.2 0-80 35.8-80 80s35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C310.2 359.8 269.9 384 224 384c-70.7 0-128-57.3-128-128z','M224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C310.2 359.8 269.9 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L292 213.8c-14.2-22.8-39.3-37.8-68-37.8z']
      
    ]
  };

  

  
  

  var faSquareH = {
    prefix: 'fasds',
    iconName: 'square-h',
    icon: [
      448,
      512,
      ["h-square"],
      'f0fd',
      
      ['M0 32L0 480l448 0 0-448L0 32zm112 96l48 0 0 24 0 80 128 0 0-80 0-24 48 0 0 24 0 104 0 104 0 24-48 0 0-24 0-80-128 0 0 80 0 24-48 0 0-24 0-80 0-48 0-80 0-24z','M336 128l0 24 0 104 0 104 0 24-48 0 0-24 0-80-128 0 0 80 0 24-48 0 0-24 0-80 0-48 0-80 0-24 48 0 0 24 0 80 128 0 0-80 0-24 48 0z']
      
    ]
  };

  
    var faHSquare = faSquareH;
  

  
  

  var faBookCopy = {
    prefix: 'fasds',
    iconName: 'book-copy',
    icon: [
      576,
      512,
      [],
      'e0be',
      
      ['M0 192L0 416c0 53 43 96 96 96l224 0 32 0 32 0 0-64-32 0-32 0-32 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l81.1 0c-10.9-18.8-17.1-40.7-17.1-64l0-224L96 96C43 96 0 139 0 192z','M288 0c-53 0-96 43-96 96l0 224c0 53 43 96 96 96l224 0 32 0 32 0 0-64-32 0 0-64 32 0L576 0 544 0 512 0 288 0zm0 288l192 0 0 64-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z']
      
    ]
  };

  

  
  

  var faBed = {
    prefix: 'fasds',
    iconName: 'bed',
    icon: [
      640,
      512,
      [128716],
      'f236',
      
      ['M256 208A80 80 0 1 1 96 208a80 80 0 1 1 160 0zm32-80l32 0 224 0c53 0 96 43 96 96l0 64 0 32-32 0-288 0-32 0 0-32 0-128 0-32z','M64 32l0 32 0 256 544 0 32 0 0 32 0 96 0 32-64 0 0-32 0-32L64 416l0 32 0 32L0 480l0-32 0-64 0-64L0 64 0 32l64 0z']
      
    ]
  };

  

  
  

  var faPersonFairy = {
    prefix: 'fasds',
    iconName: 'person-fairy',
    icon: [
      640,
      512,
      [],
      'e608',
      
      ['M0 32L0 64l0 48c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448l0 32 32 0 16 0c55.9 0 106.6-22 144-57.9l0-70.1-40 0 8-192 48.8 0c-51-77.1-138.6-128-238-128L32 32 0 32zM367.2 160l48.8 0 8 192-40 0 0 70.1C421.4 458 472.1 480 528 480l16 0 32 0 0-32c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112l0-48 0-32-32 0-2.9 0c-99.4 0-186.9 50.9-238 128z','M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm160 96l8 192-40 0 0 160-128 0 0-160-40 0 8-192 192 0z']
      
    ]
  };

  

  
  

  var faMedal = {
    prefix: 'fasds',
    iconName: 'medal',
    icon: [
      512,
      512,
      [127941],
      'f5a2',
      
      ['M0 0L144 0 250.7 160.1c-43.6 1.3-83.3 18.5-113.4 45.9L0 0zM261.3 160.1L368 0 512 0 374.7 206c-30.1-27.5-69.7-44.6-113.4-45.9z','M256 512a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm29.7-214.8l66.3 9.2-48 44.5 11.3 62.8L256 384l-59.3 29.7L208 350.8l-48-44.5 66.3-9.2L256 240l29.7 57.2z']
      
    ]
  };

  

  
  

  var faTemperatureArrowUp = {
    prefix: 'fasds',
    iconName: 'temperature-arrow-up',
    icon: [
      576,
      512,
      ["temperature-up"],
      'e040',
      
      ['M32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L288 64l0-64L224 0 128 0 64 0l0 64 0 213.5C44 302.2 32 333.7 32 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L128 300.2l0-22.7L128 64l96 0 0 213.5 0 22.7 14.2 17.6C249.4 331.5 256 348.9 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M480 160l64 0 0-32L448 32l-96 96 0 32 64 0 0 288 0 32 64 0 0-32 0-288zM224 368c0-20.9-13.4-38.7-32-45.3L192 112l0-16-32 0 0 16 0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48z']
      
    ]
  };

  
    var faTemperatureUp = faTemperatureArrowUp;
  

  
  

  var faFileCircleXmark = {
    prefix: 'fasds',
    iconName: 'file-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e5a1',
      
      ['M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0z','M384 160L224 0l0 160 160 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7L502.6 416 480 438.6l-11.3-11.3L432 390.6l-36.7 36.7L384 438.6 361.4 416l11.3-11.3L409.4 368l-36.7-36.7L361.4 320 384 297.4l11.3 11.3L432 345.4l36.7-36.7L480 297.4 502.6 320l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faTruckDroplet = {
    prefix: 'fasds',
    iconName: 'truck-droplet',
    icon: [
      640,
      512,
      [],
      'e58c',
      
      ['M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm40-242c0 36.5 32.2 66 72 66s72-29.6 72-66s-72-126-72-126s-72 89.5-72 126zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M0 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 64 32 0 0 64-32 0-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L0 416 0 0zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zm-208 0c39.8 0 72-29.6 72-66s-72-126-72-126s-72 89.5-72 126s32.2 66 72 66z']
      
    ]
  };

  

  
  

  var faDrone = {
    prefix: 'fasds',
    iconName: 'drone',
    icon: [
      512,
      512,
      [],
      'f85f',
      
      ['M0 112c0 61.9 50.1 112 112 112c17.2 0 33.4-3.9 47.9-10.7l-29.9-39.8c-5.7 1.7-11.8 2.6-18.1 2.6c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 6.3-.9 12.3-2.6 18.1C186.7 140 200 150 213.3 160c6.8-14.6 10.7-30.8 10.7-48C224 50.1 173.9 0 112 0S0 50.1 0 112zM0 400c0 61.9 50.1 112 112 112s112-50.1 112-112c0-17.2-3.9-33.4-10.7-47.9l-39.8 29.9c1.7 5.7 2.6 11.8 2.6 18.1c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c6.3 0 12.3 .9 18.1 2.6C140 325.3 150 312 160 298.7c-14.6-6.8-30.8-10.7-48-10.7C50.1 288 0 338.1 0 400zM288 112c0 17.2 3.9 33.4 10.7 47.9l39.8-29.9c-1.7-5.7-2.6-11.8-2.6-18.1c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.3-.9-18.1-2.6C372 186.7 362 200 352 213.3c14.6 6.8 30.8 10.7 48 10.7c61.9 0 112-50.1 112-112S461.9 0 400 0S288 50.1 288 112zm0 288c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.4 3.9-47.9 10.7c10 13.3 19.9 26.6 29.9 39.8c5.7-1.7 11.8-2.6 18.1-2.6c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-6.3 .9-12.3 2.6-18.1C325.3 372 312 362 298.7 352c-6.8 14.6-10.7 30.8-10.7 48z','M298.7 160L384 96l32 32-64 85.3 0 85.3L416 384l-32 32-85.3-64-85.3 0L128 416 96 384l64-85.3 0-85.3L96 128l32-32 85.3 64 85.3 0z']
      
    ]
  };

  

  
  

  var faDiceD20 = {
    prefix: 'fasds',
    iconName: 'dice-d20',
    icon: [
      512,
      512,
      [],
      'f6cf',
      
      ['M27.8 113.2L220.9 1.8 117.3 166.9 27.8 113.2zM149.4 176L256 6.1 362.6 176l-213.2 0zM291.1 1.8L484.2 113.2l-89.5 53.7L291.1 1.8z','M240 512L17.9 416.8 240 446l0 66zm254.1-95.2L272 512l0-66 222.1-29.2zM496 143.5l0 184.9L411.7 194 496 143.5zM16 328.4l0-184.9L100.3 194 16 328.4zM155.6 208l200.9 0L256 383.8 155.6 208zM276 413.2L388.2 216.8 493.5 384.6 276 413.2zM18.5 384.6L123.8 216.8 236 413.2 18.5 384.6z']
      
    ]
  };

  

  
  

  var faBeerMug = {
    prefix: 'fasds',
    iconName: 'beer-mug',
    icon: [
      512,
      512,
      ["beer-foam"],
      'e0b3',
      
      ['M32 163.2L32 512l352 0 0-66.3 109-48.4 19-8.4 0-20.8 0-176 0-32-32 0-90.9 0c-15.2 10.1-33.5 16-53.1 16c-18.8 0-36.2-5.4-51-14.7c-20.1 19-47.1 30.7-77 30.7s-56.9-11.7-77-30.7C116.2 170.6 98.8 176 80 176c-17.5 0-33.9-4.7-48-12.8zM128 224l32 0 0 16 0 160 0 16-32 0 0-16 0-160 0-16zm64 0l32 0 0 16 0 160 0 16-32 0 0-16 0-160 0-16zm64 0l32 0 0 16 0 160 0 16-32 0 0-16 0-160 0-16zm128 0l64 0 0 123.2-64 28.4L384 224z','M208 160c32.5 0 60.5-19.4 73-47.2c11.2 18.7 31.6 31.2 55 31.2c35.3 0 64-28.7 64-64s-28.7-64-64-64c-23.4 0-43.8 12.5-55 31.2C268.5 19.4 240.5 0 208 0s-60.5 19.4-73 47.2C123.8 28.5 103.4 16 80 16C44.7 16 16 44.7 16 80s28.7 64 64 64c23.4 0 43.8-12.5 55-31.2c12.5 27.8 40.5 47.2 73 47.2zm-48 80l0-16-32 0 0 16 0 160 0 16 32 0 0-16 0-160zm64 0l0-16-32 0 0 16 0 160 0 16 32 0 0-16 0-160zm64 0l0-16-32 0 0 16 0 160 0 16 32 0 0-16 0-160z']
      
    ]
  };

  
    var faBeerFoam = faBeerMug;
  

  
  

  var faFileHeart = {
    prefix: 'fasds',
    iconName: 'file-heart',
    icon: [
      384,
      512,
      [],
      'e176',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM80 299.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L192 432.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0C106.5 240 80 266.5 80 299.2z','M384 160l-160 0L224 0 384 160zM80 299.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L192 432.1l-11.1-10.7L98.2 341.8C86.6 330.7 80 315.3 80 299.2z']
      
    ]
  };

  

  
  

  var faMessageDots = {
    prefix: 'fasds',
    iconName: 'message-dots',
    icon: [
      512,
      512,
      ["comment-alt-dots","messaging"],
      'f4a3',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM96 208a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M96 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  
    var faCommentAltDots = faMessageDots;
  
    var faMessaging = faMessageDots;
  

  
  

  var faHandBackPointLeft = {
    prefix: 'fasds',
    iconName: 'hand-back-point-left',
    icon: [
      512,
      512,
      [],
      'e19f',
      
      ['M0 208l0-80 224 0 13.3 0 2.7 0 80 0 16 0 0-32-16 0-56 0 40-48 68 0c38 0 74 16.9 98.3 46.1l4.5 5.4c24 28.8 37.1 65 37.1 102.4L512 320c0 70.7-57.3 128-128 128l-16 0-48 0-80 0 0-80-32 0 0-80-32 0 0-80L0 208z','']
      
    ]
  };

  

  
  

  var faArrowsLeftRightToLine = {
    prefix: 'fasds',
    iconName: 'arrows-left-right-to-line',
    icon: [
      640,
      512,
      [],
      'e4ba',
      
      ['M0 64L0 96 0 416l0 32 64 0 0-32L64 96l0-32L0 64zm576 0l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M269.3 160l-22.6 22.6L205.3 224l229.5 0-41.4-41.4L370.7 160 416 114.7l22.6 22.6 96 96L557.3 256l-22.6 22.6-96 96L416 397.3 370.7 352l22.6-22.6L434.7 288l-229.5 0 41.4 41.4L269.3 352 224 397.3l-22.6-22.6-96-96L82.7 256l22.6-22.6 96-96L224 114.7 269.3 160z']
      
    ]
  };

  

  
  

  var faBluetooth = {
    prefix: 'fasds',
    iconName: 'bluetooth',
    icon: [
      384,
      512,
      [],
      'f293',
      
      ['M160 0l51.2 38.4 128 96L373.3 160l-34.1 25.6L245.3 256l93.9 70.4L373.3 352l-34.1 25.6-128 96L160 512l0-64 0-128L83.2 377.6 57.6 396.8 19.2 345.6l25.6-19.2L138.7 256 44.8 185.6 19.2 166.4l38.4-51.2 25.6 19.2L160 192l0-128 0-64zm64 320l0 64 42.7-32L224 320zm0-128l42.7-32L224 128l0 64z','']
      
    ]
  };

  

  
  

  var faChartSimpleHorizontal = {
    prefix: 'fasds',
    iconName: 'chart-simple-horizontal',
    icon: [
      448,
      512,
      [],
      'e474',
      
      ['M0 192L0 320l448 0 0-128L0 192z','M384 32l0 128L0 160 0 32l384 0zM256 352l0 128L0 480 0 352l256 0z']
      
    ]
  };

  

  
  

  var faMountainSun = {
    prefix: 'fasds',
    iconName: 'mountain-sun',
    icon: [
      640,
      512,
      [],
      'e52f',
      
      ['M480 80a80 80 0 1 0 160 0A80 80 0 1 0 480 80z','M256 64L0 448l0 64 320 0 192 0 128 0 0-64L480 192 412.9 299.4 256 64z']
      
    ]
  };

  

  
  

  var faCabin = {
    prefix: 'fasds',
    iconName: 'cabin',
    icon: [
      512,
      512,
      [],
      'e46d',
      
      ['M32 256l160 0 0 64L32 320l0-64zm0 96l160 0 0 64L32 416l0-64zm0 96l160 0 0 64L32 512l0-64zM320 256l160 0 0 64-160 0 0-64zm0 96l160 0 0 64-160 0 0-64zm0 96l160 0 0 64-160 0 0-64z','M0 176l0 48 384 0 96 0 32 0 0-48-32-22 0-122-96 0 0 56L256 0 0 176zM256 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faCircleX = {
    prefix: 'fasds',
    iconName: 'circle-x',
    icon: [
      512,
      512,
      [],
      'e12e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM130.9 128l59.8 0c21.8 29.3 43.5 58.5 65.3 87.8L321.3 128l59.8 0L285.9 256l95.2 128-59.8 0L256 296.2 190.7 384l-59.8 0c31.7-42.7 63.5-85.3 95.2-128L130.9 128z','M321.3 128l59.8 0L285.9 256l95.2 128-59.8 0L256 296.2 190.7 384l-59.8 0 95.2-128L130.9 128l59.8 0L256 215.8 321.3 128z']
      
    ]
  };

  

  
  

  var faFamilyDress = {
    prefix: 'fasds',
    iconName: 'family-dress',
    icon: [
      512,
      512,
      [],
      'e301',
      
      ['M0 384l64 0 0 128 112 0 0-64-32 0 0-32 0-160 0-32 32 0 16 0c-10-13.4-16-30-16-48c0-5.5 .6-10.8 1.6-16L64 160 0 384zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64zm0 160l16 0 32 0 0 32 0 160 0 32-32 0 0 64 112 0 0-128 64 0L448 160l-113.6 0c1 5.2 1.6 10.5 1.6 16c0 18-6 34.6-16 48z','M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 80l0 160-32 0 0 96-96 0 0-96-32 0 0-160 160 0z']
      
    ]
  };

  

  
  

  var faBookOpenReader = {
    prefix: 'fasds',
    iconName: 'book-open-reader',
    icon: [
      512,
      512,
      ["book-reader"],
      'f5da',
      
      ['M160 96a96 96 0 1 0 192 0A96 96 0 1 0 160 96z','M240 512l0-264-21.3-12.4C169.8 207 114.1 192 57.5 192L0 192 0 456l116.7 13c18.1 2 35.8 6.6 52.6 13.6L240 512zm32 0l48.4-24.2c20.9-10.4 43.5-17 66.8-19.3L512 456l0-264-62.3 0c-63.6 0-125.6 19.6-177.7 56l0 264z']
      
    ]
  };

  
    var faBookReader = faBookOpenReader;
  

  
  

  var faMicrophoneStand = {
    prefix: 'fasds',
    iconName: 'microphone-stand',
    icon: [
      512,
      512,
      [127908],
      'f8cb',
      
      ['M0 448L256 140.7 371.3 256c-27.8 23.1-55.5 46.3-83.3 69.4l-64 53.3C170.7 423.1 117.3 467.5 64 512L0 448zM293.5 60.1c7.5-7.5 15.1-15.1 22.6-22.6L474.5 195.9l-11.3 11.3c-3.8 3.8-7.5 7.5-11.3 11.3C399.1 165.7 346.3 112.9 293.5 60.1z','M479.2 32.8c43.7 43.7 43.7 114.7 0 158.4l-4.7 4.7L316.1 37.5l4.7-4.7c43.7-43.7 114.7-43.7 158.4 0zM293.5 60.1L451.9 218.5l-4.7 4.7c-21 21-48.4 32-75.9 32.8c0 0 0 0 0 0L256 140.7c.8-27.6 11.7-54.9 32.8-75.9l4.7-4.7zM224 480l0-101.3 64-53.3L288 480l0 32-64 0 0-32z']
      
    ]
  };

  

  
  

  var faUserHairMullet = {
    prefix: 'fasds',
    iconName: 'user-hair-mullet',
    icon: [
      448,
      512,
      ["business-front","party-back","trian-balbot"],
      'e45c',
      
      ['M104 128c0 20.4 4.1 39.6 11.6 56.7c15.9 36.2 47.1 62.6 87.4 69.5c6.8 1.2 13.8 1.8 21 1.8s14.2-.6 21-1.8c40.2-6.9 71.5-33.3 87.4-69.5c7.5-17.1 11.6-36.4 11.6-56.7c0-5.4-.3-10.8-.9-16c-2.4 0-4.8 0-7.1 0c-21.3 0-42.7 0-64 0c-5.3 0-10.7 0-16 0c-10.7-16-21.3-32-32-48c-10.7 16-21.3 32-32 48c-5.3 0-10.7 0-16 0c-21.3 0-42.7 0-64 0c-2.4 0-4.8 0-7.1 0c-.6 5.2-.9 10.6-.9 16z','M224.4 0c47.2 .1 84.8 25.8 104.6 64L360 64l0 48-24 0-64 0-16 0L224 64l-32 48-16 0-64 0-24 0 0-48 31.1 0C138.8 25.8 176.4 .1 223.6 0l.7 0zM115.6 184.7c15.9 36.2 47.1 62.6 87.4 69.5L176 288l-32 0-8-32-24 16L80 256l35.6-71.3zM245 254.2c40.2-6.9 71.5-33.3 87.4-69.5L368 256l-32 16-24-16-8 32-32 0-27-33.8zM64 320l320 0 64 192L0 512 64 320z']
      
    ]
  };

  
    var faBusinessFront = faUserHairMullet;
  
    var faPartyBack = faUserHairMullet;
  
    var faTrianBalbot = faUserHairMullet;
  

  
  

  var faPodiumStar = {
    prefix: 'fasds',
    iconName: 'podium-star',
    icon: [
      448,
      512,
      [],
      'f758',
      
      ['M44.4 192l359.1 0L368 512 80 512 44.4 192zm80.6 135.9l51.4 47.6-13.7 68.7L224 409.9l61.1 34.2-13.7-68.7 51.4-47.6-69.6-8.2L224 256l-29.3 63.6-69.6 8.2z','M288 0L176 0l0 24-8 0c-48.6 0-88 39.4-88 88l0 32-56 0L0 144l0 48 24 0 400 0 24 0 0-48-24 0-296 0 0-32c0-22.1 17.9-40 40-40l8 0 0 24 112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48z']
      
    ]
  };

  

  
  

  var faUserTieHair = {
    prefix: 'fasds',
    iconName: 'user-tie-hair',
    icon: [
      448,
      512,
      [],
      'e45f',
      
      ['M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11.1-1.4-21.8-4-32l-60 0L256 64c-16 16-32 32-48 48L97 112c-.7 5.2-1 10.6-1 16z','M256 64l32 32 60 0C333.8 40.8 283.6 0 224 0C158.7 0 104.9 48.9 97 112l111 0 48-48zm24 448l168 0L384 320l-71.8 0L272.2 483.1 238.9 359.2 272 304l-48 0-48 0 33.1 55.2L175.8 483.1 135.8 320 64 320 0 512l168 0 14.9 0 82.3 0 14.9 0z']
      
    ]
  };

  

  
  

  var faHandHoldingHand = {
    prefix: 'fasds',
    iconName: 'hand-holding-hand',
    icon: [
      576,
      512,
      [],
      'e4f7',
      
      ['M8.4 149.7l45.3 65.9 33-22.7 94.5-65L320 128l0 32-32 0-64 0-32 0 0 64 32 0 64 0 64 0 64 0 11.2 0 8.8-7 71.2-57 68.8 0 0-128-32 0L352 32 192 32l-12.4 0-10.2 7-128 88-33 22.7z','M68.8 352L140 295l8.8-7 11.2 0 64 0 64 0 64 0 32 0 0 64-32 0-64 0-32 0 0 32 138.8 0 94.5-65 33-22.7 45.3 65.9-33 22.7-128 88-10.2 7L384 480l-160 0L32 480 0 480 0 352l68.8 0z']
      
    ]
  };

  

  
  

  var faCar = {
    prefix: 'fasds',
    iconName: 'car',
    icon: [
      512,
      512,
      [128664,"automobile"],
      'f1b9',
      
      ['M0 400l0 80 96 0 0-80L0 400zM109.1 192l293.8 0L369.3 96 142.7 96c-11.2 32-22.4 64-33.6 96zM416 400l0 80 96 0 0-80-96 0z','M120 32L97.3 32 89.8 53.4 41.3 192 0 192 0 400l512 0 0-208-41.3 0L422.2 53.4 414.7 32 392 32 120 32zM402.9 192l-293.8 0 33.6-96 226.6 0 33.6 96zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  
    var faAutomobile = faCar;
  

  
  

  var faBoxBallot = {
    prefix: 'fasds',
    iconName: 'box-ballot',
    icon: [
      576,
      512,
      [128499],
      'f735',
      
      ['M0 160l128 0 0 64-48 0-16 0 0 32 16 0 48 0 320 0 48 0 16 0 0-32-16 0-48 0 0-64 128 0 0 160L0 320 0 160z','M448 0l0 256-320 0L128 0 448 0zM576 512L0 512 0 320l576 0 0 192z']
      
    ]
  };

  

  
  

  var faCircleS = {
    prefix: 'fasds',
    iconName: 'circle-s',
    icon: [
      512,
      512,
      [],
      'e121',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM153.8 359.5l14.7-45.7c7.6 2.4 15.2 4.9 22.9 7.3c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23.1-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7c7.8 2 15.5 4 23.3 6c-4 15.5-7.9 31-11.9 46.5c-7.8-2-15.5-4-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7c-20.3-3.1-36.8-1.4-47.8 2.9c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4l2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.7 5.7c-16.3-2.6-43.7-10.7-57.3-15.1c-7.6-2.4-15.2-4.9-22.9-7.3z','M223 180.4c-10.3 4.1-14.2 9.6-15.4 15.8c-1.1 6.4-.2 9.7 .6 11.6c1 2 2.9 4.6 7.4 7.7c10.1 6.8 25.7 11.5 46.8 17.4c.7 .2 1.3 .4 2 .6c18.4 5.2 41.4 11.7 58.6 23.2c9.5 6.4 18.5 15.1 24.1 27.2c5.7 12.3 7 25.9 4.4 40.3c-4.7 26.3-23 43.3-45 52c-21.3 8.4-47 9.6-72.6 5.7l-.1 0s0 0 0 0c-16.3-2.6-43.7-10.7-57.3-15.1l-22.9-7.3 14.7-45.7 22.9 7.3c13.9 4.5 37.8 11.4 50 13.4c20.2 3 36.8 1.4 47.7-2.9c10.3-4.1 14.2-9.6 15.4-15.8c1.1-6.4 .2-9.7-.6-11.6c-1-2-2.9-4.6-7.4-7.7c-10.1-6.8-25.7-11.5-46.8-17.4c-.7-.2-1.3-.4-2-.6c-18.4-5.2-41.4-11.7-58.6-23.2c-9.5-6.4-18.5-15.1-24.1-27.2c-5.7-12.3-7-25.9-4.4-40.3c4.7-26.3 23-43.3 45-52c21.3-8.4 47-9.6 72.6-5.7c8.1 1.2 24.4 4.8 32 6.7l23.2 6-11.9 46.5-23.2-6c-6.7-1.7-21.3-4.9-27.3-5.7l3.6-23.7-3.6 23.7c-20.3-3.1-36.8-1.4-47.8 2.9z']
      
    ]
  };

  

  
  

  var faCreditCard = {
    prefix: 'fasds',
    iconName: 'credit-card',
    icon: [
      576,
      512,
      [62083,128179,"credit-card-alt"],
      'f09d',
      
      ['M0 32l0 96 576 0 0-96L0 32zM0 224L0 480l576 0 0-256L0 224zM96 352l96 0 0 32-96 0 0-32zm128 0l160 0 0 32-160 0 0-32z','M576 224H0V128H576v96z']
      
    ]
  };

  
    var faCreditCardAlt = faCreditCard;
  

  
  

  var faBowlChopsticks = {
    prefix: 'fasds',
    iconName: 'bowl-chopsticks',
    icon: [
      512,
      512,
      [],
      'e2e9',
      
      ['M0 96L512 0l0 48L0 128 0 96zm0 48l512-16 0 48L0 176l0-32z','M512 224L0 224l3.6 61.2C8.5 368.1 58 438.2 128 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7L512 224z']
      
    ]
  };

  

  
  

  var faBug = {
    prefix: 'fasds',
    iconName: 'bug',
    icon: [
      512,
      512,
      [],
      'f188',
      
      ['M160 96l0 32 192 0 0-32c0-53-43-96-96-96s-96 43-96 96zm80 128l0 16 0 239.2c5.3 .5 10.6 .8 16 .8s10.7-.3 16-.8L272 240l0-16-32 0z','M64 82.7l22.6 22.6L141.3 160l229.5 0 54.6-54.6L448 82.7 493.3 128l-22.6 22.6L416 205.3l0 50.7 64 0 32 0 0 64-32 0-64 0c0 24.2-5.4 47.2-15 67.7l53.6 53.6L477.3 464 432 509.3l-22.6-22.6-47.1-47.1c-24.5 21.8-55.8 36.2-90.3 39.6L272 240l0-16-32 0 0 16 0 239.2c-34.5-3.4-65.8-17.8-90.3-39.6l-47.1 47.1L80 509.3 34.7 464l22.6-22.6L111 387.7c-9.6-20.6-15-43.5-15-67.7l-64 0L0 320l0-64 32 0 64 0 0-50.7L41.4 150.6 18.7 128 64 82.7z']
      
    ]
  };

  

  
  

  var faHandsHoldingCircle = {
    prefix: 'fasds',
    iconName: 'hands-holding-circle',
    icon: [
      640,
      512,
      [],
      'e4fb',
      
      ['M0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40L0 64zM352 338.7l0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0 0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4z','M320 0a128 128 0 1 0 0 256A128 128 0 1 0 320 0z']
      
    ]
  };

  

  
  

  var faMagnifyingGlassWaveform = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-waveform',
    icon: [
      512,
      512,
      [],
      'e661',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm96-80l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm88-32l48 0 0 24 0 176 0 24-48 0 0-24 0-176 0-24zm88 64l48 0 0 24 0 48 0 24-48 0 0-24 0-48 0-24z','M232 120l0 176 0 24-48 0 0-24 0-176 0-24 48 0 0 24zm-88 32l0 112 0 24-48 0 0-24 0-112 0-24 48 0 0 24zm176 32l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24zM441.4 486.6L330.7 376C348 363.3 363.3 348 376 330.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6z']
      
    ]
  };

  

  
  

  var faEnvelopeDot = {
    prefix: 'fasds',
    iconName: 'envelope-dot',
    icon: [
      576,
      512,
      ["envelope-badge"],
      'e16f',
      
      ['M0 64l417.6 0c-.5 2.6-.9 5.2-1.2 7.9c-.1 1.3-.2 2.7-.3 4s-.1 2.7-.1 4.1c0 41.9 32.2 76.2 73.1 79.7L256 320 0 144 0 64zM0 182.8L237.9 346.4 256 358.8l18.1-12.5L512 182.8 512 448 0 448 0 182.8z','M416 80a80 80 0 1 1 160 0A80 80 0 1 1 416 80z']
      
    ]
  };

  
    var faEnvelopeBadge = faEnvelopeDot;
  

  
  

  var faGlobeWifi = {
    prefix: 'fasds',
    iconName: 'globe-wifi',
    icon: [
      640,
      512,
      [],
      'e685',
      
      ['M0 256c0 22.1 2.8 43.5 8.1 64l125.6 0c-3.6-20.5-5.6-41.9-5.6-64s2-43.5 5.6-64L8.1 192C2.8 212.5 0 233.9 0 256zm18.6-96l122 0c17-65.6 48.3-120 74-156.7C125.4 17.8 51.6 78.5 18.6 160zm0 192c33 81.5 106.7 142.2 196 156.7c-25.7-36.7-57-91-74-156.7l-122 0zM160 256c0 22.1 2.2 43.5 6.1 64l160.5 0c5.4-19.2 14-37 25.2-53c.1-3.7 .2-7.3 .2-11c0-22.1-2.2-43.5-6.1-64l-179.7 0c-3.9 20.5-6.1 41.9-6.1 64zm13.7-96l164.6 0c-11.4-40.2-28.4-75.9-45.8-105.4c-13-21.9-25.9-40-36.5-53.5c-10.5 13.5-23.5 31.6-36.5 53.5c-17.4 29.4-34.5 65.1-45.8 105.4zm0 192c11.4 40.2 28.4 75.9 45.8 105.4c13 21.9 25.9 40 36.5 53.5c10.5-13.5 23.5-31.6 36.5-53.5c10.5-17.8 20.9-37.9 30-59.9c-1.6-9.6-2.5-19.4-2.5-29.5c0-5.4 .2-10.7 .7-16l-147 0zM297.4 3.3c25.7 36.7 57 91 74 156.7l122 0c-33-81.5-106.7-142.2-196-156.7zm0 505.3c24.3-4 47.5-11.3 69-21.6c-12-13-22-27.8-29.6-44c-12.9 25.6-26.8 47.7-39.3 65.6zm81-316.7c2.3 13.3 4 26.9 4.9 40.8C413.8 207.4 453 192 496 192l-117.6 0zM496 192c2.8 0 5.4 .1 8 .2c-2.6-.2-5.2-.2-8-.2z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm86.9-145.2C564.3 338.6 532.3 320 496 320s-68.3 18.6-86.9 46.8l-25.6-19.2c24.5-36 65.7-59.6 112.5-59.6s88.1 23.6 112.5 59.6l-25.6 19.2zM560 384l-25.6 19.2C525.6 391.5 511.7 384 496 384s-29.6 7.5-38.4 19.2L432 384c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm-84 48a20 20 0 1 1 40 0 20 20 0 1 1 -40 0z']
      
    ]
  };

  

  
  

  var faToolbox = {
    prefix: 'fasds',
    iconName: 'toolbox',
    icon: [
      512,
      512,
      [129520],
      'f552',
      
      ['M0 320l128 0 0 32 0 32 64 0 0-32 0-32 128 0 0 32 0 32 64 0 0-32 0-32 128 0 0 160L0 480 0 320zM128 32l24 0 208 0 24 0 0 24 0 72-48 0 0-48L176 80l0 48-48 0 0-72 0-24z','M0 320L0 208l80-80 352 0 80 80 0 112-128 0 0-32 0-32-64 0 0 32 0 32-128 0 0-32 0-32-64 0 0 32 0 32L0 320z']
      
    ]
  };

  

  
  

  var faPersonThroughWindow = {
    prefix: 'fasds',
    iconName: 'person-through-window',
    icon: [
      640,
      512,
      [],
      'e5a9',
      
      ['M96 128a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm32 109.9l0 18.1 0 128c21.3 0 42.7 0 64 0l0-109.9c24.5 36.6 49 73.2 73.5 109.9c14.2 21.3 28.4 42.7 42.7 64c8.3 12.4 16.6 24.9 24.9 37.3l17.8 26.6 53.3-35.5-17.8-26.6-1.2-1.8c-14.2-21.3-28.4-42.7-42.7-64c-10.7-16-21.3-32-32-48l74.6 0 40 48 83.3 0-3.7-4.5-80-96L415 272l-15 0-78.6 0-35.3-54.4 50.3-30.2 15.5-9.3 0-18.1 0-96-64 0 0 77.9L143.5 228.6 128 237.9z','M64 64l512 0 0 320-233.5 0 42.7 64L576 448l64 0 0-64 0-320 0-64L576 0 64 0 0 0 0 64 0 384l0 64 64 0 244.2 0-42.7-64L64 384 64 64z']
      
    ]
  };

  

  
  

  var faBells = {
    prefix: 'fasds',
    iconName: 'bells',
    icon: [
      640,
      512,
      [],
      'f77f',
      
      ['M0 305l241.9 88 11.3-44.4-35.3-97.1C188.6 171.2 222 83.2 293.1 41.2c-.8-.3-1.7-.6-2.5-1c-15.3-5.6-31-8.2-46.4-8.2c-55.5 0-107.5 34.2-127.6 89.4l-36.4 100-67.2 48L0 305zm248-64.4L286.7 347l-21.6 84.5 13.7 37.6L640 337.7l-13.7-37.6-70.9-50.9L516.7 142.9c-27-74.2-109.1-112.5-183.3-85.5s-112.5 109-85.4 183.2z','M97.5 374.6c-.4 3-.7 6.2-.7 9.3c0 35.4 28.7 64 64.1 64c23.1 0 43.3-12.2 54.5-30.4L97.5 374.6zm331.3 78.3c11.6 16.4 30.7 27.1 52.4 27.1c35.4 0 64.1-28.7 64.1-64c0-1.8-.1-3.6-.2-5.4L428.8 452.9z']
      
    ]
  };

  

  
  

  var faGrid2Plus = {
    prefix: 'fasds',
    iconName: 'grid-2-plus',
    icon: [
      512,
      512,
      [],
      'e197',
      
      ['M32 32l192 0 0 192L32 224 32 32zm0 256l192 0 0 192L32 480l0-192zM288 32l192 0 0 192-192 0 0-192z','M408 296l0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64z']
      
    ]
  };

  

  
  

  var faKitMedical = {
    prefix: 'fasds',
    iconName: 'kit-medical',
    icon: [
      576,
      512,
      ["first-aid"],
      'f479',
      
      ['M96 32l32 0 0 448-32 0L96 32zm352 0l32 0 0 448-32 0 0-448z','M0 32L0 480l96 0L96 32 0 32zm128 0l0 448 320 0 0-448L128 32zM576 480l0-448-96 0 0 448 96 0zM256 160l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z']
      
    ]
  };

  
    var faFirstAid = faKitMedical;
  

  
  

  var faChessPawn = {
    prefix: 'fasds',
    iconName: 'chess-pawn',
    icon: [
      320,
      512,
      [9823],
      'f443',
      
      ['M16 480l48-48 192 0 48 48 0 32L16 512l0-32z','M264 136c0 37.1-19.4 69.6-48.5 88l8.5 0 32 0 0 64-26.2 0L256 432 64 432 90.2 288 64 288l0-64 32 0 8.5 0C75.4 205.6 56 173.1 56 136C56 78.6 102.6 32 160 32s104 46.6 104 104z']
      
    ]
  };

  

  
  

  var faNfcSlash = {
    prefix: 'fasds',
    iconName: 'nfc-slash',
    icon: [
      640,
      512,
      [],
      'e1fc',
      
      ['M96 32l0 19.8 64 49.7 0-5.4 16 0 64 0 16 0 0 32-16 0-45.8 0c35.9 27.9 71.8 55.7 107.6 83.6c.7-.3 1.4-.6 2.2-.8l0-98.7 0-16 16 0 144 0 16 0 0 16 0 237.9 64 49.7L544 32 96 32zm0 139.6L96 480l391.4 0-81.2-64L176 416l-16 0 0-16 0-177.9L96 171.6zm96 75.6L192 384l173.5 0L192 247.3zM336 128l0 82.7c18.6 6.6 32 24.4 32 45.3c0 2.2-.2 4.4-.4 6.6c26.8 20.8 53.6 41.6 80.4 62.5l0-197-112 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faEllipsis = {
    prefix: 'fasds',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      ['M176 208l0 96 96 0 0-96-96 0z','M16 208l0 96 96 0 0-96-96 0zm320 0l0 96 96 0 0-96-96 0z']
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faAnchorCircleXmark = {
    prefix: 'fasds',
    iconName: 'anchor-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4ac',
      
      ['M0 352l64 0 0 128 0 32 32 0 192 0 106.8 0c-23.3-16.4-42.5-38.4-55.6-64L320 448l0-79.5 0-.5 0-.5L320 240l32 0 23.2 0c2.8-2.7 5.8-5.3 8.8-7.8l0-56.2-32 0-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faTentDoublePeak = {
    prefix: 'fasds',
    iconName: 'tent-double-peak',
    icon: [
      576,
      512,
      [],
      'e627',
      
      ['M0 192l576 0 0 320-160 0L288 288l0 224L0 512 0 192z','M7.9 142.7L0 146.9 0 192l576 0 0-45.1-7.9-4.2C510.3 112.1 461.3 67.2 425.8 12.3L417.8 0l-8.5 9.5C378.5 44.2 334.4 64 288 64s-90.5-19.8-121.3-54.5L158.2 0l-8 12.3C114.7 67.2 65.7 112.1 7.9 142.7zM288 512l128 0L288 288l0 224z']
      
    ]
  };

  

  
  

  var faTicketsAirline = {
    prefix: 'fasds',
    iconName: 'tickets-airline',
    icon: [
      640,
      512,
      ["tickets-perforated-plane","tickets-plane"],
      'e29b',
      
      ['M96 32l0 352 544 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128L96 32zm96 120l32 0 18.3 32 47.2 0L256 96l48 0 58.7 88 61.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-61.3 0L304 320l-48 0 33.5-88-47.2 0L224 264l-32 0 16-56-16-56zm352-40a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312zm241.5 64l-47.2 0L224 152l-32 0 16 56-16 56 32 0 18.3-32 47.2 0L256 320l48 0 58.7-88 61.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-61.3 0L304 96l-48 0 33.5 88z']
      
    ]
  };

  
    var faTicketsPerforatedPlane = faTicketsAirline;
  
    var faTicketsPlane = faTicketsAirline;
  

  
  

  var faArrowRightLong = {
    prefix: 'fasds',
    iconName: 'arrow-right-long',
    icon: [
      512,
      512,
      ["long-arrow-right"],
      'f178',
      
      ['M0 224l0 64 32 0 357.5 0c10.7-10.7 21.3-21.3 32-32c-10.7-10.7-21.3-21.3-32-32L32 224 0 224z','M512 256l-22.6-22.6-128-128L338.7 82.7 293.5 128l22.6 22.6L421.5 256 316.1 361.4 293.5 384l45.3 45.3 22.6-22.6 128-128L512 256z']
      
    ]
  };

  
    var faLongArrowRight = faArrowRightLong;
  

  
  

  var faUserLock = {
    prefix: 'fasds',
    iconName: 'user-lock',
    icon: [
      640,
      512,
      [],
      'f502',
      
      ['M0 512l384 0 0-208L64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faThumbsDown = {
    prefix: 'fasds',
    iconName: 'thumbs-down',
    icon: [
      512,
      512,
      [61576,128078],
      'f165',
      
      ['M160 102.3l0 25.7 0 64 0 96 0 23.1 18 14.4 7.9 6.4c34.2 27.3 54 68.7 54 112.4l0 35.7 96 0 0-35.7c0-38.1-9-75.1-25.8-108.3L464 336l48 0 0-96-16 0 0-80-24 0 0-72-24 0 0-56-48 0L280 32l-14.5 0-12.1 8.1-72 48L160 102.3z','M0 384H128V96H0V384z']
      
    ]
  };

  

  
  

  var faGripLines = {
    prefix: 'fasds',
    iconName: 'grip-lines',
    icon: [
      448,
      512,
      [],
      'f7a4',
      
      ['M0 288l0 64 448 0 0-64L0 288z','M448 160l0 64L0 224l0-64 448 0z']
      
    ]
  };

  

  
  

  var faHeadSideCough = {
    prefix: 'fasds',
    iconName: 'head-side-cough',
    icon: [
      640,
      512,
      [],
      'e061',
      
      ['M0 224.3C0 100.4 100.4 0 224.3 0L256 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 32L320 368l0 40 128 8 0 64-128 0 0 32-32 0-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zM320 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M592 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm128 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-40-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faPanFood = {
    prefix: 'fasds',
    iconName: 'pan-food',
    icon: [
      640,
      512,
      [129368],
      'e42b',
      
      ['M112 256a208 208 0 1 0 416 0 208 208 0 1 0 -416 0zm43.7-24c4.7-4.7 9.4-9.4 14.1-14.1c10.7-10.7 21.3-21.3 32-32c4.7-4.7 9.4-9.4 14.1-14.1c9.4 9.4 18.9 18.9 28.3 28.3c-4.7 4.7-9.4 9.4-14.1 14.1c-10.7 10.7-21.3 21.3-32 32c-4.7 4.7-9.4 9.4-14.1 14.1L155.7 232zm21.7 80l11.3-11.3 8-8 8-8L216 273.4 238.6 296l-8 8 16 16 33.4 0c30.9 0 56 25.1 56 56s-25.1 56-56 56s-56-25.1-56-56l0-33.4-16-16-8 8L177.4 312zM248 136c0-39.8 32.2-72 72-72s72 32.2 72 72l0 8-144 0 0-8zm48.1 85.5c.1-.8 .2-1.6 .4-2.4c.3-1.6 .8-3.1 1.4-4.5c1.2-2.9 3-5.5 5.1-7.6c4.3-4.3 10.3-7 17-7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-2.2-2.2-3.9-4.8-5.1-7.6c-.6-1.4-1.1-2.9-1.4-4.5c-.2-.8-.3-1.6-.4-2.4s-.1-1.6-.1-2.6c0-.7 0-1.5 .1-2.3zM368 272l96-96 11 11c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1c-10.9 8.7-24.5 13.5-38.5 13.5l-4.1 0c-19.4 0-38-7.7-51.8-21.4L368 272zm72 112a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M528 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM64 256a256 256 0 1 1 512 0A256 256 0 1 1 64 256zm576-72l0 144 0 24-48 0 0-24 0-144 0-24 48 0 0 24zM48 160l0 24 0 144 0 24L0 352l0-24L0 184l0-24 48 0zm182.1 54.1l-32 32L184 260.3 155.7 232l14.1-14.1 32-32L216 171.7 244.3 200l-14.1 14.1zM464 176l11 11c13.4 13.4 21 31.6 21 50.6l0 4.8c0 18.7-8.5 36.4-23.1 48.1C462 299.2 448.4 304 434.4 304l-4.1 0c-19.4 0-38-7.7-51.8-21.4L368 272l96-96zM320 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faPersonDollyEmpty = {
    prefix: 'fasds',
    iconName: 'person-dolly-empty',
    icon: [
      512,
      512,
      [],
      'f4d1',
      
      ['M194.9 174.5l46.6-11.6 5.8 23.3 49.6 198.4c17.6 2.4 32.9 12 42.9 25.7l134.4-33.6 23.3-5.8 11.6 46.6-23.3 5.8L351.4 456.9C347.1 488 320.3 512 288 512c-35.3 0-64-28.7-64-64c0-21.3 10.4-40.1 26.3-51.7L223.3 288c-5.3-21.3-10.7-42.7-16-64c-2.2-8.7-4.4-17.5-6.5-26.2l-5.8-23.3zM272 448a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM0 480l0 32 64 0 0-32s0 0 0 0l0-69.5-64-64L0 480zM32 128L0 128l0 32L0 274.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6 56.7 56.7 6.3 37.9 4 24 4 24s0 0 0 0l4 24 .5 2.7 64.9 0-2.2-13.3-4-24s0 0 0 0l-4-24-4-24-8-48-1.7-10.1-7.3-7.3L96 306.7l0-65.1 21.4 32.1 9.5 14.3 17.1 0 79.3 0-16-64-46.1 0-54.5-81.7L97.1 128 80 128l-48 0z']
      
    ]
  };

  

  
  

  var faCarTunnel = {
    prefix: 'fasds',
    iconName: 'car-tunnel',
    icon: [
      512,
      512,
      [],
      'e4de',
      
      ['M0 256L0 512l96 0 0-64 0-128 28.4 0 30.2-80.4 5.8-15.6 16.6 0 159 0 16.8 0 5.7 15.8L387.7 320l28.3 0 0 128 0 64 96 0 0-256C512 114.6 397.4 0 256 0S0 114.6 0 256zM160 448l0 64 192 0 0-64-192 0zm15.6-128l161 0-17.5-48-125.6 0-18 48z','M177 224l-16.6 0-5.8 15.6L124.4 320 96 320l0 128 0 64 64 0 0-64 192 0 0 64 64 0 0-64 0-128-28.3 0-29.2-80.2L352.8 224 336 224l-159 0zm159.6 96l-161 0 18-48 125.6 0 17.5 48zM144 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faOmega = {
    prefix: 'fasds',
    iconName: 'omega',
    icon: [
      448,
      512,
      [],
      'f67a',
      
      ['M224 96C135.6 96 64 167.6 64 256c0 59.2 32.1 110.9 80 138.6l16 9.2 0 18.5 0 25.7 0 32-32 0-96 0L0 480l0-64 32 0 35.2 0C25.8 375.4 0 318.7 0 256C0 132.3 100.3 32 224 32s224 100.3 224 224c0 62.7-25.8 119.4-67.2 160l35.2 0 32 0 0 64-32 0-96 0-32 0 0-32 0-25.7 0-18.5 16-9.2c47.9-27.7 80-79.4 80-138.6c0-88.4-71.6-160-160-160z','']
      
    ]
  };

  

  
  

  var faMountains = {
    prefix: 'fasds',
    iconName: 'mountains',
    icon: [
      640,
      512,
      [9968],
      'f6fd',
      
      ['M412.9 267.4c33 49.6 66.1 99.1 99.1 148.6l0 64 128 0 0-64L480 160 412.9 267.4z','M0 416L256 32 512 416v64H0V416z']
      
    ]
  };

  

  
  

  var faAngleDown = {
    prefix: 'fasds',
    iconName: 'angle-down',
    icon: [
      448,
      512,
      [8964],
      'f107',
      
      ['M224 397.3l22.6-22.6 160-160L429.3 192 384 146.7l-22.6 22.6L224 306.7 86.6 169.4 64 146.7 18.7 192l22.6 22.6 160 160L224 397.3z','']
      
    ]
  };

  

  
  

  var faAirConditioner = {
    prefix: 'fasds',
    iconName: 'air-conditioner',
    icon: [
      576,
      512,
      [],
      'f8f4',
      
      ['M64 128l0 32 16 0 416 0 16 0 0-32-16 0L80 128l-16 0zm0 288c0 53 43 96 96 96s96-43 96-96l0-192-64 0 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l-32-55.4C83.4 349.4 64 380.4 64 416zM320 224l0 160c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1l-32 55.4c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160-64 0z','M576 0L0 0 0 224l576 0L576 0zM80 128l416 0 16 0 0 32-16 0L80 160l-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faSquareQuestion = {
    prefix: 'fasds',
    iconName: 'square-question',
    icon: [
      448,
      512,
      ["question-square"],
      'f2fd',
      
      ['M0 32L0 480l448 0 0-448L0 32zM136 184c0-30.9 25.1-56 56-56l56.9 0c17.4 0 33.2 7.1 44.7 18.5c5.7 5.7 10.3 12.5 13.5 20.1c1.6 3.8 2.8 7.7 3.7 11.9c.4 2.1 .7 4.1 1 6.3c.1 1.1 .2 2.1 .2 3.2c.1 1.1 .1 2.2 .1 3.3c0 1.4 0 1.8 0 2.1c0 .7-.1 1.4-.1 2.1c-.1 1.4-.2 2.8-.4 4.2c-.4 2.8-.9 5.5-1.6 8.1c-1.4 5.3-3.6 10.4-6.3 15.1c-5.5 9.5-13.4 17.5-23.2 23.1c-10.8 6.2-21.5 12.3-32.3 18.5l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9c14.8-8.5 29.6-17 44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-2c0-.3 .1-.7 .1-1c0-.3 0-.6 0-1.1c0-.5 0-1-.1-1.5c-.1-.5-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4L192 176c-4.4 0-8 3.6-8 8c0 2.2 0 4.4 0 6.5l-48 0c0-2.2 0-4.4 0-6.5zm64 152l48 0c0 16 0 32 0 48l-48 0c0-16 0-32 0-48z','M192 128c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L200 236.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L192 128zm56 208l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faQuestionSquare = faSquareQuestion;
  

  
  

  var faOilTemperature = {
    prefix: 'fasds',
    iconName: 'oil-temperature',
    icon: [
      576,
      512,
      ["oil-temp"],
      'f614',
      
      ['M0 304l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c1.4 0 2.7 0 4-.1c-12.6-18.1-20-40.2-20-63.9c0-.4 0-.9 0-1.3c-13.7-2.2-26.9-6.8-38-11.8c-14.9-6.8-26.9-15.4-40-24.7L96 264.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 297.9 19.3 304 0 304zM0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-11.9-5.4-22-12-32.3-19.3c-3.2 .3-6.4 .4-9.7 .4s-6.5-.1-9.7-.4c-10.3 7.2-20.4 13.9-32.3 19.3c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7L96 408.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448zm380-80.1c1.3 0 2.7 .1 4 .1c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-11.1 5-24.2 9.7-38 11.8c0 .4 0 .9 0 1.3c0 23.8-7.4 45.8-20 63.9z','M288 0L256 0l0 32 0 96 0 102.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-70.7 32 0 32 0 0-64-32 0-32 0 0-32 32 0 32 0 0-64L352 0 288 0z']
      
    ]
  };

  
    var faOilTemp = faOilTemperature;
  

  
  

  var faFaceDrooling = {
    prefix: 'fasds',
    iconName: 'face-drooling',
    icon: [
      512,
      512,
      [],
      'e372',
      
      ['M0 256C0 397.4 114.6 512 256 512c33.9 0 66.4-6.6 96-18.6l0-122.4c-9.7 6.4-20.3 12.2-32 16.9c0 20.1 0 40.1 0 60.2c0 5.3 0 10.7 0 16l-32 0c0-5.3 0-10.7 0-16c0-17 0-33.9 0-50.9c-10.1 1.9-20.8 2.9-32 2.9c-67 0-113.8-36.7-140.5-70l-10-12.5 25-20 10 12.5c22.8 28.5 61.3 58 115.5 58s92.7-29.5 115.5-58l10-12.5 25 20-10 12.5c-3.8 4.7-7.9 9.5-12.5 14.2l0 133.6c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256zm104.8-45.1c9.5-28.5 38.4-66.9 95.2-66.9c0 10.7 0 21.3 0 32c-39.2 0-58.3 25.6-64.8 45.1c-10.1-3.4-20.2-6.7-30.4-10.1zM312 144c56.8 0 85.7 38.4 95.2 66.9l-30.4 10.1C370.3 201.6 351.2 176 312 176c0-10.7 0-21.3 0-32z','M200 176c-39.2 0-58.3 25.6-64.8 45.1l-30.4-10.1c9.5-28.5 38.4-66.9 95.2-66.9l0 32zm112 0l0-32c56.8 0 85.7 38.4 95.2 66.9l-30.4 10.1C370.3 201.6 351.2 176 312 176zM288 448l0-50.9c11.4-2.1 22.1-5.3 32-9.3l0 60.2 0 16-32 0 0-16zm64 48l0-125.1c12.3-8.1 22.9-17.4 32-26.8L384 496l0 16-32 0 0-16z']
      
    ]
  };

  

  
  

  var faDisplayCode = {
    prefix: 'fasds',
    iconName: 'display-code',
    icon: [
      576,
      512,
      ["desktop-code"],
      'e165',
      
      ['M0 0L0 416l240 0 96 0 240 0L576 0 0 0zM64 64l448 0 0 288L64 352 64 64z','M64 64l448 0 0 288L64 352 64 64zM346.7 448l69.3 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0 69.3 0L240 416l96 0 10.7 32zM249 177l17-17L232 126.1l-17 17-48 48-17 17 17 17 48 48 17 17L265.9 256l-17-17-31-31 31-31zM361 143l-17-17L310.1 160l17 17 31 31-31 31-17 17L344 289.9l17-17 48-48 17-17-17-17-48-48z']
      
    ]
  };

  
    var faDesktopCode = faDisplayCode;
  

  
  

  var faLessThan = {
    prefix: 'fasds',
    iconName: 'less-than',
    icon: [
      384,
      512,
      [62774],
      '3c',
      
      ['M384 64.5l-5 2.2L19 226.8 0 235.2l0 41.6 19 8.4 360 160 5 2.2 0-70L110.8 256 384 134.6l0-70z','']
      
    ]
  };

  

  
  

  var faArrowDownShortWide = {
    prefix: 'fasds',
    iconName: 'arrow-down-short-wide',
    icon: [
      576,
      512,
      ["sort-amount-desc","sort-amount-down-alt"],
      'f884',
      
      ['M288 32l32 0 32 0 32 0 0 64-32 0-32 0-32 0 0-64zm0 128l32 0 96 0 32 0 0 64-32 0-96 0-32 0 0-64zm0 128l32 0 160 0 32 0 0 64-32 0-160 0-32 0 0-64zm0 128l32 0 224 0 32 0 0 64-32 0-224 0-32 0 0-64z','M128 480l23.7-26 80-88 21.5-23.7-47.4-43.1-21.5 23.7L160 349.7l0-285.2 0-32-64 0 0 32 0 285.2L71.7 322.9 50.2 299.2 2.8 342.3 24.3 366l80 88L128 480z']
      
    ]
  };

  
    var faSortAmountDesc = faArrowDownShortWide;
  
    var faSortAmountDownAlt = faArrowDownShortWide;
  

  
  

  var faFlorinSign = {
    prefix: 'fasds',
    iconName: 'florin-sign',
    icon: [
      384,
      512,
      [],
      'e184',
      
      ['M32 224l0 64 112 0c8.9-21.3 17.8-42.7 26.7-64L32 224zm181.3 64L352 288l0-64-112 0-26.7 64z','M226.1 91.1C241 55.3 275.9 32 314.7 32L352 32l32 0 0 64-32 0-37.3 0c-12.9 0-24.6 7.8-29.5 19.7L157.9 420.9C143 456.7 108.1 480 69.3 480L32 480 0 480l0-64 32 0 37.3 0c12.9 0 24.6-7.8 29.5-19.7L226.1 91.1z']
      
    ]
  };

  

  
  

  var faChartMixed = {
    prefix: 'fasds',
    iconName: 'chart-mixed',
    icon: [
      512,
      512,
      ["analytics"],
      'f643',
      
      ['M32 320l0 160 64 0 0-160-64 0zm128-96l0 256 64 0 0-256-64 0zm128 64l0 192 64 0 0-192-64 0zm128-64l0 256 64 0 0-256-64 0z','M500 89L340 217l-19.4 15.5-19.8-14.9L192.6 136.5 52 249 12 199 172 71l19.4-15.5 19.8 14.9 108.2 81.1L460 39l40 50z']
      
    ]
  };

  
    var faAnalytics = faChartMixed;
  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fasds',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      ['M0 352l0 32 0 96 0 32 64 0 0-32 0-64 162.7 0-25.4 25.4L178.7 464 224 509.3l22.6-22.6 80-80L349.3 384l-22.6-22.6-80-80L224 258.7 178.7 304l22.6 22.6L226.7 352 32 352 0 352zm384 32a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M265.4 25.4L288 2.7 333.3 48 310.6 70.6 285.3 96 480 96l32 0 0 32 0 96 0 32-64 0 0-32 0-64-162.7 0 25.4 25.4L333.3 208 288 253.3l-22.6-22.6-80-80L162.7 128l22.6-22.6 80-80zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z']
      
    ]
  };

  

  
  

  var faGrill = {
    prefix: 'fasds',
    iconName: 'grill',
    icon: [
      448,
      512,
      [],
      'e5a3',
      
      ['M106.1 352.8c1.9 .3 3.8 .7 5.7 1.2s3.7 1 5.4 1.6c3.6 1.2 7 2.8 10.2 4.6c6.5 3.7 12.3 8.4 17.1 14s8.7 12.1 11.4 19.1c1.3 3.5 2.4 7.2 3.1 11c.3 1.9 .6 3.8 .8 5.8c.1 1 .2 2 .2 2.9s.1 1.9 .1 3l156.7 0 13.2 30.8 4 9.3 9.5 22.1 44.1-18.9-9.5-22.1-4-9.3L318.8 299c-14.4 6.7-29.7 12-45.6 15.6L296.2 368l-144.3 0 22.9-53.4c-15.9-3.6-31.1-8.8-45.6-15.6l-23.1 53.8z','M448 32L0 32 0 96C0 219.7 100.3 320 224 320s224-100.3 224-224l0-64zM72 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0A64 64 0 1 0 32 416a64 64 0 1 0 128 0z']
      
    ]
  };

  

  
  

  var faCircleDown = {
    prefix: 'fasds',
    iconName: 'circle-down',
    icon: [
      512,
      512,
      [61466,"arrow-alt-circle-down"],
      'f358',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0l80 0 0-128 96 0c0 42.7 0 85.3 0 128l80 0 0 32L256 416 128 288l0-32z','M304 256l80 0 0 32L256 416 128 288l0-32 80 0 0-128 96 0 0 128z']
      
    ]
  };

  
    var faArrowAltCircleDown = faCircleDown;
  

  
  

  var faPersonRunningFast = {
    prefix: 'fasds',
    iconName: 'person-running-fast',
    icon: [
      512,
      512,
      [],
      'e5ff',
      
      ['M0 95.8l0 32 16 0 112 0 16 0 0-32-16 0-112 0-16 0zm0 64l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm0 64l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0zM96 352l0 64 32 0 80 0 20.8 0 8.4-19 28.9-64.9c-1.9-1.2-3.8-2.4-5.7-3.6c-25.1-15.7-36.1-46.5-26.8-74.5c2.8-8.5 5.7-17 8.5-25.6L187.2 352 128 352l-32 0z','M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 96l-13.3 0-9.4 9.4-48 48-8 8 45.3 45.3 8-8L237.3 160l27.7 0-31.3 94c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-9.4 32.8-16 56L309.6 512l66.6 0 6.6-23.2 16-56 16-56 6.6-23.2L401 340.9 334 299l29-77.4 24.3 48.6 8.8 17.7 19.8 0 48 0 32 0 0-64-32 0-28.2 0-39.2-78.3-5.4-10.9-11.3-4.5-80-32L294.2 96 288 96l-64 0z']
      
    ]
  };

  

  
  

  var faTurnLeftDown = {
    prefix: 'fasds',
    iconName: 'turn-left-down',
    icon: [
      384,
      512,
      [],
      'e637',
      
      ['M144 0L384 0l0 96L240 96l0 224-96 0L144 0z','M32 352L192 512 352 352l0-32L32 320l0 32z']
      
    ]
  };

  

  
  

  var faWaveTriangle = {
    prefix: 'fasds',
    iconName: 'wave-triangle',
    icon: [
      640,
      512,
      [],
      'f89a',
      
      ['M175.6 10.1l26 34.7 262 349.3 102.5-141 18.8-25.9 51.8 37.6-18.8 25.9-128 176-25.5 35-26-34.7-262-349.3L73.9 258.8 55.1 284.7 3.3 247.1l18.8-25.9 128-176 25.5-35z','']
      
    ]
  };

  

  
  

  var faImagePolaroid = {
    prefix: 'fasds',
    iconName: 'image-polaroid',
    icon: [
      448,
      512,
      [],
      'f8c4',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 96l320 0 0 256L64 352 64 96z','M384 96L64 96l0 256 320 0 0-256zM128 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM352 320l-144 0-48 0-64 0 0-32 56-64 30.2 34.5L256 160l96 128 0 32z']
      
    ]
  };

  

  
  

  var faIndustry = {
    prefix: 'fasds',
    iconName: 'industry',
    icon: [
      576,
      512,
      [],
      'f275',
      
      ['M32 32l0 192 0 160 0 96 512 0 0-256 0-68.4L352 265.4l0-41.4 0-13.9 0-54.4L160 265.4l0-41.4 0-13.9L160 32 32 32z','M363.9 148.8L160 265.4l0-55.3L340.1 107.2l23.8 41.7zm192 0L352 265.4l0-55.3L532.1 107.2l23.8 41.7z']
      
    ]
  };

  

  
  

  var faBoreHole = {
    prefix: 'fasds',
    iconName: 'bore-hole',
    icon: [
      512,
      512,
      [],
      'e4c3',
      
      ['M0 128L0 512l512 0 0-384-160 0 0 224c0 53-43 96-96 96s-96-43-96-96l0-224L0 128z','M288 32l0-32L224 0l0 32 0 264.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L288 32z']
      
    ]
  };

  

  
  

  var faArrowsRepeat = {
    prefix: 'fasds',
    iconName: 'arrows-repeat',
    icon: [
      512,
      512,
      ["repeat-alt"],
      'f364',
      
      ['M50.7 384l22.6 22.6 80 80L176 509.3 221.3 464l-22.6-22.6L173.3 416 480 416l32 0 0-32 0-96 0-32-64 0 0 32 0 64-274.7 0 25.4-25.4L221.3 304 176 258.7l-22.6 22.6-80 80L50.7 384z','M0 256l0-32 0-96L0 96l32 0 306.7 0L313.4 70.6 290.7 48 336 2.7l22.6 22.6 80 80L461.3 128l-22.6 22.6-80 80L336 253.3 290.7 208l22.6-22.6L338.7 160 64 160l0 64 0 32L0 256z']
      
    ]
  };

  
    var faRepeatAlt = faArrowsRepeat;
  

  
  

  var faHorseHead = {
    prefix: 'fasds',
    iconName: 'horse-head',
    icon: [
      640,
      512,
      [],
      'f7ab',
      
      ['M203.3 298.2l8 13.8c24 41.5 68.3 70 119.3 71.9l-23.8-35.8c-28.9-7.8-53.1-26.8-67.8-52.2c-2.7-4.6-5.3-9.2-8-13.8c-9.2 5.3-18.5 10.7-27.7 16z','M64 512l0-192.8c0-109.5 69.7-207 173.4-242.3L416 16l32 48L400 96l104 64 72 192-64 64-80 0-58.6-70.4c-11.6 4.1-24.1 6.4-37.2 6.4l-.2 0s0 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3c0 0 0 0 0 0c-28.9-7.8-53.1-26.8-67.8-52.2l-8-13.8-27.7 16 8 13.8c24 41.5 68.3 70 119.3 71.9L416 512 64 512zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faCircleDollar = {
    prefix: 'fasds',
    iconName: 'circle-dollar',
    icon: [
      512,
      512,
      ["dollar-circle","usd-circle"],
      'f2e8',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm161.9 95.7c4.8-15.3 9.6-30.5 14.4-45.8c2.4 .8 4.9 1.5 7.3 2.3c8.1 2.5 16.2 5.1 24.3 7.7c13.4 4.3 29.2 9.4 38.3 10.8c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-11.2-7.7-25.1-11.4-38.4-15c-2.5-.7-5-1.4-7.5-2.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.4-23.8 22.1-39.8 42-48.3c6.5-2.8 13.4-4.9 20.7-6.3c0-14.2 0-28.4 0-42.5l48 0c0 13.9 0 27.7 0 41.6c20.3 2.9 40.2 7.8 60.1 12.8l-11.7 46.6c-18.1-4.5-36.1-9-54.6-11.7c-18.2-2.7-33.5-.5-43.7 3.8c-12.2 5.2-20 18-7 26.3c9.4 6 23.9 10.2 43.7 15.9l.9 .2c17.3 4.9 39.5 11.2 56.1 22.6c18.1 12.4 28.1 31.2 28.1 52.2c0 4.1-.4 8.2-1.1 12.4c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9l0 40.9-48 0 0-43.2c-12.9-2.9-29.7-8.2-40.7-11.8c-7.3-2.4-14.6-4.6-21.9-6.9c-2.5-.8-5-1.6-7.5-2.3z','M280 96v41.6c20.3 2.9 40.2 7.8 60.1 12.8l-11.7 46.6c-18.1-4.5-36.1-9-54.6-11.7c-18.2-2.7-33.5-.5-43.7 3.8c-12.2 5.2-20 18-7 26.3c9.4 6 23.9 10.2 43.7 15.9l.9 .2c17.3 4.9 39.5 11.2 56.1 22.6c21.6 14.8 31.7 38.8 26.9 64.6c-4.6 24.9-21.9 41.2-42.7 49.6c-8.7 3.5-18.1 5.7-28 6.9V416H232V372.8c-12.9-2.9-29.7-8.2-40.7-11.8c-9.8-3.2-19.6-6.2-29.4-9.3l14.4-45.8c10.5 3.3 21.1 6.6 31.6 10c13.5 4.3 29.3 9.4 38.3 10.8c18.9 2.8 34 1.1 43.9-2.9c13.4-5.4 19.6-21.2 6.6-30.1c-13.4-9.1-30.5-12.7-45.9-17.1c-16.8-4.7-37.7-10.7-53.5-20.8c-21.7-13.8-32.7-37-28-62.6c4.4-23.8 22.1-39.8 42-48.3c6.5-2.8 13.4-4.9 20.7-6.3V96h48z']
      
    ]
  };

  
    var faDollarCircle = faCircleDollar;
  
    var faUsdCircle = faCircleDollar;
  

  
  

  var faFaceLaughWink = {
    prefix: 'fasds',
    iconName: 'face-laugh-wink',
    icon: [
      512,
      512,
      ["laugh-wink"],
      'f59c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 32l318.4 0c-8 80.9-76.2 144-159.2 144s-151.2-63.1-159.2-144zm47.6-96c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm122.8 10.4c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2z','M176.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm116.4-2.4c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2z']
      
    ]
  };

  
    var faLaughWink = faFaceLaughWink;
  

  
  

  var faSignalFair = {
    prefix: 'fasds',
    iconName: 'signal-fair',
    icon: [
      640,
      512,
      ["signal-2"],
      'f68d',
      
      ['M288 192l0 32 0 256 0 32 64 0 0-32 0-256 0-32-64 0zM416 96l0 32 0 352 0 32 64 0 0-32 0-352 0-32-64 0zM544 0l0 32 0 448 0 32 64 0 0-32 0-448 0-32L544 0z','M224 320l0-32-64 0 0 32 0 160 0 32 64 0 0-32 0-160zM96 416l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64z']
      
    ]
  };

  
    var faSignal2 = faSignalFair;
  

  
  

  var faHouseTree = {
    prefix: 'fasds',
    iconName: 'house-tree',
    icon: [
      640,
      512,
      [],
      'e1b3',
      
      ['M277 125.1L404.5 231.4 416 241l0 15 0 256 224 0 0-48L544 352l64 0 0-48L512 192l64 0 0-48L416 0 277 125.1z','M0 512L0 256 192 96 384 256l0 256L0 512zM240 368l0-96-96 0 0 96 96 0z']
      
    ]
  };

  

  
  

  var faHockeyStickPuck = {
    prefix: 'fasds',
    iconName: 'hockey-stick-puck',
    icon: [
      640,
      512,
      [],
      'e3ae',
      
      ['M0 352l64 0 0 160L0 512 0 352zm96 0c52.1 0 104.2 0 156.2 0L419.4 17.7l57.2 28.6-224 448L243.8 512 224 512l-64 0-32 0c-10.7 0-21.3 0-32 0l0-32 0-128z','M96 352l-32 0 0 160 32 0 0-160zm544 64l-256 0 0 96 256 0 0-96z']
      
    ]
  };

  

  
  

  var faLaptopArrowDown = {
    prefix: 'fasds',
    iconName: 'laptop-arrow-down',
    icon: [
      640,
      512,
      [],
      'e1c6',
      
      ['M0 384l0 48 48 48 544 0 48-48 0-48L0 384zM64 32l0 32 0 288 64 0 0-256 168 0 0-64L96 32 64 32zm280 0l0 64 168 0 0 256 64 0 0-288 0-32-32 0L344 32z','M296 96L128 96l0 256 384 0 0-256L344 96l0 110.1 39-39 17-17L433.9 184l-17 17-80 80-17 17-17-17-80-80-17-17L240 150.1l17 17 39 39L296 96z']
      
    ]
  };

  

  
  

  var faBracketsSquare = {
    prefix: 'fasds',
    iconName: 'brackets-square',
    icon: [
      448,
      512,
      ["brackets"],
      'f7e9',
      
      ['M288 32l0 64 32 0 64 0 0 320-64 0-32 0 0 64 32 0 96 0 32 0 0-32 0-384 0-32-32 0-96 0-32 0z','M0 32l32 0 96 0 32 0 0 64-32 0L64 96l0 320 64 0 32 0 0 64-32 0-96 0L0 480l0-32L0 64 0 32z']
      
    ]
  };

  
    var faBrackets = faBracketsSquare;
  

  
  

  var faFaceSmileHearts = {
    prefix: 'fasds',
    iconName: 'face-smile-hearts',
    icon: [
      640,
      512,
      [],
      'e390',
      
      ['M64 256c0 25.4 3.7 50 10.6 73.1c1.8 1 3.6 2.2 5.4 3.4c11.8-8.1 25.9-12.5 40.4-12.5c39.5 0 71.6 32.1 71.6 71.6c0 19-7.5 37.2-21 50.6l-12.5 12.5C202.6 490.5 258.8 512 320 512c55.1 0 106.1-17.4 147.8-47c-12.7-13.3-19.8-31-19.8-49.4c0-39.5 32.1-71.6 71.6-71.6c13.1 0 25.8 3.6 36.9 10.2C569.1 324 576 290.8 576 256c0-27.4-4.3-53.8-12.3-78.5l-3.7 3.7-22.6-22.6L469 90.2c-13.4-13.4-21-31.6-21-50.6c0-1.8 .1-3.5 .2-5.2C410.5 12.5 366.7 0 320 0C178.6 0 64 114.6 64 256zm107.2-37.6c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2zm22.5 108.8l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C433.7 352.3 391.6 400 320 400s-113.7-47.7-126.3-72.8zM331.2 218.4c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2z','M547.6 11.6L560 24l12.4-12.4C579.8 4.2 589.9 0 600.4 0C622.3 0 640 17.7 640 39.6c0 10.5-4.2 20.6-11.6 28L560 136 491.6 67.6c-7.4-7.4-11.6-17.5-11.6-28C480 17.7 497.7 0 519.6 0c10.5 0 20.6 4.2 28 11.6zm-264.4 226c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zm160 0c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2zM80 376l12.4-12.4c7.4-7.4 17.5-11.6 28-11.6c21.9 0 39.6 17.7 39.6 39.6c0 10.5-4.2 20.6-11.6 28L80 488 11.6 419.6C4.2 412.2 0 402.1 0 391.6C0 369.7 17.7 352 39.6 352c10.5 0 20.6 4.2 28 11.6L80 376zm480 24l12.4-12.4c7.4-7.4 17.5-11.6 28-11.6c21.9 0 39.6 17.7 39.6 39.6c0 10.5-4.2 20.6-11.6 28L560 512l-68.4-68.4c-7.4-7.4-11.6-17.5-11.6-28c0-21.9 17.7-39.6 39.6-39.6c10.5 0 20.6 4.2 28 11.6L560 400z']
      
    ]
  };

  

  
  

  var faSquare8 = {
    prefix: 'fasds',
    iconName: 'square-8',
    icon: [
      448,
      512,
      [],
      'e25d',
      
      ['M0 32l448 0 0 448L0 480 0 32zM128 304c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42c0-39.8-32.2-72-72-72l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62zm48 0c0-17.7 14.3-32 32-32l8 0 16 0 8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32zm16-104c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24c0 13.2-10.7 24-24 24l-16 0c-13.2 0-24-10.8-24-24z','M304 200c0-39.8-32.2-72-72-72l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42zm-72 72l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c0 0 0 0 0 0l16 0c0 0 0 0 0 0zm0-48L216 224c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z']
      
    ]
  };

  

  
  

  var faSquareArrowLeft = {
    prefix: 'fasds',
    iconName: 'square-arrow-left',
    icon: [
      448,
      512,
      ["arrow-square-left"],
      'f33a',
      
      ['M0 32l448 0 0 448L0 480 0 32zM70.1 256c5.7 5.7 11.3 11.3 17 17c37.3 37.3 74.7 74.7 112 112c5.7 5.7 11.3 11.3 17 17c11.3-11.3 22.6-22.6 33.9-33.9c-5.7-5.7-11.3-11.3-17-17c-23.7-23.7-47.3-47.3-71-71c60.7 0 121.4 0 182.1 0c8 0 16 0 24 0l0-48c-8 0-16 0-24 0c-60.7 0-121.4 0-182.1 0l71-71 17-17c-11.3-11.3-22.6-22.6-33.9-33.9l-17 17L87 239l-17 17z','M70.1 256l17-17L199 127l17-17L249.9 144l-17 17-71 71L344 232l24 0 0 48-24 0-182.1 0 71 71 17 17L216 401.9l-17-17L87 273l-17-17z']
      
    ]
  };

  
    var faArrowSquareLeft = faSquareArrowLeft;
  

  
  

  var faGuitar = {
    prefix: 'fasds',
    iconName: 'guitar',
    icon: [
      512,
      512,
      [],
      'f7a6',
      
      ['M28.8 283.6C-16 328.4-7.6 409.4 47.5 464.5C78.8 495.8 118.4 512 155 512c27.9 0 54-9.4 73.4-28.8c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c16-16 23.7-37.7 23.7-61c0-23-7.5-47.6-22.2-70c-24.6 24.6-49.3 49.3-73.9 73.9c0 .9 .1 1.8 .1 2.7c0 26.5-21.5 48-48 48s-48-21.5-48-48s21.5-48 48-48c.9 0 1.8 0 2.7 .1c24.6-24.6 49.3-49.3 73.9-73.9c-22.4-14.6-47-22.2-70-22.2c-23.3 0-45 7.8-61 23.7c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6z','M367.1 99.7L376 64 448 0l64 64-64 72-35.7 8.9L255.9 301.3c-1.3-24.4-20.9-43.9-45.3-45.3L367.1 99.7z']
      
    ]
  };

  

  
  

  var faScreenUsers = {
    prefix: 'fasds',
    iconName: 'screen-users',
    icon: [
      640,
      512,
      ["users-class"],
      'f63d',
      
      ['M32 0L64 0 576 0l32 0 0 32 0 216.4c-17-15.2-39.4-24.4-64-24.4l0-160L96 64l0 160c-24.6 0-47 9.2-64 24.4L32 32 32 0z','M96 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm224 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm288-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM416 512l-32-96-128 0-32 96 192 0zM32 416L0 512l192 0-32-96L32 416zm608 96l-32-96-128 0-32 96 192 0z']
      
    ]
  };

  
    var faUsersClass = faScreenUsers;
  

  
  

  var faTrashCanSlash = {
    prefix: 'fasds',
    iconName: 'trash-can-slash',
    icon: [
      640,
      512,
      ["trash-alt-slash"],
      'e2ad',
      
      ['M96 32l0 19.8L153 96l391 0 0-64L416 32 400 0 240 0 224 32 96 32zm32 164.8L128 512l384 0 0-12.6-80-63 0 11.6-32 0 0-16 0-20.8-64-50.4 0 71.3 0 16-32 0 0-16 0-96.5-64-50.4L240 432l0 16-32 0 0-16 0-172.1-80-63zM194.2 128c36.6 28.4 73.2 56.8 109.8 85.2l0-5.2 0-16 32 0 0 16 0 30.1c21.3 16.6 42.7 33.1 64 49.7l0-79.8 0-16 32 0 0 16 0 104.6 80 62.1L512 128l-317.8 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faTrashAltSlash = faTrashCanSlash;
  

  
  

  var faSun = {
    prefix: 'fasds',
    iconName: 'sun',
    icon: [
      512,
      512,
      [9728],
      'f185',
      
      ['M0 150L73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l23.3-126.7L512 362 438.9 256 512 150 385.3 126.7 362 0 256 73.1 150 0 126.7 126.7 0 150zM384 256a128 128 0 1 1 -256 0 128 128 0 1 1 256 0z','M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z']
      
    ]
  };

  

  
  

  var faObjectsAlignCenterHorizontal = {
    prefix: 'fasds',
    iconName: 'objects-align-center-horizontal',
    icon: [
      512,
      512,
      [],
      'e3bc',
      
      ['M32 64l200 0 48 0 200 0 0 160-200 0-48 0L32 224 32 64zM96 288l136 0 48 0 136 0 0 160-136 0-48 0L96 448l0-160z','M232 0l48 0 0 64-48 0 0-64zm0 224l48 0 0 64-48 0 0-64zm0 224l48 0 0 64-48 0 0-64z']
      
    ]
  };

  

  
  

  var faChampagneGlass = {
    prefix: 'fasds',
    iconName: 'champagne-glass',
    icon: [
      320,
      512,
      ["glass-champagne"],
      'f79e',
      
      ['M34.3 226.5c0 57.4 39.3 107.1 93.7 121.4L128 448l-48 0-32 0 0 64 32 0 80 0 80 0 32 0 0-64-32 0-48 0 0-100.1c54.4-14.2 93.7-63.9 93.7-121.4c0-5.7-.4-11.4-1.2-17.2L256 0 64 0 35.5 209.3c-.8 5.8-1.2 11.5-1.2 17.2zM98.9 218c4.1-30 8.2-60 12.3-90c2.9-21.3 5.8-42.7 8.7-64l80.3 0c2.9 21.3 5.8 42.7 8.7 64c4.1 30 8.2 60 12.3 90c.4 2.8 .6 5.7 .6 8.5c0 33.5-27.2 61.6-61.7 61.6c-37.4 0-66.2-33-61.1-70z','M111.1 128L98.9 218c-5.1 37 23.7 70 61.1 70s66.2-33 61.1-70l-12.3-90-97.7 0z']
      
    ]
  };

  
    var faGlassChampagne = faChampagneGlass;
  

  
  

  var faTrashUndo = {
    prefix: 'fasds',
    iconName: 'trash-undo',
    icon: [
      448,
      512,
      ["trash-arrow-turn-left"],
      'f895',
      
      ['M32 96l384 0L392 512 56 512 32 96zM94.1 256l17 17 64 64 17 17L225.9 320l-17-17-23-23 54.1 0c22.1 0 40 17.9 40 40l0 40 0 24 48 0 0-24 0-40c0-48.6-39.4-88-88-88l-54.1 0 23-23 17-17L192 158.1l-17 17-64 64-17 17z','M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zm65 209l17-17L192 158.1l-17 17-64 64-17 17 17 17 64 64 17 17L225.9 320l-17-17-23-23 54.1 0c22.1 0 40 17.9 40 40l0 40 0 24 48 0 0-24 0-40c0-48.6-39.4-88-88-88l-54.1 0 23-23z']
      
    ]
  };

  
    var faTrashArrowTurnLeft = faTrashUndo;
  

  
  

  var faRubleSign = {
    prefix: 'fasds',
    iconName: 'ruble-sign',
    icon: [
      384,
      512,
      [8381,"rouble","rub","ruble"],
      'f158',
      
      ['M0 352l0 64 64 0 0-64L0 352zm128 0l0 64 192 0 0-64-192 0z','M64 32l32 0 144 0c79.5 0 144 64.5 144 144s-64.5 144-144 144l-112 0 0 160-64 0 0-160L0 320l0-64 64 0L64 64l0-32zm64 224l112 0c44.2 0 80-35.8 80-80s-35.8-80-80-80L128 96l0 160z']
      
    ]
  };

  
    var faRouble = faRubleSign;
  
    var faRub = faRubleSign;
  
    var faRuble = faRubleSign;
  

  
  

  var faNotes = {
    prefix: 'fasds',
    iconName: 'notes',
    icon: [
      512,
      512,
      [],
      'e202',
      
      ['M96 32l0 384 256 0 0-128 128 0 0-256L96 32z','M296 464l24 0 0 48-24 0L24 512 0 512l0-24L0 152l0-24 48 0 0 24 0 312 248 0zm56-48l0-128 128 0L352 416z']
      
    ]
  };

  

  
  

  var faGearCode = {
    prefix: 'fasds',
    iconName: 'gear-code',
    icon: [
      512,
      512,
      [],
      'e5e8',
      
      ['M6.3 176.5l59.4 54.1C64.6 238.9 64 247.4 64 256s.6 17.1 1.7 25.4L6.3 335.5l56 97 76.5-24.4c13.4 10.3 28.2 18.9 44 25.4L200 512l112 0 17.2-78.4c15.8-6.5 30.6-15.1 44-25.4l76.5 24.4 56-97-59.4-54.1c1.1-8.3 1.7-16.8 1.7-25.4s-.6-17.1-1.7-25.4l59.4-54.1-56-97-76.5 24.4C359.8 93.6 345 85 329.2 78.4L312 0 200 0 182.8 78.4c-15.8 6.5-30.6 15.1-44 25.4L62.3 79.5l-56 97zM113.4 256l11.3-11.3 40-40c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-9.6 9.6-19.1 19.1-28.7 28.7c9.6 9.6 19.1 19.1 28.7 28.7c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-13.3-13.3-26.7-26.7-40-40c-3.8-3.8-7.5-7.5-11.3-11.3zM221.6 365.2l2.6-15.8 32-192c.9-5.3 1.8-10.5 2.6-15.8c10.5 1.8 21 3.5 31.6 5.3c-.9 5.3-1.8 10.5-2.6 15.8c-10.7 64-21.3 128-32 192c-.9 5.3-1.8 10.5-2.6 15.8c-10.5-1.8-21-3.5-31.6-5.3zM313.4 216c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c13.3 13.3 26.7 26.7 40 40c3.8 3.8 7.5 7.5 11.3 11.3c-3.8 3.8-7.5 7.5-11.3 11.3c-13.3 13.3-26.7 26.7-40 40c-3.8 3.8-7.5 7.5-11.3 11.3L313.4 296c3.8-3.8 7.5-7.5 11.3-11.3c9.6-9.6 19.1-19.1 28.7-28.7c-9.6-9.6-19.1-19.1-28.7-28.7c-3.8-3.8-7.5-7.5-11.3-11.3z','M290.4 146.8l-2.6 15.8-32 192-2.6 15.8-31.6-5.3 2.6-15.8 32-192 2.6-15.8 31.6 5.3zM198.6 216l-11.3 11.3L158.6 256l28.7 28.7L198.6 296 176 318.6l-11.3-11.3-40-40L113.4 256l11.3-11.3 40-40L176 193.4 198.6 216zM336 193.4l11.3 11.3 40 40L398.6 256l-11.3 11.3-40 40L336 318.6 313.4 296l11.3-11.3L353.4 256l-28.7-28.7L313.4 216 336 193.4z']
      
    ]
  };

  

  
  

  var faYenSign = {
    prefix: 'fasds',
    iconName: 'yen-sign',
    icon: [
      320,
      512,
      [165,"cny","jpy","rmb","yen"],
      'f157',
      
      ['M16 224l32 0 58 0c7.3 13.4 14.7 26.8 22 40.2l0 23.8-80 0-32 0 0-64zm0 96l32 0 80 0 0 64-80 0-32 0 0-64zm176-55.8L214 224l58 0 32 0 0 64-32 0-80 0 0-23.8zm0 55.8l80 0 32 0 0 64-32 0-80 0 0-64z','M.7 32L128 264.2 128 448l0 32 64 0 0-32 0-183.8L319.3 32l-73 0L160 189.4 73.7 32 .7 32z']
      
    ]
  };

  
    var faCny = faYenSign;
  
    var faJpy = faYenSign;
  
    var faRmb = faYenSign;
  
    var faYen = faYenSign;
  

  
  

  var faPlaneCircleXmark = {
    prefix: 'fasds',
    iconName: 'plane-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e557',
      
      ['M0 288l0 96 192-64 0 80-64 48 0 64 128-32 128 32 0-8.2c-39.1-32.3-64-81.1-64-135.8c0-64.1 34.3-120.2 85.5-151L320 160l0-66.3C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 66.3L0 288z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faToilet = {
    prefix: 'fasds',
    iconName: 'toilet',
    icon: [
      448,
      512,
      [128701],
      'f7d8',
      
      ['M0 0L0 48l24 0 8 0 384 0 8 0 24 0 0-48L424 0 24 0 0 0zM96 80l0 32 16 0 32 0 16 0 0-32-16 0-32 0L96 80z','M421.6 201.4c-1.8-1.5-3.7-3-5.6-4.4L416 48 32 48l0 148.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c15.1 18.9 33.3 33.1 51.9 43.9L64 512l320 0-24.9-99.6c18.6-10.8 36.8-25 51.9-43.9c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6zM384 255.9c0 0 0 .1 0 .1l0 .3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3c0 0 0-.1 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8zM112 80l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faMars = {
    prefix: 'fasds',
    iconName: 'mars',
    icon: [
      448,
      512,
      [9794],
      'f222',
      
      ['M96 304a80 80 0 1 0 160 0A80 80 0 1 0 96 304z','M448 32L320 32 288 64l41.4 41.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l53.6-53.6L416 192l32-32 0-128zM176 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z']
      
    ]
  };

  

  
  

  var faVault = {
    prefix: 'fasds',
    iconName: 'vault',
    icon: [
      576,
      512,
      [],
      'e2c5',
      
      ['M0 0L0 480l80 0 16 32 64 0 16-32 224 0 16 32 64 0 16-32 80 0L576 0 0 0zM384 240A160 160 0 1 1 64 240a160 160 0 1 1 320 0zm32-64c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3L480 336l0 16-32 0 0-16 0-114.7c-18.6-6.6-32-24.4-32-45.3z','M304 240a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM64 240a160 160 0 1 1 320 0A160 160 0 1 1 64 240zm448-64c0 20.9-13.4 38.7-32 45.3L480 336l0 16-32 0 0-16 0-114.7c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48z']
      
    ]
  };

  

  
  

  var faArrowTurnLeftUp = {
    prefix: 'fasds',
    iconName: 'arrow-turn-left-up',
    icon: [
      384,
      512,
      [],
      'e634',
      
      ['M160 122.5c10.7-10.7 21.3-21.3 32-32c10.7 10.7 21.3 21.3 32 32L224 448l128 0 32 0 0 64-32 0-160 0-32 0 0-32 0-357.5z','M365.3 173.3l-22.6-22.6-128-128L192 0 169.4 22.6l-128 128L18.7 173.3 64 218.5l22.6-22.6L192 90.5 297.4 195.9 320 218.5l45.3-45.3z']
      
    ]
  };

  

  
  

  var faPersonSimple = {
    prefix: 'fasds',
    iconName: 'person-simple',
    icon: [
      256,
      512,
      [],
      'e220',
      
      ['M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64z','M224 160L32 160 24 352l40 0 0 160 128 0 0-160 40 0-8-192z']
      
    ]
  };

  

  
  

  var faTableCellsColumnUnlock = {
    prefix: 'fasds',
    iconName: 'table-cells-column-unlock',
    icon: [
      640,
      512,
      [],
      'e690',
      
      ['M0 32L0 480l384 0 0-64-24 0 0-64 24 0 0-64-24 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 32 0 32zM208 96l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64zM360 96l88 0 0 64-88 0 0-64z','M528 240c-17.7 0-32 14.3-32 32l0 48 32 0 32 0 48 0 32 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z']
      
    ]
  };

  

  
  

  var faOilWell = {
    prefix: 'fasds',
    iconName: 'oil-well',
    icon: [
      576,
      512,
      [],
      'e532',
      
      ['M137.3 448l67.8 0 11.2-32 111.4 0 11.2 32 67.8 0L340 257.5l-62.2 16.1L305.3 352l-66.6 0L265 277l-74.6 19.3L137.3 448zm90.9-259.6c26.8-6.9 53.6-13.9 80.4-20.8l-6.3-18.1L294.7 128l-45.4 0-7.5 21.4-13.6 39zM272 63.1l-.3 .9 .6 0-.3-.9z','M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L384 17.1l32.8 122.4L96 222.6 96 184l0-24-48 0 0 24 0 264-16 0L0 448l0 64 32 0 512 0 32 0 0-64-32 0L96 448l0-159.2 337.4-87.5 33.5 124.9 46.4-12.4c42.7-11.4 68-55.3 56.6-98L528.3 61.3z']
      
    ]
  };

  

  
  

  var faGlassWater = {
    prefix: 'fasds',
    iconName: 'glass-water',
    icon: [
      384,
      512,
      [],
      'e4f4',
      
      ['M0 0L5 64 40 512l304 0L379 64l5-64L319.8 0 64.2 0 0 0zM69.2 64l245.6 0c-2.5 31.4-4.9 62.9-7.4 94.3L284.8 448 99.2 448 76.6 158.3c-2.5-31.4-4.9-62.9-7.4-94.3z','M76.6 158.3L99.2 448l185.6 0 22.6-289.7-20.6 10.3c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L76.6 158.3z']
      
    ]
  };

  

  
  

  var faTrashCanCheck = {
    prefix: 'fasds',
    iconName: 'trash-can-check',
    icon: [
      448,
      512,
      [],
      'e2a9',
      
      ['M32 96l0 416 384 0 0-416L32 96zM94.1 288L128 254.1l17 17 47 47L303 207l17-17L353.9 224l-17 17L209 369l-17 17-17-17-64-64-17-17z','M144 0L128 32 0 32 0 96l448 0 0-64L320 32 304 0 144 0zM337 241l17-17L320 190.1l-17 17-111 111-47-47-17-17L94.1 288l17 17 64 64 17 17 17-17L337 241z']
      
    ]
  };

  

  
  

  var faBolt = {
    prefix: 'fasds',
    iconName: 'bolt',
    icon: [
      448,
      512,
      [9889,"zap"],
      'f0e7',
      
      ['M16 288L320 0 260.7 197.6 432 224 128 512l59.3-197.6L16 288z','']
      
    ]
  };

  
    var faZap = faBolt;
  

  
  

  var faMessageSlash = {
    prefix: 'fasds',
    iconName: 'message-slash',
    icon: [
      640,
      512,
      ["comment-alt-slash"],
      'f4a9',
      
      ['M64 0L576 0l0 416-10.8 0C398.1 286.3 231.1 156.6 64 26.9L64 0zm0 146.4L406.2 416 368 416 224 512l0-96L64 416l0-269.6z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faCommentAltSlash = faMessageSlash;
  

  
  

  var faShieldCat = {
    prefix: 'fasds',
    iconName: 'shield-cat',
    icon: [
      512,
      512,
      [],
      'e572',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM160 144l64 64c21.3 0 42.7 0 64 0c21.3-21.3 42.7-42.7 64-64c0 42.7 0 85.3 0 128.3c0 1.6-.1 3.3-.1 4.9c-.1 1.5-.2 3.1-.4 4.7c-.3 3.2-.8 6.4-1.5 9.5c-1.3 6.2-3.2 12.3-5.6 18c-4.9 11.5-11.9 21.8-20.6 30.5C306.5 357.3 282.5 368 256 368c-53 0-96-43-96-96c0-42.7 0-85.3 0-128z','M160 144l64 64 64 0 64-64 0 128c0 53-43 96-96 96s-96-43-96-96l0-128zm72 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faCaravan = {
    prefix: 'fasds',
    iconName: 'caravan',
    icon: [
      640,
      512,
      [],
      'f8ff',
      
      ['M64 128l0 128 192 0 0-128L64 128zm48 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM320 128l0 176 32 48 96 0 0-96-32 0-16 0 0-32 16 0 32 0 0-96-128 0z','M416 32L0 32 0 416l81.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96L576 416l32 0 32 0 0-64-32 0-32 0 0-160c0-88.4-71.6-160-160-160zm32 320l-96 0-32-48 0-176 128 0 0 224zM64 128l192 0 0 128L64 256l0-128z']
      
    ]
  };

  

  
  

  var faArrowUpArrowDown = {
    prefix: 'fasds',
    iconName: 'arrow-up-arrow-down',
    icon: [
      576,
      512,
      ["sort-up-down"],
      'e099',
      
      ['M274.7 336l22.6 22.6 96 96L416 477.3l22.6-22.6 96-96L557.3 336 512 290.7l-22.6 22.6L448 354.7 448 64l0-32-64 0 0 32 0 290.7-41.4-41.4L320 290.7 274.7 336z','M160 34.7l22.6 22.6 96 96L301.3 176 256 221.3l-22.6-22.6L192 157.3 192 448l0 32-64 0 0-32 0-290.7L86.6 198.6 64 221.3 18.7 176l22.6-22.6 96-96L160 34.7z']
      
    ]
  };

  
    var faSortUpDown = faArrowUpArrowDown;
  

  
  

  var faHandWave = {
    prefix: 'fasds',
    iconName: 'hand-wave',
    icon: [
      512,
      512,
      [],
      'e1a7',
      
      ['M18.7 288l22.6 22.6 9.4 9.4 22.6 22.6L180.4 449.7l4.9 4.9c22.2 22.2 49.2 36.9 77.6 44.1c58 17 122.8 6.6 173.6-32.7c47.6-36.8 75.5-93.5 75.5-153.7L512 128l0-32-32 0-16 0-32 0 0 32 0 99.5c-3-3.5-6.1-6.9-9.4-10.2l-192-192L208 2.7 162.7 48l22.6 22.6 136 136-18.7 18.7-152-152L128 50.7 82.7 96l22.6 22.6 152 152-18.7 18.7-136-136L80 130.7 34.7 176l22.6 22.6 136 136-18.7 18.7-56-56L96 274.7l-9.4-9.4L64 242.7 18.7 288z','M352 88l0 16 32 0 0-16 0-8c0-44.2-35.8-80-80-80l-8 0L280 0l0 32 16 0 8 0c26.5 0 48 21.5 48 48l0 8zM32 360l0-16L0 344l0 16 0 8c0 44.2 35.8 80 80 80l8 0 16 0 0-32-16 0-8 0c-26.5 0-48-21.5-48-48l0-8z']
      
    ]
  };

  

  
  

  var faFolderGear = {
    prefix: 'fasds',
    iconName: 'folder-gear',
    icon: [
      512,
      512,
      ["folder-cog"],
      'e187',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM129.1 251.7l32-55.4L193.6 215c8.9-7.6 19.1-13.6 30.4-17.6l0-37.5 64 0 0 37.5c11.2 4 21.5 10 30.4 17.6l32.5-18.7 32 55.4-32.5 18.7c1 5.7 1.6 11.6 1.6 17.6s-.6 11.9-1.6 17.5l32.5 18.7-32 55.4L318.4 361c-8.9 7.6-19.2 13.6-30.4 17.6l0 37.5-64 0 0-37.5c-11.2-4-21.5-10-30.4-17.6l-32.5 18.7-32-55.4 32.5-18.7c-1.1-5.7-1.6-11.6-1.6-17.5s.5-11.9 1.6-17.6l-32.5-18.7zM216 288a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M224 160l64 0 0 37.5c11.2 4 21.5 10 30.4 17.6l32.5-18.7 32 55.4-32.5 18.7c1 5.7 1.6 11.6 1.6 17.6s-.6 11.9-1.6 17.5l32.5 18.7-32 55.4L318.4 361c-8.9 7.6-19.2 13.6-30.4 17.6l0 37.5-64 0 0-37.5c-11.2-4-21.5-10-30.4-17.6l-32.5 18.7-32-55.4 32.5-18.7c-1.1-5.7-1.6-11.6-1.6-17.5s.5-11.9 1.6-17.6l-32.5-18.7 32-55.4L193.6 215c8.9-7.6 19.1-13.6 30.4-17.6l0-37.5zm32 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z']
      
    ]
  };

  
    var faFolderCog = faFolderGear;
  

  
  

  var faFolderMedical = {
    prefix: 'fasds',
    iconName: 'folder-medical',
    icon: [
      512,
      512,
      [],
      'e18c',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM160 256l64 0 0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64z','M288 192l-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64z']
      
    ]
  };

  

  
  

  var faCameraWebSlash = {
    prefix: 'fasds',
    iconName: 'camera-web-slash',
    icon: [
      640,
      512,
      ["webcam-slash"],
      'f833',
      
      ['M96 224c0 81 43 152 107.5 191.4L128 472l0 40 384 0 0-12.6L359.4 379.1c-12.6 3.2-25.8 4.9-39.4 4.9c-88.4 0-160-71.6-160-160c0-.6 0-1.3 0-1.9l-58.8-46.3C97.8 191.3 96 207.4 96 224zM142.3 87.7l50.6 39.3C222 88.7 268.1 64 320 64c88.4 0 160 71.6 160 160c0 37.5-12.9 71.9-34.4 99.2l50.6 39.3c30-38.1 47.9-86.2 47.9-138.4C544 100.3 443.7 0 320 0C247.6 0 183.2 34.4 142.3 87.7zm52.2 161.6C206.2 307.8 257.9 352 320 352c1.6 0 3.2 0 4.8-.1L194.5 249.2zm23.6-102.7L256 176c14.6-19.4 37.8-32 64-32l0 32c-15.9 0-30 7.7-38.7 19.6l139 107.9C437.6 281.7 448 254.1 448 224c0-70.7-57.3-128-128-128c-41.6 0-78.5 19.8-101.9 50.5z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faWebcamSlash = faCameraWebSlash;
  

  
  

  var faSaxophoneFire = {
    prefix: 'fasds',
    iconName: 'saxophone-fire',
    icon: [
      640,
      512,
      ["sax-hot"],
      'f8db',
      
      ['M0 208l0 48 16.9 0L4.4 309.4C1.5 321.8 0 334.4 0 347.1l0 3.1C0 439.6 72.4 512 161.8 512c49.4 0 96.1-22.6 126.8-61.4L544 128l96 0 0-32L592 64l-80 0-63 63c-11.3 11.3-22.6 22.6-33.9 33.9c-4.7 4.7-9.4 9.4-14.1 14.1c-11.3 11.3-22.6 22.6-33.9 33.9c-4.7 4.7-9.4 9.4-14.1 14.1c-11.3 11.3-22.6 22.6-33.9 33.9c-39.7 39.7-79.3 79.3-119 119l-32-32 50.9-88 13.1 0 24 0 0-48-24 0L24 208 0 208zM112 368a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32-88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M0 153.6C0 81.9 68.3 21.3 102.4 0l51.2 51.2 25.6-25.6c61.4 51.2 76.8 106.7 76.8 128c0 7.6-.7 15.1-2 22.4l-77.6 0c-10.6-32.3-48.4-60.7-48.4-60.7s-37.8 28.3-48.4 60.7L2 176c-1.3-7.3-2-14.8-2-22.4zM353 223L319 257l-8-8-17-17L328 198.1l17 17 8 8zm48-48L367 209l-8-8-17-17L376 150.1l17 17 8 8zm48-48L415 161l-8-8-17-17L424 102.1l17 17 8 8zM120 256a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM88 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  
    var faSaxHot = faSaxophoneFire;
  

  
  

  var faFileArrowDown = {
    prefix: 'fasds',
    iconName: 'file-arrow-down',
    icon: [
      384,
      512,
      ["file-download"],
      'f56d',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM86.1 320c5.7 5.7 11.3 11.3 17 17c24 24 48 48 72 72c5.7 5.7 11.3 11.3 17 17c5.7-5.7 11.3-11.3 17-17c24-24 48-48 72-72c5.7-5.7 11.3-11.3 17-17c-11.3-11.3-22.6-22.6-33.9-33.9c-5.7 5.7-11.3 11.3-17 17l-31 31c0-34 0-68 0-102.1c0-8 0-16 0-24l-48 0c0 8 0 16 0 24c0 34 0 68 0 102.1l-31-31-17-17c-11.3 11.3-22.6 22.6-33.9 33.9z','M384 160L224 0l0 160 160 0zM216 232l0-24-48 0 0 24 0 102.1-31-31-17-17L86.1 320l17 17 72 72 17 17 17-17 72-72 17-17L264 286.1l-17 17-31 31L216 232z']
      
    ]
  };

  
    var faFileDownload = faFileArrowDown;
  

  
  

  var faCompactDisc = {
    prefix: 'fasds',
    iconName: 'compact-disc',
    icon: [
      512,
      512,
      [128191,128192,128440],
      'f51f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm64 0C64 150 150 64 256 64l0 32C167.6 96 96 167.6 96 256l-32 0zm288 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z','M256 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96 32a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z']
      
    ]
  };

  

  
  

  var faToiletPortable = {
    prefix: 'fasds',
    iconName: 'toilet-portable',
    icon: [
      320,
      512,
      [],
      'e583',
      
      ['M0 64l24 0 272 0 24 0 0 24 0 400 0 24-48 0 0-24 0-8L48 480l0 8 0 24L0 512l0-24L0 88 0 64zM224 224l0 16 0 64 0 16 32 0 0-16 0-64 0-16-32 0z','M320 0L0 0 0 64l320 0 0-64zM256 240l0-16-32 0 0 16 0 64 0 16 32 0 0-16 0-64z']
      
    ]
  };

  

  
  

  var faBrakeWarning = {
    prefix: 'fasds',
    iconName: 'brake-warning',
    icon: [
      640,
      512,
      [],
      'e0c7',
      
      ['M96 256a224 224 0 1 0 448 0A224 224 0 1 0 96 256zM296 128c16 0 32 0 48 0l0 24 0 112 0 24c-16 0-32 0-48 0l0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M91.1 109l13-20.2-40.4-26L50.7 83C18.6 132.9 0 192.3 0 256s18.6 123.1 50.7 173l13 20.2 40.4-26L91.1 403C63.8 360.6 48 310.2 48 256s15.8-104.6 43.1-147zM589.3 83l-13-20.2-40.4 26 13 20.2c27.3 42.4 43.1 92.8 43.1 147s-15.8 104.6-43.1 147l-13 20.2 40.4 26 13-20.2C621.4 379.1 640 319.7 640 256s-18.6-123.1-50.7-173zM344 128l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM296 320l0 48 48 0 0-48-48 0z']
      
    ]
  };

  

  
  

  var faCircleHalf = {
    prefix: 'fasds',
    iconName: 'circle-half',
    icon: [
      512,
      512,
      [],
      'e110',
      
      ['M256 0C397.4 0 512 114.6 512 256s-114.6 256-256 256L256 0z','M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512L256 0z']
      
    ]
  };

  

  
  

  var faWindsock = {
    prefix: 'fasds',
    iconName: 'windsock',
    icon: [
      512,
      512,
      [],
      'f777',
      
      ['M64 96l0 48 64 0 0 128-64 0 0 48 64 0 0 48 80-16.7 0-286.7c-26.7-5.6-53.3-11.1-80-16.7l0 48L64 96zM272 78l0 260c32-6.7 64-13.3 96-20l0-220c-32-6.7-64-13.3-96-20zm160 33.3l0 193.3c26.7-5.6 53.3-11.1 80-16.7l0-160c-26.7-5.6-53.3-11.1-80-16.7z','M64 32L64 0 0 0 0 32 0 480l0 32 64 0 0-32L64 32zM208 64.7l0 286.7L272 338l0-260L208 64.7zM368 318l64-13.3 0-193.3L368 98l0 220z']
      
    ]
  };

  

  
  

  var faMound = {
    prefix: 'fasds',
    iconName: 'mound',
    icon: [
      576,
      512,
      [],
      'e52d',
      
      ['M142.6 178.3C173.3 127.2 228.4 96 288 96s114.7 31.2 145.4 82.3L576 416H0L142.6 178.3z','']
      
    ]
  };

  

  
  

  var faPeoplePants = {
    prefix: 'fasds',
    iconName: 'people-pants',
    icon: [
      640,
      512,
      [],
      'e219',
      
      ['M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm320 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zm320 0l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-33.8-53L552 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53-53.9-34.4 81.7-128 9.4-14.8z']
      
    ]
  };

  

  
  

  var faGridRound2Plus = {
    prefix: 'fasds',
    iconName: 'grid-round-2-plus',
    icon: [
      512,
      512,
      [],
      'e5dc',
      
      ['M224 128A96 96 0 1 1 32 128a96 96 0 1 1 192 0zm0 256A96 96 0 1 1 32 384a96 96 0 1 1 192 0zM480 128a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z','M408 296c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64z']
      
    ]
  };

  

  
  

  var faHurricane = {
    prefix: 'fasds',
    iconName: 'hurricane',
    icon: [
      384,
      512,
      [],
      'f751',
      
      ['M0 208C0 317.5 84.6 407.2 192 415.4l0 95.4c107.4-8.2 192-97.9 192-207.4S299.4 104.2 192 96L192 .6C84.6 8.8 0 98.5 0 208zm288 48A96 96 0 1 1 96 256a96 96 0 1 1 192 0z','M192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faUpload = {
    prefix: 'fasds',
    iconName: 'upload',
    icon: [
      512,
      512,
      [],
      'f093',
      
      ['M0 352L0 512l512 0 0-160-224 0 0 32 0 32-64 0 0-32 0-32L0 352zm456 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M288 416l0-32 0-258.7 65.4 65.4L376 213.3 421.3 168l-22.6-22.6-120-120L256 2.7 233.4 25.4l-120 120L90.7 168 136 213.3l22.6-22.6L224 125.3 224 384l0 32 64 0z']
      
    ]
  };

  

  
  

  var faUpFromLine = {
    prefix: 'fasds',
    iconName: 'up-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-bottom"],
      'f346',
      
      ['M0 416l32 0 320 0 32 0 0 64-32 0L32 480 0 480l0-64z','M192 32L32 192l0 32 96 0 0 160 128 0 0-160 96 0 0-32L192 32z']
      
    ]
  };

  
    var faArrowAltFromBottom = faUpFromLine;
  

  
  

  var faMoneyCheckDollarPen = {
    prefix: 'fasds',
    iconName: 'money-check-dollar-pen',
    icon: [
      640,
      512,
      ["money-check-edit-alt"],
      'f873',
      
      ['M0 64l576 0 0 108.4c-3.9 3.9-7.7 7.7-11.6 11.6L331 417.4 326.6 448 0 448 0 64zM70.7 328.7l19 6.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3 0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38zM256 192l0 32 192 0 0-32-192 0zm0 96l0 32 96 0 0-32-96 0z','M640 294.8l-71-71-41.3 41.3 71 71L640 294.8zm-63.9 63.9l-71-71L363.9 429 352 511.9 434.9 500 576.1 358.7z']
      
    ]
  };

  
    var faMoneyCheckEditAlt = faMoneyCheckDollarPen;
  

  
  

  var faCodeMerge = {
    prefix: 'fasds',
    iconName: 'code-merge',
    icon: [
      448,
      512,
      [],
      'f387',
      
      ['M48 160l8 0 48 0 9.3 0c7.6 45.4 47.1 80 94.7 80l80 0 0 8 0 48 0 8-80 0c-36 0-69.3-11.9-96-32l0 80-8 0-48 0-8 0 0-192z','M104 56l0 48-48 0 0-48 48 0zM56 0L0 0 0 56l0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56L104 0 56 0zm48 408l0 48-48 0 0-48 48 0zM56 352L0 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0zM344 248l48 0 0 48-48 0 0-48zm-56-56l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0z']
      
    ]
  };

  

  
  

  var faStop = {
    prefix: 'fasds',
    iconName: 'stop',
    icon: [
      384,
      512,
      [9209],
      'f04d',
      
      ['M0 64H384V448H0V64z','']
      
    ]
  };

  

  
  

  var faUpLong = {
    prefix: 'fasds',
    iconName: 'up-long',
    icon: [
      320,
      512,
      ["long-arrow-alt-up"],
      'f30c',
      
      ['M96 192l128 0 0 320L96 512c0-64 0-128 0-192c0-42.7 0-85.3 0-128z','M320 160L160 0 0 160l0 32s0 0 0 0l96 0 128 0 96 0 0-32z']
      
    ]
  };

  
    var faLongArrowAltUp = faUpLong;
  

  
  

  var faBlockQuote = {
    prefix: 'fasds',
    iconName: 'block-quote',
    icon: [
      448,
      512,
      [],
      'e0b5',
      
      ['M0 64l448 0 0 64L0 128 0 64zM128 224l320 0 0 64-320 0 0-64zm0 160l320 0 0 64-320 0 0-64z','M0 224H64V448H0V224z']
      
    ]
  };

  

  
  

  var faTruckPickup = {
    prefix: 'fasds',
    iconName: 'truck-pickup',
    icon: [
      640,
      512,
      [128763],
      'f63c',
      
      ['M80 400a80 80 0 1 0 160 0A80 80 0 1 0 80 400zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M224 32l32 0 128 0 15.4 0L409 44 527.4 192l80.6 0 0 96 32 0 0 64-32 0-26.8 0c-18-37.8-56.5-64-101.2-64s-83.2 26.2-101.2 64l-117.6 0c-18-37.8-56.5-64-101.2-64s-83.2 26.2-101.2 64L32 352 0 352l0-64 32 0 0-96 192 0 0-128 0-32zM368.6 96L288 96l0 96 157.4 0L368.6 96z']
      
    ]
  };

  

  
  

  var faTowerBroadcast = {
    prefix: 'fasds',
    iconName: 'tower-broadcast',
    icon: [
      576,
      512,
      ["broadcast-tower"],
      'f519',
      
      ['M0 128c0 45.8 10.7 89.1 29.7 127.5l57.4-28.3C72.3 197.3 64 163.6 64 128s8.3-69.3 23.1-99.2L29.7 .5C10.7 38.9 0 82.2 0 128zm102.5 49.7c3.3 12.4 7.8 24.2 13.3 35.3l57.4-28.3c-3.6-7.4-6.6-15.3-8.8-23.6c-8.4-31.3-4.4-62.9 8.9-89.8L115.8 43C95.9 83.3 90 130.8 102.5 177.7zM402.8 71.3c3.6 7.4 6.6 15.3 8.8 23.6c8.4 31.3 4.4 62.9-8.9 89.8L460.2 213c19.9-40.3 25.9-87.8 13.3-134.7c-3.3-12.4-7.8-24.2-13.3-35.3L402.8 71.3zm86.1-42.5C503.7 58.7 512 92.4 512 128s-8.3 69.3-23.1 99.2l57.4 28.3c19-38.4 29.7-81.7 29.7-127.5s-10.7-89.1-29.7-127.5L488.9 28.8z','M320 183.4c19.1-11.1 32-31.7 32-55.4c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.7 12.9 44.4 32 55.4L256 480l0 32 64 0 0-32 0-296.6z']
      
    ]
  };

  
    var faBroadcastTower = faTowerBroadcast;
  

  
  

  var faLoveseat = {
    prefix: 'fasds',
    iconName: 'loveseat',
    icon: [
      512,
      512,
      ["couch-small"],
      'f4cc',
      
      ['M64 32l0 192 32 0 0 128 320 0 0-128 32 0 0-192L64 32z','M96 224L0 224 0 480l96 0 0-32 320 0 0 32 96 0 0-256-96 0 0 128L96 352l0-128z']
      
    ]
  };

  
    var faCouchSmall = faLoveseat;
  

  
  

  var faPeopleDress = {
    prefix: 'fasds',
    iconName: 'people-dress',
    icon: [
      640,
      512,
      [],
      'e217',
      
      ['M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm320 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-42-65.8L272 384l-40 0 0 96 0 32-64 0 0-32 0-96-16 0 0 96 0 32-64 0 0-32 0-96-40 0L96.2 239.4l-42 65.8L.2 270.8 82 142.8 91.4 128zm320 0l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-42-65.8L592 384l-40 0 0 96 0 32-64 0 0-32 0-96-16 0 0 96 0 32-64 0 0-32 0-96-40 0 48.2-144.6-42 65.8-53.9-34.4 81.7-128 9.4-14.8z']
      
    ]
  };

  

  
  

  var faHandHoldingSkull = {
    prefix: 'fasds',
    iconName: 'hand-holding-skull',
    icon: [
      576,
      512,
      [],
      'e1a4',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M359.8 239C403 216.9 432 175.4 432 128C432 57.3 367.5 0 288 0S144 57.3 144 128c0 47.4 29 88.9 72.2 111L208 288l160 0-8.2-49zM208 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faBanana = {
    prefix: 'fasds',
    iconName: 'banana',
    icon: [
      576,
      512,
      [],
      'e2e5',
      
      ['M263.3 282.5c20.3 12 40.6 24 60.9 36.1c38.4-8.1 76.8-16.2 115.1-24.2c5.7-22.5 8.7-46.1 8.7-70.3c0-84.7-36.6-160.9-94.8-213.6L288.1 55c10.3 27.7 15.9 57.7 15.9 89c0 51-14.9 98.6-40.7 138.5z','M467.1 288.5l12.7-2.7 .9-.2 9.3 10.4 64 72L569.9 386 534 417.9l-15.9-17.9-54.7-61.6-43 9.1C374.1 444.7 274.9 512 160 512L0 512 0 400l48 0c72.9 0 138.7-30.5 185.4-79.4l-22.1-13.1-80.2 41.8-21.3 11.1L87.6 317.8l21.3-11.1 92-48 11.8-6.2 11.5 6.8 39.1 23.2 60.9 36.1 115.1-24.2 27.7-5.8z']
      
    ]
  };

  

  
  

  var faHouseTurret = {
    prefix: 'fasds',
    iconName: 'house-turret',
    icon: [
      640,
      512,
      [],
      'e1b4',
      
      ['M0 0L96 0l0 96 32 0 0-96 96 0 0 96 32 0 0-96 96 0 0 96 0 32 0 6.3L235.5 231.4 224 241l0 15 0 256L64 512l0-224L0 224l0-96L0 96 0 0zM136 168l0 40 80 0 0-40c0-22.1-17.9-40-40-40s-40 17.9-40 40z','M256 512l0-256L448 96 640 256l0 256-384 0zM496 368l0-96-96 0 0 96 96 0z']
      
    ]
  };

  

  
  

  var faChartScatterBubble = {
    prefix: 'fasds',
    iconName: 'chart-scatter-bubble',
    icon: [
      512,
      512,
      [],
      'e0e9',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M384 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-96-16a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 176a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-176 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z']
      
    ]
  };

  

  
  

  var faCircleVideo = {
    prefix: 'fasds',
    iconName: 'circle-video',
    icon: [
      512,
      512,
      ["video-circle"],
      'e12b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-96l192 0 0 192-192 0 0-192zm224 64l64-48 0 160-64-48 0-64z','M320 160l-192 0 0 192 192 0 0-192zm32 128l64 48 0-160-64 48 0 64z']
      
    ]
  };

  
    var faVideoCircle = faCircleVideo;
  

  
  

  var faGameBoardSimple = {
    prefix: 'fasds',
    iconName: 'game-board-simple',
    icon: [
      448,
      512,
      ["game-board-alt"],
      'f868',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 96l160 0 160 0 0 160 0 160-160 0L64 416l0-160L64 96z','M64 96l0 160H224V96H64zM224 256V416H384l0-160H224z']
      
    ]
  };

  
    var faGameBoardAlt = faGameBoardSimple;
  

  
  

  var faSkull = {
    prefix: 'fasds',
    iconName: 'skull',
    icon: [
      512,
      512,
      [128128],
      'f54c',
      
      ['M0 224c0 70.7 37.5 133.8 96 174.9L96 512l96 0 0-48 0-16 32 0 0 16 0 48 64 0 0-48 0-16 32 0 0 16 0 48 96 0 0-113.1c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224zm224 32A64 64 0 1 1 96 256a64 64 0 1 1 128 0zm192 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M160 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm192 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faTimelineArrow = {
    prefix: 'fasds',
    iconName: 'timeline-arrow',
    icon: [
      640,
      512,
      [],
      'e29d',
      
      ['M0 224l0 64 32 0 160 0 0 48 8 0 48 0 8 0 0-48 258.7 0-33.4 33.4L458.7 344 504 389.3l22.6-22.6 88-88L637.3 256l-22.6-22.6-88-88L504 122.7 458.7 168l22.6 22.6L514.7 224 384 224l0-48-8 0-48 0-8 0 0 48-160 0 0-48-8 0-48 0-8 0 0 48-64 0L0 224z','M152 72l0 48-48 0 0-48 48 0zM104 16L48 16l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0zM376 72l0 48-48 0 0-48 48 0zM328 16l-56 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0zM200 392l48 0 0 48-48 0 0-48zm-56-56l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0z']
      
    ]
  };

  

  
  

  var faBowlRice = {
    prefix: 'fasds',
    iconName: 'bowl-rice',
    icon: [
      512,
      512,
      [],
      'e2eb',
      
      ['M32 176l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm48-72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm48 72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zM176 32l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm0 72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm48 72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zM272 32l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm0 72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm48 72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm48-72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48zm48 72l24 0 16 0 24 0 0 48-24 0-16 0-24 0 0-48z','M512 256L0 256l0 24c0 67 39.2 124.9 96 151.8L96 480l320 0 0-48.2c56.8-27 96-84.8 96-151.8l0-24z']
      
    ]
  };

  

  
  

  var faMillSign = {
    prefix: 'fasds',
    iconName: 'mill-sign',
    icon: [
      384,
      512,
      [],
      'e1ed',
      
      ['M81.9 469.2l60.3 21.5 17.9-50 0-24.7 0-165.5L81.9 469.2zM208 116.1C226.1 103.4 248.2 96 272 96c2 0 3.8 .1 5.6 .1s3.5 .2 5.3 .4c6.4-17.9 12.8-35.8 19.2-53.8L241.9 21.2 208 116.1zM224 208l0 53.5 35.7-100C239.1 167 224 185.7 224 208z','M112 160c-26.5 0-48 21.5-48 48l0 208 0 32L0 448l0-32L0 208 0 96l64 0 0 10.8C78.5 99.9 94.8 96 112 96c31.3 0 59.7 12.9 80 33.6C212.3 108.9 240.7 96 272 96c61.9 0 112 50.1 112 112l0 208 0 32-64 0 0-32 0-208c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 208 0 32-64 0 0-32 0-208c0-26.5-21.5-48-48-48z']
      
    ]
  };

  

  
  

  var faBalloons = {
    prefix: 'fasds',
    iconName: 'balloons',
    icon: [
      640,
      512,
      [],
      'e2e4',
      
      ['M324.7 261.9C340.5 231.6 352 197 352 160c0-9.9-.7-19.6-2.2-29c29-40.5 76.5-67 130.2-67c88.4 0 160 71.6 160 160c0 112-128 208-128 208l32 80-128 0 32-80s-100.3-75.2-123.3-170.1zM384 224l32 0c0-35.3 28.7-64 64-64l0-32c-53 0-96 43-96 96z','M160 0c88.4 0 160 71.6 160 160c0 112-128 208-128 208l32 80L96 448l32-80s-128-96-128-208C0 71.6 71.6 0 160 0zM96 160c0-35.3 28.7-64 64-64l0-32c-53 0-96 43-96 96l32 0z']
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleDollar = {
    prefix: 'fasds',
    iconName: 'chart-pie-simple-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e605',
      
      ['M0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368c0-28.8 6.9-56 19.2-80L224 288l0-255.5C98.9 40.8 0 144.8 0 272zM272 .6L272 240l103.2 0c31.5-29.8 74-48 120.8-48c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-5.4 0-10.7 .2-16 .6z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z']
      
    ]
  };

  

  
  

  var faArrowUpWideShort = {
    prefix: 'fasds',
    iconName: 'arrow-up-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-up"],
      'f161',
      
      ['M288 32l0 64 32 0 224 0 32 0 0-64-32 0L320 32l-32 0zm0 128l0 64 32 0 160 0 32 0 0-64-32 0-160 0-32 0zm0 128l0 64 32 0 96 0 32 0 0-64-32 0-96 0-32 0zm0 128l0 64 32 0 32 0 32 0 0-64-32 0-32 0-32 0z','M128 32.4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L160 162.8 160 448l0 32-64 0 0-32 0-285.2L71.7 189.5 50.2 213.2 2.8 170.2l21.5-23.7 80-88 23.7-26z']
      
    ]
  };

  
    var faSortAmountUp = faArrowUpWideShort;
  

  
  

  var faUtensils = {
    prefix: 'fasds',
    iconName: 'utensils',
    icon: [
      448,
      512,
      [61685,127860,"cutlery"],
      'f2e7',
      
      ['M0 160c0 47.6 34.6 87.1 80 94.7c5.2 .9 10.5 1.3 16 1.3l32 0c5.5 0 10.8-.5 16-1.3c45.4-7.6 80-47.1 80-94.7L192 0 160 0l0 160-16 0L128 0 96 0 80 160l-16 0L64 0 32 0 0 160zm288 16l0 176 96 0 64 0L448 0C416 0 288 32 288 176z','M96 256c-5.5 0-10.8-.5-16-1.3L80 272l0 208 0 32 64 0 0-32 0-208 0-17.3c-5.2 .9-10.5 1.3-16 1.3l-32 0zM448 384l0-32-64 0 0 32 0 96 0 32 64 0 0-32 0-96z']
      
    ]
  };

  
    var faCutlery = faUtensils;
  

  
  

  var faRotateRight = {
    prefix: 'fasds',
    iconName: 'rotate-right',
    icon: [
      512,
      512,
      ["redo-alt","rotate-forward"],
      'f2f9',
      
      ['M32 256c0 57.3 21.9 114.7 65.6 158.4c87.5 87.5 229.3 87.5 316.8 0l-45.3-45.3c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0c15.1-15.1 30.2-30.2 45.3-45.3c-87.5-87.5-229.3-87.5-316.8 0C53.9 141.3 32 198.7 32 256z','M336 224l-24-24L472 40l24 24 0 160H336z']
      
    ]
  };

  
    var faRedoAlt = faRotateRight;
  
    var faRotateForward = faRotateRight;
  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fasds',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      ['M2.7 384l22.6-22.6 80-80L128 258.7 173.3 304l-22.6 22.6L125.3 352 416 352l32 0 0 64-32 0-290.7 0 25.4 25.4L173.3 464 128 509.3l-22.6-22.6-80-80L2.7 384z','M445.3 128l-22.6 22.6-80 80L320 253.3 274.7 208l22.6-22.6L322.7 160 32 160 0 160 0 96l32 0 290.7 0L297.4 70.6 274.7 48 320 2.7l22.6 22.6 80 80L445.3 128z']
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faGolfClub = {
    prefix: 'fasds',
    iconName: 'golf-club',
    icon: [
      512,
      512,
      [],
      'f451',
      
      ['M0 304l0 72 48 0 16 0 0 32-16 0L0 408l0 32 48 0 16 0 0 32-16 0L0 472l0 40 224 0 32 0 19.8 0 8.8-17.7 224-448L451.4 17.7 264 392.5l0-.5L0 304z','M0 408l0-32 48 0 16 0 0 32-16 0L0 408zm0 64l0-32 48 0 16 0 0 32-16 0L0 472z']
      
    ]
  };

  

  
  

  var faCastle = {
    prefix: 'fasds',
    iconName: 'castle',
    icon: [
      640,
      512,
      [],
      'e0de',
      
      ['M128 0l64 0 0 64 48 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 48 0 0-64 64 0 0 112 0 64 0 48-48 0-16 0-256 0-16 0-48 0 0-48 0-64L128 0z','M0 160l64 0 0 64 512 0 0-64 64 0 0 64 0 64 0 224-256 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128L0 512 0 288l0-64 0-64z']
      
    ]
  };

  

  
  

  var faKiwiBird = {
    prefix: 'fasds',
    iconName: 'kiwi-bird',
    icon: [
      576,
      512,
      [],
      'f535',
      
      ['M96 390.3c14.9 8.6 31 15.3 48 19.6l0 46 0 24-48 0 0-24 0-65.7zm112 25c16.7-1.4 32.8-4.9 48-10.3l0 50.9 0 24-48 0 0-24 0-40.7zM464 352l112 0 0 128L464 352z','M192 416c56.9 0 108-24.7 143.1-64L576 352l0-128c0-70.7-57.3-128-128-128L335.1 96C300 56.7 248.9 32 192 32C86 32 0 118 0 224S86 416 192 416zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faBlanketFire = {
    prefix: 'fasds',
    iconName: 'blanket-fire',
    icon: [
      640,
      512,
      [],
      'e3da',
      
      ['M0 0L0 32 0 192l0 32 0 96 0 96 0 32 32 0 281.8 0c-11.3-19.4-19.2-41-23.1-64L64 384l0-64 0-64 249.9 0c8.6-15.9 18.6-30.6 29.1-43.7c29.2-36.6 64-64.6 88.1-79.6l17-10.6L448 32l0-32L416 0 32 0 0 0zM96 288l0 64 32 0 160 0c0-22.7 4.4-44.1 11.5-64L128 288l-32 0z','M320 352c0-89.6 85.3-165.3 128-192l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160zM480 464.2c35.3 0 64-28.7 64-64c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faButter = {
    prefix: 'fasds',
    iconName: 'butter',
    icon: [
      640,
      512,
      [129480],
      'e3e4',
      
      ['M64 64l0 256 384 0 0-256L64 64zm416 0l0 256 96 0 0-256-96 0z','M32 320L0 320l0 64 32 0 0 64 576 0 0-64 32 0 0-64-32 0L32 320z']
      
    ]
  };

  

  
  

  var faHelmetBattle = {
    prefix: 'fasds',
    iconName: 'helmet-battle',
    icon: [
      576,
      512,
      [],
      'f6eb',
      
      ['M0 224l0 32 64 0L64 0 0 224zM512 0l0 256 64 0 0-32L512 0z','M96 224c0 80-32 192-32 192l192 96V256l-96-32V192H416v32l-96 32V512l192-96s-32-112-32-192C480 80 288 0 288 0S96 80 96 224z']
      
    ]
  };

  

  
  

  var faCircleA = {
    prefix: 'fasds',
    iconName: 'circle-a',
    icon: [
      512,
      512,
      [],
      'e0f7',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM120.6 368c37.9-80.7 75.8-161.5 113.6-242.2c2.2-4.6 4.3-9.2 6.5-13.8l30.5 0c2.2 4.6 4.3 9.2 6.5 13.8c37.9 80.7 75.8 161.4 113.6 242.2l-53 0-22.5-48-119.7 0-22.5 48-53 0zm98.1-96l74.6 0c-12.4-26.5-24.9-53-37.3-79.5c-12.4 26.5-24.9 53-37.3 79.5z','M271.2 112l-30.5 0-6.5 13.8L120.6 368l53 0 22.5-48 119.7 0 22.5 48 53 0L277.7 125.8 271.2 112zm22.1 160l-74.6 0L256 192.5 293.3 272z']
      
    ]
  };

  

  
  

  var faDiceOne = {
    prefix: 'fasds',
    iconName: 'dice-one',
    icon: [
      448,
      512,
      [9856],
      'f525',
      
      ['M0 32L0 480l448 0 0-448L0 32zM256 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M192 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z']
      
    ]
  };

  

  
  

  var faPotato = {
    prefix: 'fasds',
    iconName: 'potato',
    icon: [
      512,
      512,
      [129364],
      'e440',
      
      ['M0 364.9C0 446.2 65.8 512 147.1 512c39 0 76.4-15.5 104-43.1L272 448l112-48 80-144 4.9-4.9c27.6-27.6 43.1-65 43.1-104C512 65.8 446.2 0 364.9 0c-39 0-76.4 15.5-104 43.1L224 80l-80 48L96 208 43.1 260.9C15.5 288.5 0 325.9 0 364.9zM136 392l48 0 0 48-48 0 0-48zm32-192l48 0 0 48-48 0 0-48zm192-32l48 0 0 48-48 0 0-48z','M360 168l48 0 0 48-48 0 0-48zM168 200l48 0 0 48-48 0 0-48zm16 192l0 48-48 0 0-48 48 0z']
      
    ]
  };

  

  
  

  var faFileMedical = {
    prefix: 'fasds',
    iconName: 'file-medical',
    icon: [
      384,
      512,
      [],
      'f477',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM96 288l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0z','M384 160l-160 0L224 0 384 160zM160 224l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faPipe = {
    prefix: 'fasds',
    iconName: 'pipe',
    icon: [
      64,
      512,
      [],
      '7c',
      
      ['M64 0l0 32 0 448 0 32L0 512l0-32L0 32 0 0 64 0z','']
      
    ]
  };

  

  
  

  var faMoonOverSun = {
    prefix: 'fasds',
    iconName: 'moon-over-sun',
    icon: [
      512,
      512,
      ["eclipse-alt"],
      'f74a',
      
      ['M0 150L73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l23.3-126.7L512 362 438.9 256 512 150 385.3 126.7 362 0 256 73.1 150 0 126.7 126.7 0 150zM400 256a144 144 0 1 1 -288 0 144 144 0 1 1 288 0z','M348.9 318.6c-7.6 2-15.6 3.1-23.9 3.1c-50.5 0-91.4-40.5-91.4-90.5c0-36.9 22.3-68.6 54.2-82.7c-10.1-3-20.8-4.6-31.8-4.6c-61.9 0-112 50.1-112 112s50.1 112 112 112c38.7 0 72.8-19.6 92.9-49.4z']
      
    ]
  };

  
    var faEclipseAlt = faMoonOverSun;
  

  
  

  var faSeatAirline = {
    prefix: 'fasds',
    iconName: 'seat-airline',
    icon: [
      448,
      512,
      [],
      'e244',
      
      ['M80.5 192L320 192l32 0 0 64-32 0-212 0c-9.1-21.3-18.3-42.7-27.4-64zM96 464l24 0 96 0 0-48 48 0 0 48 96 0 24 0 0 48-24 0-240 0-24 0 0-48z','M64 0l0 32 0 121.4L121.7 288 400 288l46.2 0L430 331.2l-24 64L398.2 416 376 416l-248 0-21.1 0-8.3-19.4-96-224-2.6-6L0 160 0 32 0 0 64 0z']
      
    ]
  };

  

  
  

  var faB = {
    prefix: 'fasds',
    iconName: 'b',
    icon: [
      320,
      512,
      [98],
      '42',
      
      ['M32 32L0 32 0 64 0 224l0 32 0 32L0 448l0 32 32 0 160 0c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128L32 32zM160 224l-96 0L64 96l96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288l96 0 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64L64 416l0-128z','']
      
    ]
  };

  

  
  

  var faSquareDownRight = {
    prefix: 'fasds',
    iconName: 'square-down-right',
    icon: [
      448,
      512,
      [],
      'e26c',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 200l56-56 76 76 52-52 24 24 0 160-160 0-24-24 52-52-76-76z','M296 168l24 24 0 160-160 0-24-24 52-52-76-76 56-56 76 76 52-52z']
      
    ]
  };

  

  
  

  var faLaptopMedical = {
    prefix: 'fasds',
    iconName: 'laptop-medical',
    icon: [
      640,
      512,
      [],
      'f812',
      
      ['M0 384l0 48 48 48 544 0 48-48 0-48L0 384zM64 32l0 32 0 288 64 0 0-256 384 0 0 256 64 0 0-288 0-32-32 0L96 32 64 32z','M512 96L128 96l0 256 384 0 0-256zM288 128l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faFlyingDisc = {
    prefix: 'fasds',
    iconName: 'flying-disc',
    icon: [
      448,
      512,
      [],
      'e3a9',
      
      ['M45.9 345c7.6 7.6 18.4 11.2 31.6 11.2c40.2 0 102-33.5 157.6-89.1C308.9 193.4 343.8 108.7 313 77.9s-115.4 4.1-189.2 77.9S15.2 314.3 45.9 345z','M424.3 55.7c55.3 55.3 10.5 189.8-100.2 300.5S79 511.6 23.7 456.3C-1.5 431.1-5.9 389.6 7.1 341.4c3.2 9.5 8.4 18.5 16.2 26.3c15.6 15.6 36 20.7 55 20.5c18.9-.1 38.8-5.3 58.2-13.3c39-16.1 82-46 121.2-85.1s69-82.2 85.1-121.2c8-19.4 13.2-39.4 13.3-58.2c.1-19-5-39.5-20.5-55c-7.8-7.8-16.8-13-26.3-16.2c48.2-13 89.8-8.6 114.9 16.6z']
      
    ]
  };

  

  
  

  var faCalendarWeek = {
    prefix: 'fasds',
    iconName: 'calendar-week',
    icon: [
      448,
      512,
      [],
      'f784',
      
      ['M0 192L0 512l448 0 0-320L0 192zm64 64l320 0 0 96L64 352l0-96z','M96 0l64 0 0 64 128 0 0-64 64 0 0 64 96 0 0 128L0 192 0 64l96 0L96 0z']
      
    ]
  };

  

  
  

  var faCarCircleBolt = {
    prefix: 'fasds',
    iconName: 'car-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e342',
      
      ['M0 192L0 400l0 80 96 0 0-80 226.9 0c-1.9-10.4-2.9-21.1-2.9-32c0-97.2 78.8-176 176-176l-25.3 0L422.2 53.4 414.7 32 392 32 120 32 97.3 32 89.8 53.4 41.3 192 0 192zm128 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-18.9-96l33.6-96 226.6 0 33.6 96-293.8 0zM496 192c5.4 0 10.7 .2 16 .7l0-.7-16 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm64 16l66.7 0L472 448l104-96-66.7 0L520 288 416 384z']
      
    ]
  };

  

  
  

  var faVectorCircle = {
    prefix: 'fasds',
    iconName: 'vector-circle',
    icon: [
      512,
      512,
      [],
      'e2c6',
      
      ['M41.3 192C62.8 119.8 119.8 62.8 192 41.3c0 2.2 0 4.5 0 6.7l0 32 0 29.3c-36.9 16.1-66.6 45.8-82.7 82.7L80 192l-32 0-6.7 0zm0 128l6.7 0 32 0 16 0 13.3 0c16.1 36.9 45.8 66.6 82.7 82.7l0 29.3 0 32 0 6.7C119.8 449.2 62.8 392.2 41.3 320zM320 41.3C392.2 62.8 449.2 119.8 470.7 192c-2.2 0-4.5 0-6.7 0l-32 0-29.3 0c-16.1-36.9-45.8-66.6-82.7-82.7L320 96l0-16 0-32 0-6.7zm0 361.4c36.9-16.1 66.6-45.8 82.7-82.7l13.3 0 16 0 32 0 6.7 0C449.2 392.2 392.2 449.2 320 470.7l0-6.7 0-32 0-16 0-13.3z','M240 48l0 32 32 0 0-32-32 0zM192 0l48 0 32 0 48 0 0 48 0 32 0 48-48 0-32 0-48 0 0-48 0-32 0-48zM48 240l0 32 32 0 0-32-32 0zM0 192l48 0 32 0 48 0 0 48 0 32 0 48-48 0-32 0L0 320l0-48 0-32 0-48zM272 432l-32 0 0 32 32 0 0-32zm-32-48l32 0 48 0 0 48 0 32 0 48-48 0-32 0-48 0 0-48 0-32 0-48 48 0zM432 240l0 32 32 0 0-32-32 0zm-48-48l48 0 32 0 48 0 0 48 0 32 0 48-48 0-32 0-48 0 0-48 0-32 0-48z']
      
    ]
  };

  

  
  

  var faHouse = {
    prefix: 'fasds',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      ['M64 272l.1 240L224 512l0-160.3 128 0L352 512l160.6 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.7 64 272z','M0 240L288 0 576 240v32H512L288 88 64 272H0V240z']
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faHeartCircleExclamation = {
    prefix: 'fasds',
    iconName: 'heart-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4fe',
      
      ['M0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480l23.7-23.7c-15.1-26-23.7-56.1-23.7-88.3c0-97.2 78.8-176 176-176c26.4 0 51.4 5.8 73.8 16.2c4-13 6.2-26.6 6.2-40.4C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faCourtSport = {
    prefix: 'fasds',
    iconName: 'court-sport',
    icon: [
      640,
      512,
      [],
      'e643',
      
      ['M0 128l0 32 96 0 0 192L0 352l0 32 96 0 32 0 0-32 0-192 0-32-32 0L0 128zM208 256c0 56.4 41.7 103.1 96 110.9L304 480l32 0 0-113.1c54.3-7.8 96-54.4 96-110.9s-41.7-103.1-96-110.9L336 32l-32 0 0 113.1c-54.3 7.8-96 54.4-96 110.9zm32 0c0-38.7 27.5-71 64-78.4l0 156.8c-36.5-7.4-64-39.7-64-78.4zm96-78.4c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4l0-156.8zM512 128l0 32 0 192 0 32 32 0 96 0 0-32-96 0 0-192 96 0 0-32-96 0-32 0z','M640 480l-304 0 0-113.1c54.3-7.8 96-54.4 96-110.9s-41.7-103.1-96-110.9L336 32l304 0 0 96-96 0-32 0 0 32 0 192 0 32 32 0 96 0 0 96zM304 145.1c-54.3 7.8-96 54.4-96 110.9s41.7 103.1 96 110.9L304 480 0 480l0-96 96 0 32 0 0-32 0-192 0-32-32 0L0 128 0 32l304 0 0 113.1zm0 189.3c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4l0 156.8zm32 0l0-156.8c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4zM544 160l96 0 0 192-96 0 0-192zM96 352L0 352 0 160l96 0 0 192z']
      
    ]
  };

  

  
  

  var faOutdent = {
    prefix: 'fasds',
    iconName: 'outdent',
    icon: [
      448,
      512,
      ["dedent"],
      'f03b',
      
      ['M0 32L0 96l448 0 0-64L0 32zM0 416l0 64 448 0 0-64L0 416zM192 160l0 64 256 0 0-64-256 0zm0 128l0 64 256 0 0-64-256 0z','M0 256l128 96V160L0 256z']
      
    ]
  };

  
    var faDedent = faOutdent;
  

  
  

  var faFaceWorried = {
    prefix: 'fasds',
    iconName: 'face-worried',
    icon: [
      512,
      512,
      [],
      'e3a3',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm89.4-80.8c3.9-3.6 7.8-7.3 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0c0 10.7 0 21.3 0 32l-16 0c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-3.9 3.6-7.8 7.3-11.7 10.9L89.4 175.2zm55.2 93.5c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6zM152 430.6c4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 411.4 294.3 400 255.6 400s-74.5 11.4-103.6 30.6zM304 128l16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9l-16 0c0-10.7 0-21.3 0-32zm.5 140.7c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6z','M192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm-15.6 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 160.9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z']
      
    ]
  };

  

  
  

  var faFaceDotted = {
    prefix: 'fasds',
    iconName: 'face-dotted',
    icon: [
      512,
      512,
      [129765],
      'e47f',
      
      ['M0 256c0-25.1 3.6-49.4 10.4-72.4l59.8 23.9C66.1 223 64 239.3 64 256s2.1 33 6.2 48.5L10.4 328.4C3.6 305.4 0 281.1 0 256zM28.2 139C52.7 91.5 91.5 52.7 139 28.2L163 88C131.5 105.5 105.5 131.5 88 163L28.2 139zm0 233.9L88 349c17.5 31.5 43.5 57.5 74.9 74.9L139 483.8C91.5 459.3 52.7 420.5 28.2 373zM183.6 10.4C206.6 3.6 230.9 0 256 0s49.4 3.6 72.4 10.4L304.5 70.2C289 66.1 272.7 64 256 64s-33 2.1-48.5 6.2L183.6 10.4zm0 491.2l23.9-59.8c15.5 4 31.7 6.2 48.5 6.2s33-2.1 48.5-6.2l23.9 59.8c-23 6.8-47.3 10.4-72.4 10.4s-49.4-3.6-72.4-10.4zM349 88L373 28.2C420.5 52.7 459.3 91.5 483.8 139L424 163C406.5 131.5 380.5 105.5 349 88zm0 336c31.5-17.5 57.5-43.5 74.9-74.9L483.8 373c-24.4 47.5-63.3 86.4-110.8 110.8L349 424zm92.8-216.5l59.8-23.9c6.8 23 10.4 47.3 10.4 72.4s-3.6 49.4-10.4 72.4l-59.8-23.9c4-15.5 6.2-31.7 6.2-48.5s-2.1-33-6.2-48.5z','M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z']
      
    ]
  };

  

  
  

  var faIdCard = {
    prefix: 'fasds',
    iconName: 'id-card',
    icon: [
      576,
      512,
      [62147,"drivers-license"],
      'f2c2',
      
      ['M0 128L0 480l576 0 0-352L0 128zM64 416l32-64 160 0 32 64L64 416zM240 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm112-64l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zm0 64l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zm0 64l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32z','M576 32L0 32l0 96 576 0 0-96zM240 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm16 96L96 352 64 416l224 0-32-64z']
      
    ]
  };

  
    var faDriversLicense = faIdCard;
  

  
  

  var faBookSkull = {
    prefix: 'fasds',
    iconName: 'book-skull',
    icon: [
      448,
      512,
      ["book-dead"],
      'f6b7',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zM320 112c0 20.9-12.6 39.5-32 51.2l0 28.8-96 0 0-28.8c-19.4-11.7-32-30.3-32-51.2c0-35.3 35.8-64 80-64s80 28.7 80 64zM208 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM134.3 209.3L240 254.6l105.7-45.3 14.7-6.3L373 232.4l-14.7 6.3L280.6 272l77.7 33.3 14.7 6.3L360.4 341l-14.7-6.3L240 289.4 134.3 334.7 119.6 341 107 311.6l14.7-6.3L199.4 272l-77.7-33.3L107 232.4 119.6 203l14.7 6.3z']
      
    ]
  };

  
    var faBookDead = faBookSkull;
  

  
  

  var faAlignCenter = {
    prefix: 'fasds',
    iconName: 'align-center',
    icon: [
      448,
      512,
      [],
      'f037',
      
      ['M96 32l0 64 256 0 0-64L96 32zm0 256l0 64 256 0 0-64L96 288z','M448 480L0 480l0-64 448 0 0 64zm0-256L0 224l0-64 448 0 0 64z']
      
    ]
  };

  

  
  

  var faFaceMeh = {
    prefix: 'fasds',
    iconName: 'face-meh',
    icon: [
      512,
      512,
      [128528,"meh"],
      'f11a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 80l16 0 192 0 16 0 0 32-16 0-192 0-16 0 0-32zm.4-128c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faMeh = faFaceMeh;
  

  
  

  var faCodePullRequestClosed = {
    prefix: 'fasds',
    iconName: 'code-pull-request-closed',
    icon: [
      512,
      512,
      [],
      'e3f9',
      
      ['M80 192c2.7 0 5.3 0 8 0l48 0 8 0 0 160-8 0-48 0-8 0 0-160zm288 64l64 0 0 32 0 64-8 0-48 0-8 0 0-64 0-32z','M305.4 62.6L354.7 112l-49.4 49.4 45.3 45.3L400 157.3l49.4 49.4 45.3-45.3L445.3 112l49.4-49.4L449.4 17.4 400 66.7 350.6 17.4 305.4 62.6zM136 88l0 48-48 0 0-48 48 0zM88 32L32 32l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0L88 32zm0 376l48 0 0 48-48 0 0-48zM32 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0zM376 456l0-48 48 0 0 48-48 0zM320 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0z']
      
    ]
  };

  

  
  

  var faMobile = {
    prefix: 'fasds',
    iconName: 'mobile',
    icon: [
      384,
      512,
      [128241,"mobile-android","mobile-phone"],
      'f3ce',
      
      ['M16 384l0 128 352 0 0-128L16 384zm128 48l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32z','M16 0H368V384H16V0z']
      
    ]
  };

  
    var faMobileAndroid = faMobile;
  
    var faMobilePhone = faMobile;
  

  
  

  var faUserPilot = {
    prefix: 'fasds',
    iconName: 'user-pilot',
    icon: [
      448,
      512,
      [],
      'e2c0',
      
      ['M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M80 99.2L48 80l0-32L224 0 400 48l0 32L368 99.2l0 44.8c-16 10.7-67.2 32-144 32s-128-21.3-144-32l0-44.8zm88.8-40.7L154.5 87.2l14.3 7.2 48 24 7.2 3.6 7.2-3.6 48-24 14.3-7.2L279.2 58.5l-14.3 7.2L224 86.1 183.2 65.7l-14.3-7.2zM138.7 352L224 416l85.3-64 90.7 0 48 160L0 512 48 352l90.7 0zM320 416l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0z']
      
    ]
  };

  

  
  

  var faForward = {
    prefix: 'fasds',
    iconName: 'forward',
    icon: [
      512,
      512,
      [9193],
      'f04e',
      
      ['M0 64L256 256 0 448 0 64z','M256 64V448L512 256 256 64z']
      
    ]
  };

  

  
  

  var faLoader = {
    prefix: 'fasds',
    iconName: 'loader',
    icon: [
      512,
      512,
      [],
      'e1d4',
      
      ['M52.4 414.4l45.3 45.3L120.2 437l45.3-45.3 22.6-22.6-45.3-45.3-22.6 22.6L75 391.8 52.4 414.4zM224 384l0 32 0 64 0 32 64 0 0-32 0-64 0-32-64 0zm99.9-241.1l45.3 45.3 22.6-22.6L437 120.2l22.6-22.6L414.4 52.3 391.8 75l-45.3 45.3-22.6 22.6zm0 226.3l22.6 22.6L391.8 437l22.6 22.6 45.3-45.3L437 391.8l-45.3-45.3-22.6-22.6-45.3 45.3zM384 224l0 64 32 0 64 0 32 0 0-64-32 0-64 0-32 0z','M288 0L224 0l0 32 0 64 0 32 64 0 0-32 0-64 0-32zM0 224l0 64 32 0 64 0 32 0 0-64-32 0-64 0L0 224zM120.2 75L97.6 52.4 52.4 97.6 75 120.2l45.3 45.3 22.6 22.6 45.3-45.3-22.6-22.6L120.2 75z']
      
    ]
  };

  

  
  

  var faGlass = {
    prefix: 'fasds',
    iconName: 'glass',
    icon: [
      384,
      512,
      [129371],
      'f804',
      
      ['M0 0L5 64 40 512l304 0L379 64l5-64L319.8 0 64.2 0 0 0zM69.2 64l245.6 0c-1.7 21.3-3.3 42.7-5 64l-25 320L99.2 448l-25-320-5-64z','M74.2 128l25 320 185.6 0 25-320L74.2 128z']
      
    ]
  };

  

  
  

  var faFileCircleCheck = {
    prefix: 'fasds',
    iconName: 'file-circle-check',
    icon: [
      576,
      512,
      [],
      'e5a0',
      
      ['M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0z','M384 160l-160 0L224 0 384 160zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm222.6-32L488 313.4l-11.3 11.3L416 385.4l-28.7-28.7L376 345.4 353.4 368l11.3 11.3 40 40L416 430.6l11.3-11.3 72-72L510.6 336z']
      
    ]
  };

  

  
  

  var faRotateExclamation = {
    prefix: 'fasds',
    iconName: 'rotate-exclamation',
    icon: [
      512,
      512,
      [],
      'e23c',
      
      ['M0 272L0 432l57.6-57.6 40 40C141.3 458.1 198.7 480 256 480s114.7-21.9 158.4-65.6c24.4-24.4 42.1-53.1 52.9-83.7l-60.4-21.3c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-40-40L160 272 0 272zm44.8-90.6l60.4 21.3c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0l40 40L352 240l160 0 0-160-57.6 57.6-40-40c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4z','M280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faScribble = {
    prefix: 'fasds',
    iconName: 'scribble',
    icon: [
      512,
      512,
      [],
      'e23f',
      
      ['M170 23.3C186.5 8.3 208 0 230.3 0l1.1 0C280.3 0 320 39.7 320 88.6c0 23.5-9.3 46-25.9 62.6L103.2 342.1c-4.6 4.6-7.2 10.9-7.2 17.4C96 373 107 384 120.6 384c6.5 0 12.8-2.6 17.4-7.2L360.8 153.9c16.6-16.6 39.1-25.9 62.6-25.9c48.9 0 88.6 39.7 88.6 88.6c0 23.5-9.3 46-25.9 62.6l-88.2 88.2c-8.9 8.9-13.8 20.9-13.8 33.4c0 26.1 21.1 47.2 47.2 47.2l4.4 0c4.8 0 9.5-.8 14.1-2.3l12.2-4.1 30.4-10.1 20.2 60.7-30.4 10.1-12.2 4.1c-11.1 3.7-22.6 5.6-34.3 5.6l-4.4 0C369.8 512 320 462.2 320 400.8c0-29.5 11.7-57.8 32.6-78.6l88.2-88.2c4.6-4.6 7.2-10.9 7.2-17.4c0-13.6-11-24.6-24.6-24.6c-6.5 0-12.8 2.6-17.4 7.2L183.2 422.1c-16.6 16.6-39.1 25.9-62.6 25.9C71.7 448 32 408.3 32 359.4c0-23.5 9.3-46 25.9-62.6L248.8 105.9c4.6-4.6 7.2-10.9 7.2-17.4C256 75 245 64 231.4 64l-1.1 0c-6.4 0-12.6 2.4-17.3 6.7L53.5 215.7 10.5 168.3 170 23.3z','']
      
    ]
  };

  

  
  

  var faCommentsQuestion = {
    prefix: 'fasds',
    iconName: 'comments-question',
    icon: [
      640,
      512,
      [],
      'e14e',
      
      ['M0 176c0 37.5 13.9 72.3 37.6 100.9L0 352l108.1-21.6C137.7 344.2 171.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zm134.7-52c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 250.7l40 0 0 40-40 0 0-40z','M134.7 124c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 250.7l40 0 0 40-40 0 0-40zM432 512c-95.6 0-176.2-54.6-200.5-129C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9L640 512 531.9 490.4C502.3 504.2 468.2 512 432 512z']
      
    ]
  };

  

  
  

  var faCommentCaptions = {
    prefix: 'fasds',
    iconName: 'comment-captions',
    icon: [
      512,
      512,
      [],
      'e146',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm96-32l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48zm0 80l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm128 0l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48zm96-80l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48z','M96 208l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48zm224 0l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zM96 288l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm128 0l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faEyeDropper = {
    prefix: 'fasds',
    iconName: 'eye-dropper',
    icon: [
      512,
      512,
      ["eye-dropper-empty","eyedropper"],
      'f1fb',
      
      ['M0 472l40 40 5-4 22.7-18.1L80 480l88 0L333.4 314.6l-45.3-45.3L141.5 416 96 416l0-45.5L242.6 223.9l-45.3-45.3L32 344l0 88-9.9 12.3L4 467l-4 5z','M240.1 130.8L341.6 29.2c39-39 102.2-39 141.1 0s39 102.2 0 141.1L381.2 271.9l9.4 9.4L413.3 304 368 349.3l-22.6-22.6-160-160L162.7 144 208 98.7l22.6 22.6 9.4 9.4z']
      
    ]
  };

  
    var faEyeDropperEmpty = faEyeDropper;
  
    var faEyedropper = faEyeDropper;
  

  
  

  var faCloudBinary = {
    prefix: 'fasds',
    iconName: 'cloud-binary',
    icon: [
      640,
      512,
      [],
      'e601',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zM160 160l16 0 64 0 16 0c0 5.3 0 10.7 0 16c0 26.7 0 53.3 0 80c0 5.3 0 10.7 0 16l-16 0-64 0-16 0c0-5.3 0-10.7 0-16c0-26.7 0-53.3 0-80c0-5.3 0-10.7 0-16zm16 144l16 0 16 0 16 0c0 5.3 0 10.7 0 16c0 26.7 0 53.3 0 80c0 5.3 0 10.7 0 16l-32 0c0-5.3 0-10.7 0-16c0-21.3 0-42.7 0-64l-16 0c0-10.7 0-21.3 0-32zm16-112c0 16 0 32 0 48l32 0c0-16 0-32 0-48l-32 0zm80 112l16 0 64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0c0-5.3 0-10.7 0-16c0-26.7 0-53.3 0-80c0-5.3 0-10.7 0-16zm16-144l16 0 16 0 16 0 0 16 0 80 0 16-32 0c0-5.3 0-10.7 0-16c0-21.3 0-42.7 0-64l-16 0c0-10.7 0-21.3 0-32zm16 176c0 16 0 32 0 48l32 0 0-48-32 0zm80-176l16 0 64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16zm16 144l16 0 16 0 16 0 0 16 0 80 0 16-32 0 0-16 0-64-16 0 0-32zm16-112l0 48 32 0 0-48-32 0z','M176 160l-16 0 0 16 0 80 0 16 16 0 64 0 16 0 0-16 0-80 0-16-16 0-64 0zm16 80l0-48 32 0 0 48-32 0zm112-80l-16 0 0 32 16 0 0 64 0 16 32 0 0-16 0-80 0-16-16 0-16 0zm80 0l0 16 0 80 0 16 16 0 64 0 16 0 0-16 0-80 0-16-16 0-64 0-16 0zm32 32l32 0 0 48-32 0 0-48zM192 304l-16 0 0 32 16 0 0 64 0 16 32 0 0-16 0-80 0-16-16 0-16 0zm80 0l0 16 0 80 0 16 16 0 64 0 16 0 0-16 0-80 0-16-16 0-64 0-16 0zm32 32l32 0 0 48-32 0 0-48zm112-32l-16 0 0 32 16 0 0 64 0 16 32 0 0-16 0-80 0-16-16 0-16 0z']
      
    ]
  };

  

  
  

  var faOven = {
    prefix: 'fasds',
    iconName: 'oven',
    icon: [
      448,
      512,
      [],
      'e01d',
      
      ['M0 160l448 0 0 32-64 0L64 192 0 192l0-32zm64 96l320 0 0 192L64 448l0-192zm32 32l0 32 16 0 224 0 16 0 0-32-16 0-224 0-16 0z','M448 0l0 160L0 160 0 0 448 0zM80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM200 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM64 256l0 192 320 0 0-192L64 256zM0 192l64 0 320 0 64 0 0 64 0 192 0 64-64 0L64 512 0 512l0-64L0 256l0-64z']
      
    ]
  };

  

  
  

  var faDeleteLeft = {
    prefix: 'fasds',
    iconName: 'delete-left',
    icon: [
      576,
      512,
      [9003,"backspace"],
      'f55a',
      
      ['M0 256L176 448l400 0 0-384L176 64 0 256zm254.1-64c11.3-11.3 22.6-22.6 33.9-33.9l17 17 47 47c15.7-15.7 31.3-31.3 47-47c5.7-5.7 11.3-11.3 17-17L449.9 192c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c5.7 5.7 11.3 11.3 17 17L416 353.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c-15.7 15.7-31.4 31.3-47 47c-5.7 5.7-11.3 11.3-17 17L254.1 320c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.3 47-47l-47-47-17-17z','M433 209l17-17L416 158.1l-17 17-47 47-47-47-17-17L254.1 192l17 17 47 47-47 47-17 17L288 353.9l17-17 47-47 47 47 17 17L449.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faBackspace = faDeleteLeft;
  

  
  

  var faFaceGrin = {
    prefix: 'fasds',
    iconName: 'face-grin',
    icon: [
      512,
      512,
      [128512,"grin"],
      'f580',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 46.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faGrin = faFaceGrin;
  

  
  

  var faCloudSnow = {
    prefix: 'fasds',
    iconName: 'cloud-snow',
    icon: [
      512,
      512,
      [127784],
      'f742',
      
      ['M0 392l0 48 24 0 16 0 0 16 0 24 48 0 0-24 0-16 16 0 24 0 0-48-24 0-16 0 0-16 0-24-48 0 0 24 0 16-16 0L0 392zm192 32l0 48 24 0 16 0 0 16 0 24 48 0 0-24 0-16 16 0 24 0 0-48-24 0-16 0 0-16 0-24-48 0 0 24 0 16-16 0-24 0zm192-32l0 48 24 0 16 0 0 16 0 24 48 0 0-24 0-16 16 0 24 0 0-48-24 0-16 0 0-16 0-24-48 0 0 24 0 16-16 0-24 0z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faShelves = {
    prefix: 'fasds',
    iconName: 'shelves',
    icon: [
      640,
      512,
      ["inventory"],
      'f480',
      
      ['M0 0L0 32 0 160l0 32 0 32L0 416l0 32 0 32 0 32 64 0 0-32 512 0 0 32 64 0 0-32 0-32 0-32 0-192 0-32 0-32 0-128 0-32L576 0l0 32 0 128L64 160 64 32 64 0 0 0zM64 224l512 0 0 192L64 416l0-192z','M480 0L352 0l0 128 128 0L480 0zM96 256l0 128 128 0 0-128L96 256zm160 0l0 128 128 0 0-128-128 0z']
      
    ]
  };

  
    var faInventory = faShelves;
  

  
  

  var faAnglesUpDown = {
    prefix: 'fasds',
    iconName: 'angles-up-down',
    icon: [
      448,
      512,
      [],
      'e60d',
      
      ['M19.2 358.4l25.6 19.2 160 120L224 512l19.2-14.4 160-120 25.6-19.2-38.4-51.2-25.6 19.2L224 432 83.2 326.4 57.6 307.2 19.2 358.4z','M224 0l19.2 14.4 160 120 25.6 19.2-38.4 51.2-25.6-19.2L224 80 83.2 185.6 57.6 204.8 19.2 153.6l25.6-19.2 160-120L224 0z']
      
    ]
  };

  

  
  

  var faDownload = {
    prefix: 'fasds',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      ['M0 352L0 512l512 0 0-160-178.7 0-54.6 54.6L256 429.3l-22.6-22.6c-18.2-18.2-36.4-36.4-54.6-54.6L0 352zm456 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M288 0l0 32 0 274.7 73.4-73.4L384 210.7 429.3 256l-22.6 22.6-128 128L256 429.3l-22.6-22.6-128-128L82.7 256 128 210.7l22.6 22.6L224 306.7 224 32l0-32 64 0z']
      
    ]
  };

  

  
  

  var faArrowsDownToLine = {
    prefix: 'fasds',
    iconName: 'arrows-down-to-line',
    icon: [
      576,
      512,
      [],
      'e4b8',
      
      ['M0 416l32 0 512 0 32 0 0 64-32 0L32 480 0 480l0-64z','M70.6 249.4L48 226.7 2.7 272l22.6 22.6 80 80L128 397.3l22.6-22.6 80-80L253.3 272 208 226.7l-22.6 22.6L160 274.7 160 64l0-32L96 32l0 32 0 210.7L70.6 249.4zm320 0L368 226.7 322.7 272l22.6 22.6 80 80L448 397.3l22.6-22.6 80-80L573.3 272 528 226.7l-22.6 22.6L480 274.7 480 64l0-32-64 0 0 32 0 210.7-25.4-25.4z']
      
    ]
  };

  

  
  

  var faTugrikSign = {
    prefix: 'fasds',
    iconName: 'tugrik-sign',
    icon: [
      384,
      512,
      [],
      'e2ba',
      
      ['M25.2 232.7l15.5 62.1 31-7.8L160 265l0-66L56.2 225l-31 7.8zm0 96l15.5 62.1 31-7.8L160 361l0-66L56.2 321l-31 7.8zM224 183l0 66L327.8 223l31-7.8-15.5-62.1-31 7.8L224 183zm0 96l0 66L327.8 319l31-7.8-15.5-62.1-31 7.8L224 279z','M0 32l32 0 160 0 160 0 32 0 0 64-32 0L224 96l0 352 0 32-64 0 0-32 0-352L32 96 0 96 0 32z']
      
    ]
  };

  

  
  

  var faBatterySlash = {
    prefix: 'fasds',
    iconName: 'battery-slash',
    icon: [
      640,
      512,
      [],
      'f377',
      
      ['M32 121.2L32 160l0 192 0 64 64 0 310.2 0-81.2-64L96 352l0-180.4L32 121.2zM153 96c27.5 21.3 55 42.7 82.4 64L512 160l0 192-29.3 0c27.5 21.3 55 42.7 82.4 64l10.8 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L153 96z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faClockSixThirty = {
    prefix: 'fasds',
    iconName: 'clock-six-thirty',
    icon: [
      512,
      512,
      [],
      'e353',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232-24l48 0 0 24 0 136 0 24-48 0 0-24 0-136 0-24z','M280 416l0-24 0-136 0-24-48 0 0 24 0 136 0 24 48 0z']
      
    ]
  };

  

  
  

  var faShip = {
    prefix: 'fasds',
    iconName: 'ship',
    icon: [
      576,
      512,
      [128674],
      'f21a',
      
      ['M0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.6 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2C38.6 441.9 19.3 448 0 448z','M384 0L192 0l0 64-64 0L96 64l0 32 0 144L0 272 134.6 395.3c5.5 3.6 10.9 6.6 16.7 9.3c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0l1.1-.8L288 368l19.7 14.2s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c5.9-2.7 11.2-5.7 16.7-9.3L576 272l-96-32 0-144 0-32-32 0-64 0 0-64zM288 176L160 218.7l0-90.7 256 0 0 90.7L288 176z']
      
    ]
  };

  

  
  

  var faGameConsoleHandheld = {
    prefix: 'fasds',
    iconName: 'game-console-handheld',
    icon: [
      384,
      512,
      [],
      'f8bb',
      
      ['M0 0L384 0l0 512L0 512 0 0zM64 320l0 32 32 0 0 32 32 0 0-32 32 0 0-32-32 0 0-32-32 0 0 32-32 0zM96 64l0 160 192 0 0-160L96 64zM208 360a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64-48a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M96 64H288V224H96V64z']
      
    ]
  };

  

  
  

  var faPersonSledding = {
    prefix: 'fasds',
    iconName: 'person-sledding',
    icon: [
      512,
      512,
      ["sledding"],
      'f7cb',
      
      ['M-8.4 258.2l21.3 11.1 416 216 10.9 5.6 10.9-5.5 48-24 21.5-10.7-21.5-42.9-21.5 10.7-37.1 18.5c-18.7-9.7-37.5-19.5-56.2-29.2c-21.3-11.1-42.7-22.2-64-33.2c-35.1-18.2-70.2-36.4-105.3-54.6l-42.3-22c-45.8-23.8-91.6-47.5-137.4-71.3L13.8 215.6-8.4 258.2z','M352 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128l32 0 160 0 13.3 0 9.4 9.4 12.8 12.8 3.2 3.2L381.3 176l-22.6 22.6L301.3 256l50.7 0 32 0 0 32 0 96 0 23.9-64-33.2 0-54.6-105.3 0-42.3-22c-12.8-20.3-10.5-49.8 13.8-66L246.3 192 160 192l-32 0 0-64z']
      
    ]
  };

  
    var faSledding = faPersonSledding;
  

  
  

  var faBuildingCircleXmark = {
    prefix: 'fasds',
    iconName: 'building-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4d4',
      
      ['M0 0L384 0l0 232.2c-39.1 32.3-64 81.1-64 135.8s24.9 103.5 64 135.8l0 8.2-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faSprinkler = {
    prefix: 'fasds',
    iconName: 'sprinkler',
    icon: [
      512,
      512,
      [],
      'e035',
      
      ['M0 24a24 24 0 1 0 48 0A24 24 0 1 0 0 24zM0 128a24 24 0 1 0 48 0A24 24 0 1 0 0 128zM0 232a24 24 0 1 0 48 0A24 24 0 1 0 0 232zM64 72a24 24 0 1 0 48 0A24 24 0 1 0 64 72zm0 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm208 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 112a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM464 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 104a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 104a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M288 96l0-32-64 0 0 32 0 160L96 256l0 40 96 88 0 128 128 0 0-128 96-88 0-40-128 0 0-160z']
      
    ]
  };

  

  
  

  var faFaceLying = {
    prefix: 'fasds',
    iconName: 'face-lying',
    icon: [
      512,
      512,
      [],
      'e37e',
      
      ['M0 256C0 397.4 114.6 512 256 512c108 0 200.4-66.9 238-161.5c-4.5 1-9.2 1.5-14 1.5l-128 0-16 0 0-32 16 0 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0-16 0 0-32 16 0 192 0c11.2 0 21.7 2.9 30.9 7.9C498.8 101.8 389.3 0 256 0C114.6 0 0 114.6 0 256zm208.4-80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM153.6 387.2l9.6-12.8C180.7 351.1 208.6 336 240 336c13.6 0 26.6 2.8 38.4 8l14.7 6.4-12.8 29.3-14.7-6.4c-7.8-3.4-16.5-5.3-25.6-5.3c-20.9 0-39.5 10-51.2 25.6l-9.6 12.8-25.6-19.2zM368.4 176a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faCloudRain = {
    prefix: 'fasds',
    iconName: 'cloud-rain',
    icon: [
      512,
      512,
      [9926,127783],
      'f73d',
      
      ['M48 461.9l0 2.1c0 26.5 21.5 48 48 48s48-21.5 48-48l0-2.1c0-9.1-2.5-18-7.1-25.8L96 368 55.1 436.1c-4.7 7.8-7.1 16.7-7.1 25.8zm160 0l0 2.1c0 26.5 21.5 48 48 48s48-21.5 48-48l0-2.1c0-9.1-2.5-18-7.1-25.8L256 368l-40.9 68.1c-4.7 7.8-7.1 16.7-7.1 25.8zm160 0l0 2.1c0 26.5 21.5 48 48 48s48-21.5 48-48l0-2.1c0-9.1-2.5-18-7.1-25.8L416 368l-40.9 68.1c-4.7 7.8-7.1 16.7-7.1 25.8z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faShovelSnow = {
    prefix: 'fasds',
    iconName: 'shovel-snow',
    icon: [
      512,
      512,
      [],
      'f7c3',
      
      ['M97.4 328L120 350.6l11.3-11.3 72-72L214.6 256c-7.5-7.5-15.1-15.1-22.6-22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-24 24-48 48-72 72c-3.8 3.8-7.5 7.5-11.3 11.3zm64 64L184 414.6l11.3-11.3 72-72L278.6 320c-7.5-7.5-15.1-15.1-22.6-22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-24 24-48 48-72 72c-3.8 3.8-7.5 7.5-11.3 11.3zM255 223c11.3 11.3 22.6 22.6 33.9 33.9l89.8-89.8c10.9 5.7 23.3 8.8 36.4 8.8c21 0 41.1-8.3 56-23.2l6.9-6.9L512 112 478.1 78.1 433.9 33.9 400 0 366.1 33.9l-6.9 6.9c-14.9 14.9-23.2 35-23.2 56c0 13.1 3.2 25.5 8.8 36.4L255 223zM384 96.8c0-8.3 3.3-16.2 9.1-22.1l6.9-6.9L444.1 112l-6.9 6.9c-5.9 5.9-13.8 9.1-22.1 9.1C398 128 384 114 384 96.8z','M0 304L192 160 352 320 208 512 0 304zm203.3-36.7L214.6 256 192 233.4l-11.3 11.3-72 72L97.4 328 120 350.6l11.3-11.3 72-72zm64 64L278.6 320 256 297.4l-11.3 11.3-72 72L161.4 392 184 414.6l11.3-11.3 72-72z']
      
    ]
  };

  

  
  

  var faCableCar = {
    prefix: 'fasds',
    iconName: 'cable-car',
    icon: [
      512,
      512,
      [57551,128673,"tram"],
      'f7da',
      
      ['M3.5 157.6l10.1 46.9 23.5-5 195-41.8 0 66.3 48 0 0-76.6 205-43.9 23.5-5L498.4 51.5l-23.5 5-224 48-224 48-23.5 5zM80 288l0 96 96 0 0-96-96 0zm128 0l0 96 96 0 0-96-96 0zm128 0l0 96 96 0 0-96-96 0z','M288 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64-8a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM480 512l0-288L32 224l0 288 448 0zM176 288l0 96-96 0 0-96 96 0zm32 0l96 0 0 96-96 0 0-96zm224 0l0 96-96 0 0-96 96 0z']
      
    ]
  };

  
    var faTram = faCableCar;
  

  
  

  var faGarage = {
    prefix: 'fasds',
    iconName: 'garage',
    icon: [
      640,
      512,
      [],
      'e009',
      
      ['M128 224l384 0 0 96-384 0 0-96zm0 128l384 0 0 160-384 0 0-160zm128 64l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z','M0 128V512H96V192H544V512h96V128L320 0 0 128z']
      
    ]
  };

  

  
  

  var faSwap = {
    prefix: 'fasds',
    iconName: 'swap',
    icon: [
      640,
      512,
      [],
      'e609',
      
      ['M288 32l0 32 0 192 64 0 0-160 128 0 0 256-80 0 0 40L512 512 624 392l0-40-80 0 0-288 0-32-32 0L320 32l-32 0z','M128 0L16 120l0 40 80 0 0 288 0 32 32 0 192 0 32 0 0-32 0-192-64 0 0 160-128 0 0-256 80 0 0-40L128 0z']
      
    ]
  };

  

  
  

  var faN = {
    prefix: 'fasds',
    iconName: 'n',
    icon: [
      384,
      512,
      [110],
      '4e',
      
      ['M0 32l47 0 9.6 11.5L320 359.6 320 64l0-32 64 0 0 32 0 384 0 32-47 0-9.6-11.5L64 152.4 64 448l0 32L0 480l0-32L0 64 0 32z','']
      
    ]
  };

  

  
  

  var faPeoplePulling = {
    prefix: 'fasds',
    iconName: 'people-pulling',
    icon: [
      576,
      512,
      [],
      'e535',
      
      ['M0 128l0 32L0 320l0 32 58.2 0L84.4 509.3l.5 2.7 64.9 0-2.2-13.3L123.1 352l15.7 0 29.8 134.1 3.9 23.2 .5 2.7 64.9 0-2.2-13.3-4-24c-.1-.6-.2-1.1-.3-1.7L174.3 216.8l89.1 43.7c3.5-10.4 6.8-20.5 10.2-30.7c3.4-10.2 6.8-20.4 10.2-30.6l-138.7-68-6.7-3.3-7.4 0L32 128 0 128zM32 48a48 48 0 1 0 96 0A48 48 0 1 0 32 48z','M512 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM398.3 128.6l-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-10.1 30.4 60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16zM324.7 398l-43.4 43.4L258.7 464 304 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6l-25 62.4z']
      
    ]
  };

  

  
  

  var faEyeEvil = {
    prefix: 'fasds',
    iconName: 'eye-evil',
    icon: [
      640,
      512,
      [],
      'f6db',
      
      ['M288 256c0 40.4 32 64 32 64s32-23.6 32-64c0-13.1-3.4-24.5-7.9-33.8c-7.8 1.2-15.9 1.8-24.1 1.8s-16.2-.6-24.1-1.8c-4.6 9.3-7.9 20.7-7.9 33.8z','M320 0L258.1 111.4c-11 2.7-21.7 6.2-31.8 10.3L90 82.7l59 94.5c-7.1 8.9-13 18.4-17.7 28.3L0 256l131.3 50.5c4.6 10 10.6 19.4 17.7 28.3L90 429.3l136.3-39c10.1 4.1 20.7 7.5 31.8 10.2L320 512l61.9-111.4c11-2.7 21.7-6.2 31.8-10.3l136.3 39-59-94.5c7.1-8.9 13-18.4 17.7-28.3L640 256 508.7 205.5c-4.6-10-10.6-19.4-17.7-28.3l59-94.5-136.3 39c-10.1-4.1-20.7-7.5-31.8-10.3L320 0zm96 256c0 53-43 96-96 96s-96-43-96-96c0-19.7 6-38.1 16.2-53.3C263.7 216.2 290.9 224 320 224s56.3-7.8 79.8-21.3C410 217.9 416 236.3 416 256z']
      
    ]
  };

  

  
  

  var faUserHair = {
    prefix: 'fasds',
    iconName: 'user-hair',
    icon: [
      448,
      512,
      [],
      'e45a',
      
      ['M96 128c0 70.7 57.3 128 128 128s128-57.3 128-128c0-11.1-1.4-21.8-4-32l-60 0L256 64l-48 48L97 112c-.7 5.2-1 10.6-1 16z','M208 112l48-48 32 32 60 0C333.8 40.8 283.6 0 224 0C158.7 0 104.9 48.9 97 112l111 0zM384 304L64 304 0 512l448 0L384 304z']
      
    ]
  };

  

  
  

  var faShuttlecock = {
    prefix: 'fasds',
    iconName: 'shuttlecock',
    icon: [
      512,
      512,
      [],
      'f45b',
      
      ['M0 410.2C0 466.4 45.6 512 101.8 512c27 0 52.9-10.7 72-29.8L192 464 48 320 29.8 338.2C10.7 357.3 0 383.2 0 410.2z','M48 320l48-48L224 0l96 0 0 48-16 0-41 0L250.6 87.1l-31.3 99.2L176 208l-40 80 27 27 71.9-71.9L281.1 96.8 286.4 80 304 80l104 0 24 0 0 24 0 104 0 17.6-16.8 5.3L268.8 277.1 197 349l27 27 80-40 21.6-43.3 99.2-31.3L464 249l0-41 0-16 48 0 0 96L240 416l-48 48L48 320z']
      
    ]
  };

  

  
  

  var faCalculator = {
    prefix: 'fasds',
    iconName: 'calculator',
    icon: [
      384,
      512,
      [128425],
      'f1ec',
      
      ['M64 192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l160 0 0 64L64 448l0-64zm96-192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M384 0L0 0 0 512l384 0L384 0zM320 64l0 96L64 160l0-96 256 0zM64 192l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0zM64 384l160 0 0 64L64 448l0-64zM224 192l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm160-96l0 64-64 0 0-64 64 0zm-64 96l64 0 0 64-64 0 0-64zm64 96l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'fasds',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      ['M96 32l480 0 0 352L96 384 96 32zm80 248.5l0 9.1 0 8 0 24 24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136L376 112l-19.6 27.8L299.1 221l-17.1-19.3L264 181.5l-17.9 20.2-64 72-6.1 6.8zM192 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312zm347.6 19.8L376 112l-19.6 27.8L299.1 221l-17.1-19.3L264 181.5l-17.9 20.2-64 72-6.1 6.8 0 9.1 0 8 0 24 24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136z']
      
    ]
  };

  

  
  

  var faVenusDouble = {
    prefix: 'fasds',
    iconName: 'venus-double',
    icon: [
      640,
      512,
      [9890],
      'f226',
      
      ['M112 176a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM344 34c14.6 15.6 26.8 33.4 36 53c18.8-14.4 42.4-23 68-23c61.9 0 112 50.1 112 112s-50.1 112-112 112c-25.6 0-49.1-8.6-68-23c-9.3 19.5-21.5 37.4-36 53c21 15.4 45.4 26.2 72 31.1l0 34.9-32 0-32 0 0 64 32 0 32 0 0 32 0 32 64 0 0-32 0-32 32 0 32 0 0-64-32 0-32 0 0-34.9c81.9-15 144-86.8 144-173.1C624 78.8 545.2 0 448 0c-38.9 0-74.9 12.6-104 34z','M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0 32 0 0 64-32 0-32 0 0 32 0 32-64 0 0-32 0-32-32 0-32 0 0-64 32 0 32 0 0-34.9C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zm32 0c0-19.8-2.8-39-8-57.2C406.5 104.7 426.2 96 448 96c44.2 0 80 35.8 80 80s-35.8 80-80 80c-21.8 0-41.5-8.7-56-22.8c5.2-18.2 8-37.3 8-57.2z']
      
    ]
  };

  

  
  

  var faRightFromLine = {
    prefix: 'fasds',
    iconName: 'right-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-left"],
      'f347',
      
      ['M0 64L0 96 0 416l0 32 64 0 0-32L64 96l0-32L0 64z','M448 256L288 96l-32 0 0 96L96 192l0 128 160 0 0 96 32 0L448 256z']
      
    ]
  };

  
    var faArrowAltFromLeft = faRightFromLine;
  

  
  

  var faPersonHiking = {
    prefix: 'fasds',
    iconName: 'person-hiking',
    icon: [
      384,
      512,
      ["hiking"],
      'f6ec',
      
      ['M0 272l96 16L144 96 48 96 0 272zM336 160l0 24c0 8 0 16 0 24c0 21.3 0 42.7 0 64l0 216 0 24 48 0 0-24 0-304 0-24-48 0z','M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-23.5 69.1l31.3 7.8 48 12 12 3 6.9 10.3L305.1 208l30.9 0 0 64-48 0-17.1 0-9.5-14.2-18.1-27.1L224.2 307l54.4 54.4 9.4 9.4 0 13.3 0 96 0 32-64 0 0-32 0-82.7-69.7-69.7-1.1-.3 .2-.7-3.3-3.3c-15.8-15.8-22.2-38.6-16.9-60.3l27.8-114.5 7.6-31.3zM117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L136.7 512l-66.2 0 46.8-178z']
      
    ]
  };

  
    var faHiking = faPersonHiking;
  

  
  

  var faClosedCaptioning = {
    prefix: 'fasds',
    iconName: 'closed-captioning',
    icon: [
      576,
      512,
      [],
      'f20a',
      
      ['M0 32l576 0 0 448L0 480 0 32zM104 256c0 53 43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C232 295.1 217 304 200 304c-26.5 0-48-21.5-48-48s21.5-48 48-48c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-46.9-44.6-81.1-44.6c-53 0-96 43-96 96zm192 0c0 53 43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C424 295.1 409 304 392 304c-26.5 0-48-21.5-48-48s21.5-48 48-48c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-47-44.6-81.1-44.6c-53 0-96 43-96 96z','M152 256c0-26.5 21.5-48 48-48c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-46.9-44.6-81.1-44.6c-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C232 295.1 217 304 200 304c-26.5 0-48-21.5-48-48zm192 0c0-26.5 21.5-48 48-48c17 0 32 8.9 40.6 22.3l40.5-25.7c-17-26.8-47-44.6-81.1-44.6c-53 0-96 43-96 96s43 96 96 96c34.2 0 64.1-17.8 81.1-44.6l-40.5-25.7C424 295.1 409 304 392 304c-26.5 0-48-21.5-48-48z']
      
    ]
  };

  

  
  

  var faBadminton = {
    prefix: 'fasds',
    iconName: 'badminton',
    icon: [
      576,
      512,
      [],
      'e33a',
      
      ['M0 448l63.7 64 95.6-96L95.6 352 0 448zm447.3 54.3l30.8 8.8 4.4-15.4 13.2-46 0 46.2 0 16 32 0 0-16 0-46.2 13.2 46 4.4 15.4 30.8-8.8L571.7 487l-11.2-39-97.6 0-11.2 39-4.4 15.4zM462 400l0 32 95.6 0 0-32c0-26.5-21.4-48-47.8-48s-47.8 21.5-47.8 48z','M240.2 112.2C272.6 79.8 312.9 64 349 64c28.2 0 53.2 9.6 71.3 27.7S448 134.9 448 163c0 36-15.8 76.4-48.2 108.8c-59.4 59.4-139.7 60.9-180.1 20.5C201.6 274.1 192 249.1 192 221c0-36 15.8-76.4 48.2-108.8zM349 0c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 32.4 8.4 64.2 26.2 91.6l-48.8 48.8 45.3 45.3 48.8-48.8c73.3 48.1 177.5 27.4 245.7-40.8c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0z']
      
    ]
  };

  

  
  

  var faHouseMedicalCircleExclamation = {
    prefix: 'fasds',
    iconName: 'house-medical-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e512',
      
      ['M0 240l0 47.6 64.1 0 0 224.4 330.7 0c-45.2-31.8-74.7-84.4-74.8-143.8c-.1 8.7-7.2 15.8-16 15.8l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 40.2 0c32.3-39.1 81.1-64 135.8-64c8.3 0 16.5 .6 24.5 1.7L288.4 0 0 240zM320 352l0 15.3c0-5.2 .3-10.3 .7-15.3l-.7 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faGearComplexCode = {
    prefix: 'fasds',
    iconName: 'gear-complex-code',
    icon: [
      512,
      512,
      [],
      'e5eb',
      
      ['M-1.3 208L0 304l55.3 7c4.5 16.6 11.1 32.4 19.4 47.1l-35 45L107.6 471l44.6-34.7c14.8 8.5 30.7 15.3 47.5 20l7 55.7 96 0 6.9-55c17.2-4.6 33.6-11.3 48.7-19.9L401.8 471l67.9-67.9L436.2 360c8.9-15.3 15.8-31.8 20.6-49.3l54-6.7 0-96-54-6.7c-4.7-17.4-11.7-34-20.6-49.3l33.5-43.1L401.8 41 358.3 74.9c-15.2-8.6-31.5-15.3-48.7-19.9L302.7 0l-96 0-7 55.7c-16.8 4.7-32.7 11.5-47.5 20L107.6 41 39.7 108.9l35 45c-8.3 14.7-14.8 30.4-19.4 47L-1.3 208zm114.7 48l11.3-11.3c13.3-13.3 26.7-26.7 40-40c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-9.6 9.6-19.1 19.1-28.7 28.7c9.6 9.6 19.1 19.1 28.7 28.7c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-13.3-13.3-26.7-26.7-40-40c-3.8-3.8-7.5-7.5-11.3-11.3zM221.6 365.2l2.6-15.8 32-192c.9-5.3 1.8-10.5 2.6-15.8c10.5 1.8 21 3.5 31.6 5.3c-.9 5.3-1.8 10.5-2.6 15.8c-10.7 64-21.3 128-32 192c-.9 5.3-1.8 10.5-2.6 15.8c-10.5-1.8-21-3.5-31.6-5.3zM313.4 216c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c13.3 13.3 26.7 26.7 40 40c3.8 3.8 7.5 7.5 11.3 11.3c-3.8 3.8-7.5 7.5-11.3 11.3c-13.3 13.3-26.7 26.7-40 40c-3.8 3.8-7.5 7.5-11.3 11.3L313.4 296l11.3-11.3c9.6-9.6 19.1-19.1 28.7-28.7c-9.6-9.6-19.1-19.1-28.7-28.7c-3.8-3.8-7.5-7.5-11.3-11.3z','M290.4 146.8l-2.6 15.8-32 192-2.6 15.8-31.6-5.3 2.6-15.8 32-192 2.6-15.8 31.6 5.3zM198.6 216l-11.3 11.3L158.6 256l28.7 28.7L198.6 296 176 318.6l-11.3-11.3-40-40L113.4 256l11.3-11.3 40-40L176 193.4 198.6 216zM336 193.4l11.3 11.3 40 40L398.6 256l-11.3 11.3-40 40L336 318.6 313.4 296l11.3-11.3L353.4 256l-28.7-28.7L313.4 216 336 193.4z']
      
    ]
  };

  

  
  

  var faCirclePhoneHangup = {
    prefix: 'fasds',
    iconName: 'circle-phone-hangup',
    icon: [
      512,
      512,
      ["phone-circle-down"],
      'e11d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 6.8l10.7-10.4C147.9 212.1 201.9 192 256 192s108.1 20.1 149.3 60.4L416 262.8 378.7 320 304 299.2l5.6-49.1c-34.9-10.5-72.3-10.5-107.2 0l5.6 49.1L133.3 320 96 262.8z','M416 262.8L378.7 320 304 299.2l5.6-49.1c-34.9-10.5-72.3-10.5-107.2 0l5.6 49.1L133.3 320 96 262.8l10.7-10.4c82.5-80.5 216.2-80.5 298.7 0L416 262.8z']
      
    ]
  };

  
    var faPhoneCircleDown = faCirclePhoneHangup;
  

  
  

  var faCompressWide = {
    prefix: 'fasds',
    iconName: 'compress-wide',
    icon: [
      512,
      512,
      [],
      'f326',
      
      ['M0 288l0 64 32 0 64 0 0 64 0 32 64 0 0-32 0-96 0-32-32 0-96 0L0 288zM352 64l0 32 0 96 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-64 0-32-64 0z','M160 96l0-32L96 64l0 32 0 64-64 0L0 160l0 64 32 0 96 0 32 0 0-32 0-96zM352 416l0 32 64 0 0-32 0-64 64 0 32 0 0-64-32 0-96 0-32 0 0 32 0 96z']
      
    ]
  };

  

  
  

  var faFaceSpiralEyes = {
    prefix: 'fasds',
    iconName: 'face-spiral-eyes',
    icon: [
      512,
      512,
      [],
      'e485',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm52.4-45.5c-5.5-53.8 41.1-108.1 101-110.5c.3 8 .6 16 1 24c-46.9 1.9-82.2 45-78.1 84.3l0 .3 0 .3c2 40.2 40.8 70.7 76.2 66.7l.3 0 .3 0c36.3-2 62.1-35.7 58.4-64.5l0-.3 0-.3c-2.1-29.8-31.3-51-56-47.5l-.3 0-.3 0c-25.7 2.2-42 26.2-38.9 44.5l.1 .4 0 .4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1 .3 0c15.2-2.1 21.9-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2c-.9-.5-1.8-.9-2.6-1.2c1.7 1.9 2.8 4.2 3 6.9c1 11.1-8.8 15.8-14.1 16.4c-6.6 .8-13.4-2.2-17.6-8.5c-5-6.8-4.4-15.6-1.8-21.8c2.9-7 8.9-13.2 17.8-16c9.2-3.3 19.4-1.3 27.5 3.3c8.3 4.9 15.5 13.4 17.9 24.8c5.8 22.8-11.9 49.5-39.5 53.6c-27.7 5.3-59.8-16.2-63.6-49.2c-5.4-33 21.9-68.7 60.3-72.1c38.2-5.2 79.6 25.8 82.9 69.3c5.4 43.3-31.5 88.2-80.6 91.2c-48.8 5.3-99.6-35.1-102.5-89.1zm54.1 166.4l14.3-7.2 32-16 8.3-4.2 7.7 5.2L208 380.8l39.1-26.1 8.9-5.9 8.9 5.9L304 380.8l39.1-26.1 7.7-5.2 8.3 4.2 32 16 14.3 7.2-14.3 28.6-14.3-7.2-23.7-11.8-40.3 26.8-8.9 5.9-8.9-5.9L256 387.2l-39.1 26.1-8.9 5.9-8.9-5.9-40.3-26.8-23.7 11.8-14.3 7.2-14.3-28.6zm170-169.2c-5.4-43.3 31.5-88.2 80.6-91.2c48.8-5.3 99.6 35.2 102.5 89.1c.3 2.9 .4 5.8 .4 8.7c0 50.8-44.8 99.5-101.4 101.8l-1-24c46.9-1.9 82.2-45 78.1-84.3l0-.3 0-.3c-2-40.2-40.8-70.7-76.2-66.7l-.3 0-.3 0c-36.3 2-62.1 35.7-58.4 64.5l0 .3 0 .3c2.1 29.8 31.3 51 56 47.5l.3 0 .3 0c25.7-2.2 42-26.2 38.9-44.5l-.1-.4c0-.1 0-.2 0-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3 .1-.3 0c-15.2 2.1-21.9 16.4-19.9 24c0 .1 .1 .2 .1 .4l.1 .4c1 4.4 3.5 7.4 6.5 9.2c.9 .5 1.8 .9 2.6 1.2c-1.7-1.8-2.7-4.2-3-6.9c-1-11.1 8.8-15.8 14.1-16.4c6.6-.8 13.4 2.2 17.6 8.5c5 6.8 4.4 15.6 1.8 21.8c-2.9 7-8.9 13.2-17.8 16c-9.2 3.3-19.4 1.3-27.5-3.3c-8.3-4.9-15.5-13.4-17.9-24.8c-5.8-22.8 11.9-49.5 39.5-53.6c27.7-5.3 59.8 16.2 63.6 49.2c5.4 33-21.9 68.7-60.3 72.1c-38.4 5-79.6-25.9-82.9-69.3z','M76.3 208.3c-4.2-39.3 31.1-82.4 78.1-84.3l-1-24c-59.9 2.4-106.5 56.7-101 110.5c2.9 53.9 53.7 94.3 102.5 89.1c49.1-3 85.9-47.9 80.6-91.2c-3.3-43.5-44.7-74.4-82.9-69.3c-38.4 3.4-65.7 39.2-60.3 72.1c3.8 33 35.9 54.5 63.6 49.2c27.7-4.1 45.3-30.8 39.5-53.6c-2.4-11.5-9.5-20-17.9-24.8c-8-4.7-18.3-6.6-27.5-3.3c-8.9 2.8-14.9 9-17.8 16c-2.6 6.3-3.2 15 1.8 21.8c4.2 6.3 11.1 9.2 17.6 8.5c5.3-.6 15.1-5.3 14.1-16.4c-.2-2.7-1.3-5.1-3-6.9c.8 .3 1.7 .6 2.6 1.2c3.1 1.8 5.7 4.9 6.5 9.2l.1 .4 .1 .4c2.1 7.7-4.7 21.9-19.9 24l-.3 0-.3 .1c-14 2.8-33.3-9.1-35.5-28.6l0-.4-.1-.4c-3.1-18.3 13.2-42.4 38.9-44.5l.3 0 .3 0c24.7-3.5 53.8 17.7 56 47.5l0 .3 0 .3c3.7 28.8-22.1 62.5-58.4 64.5l-.3 0-.3 0c-35.4 4-74.2-26.5-76.2-66.7l0-.3 0-.3zm359.3-.5c4.2 39.3-31.1 82.4-78.1 84.3l1 24c59.9-2.4 106.5-56.7 101-110.5c-2.9-53.9-53.7-94.3-102.5-89.1c-49.1 3-85.9 47.9-80.6 91.2c3.3 43.5 44.7 74.4 82.9 69.3c38.4-3.4 65.7-39.2 60.3-72.1c-3.8-33-35.9-54.5-63.6-49.2c-27.7 4.1-45.3 30.8-39.5 53.6c2.4 11.5 9.5 20 17.9 24.8c8 4.7 18.3 6.6 27.5 3.3c8.9-2.8 14.9-9 17.8-16c2.6-6.3 3.2-15-1.8-21.8c-4.2-6.3-11.1-9.2-17.6-8.5c-5.3 .6-15.1 5.3-14.1 16.4c.2 2.7 1.3 5.1 3 6.9c-.8-.3-1.7-.6-2.6-1.2c-3.1-1.8-5.7-4.9-6.5-9.2l-.1-.4-.1-.4c-2.1-7.7 4.7-21.9 19.9-24l.3 0 .3-.1c14-2.8 33.3 9.1 35.5 28.6l0 .4 .1 .4c3.1 18.3-13.2 42.4-38.9 44.5l-.3 0-.3 0c-24.7 3.5-53.8-17.7-56-47.5l0-.3 0-.3c-3.7-28.8 22.1-62.5 58.4-64.5l.3 0 .3 0c35.4-4 74.2 26.5 76.2 66.7l0 .3 0 .3z']
      
    ]
  };

  

  
  

  var faArrowUpFromArc = {
    prefix: 'fasds',
    iconName: 'arrow-up-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b4',
      
      ['M0 224l0 32C0 397.4 114.6 512 256 512s256-114.6 256-256l0-32-64 0 0 32c0 106-86 192-192 192S64 362 64 256l0-32L0 224z','M98.7 160l22.6-22.6 112-112L256 2.7l22.6 22.6 112 112L413.3 160 368 205.3l-22.6-22.6L288 125.3 288 320l0 32-64 0 0-32 0-194.7-57.4 57.4L144 205.3 98.7 160z']
      
    ]
  };

  

  
  

  var faLightbulbMessage = {
    prefix: 'fasds',
    iconName: 'lightbulb-message',
    icon: [
      576,
      512,
      [],
      'e687',
      
      ['M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l144 0 0-160 105.4 0c4.3-15.3 6.6-31.4 6.6-48C368 78.8 289.2 0 192 0S16 78.8 16 176zm64 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80l-32 0zm32 240l0 96 144 0 0-96-144 0z','M288 256l288 0 0 192-96 0 0 64-74.7-64L288 448l0-192z']
      
    ]
  };

  

  
  

  var faPipeValve = {
    prefix: 'fasds',
    iconName: 'pipe-valve',
    icon: [
      512,
      512,
      [],
      'e439',
      
      ['M64 192l0 256 384 0 0-256-160 0 0-76.8L256 112l-32 3.2 0 76.8L64 192zM224 64l0 12.8L256 80l32-3.2L288 64c0-17.7-14.3-32-32-32s-32 14.3-32 32z','M96 128l160-16 160 16 0-64L256 80 96 64l0 64zM64 160L0 160l0 32L0 448l0 32 64 0 0-32 0-256 0-32zm448 32l0-32-64 0 0 32 0 256 0 32 64 0 0-32 0-256z']
      
    ]
  };

  

  
  

  var faClockFiveThirty = {
    prefix: 'fasds',
    iconName: 'clock-five-thirty',
    icon: [
      512,
      512,
      [],
      'e34a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232 0l44-13.3 64 96 13.3 20-39.9 26.6-13.3-20-20-30 0 56.7 0 24-48 0 0-24 0-136z','M280 416l0-24 0-56.7 20 30 13.3 20 39.9-26.6-13.3-20-64-96L232 256l0 136 0 24 48 0z']
      
    ]
  };

  

  
  

  var faPersonRifle = {
    prefix: 'fasds',
    iconName: 'person-rifle',
    icon: [
      576,
      512,
      [],
      'e54e',
      
      ['M1.2 422.1l68.9 40.7 20.3-34.4L144 337.7 144 512l192 0 0-320-16 0-160 0-22.8 0-11.6 19.7-104 176L1.2 422.1zM160 80a80 80 0 1 0 160 0A80 80 0 1 0 160 80z','M448 0l16 0 0 128 16 0 0 141.3 16-5.3 0-72 48 0 0 112-64 21.3 0 26.7 64 0 0 48-60 0 28 112-96 0 0-112-48 0 0-208 32 0 0-64 16 0 0-96-16 0 0-32 16 0 32 0z']
      
    ]
  };

  

  
  

  var faDiagramNext = {
    prefix: 'fasds',
    iconName: 'diagram-next',
    icon: [
      512,
      512,
      [],
      'e476',
      
      ['M0 288L0 480l512 0 0-192-128 0 0 32 0 13.3-9.4 9.4-96 96L256 461.3l-22.6-22.6-96-96-9.4-9.4 0-13.3 0-32L0 288z','M512 224l0-192L0 32 0 224l232 0 0 64-72 0 0 32 96 96 96-96 0-32-72 0 0-64 232 0z']
      
    ]
  };

  

  
  

  var faChartTreeMap = {
    prefix: 'fasds',
    iconName: 'chart-tree-map',
    icon: [
      512,
      512,
      [],
      'e0ea',
      
      ['M0 272L0 480l224 0 0-208L0 272zm256-80l0 128 256 0 0-128-256 0z','M0 32l224 0 0 208L0 240 0 32zm256 0l256 0 0 128-256 0 0-128zM512 352l0 128-256 0 0-128 256 0z']
      
    ]
  };

  

  
  

  var faTty = {
    prefix: 'fasds',
    iconName: 'tty',
    icon: [
      512,
      512,
      ["teletype"],
      'f1e4',
      
      ['M0 174C29.9 132 122.9 48 256 48s226.1 84 256 126l-51.2 90-128-42 0-78c-49.6-18.1-104-18.1-153.6 0l0 78-128 42L0 174z','M96 320l-64 0 0 64 64 0 0-64zm0 96l-64 0 0 64 64 0 0-64zm32-96l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm-32 0l-256 0 0 64 256 0 0-64z']
      
    ]
  };

  
    var faTeletype = faTty;
  

  
  

  var faLaptopFile = {
    prefix: 'fasds',
    iconName: 'laptop-file',
    icon: [
      640,
      512,
      [],
      'e51d',
      
      ['M0 288l0 48 48 48 272 0 0-96-192 0 0-224 320 0 0 32 64 0 0-64 0-32L480 0 96 0 64 0l0 32 0 256L0 288z','M352 128l160 0 0 128 128 0 0 256-288 0 0-384zm192 0l96 96-96 0 0-96z']
      
    ]
  };

  

  
  

  var faFlagUsa = {
    prefix: 'fasds',
    iconName: 'flag-usa',
    icon: [
      448,
      512,
      [],
      'f74d',
      
      ['M64 235.8l0 63.3 63.5-13.6c43-9.2 87.9-4.6 128.1 13.3l16.1 7.2c41.6 18.5 88.8 20.1 131.6 4.6L448 294.3l0-62-33.7 12.3C363.7 263 307.9 261 258.7 239.2L242.6 232c-34-15.1-72-19.1-108.4-11.3L64 235.8zm0 96L64 400l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 384l0-55.7-33.7 12.3C363.7 359 307.9 357 258.7 335.2L242.6 328c-34-15.1-72-19.1-108.4-11.3L64 331.8zM192 27l0 62.9c21.8 2.2 43.3 7.9 63.6 16.9l16.1 7.2c41.6 18.5 88.8 20.1 131.6 4.6L448 102.2 448 16 393.6 43.2c-46.3 23.2-100.8 23.2-147.1 0c-17.2-8.6-35.6-14-54.4-16.3zm0 95.1l0 63.8c21.8 2.2 43.3 7.9 63.6 16.9l16.1 7.2c41.6 18.5 88.8 20.1 131.6 4.6L448 198.3l0-62-33.7 12.3C363.7 167 307.9 165 258.7 143.2L242.6 136c-16.2-7.2-33.2-11.9-50.6-13.9z','M192 122.1l0-32.2L192 27c-19.6-2.3-39.6-1.1-59 3.8L64 48l0-16L64 0 0 0 0 32 0 64l0 56.8 0 32.7 0 63.3 0 32.7 0 63.3 0 32.7L0 416l0 64 0 32 64 0 0-32 0-80 0-68.2 0-32.7 0-63.3L64 224l0-20.9 63.5-13.6c21.3-4.6 43-5.7 64.5-3.6l0-63.8zM80 96a16 16 0 1 1 32 0A16 16 0 1 1 80 96zm64-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 144a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faCitrus = {
    prefix: 'fasds',
    iconName: 'citrus',
    icon: [
      512,
      512,
      [],
      'e2f4',
      
      ['M16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-61-22.8-116.7-60.3-159.1C420.8 122.5 403 128 384 128l-80 0-16 0 0-16 0-16c0-1.4 0-2.7 .1-4.1s.1-2.7 .3-4.1c.2-2.7 .6-5.3 1-8c.9-5.2 2.2-10.3 3.9-15.3c3.4-9.8 8.3-18.9 14.6-27c-16.7-3.7-34-5.6-51.8-5.6C123.5 32 16 139.5 16 272z','M288 128V112 96c0-53 43-96 96-96h80 16V16 32c0 53-43 96-96 96H304 288z']
      
    ]
  };

  

  
  

  var faLightsHoliday = {
    prefix: 'fasds',
    iconName: 'lights-holiday',
    icon: [
      640,
      512,
      [],
      'f7b2',
      
      ['M32.1 307.7c0-11.3 1.5-22.3 5.3-32.6c11.2-30.8 39.4-50.6 70.2-52.5c10.7-.7 21.7 .8 32.3 4.7s20 9.8 27.8 17.2c22.3 21.3 31.2 54.5 20 85.3c-21.9 60.1-119 92.9-119 92.9s-36.7-60.2-36.7-115.1zM240 336c0-32.8 19.7-61 48-73.3c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7c28.3 12.3 48 40.5 48 73.3c0 64-80 128-80 128s-80-64-80-128zm212.2-6.1c-11.2-30.8-2.3-64.1 20-85.3c7.7-7.4 17.1-13.3 27.8-17.2s21.7-5.4 32.3-4.7c30.8 1.9 59 21.7 70.2 52.5c21.9 60.1-31.4 147.6-31.4 147.6s-97.1-32.8-119-92.9z','M16 96C.1 123.8 .1 123.8 .1 123.8s0 0 0 0c0 0 0 0 .1 0l.1 .1 .4 .2c.3 .2 .8 .4 1.3 .7c1.1 .6 2.6 1.4 4.6 2.4c3.9 2 9.5 4.7 16.8 8c14.6 6.5 35.8 14.9 63.1 23.3c12.2 3.8 25.7 7.5 40.3 11.1l-19.3 53c10.7-.7 21.7 .8 32.3 4.7s20 9.8 27.8 17.2l22.7-62.4c29.5 4.6 62.1 7.9 97.6 9.2l0 71.2c9.8-4.3 20.6-6.7 32-6.7s22.2 2.4 32 6.7l0-71.2c35.5-1.3 68.1-4.6 97.6-9.2l22.7 62.4c7.7-7.4 17.1-13.3 27.8-17.2s21.7-5.4 32.3-4.7l-19.3-53c14.6-3.6 28.1-7.3 40.3-11.1c27.3-8.4 48.5-16.9 63.1-23.3c7.3-3.2 12.9-6 16.8-8c2-1 3.5-1.8 4.6-2.4c.5-.3 1-.5 1.3-.7l.4-.2 .1-.1c0 0 0 0 .1 0c0 0 0 0 0 0L624 96c-15.9-27.8-15.9-27.8-15.9-27.8c0 0 0 0 0 0l-.6 .4c-.6 .3-1.7 .9-3.2 1.7c-3 1.5-7.6 3.8-13.8 6.5c-12.4 5.5-31.2 13.1-55.9 20.7C485.2 112.6 412.4 128 320 128s-165.2-15.4-214.6-30.6C80.7 89.8 61.9 82.3 49.5 76.8c-6.2-2.8-10.8-5-13.8-6.5c-1.5-.8-2.5-1.3-3.2-1.7l-.6-.4c0 0-.1 0-.1 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0L16 96z']
      
    ]
  };

  

  
  

  var faPipeCollar = {
    prefix: 'fasds',
    iconName: 'pipe-collar',
    icon: [
      512,
      512,
      [],
      'e437',
      
      ['M48 63.9c0 .6 0 1.2 .1 1.7s.1 1.1 .2 1.6c.2 1 .5 2 .9 3c.8 1.9 2 3.6 3.4 5.1C55.6 78.2 59.6 80 64 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-4.4 0-8.4 1.8-11.3 4.7c-1.4 1.4-2.6 3.2-3.4 5.1c-.4 1-.7 2-.9 3c-.1 .5-.2 1-.2 1.6c-.1 .5-.1 1-.1 1.6zm0 383.9c0 .8 0 1.3 .1 1.8c.1 .5 .1 1.1 .2 1.6c.2 1 .5 2 .9 3c.8 1.9 2 3.6 3.4 5.1c2.9 2.9 6.9 4.7 11.3 4.7c8.8 0 16-7.2 16-16s-7.2-16-16-16c-4.4 0-8.4 1.8-11.3 4.7c-1.4 1.4-2.6 3.2-3.4 5.1c-.4 1-.7 2-.9 3c-.1 .5-.2 1-.2 1.6c-.1 .5-.1 1-.1 1.5zM96.2 247.7c-.1 1.4-.1 2.7-.2 4.1c0 1.4-.1 2.8-.1 4.2s0 2.8 .1 4.2c0 1.4 .1 2.7 .2 4.1c.1 2.7 .3 5.4 .6 8.1c.5 5.4 1.4 10.7 2.4 15.9c2.1 10.4 5.3 20.5 9.3 30c8.1 19.1 19.8 36.4 34.3 50.9c29 29 69 46.9 113.1 46.9c88.4 0 160-71.6 160-160s-71.6-160-160-160c-44.2 0-84.2 17.9-113.1 46.9c-14.5 14.5-26.2 31.7-34.3 50.9c-4 9.6-7.2 19.6-9.3 30c-1.1 5.2-1.9 10.5-2.4 15.9c-.3 2.7-.5 5.4-.6 8.1zM432 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 384a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M95.9 0l32.8 33.9C166.1 12.3 209.6 0 256 0c46.2 0 89.5 12.2 126.9 33.6L415.4 0l95.9 0 0 95.9-33.4 32.3C499.6 165.8 512 209.5 512 256c0 46.4-12.3 89.8-33.9 127.4l33.2 32.1L512 512l-96.6-.7-32.1-33.2C345.8 499.7 302.4 512 256 512c-46.5 0-90.2-12.4-127.8-34.1L95.9 511.3 0 511.3l0-95.9 33.6-32.5C12.2 345.5 0 302.2 0 256c0-46.4 12.3-89.9 33.9-127.4L0 95.9 0 0 95.9 0zM64 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM256 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM80 448a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 368a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faPersonDressSimple = {
    prefix: 'fasds',
    iconName: 'person-dress-simple',
    icon: [
      256,
      512,
      [],
      'e21c',
      
      ['M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64z','M192 160L64 160 0 384l64 0 0 128 128 0 0-128 64 0L192 160z']
      
    ]
  };

  

  
  

  var faCircleB = {
    prefix: 'fasds',
    iconName: 'circle-b',
    icon: [
      512,
      512,
      [],
      'e0fd',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C356.3 261.6 368 283.4 368 308c0 42-34 76-76 76l-108 0-24 0 0-24 0-80 0-24 0-24 0-80 0-24zm48 48l0 56 68 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-68 0zm0 104l0 56 84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0z','M184 128l-24 0 0 24 0 80 0 24 0 24 0 80 0 24 24 0 108 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76l-92 0zm92 104l-68 0 0-56 68 0c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-68 48l68 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-84 0 0-56z']
      
    ]
  };

  

  
  

  var faRightLong = {
    prefix: 'fasds',
    iconName: 'right-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-right"],
      'f30b',
      
      ['M0 192c64 0 128 0 192 0c42.7 0 85.3 0 128 0l0 128L0 320 0 192z','M352 416L512 256 352 96l-32 0s0 0 0 0l0 96 0 128 0 96 32 0z']
      
    ]
  };

  
    var faLongArrowAltRight = faRightLong;
  

  
  

  var faLaptopSlash = {
    prefix: 'fasds',
    iconName: 'laptop-slash',
    icon: [
      640,
      512,
      [],
      'e1c7',
      
      ['M0 384l365.5 0 121.8 96L48 480 0 432l0-48zM64 146.4l64 50.4L128 352l-64 0 0-205.6zM70.5 32L96 32l448 0 32 0 0 32 0 288-64 0 0-256L153 96 70.5 32zM523.9 384L640 384l0 48-23.7 23.7L523.9 384z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faCoin = {
    prefix: 'fasds',
    iconName: 'coin',
    icon: [
      512,
      512,
      [129689],
      'f85c',
      
      ['M0 208C0 128.5 114.6 64 256 64s256 64.5 256 144s-114.6 144-256 144S0 287.5 0 208zm64-8c0 20.5 10.5 36.7 22.6 48.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200zm32 0c0-35.3 71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64s-160-28.7-160-64z','M464 394.6c30.2-21 48-46.8 48-74.6l0-29.9c-13.2 15.6-29.7 29.3-48 40.9l0 63.7zM336 377.3l0 64.3c36.2-6 68.9-15.9 96-28.7l0-64.7c-28.4 13.2-60.9 23-96 29zM208 445.8c15.5 1.5 31.6 2.2 48 2.2s32.5-.8 48-2.2l0-64.1c-15.7 1.6-31.7 2.4-48 2.4s-32.3-.8-48-2.4l0 64.1zM80 348.3L80 413c27.1 12.8 59.8 22.7 96 28.7l0-64.3c-35.1-6-67.6-15.9-96-29zM48 331c-18.3-11.5-34.8-25.2-48-40.9L0 320c0 27.9 17.8 53.6 48 74.6L48 331zM64 200c0 20.5 10.5 36.7 22.6 48.2c12 11.4 27.7 20.1 44.4 26.8c33.6 13.4 77.8 21 125 21s91.4-7.6 125-21c16.7-6.7 32.4-15.4 44.4-26.8C437.5 236.7 448 220.5 448 200s-10.5-36.7-22.6-48.2c-12-11.4-27.7-20.1-44.4-26.8c-33.6-13.4-77.8-21-125-21s-91.4 7.6-125 21c-16.7 6.7-32.4 15.4-44.4 26.8C74.5 163.3 64 179.5 64 200zm192 64c-88.4 0-160-28.7-160-64s71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64z']
      
    ]
  };

  

  
  

  var faPowerOff = {
    prefix: 'fasds',
    iconName: 'power-off',
    icon: [
      512,
      512,
      [9211],
      'f011',
      
      ['M224 0l0 32 0 224 0 32 64 0 0-32 0-224 0-32L224 0z','M143.5 120.6C104.7 152.9 80 201.6 80 256c0 97.2 78.8 176 176 176s176-78.8 176-176c0-54.4-24.7-103.1-63.5-135.4l40.9-49.2C462.2 115.4 496 181.8 496 256c0 132.5-107.5 240-240 240S16 388.5 16 256c0-74.2 33.7-140.6 86.6-184.6l40.9 49.2z']
      
    ]
  };

  

  
  

  var faTicket = {
    prefix: 'fasds',
    iconName: 'ticket',
    icon: [
      576,
      512,
      [127903],
      'f145',
      
      ['M0 64L0 208c26.5 0 48 21.5 48 48s-21.5 48-48 48L0 448l576 0 0-144c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-144L0 64zm96 64l32 0 320 0 32 0 0 32 0 192 0 32-32 0-320 0-32 0 0-32 0-192 0-32zm32 32l0 192 320 0 0-192-320 0z','M448 160l0 192-320 0 0-192 320 0zM128 128l-32 0 0 32 0 192 0 32 32 0 320 0 32 0 0-32 0-192 0-32-32 0-320 0z']
      
    ]
  };

  

  
  

  var faSwordLaserAlt = {
    prefix: 'fasds',
    iconName: 'sword-laser-alt',
    icon: [
      512,
      512,
      [],
      'e03c',
      
      ['M197.1 256L480 0l32 32L309.3 256l-112.3 0z','M61.7 493.7L80 512l98.3-98.3L160 395.3 61.7 493.7zM50.3 482.3L148.7 384 128 363.3 29.7 461.7l20.7 20.7zm-32-32L116.7 352 98.3 333.7 0 432l18.3 18.3zm91.3-128l24 24 32 32 24 24L336 256l-160 0-66.3 66.3z']
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fasds',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      ['M16 208l96 0 0 96-96 0 0-96z','M112 48L16 48l0 96 96 0 0-96zm0 320l-96 0 0 96 96 0 0-96z']
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faRouter = {
    prefix: 'fasds',
    iconName: 'router',
    icon: [
      576,
      512,
      [],
      'f8da',
      
      ['M64 384l0 64 64 0 0-64-64 0zM166.9 69.9l31.7 36C239.5 69.8 293.2 48 352 48s112.5 21.8 153.4 57.9l31.7-36C487.8 26.4 422.9 0 352 0S216.2 26.4 166.9 69.9zm79.4 79.5l30.2 37.3C297.1 170 323.4 160 352 160s54.9 10 75.5 26.7l30.2-37.3C428.8 126 392 112 352 112s-76.8 14-105.7 37.4z','M376 248l0-24-48 0 0 24 0 72L0 320 0 512l576 0 0-192-200 0 0-72zM128 384l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64z']
      
    ]
  };

  

  
  

  var faWandSparkles = {
    prefix: 'fasds',
    iconName: 'wand-sparkles',
    icon: [
      512,
      512,
      [],
      'f72b',
      
      ['M0 144l56 24 24 56 24-56 56-24-56-24L80 64 56 120 0 144zM160 48l32 16 16 32 16-32 32-16L224 32 208 0 192 32 160 48zM352 368l56 24 24 56 24-56 56-24-56-24-24-56-24 56-56 24z','M80 512L0 432 128 316.8l0-60.8 67.6 0L480 0l32 32L416 138.7l0 53.3-48 0L80 512z']
      
    ]
  };

  

  
  

  var faSquareU = {
    prefix: 'fasds',
    iconName: 'square-u',
    icon: [
      448,
      512,
      [],
      'e281',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 144l48 0 0 24 0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120 0-24 48 0 0 24 0 120c0 53.6-37.7 98.4-88 109.4l0 2.6-24 0c-61.9 0-112-50.1-112-112l0-120 0-24z','M160 144l0 24 0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120 0-24 48 0 0 24 0 120c0 53.6-37.7 98.4-88 109.4l0 2.6-24 0c-61.9 0-112-50.1-112-112l0-120 0-24 48 0z']
      
    ]
  };

  

  
  

  var faPersonPregnant = {
    prefix: 'fasds',
    iconName: 'person-pregnant',
    icon: [
      384,
      512,
      [],
      'e31e',
      
      ['M144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M140.9 128l-18.1 0-9.3 15.5-76.9 128L20.1 298.9l54.9 33 16.5-27.4 4.6-7.6L96 384l24 0 0 96 0 32 64 0 0-32 0-96 8 0 8 0 0 96 0 32 64 0 0-32 0-96 40 0 48 0 0-64c0-46.8-33.4-85.7-77.7-94.3L256 128l-32 0-32 0-16 0-35.1 0z']
      
    ]
  };

  

  
  

  var faFlask = {
    prefix: 'fasds',
    iconName: 'flask',
    icon: [
      448,
      512,
      [],
      'f0c3',
      
      ['M0 422.9L0 432l0 48 0 32 32 0 384 0 32 0 0-32 0-48 0-9.1-4.7-7.7L320 214.9 320 64l32 0 0-64L320 0 288 0 160 0 128 0 96 0l0 64 32 0 0 150.9L4.7 415.2 0 422.9zm64 18.1c24.8-40.4 49.7-80.7 74.5-121.1c16.3-26.4 32.5-52.8 48.8-79.2l4.7-7.7 0-9.1 0-160 64 0 0 160 0 9.1 4.7 7.7c16.3 26.4 32.5 52.8 48.8 79.2L384 441.1l0 6.9L64 448l0-6.9z','M309.5 320l-171 0L64 441.1l0 6.9 320 0 0-6.9L309.5 320z']
      
    ]
  };

  

  
  

  var faSwordsLaser = {
    prefix: 'fasds',
    iconName: 'swords-laser',
    icon: [
      640,
      512,
      [],
      'e03d',
      
      ['M128 32L160 0 384 202.7l0 112.3L128 32zm91.6 203.6L247 210.8l51.9 56.7L224 350.3 224 240l-4.4-4.4zm124-112.2L480 0l32 32L390.5 166.3l-46.9-42.9z','M640 432l-18.3 18.3L523.3 352l18.3-18.3L640 432zM512 363.3l98.3 98.3-20.7 20.7L491.3 384 512 363.3zM560 512l-98.3-98.3L480 395.3l98.3 98.3L560 512zM474.3 378.3l-24 24L384 336l0-144 14.7-1.2L530.3 322.3l-24 24-32 32zM80 512L0 432 129.4 302.6l-8-8c-12.5-12.5-12.5-32.8 0-45.3c12.4-12.4 32.5-12.5 45-.2l8.2 8.2L208 224l16 16 0 128L80 512zM184 344a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faCentSign = {
    prefix: 'fasds',
    iconName: 'cent-sign',
    icon: [
      384,
      512,
      [],
      'e3f5',
      
      ['M192 0l0 32 0 34.7c10.4-1.7 21.1-2.7 32-2.7c1.4 0 2.7 0 4.1 0s2.7 .1 4.1 .1c2.7 .1 5.4 .3 8 .5c5.3 .4 10.6 1.1 15.8 2L256 32l0-32L192 0zm0 445.3l0 34.7 0 32 64 0 0-32 0-34.7c-10.4 1.7-21.1 2.7-32 2.7c-1.4 0-2.7 0-4.1 0s-2.7-.1-4.1-.1c-2.7-.1-5.4-.3-8.1-.5c-5.3-.4-10.6-1.1-15.8-2z','M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c41.9 0 79-20.1 102.4-51.2l51.2 38.4C342.6 417.8 286.8 448 224 448C118 448 32 362 32 256S118 64 224 64c62.8 0 118.6 30.2 153.6 76.8l-51.2 38.4C303 148.1 265.9 128 224 128z']
      
    ]
  };

  

  
  

  var faHamsa = {
    prefix: 'fasds',
    iconName: 'hamsa',
    icon: [
      512,
      512,
      [],
      'f665',
      
      ['M0 288l0 48L95.4 441c41.1 45.2 99.4 71 160.6 71s119.4-25.8 160.6-71L512 336l0-48-96 0 0-256-80 0 0 192-40 0L296 0 216 0l0 224-40 0 0-192L96 32l0 256L0 288zm160 64s48-64 96-64s96 64 96 64s-48 64-96 64s-96-64-96-64z','M224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z']
      
    ]
  };

  

  
  

  var faMapPin = {
    prefix: 'fasds',
    iconName: 'map-pin',
    icon: [
      320,
      512,
      [128205],
      'f276',
      
      ['M128 284.4c5.1 1.2 10.4 2.1 15.8 2.7c2.7 .3 5.3 .5 8.1 .7c1.3 .1 2.7 .1 4.1 .2c1.2 0 2.5 .1 4 .1c11 0 21.7-1.2 32-3.6L192 480l0 32-64 0 0-32 0-195.6z','M160 288A144 144 0 1 0 160 0a144 144 0 1 0 0 288zM96 144l-32 0c0-53 43-96 96-96l0 32c-35.3 0-64 28.7-64 64z']
      
    ]
  };

  

  
  

  var faCroissant = {
    prefix: 'fasds',
    iconName: 'croissant',
    icon: [
      512,
      512,
      [129360],
      'f7f6',
      
      ['M0 288c0 66.7 22.6 128 60.7 176.8L238.2 326.7 6.3 227.9C2.2 247.3 0 267.4 0 288zM227.9 6.3l98.9 231.9L464.8 60.7C416 22.6 354.7 0 288 0c-20.6 0-40.7 2.2-60.1 6.3z','M468.6 108L390 209l90 15 32-41.3c-10.2-27.4-25-52.7-43.4-74.7zM209 390l15 90-41.3 32c-27.4-10.2-52.7-25-74.7-43.4L209 390zM0 190.4C30.2 100.9 100.9 30.3 190.4 0L306.4 272 272 306.4 0 190.4z']
      
    ]
  };

  

  
  

  var faNetworkWired = {
    prefix: 'fasds',
    iconName: 'network-wired',
    icon: [
      640,
      512,
      [],
      'f6ff',
      
      ['M0 224l0 64 32 0 96 0 0 32 64 0 0-32 256 0 0 32 64 0 0-32 96 0 32 0 0-64-32 0-256 0 0-32-64 0 0 32L32 224 0 224z','M384 64l0 64-128 0 0-64 128 0zM256 0L192 0l0 64 0 64 0 64 64 0 128 0 64 0 0-64 0-64 0-64L384 0 256 0zM224 384l0 64L96 448l0-64 128 0zM96 320l-64 0 0 64 0 64 0 64 64 0 128 0 64 0 0-64 0-64 0-64-64 0L96 320zm320 64l128 0 0 64-128 0 0-64zm-64-64l0 64 0 64 0 64 64 0 128 0 64 0 0-64 0-64 0-64-64 0-128 0-64 0z']
      
    ]
  };

  

  
  

  var faFolderTree = {
    prefix: 'fasds',
    iconName: 'folder-tree',
    icon: [
      576,
      512,
      [],
      'f802',
      
      ['M0 0L0 32l0 96L0 416l0 32 32 0 256 0 0-64L64 384l0-224 224 0 0-64L64 96l0-64L64 0 0 0z','M288 0l0 224 288 0 0-192L432 32 400 0 288 0zm0 288l0 224 288 0 0-192-144 0-32-32-112 0z']
      
    ]
  };

  

  
  

  var faPeople = {
    prefix: 'fasds',
    iconName: 'people',
    icon: [
      640,
      512,
      [],
      'e216',
      
      ['M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm320 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M91.4 128l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-33.8-53L232 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-227.8-33.8 53L.2 270.8 82 142.8 91.4 128zm320 0l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-42-65.8L592 384l-40 0 0 96 0 32-64 0 0-32 0-96-16 0 0 96 0 32-64 0 0-32 0-96-40 0 48.2-144.6-42 65.8-53.9-34.4 81.7-128 9.4-14.8z']
      
    ]
  };

  

  
  

  var faCauldron = {
    prefix: 'fasds',
    iconName: 'cauldron',
    icon: [
      448,
      512,
      [],
      'f6bf',
      
      ['M96 160l0 160 64 0 0-160-64 0zM128 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M35.1 224C16.5 257 0 297.1 0 334.4c0 37.4 11.9 69.4 32 95.5L32 512l48 0 0-39c40.4 25.5 91.8 39 144 39s103.6-13.5 144-39l0 39 48 0 0-82.1c20.1-26.1 32-58.1 32-95.5c0-37.3-16.5-77.4-35.1-110.4l35.1 0 0-64-80 0-144 0-64 0 0 160-64 0 0-160-16 0L0 160l0 64 35.1 0z']
      
    ]
  };

  

  
  

  var faSliders = {
    prefix: 'fasds',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      ['M0 64l0 64 32 0 64 0 0-64L32 64 0 64zM0 224l0 64 32 0 256 0 0-64L32 224 0 224zM0 384l0 64 32 0 32 0 0-64-32 0L0 384zm224 0l0 64 256 0 32 0 0-64-32 0-256 0zM256 64l0 64 224 0 32 0 0-64-32 0L256 64zM448 224l0 64 32 0 32 0 0-64-32 0-32 0z','M112 384l64 0 0 64-64 0 0-64zM64 448l0 48 48 0 64 0 48 0 0-48 0-64 0-48-48 0-64 0-48 0 0 48 0 64zM336 224l64 0 0 64-64 0 0-64zm-48 64l0 48 48 0 64 0 48 0 0-48 0-64 0-48-48 0-64 0-48 0 0 48 0 64zM144 128l0-64 64 0 0 64-64 0zM96 176l48 0 64 0 48 0 0-48 0-64 0-48-48 0-64 0L96 16l0 48 0 64 0 48z']
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faOutlet = {
    prefix: 'fasds',
    iconName: 'outlet',
    icon: [
      448,
      512,
      [],
      'e01c',
      
      ['M64 256c0 88 64 128 64 128l192 0s64-40 64-128s-64-128-64-128l-192 0s-64 40-64 128zm80-64l32 0 0 16 0 48 0 16-32 0 0-16 0-48 0-16zm56 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24-48 0 0-24zm72-120l32 0 0 16 0 48 0 16-32 0 0-16 0-48 0-16z','M448 32L0 32 0 480l448 0 0-448zM64 256c0-88 64-128 64-128l192 0s64 40 64 128s-64 128-64 128l-192 0s-64-40-64-128z']
      
    ]
  };

  

  
  

  var faFilterList = {
    prefix: 'fasds',
    iconName: 'filter-list',
    icon: [
      512,
      512,
      [],
      'e17c',
      
      ['M0 64l0 64L112 256l0 128 128 96 0-224L352 128l0-64L0 64z','M416 64l64 0 32 0 0 64-32 0-64 0-32 0 0-64 32 0zM320 224l32 0 128 0 32 0 0 64-32 0-128 0-32 0 0-64zm0 160l32 0 128 0 32 0 0 64-32 0-128 0-32 0 0-64z']
      
    ]
  };

  

  
  

  var faKhanda = {
    prefix: 'fasds',
    iconName: 'khanda',
    icon: [
      512,
      512,
      [9772],
      'f66d',
      
      ['M192 48L256 0l64 48s-6.6 10.6-14.5 27.5c-5.7 12.3-12.1 28-17.1 45.3c-4.9 17.3-8.4 36.2-8.4 55.2s3.5 37.9 8.4 55.2c4.9 17.3 11.3 33 17.1 45.3C313.4 293.4 320 304 320 304l-48 36 0 22.6-16 11-16-11 0-22.6-48-36s6.6-10.6 14.5-27.5c5.7-12.3 12.1-28 17.1-45.3c4.9-17.3 8.4-36.2 8.4-55.2s-3.5-37.9-8.4-55.2c-4.9-17.3-11.3-33-17.1-45.3C198.6 58.6 192 48 192 48zm32 432c0-11.8 6.4-22.2 16-27.7l0-28.9 16-11c5.3 3.7 10.7 7.3 16 11l0 28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32z','M128 48c-17.3 25.9-32 85.1-32 132.6c0 75.4 52.2 118.9 109.4 158.2l.1 .1L256 373.6l50.5-34.7 .1-.1C363.8 299.5 416 256 416 180.6c0-47.6-14.7-106.7-32-132.6c0 0 128 54.5 128 176c0 96-112 192-112 192l-83.4-45.3L284.2 393l46.1 31.7c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L256 412.4 199.8 451c-1.5 11.8-11.6 21-23.8 21c-13.3 0-24-10.7-24-24s10.7-24 24-24c2 0 3.9 .2 5.7 .7L227.8 393l-32.4-22.3L112 416s-112-96-112-192C0 102.5 128 48 128 48zm16 128c0-44.1 25.5-82.2 62.5-100.5c5.7 12.3 12.1 28 17.1 45.3C204.7 131.9 192 152.5 192 176s12.7 44.1 31.6 55.2c-4.9 17.3-11.3 33-17.1 45.3C169.5 258.2 144 220.1 144 176zm176 0c0-23.5-12.7-44.1-31.6-55.2c4.9-17.3 11.3-33 17.1-45.3C342.5 93.8 368 131.9 368 176s-25.5 82.2-62.5 100.5c-5.7-12.3-12.1-28-17.1-45.3C307.3 220.1 320 199.5 320 176z']
      
    ]
  };

  

  
  

  var faOlive = {
    prefix: 'fasds',
    iconName: 'olive',
    icon: [
      448,
      512,
      [],
      'e316',
      
      ['M264.3 114.6c-.3 5.9-.4 14 .4 23.1c1.7 18.2 7.2 40.1 22.3 55.3c19.5 19.5 50.4 23 69.8 23c10.7 0 18-1.1 18-1.1s8.4-57.5-21.9-87.8c-15.2-15.2-37.1-20.6-55.3-22.3c-9.1-.8-17.2-.8-23.1-.4c-2.9 .2-5.3 .4-6.9 .5c-1.6 .2-2.5 .3-2.5 .3c0 .1-.1 1-.3 2.5c-.2 1.6-.4 4-.5 6.9z','M160 480C71.6 480 0 408.4 0 320C0 128 181.9 32 280 32c56 0 112 56 112 56s56 56 56 112c0 98.1-96 280-288 280zM287.1 192.9c30.3 30.3 87.8 21.9 87.8 21.9s8.4-57.5-21.9-87.8s-87.8-21.9-87.8-21.9s-8.4 57.5 21.9 87.8z']
      
    ]
  };

  

  
  

  var faHoneyPot = {
    prefix: 'fasds',
    iconName: 'honey-pot',
    icon: [
      448,
      512,
      [127855],
      'e418',
      
      ['M0 224l448 0c0 50.4-10.5 93-25.5 128l-397 0C10.5 317 0 274.4 0 224zM128 32l48 0 0 104 0 24-48 0 0-24 0-104z','M64 32l64 0 0 104 0 24 48 0 0-24 0-104 208 0 32 0 0 64-32 0c38.9 29.2 64 75.7 64 128L0 224c0-52.3 25.1-98.8 64-128L32 96l0-64 32 0zM25.5 352l397 0C385.2 439.3 320 480 320 480l-192 0s-65.2-40.7-102.5-128z']
      
    ]
  };

  

  
  

  var faCoins = {
    prefix: 'fasds',
    iconName: 'coins',
    icon: [
      512,
      512,
      [],
      'f51e',
      
      ['M128 80c0 18 14.3 34.6 38.4 48c.4 .2 .7 .4 1.1 .6c8.1-.4 16.3-.6 24.5-.6c56.2 0 108.6 9.4 148.1 25.9c3.8 1.6 7.6 3.3 11.3 5c49.8-3.4 93.2-14.8 122.3-30.9C497.7 114.6 512 98 512 80c0-44.2-86-80-192-80S128 35.8 128 80zM391.9 186.6C405.4 200.1 416 218.1 416 240l0 5.3c19.9-4.8 37.6-11.1 52.2-18.4c1.9-.9 3.7-1.9 5.5-2.9c24.1-13.4 38.4-30 38.4-48l0-35.4c-12.5 10.3-27.6 18.7-43.9 25.5c-21.9 9.1-47.8 16.1-76.2 20.5zM416 278.1l0 63.2c57.4-13.8 96-39.7 96-69.3l0-35.4c-12.5 10.3-27.6 18.7-43.9 25.5c-15.6 6.5-33.1 11.9-52.1 16z','M384 240c0 18-14.3 34.6-38.4 48c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-44.2 86-80 192-80s192 35.8 192 80zM192 352c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352zm148.1 70.1c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448s108.6-9.4 148.1-25.9z']
      
    ]
  };

  

  
  

  var faMountainCity = {
    prefix: 'fasds',
    iconName: 'mountain-city',
    icon: [
      640,
      512,
      [],
      'e52e',
      
      ['M288 0l0 144.4L357.7 256l58.3 0 0 64-18.3 0L507.1 495l10.6 17L640 512l0-320-72 0 0-72 0-24-48 0 0 24 0 72-40 0L480 0 288 0zm64 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm160 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M450 464l30 48-56.6 0L56.6 512 0 512l30-48L211.7 173.3 240 128l28.3 45.3L450 464zM303.4 320L240 218.6 161.8 343.7 192 384l48-64 63.4 0z']
      
    ]
  };

  

  
  

  var faFluxCapacitor = {
    prefix: 'fasds',
    iconName: 'flux-capacitor',
    icon: [
      448,
      512,
      [],
      'f8ba',
      
      ['M0 32l448 0 0 448L0 480 0 32zM48 160c0 44.2 35.8 80 80 80c16.3 0 31.5-4.9 44.1-13.3c12 12 23.9 23.9 35.9 35.9l0 11c-36.5 7.4-64 39.7-64 78.4c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4l0-11 35.9-35.9c12.6 8.4 27.8 13.3 44.1 13.3c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80c0 16.3 4.9 31.5 13.3 44.1c-9.8 9.8-19.5 19.5-29.3 29.3c-9.8-9.8-19.5-19.5-29.3-29.3c8.4-12.6 13.3-27.8 13.3-44.1c0-44.2-35.8-80-80-80s-80 35.8-80 80z','M171.3 180.7c3-6.3 4.7-13.3 4.7-20.7c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48c7.4 0 14.4-1.7 20.7-4.7L208 262.6l0 44.1c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-44.1 59.3-59.3c6.3 3 13.3 4.7 20.7 4.7c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7L224 233.4l-52.7-52.7z']
      
    ]
  };

  

  
  

  var faBatteryHalf = {
    prefix: 'fasds',
    iconName: 'battery-half',
    icon: [
      576,
      512,
      ["battery-3"],
      'f242',
      
      ['M0 96l64 0 416 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0L64 416 0 416l0-64L0 160 0 96zm64 64l0 192 416 0 0-192L64 160z','M96 192h192v128H96V192z']
      
    ]
  };

  
    var faBattery3 = faBatteryHalf;
  

  
  

  var faBoltAuto = {
    prefix: 'fasds',
    iconName: 'bolt-auto',
    icon: [
      576,
      512,
      [],
      'e0b6',
      
      ['M0 288L304 0 253.8 200.8 416 224 112 512l50.2-200.8L0 288z','M492.7 480l13.7 32 69.6 0L480 288l-64 0L320 512l69.6 0 13.7-32 89.3 0zm-27.4-64l-34.5 0L448 375.8 465.2 416z']
      
    ]
  };

  

  
  

  var faIndustryWindows = {
    prefix: 'fasds',
    iconName: 'industry-windows',
    icon: [
      576,
      512,
      [127981,"industry-alt"],
      'f3b3',
      
      ['M32 32l128 0 0 178.1 0 13.9 0 41.4c64-36.6 128-73.1 192-109.7l0 54.4 0 13.9 0 41.4c64-36.6 128-73.1 192-109.7l0 68.4 0 256L32 480l0-96 0-160L32 32zm88 280l0 80 80 0 0-80c-26.7 0-53.3 0-80 0zm128 0l0 80 80 0 0-80c-26.7 0-53.3 0-80 0zm128 0l0 80 80 0 0-80c-26.7 0-53.3 0-80 0z','M160 265.4L363.9 148.8l-23.8-41.7L160 210.1l0 55.3zm192 0L555.9 148.8l-23.8-41.7L352 210.1l0 55.3zM200 392l0-80-80 0 0 80 80 0zm128-80l-80 0 0 80 80 0 0-80zm48 0l0 80 80 0 0-80-80 0z']
      
    ]
  };

  
    var faIndustryAlt = faIndustryWindows;
  

  
  

  var faCarMirrors = {
    prefix: 'fasds',
    iconName: 'car-mirrors',
    icon: [
      576,
      512,
      [],
      'e343',
      
      ['M32 400l0 80 96 0 0-80-96 0zM141.1 192l293.8 0L401.3 96 174.7 96c-11.2 32-22.4 64-33.6 96zM448 400l0 80 96 0 0-80-96 0z','M152 32l-22.7 0-7.5 21.4L84.5 160 0 160l0 64 32 0 0 176 512 0 0-176 32 0 0-64-84.5 0L454.2 53.4 446.7 32 424 32 152 32zM434.9 192l-293.8 0 33.6-96 226.6 0 33.6 96zM96 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faRacquet = {
    prefix: 'fasds',
    iconName: 'racquet',
    icon: [
      512,
      512,
      [],
      'f45a',
      
      ['M0 448l96-96c3.1 3.1 6.3 6.3 9.4 9.4c15.1 15.1 30.2 30.2 45.3 45.3c3.1 3.1 6.2 6.2 9.4 9.4L64 512 0 448z','M240.2 112.2C272.6 79.8 312.9 64 349 64c28.2 0 53.2 9.6 71.3 27.7S448 134.9 448 163c0 36-15.8 76.4-48.2 108.8c-59.4 59.4-139.7 60.9-180.1 20.5C201.6 274.1 192 249.1 192 221c0-36 15.8-76.4 48.2-108.8zM349 0c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 32.4 8.4 64.2 26.2 91.6l-48.8 48.8 45.3 45.3 48.8-48.8c73.3 48.1 177.5 27.4 245.7-40.8c43.6-43.6 67-99.8 66.9-154c0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0z']
      
    ]
  };

  

  
  

  var faPiggyBank = {
    prefix: 'fasds',
    iconName: 'piggy-bank',
    icon: [
      576,
      512,
      [],
      'f4d3',
      
      ['M208 96c0 13.2 2.7 25.7 7.5 37.2c12.9-3.4 26.5-5.2 40.5-5.2l128 0c1.8 0 3.5 0 5.2 .1s3.5 .1 5.2 .2c3.6-10.1 5.6-21 5.6-32.3c0-53-43-96-96-96s-96 43-96 96z','M512 96l-18.8 75.1c15.8 14.8 28.7 32.8 37.5 52.9l45.3 0 0 160-64 0c-9.1 12.1-19.9 22.9-32 32l0 96-96 0 0-64-128 0 0 64-96 0 0-96c-34.9-26.2-58.7-66.3-63.2-112L68 304c-37.6 0-68-30.4-68-68s30.4-68 68-68l12 0 0 48-12 0c-11 0-20 9-20 20s9 20 20 20l31.2 0C114 183 178.6 128 256 128l128 0c7.8 0 15.5 .6 23 1.6C424.6 109.1 450.8 96 480 96l32 0zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faCarBump = {
    prefix: 'fasds',
    iconName: 'car-bump',
    icon: [
      640,
      512,
      [],
      'f5e0',
      
      ['M400 512l221.7 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96z','M86.3 70.1L65.1 75.8 62.7 97.6 48.3 229.4 7.6 240.3 57.3 425.8 78 503l92.7-24.8L150 400.9l278.2-74.5 20.7 77.3 92.7-24.8L521 301.5 471.3 116.1 430.6 127 352.2 20 339.2 2.4 318.1 8 86.3 70.1zm278 74.6L114.6 211.6l9.3-85.3L313.5 75.5l50.8 69.2zM94.3 316.5a32 32 0 1 1 61.8-16.6A32 32 0 1 1 94.3 316.5zM395.1 202.7a32 32 0 1 1 16.6 61.8 32 32 0 1 1 -16.6-61.8z']
      
    ]
  };

  

  
  

  var faSushiRoll = {
    prefix: 'fasds',
    iconName: 'sushi-roll',
    icon: [
      448,
      512,
      ["maki-roll","makizushi"],
      'e48b',
      
      ['M85.2 175.9c10.1 7 23.4 13.2 39.2 18.2l35.2-32.6 74.9-26.4 8.9 19.4 3.4 7.5 7.7 2.9 73.7 27.6c20-6.9 35.7-15.7 45.3-25.8l-97.2-36.4L253.8 81.1c-9.7-.7-19.6-1.1-29.8-1.1c-4.9 0-9.8 .1-14.6 .3l8.4 18.3-75.3 26.5-3.9 1.4-3 2.8L85.2 175.9z','M448 368l0-224C448 82.1 347.7 32 224 32S0 82.1 0 144L0 368s48 112 224 112s224-112 224-112zM224 208c-88.4 0-160-28.7-160-64s71.6-64 160-64s160 28.7 160 64s-71.6 64-160 64z']
      
    ]
  };

  
    var faMakiRoll = faSushiRoll;
  
    var faMakizushi = faSushiRoll;
  

  
  

  var faFaceHeadBandage = {
    prefix: 'fasds',
    iconName: 'face-head-bandage',
    icon: [
      576,
      512,
      [],
      'e37a',
      
      ['M59.8 372.2C102.2 455.2 188.5 512 288 512c141.4 0 256-114.6 256-256c0-8.2-.4-16.4-1.1-24.4l-15-4.5C451.9 204.3 371.4 192 288 192c-14.1 0-28 .3-41.9 1c-9.4 5.3-18.6 10.8-27.6 16.6c12.7 4.2 21.9 16.2 21.9 30.4c0 17.7-14.3 32-32 32s-32-14.3-32-32c-40.5 32.4-76 70.8-105.1 114c-1.2 1.8-2.8 4.4-4.7 7.5c-2 3.2-4.3 6.9-6.7 10.7zm40-289.8c36.2-7.2 73.1-12.4 110.7-15.4c49.3-24.6 102.2-43 157.7-54.3C342.9 4.5 316 0 288 0C213.6 0 146.6 31.8 99.8 82.4zM235.9 347.6l15.3-4.8c13.4-4.2 28.4-6.8 44.8-6.8c44.2 0 77.2 18.3 98.8 37.9l11.8 10.8-21.5 23.7-11.8-10.8C356.4 382.2 330.8 368 296 368c-13.1 0-24.8 2-35.2 5.3l-15.3 4.8-9.6-30.5zM400.4 240a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M476.2 82.4c-16.4-17.8-35.3-33.2-56.1-45.7c-41.3 5.1-81.2 14.4-119.5 27.4c60 .8 118.7 7.1 175.6 18.4zM506 121.8c-32.7-7.9-66.1-14-100.1-18.3C367.3 98.5 328 96 288 96c-23.1 0-46.1 .8-68.8 2.5c-51 3.7-100.9 11.6-149.3 23.2c-14.1 22.8-24.6 47.9-31 74.7c19.1-5.7 38.5-10.8 58.1-15.3c45.4-10.2 92.2-16.9 140-19.7c16.9-1 33.8-1.5 51-1.5c86.6 0 170.2 12.7 249 36.4c-6.4-26.8-17-51.9-31-74.7zM177 199.3c-43.4 5.8-85.7 14.9-126.6 27.1c-6.2 6.7-12.3 13.5-18.2 20.5c-.1 3-.2 6.1-.2 9.1c0 28 4.5 54.9 12.8 80.1c35.7-52.9 80.5-99.3 132.2-136.7zm41.6 10.3c-14.6 9.4-28.6 19.6-42.1 30.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-14.1-9.2-26.1-21.9-30.4zM368.4 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faCircleLocationArrow = {
    prefix: 'fasds',
    iconName: 'circle-location-arrow',
    icon: [
      512,
      512,
      ["location-circle"],
      'f602',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm86.3-11.3c94.3-33.9 188.6-67.9 282.8-101.8c-33.9 94.3-67.9 188.6-101.8 282.8L233.4 278.6 86.3 244.7z','M86.3 244.7l147.1 33.9 33.9 147.1L369.1 142.9 86.3 244.7z']
      
    ]
  };

  
    var faLocationCircle = faCircleLocationArrow;
  

  
  

  var faFolderHeart = {
    prefix: 'fasds',
    iconName: 'folder-heart',
    icon: [
      512,
      512,
      [],
      'e189',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM144 251.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L256 384.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z','M203.2 192c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 384.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z']
      
    ]
  };

  

  
  

  var faPlaneUp = {
    prefix: 'fasds',
    iconName: 'plane-up',
    icon: [
      512,
      512,
      [],
      'e22d',
      
      ['M0 288l0 96 192-64 0-160L0 288zM320 160l0 160 192 64 0-96L320 160z','M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7L320 400l64 48 0 64L256 480 128 512l0-64 64-48 0-306.3z']
      
    ]
  };

  

  
  

  var faMobileScreen = {
    prefix: 'fasds',
    iconName: 'mobile-screen',
    icon: [
      384,
      512,
      ["mobile-android-alt"],
      'f3cf',
      
      ['M16 0L368 0l0 512L16 512 16 0zM80 64l0 320 224 0 0-320L80 64zm64 368l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0z','M80 64H304V384H80V64z']
      
    ]
  };

  
    var faMobileAndroidAlt = faMobileScreen;
  

  
  

  var faBellSchool = {
    prefix: 'fasds',
    iconName: 'bell-school',
    icon: [
      512,
      512,
      [],
      'f5d5',
      
      ['M0 208a208 208 0 1 0 416-.2A208 208 0 1 0 0 208zm288 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M208 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 256c55.9 0 106.6-22 144-57.9L352 464l88 0 0-22.4c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48c0 17.8-9.7 33.3-24 41.6l0 46.4 0 24-24 0-112 0L64 512l0-153.9C101.4 394 152.1 416 208 416z']
      
    ]
  };

  

  
  

  var faTemperatureThreeQuarters = {
    prefix: 'fasds',
    iconName: 'temperature-three-quarters',
    icon: [
      320,
      512,
      ["temperature-3","thermometer-3","thermometer-three-quarters"],
      'f2c8',
      
      ['M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L272 64l0-64L208 0 112 0 48 0l0 64 0 213.5C28 302.2 16 333.7 16 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L112 300.2l0-22.7L112 64l96 0 0 213.5 0 22.7 14.2 17.6C233.4 331.5 240 348.9 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M176 176l0-16-32 0 0 16 0 146.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L176 176z']
      
    ]
  };

  
    var faTemperature3 = faTemperatureThreeQuarters;
  
    var faThermometer3 = faTemperatureThreeQuarters;
  
    var faThermometerThreeQuarters = faTemperatureThreeQuarters;
  

  
  

  var faBoxingGlove = {
    prefix: 'fasds',
    iconName: 'boxing-glove',
    icon: [
      448,
      512,
      [129354,"glove-boxing"],
      'f438',
      
      ['M32 400l131.2 0-28 18.7-13.3 8.9 17.8 26.6 13.3-8.9L192 419.2l39.1 26.1 13.3 8.9 17.8-26.6-13.3-8.9-28-18.7L352 400l0 112L32 512l0-112z','M384 0L0 0 0 352l32 32 0 16 131.2 0-28-18.7-13.3-8.9 17.8-26.6 13.3 8.9L192 380.8l39.1-26.1 13.3-8.9 17.8 26.6-13.3 8.9-28 18.7L352 400l0-16 96-96 0-128-16 0-48 0-80 0 0 32 0 64 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-80-160 0-5.3 0-4.3-3.2-32-24-12.8-9.6 19.2-25.6 12.8 9.6L117.3 160 272 160l0-16 0-16 16 0 96 0L384 0z']
      
    ]
  };

  
    var faGloveBoxing = faBoxingGlove;
  

  
  

  var faHouseChimneyMedical = {
    prefix: 'fasds',
    iconName: 'house-chimney-medical',
    icon: [
      576,
      512,
      ["clinic-medical"],
      'f7f2',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16L288 88C213.3 149.3 138.7 210.6 64 272zm128 16l64 0 0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64z','M0 240L288 0 416 106.7 416 32l96 0 0 154.7L576 240l0 32-64 0L288 88 64 272 0 272l0-32zm256 48l0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0z']
      
    ]
  };

  
    var faClinicMedical = faHouseChimneyMedical;
  

  
  

  var faCards = {
    prefix: 'fasds',
    iconName: 'cards',
    icon: [
      640,
      512,
      [],
      'e3ed',
      
      ['M320 64l0 50.3c48.3 83.7 96.6 167.4 144.9 251L320 449l0 63 320 0 0-448L320 64zM473.9 187.6c-14-14.5-13.2-38.5 2.5-51.9c13.5-11.7 34.2-9.5 46.7 3.2l5 5.2 4.7-5.2c12.5-12.7 33-15 46.9-3.2c15.5 13.5 16.2 37.5 2.2 51.9l-54 55.8-54.1-55.8z','M464.9 365.4L210.9 512 0 146.7 254 0 464.9 365.4zM176.8 154.2l-12.6 47.1-20.4 76.1c-7 26 8.5 52.7 34.4 59.7s52.7-8.5 59.7-34.4l2.7-10 17.8 30.8-12.1 7-12.1 7 13.9 24.1 12.1-7 12.1-7 24.1-13.9 12.1-7 12.1-7-13.9-24.1-12.1 7-12.1 7-17.7-30.7 10 2.7c26 7 52.7-8.5 59.7-34.4s-8.5-52.7-34.4-59.7l-76.1-20.4-47.1-12.6z']
      
    ]
  };

  

  
  

  var faLocationDotSlash = {
    prefix: 'fasds',
    iconName: 'location-dot-slash',
    icon: [
      640,
      512,
      ["map-marker-alt-slash"],
      'f605',
      
      ['M128.1 196.9C133.5 310 320 512 320 512s39.1-42.4 82.1-99.2L128.1 196.9zM153.5 96.4l90.6 70.3C254.7 134.9 284.7 112 320 112c44.2 0 80 35.8 80 80c0 28.2-14.6 53-36.7 67.3l94.2 73.2C488.3 282.6 512 231.4 512 192C512 86 426 0 320 0C248.8 0 186.6 38.8 153.5 96.4z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faMapMarkerAltSlash = faLocationDotSlash;
  

  
  

  var faCaretDown = {
    prefix: 'fasds',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      ['M160 384L0 240l0-48 320 0 0 48L160 384z','']
      
    ]
  };

  

  
  

  var faBallot = {
    prefix: 'fasds',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      ['M0 0L0 512l448 0L448 0 0 0zM64 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zM192 112l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 128l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 128l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32z','M64 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zm64 128l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faUsbDrive = {
    prefix: 'fasds',
    iconName: 'usb-drive',
    icon: [
      640,
      512,
      [],
      'f8e9',
      
      ['M480 128l160 0 0 256-160 0 0-256zm56 56l0 48 48 0 0-48-48 0zm0 96l0 48 48 0 0-48-48 0z','M0 96H480V416H0V96z']
      
    ]
  };

  

  
  

  var faArrowsFromDottedLine = {
    prefix: 'fasds',
    iconName: 'arrows-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a3',
      
      ['M0 224l64 0 0 64L0 288l0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M128 96L224 0l96 96 0 32-64 0 0 32 0 32-64 0 0-32 0-32-64 0 0-32zM256 320l0 32 0 16 0 16 64 0 0 32-96 96-96-96 0-32 64 0 0-16 0-16 0-32 64 0z']
      
    ]
  };

  

  
  

  var faKeyboard = {
    prefix: 'fasds',
    iconName: 'keyboard',
    icon: [
      576,
      512,
      [9000],
      'f11c',
      
      ['M0 64L0 448l576 0 0-384L0 64zm64 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l256 0 0 64-256 0 0-64zm96-192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M128 128l-64 0 0 64 64 0 0-64zm0 96l-64 0 0 64 64 0 0-64zM64 320l0 64 64 0 0-64-64 0zM224 128l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm160-96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm160-96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm160-96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faTimeline = {
    prefix: 'fasds',
    iconName: 'timeline',
    icon: [
      640,
      512,
      [],
      'e29c',
      
      ['M0 224l0 64 32 0 256 0 0 48 8 0 48 0 8 0 0-48 256 0 32 0 0-64-32 0-64 0 0-48-8 0-48 0-8 0 0 48-320 0 0-48-8 0-48 0-8 0 0 48-64 0L0 224z','M152 72l0 48-48 0 0-48 48 0zM104 16L48 16l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0zM536 72l0 48-48 0 0-48 48 0zM488 16l-56 0 0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0zM296 392l48 0 0 48-48 0 0-48zm-56-56l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0z']
      
    ]
  };

  

  
  

  var faS = {
    prefix: 'fasds',
    iconName: 's',
    icon: [
      320,
      512,
      [115],
      '53',
      
      ['M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0s0 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3L-8.5 436.3l20.2-60.7 30.4 10.1c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4l30.9 8.2-16.5 61.8-30.9-8.2c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z','']
      
    ]
  };

  

  
  

  var faOverline = {
    prefix: 'fasds',
    iconName: 'overline',
    icon: [
      448,
      512,
      [],
      'f876',
      
      ['M400 304A176 176 0 1 1 48 304a176 176 0 1 1 352 0zm-288 0a112 112 0 1 0 224 0 112 112 0 1 0 -224 0z','M0 32l32 0 384 0 32 0 0 64-32 0L32 96 0 96 0 32z']
      
    ]
  };

  

  
  

  var faSquareUpLeft = {
    prefix: 'fasds',
    iconName: 'square-up-left',
    icon: [
      448,
      512,
      [],
      'e282',
      
      ['M0 32L0 480l448 0 0-448L0 32zM128 160l160 0 24 24-52 52 76 76-56 56-76-76-52 52-24-24 0-160z','M152 344l-24-24 0-160 160 0 24 24-52 52 76 76-56 56-76-76-52 52z']
      
    ]
  };

  

  
  

  var faBaseballBatBall = {
    prefix: 'fasds',
    iconName: 'baseball-bat-ball',
    icon: [
      512,
      512,
      [],
      'f432',
      
      ['M55.3 405.4c17.1 17.1 34.2 34.2 51.3 51.3l51.9-51.9c9.6-9.6 20.3-18.2 31.9-25.5c9.2-5.8 18.4-11.6 27.6-17.4c-22.6-22.6-45.2-45.2-67.9-67.9c-5.8 9.2-11.6 18.4-17.4 27.6c-7.3 11.5-15.8 22.2-25.5 31.9L55.3 405.4zM352 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M408.9 7.1l-5.7-5.7-5.7 5.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6l-55.7 88.2 67.9 67.9 88.2-55.7c12.5-7.9 24.1-17.2 34.6-27.7L504.9 114.5l5.7-5.7-5.7-5.7-96-96zM50.9 401l-17-17L0 417.9l17 17 60.2 60.2 17 17L128 478.1l-17-17L50.9 401z']
      
    ]
  };

  

  
  

  var faPenNibSlash = {
    prefix: 'fasds',
    iconName: 'pen-nib-slash',
    icon: [
      640,
      512,
      [],
      'e4a1',
      
      ['M64 448l20.7 20.7 144-144c-3-6.3-4.7-13.3-4.7-20.7c0-9.4 2.7-18.2 7.4-25.7l-87.8-69.2L64 448zm43.3 43.3L128 512l281.1-93.7L306.4 337.4c-8.7 9-20.9 14.6-34.4 14.6c-7.4 0-14.4-1.7-20.7-4.7l-144 144zM212.8 142.4L446.7 324 480 224l.7-.7-128-128L352 96 212.8 142.4zM375.3 72.7l128 128L576 128 448 0 375.3 72.7z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faListRadio = {
    prefix: 'fasds',
    iconName: 'list-radio',
    icon: [
      512,
      512,
      [],
      'e1d0',
      
      ['M160 64l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zm0 160l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zm0 160l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64z','M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faLampStreet = {
    prefix: 'fasds',
    iconName: 'lamp-street',
    icon: [
      512,
      512,
      [],
      'e1c5',
      
      ['M0 176L0 512l64 0 0-336c0-61.9 50.1-112 112-112s112 50.1 112 112l0 18.7c10.4-1.7 21.1-2.7 32-2.7c1.4 0 2.7 0 4.1 0s2.7 .1 4.1 .1c2.7 .1 5.4 .3 8.1 .5c5.3 .4 10.6 1.1 15.8 2l0-18.7C352 78.8 273.2 0 176 0S0 78.8 0 176zM256 384c0 35.3 28.7 64 64 64s64-28.7 64-64l-128 0z','M320 192c-106 0-192 86-192 192H512c0-106-86-192-192-192z']
      
    ]
  };

  

  
  

  var faCloudSleet = {
    prefix: 'fasds',
    iconName: 'cloud-sleet',
    icon: [
      512,
      512,
      [],
      'f741',
      
      ['M0 512l48 0 72-160-48 0L0 512zM128 392l0 48 24 0 16 0 0 16 0 24 48 0 0-24 0-16 16 0 24 0 0-48-24 0-16 0 0-16 0-24-48 0 0 24 0 16-16 0-24 0zM256 512l48 0 72-160-48 0L256 512zM384 392l0 48 24 0 16 0 0 16 0 24 48 0 0-24 0-16 16 0 24 0 0-48-24 0-16 0 0-16 0-24-48 0 0 24 0 16-16 0-24 0z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faFaucet = {
    prefix: 'fasds',
    iconName: 'faucet',
    icon: [
      512,
      512,
      [],
      'e005',
      
      ['M0 256L0 384l132.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-88.4-71.6-160-160-160l-32 0-32-32-32 0 0-76.8L224 144l-32 3.2 0 76.8-32 0-32 32L0 256zM192 64l0 44.8 32 3.2 32-3.2L256 64l-64 0z','M64 160l160-16 160 16V96L224 112 64 96v64z']
      
    ]
  };

  

  
  

  var faArrowsMaximize = {
    prefix: 'fasds',
    iconName: 'arrows-maximize',
    icon: [
      512,
      512,
      ["expand-arrows"],
      'f31d',
      
      ['M32 32l0 32 0 128 0 32 64 0 0-32 0-50.7L210.7 256 256 210.7 141.3 96 192 96l32 0 0-64-32 0L64 32 32 32zM256 301.3L370.7 416 320 416l-32 0 0 64 32 0 128 0 32 0 0-32 0-128 0-32-64 0 0 32 0 50.7L301.3 256 256 301.3z','M288 32l32 0 128 0 32 0 0 32 0 128 0 32-64 0 0-32 0-50.7L141.3 416l50.7 0 32 0 0 64-32 0L64 480l-32 0 0-32 0-128 0-32 64 0 0 32 0 50.7L370.7 96 320 96l-32 0 0-64z']
      
    ]
  };

  
    var faExpandArrows = faArrowsMaximize;
  

  
  

  var faCarBolt = {
    prefix: 'fasds',
    iconName: 'car-bolt',
    icon: [
      512,
      512,
      [],
      'e341',
      
      ['M0 400l0 80 96 0 0-80L0 400zm416 0l0 80 96 0 0-80-96 0z','M120 32L97.3 32 89.8 53.4 41.3 192 0 192 0 400l512 0 0-208-41.3 0L422.2 53.4 414.7 32 392 32 120 32zM64 288a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 224L288 96l-24 96 88 0L224 320l24-96-88 0z']
      
    ]
  };

  

  
  

  var faPallet = {
    prefix: 'fasds',
    iconName: 'pallet',
    icon: [
      640,
      512,
      [],
      'f482',
      
      ['M32 320L0 320l0 64 32 0 32 0 0 64-32 0L0 448l0 64 32 0 32 0 32 0 32 0 160 0 32 0 32 0 160 0 32 0 32 0 32 0 32 0 0-64-32 0-32 0 0-64 32 0 32 0 0-64-32 0-32 0-32 0-32 0-160 0-32 0-32 0-160 0-32 0-32 0-32 0zm96 64l160 0 0 64-160 0 0-64zm224 0l160 0 0 64-160 0 0-64z','']
      
    ]
  };

  

  
  

  var faBackwardStep = {
    prefix: 'fasds',
    iconName: 'backward-step',
    icon: [
      320,
      512,
      ["step-backward"],
      'f048',
      
      ['M0 64L0 96 0 416l0 32 64 0 0-32 0-160L64 96l0-32L0 64z','M320 64V448L64 256 320 64z']
      
    ]
  };

  
    var faStepBackward = faBackwardStep;
  

  
  

  var faTruckTow = {
    prefix: 'fasds',
    iconName: 'truck-tow',
    icon: [
      640,
      512,
      [],
      'e2b8',
      
      ['M0 144l0 16 0 16c0 26.5 21.5 48 48 48l16 0 0-2.7c18.6-6.6 32-24.4 32-45.3L96 64l96 192 192 0L160 0 64 0l0 16 0 16 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16 0-16L0 144zM96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M416 96l-32 0 0 32 0 128L0 256 0 416l65.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l97.1 0 1.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l33.1 0 0-128 0-32 0-32 0-13.3-9.4-9.4-96-96L525.3 96 512 96l-96 0zM576 256l-128 0 0-96 50.7 0L576 237.3l0 18.7z']
      
    ]
  };

  

  
  

  var faInputNumeric = {
    prefix: 'fasds',
    iconName: 'input-numeric',
    icon: [
      640,
      512,
      [],
      'e1bd',
      
      ['M0 64l0 64L0 384l0 64 64 0 512 0 64 0 0-64 0-256 0-64-64 0L64 64 0 64zm64 64l512 0 0 256L64 384l0-256z','M325.4 211.8c-7-8-19.4-7.9-26.3 .1l-16.9 19.7-36.4-31.2 16.9-19.7c25.9-30.3 72.7-30.5 98.9-.5l15.8 18.1-3.4 3c8 22.3 3.4 48-13.5 66.4L326.8 304l33.2 0 24 0 0 48-24 0-88 0-16 0 0-42 69.1-74.9c6-6.5 6.2-16.6 .3-23.3zM128 160l32 0 24 0 0 24 0 120 16 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0 16 0 0-96-8 0-24 0 0-48 24 0z']
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fasds',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 96l48 0c0 8 0 16 0 24c0 41 0 82.1 0 123.2L365.3 300l20 13.3c-8.9 13.3-17.8 26.6-26.6 39.9l-20-13.3c-32-21.3-64-42.7-96-64c-3.6-2.4-7.1-4.7-10.7-7.1c0-4.3 0-8.6 0-12.8c0-45.3 0-90.7 0-136c0-8 0-16 0-24z','M232 96l0 24 0 136 0 12.8 10.7 7.1 96 64 20 13.3 26.6-39.9-20-13.3L280 243.2 280 120l0-24-48 0z']
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faDash = {
    prefix: 'fasds',
    iconName: 'dash',
    icon: [
      512,
      512,
      ["minus-large"],
      'e404',
      
      ['M0 224l32 0 448 0 32 0 0 64-32 0L32 288 0 288l0-64z','']
      
    ]
  };

  
    var faMinusLarge = faDash;
  

  
  

  var faRaindrops = {
    prefix: 'fasds',
    iconName: 'raindrops',
    icon: [
      448,
      512,
      [],
      'f75c',
      
      ['M0 349.2L0 352c0 35.3 28.7 64 64 64s64-28.7 64-64l0-2.8c0-12.1-3.3-24-9.5-34.4L64 224 9.5 314.8C3.3 325.2 0 337.1 0 349.2zm96-192l0 2.8c0 35.3 28.7 64 64 64s64-28.7 64-64l0-2.8c0-12.1-3.3-24-9.5-34.4L160 32l-54.5 90.8c-6.2 10.4-9.5 22.3-9.5 34.4z','M211.7 293.5L320 128 428.3 293.5c12.8 19.6 19.7 42.6 19.7 66C448 426 394 480 327.5 480h-15C246 480 192 426 192 359.5c0-23.4 6.8-46.4 19.7-66z']
      
    ]
  };

  

  
  

  var faArrowDownArrowUp = {
    prefix: 'fasds',
    iconName: 'arrow-down-arrow-up',
    icon: [
      576,
      512,
      ["sort-alt"],
      'f883',
      
      ['M274.7 173.3L320 218.5l22.6-22.6L384 154.5l0 290.7 0 32 64 0 0-32 0-290.7 41.4 41.4L512 218.5l45.3-45.3-22.6-22.6-96-96L416 32 393.4 54.6l-96 96-22.6 22.6z','M160 480l22.6-22.6 96-96 22.6-22.6L256 293.5l-22.6 22.6L192 357.5l0-290.7 0-32-64 0 0 32 0 290.7L86.6 316.1 64 293.5 18.7 338.7l22.6 22.6 96 96L160 480z']
      
    ]
  };

  
    var faSortAlt = faArrowDownArrowUp;
  

  
  

  var faLightSwitchOn = {
    prefix: 'fasds',
    iconName: 'light-switch-on',
    icon: [
      384,
      512,
      [],
      'e019',
      
      ['M96 96l0 160 192 0 0-160L96 96z','M0 0L384 0l0 512L0 512 0 0zM96 416l192 0 0-320L96 96l0 320zM208 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faSquareRootVariable = {
    prefix: 'fasds',
    iconName: 'square-root-variable',
    icon: [
      576,
      512,
      ["square-root-alt"],
      'f698',
      
      ['M0 224l0 64 32 0 45.6 0L180.4 464.1l9.3 15.9 42.4 0 6.7-23L344 96l200 0 32 0 0-64-32 0L320 32l-24 0-6.7 23L198.1 367.6 123.6 239.9 114.4 224 96 224l-64 0L0 224z','M505.4 249.4L528 226.7 573.3 272l-22.6 22.6L525.3 320l25.4 25.4L573.3 368 528 413.3l-22.6-22.6L480 365.3l-25.4 25.4L432 413.3 386.7 368l22.6-22.6L434.7 320l-25.4-25.4L386.7 272 432 226.7l22.6 22.6L480 274.7l25.4-25.4z']
      
    ]
  };

  
    var faSquareRootAlt = faSquareRootVariable;
  

  
  

  var faArrowUpFromDottedLine = {
    prefix: 'fasds',
    iconName: 'arrow-up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e09b',
      
      ['M0 416l64 0 0 64L0 480l0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M224 34.7l22.6 22.6 128 128L397.3 208 352 253.3l-22.6-22.6L256 157.3 256 320l0 32-64 0 0-32 0-162.7-73.4 73.4L96 253.3 50.7 208l22.6-22.6 128-128L224 34.7z']
      
    ]
  };

  

  
  

  var faU = {
    prefix: 'fasds',
    iconName: 'u',
    icon: [
      384,
      512,
      [117],
      '55',
      
      ['M64 32l0 32 0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224 0-32 64 0 0 32 0 224c0 106-86 192-192 192S0 394 0 288L0 64 0 32l64 0z','']
      
    ]
  };

  

  
  

  var faArrowTurnUp = {
    prefix: 'fasds',
    iconName: 'arrow-turn-up',
    icon: [
      384,
      512,
      ["level-up"],
      'f148',
      
      ['M0 448l0 64 32 0 160 0 32 0 0-32 0-357.5c-10.7-10.7-21.3-21.3-32-32c-10.7 10.7-21.3 21.3-32 32L160 448 32 448 0 448z','M18.7 173.3l22.6-22.6 128-128L192 0l22.6 22.6 128 128 22.6 22.6L320 218.5l-22.6-22.6L192 90.5 86.6 195.9 64 218.5 18.7 173.3z']
      
    ]
  };

  
    var faLevelUp = faArrowTurnUp;
  

  
  

  var faMobileSignalOut = {
    prefix: 'fasds',
    iconName: 'mobile-signal-out',
    icon: [
      512,
      512,
      [],
      'e1f0',
      
      ['M0 0L0 64 0 448l0 64 64 0 224 0 64 0 0-64 0-160-64 0 0 160L64 448 64 64l160 0 0-64L64 0 0 0zM128 384l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0z','M464 256c0-114.9-93.1-208-208-208l0-48C397.4 0 512 114.6 512 256l-48 0zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0-80l0-48c88.4 0 160 71.6 160 160l-48 0c0-61.9-50.1-112-112-112z']
      
    ]
  };

  

  
  

  var faGripVertical = {
    prefix: 'fasds',
    iconName: 'grip-vertical',
    icon: [
      320,
      512,
      [],
      'f58e',
      
      ['M192 32l128 0 0 128-128 0 0-128zm0 160l128 0 0 128-128 0 0-128zm0 160l128 0 0 128-128 0 0-128z','M0 480l128 0 0-128L0 352 0 480zM0 320l128 0 0-128L0 192 0 320zM0 32L0 160l128 0 0-128L0 32z']
      
    ]
  };

  

  
  

  var faSquareD = {
    prefix: 'fasds',
    iconName: 'square-d',
    icon: [
      448,
      512,
      [],
      'e268',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0-24 0 0-24 0-208 0-24zm48 48l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z','M128 128l24 0 72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0-24 0 0-24 0-208 0-24zm48 48l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z']
      
    ]
  };

  

  
  

  var faAxe = {
    prefix: 'fasds',
    iconName: 'axe',
    icon: [
      640,
      512,
      [129683],
      'f6b2',
      
      ['M0 448l64 64L336 240l-64-64L0 448zm384-96l0 64 32 0c123.7 0 224-100.3 224-224l0-32-64 0 0 32c0 88.4-71.6 160-160 160l-32 0zM400 48l64 64 48-48L448 0 400 48z','M224 128L352 0 512 160l64 0 0 32c0 88.4-71.6 160-160 160l-32 0 0-64L224 128z']
      
    ]
  };

  

  
  

  var faChessClock = {
    prefix: 'fasds',
    iconName: 'chess-clock',
    icon: [
      640,
      512,
      [],
      'f43d',
      
      ['M96 32l0 48 56 0 0 48 48 0 0-48 56 0 0-48L96 32zm64 192l0 16 0 64 0 16 32 0 0-16 0-64 0-16-32 0zM384 96l0 32 160 0 0-32L384 96zm57.4 208L464 326.6l11.3-11.3 48-48L534.6 256 512 233.4l-11.3 11.3-48 48L441.4 304z','M0 128l640 0 0 352L0 480 0 128zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z']
      
    ]
  };

  

  
  

  var faPeapod = {
    prefix: 'fasds',
    iconName: 'peapod',
    icon: [
      512,
      512,
      [],
      'e31c',
      
      ['M88 368a56 56 0 1 0 112 0A56 56 0 1 0 88 368zM200 256a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM312 144a56 56 0 1 0 112 0 56 56 0 1 0 -112 0z','M512 0L416 0C186.2 0 0 186.2 0 416l0 96 96 0c229.8 0 416-186.2 416-416l0-96zM256 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM88 368a56 56 0 1 1 112 0A56 56 0 1 1 88 368zM368 88a56 56 0 1 1 0 112 56 56 0 1 1 0-112z']
      
    ]
  };

  

  
  

  var faShareAll = {
    prefix: 'fasds',
    iconName: 'share-all',
    icon: [
      576,
      512,
      [],
      'f367',
      
      ['M352 32l0 88 96 88-96 88 0 88 32 0L576 208 384 32l-32 0z','M448 208L256 384l-32 0 0-96-16 0c-61.9 0-112 50.1-112 112c0 48 32 80 32 80s-128-48-128-176c0-97.2 78.8-176 176-176l48 0 0-96 32 0L448 208z']
      
    ]
  };

  

  
  

  var faDisplayMedical = {
    prefix: 'fasds',
    iconName: 'display-medical',
    icon: [
      576,
      512,
      ["desktop-medical"],
      'e166',
      
      ['M0 0L0 416l240 0 96 0 240 0L576 0 0 0zM64 64l448 0 0 288L64 352 64 64z','M64 64l448 0 0 288L64 352 64 64zM346.7 448l69.3 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0 69.3 0L240 416l96 0 10.7 32zM256 112l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z']
      
    ]
  };

  
    var faDesktopMedical = faDisplayMedical;
  

  
  

  var faFolderMusic = {
    prefix: 'fasds',
    iconName: 'folder-music',
    icon: [
      512,
      512,
      [],
      'e18d',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM128 384c0-17.7 21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48 21.6-8.1 0 23.1 0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 384c0 17.7-21.5 32-48 32s-48-14.3-48-32z','M352 168.9l0 23.1 0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 384c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48 21.6-8.1z']
      
    ]
  };

  

  
  

  var faHexagonVerticalNftSlanted = {
    prefix: 'fasds',
    iconName: 'hexagon-vertical-nft-slanted',
    icon: [
      448,
      512,
      [],
      'e506',
      
      ['M0 128L224 0 448 128l0 256L224 512 0 384 0 128zm64 37.1l0 181.7 32 18.3 0-5.1 0-93.9L127.2 383 160 401.7l0-17.7 0-2.1L160 112l0-1.7-32 18.3 0 133.3L97.1 146.2 64 165.1zM192 92l0 164 0 164 32 18.3 0-6.3 0-160c10.7 0 21.3 0 32 0c5.3 0 10.7 0 16 0l0-32c-5.3 0-10.7 0-16 0c-10.7 0-21.3 0-32 0l0-129.2 48 27.5 0-36.9L223.8 73.8C213.2 79.9 202.6 85.9 192 92zm104 23.1l0 36.9 24 13.7 0 217.7 32-18.3L352 184l32 18.2 0-36.8-40.1-22.8c-16-9.2-32-18.3-47.9-27.5z','M223.8 73.8L192 92l0 164 0 164 32 18.3 0-6.3 0-160 32 0 16 0 0-32-16 0-32 0 0-129.2 48 27.5 0-36.9L223.8 73.8zM352 365.1L352 184l32 18.2 0-36.8-40.1-22.8s0 0 0 0L296 115.1l0 36.9 24 13.7 0 217.7 32-18.3zM160 401.7l0-17.7 0-2.1L160 112l0-1.7-32 18.3 0 133.3L97.1 146.2 64 165.1l0 181.7 32 18.3 0-5.1 0-93.9L127.2 383 160 401.7z']
      
    ]
  };

  

  
  

  var faTabletScreen = {
    prefix: 'fasds',
    iconName: 'tablet-screen',
    icon: [
      448,
      512,
      ["tablet-android-alt"],
      'f3fc',
      
      ['M0 0L448 0l0 512L0 512 0 0zM64 64l0 320 48 0 224 0 48 0 0-320-48 0L112 64 64 64zm96 368l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z','M64 64H384V384H64V64z']
      
    ]
  };

  
    var faTabletAndroidAlt = faTabletScreen;
  

  
  

  var faToiletPaperBlank = {
    prefix: 'fasds',
    iconName: 'toilet-paper-blank',
    icon: [
      640,
      512,
      ["toilet-paper-alt"],
      'f71f',
      
      ['M8 512l357.3 0 8.2-19.7c14.1-34.1 23.6-70.7 29.9-108.3C414.3 320.1 416 253.4 416 192c0-79.2 24-147.2 58.2-176.5C485.8 5.5 498.6 0 512 0L160 0C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8L8 512z','M416 192c0 61.4-1.7 128.1-12.5 192L512 384c53 0 96-86 96-192S565 0 512 0c-13.4 0-26.2 5.5-37.8 15.5C440 44.8 416 112.8 416 192c0 0 0 0 0 0zm128 0c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z']
      
    ]
  };

  
    var faToiletPaperAlt = faToiletPaperBlank;
  

  
  

  var faFolderXmark = {
    prefix: 'fasds',
    iconName: 'folder-xmark',
    icon: [
      512,
      512,
      ["folder-times"],
      'f65f',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM158.1 224c11.3-11.3 22.6-22.6 33.9-33.9l17 17 47 47 47-47 17-17L353.9 224c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.3 31.4 47 47l17 17L320 385.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c-15.7 15.7-31.3 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9l17-17 47-47-47-47-17-17z','M337 241l17-17L320 190.1l-17 17-47 47-47-47-17-17L158.1 224l17 17 47 47-47 47-17 17L192 385.9l17-17 47-47 47 47 17 17L353.9 352l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faFolderTimes = faFolderXmark;
  

  
  

  var faFilmCanister = {
    prefix: 'fasds',
    iconName: 'film-canister',
    icon: [
      576,
      512,
      ["film-cannister"],
      'f8b7',
      
      ['M32 96l288 0 0 32 0 288 0 32L32 448 32 96z','M96 0L256 0l0 32 64 0 32 0 0 64-32 0L32 96 0 96 0 32l32 0 64 0L96 0zM0 448l32 0 288 0 32 0 0 64-32 0L32 512 0 512l0-64zM320 128l256 0 0 192-64 0 0 96-192 0 0-288zm72 40l0 48 48 0 0-48-48 0zm144 0l-48 0 0 48 48 0 0-48zM392 328l0 48 48 0 0-48-48 0z']
      
    ]
  };

  
    var faFilmCannister = faFilmCanister;
  

  
  

  var faSplit = {
    prefix: 'fasds',
    iconName: 'split',
    icon: [
      512,
      512,
      [],
      'e254',
      
      ['M178.7 288L297.4 406.6l9.4 9.4 13.3 0 64 0 0 64 32 0 96-96-96-96-32 0 0 64-50.7 0-96-96-22.6 22.6c-3.1 3.1-6.2 6.2-9.4 9.4L192 288l-13.3 0z','M512 128L416 32l-32 0 0 64-64 0-13.3 0-9.4 9.4L178.7 224 32 224 0 224l0 64 32 0 160 0 13.3 0 9.4-9.4L333.3 160l50.7 0 0 64 32 0 96-96z']
      
    ]
  };

  

  
  

  var faWaveformLines = {
    prefix: 'fasds',
    iconName: 'waveform-lines',
    icon: [
      640,
      512,
      ["waveform-path"],
      'f8f2',
      
      ['M96 192l0 32 0 64 0 32 64 0 0-32 0-64 0-32-64 0zM288 0l0 32 0 448 0 32 64 0 0-32 0-448 0-32L288 0zM480 64l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M256 128l0-32-64 0 0 32 0 256 0 32 64 0 0-32 0-256zm192 32l0-32-64 0 0 32 0 192 0 32 64 0 0-32 0-192zM0 224l0 64 64 0 0-64L0 224zm576 0l0 64 64 0 0-64-64 0z']
      
    ]
  };

  
    var faWaveformPath = faWaveformLines;
  

  
  

  var faWaterArrowUp = {
    prefix: 'fasds',
    iconName: 'water-arrow-up',
    icon: [
      576,
      512,
      ["water-rise"],
      'f775',
      
      ['M0 320l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 313.9 19.3 320 0 320zM0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448z','M320 115.6l34.5 31.3 23.7 21.5 43-47.4L397.5 99.6l-88-80L288 0 266.5 19.6l-88 80-23.7 21.5 43.1 47.4 23.7-21.5L256 115.6l0 92.4 0 32 64 0 0-32 0-92.4z']
      
    ]
  };

  
    var faWaterRise = faWaterArrowUp;
  

  
  

  var faPlaceOfWorship = {
    prefix: 'fasds',
    iconName: 'place-of-worship',
    icon: [
      640,
      512,
      [],
      'f67f',
      
      ['M0 352L0 512l160 0 0-240L0 352zm480-80l0 240 160 0 0-160L480 272z','M224 185.6L224 96 320 0l96 96 0 89.6L480 224l0 288-96 0 0-96c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96-96 0 0-288 64-38.4z']
      
    ]
  };

  

  
  

  var faPersonSkiJumping = {
    prefix: 'fasds',
    iconName: 'person-ski-jumping',
    icon: [
      512,
      512,
      ["ski-jump"],
      'f7c7',
      
      ['M7.1 469l22 42.7 21.3-11L499 269.3l13-6.7 0-14.6 0-56 0-24-48 0 0 24 0 41.4C369.3 282.2 274.5 331.1 179.8 380c-28.2 14.6-56.5 29.1-84.7 43.7L28.5 458 7.1 469z','M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 96l32 0 160 0 13.3 0 9.4 9.4 13.8 13.8 25.9 25.9-29.2 22.2L230.1 260.8l-6.4 7.5c-2.4 2.8-4.4 6.1-5.7 9.6L179.8 380 95.1 423.7l63-168.3c3.9-10.5 9.7-20.3 17-28.8L232.1 160 160 160l-32 0 0-64z']
      
    ]
  };

  
    var faSkiJump = faPersonSkiJumping;
  

  
  

  var faPlugCirclePlus = {
    prefix: 'fasds',
    iconName: 'plug-circle-plus',
    icon: [
      576,
      512,
      [],
      'e55f',
      
      ['M0 160l32 0 320 0 32 0 0 38.6C310.1 219.5 256 287.4 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 99.2-64 0 0-99.2C87 398 32 333.4 32 256l0-32L0 224l0-64zM64 0l64 0 0 32 0 96-64 0 0-96L64 0zM256 0l64 0 0 32 0 96-64 0 0-96 0-32z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faCircle7 = {
    prefix: 'fasds',
    iconName: 'circle-7',
    icon: [
      512,
      512,
      [],
      'e0f4',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 144 0 24 0 0 29.4-2.3 4.9L245.5 384l-53 0 3.9-8.2L290.2 176 184 176l-24 0 0-48z','M352 128l-24 0-144 0-24 0 0 48 24 0 106.2 0L196.3 375.8l-3.9 8.2 53 0L349.7 162.2l2.3-4.9 0-29.4z']
      
    ]
  };

  

  
  

  var faScannerTouchscreen = {
    prefix: 'fasds',
    iconName: 'scanner-touchscreen',
    icon: [
      512,
      512,
      [],
      'f48a',
      
      ['M0 96L0 512l352 0 0-416L0 96zm64 64l224 0 0 288L64 448l0-288z','M192 0L128 0l0 64 64 0 0-64zM352 0L288 0l0 64 64 0 0-64zM224 0l0 64 32 0 0-64L224 0zM416 0L384 0l0 288 32 0L416 0zm32 0l0 288 64 0L512 0 448 0zM288 160L64 160l0 288 224 0 0-288z']
      
    ]
  };

  

  
  

  var faWaterArrowDown = {
    prefix: 'fasds',
    iconName: 'water-arrow-down',
    icon: [
      576,
      512,
      ["water-lower"],
      'f774',
      
      ['M0 320l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 313.9 19.3 320 0 320zM0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448z','M256 222.2l0 1.8 2 0 8.4 7.7L288 251.2l21.5-19.6L318 224l2 0 0-1.8 77.5-70.5 23.7-21.5-43-47.4-23.7 21.5L320 135.7 320 32l0-32L256 0l0 32 0 103.7-34.5-31.3L197.8 82.8l-43.1 47.4 23.7 21.5L256 222.2z']
      
    ]
  };

  
    var faWaterLower = faWaterArrowDown;
  

  
  

  var faFaceSwear = {
    prefix: 'fasds',
    iconName: 'face-swear',
    icon: [
      640,
      512,
      [],
      'e399',
      
      ['M64 256C64 114.6 178.6 0 320 0S576 114.6 576 256L64 256zM171.8 154.1l15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4zm160 11.8l10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1z','M0 288l640 0 0 224L0 512 0 288zm416 96l0-32-16 0-16 0 0-16 0-16-32 0 0 16 0 16-32 0 0-16 0-16-32 0 0 16 0 16-16 0-16 0 0 32 16 0 16 0 0 32-16 0-16 0 0 32 16 0 16 0 0 16 0 16 32 0 0-16 0-16 32 0 0 16 0 16 32 0 0-16 0-16 16 0 16 0 0-32-16 0-16 0 0-32 16 0 16 0zm-64 0l0 32-32 0 0-32 32 0zm220.1-29.6l10.4-12.1-24.3-20.8-10.4 12.1-96 112-10.4 12.1 24.3 20.8 10.4-12.1 96-112zM472 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM224 336l0-16-32 0 0 16 0 64 0 16 32 0 0-16 0-64zm0 112l-32 0 0 32 32 0 0-32zM80.8 341.1C69.7 347 59 358.5 60.1 376.3c1 15.2 11.2 24.1 20.4 29.1c8.2 4.4 18.3 7.2 26.3 9.5c0 0 0 0 0 0s0 0 0 0l1.6 .5c9.4 2.6 16.1 4.7 20.7 7.4c3.6 2.1 3.6 3.2 3.6 3.8l0 .1c.1 1.9-.4 2.8-.7 3.3c-.4 .6-1.3 1.6-3.1 2.5c-4 2.2-10.1 3.3-16.1 3.1c-8.4-.3-16.4-2.8-26.8-6.1c-1.7-.5-3.5-1.1-5.3-1.7l-15.3-4.8L56 453.7l15.3 4.8c1.4 .5 3 .9 4.5 1.4c0 0 0 0 0 0c6.1 2 13.1 4.2 20.6 5.8l0 14.3 32 0 0-13.7c5.4-1.1 10.8-2.9 15.8-5.6c11.3-6.2 21-17.6 20.5-34.9c-.4-15.4-9.8-24.9-19.3-30.6c-8.7-5.2-19.6-8.2-28-10.6c0 0 0 0 0 0l-.2-.1c-9.6-2.7-16.5-4.7-21.4-7.3c-2.3-1.2-3.2-2.1-3.5-2.5c0 0 0 0 0 0c-.1-.1-.1-.1-.1-.4c-.1-1.5 .2-2 .5-2.4c.4-.6 1.3-1.5 3.3-2.6c4.3-2.3 10.9-3.5 16.3-3.5c7.3 .1 15.3 1.6 23.7 3.7l15.5 3.9 7.7-31.1-15.5-3.9c-4.7-1.2-9.8-2.3-15.1-3.2l0-15.3-32 0 0 15.5c-5.3 1.1-10.7 2.9-15.6 5.6z']
      
    ]
  };

  

  
  

  var faRadioTuner = {
    prefix: 'fasds',
    iconName: 'radio-tuner',
    icon: [
      512,
      512,
      ["radio-alt"],
      'f8d8',
      
      ['M0 128c63.2 0 126.5 0 189.8 0c107.4 0 214.8 0 322.2 0l0 384L0 512 0 128zm64 64l0 64c10.7 0 21.3 0 32 0c106.7 0 213.3 0 320 0c10.7 0 21.3 0 32 0l0-64c-10.7 0-21.3 0-32 0c-106.7 0-213.3 0-320 0c-10.7 0-21.3 0-32 0zm0 144l0 32 16 0 128 0 16 0 0-32-16 0L80 336l-16 0zm16 64l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm240-16a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M509 49.6l-23.3 5.7L189.8 128 0 128l0-2.8 18.3-4.5 456-112L497.6 3 509 49.6zM64 192l32 0 320 0 32 0 0 64-32 0L96 256l-32 0 0-64zM320 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z']
      
    ]
  };

  
    var faRadioAlt = faRadioTuner;
  

  
  

  var faFaceSmilePlus = {
    prefix: 'fasds',
    iconName: 'face-smile-plus',
    icon: [
      640,
      512,
      ["smile-plus"],
      'f5b9',
      
      ['M0 288a224 224 0 1 0 448 0A224 224 0 1 0 0 288zm112.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM116 367.3l24-21.2c20.5 23.3 50.6 37.9 84 37.9s63.5-14.6 84-37.9l24 21.2C305.6 397.1 267 416 224 416s-81.6-18.9-108-48.7zM336.4 240a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M568 0l0 24 0 48 48 0 24 0 0 48-24 0-48 0 0 48 0 24-48 0 0-24 0-48-48 0-24 0 0-48 24 0 48 0 0-48 0-24 48 0zM144.4 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  
    var faSmilePlus = faFaceSmilePlus;
  

  
  

  var faMoped = {
    prefix: 'fasds',
    iconName: 'moped',
    icon: [
      640,
      512,
      [],
      'e3b9',
      
      ['M64 384c0 53 43 96 96 96s96-43 96-96l-48 0c0 26.5-21.5 48-48 48s-48-21.5-48-48l-48 0zM96 96l0 64 160 0 0-64L96 96zM416 384a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M328 32l24 0 64 0 17.1 0 5.6 16.1 15.6 44.8L512 64l32 0 0 96-32 0-41.7-20.8L500 224.4c4-.3 8-.4 12-.4c43.7 0 83.3 17.5 112.1 45.8l-33.6 34.2C570.2 284.2 542.6 272 512 272c-52.7 0-97 36.5-108.9 85.6c-2 8.4-3.1 17.3-3.1 26.4l-32 0-16 0L0 384l0-64c0-70.7 57.3-128 128-128l128 0 0 128 109.3 0c16.8-38.5 48.4-69.2 87.6-84.7L398.9 80 352 80l-24 0 0-48z']
      
    ]
  };

  

  
  

  var faTemperatureSnow = {
    prefix: 'fasds',
    iconName: 'temperature-snow',
    icon: [
      576,
      512,
      ["temperature-frigid"],
      'f768',
      
      ['M288 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L544 64l0-64L480 0 384 0 320 0l0 64 0 213.5c-20 24.7-32 56.2-32 90.5zm64 0c0-19.1 6.6-36.5 17.8-50.3L384 300.2l0-22.7L384 64l96 0 0 213.5 0 22.7 14.2 17.6C505.4 331.5 512 348.9 512 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M288 96.9l-22.6-6.1-4.1 15.5-12.9 48.2L200 182.4l0-55.8 35.3-35.3L246.6 80 224 57.4 212.7 68.7 200 81.4 200 56l0-24-48 0 0 24 0 25.4L139.3 68.7 128 57.4 105.4 80l11.3 11.3L152 126.6l0 55.8-48.3-27.9L90.7 106.3 86.6 90.8 55.7 99.1l4.1 15.5 4.6 17.3-15-8.7-20.8-12-24 41.6 20.8 12 15 8.7-17.3 4.6L7.7 182.3 16 213.2 31.4 209l48.2-12.9L128 224 79.7 251.9 31.4 239 16 234.8 7.7 265.7l15.5 4.1 17.3 4.6-15 8.7-20.8 12 24 41.6 20.8-12 15-8.7-4.6 17.3-4.1 15.5 30.9 8.3 4.1-15.5 12.9-48.2L152 265.6l0 55.8-35.3 35.3L105.4 368 128 390.6l11.3-11.3L152 366.6l0 25.4 0 24 48 0 0-24 0-25.4 12.7 12.7L224 390.6 246.6 368l-11.3-11.3L200 321.4l0-55.8 48.3 27.9 10.9 40.7c4.8-24.7 14.8-47.6 28.8-67.4l0-19.1-15.7 4.2L224 224l48.3-27.9 15.7 4.2 0-68.7-.5 .3 .5-1.8 0-33.2zM448 256l-32 0 0 16 0 50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.7 0-16z']
      
    ]
  };

  
    var faTemperatureFrigid = faTemperatureSnow;
  

  
  

  var faTabletRugged = {
    prefix: 'fasds',
    iconName: 'tablet-rugged',
    icon: [
      448,
      512,
      [],
      'f48f',
      
      ['M0 64l0 96 32 16 0 16L0 208l0 96 32 16 0 16L0 352l0 96 32 16 0 48 64 0 256 0 64 0 0-48 32-16 0-96-32-16 0-16 32-16 0-96-32-16 0-16 32-16 0-96L416 48l0-48L352 0 96 0 32 0l0 48L0 64zm96 0l256 0 0 384L96 448 96 64z','M96 64H352V448H96V64z']
      
    ]
  };

  

  
  

  var faDistributeSpacingHorizontal = {
    prefix: 'fasds',
    iconName: 'distribute-spacing-horizontal',
    icon: [
      512,
      512,
      [],
      'e365',
      
      ['M160 96l192 0 0 320-192 0 0-320z','M80 0L32 0l0 512 48 0L80 0zM480 0L432 0l0 512 48 0L480 0z']
      
    ]
  };

  

  
  

  var faEyeDropperFull = {
    prefix: 'fasds',
    iconName: 'eye-dropper-full',
    icon: [
      512,
      512,
      [],
      'e172',
      
      ['M0 472l40 40 5-4 22.7-18.1L80 480l88 0L333.4 314.6l-45.3-45.3c-8.5 8.5-16.9 16.9-25.4 25.4L141.5 416 96 416l0-45.5c40.4-40.4 80.8-80.8 121.3-121.3c8.5-8.5 16.9-16.9 25.4-25.4l-45.3-45.3L32 344l0 88-9.9 12.3L4 467l-4 5z','M341.6 29.2L240.1 130.8l-9.4-9.4L208 98.7 162.7 144l22.6 22.6 160 160L368 349.3 413.3 304l-22.6-22.6-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zm-124.4 220L96 370.5 96 416l45.5 0L262.7 294.7l-45.5-45.5z']
      
    ]
  };

  

  
  

  var faVials = {
    prefix: 'fasds',
    iconName: 'vials',
    icon: [
      512,
      512,
      [],
      'f493',
      
      ['M0 32l32 0 56 0 48 0 56 0 32 0 0 64-32 0 0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80L32 96 0 96 0 32zM88 96l0 160 0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144 0-160L88 96zM288 32l32 0 56 0 48 0 56 0 32 0 0 64-32 0 0 304c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-304-32 0 0-64zm88 64l0 160 0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144 0-160-48 0z','M88 256l48 0 0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144zm288 0l48 0 0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144z']
      
    ]
  };

  

  
  

  var faShieldPlus = {
    prefix: 'fasds',
    iconName: 'shield-plus',
    icon: [
      512,
      512,
      [],
      'e24a',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM144 232c8 0 16 0 24 0c21.3 0 42.7 0 64 0c0-21.3 0-42.7 0-64c0-8 0-16 0-24c16 0 32 0 48 0c0 8 0 16 0 24c0 21.3 0 42.7 0 64c21.3 0 42.7 0 64 0c8 0 16 0 24 0c0 16 0 32 0 48c-8 0-16 0-24 0c-21.3 0-42.7 0-64 0c0 21.3 0 42.7 0 64c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-21.3 0-42.7 0-64c-21.3 0-42.7 0-64 0c-8 0-16 0-24 0c0-16 0-32 0-48z','M232 344l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  

  
  

  var faBookFont = {
    prefix: 'fasds',
    iconName: 'book-font',
    icon: [
      448,
      512,
      [],
      'e0bf',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zM250.1 64l4.4 9.1 61.2 128 40.2 84 1.4 2.9-35.5 0-30.6-64-102.3 0-30.6 64-35.5 0 1.4-2.9 40.2-84 61.2-128 4.4-9.1 20.2 0zm25.7 128L240 117.1 204.2 192l71.7 0z']
      
    ]
  };

  

  
  

  var faCartShopping = {
    prefix: 'fasds',
    iconName: 'cart-shopping',
    icon: [
      576,
      512,
      [128722,"shopping-cart"],
      'f07a',
      
      ['M122 32l454 0L496 288l-325.3 0C154.5 202.7 138.2 117.3 122 32z','M0 0L24 0 96 0l19.9 0 3.7 19.5L179.9 336 488 336l24 0 0 48-24 0-328 0-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  
    var faShoppingCart = faCartShopping;
  

  
  

  var faCarGarage = {
    prefix: 'fasds',
    iconName: 'car-garage',
    icon: [
      640,
      512,
      [],
      'f5e2',
      
      ['M4.7 170.7l29.9 56.6 28.3-15L320 76.2 577 212.3l28.3 15 29.9-56.6-28.3-15L335 11.7 320 3.8l-15 7.9L33 155.7l-28.3 15z','M224 160l-21.1 0-8.3 19.4L148 288l-36 0 0 96 0 64 0 64 80 0 0-64 256 0 0 64 80 0 0-64 0-64 0-96-36 0L445.4 179.4 437.1 160 416 160l-192 0zM422.3 288l-204.7 0 27.4-64 149.8 0 27.4 64zM168 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faPersonMilitaryRifle = {
    prefix: 'fasds',
    iconName: 'person-military-rifle',
    icon: [
      512,
      512,
      [],
      'e54b',
      
      ['M143 241.3L153.2 224l16.7 0C230.6 310.7 291.3 397.4 352 484.1l0 27.9-19.5 0L143 241.3zM176 112c0-11.4 2.4-22.2 6.7-32l146.7 0c4.3 9.8 6.7 20.6 6.7 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zM331.6 224L421.9 67.7l-13.9-8L424 32l13.9 8 27.7 16 13.9 8L416 173.9l29.3 16.9-52.4 90.8-22.4-38L358.8 224 336 224l-4.4 0z','M352 0L160 32l0 48 192 0 0-80zM143 241.3l-1.4 2.4-104 176L17.2 454.1l68.9 40.7 20.3-34.4L160 369.7 160 512l172.5 0L143 241.3zM352 484.1l0-114.4 53.6 90.6 20.3 34.4 68.9-40.7-20.3-34.4-104-176L358.8 224 336 224l-160 0-6.1 0L352 484.1zM272 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z']
      
    ]
  };

  

  
  

  var faFlagSwallowtail = {
    prefix: 'fasds',
    iconName: 'flag-swallowtail',
    icon: [
      448,
      512,
      ["flag-alt"],
      'f74c',
      
      ['M64 32l0 320 384 0L352 192 448 32 64 32z','M64 0l0 32 0 448 0 32L0 512l0-32L0 32 0 0 64 0z']
      
    ]
  };

  
    var faFlagAlt = faFlagSwallowtail;
  

  
  

  var faStarOfDavid = {
    prefix: 'fasds',
    iconName: 'star-of-david',
    icon: [
      512,
      512,
      [10017],
      'f69a',
      
      ['M16 112l56 0 91.3 0-34.4 56-42.3 0 21.1 34.5c11 17.8 21.9 35.7 32.9 53.5c18 29.3 36 58.7 54 88l-65.7 0c-7-11.5-14.1-23-21.1-34.5c-11-17.8-21.9-35.7-32.9-53.5c-18-29.3-36-58.7-54-88L16 160l0-48zM163.3 400l65.7 0 27 44c9-14.7 18-29.4 27-44c11.5-18.7 22.9-37.3 34.4-56c18-29.3 36-58.7 54-88l32.9 53.5c-7 11.5-14.1 23-21.1 34.5l-34.4 56c-22.9 37.3-45.8 74.7-68.7 112l-48 0L163.3 400zm31.3-232c11.5-18.7 22.9-37.3 34.4-56l54 0 65.7 0 91.3 0 56 0 0 48-4.9 8-54 88c-11-17.8-21.9-35.7-32.9-53.5L425.4 168l-42.3 0-65.7 0-122.8 0z','M16 400l56 0 211 0 34.4-56L86.6 344l21.1-34.5L74.9 256l-54 88L16 352l0 48zm91.8-197.5L140.6 256 256 68l27 44 65.7 0L280 0 232 0 107.8 202.5zM383.1 168l-65.7 0 108 176-42.3 0-34.4 56 91.3 0 56 0 0-48-4.9-8-108-176z']
      
    ]
  };

  

  
  

  var faMosquito = {
    prefix: 'fasds',
    iconName: 'mosquito',
    icon: [
      640,
      512,
      [],
      'e52b',
      
      ['M0 320.6c0 84.6 97.6 127 154.6 67.1C199.1 347.2 243.5 306.6 288 266l32-29.2c10.7 9.7 21.3 19.5 32 29.4c44.4 40.4 88.9 81 133.4 121.6C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2c-51-8-102-16-153-23.9c-22.1-3.5-44.2-6.9-66.3-10.4c-14.2 0-28.4 0-42.7 0c-22.1 3.5-44.2 6.9-66.3 10.4c-51 8-102 16-153 23.9C34 232.3 0 272.7 0 320.6z','M288 266l0 .2-67 87-5 6.5 0 8.2 0 53.5-40.4 37.9-17.5 16.4 32.9 35 17.5-16.4 48-45.1 7.6-7.1 0-10.4 0-55.7 24-31.2 0 62.9 0 32 64 0 0-32 0-62.9L376 376l0 55.7 0 10.4 7.6 7.1 48 45.1 17.5 16.4 32.9-35-17.5-16.4L424 421.4l0-53.5 0-8.2-5-6.5-67-87 0-.2-32-29.2L288 266zm119.7-63.6L449 161.1l13-13-9.1-15.9L429.5 91.4l36.3-40.1 16.1-17.8L446.3 1.3 430.2 19.1l-48 53L370.5 85l8.6 15.1 22.9 40L352 190.3l0-38.2 0-32-24 0 0-48.2 0-8-16 0 0 8 0 48.2-24 0 0 32 0 38.1-50.1-50.1 22.9-40L269.5 85 257.8 72.1l-48-53L193.7 1.3 158.1 33.5l16.1 17.8 36.3 40.1-23.3 40.8-9.1 15.9 13 13 41.3 41.4 66.3-10.4 42.7 0 66.3 10.4z']
      
    ]
  };

  

  
  

  var faDuck = {
    prefix: 'fasds',
    iconName: 'duck',
    icon: [
      512,
      512,
      [129414],
      'f6d8',
      
      ['M400 211c19.7-18.9 32-45.6 32-75c0-3.4-.2-6.7-.5-10.1L448 128l64 0c0 53-43 96-96 96l-16 0 0-13z','M432 136c0 29.5-12.3 56.1-32 75l0 48c24.6 23.3 40 56.3 40 93c0 70.7-57.3 128-128 128l-120 0C86 480 0 394 0 288l0-32 32 0 32 32 208-59.4 0-4.9c-28.9-18.5-48-50.8-48-87.7c0-57.4 46.6-104 104-104s104 46.6 104 104zm-64 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM308.6 295.1c-2.4 41.2-32.6 79-77.3 90.1c-40.3 10.1-80.5-4.6-103.7-33.5l-25 20c31.1 38.7 84 57.6 136.4 44.5c58-14.5 98.3-63.8 101.5-119.3l-31.9-1.9z']
      
    ]
  };

  

  
  

  var faMosque = {
    prefix: 'fasds',
    iconName: 'mosque',
    icon: [
      640,
      512,
      [128332],
      'f678',
      
      ['M0 128C0 32 80 0 80 0s80 32 80 128l0 32 0 96-32 0 0 256L0 512 0 160l0-32zm192 96c0-74 53.5-105.2 107.9-137C339.6 63.9 379.8 40.5 400 0c20.2 40.5 60.4 63.9 100.1 87C554.5 118.8 608 150 608 224c0 27-11.4 48.4-24.6 64l-366.7 0c-13.2-15.6-24.6-37-24.6-64z','M0 160l160 0 0 96-32 0 0 256L0 512 0 160zM352 512l-64 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-80 0 0-224 480 0 0 224-80 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-58c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454l0 58z']
      
    ]
  };

  

  
  

  var faBookHeart = {
    prefix: 'fasds',
    iconName: 'book-heart',
    icon: [
      448,
      512,
      [],
      'f499',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zm32 155.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L240 288.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z']
      
    ]
  };

  

  
  

  var faDropletSlash = {
    prefix: 'fasds',
    iconName: 'droplet-slash',
    icon: [
      640,
      512,
      ["tint-slash"],
      'f5c7',
      
      ['M128 320c0 106 86 192 192 192c53.2 0 101.4-21.6 136.1-56.6L159.8 221.9c-19 36.2-31.8 70.8-31.8 98.1zm64 0l32 0 0 16c0 44.2 35.8 80 80 80l16 0 0 32-16 0c-61.9 0-112-50.1-112-112l0-16zm17.9-179.8L505.5 369.7c4.2-15.8 6.5-32.5 6.5-49.7C512 214 320 0 320 0s-57.9 64.5-110.1 140.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faTintSlash = faDropletSlash;
  

  
  

  var faGear = {
    prefix: 'fasds',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      ['M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M312 0L200 0 182.8 78.4c-15.8 6.5-30.6 15.1-44 25.4L62.3 79.5l-56 97 59.4 54.1C64.6 238.9 64 247.4 64 256s.6 17.1 1.7 25.4L6.3 335.5l56 97 76.5-24.4c13.4 10.3 28.2 18.9 44 25.4L200 512l112 0 17.2-78.4c15.8-6.5 30.6-15.1 44-25.4l76.5 24.4 56-97-59.4-54.1c1.1-8.3 1.7-16.8 1.7-25.4s-.6-17.1-1.7-25.4l59.4-54.1-56-97-76.5 24.4C359.8 93.6 345 85 329.2 78.4L312 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z']
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faCameraSecurity = {
    prefix: 'fasds',
    iconName: 'camera-security',
    icon: [
      448,
      512,
      ["camera-home"],
      'f8fe',
      
      ['M128 208a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M0 0L448 0l0 416-144 0 80 56 0 40L64 512l0-40 80-56L0 416 0 0zM224 336a128 128 0 1 0 0-256 128 128 0 1 0 0 256z']
      
    ]
  };

  
    var faCameraHome = faCameraSecurity;
  

  
  

  var faUserDoctorHairLong = {
    prefix: 'fasds',
    iconName: 'user-doctor-hair-long',
    icon: [
      448,
      512,
      [],
      'e459',
      
      ['M128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-11.2-1.9-22-5.5-32L256 96 240 80l-32 32-78.7 0c-.9 5.2-1.3 10.5-1.3 16z','M320 144c0 53-43 96-96 96s-96-43-96-96l0-16c0-5.5 .5-10.8 1.3-16l78.7 0 32-32 16 16 58.5 0c3.5 10 5.5 20.8 5.5 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16 0 48L48 240l0 32 176 0 176 0 0-32-48-48 0-48 0-16C352 57.3 294.7 0 224 0zM160 370.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-50.3-80 0L0 512l448 0L400 320l-80 0 0 42c27.6 7.1 48 32.2 48 62l0 40 0 16-16 0-16 0-16 0 0-32 16 0 0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24 16 0 0 32-16 0-16 0-16 0 0-16 0-40c0-29.8 20.4-54.9 48-62l0-42-128 0 0 50.3zm8 53.7a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  

  
  

  var faFileCertificate = {
    prefix: 'fasds',
    iconName: 'file-certificate',
    icon: [
      512,
      512,
      ["file-award"],
      'f5f3',
      
      ['M128 0L352 0l0 160 160 0 0 352-320 0c0-21.3 0-42.7 0-64l0-57.8 27.6-3.8 6-.8 .8-6 4.4-32.2 25.7-19.9 4.8-3.7-2.3-5.6L246.7 288 259 257.9l2.3-5.6-4.8-3.7-25.7-19.9-4.4-32.2-.8-6-6-.8-32.2-4.4-19.9-25.7-3.7-4.8-5.6 2.3c-10 4.1-20.1 8.2-30.1 12.3c0-56.4 0-112.9 0-169.3z','M512 160l-160 0L352 0 512 160zM92.3 154.6l5.6 2.3L128 169.3 158.1 157l5.6-2.3 3.7 4.8 19.9 25.7 32.2 4.4 6 .8 .8 6 4.4 32.2 25.7 19.9 4.8 3.7-2.3 5.6L246.7 288 259 318.1l2.3 5.6-4.8 3.7-25.7 19.9-4.4 32.2-.8 6-6 .8L192 390.2 192 512l-64-40L64 512l0-121.8-27.6-3.8-6-.8-.8-6-4.4-32.2L-.5 327.4l-4.8-3.7 2.3-5.6L9.3 288-3 257.9l-2.3-5.6 4.8-3.7 25.7-19.9 4.4-32.2 .8-6 6-.8 32.2-4.4 19.9-25.7 3.7-4.8zM192 288A64 64 0 1 0 64 288a64 64 0 1 0 128 0z']
      
    ]
  };

  
    var faFileAward = faFileCertificate;
  

  
  

  var faMessageXmark = {
    prefix: 'fasds',
    iconName: 'message-xmark',
    icon: [
      512,
      512,
      ["comment-alt-times","message-times"],
      'f4ab',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM158.1 144c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.4 31.4 47 47c-15.7 15.7-31.4 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47l47 47 17 17L353.9 272l-17-17-47-47c15.7-15.7 31.4-31.4 47-47l17-17c-11.3-11.3-22.6-22.6-33.9-33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.4 31.4-47 47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17c-11.3 11.3-22.6 22.6-33.9 33.9z','M337 161l17-17L320 110.1l-17 17-47 47-47-47-17-17L158.1 144l17 17 47 47-47 47-17 17L192 305.9l17-17 47-47 47 47 17 17L353.9 272l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faCommentAltTimes = faMessageXmark;
  
    var faMessageTimes = faMessageXmark;
  

  
  

  var faHousePersonReturn = {
    prefix: 'fasds',
    iconName: 'house-person-return',
    icon: [
      640,
      512,
      ["house-person-arrive","house-return"],
      'e011',
      
      ['M0 216l0 48 64 0 0 160 275.8 0 17.5-64.3 2-7.5 5.2-5.7 14.7-16.1-13.7 6.8-28.6 14.3-14.3-28.6-28.6-57.2-14.3-28.6 28.6-14.3 28.9-14.5 37.5-74.9 3-6L240 8 0 216zm144-24l96 0 0 96-96 0 0-96z','M480 48a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm17.7 80.6l10-2 9.3 4.1 72 32 12.9 5.7 4.5 13.4 16 48 10.1 30.4-60.7 20.2-10.1-30.4-11.5-34.6-36.7-16.3 17 63.6c5.6 21.1 .1 43.6-14.7 59.7l-70.9 77.4-22 80.5-8.4 30.9-61.7-16.8 8.4-30.9 24-88 2-7.5 5.2-5.7 52.3-57-18.4-62.4-13.7 27.4-4.8 9.5-9.5 4.8-48 24-28.6-57.2 38.5-19.2 35.2-70.5 7-14 15.3-3.1 80-16zM571.3 398l43.4 43.4L637.3 464 592 509.3l-22.6-22.6-48-48-4.6-4.6-2.4-6.1-15.7-39.3 40.7-44.4c2.5-2.7 4.8-5.6 7-8.6l25 62.4z']
      
    ]
  };

  
    var faHousePersonArrive = faHousePersonReturn;
  
    var faHouseReturn = faHousePersonReturn;
  

  
  

  var faCartCircleArrowDown = {
    prefix: 'fasds',
    iconName: 'cart-circle-arrow-down',
    icon: [
      640,
      512,
      [],
      'e3ef',
      
      ['M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L525.2 194.4c-9.5-1.6-19.3-2.4-29.2-2.4c-68.4 0-127.7 39-156.8 96l-168.5 0 9.1 48 143 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L160 384l-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM224 464a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M352 368a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm211.3 19.3l-56 56L496 454.6l-11.3-11.3-56-56L417.4 376 440 353.4l11.3 11.3L480 393.4l0-89.4 0-16 32 0 0 16 0 89.4 28.7-28.7L552 353.4 574.6 376l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faFaceSmileHalo = {
    prefix: 'fasds',
    iconName: 'face-smile-halo',
    icon: [
      512,
      512,
      [],
      'e38f',
      
      ['M16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5C413.9 178.3 339 192 256 192s-157.9-13.7-210.4-35.5C26.7 190.7 16 230.1 16 272zm104 32c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm9.7 55.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 384.3 327.6 432 256 432s-113.7-47.7-126.3-72.8zM280 304c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M256 160c141.4 0 256-35.8 256-80S397.4 0 256 0S0 35.8 0 80s114.6 80 256 80zm0-48C150 112 64 97.7 64 80s86-32 192-32s192 14.3 192 32s-86 32-192 32zM176 224c-28 0-56 40-56 80c0 0 28-32 56-32s56 32 56 32c0-40-28-80-56-80zm104 80s28-32 56-32s56 32 56 32c0-40-28-80-56-80s-56 40-56 80z']
      
    ]
  };

  

  
  

  var faCircleBolt = {
    prefix: 'fasds',
    iconName: 'circle-bolt',
    icon: [
      512,
      512,
      [],
      'e0fe',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-8L320 112 280 240l88 0 0 24L192 400l40-128-88 0 0-24z','M368 264L192 400l40-128H144V248L320 112 280 240h88v24z']
      
    ]
  };

  

  
  

  var faPresentationScreen = {
    prefix: 'fasds',
    iconName: 'presentation-screen',
    icon: [
      576,
      512,
      ["presentation"],
      'f685',
      
      ['M32 64l0 256 0 32 32 0 192 0 64 0 192 0 32 0 0-32 0-256-64 0 0 224L96 288 96 64 32 64z','M0 0L32 0 544 0l32 0 0 64-32 0L32 64 0 64 0 0zM256 386.7l0-34.7 64 0 0 34.7 54.6 54.6L397.3 464 352 509.3l-22.6-22.6L288 445.3l-41.4 41.4L224 509.3 178.7 464l22.6-22.6L256 386.7z']
      
    ]
  };

  
    var faPresentation = faPresentationScreen;
  

  
  

  var faHandsAslInterpreting = {
    prefix: 'fasds',
    iconName: 'hands-asl-interpreting',
    icon: [
      640,
      512,
      ["american-sign-language-interpreting","asl-interpreting","hands-american-sign-language-interpreting"],
      'f2a3',
      
      ['M312 357.4l16.8 61.7 30.9-8.4 84.7-23.1-65.6 54.7-24.6 20.5 41 49.2 24.6-20.5 85.9-71.6-15 30-14.3 28.6 57.2 28.6 14.3-28.6 77.9-155.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-72 0-8 0c-46.2 3.8-83.8 37.4-93.6 81.6l62.5 13.8c4-17.9 20-31.3 39.1-31.3c22.1 0 40 17.9 40 40s-17.9 40-40 40c-19.1 0-35.1-13.4-39.1-31.3l-62.5 13.8c8 36.3 34.9 65.5 69.9 76.7L342.9 349 312 357.4z','M285.1 49.4L260.5 69.9l-65.6 54.7 84.7-23.1 30.9-8.4 16.8 61.7-30.9 8.4-64.8 17.7c35 11.2 61.9 40.4 69.9 76.7l-62.5 13.8c-4-17.9-20-31.3-39.1-31.3c-22.1 0-40 17.9-40 40s17.9 40 40 40c19.1 0 35.1-13.4 39.1-31.3l62.5 13.8c-9.7 44.1-47.4 77.7-93.6 81.2l0 .3-8 0-72 0C57.3 384 0 326.7 0 256l0-9.3c0-19.9 4.6-39.5 13.5-57.2L91.4 33.7 105.7 5.1l57.2 28.6L148.6 62.3l-15 30 85.9-71.6L244.1 .3l41 49.2z']
      
    ]
  };

  
    var faAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  
    var faAslInterpreting = faHandsAslInterpreting;
  
    var faHandsAmericanSignLanguageInterpreting = faHandsAslInterpreting;
  

  
  

  var faChartUser = {
    prefix: 'fasds',
    iconName: 'chart-user',
    icon: [
      640,
      512,
      ["user-chart"],
      'f6a3',
      
      ['M160 0l32 0L608 0l32 0 0 32 0 352 0 32-32 0-283.4 0-19.2-64L576 352l0-288L224 64l0 49.1C205.2 102.2 183.3 96 160 96l0-64 0-32zM286.1 192L320 158.1l17 17 47 47 55-55-39-39 16-16 112 0 0 112-16 16-39-39-72 72-17 17-17-17-64-64-17-17z','M160 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM320 512L272 352 48 352 0 512l320 0z']
      
    ]
  };

  
    var faUserChart = faChartUser;
  

  
  

  var faBookCircleArrowRight = {
    prefix: 'fasds',
    iconName: 'book-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e0bc',
      
      ['M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 198.6C374.1 219.5 320 287.4 320 368c0 5.4 .2 10.7 .7 16L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l243.2 0c13.1 25.6 32.2 47.6 55.6 64L384 512 96 512c-53 0-96-43-96-96L0 96z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56L582.6 368l-11.3 11.3-56 56L504 446.6 481.4 424l11.3-11.3L521.4 384 432 384l-16 0 0-32 16 0 89.4 0-28.7-28.7L481.4 312 504 289.4l11.3 11.3z']
      
    ]
  };

  

  
  

  var faVolumeOff = {
    prefix: 'fasds',
    iconName: 'volume-off',
    icon: [
      320,
      512,
      [],
      'f026',
      
      ['','M0 352V160H128L272 32h48V480H272L128 352H0z']
      
    ]
  };

  

  
  

  var faFlaskRoundPoison = {
    prefix: 'fasds',
    iconName: 'flask-round-poison',
    icon: [
      448,
      512,
      ["flask-poison"],
      'f6e0',
      
      ['M16 352c0 64.3 29.2 121.8 75.1 160l265.8 0c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6L320 64l32 0 0-64L320 0 256 0 192 0 128 0 96 0l0 64 32 0 0 103.4C61.4 202.1 16 271.8 16 352zm96-40c0-48.6 50.1-88 112-88s112 39.4 112 88c0 29.9-19 56.3-48 72.2l0 47.8-128 0 0-47.8c-29-15.9-48-42.3-48-72.2z','M288 384.2c29-15.9 48-42.3 48-72.2c0-48.6-50.1-88-112-88s-112 39.4-112 88c0 29.9 19 56.3 48 72.2l0 47.8 128 0 0-47.8zM160 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  
    var faFlaskPoison = faFlaskRoundPoison;
  

  
  

  var faFrancSign = {
    prefix: 'fasds',
    iconName: 'franc-sign',
    icon: [
      320,
      512,
      [],
      'e18f',
      
      ['M0 320l0 64 48 0 0-64L0 320zm112 0l0 64 112 0 0-64-112 0z','M80 32L48 32l0 32 0 128 0 64 0 192 0 32 64 0 0-32 0-192 176 0 0-64-176 0 0-96 176 0 32 0 0-64-32 0L80 32z']
      
    ]
  };

  

  
  

  var faArrowDownLeft = {
    prefix: 'fasds',
    iconName: 'arrow-down-left',
    icon: [
      384,
      512,
      [],
      'e091',
      
      ['M96 306.7L297.4 105.4 320 82.7 365.3 128l-22.6 22.6L141.3 352 96 352l0-45.3z','M32 416l32 0 224 0 32 0 0-64-32 0L96 352l0-192 0-32-64 0 0 32 0 224 0 32z']
      
    ]
  };

  

  
  

  var faStreetView = {
    prefix: 'fasds',
    iconName: 'street-view',
    icon: [
      512,
      512,
      [],
      'f21d',
      
      ['M0 424c0 22.1 15.1 37.4 29.8 47c15.2 9.9 35.5 17.5 57.8 23.3C132.7 505.9 192.9 512 256 512s123.3-6.1 168.4-17.8c22.4-5.8 42.6-13.3 57.8-23.3c14.7-9.6 29.8-24.9 29.8-47s-15.1-37.4-29.8-47c-15.2-9.9-35.5-17.5-57.8-23.3c-30.9-8-68.8-13.4-109.9-16l-5.3 47.8c39.6 2.4 75.3 7.4 103.2 14.7c56.6 14.6 56.6 32.9 0 47.5C372.5 458.1 316.6 464 256 464s-116.5-5.9-156.4-16.2c-56.6-14.6-56.6-32.9 0-47.5c27.9-7.2 63.6-12.3 103.2-14.7c-1.8-15.9-3.5-31.8-5.3-47.8c-41.1 2.6-79 8-109.9 16C65.2 359.6 45 367.1 29.8 377C15.1 386.6 0 401.9 0 424z','M256 0a64 64 0 1 1 0 128A64 64 0 1 1 256 0zM160 224c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 80-33.8 0L304 432l-96 0L193.8 304 160 304l0-80z']
      
    ]
  };

  

  
  

  var faFontCase = {
    prefix: 'fasds',
    iconName: 'font-case',
    icon: [
      640,
      512,
      [],
      'f866',
      
      ['M384 288l0 64c0 70.7 57.3 128 128 128c23.3 0 45.2-6.2 64-17.1l0 17.1 64 0 0-32 0-96 0-64 0-96 0-32-64 0 0 17.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128zm64 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64z','M153 32l-7.3 21.8L2.6 480l67.5 0 37.6-112 136.6 0 37.6 112 67.5 0L206.3 53.8 199 32l-46 0zm69.8 272l-93.6 0L176 164.6 222.8 304z']
      
    ]
  };

  

  
  

  var faPlugCircleCheck = {
    prefix: 'fasds',
    iconName: 'plug-circle-check',
    icon: [
      576,
      512,
      [],
      'e55c',
      
      ['M0 160l32 0 320 0 32 0 0 38.6C310.1 219.5 256 287.4 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 99.2-64 0 0-99.2C87 398 32 333.4 32 256l0-32L0 224l0-64zM64 0l64 0 0 32 0 96-64 0 0-96L64 0zM256 0l64 0 0 32 0 96-64 0 0-96 0-32z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faArrowLeftLong = {
    prefix: 'fasds',
    iconName: 'arrow-left-long',
    icon: [
      512,
      512,
      ["long-arrow-left"],
      'f177',
      
      ['M90.5 256c10.7-10.7 21.3-21.3 32-32L480 224l32 0 0 64-32 0-357.5 0c-10.7-10.7-21.3-21.3-32-32z','M0 256l22.6 22.6 128 128 22.6 22.6L218.5 384l-22.6-22.6L90.5 256 195.9 150.6 218.5 128 173.3 82.7l-22.6 22.6-128 128L0 256z']
      
    ]
  };

  
    var faLongArrowLeft = faArrowLeftLong;
  

  
  

  var faTrashSlash = {
    prefix: 'fasds',
    iconName: 'trash-slash',
    icon: [
      640,
      512,
      [],
      'e2b3',
      
      ['M96 32l128 0L240 0 400 0l16 32 128 0 0 64L153 96 96 51.8 96 32zm36.5 168.4L489.9 482 488 512l-336 0L132.5 200.4zM194.2 128L512 128 497.3 363.3C396.2 284.9 295.2 206.4 194.2 128z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faChess = {
    prefix: 'fasds',
    iconName: 'chess',
    icon: [
      512,
      512,
      [],
      'f439',
      
      ['M288 477.4l1.5-2.1 40-56 2.4-3.4 4.1 0 128 0 4.1 0 2.4 3.4 40 56 1.5 2.1 0 2.6 0 24 0 8-8 0-208 0-8 0 0-8 0-24 0-2.6zM304 192l40 0 0 32 24 0 0-32 64 0 0 32 24 0 0-32 40 0 0 80-36.8 40 3.3 72L337 384l2.2-72L304 272l0-80zm80 112l0 32 32 0 0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z','M144 16l0-16L112 0l0 16 0 16L96 32 80 32l0 32 16 0 16 0 0 32L40 96l0 24 29.3 88L48 208l0 48 24 0 5.8 0L60.4 384l135.3 0L178.2 256l5.8 0 24 0 0-48-21.3 0L216 120l0-24-72 0 0-32 16 0 16 0 0-32-16 0-16 0 0-16zM43.9 416l-2.4 3.4-40 56L0 477.4 0 480l0 24 0 8 8 0 240 0 8 0 0-8 0-24 0-2.6-1.5-2.1-40-56-2.4-3.4-4.1 0L48 416l-4.1 0z']
      
    ]
  };

  

  
  

  var faGif = {
    prefix: 'fasds',
    iconName: 'gif',
    icon: [
      576,
      512,
      [],
      'e190',
      
      ['M0 32l576 0 0 448L0 480 0 32zM80 256c0 53 43 96 96 96c19.6 0 37.5-6.1 52.8-15.8l11.2-7.1 0-13.2 0-35.9 0-24-48 0 0 24 0 21.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48s21.5-48 48-48c12.3 0 23.5 4.6 32 12.2l32-35.8c-17-15.2-39.4-24.5-64-24.5c-53 0-96 43-96 96zm192-96l0 24 0 144 0 24 48 0 0-24 0-144 0-24-48 0zm80 0l0 24 0 80 0 64 0 24 48 0 0-24 0-40 40 0 24 0 0-48-24 0-40 0 0-32 64 0 24 0 0-48-24 0-88 0-24 0z','M128 256c0-26.5 21.5-48 48-48c12.3 0 23.5 4.6 32 12.2l32-35.8c-17-15.2-39.4-24.5-64-24.5c-53 0-96 43-96 96s43 96 96 96c19.6 0 37.5-6.1 52.8-15.8l11.2-7.1 0-13.2 0-35.9 0-24-48 0 0 24 0 21.1c-5.3 1.9-10.6 2.9-16 2.9c-26.5 0-48-21.5-48-48zm192-72l0-24-48 0 0 24 0 144 0 24 48 0 0-24 0-144zm56-24l-24 0 0 24 0 80 0 64 0 24 48 0 0-24 0-40 40 0 24 0 0-48-24 0-40 0 0-32 64 0 24 0 0-48-24 0-88 0z']
      
    ]
  };

  

  
  

  var faRightToLine = {
    prefix: 'fasds',
    iconName: 'right-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-right"],
      'f34c',
      
      ['M384 64l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M352 256L192 96l-32 0 0 96L0 192 0 320l160 0 0 96 32 0L352 256z']
      
    ]
  };

  
    var faArrowAltToRight = faRightToLine;
  

  
  

  var faFireFlame = {
    prefix: 'fasds',
    iconName: 'fire-flame',
    icon: [
      384,
      512,
      ["flame"],
      'f6df',
      
      ['M0 320.2C0 425.4 86.8 512 192 512s192-86.6 192-191.8c0-21.1-3.7-42.3-10.9-62.2c-34.8-95.8-93.3-181.2-170-248.3L192 0 180.9 9.7C104.2 76.8 45.7 162.2 10.9 258C3.7 277.8 0 299 0 320.2zm80-.6c0-25.5 12-49.6 32.4-64.9L128 243l0 55c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-16.8-16.8c-11.7-11.7-18.3-27.7-18.3-44.3c0-19 8.6-37 23.5-48.9L208 144l0 15.9c0 12.9 5.2 25.2 14.3 34.2l47.1 46.4C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109l-3 0c-61.9 0-112-50.6-112-112.4z','M191.5 157.2L208 144v15.9c0 12.9 5.2 25.2 14.3 34.2l47.1 46.4C291.5 262.2 304 292 304 323c0 60.2-48.8 109-109 109h-3c-61.9 0-112-50.6-112-112.4c0-25.5 12-49.6 32.4-64.9L128 243v55c0 24.3 19.8 44 44.1 44c24.2 0 43.9-19.6 43.9-43.8c0-11.6-4.6-22.8-12.8-31l-16.8-16.8c-11.7-11.7-18.3-27.7-18.3-44.3c0-19 8.6-37 23.5-48.9z']
      
    ]
  };

  
    var faFlame = faFireFlame;
  

  
  

  var faMinus = {
    prefix: 'fasds',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      ['M432 288l-32 0L48 288l-32 0 0-64 32 0 352 0 32 0 0 64z','']
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faCircle5 = {
    prefix: 'fasds',
    iconName: 'circle-5',
    icon: [
      512,
      512,
      [],
      'e0f2',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm162.9 75.4l42.3-22.7c1.8 3.4 3.6 6.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3l33 0c8.7 0 16.6-3.5 22.2-9.2c2.8-2.8 5.1-6.2 6.7-10c.8-1.9 1.4-3.9 1.8-5.9c.2-1 .4-2.1 .5-3.1c.1-.5 .1-1.1 .1-1.6s0-1 0-1.7c0-.5 0-1 0-1.4c0-.5-.1-1-.1-1.5c-.1-1-.2-1.9-.4-2.9c-.4-1.9-.9-3.7-1.6-5.5c-1.4-3.5-3.3-6.8-5.8-9.5c-5-5.6-11.9-9.4-19.8-10.4c-26.4-3.2-52.8-6.3-79.1-9.5c-7.7-.9-15.4-1.8-23.2-2.8l2.1-23.2c2.7-29.3 5.3-58.7 8-88l2-21.8 21.9 0 104 0 24 0 0 48-24 0-82.1 0c-1.3 14.3-2.6 28.6-3.9 42.9l56 6.7c39.9 4.8 70 38.7 70 78.9c0 43.9-35.6 79.5-79.5 79.5l-33 0c-29.8 0-57.1-16.4-71.2-42.6c-1.8-3.3-3.6-6.7-5.4-10z','M186.1 128l21.9 0 104 0 24 0 0 48-24 0-82.1 0L226 218.9l56 6.7c39.9 4.8 70 38.7 70 78.9c0 43.9-35.6 79.5-79.5 79.5l-33 0c-29.8 0-57.1-16.4-71.2-42.6l-5.4-10 42.3-22.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3l33 0c17.4 0 31.5-14.1 31.5-31.5c0-15.9-11.9-29.3-27.7-31.2l-79.1-9.5L174 261.1l2.1-23.2 8-88 2-21.8z']
      
    ]
  };

  

  
  

  var faCircleSterling = {
    prefix: 'fasds',
    iconName: 'circle-sterling',
    icon: [
      512,
      512,
      [],
      'e5cf',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144.7 368l18-35c7.1-13.8 14.2-27.6 21.3-41.4l-.1-19.6L160 272c0-16 0-32 0-48l23.5 0-.2-33.1c0-1.4 0-2.7 .1-4s.2-2.7 .3-4c.3-2.6 .6-5.3 1.1-7.8c1-5.1 2.5-10.1 4.5-14.8c3.9-9.4 9.7-17.9 16.7-25.1c14.2-14.3 33.8-23.1 55.6-23.1c10 0 19.8 1.9 29.1 5.6l30.3 12.1 22.3 8.9-17.8 44.6c-7.4-3-14.9-5.9-22.3-8.9c-10.1-4-20.2-8.1-30.3-12.1c-3.6-1.4-7.4-2.2-11.3-2.2c-8.4 0-16 3.4-21.5 9c-2.7 2.8-5 6.1-6.5 9.7c-.8 1.8-1.3 3.7-1.7 5.7c-.2 1-.3 2-.4 3c0 .5-.1 1-.1 1.6c0 .5 0 1 0 1.6c.1 11.2 .2 22.3 .2 33.5l32.5 0 24 0c0 16 0 32 0 48l-24 0-32.2 0c.1 8.4 .1 16.8 .2 25.2l0 5.9c-.9 1.7-1.8 3.5-2.7 5.3c-2 3.9-4 7.8-6 11.6L328 320l24 0 0 48-24 0-144 0-39.3 0z','M231.2 190.5c-.1-16.8 13.5-30.5 30.3-30.5c3.9 0 7.7 .7 11.3 2.2l30.3 12.1 22.3 8.9 17.8-44.6-22.3-8.9-30.3-12.1c-9.2-3.7-19.1-5.6-29.1-5.6c-43.5 0-78.6 35.4-78.3 78.9l.2 33.1L160 224l0 48 23.8 0 .1 19.6L162.7 333l-18 35 39.3 0 144 0 24 0 0-48-24 0-104.7 0 6-11.6 2.7-5.3 0-5.9-.2-25.2 32.2 0 24 0 0-48-24 0-32.5 0-.2-33.5z']
      
    ]
  };

  

  
  

  var faBracketRoundRight = {
    prefix: 'fasds',
    iconName: 'bracket-round-right',
    icon: [
      192,
      512,
      [],
      '29',
      
      ['M192 256C192 140.2 120.1 62.9 81.8 37.4L46.3 90.6C71.9 107.7 128 167 128 256s-56.1 148.3-81.8 165.4l35.5 53.3C120.1 449 192 371.8 192 256z','']
      
    ]
  };

  

  
  

  var faVirusSlash = {
    prefix: 'fasds',
    iconName: 'virus-slash',
    icon: [
      640,
      512,
      [],
      'e075',
      
      ['M64 224l0 32 0 32 32 0 11.5 0c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2-22.6 22.6L139 437c7.5 7.5 15.1 15.1 22.6 22.6L184.2 437l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5 0 32 32 0 32 0 0-32 0-11.5c0-31.2 23.6-52.7 50-55.7L144.7 210c-9.5 8.5-22.2 14-37.2 14L96 224l-32 0zM133.3 80.7L264.2 182.3c7-4 15.2-6.3 23.8-6.3c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.8L476.4 347.1c-1.4-29.7 21.2-59.1 56-59.1l11.5 0 32 0 0-32 0-32-32 0-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2 22.6-22.6L501 75 478.4 52.4 455.8 75l-8.2 8.2C412.3 118.4 352 93.4 352 43.5L352 32l0-32L320 0 288 0l0 32 0 11.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75 161.6 52.4 139 75l-5.7 5.7z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faDna = {
    prefix: 'fasds',
    iconName: 'dna',
    icon: [
      448,
      512,
      [129516],
      'f471',
      
      ['M0 0L0 32C0 91.8 30.3 139.5 69.4 178.6c28 28 62.5 53.5 97.3 77.4c.4-.3 .9-.6 1.3-.9c5.6-3.9 11.2-7.7 16.9-11.4c.5-.3 1-.7 1.5-1c5.3-3.5 10.5-7 15.9-10.7l2.4-1.6 1.5-1c5.6-3.7 11-7.3 16.4-10.9c.5-.3 1-.7 1.5-1c-41.8-28.1-80.1-54.9-109.4-84.1c-1.8-1.8-3.5-3.6-5.2-5.4c-10.1-10.7-18.7-21.3-25.5-32l280.2 0c6.5-10.2 11.5-20.6 14.8-31.2C382.3 54.2 384 43.3 384 32L64 32 64 0 0 0zM109.4 384l229.2 0c10.1 10.7 18.6 21.3 25.5 32c6.5 10.2 11.5 20.6 14.8 31.2c3.4 10.7 5.1 21.6 5.1 32.8l0 32 64 0 0-32c0-59.8-30.3-107.5-69.4-146.6c-28-28-62.5-53.5-97.3-77.4c-.8 .6-1.7 1.1-2.5 1.7c-5.3 3.6-10.6 7.2-15.9 10.8c-.8 .6-1.6 1.1-2.5 1.7c-5.6 3.8-11.3 7.5-17.1 11.4l-1.5 1-1.9 1.3c-.7 .5-1.4 .9-2.1 1.4c-4.6 3.1-9.2 6.2-13.8 9.2c20.9 14 40.8 27.7 59.3 41.5l-118.5 0c-19.5 14.7-36.7 29.1-51 43.5c-1.3 1.3-2.6 2.7-3.9 4c-.2 .2-.3 .3-.5 .5z','M448 32l0-32L384 0l0 32c0 34.2-15.9 65-45.4 96l-229.2 0c15.2 15.9 33.8 31.8 55.4 48l118.5 0c-23.6 17.7-49.7 35.2-77 53.4l-1.6 1s0 0 0 0s0 0 0 0c-46.9 31.2-97.1 64.7-135.3 102.9C30.3 372.5 0 420.2 0 480l0 32 64 0 0-32 320 0c0-22.6-7-43.6-19.9-64L83.9 416c8-12.5 18.3-24.9 30.7-37.4c33.3-33.3 78.4-63.5 127.1-96l1.6-1s0 0 0 0c46.9-31.2 97.1-64.7 135.3-102.9C417.7 139.5 448 91.8 448 32z']
      
    ]
  };

  

  
  

  var faTurnLeftUp = {
    prefix: 'fasds',
    iconName: 'turn-left-up',
    icon: [
      384,
      512,
      [],
      'e638',
      
      ['M144 192l0 320 240 0 0-96-144 0 0-224-96 0z','M32 160L192 0 352 160l0 32L32 192l0-32z']
      
    ]
  };

  

  
  

  var faCloudBoltMoon = {
    prefix: 'fasds',
    iconName: 'cloud-bolt-moon',
    icon: [
      576,
      512,
      ["thunderstorm-moon"],
      'f76d',
      
      ['M96 360l0 24 88 0L144 512 320 376l0-24-88 0 40-128L96 360zM348.3 73.1c38.1 16.5 65.1 53.8 67.2 97.5c32.9 15.7 57 47 62.6 84.5c42.5-4.8 78.6-30.6 97.9-66.8c-10.9 4.3-22.7 6.7-35.1 6.7c-52.8 0-95.6-43-95.6-96c0-41.9 26.7-77.5 64-90.6C495 3 479.6 0 463.6 0c-50.9 0-94.8 29.9-115.2 73.2z','M447.9 351.9l-80 0-15.9 0 0-31.9-76.5 0 40-128-51 0L64 344.3l0 7.6-64 0 0-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7l0 80z']
      
    ]
  };

  
    var faThunderstormMoon = faCloudBoltMoon;
  

  
  

  var faCircleUpRight = {
    prefix: 'fasds',
    iconName: 'circle-up-right',
    icon: [
      512,
      512,
      [],
      'e129',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 56l76-76-52-52 24-24 160 0 0 160-24 24-52-52-76 76-56-56z','M328 344l24-24 0-160-160 0-24 24 52 52-76 76 56 56 76-76 52 52z']
      
    ]
  };

  

  
  

  var faKeyboardDown = {
    prefix: 'fasds',
    iconName: 'keyboard-down',
    icon: [
      576,
      512,
      [],
      'e1c2',
      
      ['M0 0L576 0l0 288L0 288 0 0zM64 64l0 64 64 0 0-64L64 64zm0 96l0 64 64 0 0-64-64 0zm96-96l0 64 64 0 0-64-64 0zm0 96l0 64 256 0 0-64-256 0zm96-96l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M128 64L64 64l0 64 64 0 0-64zm0 96l-64 0 0 64 64 0 0-64zm320 0l0 64 64 0 0-64-64 0zM224 64l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zm160 0l-64 0 0 64 64 0 0-64zm32 0l0 64 64 0 0-64-64 0zM160 352l0 32L288 512 416 384l0-32-256 0z']
      
    ]
  };

  

  
  

  var faLeftLong = {
    prefix: 'fasds',
    iconName: 'left-long',
    icon: [
      512,
      512,
      ["long-arrow-alt-left"],
      'f30a',
      
      ['M192 192l0 128c42.7 0 85.3 0 128 0c64 0 128 0 192 0l0-128-320 0z','M160 96L0 256 160 416l32 0s0 0 0 0l0-96 0-128 0-96-32 0z']
      
    ]
  };

  
    var faLongArrowAltLeft = faLeftLong;
  

  
  

  var faMoneyBill1 = {
    prefix: 'fasds',
    iconName: 'money-bill-1',
    icon: [
      576,
      512,
      ["money-bill-alt"],
      'f3d1',
      
      ['M64 192l0 128c35.3 0 64 28.7 64 64l320 0c0-35.3 28.7-64 64-64l0-128c-35.3 0-64-28.7-64-64l-320 0c0 35.3-28.7 64-64 64zm320 64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z','M0 64l576 0 0 384L0 448 0 64zm128 64c0 35.3-28.7 64-64 64l0 128c35.3 0 64 28.7 64 64l320 0c0-35.3 28.7-64 64-64l0-128c-35.3 0-64-28.7-64-64l-320 0zm144 60l16 0 20 0 0 20 0 68 4 0 20 0 0 40-20 0-4 0-40 0-4 0-20 0 0-40 20 0 4 0 0-48-16 0 0-40 20 0z']
      
    ]
  };

  
    var faMoneyBillAlt = faMoneyBill1;
  

  
  

  var faCropSimple = {
    prefix: 'fasds',
    iconName: 'crop-simple',
    icon: [
      512,
      512,
      ["crop-alt"],
      'f565',
      
      ['M64 0l0 32 0 32 0 64 0 288 0 32 32 0 288 0 0-64-256 0 0-256 0-64 0-32 0-32L64 0zM448 384l0 64 32 0 32 0 0-64-32 0-32 0z','M32 64L0 64l0 64 32 0 32 0 0-64L32 64zM384 480l0 32 64 0 0-32 0-384 0-32-32 0L128 64l0 64 256 0 0 352z']
      
    ]
  };

  
    var faCropAlt = faCropSimple;
  

  
  

  var faIndianRupeeSign = {
    prefix: 'fasds',
    iconName: 'indian-rupee-sign',
    icon: [
      320,
      512,
      ["indian-rupee","inr"],
      'e1bc',
      
      ['M0 144l0 64 32 0 153.3 0c4.3-9.8 6.7-20.6 6.7-32c0-1.4 0-2.9-.1-4.3c-.1-1.4-.2-2.8-.3-4.1c-.3-2.8-.7-5.5-1.3-8.2c-1.1-5.4-2.8-10.5-4.9-15.4L32 144 0 144zm252.4 0c2.3 10.3 3.6 21 3.6 32c0 2.8-.1 5.5-.2 8.2c-.2 2.7-.4 5.4-.7 8c-.6 5.3-1.5 10.6-2.7 15.7l35.6 0 32 0 0-64-32 0-35.6 0z','M32 32L0 32 0 96l32 0 32 0 32 0 16 0c44.2 0 80 35.8 80 80s-35.8 80-80 80l-80 0L0 256l0 32 0 11.1 0 17.5L14.8 326 222.8 459l27 17.2 34.5-53.9-27-17.2L123.5 319.6C197.6 313.7 256 251.7 256 176c0-29.6-8.9-57.1-24.2-80L288 96l32 0 0-64-32 0L112 32 96 32 64 32 32 32z']
      
    ]
  };

  
    var faIndianRupee = faIndianRupeeSign;
  
    var faInr = faIndianRupeeSign;
  

  
  

  var faListTimeline = {
    prefix: 'fasds',
    iconName: 'list-timeline',
    icon: [
      512,
      512,
      [],
      'e1d1',
      
      ['M144 96l64 48 240 0 0-96L208 48 144 96zm0 160l64 48 304 0 0-96-304 0-64 48zm0 160l64 48 240 0 0-96-240 0-64 48z','M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z']
      
    ]
  };

  

  
  

  var faMoneyBillsSimple = {
    prefix: 'fasds',
    iconName: 'money-bills-simple',
    icon: [
      640,
      512,
      ["money-bills-alt"],
      'e1f4',
      
      ['M0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312 0-24L0 96zM288 208a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M640 32L96 32l0 352 544 0 0-352zM368 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z']
      
    ]
  };

  
    var faMoneyBillsAlt = faMoneyBillsSimple;
  

  
  

  var faBadgeDollar = {
    prefix: 'fasds',
    iconName: 'badge-dollar',
    icon: [
      512,
      512,
      [],
      'f645',
      
      ['M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm178.3 79.3l12.6-38c6.3 2.1 12.7 4.2 19 6.3c2.2 .7 4.5 1.5 7 2.3c10.6 3.6 22.7 7.7 29.6 8.9c14.5 2.3 25.9 .9 33.2-2.3c6.6-2.8 9.4-6.7 10.2-11.4c.8-4.8 .2-7.4-.4-8.7c-.6-1.4-1.9-3.2-4.9-5.4c-6.9-5-17.8-8.7-33.2-13.3c-.8-.2-1.6-.5-2.3-.7c-13.1-3.9-29.8-9-42.4-17.5c-7.1-4.8-14.1-11.5-18.5-20.8c-4.5-9.5-5.5-19.9-3.6-30.9c3.4-19.4 17.2-32.9 33.3-40.2c5.9-2.7 12.3-4.6 19.1-5.9c0-2.8 0-5.7 0-8.5c0-6.7 0-13.3 0-20c13.3 0 26.7 0 40 0c0 6.7 0 13.3 0 20c0 2.9 0 5.9 0 8.8c7.2 1.3 19.9 3.8 25.1 5.2c6.4 1.7 12.9 3.4 19.3 5.1c-3.4 12.9-6.9 25.8-10.3 38.7c-6.4-1.7-12.9-3.4-19.3-5.1c-4.4-1.2-19.5-4.1-24.3-4.9c-13.9-2.2-25.5-.4-33.1 3c-7.5 3.4-9.9 7.6-10.4 10.6c-.7 4.2-.1 6.1 .3 6.9c.5 1 1.7 2.7 4.8 4.8c7.2 4.9 18.2 8.3 33.8 13l.8 .2c13.5 4.1 31.2 9.4 44.4 19c7.2 5.2 13.9 12.3 18.1 21.8c4.2 9.7 5.1 20.3 3.1 31.4c-3.5 20.3-16.9 34.1-33.8 41.4c-5.8 2.5-12 4.2-18.5 5.3c0 2.7 0 5.3 0 8c0 6.7 0 13.3 0 20c-13.3 0-26.7 0-40 0c0-6.7 0-13.3 0-20c0-3 0-5.9 0-8.9c-10.6-2.2-25.3-7.3-34.6-10.4c-1.9-.7-3.6-1.2-5-1.7c-6.3-2.1-12.6-4.2-19-6.3z','M276.9 129.3l0 20 0 8.8c7.2 1.3 19.9 3.8 25.1 5.2l19.3 5.1-10.3 38.7L291.7 202c-4.4-1.2-19.5-4.1-24.3-4.9c-13.9-2.2-25.5-.4-33.1 3c-7.5 3.4-9.9 7.6-10.4 10.6c-.7 4.2-.1 6.1 .3 6.9c.5 1 1.7 2.7 4.8 4.8c7.2 4.9 18.2 8.3 33.8 13l.8 .2c13.5 4.1 31.2 9.4 44.4 19c7.2 5.2 13.9 12.3 18.1 21.8c4.2 9.7 5.1 20.3 3.1 31.4c-3.5 20.3-16.9 34.1-33.8 41.4c-5.8 2.5-12 4.2-18.5 5.3l0 8 0 20-40 0 0-20 0-8.9c-10.6-2.2-25.3-7.3-34.6-10.4c0 0 0 0 0 0s0 0 0 0c-1.9-.7-3.6-1.2-5-1.7l-19-6.3 12.6-38 19 6.3c2.2 .7 4.5 1.5 6.9 2.3c0 0 0 0 0 0s0 0 0 0c10.6 3.6 22.7 7.7 29.6 8.9c14.5 2.3 25.9 .9 33.2-2.3c6.6-2.8 9.4-6.7 10.2-11.4c.8-4.8 .2-7.4-.4-8.7c-.6-1.4-1.9-3.2-4.9-5.4c-6.9-5-17.8-8.7-33.2-13.3l-2.3-.7c-13.1-3.9-29.8-9-42.4-17.5c-7.1-4.8-14.1-11.5-18.5-20.8c-4.5-9.5-5.5-19.9-3.6-30.9c3.4-19.4 17.2-32.9 33.3-40.2c5.9-2.7 12.3-4.6 19.1-5.9l0-8.5 0-20 40 0z']
      
    ]
  };

  

  
  

  var faBallPile = {
    prefix: 'fasds',
    iconName: 'ball-pile',
    icon: [
      576,
      512,
      [],
      'f77e',
      
      ['M0 432a80 80 0 1 0 160 0A80 80 0 1 0 0 432zM208 80a80 80 0 1 0 160 0A80 80 0 1 0 208 80zm0 352a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm208 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M176 328a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm224 0a80 80 0 1 0 0-160 80 80 0 1 0 0 160z']
      
    ]
  };

  

  
  

  var faFaceSmileUpsideDown = {
    prefix: 'fasds',
    iconName: 'face-smile-upside-down',
    icon: [
      512,
      512,
      [],
      'e395',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm129.7-71.2C142.3 159.7 184.4 112 256 112s113.7 47.7 126.3 72.8l-28.6 14.3C344.9 181.7 312.4 144 256 144s-88.9 37.7-97.7 55.2l-28.6-14.3zm14.1 115.9c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6zm160 0c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6z','M175.6 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm160 0a32 32 0 1 0 0 64 32 32 0 1 0 0-64z']
      
    ]
  };

  

  
  

  var faChartGantt = {
    prefix: 'fasds',
    iconName: 'chart-gantt',
    icon: [
      512,
      512,
      [],
      'e0e4',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M160 96l-32 0 0 64 32 0 96 0 32 0 0-64-32 0-96 0zm64 96l-32 0 0 64 32 0 128 0 32 0 0-64-32 0-128 0zm160 96l-32 0 0 64 32 0 64 0 32 0 0-64-32 0-64 0z']
      
    ]
  };

  

  
  

  var faTrainSubway = {
    prefix: 'fasds',
    iconName: 'train-subway',
    icon: [
      448,
      512,
      ["subway"],
      'f239',
      
      ['M2.8 512l22.6-22.6L66.7 448l90.5 0-64 64L2.8 512zM64 96l144 0 0 160L64 256 64 96zm176 0l144 0 0 160-144 0 0-160zm50.7 352l90.5 0 41.4 41.4L445.3 512l-90.5 0-64-64z','M0 0L448 0l0 448L0 448 0 0zM64 96l0 160 144 0 0-160L64 96zm320 0L240 96l0 160 144 0 0-160zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm224 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faSubway = faTrainSubway;
  

  
  

  var faGameConsoleHandheldCrank = {
    prefix: 'fasds',
    iconName: 'game-console-handheld-crank',
    icon: [
      576,
      512,
      [],
      'e5b9',
      
      ['M0 32L0 480l448 0 0-160 0-48 0-240L0 32zM64 96l320 0 0 160L64 256 64 96zm0 256l16 0 16 0 0-16 0-16 32 0 0 16 0 16 16 0 16 0 0 32-16 0-16 0 0 16 0 16-32 0 0-16 0-16-16 0-16 0 0-32zm208 8a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM480 144l0 80 48 0 48 0 0-80-96 0z','M384 96L64 96l0 160 320 0 0-160zM528 296l0-72-48 0 0 48-32 0 0 48 56 0 24 0 0-24z']
      
    ]
  };

  

  
  

  var faSportsball = {
    prefix: 'fasds',
    iconName: 'sportsball',
    icon: [
      512,
      512,
      [],
      'e44b',
      
      ['M14 359.2c0 37.8 4.2 73.5 10.4 103.9l.3 1.5C65.4 424 106 383.3 146.7 342.7c-34.8-30.2-79-49.8-127.6-53.9c-3.5 23.8-5 47.5-5 70.4zm10.9-102c55.1 5.3 105.1 28.1 144.4 62.8c21.3-21.3 42.7-42.7 64-64c-46.7-46.6-93.3-93.3-139.9-139.9C83.2 127.9 74.1 140.5 66 153.6c-19.8 32.3-33 67.7-41.1 103.6zM47 487.6l3.5 .6c65.6 11 122.9 12.5 172.8 6c-3.9-49.1-23.6-93.7-54-128.8L47 487.6zM115.8 93.2L256 233.4l26.4-26.4c12.5-12.5 25.1-25.1 37.6-37.6c-35-39.7-58-90.3-63-146.1c-17 3.6-33 8.3-48.1 13.9c-37 13.7-67.8 33-93.1 56zM192 342.6c35 39.7 58 90.3 63 146.1c17-3.6 33-8.3 48.1-13.9c37-13.7 67.8-33 93.1-56c-46.7-46.7-93.5-93.5-140.2-140.2c-21.3 21.3-42.7 42.7-64 64zM278.6 256c46.6 46.6 93.3 93.3 139.9 139.9c10.3-11.8 19.4-24.4 27.4-37.5c19.8-32.3 33-67.7 41.1-103.6c-55.1-5.3-105.1-28.1-144.4-62.8c-21.3 21.3-42.7 42.7-64 64zM288.7 17.9c3.9 49.1 23.6 93.7 54 128.8C383.5 105.9 424.2 65.2 465 24.4c-1.2-.2-2.3-.4-3.5-.6C421.6 17.2 384.8 14 350.8 14c-21.9 0-42.6 1.3-62.1 3.9zm76.6 151.4c34.8 30.2 79 49.8 127.6 53.9c3.5-23.8 5-47.5 5-70.4c0-37.8-4.2-73.5-10.4-103.9l-.3-1.5C446.6 88 406 128.7 365.3 169.3z','M487.2 47.4L278.6 256 418.6 395.9c-6.9 8-14.4 15.6-22.3 22.9L256 278.6 47 487.6l-18.2-3-4.1-19.9L233.4 256 93.5 116.1c6.9-8 14.4-15.6 22.3-22.9L256 233.4l209-209 18.2 3 4.1 19.9z']
      
    ]
  };

  

  
  

  var faSignalBarsFair = {
    prefix: 'fasds',
    iconName: 'signal-bars-fair',
    icon: [
      640,
      512,
      ["signal-alt-2"],
      'f692',
      
      ['M352 128l0 384 96 0 0-384-96 0zM512 0l0 512 96 0L608 0 512 0z','M288 256l-96 0 0 256 96 0 0-256zM128 384l-96 0 0 128 96 0 0-128z']
      
    ]
  };

  
    var faSignalAlt2 = faSignalBarsFair;
  

  
  

  var faDistributeSpacingVertical = {
    prefix: 'fasds',
    iconName: 'distribute-spacing-vertical',
    icon: [
      512,
      512,
      [],
      'e366',
      
      ['M96 160l320 0 0 192L96 352l0-192z','M512 32L0 32 0 80l512 0 0-48zm0 400L0 432l0 48 512 0 0-48z']
      
    ]
  };

  

  
  

  var faCircleLeft = {
    prefix: 'fasds',
    iconName: 'circle-left',
    icon: [
      512,
      512,
      [61840,"arrow-alt-circle-left"],
      'f359',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 0L224 128l32 0 0 80 128 0 0 96-128 0 0 80-32 0L96 256z','M256 208l0-80-32 0L96 256 224 384l32 0 0-80 128 0 0-96-128 0z']
      
    ]
  };

  
    var faArrowAltCircleLeft = faCircleLeft;
  

  
  

  var faCowbellCirclePlus = {
    prefix: 'fasds',
    iconName: 'cowbell-circle-plus',
    icon: [
      576,
      512,
      ["cowbell-more"],
      'f8b4',
      
      ['M0 416l262.6 0c-4.3-15.3-6.6-31.4-6.6-48c0-87.6 63.9-160.2 147.7-173.7L384 96l-64 0 0-72 0-24L296 0 152 0 128 0l0 24 0 72L64 96 0 416zm160 32c0 35.3 28.7 64 64 64c29.2 0 53.9-19.6 61.5-46.4c-3.8-5.7-7.2-11.5-10.3-17.6L160 448zM176 48l96 0 0 48-96 0 0-48z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  
    var faCowbellMore = faCowbellCirclePlus;
  

  
  

  var faPlaneArrival = {
    prefix: 'fasds',
    iconName: 'plane-arrival',
    icon: [
      640,
      512,
      [128748],
      'f5af',
      
      ['M0 448l32 0 576 0 32 0 0 64-32 0L32 512 0 512l0-64zm192-80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M32 64l.3 132.1 88.5 89.3 298.9 81.2c42.9 11.6 88.3 9.4 129.8-6.4c28.5-10.8 34.4-48.6 10.6-67.6L526 265.3c-13.5-10.8-29-18.8-45.7-23.4L375.7 212.9 256 0 176 0l48.8 170.9L128 144 104 80 32 64z']
      
    ]
  };

  

  
  

  var faPersonFromPortal = {
    prefix: 'fasds',
    iconName: 'person-from-portal',
    icon: [
      512,
      512,
      ["portal-exit"],
      'e023',
      
      ['M0 256C0 397.4 35.8 512 80 512c25.3 0 47.8-37.5 62.5-96L128 416l-32 0 0-64 32 0 26.2 0c3.8-29.6 5.8-62.1 5.8-96c0-18-.6-35.5-1.7-52.4L130.7 176l22.6-22.6C141 63.1 112.8 0 80 0C35.8 0 0 114.6 0 256z','M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM224 96l-13.3 0-9.4 9.4-48 48L130.7 176 176 221.3l22.6-22.6L237.3 160l27.7 0-31.3 94c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-9.4 32.8-16 56L309.6 512l66.6 0 6.6-23.2 16-56 16-56 6.6-23.2L401 340.9 334 299l29-77.4 24.3 48.6 8.8 17.7 19.8 0 48 0 32 0 0-64-32 0-28.2 0-39.2-78.3-5.4-10.9-11.3-4.5-80-32L294.2 96 288 96l-64 0zM205.5 310.7L187.2 352 128 352l-32 0 0 64 32 0 80 0 20.8 0 8.4-19L253 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9z']
      
    ]
  };

  
    var faPortalExit = faPersonFromPortal;
  

  
  

  var faCalendarPlus = {
    prefix: 'fasds',
    iconName: 'calendar-plus',
    icon: [
      448,
      512,
      [],
      'f271',
      
      ['M0 192l448 0 0 320L0 512 0 192zM120 328l0 48 24 0 56 0 0 56 0 24 48 0 0-24 0-56 56 0 24 0 0-48-24 0-56 0 0-56 0-24-48 0 0 24 0 56-56 0-24 0z','M96 0l64 0 0 64 128 0 0-64 64 0 0 64 96 0 0 128L0 192 0 64l96 0L96 0zM248 248l0 24 0 56 56 0 24 0 0 48-24 0-56 0 0 56 0 24-48 0 0-24 0-56-56 0-24 0 0-48 24 0 56 0 0-56 0-24 48 0z']
      
    ]
  };

  

  
  

  var faPersonSkiingNordic = {
    prefix: 'fasds',
    iconName: 'person-skiing-nordic',
    icon: [
      576,
      512,
      ["skiing-nordic"],
      'f7ca',
      
      ['M0 464l0 48 24 0 135.3 0 1.4 0 158.6 0 1.4 0L552 512l24 0 0-24 0-56 0-24-48 0 0 24 0 32-93.4 0 27.1-176c-4.6 0-9.2 0-13.7 0c-6.2 0-12.4 0-18.6 0L402.3 464l-44.4 0-66.6 0-88.5 0-70.6 0-32.4 0 52.9-251.4c-2.9 2.9-5.8 5.8-8.6 8.6c-7.1-7.1-14.3-14.3-21.4-21.4L67 464l-43 0L0 464z','M336 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM178.7 96L192 96l48 0 4.8 0 4.6 1.4 104 32 14.4 4.4 5.8 13.9L405.3 224l42.7 0 32 0 0 64-32 0-64 0-21.3 0-8.2-19.7-21.5-51.7L302 299 369 340.9l20.4 12.8-6.6 23.2L357.8 464l-66.6 0 23.3-81.6-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.3-94-27.7 0-38.6 38.6L144 221.3 98.7 176l22.6-22.6 48-48 9.4-9.4zm24 368l-70.6 0 58.7-125.7c5.9 6.6 12.8 12.5 20.6 17.3l32.4 20.3L202.8 464zm-42.1 48c-.4 0-.9 0-1.4 0l1.4 0zm160.1 0c-.5 0-1 0-1.4 0l1.4 0z']
      
    ]
  };

  
    var faSkiingNordic = faPersonSkiingNordic;
  

  
  

  var faArrowDownRight = {
    prefix: 'fasds',
    iconName: 'arrow-down-right',
    icon: [
      384,
      512,
      [],
      'e093',
      
      ['M18.7 128l22.6 22.6L242.7 352l45.3 0 0-45.3L86.6 105.4 64 82.7 18.7 128z','M352 416l-32 0L96 416l-32 0 0-64 32 0 192 0 0-192 0-32 64 0 0 32 0 224 0 32z']
      
    ]
  };

  

  
  

  var faGrate = {
    prefix: 'fasds',
    iconName: 'grate',
    icon: [
      448,
      512,
      [],
      'e193',
      
      ['M64 224l0 64 32 0 0 128 64 0 0-128 32 0 0 128 64 0 0-128 32 0 0 128 64 0 0-128 32 0 0-64-32 0 0-128-64 0 0 128-32 0 0-128-64 0 0 128-32 0 0-128L96 96l0 128-32 0z','M0 32l448 0 0 448L0 480 0 32zM64 96l0 320 320 0 0-320L64 96z']
      
    ]
  };

  

  
  

  var faTrafficCone = {
    prefix: 'fasds',
    iconName: 'traffic-cone',
    icon: [
      512,
      512,
      [],
      'f636',
      
      ['M85.7 352l340.6 0-25.1-64-290.3 0c-8.4 21.3-16.8 42.7-25.1 64zm62.9-160l214.9 0-25.1-64-164.6 0c-8.4 21.3-16.8 42.7-25.1 64z','M173.7 128L224 0l64 0 50.3 128-164.6 0zm-25.1 64l214.9 0 37.7 96-290.3 0 37.7-96zM48 448l37.7-96 340.6 0L464 448l48 0 0 64L0 512l0-64 48 0z']
      
    ]
  };

  

  
  

  var faHouseMedicalCircleCheck = {
    prefix: 'fasds',
    iconName: 'house-medical-circle-check',
    icon: [
      640,
      512,
      [],
      'e511',
      
      ['M0 240l0 47.6 64.1 0 0 224.4 330.7 0c-45.2-31.8-74.7-84.4-74.8-143.8c-.1 8.7-7.2 15.8-16 15.8l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 40.2 0c32.3-39.1 81.1-64 135.8-64c8.3 0 16.5 .6 24.5 1.7L288.4 0 0 240zM320 352l0 15.3c0-5.2 .3-10.3 .7-15.3l-.7 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faAlarmExclamation = {
    prefix: 'fasds',
    iconName: 'alarm-exclamation',
    icon: [
      512,
      512,
      [],
      'f843',
      
      ['M32 288c0 50.3 16.6 96.8 44.6 134.2L57.4 441.4 34.7 464 80 509.3l22.6-22.6 19.2-19.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l19.2 19.2L432 509.3 477.3 464l-22.6-22.6-19.2-19.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zM232 160l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 200l48 0 0 48-48 0 0-48z','M160.9 25.5L14.9 147.2C5.5 132.3 0 114.7 0 95.8C0 42.9 42.9 0 95.8 0c25.1 0 48 9.7 65.1 25.5zm190.3 0C368.2 9.7 391.1 0 416.2 0C469.1 0 512 42.9 512 95.8c0 18.9-5.5 36.5-14.9 51.4L351.1 25.5zM280 160l0 24 0 112 0 24-48 0 0-24 0-112 0-24 48 0zM232 360l48 0 0 48-48 0 0-48z']
      
    ]
  };

  

  
  

  var faTarpDroplet = {
    prefix: 'fasds',
    iconName: 'tarp-droplet',
    icon: [
      576,
      512,
      [],
      'e57c',
      
      ['M0 128l197.5 0c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64L576 128l0 224-160 0 0 160L0 512 0 128zm64 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M288 160c35.3 0 64-26.9 64-60S288-8 288-8s-64 74.9-64 108s28.7 60 64 60zM416 512L576 352l-160 0 0 160z']
      
    ]
  };

  

  
  

  var faRectangleList = {
    prefix: 'fasds',
    iconName: 'rectangle-list',
    icon: [
      576,
      512,
      ["list-alt"],
      'f022',
      
      ['M0 32l576 0 0 448L0 480 0 32zM96 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM200 136l0 48 24 0 224 0 24 0 0-48-24 0-224 0-24 0zm0 96l0 48 24 0 224 0 24 0 0-48-24 0-224 0-24 0zm0 96l0 48 24 0 224 0 24 0 0-48-24 0-224 0-24 0z','M200 136l24 0 224 0 24 0 0 48-24 0-224 0-24 0 0-48zm0 192l24 0 224 0 24 0 0 48-24 0-224 0-24 0 0-48zm24-96l224 0 24 0 0 48-24 0-224 0-24 0 0-48 24 0z']
      
    ]
  };

  
    var faListAlt = faRectangleList;
  

  
  

  var faDumbbell = {
    prefix: 'fasds',
    iconName: 'dumbbell',
    icon: [
      640,
      512,
      [],
      'f44b',
      
      ['M0 224l0 64 32 0 0-64L0 224zm192 0l0 64 256 0 0-64-256 0zm416 0l0 64 32 0 0-64-32 0z','M192 32L96 32l0 96-64 0 0 256 64 0 0 96 96 0 0-448zm256 0l0 448 96 0 0-96 64 0 0-256-64 0 0-96-96 0z']
      
    ]
  };

  

  
  

  var faFaceGrinSquintTears = {
    prefix: 'fasds',
    iconName: 'face-grin-squint-tears',
    icon: [
      512,
      512,
      [129315,"grin-squint-tears"],
      'f586',
      
      ['M36.5 387.9c4.2-1.1 8.4-2.1 12.5-3c19.7-4.3 40-7.1 50.5-8.6l42.1-5.8-5.9 42c-1.5 10.5-4.4 30.9-8.8 50.6c-.9 4-1.9 8.1-3 12.2C164.4 499.8 210.2 512 256 512c65.5 0 131-25 181-75c84.9-84.9 97.7-214.5 38.5-312.9c-4.2 1.1-8.4 2.1-12.5 3c-19.7 4.3-40 7.1-50.5 8.6l-42.1 5.8 5.9-42c1.5-10.5 4.4-30.9 8.8-50.6c.9-4 1.9-8.1 3-12.2C347.6 12.2 301.8 0 256 0C190.5 0 125 25 75 75C-9.9 159.9-22.7 289.5 36.5 387.9zM75 278.6c43.1-12.9 86.2-25.9 129.3-38.8c-12.9 43.1-25.9 86.2-38.8 129.3l-12.9-77.6c-25.9-4.3-51.7-8.6-77.6-12.9zM176 402.2c45.6-19.7 92-51 133.8-92.8s73.1-88.2 92.8-133.8c40.8 63.7 33.5 149.2-21.9 204.7S239.7 443 176 402.2zm63.9-197.9c12.9-43.1 25.9-86.2 38.8-129.3l12.9 77.6 77.6 12.9c-43.1 12.9-86.2 25.9-129.3 38.8z','M408 104c3-21 11.1-77 24.8-90.8c17.9-17.9 47.1-17.6 65.3 .7s18.6 47.6 .7 65.6C485.1 93.3 429 101.1 408 104zM239.8 204.3L278.6 75l12.9 77.6 77.6 12.9L239.8 204.3zm-35.6 35.6L165.5 369.1l-12.9-77.6L75 278.6l129.3-38.8zM13.2 432.5C26.9 418.7 83 410.9 104 408c-3 21-11.1 77-24.8 90.8c-17.9 17.9-47.1 17.6-65.3-.7s-18.6-47.6-.7-65.6z']
      
    ]
  };

  
    var faGrinSquintTears = faFaceGrinSquintTears;
  

  
  

  var faReel = {
    prefix: 'fasds',
    iconName: 'reel',
    icon: [
      448,
      512,
      [],
      'e238',
      
      ['M64 64l0 48 320 0 0-48L64 64zm0 80l0 32 320 0 0-32L64 144zm0 64l0 32 368 0 16 0 0-32-16 0L64 208zm0 64l0 32 320 0 0-32L64 272zm0 64l0 32 320 0 0-32L64 336zm0 64l0 48 320 0 0-48L64 400z','M0 0L32 0 416 0l32 0 0 64-32 0L32 64 0 64 0 0zM0 448l32 0 384 0 32 0 0 64-32 0L32 512 0 512l0-64z']
      
    ]
  };

  

  
  

  var faHardDrive = {
    prefix: 'fasds',
    iconName: 'hard-drive',
    icon: [
      512,
      512,
      [128436,"hdd"],
      'f0a0',
      
      ['M0 32l512 0 0 256L0 288 0 32zM352 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M0 288l512 0 0 192L0 480 0 288zm352 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faHdd = faHardDrive;
  

  
  

  var faTvMusic = {
    prefix: 'fasds',
    iconName: 'tv-music',
    icon: [
      640,
      512,
      [],
      'f8e6',
      
      ['M0 0L64 0 576 0l64 0 0 64 0 288 0 64-64 0L64 416 0 416l0-64L0 64 0 0zM64 64l0 288 512 0 0-288L64 64zM96 448l32 0 384 0 32 0 0 64-32 0-384 0-32 0 0-64z','M576 64L64 64l0 288 512 0 0-288zM416 112l0 40 0 104c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-50.7-96 36 0 76.9c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-57.8 0-40 0-11.1 10.4-3.9 128-48L416 88.9l0 23.1z']
      
    ]
  };

  

  
  

  var faArrowRotateLeft = {
    prefix: 'fasds',
    iconName: 'arrow-rotate-left',
    icon: [
      512,
      512,
      [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"],
      'f0e2',
      
      ['M80 115.2L80 160l45.7 0 17.1-17.1c62.5-62.5 163.8-62.5 226.3 0s62.5 163.8 0 226.3s-163.8 62.5-226.3 0L97.6 414.4C141.3 458.1 198.7 480 256 480s114.7-21.9 158.4-65.6S480 313.3 480 256s-21.9-114.7-65.6-158.4S313.3 32 256 32S141.3 53.9 97.6 97.6L80 115.2z','M16 224l32 0 128 0 32 0 0-64-32 0-96 0 0-96 0-32L16 32l0 32 0 128 0 32z']
      
    ]
  };

  
    var faArrowLeftRotate = faArrowRotateLeft;
  
    var faArrowRotateBack = faArrowRotateLeft;
  
    var faArrowRotateBackward = faArrowRotateLeft;
  
    var faUndo = faArrowRotateLeft;
  

  
  

  var faCookie = {
    prefix: 'fasds',
    iconName: 'cookie',
    icon: [
      512,
      512,
      [127850],
      'f563',
      
      ['M16 222.1L42 370.4 149.8 475l148.3 21 132.3-70.7L496 289.9 470 141.6 362.2 37 213.9 16 81.7 86.7 16 222.1zM144 336l32-32 32 32-32 32-32-32zm32-160l32-32 32 32-32 32-32-32zM336 304l32-32 32 32-32 32-32-32z','M176 176l32 32 32-32-32-32-32 32zM144 336l32 32 32-32-32-32-32 32zm224 0l32-32-32-32-32 32 32 32z']
      
    ]
  };

  

  
  

  var faOctagonDivide = {
    prefix: 'fasds',
    iconName: 'octagon-divide',
    icon: [
      512,
      512,
      [],
      'e203',
      
      ['M0 160L160 0 352 0 512 160l0 192L352 512l-192 0L0 352 0 160zm144 72l0 48 24 0 176 0 24 0 0-48-24 0-176 0-24 0zm80-104l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0z','M224 128l64 0 0 64-64 0 0-64zM144 232l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm144 88l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faCommentArrowUpRight = {
    prefix: 'fasds',
    iconName: 'comment-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e145',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm150.1 72c5.7-5.7 11.3-11.3 17-17c29-29 58-58 87-87L200 208l-24 0c0-16 0-32 0-48l24 0 112 0 24 0 0 24 0 112 0 24-48 0c0-8 0-16 0-24c0-18 0-36 0-54.1c-29 29-58 58-87 87c-5.7 5.7-11.3 11.3-17 17L150.1 312z','M176 160l24 0 112 0 24 0 0 24 0 112 0 24-48 0 0-24 0-54.1-87 87-17 17L150.1 312l17-17 87-87L200 208l-24 0 0-48z']
      
    ]
  };

  

  
  

  var faOctagon = {
    prefix: 'fasds',
    iconName: 'octagon',
    icon: [
      512,
      512,
      [128721],
      'f306',
      
      ['M0 352V160L160 0H352L512 160V352L352 512H160L0 352z','']
      
    ]
  };

  

  
  

  var faBorderBottomRight = {
    prefix: 'fasds',
    iconName: 'border-bottom-right',
    icon: [
      448,
      512,
      ["border-style-alt"],
      'f854',
      
      ['M0 32L0 96l64 0 0-64L0 32zm0 96l0 64 64 0 0-64L0 128zm0 96l0 64 64 0 0-64L0 224zm0 96l0 64 64 0 0-64L0 320zM96 32l0 64 64 0 0-64L96 32zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z','M448 32l0 32 0 384 0 32-32 0L32 480 0 480l0-64 32 0 352 0 0-352 0-32 64 0z']
      
    ]
  };

  
    var faBorderStyleAlt = faBorderBottomRight;
  

  
  

  var faCarBuilding = {
    prefix: 'fasds',
    iconName: 'car-building',
    icon: [
      640,
      512,
      [],
      'f859',
      
      ['M0 0L352 0l0 128-32 0-23.1 0-23.1 0-7.3 21.9-7.3 21.9L252.5 192 192 192l0 64 0 32 0 160 0 32L0 480 0 0zM64 96l0 64 64 0 0-64L64 96zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zM192 96l0 64 64 0 0-64-64 0z','M320 160l-23.1 0-7.3 21.9L254.3 288 224 288l0 160s0 0 0 0l0 64 80 0 0-64 256 0 0 64 80 0 0-64s0 0 0 0l0-160-30.3 0L574.4 181.9 567.1 160 544 160l-224 0zM542.3 288l-220.5 0 21.3-64 177.9 0 21.3 64zM280 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faMessageMusic = {
    prefix: 'fasds',
    iconName: 'message-music',
    icon: [
      512,
      512,
      ["comment-alt-music"],
      'f8af',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM128 288c0 17.7 21.5 32 48 32s48-14.3 48-32l0-100.9 96-36 0 74.7c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32s21.5 32 48 32s48-14.3 48-32l0-128 0-32 0-23.1L330.4 81l-128 48L192 132.9l0 11.1 0 32 0 81.8c-5-1.2-10.4-1.8-16-1.8c-26.5 0-48 14.3-48 32z','M352 72.9L352 96l0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 288c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48L352 72.9z']
      
    ]
  };

  
    var faCommentAltMusic = faMessageMusic;
  

  
  

  var faCameraViewfinder = {
    prefix: 'fasds',
    iconName: 'camera-viewfinder',
    icon: [
      512,
      512,
      ["screenshot"],
      'e0da',
      
      ['M0 0L0 24 0 136l0 24 48 0 0-24 0-88 88 0 24 0 0-48L136 0 24 0 0 0zM0 352l0 24L0 488l0 24 24 0 112 0 24 0 0-48-24 0-88 0 0-88 0-24L0 352zM352 0l0 48 24 0 88 0 0 88 0 24 48 0 0-24 0-112 0-24L488 0 376 0 352 0zm0 464l0 48 24 0 112 0 24 0 0-24 0-112 0-24-48 0 0 24 0 88-88 0-24 0z','M192 96l-12 32-84 0 0 256 320 0 0-256-84 0L320 96 192 96zm64 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z']
      
    ]
  };

  
    var faScreenshot = faCameraViewfinder;
  

  
  

  var faMoneyBillWheat = {
    prefix: 'fasds',
    iconName: 'money-bill-wheat',
    icon: [
      512,
      512,
      [],
      'e52a',
      
      ['M0 256L0 512l512 0 0-256L0 256zm48 48l48 0c0 26.5-21.5 48-48 48l0-48zm0 112c26.5 0 48 21.5 48 48l-48 0 0-48zm272-32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-80l48 0 0 48c-26.5 0-48-21.5-48-48zm0 160c0-26.5 21.5-48 48-48l0 48-48 0z','M160 0l16 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16zM32 16l24 0 48 0 24 0 0 48-24 0L56 64 32 64l0-48zM0 88l24 0 112 0 24 0 0 48-24 0L24 136 0 136 0 88zm56 72l48 0 24 0 0 48-24 0-48 0-24 0 0-48 24 0zM288 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16 16 0zm96 0l16 0c44.2 0 80 35.8 80 80l0 16-16 0c-44.2 0-80-35.8-80-80l0-16zm80 128l16 0 0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80zm-96 0l0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80l16 0zm-128 0l16 0 0 16c0 44.2-35.8 80-80 80l-16 0 0-16c0-44.2 35.8-80 80-80z']
      
    ]
  };

  

  
  

  var faPlusLarge = {
    prefix: 'fasds',
    iconName: 'plus-large',
    icon: [
      512,
      512,
      [],
      'e59e',
      
      ['M288 32l0-32L224 0l0 32 0 192L32 224 0 224l0 64 32 0 192 0 0 192 0 32 64 0 0-32 0-192 192 0 32 0 0-64-32 0-192 0 0-192z','']
      
    ]
  };

  

  
  

  var faBellSchoolSlash = {
    prefix: 'fasds',
    iconName: 'bell-school-slash',
    icon: [
      640,
      512,
      [],
      'f5d6',
      
      ['M64 208c0-19.3 2.6-37.9 7.5-55.6L373 389.9C343.1 406.5 308.7 416 272 416C157.1 416 64 322.9 64 208zM117.7 68.6C155.7 26.5 210.8 0 272 0C386.9 0 480 93.1 480 208c0 42.5-12.8 82-34.6 115c-34-26.4-67.9-52.7-101.8-79.1c5.4-10.8 8.5-23 8.5-35.9c0-44.2-35.8-80-80-80c-20.1 0-38.5 7.4-52.5 19.6c-33.9-26.4-67.9-52.7-101.8-79.1zM128 400c40.1 30.1 90 48 144 48c47 0 90.9-13.5 127.9-36.9L416 423.8l0 40.2 51.1 0c20.3 16 40.6 32 60.9 48l-112 0-32 0-256 0 0-112zM245.6 167.9c7.6-5 16.6-7.9 26.4-7.9c26.5 0 48 21.5 48 48c0 5.5-.9 10.7-2.6 15.6c-23.9-18.6-47.9-37.2-71.8-55.7zM497.2 363.2c8.3-7 19.1-11.2 30.8-11.2c26.5 0 48 21.5 48 48c0 7.4-1.7 14.5-4.7 20.8c-24.7-19.2-49.4-38.4-74.1-57.5z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faBowlingBallPin = {
    prefix: 'fasds',
    iconName: 'bowling-ball-pin',
    icon: [
      576,
      512,
      [],
      'e0c3',
      
      ['M96 220a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm72-48a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zm0 88a28 28 0 1 0 56 0 28 28 0 1 0 -56 0zM404 442.5L423.9 512l112.3 0L576 368 524.9 209.6c-1.9-5.7-3.3-11.6-4.1-17.6l-81.7 0c-.8 6-2.2 11.9-4.1 17.6l-2.9 8.6C442.4 244.8 448 273.8 448 304c0 51.6-16.3 99.4-44 138.5zM416 64l0 1.1c0 7.4 1 14.8 2.9 22l17.7 64.8c.7 2.7 1.3 5.4 1.8 8.1l83.1 0c.5-2.7 1.1-5.4 1.8-8.1l17.7-64.8c2-7.2 2.9-14.6 2.9-22l0-1.1c0-35.3-28.7-64-64-64s-64 28.7-64 64z','M0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zM224 172a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM196 288a28 28 0 1 0 0-56 28 28 0 1 0 0 56zm-44-68a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zm286.5-60l83.1 0c-1 5.7-1.5 11.4-1.5 17.1l0 2.1c0 4.3 .3 8.5 .9 12.8l-81.7 0c.6-4.2 .9-8.5 .9-12.8l0-2.1c0-5.8-.5-11.5-1.5-17.1z']
      
    ]
  };

  

  
  

  var faArrowDownAZ = {
    prefix: 'fasds',
    iconName: 'arrow-down-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-asc","sort-alpha-down"],
      'f15d',
      
      ['M292.8 256l70.4 0 14.7-32 76.3 0 14.7 32 70.4 0-6.1-13.3-88-192L436.5 32l-41.1 0-8.6 18.7-88 192L292.8 256zM320 288l0 64 32 0 52 0-73 63.9L320 425.5l0 14.5 0 8 0 32 32 0 128 0 32 0 0-64-32 0-52 0 73-63.9 10.9-9.6 0-14.5 0-8 0-32-32 0-128 0-32 0zm79.9-112L416 140.8 432.1 176l-32.3 0z','M160 480l23.6-25.7 88-96 21.6-23.6L246 291.4 224.4 315 192 350.4l0-285.7 0-32-64 0 0 32 0 285.7L95.6 315 74 291.4 26.8 334.7l21.6 23.6 88 96L160 480z']
      
    ]
  };

  
    var faSortAlphaAsc = faArrowDownAZ;
  
    var faSortAlphaDown = faArrowDownAZ;
  

  
  

  var faCheckDouble = {
    prefix: 'fasds',
    iconName: 'check-double',
    icon: [
      448,
      512,
      [],
      'f560',
      
      ['M34.7 144l22.6 22.6 80 80L160 269.3l22.6-22.6 160-160L365.3 64 320 18.7 297.4 41.4 160 178.7l-57.4-57.4L80 98.7 34.7 144z','M447.9 206.5l-23.2 22L181 459.3l-22 20.8-22-20.8L23.2 351.6 0 329.6l44-46.5 23.2 22L159 392 380.7 182l23.2-22 44 46.5z']
      
    ]
  };

  

  
  

  var faPeopleDressSimple = {
    prefix: 'fasds',
    iconName: 'people-dress-simple',
    icon: [
      512,
      512,
      [],
      'e218',
      
      ['M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64z','M64 160l128 0 64 224-64 0 0 128L64 512l0-128L0 384 64 160zM256 384l64-224 128 0 64 224-64 0 0 128-128 0 0-128-64 0z']
      
    ]
  };

  

  
  

  var faVestPatches = {
    prefix: 'fasds',
    iconName: 'vest-patches',
    icon: [
      448,
      512,
      [],
      'e086',
      
      ['M136 416a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM128 0l7 0 13.3 0 6.9 11.1 .3 .4c.4 .6 1.2 1.5 2.3 2.8c2.3 2.6 6.1 6.3 11.5 10.1C179.9 31.8 197.4 40 224 40s44.1-8.2 54.7-15.6c5.4-3.8 9.2-7.5 11.5-10.1c1.1-1.3 1.9-2.3 2.3-2.8l.3-.4L299.6 0 313 0l7 0L296.8 69.7C279.3 79.8 255.3 88 224 88s-55.3-8.3-72.8-18.3C143.5 46.5 135.7 23.2 128 0zM304 280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0 0-48 0-8z','M128 0L64 0l0 160L0 256 0 512l192 0 0-224 0-5.2 1.6-4.9 13.5-40.5L128 0zm96 288l0 224 224 0 0-256-64-96L384 0 320 0 224 288zM56 416a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM80.5 255.5L96 271l15.5-15.5L120 247l17 17-8.5 8.5L113 288l15.5 15.5L137 312l-17 17-8.5-8.5L96 305 80.5 320.5 72 329 55 312l8.5-8.5L79 288 63.5 272.5 55 264l17-17 8.5 8.5zM304 280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0-48 0 0-48 0-8z']
      
    ]
  };

  

  
  

  var faLaptopBinary = {
    prefix: 'fasds',
    iconName: 'laptop-binary',
    icon: [
      640,
      512,
      [],
      'e5e7',
      
      ['M0 384l0 48 48 48 544 0 48-48 0-48L0 384zM64 32l0 32 0 288 64 0 0-256 384 0 0 256 64 0 0-288 0-32-32 0L96 32 64 32z','M512 96L128 96l0 256 64 0 0-48-16 0 0-32 16 0 16 0 16 0 0 16 0 64 48 0 0-64 0-16 16 0 64 0 16 0 0 16 0 64 48 0 0-48-16 0 0-32 16 0 16 0 16 0 0 16 0 64 64 0 0-256zM336 352l0-48-32 0 0 48 32 0zM160 128l16 0 64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16zm32 32l0 48 32 0 0-48-32 0zm96-32l16 0 16 0 16 0 0 16 0 80 0 16-32 0 0-16 0-64-16 0 0-32zm112 0l64 0 16 0 0 16 0 80 0 16-16 0-64 0-16 0 0-16 0-80 0-16 16 0zm16 80l32 0 0-48-32 0 0 48z']
      
    ]
  };

  

  
  

  var faTent = {
    prefix: 'fasds',
    iconName: 'tent',
    icon: [
      576,
      512,
      [],
      'e57d',
      
      ['M0 512l288 0 0-256L448 512l128 0L544 176 288 0 32 160 0 512z','M288 256V512H448L288 256z']
      
    ]
  };

  

  
  

  var faAlien = {
    prefix: 'fasds',
    iconName: 'alien',
    icon: [
      448,
      512,
      [128125],
      'f8f5',
      
      ['M0 224C0 400 224 512 224 512s224-112 224-288C448 100.3 347.7 0 224 0S0 100.3 0 224zm64 0l48 0c44.2 0 80 35.8 80 80l0 16-48 0c-44.2 0-80-35.8-80-80l0-16zm192 80c0-44.2 35.8-80 80-80l48 0 0 16c0 44.2-35.8 80-80 80l-48 0 0-16z','M112 224c44.2 0 80 35.8 80 80l0 16-48 0c-44.2 0-80-35.8-80-80l0-16 48 0zm224 0l48 0 0 16c0 44.2-35.8 80-80 80l-48 0 0-16c0-44.2 35.8-80 80-80z']
      
    ]
  };

  

  
  

  var faPersonCane = {
    prefix: 'fasds',
    iconName: 'person-cane',
    icon: [
      448,
      512,
      [],
      'e53c',
      
      ['M304 376l0 8 0 24 48 0 0-24 0-8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 112 0 24 48 0 0-24 0-112c0-30.9-25.1-56-56-56s-56 25.1-56 56z','M176 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM120 256.9L91.4 304.5 74.9 331.9l-54.9-33 16.5-27.4 76.9-128 9.3-15.5 18.1 0 102.2 0 15 0 9.6 11.6 92.9 112 20.4 24.6-49.3 40.9-20.4-24.6L264 235.3 264 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32-64 0 0-32 0-223.1z']
      
    ]
  };

  

  
  

  var faCloudRainbow = {
    prefix: 'fasds',
    iconName: 'cloud-rainbow',
    icon: [
      576,
      512,
      [],
      'f73e',
      
      ['M263.6 189.7c6.5 5 12.5 10.4 18 16.4c16.1-9 34.7-14.1 54.4-14.1l.5 0C388.2 114.8 476.2 64 576 64l0-64C440.1 0 322.3 77 263.6 189.7zm108.1 8.1c20.9 7 39 20 52.3 36.9c35.1-45.4 90.1-74.7 152-74.7l0-64c-83.5 0-157.6 40-204.4 101.8zm69.6 67.9c3 8.3 5.1 17.1 6.1 26.2c15.2 3.8 29.3 10.4 41.8 19.1c15.4-32.5 48.5-55 86.8-55l0-64c-56.6 0-106.3 29.4-134.7 73.7z','M0 512l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28c-18.7-35.7-56.1-60-99.2-60c-61.9 0-112 50.1-112 112l0 21.5C26.7 338.6 0 374.2 0 416l0 96z']
      
    ]
  };

  

  
  

  var faCrosshairs = {
    prefix: 'fasds',
    iconName: 'crosshairs',
    icon: [
      512,
      512,
      [],
      'f05b',
      
      ['M42.4 224l65 0c12.5-58.3 58.4-104.1 116.6-116.6c0-21.7 0-43.3 0-65C130.3 56.3 56.3 130.3 42.4 224zm0 64c13.9 93.7 88 167.7 181.6 181.6c0-21.7 0-43.3 0-65C165.7 392.1 119.9 346.3 107.4 288c-21.7 0-43.3 0-65 0zM288 42.4l0 65c58.3 12.5 104.1 58.4 116.6 116.6l65 0C455.7 130.3 381.7 56.3 288 42.4zm0 362.3l0 65c93.7-13.9 167.7-88 181.6-181.6c-21.7 0-43.3 0-65 0C392.1 346.3 346.3 392.1 288 404.6z','M288 0l0 32 0 96 0 32-64 0 0-32 0-96 0-32 64 0zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm256 32l-96 0-32 0 0-64 32 0 96 0 32 0 0 64-32 0zM288 352l0 32 0 96 0 32-64 0 0-32 0-96 0-32 64 0zM128 288l-96 0L0 288l0-64 32 0 96 0 32 0 0 64-32 0z']
      
    ]
  };

  

  
  

  var faMusicMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'music-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e662',
      
      ['M129.8 180.2L352 106.2l0 285.7c0 1.3 0 2.5-.1 3.8c.1 1.4 .1 2.8 .1 4.2c0 5.5-.6 10.7-1.8 15.7c40.4-2.7 77.7-17 108.5-39.6L569.4 486.6 592 509.3 637.3 464l-22.6-22.6L504 330.7c25.2-34.4 40-76.8 40-122.7C544 93.1 450.9 0 336 0C230.6 0 143.4 78.5 129.8 180.2z','M320 185.3l0-33.3-31.6 10.5-192 64L80 232l0 17.3 0 48 0 120.3c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48c32.5 0 59.3-18.1 63.4-41.6c.4-1.7 .6-3.4 .6-5.2l0-1.2 0-149.5 144-48 0 87c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.3-.1-2.5-.2-3.7c.1-1 .2-2 .2-3l0-160 0-48z']
      
    ]
  };

  

  
  

  var faTruck = {
    prefix: 'fasds',
    iconName: 'truck',
    icon: [
      640,
      512,
      [9951,128666],
      'f0d1',
      
      ['M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M416 0L0 0 0 416l65.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l66.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l1.1 0 32 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0 0-96zm0 160l50.7 0L544 237.3l0 18.7-128 0 0-96z']
      
    ]
  };

  

  
  

  var faLandmark = {
    prefix: 'fasds',
    iconName: 'landmark',
    icon: [
      512,
      512,
      [127963],
      'f66f',
      
      ['M0 464l0 48 512 0 0-48-64-48 0-224-64 0 0 224-40 0 0-224-64 0 0 224-48 0 0-224-64 0 0 224-40 0 0-224-64 0 0 224L0 464z','M512 192H0V144L256 0 512 144v48z']
      
    ]
  };

  

  
  

  var faHouseWindow = {
    prefix: 'fasds',
    iconName: 'house-window',
    icon: [
      576,
      512,
      [],
      'e3b3',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272zm160-32l128 0 0 128-128 0 0-128z','M0 240L288 0 576 240v32H512L288 88 64 272H0V240z']
      
    ]
  };

  

  
  

  var faHoseReel = {
    prefix: 'fasds',
    iconName: 'hose-reel',
    icon: [
      640,
      512,
      [],
      'e41a',
      
      ['M64 256c0 141.4 114.6 256 256 256c54.3 0 104.8-17 146.3-45.9l-36.6-52.5C398.6 435.3 360.8 448 320 448c-106 0-192-86-192-192s86-192 192-192s192 86 192 192l0 96 64 0 0-96C576 114.6 461.4 0 320 0S64 114.6 64 256zm96 0a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm256 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zm-160 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M480 352l24 0 80 0 24 0 0 48-24 0-2.3 0-11.4 80 13.7 0 0 32-16 0-48 0-16 0 0-32 13.7 0-11.4-80-2.3 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faFamilyPants = {
    prefix: 'fasds',
    iconName: 'family-pants',
    icon: [
      512,
      512,
      [],
      'e302',
      
      ['M24 352l40 0 0 160 112 0 0-64-32 0 0-32 0-160 0-32 32 0 16 0c-10-13.4-16-30-16-48c0-5.5 .6-10.8 1.6-16L32 160 24 352zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64zm0 160l16 0 32 0 0 32 0 160 0 32-32 0 0 64 112 0 0-160 40 0-8-192-145.6 0c1 5.2 1.6 10.5 1.6 16c0 18-6 34.6-16 48z','M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 80l0 160-32 0 0 96-96 0 0-96-32 0 0-160 160 0z']
      
    ]
  };

  

  
  

  var faPlateUtensils = {
    prefix: 'fasds',
    iconName: 'plate-utensils',
    icon: [
      640,
      512,
      [58713],
      'e43b',
      
      ['M152 256.6l0 127.1C192.5 441.9 259.8 480 336 480c89.4 0 166.5-52.3 202.4-128L512 352l-32 0 0-26.2C454.1 379.2 399.3 416 336 416c-88.4 0-160-71.6-160-160c0-4.2 .2-8.3 .5-12.4c-7.5 5.3-15.7 9.7-24.5 13.1zM202.9 75.8L222.7 143c29-29 69-47 113.3-47c63.3 0 118.1 36.8 144 90.2l0-26.2c0-25.1 4.2-46.8 11.2-65.5C450.9 55.8 396.2 32 336 32c-49.8 0-95.9 16.3-133.1 43.8zM208 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0z','M40 16l16 0 0 136 16 0L88 16l16 0 16 136 16 0 0-136 16 0 40 136c0 41.5-31.6 75.6-72 79.6L120 472l0 24-48 0 0-24 0-240.4c-40.4-4-72-38.1-72-79.6L40 16zM512 160C512 32 640 16 640 16l0 176 0 24 0 104 0 152 0 24-48 0 0-24 0-152-80 0 0-160z']
      
    ]
  };

  

  
  

  var faPrescriptionBottleMedical = {
    prefix: 'fasds',
    iconName: 'prescription-bottle-medical',
    icon: [
      384,
      512,
      ["prescription-bottle-alt"],
      'f486',
      
      ['M32 96l320 0 0 416L32 512 32 96zM96 256l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0z','M384 0L0 0 0 96l384 0 0-96zM160 192l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z']
      
    ]
  };

  
    var faPrescriptionBottleAlt = faPrescriptionBottleMedical;
  

  
  

  var faBraille = {
    prefix: 'fasds',
    iconName: 'braille',
    icon: [
      640,
      512,
      [],
      'f2a1',
      
      ['M0 416a64 64 0 1 0 128 0A64 64 0 1 0 0 416zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm80-160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm80-160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM352 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm80-160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM512 96a64 64 0 1 0 128 0A64 64 0 1 0 512 96zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm0 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM592 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M64 160A64 64 0 1 0 64 32a64 64 0 1 0 0 128zm0 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 96A64 64 0 1 0 160 96a64 64 0 1 0 128 0zm128 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faCalendarClock = {
    prefix: 'fasds',
    iconName: 'calendar-clock',
    icon: [
      576,
      512,
      ["calendar-time"],
      'e0d2',
      
      ['M0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0l0 64L0 64zM0 192L0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176L0 192zm432 0c5.4 0 10.7 .2 16 .7l0-.7-16 0z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0 0 16z']
      
    ]
  };

  
    var faCalendarTime = faCalendarClock;
  

  
  

  var faClockDesk = {
    prefix: 'fasds',
    iconName: 'clock-desk',
    icon: [
      448,
      512,
      [],
      'e134',
      
      ['M0 224a224 224 0 1 0 448 0A224 224 0 1 0 0 224zM200 96l48 0 0 24 0 94.1 41 41 17 17L272 305.9l-17-17-48-48-7-7 0-9.9 0-104 0-24z','M248 120l0-24-48 0 0 24 0 104 0 9.9 7 7 48 48 17 17L305.9 272l-17-17-41-41 0-94.1zM448 224c0 123.7-100.3 224-224 224S0 347.7 0 224L0 512l448 0 0-288z']
      
    ]
  };

  

  
  

  var faCalendarCheck = {
    prefix: 'fasds',
    iconName: 'calendar-check',
    icon: [
      448,
      512,
      [],
      'f274',
      
      ['M0 192l448 0 0 320L0 512 0 192zM102.1 336l17 17 64 64 17 17 17-17L329 305l17-17L312 254.1l-17 17-95 95-47-47-17-17L102.1 336z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zM329 305l17-17L312 254.1l-17 17-95 95-47-47-17-17L102.1 336l17 17 64 64 17 17 17-17L329 305z']
      
    ]
  };

  

  
  

  var faPlaneProp = {
    prefix: 'fasds',
    iconName: 'plane-prop',
    icon: [
      576,
      512,
      [],
      'e22b',
      
      ['M231.7 194.4c2.8-22.1 5.5-44.3 8.3-66.4c2.7-21.3 5.3-42.7 8-64s5.3-42.7 8-64l64 0 8 64 8 64 8 64-88 0-24.3 2.4z','M231.7 317.6L256 320l88 0 138.3 0c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64L344 192l-88 0-24.3 2.4-110 11L112 128l-64 0L36 224.2c-1.3-.2-2.6-.2-4-.2c-17.7 0-32 14.3-32 32s14.3 32 32 32c1.3 0 2.7-.1 4-.2L48 384l64 0 9.7-77.4 110 11zM336 128l32 0 0 16 0 16 32 0 0-16 0-32 16 0 0-32-16 0 0-32 0-16-32 0 0 16 0 16-40 0 8 64zM248 64l-56 0 0 64 48 0 8-64zm-8 320l-48 0 0 64 56 0-8-64zm88 64l40 0 0 16 0 16 32 0 0-16 0-32 16 0 0-32-16 0 0-32 0-16-32 0 0 16 0 16-32 0-8 64z']
      
    ]
  };

  

  
  

  var faNfcSignal = {
    prefix: 'fasds',
    iconName: 'nfc-signal',
    icon: [
      512,
      512,
      [],
      'e1fb',
      
      ['M0 32L0 480l225.8 0c2.5-22.2 7.4-43.6 14.6-64L80 416l-16 0 0-16 0-288 0-16 16 0 64 0 16 0 0 32-16 0-48 0 0 256 157.9 0c22.5-45.2 56.4-83.6 98.1-111.5L352 128l-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-98.7 0-16 16 0 144 0 16 0 0 16 0 141.9c20.1-10 41.6-17.7 64-22.8L448 32 0 32z','M304 512c0-114.9 93.1-208 208-208l0-48c-141.4 0-256 114.6-256 256l48 0zm144-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-80l0-48c-88.4 0-160 71.6-160 160l48 0c0-61.9 50.1-112 112-112z']
      
    ]
  };

  

  
  

  var faStarSharpHalfStroke = {
    prefix: 'fasds',
    iconName: 'star-sharp-half-stroke',
    icon: [
      576,
      512,
      ["star-sharp-half-alt"],
      'e28d',
      
      ['M288 .1c0 60.5 0 120.9 0 181.3c3.5 10.4 6.9 20.9 10.3 31.5l12.6 38.7 40.7 0 33.3 0L358 271.1 325 295l12.6 38.7 10.3 31.7L321 345.8l-32.9-23.9c-.1 23.1-.1 46.2-.1 69.3c29.8 21.6 59.6 43.2 89.3 64.8l77.1 56L425 421.4l-34.1-105 89.3-64.9 77.1-56-95.3 0-110.4 0-34.1-105C307.7 60.4 297.9 30.2 288 .1z','M288 391.2l0-391L224.5 195.6l-205.6 0L185.2 316.4 121.7 512 288 391.2z']
      
    ]
  };

  
    var faStarSharpHalfAlt = faStarSharpHalfStroke;
  

  
  

  var faWater = {
    prefix: 'fasds',
    iconName: 'water',
    icon: [
      576,
      512,
      [],
      'f773',
      
      ['M0 240l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2C38.6 233.9 19.3 240 0 240z','M272.4 141.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5C80.8 67.5 68.8 76.1 54 82.9C38.6 89.9 19.3 96 0 96l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9zm0 288c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 377.9 19.3 384 0 384l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z']
      
    ]
  };

  

  
  

  var faWaveform = {
    prefix: 'fasds',
    iconName: 'waveform',
    icon: [
      640,
      512,
      [],
      'f8f1',
      
      ['M429 64l38.5 0 4.3 28.4L500.2 282l20.4-95 5.8-27 30.4 0 9.5 22.8L600 264l8 0 24 0 0 48-24 0-24 0-16 0-6.2-14.8-10.5-25.1L519.5 421l-5.8 27-37.2 0-4.3-28.4L446.8 249.5 407.7 483.9 403 512l-38.7 0-4.1-28.6L320 201.7 279.8 483.4 275.7 512 237 512l-4.7-28.1L193.2 249.5 167.7 419.6 163.5 448l-37.2 0-5.8-27L88.6 272.1 78.2 297.2 72 312l-16 0-24 0L8 312l0-48 24 0 8 0 33.8-81.2L83.3 160l30.4 0 5.8 27 20.4 95L168.3 92.4 172.5 64 211 64l4.7 28.1 38.5 231L296.2 28.6 300.3 0l39.3 0 4.1 28.6 42.1 294.5 38.5-231L429 64z','']
      
    ]
  };

  

  
  

  var faTricycleAdult = {
    prefix: 'fasds',
    iconName: 'tricycle-adult',
    icon: [
      640,
      512,
      [],
      'e5c4',
      
      ['M0 352c0-28.4 12.3-53.9 31.9-71.4C48.9 265.3 71.3 256 96 256c39.9 0 74.1 24.3 88.6 58.9c4.8 11.4 7.4 23.9 7.4 37.1c0 16.9-4.3 32.7-12 46.5c3.8 1 7.8 1.5 12 1.5c26.5 0 48-21.5 48-48c0-9.7-2.9-18.8-7.9-26.4c18.3 4.1 36.6 8.2 54.9 12.3c.7 4.6 1 9.3 1 14c0 53-43 96-96 96c-17.5 0-33.9-4.7-48-12.8c-14.1 8.2-30.5 12.8-48 12.8c-53 0-96-43-96-96zM23.1 108.7L83.3 87.1l10.8 30.1 18 50.1 86.5 18.2 31.3 6.6-13.2 62.6-31.3-6.6-104-21.9-17.5-3.7-6-16.8-24-66.9L23.1 108.7zM48 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm592 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0zm-144 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M312 64l-24 0 0 48 24 0 35.5 0 81.5 115.9L372 304l-17.3 0L37.3 232.6l-23.4-5.3L3.3 274.1l23.4 5.3 5.1 1.2C48.9 265.3 71.3 256 96 256c39.9 0 74.1 24.3 88.6 58.9l162.2 36.5 2.6 .6 2.7 0 32 0 12 0 7.2-9.6 54.9-73.2 13.7 19.5c10.6-12.1 24.2-21.5 39.7-27L379.6 74.2 372.5 64 360 64l-48 0z']
      
    ]
  };

  

  
  

  var faFileEps = {
    prefix: 'fasds',
    iconName: 'file-eps',
    icon: [
      512,
      512,
      [],
      'e644',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM160 352l0 16 0 64 0 64 0 16 16 0 64 0 16 0 0-32-16 0-48 0 0-32 32 0 16 0 0-32-16 0-32 0 0-32 48 0 16 0 0-32-16 0-64 0-16 0zm144 0l-16 0 0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm117.7-80c-25.2 0-45.7 20.4-45.7 45.7c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7L424 480l-16 0 0 32 16 0 34.3 0c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7l26.3 0 16 0 0-32-16 0-26.3 0z']
      
    ]
  };

  

  
  

  var faHandHoldingDroplet = {
    prefix: 'fasds',
    iconName: 'hand-holding-droplet',
    icon: [
      576,
      512,
      ["hand-holding-water"],
      'f4c1',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M211.2 102.4L288 0l76.8 102.4C377.3 119 384 139.2 384 160c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6z']
      
    ]
  };

  
    var faHandHoldingWater = faHandHoldingDroplet;
  

  
  

  var faSquare4 = {
    prefix: 'fasds',
    iconName: 'square-4',
    icon: [
      448,
      512,
      [],
      'e259',
      
      ['M0 32l448 0 0 448L0 480 0 32zM112.4 320l31.6 0 96 0 0 40 0 24 48 0 0-24 0-40 8 0 24 0 0-48-24 0-8 0 0-56 0-24-48 0 0 24 0 56-64.4 0 40-144-49.8 0L120.9 289.6 112.4 320z','M120.9 289.6L165.8 128l49.8 0-40 144 64.4 0 0-56 0-24 48 0 0 24 0 56 8 0 24 0 0 48-24 0-8 0 0 40 0 24-48 0 0-24 0-40-96 0-31.6 0 8.5-30.4z']
      
    ]
  };

  

  
  

  var faBuoyMooring = {
    prefix: 'fasds',
    iconName: 'buoy-mooring',
    icon: [
      576,
      512,
      [],
      'e5b6',
      
      ['M0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448zM153 288l65.3 0 139.5 0 65.3 0L383.4 89.7 378.2 64 352 64l-32 0 0-64L256 0l0 64-32 0-26.2 0-5.1 25.7L153 288z','M153 288L131.9 393.6c6.5 4.4 12.6 8 19.4 11.1c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0s0 0 0 0l1.1-.8L288 368l19.7 14.2s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c6.8-3.1 12.9-6.7 19.4-11.1L423 288l-65.3 0-139.5 0L153 288z']
      
    ]
  };

  

  
  

  var faArrowDown19 = {
    prefix: 'fasds',
    iconName: 'arrow-down-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-asc","sort-numeric-down"],
      'f162',
      
      ['M344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.6-6.2 44.8-18 64.1L453.5 480l-74.9 0 10.1-16.6 25.1-41.3C373.9 413.7 344 378.3 344 336zm8-304l32 0 48 0 32 0 0 32 0 96 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-64-16 0-32 0 0-64zm48 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M160 480l23.6-25.7 88-96 21.6-23.6L246 291.4 224.4 315 192 350.4l0-285.7 0-32-64 0 0 32 0 285.7L95.6 315 74 291.4 26.8 334.7l21.6 23.6 88 96L160 480z']
      
    ]
  };

  
    var faSortNumericAsc = faArrowDown19;
  
    var faSortNumericDown = faArrowDown19;
  

  
  

  var faSleigh = {
    prefix: 'fasds',
    iconName: 'sleigh',
    icon: [
      640,
      512,
      [],
      'f7cc',
      
      ['M32 416l0 64 32 0 544 0 32 0 0-32 0-64 0-32-64 0 0 32 0 32-128 0-64 0-192 0-64 0-64 0-32 0z','M0 32l32 0 23 0 1 0s0 0 0 0c60 .4 115.6 31.4 147.4 82.3C246.1 182.5 320.9 224 401.4 224l46.6 0 0-128 32 0 32 0 32 0 32 0 0 64-32 0 0 96c0 53-43 96-96 96l0 64-64 0 0-64-192 0 0 64-64 0 0-64c-53 0-96-43-96-96L32 96 0 96 0 32z']
      
    ]
  };

  

  
  

  var faCarOn = {
    prefix: 'fasds',
    iconName: 'car-on',
    icon: [
      512,
      512,
      [],
      'e4dd',
      
      ['M22.1 56L39 73l48 48 17 17L137.9 104 121 87 73 39l-17-17L22.1 56zM232 0l0 24 0 80 0 24 48 0 0-24 0-80 0-24L232 0zM374.1 104L408 137.9l17-17 48-48 17-17L456 22.1 439 39 391 87l-17 17z','M160 160l-21.1 0-8.3 19.4L84 288l-36 0 0 96 0 64 0 64 80 0 0-64 256 0 0 64 80 0 0-64 0-64 0-96-36 0L381.4 179.4 373.1 160 352 160l-192 0zM358.3 288l-204.7 0 27.4-64 149.8 0 27.4 64zM104 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faMeteor = {
    prefix: 'fasds',
    iconName: 'meteor',
    icon: [
      512,
      512,
      [9732],
      'f753',
      
      ['M0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L496 208l-59.9 4.6L512 0 299.4 75.9 304 16 101.3 133.4C38.6 169.7 0 236.6 0 309zm320 11A128 128 0 1 1 64 320a128 128 0 1 1 256 0z','M64 320a128 128 0 1 1 256 0A128 128 0 1 1 64 320zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faCartArrowUp = {
    prefix: 'fasds',
    iconName: 'cart-arrow-up',
    icon: [
      576,
      512,
      [],
      'e3ee',
      
      ['M122 32l48.8 256L312 288c0-36.7 0-73.4 0-110.1c-7.7 7.7-15.4 15.4-23 23c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9l17-17 64-64c5.7-5.7 11.3-11.3 17-17c5.7 5.7 11.3 11.3 17 17l64 64c5.7 5.7 11.3 11.3 17 17L400 217.9l-17-17c-7.7-7.7-15.3-15.4-23-23c0 36.7 0 73.4 0 110.1l136 0L576 32 122 32z','M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0L119.6 19.5 115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM312 177.9L312 288l48 0 0-110.1 23 23 17 17L433.9 184l-17-17-64-64-17-17-17 17-64 64-17 17L272 217.9l17-17 23-23z']
      
    ]
  };

  

  
  

  var faSquareVirus = {
    prefix: 'fasds',
    iconName: 'square-virus',
    icon: [
      448,
      512,
      [],
      'e578',
      
      ['M0 32L0 480l448 0 0-448L0 32zM62.6 230.9l24 0c29.3 0 43.9-35.4 23.2-56.1c-5.7-5.7-11.3-11.3-17-17l17-17c5.7-5.7 11.3-11.3 17-17l17 17c10.3 10.3 24.4 11.9 35.8 7.1c5.7-2.4 10.8-6.3 14.4-11.5c1.8-2.6 3.3-5.5 4.3-8.6c.5-1.6 .9-3.2 1.2-4.9c.1-.9 .2-1.7 .3-2.6c.1-.8 .1-1.6 .1-2.7c0-8 0-16 0-24l24 0 24 0c0 8 0 16 0 24c.2 29.3 35.4 43.8 56.1 23.2l17-17c5.7 5.7 11.3 11.3 17 17l17 17-17 17c-20.7 20.7-6 56.1 23.2 56.1l24 0 0 24 0 24-24 0c-29.3 0-43.9 35.4-23.2 56.1l17 17-17 17c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-20.7-20.7-56.1-6-56.1 23.2c0 8 0 16 0 24l-24 0-24 0c0-8 0-16 0-24.3c0-.7 0-1.6-.1-2.4s-.2-1.7-.3-2.6c-.3-1.7-.7-3.3-1.2-4.9c-1-3.2-2.5-6-4.3-8.6c-3.6-5.2-8.7-9.1-14.4-11.5c-11.4-4.7-25.4-3.2-35.8 7.1c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17s-11.3-11.3-17-17l17-17c20.7-20.7 6-56.1-23.2-56.1l-24 0c0-8 0-16 0-24s0-16 0-24z','M337.8 140.9l-17-17-17 17c-20.7 20.7-56.1 6-56.1-23.2l0-24-24 0-24 0 0 24c0 29.3-35.4 43.9-56.1 23.2l-17-17-17 17s0 0 0 0l-17 17 17 17c20.7 20.7 6 56.1-23.2 56.1l-24 0 0 24 0 24 24 0c29.3 0 43.9 35.4 23.2 56.1l-17 17 17 17 17 17 17-17c20.7-20.7 56.1-6 56.1 23.2l0 24 24 0 24 0 0-24c0-29.3 35.4-43.9 56.1-23.2l17 17 17-17 17-17-17-17c-20.7-20.7-6-56.1 23.2-56.1l24 0 0-24 0-24-24 0c-29.3 0-43.9-35.4-23.2-56.1l17-17-17-17s0 0 0 0s0 0 0 0zM160 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faCamera = {
    prefix: 'fasds',
    iconName: 'camera',
    icon: [
      512,
      512,
      [62258,"camera-alt"],
      'f030',
      
      ['M160 288a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M160 32L138.7 96 0 96 0 480l512 0 0-384L373.3 96 352 32 160 32zm96 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z']
      
    ]
  };

  
    var faCameraAlt = faCamera;
  

  
  

  var faCameraPolaroid = {
    prefix: 'fasds',
    iconName: 'camera-polaroid',
    icon: [
      576,
      512,
      [],
      'f8aa',
      
      ['M0 352l0 96 0 32 32 0 512 0 32 0 0-32 0-96L0 352zm96 48l16 0 352 0 16 0 0 32-16 0-352 0-16 0 0-32zM224 192a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M64 32l32 0 384 0 32 0 0 32 0 182.3 58.6 87.9 5.4 8.1 0 9.7L0 352l0-9.7 5.4-8.1L64 246.3 64 64l0-32zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM384 96l0 64 64 0 0-64-64 0z']
      
    ]
  };

  

  
  

  var faCloudMeatball = {
    prefix: 'fasds',
    iconName: 'cloud-meatball',
    icon: [
      512,
      512,
      [],
      'f73b',
      
      ['M0 400a48 48 0 1 0 96 0A48 48 0 1 0 0 400zm144-16l0 32 28.1 18.7-6.6 33.1 22.6 22.6 33.1-6.6L240 512l32 0 18.7-28.1 33.1 6.6 22.6-22.6-6.6-33.1L368 416l0-32-28.1-18.7 6.6-33.1-22.6-22.6-33.1 6.6L272 288l-32 0-18.7 28.1-33.1-6.6-22.6 22.6 6.6 33.1L144 384zm272 16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M0 320l96 0 36.4 0 10.5-10.5 22.6-22.6 12.1-12.1 16.8 3.4 12.1 2.4 6.9-10.3 9.5-14.2 17.1 0 32 0 17.1 0 9.5 14.2 6.9 10.3 12.1-2.4 16.8-3.4 12.1 12.1 22.6 22.6L379.6 320l36.4 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faMessageHeart = {
    prefix: 'fasds',
    iconName: 'message-heart',
    icon: [
      512,
      512,
      [],
      'e5c9',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM144 171.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 304.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z','M203.2 112c-32.7 0-59.2 26.5-59.2 59.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L256 304.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0z']
      
    ]
  };

  

  
  

  var faHammerCrash = {
    prefix: 'fasds',
    iconName: 'hammer-crash',
    icon: [
      640,
      512,
      [],
      'e414',
      
      ['M276.3 399.1l112.1-54.6 77.4 97.8 27.2-121.7 124.7 .5L539.6 224l78.2-97.2-124.7 .5L465.8 5.6 400.4 88.4l5.9 3 28.6 14.3-14.3 28.6-88 176-14.3 28.6-25.1-12.5-16.9 72.7z','M0 144L304 296l88-176L184 16 64 16 0 144zM195 277.3l-85.9-42.9L.1 452.5l85.9 42.9L195 277.3z']
      
    ]
  };

  

  
  

  var faFishingRod = {
    prefix: 'fasds',
    iconName: 'fishing-rod',
    icon: [
      448,
      512,
      [],
      'e3a8',
      
      ['M0 288L0 512l128 0 0-224-40 0 0-181.9L291.4 48 328 48l0 88 0 24 48 0 0-24 0-112 0-24L352 0 288 0l-3.4 0-3.2 .9-224 64L40 69.9 40 88l0 200L0 288z','M352 192c-32 16-96 75.2-96 152c0 32 16 80 64 112l-32 40 0 16 128 0 0-16-32-40c48-32 64-80 64-112c0-76.8-64-136-96-152zm8 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faCircleInfo = {
    prefix: 'fasds',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192-32l24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0 24 0 0-64-24 0-24 0 0-48zm32-96l64 0 0 64-64 0 0-64z','M288 128l0 64-64 0 0-64 64 0zm-96 96l24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0 24 0 0-64-24 0-24 0 0-48z']
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faSlashBack = {
    prefix: 'fasds',
    iconName: 'slash-back',
    icon: [
      320,
      512,
      [],
      '5c',
      
      ['M.1 0L71.2 0 319.9 512l-71.2 0L.1 0z','']
      
    ]
  };

  

  
  

  var faUserDoctor = {
    prefix: 'fasds',
    iconName: 'user-doctor',
    icon: [
      448,
      512,
      ["user-md"],
      'f0f0',
      
      ['M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z','M160 304l0 66.3c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7l0-66.3-64 0L0 512l448 0L384 304l-64 0 0 58c27.6 7.1 48 32.2 48 62l0 40 0 16-16 0-16 0-16 0 0-32 16 0 0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 24 16 0 0 32-16 0-16 0-16 0 0-16 0-40c0-29.8 20.4-54.9 48-62l0-58-128 0zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  
    var faUserMd = faUserDoctor;
  

  
  

  var faMeterBolt = {
    prefix: 'fasds',
    iconName: 'meter-bolt',
    icon: [
      640,
      512,
      [],
      'e1e9',
      
      ['M0 256C0 397.4 114.6 512 256 512c80.8 0 152.9-37.5 199.9-96L384 416l0-71.7 127.9-97.1C507.2 109.9 394.4 0 256 0C114.6 0 0 114.6 0 256zM128 128l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32zm96 0l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32zm96 0l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32z','M640 376L464 512l40-128H416V360L592 224 552 352h88v24z']
      
    ]
  };

  

  
  

  var faHouseChimneyBlank = {
    prefix: 'fasds',
    iconName: 'house-chimney-blank',
    icon: [
      576,
      512,
      [],
      'e3b0',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272z','M288 0L0 240l0 32 64 0L288 88 512 272l64 0 0-32-64-53.3L512 32l-96 0 0 74.7L288 0z']
      
    ]
  };

  

  
  

  var faHouseHeart = {
    prefix: 'fasds',
    iconName: 'house-heart',
    icon: [
      576,
      512,
      ["home-heart"],
      'f4c9',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272zm112 43.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 448.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z','M288 0L0 240l0 32 64 0L288 88 512 272l64 0 0-32L288 0zM176 315.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L288 448.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0c-32.7 0-59.2 26.5-59.2 59.2z']
      
    ]
  };

  
    var faHomeHeart = faHouseHeart;
  

  
  

  var faFileXmark = {
    prefix: 'fasds',
    iconName: 'file-xmark',
    icon: [
      384,
      512,
      ["file-times"],
      'f317',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM94.1 256c5.7 5.7 11.3 11.3 17 17l47 47c-15.7 15.7-31.3 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47l47 47 17 17c11.3-11.3 22.6-22.6 33.9-33.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47l47-47c5.7-5.7 11.3-11.3 17-17c-11.3-11.3-22.6-22.6-33.9-33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.4 31.4-47 47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17c-11.3 11.3-22.6 22.6-33.9 33.9z','M384 160l-160 0L224 0 384 160zm-94.1 96l-17 17-47 47 47 47 17 17L256 417.9l-17-17-47-47-47 47-17 17L94.1 384l17-17 47-47-47-47-17-17L128 222.1l17 17 47 47 47-47 17-17L289.9 256z']
      
    ]
  };

  
    var faFileTimes = faFileXmark;
  

  
  

  var faMountain = {
    prefix: 'fasds',
    iconName: 'mountain',
    icon: [
      512,
      512,
      [127956],
      'f6fc',
      
      ['M143.1 201.4c21.6 28.9 43.3 57.7 64.9 86.6c16-21.3 32-42.7 48-64c42.7 0 85.3 0 128 0C341.3 160 298.7 96 256 32c-37.6 56.5-75.3 112.9-112.9 169.4z','M384 224l-128 0-48 64-64.9-86.6L0 416l0 64 512 0 0-64L384 224z']
      
    ]
  };

  

  
  

  var faHourglass = {
    prefix: 'fasds',
    iconName: 'hourglass',
    icon: [
      384,
      512,
      [9203,62032,"hourglass-empty"],
      'f254',
      
      ['M32 64l32 0 32 0 192 0 32 0 32 0 0 64 0 13.3-9.4 9.4L237.3 256 342.6 361.4l9.4 9.4 0 13.3 0 64-32 0-32 0L96 448l-32 0-32 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64z','M32 0L0 0 0 64l32 0 320 0 32 0 0-64L352 0 32 0zm0 448L0 448l0 64 32 0 320 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  
    var faHourglassEmpty = faHourglass;
  

  
  

  var faNfcTrash = {
    prefix: 'fasds',
    iconName: 'nfc-trash',
    icon: [
      640,
      512,
      [],
      'e1fd',
      
      ['M0 32L0 480l381.6 0-4.6-64-9.1 0L80 416l-16 0 0-16 0-288 0-16 16 0 64 0 16 0 0 32-16 0-48 0 0 256 256 0 0-96 0-96 0-64-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-98.7 0-16 16 0 144 0 16 0 0 16 0 80 34.3 0 16-32 13.7 0 0-128L0 32z','M464 192l-9.9 0-4.4 8.8L438.1 224 400 224l-16 0 0 32 16 0 48 0 128 0 48 0 16 0 0-32-16 0-38.1 0-11.6-23.2-4.4-8.8-9.9 0-96 0zm-64 96l16 224 192 0 16-224-224 0z']
      
    ]
  };

  

  
  

  var faTruckFieldUn = {
    prefix: 'fasds',
    iconName: 'truck-field-un',
    icon: [
      640,
      512,
      [],
      'e58e',
      
      ['M96 400a80 80 0 1 0 160 0A80 80 0 1 0 96 400zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M384 32L32 32l0 96L0 128 0 288l32 0 0 32L0 320l0 64 32 0 33.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l66.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l33.1 0 32 0 0-64-32 0 0-96-68.1 0L477.2 83l-8.4-19L448 64l-64 0 0-32zm0 96l43.2 0 42.7 96L384 224l0-96zM128 144l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-16 32 0 0 16 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64 0-16 32 0 0 16zm112-16l8 0 9.9 0 4.4 8.8L288 188.2l0-44.2 0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L256 195.8l0 44.2 0 16-32 0 0-16 0-96 0-16 16 0z']
      
    ]
  };

  

  
  

  var faPuzzlePieceSimple = {
    prefix: 'fasds',
    iconName: 'puzzle-piece-simple',
    icon: [
      640,
      512,
      ["puzzle-piece-alt"],
      'e231',
      
      ['M256 144c0-17.8 12.9-33.3 32-41.6L288 64 128 64l0 160-38.4 0c-8.3-19.1-23.8-32-41.6-32c-26.5 0-48 28.7-48 64s21.5 64 48 64c17.8 0 33.3-12.9 41.6-32l38.4 0 0 160 160 0 0-38.4c-19.1-8.3-32-23.8-32-41.6c0-26.5 28.7-48 64-48s64 21.5 64 48c0 17.8-12.9 33.3-32 41.6l0 38.4 160 0 0-160 38.4 0c8.3 19.1 23.8 32 41.6 32c26.5 0 48-28.7 48-64s-21.5-64-48-64c-17.8 0-33.3 12.9-41.6 32L512 224l0-160L352 64l0 38.4c19.1 8.3 32 23.8 32 41.6c0 26.5-28.7 48-64 48s-64-21.5-64-48z','']
      
    ]
  };

  
    var faPuzzlePieceAlt = faPuzzlePieceSimple;
  

  
  

  var faTreeDeciduous = {
    prefix: 'fasds',
    iconName: 'tree-deciduous',
    icon: [
      512,
      512,
      [127795,"tree-alt"],
      'f400',
      
      ['M0 288l0 96 224 0 0-168 0-32 64 0 0 32 0 168 224 0 0-96c0-35.5-19.3-66.6-48-83.2l0-44.8c0-44.2-35.8-80-80-80l-33.3 0C343.1 34.6 303.6 0 256 0s-87.1 34.6-94.7 80L128 80c-44.2 0-80 35.8-80 80l0 44.8C19.3 221.4 0 252.5 0 288z','M288 184l0 32 0 264 0 32-64 0 0-32 0-264 0-32 64 0z']
      
    ]
  };

  
    var faTreeAlt = faTreeDeciduous;
  

  
  

  var faIndent = {
    prefix: 'fasds',
    iconName: 'indent',
    icon: [
      448,
      512,
      [],
      'f03c',
      
      ['M0 32L0 96l448 0 0-64L0 32zM0 416l0 64 448 0 0-64L0 416zM192 160l0 64 256 0 0-64-256 0zm0 128l0 64 256 0 0-64-256 0z','M128 256L0 352V160l128 96z']
      
    ]
  };

  

  
  

  var faCommentMusic = {
    prefix: 'fasds',
    iconName: 'comment-music',
    icon: [
      512,
      512,
      [],
      'f8b0',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm128 80c0-17.7 21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48 21.6-8.1 0 23.1 0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 320c0 17.7-21.5 32-48 32s-48-14.3-48-32z','M352 104.9l0 23.1 0 32 0 128c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-74.7-96 36L224 320c0 17.7-21.5 32-48 32s-48-14.3-48-32s21.5-32 48-32c5.6 0 11 .6 16 1.8l0-81.8 0-32 0-11.1 10.4-3.9 128-48 21.6-8.1z']
      
    ]
  };

  

  
  

  var faRugbyBall = {
    prefix: 'fasds',
    iconName: 'rugby-ball',
    icon: [
      512,
      512,
      [],
      'e3c6',
      
      ['M16 336l0 96L120.2 233.4 233.4 120.2 432 16l-96 0C159.3 16 16 159.3 16 336zM80 496l96 0c176.7 0 320-143.3 320-320l0-96L391.8 278.6 278.6 391.8 80 496z','M233.4 120.2L432 16l64 64L391.8 278.6 278.6 391.8 80 496 16 432 120.2 233.4 233.4 120.2z']
      
    ]
  };

  

  
  

  var faMessageMedical = {
    prefix: 'fasds',
    iconName: 'message-medical',
    icon: [
      512,
      512,
      ["comment-alt-medical"],
      'f7f4',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM160 176l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0z','M288 112l-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64z']
      
    ]
  };

  
    var faCommentAltMedical = faMessageMedical;
  

  
  

  var faReflectHorizontal = {
    prefix: 'fasds',
    iconName: 'reflect-horizontal',
    icon: [
      512,
      512,
      [],
      'e664',
      
      ['M0 96L0 416l32 0L192 256 32 96 0 96zM320 256L480 416l32 0 0-320-32 0L320 256z','M280 0l0 24 0 464 0 24-48 0 0-24 0-464 0-24 48 0z']
      
    ]
  };

  

  
  

  var faParachuteBox = {
    prefix: 'fasds',
    iconName: 'parachute-box',
    icon: [
      512,
      512,
      [],
      'f4cd',
      
      ['M24.9 192l43.2 0L184.5 320l55.5 0 0-128 32 0 0 128 55.5 0L443.8 192l43.2 0L352 340.6 352 512l-192 0 0-171.4L24.9 192z','M128.5 192l254.9 0c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16zM358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16l96.5 0c-8.3-49.9-50.3-138.5-153.1-175.3zm-205.7 0C50.3 53.5 8.3 142.1 0 192l96.5 0c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3z']
      
    ]
  };

  

  
  

  var faCircleNodes = {
    prefix: 'fasds',
    iconName: 'circle-nodes',
    icon: [
      512,
      512,
      [],
      'e4e2',
      
      ['M114.1 280.4c20-9.4 35.4-26.9 42.1-48.2L301.9 359.6c-20 9.4-35.4 26.9-42.1 48.2L114.1 280.4zm22.1-129.3L320 77.5c0 .8 0 1.7 0 2.5c0 22.3 9.1 42.4 23.8 56.9L160 210.5c0-.9 0-1.6 0-2.5c0-1.5 0-2.8-.1-4.2c-.1-1.4-.2-2.7-.3-4.1c-.3-2.7-.7-5.4-1.2-8c-.5-2.6-1.2-5.2-2-7.7c-.4-1.2-.8-2.5-1.3-3.7s-.9-2.4-1.5-3.7c-4.1-9.6-10.1-18.3-17.4-25.5zM317.6 354.1l37.8-207.7c6.4 4.3 13.4 7.7 20.9 10c3.7 1.2 7.6 2.1 11.6 2.7c2 .3 4 .5 6 .7c1 .1 2 .1 3.1 .2s2 .1 3.1 .1c6.3 0 12.5-.7 18.4-2.1L380.6 365.6c-6.4-4.3-13.4-7.7-20.9-10c-3.7-1.2-7.6-2.1-11.6-2.7c-2-.3-4-.5-6-.7c-1-.1-2-.1-3.1-.2s-2-.1-3.1-.1c-6.3 0-12.5 .7-18.4 2.1z','M320 80a80 80 0 1 1 160 0A80 80 0 1 1 320 80zM256 432a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM80 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z']
      
    ]
  };

  

  
  

  var faCircleWifiCircleWifi = {
    prefix: 'fasds',
    iconName: 'circle-wifi-circle-wifi',
    icon: [
      640,
      512,
      ["circle-wifi-group"],
      'e67e',
      
      ['M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-15.7 2.1-30.9 5.9-45.4c-16.1-21-41.4-34.6-69.9-34.6c-30.4 0-57.3 15.5-73.1 38.9l-34.4-34.4c24.9-32 63.7-52.6 107.4-52.6c34.9 0 66.7 13.1 90.7 34.7c8.9-14.2 19.8-27.1 32.2-38.2C345.7 208.7 302.8 192 256 192c-57.1 0-108.4 24.9-143.5 64.5l-34-34C122.4 174.3 185.7 144 256 144c63.6 0 121.4 24.7 164.3 65.1C443.2 198.1 468.9 192 496 192c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zM288 368a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm86.9-145.2C564.3 338.6 532.3 320 496 320s-68.3 18.6-86.9 46.8l-25.6-19.2c24.5-36 65.7-59.6 112.5-59.6s88.1 23.6 112.5 59.6l-25.6 19.2zM560 384l-25.6 19.2C525.6 391.5 511.7 384 496 384s-29.6 7.5-38.4 19.2L432 384c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm-84 48a20 20 0 1 1 40 0 20 20 0 1 1 -40 0z']
      
    ]
  };

  
    var faCircleWifiGroup = faCircleWifiCircleWifi;
  

  
  

  var faArrowTurnDownLeft = {
    prefix: 'fasds',
    iconName: 'arrow-turn-down-left',
    icon: [
      512,
      512,
      [],
      'e2e1',
      
      ['M90.5 288c10.7 10.7 21.3 21.3 32 32l354.7 0 32 0 0-32 0-224 0-32-64 0 0 32 0 192-322.7 0-32 32z','M173.3 114.7l-22.6 22.6-128 128L0 288l22.6 22.6 128 128 22.6 22.6L218.5 416l-22.6-22.6L90.5 288 195.9 182.6 218.5 160l-45.3-45.3z']
      
    ]
  };

  

  
  

  var faBorderNone = {
    prefix: 'fasds',
    iconName: 'border-none',
    icon: [
      448,
      512,
      [],
      'f850',
      
      ['M0 416l0 64 64 0 0-64L0 416zm96 64l64 0 0-64-64 0 0 64zM96 96l64 0 0-64L96 32l0 64zm0 128l0 64 64 0 0-64-64 0zM288 480l64 0 0-64-64 0 0 64zm0-448l0 64 64 0 0-64-64 0zm0 256l64 0 0-64-64 0 0 64zM192 416l0 64 64 0 0-64-64 0zm0-320l64 0 0-64-64 0 0 64zm0 128l0 64 64 0 0-64-64 0zM384 480l64 0 0-64-64 0 0 64zm0-384l64 0 0-64-64 0 0 64zM0 32L0 96l64 0 0-64L0 32zM384 288l64 0 0-64-64 0 0 64zM0 224l0 64 64 0 0-64L0 224zM192 384l64 0 0-64-64 0 0 64zm192-64l0 64 64 0 0-64-64 0zM0 384l64 0 0-64L0 320l0 64zM384 128l0 64 64 0 0-64-64 0zM0 192l64 0 0-64L0 128l0 64zm192-64l0 64 64 0 0-64-64 0z','']
      
    ]
  };

  

  
  

  var faCircleSmall = {
    prefix: 'fasds',
    iconName: 'circle-small',
    icon: [
      320,
      512,
      [],
      'e122',
      
      ['M0 256a160 160 0 1 1 320 0A160 160 0 1 1 0 256z','']
      
    ]
  };

  

  
  

  var faBottleBaby = {
    prefix: 'fasds',
    iconName: 'bottle-baby',
    icon: [
      512,
      512,
      [],
      'e673',
      
      ['M112 272l112 0 0 48-112 0 0 64 112 0 0 48-112 0 0 80 288 0 0-240c0-31.2-10.1-61.5-28.8-86.4L352 160l-192 0-19.2 25.6C122.1 210.5 112 240.8 112 272zM192 64l0 32 128 0 0-32L288 48l0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16L192 64z','M352 96L160 96l0 64 192 0 0-64zM112 272l0 48 112 0 0-48-112 0zm0 112l0 48 112 0 0-48-112 0z']
      
    ]
  };

  

  
  

  var faLitecoinSign = {
    prefix: 'fasds',
    iconName: 'litecoin-sign',
    icon: [
      384,
      512,
      [],
      'e1d3',
      
      ['M8.4 229.4L26 291l30.8-8.8 7.2-2.1c0-22.2 0-44.4 0-66.6l-24.8 7.1L8.4 229.4zM128 195.3l0 66.6 136.8-39.1 30.8-8.8L278 152.4l-30.8 8.8L128 195.3z','M128 32l0 32 0 352 224 0 32 0 0 64-32 0L96 480l-32 0 0-32L64 64l0-32 64 0z']
      
    ]
  };

  

  
  

  var faH6 = {
    prefix: 'fasds',
    iconName: 'h6',
    icon: [
      640,
      512,
      [],
      'e413',
      
      ['M0 64L0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96l0-32L0 64z','M386.6 198.4L485.1 64l79.4 0-70.4 96c.6 0 1.3 0 1.9 0c79.5 0 144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144c0-38 12.1-75 34.6-105.6zM416 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z']
      
    ]
  };

  

  
  

  var faCircleY = {
    prefix: 'fasds',
    iconName: 'circle-y',
    icon: [
      512,
      512,
      [],
      'e12f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM120.6 144l59.5 0L256 247.4 331.8 144l59.5 0C354.2 194.6 317.1 245.2 280 295.9c0 26.7 0 53.4 0 80.1c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-26.7 0-53.4 0-80.1C194.9 245.2 157.8 194.6 120.6 144z','M120.6 144L232 295.9l0 80.1 0 24 48 0 0-24 0-80.1L391.4 144l-59.5 0L256 247.4 180.2 144l-59.5 0z']
      
    ]
  };

  

  
  

  var faAppleCore = {
    prefix: 'fasds',
    iconName: 'apple-core',
    icon: [
      384,
      512,
      [],
      'e08f',
      
      ['M176 80l0 16 0 16 16 0 16 0c44.2 0 80-35.8 80-80l0-16 0-16L272 0 256 0c-44.2 0-80 35.8-80 80z','M19.1 449.5C65.5 417.8 96 364.4 96 304c0-62.6-32.6-117.5-81.8-148.7C31.2 138.4 53.1 128 80 128l112 32 112-32c26.9 0 48.8 10.4 65.8 27.3C320.6 186.5 288 241.4 288 304c0 60.4 30.5 113.8 76.9 145.5C335 488.6 295.5 512 256 512l-64-16-64 16c-39.5 0-79-23.4-108.9-62.5z']
      
    ]
  };

  

  
  

  var faArrowUp91 = {
    prefix: 'fasds',
    iconName: 'arrow-up-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-up-alt"],
      'f887',
      
      ['M344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.6-6.2 44.8-18 64.1L458.3 256l-74.9 0 5.2-8.6 25.1-41.3C373.9 197.7 344 162.3 344 120zm8 168l32 0 48 0 32 0 0 32 0 96 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-64-16 0-32 0 0-64zm48-168a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M160 32.6l23.6 25.7 88 96L293.2 178 246 221.2l-21.6-23.6L192 162.3 192 448l0 32-64 0 0-32 0-285.7L95.6 197.6 74 221.2 26.8 178l21.6-23.6 88-96L160 32.6z']
      
    ]
  };

  
    var faSortNumericUpAlt = faArrowUp91;
  

  
  

  var faPersonPinball = {
    prefix: 'fasds',
    iconName: 'person-pinball',
    icon: [
      640,
      512,
      [],
      'e21d',
      
      ['M192 288l32 0 32 0 0-45.8 292.1-48.7L513.6 90.1 512 85.2l0-5.2 0-48 0-32 32 0 64 0 32 0 0 32 0 146.2 0 37.8 0 8 0 32 0 224 0 32-64 0 0-32 0-96-320 0 0 96 0 32-64 0 0-32 0-192zm64 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM0 128l32 0 48 0 17.1 0 9.5 14.3L161.1 224l62.9 0 32 0 0 64-32 0-80 0-17.1 0-9.5-14.3L96 241.7l0 65.1 54.6 54.6 9.4 9.4 0 13.3 0 96 0 32-64 0 0-32 0-82.7L41.4 342.6 18.7 320C6.7 308 0 291.7 0 274.7L0 160l0-32zM0 480L0 346.5l64 64L64 480s0 0 0 0l0 32L0 512l0-32z']
      
    ]
  };

  

  
  

  var faLungs = {
    prefix: 'fasds',
    iconName: 'lungs',
    icon: [
      640,
      512,
      [129729],
      'f604',
      
      ['M.2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7L256 473l0-186.3L161.2 347c-9 5.7-18 11.5-27 17.2c-11.5-18-22.9-36-34.4-54l27-17.2c43.1-27.4 86.1-54.8 129.2-82.2L256 96 152 96c-26.9 35.8-51.5 73.2-73.8 112.1C45.8 264.9 9.1 341.4 .2 412zM384 96l0 114.8c43.1 27.4 86.1 54.8 129.2 82.2l27 17.2-34.4 54-27-17.2c-31.6-20.1-63.2-40.2-94.8-60.3L384 473l145.4 36.4c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-8.8-70.6-45.5-147.2-78-203.9c-16.5-28.9-32.4-53.6-44.3-71.1c-9.5-14-19.4-27.6-29.5-41.1L384 96z','M352 0l0 32 0 32 0 126.4L513.2 293l27 17.2-34.4 54-27-17.2L320 245.9 161.2 347l-27 17.2-34.4-54 27-17.2L288 190.4 288 64l0-32 0-32 64 0z']
      
    ]
  };

  

  
  

  var faRibbon = {
    prefix: 'fasds',
    iconName: 'ribbon',
    icon: [
      448,
      512,
      [127895],
      'f4d6',
      
      ['M0 448l112 64L226.9 386.9c-27.8-31.9-55.6-63.7-83.3-95.6L0 448zM96 64c16.9 18.4 33.7 36.8 50.6 55.2L224 96l77.4 23.2L352 64 304 0 144 0 96 64z','M96 64L448 448 336 512 64 200l0-88L96 64zM328.4 270.2L245.7 180 352 64l32 56 0 88-55.6 62.2z']
      
    ]
  };

  

  
  

  var faLockA = {
    prefix: 'fasds',
    iconName: 'lock-a',
    icon: [
      448,
      512,
      [],
      'e422',
      
      ['M0 192L0 512l448 0 0-320-80 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144l0 48L0 192zM128 448l80-192 32 0 80 192-34.7 0-16.7-40-89.3 0-16.7 40L128 448zm16-304c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48-160 0 0-48zm48.7 232l62.7 0L224 300.8 192.7 376z','M268.7 408l16.7 40 34.7 0L240 256l-32 0L128 448l34.7 0 16.7-40 89.3 0zm-13.3-32l-62.7 0L224 300.8 255.3 376z']
      
    ]
  };

  

  
  

  var faArrowRightToCity = {
    prefix: 'fasds',
    iconName: 'arrow-right-to-city',
    icon: [
      640,
      512,
      [],
      'e4b3',
      
      ['M288 0l0 512 96 0 96 0 160 0 0-320-72 0 0-72 0-24-48 0 0 24 0 72-40 0L480 0 288 0zm64 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm160 0l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M150.6 153.4L128 130.7 82.7 176l22.6 22.6L130.7 224 32 224 0 224l0 64 32 0 98.7 0-25.4 25.4L82.7 336 128 381.3l22.6-22.6 80-80L253.3 256l-22.6-22.6-80-80z']
      
    ]
  };

  

  
  

  var faChartLineDown = {
    prefix: 'fasds',
    iconName: 'chart-line-down',
    icon: [
      512,
      512,
      [128201],
      'f64d',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M326.6 121.4L304 98.7l-22.6 22.6L208 194.7l-57.4-57.4-45.3 45.3 80 80L208 285.3l22.6-22.6L304 189.3l57.4 57.4L320 288l32 32 128 0 0-128-32-32-41.4 41.4-80-80z']
      
    ]
  };

  

  
  

  var faPaperclip = {
    prefix: 'fasds',
    iconName: 'paperclip',
    icon: [
      448,
      512,
      [128206],
      'f0c6',
      
      ['M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l144-144L408 256.4 447.6 296l-19.8 19.8-144 144c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144L288 120.4 327.6 160l-19.8 19.8-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z','']
      
    ]
  };

  

  
  

  var faBinRecycle = {
    prefix: 'fasds',
    iconName: 'bin-recycle',
    icon: [
      576,
      512,
      [],
      'e5f7',
      
      ['M0 32l576 0 0 64L0 96 0 32zm32 96l512 0L512 480 64 480 32 128zM136 361.6c0 30.1 24.4 54.4 54.4 54.4l73.6 0 0-48-73.6 0c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l36-51.4L180.4 281l-34.5 49.3c-6.4 9.1-9.8 20-9.8 31.2zm71.9-119.9l40.8 25.5 33.8-48.3c1.3-1.8 3.3-2.9 5.5-2.9s4.3 1.1 5.5 2.9l33.8 48.3 40.8-25.5-35.2-50.3c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-35.2 50.3zM312 368l0 48 73.6 0c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22-9.8-31.2L395.6 281l-40.8 25.5 36 51.4c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4L312 368z','M282.5 218.9c1.3-1.8 3.3-2.9 5.5-2.9s4.3 1.1 5.5 2.9l33.8 48.3 40.8-25.5-35.2-50.3c-10.2-14.6-27-23.3-44.8-23.3s-34.6 8.7-44.8 23.3l-35.2 50.3 40.8 25.5 33.8-48.3zm-61.3 87.6L180.4 281l-34.5 49.3c-6.4 9.1-9.8 20-9.8 31.2c0 30.1 24.4 54.4 54.4 54.4l73.6 0 0-48-73.6 0c-3.5 0-6.4-2.9-6.4-6.4c0-1.3 .4-2.6 1.2-3.7l36-51.4zM312 368l0 48 73.6 0c30.1 0 54.4-24.4 54.4-54.4c0-11.2-3.4-22.1-9.8-31.2L395.6 281l-40.8 25.5 36 51.4c.8 1.1 1.2 2.4 1.2 3.7c0 3.5-2.9 6.4-6.4 6.4L312 368z']
      
    ]
  };

  

  
  

  var faAnglesUp = {
    prefix: 'fasds',
    iconName: 'angles-up',
    icon: [
      448,
      512,
      ["angle-double-up"],
      'f102',
      
      ['M18.7 416L64 461.3l22.6-22.6L224 301.3 361.4 438.6 384 461.3 429.3 416l-22.6-22.6-160-160L224 210.7l-22.6 22.6-160 160L18.7 416z','M224 18.7l22.6 22.6 160 160L429.3 224 384 269.3l-22.6-22.6L224 109.3 86.6 246.6 64 269.3 18.7 224l22.6-22.6 160-160L224 18.7z']
      
    ]
  };

  
    var faAngleDoubleUp = faAnglesUp;
  

  
  

  var faFaceTissue = {
    prefix: 'fasds',
    iconName: 'face-tissue',
    icon: [
      512,
      512,
      [],
      'e39c',
      
      ['M0 256c0 15.9 1.5 31.5 4.2 46.7l205.9-38.1 45.8-8.5-8.5 45.8-9.4 51 18 12 39.1-26.1 8.9-5.9 8.9 5.9 40.3 26.8 23.7-11.8 14.3-7.2 14.3 28.6-14.3 7.2-32 16-8.3 4.2-7.7-5.2L304 371.2l-39.1 26.1-8.9 5.9-8.9-5.9L231.7 387 209.3 507.8c15.1 2.8 30.7 4.2 46.7 4.2c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256zM112 128l118.9 64L112 256l45.7-64L112 128zm169.1 64L400 128l-45.7 64L400 256 281.1 192z','M0 336l216-40L176 512l-48-64L32 480l32-96L0 336z']
      
    ]
  };

  

  
  

  var faDollyEmpty = {
    prefix: 'fasds',
    iconName: 'dolly-empty',
    icon: [
      576,
      512,
      [],
      'f473',
      
      ['M351.9 416A96 96 0 1 1 160 416a96 96 0 1 1 191.9 0z','M32 0L0 0 0 64l32 0 72.9 0L197 340.2c16.3-12.7 36.7-20.2 59-20.2c.6 0 1.2 0 1.7 0L158.4 21.9 151.1 0 128 0 32 0zM331.8 357c12.7 16.3 20.2 36.7 20.2 59c0 .6 0 1.2 0 1.7l202.1-67.4 30.4-10.1-20.2-60.7-30.4 10.1L331.8 357z']
      
    ]
  };

  

  
  

  var faEnvelope = {
    prefix: 'fasds',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      ['M0 144L0 448l512 0 0-304L256 320 0 144z','M0 144V64H512v80L256 320 0 144z']
      
    ]
  };

  

  
  

  var faTruckLadder = {
    prefix: 'fasds',
    iconName: 'truck-ladder',
    icon: [
      640,
      512,
      [],
      'e657',
      
      ['M0 0L352 0l0 48-32 0 0 96 32 0 0 48L0 192l0-48 32 0 0-96L0 48 0 0zM80 48l0 96 32 0 0-96L80 48zM240 432A80 80 0 1 1 80 432a80 80 0 1 1 160 0zM160 48l0 96 32 0 0-96-32 0zm80 0l0 96 32 0 0-96-32 0zM560 432a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M416 96l-32 0 0 32 0 96L0 224 0 416l49.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l98.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l49.1 0 0-128 0-32 0-32 0-13.3-9.4-9.4-96-96L525.3 96 512 96l-96 0zM576 256l-128 0 0-96 50.7 0L576 237.3l0 18.7z']
      
    ]
  };

  

  
  

  var faHeadSide = {
    prefix: 'fasds',
    iconName: 'head-side',
    icon: [
      512,
      512,
      [],
      'f6e9',
      
      ['M0 224.3C0 100.4 100.4 0 224.3 0L256 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zM320 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M352 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z']
      
    ]
  };

  

  
  

  var faCakeCandles = {
    prefix: 'fasds',
    iconName: 'cake-candles',
    icon: [
      448,
      512,
      [127874,"birthday-cake","cake"],
      'f1fd',
      
      ['M0 224l64 0 64 0 64 0 64 0 64 0 64 0 64 0 0 144.8L419.2 384 352 352l-64 32-64-32-64 32L96 352 28.8 384 0 368.8 0 224zM56 69.6c0-8.8 2.8-17.5 7.9-24.6L96 0l32.1 44.9c5.1 7.2 7.9 15.8 7.9 24.6l0 2.4c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-2.4zm128 0c0-8.8 2.8-17.5 7.9-24.6L224 0l32.1 44.9c5.1 7.2 7.9 15.8 7.9 24.6l0 2.4c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-2.4zm128 0c0-8.8 2.8-17.5 7.9-24.6L352 0l32.1 44.9c5.1 7.2 7.9 15.8 7.9 24.6l0 2.4c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-2.4z','M128 176l0 16 0 32-64 0 0-32 0-16 0-32 64 0 0 32zm128 0l0 16 0 32-64 0 0-32 0-16 0-32 64 0 0 32zm128 0l0 16 0 32-64 0 0-32 0-16 0-32 64 0 0 32zm64 192.8L448 512 0 512 0 368.8 28.8 384 96 352l64 32 64-32 64 32 64-32 67.2 32L448 368.8z']
      
    ]
  };

  
    var faBirthdayCake = faCakeCandles;
  
    var faCake = faCakeCandles;
  

  
  

  var faSquare1 = {
    prefix: 'fasds',
    iconName: 'square-1',
    icon: [
      448,
      512,
      [],
      'e256',
      
      ['M0 32l448 0 0 448L0 480 0 32zM144 164.5l0 54.9 11.7-6.5L200 188.3 200 336l-32 0-24 0 0 48 24 0 56 0 56 0 24 0 0-48-24 0-32 0 0-184 0-24-24 0-8 0-6.2 0-5.4 3L144 164.5z','M209.8 128l6.2 0 8 0 24 0 0 24 0 184 32 0 24 0 0 48-24 0-56 0-56 0-24 0 0-48 24 0 32 0 0-147.7L155.7 213 144 219.5l0-54.9L204.3 131l5.4-3z']
      
    ]
  };

  

  
  

  var faComment = {
    prefix: 'fasds',
    iconName: 'comment',
    icon: [
      512,
      512,
      [61669,128489],
      'f075',
      
      ['M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1z','']
      
    ]
  };

  

  
  

  var faEllipsisStrokeVertical = {
    prefix: 'fasds',
    iconName: 'ellipsis-stroke-vertical',
    icon: [
      192,
      512,
      ["ellipsis-v-alt"],
      'f39c',
      
      ['M32 192l0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0-48 0zm48 48l32 0 0 32-32 0 0-32z','M80 80l0 32 32 0 0-32L80 80zM32 32l48 0 32 0 48 0 0 48 0 32 0 48-48 0-32 0-48 0 0-48 0-32 0-48zM80 400l0 32 32 0 0-32-32 0zM32 352l48 0 32 0 48 0 0 48 0 32 0 48-48 0-32 0-48 0 0-48 0-32 0-48z']
      
    ]
  };

  
    var faEllipsisVAlt = faEllipsisStrokeVertical;
  

  
  

  var faBracketsCurly = {
    prefix: 'fasds',
    iconName: 'brackets-curly',
    icon: [
      576,
      512,
      [],
      'f7ea',
      
      ['M352 32l0 64 32 0 64 0 0 96 0 13.3 9.4 9.4L498.7 256l-41.4 41.4-9.4 9.4 0 13.3 0 96-64 0-32 0 0 64 32 0 96 0 32 0 0-32 0-114.7 54.6-54.6 9.4-9.4 0-26.5-9.4-9.4L512 178.7 512 64l0-32-32 0-96 0-32 0z','M96 32L64 32l0 32 0 114.7L9.4 233.4 0 242.7l0 26.5 9.4 9.4L64 333.3 64 448l0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-96 0-13.3-9.4-9.4L77.3 256l41.4-41.4 9.4-9.4 0-13.3 0-96 64 0 32 0 0-64-32 0L96 32z']
      
    ]
  };

  

  
  

  var faCircleYen = {
    prefix: 'fasds',
    iconName: 'circle-yen',
    icon: [
      512,
      512,
      [],
      'e5d0',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM137.5 144c20.4 0 40.7 0 61 0c19.2 24.4 38.3 48.8 57.5 73.2c19.2-24.4 38.3-48.8 57.5-73.2c20.4 0 40.7 0 61 0c-3.9 4.9-7.8 9.9-11.7 14.8c-21.3 27.1-42.5 54.1-63.8 81.2c9.6 0 19.3 0 28.9 0c8 0 16 0 24 0l0 48c-8 0-16 0-24 0c-16 0-32 0-48 0c0 5.3 0 10.7 0 16c16 0 32 0 48 0c8 0 16 0 24 0l0 48-24 0-48 0c0 8.3 0 16.7 0 25c0 8 0 16 0 24c-16 0-32 0-48 0c0-8 0-16 0-24c0-8.3 0-16.7 0-25l-48 0-24 0c0-16 0-32 0-48c8 0 16 0 24 0c16 0 32 0 48 0c0-5.3 0-10.7 0-16c-16 0-32 0-48 0c-8 0-16 0-24 0c0-16 0-32 0-48c8 0 16 0 24 0c9.6 0 19.3 0 28.9 0c-21.3-27.1-42.5-54.1-63.8-81.2c-3.9-4.9-7.8-9.9-11.7-14.8z','M149.1 158.8L137.5 144l61 0L256 217.2 313.5 144l61 0-11.7 14.8L299.1 240l28.9 0 24 0 0 48-24 0-48 0 0 16 48 0 24 0 0 48-24 0-48 0 0 25 0 24-48 0 0-24 0-25-48 0-24 0 0-48 24 0 48 0 0-16-48 0-24 0 0-48 24 0 28.9 0-63.8-81.2z']
      
    ]
  };

  

  
  

  var faCoffeeBean = {
    prefix: 'fasds',
    iconName: 'coffee-bean',
    icon: [
      448,
      512,
      [],
      'e13e',
      
      ['M0 318.9c0-65.4 30.9-138.6 89.6-197.3C174.3 36.9 289.4 10 367.3 50.6c-21.2 42.4-42.4 84.9-63.6 127.3c-62.2 41.5-124.5 83-186.7 124.5c-1.6 1.1-3.3 2.2-4.9 3.3c-.9 1.7-1.9 3.4-2.8 5.1c-22.3 40.6-44.7 81.2-67 121.8C13.8 402.6 0 362.5 0 318.9zM81 461.6L148.5 339 335.6 214.3c1.8-1.2 3.5-2.4 5.3-3.5c.9-1.9 1.9-3.8 2.9-5.7c20.8-41.7 41.7-83.4 62.5-125c70.6 75 49.7 212.8-47.9 310.4C299.7 449.1 226.5 480 161.1 480c-28.9 0-56.2-6-80.1-18.4z','M367.3 50.6c13.1 6.8 25.2 15.6 35.9 26.3c1 1 2.1 2.1 3.1 3.2L343.8 205l-2.9 5.7-5.3 3.5L148.5 339 81 461.6c-13.3-6.9-25.4-15.6-36.2-26.4c-.9-.9-1.7-1.7-2.6-2.6l67-121.8 2.8-5.1 4.9-3.3L303.7 177.9 367.3 50.6z']
      
    ]
  };

  

  
  

  var faInboxes = {
    prefix: 'fasds',
    iconName: 'inboxes',
    icon: [
      512,
      512,
      [],
      'e1bb',
      
      ['M0 352l144 0 32 64 160 0 32-64 144 0 0 160L0 512 0 352zM79.3 160c12.8-32 25.6-64 38.4-96l276.7 0 38.4 96L368 160l-32 64-160 0c-10.7-21.3-21.3-42.7-32-64l-64.7 0z','M96 0L74.3 0l-8 20.1-64 160L0 185.8 0 192l0 96 0 32 32 0 448 0 32 0 0-32 0-96 0-6.2-2.3-5.7-64-160L437.7 0 416 0 96 0zM79.3 160l38.4-96 276.7 0 38.4 96L368 160l-32 64-160 0-32-64-64.7 0z']
      
    ]
  };

  

  
  

  var faBookSection = {
    prefix: 'fasds',
    iconName: 'book-section',
    icon: [
      448,
      512,
      ["book-law"],
      'e0c1',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zM235.9 243.2l-7.5-2c-22.1-5.9-68-18.1-59.5-62.7c2.1-11.2 7.9-20.4 16.7-27.5c-12.2-9.4-20.7-23.1-16.7-44.5c6.1-31.8 40.4-48 87.5-41.3c8.3 1.2 18 3.5 30.2 7.3l-9.5 30.6c-10.6-3.3-18.6-5.3-25.2-6.2c-27.8-4-49.1 2.5-51.6 15.7c-1.8 9.3-.2 16.1 36.2 25.8l7.3 1.9c0 0 0 0 0 0c30.1 7.8 75.6 19.6 67 64.7c-2.1 11.2-8 20.5-16.7 27.6c12.6 9.5 20.7 23.2 16.7 44.4c-5.2 27-30.8 42.8-67.3 42.8c-6.4 0-13.2-.5-20.2-1.5c-12.9-1.8-26.6-6.2-38.6-10.1c0 0 0 0 0 0l-5.8-1.9 9.8-30.5 5.9 1.9c10.7 3.5 22.9 7.5 33.1 8.9c28 3.9 49.2-2.5 51.7-15.7c2.4-12.8-5.7-17.9-43.6-27.7zm0-72s-9.4-2.5-10.3-2.7c-8.7 1.2-23 4.8-25.2 16.1c-1.8 9.3-.2 16.1 36.3 25.8c0 0 14.1 3.7 17.7 4.7c8.7-1.2 23-4.8 25.2-16.1c2.4-12.8-5.7-17.9-43.6-27.7z']
      
    ]
  };

  
    var faBookLaw = faBookSection;
  

  
  

  var faStretcher = {
    prefix: 'fasds',
    iconName: 'stretcher',
    icon: [
      640,
      512,
      [],
      'f825',
      
      ['M192 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-5.3-.7-10.5-1.9-15.5L368 396.2l49.9 36.3c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-12.4 0-24 3.5-33.9 9.7l-37.3-27.1 108-78.5-81.6 0L368 336.9 300.8 288l-81.6 0 108 78.5-37.3 27.1c-9.8-6.1-21.4-9.7-33.9-9.7c-35.3 0-64 28.7-64 64zm80 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm224 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M189.1 192L70.8 63.5 .2 128.5l132.5 144L146.9 288l21.1 0 472 0 0-96-450.9 0z']
      
    ]
  };

  

  
  

  var faTag = {
    prefix: 'fasds',
    iconName: 'tag',
    icon: [
      448,
      512,
      [127991],
      'f02b',
      
      ['M0 32L0 256 224 480 448 256 224 32 0 32zm112 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z','']
      
    ]
  };

  

  
  

  var faSteeringWheel = {
    prefix: 'fasds',
    iconName: 'steering-wheel',
    icon: [
      512,
      512,
      [],
      'f622',
      
      ['M64 256c0 10.9 .9 21.6 2.7 32l102.2 0L224 358.9l0 86.5c10.4 1.7 21.1 2.7 32 2.7s21.6-.9 32-2.7l0-86.5L343.1 288l102.2 0c1.7-10.4 2.7-21.1 2.7-32s-.9-21.6-2.7-32L344 224l-24-32-128 0-24 32L66.7 224c-1.7 10.4-2.7 21.1-2.7 32z','M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z']
      
    ]
  };

  

  
  

  var faPlaneLock = {
    prefix: 'fasds',
    iconName: 'plane-lock',
    icon: [
      640,
      512,
      [],
      'e558',
      
      ['M0 288l0 96 192-64 0 80-64 48 0 64 128-32 128 32 0-64-64-48 0-80 64 21.3 0-53.3 32 0 0-16c0-15 3-29.4 8.3-42.5L320 160l0-66.3C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 66.3L0 288z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faTruckFire = {
    prefix: 'fasds',
    iconName: 'truck-fire',
    icon: [
      640,
      512,
      [],
      'e65a',
      
      ['M0 0L0 48l32 0 0 48 48 0 0-48 56 0 0 48 48 0 0-48 48 0 0 48 48 0 0-48 56 0 0 48 48 0 0-48 256 0 0-48L0 0zM80 432a80 80 0 1 0 160 0A80 80 0 1 0 80 432zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M496 96c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0 32 0 0 32 0 128 0 160-49.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-98.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L0 416 0 256l400 0 16 0 0-16 0-144 32 0 48 0zM384 96l0 128L0 224 0 96l384 0zM576 256l0-96-96 0 0 96 96 0z']
      
    ]
  };

  

  
  

  var faSatellite = {
    prefix: 'fasds',
    iconName: 'satellite',
    icon: [
      512,
      512,
      [128752],
      'f7bf',
      
      ['M96 128l96 96L320 96 224 0 96 128zM288 320l96 96L512 288l-96-96c-42.7 42.7-85.3 85.3-128 128z','M175 241L400 16l96 96L271 337c10.9 24.1 17 50.9 17 79c0 34.5-9.1 66.9-25.1 94.9L143.3 391.3l-24.4 24.4c.7 2.6 1.1 5.4 1.1 8.3c0 17.7-14.3 32-32 32s-32-14.3-32-32s14.3-32 32-32c2.9 0 5.6 .4 8.3 1.1l24.4-24.4L1.1 249.1c28-16 60.4-25.1 94.9-25.1c28.2 0 54.9 6.1 79 17z']
      
    ]
  };

  

  
  

  var faChessClockFlip = {
    prefix: 'fasds',
    iconName: 'chess-clock-flip',
    icon: [
      640,
      512,
      ["chess-clock-alt"],
      'f43e',
      
      ['M96 96l160 0 0 32L96 128l0-32zm57.4 208l11.3-11.3 48-48L224 233.4 246.6 256l-11.3 11.3-48 48L176 326.6 153.4 304zM384 32l160 0 0 48-56 0 0 48-48 0 0-48-56 0 0-48zm64 192l32 0 0 16 0 64 0 16-32 0 0-16 0-64 0-16z','M0 128l640 0 0 352L0 480 0 128zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zM464 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z']
      
    ]
  };

  
    var faChessClockAlt = faChessClockFlip;
  

  
  

  var faFilePlusMinus = {
    prefix: 'fasds',
    iconName: 'file-plus-minus',
    icon: [
      384,
      512,
      [],
      'e177',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM112 256l0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16-32 0 0 16 0 48-48 0-16 0zm0 128l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0z','M384 160L224 0l0 160 160 0zM208 208l0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48zM128 384l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0z']
      
    ]
  };

  

  
  

  var faUserVisor = {
    prefix: 'fasds',
    iconName: 'user-visor',
    icon: [
      448,
      512,
      [],
      'e04c',
      
      ['M105.3 176l237.4 0c-19 46.9-65 80-118.7 80s-99.7-33.1-118.7-80zM124.1 48C147.5 18.7 183.6 0 224 0s76.5 18.7 99.9 48L124.1 48zM280 456c13.3-29.3 26.7-58.7 40-88l40 88-8 8-24-24c-13.3 8-26.7 16-40 24c-2.7-2.7-5.3-5.3-8-8z','M80 48l0 128 288 0 0-128L80 48zm48 48l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zM384 304L64 304 0 512l448 0L384 304zM328 440l-40 24-8-8 40-88 40 88-8 8-24-24z']
      
    ]
  };

  

  
  

  var faLiraSign = {
    prefix: 'fasds',
    iconName: 'lira-sign',
    icon: [
      320,
      512,
      [8356],
      'f195',
      
      ['M0 192l0 64 48 0 0-64L0 192zm0 96l0 64 40.2 0c2.6-5.2 5.2-10.4 7.8-15.6L48 288 0 288zm112-96l0 64 144 0 0-64-144 0zm0 96l0 56 0 7.6-.2 .4L256 352l0-64-144 0z','M173.9 96c-34.2 0-61.9 27.7-61.9 61.9L112 344l0 7.6-3.4 6.8L79.8 416 288 416l32 0 0 64-32 0L32 480 0 480l0-32 0-8 0-7.6 3.4-6.8L48 336.4l0-178.5C48 88.4 104.4 32 173.9 32c16 0 31.9 3.1 46.8 9l63.2 25.3 29.7 11.9-23.8 59.4-29.7-11.9-63.2-25.3c-7.3-2.9-15.1-4.4-23-4.4z']
      
    ]
  };

  

  
  

  var faChild = {
    prefix: 'fasds',
    iconName: 'child',
    icon: [
      320,
      512,
      [],
      'f1ae',
      
      ['M96 64a64 64 0 1 0 128 0A64 64 0 1 0 96 64z','M116.9 160l-16 0-9.6 12.8-72.1 96L0 294.4l51.2 38.4 19.2-25.6L80 294.4 80 480l0 32 64 0 0-32 0-96 32 0 0 96 0 32 64 0 0-32 0-185.6 9.6 12.8 19.2 25.6L320 294.4l-19.2-25.6-72.1-96L219.1 160l-16 0-86.2 0z']
      
    ]
  };

  

  
  

  var faWashingMachine = {
    prefix: 'fasds',
    iconName: 'washing-machine',
    icon: [
      448,
      512,
      ["washer"],
      'f898',
      
      ['M80 304c0 79.5 64.5 144 144 144c77.6 0 140.9-61.4 143.9-138.2C350 315.4 328.1 320 304 320c-32 0-56-16-80-32s-48-32-80-32c-19.7 0-40.6 4.7-59 10.4c-3.2 12-5 24.6-5 37.6zM160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M448 0L0 0 0 512l448 0L448 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  
    var faWasher = faWashingMachine;
  

  
  

  var faBookSparkles = {
    prefix: 'fasds',
    iconName: 'book-sparkles',
    icon: [
      448,
      512,
      ["book-spells"],
      'f6b8',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM264 200l-56 24 56 24 24 56 24-56 56-24-56-24-24-56-24 56zM176 64L160 96l-32 16 32 16 16 32 16-32 32-16L192 96 176 64z']
      
    ]
  };

  
    var faBookSpells = faBookSparkles;
  

  
  

  var faSquareArrowDownRight = {
    prefix: 'fasds',
    iconName: 'square-arrow-down-right',
    icon: [
      448,
      512,
      [],
      'e262',
      
      ['M0 32L0 480l448 0 0-448L0 32zM102.1 168L136 134.1l17 17 135 135L288 184l0-24 48 0 0 24 0 160 0 24-24 0-152 0-24 0 0-48 24 0 94.1 0L119 185l-17-17z','M336 368l-24 0-152 0-24 0 0-48 24 0 94.1 0L119 185l-17-17L136 134.1l17 17 135 135L288 184l0-24 48 0 0 24 0 160 0 24z']
      
    ]
  };

  

  
  

  var faFilmSlash = {
    prefix: 'fasds',
    iconName: 'film-slash',
    icon: [
      640,
      512,
      [],
      'e179',
      
      ['M64 146.4L64 480l423.4 0-81.2-64L224 416l0-128 19.7 0L176 234.7l0 53.3-64 0 0-64 50.5 0L64 146.4zM70.5 32L224 151.1 224 96l192 0 0 128-98.1 0C403.9 290.8 490 357.6 576 424.4L576 32 70.5 32zM112 352l64 0 0 64-64 0 0-64zM464 96l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faBusSchool = {
    prefix: 'fasds',
    iconName: 'bus-school',
    icon: [
      512,
      512,
      [],
      'f5dd',
      
      ['M64 448l0 64 96 0 0-64-96 0zm48-320c0 42.7 0 85.3 0 128l128 0 0-128-128 0zm160 0l0 128 128 0 0-128-128 0zm80 320l0 64 96 0 0-64-96 0z','M256 0C371.9 0 464 48 464 48l0 48 0 16 48 0 0 128-48 0 0 16 16 0 0 192L32 448l0-192 16 0L48 96s0 0 0 0l0-48s92.1-48 208-48zM48 112l0 128L0 240 0 112l48 0zm224 16l0 128 128 0 0-128-128 0zm-32 0l-128 0 0 128 128 0 0-128zM112 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 96l0-32-16 0L176 64l-16 0 0 32 16 0 160 0 16 0z']
      
    ]
  };

  

  
  

  var faClipboardUser = {
    prefix: 'fasds',
    iconName: 'clipboard-user',
    icon: [
      384,
      512,
      [],
      'f7f3',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-24 0-48 0-24 80 0 0 448L0 512 0 64zM80 448l224 0-32-96-160 0L80 448zm48-192a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M270.4 64L304 64l0 96-112 0L80 160l0-96 33.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 96l32 96L80 448l32-96 160 0z']
      
    ]
  };

  

  
  

  var faFaceFearful = {
    prefix: 'fasds',
    iconName: 'face-fearful',
    icon: [
      512,
      512,
      [],
      'e375',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM73.4 127.2c3.9-3.6 7.8-7.3 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0c0 10.7 0 21.3 0 32l-16 0c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-3.9 3.6-7.8 7.3-11.7 10.9L73.4 127.2zM224 224A64 64 0 1 1 96 224a64 64 0 1 1 128 0zM176 400c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16-160 0 0-16zM416 224a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM320 80l16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9l-16 0 0-32z','M163 112.9c-21.2 2.8-40.6 12.4-56.1 26.8L95.2 150.6 73.4 127.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0c-4.4 0-8.8 .3-13 .9zm186.1 0c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8zM128.4 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faLocationExclamation = {
    prefix: 'fasds',
    iconName: 'location-exclamation',
    icon: [
      384,
      512,
      ["map-marker-exclamation"],
      'f608',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192z','M216 120l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faMapMarkerExclamation = faLocationExclamation;
  

  
  

  var faTableRows = {
    prefix: 'fasds',
    iconName: 'table-rows',
    icon: [
      512,
      512,
      ["rows"],
      'e292',
      
      ['M128 224l0 64 320 0 0-64-320 0z','M128 416l320 0 0-320L128 96l0 320zM0 480l0-64L0 96 0 32l64 0 384 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480z']
      
    ]
  };

  
    var faRows = faTableRows;
  

  
  

  var faHatCowboySide = {
    prefix: 'fasds',
    iconName: 'hat-cowboy-side',
    icon: [
      640,
      512,
      [],
      'f8c1',
      
      ['M0 366.2L0 448l32 0 0-81.8c0-17.4 4-34.5 11.8-50.1l7.8-15.7C75.1 253.6 123 224 175.4 224c28.4 0 56.1 8.7 79.3 25L522.4 436.4C533.2 444 546 448 559.1 448l.9 0c2.5 0 5-.1 7.5-.3c40.7-3.8 72.5-38 72.5-79.7l0-8.1c0-12.7-2.7-25.2-7.8-36.8c-18.1-40.8-54-71-97.4-81.8l-32.1-8c1 5.1 1.9 10.1 2.9 15.2l3.7 19.5 17.7 4.4c33.8 8.4 61.7 32 75.9 63.8c3.3 7.5 5.1 15.6 5.1 23.8l0 8.1c0 26.5-21.5 48-48 48l-.9 0c-6.6 0-13-2-18.3-5.8L273 222.8c-28.6-20-62.7-30.8-97.7-30.8c-11.4 0-22.5 1.1-33.4 3.3C91 205.5 46.8 238.6 23 286.1l-7.8 15.7c-10 20-15.2 42-15.2 64.4z','M141.9 195.3L160 96 400 32l64 0 38.7 201.2 2.9 15.2 3.7 19.5 17.7 4.4c33.8 8.4 61.7 32 75.9 63.8c3.3 7.5 5.1 15.6 5.1 23.8l0 8.1c0 26.5-21.5 48-48 48l-.9 0c-6.6 0-13-2-18.3-5.8L273 222.8c-28.6-20-62.7-30.8-97.7-30.8c-11.4 0-22.5 1.1-33.4 3.3zM32 448l0-81.8c0-17.4 4-34.5 11.8-50.1l7.8-15.7C75.1 253.6 123 224 175.4 224c28.4 0 56.1 8.7 79.3 25L522.4 436.4C533.2 444 546 448 559.1 448L544 448 96 448l-64 0zm528 0c2.5 0 5-.1 7.5-.3l.5 .3-8 0z']
      
    ]
  };

  

  
  

  var faDiscDrive = {
    prefix: 'fasds',
    iconName: 'disc-drive',
    icon: [
      512,
      512,
      [],
      'f8b5',
      
      ['M96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M32 32l448 0 0 384 32 0 0 64-32 0L32 480 0 480l0-64 32 0L32 32zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192 0A160 160 0 1 0 96 256a160 160 0 1 0 320 0z']
      
    ]
  };

  

  
  

  var faPhoneVolume = {
    prefix: 'fasds',
    iconName: 'phone-volume',
    icon: [
      512,
      512,
      ["volume-control-phone"],
      'f2a0',
      
      ['M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512l-32 0C200.6 512 0 311.4 0 64L0 32z','M464 256c0-114.9-93.1-208-208-208l0-48C397.4 0 512 114.6 512 256l-48 0zM256 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0-80l0-48c88.4 0 160 71.6 160 160l-48 0c0-61.9-50.1-112-112-112z']
      
    ]
  };

  
    var faVolumeControlPhone = faPhoneVolume;
  

  
  

  var faSealQuestion = {
    prefix: 'fasds',
    iconName: 'seal-question',
    icon: [
      512,
      512,
      [],
      'e243',
      
      ['M0 256l75 75 0 106 106 0 75 75 75-75 106 0 0-106 75-75-75-75 0-106L331 75 256 0 181 75 75 75l0 106L0 256zm168-72c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1l0 24-4.7 0c-5.2 12.8-14.6 23.7-27 30.8c-10.8 6.2-21.5 12.3-32.3 18.5c0 2.5 0 5 0 7.6c0 8 0 16 0 24c-16 0-32 0-48 0c0-8 0-16 0-24c0-7.2 0-14.3 0-21.5c0-4.6 0-9.3 0-13.9c4-2.3 8-4.6 12.1-6.9c14.8-8.5 29.6-17 44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-2c0-.3 .1-.7 .1-1s0-.7 0-1c0-1-.1-1.3-.1-1.6c-.1-.5-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4c-18.9 0-37.9 0-56.9 0c-4.4 0-8 3.6-8 8c0 2.2 0 4.4 0 6.5c-16 0-32 0-48 0c0-2.2 0-4.4 0-6.5zm64 152l48 0c0 16 0 32 0 48l-48 0c0-16 0-32 0-48z','M224 128c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 236.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 128zm56 208l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faSolarSystem = {
    prefix: 'fasds',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      ['M0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-18.5-11.9-31.8-31.3-35.6-53.8C312.5 441.6 285 448 256 448C150 448 64 362 64 256c0-41.9 13.4-80.6 36.2-112.2c-1.4 .1-2.8 .2-4.2 .2c-.7 0-1.5 0-2.2 0s-1.4-.1-2.1-.1c-1.4-.1-2.8-.3-4.2-.6c-2.8-.5-5.5-1.2-8-2.2c-5.2-1.9-9.9-4.7-14.1-8.1c-8.3-6.9-14.3-16.5-16.5-27.5C18.2 147.7 0 199.7 0 256zm104 0c0 83.9 68.1 152 152 152s152-68.1 152-152c0-26.6-6.8-51.5-18.8-73.3C383.3 197.5 368.9 208 352 208c-.6 0-1.3 0-1.9 0s-1.3-.1-1.9-.1c7.5 14.4 11.8 30.8 11.8 48.2c0 57.4-46.6 104-104 104s-104-46.6-104-104s46.6-104 104-104c20.6 0 39.8 6 56 16.4l0-.4c0-.6 0-1.1 0-1.7s.1-1.1 .1-1.7c.1-1.1 .2-2.2 .4-3.3c.4-2.2 .9-4.3 1.6-6.3c1.4-4.1 3.4-7.8 5.9-11.2c5.1-6.7 12.2-11.8 20.5-14.2C316.4 113.5 287.3 104 256 104c-83.9 0-152 68.1-152 152zM138.8 28.4c18.6 11.8 32 31.1 36 53.6C199.4 70.4 227 64 256 64c106 0 192 86 192 192c0 41.9-13.4 80.6-36.2 112.2c1.4-.1 2.8-.2 4.2-.2c.7 0 1.5 0 2.2 0s1.4 .1 2.1 .1c1.4 .1 2.8 .3 4.2 .6c2.8 .5 5.5 1.2 8 2.2c5.2 1.9 9.9 4.7 14.1 8.1c8.3 6.9 14.3 16.5 16.5 27.5C493.9 364.2 512 312.2 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4z','M96 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM416 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM312 168a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM256 320l-64-64 64-64 64 64-64 64z']
      
    ]
  };

  

  
  

  var faBookTanakh = {
    prefix: 'fasds',
    iconName: 'book-tanakh',
    icon: [
      448,
      512,
      ["tanakh"],
      'f827',
      
      ['M32 384l64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0 0-64z','M448 96c0-53-43-96-96-96L64 0 32 0 0 0 0 384l32 0 64 0 96 0 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0-96 0-64 0L0 448l0 64 32 0 32 0 288 0c53 0 96-43 96-96l0-320zM208 40l13.9 24 27.7 48 55.4 0 27.7 0-13.9 24-27.7 48 27.7 48 13.9 24L305 256l-55.4 0-27.7 48L208 328l-13.9-24-27.7-48L111 256l-27.7 0 13.9-24 27.7-48L97.1 136 83.3 112l27.7 0 55.4 0 27.7-48L208 40zm55.4 96l13.9 24 13.9-24-27.7 0zm0 48l-27.7-48-55.4 0-27.7 48 27.7 48 55.4 0 27.7-48zm13.9 24l-13.9 24 27.7 0-13.9-24zm-55.4 48l-27.7 0L208 280l13.9-24zm-69.3-24l-13.9-24-13.9 24 27.7 0zm-13.9-72l13.9-24-27.7 0 13.9 24zm55.4-48l27.7 0L208 88l-13.9 24z']
      
    ]
  };

  
    var faTanakh = faBookTanakh;
  

  
  

  var faTableCellsLarge = {
    prefix: 'fasds',
    iconName: 'table-cells-large',
    icon: [
      512,
      512,
      ["th-large"],
      'f009',
      
      ['M64 224l0 64 160 0 0 128 64 0 0-128 160 0 0-64-160 0 0-128-64 0 0 128L64 224z','M448 96l0 320L64 416 64 96l384 0zM64 32L0 32 0 96 0 416l0 64 64 0 384 0 64 0 0-64 0-320 0-64-64 0L64 32z']
      
    ]
  };

  
    var faThLarge = faTableCellsLarge;
  

  
  

  var faCloudDrizzle = {
    prefix: 'fasds',
    iconName: 'cloud-drizzle',
    icon: [
      512,
      512,
      [],
      'f738',
      
      ['M40 352l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm96 64l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm96-64l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm96 64l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm96-64l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faPeoplePantsSimple = {
    prefix: 'fasds',
    iconName: 'people-pants-simple',
    icon: [
      512,
      512,
      [],
      'e21a',
      
      ['M64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64z','M32 160l192 0 8 192-40 0 0 160L64 512l0-160-40 0 8-192zm256 0l192 0 8 192-40 0 0 160-128 0 0-160-40 0 8-192z']
      
    ]
  };

  

  
  

  var faFlowerTulip = {
    prefix: 'fasds',
    iconName: 'flower-tulip',
    icon: [
      512,
      512,
      [127799],
      'f801',
      
      ['M0 320l0 16c0 97.2 78.8 176 176 176l48 0 32 0 32 0 48 0c97.2 0 176-78.8 176-176l0-16-80 0c-59.5 0-112.1 29.5-144 74.8L288 256l-64 0 0 138.8C192.1 349.5 139.5 320 80 320L0 320z','M96 128V32l80 48L256 0l80 80 80-48v96c0 70.7-57.3 128-128 128H224c-70.7 0-128-57.3-128-128z']
      
    ]
  };

  

  
  

  var faBusinessTime = {
    prefix: 'fasds',
    iconName: 'business-time',
    icon: [
      640,
      512,
      ["briefcase-clock"],
      'f64a',
      
      ['M0 96L0 256l192 0 160 0 8.2 0c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7L512 96 384 96l0-72 0-24L360 0 152 0 128 0l0 24 0 72L0 96zM0 288L0 480l360.2 0C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16L192 352l0-64L0 288zM176 48l160 0 0 48L176 96l0-48z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0 0 16z']
      
    ]
  };

  
    var faBriefcaseClock = faBusinessTime;
  

  
  

  var faCommentDollar = {
    prefix: 'fasds',
    iconName: 'comment-dollar',
    icon: [
      512,
      512,
      [],
      'f651',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm182.7 72.7c4.2-12.7 8.4-25.3 12.6-38c6.3 2.1 12.7 4.2 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7c-.7-.2-1.5-.4-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c2.6 6.1 3.9 12.5 3.9 19.2c0 3.4-.3 6.8-.9 10.2c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3z','M276 124l0 20 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0z']
      
    ]
  };

  

  
  

  var faPersonDress = {
    prefix: 'fasds',
    iconName: 'person-dress',
    icon: [
      320,
      512,
      ["female"],
      'f182',
      
      ['M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M108.9 128l-17.5 0L82 142.8 .2 270.8l53.9 34.4 42-65.8L48 384l40 0 0 96 0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-96 40 0L223.8 239.4l42 65.8 53.9-34.4L238 142.8 228.6 128l-17.5 0-102.2 0z']
      
    ]
  };

  
    var faFemale = faPersonDress;
  

  
  

  var faDreidel = {
    prefix: 'fasds',
    iconName: 'dreidel',
    icon: [
      448,
      512,
      [],
      'f792',
      
      ['M89.4 153.4L326.6 390.6c26.7-26.7 53.3-53.3 80-80L429.3 288l-22.6-22.6L333.3 192l89.4-89.4L445.3 80 400 34.7 377.4 57.4 288 146.7 214.6 73.4 192 50.7 169.4 73.4c-26.7 26.7-53.3 53.3-80 80z','M326.6 390.6L89.4 153.4l-80 80L0 242.7 0 256 0 448l0 32 32 0 192 0 13.3 0 9.4-9.4 80-80z']
      
    ]
  };

  

  
  

  var faOtter = {
    prefix: 'fasds',
    iconName: 'otter',
    icon: [
      640,
      512,
      [129446],
      'f700',
      
      ['M64 144c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 16 0 32 0 16-32 0-16 0-19.2-14.4c-2.6-2-5.3-3.9-7.9-5.9c2.5-1.7 5-3.3 7.5-5l3.6-2.4 0-4.3 0-24 0-8-8 0-48 0-8 0 0 8 0 24 0 4.3 3.6 2.4 7.5 5-7.9 5.9L112 208l-16 0-32 0 0-8 0-56zm16 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM96 256l32 0 32-24 32 24 37.5 0c13.2 37.3 48.7 64 90.5 64l32 0 32 0 0 32 0 32-128 0 0-64-32 0-64 0c-35.3 0-64-28.7-64-64zM208 144a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M188.8 193.6L208 208l16 0 32 0 0-16 0-32 0-16c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 56 0 8 32 0 16 0 19.2-14.4 7.9-5.9-7.5-5-3.6-2.4 0-4.3 0-24 0-8 8 0 48 0 8 0 0 8 0 24 0 4.3-3.6 2.4-7.5 5 7.9 5.9zM256 320l0 64 128 0 0-32 0-32 32-32 32-32 0-32 0-32 64 0 0 48 0 16 0 64 32 0 0-115.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8 8.2-30.9 19.9 4C576 86.1 640 164.2 640 254.9l0 1.1s0 0 0 0c0 123.7-100.3 224-224 224l-1.1 0L256 480l-.6 0C132 480 32 380 32 256.6l0-.6-16 0 0-48 0-64L0 144 0 96l24 0 2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0 24 0 0 48-16 0 0 16 48 0 32 0 0 64-32 0-32 0 0 32 80 0-48 48 0 16-32 0c-41.8 0-77.4-26.7-90.5-64L192 256l-32-24-32 24-32 0c0 35.3 28.7 64 64 64l64 0 32 0z']
      
    ]
  };

  

  
  

  var faUserSecret = {
    prefix: 'fasds',
    iconName: 'user-secret',
    icon: [
      448,
      512,
      [128373],
      'f21b',
      
      ['M112 167c3 .5 6 1 9.1 1.5c3.1 .5 6.2 .9 9.4 1.4c4.5 18 9 36 13.5 54.1c21.3 0 42.7 0 64 0c2.7-10.7 5.3-21.3 8-32c5.3 0 10.7 0 16 0c2.7 10.7 5.3 21.3 8 32c21.3 0 42.7 0 64 0c4.5-18 9-36 13.5-54.1c6.4-.9 12.6-1.9 18.5-2.9l0 17c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-17z','M160 0l64 32L288 0l38.9 87.5C380.5 96 416 111 416 128c0 18-39.7 33.7-98.5 41.9L304 224l-64 0-8-32-16 0-8 32-64 0-13.5-54.1C71.7 161.7 32 146 32 128c0-17 35.5-32 89.1-40.5L160 0zM272 480l72-256 72 0L375.3 336l40.7 0 32 176-168 0-56 0-56 0L0 512 32 336l40.7 0L32 224l72 0 72 256 1.1 .7 31.2-106.9L176 320l48 0 48 0-32.3 53.8 31.2 106.9 1.1-.7z']
      
    ]
  };

  

  
  

  var faRv = {
    prefix: 'fasds',
    iconName: 'rv',
    icon: [
      640,
      512,
      [],
      'f7be',
      
      ['M112 448a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm320 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M224 0L384 0l0 32 224 0 0 128-224 0 0 256-117.5 0c-13.2-37.3-48.7-64-90.5-64c-38.9 0-72.5 23.2-87.5 56.5L0 320 0 32l224 0 0-32zM96 128l0 96 160 0 0-96L96 128zM416 320l0-32 0-72 0-24 24 0 88 0 8.6 0 6.6 5.4 88 72 8.8 7.2 0 11.4 0 32 0 96-53.5 0c-13.2-37.3-48.7-64-90.5-64c-33.4 0-62.8 17-80 42.9l0-74.9zm162.1-32l-58.7-48L464 240l0 48 114.1 0z']
      
    ]
  };

  

  
  

  var faClockElevenThirty = {
    prefix: 'fasds',
    iconName: 'clock-eleven-thirty',
    icon: [
      512,
      512,
      [],
      'e348',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM158.7 153.3l39.9-26.6 13.3 20 64 96 4 6 0 7.3 0 136 0 24-48 0 0-24 0-128.7-60-90-13.3-20z','M232 416l0-24 0-128.7-60-90-13.3-20 39.9-26.6 13.3 20 64 96 4 6 0 7.3 0 136 0 24-48 0z']
      
    ]
  };

  

  
  

  var faExpandWide = {
    prefix: 'fasds',
    iconName: 'expand-wide',
    icon: [
      512,
      512,
      [],
      'f320',
      
      ['M0 288l0 32 0 96 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-64 0-32L0 288zM352 64l0 64 32 0 64 0 0 64 0 32 64 0 0-32 0-96 0-32-32 0-96 0-32 0z','M0 192l0 32 64 0 0-32 0-64 64 0 32 0 0-64-32 0L32 64 0 64 0 96l0 96zM512 320l0-32-64 0 0 32 0 64-64 0-32 0 0 64 32 0 96 0 32 0 0-32 0-96z']
      
    ]
  };

  

  
  

  var faBriefcaseArrowRight = {
    prefix: 'fasds',
    iconName: 'briefcase-arrow-right',
    icon: [
      512,
      512,
      [],
      'e2f2',
      
      ['M0 96L0 480l512 0 0-384L384 96l0-72 0-24L360 0 152 0 128 0l0 24 0 72L0 96zM128 264c8 0 16 0 24 0c50 0 100 0 150.1 0c-13-13-26-26-39-39c-5.7-5.7-11.3-11.3-17-17c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c26.7 26.7 53.3 53.3 80 80c5.7 5.7 11.3 11.3 17 17c-5.7 5.7-11.3 11.3-17 17c-26.7 26.7-53.3 53.3-80 80l-17 17L246.1 368l17-17 39-39c-50 0-100 0-150.1 0c-8 0-16 0-24 0l0-48zM176 48l160 0 0 48L176 96l0-48z','M280 174.1l17 17 80 80 17 17-17 17-80 80-17 17L246.1 368l17-17 39-39L152 312l-24 0 0-48 24 0 150.1 0-39-39-17-17L280 174.1z']
      
    ]
  };

  

  
  

  var faSuitcaseMedical = {
    prefix: 'fasds',
    iconName: 'suitcase-medical',
    icon: [
      512,
      512,
      ["medkit"],
      'f0fa',
      
      ['M96 96l0 384 32 0 0-352 0-32L96 96zm288 0l0 32 0 352 32 0 0-384-32 0z','M128 0l24 0L360 0l24 0 0 24 0 72 0 32 0 352-256 0 0-352 0-32 0-72 0-24zM336 48L176 48l0 48 160 0 0-48zM96 96l0 384L0 480 0 96l96 0zM416 480l0-384 96 0 0 384-96 0zM224 192l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z']
      
    ]
  };

  
    var faMedkit = faSuitcaseMedical;
  

  
  

  var faO = {
    prefix: 'fasds',
    iconName: 'o',
    icon: [
      448,
      512,
      [111],
      '4f',
      
      ['M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z','']
      
    ]
  };

  

  
  

  var faBookBible = {
    prefix: 'fasds',
    iconName: 'book-bible',
    icon: [
      448,
      512,
      ["bible"],
      'f647',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96zM208 64l0 64-64 0 0 64 64 0 0 128 64 0 0-128 64 0 0-64-64 0 0-64-64 0z']
      
    ]
  };

  
    var faBible = faBookBible;
  

  
  

  var faMessagesQuestion = {
    prefix: 'fasds',
    iconName: 'messages-question',
    icon: [
      640,
      512,
      [],
      'e1e7',
      
      ['M0 0L416 0l0 320-213.3 0L96 384l0-64L0 320 0 0zM134.9 103.2c-.1 .7-.1 1.5-.2 2.1c0 .8-.1 1.6-.1 2.4c0 2.1 0 4 0 5.8c13.3 0 26.7 0 40 0c0-1.8 0-3.6 0-5.5c0-.7 0-.7 .1-1.4c.1-.4 .2-.8 .4-1.2c.3-.8 .8-1.5 1.4-2.1c1.2-1.2 2.9-2 4.7-2l47.4 0c7 0 12.6 5.7 12.6 12.6c0 4.5-2.4 8.7-6.3 10.9C222.7 132 210.4 139 198 146.1c-3.3 1.9-6.7 3.8-10 5.8c0 3.9 0 7.7 0 11.6c0 6 0 11.9 0 17.9c0 6.7 0 13.3 0 20c13.3 0 26.7 0 40 0c0-6.7 0-13.3 0-20c0-2.1 0-4.2 0-6.3c9-5.1 17.9-10.3 26.9-15.4c16.4-9.4 26.4-26.8 26.4-45.6c0-29.1-23.6-52.6-52.6-52.6c-15.8 0-31.6 0-47.4 0c-12.9 0-24.6 5.2-33 13.7c-4.2 4.2-7.6 9.3-10 14.8c-1.2 2.8-2.1 5.7-2.7 8.7c-.3 1.5-.5 3.1-.7 4.6zM188 234.7a28.3 28.3 0 1 0 40 40 28.3 28.3 0 1 0 -40-40z','M134.7 108c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 175l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 124.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 234.7l40 0 0 40-40 0 0-40zM256 448l0-96 192 0 0-224 192 0 0 320-96 0 0 64L437.3 448 256 448z']
      
    ]
  };

  

  
  

  var faGamepadModern = {
    prefix: 'fasds',
    iconName: 'gamepad-modern',
    icon: [
      640,
      512,
      [63676,127918,"gamepad-alt"],
      'e5a2',
      
      ['M0 480L42.8 96 160 32l160 0 160 0L597.2 96 640 480l-200 0-16-96-208 0-16 96L0 480zM112 200l0 48 24 0 32 0 0 32 0 24 48 0 0-24 0-32 32 0 24 0 0-48-24 0-32 0 0-32 0-24-48 0 0 24 0 32-32 0-24 0zm280 72a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm64-96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M216 144l0 24 0 32 32 0 24 0 0 48-24 0-32 0 0 32 0 24-48 0 0-24 0-32-32 0-24 0 0-48 24 0 32 0 0-32 0-24 48 0z']
      
    ]
  };

  
    var faGamepadAlt = faGamepadModern;
  

  
  

  var faCurlingStone = {
    prefix: 'fasds',
    iconName: 'curling-stone',
    icon: [
      576,
      512,
      [129356,"curling"],
      'f44a',
      
      ['M0 288l0 48 576 0 0-48-64-64-32 0L96 224l-32 0L0 288zm0 80l0 48 64 64 448 0 64-64 0-48L0 368z','M192 32l-32 0 0 32 0 96-64 0 0 64 384 0 0-64-256 0 0-64 160 0 32 0 0-64-32 0L192 32z']
      
    ]
  };

  
    var faCurling = faCurlingStone;
  

  
  

  var faTankWater = {
    prefix: 'fasds',
    iconName: 'tank-water',
    icon: [
      448,
      512,
      [],
      'e452',
      
      ['M64 297.9L64 348l0 68 320 0 0-68 0-50.1c-8.3-3-16.2-6.8-23.4-10.8c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-15.8 9-35.5 16.8-55.1 16.9l-.5 0c-19.6-.1-39.3-7.9-55.1-16.9c-15.4-8.7-27-19.1-40-30.7l-.7-.6-.7 .6c-13 11.6-24.6 22-40 30.7c-7.1 4-15 7.8-23.3 10.8zM168 168.2c0 30.8 25.2 55.8 56 55.8s56-25 56-55.8c0-10.6-3-21-8.7-29.9L224 64l-47.3 74.3c-5.7 8.9-8.7 19.3-8.7 29.9z','M241.6 32L251 46.8 282.3 96 384 96l0 320L64 416 64 96l101.7 0L197 46.8 206.4 32 64 32 0 32 0 96 0 416l0 64 64 0 320 0 64 0 0-64 0-320 0-64-64 0L241.6 32z']
      
    ]
  };

  

  
  

  var faImageLandscape = {
    prefix: 'fasds',
    iconName: 'image-landscape',
    icon: [
      576,
      512,
      ["landscape"],
      'e1b5',
      
      ['M0 64L0 448l576 0 0-384L0 64zM80.8 384c4.3-5.1 8.5-10.2 12.8-15.4c26.7-32 53.3-64 80-96c6.1-7.4 12.3-14.8 18.4-22.1c6.1 7.4 12.3 14.8 18.4 22.1c7.9 9.5 15.8 19 23.7 28.5c24.9-33.2 49.8-66.3 74.6-99.5c6.4-8.5 12.8-17.1 19.2-25.6l19.2 25.6L484 384 80.8 384zM192 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M328 176l19.2 25.6L484 384 80.8 384l12.8-15.4 80-96L192 250.5l18.4 22.1 23.7 28.5 74.6-99.5L328 176z']
      
    ]
  };

  
    var faLandscape = faImageLandscape;
  

  
  

  var faArrowUpToDottedLine = {
    prefix: 'fasds',
    iconName: 'arrow-up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a1',
      
      ['M0 32l64 0 0 64L0 96 0 32zm96 0l64 0 0 64L96 96l0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M224 146.7l22.6 22.6 128 128L397.3 320 352 365.3l-22.6-22.6L256 269.3l0 66.7 0 112 0 32-64 0 0-32 0-112 0-66.7-73.4 73.4L96 365.3 50.7 320l22.6-22.6 128-128L224 146.7z']
      
    ]
  };

  

  
  

  var faSiren = {
    prefix: 'fasds',
    iconName: 'siren',
    icon: [
      448,
      512,
      [],
      'e02d',
      
      ['M48 352L80 96l288 0 32 256-261.9 0 21.8-174 2.2-18-32.2 0-1.8 14L105.9 352 48 352z','M448 352L0 352 0 480l448 0 0-128z']
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fasds',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM176 352l-16 0 0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80l-16 0 0 16 0 128 0 16 16 0 32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm32 128l-16 0 0-96 16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16zm80-128l0 16 0 64 0 64 0 16 32 0 0-16 0-48 32 0 16 0 0-32-16 0-32 0 0-32 32 0 16 0 0-32-16 0-48 0-16 0z']
      
    ]
  };

  

  
  

  var faBagShoppingMinus = {
    prefix: 'fasds',
    iconName: 'bag-shopping-minus',
    icon: [
      448,
      512,
      [],
      'e650',
      
      ['M0 160l112 0 48 0 128 0 48 0 112 0 0 352L0 512 0 160zM120 312l0 48 24 0 160 0 24 0 0-48-24 0-160 0-24 0z','M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48 48 0 0-48C336 50.1 285.9 0 224 0S112 50.1 112 112l0 48 48 0 0-48zM144 312l-24 0 0 48 24 0 160 0 24 0 0-48-24 0-160 0z']
      
    ]
  };

  

  
  

  var faTableCells = {
    prefix: 'fasds',
    iconName: 'table-cells',
    icon: [
      512,
      512,
      ["th"],
      'f00a',
      
      ['M64 160l0 64 80 0 0 64-80 0 0 64 80 0 0 64 64 0 0-64 96 0 0 64 64 0 0-64 80 0 0-64-80 0 0-64 80 0 0-64-80 0 0-64-64 0 0 64-96 0 0-64-64 0 0 64-80 0zm144 64l96 0 0 64-96 0 0-64z','M512 32L0 32 0 480l512 0 0-448zM448 96l0 320L64 416 64 96l384 0z']
      
    ]
  };

  
    var faTh = faTableCells;
  

  
  

  var faCircleSort = {
    prefix: 'fasds',
    iconName: 'circle-sort',
    icon: [
      512,
      512,
      ["sort-circle"],
      'e030',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-64L256 96l112 96 0 32-224 0 0-32zm0 96l224 0 0 32L256 416 144 320l0-32z','M256 96L144 192l0 32 224 0 0-32L256 96zm0 320l112-96 0-32-224 0 0 32 112 96z']
      
    ]
  };

  
    var faSortCircle = faCircleSort;
  

  
  

  var faUpRightFromSquare = {
    prefix: 'fasds',
    iconName: 'up-right-from-square',
    icon: [
      512,
      512,
      ["external-link-alt"],
      'f35d',
      
      ['M0 32l32 0 128 0 32 0 0 64-32 0L64 96l0 352 352 0 0-96 0-32 64 0 0 32 0 128 0 32-32 0L32 512 0 512l0-32L0 64 0 32z','M480 208l32-32L512 0 336 0 304 32l65.4 65.4-168 168L178.7 288 224 333.3l22.6-22.6 168-168L480 208z']
      
    ]
  };

  
    var faExternalLinkAlt = faUpRightFromSquare;
  

  
  

  var faCherries = {
    prefix: 'fasds',
    iconName: 'cherries',
    icon: [
      640,
      512,
      [],
      'e0ec',
      
      ['M0 336C0 224 96 224 96 224c30.6 0 56.3 9.5 73.5 18.2c7.1 3.6 12.7 7 16.6 9.6c3.8 2.5 5.9 4.2 5.9 4.2c0 0 .3-.3 .8-.6s1.2-.9 2.2-1.6c2-1.4 4.8-3.3 8.5-5.5c7.4-4.5 18.1-10.1 31.4-14.8c14.9-5.3 33-9.5 53.1-9.5c0 0 96 0 96 112c0 160-144 176-192 176S0 480 0 336zM353.9 488.9c36-32 62.1-80.9 62.1-152.9c0-53.1-18.7-88.3-43.2-110.5c17.1 2.4 32.1 7.4 44.1 12.7C436.4 246.7 448 256 448 256s7.2-5.7 19.7-12.4c17-9 44-19.6 76.3-19.6c0 0 96 0 96 112c0 160-144 176-192 176c-20.3 0-57.6-5.7-94.1-23.1z','M300.5 19.5L288 40c12.5-20.5 12.5-20.5 12.5-20.5s0 0 0 0c0 0 0 0 0 0l.1 .1 .4 .3c.3 .2 .8 .5 1.4 .9c1.2 .8 2.9 1.9 5.1 3.4c4.3 2.9 10.4 7.2 17.6 12.7c14.5 11.1 34 27.4 54.1 48.5c35.4 37.3 74 91 88.3 158.2C455.2 250.3 448 256 448 256s-11.6-9.3-31.2-17.9c-14-48.4-43.1-88.9-72.2-119.6c-14.7-15.5-29.1-28.1-41-37.6c-3.1 11.7-7.4 25.7-13.1 41.3C279 154.1 261.3 193 234.9 233.5C208.4 242.9 192 256 192 256s-8.3-6.6-22.5-13.8c38.6-48.8 62.1-98.1 76-136.4c7.6-21 12.4-38.5 15.2-50.7c1.4-6.1 2.3-10.8 2.9-13.9c.3-1.6 .5-2.7 .6-3.5l.1-.8 0-.1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L269.1 .3l31.4 19.2z']
      
    ]
  };

  

  
  

  var faFileVideo = {
    prefix: 'fasds',
    iconName: 'file-video',
    icon: [
      384,
      512,
      [],
      'f1c8',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM64 256l0 160 160 0 0-160L64 256zm192 48l0 64 64 32 0-128-64 32z','M384 160L224 0l0 160 160 0zM64 256l0 160 160 0 0-160L64 256zM320 400l0-128-64 32 0 64 64 32z']
      
    ]
  };

  

  
  

  var faUsersViewfinder = {
    prefix: 'fasds',
    iconName: 'users-viewfinder',
    icon: [
      640,
      512,
      [],
      'e595',
      
      ['M96 336l94.3 0 19.4-58.1 7.3-21.9L120 256 96 336zm31.8-160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 384l224 0-16-48-16-48-17.6 0-124.8 0L240 288l-16 48-16 48zm48-192a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm160-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm7.1 80l7.3 21.9L449.7 336l94.3 0-24-80-96.9 0z','M24 0L0 0 0 24 0 136l0 24 48 0 0-24 0-88 88 0 24 0 0-48L136 0 24 0zM616 0L504 0 480 0l0 48 24 0 88 0 0 88 0 24 48 0 0-24 0-112 0-24L616 0zM0 512l24 0 112 0 24 0 0-48-24 0-88 0 0-88 0-24L0 352l0 24L0 488l0 24zm616 0l24 0 0-24 0-112 0-24-48 0 0 24 0 88-88 0-24 0 0 48 24 0 112 0z']
      
    ]
  };

  

  
  

  var faGalaxy = {
    prefix: 'fasds',
    iconName: 'galaxy',
    icon: [
      512,
      512,
      [],
      'e008',
      
      ['M28.4 156.4l0 28.4c0 72.1 44.7 133.7 107.8 158.7c15 5.9 31.1 9.8 47.8 11.3c1.5 .4 3.2 .7 4.9 .7c.8 0 1.7-.1 2.5-.2c2.6 .1 5.1 .2 7.7 .2c18 0 34.4-2.8 49-8c-1.8 19.2-6.9 37.8-14.8 55c-13.9 30.1-36.4 56.1-65.6 74l-11.2 6.9 28.4 0c72.1 0 133.7-44.7 158.7-107.8c5.9-15 9.8-31.1 11.3-47.8c.4-1.6 .7-3.2 .7-4.9c0-.8-.1-1.7-.2-2.5c.1-2.6 .2-5.1 .2-7.7c0-18-2.8-34.4-8-49c19.2 1.8 37.8 6.9 55 14.8c30.1 13.9 56.1 36.4 74 65.6l6.9 11.2 0-28.4c0-72.1-44.7-133.7-107.8-158.7c-15-5.9-31.1-9.8-47.8-11.3c-1.3-.4-2.7-.6-4.1-.6c-1.6 0-2.5 0-3.3 .2c-2.6-.1-5.1-.2-7.7-.2c-18 0-34.4 2.8-49 8c1.8-19.2 6.9-37.8 14.8-55c13.9-30.1 36.4-56.1 65.6-74l11.2-6.9-28.4 0c-72.1 0-133.7 44.7-158.7 107.8c-5.9 15-9.8 31.1-11.3 47.8c-.1 .4-.2 .8-.3 1.2s-.1 .8-.2 1.2c-.1 .4-.1 .8-.1 1.2s0 .8 0 1.2c0 .5 0 .9 0 1.2c0 .4 .1 .8 .1 1.2c-.1 1.3-.1 2.6-.1 3.9c0 1.3 0 2.5 0 3.8c0 1.2 0 2.3 0 3.3c0 1.1 .1 2.2 .1 3.3c.1 2.2 .2 4.4 .4 6.5c.3 4.3 .9 8.5 1.5 12.6c1.3 8.2 3.3 15.9 5.9 23.2c-19.2-1.8-37.8-6.9-55-14.8c-30.1-13.9-56.1-36.4-74-65.6l-6.9-11.2zm192 99.6L256 220.4 291.6 256 256 291.6 220.4 256z','M145.4 44.8c-51 51-63 126.1-36 188.5c17.2 7.9 35.8 13 55 14.8c-5.2-14.6-8-31-8-49c0-2.6 .1-5.2 .2-7.7c-.1-.8-.2-1.7-.2-2.5c0-1.7 .2-3.3 .7-4.9c1.5-16.7 5.3-32.8 11.3-47.8c-11.5-31.1-13.9-65.4-6-98.7l3.1-12.8L145.4 44.8zm-9.1 298.8c-31.1 11.5-65.4 13.9-98.7 6l-12.8-3.1 20.1 20.1c51 51 126.1 63 188.5 36c7.9-17.2 13-35.8 14.8-55c-14.6 5.2-31 8-49 8c-2.6 0-5.2-.1-7.7-.2c-.8 .1-1.7 .2-2.5 .2c-1.7 0-3.3-.2-4.9-.7c-16.7-1.5-32.8-5.3-47.8-11.3zm207.4 32.1c11.5 31.1 13.9 65.4 6 98.7l-3.1 12.8 20.1-20.1c51-51 63-126.1 36-188.5c-17.2-7.9-35.8-13-55-14.8c5.2 14.6 8 31 8 49c0 2.6-.1 5.1-.2 7.7c.1 .8 .2 1.7 .2 2.5c0 1.7-.2 3.3-.7 4.9c-1.5 16.7-5.3 32.8-11.3 47.8zm32.1-207.4c31.1-11.5 65.4-13.9 98.7-6l12.8 3.1-20.1-20.1c-51-51-126.1-63-188.5-36c-7.9 17.2-13 35.8-14.8 55c14.6-5.2 31-8 49-8c2.6 0 5.2 .1 7.7 .2c.8-.1 1.7-.2 2.5-.2c1.7 0 3.3 .2 4.9 .7c16.7 1.5 32.8 5.3 47.8 11.3z']
      
    ]
  };

  

  
  

  var faJ = {
    prefix: 'fasds',
    iconName: 'j',
    icon: [
      320,
      512,
      [106],
      '4a',
      
      ['M320 32l0 32 0 256c0 88.4-71.6 160-160 160S0 408.4 0 320l0-32 0-32 64 0 0 32 0 32c0 53 43 96 96 96s96-43 96-96l0-256 0-32 64 0z','']
      
    ]
  };

  

  
  

  var faHighDefinition = {
    prefix: 'fasds',
    iconName: 'high-definition',
    icon: [
      576,
      512,
      ["rectangle-hd"],
      'e1ae',
      
      ['M0 32L0 480l576 0 0-448L0 32zM112 160l48 0 0 24 0 48 64 0 0-48 0-24 48 0 0 24 0 72 0 72 0 24-48 0 0-24 0-48-64 0 0 48 0 24-48 0 0-24 0-72 0-72 0-24zm192 0l24 0 56 0c53 0 96 43 96 96s-43 96-96 96l-56 0-24 0 0-24 0-144 0-24zm48 48l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z','M160 184l0-24-48 0 0 24 0 72 0 72 0 24 48 0 0-24 0-48 64 0 0 48 0 24 48 0 0-24 0-72 0-72 0-24-48 0 0 24 0 48-64 0 0-48zm168-24l-24 0 0 24 0 144 0 24 24 0 56 0c53 0 96-43 96-96s-43-96-96-96l-56 0zm56 144l-32 0 0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z']
      
    ]
  };

  
    var faRectangleHd = faHighDefinition;
  

  
  

  var faRestroom = {
    prefix: 'fasds',
    iconName: 'restroom',
    icon: [
      640,
      512,
      [],
      'f7bd',
      
      ['M1.5 294.5l54.5 17L56 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-168.5 54.5-17-44.9-144-7-22.5-23.5 0L76.9 128l-23.5 0-7 22.5L1.5 294.5zM80 48a48 48 0 1 0 96 0A48 48 0 1 0 80 48zM385.5 294.5L425.7 307 400 384l40 0 0 96 0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-96 40 0-25.7-77 40.2-12.5-44.9-144-7-22.5-23.5 0-102.2 0-23.5 0-7 22.5-44.9 144zM464 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M344 0l0 24 0 464 0 24-48 0 0-24 0-464 0-24 48 0z']
      
    ]
  };

  

  
  

  var faDiceD6 = {
    prefix: 'fasds',
    iconName: 'dice-d6',
    icon: [
      448,
      512,
      [],
      'f6d1',
      
      ['M16 112L224 240 432 112 224 0 16 112z','M0 144L208 272l0 240L0 384 0 144zm448 0l0 240L240 512l0-240L448 144z']
      
    ]
  };

  

  
  

  var faAlignLeft = {
    prefix: 'fasds',
    iconName: 'align-left',
    icon: [
      448,
      512,
      [],
      'f036',
      
      ['M0 32L0 96l288 0 0-64L0 32zM0 288l0 64 288 0 0-64L0 288z','M0 480l448 0 0-64L0 416l0 64zM0 224l448 0 0-64L0 160l0 64z']
      
    ]
  };

  

  
  

  var faTemperatureSun = {
    prefix: 'fasds',
    iconName: 'temperature-sun',
    icon: [
      640,
      512,
      ["temperature-hot"],
      'f76a',
      
      ['M320 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L576 64l0-64L512 0 416 0 352 0l0 64 0 213.5c-20 24.7-32 56.2-32 90.5zm64 0c0-19.1 6.6-36.5 17.8-50.3L416 300.2l0-22.7L416 64l96 0 0 213.5 0 22.7 14.2 17.6C537.4 331.5 544 348.9 544 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M104 104L121.3 0 208 60.7 294.7 0 312 104l8 1.3 0 153.4c-20.2 28.6-32 63.5-32 101.2c0 17.7 2.6 34.9 7.5 51l-.8 5L208 355.3 121.3 416 104 312 0 294.7 60.7 208 0 121.3 104 104zm104 40a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM464 96c8.8 0 16 7.2 16 16l0 210.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L448 112c0-8.8 7.2-16 16-16z']
      
    ]
  };

  
    var faTemperatureHot = faTemperatureSun;
  

  
  

  var faCupStrawSwoosh = {
    prefix: 'fasds',
    iconName: 'cup-straw-swoosh',
    icon: [
      384,
      512,
      [],
      'e364',
      
      ['M32 192l320 0-6.4 64c-50.7 .6-85.3 8.9-111.2 22.8c-25.7 13.9-40.8 32.5-53.1 47.7l-1.9 2.3c-12.7 15.6-23.5 28.1-42.8 37.6C119.3 375 93.5 382 51.2 383.6L32 192zM55.9 431.5c45.2-2 77.3-9.8 101.9-22c29.2-14.4 45.4-34 58.7-50.4l.7-.8c13-16 22.7-28 39.9-37.2c16.1-8.7 40.9-15.9 83.6-17L320 512 64 512l-8.1-80.5z','M224 0L205 0l-4.4 18.5L174.9 128 32 128 0 128l0 64 32 0 320 0 32 0 0-64-32 0-127.8 0L243 48l37 0 24 0 0-48L280 0 224 0z']
      
    ]
  };

  

  
  

  var faArrowLeftFromBracket = {
    prefix: 'fasds',
    iconName: 'arrow-left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e668',
      
      ['M320 32l0 64 32 0 96 0 0 320-96 0-32 0 0 64 32 0 128 0 32 0 0-32 0-384 0-32-32 0L352 32l-32 0z','M0 256l22.6-22.6 128-128 22.6-22.6L218.5 128l-22.6 22.6L122.5 224 320 224l32 0 0 64-32 0-197.5 0 73.4 73.4L218.5 384l-45.3 45.3-22.6-22.6-128-128L0 256z']
      
    ]
  };

  

  
  

  var faRuler = {
    prefix: 'fasds',
    iconName: 'ruler',
    icon: [
      512,
      512,
      [128207],
      'f545',
      
      ['M0 352L160 512 512 160 352 0 283.3 68.7c16 16 32 32 48 48c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-16-16-32-32-48-48c-13.8 13.8-27.6 27.6-41.4 41.4c16 16 32 32 48 48c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-16-16-32-32-48-48c-13.8 13.8-27.6 27.6-41.4 41.4c16 16 32 32 48 48c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-16-16-32-32-48-48c-13.8 13.8-27.6 27.6-41.4 41.4c16 16 32 32 48 48c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-48-48C45.8 306.2 22.9 329.1 0 352z','M283.3 68.7l48 48L342.6 128 320 150.6l-11.3-11.3-48-48 22.6-22.6zm-86.6 86.6l22.6-22.6 48 48L278.6 192 256 214.6l-11.3-11.3-48-48zm-64 64l22.6-22.6 48 48L214.6 256 192 278.6l-11.3-11.3-48-48zm-64 64l22.6-22.6 48 48L150.6 320 128 342.6l-11.3-11.3-48-48z']
      
    ]
  };

  

  
  

  var faPersonCircleXmark = {
    prefix: 'fasds',
    iconName: 'person-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e543',
      
      ['M.2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 2.3-1.4c8.4-21.4 20.8-40.7 36.3-57L238 142.8 228.6 128l-17.5 0-102.2 0-17.5 0L82 142.8 .2 270.8zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7L502.6 320z']
      
    ]
  };

  

  
  

  var faArrowLeft = {
    prefix: 'fasds',
    iconName: 'arrow-left',
    icon: [
      448,
      512,
      [8592],
      'f060',
      
      ['M93.3 256c10.7-10.7 21.3-21.3 32-32L416 224l32 0 0 64-32 0-290.7 0c-10.7-10.7-21.3-21.3-32-32z','M2.7 256l22.6-22.6 144-144L192 66.7 237.3 112l-22.6 22.6L93.3 256 214.6 377.4 237.3 400 192 445.3l-22.6-22.6-144-144L2.7 256z']
      
    ]
  };

  

  
  

  var faLeafMaple = {
    prefix: 'fasds',
    iconName: 'leaf-maple',
    icon: [
      512,
      512,
      [127809],
      'f6f6',
      
      ['M16 56L64 240 16 272l122.2 67.9L274.3 203.7c5.7-5.7 11.3-11.3 17-17l33.9 33.9-17 17c-13.4 13.4-26.8 26.8-40.3 40.3c-32 32-63.9 63.9-95.9 95.9L240 496l32-48 184 48-8-64 56-48-56-48 16-64-80 0 128-96-64-32L480 32 368 64 336 0 240 128l0-80L176 64 128 8 80 64 16 56z','M7.3 470.7l17-17 250-250 17-17 33.9 33.9-17 17-250 250-17 17L7.3 470.7z']
      
    ]
  };

  

  
  

  var faRepublican = {
    prefix: 'fasds',
    iconName: 'republican',
    icon: [
      640,
      512,
      [],
      'f75e',
      
      ['M0 288l0 96 0 96 128 0 0-96 192 0 0 96 128 0 0-96 0-32 32 0 0 48c0 44.2 35.8 80 80 80s80-35.8 80-80l0-48 0-32-64 0 0 32 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80 0-32-32 0-64 0-32 0-96 0-192 0L0 288z','M160 32C71.6 32 0 103.6 0 192l0 96 544 0 0-96c0-88.4-71.6-160-160-160L160 32zM143.6 160l36.3 4.6-26.5 24.4L160 224l-32.1-16.9L95.7 224l6.7-34.9L75.8 164.7l36.3-4.6 15.7-32 15.7 32zm128.3-32l15.7 32 36.3 4.6-26.5 24.4L304 224l-32.1-16.9L239.7 224l6.7-34.9-26.5-24.4 36.3-4.6 15.7-32zm159.7 32l36.3 4.6-26.5 24.4L448 224l-32.1-16.9L383.7 224l6.7-34.9-26.5-24.4 36.3-4.6 15.7-32 15.7 32z']
      
    ]
  };

  

  
  

  var faHandsClapping = {
    prefix: 'fasds',
    iconName: 'hands-clapping',
    icon: [
      512,
      512,
      [],
      'e1a8',
      
      ['M201.8 27.6L228.4 9.8l8.9 13.3 32 48 8.9 13.3-26.6 17.8-8.9-13.3-32-48-8.9-13.3zM304 0l32 0 0 16 0 64 0 16-32 0 0-16 0-64 0-16zm51.4 508c48.1-39.6 76.6-99 76.6-162.4l0-91.5 16 16 0-86.1 0-24 24 0 16 0 24 0 0 24 0 161.6c0 57.1-30 110-78.9 139.4c-24.2 14.5-50.9 22.1-77.7 23.1zm6.4-423.6l8.9-13.3 32-48 8.9-13.3 26.6 17.8-8.9 13.3-32 48-8.9 13.3L361.8 84.4z','M152 102.1l17 17 151 151 0-86.1 0-24 24 0 16 0 24 0 0 24 0 161.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361l-17-17L24 310.1l17 17 64 64L127 369 23 265l-17-17L40 214.1l17 17L161 335 183 313 55 185l-17-17L72 134.1l17 17L217 279 239 257 135 153l-17-17L152 102.1z']
      
    ]
  };

  

  
  

  var faSnowflakes = {
    prefix: 'fasds',
    iconName: 'snowflakes',
    icon: [
      640,
      512,
      [],
      'f7cf',
      
      ['M482.2 36.2L510.1 64 482.2 91.8l33.9 33.9L544 97.9l27.8 27.8 33.9-33.9L577.9 64l27.8-27.8L571.8 2.2 544 30.1 516.2 2.2 482.2 36.2zm31 191l17 17L542.1 256l-11.8 11.8-17 17 33.9 33.9 17-17L576 289.9l11.8 11.8 17 17 33.9-33.9-17-17L609.9 256l11.8-11.8 17-17-33.9-33.9-17 17L576 222.1l-11.8-11.8-17-17-33.9 33.9z','M256 0H192V62.1L166.4 36.5 132.5 70.4 192 129.9v70.6l-61.2-35.3L109 83.9 62.7 96.3l9.4 35-39.9-23L.2 163.7l39.9 23-35 9.4 12.4 46.4 81.3-21.8L160 256 98.8 291.3 17.5 269.5 5.1 315.9l35 9.4L.2 348.3l32 55.4 39.9-23-9.4 35L109 428.1l21.8-81.3L192 311.4v70.6l-59.5 59.5 33.9 33.9L192 449.9V512h64V449.9l25.6 25.6 33.9-33.9L256 382.1V311.4l61.2 35.3L339 428.1l46.4-12.4-9.4-35 39.9 23 32-55.4-39.9-23 35-9.4-12.4-46.4-81.3 21.8L288 256l61.2-35.3 81.3 21.8 12.4-46.4-35-9.4 39.9-23-32-55.4-39.9 23 9.4-35L339 83.9l-21.8 81.3L256 200.6V129.9l59.5-59.5L281.6 36.5 256 62.1V0z']
      
    ]
  };

  

  
  

  var faCircleAmpersand = {
    prefix: 'fasds',
    iconName: 'circle-ampersand',
    icon: [
      512,
      512,
      [],
      'e0f8',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 64.3c0-22.9 10.9-44.5 29.4-58.1l21.9-16.1-7.3-7.7c-12.8-13.4-20-31.2-20-49.8l0-36.7 0-24 24 0 96 0 24 0 0 24 0 35.7c0 20.4-9.7 39.6-26.2 51.6l-18 13.2 28.6 29.9 27.7-40.1 13.7-19.7 39.5 27.3-13.7 19.7-33.3 48.1 60.9 63.6c.8 .8 1.5 1.7 2.2 2.6l-66.1 0-24.8-25.9-10.8 15.6L284.6 384 272 384l-16 0-88 0-24 0 0-24 0-39.7zm48 0l0 15.7 67.4 0 9.2-13.3-39.8-41.5-27 19.8c-6.2 4.5-9.8 11.7-9.8 19.4zM216 176l0 12.7c0 6.2 2.4 12.1 6.7 16.6l11.7 12.2 23.1-16.9c4.1-3 6.5-7.8 6.5-12.9l0-11.7-48 0z','M192 128l-24 0 0 24 0 36.7c0 18.6 7.2 36.4 20 49.8l7.3 7.7-21.9 16.1c-18.5 13.6-29.4 35.1-29.4 58.1l0 39.7 0 24 24 0 88 0 16 0 12.6 0 7.2-10.3 10.8-15.6L327.4 384l66.1 0c-.7-.9-1.4-1.8-2.2-2.6l-60.9-63.6 33.3-48.1 13.7-19.7-39.5-27.3-13.7 19.7-27.7 40.1-28.6-29.9 18-13.2c16.4-12.1 26.2-31.2 26.2-51.6l0-35.7 0-24-24 0-96 0zm65.5 72.6l-23.1 16.9-11.7-12.2c-4.3-4.5-6.7-10.4-6.7-16.6l0-12.7 48 0 0 11.7c0 5.1-2.4 9.9-6.5 12.9zM201.8 301l27-19.8 39.8 41.5L259.4 336 192 336l0-15.7c0-7.6 3.6-14.8 9.8-19.4z']
      
    ]
  };

  

  
  

  var faCampfire = {
    prefix: 'fasds',
    iconName: 'campfire',
    icon: [
      512,
      512,
      [],
      'f6ba',
      
      ['M112 174.5C112 93.1 189.6 24.2 228.4 0l58.2 58.2 29.1-29.1c69.8 58.2 87.3 121.2 87.3 145.5c0 80.3-65.1 145.5-145.5 145.5S112 254.9 112 174.5zm87.3 43.8c0 32.1 26 58.2 58.2 58.2s58.2-26 58.2-58.2c0-43.6-58.2-87.3-58.2-87.3s-58.2 43.6-58.2 87.3z','M256 366.5l214.4-67.4 19.2 61.1L362.7 400l126.9 39.9-19.2 61.1L256 433.5 41.6 500.9 22.4 439.9 149.3 400 22.4 360.1l19.2-61.1L256 366.5z']
      
    ]
  };

  

  
  

  var faHandsHolding = {
    prefix: 'fasds',
    iconName: 'hands-holding',
    icon: [
      640,
      512,
      [],
      'f4c2',
      
      ['M80 104l0 8 0 32 0 80 0 66.7 84.1 84.1L205.8 347l-36.4-36.4L146.7 288l-9.4-9.4L114.7 256 160 210.7l22.6 22.6 9.4 9.4 22.6 22.6 64 64 9.4 9.4 0 13.3 0 64 0 32 0 32 0 32-32 0-96 0-13.3 0-9.4-9.4-128-128L0 365.3 0 352 0 224l0-64 0-32 0-24L0 64l80 0 0 40zm480 0l0-40 80 0 0 40 0 24 0 32 0 64 0 128 0 13.3-9.4 9.4-128 128-9.4 9.4L480 512l-96 0-32 0 0-32 0-32 0-32 0-64 0-13.3 9.4-9.4 64-64L448 242.7l9.4-9.4L480 210.7 525.3 256l-22.6 22.6-9.4 9.4-22.6 22.6L434.2 347l41.7 27.8L560 290.7l0-66.7 0-80 0-32 0-8z','']
      
    ]
  };

  

  
  

  var faHeadphones = {
    prefix: 'fasds',
    iconName: 'headphones',
    icon: [
      512,
      512,
      [127911],
      'f025',
      
      ['M2 256l30 0 18.4 0C65.8 156.3 152 80 256 80s190.2 76.3 205.6 176l18.4 0 30 0C494.3 129.7 386.5 32 256 32S17.7 129.7 2 256z','M2 256c-1.3 10.5-2 21.2-2 32l0 96 0 96 128 0 0-224-77.6 0L2 256zm459.6 0L384 256l0 224 128 0 0-96 0-96c0-10.8-.7-21.5-2-32l-48.5 0z']
      
    ]
  };

  

  
  

  var faTengeSign = {
    prefix: 'fasds',
    iconName: 'tenge-sign',
    icon: [
      384,
      512,
      [8376,"tenge"],
      'f7d7',
      
      ['M0 160l0 64 160 0 0 256 64 0 0-256 160 0 0-64-160 0-64 0L0 160z','M0 32H384V96H0V32z']
      
    ]
  };

  
    var faTenge = faTengeSign;
  

  
  

  var faSquare7 = {
    prefix: 'fasds',
    iconName: 'square-7',
    icon: [
      448,
      512,
      [],
      'e25c',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 144 0 24 0 0 29.4-2.3 4.9L213.5 384l-53 0 3.9-8.2L258.2 176 152 176l-24 0 0-48z','M320 128l-24 0-144 0-24 0 0 48 24 0 106.2 0L164.3 375.8l-3.9 8.2 53 0L317.7 162.2l2.3-4.9 0-29.4z']
      
    ]
  };

  

  
  

  var faLampFloor = {
    prefix: 'fasds',
    iconName: 'lamp-floor',
    icon: [
      384,
      512,
      [],
      'e015',
      
      ['M160 224l0 224 32 0 32 0 0-224-64 0z','M0 224L64 0 320 0l64 224L0 224zM96 448l96 0 96 0 32 0 0 64-32 0-96 0-96 0-32 0 0-64 32 0z']
      
    ]
  };

  

  
  

  var faSunCloud = {
    prefix: 'fasds',
    iconName: 'sun-cloud',
    icon: [
      640,
      512,
      [127780],
      'f763',
      
      ['M0 150L73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l11.8-64L288 448l0-68c-10.2 2.6-21 4-32 4c-70.7 0-128-57.3-128-128s57.3-128 128-128c61.3 0 112.6 43.1 125.1 100.7c20.5-22.5 50-36.7 82.9-36.7c6.1 0 12.2 .5 18 1.4L512 150 385.3 126.7 362 0 256 73.1 150 0 126.7 126.7 0 150zM160 256c0 53 43 96 96 96c11.3 0 22.1-1.9 32.2-5.5c2.2-39.3 28.1-72.3 63.7-85c.1-1.8 .2-3.7 .2-5.5c0-53-43-96-96-96s-96 43-96 96z','M320 416l64 0 184 0 72 0 0-72c0-39.8-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64l0 64z']
      
    ]
  };

  

  
  

  var faDivide = {
    prefix: 'fasds',
    iconName: 'divide',
    icon: [
      448,
      512,
      [247,10135],
      'f529',
      
      ['M16 224l0 64 32 0 352 0 32 0 0-64-32 0L48 224l-32 0z','M272 48l-96 0 0 96 96 0 0-96zm0 320l-96 0 0 96 96 0 0-96z']
      
    ]
  };

  

  
  

  var faEnvelopeOpenDollar = {
    prefix: 'fasds',
    iconName: 'envelope-open-dollar',
    icon: [
      512,
      512,
      [],
      'f657',
      
      ['M64 32l149.3 0 85.3 0L448 32l0 112 0 80 0 27.2L256 388.3 64 251.2 64 224l0-80L64 32zM182.7 280.7l19 6.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3 0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38z','M489.3 221.7L448 251.2l0-27.2 0-80 64 48 0 13.5-22.7 16.2zm18.6 26l4.1-2.9L512 448l0 64-64 0L64 512 0 512l0-64L0 244.8l4.1 2.9L246.7 421l9.3 6.6 9.3-6.6L507.9 247.7zm-485.2-26L0 205.5 0 192l64-48 0 80 0 27.2L22.7 221.7zM256 0l42.7 32-85.3 0L256 0zm20 112l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c0 0 0 0 0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20z']
      
    ]
  };

  

  
  

  var faCubes = {
    prefix: 'fasds',
    iconName: 'cubes',
    icon: [
      576,
      512,
      [],
      'f1b3',
      
      ['M48 323.2l80 30.7 0 92.4c-26.7-11.7-53.3-23.4-80-35.2l0-87.9zm128 30.7c26.7-10.2 53.3-20.4 80-30.7l0 87.9c-26.7 11.7-53.3 23.4-80 35.2l0-92.4zM184 121l80 30.7 0 89.2c-26.7-10.1-53.3-20.2-80-30.3l0-89.6zm128 30.7c26.7-10.2 53.3-20.4 80-30.7l0 89.6c-26.7 10.1-53.3 20.2-80 30.3l0-89.2zm8 171.6c26.7 10.2 53.3 20.4 80 30.7l0 92.4c-26.7-11.7-53.3-23.4-80-35.2l0-87.9zm128 30.7c26.7-10.2 53.3-20.4 80-30.7l0 87.9c-26.7 11.7-53.3 23.4-80 35.2l0-92.4z','M288 4.2l8.5 3.2L424.5 56 440 61.9l0 16.6 0 126.1 120.5 45.7 15.5 5.9 0 16.6 0 154.1 0 15.7-14.3 6.3L433.7 505l-9.7 4.2-9.7-4.2L288 449.5 161.7 505l-9.7 4.2-9.7-4.2-128-56.3L0 442.4l0-15.7L0 272.6l0-16.6 15.5-5.9L136 204.5l0-126.1 0-16.6L151.5 56l128-48.5L288 4.2zm24 236.7l80-30.3 0-89.6-80 30.7 0 89.2zm-48 0l0-89.2L184 121l0 89.6 80 30.3zM288 55.6L217.3 82.4 288 109.5l70.7-27.1L288 55.6zM48 411.1l80 35.2 0-92.4L48 323.2l0 87.9zm128 35.2l80-35.2 0-87.9-80 30.7 0 92.4zM152 311.7l81.2-31.1L152 249.8 70.8 280.6 152 311.7zm168 99.4l80 35.2 0-92.4-80-30.7 0 87.9zm128 35.2l80-35.2 0-87.9-80 30.7 0 92.4zM424 311.7l81.2-31.1L424 249.8l-81.2 30.8L424 311.7z']
      
    ]
  };

  

  
  

  var faSquareR = {
    prefix: 'fasds',
    iconName: 'square-r',
    icon: [
      448,
      512,
      [],
      'e27c',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 104 0c44.2 0 80 35.8 80 80l0 24-3.7 0c-8.4 26.7-30.4 47.4-57.9 53.9L337.1 384l-57 0-61.3-96L176 288l0 72 0 24-48 0 0-24 0-96 0-112 0-24zm48 48l0 64 56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0z','M152 128l-24 0 0 24 0 112 0 96 0 24 48 0 0-24 0-72 42.9 0 61.3 96 57 0-62.7-98.1c27.5-6.5 49.5-27.2 57.9-53.9l3.7 0 0-24c0-44.2-35.8-80-80-80l-104 0zm80 112l-56 0 0-64 80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0z']
      
    ]
  };

  

  
  

  var faBillboard = {
    prefix: 'fasds',
    iconName: 'billboard',
    icon: [
      640,
      512,
      [],
      'e5cd',
      
      ['M160 128l0 64 32 0 32 0 32 0 32 0 0-64-32 0 0-32 0-64 0-32L192 0l0 32 0 64 0 32-32 0zM288 416l0 64 0 32 64 0 0-32 0-64-64 0zm64-288l0 64 32 0 32 0 32 0 32 0 0-64-32 0 0-32 0-64 0-32L384 0l0 32 0 64 0 32-32 0z','M192 32L96 32 32 32l0 64 0 256L0 352l0 64 32 0 64 0 448 0 64 0 32 0 0-64-32 0 0-256 0-64-64 0-96 0 0 64 96 0 0 256L96 352 96 96l96 0 0-64zm64 64l128 0 0-64L256 32l0 64z']
      
    ]
  };

  

  
  

  var fa0 = {
    prefix: 'fasds',
    iconName: '0',
    icon: [
      320,
      512,
      [],
      '30',
      
      ['M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 96c-53 0-96 43-96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96z','']
      
    ]
  };

  

  
  

  var faShirt = {
    prefix: 'fasds',
    iconName: 'shirt',
    icon: [
      640,
      512,
      [128085,"t-shirt","tshirt"],
      'f553',
      
      ['M0 144L88 256l72-58.9L160 512l320 0 0-314.9L552 256l88-112L464 0 432 0c0 61.9-50.1 112-112 112S208 61.9 208 0L176 0 0 144z','M208 0c0 61.9 50.1 112 112 112s112-50.1 112-112L400 0c0 44.2-35.8 80-80 80s-80-35.8-80-80L208 0z']
      
    ]
  };

  
    var faTShirt = faShirt;
  
    var faTshirt = faShirt;
  

  
  

  var faClockSix = {
    prefix: 'fasds',
    iconName: 'clock-six',
    icon: [
      512,
      512,
      [],
      'e352',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 96l48 0 0 24 0 240 0 24-48 0 0-24 0-240 0-24z','M280 96l0 24 0 240 0 24-48 0 0-24 0-240 0-24 48 0z']
      
    ]
  };

  

  
  

  var faHose = {
    prefix: 'fasds',
    iconName: 'hose',
    icon: [
      448,
      512,
      [],
      'e419',
      
      ['M0 176c0 79.5 64.5 144 144 144l272 0 32 0 0-64-32 0-272 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l144 0 0-64L144 32C64.5 32 0 96.5 0 176zM0 352l0 64 32 0 384 0 32 0 0-64-32 0L32 352 0 352zm0 96l0 64 32 0 384 0 32 0 0-64-32 0L32 448 0 448z','M288 128l0-24 0-80 0-24 48 0 0 24 0 2.3 80 11.4L416 24l32 0 0 16 0 48 0 16-32 0 0-13.7-80 11.4 0 2.3 0 24-48 0z']
      
    ]
  };

  

  
  

  var faPhoneXmark = {
    prefix: 'fasds',
    iconName: 'phone-xmark',
    icon: [
      576,
      512,
      [],
      'e227',
      
      ['M32 32L176 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L400 288l144 80L512 512l-32 0C232.6 512 32 311.4 32 64l0-32z','M529 49l17-17L512-1.9 495 15l-47 47L401 15l-17-17L350.1 32l17 17 47 47-47 47-17 17L384 193.9l17-17 47-47 47 47 17 17L545.9 160l-17-17-47-47 47-47z']
      
    ]
  };

  

  
  

  var faGuitars = {
    prefix: 'fasds',
    iconName: 'guitars',
    icon: [
      512,
      512,
      [],
      'f8bf',
      
      ['M0 408c0 57.4 57.3 104 128 104c41.3 0 77.9-15.9 101.4-40.5c-3.5-10.5-5.4-21.7-5.4-33.3c0-20.9 6.2-40.2 15-56.5c2.3-4.3 4.7-9 7-13.9c-3.9-7.6-8.9-14.7-14.8-21.3c-10.3-11.4-11.1-30.4-2.9-43.4C235.8 291.3 240 278 240 264c0-42.1-37.7-77.3-88-86l0 94c9.7 7.3 16 18.9 16 32c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1 6.3-24.7 16-32l0-94c-50.3 8.6-88 43.8-88 86c0 14 4.2 27.3 11.6 39.1c8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408zm256 30.2c0 40.8 33 73.8 73.8 73.8l108.4 0c40.8 0 73.8-33 73.8-73.8c0-14.5-4.3-28.6-11.2-41.3C489 374.9 472 337.5 472 304c0-9.8 1.5-18 3.6-24.8c1.2-3.9 2.6-7.9 3.9-11.8c4.2-12.4 8.5-25 8.5-37.8l0-37.5-32 0s0 39.6-48 46.9c-4.8 .7-10.1 1.1-16 1.1l-16 0c-5.9 0-11.2-.5-16-1.5c-48-9.7-48-62.5-48-62.5l-32 0 0 53.5c0 12.9 4.3 25.4 8.5 37.8c1.4 4 2.7 7.9 3.9 11.8c2.1 6.8 3.6 15.1 3.6 24.8c0 33.5-17 70.9-28.8 92.9c-6.9 12.7-11.2 26.9-11.2 41.3zM336 304l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zm0 64l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32z','M80 0l24 0 48 0 24 0 0 24 0 56 0 5.7-2.5 5.1L152 133.7 152 272c-6.7-5-15-8-24-8s-17.3 3-24 8l0-138.3L82.5 90.7 80 85.7 80 80l0-56L80 0zM328 112L352 0l32 0c22.1 0 40 17.9 40 40l0 4.4c0 12.4-6.4 23.3-16 29.7l0 164.7c-4.8 .7-10.1 1.1-16 1.1l-16 0c-5.9 0-11.2-.5-16-1.5l0-89.9L328 112zm24 192l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0zm0 64l64 0 16 0 0 32-16 0-64 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faScrollOld = {
    prefix: 'fasds',
    iconName: 'scroll-old',
    icon: [
      576,
      512,
      [],
      'f70f',
      
      ['M64 32l352 0c35.3 0 64 28.7 64 64l0 16 0 16-32 32 32 32 0 16 0 16-32 32 32 32 0 16 0 48-48 0-16 0-32 32-32-32-16 0-48 0 0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-128 0-16 32-32-32-32 0-16 0-16 0-64c0-35.3-28.7-64-64-64z','M128 160l0-64c0-35.3-28.7-64-64-64S0 60.7 0 96l0 64 128 0zM288 352l0 48c0 44.2-35.8 80-80 80l272 0c53 0 96-43 96-96l0-32-144 0-16 0-32 32-32-32-16 0-48 0z']
      
    ]
  };

  

  
  

  var faQuoteRight = {
    prefix: 'fasds',
    iconName: 'quote-right',
    icon: [
      448,
      512,
      [8221,"quote-right-alt"],
      'f10e',
      
      ['M0 96L0 288l128 0 0 8c0 30.9-25.1 56-56 56l-8 0-32 0 0 64 32 0 8 0c66.3 0 120-53.7 120-120l0-8 0-96 0-96L0 96z','M328 416c66.3 0 120-53.7 120-120l0-8 0-96 0-96L256 96l0 192 128 0 0 8c0 30.9-25.1 56-56 56l-8 0-32 0 0 64 32 0 8 0z']
      
    ]
  };

  
    var faQuoteRightAlt = faQuoteRight;
  

  
  

  var faPenClipSlash = {
    prefix: 'fasds',
    iconName: 'pen-clip-slash',
    icon: [
      640,
      512,
      ["pen-alt-slash"],
      'e20f',
      
      ['M64 512l160-32L340.1 363.9 196.9 251.1 96 352 64 512zM191.9 126.2c12.7 9.9 25.5 19.8 38.2 29.7L288 97.9l31 31-54 54c48 37.3 96.1 74.6 144.1 111.9L447 257l33-33 1-1L305 47l-17-17L271 47l-79.2 79.2zM375.6 72.4l128 128L576 128 448 0 375.6 72.4z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faPenAltSlash = faPenClipSlash;
  

  
  

  var faPoo = {
    prefix: 'fasds',
    iconName: 'poo',
    icon: [
      512,
      512,
      [128169],
      'f2fe',
      
      ['M160 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M256 48c0 44.2-35.8 80-80 80l-10.5 0-5.5 0c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48L104 240c-39.8 0-72 32.2-72 72c0 25.6 13.4 48.2 33.6 60.9C27.5 385.6 0 421.6 0 464l0 48 512 0 0-48c0-42.4-27.5-78.4-65.6-91.1C466.6 360.2 480 337.6 480 312c0-39.8-32.2-72-72-72l-13.7 0c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96c-5.1 0-10.2 .4-15.1 1.2C250.4 14.3 256 30.5 256 48zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 448c-64 0-96-64-96-64l192 0s-32 64-96 64z']
      
    ]
  };

  

  
  

  var faFaceMelting = {
    prefix: 'fasds',
    iconName: 'face-melting',
    icon: [
      640,
      512,
      [129760],
      'e483',
      
      ['M0 448l0 32 0 32 32 0 288 0 256 0 32 0 0-32 0-32-32 0-16 0c-8.9 0-16-7.2-16-16s7.2-16 16-16l48 0 32 0 0-32 0-32-32 0-1.3 0c-23.6 0-39.8-24.1-35.4-47.2c3-15.8 4.6-32.1 4.6-48.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 38.5 8.5 75.1 23.8 107.9c15.5 33.4-6 84.1-42.8 84.1L32 448 0 448zM177.5 299l28.8-14 7 14.4c12 24.7 35.9 53.6 77.8 64.8s77.1-1.9 99.8-17.2l13.3-9L422 364.5l-13.3 9c-28.1 19-72.8 35.9-126 21.7s-83.4-51.2-98.3-81.7l-7-14.4zM287.5 189a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM441 238.7a32 32 0 1 1 -61.8-16.6A32 32 0 1 1 441 238.7z','M247.2 219.9a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8zm154.6 41.4a32 32 0 1 0 16.6-61.8 32 32 0 1 0 -16.6 61.8z']
      
    ]
  };

  

  
  

  var faBookMedical = {
    prefix: 'fasds',
    iconName: 'book-medical',
    icon: [
      448,
      512,
      [],
      'f7e6',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zM208 96l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faArrowDownSmallBig = {
    prefix: 'fasds',
    iconName: 'arrow-down-small-big',
    icon: [
      576,
      512,
      ["sort-size-down-alt"],
      'f88d',
      
      ['M320 32l0 160 160 0 0-160L320 32zm0 224l0 224 224 0 0-224-224 0z','M160 480l23.7-26 80-88 21.5-23.7-47.4-43.1-21.5 23.7L192 349.7l0-285.2 0-32-64 0 0 32 0 285.2-24.3-26.8L82.2 299.2 34.8 342.3 56.3 366l80 88L160 480z']
      
    ]
  };

  
    var faSortSizeDownAlt = faArrowDownSmallBig;
  

  
  

  var faGaugeSimple = {
    prefix: 'fasds',
    iconName: 'gauge-simple',
    icon: [
      512,
      512,
      ["gauge-simple-med","tachometer-average"],
      'f629',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm192 96c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64z','M280 88l0-24-48 0 0 24 0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3L280 88z']
      
    ]
  };

  
    var faGaugeSimpleMed = faGaugeSimple;
  
    var faTachometerAverage = faGaugeSimple;
  

  
  

  var faTrash = {
    prefix: 'fasds',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      ['M32 96L56 512l336 0L416 96 32 96z','M304 0L144 0 128 32 0 32 0 96l448 0 0-64L320 32 304 0z']
      
    ]
  };

  

  
  

  var faHandFingersCrossed = {
    prefix: 'fasds',
    iconName: 'hand-fingers-crossed',
    icon: [
      384,
      512,
      [],
      'e1a3',
      
      ['M0 272l0 91c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l-96 0 0-32-64 0 0 48 0 16-16 0L96 384l-16 0 0-32 16 0 96 0 0-32 0-48-41.4 0-35.3 0L80 272 0 272zM29.5 33.6L43 62.6l32 68.7 35.3-75.7L101 35.6 87.5 6.6l-58 27.1zM59.6 240l70.6 0L212.8 63l13.5-29-58-27.1-13.5 29L59.6 240zm105.9 0l26.4 0 0-9.4L181 207l-15.4 33z','M288 160l-64 0 0 128 64 0 0-128zm96 32l-64 0 0 128 64 0 0-128z']
      
    ]
  };

  

  
  

  var faCloudWord = {
    prefix: 'fasds',
    iconName: 'cloud-word',
    icon: [
      640,
      512,
      [],
      'e138',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zm128-48l16 0 192 0 16 0 0 32-16 0-192 0-16 0 0-32zm0 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm160 0l16 0 192 0 16 0 0 32-16 0-192 0-16 0 0-32zm96-64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z','M128 288l16 0 192 0 16 0 0 32-16 0-192 0-16 0 0-32zm112 64l16 0 0 32-16 0-96 0-16 0 0-32 16 0 96 0zm256 0l16 0 0 32-16 0-192 0-16 0 0-32 16 0 192 0zm-96-64l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faPhoneArrowDownLeft = {
    prefix: 'fasds',
    iconName: 'phone-arrow-down-left',
    icon: [
      512,
      512,
      ["phone-arrow-down","phone-incoming"],
      'e223',
      
      ['M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512l-32 0C200.6 512 0 311.4 0 64L0 32z','M505.9 40L489 57l-119 119 54.1 0 24 0 0 48-24 0-112 0-24 0 0-24 0-112 0-24 48 0 0 24 0 54.1L455 23l17-17L505.9 40z']
      
    ]
  };

  
    var faPhoneArrowDown = faPhoneArrowDownLeft;
  
    var faPhoneIncoming = faPhoneArrowDownLeft;
  

  
  

  var faOrnament = {
    prefix: 'fasds',
    iconName: 'ornament',
    icon: [
      384,
      512,
      [],
      'f7b8',
      
      ['M0 320c0 22.4 3.8 44 10.9 64l362.2 0c7.1-20 10.9-41.6 10.9-64s-3.8-44-10.9-64L10.9 256C3.8 276 0 297.6 0 320zM128 64l0 32 32 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64z','M96 96l192 0 0 57.7c39.3 22.7 69.7 58.9 85.1 102.3L10.9 256C26.3 212.6 56.7 176.4 96 153.7L96 96zM10.9 384l362.1 0C346.7 458.6 275.6 512 192 512s-154.7-53.4-181.1-128z']
      
    ]
  };

  

  
  

  var faFileXml = {
    prefix: 'fasds',
    iconName: 'file-xml',
    icon: [
      512,
      512,
      [],
      'e654',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zm32 192l-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0 0 16 0 128 0 16 32 0 0-16 0-73 18 32.7 14.3 26 13.9-26.2L384 421.8l0 74.2 0 16 32 0 0-16 0-128 0-16zm-224 0l-32 0 0 16c0 13.6 4 26.9 11.6 38.2L188.8 432l-17.2 25.8C164 469.1 160 482.4 160 496l0 16 32 0 0-16c0-7.3 2.2-14.4 6.2-20.4l9.8-14.7 9.8 14.7c4 6.1 6.2 13.2 6.2 20.4l0 16 32 0 0-16c0-13.6-4-26.9-11.6-38.2L227.2 432l17.2-25.8C252 394.9 256 381.6 256 368l0-16-32 0 0 16c0 7.3-2.2 14.4-6.2 20.4L208 403.2l-9.8-14.7c-4-6.1-6.2-13.2-6.2-20.4l0-16zM448 512l16 0 32 0 16 0 0-32-16 0-16 0 0-112 0-16-32 0 0 16 0 128 0 16z']
      
    ]
  };

  

  
  

  var faCarSideBolt = {
    prefix: 'fasds',
    iconName: 'car-side-bolt',
    icon: [
      640,
      512,
      [],
      'e344',
      
      ['M64 432a80 80 0 1 0 160 0A80 80 0 1 0 64 432zm352 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M96 64L42.7 224 0 224 0 432l32 0c0-61.9 50.1-112 112-112s112 50.1 112 112l128 0c0-61.9 50.1-112 112-112s112 50.1 112 112l32 0 0-208-117.3 0L416 64 96 64zM208 240L336 112l-24 96 88 0L272 336l24-96-88 0z']
      
    ]
  };

  

  
  

  var faBrightness = {
    prefix: 'fasds',
    iconName: 'brightness',
    icon: [
      512,
      512,
      [],
      'e0c9',
      
      ['M0 224l0 64 32 0 48 0 32 0 0-64-32 0-48 0L0 224zM50.7 96l22.6 22.6 32 32L128 173.3 173.3 128l-22.6-22.6-32-32L96 50.7 50.7 96zm0 320L96 461.3l22.6-22.6 32-32L173.3 384 128 338.7l-22.6 22.6-32 32L50.7 416zM224 0l0 32 0 48 0 32 64 0 0-32 0-48 0-32L224 0zm0 400l0 32 0 48 0 32 64 0 0-32 0-48 0-32-64 0zM338.7 128L384 173.3l22.6-22.6 32-32L461.3 96 416 50.7 393.4 73.4l-32 32L338.7 128zm0 256l22.6 22.6 32 32L416 461.3 461.3 416l-22.6-22.6-32-32L384 338.7 338.7 384zM400 224l0 64 32 0 48 0 32 0 0-64-32 0-48 0-32 0z','M160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z']
      
    ]
  };

  

  
  

  var faBoxCircleCheck = {
    prefix: 'fasds',
    iconName: 'box-circle-check',
    icon: [
      576,
      512,
      [],
      'e0c4',
      
      ['M0 160l208 0 0-128L64 32 0 160zm0 32L0 480l296.2 0C271.1 449.6 256 410.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192zM240 32l0 128 176 0 32 0L384 32 240 32z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faShowerDown = {
    prefix: 'fasds',
    iconName: 'shower-down',
    icon: [
      384,
      512,
      ["shower-alt"],
      'e24d',
      
      ['M32 352.4C32 369.8 46.2 384 63.6 384l.8 0C81.8 384 96 369.8 96 352.4c0-5.5-1.4-10.9-4.2-15.7L64 288 36.2 336.7c-2.7 4.8-4.2 10.2-4.2 15.7zm64 128c0 17.5 14.2 31.6 31.6 31.6l.8 0c17.5 0 31.6-14.2 31.6-31.6c0-5.5-1.4-10.9-4.2-15.7L128 416l-27.8 48.7c-2.7 4.8-4.2 10.2-4.2 15.7zm64-128c0 17.5 14.2 31.6 31.6 31.6l.8 0c17.5 0 31.6-14.2 31.6-31.6c0-5.5-1.4-10.9-4.2-15.7L192 288l-27.8 48.7c-2.7 4.8-4.2 10.2-4.2 15.7zm64 128c0 17.5 14.2 31.6 31.6 31.6l.8 0c17.5 0 31.6-14.2 31.6-31.6c0-5.5-1.4-10.9-4.2-15.7L256 416l-27.8 48.7c-2.7 4.8-4.2 10.2-4.2 15.7zm64-128c0 17.5 14.2 31.6 31.6 31.6l.8 0c17.5 0 31.6-14.2 31.6-31.6c0-5.5-1.4-10.9-4.2-15.7L320 288l-27.8 48.7c-2.7 4.8-4.2 10.2-4.2 15.7z','M224 32l0-32L160 0l0 32 0 3.2C87 50 32 114.6 32 192L0 192l0 64 32 0 320 0 32 0 0-64-32 0c0-77.4-55-142-128-156.8l0-3.2z']
      
    ]
  };

  
    var faShowerAlt = faShowerDown;
  

  
  

  var faPersonDigging = {
    prefix: 'fasds',
    iconName: 'person-digging',
    icon: [
      576,
      512,
      ["digging"],
      'f85e',
      
      ['M.6 236.9l22.2 9.2 347.9 145L352 416l-64 0-32 96 320 0 0-48L448 288l-47.6 63.5c-30.6-12.8-61.2-25.5-91.9-38.3L62.5 210.7c-7.1-2.9-14.2-5.9-21.2-8.8l-22.2-9.2L.6 236.9z','M304 64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM133.8 121.5L119 140 62.5 210.7 308.5 313.2 253.6 179.8l-5.1-12.5-12.6-5-80-32-22-8.8zM92.6 306.6L58.4 291.9 49 328 1.3 512l66.1 0 34.2-131.9 58.4 25 0 74.9 0 32 64 0 0-32 0-96 0-21.1-19.4-8.3-112-48z']
      
    ]
  };

  
    var faDigging = faPersonDigging;
  

  
  

  var faMouseField = {
    prefix: 'fasds',
    iconName: 'mouse-field',
    icon: [
      512,
      512,
      [],
      'e5a8',
      
      ['M272 88c0-22.1 17.9-40 40-40s40 17.9 40 40l0 40-40 0c-22.1 0-40-17.9-40-40z','M396.2 113.6c2.5-8.1 3.8-16.7 3.8-25.6c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 29.8 14.8 56.1 37.4 72l-5.4 0c-88.4 0-160 71.6-160 160l0 48-24 0c-39.8 0-72 32.2-72 72s32.2 72 72 72l384 0 24 0 0-48-24 0L72 464c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 136 0 8 0 19 0 133 0 24 0 0-24 0-16 0-16.8-15.8-5.7-49.9-18.2 23.8-63.5c2 .1 4 .2 6 .2L512 272l0-23.1c0-43-19.8-81.4-50.8-106.5C473 127.4 480 108.5 480 88c0-46.4-35.9-84.4-81.4-87.8C419.2 20.6 432 48.8 432 80c0 14.5-2.8 28.4-7.8 41.1c-8.9-3.4-18.3-6-28-7.5zM400 196a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM312 48c22.1 0 40 17.9 40 40l0 40-40 0c-22.1 0-40-17.9-40-40s17.9-40 40-40z']
      
    ]
  };

  

  
  

  var faCoffeePot = {
    prefix: 'fasds',
    iconName: 'coffee-pot',
    icon: [
      512,
      512,
      [],
      'e002',
      
      ['M64 328l0 16c0 80 72 136 72 136l304 0s72-56 72-136l0-16c0-67.2-39.4-125.1-96.4-152l-255.3 0C103.4 202.9 64 260.8 64 328zm64.3-8c4.1-53.7 49-96 103.7-96l112 0c54.7 0 99.6 42.3 103.7 96c.2 2.6 .3 5.3 .3 8l0 16c0 5.3-.6 10.5-1.7 15.6c-.6 2.5-1.2 5-2 7.6c-.8 2.6-1.8 5.2-2.8 7.8c-1 2.5-2.1 4.9-3.3 7.3c-1.2 2.4-2.5 4.9-3.9 7.2c-.7 1.2-1.4 2.3-2.1 3.5c-.8 1.2-1.5 2.4-2.3 3.6c-.7 1.1-1.5 2.2-2.2 3.2c-.8 1.1-1.5 2.1-2.3 3.2c-.3 .4-.6 .8-.8 1.1c-.8 1-1.5 2-2.3 3c-.9 1.1-1.7 2.1-2.6 3.2c-.8 1-1.7 2-2.5 2.9c-.8 .9-1.6 1.8-2.4 2.7c-84.4 0-168.7 0-253.2-.2c-.8-.9-1.6-1.8-2.4-2.7c-.9-1-1.8-2.1-2.7-3.1c-.8-.9-1.6-1.9-2.4-2.9c-.8-1-1.5-1.9-2.3-2.9c-.3-.4-.6-.8-.9-1.2c-.8-1-1.5-2.1-2.3-3.2c-.8-1.1-1.5-2.2-2.3-3.4s-1.5-2.3-2.2-3.5c-.7-1.2-1.4-2.3-2.1-3.5c-1.4-2.4-2.7-4.8-3.9-7.2c-1.2-2.5-2.4-5-3.4-7.6c-1-2.5-1.9-5-2.7-7.5c-.8-2.6-1.5-5.1-2-7.6c-1.1-5.1-1.7-10.3-1.7-15.5l0-16c0-2.7 .1-5.4 .3-8z','M0 32l32 0 64 0 96 0 32 0 256 0L416 176l-256 0L124.4 96 64 96l0 96 0 32L0 224l0-32L0 64 0 32zM448 344c0 27.4-16.8 53.7-33.5 72l-253.1 0c-16.7-18.3-33.5-44.6-33.5-72l0-16c0-2.7 .1-5.4 .3-8l319.4 0c.2 2.6 .3 5.3 .3 8l0 16z']
      
    ]
  };

  

  
  

  var faPenFancy = {
    prefix: 'fasds',
    iconName: 'pen-fancy',
    icon: [
      512,
      512,
      [10002,128395],
      'f5ac',
      
      ['M9.1 480.3l88-88c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-88 88L224 448c16-42.7 32-85.3 48-128c-26.7-26.7-53.3-53.3-80-80c-42.7 16-85.3 32-128 48L9.1 480.3z','M416 0L192 240l80 80L512 96 416 0z']
      
    ]
  };

  

  
  

  var faChartKanban = {
    prefix: 'fasds',
    iconName: 'chart-kanban',
    icon: [
      448,
      512,
      [],
      'e64f',
      
      ['M160 32l0 256 128 0 0-256L160 32z','M448 480l-128 0 0-448 128 0 0 448zM128 416L0 416 0 32l128 0 0 384z']
      
    ]
  };

  

  
  

  var faHatWizard = {
    prefix: 'fasds',
    iconName: 'hat-wizard',
    icon: [
      512,
      512,
      [],
      'f6e8',
      
      ['M0 448l0 64 32 0 448 0 32 0 0-64-32 0-16 0L48 448l-16 0L0 448zM224 176l32 16 16 32 16-32 32-16-32-16-16-32-16 32-32 16z','M192 128L48 448l416 0L352 192 416 0 192 128zm8 200l24-56 24 56 56 24-56 24-24 56-24-56-56-24 56-24zm72-104l-16-32-32-16 32-16 16-32 16 32 32 16-32 16-16 32z']
      
    ]
  };

  

  
  

  var faSquareKanban = {
    prefix: 'fasds',
    iconName: 'square-kanban',
    icon: [
      448,
      512,
      [],
      'e488',
      
      ['M0 32L0 480l448 0 0-448L0 32zm96 96l64 0 0 192-64 0 0-192zm96 0l64 0 0 128-64 0 0-128zm96 0l64 0 0 256-64 0 0-256z','M288 384l64 0 0-256-64 0 0 256zM96 320l64 0 0-192-64 0 0 192zm160-64l0-128-64 0 0 128 64 0z']
      
    ]
  };

  

  
  

  var faGarageCar = {
    prefix: 'fasds',
    iconName: 'garage-car',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      ['M160 363.5l0 4.5 0 24 0 24 0 64 0 32 64 0 0-32 0-16 192 0 0 16 0 32 64 0 0-32 0-64 0-24 0-25.8 0-4.5-1.7-4.2-40-102.2-6-15.3L416 240l-192 0-16.5 0-5.9 15.4-40 104-1.6 4.2zM264 400a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-42-64l18.5-48 159.1 0 18.8 48L222 336zm202 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M0 128V512H96V192H544V512h96V128L320 0 0 128z']
      
    ]
  };

  

  
  

  var faTextWidth = {
    prefix: 'fasds',
    iconName: 'text-width',
    icon: [
      448,
      512,
      [],
      'f035',
      
      ['M0 32l32 0 192 0 192 0 32 0 0 32 0 64 0 32-64 0 0-32 0-32L256 96l0 128 32 0 0 64-32 0-64 0-32 0 0-64 32 0 0-128L64 96l0 32 0 32L0 160l0-32L0 64 0 32z','M96 480L0 384l96-96 32 0 0 64 192 0 0-64 32 0 96 96-96 96-32 0 0-64-192 0 0 64-32 0z']
      
    ]
  };

  

  
  

  var faPersonBooth = {
    prefix: 'fasds',
    iconName: 'person-booth',
    icon: [
      576,
      512,
      [],
      'f756',
      
      ['M192 0l0 32 0 160 64 0 0-160 0-32L192 0zm0 320l0 160 0 32 64 0 0-32 0-160-64 0zm89 128l39 0 32 0 64 0 32 0 32 0 0-32 0-384 0-32L448 0 320 0 283.1 0l5.2 36.5 31.2 218.6L288.6 409.7 281 448zM512 0l0 32 0 448 0 32 64 0 0-32 0-448 0-32L512 0z','M64 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM0 192l0-32 32 0 48 0 13.3 0 9.4 9.4L157.3 224l66.7 0 32 0 0 64-32 0-80 0-13.3 0-9.4-9.4-9.4-9.4 0 72.1 41.6 55.5 6.4 8.5 0 10.7 0 64 0 32-64 0 0-32 0-53.3L64 384l0 96 0 32L0 512l0-32L0 298.7s0 0 0 0L0 288l0-96z']
      
    ]
  };

  

  
  

  var faBanBug = {
    prefix: 'fasds',
    iconName: 'ban-bug',
    icon: [
      512,
      512,
      ["debug"],
      'f7f9',
      
      ['M125.2 275.4l6.3 31.4 15.7-3.1 28.9-5.8 0 30.6-16.2 9.7L146 346.5 162.5 374l13.7-8.2 18.4-11.1L224 384l64 0 25.4-25.4C267.6 312.8 221.8 267 176 221.3l0 44-35.1 7-15.7 3.1zm73.5-122.1L345 299.7l19.9 4 15.7 3.1 6.3-31.4-15.7-3.1-35.1-7 0-18.6 35.1-7 15.7-3.1-6.3-31.4-15.7 3.1L336 214.1l0-30.6 16.2-9.7 13.7-8.2L349.5 138l-13.7 8.2-18.4 11.1L288 128l-64 0-25.4 25.4z','M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z']
      
    ]
  };

  
    var faDebug = faBanBug;
  

  
  

  var faBridgeWater = {
    prefix: 'fasds',
    iconName: 'bridge-water',
    icon: [
      576,
      512,
      [],
      'e4ce',
      
      ['M0 416l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2C38.6 409.9 19.3 416 0 416z','M576 64L0 64l0 96c53 0 96 43 96 96l0 80s0 0 0 0l18.6 13.4 1.1 .8s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3l0-127c0-53 43-96 96-96s96 43 96 96l0 127c13 0 27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L480 336l0-80c0-53 43-96 96-96l0-96z']
      
    ]
  };

  

  
  

  var faVentDamper = {
    prefix: 'fasds',
    iconName: 'vent-damper',
    icon: [
      640,
      512,
      [],
      'e465',
      
      ['M0 160l64 0 0 192L0 352 0 160zm576 0l64 0 0 192-64 0 0-192z','M576 64L64 64l0 384 512 0 0-384zM184 144l272 0 24 0 0 48-24 0-272 0-24 0 0-48 24 0zm0 88l272 0 24 0 0 48-24 0-272 0-24 0 0-48 24 0zm0 88l272 0 24 0 0 48-24 0-272 0-24 0 0-48 24 0z']
      
    ]
  };

  

  
  

  var faMosquitoNet = {
    prefix: 'fasds',
    iconName: 'mosquito-net',
    icon: [
      640,
      512,
      [],
      'e52c',
      
      ['M0 286.3c0 72.6 87.8 109 139.2 57.6L256 242.3l0 23.1-59.3 59.3-4.7 4.7 0 6.6 0 44.2-30.3 60.6-7.2 14.3 28.6 14.3 7.2-14.3 32-64 1.7-3.4 0-3.8 0-41.4 32-32 0 50 0 32 64 0 0-32 0-50 32 32 0-45.3-32-32 0-23.1 32 27.9 0-14.1 32 0 0-32 80 0 16 0 67 0c-11.7-9.9-26.3-16.5-42.4-18.5L344.7 181.6l49.6-41.3 8.4-7-3.5-10.4L385.4 81.6 414 30.2l7.8-14L393.8 .6l-7.8 14L354 72.2l-3.4 6.2 2.2 6.7 12.5 37.6L320 160.5l0-22.6 0-32-23.8 0 0-34.2 0-8.2-16.3 0 0 8.2 0 34.2-23.8 0 0 32 0 22.6-45.4-37.8 12.5-37.6 2.2-6.7L222 72.2 190 14.6l-7.8-14-28 15.5 7.8 14 28.6 51.4-13.8 41.3-3.5 10.4 8.4 7 49.6 41.3L71.4 205.5C30.6 210.6 0 245.2 0 286.3zM361.4 352l1.5 1.5c.4-.5 .9-1 1.3-1.5l-2.8 0z','M528 272l0-16-32 0 0 16 0 16-48 0 0-16 0-16-32 0 0 16 0 16-16 0-16 0 0 32 16 0 16 0 0 48-16 0-16 0 0 32 16 0 16 0 0 48-16 0-16 0 0 32 16 0 16 0 0 16 0 16 32 0 0-16 0-16 48 0 0 16 0 16 32 0 0-16 0-16 48 0 0 16 0 16 32 0 0-16 0-16 16 0 16 0 0-32-16 0-16 0 0-48 16 0 16 0 0-32-16 0-16 0 0-48 16 0 16 0 0-32-16 0-16 0 0-16 0-16-32 0 0 16 0 16-48 0 0-16zm48 48l0 48-48 0 0-48 48 0zm0 80l0 48-48 0 0-48 48 0zM448 368l0-48 48 0 0 48-48 0zm0 80l0-48 48 0 0 48-48 0z']
      
    ]
  };

  

  
  

  var faRocketLaunch = {
    prefix: 'fasds',
    iconName: 'rocket-launch',
    icon: [
      512,
      512,
      [128640],
      'e027',
      
      ['M0 287.6l118.5 .2c19.8-44.1 52.6-114.1 81.3-159.9L80 128 0 287.6zM.5 511.5s116.5 8 166-41.5c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C-7.5 395 .5 511.5 .5 511.5zm64.1-64.1s-2.7-38.7 13.8-55.2c11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4c-16.5 16.5-55.2 13.8-55.2 13.8zm159.1-55.5c.3 39.9 .3 80 .3 120.1l160-80 0-119.9c-45.6 28.5-115.4 60.4-160.3 79.8z','M223.7 391.9c-4-56-49.1-100.6-105.3-103.8c21.4-47.9 58.4-126.6 88.8-171.5C296.6-15.1 433.7-7.9 502.7 9.3c17.2 68.9 24.5 206-107.4 295.4c-44.7 30.3-123.1 66.2-171.6 87.2zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z']
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngine = {
    prefix: 'fasds',
    iconName: 'starfighter-twin-ion-engine',
    icon: [
      576,
      512,
      ["starfighter-alt"],
      'e038',
      
      ['M64 211.2l0 89.6 75.6 15.1C132.1 297.4 128 277.2 128 256c0-1.3 0-2.6 0-4s.1-2.6 .1-3.9c.1-2.6 .3-5.2 .6-7.8c.5-5.2 1.3-10.3 2.2-15.3c2-10 4.9-19.7 8.6-29L64 211.2zm372.4-15.1c7.5 18.5 11.6 38.7 11.6 59.9c0 1.3 0 2.6 0 4s-.1 2.6-.1 3.9c-.1 2.6-.3 5.2-.6 7.8c-.5 5.2-1.3 10.3-2.2 15.3c-2 10-4.9 19.7-8.6 29L512 300.8l0-89.6-75.6-15.1z','M64 32l0 32 0 384 0 32L0 480l0-32L0 64 0 32l64 0zm512 0l0 32 0 384 0 32-64 0 0-32 0-384 0-32 64 0zM272 350.7l0-32.7c-5.9-1.5-11.4-3.8-16.5-6.8l-23.1 23.1c11.6 8.2 25 14 39.6 16.4zm-62.3-39l23.1-23.1c-3-5.1-5.3-10.6-6.8-16.5l-32.7 0c2.4 14.6 8.2 28.1 16.4 39.6zM193.3 240l32.7 0c1.5-5.9 3.8-11.4 6.8-16.5l-23.1-23.1c-8.2 11.6-14 25-16.4 39.6zm39-62.3l23.1 23.1c5.1-3 10.6-5.3 16.5-6.8l0-32.7c-14.6 2.4-28.1 8.2-39.6 16.4zM343.6 334.3l-23.1-23.1c-5.1 3-10.6 5.3-16.5 6.8l0 32.7c14.6-2.4 28.1-8.2 39.6-16.4zm22.6-22.6c8.2-11.6 14-25 16.4-39.6L350 272c-1.5 5.9-3.8 11.4-6.8 16.5l23.1 23.1zM350 240l32.7 0c-2.4-14.6-8.2-28.1-16.4-39.6l-23.1 23.1c3 5.1 5.3 10.6 6.8 16.5zm-6.4-62.3c-11.6-8.2-25-14-39.6-16.4l0 32.7c5.9 1.5 11.4 3.8 16.5 6.8l23.1-23.1zM128 256a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zm182.8 22.5c5.7-5.8 9.2-13.7 9.2-22.5c0-17.7-14.3-32-32-32s-32 14.3-32 32s14.3 32 32 32c8.8 0 16.7-3.5 22.5-9.2l.3-.3z']
      
    ]
  };

  
    var faStarfighterAlt = faStarfighterTwinIonEngine;
  

  
  

  var faDiceSix = {
    prefix: 'fasds',
    iconName: 'dice-six',
    icon: [
      448,
      512,
      [9861],
      'f526',
      
      ['M0 32l448 0 0 448L0 480 0 32zM96 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M128 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM320 128a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z']
      
    ]
  };

  

  
  

  var faStarfighterTwinIonEngineAdvanced = {
    prefix: 'fasds',
    iconName: 'starfighter-twin-ion-engine-advanced',
    icon: [
      640,
      512,
      ["starfighter-alt-advanced"],
      'e28e',
      
      ['M64 217.6l0 76.8 107.6 21.5C164.1 297.4 160 277.2 160 256c0-1.3 0-2.6 0-4s.1-2.6 .1-3.9c.1-2.6 .3-5.2 .6-7.8c.5-5.2 1.3-10.3 2.2-15.3c2-10 4.9-19.7 8.6-29L64 217.6zm404.4-21.5c7.5 18.5 11.6 38.7 11.6 59.9c0 1.3 0 2.6 0 4s-.1 2.6-.1 3.9c-.1 2.6-.3 5.2-.6 7.8c-.5 5.2-1.3 10.3-2.2 15.3c-2 10-4.9 19.7-8.6 29L576 294.4l0-76.8L468.4 196.1z','M488.5 53.7L576 148.5l0 200.3L487 460l50 40 96-120 7-8.8 0-11.2 0-224 0-12.5-8.5-9.2-96-104-47 43.4zM64 155.8l88.3-103L103.7 11.2l-96 112-7.7 9L0 144 0 368l0 11.8 7.7 9 96 112 48.6-41.7L64 356.2l0-200.3zM414.7 272c-2.4 14.6-8.2 28.1-16.4 39.6l-23.1-23.1c3-5.1 5.3-10.6 6.8-16.5l32.7 0zm-39 62.3c-11.6 8.2-25 14-39.6 16.4l0-32.7c5.9-1.5 11.4-3.8 16.5-6.8l23.1 23.1zM304 350.7c-14.6-2.4-28.1-8.2-39.6-16.4l23.1-23.1c5.1 3 10.6 5.3 16.5 6.8l0 32.7zm-62.3-39c-8.2-11.6-14-25-16.4-39.6l32.7 0c1.5 5.9 3.8 11.4 6.8 16.5l-23.1 23.1zM414.7 240L382 240c-1.5-5.9-3.8-11.4-6.8-16.5l23.1-23.1c8.2 11.6 14 25 16.4 39.6zm-39-62.3l-23.1 23.1c-5.1-3-10.6-5.3-16.5-6.8l0-32.7c14.6 2.4 28.1 8.2 39.6 16.4zM304 194c-5.9 1.5-11.4 3.8-16.5 6.8l-23.1-23.1c11.6-8.2 25-14 39.6-16.4l0 32.7zm-39.1 29.5c-3 5.1-5.3 10.6-6.8 16.5l-32.7 0c2.4-14.6 8.2-28.1 16.4-39.6l23.1 23.1zM320 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm22.8-137.5l-.3 .3c-5.8 5.7-13.7 9.2-22.5 9.2c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32c0 8.8-3.5 16.7-9.2 22.5z']
      
    ]
  };

  
    var faStarfighterAltAdvanced = faStarfighterTwinIonEngineAdvanced;
  

  
  

  var faShieldVirus = {
    prefix: 'fasds',
    iconName: 'shield-virus',
    icon: [
      512,
      512,
      [],
      'e06c',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM112 240c5.3 0 10.7 0 16 0c33 0 49.5-39.9 26.2-63.2c-3.8-3.8-7.5-7.5-11.3-11.3c3.8-3.8 7.5-7.5 11.3-11.3c3.8-3.8 7.5-7.5 11.3-11.3l11.3 11.3c11.7 11.7 27.5 13.4 40.3 8c6.4-2.7 12.1-7.1 16.3-12.9c2-2.9 3.7-6.2 4.8-9.7c.6-1.8 1-3.6 1.3-5.6c.1-1 .3-2 .3-2.9s.1-1.9 .1-3c0-5.3 0-10.7 0-16c5.3 0 10.7 0 16 0s10.7 0 16 0c0 5.3 0 10.7 0 16c0 33 39.9 49.5 63.2 26.2l11.3-11.3c3.8 3.8 7.5 7.5 11.3 11.3s7.5 7.5 11.3 11.3c-3.8 3.8-7.5 7.5-11.3 11.3C334.5 200.1 351 240 384 240l16 0c0 5.3 0 10.7 0 16s0 10.7 0 16c-5.3 0-10.7 0-16 0c-33 0-49.5 39.9-26.2 63.2c3.8 3.8 7.5 7.5 11.3 11.3c-3.8 3.8-7.5 7.5-11.3 11.3s-7.5 7.5-11.3 11.3c-3.8-3.8-7.5-7.5-11.3-11.3C311.9 334.5 272 351 272 384c0 5.3 0 10.7 0 16l-16 0-16 0c0-5.3 0-10.7 0-16.2c0-1 0-1.9-.1-2.9c-.1-1-.2-1.9-.3-2.9c-.3-1.9-.7-3.8-1.3-5.5c-1.1-3.5-2.8-6.8-4.8-9.7c-4.1-5.8-9.8-10.2-16.3-12.9c-12.9-5.3-28.7-3.6-40.3 8c-3.8 3.8-7.5 7.5-11.3 11.3c-3.8-3.8-7.5-7.5-11.3-11.3s-7.5-7.5-11.3-11.3c3.8-3.8 7.5-7.5 11.3-11.3C177.5 311.9 161 272 128 272c-5.3 0-10.7 0-16 0c0-5.3 0-10.7 0-16s0-10.7 0-16z','M357.8 154.2l-11.3-11.3-11.3 11.3C311.9 177.5 272 161 272 128l0-16-16 0-16 0 0 16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-11.3 11.3s0 0 0 0l-11.3 11.3 11.3 11.3C177.5 200.1 161 240 128 240l-16 0 0 16 0 16 16 0c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3s0 0 0 0l11.3 11.3 11.3-11.3C200.1 334.5 240 351 240 384l0 16 16 0 16 0 0-16c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C334.5 311.9 351 272 384 272l16 0 0-16 0-16-16 0c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3zM208 232a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faConveyorBeltBoxes = {
    prefix: 'fasds',
    iconName: 'conveyor-belt-boxes',
    icon: [
      640,
      512,
      ["conveyor-belt-alt"],
      'f46f',
      
      ['M0 416c0 53 43 96 96 96l448 0c53 0 96-43 96-96s-43-96-96-96L96 320c-53 0-96 43-96 96zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M320 0L64 0l0 256 256 0L320 0zM576 64L384 64l0 192 192 0 0-192z']
      
    ]
  };

  
    var faConveyorBeltAlt = faConveyorBeltBoxes;
  

  
  

  var faLaptopMobile = {
    prefix: 'fasds',
    iconName: 'laptop-mobile',
    icon: [
      640,
      512,
      ["phone-laptop"],
      'f87a',
      
      ['M0 288l0 48 48 48 304 0 0-96-224 0 0-224 320 0 0 32 64 0 0-64 0-32L480 0 96 0 64 0l0 32 0 256L0 288zm448-96l0 256 128 0 0-256-128 0z','M576 192l0 256-128 0 0-256 128 0zM448 128l-64 0 0 64 0 256 0 64 64 0 128 0 64 0 0-64 0-256 0-64-64 0-128 0z']
      
    ]
  };

  
    var faPhoneLaptop = faLaptopMobile;
  

  
  

  var faDoorClosed = {
    prefix: 'fasds',
    iconName: 'door-closed',
    icon: [
      576,
      512,
      [128682],
      'f52a',
      
      ['M96 0l0 448 0 64 384 0 0-64L480 0 96 0zM416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M384 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 448l32 0 64 0 0 64-64 0L0 512l0-64zm576 64l-32 0-64 0 0-64 64 0 32 0 0 64z']
      
    ]
  };

  

  
  

  var faDialLow = {
    prefix: 'fasds',
    iconName: 'dial-low',
    icon: [
      576,
      512,
      [],
      'e15d',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M129.4 311.6c11.6 77 78 136 158.2 136c88.4 0 160-71.6 160-160s-71.6-160-160-160c-80.2 0-146.6 59-158.2 136l158.2 0 24 0 0 48-24 0-158.2 0z']
      
    ]
  };

  

  
  

  var faOctagonExclamation = {
    prefix: 'fasds',
    iconName: 'octagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e204',
      
      ['M0 160L160 0 352 0 512 160l0 192L352 512l-192 0L0 352 0 160zm232-32l0 24 0 112 0 24 48 0 0-24 0-112 0-24-48 0zm0 192l0 48 48 0 0-48-48 0z','M280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faArrowUp19 = {
    prefix: 'fasds',
    iconName: 'arrow-up-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-up"],
      'f163',
      
      ['M344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.6-6.2 44.8-18 64.1L453.5 480l-74.9 0 10.1-16.6 25.1-41.3C373.9 413.7 344 378.3 344 336zm8-304l32 0 48 0 32 0 0 32 0 96 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-64-16 0-32 0 0-64zm48 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M160 32.6l23.6 25.7 88 96L293.2 178 246 221.2l-21.6-23.6L192 162.3 192 448l0 32-64 0 0-32 0-285.7L95.6 197.6 74 221.2 26.8 178l21.6-23.6 88-96L160 32.6z']
      
    ]
  };

  
    var faSortNumericUp = faArrowUp19;
  

  
  

  var faPipeCircleCheck = {
    prefix: 'fasds',
    iconName: 'pipe-circle-check',
    icon: [
      640,
      512,
      [],
      'e436',
      
      ['M0 96l0 32L0 384l0 32 64 0 0-32 0-256 0-32L0 96zm96 32l0 256 224.7 0c-.5-5.3-.7-10.6-.7-16c0-68.4 39-127.7 96-156.8l0-83.2L96 128zM448 96l0 32 0 70.6c15.3-4.3 31.4-6.6 48-6.6c5.4 0 10.7 .2 16 .7l0-64.7 0-32-64 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faUserGear = {
    prefix: 'fasds',
    iconName: 'user-gear',
    icon: [
      640,
      512,
      ["user-cog"],
      'f4fe',
      
      ['M0 512l404 0 0-27.7-37.1 21.4-77-133.2L326 351.7l-36.1-20.8L305.4 304 64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M524.1 206.4l-88.1 0 0 42.2c-8 3.4-15.6 7.8-22.5 12.9l-34.9-20.2-44.9 77.8 34.9 20.2c-.4 4.1-.7 8.2-.7 12.4s.2 8.3 .7 12.4l-34.9 20.1 45 77.8 34.9-20.1c6.9 5.1 14.5 9.4 22.5 12.9l0 42.2 88.1 0 0-42.4c7.9-3.4 15.4-7.7 22.3-12.8l35 20.2 45-77.8L591.2 364c.4-4 .7-8.1 .7-12.3s-.2-8.2-.7-12.3l35.2-20.3-45-77.8-35 20.2c-6.9-5.1-14.3-9.4-22.3-12.8l0-42.4zM480 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  
    var faUserCog = faUserGear;
  

  
  

  var faPuzzle = {
    prefix: 'fasds',
    iconName: 'puzzle',
    icon: [
      512,
      512,
      [],
      'e443',
      
      ['M0 288L0 512l224 0 0-80-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-80-80 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L0 288zM304 0l0 80 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 64 64 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 80 0L512 0 304 0z','M0 288l80 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 80 0 0-80 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-80L0 64 0 288zm224 0l0 80-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 80 224 0 0-224-80 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-80 0z']
      
    ]
  };

  

  
  

  var faSquareHeart = {
    prefix: 'fasds',
    iconName: 'square-heart',
    icon: [
      448,
      512,
      [128159,"heart-square"],
      'f4c8',
      
      ['M0 32L0 480l448 0 0-448L0 32zM80 227.6c0-41.8 33.9-75.6 75.6-75.6c23 0 44.7 10.4 59.1 28.4l9.3 11.6 9.3-11.6c14.4-17.9 36.1-28.4 59.1-28.4c41.8 0 75.6 33.9 75.6 75.6l0 3.6c0 21-8.3 41.1-23.2 56L320 311.9l-96 96-96-96-24.8-24.8c-14.9-14.9-23.2-35-23.2-56l0-3.6z','M128 311.9l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56l0-3.6c0-41.8 33.9-75.6 75.6-75.6c23 0 44.7 10.4 59.1 28.4l9.3 11.6 9.3-11.6c14.4-17.9 36.1-28.4 59.1-28.4c41.8 0 75.6 33.9 75.6 75.6l0 3.6c0 21-8.3 41.1-23.2 56L320 311.9l-96 96-96-96z']
      
    ]
  };

  
    var faHeartSquare = faSquareHeart;
  

  
  

  var faSquare5 = {
    prefix: 'fasds',
    iconName: 'square-5',
    icon: [
      448,
      512,
      [],
      'e25a',
      
      ['M0 32L0 480l448 0 0-448L0 32zM130.9 331.4l42.3-22.7c1.8 3.4 3.6 6.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3l33 0c8.7 0 16.6-3.5 22.2-9.2c2.8-2.8 5.1-6.2 6.7-10c.8-1.9 1.4-3.9 1.8-5.9c.2-1 .4-2.1 .5-3.1c.1-.5 .1-1.1 .1-1.6s0-1 0-1.7c0-.5 0-1 0-1.4c0-.5-.1-1-.1-1.5c-.1-1-.2-1.9-.4-2.9c-.4-1.9-.9-3.7-1.6-5.5c-1.4-3.5-3.3-6.8-5.8-9.5c-5-5.6-11.9-9.4-19.8-10.4c-26.4-3.2-52.8-6.3-79.1-9.5c-7.7-.9-15.4-1.8-23.2-2.8l2.1-23.2 8-88 2-21.8 21.9 0 104 0 24 0c0 16 0 32 0 48l-24 0-82.1 0c-1.3 14.3-2.6 28.6-3.9 42.9c18.7 2.2 37.3 4.5 56 6.7c20 2.4 37.5 12.1 50 26.2c6.3 7 11.3 15.2 14.7 24.1c1.7 4.5 3.1 9.1 4 13.9c.5 2.4 .8 4.8 1 7.3c.1 1.2 .2 2.4 .3 3.7c.1 1.3 .1 2.5 .1 3.8c0 1.4 0 2.8-.1 4.1c-.1 1.3-.2 2.7-.3 4c-.3 2.7-.7 5.3-1.2 7.9c-1.1 5.2-2.6 10.2-4.6 14.9c-4 9.5-9.8 18.1-17 25.3c-14.4 14.4-34.2 23.3-56.2 23.3l-33 0c-29.8 0-57.1-16.4-71.2-42.6c-1.8-3.3-3.6-6.7-5.4-10z','M154.1 128l21.9 0 104 0 24 0 0 48-24 0-82.1 0L194 218.9l56 6.7c39.9 4.8 70 38.7 70 78.9c0 43.9-35.6 79.5-79.5 79.5l-33 0c-29.8 0-57.1-16.4-71.2-42.6l-5.4-10 42.3-22.7 5.4 10c5.7 10.7 16.9 17.3 29 17.3l33 0c17.4 0 31.5-14.1 31.5-31.5c0-15.9-11.9-29.3-27.7-31.2l-79.1-9.5L142 261.1l2.1-23.2 8-88 2-21.8z']
      
    ]
  };

  

  
  

  var faHouseBlank = {
    prefix: 'fasds',
    iconName: 'house-blank',
    icon: [
      576,
      512,
      ["home-blank"],
      'e487',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.7 64 272z','M0 240L288 0 576 240v32H512L288 88 64 272H0V240z']
      
    ]
  };

  
    var faHomeBlank = faHouseBlank;
  

  
  

  var faLightbulbSlash = {
    prefix: 'fasds',
    iconName: 'lightbulb-slash',
    icon: [
      640,
      512,
      [],
      'f673',
      
      ['M152.4 229.8c5.4 16.8 13.2 32.4 23 46.6c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l108.1 0L152.4 229.8zm8-128l52.7 40.9C227.3 97.1 269.8 64 320 64l0 32c-40.2 0-73.4 29.6-79.1 68.2L436.2 315.9c4.3-6.1 8.7-12.1 13.1-18.1c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0C249.3 0 188.4 41.7 160.4 101.7zM240 416l0 96 160 0 0-87.1L388.7 416 240 416z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faBooksMedical = {
    prefix: 'fasds',
    iconName: 'books-medical',
    icon: [
      576,
      512,
      [],
      'f7e8',
      
      ['M64 0L192 0l0 96L64 96 64 0zm0 416l128 0 0 96L64 512l0-96zM224 0L352 0l0 24.7L352 96 224 96l0-96zm0 128l128 0 0-9.8c39.1-10.5 78.2-20.9 117.3-31.4c2.8 10.3 5.6 20.6 8.4 30.9L352.2 151.3l-.2-.6L352 384l-128 0 0-256zm0 288l128 0 0 96-128 0 0-96zm195.4-17.7l125.5-33.6 8.4 30.9L427.8 429.2l-8.4-30.9z','M352 118.2l0 9.8-128 0 0-32 128 0 0-71.3L445.7 0l23.6 86.8L352 118.2zm.2 33.1l125.5-33.6 67.2 247L419.4 398.3l-67.2-247zm75.6 277.9l125.5-33.6L576 478.9 450.3 512l-22.5-82.8zM192 96l0 32L64 128l0-32 128 0zM64 416l0-32 128 0 0 32L64 416zm160-32l128 0 0 32-128 0 0-32zM64 160l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64L0 288l0-64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faKeyboardBrightness = {
    prefix: 'fasds',
    iconName: 'keyboard-brightness',
    icon: [
      640,
      512,
      [],
      'e1c0',
      
      ['M0 352l0 64 32 0 64 0 32 0 0-64-32 0-64 0L0 352zM66.7 176l22.6 22.6 64 64L176 285.3 221.3 240l-22.6-22.6-64-64L112 130.7 66.7 176zM288 64l0 32 0 96 0 32 64 0 0-32 0-96 0-32-64 0zM418.7 240L464 285.3l22.6-22.6 64-64L573.3 176 528 130.7l-22.6 22.6-64 64L418.7 240zM512 352l0 64 32 0 64 0 32 0 0-64-32 0-64 0-32 0z','M192 352l32 0 192 0 32 0 0 64-32 0-192 0-32 0 0-64z']
      
    ]
  };

  

  
  

  var faHeadSideVirus = {
    prefix: 'fasds',
    iconName: 'head-side-virus',
    icon: [
      512,
      512,
      [],
      'e064',
      
      ['M0 224.3c0 58.7 23 115 64 156.9L64 480l0 32 32 0 192 0 32 0 0-32 0-32 96 0 32 0 0-32 0-96 32 0 32 0 0-32 0-16 0-11.2-7-8.8-57.3-71.7C441.6 79.7 358.1 0 256 0L224.3 0C100.4 0 0 100.4 0 224.3zM80 192l16 0c33 0 49.5-39.9 26.2-63.2l-11.3-11.3c3.8-3.8 7.5-7.5 11.3-11.3l11.3-11.3 11.3 11.3C168.1 129.5 208 113 208 80l0-16 16 0 16 0 0 16c0 33 39.9 49.5 63.2 26.2l11.3-11.3 11.3 11.3 11.3 11.3-11.3 11.3C302.5 152.1 319 192 352 192l16 0 0 16 0 16-16 0c-33 0-49.5 39.9-26.2 63.2l11.3 11.3-11.3 11.3-11.3 11.3-11.3-11.3C279.9 286.5 240 303 240 336l0 16-16 0-16 0 0-16c0-33-39.9-49.5-63.2-26.2l-11.3 11.3c-3.8-3.8-7.5-7.5-11.3-11.3l-11.3-11.3 11.3-11.3C145.5 263.9 129 224 96 224l-16 0 0-16 0-16z','M325.8 106.2L314.5 94.9l-11.3 11.3C279.9 129.5 240 113 240 80l0-16-16 0-16 0 0 16c0 33-39.9 49.5-63.2 26.2L133.5 94.9l-11.3 11.3s0 0 0 0l-11.3 11.3 11.3 11.3C145.5 152.1 129 192 96 192l-16 0 0 16 0 16 16 0c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3s0 0 0 0l11.3 11.3 11.3-11.3C168.1 286.5 208 303 208 336l0 16 16 0 16 0 0-16c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C302.5 263.9 319 224 352 224l16 0 0-16 0-16-16 0c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3zM176 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faRectangleCode = {
    prefix: 'fasds',
    iconName: 'rectangle-code',
    icon: [
      512,
      512,
      [],
      'e322',
      
      ['M0 32L0 480l512 0 0-448L0 32zM94.1 256l17-17 64-64 17-17c11.3 11.3 22.6 22.6 33.9 33.9l-17 17-47 47c15.7 15.7 31.4 31.4 47 47c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9l-17-17c-21.3-21.3-42.7-42.7-64-64l-17-17zm192-64L320 158.1c5.7 5.7 11.3 11.3 17 17c21.3 21.3 42.7 42.7 64 64c5.7 5.7 11.3 11.3 17 17c-5.7 5.7-11.3 11.3-17 17c-21.3 21.3-42.7 42.7-64 64l-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17z','M225.9 192l-17 17-47 47 47 47 17 17L192 353.9l-17-17-64-64-17-17 17-17 64-64 17-17L225.9 192zM320 158.1l17 17 64 64 17 17-17 17-64 64-17 17L286.1 320l17-17 47-47-47-47-17-17L320 158.1z']
      
    ]
  };

  

  
  

  var faTrafficLightSlow = {
    prefix: 'fasds',
    iconName: 'traffic-light-slow',
    icon: [
      320,
      512,
      [],
      'f639',
      
      ['M112 240a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM160 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z']
      
    ]
  };

  

  
  

  var faKiwiFruit = {
    prefix: 'fasds',
    iconName: 'kiwi-fruit',
    icon: [
      448,
      512,
      [],
      'e30c',
      
      ['M0 176c0 79.5 100.3 144 224 144s224-64.5 224-144S347.7 32 224 32S0 96.5 0 176zm64-16l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32zm41.4-56L128 81.4l11.3 11.3 16 16L166.6 120 144 142.6l-11.3-11.3-16-16L105.4 104zm0 144l11.3-11.3 16-16L144 209.4 166.6 232l-11.3 11.3-16 16L128 270.6 105.4 248zM168 176c0-13.3 25.1-24 56-24s56 10.7 56 24s-25.1 24-56 24s-56-10.7-56-24zM208 64l32 0 0 16 0 24 0 16-32 0 0-16 0-24 0-16zm0 168l32 0 0 16 0 24 0 16-32 0 0-16 0-24 0-16zm73.4-112l11.3-11.3 16-16L320 81.4 342.6 104l-11.3 11.3-16 16L304 142.6 281.4 120zm0 112L304 209.4l11.3 11.3 16 16L342.6 248 320 270.6l-11.3-11.3-16-16L281.4 232zM320 160l16 0 32 0 16 0 0 32-16 0-32 0-16 0 0-32z','M240 64l-32 0 0 16 0 24 0 16 32 0 0-16 0-24 0-16zM128 81.4L105.4 104l11.3 11.3 16 16L144 142.6 166.6 120l-11.3-11.3-16-16L128 81.4zM342.6 104L320 81.4 308.7 92.7l-16 16L281.4 120 304 142.6l11.3-11.3 16-16L342.6 104zM64 160l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zm256 0l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zM166.6 232L144 209.4l-11.3 11.3-16 16L105.4 248 128 270.6l11.3-11.3 16-16L166.6 232zM304 209.4L281.4 232l11.3 11.3 16 16L320 270.6 342.6 248l-11.3-11.3-16-16L304 209.4zM240 232l-32 0 0 16 0 24 0 16 32 0 0-16 0-24 0-16zM224 480c123.7 0 224-100.3 224-224l0-80c0 79.5-100.3 144-224 144S0 255.5 0 176l0 80C0 379.7 100.3 480 224 480z']
      
    ]
  };

  

  
  

  var faPawClaws = {
    prefix: 'fasds',
    iconName: 'paw-claws',
    icon: [
      512,
      512,
      [],
      'f702',
      
      ['M0 236.8L0 240l0 .4c0 13.2 3.8 27.6 11.6 41.1c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1C91.1 214.7 77.9 203 64 196.8L64 128 12.2 199.2C4.3 210.1 0 223.3 0 236.8zM112 128c-.2 11.3 1.5 23.2 5.5 35.1c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8C226.3 100.2 210.3 81 192 71.2L192 0 138.9 58.4C121.6 77.4 112 102.3 112 128zm165.5-3.1c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1c0-25.7-9.6-50.6-26.9-69.6L320 0l0 71.2c-18.3 9.8-34.3 28.9-42.5 53.6zM411.6 230.6c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.8-13.5 11.6-27.8 11.6-41.1l0-.4 0-3.2c0-13.5-4.3-26.7-12.2-37.6L448 128l0 68.8c-13.9 6.1-27.1 17.8-36.4 33.7z','M64 512c0-176 128-256 192-256s192 80 192 256L256 464 64 512z']
      
    ]
  };

  

  
  

  var faBorderInner = {
    prefix: 'fasds',
    iconName: 'border-inner',
    icon: [
      448,
      512,
      [],
      'f84e',
      
      ['M0 32L0 96l64 0 0-64L0 32zm0 96l0 64 64 0 0-64L0 128zM0 320l0 64 64 0 0-64L0 320zm0 96l0 64 64 0 0-64L0 416zM96 32l0 64 64 0 0-64L96 32zm0 384l0 64 64 0 0-64-64 0zM288 32l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zM384 32l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M192 448l0 32 64 0 0-32 0-160 160 0 32 0 0-64-32 0-160 0 0-160 0-32-64 0 0 32 0 160L32 224 0 224l0 64 32 0 160 0 0 160z']
      
    ]
  };

  

  
  

  var faToothbrush = {
    prefix: 'fasds',
    iconName: 'toothbrush',
    icon: [
      576,
      512,
      [129701],
      'f635',
      
      ['M32 256l0 24 0 136 48 0 0-136 0-24-48 0zm80 0l0 24 0 136 48 0 0-136 0-24-48 0zm80 0l0 24 0 136 48 0 0-136 0-24-48 0zm80 0l0 24 0 136 48 0 0-136 0-24-48 0zm80 0l0 24 0 136 48 0 0-136 0-24-48 0z','M0 160c0-35.3 28.7-64 64-64l224 0c37.7 0 40-33.2 40-64c57.4 0 120 31.6 120 96c0 53-43 96-96 96L0 224l0-64zM32 416l512 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0z']
      
    ]
  };

  

  
  

  var faCalendarCirclePlus = {
    prefix: 'fasds',
    iconName: 'calendar-circle-plus',
    icon: [
      576,
      512,
      [],
      'e470',
      
      ['M0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0l0 64L0 64zM0 192L0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faRampLoading = {
    prefix: 'fasds',
    iconName: 'ramp-loading',
    icon: [
      448,
      512,
      [],
      'f4d4',
      
      ['M32 0L64 0 384 0l32 0 0 32 0 408.4-64-128L352 64 96 64l0 248.4-64 128L32 32 32 0z','M128 320H320l96 192H32l96-192z']
      
    ]
  };

  

  
  

  var faNarwhal = {
    prefix: 'fasds',
    iconName: 'narwhal',
    icon: [
      640,
      512,
      [],
      'f6fe',
      
      ['M0 96L0 224l64 32 0 96c0 88.4 71.6 160 160 160l240 0c97.2 0 176-78.8 176-176c0-49-20.2-93.2-52.7-125.2c-20.8-20.5-46.7-35.8-75.6-44.1c-15.5-4.4-31.8-6.8-48.6-6.8c-50.9 0-100.7 17.5-140.2 49.6L128 368l0-112 64-32 0-128L96 144 0 96zM520 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M587.3 210.8c-20.8-20.5-46.7-35.8-75.6-44.1L640 0 587.3 210.8zM496 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faTableLayout = {
    prefix: 'fasds',
    iconName: 'table-layout',
    icon: [
      512,
      512,
      [],
      'e290',
      
      ['M64 160l384 0 0 64-256 0 0 192-64 0 0-192-64 0 0-64z','M512 32L0 32 0 480l512 0 0-448zM448 96l0 320L64 416 64 96l384 0z']
      
    ]
  };

  

  
  

  var faChildReaching = {
    prefix: 'fasds',
    iconName: 'child-reaching',
    icon: [
      384,
      512,
      [],
      'e59d',
      
      ['M128 64a64 64 0 1 0 128 0A64 64 0 1 0 128 64z','M143 176l1 0 96 0 2.3 0 68.9-84.3L331.5 67 381 107.5l-20.3 24.8-78.5 96L272.7 240l-.7 0 0 240 0 32-64 0 0-32 0-96-32 0 0 96 0 32-64 0 0-32 0-241.2-8.6-10.3-80-96L2.9 107.9l49.2-41L72.6 91.5 143 176z']
      
    ]
  };

  

  
  

  var faCalendarXmark = {
    prefix: 'fasds',
    iconName: 'calendar-xmark',
    icon: [
      448,
      512,
      ["calendar-times"],
      'f273',
      
      ['M0 192L0 512l448 0 0-320L0 192zm126.1 96L160 254.1l17 17 47 47 47-47 17-17L321.9 288l-17 17-47 47 47 47 17 17L288 449.9l-17-17-47-47-47 47-17 17L126.1 416l17-17 47-47-47-47-17-17z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zM305 305l17-17L288 254.1l-17 17-47 47-47-47-17-17L126.1 288l17 17 47 47-47 47-17 17L160 449.9l17-17 47-47 47 47 17 17L321.9 416l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faCalendarTimes = faCalendarXmark;
  

  
  

  var faComputerMouseScrollwheel = {
    prefix: 'fasds',
    iconName: 'computer-mouse-scrollwheel',
    icon: [
      384,
      512,
      ["mouse-alt"],
      'f8cd',
      
      ['M0 0L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160L384 0 0 0zM160 96l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32z','M224 96l0 32 0 32 0 32-64 0 0-32 0-32 0-32 64 0z']
      
    ]
  };

  
    var faMouseAlt = faComputerMouseScrollwheel;
  

  
  

  var faPhone = {
    prefix: 'fasds',
    iconName: 'phone',
    icon: [
      512,
      512,
      [128222,128379],
      'f095',
      
      ['M68.9 18.1c.3 2.2 .6 4.4 .9 6.6c.3 2.2 .6 4.4 1 6.6c.7 4.4 1.4 8.7 2.2 13.1c1.6 8.7 3.4 17.3 5.5 25.8c4.1 17 9 33.7 14.8 50c11.6 32.5 26.5 63.5 44.4 92.5l25-20.5c-32.4-53.7-54.1-114.6-62.2-179.7c-10.5 1.9-21 3.8-31.5 5.7zM299.4 374.4c58 35.7 123.9 59.7 194.5 68.7l5.7-31.5c-65.1-8.1-126-29.8-179.7-62.2l-20.5 25z','M68.9 18.1l-36 6.5L0 30.6 0 64C0 311.4 200.6 512 448 512l33.4 0 6-32.8 6.6-36C272.6 414.8 97.2 239.4 68.9 18.1zM499.6 411.6l3.7-20.4 5.6-30.7-28.4-12.9-88-40-28-12.7L345 318.7l-25.1 30.7c53.7 32.4 114.6 54.1 179.7 62.2zm-337-219.5L193.3 167l23.8-19.5-12.7-28-40-88L151.5 3.1 120.8 8.7l-20.5 3.7c8.1 65.1 29.8 126 62.2 179.7z']
      
    ]
  };

  

  
  

  var faFaceGrinTears = {
    prefix: 'fasds',
    iconName: 'face-grin-tears',
    icon: [
      640,
      512,
      [128514,"grin-tears"],
      'f588',
      
      ['M66.3 221.5c13.5-2.4 25.8-4.1 33.2-5.1l42.1-5.8-5.9 42c-1.5 10.5-4.4 30.9-8.8 50.6c-2.2 9.8-5 20.3-8.4 29.6c-3 8.2-8 20-16.6 28.7c-3.4 3.4-7.1 6.5-10.9 9.1C133 454.4 219.8 512 320 512s187-57.6 229-141.5c-3.8-2.6-7.5-5.7-10.9-9.1c-8.7-8.7-13.7-20.5-16.6-28.7c-3.4-9.3-6.2-19.8-8.4-29.6c-4.4-19.7-7.4-40.1-8.8-50.6l-5.9-42 42 5.8c7.5 1 19.8 2.7 33.3 5.2C556.8 96.4 449.7 0 320 0S83.2 96.4 66.3 221.5zM160 302.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C464.3 376.7 398.7 432 320.3 432s-144-55.3-160.2-129.2zM184 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M240 152c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zM104 248c-3 21-11.1 77-24.8 90.8c-17.9 17.9-47.1 17.6-65.3-.7s-18.6-47.6-.7-65.6C26.9 258.7 83 250.9 104 248zm432 0c21 2.9 77.1 10.7 90.8 24.5c17.9 18 17.5 47.3-.7 65.6s-47.4 18.6-65.3 .7C547.1 325 539 269 536 248zM344 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z']
      
    ]
  };

  
    var faGrinTears = faFaceGrinTears;
  

  
  

  var faSpinnerThird = {
    prefix: 'fasds',
    iconName: 'spinner-third',
    icon: [
      512,
      512,
      [],
      'f3f4',
      
      ['M0 256C0 397.4 114.6 512 256 512c94.7 0 177.5-51.5 221.7-128l-55.4-32c-33.2 57.4-95.2 96-166.3 96C150 448 64 362 64 256S150 64 256 64l0-64C114.6 0 0 114.6 0 256z','M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0l0 64c106 0 192 86 192 192c0 35-9.4 67.8-25.7 96l55.4 32z']
      
    ]
  };

  

  
  

  var faLungsVirus = {
    prefix: 'fasds',
    iconName: 'lungs-virus',
    icon: [
      640,
      512,
      [],
      'e067',
      
      ['M.2 412c-.2 1.3-.2 2.6-.2 4l0 7c0 49.1 39.8 89 89 89c7.3 0 14.5-.9 21.6-2.7l119.9-30-68.9-68.9 32.7-32.7c3.6-3.6 1.1-9.8-4.1-9.8L144 368l0-96 46.2 0c5.1 0 7.7-6.2 4.1-9.8l-32.7-32.7 67.9-67.9L256 188.1l0-60.1 0-32-32 0-56 0-16 0c-3.2 4.3-6.4 8.5-9.6 12.8l-.4 .6-1.1 1.5c-1 1.3-2.3 3.2-4.1 5.6c-3.5 4.8-8.4 11.8-14.3 20.6c-11.8 17.5-27.8 42.2-44.3 71.1C45.8 264.9 9.1 341.4 .2 412zM288 0l0 32 0 32 0 80 64 0 0-80 0-32 0-32L288 0zm96 96l0 32 0 60.1 26.5-26.5 67.9 67.9-32.7 32.7c-3.6 3.6-1.1 9.8 4.1 9.8l46.2 0 0 96-46.2 0c-5.1 0-7.7 6.2-4.1 9.8l32.7 32.7-68.9 68.9 119.9 30c7.1 1.8 14.3 2.7 21.6 2.7c49.1 0 89-39.8 89-89l0-7c0-1.3-.1-2.7-.2-4c-8.8-70.6-45.5-147.2-78-203.9c-16.5-28.9-32.4-53.6-44.3-71.1c-5.9-8.8-10.8-15.7-14.3-20.6c-1.7-2.4-3.1-4.3-4.1-5.6l-1.1-1.5-.4-.5c-3.3-4.4-6.5-8.6-9.7-12.9l-16 0-56 0-32 0z','M421.8 218.2l-11.3-11.3-11.3 11.3C375.9 241.5 336 225 336 192l0-16-16 0-16 0 0 16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-11.3 11.3s0 0 0 0l-11.3 11.3 11.3 11.3C241.5 264.1 225 304 192 304l-16 0 0 16 0 16 16 0c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3s0 0 0 0l11.3 11.3 11.3-11.3C264.1 398.5 304 415 304 448l0 16 16 0 16 0 0-16c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C398.5 375.9 415 336 448 336l16 0 0-16 0-16-16 0c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3zM272 296a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 40a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faUsersBetweenLines = {
    prefix: 'fasds',
    iconName: 'users-between-lines',
    icon: [
      640,
      512,
      [],
      'e591',
      
      ['M32 352l135.4 0 28.2-75.2 7.8-20.8L64 256 32 352zM83.2 160a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm94.4 256l288 0-24-64-24-64-12.3 0-170.7 0-9.1 0-24 64-24 64zm64-240a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm193.6-16a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm4.6 96l7.8 20.8L475.8 352 608 352l-32-96-136.2 0z','M24 0L0 0 0 48l24 0 592 0 24 0 0-48L616 0 24 0zm0 464L0 464l0 48 24 0 592 0 24 0 0-48-24 0L24 464z']
      
    ]
  };

  

  
  

  var faChildDress = {
    prefix: 'fasds',
    iconName: 'child-dress',
    icon: [
      320,
      512,
      [],
      'e59c',
      
      ['M96 64a64 64 0 1 0 128 0A64 64 0 1 0 96 64z','M116.9 160l-16 0-9.6 12.8-72.1 96L0 294.4l51.2 38.4 19.2-25.6 15.4-20.4L48 400l40 0 0 80 0 32 64 0 0-32 0-80 16 0 0 80 0 32 64 0 0-32 0-80 40 0L234.3 286.8l15.3 20.4 19.2 25.6L320 294.4l-19.2-25.6-72.1-96L219.1 160l-16 0-86.2 0z']
      
    ]
  };

  

  
  

  var faCardClub = {
    prefix: 'fasds',
    iconName: 'card-club',
    icon: [
      384,
      512,
      [],
      'e3e9',
      
      ['M0 0L0 512l384 0L384 0 0 0zM80 264c0-28.9 21.9-52.7 50.1-55.7c-1.4-5.2-2.1-10.7-2.1-16.3c0-35.3 28.7-64 64-64s64 28.7 64 64c0 5.6-.7 11.1-2.1 16.3c28.2 2.9 50.1 26.8 50.1 55.7c0 30.9-25.1 56-56 56c-15.7 0-29.8-6.4-40-16.8l0 32.8 16 0 16 0 0 32-16 0-16 0-32 0-16 0-16 0 0-32 16 0 16 0 0-32.8c-10.2 10.4-24.3 16.8-40 16.8c-30.9 0-56-25.1-56-56z','M253.9 208.3c1.4-5.2 2.1-10.7 2.1-16.3c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.6 .7 11.1 2.1 16.3C101.9 211.3 80 235.1 80 264c0 30.9 25.1 56 56 56c15.7 0 29.8-6.4 40-16.8l0 32.8-16 0-16 0 0 32 16 0 16 0 32 0 16 0 16 0 0-32-16 0-16 0 0-32.8c10.2 10.4 24.3 16.8 40 16.8c30.9 0 56-25.1 56-56c0-28.9-21.9-52.7-50.1-55.7z']
      
    ]
  };

  

  
  

  var faRulerTriangle = {
    prefix: 'fasds',
    iconName: 'ruler-triangle',
    icon: [
      512,
      512,
      [128208],
      'f61c',
      
      ['M0 0L48 0c20.2 20.2 40.5 40.5 60.7 60.7c-8 8-16 16-24 24c-3.8 3.8-7.5 7.5-11.3 11.3c7.5 7.5 15.1 15.1 22.6 22.6c3.8-3.8 7.5-7.5 11.3-11.3c8-8 16-16 24-24c19.1 19.1 38.2 38.2 57.4 57.4c-8 8-16 16-24 24c-3.8 3.8-7.5 7.5-11.3 11.3c7.5 7.5 15.1 15.1 22.6 22.6c3.8-3.8 7.5-7.5 11.3-11.3c8-8 16-16 24-24c19.1 19.1 38.2 38.2 57.4 57.4c-8 8-16 16-24 24c-3.8 3.8-7.5 7.5-11.3 11.3c7.5 7.5 15.1 15.1 22.6 22.6c3.8-3.8 7.5-7.5 11.3-11.3c8-8 16-16 24-24c19.1 19.1 38.2 38.2 57.4 57.4c-8 8-16 16-24 24c-3.8 3.8-7.5 7.5-11.3 11.3L336 358.6l11.3-11.3 24-24 57.4 57.4c-8 8-16 16-24 24c-3.8 3.8-7.5 7.5-11.3 11.3L416 438.6l11.3-11.3 24-24L512 464l0 48L0 512 0 0zM128 256l0 128 128 0L128 256z','M108.7 60.7l-24 24L73.4 96 96 118.6l11.3-11.3 24-24L108.7 60.7zm80 80l-24 24L153.4 176 176 198.6l11.3-11.3 24-24-22.6-22.6zm80 80l-24 24L233.4 256 256 278.6l11.3-11.3 24-24-22.6-22.6zm80 80l-24 24L313.4 336 336 358.6l11.3-11.3 24-24-22.6-22.6zm80 80l-24 24L393.4 416 416 438.6l11.3-11.3 24-24-22.6-22.6z']
      
    ]
  };

  

  
  

  var faHousePersonLeave = {
    prefix: 'fasds',
    iconName: 'house-person-leave',
    icon: [
      640,
      512,
      ["house-leave","house-person-depart"],
      'e00f',
      
      ['M0 216l0 48 64 0 0 160 253.5 0 44-44L384 323.7l3.9-9.7-9.7-3.2-60.7-20.2L287 280.5l10.1-30.4 30.6-91.7 4.5-13.4 12.9-5.7 30.6-13.6L240 8 0 216zm144-24l96 0 0 96-96 0 0-96z','M576 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM462.3 128.6l-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48-10.1 30.4 60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16zM388.7 398l-43.4 43.4L322.7 464 368 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6l-25 62.4z']
      
    ]
  };

  
    var faHouseLeave = faHousePersonLeave;
  
    var faHousePersonDepart = faHousePersonLeave;
  

  
  

  var faLeftFromBracket = {
    prefix: 'fasds',
    iconName: 'left-from-bracket',
    icon: [
      512,
      512,
      [],
      'e66c',
      
      ['M320 32l0 64 32 0 96 0 0 320-96 0-32 0 0 64 32 0 128 0 32 0 0-32 0-384 0-32-32 0L352 32l-32 0z','M0 256L160 416l32 0 0-96 160 0 0-128-160 0 0-96-32 0L0 256z']
      
    ]
  };

  

  
  

  var faMarsDouble = {
    prefix: 'fasds',
    iconName: 'mars-double',
    icon: [
      640,
      512,
      [9891],
      'f227',
      
      ['M256 304A80 80 0 1 1 96 304a80 80 0 1 1 160 0zm48 164c18.9-14.8 35.2-32.8 48.1-53.1c5.2 .7 10.6 1.1 16 1.1c61.9 0 112-50.1 112-112c0-35.7-16.7-67.5-42.7-88L480 173.3l0-26.5 41.4-41.4L480 64l32-32 128 0 0 128-32 32-41.4-41.4L513 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-22.6 0-44.2-4.3-64-12z','M320 32l128 0 0 128-32 32-41.4-41.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l53.6-53.6L288 64l32-32zM288 304A112 112 0 1 0 64 304a112 112 0 1 0 224 0zm95.9 0c0-28.3-5.7-55.4-15.9-80c44.2 0 79.9 35.8 79.9 80s-35.8 80-79.9 80c10.3-24.6 15.9-51.7 15.9-80z']
      
    ]
  };

  

  
  

  var faLocationCrosshairs = {
    prefix: 'fasds',
    iconName: 'location-crosshairs',
    icon: [
      512,
      512,
      ["location"],
      'f601',
      
      ['M176 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M288 0l0 32 0 34.7C368.4 80.1 431.9 143.6 445.3 224l34.7 0 32 0 0 64-32 0-34.7 0C431.9 368.4 368.4 431.9 288 445.3l0 34.7 0 32-64 0 0-32 0-34.7C143.6 431.9 80.1 368.4 66.7 288L32 288 0 288l0-64 32 0 34.7 0C80.1 143.6 143.6 80.1 224 66.7L224 32l0-32 64 0zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0z']
      
    ]
  };

  
    var faLocation = faLocationCrosshairs;
  

  
  

  var faChessQueenPiece = {
    prefix: 'fasds',
    iconName: 'chess-queen-piece',
    icon: [
      256,
      512,
      ["chess-queen-alt"],
      'f446',
      
      ['M0 480l0 32 256 0 0-32-48-64L48 416 0 480z','M104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM48 192l18.5 0L16 92 37 78l4.6 4.6c6 6 14.5 10.3 22.3 7.1C75 85.2 79 74.6 79 64l28 0s0 21 21 21s21-21 21-21l28 0c0 10.6 4 21.2 15 25.7c7.8 3.2 16.3-1.1 22.3-7.1L219 78l21 14L189.5 192l18.5 0 0 48-23 0 23 176L48 416 71 240l-23 0 0-48z']
      
    ]
  };

  
    var faChessQueenAlt = faChessQueenPiece;
  

  
  

  var faBiohazard = {
    prefix: 'fasds',
    iconName: 'biohazard',
    icon: [
      576,
      512,
      [9763],
      'f780',
      
      ['M80 272c0 83.5 49.2 155.6 120.3 188.7c13-17.2 21.6-37.5 23.6-59.7C176.5 377.4 144 328.5 144 272c0-1.1 0-2.1 0-3.2c-20.4-8.9-42.3-11.8-63.6-9.7c-.3 4.3-.4 8.6-.4 12.9zm11.4-68.1c14.7-5.8 29.9-9.5 45.2-11c-.9-1.8-1.7-3.6-2.5-5.5s-1.6-3.7-2.3-5.6c-1.5-3.7-2.8-7.6-4.1-11.4c-2.4-7.7-4.3-15.7-5.6-23.9c-13.1 17.2-23.5 36.6-30.7 57.4zm78.7-103.3c8.1 19.9 21 37.7 38.8 51c22.7-14.9 49.8-23.6 79-23.6s56.3 8.7 79 23.6c17.8-13.3 30.7-31.1 38.4-51.3C372 77.4 331.6 64 288 64c-43.8 0-84.4 13.5-117.9 36.6zm86.7 377.1c10.2 1.5 20.6 2.3 31.2 2.3s21-.8 31.2-2.3c-12-9.1-22.4-19.6-31.2-31.1c-1.1 1.4-2.2 2.9-3.3 4.3s-2.3 2.8-3.5 4.2c-2.4 2.7-4.9 5.4-7.5 8c-5.2 5.2-10.8 10.1-16.8 14.7zM352.1 401c2 22.2 10.6 42.5 23.6 59.7C446.8 427.6 496 355.5 496 272c0-4.3-.1-8.6-.4-12.9c-21.4-2.1-43.3 .8-63.6 9.7c0 1.1 0 2.1 0 3.2c0 56.5-32.5 105.4-79.9 129zm87.3-208.1c1.9 .2 3.8 .4 5.7 .7s3.8 .6 5.7 .9c3.8 .7 7.6 1.4 11.4 2.4c7.6 1.8 15 4.2 22.4 7.1c-7.2-20.8-17.6-40.1-30.7-57.4c-2.6 16.3-7.6 31.9-14.5 46.3z','M120 120c0-45.4 18-86.6 47.2-116.8C142.1 77.9 182.4 176 288 176S433.9 77.9 408.8 3.2C438 33.4 456 74.6 456 120c0 26.1-6 50.8-16.6 72.9c22.4 2.3 44.6 9 65.3 20.6c33.7 18.8 58 47.3 71.3 79.7c-57.1-48-153.9-53.7-204.4 30.8s2.9 162.6 74.6 186.3c-35.7 5.1-73.5-.9-107.2-19.7c-20.6-11.5-37.7-26.6-50.9-44c-13.2 17.4-30.3 32.6-50.9 44c-33.7 18.8-71.5 24.8-107.2 19.7C201.5 486.6 255 408.6 204.4 324S57.1 245.2 0 293.2c13.3-32.4 37.6-60.9 71.3-79.7c20.7-11.5 43-18.3 65.3-20.6C126 170.8 120 146.1 120 120zM288 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96z']
      
    ]
  };

  

  
  

  var faWebAwesome = {
    prefix: 'fasds',
    iconName: 'web-awesome',
    icon: [
      640,
      512,
      [],
      'e682',
      
      ['M46.4 192L176 480l288 0L593.6 192c-.5 0-1.1 0-1.6 0c-1 0-2.1 0-3.1-.1s-2-.2-3-.3c-2-.3-3.9-.6-5.8-1.1c-3.8-1-7.4-2.4-10.8-4.2c-6.8-3.6-12.6-8.9-16.9-15.2L448 192 342 99.2c-6.6 3.1-14 4.8-21.8 4.8c-1 0-2 0-2.9-.1s-1.9-.1-2.9-.2c-1.9-.2-3.8-.5-5.6-.9c-3.7-.8-7.2-2-10.6-3.6L192 192 87.6 171.1C79 183.7 64.4 192 48 192c-.5 0-1.1 0-1.6 0z','M268.2 52a52 52 0 1 1 104 0 52 52 0 1 1 -104 0zM0 144a48 48 0 1 1 96 0A48 48 0 1 1 0 144zM592 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faBalloon = {
    prefix: 'fasds',
    iconName: 'balloon',
    icon: [
      384,
      512,
      [],
      'e2e3',
      
      ['M64 192l32 0c0-53 43-96 96-96l0-32C121.3 64 64 121.3 64 192z','M0 192C0 86 86 0 192 0S384 86 384 192c0 128-160 240-160 240l32 80-128 0 32-80S0 320 0 192zm96 0c0-53 43-96 96-96l0-32C121.3 64 64 121.3 64 192l32 0z']
      
    ]
  };

  

  
  

  var faSensorOn = {
    prefix: 'fasds',
    iconName: 'sensor-on',
    icon: [
      640,
      512,
      [],
      'e02b',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 96c16 0 32 0 48 0l0 24 0 144 0 24c-16 0-32 0-48 0l0-24 0-144 0-24zm80 0c16 0 32 0 48 0l0 24 0 144 0 24c-16 0-32 0-48 0l0-24 0-144 0-24zm80 0c16 0 32 0 48 0l0 24 0 144 0 24c-16 0-32 0-48 0l0-24 0-144 0-24z','M597.3 108l20-13.3L590.7 54.7 570.7 68l-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM536 232l-24 0 0 48 24 0 80 0 24 0 0-48-24 0-80 0zm13.3 140l-20-13.3-26.6 39.9 20 13.3 48 32 20 13.3 26.6-39.9-20-13.3-48-32zM112 120l0-24L64 96l0 24 0 144 0 24 48 0 0-24 0-144zm80 0l0-24-48 0 0 24 0 144 0 24 48 0 0-24 0-144zm80 0l0-24-48 0 0 24 0 144 0 24 48 0 0-24 0-144z']
      
    ]
  };

  

  
  

  var faMessagesDollar = {
    prefix: 'fasds',
    iconName: 'messages-dollar',
    icon: [
      640,
      512,
      ["comments-alt-dollar"],
      'f652',
      
      ['M0 0L416 0l0 320-213.3 0L96 384l0-64L0 320 0 0zM134.7 232.7l19 6.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3 0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38z','M228 64l0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2s0 0 0 0s0 0 0 0s0 0 0 0c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c0 0 0 0 0 0c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3 12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.1c0 0 0 0 0 0c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20zm28 384l0-96 192 0 0-224 192 0 0 320-96 0 0 64L437.3 448 256 448z']
      
    ]
  };

  
    var faCommentsAltDollar = faMessagesDollar;
  

  
  

  var faArrowRotateRight = {
    prefix: 'fasds',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      ['M32 256c0 57.3 21.9 114.7 65.6 158.4S198.7 480 256 480s114.7-21.9 158.4-65.6l-45.3-45.3c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160l45.7 0 0-44.8L414.4 97.6C370.6 53.9 313.3 32 256 32S141.3 53.9 97.6 97.6S32 198.7 32 256z','M496 224l-32 0-128 0-32 0 0-64 32 0 96 0 0-96 0-32 64 0 0 32 0 128 0 32z']
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faUserMusic = {
    prefix: 'fasds',
    iconName: 'user-music',
    icon: [
      640,
      512,
      [],
      'f8eb',
      
      ['M0 512l307.1 0c-11.3-12.6-19.1-29-19.1-48.2c0-25.6 13.9-46.3 31.5-59.5c13.7-10.2 30.5-16.9 48.5-19.4l0-80.9L64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M640 185.3l0-33.3-31.6 10.5-192 64L400 232l0 17.3 0 48 0 120.3c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48c32.5 0 59.3-18.1 63.4-41.6c.4-1.7 .6-3.4 .6-5.2l0-1.2 0-149.5 144-48 0 87c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.3-.1-2.5-.2-3.7c.1-1 .2-2 .2-3l0-160 0-48z']
      
    ]
  };

  

  
  

  var faFacePensive = {
    prefix: 'fasds',
    iconName: 'face-pensive',
    icon: [
      512,
      512,
      [],
      'e384',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm72.8-62.3c7.6-3.8 15.2-7.6 22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18 25 20c-4.8 6-9.6 12-14.4 18c-13 16.3-29.4 29.5-48 38.8L87.2 222.3 72.8 193.7zm18.4 91.9l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-17.2 22.9-43 34.4-68.8 34.4s-51.6-11.5-68.8-34.4zM192 384l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm91.2-98.4l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-17.2 22.9-43 34.4-68.8 34.4s-51.6-11.5-68.8-34.4zM339.5 154c8.3-6.7 16.7-13.3 25-20l14.4 18c10.1 12.7 22.9 23 37.4 30.2c7.6 3.8 15.2 7.6 22.9 11.4l-14.3 28.6L402 210.9c-18.6-9.3-35-22.6-48.1-38.8c-4.8-6-9.6-12-14.4-18z','M95.7 182.3L72.8 193.7l14.3 28.6L110 210.9c18.6-9.3 35-22.6 48-38.8l14.4-18-25-20-14.4 18c-10.1 12.7-22.9 23-37.4 30.2zm213.1 84.1l-25.6 19.2c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2c-21.6 28.8-64.8 28.8-86.4 0zm-105.6 0c-21.6 28.8-64.8 28.8-86.4 0L91.2 285.6c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2zm213.1-84.1c-14.5-7.2-27.2-17.6-37.4-30.2l-14.4-18-25 20 14.4 18c13 16.3 29.4 29.5 48.1 38.8l22.9 11.4 14.3-28.6-22.9-11.4z']
      
    ]
  };

  

  
  

  var faHandsPraying = {
    prefix: 'fasds',
    iconName: 'hands-praying',
    icon: [
      640,
      512,
      ["praying-hands"],
      'f684',
      
      ['M336 208l0 112 0 112 256 80 48 0 0-144L528 326l0-102 0-9.4-5-7.9L395 6.8l-55 32.6L432 208.2 432 320l-32 0 0-112-64 0z','M245 6.8l-128 200-5 7.9 0 9.4 0 102L0 368 0 512l48 0 256-80 0-112 0-112-64 0 0 112-32 0 0-111.8L300.1 39.3 245 6.8z']
      
    ]
  };

  
    var faPrayingHands = faHandsPraying;
  

  
  

  var faHandScissors = {
    prefix: 'fasds',
    iconName: 'hand-scissors',
    icon: [
      512,
      512,
      [],
      'f257',
      
      ['M40 208L0 208l0 80 40 0 168 0 0 80 32 0 0 80 80 0 48 0 16 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L288 64l0 32.3 76.9 24.5 15.2 4.9-9.7 30.5-15.2-4.9L288 129.9c0 0 0 .1 0 .1L108 73.4l-38.2-12-24 76.3 38.2 12L269.5 208 40 208z','']
      
    ]
  };

  

  
  

  var faDrumSteelpan = {
    prefix: 'fasds',
    iconName: 'drum-steelpan',
    icon: [
      576,
      512,
      [],
      'f56a',
      
      ['M48 160c0 9.9 8 29.9 55 49.8c22.2 9.4 49.7 17 81 22.2l38-55.9L164.8 91.7c-23.4 4.9-44.2 11.2-61.7 18.6C56 130.1 48 150.1 48 160zM225.5 82.8L249.9 160l76.2 0 24.4-77.2C330.7 81 309.8 80 288 80s-42.7 1-62.5 2.8zm9.9 155.3c16.9 1.3 34.5 1.9 52.7 1.9s35.8-.7 52.7-1.9L326.1 192l-76.2 0-14.6 46.1zM353.9 176l38.1 55.9c31.4-5.2 58.8-12.8 81-22.2c47.1-19.9 55-39.9 55-49.8s-8-29.9-55-49.8c-17.5-7.4-38.3-13.7-61.7-18.6L353.9 176z','M473 209.8c-22.2 9.4-49.7 17-81 22.2L353.9 176l57.4-84.3c23.4 4.9 44.2 11.2 61.7 18.6c47.1 19.9 55 39.9 55 49.8s-8 29.9-55 49.8zM340.7 238.1c-16.9 1.3-34.5 1.9-52.7 1.9s-35.8-.7-52.7-1.9L249.9 192l76.2 0 14.6 46.1zm-156.6-6.1c-31.4-5.2-58.8-12.8-81-22.2C56 189.9 48 169.9 48 160s8-29.9 55-49.8c17.5-7.4 38.3-13.7 61.7-18.6L222.1 176l-38 55.9zM225.5 82.8C245.3 81 266.2 80 288 80s42.7 1 62.5 2.8L326.1 160l-76.2 0L225.5 82.8zM576 160C576 80 447.1 32 288 32S0 80 0 160L0 352c0 80 128.9 128 288 128s288-48 288-128l0-192z']
      
    ]
  };

  

  
  

  var faHandPointer = {
    prefix: 'fasds',
    iconName: 'hand-pointer',
    icon: [
      448,
      512,
      [],
      'f25a',
      
      ['M.1 325.4l24 32L80 432c33.7 45 84.6 73.4 140 79c4.8 .7 9.7 1 14.7 1l5.2 0 64.1 0 16 0c70.7 0 128-57.3 128-128l0-16 0-48 0-80-80 0 0-32-80 0 0-32-80 0L208 0 128 0l0 362.7L88.1 309.4l-24-32-64 48zM208 288l32 0c0 5.3 0 10.7 0 16c0 32 0 64 0 96c0 5.3 0 10.7 0 16l-32 0c0-5.3 0-10.7 0-16c0-32 0-64 0-96c0-5.3 0-10.7 0-16zm64 0l32 0c0 5.3 0 10.7 0 16c0 32 0 64 0 96c0 5.3 0 10.7 0 16l-32 0c0-5.3 0-10.7 0-16c0-32 0-64 0-96c0-5.3 0-10.7 0-16zm64 0l32 0 0 16 0 96 0 16-32 0 0-16 0-96 0-16z','M240 288l0 16 0 96 0 16-32 0 0-16 0-96 0-16 32 0zm64 0l0 16 0 96 0 16-32 0 0-16 0-96 0-16 32 0zm64 16l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16z']
      
    ]
  };

  

  
  

  var faBacterium = {
    prefix: 'fasds',
    iconName: 'bacterium',
    icon: [
      512,
      512,
      [],
      'e05a',
      
      ['M-5.7 383.5L7.5 429.7l23.1-6.6 13.8-3.9C54.7 439.3 71 456 91.1 466.8l-1.9 5.6-7.6 22.8 45.5 15.2 7.6-22.8 2.6-7.8c24.5 1.5 47.7-5.1 67-17.5L215 473l17 17L265.9 456l-17-17-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4 22.1 9.5 18.9-44.1-22.1-9.5-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5 6.6 23.1 46.2-13.2-6.6-23.1L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249l17 17L489.9 232l-17-17-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2 23.1-6.6L504.5 82.3l-23.1 6.6-13.7 3.9c-10.5-20.6-27-37-46.8-47.6l1.9-5.7 7.6-22.8L384.8 1.6l-7.6 22.8-2.6 7.8c-10.4-.6-21.1 .2-31.8 2.7c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7L292.6 8.5 248.5 27.4l9.5 22.1 4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7l-13.3-20L142.7 89.3l13.3 20 7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3l-18.7-15-30 37.5 18.7 15 15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9-22.3-8.9L8.8 293.4l22.3 8.9 11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .5c-.5 5.1-.6 10-.4 14.9l-14.7 4.2-23.1 6.6zm117.9-68.5c.2-1.6 .4-3.2 .7-4.7c.6-3.1 1.6-6.1 2.8-9c2.4-5.7 5.9-10.9 10.3-15.3c8.7-8.7 20.7-14.1 33.9-14.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-13.3 0-25.3-5.4-33.9-14.1c-4.3-4.3-7.9-9.5-10.3-15.3c-1.2-2.9-2.2-5.9-2.8-9c-.3-1.6-.6-3.2-.7-4.8c-.1-.8-.1-1.6-.2-2.4s-.1-1.5-.1-2l0-.5 0-.5c0-.5 0-1.2 .1-2c0-.8 .1-1.6 .2-2.4zM264 208a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M160 272a48 48 0 1 0 0 96 48 48 0 1 0 0-96z']
      
    ]
  };

  

  
  

  var faGridDividers = {
    prefix: 'fasds',
    iconName: 'grid-dividers',
    icon: [
      512,
      512,
      [],
      'e3ad',
      
      ['M32 96l0 128 128 0 0-128L32 96zm0 288l0 128 128 0 0-128L32 384zM192 96l0 128 128 0 0-128L192 96zm0 288l0 128 128 0 0-128-128 0zM352 96l0 128 128 0 0-128L352 96zm0 288l0 128 128 0 0-128-128 0z','M512 0L0 0 0 48l512 0 0-48zm0 288L0 288l0 48 512 0 0-48z']
      
    ]
  };

  

  
  

  var faHandHoldingDollar = {
    prefix: 'fasds',
    iconName: 'hand-holding-dollar',
    icon: [
      576,
      512,
      ["hand-holding-usd"],
      'f4c0',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M312 8l0 24 0 2.9c6.4 1.2 14.3 2.8 18.2 3.9L353.4 45 341 91.4l-23.2-6.2c-3.7-1-17-3.6-21.3-4.3c-11.6-1.8-20.8-.3-26.4 2.3c-5.5 2.5-5.9 4.8-5.9 5.1c0 0 0 0 0 0c-.3 1.5-.2 2.3-.2 2.7c.2 .2 .7 .9 2.2 1.9c5.5 3.7 14.4 6.6 28.8 10.9l1 .3c12 3.6 28.7 8.7 41.4 17.9c7.1 5.2 14 12.3 18.2 22.1c4.3 9.9 5.1 20.7 3.2 31.7c-3.6 20.6-17.3 34.5-34 41.7c-4.2 1.8-8.5 3.2-13 4.2l0 2.2 0 24-48 0 0-24 0-3.2c-9.3-2.4-20.3-6.1-27.3-8.5c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.1-1.1-4.2-1.4l-22.8-7.6 15.2-45.5 22.8 7.6c2.1 .7 4.3 1.5 6.6 2.2c9.5 3.2 19.7 6.7 25.4 7.6c12.3 1.9 21.4 .6 26.6-1.6c4.4-1.9 5.3-3.8 5.6-5.8c.3-1.8 .3-2.9 .2-3.5c-.1-.6-.2-.8-.2-.9c0 0 0 0 0 0c0-.1-.4-.9-2.4-2.4c-5.2-3.8-14-6.8-28.1-11.1l-2.3-.7c-11.6-3.5-27.5-8.2-39.6-16.5c-7-4.8-14.1-11.5-18.7-21.1c-4.6-9.8-5.6-20.5-3.7-31.4c3.5-20 17.6-33.5 33.4-40.7c4.3-2 8.9-3.5 13.6-4.7l0-2.8 0-24 48 0zM264.1 91.2s0 0 0-.1c0 .1 0 .1 0 .1z']
      
    ]
  };

  
    var faHandHoldingUsd = faHandHoldingDollar;
  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fasds',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM224 128l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M288 128l0 64-64 0 0-64 64 0zm0 96l0 64-64 0 0-64 64 0zm0 160l-64 0 0-64 64 0 0 64z']
      
    ]
  };

  

  
  

  var faFaceGrinSquint = {
    prefix: 'fasds',
    iconName: 'face-grin-squint',
    icon: [
      512,
      512,
      [128518,"grin-squint"],
      'f585',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 46.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zM112 144l118.9 64L112 272l45.7-64L112 144zm169.1 64L400 144l-45.7 64L400 272 281.1 208z','M230.9 208L112 144l45.7 64L112 272l118.9-64zm50.3 0L400 272l-45.7-64L400 144 281.1 208z']
      
    ]
  };

  
    var faGrinSquint = faFaceGrinSquint;
  

  
  

  var faSquareLeft = {
    prefix: 'fasds',
    iconName: 'square-left',
    icon: [
      448,
      512,
      [11013,"arrow-alt-square-left"],
      'f351',
      
      ['M0 32l448 0 0 448L0 480 0 32zM64 256L192 384l32 0 0-80 128 0 0-96-128 0 0-80-32 0L64 256z','M224 208l0-80-32 0L64 256 192 384l32 0 0-80 128 0 0-96-128 0z']
      
    ]
  };

  
    var faArrowAltSquareLeft = faSquareLeft;
  

  
  

  var faDiamond = {
    prefix: 'fasds',
    iconName: 'diamond',
    icon: [
      512,
      512,
      [9830],
      'f219',
      
      ['M0 256L256 0 512 256 256 512 0 256z','']
      
    ]
  };

  

  
  

  var faUserNurseHairLong = {
    prefix: 'fasds',
    iconName: 'user-nurse-hair-long',
    icon: [
      448,
      512,
      [],
      'e45e',
      
      ['M128 160c0 53 43 96 96 96s96-43 96-96l0-16-8 0c-.2 0-.5 0-.7 0L288 144l-32-16-32 32-47.1 0c-.3 0-.6 0-.9 0l-48 0z','M48 288l0-32 48-48L96 48 224 0 352 48l0 160 48 48 0 32L48 288zM208 64l-24 0 0 32 24 0 0 24 32 0 0-24 24 0 0-32-24 0 0-24-32 0 0 24zm-31.1 96l-.9 0-48 0c0 53 43 96 96 96s96-43 96-96l0-16-8 0-.7 0L288 144l-32-16-32 32-47.1 0zM224 424l82.8-88 77.2 0 64 176L0 512 64 336l77.2 0L224 424z']
      
    ]
  };

  

  
  

  var faAlbumCirclePlus = {
    prefix: 'fasds',
    iconName: 'album-circle-plus',
    icon: [
      576,
      512,
      [],
      'e48c',
      
      ['M0 32L0 480l296.2 0c-16.2-19.7-28.3-42.9-34.8-68.4c-12 2.9-24.5 4.4-37.4 4.4c-88.4 0-160-71.6-160-160s71.6-160 160-160c69.3 0 128.3 44 150.5 105.6c18-6.2 37.4-9.6 57.5-9.6c5.4 0 10.7 .2 16 .7L448 32 0 32zM192 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faScarf = {
    prefix: 'fasds',
    iconName: 'scarf',
    icon: [
      512,
      512,
      [129507],
      'f7c1',
      
      ['M4.7 388.7l112-112 22.6 22.6-112 112L4.7 388.7zm48 48l112-112 22.6 22.6-112 112L52.7 436.7zm48 48l112-112 22.6 22.6-112 112-22.6-22.6zM288 406.6l11.3-11.3c3.8-3.8 7.5-7.5 11.3-11.3L411.3 484.7l-22.6 22.6c-33.6-33.6-67.1-67.1-100.7-100.7zm48-48l11.3-11.3L358.6 336 459.3 436.7l-22.6 22.6L336 358.6zm48-48c3.8-3.8 7.5-7.5 11.3-11.3s7.5-7.5 11.3-11.3c33.6 33.6 67.1 67.1 100.7 100.7l-22.6 22.6L384 310.6z','M175.3 0L184 0 328 0l8.7 0 4.7 7.3 72 112 2.5 4 0 4.7 0 80 0 6.6-4.7 4.7-14.1 14.1L278.6 114.7 297.4 96 256 96l-41.4 0L256 137.4 374.6 256l9.4 9.4 11.3 11.3L406.6 288l-11.3 11.3-48 48-48 48L288 406.6l-11.3-11.3-176-176L96 214.6l0-6.6 0-80 0-4.7 2.5-4 72-112L175.3 0z']
      
    ]
  };

  

  
  

  var faPlantWilt = {
    prefix: 'fasds',
    iconName: 'plant-wilt',
    icon: [
      512,
      512,
      [],
      'e5aa',
      
      ['M48 248l0 13c9.6-3.3 20.4-5 32-5c1.5 0 2.9 0 4.3 .1s2.8 .1 4.2 .2c2.8 .2 5.5 .5 8.2 .9c5.3 .8 10.4 2.1 15.2 3.7l0-13c0-30.9 25.1-56 56-56s56 25.1 56 56l0 32 0 200 0 32 64 0 0-32 0-200 0-32 0-128c0-30.9 25.1-56 56-56s56 25.1 56 56l0 13c9.6-3.3 20.4-5 32-5c1.5 0 2.9 0 4.3 .1s2.8 .1 4.2 .2c2.8 .2 5.5 .5 8.2 .9c5.3 .8 10.4 2.1 15.2 3.7l0-13C464 53.7 410.3 0 344 0S224 53.7 224 120l0 21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120z','M512 203.1c0 28.9-35.8 79.4-80 116.9c-44.2-37.5-80-87.6-80-116.9c0-47.3 32.9-75.1 80-75.1s80 27.8 80 75.1zm-352 128c0 28.9-35.8 79.4-80 116.9C35.8 410.5 0 360.4 0 331.1C0 283.8 32.9 256 80 256s80 27.8 80 75.1z']
      
    ]
  };

  

  
  

  var faCommentDots = {
    prefix: 'fasds',
    iconName: 'comment-dots',
    icon: [
      512,
      512,
      [62075,128172,"commenting"],
      'f4ad',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M96 240a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  
    var faCommenting = faCommentDots;
  

  
  

  var faCalendarArrowUp = {
    prefix: 'fasds',
    iconName: 'calendar-arrow-up',
    icon: [
      448,
      512,
      ["calendar-upload"],
      'e0d1',
      
      ['M0 192l448 0 0 320L0 512 0 192zM110.1 344L144 377.9l17-17 39-39L200 424l0 24 48 0 0-24 0-102.1 39 39 17 17L337.9 344l-17-17-80-80-17-17-17 17-80 80-17 17z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zm88 424l0-102.1 39 39 17 17L337.9 344l-17-17-80-80-17-17-17 17-80 80-17 17L144 377.9l17-17 39-39L200 424l0 24 48 0 0-24z']
      
    ]
  };

  
    var faCalendarUpload = faCalendarArrowUp;
  

  
  

  var faSortUp = {
    prefix: 'fasds',
    iconName: 'sort-up',
    icon: [
      320,
      512,
      ["sort-asc"],
      'f0de',
      
      ['M0 288l0 48 17.8 16L160 480 302.2 352 320 336l0-48-64 0L64 288 0 288zm113.4 64l93.1 0L160 393.9 113.4 352z','M0 176L160 32 320 176v48H0V176z']
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faSquareL = {
    prefix: 'fasds',
    iconName: 'square-l',
    icon: [
      448,
      512,
      [],
      'e275',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l48 0 0 24 0 184 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-208 0-24z','M176 128l0 24 0 184 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-208 0-24 48 0z']
      
    ]
  };

  

  
  

  var faTennisBall = {
    prefix: 'fasds',
    iconName: 'tennis-ball',
    icon: [
      512,
      512,
      [127934],
      'f45e',
      
      ['M.2 245.1c24.8 8.7 51.3 12.3 77.9 10.4c42.9-3.2 83.5-20.6 115.2-49.6s52.9-67.7 60-110.1c5.4-32.2 2.5-65.1-8.2-95.6c3.6-.2 7.2-.2 10.9-.2C397.4 0 512 114.6 512 256c0 3.7-.1 7.3-.2 10.9c-21.5-7.6-44.1-11.3-67-10.9c-27.5 .5-54.6 6.8-79.5 18.7s-46.9 28.9-64.5 50.1s-30.6 45.8-37.9 72.4s-8.8 54.4-4.4 81.6c1.8 11.3 4.7 22.4 8.4 33.1c-3.6 .2-7.2 .2-10.9 .2C114.6 512 0 397.4 0 256c0-3.6 .1-7.3 .2-10.9zm4.5-38.3C24.6 104.9 104.9 24.6 206.8 4.7c11.1 26.7 14.5 56.1 9.7 84.9c-5.7 34.1-22.8 65.4-48.4 88.7s-58.3 37.4-92.8 39.9C51.1 220 26.9 216 4.7 206.8zM295.4 472.7c-3.5-21.9-2.3-44.3 3.5-65.7s16.3-41.3 30.5-58.3s32-30.8 52-40.3s41.8-14.7 64-15.1c21.2-.4 42.3 3.7 61.9 11.8C487.4 407.1 407.1 487.4 305.2 507.3c-4.6-11.1-7.9-22.7-9.8-34.6z','M305.2 507.3c-12.5 2.4-25.3 3.9-38.3 4.5c-3.8-10.7-6.6-21.8-8.4-33.1c-4.4-27.2-2.9-55 4.4-81.6s20.2-51.2 37.9-72.4s39.7-38.2 64.5-50.1s52-18.2 79.5-18.7c22.8-.4 45.5 3.3 67 10.9c-.5 13-2.1 25.8-4.5 38.3c-19.6-8.1-40.6-12.1-61.9-11.8c-22.2 .4-44 5.5-64 15.1s-37.7 23.3-52 40.3s-24.6 36.9-30.5 58.3s-7.1 43.8-3.5 65.7c1.9 11.9 5.2 23.5 9.8 34.6zM245.1 .2c10.7 30.5 13.7 63.4 8.2 95.6c-7.1 42.4-28.3 81.2-60 110.1s-72.4 46.4-115.2 49.6c-26.6 2-53.1-1.7-77.9-10.4c.5-13 2.1-25.8 4.5-38.3C26.9 216 51.1 220 75.3 218.2c34.5-2.5 67.2-16.6 92.8-39.9s42.6-54.5 48.4-88.7c4.8-28.7 1.4-58.2-9.7-84.9c12.5-2.4 25.3-3.9 38.3-4.5z']
      
    ]
  };

  

  
  

  var faFaceTongueMoney = {
    prefix: 'fasds',
    iconName: 'face-tongue-money',
    icon: [
      512,
      512,
      [],
      'e39d',
      
      ['M0 256C0 364.6 67.7 457.5 163.1 494.6C151.1 476.8 144 455.2 144 432l0-13.7c-26-25.5-43.4-59.9-47.2-98.3l318.4 0c-3.8 38.4-21.2 72.7-47.2 98.3l0 13.7c0 23.2-7.1 44.8-19.1 62.6C444.3 457.5 512 364.6 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm120-27.7c3.2-10.2 6.3-20.4 9.5-30.6c5.1 1.6 10.2 3.2 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.4c0-.2 0-.4-.1-.6c-.1-.2-.2-.5-.4-.8c-.5-.6-1.4-1.4-3.2-2.5c-4.5-2.6-11-4.7-21.5-7.7l-.8-.2c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1c-1.1-17.9 9.5-29.3 20.6-35.2c5-2.7 10.4-4.5 15.6-5.6l0-7.5 0-16c10.7 0 21.3 0 32 0l0 16 0 7.3c5.3 .9 10.4 2 15.1 3.2c5.2 1.3 10.4 2.6 15.5 3.9c-2.6 10.4-5.1 20.7-7.7 31.1c-5.2-1.3-10.4-2.6-15.5-3.9c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.7 7.4c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.3 30.6c.5 17.3-9.2 28.7-20.5 34.9c-5 2.7-10.5 4.5-15.8 5.6l0 8.6 0 16c-10.7 0-21.3 0-32 0l0-16 0-9.2c-7.5-1.6-14.5-3.8-20.6-5.8c-1.6-.5-3.1-1-4.5-1.4c-5.1-1.6-10.2-3.2-15.3-4.8zm160 0c3.2-10.2 6.3-20.4 9.5-30.6c5.1 1.6 10.2 3.2 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.4c0-.6 0-1.7-3.6-3.8c-4.5-2.6-11-4.7-21.5-7.7l-.8-.2c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1c-1.1-17.9 9.5-29.3 20.6-35.2c5-2.7 10.4-4.5 15.6-5.6l0-7.5 0-16c10.7 0 21.3 0 32 0l0 16 0 7.3c5.3 .9 10.4 2 15.1 3.2c5.2 1.3 10.4 2.6 15.5 3.9c-2.6 10.4-5.1 20.7-7.7 31.1c-5.2-1.3-10.4-2.6-15.5-3.9c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.7 7.4c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.4 30.6c0 .4 0 .9 0 1.3c0 16.6-9.5 27.6-20.5 33.6c-5 2.7-10.5 4.5-15.8 5.6l0 8.6 0 16c-10.7 0-21.3 0-32 0l0-16 0-9.2c-7.5-1.6-14.5-3.8-20.6-5.8c-1.6-.5-3.1-1-4.5-1.4c-5.1-1.6-10.2-3.2-15.3-4.8z','M192.4 86.6l0 16 0 7.3c5.3 .9 10.4 2 15.1 3.2l15.5 3.9-7.7 31.1L199.8 144c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4c0 0 0 0 0 0c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.4 7.3l.2 .1s0 0 0 0c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.3 30.6c.5 17.3-9.2 28.8-20.5 34.9c-5 2.7-10.5 4.5-15.8 5.6l0 8.6 0 16-32 0 0-16 0-9.2c-7.5-1.6-14.5-3.8-20.6-5.8c0 0 0 0 0 0c-1.6-.5-3.1-1-4.5-1.4L120 228.3l9.5-30.6 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.3l0-.1c0-.6 0-1.7-3.6-3.8c-4.6-2.7-11.3-4.8-20.7-7.4l-1.6-.5s0 0 0 0s0 0 0 0s0 0 0 0c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1c-1.1-17.9 9.5-29.3 20.6-35.2c5-2.7 10.4-4.5 15.6-5.6l0-7.5 0-16 32 0zm160 0l0 16 0 7.3c5.3 .9 10.4 2 15.1 3.2l15.5 3.9-7.7 31.1L359.8 144c-8.4-2.1-16.4-3.6-23.7-3.7c-5.5-.1-12 1.1-16.3 3.5c-2 1.1-3 2.1-3.3 2.6c-.2 .3-.5 .9-.5 2.4c0 .3 0 .3 .1 .4c0 0 0 0 0 0c.3 .4 1.2 1.3 3.5 2.5c4.9 2.7 11.9 4.6 21.4 7.3l.2 .1s0 0 0 0c8.4 2.4 19.3 5.4 28 10.6c9.6 5.6 18.9 15.2 19.4 30.6c.5 17.3-9.2 28.8-20.5 34.9c-5 2.7-10.5 4.5-15.8 5.6l0 8.6 0 16-32 0 0-16 0-9.2c-7.5-1.6-14.5-3.8-20.6-5.8c0 0 0 0 0 0c-1.6-.5-3.1-1-4.5-1.4L280 228.3l9.5-30.6 15.3 4.8c1.8 .6 3.6 1.1 5.3 1.7c10.4 3.3 18.4 5.8 26.8 6.1c6 .2 12.1-1 16.1-3.1c1.8-1 2.7-1.9 3.1-2.5c.3-.5 .8-1.4 .7-3.3l0-.1c0-.6 0-1.7-3.6-3.8c-4.6-2.7-11.3-4.8-20.7-7.4l-1.6-.5s0 0 0 0c-8-2.3-18.1-5.1-26.3-9.5c-9.2-5-19.4-13.8-20.4-29.1c-1.1-17.9 9.5-29.3 20.6-35.2c5-2.7 10.4-4.5 15.6-5.6l0-7.5 0-16 32 0zM336 352l0 80c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-80 160 0zm-67.3 16l-24 0 0 15.8c-3.2 .8-6.5 1.9-9.6 3.6c-7.7 4.1-15.2 12.1-14.4 24.7c.7 10.8 7.9 17 14.2 20.4c5.5 3 12.4 4.9 17.7 6.4l1.1 .3c6.2 1.8 10.5 3.1 13.4 4.8c1.1 .7 1.6 1.1 1.7 1.3l0 .1c0 1-.2 1.3-.2 1.4c-.1 .2-.5 .6-1.5 1.2c-2.3 1.3-6.1 2-9.9 1.9c-5.4-.2-10.4-1.8-17.3-4c0 0 0 0 0 0c-1.1-.4-2.3-.7-3.5-1.1l-11.5-3.6-7.1 22.9 11.5 3.6c.9 .3 1.9 .6 3 .9c3.7 1.2 8 2.6 12.7 3.6l0 17 24 0 0-16.6c3.3-.8 6.6-1.9 9.7-3.6c7.9-4.3 14.7-12.3 14.3-24.4c-.3-10.8-6.9-17.5-13.5-21.4c-5.9-3.5-13.3-5.6-18.8-7.1c0 0 0 0 0 0l-.2-.1c-6.4-1.8-10.8-3.1-13.9-4.7c-.9-.5-1.4-.9-1.7-1.1c0-.2 0-.3 0-.3s0 0 0 0s0 0 0 0c.1-.1 .5-.6 1.7-1.3c2.6-1.4 6.7-2.2 10.1-2.1c4.7 .1 9.8 1 15.3 2.4l11.6 2.9 5.8-23.3-11.6-2.9c-2.8-.7-5.8-1.4-9-1.9l0-15.6z']
      
    ]
  };

  

  
  

  var faUserPoliceTie = {
    prefix: 'fasds',
    iconName: 'user-police-tie',
    icon: [
      448,
      512,
      [],
      'e334',
      
      ['M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M80 99.2L48 80l0-32L224 0 400 48l0 32L368 99.2l0 44.8c-16 10.7-67.2 32-144 32s-128-21.3-144-32l0-44.8zM227 48.6l-3-1.2-3 1.2L189 61.4l-5 2 0 5.4c0 17.2 7 46.1 36.9 58.6l3.1 1.3 3.1-1.3C257 114.9 264 86 264 68.8l0-5.4-5-2L227 48.6zM128 352l67.8 112.9L208 416l-32-64 96 0-32 64 12.2 48.9L320 352l80 0 48 160-192 0-64 0L0 512 48 352l80 0zm224 48.4l-4.6 14.2-6.1 18.8-19.8 0-14.9 0 12.1 8.7 16 11.6-6.2 18.8L324 486.5l12-8.8 16-11.7 16 11.7 12 8.8-4.6-14.1-6.2-18.8 16-11.6 12.1-8.7-14.9 0-19.8 0-6.1-18.8L352 400.4z']
      
    ]
  };

  

  
  

  var faFileUser = {
    prefix: 'fasds',
    iconName: 'file-user',
    icon: [
      384,
      512,
      [],
      'f65c',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM80 448l224 0-32-96-160 0L80 448zm48-192a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M384 160L224 0l0 160 160 0zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm16 96l-160 0L80 448l224 0-32-96z']
      
    ]
  };

  

  
  

  var faScaleUnbalanced = {
    prefix: 'fasds',
    iconName: 'scale-unbalanced',
    icon: [
      640,
      512,
      ["balance-scale-left"],
      'f515',
      
      ['M87.5 139.8l20.2 60.7 30.4-10.1 135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2L288 480l0 32 32 0 192 0 32 0 0-64-32 0-160 0 0-294.7c21-9.2 37.2-27 44.2-49l125.9-42L501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6 87.5 139.8z','M481.5 96L496 96l32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0-128 0-9.9 0-7-7-40-40-7-7 0-9.9 0-32 0-5.9 2.7-5.2 88-168L481.5 96zm29 48L435.1 288l153.8 0L513.5 144l-3 0zm-413 80l14.5 0 32 0 14.5 0 6.7 12.9 88 168 2.7 5.2 0 5.9 0 32 0 9.9-7 7-40 40-7 7-9.9 0L64 512l-9.9 0-7-7L7 465l-7-7L0 448l0-32 0-5.9 2.7-5.2 88-168L97.5 224zm29 48L51.1 416l153.8 0L129.5 272l-3 0z']
      
    ]
  };

  
    var faBalanceScaleLeft = faScaleUnbalanced;
  

  
  

  var faFaceKissClosedEyes = {
    prefix: 'fasds',
    iconName: 'face-kiss-closed-eyes',
    icon: [
      512,
      512,
      [],
      'e37d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm107.2-37.6c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2zM236.1 303l3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-1.3-5-2.6-10-3.7-15.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7c0-4.6 0-9.3 0-14c.1 0 .1-.1 .5-.3l.6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3c-.2-.1-.3-.2-.7-.4zm31.1-84.6c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2z','M132.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2zm160 0c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2z']
      
    ]
  };

  

  
  

  var faVihara = {
    prefix: 'fasds',
    iconName: 'vihara',
    icon: [
      640,
      512,
      [],
      'f6a7',
      
      ['M64 448l64 0 0 64-64 0 0-64zM96 288l64 0 0 64-64 0 0-64zm64-160l64 0 0 64-64 0 0-64zM288 448l64 0 0 64-64 0 0-64zM416 128l64 0 0 64-64 0 0-64zm64 160l64 0 0 64-64 0 0-64zm32 160l64 0 0 64-64 0 0-64z','M320 0s-96 80-176 80l-16 0 0 48 24 0 144 0 24 0 24 0 144 0 24 0 0-48-16 0C416 80 320 0 320 0zM138.7 208c-27.7 20.8-61.4 32-96 32L32 240l0 48 576 0 0-48-10.7 0c-34.6 0-68.3-11.2-96-32L480 192l-320 0-21.3 16zM96 352L57.6 380.8C41 393.3 20.8 400 0 400l0 48 640 0 0-48c-20.8 0-41-6.7-57.6-19.2L544 352 96 352z']
      
    ]
  };

  

  
  

  var faFloppyDisk = {
    prefix: 'fasds',
    iconName: 'floppy-disk',
    icon: [
      448,
      512,
      [128190,128426,"save"],
      'f0c7',
      
      ['M0 32L0 64 0 448l0 32 32 0 384 0 32 0 0-32 0-288 0-13.3-9.4-9.4-96-96L333.3 32 320 32 32 32 0 32zM64 96l256 0 0 128L64 224 64 96zM288 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M224 288a64 64 0 1 0 0 128 64 64 0 1 0 0-128z']
      
    ]
  };

  
    var faSave = faFloppyDisk;
  

  
  

  var faShop = {
    prefix: 'fasds',
    iconName: 'shop',
    icon: [
      640,
      512,
      ["store-alt"],
      'f54f',
      
      ['M64 192l0 32 0 160 0 128 320 0 0-128 0-160 128 0 0 288 64 0 0-320-32 0-32 0L64 192zm64 32l192 0 0 160-192 0 0-160z','M640 192H0V128L96 0H544l96 128v64z']
      
    ]
  };

  
    var faStoreAlt = faShop;
  

  
  

  var faPrescription = {
    prefix: 'fasds',
    iconName: 'prescription',
    icon: [
      448,
      512,
      [],
      'f5b1',
      
      ['M130.7 464L176 509.3l22.6-22.6c29.8-29.8 59.6-59.6 89.4-89.4c15.1-15.1 30.2-30.2 45.3-45.3c29.8-29.8 59.6-59.6 89.4-89.4L445.3 240 400 194.7l-22.6 22.6c-29.8 29.8-59.6 59.6-89.4 89.4c-15.1 15.1-30.2 30.2-45.3 45.3l-89.4 89.4L130.7 464z','M0 0L32 0 176 0c61.9 0 112 50.1 112 112c0 52.8-36.6 97.1-85.8 108.9L288 306.7 242.7 352l-128-128L64 224l0 64 0 32L0 320l0-32 0-96L0 32 0 0zM288 397.3L333.3 352l89.4 89.4L445.3 464 400 509.3l-22.6-22.6L288 397.3zM64 160l112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 64l0 96z']
      
    ]
  };

  

  
  

  var faWalker = {
    prefix: 'fasds',
    iconName: 'walker',
    icon: [
      448,
      512,
      [],
      'f831',
      
      ['M448 448.1A64 64 0 1 1 320 448a64 64 0 1 1 128 .1z','M118.7 0L144 0 384 0l32 0 0 32 0 360.6c-9.4-5.4-20.3-8.6-32-8.6s-22.6 3.1-32 8.6L352 224l-220.5 0L71.1 479.4l-7.4 31.1L1.5 495.8l7.4-31.1 104-440L118.7 0zM352 64L169.3 64l-22.7 96L352 160l0-96z']
      
    ]
  };

  

  
  

  var faScreencast = {
    prefix: 'fasds',
    iconName: 'screencast',
    icon: [
      576,
      512,
      [],
      'e23e',
      
      ['M0 32L0 96l0 96c22 0 43.4 2.5 64 7.1L64 96l448 0 0 320-231.1 0c4.7 20.6 7.1 42 7.1 64l224 0 64 0 0-64 0-320 0-64-64 0L64 32 0 32z','M208 480c0-114.9-93.1-208-208-208l0-48c141.4 0 256 114.6 256 256l-48 0zM0 448a32 32 0 1 1 64 0A32 32 0 1 1 0 448zm0-80l0-48c88.4 0 160 71.6 160 160l-48 0c0-61.9-50.1-112-112-112z']
      
    ]
  };

  

  
  

  var faDiploma = {
    prefix: 'fasds',
    iconName: 'diploma',
    icon: [
      640,
      512,
      ["scroll-ribbon"],
      'f5ea',
      
      ['M0 144l160 0 48 0 48 0 0 236L64 416 0 288 0 144zm384 0l48 0 48 0 160 0 0 144L576 416 384 380l0-236z','M208 144l-48 0 0-31c0-44.7 36.3-81 81-81c23.4 0 45.6 10.1 61 27.7l18 20.6 18-20.6C353.4 42.1 375.6 32 399 32c44.7 0 81 36.3 81 81l0 31-48 0 0-31 0-.5 0-.5c0-17.7-14.3-32-32-32l-1 0c-9.5 0-18.6 4.1-24.8 11.3L328 144l56 0 0 336-64-40-64 40 0-336 56 0L265.9 91.3C259.6 84.1 250.5 80 241 80c-18.1 0-32.7 14.5-33 32.5l0 .5 0 31z']
      
    ]
  };

  
    var faScrollRibbon = faDiploma;
  

  
  

  var faShirtTankTop = {
    prefix: 'fasds',
    iconName: 'shirt-tank-top',
    icon: [
      384,
      512,
      [],
      'e3c9',
      
      ['M112 32l0-32L48 0l0 32 0 32 0 16 0 48L0 256 0 512l384 0 0-256L336 128l0-48 0-16 0-32 0-32L272 0l0 32 0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48z','']
      
    ]
  };

  

  
  

  var faChessBishopPiece = {
    prefix: 'fasds',
    iconName: 'chess-bishop-piece',
    icon: [
      256,
      512,
      ["chess-bishop-alt"],
      'f43b',
      
      ['M0 480l0 32 256 0 0-32-48-64L48 416 0 480z','M176 32L80 32l0 48 20.7 0C79.4 100.3 48 139.2 48 192c0 26.3 13.6 40.5 26.3 48L72 240l-24 0 0 48 24 0 4.4 0L48 416l160 0L179.6 288l4.4 0 24 0 0-48-24 0-2.3 0c12.7-7.5 26.3-21.7 26.3-48c0-25.9-7.5-48.4-17.7-67l-48.6 48.6-5.7 5.7L124.7 168l5.7-5.7L181.7 111c-8.7-12.8-18.3-23.3-26.4-31L176 80l0-48z']
      
    ]
  };

  
    var faChessBishopAlt = faChessBishopPiece;
  

  
  

  var faFaceFrown = {
    prefix: 'fasds',
    iconName: 'face-frown',
    icon: [
      512,
      512,
      [9785,"frown"],
      'f119',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM124 394.5l4.7-15.3C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3l4.7 15.3L357.5 404l-4.7-15.3C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7L154.5 404 124 394.5zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faFrown = faFaceFrown;
  

  
  

  var faDryer = {
    prefix: 'fasds',
    iconName: 'dryer',
    icon: [
      448,
      512,
      [],
      'f861',
      
      ['M80.9 288l95.1 0 16 0 0 32-16 0-95.1 0c8 72 69 128 143.1 128c79.5 0 144-64.5 144-144s-64.5-144-144-144c-74.1 0-135.2 56-143.1 128zM160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M448 0L0 0 0 512l448 0L448 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faWindowMaximize = {
    prefix: 'fasds',
    iconName: 'window-maximize',
    icon: [
      512,
      512,
      [128470],
      'f2d0',
      
      ['M64 96l384 0 0 64L64 160l0-64z','M0 480l512 0 0-448L0 32 0 480zM448 96l0 64L64 160l0-64 384 0z']
      
    ]
  };

  

  
  

  var faHouseChimney = {
    prefix: 'fasds',
    iconName: 'house-chimney',
    icon: [
      576,
      512,
      [63499,"home-lg"],
      'e3af',
      
      ['M64 272l.1 240L224 512l0-160.3 128 0L352 512l160.6 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272z','M288 0L0 240l0 32 64 0L288 88 512 272l64 0 0-32-64-53.3L512 32l-96 0 0 74.7L288 0z']
      
    ]
  };

  
    var faHomeLg = faHouseChimney;
  

  
  

  var faArrowUpLeftFromCircle = {
    prefix: 'fasds',
    iconName: 'arrow-up-left-from-circle',
    icon: [
      512,
      512,
      [],
      'e09e',
      
      ['M64 288c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64l0 64c88.4 0 160 71.6 160 160s-71.6 160-160 160s-160-71.6-160-160l-64 0z','M0 0L32 0 192 0l32 0 0 64-32 0-82.7 0L342.6 297.4 365.3 320 320 365.3l-22.6-22.6L64 109.3 64 192l0 32L0 224l0-32L0 32 0 0z']
      
    ]
  };

  

  
  

  var faHeartCircleXmark = {
    prefix: 'fasds',
    iconName: 'heart-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e501',
      
      ['M0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480l23.7-23.7c-15.1-26-23.7-56.1-23.7-88.3c0-97.2 78.8-176 176-176c26.4 0 51.4 5.8 73.8 16.2c4-13 6.2-26.6 6.2-40.4C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7L502.6 320z']
      
    ]
  };

  

  
  

  var faBus = {
    prefix: 'fasds',
    iconName: 'bus',
    icon: [
      576,
      512,
      [128653],
      'f207',
      
      ['M96 448l0 64 96 0 0-64-96 0zm32-320c0 53.3 0 106.7 0 160l144 0 0-160-144 0zm176 0l0 160 144 0 0-160-144 0zm80 320l0 64 96 0 0-64-96 0z','M288 0C412.8 0 512 48 512 48l0 48 0 32 32 0 0 128-32 0 0 192L64 448l0-192-32 0 0-128 32 0 0-32s0 0 0 0l0-48s99.2-48 224-48zm16 128l0 160 144 0 0-160-144 0zm-32 0l-144 0 0 160 144 0 0-160zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 96l0-32-16 0L208 64l-16 0 0 32 16 0 160 0 16 0z']
      
    ]
  };

  

  
  

  var faPump = {
    prefix: 'fasds',
    iconName: 'pump',
    icon: [
      640,
      512,
      [],
      'e442',
      
      ['M64 224l96 0 0-160 160 0 0 160 32 0 0 160L64 384l0-160z','M160 0L128 0l0 64 32 0 160 0 32 0 0-64L320 0 160 0zM64 208l0-32L0 176l0 32L0 384l0 32 64 0 0-32 0-176zM448 96l-96 64 0 288 96 64 192 0 0-416L448 96zm0 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm0 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm0 96l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z']
      
    ]
  };

  

  
  

  var faSignal = {
    prefix: 'fasds',
    iconName: 'signal',
    icon: [
      640,
      512,
      [128246,"signal-5","signal-perfect"],
      'f012',
      
      ['','M608 0l0 32 0 448 0 32-64 0 0-32 0-448 0-32 64 0zM480 96l0 32 0 352 0 32-64 0 0-32 0-352 0-32 64 0zM352 224l0 256 0 32-64 0 0-32 0-256 0-32 64 0 0 32zM224 288l0 32 0 160 0 32-64 0 0-32 0-160 0-32 64 0zM96 416l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z']
      
    ]
  };

  
    var faSignal5 = faSignal;
  
    var faSignalPerfect = faSignal;
  

  
  

  var faFileCode = {
    prefix: 'fasds',
    iconName: 'file-code',
    icon: [
      384,
      512,
      [],
      'f1c9',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM54.1 320c5.7 5.7 11.3 11.3 17 17c16 16 32 32 48 48c5.7 5.7 11.3 11.3 17 17c11.3-11.3 22.6-22.6 33.9-33.9c-5.7-5.7-11.3-11.3-17-17l-31-31c10.3-10.3 20.7-20.7 31-31c5.7-5.7 11.3-11.3 17-17c-11.3-11.3-22.6-22.6-33.9-33.9c-5.7 5.7-11.3 11.3-17 17L71 303l-17 17zm160-48c5.7 5.7 11.3 11.3 17 17c10.3 10.3 20.7 20.7 31 31c-10.3 10.3-20.7 20.7-31 31l-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c16-16 32-32 48-48c5.7-5.7 11.3-11.3 17-17c-5.7-5.7-11.3-11.3-17-17c-16-16-32-32-48-48l-17-17c-11.3 11.3-22.6 22.6-33.9 33.9z','M384 160L224 0l0 160 160 0zM153 289l17-17L136 238.1l-17 17L71 303l-17 17 17 17 48 48 17 17L169.9 368l-17-17-31-31 31-31zM265 255l-17-17L214.1 272l17 17 31 31-31 31-17 17L248 401.9l17-17 48-48 17-17-17-17-48-48z']
      
    ]
  };

  

  
  

  var faToiletPaperBlankUnder = {
    prefix: 'fasds',
    iconName: 'toilet-paper-blank-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse-alt"],
      'e29f',
      
      ['M0 192C0 86 43 0 96 0L416 0c-53 0-96 86-96 192c0 1.3 0 2.6 0 3.9c1 104.2 43.6 188.1 96 188.1l-256 0-32 0-32 0C43 384 0 298 0 192z','M416 384c-52.4 0-94.9-83.8-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0s96 86 96 192l0 320-352 0 0-128 256 0zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z']
      
    ]
  };

  
    var faToiletPaperReverseAlt = faToiletPaperBlankUnder;
  

  
  

  var faFloppyDisks = {
    prefix: 'fasds',
    iconName: 'floppy-disks',
    icon: [
      512,
      512,
      [],
      'e183',
      
      ['M0 96l0 24L0 488l0 24 24 0 368 0 24 0 0-48-24 0L48 464l0-344 0-24L0 96zM240 288a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M120 0L96 0l0 24 0 368 0 24 24 0 368 0 24 0 0-24 0-264 0-9.9-7-7L401 7l-7-7L384 0 120 0zm40 64l224 0 0 96-224 0 0-96zM304 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z']
      
    ]
  };

  

  
  

  var faTowerObservation = {
    prefix: 'fasds',
    iconName: 'tower-observation',
    icon: [
      512,
      512,
      [],
      'e586',
      
      ['','M64 96L256 0 448 96l0 32-32 0 0 128-36.9 0 32 192 68.9 0 32 0 0 64-32 0-95.5 0c-.4 0-.8 0-1.1 0l-254.8 0c-.4 0-.8 0-1.1 0L32 512 0 512l0-64 32 0 68.9 0 32-192L96 256l0-128-32 0 0-32zM314.5 448L256 399.2 197.5 448l117 0zM193.1 284.3L256 336.8l62.9-52.5L314.2 256l-116.5 0-4.7 28.3zm-9.1 54.9l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM352 128l-192 0 0 32 192 0 0-32z']
      
    ]
  };

  

  
  

  var faPen = {
    prefix: 'fasds',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      ['M288 96L416 224l96-96L384 0 288 96z','M32 352L0 512l160-32L416 224 288 96 32 352z']
      
    ]
  };

  

  
  

  var faUserSlash = {
    prefix: 'fasds',
    iconName: 'user-slash',
    icon: [
      640,
      512,
      [],
      'f506',
      
      ['M96 512l448 0-16 0L264 304l-104 0L96 512zm96-385.7L353.4 251.6C407.9 236.9 448 187.1 448 128C448 57.3 390.7 0 320 0C249.9 0 192.9 56.4 192 126.3z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faManhole = {
    prefix: 'fasds',
    iconName: 'manhole',
    icon: [
      512,
      512,
      [],
      'e1d6',
      
      ['M96 256c0 77.5 55 142.1 128.2 156.8c1.6-16.2 15.2-28.8 31.8-28.8s30.3 12.6 31.8 28.8C361 398.1 416 333.5 416 256s-55-142.1-128.2-156.8C286.3 115.4 272.6 128 256 128s-30.3-12.6-31.8-28.8C151 113.9 96 178.5 96 256zm80-80l32 0 0 32-32 0 0-32zm0 64l32 0 0 32-32 0 0-32zm0 64l32 0 0 32-32 0 0-32zm64-128l32 0 0 32-32 0 0-32zm0 64l32 0 0 32-32 0 0-32zm0 64l32 0 0 32-32 0 0-32zm64-128l32 0 0 32-32 0 0-32zm0 64l32 0 0 32-32 0 0-32zm0 64l32 0 0 32-32 0 0-32z','M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-448a192 192 0 1 1 0 384 192 192 0 1 1 0-384z']
      
    ]
  };

  

  
  

  var faHexagon = {
    prefix: 'fasds',
    iconName: 'hexagon',
    icon: [
      512,
      512,
      [11043],
      'f312',
      
      ['M128 32L0 256 128 480l256 0L512 256 384 32 128 32z','']
      
    ]
  };

  

  
  

  var faFileShield = {
    prefix: 'fasds',
    iconName: 'file-shield',
    icon: [
      576,
      512,
      [],
      'e4f0',
      
      ['M0 0L224 0l0 160 160 0 0 48.3L256 257.8l0 38.2c0 76.6 34.3 164.8 106.1 216L0 512 0 0z','M384 160L224 0l0 160 160 0zM527.3 312.4c-5.2 61-38.8 121.7-95.3 148l0-184.9 95.3 36.9zM432 512c96-32 144-130.2 144-216l0-16.2L432 224 288 279.8l0 16.2c0 85.8 48 184 144 216z']
      
    ]
  };

  

  
  

  var faPersonMilitaryToPerson = {
    prefix: 'fasds',
    iconName: 'person-military-to-person',
    icon: [
      512,
      512,
      [],
      'e54c',
      
      ['M272 432l96 80 16 0 0-56 104 0 24 0 0-48-24 0-104 0 0-56-16 0-96 80zm16-112l192 0L448 192l-128 0L288 320zM320 96a64 64 0 1 0 128 0A64 64 0 1 0 320 96z','M200 0L56 14.1l0 32 144 0L200 0zM189.5 78.1l-122.9 0C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM192 192L83.8 192 217.8 295 192 192zM32 320l165.8 0L58.7 213.1 32 320zm96 136l0 56 16 0 96-80-96-80-16 0 0 56L24 408 0 408l0 48 24 0 104 0z']
      
    ]
  };

  

  
  

  var faAudioDescription = {
    prefix: 'fasds',
    iconName: 'audio-description',
    icon: [
      576,
      512,
      [],
      'f29e',
      
      ['M0 32L0 480l576 0 0-448L0 32zM94.4 352c25.2-59.1 50.4-118.3 75.6-177.4c2.1-4.9 4.1-9.7 6.2-14.6l31.7 0c2.1 4.9 4.1 9.7 6.2 14.6c25.2 59.1 50.4 118.3 75.6 177.4l-52.2 0-10.3-24.2-70.4 0L146.5 352l-52.2 0zm79.5-64.2l36.3 0c-6-14.2-12.1-28.4-18.1-42.6c-6 14.2-12.1 28.4-18.1 42.6zM304 160l24 0 56 0c53 0 96 43 96 96s-43 96-96 96l-56 0-24 0c0-8 0-16 0-24c0-48 0-96 0-144c0-8 0-16 0-24zm48 48l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z','M207.9 160l-31.7 0-6.2 14.6L94.4 352l52.2 0 10.3-24.2 70.4 0L237.5 352l52.2 0L214.1 174.6 207.9 160zm2.3 127.8l-36.3 0L192 245.2l18.1 42.6zM304 160l0 24 0 144 0 24 24 0 56 0c53 0 96-43 96-96s-43-96-96-96l-56 0-24 0zm48 48l32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0 0-96z']
      
    ]
  };

  

  
  

  var faArrowsMinimize = {
    prefix: 'fasds',
    iconName: 'arrows-minimize',
    icon: [
      512,
      512,
      ["compress-arrows"],
      'e0a5',
      
      ['M2.7 464L48 509.3l22.6-22.6L160 397.3l0 34.7 0 32 64 0 0-32 0-112 0-32-32 0L80 288l-32 0 0 64 32 0 34.7 0L25.4 441.4 2.7 464zM288 48l0 32 0 112 0 32 32 0 112 0 32 0 0-64-32 0-34.7 0 89.4-89.4L509.3 48 464 2.7 441.4 25.4 352 114.7 352 80l0-32-64 0z','M48 2.7L70.6 25.4 160 114.7 160 80l0-32 64 0 0 32 0 112 0 32-32 0L80 224l-32 0 0-64 32 0 34.7 0L25.4 70.6 2.7 48 48 2.7zM288 288l32 0 112 0 32 0 0 64-32 0-34.7 0 89.4 89.4L509.3 464 464 509.3l-22.6-22.6L352 397.3l0 34.7 0 32-64 0 0-32 0-112 0-32z']
      
    ]
  };

  
    var faCompressArrows = faArrowsMinimize;
  

  
  

  var faBootHeeled = {
    prefix: 'fasds',
    iconName: 'boot-heeled',
    icon: [
      512,
      512,
      [],
      'e33f',
      
      ['M32 416l128 0 160 48 160 0 8 0 24 0 0 48-24 0-8 0-136 0-24 0-16 0L160 464l0 48L32 512l0-96z','M32 0l96 0 0 240 0 16 32 0 0-16L160 0 288 0l0 288 192 96 0 80-160 0L160 416 32 416l0-32L64 256 32 64 32 0z']
      
    ]
  };

  

  
  

  var faTicketAirline = {
    prefix: 'fasds',
    iconName: 'ticket-airline',
    icon: [
      640,
      512,
      ["ticket-perforated-plane","ticket-plane"],
      'e29a',
      
      ['M0 64L0 448l640 0 0-144c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-144L0 64zM64 192l32 0 24 32 56 0-32-96 56 0 56 96 46.9 0c16.1 0 31.5 6.4 42.8 17.7c3.9 3.9 5.9 9.1 5.9 14.3s-2 10.3-5.9 14.3C334.4 281.6 319 288 302.9 288L256 288l-56 96-56 0 32-96-56 0L96 320l-32 0 16-64L64 192zm384-64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M144 128l32 96-56 0L96 192l-32 0 16 64L64 320l32 0 24-32 56 0-32 96 56 0 56-96 46.9 0c16.1 0 31.5-6.4 42.8-17.7c7.9-7.9 7.9-20.7 0-28.5C334.4 230.4 319 224 302.9 224L256 224l-56-96-56 0z']
      
    ]
  };

  
    var faTicketPerforatedPlane = faTicketAirline;
  
    var faTicketPlane = faTicketAirline;
  

  
  

  var faHeat = {
    prefix: 'fasds',
    iconName: 'heat',
    icon: [
      448,
      512,
      [],
      'e00c',
      
      ['M144 32l0 32 0 80c0 48.5 15.7 95.6 44.8 134.4L208 304c20.8 27.7 32 61.4 32 96l0 48 0 32 64 0 0-32 0-48c0-48.5-15.7-95.6-44.8-134.4L240 240c-20.8-27.7-32-61.4-32-96l0-80 0-32-64 0z','M64 128l0-32L0 96l0 32 0 32c0 48.5 15.7 95.6 44.8 134.4L64 320c20.8 27.7 32 61.4 32 96l0 32 0 32 64 0 0-32 0-32c0-48.5-15.7-95.6-44.8-134.4L96 256c-20.8-27.7-32-61.4-32-96l0-32zm288 0l0-32-64 0 0 32 0 32c0 48.5 15.7 95.6 44.8 134.4L352 320c20.8 27.7 32 61.4 32 96l0 32 0 32 64 0 0-32 0-32c0-48.5-15.7-95.6-44.8-134.4L384 256c-20.8-27.7-32-61.4-32-96l0-32z']
      
    ]
  };

  

  
  

  var faFaceSadCry = {
    prefix: 'fasds',
    iconName: 'face-sad-cry',
    icon: [
      512,
      512,
      [128557,"sad-cry"],
      'f5b3',
      
      ['M0 256c0 94.8 51.5 177.5 128 221.8c0-63.2 0-126.5 0-189.8c0-5.3 0-10.7 0-16l32 0c0 5.3 0 10.7 0 16c0 68.5 0 136.9 0 205.4c29.6 12 62.1 18.6 96 18.6s66.4-6.6 96-18.6L352 288l0-16 32 0 0 16 0 189.8c76.5-44.3 128-127 128-221.8C512 114.6 397.4 0 256 0S0 114.6 0 256zm91.2-37.6c34.4-45.9 103.2-45.9 137.6 0c-8.6 6.4-17.1 12.8-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2zM208 336c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zm75.2-117.6c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2z','M203.2 237.6l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0zM128 477.8c10.2 5.9 20.9 11.2 32 15.6L160 288l0-16-32 0 0 16 0 189.8zm224 15.6c11.1-4.5 21.8-9.7 32-15.6L384 288l0-16-32 0 0 16 0 205.4zM308.8 237.6c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2z']
      
    ]
  };

  
    var faSadCry = faFaceSadCry;
  

  
  

  var faEye = {
    prefix: 'fasds',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      ['M0 256C30 181.3 129.6 32 288 32s258 149.3 288 224c-30 74.7-129.6 224-288 224S30 330.7 0 256zm144 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0z','M193.8 237.2c-1.2 6.1-1.8 12.4-1.8 18.8c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8L288 256l-94.2-18.8z']
      
    ]
  };

  

  
  

  var faBusSimple = {
    prefix: 'fasds',
    iconName: 'bus-simple',
    icon: [
      448,
      512,
      ["bus-alt"],
      'f55e',
      
      ['M32 448l96 0 0 64-96 0 0-64zM64 96l320 0 0 192L64 288 64 96zM320 448l96 0 0 64-96 0 0-64z','M224 0C348.8 0 448 48 448 48l0 48 0 352L0 448 0 96 0 48S99.2 0 224 0zM64 288l320 0 0-192L64 96l0 192zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faBusAlt = faBusSimple;
  

  
  

  var faChestnut = {
    prefix: 'fasds',
    iconName: 'chestnut',
    icon: [
      448,
      512,
      [127792],
      'e3f6',
      
      ['M0 384l448 0 0 32-64 64L64 480 0 416l0-32z','M448 352c0-134.3-101.7-213.8-168.4-265.8C251 63.8 228.8 46.4 224 32c-4.8 14.4-27 31.8-55.6 54.2C101.7 138.2 0 217.7 0 352v32H448V352z']
      
    ]
  };

  

  
  

  var faTape = {
    prefix: 'fasds',
    iconName: 'tape',
    icon: [
      576,
      512,
      [],
      'f4db',
      
      ['M64 256a160 160 0 1 0 320 0A160 160 0 1 0 64 256zm224 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M64 256a160 160 0 1 1 320 0A160 160 0 1 1 64 256zM380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480l320 0 32 0 0-64-32 0-163.2 0z']
      
    ]
  };

  

  
  

  var faBasketShopping = {
    prefix: 'fasds',
    iconName: 'basket-shopping',
    icon: [
      576,
      512,
      ["shopping-basket"],
      'f291',
      
      ['M0 192l0 64 32 0L96 512l384 0 64-256 32 0 0-64-124.4 0c6 12.5 12 25.1 18.1 37.6c3.5 7.2 6.9 14.4 10.4 21.6c-14.4 6.9-28.8 13.8-43.3 20.8c-3.5-7.2-6.9-14.4-10.4-21.6c-9.3-19.5-18.7-38.9-28-58.4l-220.7 0c-9.3 19.5-18.7 38.9-28 58.4c-3.5 7.2-6.9 14.4-10.4 21.6c-14.4-6.9-28.8-13.8-43.3-20.8l10.4-21.6L124.4 192 0 192zM160 304l32 0 0 16 0 96 0 16-32 0 0-16 0-96 0-16zm112 0l32 0 0 16 0 96 0 16-32 0 0-16 0-96 0-16zm112 0l32 0 0 16 0 96 0 16-32 0 0-16 0-96 0-16z','M245.6 50.4L256 28.7 212.7 8 202.4 29.6l-96 200L96 251.3 139.3 272l10.4-21.6 96-200zm84.7 0l96 200L436.7 272 480 251.3l-10.4-21.6-96-200L363.3 8 320 28.7l10.4 21.6z']
      
    ]
  };

  
    var faShoppingBasket = faBasketShopping;
  

  
  

  var faHouseMedicalFlag = {
    prefix: 'fasds',
    iconName: 'house-medical-flag',
    icon: [
      640,
      512,
      [],
      'e514',
      
      ['M0 240l0 47.6 64.1 0 0 224.4L416 512l0-346.8L256.4 32 0 240zm160 16l64 0 0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64z','M512 32l0-32L448 0l0 32 0 160 0 320 64 0 0-320 128 0 0-160L512 32z']
      
    ]
  };

  

  
  

  var faMobileButton = {
    prefix: 'fasds',
    iconName: 'mobile-button',
    icon: [
      384,
      512,
      [],
      'f10b',
      
      ['M16 384l352 0 0 128L16 512l0-128zm144 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M16 0H368V384H16V0z']
      
    ]
  };

  

  
  

  var faTerminal = {
    prefix: 'fasds',
    iconName: 'terminal',
    icon: [
      576,
      512,
      [],
      'f120',
      
      ['M224 416l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64z','M-.5 76.8L22.2 99.4 178.7 256 22.2 412.6-.5 435.2l45.3 45.3 22.6-22.6L246.6 278.6 269.3 256l-22.6-22.6L67.4 54.2 44.8 31.5-.5 76.8z']
      
    ]
  };

  

  
  

  var faCircleSortUp = {
    prefix: 'fasds',
    iconName: 'circle-sort-up',
    icon: [
      512,
      512,
      ["sort-circle-up"],
      'e032',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-64L256 96l112 96 0 32-224 0 0-32zm0 96l224 0 0 32L256 416 144 320l0-32z','M144 192L256 96l112 96v32H144V192z']
      
    ]
  };

  
    var faSortCircleUp = faCircleSortUp;
  

  
  

  var faBanSmoking = {
    prefix: 'fasds',
    iconName: 'ban-smoking',
    icon: [
      512,
      512,
      [128685,"smoking-ban"],
      'f54d',
      
      ['M96 224l0 16 0 64 0 16 16 0 162.7 0c-32-32-64-64-96-96L112 224l-16 0zM256 96l0 16c0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16l0 16 32 0 0-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16l0-16-32 0zm13.3 128c10.7 10.7 21.3 21.3 32 32l82.7 0 0 32-50.7 0 32 32 34.7 0 16 0 0-16 0-64 0-16-16 0-130.7 0z','M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z']
      
    ]
  };

  
    var faSmokingBan = faBanSmoking;
  

  
  

  var faCartFlatbed = {
    prefix: 'fasds',
    iconName: 'cart-flatbed',
    icon: [
      640,
      512,
      ["dolly-flatbed"],
      'f474',
      
      ['M160 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48zM192 32l144 0 0 160 64-48 64 48 0-160 144 0 0 288-416 0 0-288zM448 464c0-5.6 1-11 2.7-16l90.5 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48z','M32 0L0 0 0 64l32 0 32 0 0 352 0 32 32 0 512 0 32 0 0-64-32 0-480 0 0-352 0-32L96 0 32 0zM336 192l64-48 64 48 0-160L336 32l0 160z']
      
    ]
  };

  
    var faDollyFlatbed = faCartFlatbed;
  

  
  

  var faCircleR = {
    prefix: 'fasds',
    iconName: 'circle-r',
    icon: [
      512,
      512,
      [],
      'e120',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 104 0c44.2 0 80 35.8 80 80c0 37.8-26.3 69.5-61.6 77.9L369.1 384l-57 0-61.3-96L208 288l0 72 0 24-48 0 0-24 0-96 0-112 0-24zm48 48l0 64 56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0z','M184 128l-24 0 0 24 0 112 0 96 0 24 48 0 0-24 0-72 42.9 0 61.3 96 57 0-62.7-98.1c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80l-104 0zm80 112l-56 0 0-64 80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0z']
      
    ]
  };

  

  
  

  var faArrowUpRight = {
    prefix: 'fasds',
    iconName: 'arrow-up-right',
    icon: [
      384,
      512,
      [],
      'e09f',
      
      ['M18.7 384L64 429.3l22.6-22.6L288 205.3l0-45.3-45.3 0L41.4 361.4 18.7 384z','M352 96l-32 0L96 96 64 96l0 64 32 0 192 0 0 192 0 32 64 0 0-32 0-224 0-32z']
      
    ]
  };

  

  
  

  var faDolphin = {
    prefix: 'fasds',
    iconName: 'dolphin',
    icon: [
      512,
      512,
      [],
      'e168',
      
      ['M0 221.9L0 240l0 16 0 32 32 0 144 0 16 0 16 0 80 64 32 0 0-64 6.6 0c31.7 0 57.4 25.7 57.4 57.4c0 30.6-24 55.8-54.5 57.3l-60 3L248 352l-88 0 32 80-32 80 88 0 18.3-45.7 72.5 4c94.1 5.2 173.3-70 173.3-164.3c0-81.8-32.2-156.3-84.6-211.3L480 16 464 0 335.4 28.6C296.3 10.2 252.6 0 206.5 0L176 0C96.5 0 32 64.5 32 144c0 18.6 3.5 36.4 10 52.7L15.5 212.6 0 221.9zM200 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M176 120a24 24 0 1 0 0 48 24 24 0 1 0 0-48z']
      
    ]
  };

  

  
  

  var faArrowsToLine = {
    prefix: 'fasds',
    iconName: 'arrows-to-line',
    icon: [
      448,
      512,
      [],
      'e0a7',
      
      ['M0 224l32 0 384 0 32 0 0 64-32 0L32 288 0 288l0-64z','M256 0l0 32 0 32 64 0 0 32-96 96L128 96l0-32 64 0 0-32 0-32 64 0zm0 448l0 32 0 32-64 0 0-32 0-32-64 0 0-32 96-96 96 96 0 32-64 0z']
      
    ]
  };

  

  
  

  var faFaucetDrip = {
    prefix: 'fasds',
    iconName: 'faucet-drip',
    icon: [
      512,
      512,
      [128688],
      'e006',
      
      ['M0 192L0 320l132.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-88.4-71.6-160-160-160l-32 0-32-32-32 0 0-76.8L224 80l-32 3.2 0 76.8-32 0-32 32L0 192zM192 0l0 44.8L224 48l32-3.2L256 0 192 0z','M224 80L64 96l0-64L224 48 384 32l0 64L224 80zM448 416l27.8 48.7c2.7 4.8 4.2 10.2 4.2 15.7c0 17.5-14.2 31.6-31.6 31.6l-.8 0c-17.5 0-31.6-14.2-31.6-31.6c0-5.5 1.4-10.9 4.2-15.7L448 416z']
      
    ]
  };

  

  
  

  var faBarsProgress = {
    prefix: 'fasds',
    iconName: 'bars-progress',
    icon: [
      512,
      512,
      ["tasks-alt"],
      'f828',
      
      ['M192 288l0 64 256 0 0 32-256 0 0 64 256 0 64 0 0-64 0-32 0-64-64 0-256 0zM320 64l0 64 128 0 0 32-128 0 0 64 128 0 64 0 0-64 0-32 0-64-64 0L320 64z','M0 64H320V224H0V64zM0 288H192V448H0V288z']
      
    ]
  };

  
    var faTasksAlt = faBarsProgress;
  

  
  

  var faNfcSymbol = {
    prefix: 'fasds',
    iconName: 'nfc-symbol',
    icon: [
      512,
      512,
      [],
      'e531',
      
      ['M146.8 290.4l23.8 21.4 178.3 160 17.3 15.5 20.1-11.6C461.6 432.1 512 348.8 512 256s-50.3-176.1-125.7-219.7l-32 55.4C410.1 124 448 186.4 448 256c0 61.4-29.5 117.2-74.8 151.7L213.4 264.2l-23.8-21.4-42.7 47.6z','M145.8 24.7l17.3 15.5 178.3 160 23.8 21.4-42.7 47.6-23.8-21.4L138.8 104.4C93.5 138.8 64 194.6 64 256c0 69.6 37.9 132 93.7 164.3l-32 55.4C50.3 432.1 0 348.8 0 256S50.3 79.9 125.7 36.3l20.1-11.6z']
      
    ]
  };

  

  
  

  var faSquareChevronUp = {
    prefix: 'fasds',
    iconName: 'square-chevron-up',
    icon: [
      448,
      512,
      ["chevron-square-up"],
      'f32c',
      
      ['M0 32L0 480l448 0 0-448L0 32zM86.1 288c5.7-5.7 11.3-11.3 17-17L207 167l17-17 17 17c34.7 34.7 69.3 69.3 104 104c5.7 5.7 11.3 11.3 17 17L328 321.9l-17-17c-29-29-58-58-87-87c-29 29-58 58-87 87c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9z','M224 150.1l17 17L345 271l17 17L328 321.9l-17-17-87-87-87 87-17 17L86.1 288l17-17L207 167l17-17z']
      
    ]
  };

  
    var faChevronSquareUp = faSquareChevronUp;
  

  
  

  var faHouseSignal = {
    prefix: 'fasds',
    iconName: 'house-signal',
    icon: [
      576,
      512,
      [],
      'e012',
      
      ['M96 208L336 0 576 208l0 48-64 0 0 160-240.4 0C242.7 334.2 177.8 269.3 96 240.4L96 208zm192-16l0 96 96 0 0-96-96 0z','M208 512c0-114.9-93.1-208-208-208l0-48c141.4 0 256 114.6 256 256l-48 0zM0 480a32 32 0 1 1 64 0A32 32 0 1 1 0 480zm0-80l0-48c88.4 0 160 71.6 160 160l-48 0c0-61.9-50.1-112-112-112z']
      
    ]
  };

  

  
  

  var faFaceRaisedEyebrow = {
    prefix: 'fasds',
    iconName: 'face-raised-eyebrow',
    icon: [
      512,
      512,
      [],
      'e388',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM112 144c5.3 0 10.7 0 16 0c21.3 0 42.7 0 64 0c5.3 0 10.7 0 16 0l0 32c-5.3 0-10.7 0-16 0c-21.3 0-42.7 0-64 0c-5.3 0-10.7 0-16 0l0-32zm32 192l16 0 192 0 16 0 0 32-16 0-192 0-16 0 0-32zm64.4-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm57-80c3.8-3.8 7.5-7.5 11.3-11.3c9.8-9.8 19.7-19.7 29.5-29.5c25-25 66.6-20.9 86.2 8.5c1.6 2.5 3.3 4.9 4.9 7.4c3 4.4 5.9 8.9 8.9 13.3c-8.9 5.9-17.7 11.8-26.6 17.8c-3-4.4-5.9-8.9-8.9-13.3c-1.6-2.5-3.3-4.9-4.9-7.4c-8.4-12.6-26.2-14.4-36.9-3.7c-9.8 9.8-19.7 19.7-29.5 29.5c-3.8 3.8-7.5 7.5-11.3 11.3L265.4 160zm103 80a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M328.8 141.8c10.7-10.7 28.5-8.9 36.9 3.7l4.9 7.4 8.9 13.3 26.6-17.8-8.9-13.3-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5L265.4 160 288 182.6l11.3-11.3 29.5-29.5zM128 144l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zm80.4 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z']
      
    ]
  };

  

  
  

  var faFaceZipper = {
    prefix: 'fasds',
    iconName: 'face-zipper',
    icon: [
      512,
      512,
      [],
      'e3a5',
      
      ['M0 256C0 397.4 114.6 512 256 512c40 0 77.8-9.2 111.5-25.5l-44.1-88.2L316.2 384 304 384l0-16 0-32 0-16 32 0 0 16 0 18.7 25.4-25.4 16.3-16.3 20.6 10.3 88.2 44.1C502.8 333.8 512 296 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm112 64l32 0 0 16 0 32 0 16-32 0 0-16 0-32 0-16zm32.4-112c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM176 320l32 0 0 16 0 32 0 16-32 0 0-16 0-32 0-16zm64 0l32 0 0 16 0 32 0 16-32 0 0-16 0-32 0-16zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM512 416L384 352l-32 32 64 128 32 0 64-64 0-32zm-55 8l-8.5 8.5-16 16L424 457l-17-17 8.5-8.5 16-16L440 407l17 17z']
      
    ]
  };

  

  
  

  var faCardDiamond = {
    prefix: 'fasds',
    iconName: 'card-diamond',
    icon: [
      384,
      512,
      [],
      'e3ea',
      
      ['M0 0L0 512l384 0L384 0 0 0zM80 256L192 144 304 256 192 368 80 256z','M192 368L80 256 192 144 304 256 192 368z']
      
    ]
  };

  

  
  

  var faSquareParking = {
    prefix: 'fasds',
    iconName: 'square-parking',
    icon: [
      448,
      512,
      [127359,"parking"],
      'f540',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l32 0 80 0c53 0 96 43 96 96l0 32-5.5 0c-13.2 37.3-48.7 64-90.5 64l-48 0 0 32 0 32-64 0 0-32 0-32 0-32 0-32 0-96 0-32zm64 64l0 64 48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0z','M128 128l32 0 80 0c53 0 96 43 96 96l0 32-5.5 0c-13.2 37.3-48.7 64-90.5 64l-48 0 0 32 0 32-64 0 0-32 0-32 0-64 0-96 0-32zm64 128l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64z']
      
    ]
  };

  
    var faParking = faSquareParking;
  

  
  

  var faUserRobot = {
    prefix: 'fasds',
    iconName: 'user-robot',
    icon: [
      448,
      512,
      [],
      'e04b',
      
      ['M32 128l0 128 48 0 0-128-48 0zM144 448l0 16 0 48 32 0 0-48 0-16-32 0zM208 0l0 16 0 48 32 0 0-48 0-16L208 0zm0 448l0 16 0 48 32 0 0-48 0-16-32 0zm64 0l0 16 0 48 32 0 0-48 0-16-32 0zm96-320l0 128 48 0 0-128-48 0z','M80 64l288 0 0 256L80 320 80 64zm112 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM176 240l-32 0 0 32 32 0 0-32zm32 0l0 32 32 0 0-32-32 0zm64 0l0 32 32 0 0-32-32 0zM48 352l352 0 48 160-96 0 0-96L96 416l0 96L0 512 48 352z']
      
    ]
  };

  

  
  

  var faFaceMehBlank = {
    prefix: 'fasds',
    iconName: 'face-meh-blank',
    icon: [
      512,
      512,
      [128566,"meh-blank"],
      'f5a4',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faMehBlank = faFaceMehBlank;
  

  
  

  var faForwardFast = {
    prefix: 'fasds',
    iconName: 'forward-fast',
    icon: [
      512,
      512,
      [9197,"fast-forward"],
      'f050',
      
      ['M448 64l64 0 0 32 0 320 0 32-64 0 0-32 0-136 0-48 0-136 0-32z','M448 280L224 448l0-168L0 448 0 64 224 232l0-168L448 232l0 48z']
      
    ]
  };

  
    var faFastForward = faForwardFast;
  

  
  

  var faWineGlass = {
    prefix: 'fasds',
    iconName: 'wine-glass',
    icon: [
      320,
      512,
      [127863],
      'f4e3',
      
      ['M14.5 192.7L32 0 288 0l17.5 192.7c.4 4.5 .6 9 .6 13.4c0 68.9-48.4 127.7-114.1 142.4l0 99.5 80 0 0 64-112 0L48 512l0-64 80 0 0-99.5C58 332.9 7.7 267.3 14.5 192.7zm63.7 5.8C73.9 246.5 111.7 288 160 288s86.1-41.5 81.8-89.5c-2.1-23.5-4.3-47-6.4-70.5c-1.9-21.3-3.9-42.7-5.8-64L90.4 64l-5.8 64c-2.1 23.5-4.3 47-6.4 70.5z','M84.6 128l-6.4 70.5C73.9 246.5 111.7 288 160 288s86.1-41.5 81.8-89.5L235.4 128 84.6 128z']
      
    ]
  };

  

  
  

  var faTags = {
    prefix: 'fasds',
    iconName: 'tags',
    icon: [
      512,
      512,
      [],
      'f02c',
      
      ['M303 65L454.2 216.2l0 79.6L303 447 337 481 495.2 322.7l7-7 0-9.9 0-99.5 0-9.9-7-7L337 31 303 65z','M0 32L0 256 224 480 416 288l0-64L224 32 0 32zm112 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faArrowTurnRight = {
    prefix: 'fasds',
    iconName: 'arrow-turn-right',
    icon: [
      512,
      512,
      [],
      'e635',
      
      ['M0 192l0 32L0 448l0 32 64 0 0-32 0-192 322.7 0 32-32-32-32L32 192 0 192z','M336 397.3l22.6-22.6 128-128L509.3 224l-22.6-22.6-128-128L336 50.7 290.7 96l22.6 22.6L418.7 224 313.4 329.4 290.7 352 336 397.3z']
      
    ]
  };

  

  
  

  var faHeadSideMedical = {
    prefix: 'fasds',
    iconName: 'head-side-medical',
    icon: [
      512,
      512,
      [],
      'f809',
      
      ['M0 224.2C0 100.6 100.2 0 224 0l32 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8c-41-41.9-64-98.3-64-157zM128 160l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0z','M256 96l-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64z']
      
    ]
  };

  

  
  

  var faFileCircleMinus = {
    prefix: 'fasds',
    iconName: 'file-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ed',
      
      ['M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0z','M384 160l-160 0L224 0 384 160zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 16l0-32-16 0-128 0-16 0 0 32 16 0 128 0 16 0z']
      
    ]
  };

  

  
  

  var faUserTieHairLong = {
    prefix: 'fasds',
    iconName: 'user-tie-hair-long',
    icon: [
      448,
      512,
      [],
      'e460',
      
      ['M128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-11.2-1.9-22-5.5-32L256 96 240 80l-32 32-78.7 0c-.9 5.2-1.3 10.5-1.3 16z','M320 128c0-11.2-1.9-22-5.5-32L256 96 240 80l-32 32-78.7 0c-.9 5.2-1.3 10.5-1.3 16l0 16c0 53 43 96 96 96s96-43 96-96l0-16zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128l0 16 0 48 48 48 0 32-176 0L48 272l0-32 48-48 0-48 0-16zM280 512l-14.9 0-82.3 0L168 512 0 512 64 320l71.8 0 39.9 163.1 33.4-123.9L176 304l48 0 48 0-33.1 55.2 33.4 123.9L312.2 320l71.8 0 64 192-168 0z']
      
    ]
  };

  

  
  

  var faTeethOpen = {
    prefix: 'fasds',
    iconName: 'teeth-open',
    icon: [
      576,
      512,
      [],
      'f62f',
      
      ['M48 176l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 144l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0zM176 144l0 80 96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 176l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0zM304 144l0 80 96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 176l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0zM432 176l0 48 96 0 0-48c0-26.5-21.5-48-48-48s-48 21.5-48 48zm0 144l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48-96 0z','M576 32L0 32 0 256l576 0 0-224zM224 96c26.5 0 48 21.5 48 48l0 80-96 0 0-80c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80-96 0 0-80zM96 128c26.5 0 48 21.5 48 48l0 48-96 0 0-48c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 48-96 0 0-48zM576 480l0-192L0 288 0 480l576 0zM96 416c-26.5 0-48-21.5-48-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48zm80-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48zm80-48l0-48 96 0 0 48c0 26.5-21.5 48-48 48s-48-21.5-48-48z']
      
    ]
  };

  

  
  

  var faCommentMedical = {
    prefix: 'fasds',
    iconName: 'comment-medical',
    icon: [
      512,
      512,
      [],
      'f7f5',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160-32l64 0 0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64z','M288 144l-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64z']
      
    ]
  };

  

  
  

  var faPanorama = {
    prefix: 'fasds',
    iconName: 'panorama',
    icon: [
      640,
      512,
      [],
      'e209',
      
      ['M0 32L0 64 0 448l0 32 32 0 16 0 5.5 0 5.2-1.9c.4-.1 .6-.2 .9-.3c.7-.2 1.8-.6 3.4-1.1c3.1-1 7.7-2.5 13.9-4.2c12.3-3.5 30.5-8.3 53.7-13.2C176.8 449.7 242.6 440 320 440s143.2 9.7 189.5 19.3c23.1 4.8 41.4 9.6 53.7 13.2c6.2 1.8 10.8 3.2 13.9 4.2c1.5 .5 2.7 .9 3.4 1.1l.7 .3c1.9 .7 3.6 1.3 5.3 1.9l5.5 0 16 0 32 0 0-32 0-384 0-32-32 0-16 0-5.5 0-5.2 1.9c-.4 .1-.6 .2-.9 .3c-.7 .2-1.8 .6-3.4 1.1c-3.1 1-7.7 2.5-13.9 4.2c-12.3 3.5-30.5 8.3-53.7 13.2C463.2 62.3 397.4 72 320 72s-143.2-9.7-189.5-19.3c-23.1-4.8-41.4-9.6-53.7-13.2c-6.2-1.8-10.8-3.2-13.9-4.2c-1.5-.5-2.7-.9-3.4-1.1l-.7-.3c-1.9-.7-3.6-1.3-5.3-1.9L48 32 32 32 0 32zM88.4 401l39.5-49.3c23.1-28.9 46.2-57.8 69.4-86.7L216 241.6 234.7 265c8.8 11 17.6 22 26.4 33.1c29-42.5 58-85 87-127.6c6.6-9.7 13.2-19.4 19.8-29.1c6.6 9.7 13.2 19.4 19.8 29.1c41.5 60.9 83 121.7 124.5 182.6c10.6 15.6 21.2 31.1 31.8 46.7c-18.6-3.2-37.1-6.3-55.7-9.5C442.7 382.4 385.2 376 320 376c-19 0-37.3 .5-54.9 1.5c-.3 .4-.6 .8-.8 1.2l-.9-1.1c-42.5 2.4-80.5 7.3-112.7 12.8c-20.7 3.6-41.5 7.1-62.2 10.7zM160 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M387.8 170.5L368 141.4l-19.8 29.1-87 127.6L234.7 265 216 241.6 197.3 265l-69.4 86.7L88.4 401l62.2-10.7c32.2-5.5 70.2-10.4 112.7-12.8l.9 1.1 .8-1.2c17.6-1 35.9-1.5 54.9-1.5c65.2 0 122.7 6.4 168.4 14.2l55.7 9.5L512.3 353 387.8 170.5z']
      
    ]
  };

  

  
  

  var faClipboardQuestion = {
    prefix: 'fasds',
    iconName: 'clipboard-question',
    icon: [
      384,
      512,
      [],
      'e4e3',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-24 0-48 0-24 80 0 0 448L0 512 0 64zM104 264l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L168 316.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.1 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L160 208c-30.9 0-56 25.1-56 56zm64 152l0 48 48 0 0-48-48 0z','M270.4 64L304 64l0 96-112 0L80 160l0-96 33.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM104 264c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 344.4l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L160 256c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 200l0-48 48 0 0 48-48 0z']
      
    ]
  };

  

  
  

  var faCartCircleCheck = {
    prefix: 'fasds',
    iconName: 'cart-circle-check',
    icon: [
      640,
      512,
      [],
      'e3f1',
      
      ['M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L525.2 194.4c-9.5-1.6-19.3-2.4-29.2-2.4c-68.4 0-127.7 39-156.8 96l-168.5 0 9.1 48 143 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L160 384l-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM224 464a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faRoute = {
    prefix: 'fasds',
    iconName: 'route',
    icon: [
      512,
      512,
      [],
      'f4d7',
      
      ['M96 512l384 0 32 0 0-32 0-128 0-32-32 0-192 0 0-64 128 0s-1.8-1.8-4.8-4.9s-7.4-7.8-12.5-13.6C388.5 226 375 210 362.1 192L256 192l-32 0 0 32 0 128 0 32 32 0 192 0 0 64-298.1 0C124.1 483.9 96 512 96 512z','M512 96c0 64-96 160-96 160s-96-96-96-160c0-53 43-96 96-96s96 43 96 96zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 352c0 64-96 160-96 160s-96-96-96-160c0-53 43-96 96-96s96 43 96 96zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z']
      
    ]
  };

  

  
  

  var faTruckField = {
    prefix: 'fasds',
    iconName: 'truck-field',
    icon: [
      640,
      512,
      [],
      'e58d',
      
      ['M96 400a80 80 0 1 0 160 0A80 80 0 1 0 96 400zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M32 32l352 0 0 32 64 0 20.8 0 8.4 19 62.7 141 68.1 0 0 96 32 0 0 64-32 0-33.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L32 384 0 384l0-64 32 0 0-32L0 288 0 128l32 0 0-96zM384 224l85.9 0-42.7-96L384 128l0 96z']
      
    ]
  };

  

  
  

  var faBasketShoppingPlus = {
    prefix: 'fasds',
    iconName: 'basket-shopping-plus',
    icon: [
      576,
      512,
      [],
      'e653',
      
      ['M0 192l124.4 0 53.2 0 220.7 0 53.2 0L576 192l0 64-32 0L480 512 96 512 32 256 0 256l0-64zM184 328l0 48 24 0 56 0 0 56 0 24 48 0 0-24 0-56 56 0 24 0 0-48-24 0-56 0 0-56 0-24-48 0 0 24 0 56-56 0-24 0z','M245.6 50.4L177.7 192l-53.2 0L202.4 29.6 212.7 8 256 28.7 245.6 50.4zm128-20.8L451.6 192l-53.2 0-68-141.6L320 28.7 363.3 8l10.4 21.6zM264 432l0-56-56 0-24 0 0-48 24 0 56 0 0-56 0-24 48 0 0 24 0 56 56 0 24 0 0 48-24 0-56 0 0 56 0 24-48 0 0-24z']
      
    ]
  };

  

  
  

  var faUserCrown = {
    prefix: 'fasds',
    iconName: 'user-crown',
    icon: [
      448,
      512,
      [],
      'f6a4',
      
      ['M96 128l32 0 16 0 160 0 16 0 32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M96 53.7L96 0l48 24 16 8L224 0l64 32 16-8L352 0l0 53.7L352 80l0 48-32 0-16 0-160 0-16 0-32 0 0-48 0-26.3zM384 304l64 208L0 512 64 304l320 0z']
      
    ]
  };

  

  
  

  var faFaceClouds = {
    prefix: 'fasds',
    iconName: 'face-clouds',
    icon: [
      640,
      512,
      [],
      'e47d',
      
      ['M64 256c0 107.4 66.2 199.4 160 237.4l0-29.4c0-54.7 34.3-101.3 82.5-119.7C317.4 293.8 362.3 256 416 256c29.1 0 55.6 11.1 75.5 29.2c8.9-3.4 18.5-5.2 28.5-5.2c20 0 38.3 7.3 52.3 19.5c2.4-14.1 3.7-28.7 3.7-43.5C576 114.6 461.4 0 320 0c-20.6 0-40.7 2.4-59.9 7C295.2 21.3 320 55.8 320 96l0 64 0 32-32 0-19.9 0c2.7 4.7 4.3 10.2 4.3 16c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-5.8 1.6-11.3 4.3-16L72.1 192c-5.3 20.5-8.1 41.9-8.1 64zm368.4-48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M128 0C104.3 0 83.6 12.9 72.6 32L64 32C28.7 32 0 60.7 0 96l0 64 224 0 64 0 0-64c0-35.3-28.7-64-64-64l-40.6 0C172.4 12.9 151.7 0 128 0zM336 368c0 .4 0 .9 0 1.3c-45.4 7.6-80 47.1-80 94.7l0 48 384 0 0-48c0-44.7-30.6-82.3-72-93l0-11c0-26.5-21.5-48-48-48c-13.9 0-26.4 5.9-35.1 15.3C470.9 303.8 445.3 288 416 288c-44.2 0-80 35.8-80 80z']
      
    ]
  };

  

  
  

  var faAnchorCircleExclamation = {
    prefix: 'fasds',
    iconName: 'anchor-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ab',
      
      ['M0 352l64 0 0 128 0 32 32 0 192 0 106.8 0c-23.3-16.4-42.5-38.4-55.6-64L320 448l0-79.5 0-.5 0-.5L320 240l32 0 23.2 0c2.8-2.7 5.8-5.3 8.8-7.8l0-56.2-32 0-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faFiles = {
    prefix: 'fasds',
    iconName: 'files',
    icon: [
      448,
      512,
      [],
      'e178',
      
      ['M96 0L352 0l0 96 96 0 0 320L96 416 96 0z','M352 0l0 96 96 0L352 0zM48 120l0-24L0 96l0 24L0 488l0 24 24 0 304 0 24 0 0-48-24 0L48 464l0-344z']
      
    ]
  };

  

  
  

  var faCircleCaretLeft = {
    prefix: 'fasds',
    iconName: 'circle-caret-left',
    icon: [
      512,
      512,
      ["caret-circle-left"],
      'f32e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144 0L272 128l32 0 0 256-32 0L144 256z','M304 384l-32 0L144 256 272 128l32 0 0 256z']
      
    ]
  };

  
    var faCaretCircleLeft = faCircleCaretLeft;
  

  
  

  var faTrashXmark = {
    prefix: 'fasds',
    iconName: 'trash-xmark',
    icon: [
      448,
      512,
      [],
      'e2b4',
      
      ['M32 96L56 512l336 0L416 96 32 96zm94.1 128L160 190.1l17 17 47 47 47-47 17-17L321.9 224l-17 17-47 47 47 47 17 17L288 385.9l-17-17-47-47-47 47-17 17L126.1 352l17-17 47-47-47-47-17-17z','M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zM321.9 224l-17 17-47 47 47 47 17 17L288 385.9l-17-17-47-47-47 47-17 17L126.1 352l17-17 47-47-47-47-17-17L160 190.1l17 17 47 47 47-47 17-17L321.9 224z']
      
    ]
  };

  

  
  

  var faCat = {
    prefix: 'fasds',
    iconName: 'cat',
    icon: [
      576,
      512,
      [128008],
      'f6be',
      
      ['M171.8 261.9c17.4 8.7 34.8 17.4 52.2 26.1c0-23.4 0-46.9 0-70.3c-19.9 11.5-37.6 26.6-52.2 44.2zM241 209c15.7 15.7 31.4 31.4 47 47c4.2-21 8.4-42 12.6-63c-21.1 2.1-41.1 7.6-59.6 16z','M337.1 192L320 192c-6.5 0-13 .3-19.4 1L288 256l-47-47c-5.8 2.6-11.5 5.5-17 8.7l0 70.3-52.2-26.1c-4.2 5.1-8.1 10.4-11.8 15.9l0-21.8 0-64c0-53-43-96-96-96L32 96l0 64 32 0c17.7 0 32 14.3 32 32l0 288 0 32 32 0 208 0 32 0 0-64-32 0-56 0L416 339.2 416 480l0 32 64 0 0-32 0-192 0-32 0-4c-10.2 2.6-21 4-32 4c-47.4 0-88.7-25.7-110.9-64zm194.3-16.4c8-14 12.6-30.3 12.6-47.6l0-82.7L544 0 512 32 480 64s0 0 0 0l-64 0s0 0 0 0L384 32 352 0l0 45.3 0 82.7s0 0 0 0c0 18.6 5.3 36 14.5 50.8c2.9 4.7 6.3 9.1 9.9 13.2c0 0 0 0 0 0c17.6 19.6 43.1 32 71.6 32c11.2 0 22-1.9 32-5.5c0 0 0 0 0 0c21.8-7.7 40-23.1 51.4-42.9zM400 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faTruckFront = {
    prefix: 'fasds',
    iconName: 'truck-front',
    icon: [
      512,
      512,
      [],
      'e2b7',
      
      ['M32 448l96 0 0 64-96 0 0-64zm80-224l24-96 240 0 24 96-288 0zM384 448l96 0 0 64-96 0 0-64z','M512 0L0 0 0 448l512 0L512 0zM112 224l24-96 240 0 24 96-288 0zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faSquareQuarters = {
    prefix: 'fasds',
    iconName: 'square-quarters',
    icon: [
      448,
      512,
      [],
      'e44e',
      
      ['M64 96l0 320L224 256 64 96zM224 256L384 416l0-320L224 256z','M384 96l0 320L64 416 64 96l320 0zM64 32L0 32 0 96 0 416l0 64 64 0 320 0 64 0 0-64 0-320 0-64-64 0L64 32z']
      
    ]
  };

  

  
  

  var faFileDoc = {
    prefix: 'fasds',
    iconName: 'file-doc',
    icon: [
      512,
      512,
      [],
      'e5ed',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM176 352l-16 0 0 16 0 128 0 16 16 0 32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm16 128l0-96 16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-16 0zM456 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8 0-16-32 0 0 16 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8 0 16 32 0 0-16 0-8c0-22.1-17.9-40-40-40l-16 0zM288 392l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8z']
      
    ]
  };

  

  
  

  var faArrowDownFromDottedLine = {
    prefix: 'fasds',
    iconName: 'arrow-down-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e090',
      
      ['M0 34.7l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z','M224 480l22.6-22.6 128-128 22.6-22.6L352 261.5l-22.6 22.6L256 357.5l0-162.7 0-32-64 0 0 32 0 162.7-73.4-73.4L96 261.5 50.7 306.7l22.6 22.6 128 128L224 480z']
      
    ]
  };

  

  
  

  var faPhoneFlip = {
    prefix: 'fasds',
    iconName: 'phone-flip',
    icon: [
      512,
      512,
      [128381,"phone-alt"],
      'f879',
      
      ['M12.4 411.6l5.7 31.5c2.2-.3 4.4-.6 6.6-.9s4.4-.6 6.6-1c4.4-.7 8.7-1.4 13.1-2.2c8.7-1.6 17.3-3.4 25.8-5.5c17-4.1 33.7-9 50-14.8c32.5-11.6 63.5-26.5 92.5-44.3l-20.5-25c-53.7 32.4-114.6 54.1-179.7 62.2zm337-219.5c8.3 6.8 16.7 13.6 25 20.5c35.7-58 59.7-123.9 68.7-194.5c-10.5-1.9-21-3.8-31.5-5.7c-8.1 65.1-29.8 126-62.2 179.7z','M443.1 18.1l36 6.5 32.8 6L512 64c0 247.4-200.6 448-448 448l-33.4 0-6-32.8-6.6-36c221.3-28.4 396.7-203.7 425.1-425zM12.4 411.6L8.6 391.2 3.1 360.5l28.4-12.9 88-40 28-12.7L167 318.7l25.1 30.7c-53.7 32.4-114.6 54.1-179.7 62.2zm337-219.5L318.7 167l-23.8-19.5 12.7-28 40-88L360.5 3.1l30.7 5.6 20.5 3.7c-8.1 65.1-29.8 126-62.2 179.7z']
      
    ]
  };

  
    var faPhoneAlt = faPhoneFlip;
  

  
  

  var faBridge = {
    prefix: 'fasds',
    iconName: 'bridge',
    icon: [
      576,
      512,
      [],
      'e4c8',
      
      ['M0 32l32 0 512 0 32 0 0 64-32 0-40 0 0 64-48 0 0-64-80 0 0 64-48 0 0-64-80 0 0 64-48 0 0-64-80 0 0 64-48 0 0-64L32 96 0 96 0 32z','M0 160H576V288c-53 0-96 43-96 96v96H384V384c0-53-43-96-96-96s-96 43-96 96v96H96V384c0-53-43-96-96-96V160z']
      
    ]
  };

  

  
  

  var faHatCowboy = {
    prefix: 'fasds',
    iconName: 'hat-cowboy',
    icon: [
      640,
      512,
      [],
      'f8c0',
      
      ['M141.1 290.8C186.8 307.1 246.2 320 320 320c2.3 0 4.6 0 6.9 0s4.5-.1 6.8-.1c4.5-.1 8.9-.2 13.3-.4c8.8-.4 17.3-1 25.7-1.7c16.7-1.5 32.4-3.6 47.3-6.2c29.8-5.3 56.1-12.6 78.9-20.7l-20.4-70.5C431.8 243 377.7 256 320 256s-111.8-13-158.5-35.7l-20.4 70.5z','M216 32L161.5 220.3C208.2 243 262.3 256 320 256s111.8-13 158.5-35.7L424 32 320 80 216 32zM24 224L0 256s96 192 320 192s320-192 320-192l-24-32s-94.5 96-296 96s-296-96-296-96z']
      
    ]
  };

  

  
  

  var faWarehouseFull = {
    prefix: 'fasds',
    iconName: 'warehouse-full',
    icon: [
      640,
      512,
      ["warehouse-alt"],
      'f495',
      
      ['M128 224l192 0 0 128-192 0 0-128zm0 160l192 0 0 128-192 0 0-128zm224 0l160 0 0 128-160 0 0-128z','M0 128V512H96V192H544V512h96V128L320 0 0 128z']
      
    ]
  };

  
    var faWarehouseAlt = faWarehouseFull;
  

  
  

  var faCodeBranch = {
    prefix: 'fasds',
    iconName: 'code-branch',
    icon: [
      448,
      512,
      [],
      'f126',
      
      ['M48 160l8 0 48 0 8 0 0 81.1c18.8-10.9 40.7-17.1 64-17.1l96 0c35.3 0 64-28.7 64-64l8 0 48 0 8 0c0 70.7-57.3 128-128 128l-96 0c-35.3 0-64 28.7-64 64l-8 0-48 0-8 0 0-192z','M104 56l0 48-48 0 0-48 48 0zM56 0L0 0 0 56l0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56L104 0 56 0zM392 56l0 48-48 0 0-48 48 0zM344 0L288 0l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56L392 0 344 0zM56 408l48 0 0 48-48 0 0-48zM0 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0L0 352z']
      
    ]
  };

  

  
  

  var faObjectSubtract = {
    prefix: 'fasds',
    iconName: 'object-subtract',
    icon: [
      512,
      512,
      [],
      'e49e',
      
      ['M0 0L0 64 0 288l0 64 64 0 96 0 128 0 64 0 0-64 0-128 0-96 0-64L288 0 64 0 0 0zM64 64l224 0 0 224L64 288 64 64z','M160 512l352 0 0-352-160 0 0 192-192 0 0 160z']
      
    ]
  };

  

  
  

  var faHouseWater = {
    prefix: 'fasds',
    iconName: 'house-water',
    icon: [
      576,
      512,
      ["house-flood"],
      'f74f',
      
      ['M0 240l0 47.6 64.1 0 0 103.3c3.8-2.6 7.8-5.5 12.2-8.7c.4-.3 .8-.5 1.1-.8L96 368l18.6 13.4 1.1 .8c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c.4-.3 .8-.5 1.1-.8L288 368l19.7 14.2c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5L480 368l19.7 14.2c4.5 3.3 8.6 6.2 12.5 8.9l-.5-103.5 64.2 0 0-47.6L288.4 0 0 240zm224-24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80z','M272.4 493.1c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9z']
      
    ]
  };

  
    var faHouseFlood = faHouseWater;
  

  
  

  var faPopcorn = {
    prefix: 'fasds',
    iconName: 'popcorn',
    icon: [
      448,
      512,
      [127871],
      'f819',
      
      ['M32 156c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4c0 .4-.1 .8-.1 1.2c-3.3-.8-6.7-1.2-10.2-1.2l-77.3 0-208.4 0-77.3 0-10.3 0c-.1-1.3-.2-2.7-.2-4z','M0 160L80 512l288 0 80-352L0 160zM130.1 464L93.6 208l32.3 0 36.6 256-32.3 0zm155.4 0l36.6-256 32.3 0L317.9 464l-32.3 0zM240 464l-32 0 0-16 0-224 0-16 32 0 0 16 0 224 0 16z']
      
    ]
  };

  

  
  

  var faFaceHandOverMouth = {
    prefix: 'fasds',
    iconName: 'face-hand-over-mouth',
    icon: [
      512,
      512,
      [129762],
      'e378',
      
      ['M0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-82.4 0-32 32 0 40 0 21.7 0 51.7-51.7L280 228.1l22.6 22.6 9.4 9.4 16-16 22.6 22.6 22.6 22.6L395.9 312l-16 16 9.4 9.4L411.9 360l-22.6 22.6-9.4 9.4 9.4 9.4L411.9 424l-22.6 22.6-52.3 52.3C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm208.4-64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-1.7 104l-11.3 11.3-56 56 9.4 9.4 72-72L328 289.4 350.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L344 337.4 366.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L344 401.4 366.6 424l-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-12.8 0-20 0-29.6 0-20 40 0 0 20 0 15 84.7-84.7L280 273.4 302.6 296z']
      
    ]
  };

  

  
  

  var faCircleK = {
    prefix: 'fasds',
    iconName: 'circle-k',
    icon: [
      512,
      512,
      [],
      'e113',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l48 0 0 24 0 83.8L222.1 220l82.5-92 64.5 0-1 1.1L270.3 238.3 362 376.7l4.8 7.3-57.6 0L237.1 275.2 208 307.7l0 52.3 0 24-48 0 0-24 0-61.5L160 152l0-24z','M304.6 128l64.5 0-1 1.1L270.3 238.3 362 376.7l4.8 7.3-57.6 0L237.1 275.2 208 307.7l0 52.3 0 24-48 0 0-24 0-61.5L160 152l0-24 48 0 0 24 0 83.8L222.1 220l82.5-92z']
      
    ]
  };

  

  
  

  var faArrowRightFromArc = {
    prefix: 'fasds',
    iconName: 'arrow-right-from-arc',
    icon: [
      512,
      512,
      [],
      'e4b1',
      
      ['M0 256C0 397.4 114.6 512 256 512l32 0 0-64-32 0C150 448 64 362 64 256S150 64 256 64l32 0 0-64L256 0C114.6 0 0 114.6 0 256z','M352 98.7l22.6 22.6 112 112L509.3 256l-22.6 22.6-112 112L352 413.3 306.7 368l22.6-22.6L386.7 288 192 288l-32 0 0-64 32 0 194.7 0-57.4-57.4L306.7 144 352 98.7z']
      
    ]
  };

  

  
  

  var faTypewriter = {
    prefix: 'fasds',
    iconName: 'typewriter',
    icon: [
      512,
      512,
      [],
      'f8e7',
      
      ['M64 0L96 0 352 0l0 96 96 0 0 96-96 0-32 32-128 0-32-32-96 0L64 32 64 0z','M448 80l0 16-96 0 0-96 16 0 13.3 0 9.4 9.4 48 48 9.4 9.4L448 80zM0 288l0-96 160 0 32 32 128 0 32-32 160 0 0 96-32 0 0 224L32 512l0-224L0 288zm400 0l0 32 32 0 0-32-32 0zm-64 32l32 0 0-32-32 0 0 32zm-64-32l0 32 32 0 0-32-32 0zm-64 0l0 32 32 0 0-32-32 0zm-64 0l0 32 32 0 0-32-32 0zm-64 0l0 32 32 0 0-32-32 0zm64 128l0 32 16 0 192 0 16 0 0-32-16 0-192 0-16 0zm0-64l-32 0 0 32 32 0 0-32zm32 0l0 32 32 0 0-32-32 0zm96 0l-32 0 0 32 32 0 0-32zm32 0l0 32 32 0 0-32-32 0zm96 0l-32 0 0 32 32 0 0-32z']
      
    ]
  };

  

  
  

  var faCanFood = {
    prefix: 'fasds',
    iconName: 'can-food',
    icon: [
      384,
      512,
      [129387],
      'e3e6',
      
      ['M16 64c0 1.3 .1 2.5 .3 3.8C21.7 101.4 98.3 128 192 128s170.3-26.6 175.7-60.2c.2-1.2 .3-2.5 .3-3.8c0-35.3-78.8-64-176-64S16 28.7 16 64zm96 160l0 66.1 0 93.9 160 0 0-93.9 0-66.1c-53.3 0-106.7 0-160 0z','M320 434.3l0-158.9c-13.8 6-30 11-48 14.7l0-66.1-160 0 0 66.1c-18-3.8-34.2-8.8-48-14.7l0 158.9c3.4 3 10.2 7.5 21.7 12.2C110.5 456.6 148.1 464 192 464s81.5-7.4 106.3-17.5c11.5-4.7 18.3-9.2 21.7-12.2zm48 5.7c0 39.8-78.8 72-176 72s-176-32.2-176-72L16 72c0-1.4 .1-2.8 .3-4.2C21.7 101.4 98.3 128 192 128s170.3-26.6 175.7-60.2c.2 1.4 .3 2.8 .3 4.2l0 368z']
      
    ]
  };

  

  
  

  var faBorderCenterH = {
    prefix: 'fasds',
    iconName: 'border-center-h',
    icon: [
      448,
      512,
      [],
      'f89c',
      
      ['M0 32l64 0 0 64L0 96 0 32zm0 96l64 0 0 64L0 192l0-64zM0 320l64 0 0 64L0 384l0-64zm0 96l64 0 0 64L0 480l0-64zM96 32l64 0 0 64L96 96l0-64zm0 384l64 0 0 64-64 0 0-64zM192 32l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zM288 32l64 0 0 64-64 0 0-64zm0 384l64 0 0 64-64 0 0-64zM384 32l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M0 224l32 0 384 0 32 0 0 64-32 0L32 288 0 288l0-64z']
      
    ]
  };

  

  
  

  var faBookBookmark = {
    prefix: 'fasds',
    iconName: 'book-bookmark',
    icon: [
      448,
      512,
      [],
      'e0bb',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 352 0l0 224-80-64-80 64L192 0 96 0z']
      
    ]
  };

  

  
  

  var faHandshakeSlash = {
    prefix: 'fasds',
    iconName: 'handshake-slash',
    icon: [
      640,
      512,
      [],
      'e060',
      
      ['M0 128L0 384l96 0 0-212.4L40.6 128 0 128zM64 336a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64-139.2L128 352l28.2 0 73.9 67.4 35.4 32.4 47.7-52.2 22.3 20.5 35.4 32.4 34.2-37.3L128 196.8zm35.6-92.6c14.5 11.3 29.1 22.6 43.6 33.9L298.8 64 224 64l-60.4 40.3zm69.6 54c21.2 16.4 42.4 32.9 63.5 49.3l77.4-60.2 12.6-9.8 19.6 25.3-12.6 9.8-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L411.3 64l-61.7 0L233.2 158.3zm89.6 69.6C384.9 276.1 447 324.2 509 372.4l6.8-7.4-35.4-32.4-134.2-123-23.4 18.2zM544 128l0 256 96 0 0-256-96 0zm64 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faPlaneDeparture = {
    prefix: 'fasds',
    iconName: 'plane-departure',
    icon: [
      640,
      512,
      [128747],
      'f5b0',
      
      ['M0 448l32 0 576 0 32 0 0 64-32 0L32 512 0 512l0-64z','M381 114.9L160 32 64 80 234.6 189.7 136 240 64 208 0 240 96 352l160 0L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48l-57.4 0c-20.2 0-40.2 4.8-58.2 14L381 114.9z']
      
    ]
  };

  

  
  

  var faBuoy = {
    prefix: 'fasds',
    iconName: 'buoy',
    icon: [
      576,
      512,
      [],
      'e5b5',
      
      ['M0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448zM160 0l0 64 25 0 65.3 0 75.5 0L391 64l25 0 0-64L160 0z','M442.2 320L391 64l-65.3 0 9.8 49L288 168.5 240.4 113l9.8-49L185 64 133.8 320 64 320l0 70.9c3.8-2.6 7.8-5.5 12.3-8.7l1.1-.8L96 368l18.6 13.4 1.1 .8s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0l1.1-.8L288 368l19.7 14.2s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L480 368l19.7 14.2c4.4 3.2 8.5 6.1 12.3 8.7l0-70.9-69.8 0zM347.5 172.8l17 84.9-44.9-52.4 27.9-32.6zm-91.1 32.6l-44.9 52.4 17-84.9 27.9 32.6zM221.3 320L288 242.2 354.7 320l-133.4 0z']
      
    ]
  };

  

  
  

  var faImageUser = {
    prefix: 'fasds',
    iconName: 'image-user',
    icon: [
      512,
      512,
      [],
      'e1b8',
      
      ['M0 32L0 480l512 0 0-448L0 32zM144 384l32-96 160 0 32 96-224 0zM320 192a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M256 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM368 384l-32-96-160 0-32 96 224 0z']
      
    ]
  };

  

  
  

  var faTicketsPerforated = {
    prefix: 'fasds',
    iconName: 'tickets-perforated',
    icon: [
      640,
      512,
      [],
      'e63f',
      
      ['M96 32l544 0 0 128c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 128L96 384 96 32zm416 80a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312zm496-8a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fasds',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm168-72c0-.5 0-1 0 0zm64 152l48 0c0 16 0 32 0 48l-48 0c0-16 0-32 0-48z','M224 128c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 236.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 128zm56 208l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faFileImage = {
    prefix: 'fasds',
    iconName: 'file-image',
    icon: [
      384,
      512,
      [128443],
      'f1c5',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM64 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 160l0 32 64 0 64 0 128 0 0-32L224 288l-63.5 84.7L128 328 64 416z','M384 160l-160 0L224 0 384 160zM320 416l0 32-128 0-64 0-64 0 0-32 64-88 32.5 44.7L224 288l96 128z']
      
    ]
  };

  

  
  

  var faRupeeSign = {
    prefix: 'fasds',
    iconName: 'rupee-sign',
    icon: [
      448,
      512,
      [8360,"rupee"],
      'f156',
      
      ['M246.6 447.5l29.8 11.6c1.7 .6 3.8 1.5 6.3 2.5c5.2 2.1 11.7 4.7 17.7 6.9c8.7 3.3 19.9 7.2 29.3 9c8.8 1.6 17.5 2.5 26.2 2.5c16.5 0 32.7-3.1 47.2-10.4c23.3-11.6 39.6-32.8 43.8-60.9c.8-5.2 1.2-10.3 1.2-15.3c0-10-1.6-19.6-5-28.7c-5.1-13.7-13.6-24.3-23.1-32.3c-17.1-14.5-39.7-22.5-55.7-28.1c-.4-.2-.9-.3-1.3-.5c-19.2-6.8-30.7-11.1-37.9-16.8c-2.8-2.2-3.7-3.8-4.2-4.9c-.4-1-1.3-3.8-.4-9.8c.7-4.5 3.2-8.7 9.5-12c6.8-3.6 18-5.9 32.6-3.2c5.6 1 23.3 5.1 27.9 6.5l30.6 9.5L440 212l-30.6-9.5c-8.1-2.5-28.5-7.1-35.4-8.4c-49.9-9.1-108.5 11.8-116.9 68.9c-2.2 15.2-1.1 29.8 4.4 43.2c5.4 13.4 14.2 23.5 23.7 31c16.3 12.9 37.8 20.5 53.3 25.9c1 .4 2.1 .7 3 1.1c18.7 6.6 30.1 11.2 36.9 17c2.7 2.3 3.9 4.2 4.5 5.9c.6 1.7 1.5 5.4 .5 12.3c-1 7-4.1 10.6-9.1 13c-6.2 3.1-17.2 5.1-32.9 2.3c-3.4-.7-9.9-2.7-18.7-6c-5.5-2.1-10.6-4.1-15.4-6c-2.7-1.1-5.4-2.1-7.9-3.1l-29.8-11.6-23.2 59.7z','M32 32L0 32 0 64 0 288 0 480l64 0 0-160 40.6 0 51.2 160 67.2 0-.6-1.8L168.2 308.6c51.6-21.9 87.8-73 87.8-132.6c0-79.5-64.5-144-144-144L32 32zm80 224l-48 0L64 96l48 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z']
      
    ]
  };

  
    var faRupee = faRupeeSign;
  

  
  

  var faDiagramNested = {
    prefix: 'fasds',
    iconName: 'diagram-nested',
    icon: [
      448,
      512,
      [],
      'e157',
      
      ['M64 224l0 160 0 32 32 0 160 0 0-64-128 0 0-128-64 0z','M192 32L0 32 0 224l192 0 0-192zM448 288l-192 0 0 192 192 0 0-192z']
      
    ]
  };

  

  
  

  var faVectorPolygon = {
    prefix: 'fasds',
    iconName: 'vector-polygon',
    icon: [
      448,
      512,
      [],
      'e2c7',
      
      ['M32 160l0 192 64 0 0-192-64 0zm96-96l0 64 192 0 0-64L128 64zm0 320l0 64 192 0 0-64-192 0zM292.3 192l27.7 0c15.5 0 28.4 11 31.4 25.6l.6-1.1 27.8-48.6 4.5-7.9L320 160l0-16.5L292.3 192zm0 128L320 368.5l0-16.5 32 0 32.3 0-4.5-7.9L352 295.5l0 24.5-32 0-27.7 0z','M128 32L0 32 0 160l128 0 0-128zM80 80l0 32-32 0 0-32 32 0zM448 32L320 32l0 128 128 0 0-128zM400 80l0 32-32 0 0-32 32 0zM0 352L0 480l128 0 0-128L0 352zm48 48l32 0 0 32-32 0 0-32zm400-48l-128 0 0 128 128 0 0-128zm-48 48l0 32-32 0 0-32 32 0zM224 192l0 128 128 0 0-128-128 0zm48 48l32 0 0 32-32 0 0-32z']
      
    ]
  };

  

  
  

  var faBugs = {
    prefix: 'fasds',
    iconName: 'bugs',
    icon: [
      576,
      512,
      [],
      'e4d0',
      
      ['M238.3 383.6l37.8 29.6 14.8-18.9 25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l14.2 13.7L433.4 472l-8 22.6 45.3 15.9 8-22.6L495.8 439l5.1-14.5-11.1-10.7-28-27.1 11.6-20.1 27.7 16 17 9.8 13-14.8L558.2 347 574 329l-36.1-31.7-15.8 18-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2l65.6-47 19.5-14-27.9-39-19.5 14-51.4 36.8 6.2-62.9 2.3-23.9-47.8-4.7-2.3 23.9L424.8 250c-12.3 1-24.2 5.6-34.1 13.3L376 254.8l6.8-20 7.7-22.7L345 196.7l-7.7 22.7-13.1 38.6-6.3 18.6 17 9.8 27.7 16L351 322.7 313.5 312 298 307.5l-10 12.7-34.9 44.5-14.8 18.9z','M164.5 107.4l29.7-65.5 9.9-21.9L160.4 .2l-9.9 21.9L128 71.7 105.5 22.1 95.6 .2 51.9 20.1l9.9 21.9 29.7 65.5c-10.2 7.1-18.2 17-22.9 28.6l-15.2 0-2.1-18.7L48.7 93.5 1 98.8l2.7 23.9 4.5 40L10.5 184 32 184l32 0 0 23.3-37.8 9.5-16.1 4L8.2 237.3l-6.4 56L-1 317.1l47.7 5.5 2.7-23.8L54 259.3l17.9-4.5C82.8 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l17.9 4.5 4.5 39.5 2.7 23.8 47.7-5.5-2.7-23.8-6.4-56L246 220.8l-16.1-4L192 207.3l0-23.3 32 0 21.3 0 2.5-21.1 4.8-40L255.5 99l-47.7-5.7L205 117.1 202.7 136l-15.4 0c-4.7-11.6-12.7-21.5-22.9-28.6z']
      
    ]
  };

  

  
  

  var faWrench = {
    prefix: 'fasds',
    iconName: 'wrench',
    icon: [
      512,
      512,
      [128295],
      'f0ad',
      
      ['M0 416l96 96L297.5 310.5c-44.5-16.1-79.9-51.5-96-96L0 416zm70.1-8L104 374.1 137.9 408 104 441.9 70.1 408z','M352 320c88.4 0 160-71.6 160-160c0-23.5-5.1-45.8-14.1-65.9L400 192l-80 0 0-80 97.9-97.9C397.8 5.1 375.5 0 352 0C263.6 0 192 71.6 192 160s71.6 160 160 160z']
      
    ]
  };

  

  
  

  var faArrowTurnLeft = {
    prefix: 'fasds',
    iconName: 'arrow-turn-left',
    icon: [
      512,
      512,
      [],
      'e632',
      
      ['M90.5 224l32-32 354.7 0 32 0 0 32 0 224 0 32-64 0 0-32 0-192-322.7 0c-10.7-10.7-21.3-21.3-32-32z','M173.3 397.3l-22.6-22.6-128-128L0 224l22.6-22.6 128-128 22.6-22.6L218.5 96l-22.6 22.6L90.5 224 195.9 329.4 218.5 352l-45.3 45.3z']
      
    ]
  };

  

  
  

  var faTransporter6 = {
    prefix: 'fasds',
    iconName: 'transporter-6',
    icon: [
      512,
      512,
      [],
      'e2a7',
      
      ['M0 48L32 32 48 0 64 32 96 48 64 64 48 96 32 64 0 48zM96 256l16 0 288 0 16 0 0 32-16 0-288 0-16 0 0-32zM208 0l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zM416 400l32-16 16-32 16 32 32 16-32 16-16 32-16-32-32-16z','M96 448H416v64H96V448z']
      
    ]
  };

  

  
  

  var faUtilityPole = {
    prefix: 'fasds',
    iconName: 'utility-pole',
    icon: [
      512,
      512,
      [],
      'e2c3',
      
      ['M0 32l48 0 0 24 0 8L0 64l0-8L0 32zm80 0l48 0 0 24 0 8L80 64l0-8 0-24zm3.2 96l57.7 0L224 183.4l0 38.5L83.2 128zM288 183.4L371.2 128l57.7 0L288 221.9l0-38.5zM384 32l48 0 0 24 0 8-48 0 0-8 0-24zm80 0l48 0 0 24 0 8-48 0 0-8 0-24z','M288 0V64H512v64H288V512H224V128H0V64H224V0h64z']
      
    ]
  };

  

  
  

  var faBurger = {
    prefix: 'fasds',
    iconName: 'burger',
    icon: [
      512,
      512,
      ["hamburger"],
      'f805',
      
      ['M32 192l0 32 448 0 0-32s0-160-224-160S32 192 32 192zm0 192l0 96 448 0 0-96L32 384zM144 128a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM272 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M16 256H496v96H16V256z']
      
    ]
  };

  
    var faHamburger = faBurger;
  

  
  

  var faStaff = {
    prefix: 'fasds',
    iconName: 'staff',
    icon: [
      512,
      512,
      [],
      'f71b',
      
      ['M96 288l60.1 0c-20 20-40.1 40.1-60.1 60.1L96 288zm265.1-.7c27.5-7.9 55.1-15.7 82.6-23.6L413.7 317l-52.6-29.7z','M306.3 0L336 0 464 0l48 0 0 48 0 160 0 36.2-34.8 9.9-212 60.6L105.9 473.9 72 507.9 4.1 440l33.9-33.9 168-168 8.8-8.8 12-3.4L416 171.8 416 96l-50.3 0-2.7 5.5-21.5 42.9-85.9-42.9 21.5-42.9 16-32L306.3 0z']
      
    ]
  };

  

  
  

  var faChartRadar = {
    prefix: 'fasds',
    iconName: 'chart-radar',
    icon: [
      512,
      512,
      [],
      'e0e7',
      
      ['M-5 256l9.4 16.1 112 192 9.3 15.9 18.4 0 224 0 18.4 0 9.3-15.9 112-192L517 256l-9.4-16.1-112-192L386.4 32 368 32 144 32l-18.4 0-9.3 15.9-112 192L-5 256zM69 256L162.4 96l187.2 0L443 256 349.6 416l-187.2 0L69 256z','M290.2 180.8c3.7-6.1 5.8-13.2 5.8-20.8c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 3.9 .6 7.7 1.6 11.2L160 248c-22.1 0-40 17.9-40 40s17.9 40 40 40c10.2 0 19.6-3.9 26.7-10.2l97.2 19.4c6.4 13.5 20.2 22.7 36.1 22.7c22.1 0 40-17.9 40-40c0-18.5-12.6-34.1-29.6-38.6L290.2 180.8zm-8.9 107L202 271.9l47.5-63.4 31.7 79.2z']
      
    ]
  };

  

  
  

  var faLockHashtag = {
    prefix: 'fasds',
    iconName: 'lock-hashtag',
    icon: [
      448,
      512,
      [],
      'e423',
      
      ['M0 192L0 512l448 0 0-320-80 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144l0 48L0 192zm112 96l16 0 32 0 0-32 0-16 32 0 0 16 0 32 64 0 0-32 0-16 32 0 0 16 0 32 32 0 16 0 0 32-16 0-32 0 0 64 32 0 16 0 0 32-16 0-32 0 0 32 0 16-32 0 0-16 0-32-64 0 0 32 0 16-32 0 0-16 0-32-32 0-16 0 0-32 16 0 32 0 0-64-32 0-16 0 0-32zm32-144c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48-160 0 0-48zm48 176l0 64 64 0 0-64-64 0z','M192 256l0-16-32 0 0 16 0 32-32 0-16 0 0 32 16 0 32 0 0 64-32 0-16 0 0 32 16 0 32 0 0 32 0 16 32 0 0-16 0-32 64 0 0 32 0 16 32 0 0-16 0-32 32 0 16 0 0-32-16 0-32 0 0-64 32 0 16 0 0-32-16 0-32 0 0-32 0-16-32 0 0 16 0 32-64 0 0-32zm64 128l-64 0 0-64 64 0 0 64z']
      
    ]
  };

  

  
  

  var faTurnDownLeft = {
    prefix: 'fasds',
    iconName: 'turn-down-left',
    icon: [
      512,
      512,
      [],
      'e331',
      
      ['M192 240l0 96 272 0 48 0 0-48 0-208 0-48-96 0 0 48 0 160-224 0z','M160 448L0 288 160 128l32 0 0 320-32 0z']
      
    ]
  };

  

  
  

  var faFileAudio = {
    prefix: 'fasds',
    iconName: 'file-audio',
    icon: [
      384,
      512,
      [],
      'f1c7',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM64 296l0 80 56 0 40 40 16 0 0-160-16 0-40 40-56 0zm143.5 12c9.8 5.5 16.5 15.9 16.5 28s-6.6 22.5-16.5 28l15.5 28C242.7 381 256 360.1 256 336s-13.3-45-32.9-56l-15.5 28zm31.1-56C268.1 268.5 288 299.9 288 336s-19.9 67.5-49.4 83.9l15.5 28C293.4 426.1 320 384.1 320 336s-26.6-90.1-65.8-111.9l-15.5 28z','M384 160L224 0l0 160 160 0zM254.2 447.9C293.4 426.1 320 384.1 320 336s-26.6-90.1-65.8-111.9l-15.5 28C268.1 268.5 288 299.9 288 336s-19.9 67.5-49.4 83.9l15.5 28zm-31.1-56C242.7 381 256 360.1 256 336s-13.3-45-32.9-56l-15.5 28c9.8 5.5 16.5 15.9 16.5 28s-6.6 22.5-16.5 28l15.5 28zM64 376l56 0 40 40 16 0 0-160-16 0-40 40-56 0 0 80z']
      
    ]
  };

  

  
  

  var faPool8Ball = {
    prefix: 'fasds',
    iconName: 'pool-8-ball',
    icon: [
      512,
      512,
      [],
      'e3c5',
      
      ['M200 216c0 30.9 25.1 56 56 56s56-25.1 56-56c0-16.6-7.2-31.5-18.7-41.8C300 166 304 155.5 304 144c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 11.5 4 22 10.7 30.2C207.2 184.5 200 199.4 200 216zm80 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-8-72a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-448a128 128 0 1 1 0 256 128 128 0 1 1 0-256z']
      
    ]
  };

  

  
  

  var faTruckClock = {
    prefix: 'fasds',
    iconName: 'truck-clock',
    icon: [
      640,
      512,
      ["shipping-timed"],
      'f48c',
      
      ['M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zM192 96l0 16 0 64 0 16 16 0 32 0 16 0 0-32-16 0-16 0 0-48 0-16-32 0zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M0 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 32 0 32 32 0 0 64-32 0-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L0 416 0 0zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM208 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224z']
      
    ]
  };

  
    var faShippingTimed = faTruckClock;
  

  
  

  var faCartCirclePlus = {
    prefix: 'fasds',
    iconName: 'cart-circle-plus',
    icon: [
      640,
      512,
      [],
      'e3f3',
      
      ['M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L525.2 194.4c-9.5-1.6-19.3-2.4-29.2-2.4c-68.4 0-127.7 39-156.8 96l-168.5 0 9.1 48 143 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L160 384l-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM224 464a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 160l0-32-16 0-48 0 0-48 0-16-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0z']
      
    ]
  };

  

  
  

  var faClipboardCheck = {
    prefix: 'fasds',
    iconName: 'clipboard-check',
    icon: [
      384,
      512,
      [],
      'f46c',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-72 0-24 80 0 0 448L0 512 0 64zM62.1 320l17 17 64 64 17 17 17-17L305 273l17-17L288 222.1l-17 17-111 111-47-47-17-17L62.1 320z','M270.4 64C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L80 64l0 96 112 0 112 0 0-96-33.6 0zM168 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM305 273l17-17L288 222.1l-17 17-111 111-47-47-17-17L62.1 320l17 17 64 64 17 17 17-17L305 273z']
      
    ]
  };

  

  
  

  var faFlatbreadStuffed = {
    prefix: 'fasds',
    iconName: 'flatbread-stuffed',
    icon: [
      576,
      512,
      [129369],
      'e40c',
      
      ['M13 282.9L75 365.7l.5 25.5L133.8 333c-13.7-19.5-21.8-43.3-21.8-69c0-66.3 53.7-120 120-120c25.7 0 49.5 8.1 69 21.8L422.5 44.2l-75.9 9L255.9 3.4 185.1 78.8 83.6 98.9 77.8 202.2 13 282.9zM144 264c0 16.8 4.7 32.5 12.9 45.9l121-121C264.5 180.7 248.8 176 232 176c-48.6 0-88 39.4-88 88z','M464.3 47.7c106.2 106.2 106.2 278.4 0 384.7s-278.4 106.2-384.7 0L464.3 47.7zM272 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faOctagonCheck = {
    prefix: 'fasds',
    iconName: 'octagon-check',
    icon: [
      512,
      512,
      [],
      'e426',
      
      ['M0 160L160 0 352 0 512 160l0 192L352 512l-192 0L0 352 0 160zm126.1 96c.3 .3 .6 .6 1 1c5.3 5.3 10.7 10.7 16 16c21.3 21.3 42.7 42.7 64 64l17 17 17-17c42.7-42.7 85.3-85.3 128-128c5.3-5.3 10.7-10.7 16-16c.3-.3 .6-.6 1-1L352 158.1l-1 1c-5.3 5.3-10.7 10.7-16 16c-37 37-74 74-111 111c-15.7-15.7-31.4-31.3-47-47c-5.3-5.3-10.7-10.7-16-16c-.3-.3-.6-.6-1-1L126.1 256z','M385 193L241 337l-17 17-17-17-80-80L161 223l63 63L351 159 385 193z']
      
    ]
  };

  

  
  

  var faWallet = {
    prefix: 'fasds',
    iconName: 'wallet',
    icon: [
      512,
      512,
      [],
      'f555',
      
      ['M0 32l0 96 480 0 0-96L0 32z','M512 128L0 128 0 480l512 0 0-352zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fasds',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      ['M96 336l94.3 0 19.4-58.1 7.3-21.9L120 256 96 336zm31.8-160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 384l224 0-16-48-16-48-17.6 0-124.8 0L240 288l-16 48-16 48zm48-192a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm160-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm7.1 80l7.3 21.9L449.7 336l94.3 0-24-80-96.9 0z','M57 23L40 6.1 6.1 40 23 57l56 56 17 17L129.9 96 113 79 57 23zM583 23L527 79l-17 17L544 129.9l17-17 56-56 17-17L600 6.1 583 23zM40 505.9l17-17 56-56 17-17L96 382.1 79 399 23 455l-17 17L40 505.9zm543-17l17 17L633.9 472l-17-17-56-56-17-17L510.1 416l17 17 56 56z']
      
    ]
  };

  

  
  

  var faVolumeHigh = {
    prefix: 'fasds',
    iconName: 'volume-high',
    icon: [
      640,
      512,
      [128266,"volume-up"],
      'f028',
      
      ['M380.8 217.6c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-28.8 38.4zm57.6-76.8c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2l28.8 38.4c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4zM496 64c58.3 43.8 96 113.5 96 192s-37.7 148.2-96 192l28.8 38.4C594.7 433.9 640 350.3 640 256.1c0-94.4-45.3-178-115.2-230.5L496 64z','M0 352V160H128L272 32h48V480H272L128 352H0z']
      
    ]
  };

  
    var faVolumeUp = faVolumeHigh;
  

  
  

  var faCloudSlash = {
    prefix: 'fasds',
    iconName: 'cloud-slash',
    icon: [
      640,
      512,
      [],
      'e137',
      
      ['M0 336L0 480l144 0 343.4 0L97.2 172.6c-.8 6.4-1.2 12.9-1.2 19.4l0 8.2C40.1 220 0 273.3 0 336zM137.8 84.2C298.9 209.2 459.9 334.3 620.9 459.3c6.2 4.8 12.4 9.6 18.6 14.5c.1 0 .3 0 .4 .1c.1-40.7 .1-81.3 .1-121.9c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-46.8 0-89 20.1-118.2 52.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faInboxOut = {
    prefix: 'fasds',
    iconName: 'inbox-out',
    icon: [
      512,
      512,
      [128228,"inbox-arrow-up"],
      'f311',
      
      ['M0 320L0 512l512 0 0-192-144 0-32 64-160 0-32-64L0 320z','M288 333.3l0-32 0-178.7 41.4 41.4L352 186.5l45.3-45.3-22.6-22.6-96-96L256 0 233.4 22.6l-96 96-22.6 22.6L160 186.5l22.6-22.6L224 122.5l0 178.7 0 32 64 0z']
      
    ]
  };

  
    var faInboxArrowUp = faInboxOut;
  

  
  

  var faClockOneThirty = {
    prefix: 'fasds',
    iconName: 'clock-one-thirty',
    icon: [
      512,
      512,
      [],
      'e34f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232-7.3l4-6 64-96 13.3-20 39.9 26.6-13.3 20-60 90L280 392l0 24-48 0 0-24 0-136 0-7.3z','M280 416l0-24 0-128.7 60-90 13.3-20-39.9-26.6-13.3 20-64 96-4 6 0 7.3 0 136 0 24 48 0z']
      
    ]
  };

  

  
  

  var faMobileScreenButton = {
    prefix: 'fasds',
    iconName: 'mobile-screen-button',
    icon: [
      384,
      512,
      ["mobile-alt"],
      'f3cd',
      
      ['M16 0L368 0l0 512L16 512 16 0zM80 64l0 320 224 0 0-320L80 64zm80 384a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M80 64H304V384H80V64z']
      
    ]
  };

  
    var faMobileAlt = faMobileScreenButton;
  

  
  

  var faSlider = {
    prefix: 'fasds',
    iconName: 'slider',
    icon: [
      512,
      512,
      [],
      'e252',
      
      ['M0 224l0 64 32 0 192 0 0-64L32 224 0 224zm416 0l0 64 64 0 32 0 0-64-32 0-64 0z','M352 160l0 192-32 0 0-192 32 0zM320 96l-64 0 0 64 0 192 0 64 64 0 32 0 64 0 0-64 0-192 0-64-64 0-32 0z']
      
    ]
  };

  

  
  

  var faCircleUp = {
    prefix: 'fasds',
    iconName: 'circle-up',
    icon: [
      512,
      512,
      [61467,"arrow-alt-circle-up"],
      'f35b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-32L256 96 384 224l0 32-80 0c0 42.7 0 85.3 0 128l-96 0 0-128-80 0 0-32z','M304 256l80 0 0-32L256 96 128 224l0 32 80 0 0 128 96 0 0-128z']
      
    ]
  };

  
    var faArrowAltCircleUp = faCircleUp;
  

  
  

  var faBadgeCheck = {
    prefix: 'fasds',
    iconName: 'badge-check',
    icon: [
      512,
      512,
      [],
      'f336',
      
      ['M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm126.1 0L160 222.1c.3 .3 .6 .6 1 1c5.3 5.3 10.7 10.7 16 16c15.7 15.7 31.4 31.4 47 47c37-37 74-74 111-111c5.3-5.3 10.7-10.7 16-16c.3-.3 .6-.6 1-1L385.9 192l-1 1c-5.3 5.3-10.7 10.7-16 16c-42.7 42.7-85.3 85.3-128 128c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-21.3-21.3-42.7-42.7-64-64c-5.3-5.3-10.7-10.7-16-16c-.3-.3-.6-.6-1-1z','M385 193L241 337l-17 17-17-17-80-80L161 223l63 63L351 159 385 193z']
      
    ]
  };

  

  
  

  var faSatelliteDish = {
    prefix: 'fasds',
    iconName: 'satellite-dish',
    icon: [
      512,
      512,
      [128225],
      'f7c0',
      
      ['M192 0l0 64c141.4 0 256 114.6 256 256l64 0C512 143.3 368.7 0 192 0zm0 96l0 64c88.4 0 160 71.6 160 160l64 0C416 196.3 315.7 96 192 96z','M164.7 324.7L32.4 192.4C11.9 224.7 0 262.9 0 304C0 418.9 93.1 512 208 512c41.1 0 79.3-11.9 111.6-32.4L187.3 347.3l28.4-28.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3l-28.4 28.4z']
      
    ]
  };

  

  
  

  var faForkKnife = {
    prefix: 'fasds',
    iconName: 'fork-knife',
    icon: [
      576,
      512,
      ["utensils-alt"],
      'f2e6',
      
      ['M0 104c0 70.7 63.5 136.2 154.7 226.8L265.4 220.1l-50.7-50.7L192 146.7C143.1 97.8 94.2 48.9 45.3 0C45.3 0 0 40 0 104zM310.6 355.9L441.4 486.6 464 509.3 509.3 464l-22.6-22.6L355.9 310.6l-45.3 45.3z','M472 8l16 16L384 128l16 16L512 48l16 16L432 176l16 16L552 88l16 16L497.5 227.4C481.7 255 452.4 272 420.7 272c-19.4 0-38.1-6.4-53.4-18L134.6 486.6 112 509.3 66.7 464l22.6-22.6L322 208.8c-11.6-15.3-18-34-18-53.4c0-31.8 17-61.1 44.6-76.8L472 8z']
      
    ]
  };

  
    var faUtensilsAlt = faForkKnife;
  

  
  

  var faBasketball = {
    prefix: 'fasds',
    iconName: 'basketball',
    icon: [
      512,
      512,
      [127936,"basketball-ball"],
      'f434',
      
      ['M0 256c0 64.8 24 123.9 63.7 169l.3 .4C120.5 368.9 176.9 312.4 233.4 256L172 194.6C138.5 222.9 95.3 240 48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256zm5.6-53.7C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6C35.5 119 15 158.6 5.6 202.3zM86.6 64c28.4 28.4 56.8 56.8 85.2 85.2c1.4-1.7 2.8-3.5 4.2-5.3c1.3-1.8 2.6-3.5 3.9-5.4c2.6-3.7 4.9-7.5 7.2-11.4c4.4-7.8 8.2-16 11.4-24.5s5.5-17.4 7.1-26.5c.4-2.3 .8-4.6 1.1-6.9c.3-2.3 .6-4.6 .8-6.9c.2-2.6 .4-5 .5-7.5c0-1 .1-2 .1-2.8l0-.5c0-1.1 0-2.1 0-3c0-.2 0-.3 0-.5c0-2 0-3.7-.1-5.4c-.1-1.9-.2-3.6-.3-5.3c-.3-3.8-.6-7.3-1.1-10.9c-1-7.1-2.4-14-4.2-20.8C158.6 15 119 35.5 86.6 64zm0 384c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124c-20.5-20.5-40.9-40.9-61.4-61.4C199.5 335.1 143.1 391.5 86.6 448zm108-276L256 233.4C312.5 176.9 368.9 120.5 425.4 64C380.2 24.2 320.9 0 256 0c-7.3 0-14.6 .3-21.8 .9c.5 2 .9 3.8 1.3 5.7s.8 3.8 1.2 5.7c.7 3.9 1.3 7.8 1.8 11.7c.5 4 .9 8 1.1 12c.1 2 .2 4.1 .3 6s.1 3.8 .1 6c0 .2 0 .3 0 .5c0 1.3 0 2.6 0 3.9c0 .1 0 .2 0 .5c0 1.2-.1 2.5-.1 3.7c0 .2 0 .5 0 .7c-.1 1.2-.1 2.4-.2 3.7c-.1 1.6-.2 3-.3 4.4c-.5 5.9-1.3 11.6-2.3 17.2c-2 11.2-5.1 22.1-9 32.6c-7.8 20.9-19.2 40.1-33.3 56.8zm84 84c20.5 20.5 40.9 40.9 61.4 61.4c33.5-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4C391.5 143.1 335.1 199.6 278.6 256zM304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2C317.5 390.3 304 425.6 304 464zm58.7-123.9L448 425.4c28.6-32.3 49.1-71.9 58.4-115.7C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1z','M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4c10.4-2.2 21-3.8 31.9-4.7C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64c8 7.1 15.6 14.6 22.6 22.6L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8c-.9 10.8-2.5 21.5-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c-7.1 8-14.6 15.6-22.6 22.6l-85.2-85.2C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4c-10.4 2.2-21 3.8-31.9 4.7C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124L256 278.6 86.6 448c-8-7.1-15.6-14.6-22.6-22.6L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240c-16.2 0-32-2-47.1-5.8c.9-10.8 2.5-21.5 4.7-31.9C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6c7.1-8 14.6-15.6 22.6-22.6z']
      
    ]
  };

  
    var faBasketballBall = faBasketball;
  

  
  

  var faTrademark = {
    prefix: 'fasds',
    iconName: 'trademark',
    icon: [
      640,
      512,
      [8482],
      'f25c',
      
      ['M288 96l48 0 9.6 12.8L464 266.7 582.4 108.8 592 96l48 0 0 32 0 256 0 32-64 0 0-32 0-160L489.6 339.2 464 373.3l-25.6-34.1L352 224l0 160 0 32-64 0 0-32 0-256 0-32z','M32 96L0 96l0 64 32 0 64 0 0 224 0 32 64 0 0-32 0-224 64 0 32 0 0-64-32 0-64 0L96 96 32 96z']
      
    ]
  };

  

  
  

  var faCircleDashed = {
    prefix: 'fasds',
    iconName: 'circle-dashed',
    icon: [
      512,
      512,
      [],
      'e105',
      
      ['M1.1 280C6 332.7 26.9 380.7 58.8 419.3l45.5-45.5C83.7 347.2 69.9 315.1 65.5 280L1.1 280zM92.7 58.8l45.5 45.5c26.6-20.6 58.7-34.5 93.7-38.8l0-64.4C179.3 6 131.3 26.9 92.7 58.8zM280 446.5l0 64.4c52.7-4.9 100.7-25.8 139.3-57.7l-45.5-45.5c-26.6 20.6-58.7 34.5-93.7 38.8zM407.7 138.3c20.6 26.6 34.5 58.7 38.8 93.7l64.4 0c-4.9-52.7-25.8-100.7-57.7-139.3l-45.5 45.5z','M1.1 232C6 179.3 26.9 131.3 58.8 92.7l45.5 45.5C83.7 164.8 69.9 196.9 65.5 232L1.1 232zM407.7 373.7c20.6-26.6 34.5-58.7 38.8-93.7l64.4 0c-4.9 52.7-25.8 100.7-57.7 139.3l-45.5-45.5zM92.7 453.2l45.5-45.5c26.6 20.6 58.7 34.5 93.7 38.8l0 64.4c-52.7-4.9-100.7-25.8-139.3-57.7zM419.3 58.8l-45.5 45.5C347.2 83.7 315.1 69.9 280 65.5l0-64.4C332.7 6 380.7 26.9 419.3 58.8z']
      
    ]
  };

  

  
  

  var faPlaneSlash = {
    prefix: 'fasds',
    iconName: 'plane-slash',
    icon: [
      640,
      512,
      [],
      'e069',
      
      ['M32 128L64 256 32 384l64 0 48-64 102.9 0L192 512l96 0 74.5-130.4L40.6 128 32 128zM192 0l46.4 162.3L441.5 320l72.8 0c34.2 0 93.7-28 93.7-64c0-35-59.5-64-93.7-64l-116.6 0L288 0 192 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faInterrobang = {
    prefix: 'fasds',
    iconName: 'interrobang',
    icon: [
      320,
      512,
      [8253],
      'e5ba',
      
      ['M16 160l0 16 64 0 0-16c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 9.3c0 19.6-9 38.2-24.5 50.3L192 238.2l0 81.4L255.1 270C286 245.7 304 208.6 304 169.3l0-9.3c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160z','M192 176l0-32-64 0 0 32 0 144 0 32 64 0 0-32 0-144zm8 224l-80 0 0 80 80 0 0-80z']
      
    ]
  };

  

  
  

  var faUserAstronaut = {
    prefix: 'fasds',
    iconName: 'user-astronaut',
    icon: [
      448,
      512,
      [],
      'f4fb',
      
      ['M112 128l0 32c0 53 43 96 96 96l32 0c53 0 96-43 96-96l0-32L304 96 144 96l-32 32zm16 48l32-16 16-32 16 32 32 16-32 16-16 32-16-32-32-16zm0 240l0 96 32 0 0-48 0-16 32 0 0 16 0 48 128 0 0-96-192 0zm160 48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M224 0c65.6 0 122 39.5 146.7 96L400 96l0 128-29.3 0C346 280.5 289.6 320 224 320s-122-39.5-146.7-96L48 224 48 96l29.3 0C102 39.5 158.4 0 224 0zM336 160l0-32L304 96 144 96l-32 32 0 32c0 53 43 96 96 96l32 0c53 0 96-43 96-96zM97 304c33.8 29.9 78.3 48 127 48s93.2-18.1 127-48l49 0 48 208-128 0 0-96-192 0 0 96L0 512 48 304l49 0z']
      
    ]
  };

  

  
  

  var faRecycle = {
    prefix: 'fasds',
    iconName: 'recycle',
    icon: [
      512,
      512,
      [9842,9850,9851],
      'f1b8',
      
      ['M-5.3 333.1l9.6 16.7L51.8 432 61 448l18.5 0 80.5 0 0-64-62 0L69.3 334.4l50.8-81.3c-18.5-10.7-37-21.3-55.5-32L4.9 316.8-5.3 333.1zM149.4 85.6l55.5 32L238.3 64l35.4 0 53.2 85.2 55.5-32L318.5 15 309.1 0 291.4 0 220.6 0 202.8 0l-9.4 15L149.4 85.6zM320 384l0 64 112.5 0 18.5 0 9.2-16 15.5-26.9 32-55.4 9.6-16.7-10.2-16.3-43.3-69.3-55.5 32 34.3 54.8-22.4 38.8L414 384l-94 0z','M412.6 229l32.2-120.2L432.8 88 280.4 176l12 20.8L412.6 229zM180.4 260.2L148.2 140 28 172.2 16 193l152.4 88 12-20.8zM296 328l-88 88 88 88 24 0 0-176-24 0z']
      
    ]
  };

  

  
  

  var faBackwardFast = {
    prefix: 'fasds',
    iconName: 'backward-fast',
    icon: [
      512,
      512,
      [9198,"fast-backward"],
      'f049',
      
      ['M0 64L0 96 0 416l0 32 64 0 0-32 0-136 0-48L64 96l0-32L0 64z','M64 280L288 448l0-168L512 448l0-384L288 232l0-168L64 232l0 48z']
      
    ]
  };

  
    var faFastBackward = faBackwardFast;
  

  
  

  var faSword = {
    prefix: 'fasds',
    iconName: 'sword',
    icon: [
      512,
      512,
      [128481],
      'f71c',
      
      ['M144 272L400 16 512 0 496 112 240 368l-96-96z','M96 512L0 416l32-32 32 16 56-56L64 256l32-32L288 416l-32 32-88-56-56 56 16 32L96 512z']
      
    ]
  };

  

  
  

  var faCartCircleExclamation = {
    prefix: 'fasds',
    iconName: 'cart-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e3f2',
      
      ['M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L525.2 194.4c-9.5-1.6-19.3-2.4-29.2-2.4c-68.4 0-127.7 39-156.8 96l-168.5 0 9.1 48 143 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L160 384l-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM224 464a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faLeftToBracket = {
    prefix: 'fasds',
    iconName: 'left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e66d',
      
      ['M0 32L0 64 0 448l0 32 32 0 128 0 32 0 0-64-32 0-96 0L64 96l96 0 32 0 0-64-32 0L32 32 0 32z','M160 256L320 416l32 0 0-96 160 0 0-128-160 0 0-96-32 0L160 256z']
      
    ]
  };

  

  
  

  var faCircle = {
    prefix: 'fasds',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      ['M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z','']
      
    ]
  };

  

  
  

  var faSquarePollHorizontal = {
    prefix: 'fasds',
    iconName: 'square-poll-horizontal',
    icon: [
      448,
      512,
      ["poll-h"],
      'f682',
      
      ['M0 32L0 480l448 0 0-448L0 32zm96 96l160 0 0 64L96 192l0-64zm0 96l256 0 0 64L96 288l0-64zm0 96l96 0 0 64-96 0 0-64z','M256 128l0 64L96 192l0-64 160 0zm96 96l0 64L96 288l0-64 256 0zM192 384l-96 0 0-64 96 0 0 64z']
      
    ]
  };

  
    var faPollH = faSquarePollHorizontal;
  

  
  

  var faHouseFloodWaterCircleArrowRight = {
    prefix: 'fasds',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e50f',
      
      ['M32 336c19.3 0 38.6-6.1 54-13.1c5.4-2.5 10.5-5.2 15.3-8.1c13.7 3.4 28 5.2 42.7 5.2c6.2 0 12.3-.3 18.3-.9c2.5 1.3 5.1 2.6 7.7 3.8c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C92.6 390.1 63.9 400 32 400l0-64zm0 112c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C92.6 502.1 63.9 512 32 512l0-64zM254.8 280.8C294.6 248.5 320 199.2 320 144c0-27.4-6.3-53.4-17.5-76.5L400 0 608 144l0 48-48.6 0 .3 80.8c-8.8-4.9-17.1-10.8-28-18.6L512 240l-19.7 14.2c-13.9 10-23.6 17-35.5 22.5C443.6 282.7 429 287 416 287s-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5L320 240l-18.6 13.4-1.1 .8c-13.9 10-23.6 17-35.5 22.5c-3.2 1.5-6.6 2.9-9.9 4.1z','M144 288A144 144 0 1 0 144 0a144 144 0 1 0 0 288zM163.3 76.7l56 56L230.6 144l-11.3 11.3-56 56L152 222.6 129.4 200l11.3-11.3L169.4 160 80 160l-16 0 0-32 16 0 89.4 0L140.7 99.3 129.4 88 152 65.4l11.3 11.3z']
      
    ]
  };

  

  
  

  var faMoneyBillTrendUp = {
    prefix: 'fasds',
    iconName: 'money-bill-trend-up',
    icon: [
      512,
      512,
      [],
      'e529',
      
      ['M0 256L0 512l512 0 0-256L0 256zm48 48l48 0c0 26.5-21.5 48-48 48l0-48zm0 112c26.5 0 48 21.5 48 48l-48 0 0-48zm272-32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96-80l48 0 0 48c-26.5 0-48-21.5-48-48zm0 160c0-26.5 21.5-48 48-48l0 48-48 0z','M352 0L320 0l0 64 32 0 18.7 0-84.4 84.4L196.8 71.7 176 53.9 155.2 71.7l-112 96 41.7 48.6L176 138.1l91.2 78.1 22.5 19.3 21-21L416 109.3l0 18.7 0 32 64 0 0-32 0-96 0-32L448 0 352 0z']
      
    ]
  };

  

  
  

  var faMoneyBillTransfer = {
    prefix: 'fasds',
    iconName: 'money-bill-transfer',
    icon: [
      640,
      512,
      [],
      'e528',
      
      ['M32 64l0 291 51.3-43.4 8.9-7.6 11.7 0 24 0 32 0 0 32 0 24 96 0 64 0 0 88 288 0 0-291-51.3 43.4-8.9 7.6L536 208l-24 0-32 0 0-32 0-24-96 0-64 0 0-88L32 64zm64 64l64 0c0 35.3-28.7 64-64 64l0-64zM384 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm96 128c0-35.3 28.7-64 64-64l0 64-64 0z','M512 176l0-64-128 0-24 0 0-48 24 0 128 0 0-64 24 0L640 88 536 176l-24 0zM128 400l128 0 24 0 0 48-24 0-128 0 0 64-24 0L0 424l104-88 24 0 0 64z']
      
    ]
  };

  

  
  

  var faElevator = {
    prefix: 'fasds',
    iconName: 'elevator',
    icon: [
      512,
      512,
      [],
      'e16d',
      
      ['M0 128L0 512l512 0 0-384L0 128zM80 448l24-96 112 0 24 96L80 448zM208 272a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm64 176l24-96 112 0 24 96-160 0zM400 272a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M64 80L144 0l80 80 0 16L64 96l0-16zM288 16l0-16L448 0l0 16L368 96 288 16zM160 224a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 448l24-96 112 0 24 96L80 448zm328-96l24 96-160 0 24-96 112 0zM304 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z']
      
    ]
  };

  

  
  

  var faTally3 = {
    prefix: 'fasds',
    iconName: 'tally-3',
    icon: [
      640,
      512,
      [],
      'e296',
      
      ['M96 32l0 32 0 384 0 32 64 0 0-32 0-384 0-32L96 32zm128 0l0 32 0 384 0 32 64 0 0-32 0-384 0-32-64 0z','M416 32l0 32 0 384 0 32-64 0 0-32 0-384 0-32 64 0z']
      
    ]
  };

  

  
  

  var faHouseChimneyHeart = {
    prefix: 'fasds',
    iconName: 'house-chimney-heart',
    icon: [
      576,
      512,
      [],
      'e1b2',
      
      ['M64 272l.1 240 448.5 0c-.2-80-.3-160-.6-240c-64.4-52.9-128.9-105.9-193.3-158.8C308.5 104.8 298.2 96.4 288 88C213.3 149.3 138.7 210.6 64 272zm112 43.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 448.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z','M0 240L288 0 416 106.7 416 32l96 0 0 154.7L576 240l0 32-64 0L288 88 64 272 0 272l0-32zm176 75.2c0-32.7 26.5-59.2 59.2-59.2l2.4 0c15.9 0 31.2 6.2 42.7 17.2l7.7 7.4 7.7-7.4c11.5-11 26.8-17.2 42.7-17.2l2.4 0c32.7 0 59.2 26.5 59.2 59.2c0 16.1-6.6 31.5-18.2 42.7l-82.8 79.6L288 448.1l-11.1-10.7-82.8-79.6c-11.6-11.2-18.2-26.6-18.2-42.7z']
      
    ]
  };

  

  
  

  var faTableTree = {
    prefix: 'fasds',
    iconName: 'table-tree',
    icon: [
      512,
      512,
      [],
      'e293',
      
      ['M96 160l0 96 0 16 0 80 0 16 16 0 128 0 16 0 0-32-16 0-112 0 0-64 48 0 16 0 0-32-16 0-48 0 0-80-32 0zm128 64l0 64 192 0 0-64-192 0zm64 96l0 64 128 0 0-64-128 0z','M512 32L0 32 0 480l512 0 0-448zM448 160l0 256L64 416l0-256 384 0z']
      
    ]
  };

  

  
  

  var faLockOpen = {
    prefix: 'fasds',
    iconName: 'lock-open',
    icon: [
      576,
      512,
      [],
      'f3c1',
      
      ['M288 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 0 32 64 0 0-32 0-48C576 64.5 511.5 0 432 0S288 64.5 288 144z','M0 192H448V512H0V192z']
      
    ]
  };

  

  
  

  var faSolarPanel = {
    prefix: 'fasds',
    iconName: 'solar-panel',
    icon: [
      640,
      512,
      [],
      'f5ba',
      
      ['M0 324.6L0 328l0 24 0 32 32 0 256 0 64 0 256 0 32 0 0-32 0-24 0-3.4-.7-3.3-64-296L569.8 0 544 0 96 0 70.2 0 64.7 25.2l-64 296L0 324.6zM66.5 320L89 216c3.5-16 6.9-32 10.4-48c7.5-34.7 15-69.3 22.5-104l90.9 0 48.2 0 118.2 0 48.2 0 90.9 0 22.5 104c3.5 16 6.9 32 10.4 48c7.5 34.7 15 69.3 22.5 104l-120.6 0-48.2 0-169.4 0-48.2 0L66.5 320z','M121.8 64L99.3 168l102.9 0L212.7 64l-90.9 0zM66.5 320l120.6 0 10.4-104L89 216 66.5 320zm168.9 0l169.4 0L394.3 216l-148.6 0L235.3 320zm217.6 0l120.6 0L551 216l-108.5 0 10.4 104zM437.7 168l102.9 0L518.2 64l-90.9 0 10.4 104zm-187.2 0l139 0L379.1 64 260.9 64 250.5 168zM416 448l-64 0 0-64-64 0 0 64-64 0-32 0 0 64 32 0 192 0 32 0 0-64-32 0z']
      
    ]
  };

  

  
  

  var faShieldDog = {
    prefix: 'fasds',
    iconName: 'shield-dog',
    icon: [
      512,
      512,
      [],
      'e573',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM128 160l72 0 8 0c8 0 16 0 24 0c24 0 48 0 72 0l16 32c26.7 0 53.3 0 80 0c0 16 0 32 0 48.3c0 1.4 0 2.7-.1 4.1c-.1 1.2-.2 2.5-.3 3.8c-.3 2.7-.7 5.3-1.2 7.9c-1.1 5.2-2.6 10.2-4.7 15c-4 9.6-9.9 18.2-17.1 25.4C362.1 311 342.1 320 320 320l-48 0c0 21.3 0 42.7 0 64c-42.7-21.3-85.3-42.7-128-64c8-16 16-32 24-48l-.3 0c-21.9-.2-39.7-18-39.7-40l0-72z','M144 320l24-48c22.1 0 40-17.9 40-40l0-72 24 0 72 0 16 32 80 0 0 48c0 44.2-35.8 80-80 80l-48 0 0 64L144 320zm128-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faShutters = {
    prefix: 'fasds',
    iconName: 'shutters',
    icon: [
      512,
      512,
      [],
      'e449',
      
      ['M0 224l512 0-24-96L24 128 0 224zM0 352l512 0-24-96L24 256 0 352zM0 480l512 0-24-96L24 384 0 480z','M0 32l32 0 448 0 32 0 0 64-32 0L32 96 0 96 0 32z']
      
    ]
  };

  

  
  

  var faBitcoinSign = {
    prefix: 'fasds',
    iconName: 'bitcoin-sign',
    icon: [
      320,
      512,
      [],
      'e0b4',
      
      ['M48 0l0 64 16 0 48 0 0-64L48 0zm0 448l0 64 64 0 0-64-48 0-16 0zM144 0l0 64 32 0c1.4 0 2.8 0 4.2 .1s2.7 .1 4.1 .2c2.7 .2 5.4 .5 8.1 .9c5.3 .8 10.6 1.9 15.6 3.5L208 0 144 0zm0 448l0 64 64 0 0-64-64 0z','M64 128l0 96 112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L64 128zM0 224l0-96L0 64l64 0 112 0c61.9 0 112 50.1 112 112c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112L64 448 0 448l0-64 0-96 0-64zm176 64L64 288l0 96 144 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z']
      
    ]
  };

  

  
  

  var faArrowDownTriangleSquare = {
    prefix: 'fasds',
    iconName: 'arrow-down-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-down"],
      'f888',
      
      ['M304 224L416 32 528 224l-224 0zm16 64l192 0 0 192-192 0 0-192z','M160 480l23.7-26 80-88 21.5-23.7-47.4-43.1-21.5 23.7L192 349.7l0-285.2 0-32-64 0 0 32 0 285.2-24.3-26.8L82.2 299.2 34.8 342.3 56.3 366l80 88L160 480z']
      
    ]
  };

  
    var faSortShapesDown = faArrowDownTriangleSquare;
  

  
  

  var faCube = {
    prefix: 'fasds',
    iconName: 'cube',
    icon: [
      512,
      512,
      [],
      'f1b2',
      
      ['M64 189.4c53.3 19 106.7 38.1 160 57.1l0 180c-53.3-19-106.7-38.1-160-57.1l0-180zm224 57.1c53.3-19 106.7-38.1 160-57.1l0 180L288 426.6l0-180z','M256 6l10.8 3.8 224 80L512 97.4l0 22.6 0 272 0 22.6-21.2 7.6-224 80L256 506l-10.8-3.8-224-80L0 414.6 0 392 0 120 0 97.4l21.2-7.6 224-80L256 6zM64 369.4l160 57.1 0-180L64 189.4l0 180zm224 57.1l160-57.1 0-180L288 246.6l0 180zM256 74L93.5 132 256 190l162.5-58L256 74z']
      
    ]
  };

  

  
  

  var faHandsHoldingDollar = {
    prefix: 'fasds',
    iconName: 'hands-holding-dollar',
    icon: [
      640,
      512,
      ["hands-usd"],
      'f4c5',
      
      ['M0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40L0 64zM352 338.7l0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0 0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4z','M344 8l0 24 0 2.9c6.4 1.2 14.3 2.8 18.2 3.9L385.4 45 373 91.4l-23.2-6.2c-3.7-1-17-3.6-21.3-4.3c-11.6-1.8-20.8-.3-26.4 2.3c-5.5 2.5-5.9 4.8-5.9 5.1c0 0 0 0 0 0c-.3 1.5-.2 2.3-.2 2.7c.2 .2 .7 .9 2.2 1.9c5.5 3.7 14.4 6.6 28.8 10.9l1 .3c12 3.6 28.7 8.7 41.4 17.9c7.1 5.2 14 12.3 18.2 22.1c4.3 9.9 5.1 20.7 3.2 31.7c-3.6 20.6-17.3 34.5-34 41.7c-4.2 1.8-8.5 3.2-13 4.2l0 2.2 0 24-48 0 0-24 0-3.2c-9.3-2.4-20.3-6.1-27.3-8.5c0 0 0 0 0 0s0 0 0 0c-1.7-.6-3.1-1.1-4.2-1.4l-22.8-7.6 15.2-45.5 22.8 7.6c2.1 .7 4.3 1.5 6.6 2.2c9.5 3.2 19.7 6.7 25.4 7.6c12.3 1.9 21.4 .6 26.6-1.6c4.4-1.9 5.3-3.8 5.6-5.8c.3-1.8 .3-2.9 .2-3.5c-.1-.6-.2-.8-.2-.9c0 0 0 0 0 0c0-.1-.4-.9-2.4-2.4c-5.2-3.8-14-6.8-28.1-11.1l-2.3-.7c-11.6-3.5-27.5-8.2-39.6-16.5c-7-4.8-14.1-11.5-18.7-21.1c-4.6-9.8-5.6-20.5-3.7-31.4c3.5-20 17.6-33.5 33.4-40.7c4.3-2 8.9-3.5 13.6-4.7l0-2.8 0-24 48 0zM296.1 91.2s0 0 0-.1c0 .1 0 .1 0 .1z']
      
    ]
  };

  
    var faHandsUsd = faHandsHoldingDollar;
  

  
  

  var faToiletPaperXmark = {
    prefix: 'fasds',
    iconName: 'toilet-paper-xmark',
    icon: [
      512,
      512,
      [],
      'e5b3',
      
      ['M0 192C0 298 43 384 96 384l32 0 32 0 256 0c-52.4 0-94.9-83.9-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0L96 0C43 0 0 86 0 192zm86.1-48L120 110.1l17 17 31 31 31-31 17-17L249.9 144l-17 17-31 31 31 31 17 17L216 273.9l-17-17-31-31-31 31-17 17L86.1 240l17-17 31-31-31-31-17-17z','M416 384c-52.4 0-94.9-83.8-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0s96 86 96 192l0 320-352 0 0-128 256 0zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z']
      
    ]
  };

  

  
  

  var faWifiSlash = {
    prefix: 'fasds',
    iconName: 'wifi-slash',
    icon: [
      640,
      512,
      [],
      'f6ac',
      
      ['M9.8 156.7C20 147 30.7 137.7 41.7 128.9l51.9 40.9C79.7 179.9 66.6 191 54.2 202.9L9.8 156.7zm117-81C185.3 47.7 250.8 32 320 32c120.4 0 229.7 47.5 310.2 124.7l-44.3 46.2C516.8 136.7 423.2 96 320 96c-47.7 0-93.3 8.7-135.4 24.5c-19.3-15-38.5-29.9-57.8-44.9zM129.5 264c13.4-11.9 28-22.5 43.5-31.7L228 275.7c-20.6 9.3-39.5 21.6-56.2 36.3l-42.4-48zM256 416c0-35.3 28.7-64 64-64c1.7 0 3.5 .1 5.2 .2L380.8 396c2.1 6.3 3.2 13 3.2 20c0 35.3-28.7 64-64 64s-64-28.7-64-64zm24.2-221.3c13-1.8 26.3-2.7 39.8-2.7c73 0 139.8 27.2 190.5 72l-42.4 48c-28.8-25.4-64.2-43.6-103.3-51.5c-28.2-21.9-56.5-43.8-84.7-65.7z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faSquareInfo = {
    prefix: 'fasds',
    iconName: 'square-info',
    icon: [
      448,
      512,
      [8505,"info-square"],
      'f30f',
      
      ['M0 32L0 480l448 0 0-448L0 32zM160 224l24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0 24 0 0-64-24 0-24 0 0-48zm32-96l64 0 0 64-64 0 0-64z','M256 128l0 64-64 0 0-64 64 0zm-96 96l24 0 48 0 24 0 0 24 0 88 8 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0 24 0 0-64-24 0-24 0 0-48z']
      
    ]
  };

  
    var faInfoSquare = faSquareInfo;
  

  
  

  var faTemperatureQuarter = {
    prefix: 'fasds',
    iconName: 'temperature-quarter',
    icon: [
      320,
      512,
      ["temperature-1","thermometer-1","thermometer-quarter"],
      'f2ca',
      
      ['M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L272 64l0-64L208 0 112 0 48 0l0 64 0 213.5C28 302.2 16 333.7 16 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L112 300.2l0-22.7L112 64l96 0 0 213.5 0 22.7 14.2 17.6C233.4 331.5 240 348.9 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M176 272l0-16-32 0 0 16 0 50.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3l0-50.8z']
      
    ]
  };

  
    var faTemperature1 = faTemperatureQuarter;
  
    var faThermometer1 = faTemperatureQuarter;
  
    var faThermometerQuarter = faTemperatureQuarter;
  

  
  

  var faR = {
    prefix: 'fasds',
    iconName: 'r',
    icon: [
      320,
      512,
      [114],
      '52',
      
      ['M32 32L0 32 0 64 0 288 0 448l0 32 64 0 0-32 0-128 93.2 0L246 480l73.2 0-4.2-7.5L225.5 311.3C280.7 291.1 320 238.1 320 176c0-79.5-64.5-144-144-144L32 32zM176 256L64 256 64 96l112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z','']
      
    ]
  };

  

  
  

  var faLockKeyhole = {
    prefix: 'fasds',
    iconName: 'lock-keyhole',
    icon: [
      448,
      512,
      ["lock-alt"],
      'f30d',
      
      ['M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 64 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144z','M448 192L0 192 0 512l448 0 0-320zM256 320l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z']
      
    ]
  };

  
    var faLockAlt = faLockKeyhole;
  

  
  

  var faDiamondHalf = {
    prefix: 'fasds',
    iconName: 'diamond-half',
    icon: [
      512,
      512,
      [],
      'e5b7',
      
      ['M256 0L512 256 256 512 256 0z','M256 0L0 256 256 512 256 0z']
      
    ]
  };

  

  
  

  var faKitchenSet = {
    prefix: 'fasds',
    iconName: 'kitchen-set',
    icon: [
      576,
      512,
      [],
      'e51a',
      
      ['M0 480l0 32 224 0 0-32L0 480zM64 144a80 80 0 1 0 160 0A80 80 0 1 0 64 144zM256 272l0 48 32 0 224 0 32 0 0-48-120 0 0-32-48 0 0 32-120 0z','M224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zm60.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112l59.6 0 0-16 48 0 104 0 48 0 0 48 0 48-48 0-104 0-48 0 0-16-59.6 0zM128 320l32 0 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0 32L32 448l0-128 96 0zm48 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zm336-64l0 192-224 0 0-192 224 0z']
      
    ]
  };

  

  
  

  var faAppleWhole = {
    prefix: 'fasds',
    iconName: 'apple-whole',
    icon: [
      448,
      512,
      [127822,127823,"apple-alt"],
      'f5d1',
      
      ['M208 80l0 16 0 16 16 0 16 0c44.2 0 80-35.8 80-80l0-16 0-16L304 0 288 0c-44.2 0-80 35.8-80 80z','M112 128C35.7 128 0 211.7 0 288C0 416 80 512 160 512l64-16 64 16c80 0 160-96 160-224c0-76.3-35.7-160-112-160L224 160 112 128z']
      
    ]
  };

  
    var faAppleAlt = faAppleWhole;
  

  
  

  var faCircleEuro = {
    prefix: 'fasds',
    iconName: 'circle-euro',
    icon: [
      512,
      512,
      [],
      'e5ce',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112-48l40.7 0c19.2-46.9 65.4-80 119.2-80l41.1 0 24 0 0 48-24 0-41.1 0c-26.3 0-49.6 12.6-64.4 32l96.5 0 0 32-111.1 0c-1.1 5.4-1.7 11-1.7 16.8c0 5.2 .5 10.3 1.4 15.2L304 272l0 32-97.6 0c14.7 20.3 38.5 33.5 65.5 33.5l41.1 0 24 0 0 48-24 0-41.1 0c-54.4 0-101-33.8-119.8-81.5L112 304l0-32 32 0c-.6-5-.9-10.1-.9-15.2c0-5.7 .4-11.3 1.1-16.8L112 240l0-32z','M144.2 240c-.7 5.5-1.1 11.1-1.1 16.8c0 5.2 .3 10.2 .9 15.2l-32 0 0 32 40.1 0c18.8 47.7 65.4 81.5 119.8 81.5l41.1 0 24 0 0-48-24 0-41.1 0c-27 0-50.8-13.2-65.5-33.5l97.6 0 0-32-111.4 0c-.9-4.9-1.4-10-1.4-15.2c0-5.7 .6-11.4 1.7-16.8L304 240l0-32-96.5 0c14.7-19.4 38.1-32 64.4-32l41.1 0 24 0 0-48-24 0-41.1 0c-53.9 0-100 33.1-119.2 80L112 208l0 32 32.2 0z']
      
    ]
  };

  

  
  

  var faToiletPaperSlash = {
    prefix: 'fasds',
    iconName: 'toilet-paper-slash',
    icon: [
      640,
      512,
      [],
      'e072',
      
      ['M8 512l325.3 0c17-40.8 28.5-82.5 36.2-124.9L66.5 148.4C64.9 162.4 64 177 64 192c0 89.9-3.9 190.6-37.6 275.8L8 512zM94.9 50.9c95.7 74.3 191.5 148.7 287.2 223c1.4-27.1 1.9-54.4 1.9-81.9c0-65.5 13.2-142.4 60.2-192L160 0c-25.1 0-48 19.3-65.1 50.9zM416 192c0 48.6 9 92.9 23.9 126.7c27.5 21.4 55.1 42.8 82.6 64.1C570.6 372.4 608 291 608 192C608 86 565 0 512 0s-96 86-96 192zm64 0c0-35.3 14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64s-32-28.7-32-64z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faRabbit = {
    prefix: 'fasds',
    iconName: 'rabbit',
    icon: [
      512,
      512,
      [128007],
      'f708',
      
      ['M96 432c0-12.1 1.1-24 3.3-35.5C114 317.7 176.8 255.9 256 242.7l0-88.8c-29.7-37.6-42.4-86.4-34-134.4L224 8l32-8 10.4 10.3C298 41.7 314.1 84.6 311.9 128l24 0c1-23.7-2.8-47.2-11-69.2c7.6-17.8 18.6-34.2 32.7-48.3L368 0l24 8 3 11.9c10.4 41.6 3.3 85.1-18.6 120.8L448 199.1l0 88.9-96 0 0 10.3 78 210.6 1.2 3.1-68.2 0L317.7 390.1 265.6 448l22.4 0 32 0 0 64-32 0-80 0-48 0-32 0-32 0 0-40.8L96 432zM352 208a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M368 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM56 376c17.4 0 33 8 43.3 20.5C97.1 408 96 419.9 96 432l0 39.2C85.8 481.6 71.7 488 56 488c-30.9 0-56-25.1-56-56s25.1-56 56-56z']
      
    ]
  };

  

  
  

  var faValueAbsolute = {
    prefix: 'fasds',
    iconName: 'value-absolute',
    icon: [
      512,
      512,
      [],
      'f6a6',
      
      ['M0 32L0 64 0 448l0 32 64 0 0-32L64 64l0-32L0 32zm448 0l0 32 0 384 0 32 64 0 0-32 0-384 0-32-64 0z','M182.6 137.4L160 114.7 114.7 160l22.6 22.6L210.7 256l-73.4 73.4L114.7 352 160 397.3l22.6-22.6L256 301.3l73.4 73.4L352 397.3 397.3 352l-22.6-22.6L301.3 256l73.4-73.4L397.3 160 352 114.7l-22.6 22.6L256 210.7l-73.4-73.4z']
      
    ]
  };

  

  
  

  var faAngel = {
    prefix: 'fasds',
    iconName: 'angel',
    icon: [
      576,
      512,
      [],
      'f779',
      
      ['M0 160L0 280l48 72L0 456l0 56 96 0L224 256l24 0-96-96L0 160zM160 64c0 14 9 27 24.3 37.5c4.1-10 9.6-19.3 16.3-27.7c-2.7-2-4.8-4-6.2-5.6c-1.4-1.7-2-2.8-2.3-3.5c-.1-.3-.2-.5-.2-.6c0-.2 0-.3 0-.3s.1-.3 .2-.6c.3-.6 .9-1.8 2.3-3.5c2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4c1.4 1.7 2 2.8 2.3 3.5c.1 .3 .2 .5 .2 .6c0 .2 0 .3 0 .3s-.1 .3-.2 .6c-.3 .6-.9 1.8-2.3 3.5c-1.4 1.7-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64zM328 256l24 0L480 512l96 0 0-56L528 352l48-72 0-120-152 0-96 96z','M288 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM96 512L224 256l128 0L480 512 96 512z']
      
    ]
  };

  

  
  

  var faFolders = {
    prefix: 'fasds',
    iconName: 'folders',
    icon: [
      576,
      512,
      [],
      'f660',
      
      ['M0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312 0-24L0 96z','M96 384H576V96H368L304 32H96V384z']
      
    ]
  };

  

  
  

  var faGaugeCirclePlus = {
    prefix: 'fasds',
    iconName: 'gauge-circle-plus',
    icon: [
      640,
      512,
      [],
      'e498',
      
      ['M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faCirclePause = {
    prefix: 'fasds',
    iconName: 'circle-pause',
    icon: [
      512,
      512,
      [62092,"pause-circle"],
      'f28b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-96l64 0 0 32 0 128 0 32-64 0 0-32 0-128 0-32zm128 0l64 0 0 32 0 128 0 32-64 0 0-32 0-128 0-32z','M224 160l0 32 0 128 0 32-64 0 0-32 0-128 0-32 64 0zm128 0l0 32 0 128 0 32-64 0 0-32 0-128 0-32 64 0z']
      
    ]
  };

  
    var faPauseCircle = faCirclePause;
  

  
  

  var faBottleWater = {
    prefix: 'fasds',
    iconName: 'bottle-water',
    icon: [
      320,
      512,
      [],
      'e4c5',
      
      ['M32 167.5c0-19.5 10-37.6 26.6-47.9C71.1 111.7 83.7 103.9 96 96l127.9 0c12.4 7.9 25 15.7 37.6 23.6C278 129.9 288 148 288 167.5c0 17-7.5 32.3-19.4 42.6C280.6 221.7 288 238 288 256c0 19.1-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48s-8.4 36.3-21.7 48c13.3 11.7 21.7 28.9 21.7 48l0 64-64 0L96 512l-64 0 0-64c0-19.1 8.4-36.3 21.7-48C40.4 388.3 32 371.1 32 352s8.4-36.3 21.7-48C40.4 292.3 32 275.1 32 256c0-18 7.4-34.3 19.4-45.9C39.5 199.7 32 184.5 32 167.5zM96 224l0 32 128 0 0-32L96 224zm0 128l0 32 128 0 0-32L96 352z','M224 0L96 0l0 96 128 0 0-96zM96 224l0 32 128 0 0-32L96 224zm0 128l0 32 128 0 0-32L96 352z']
      
    ]
  };

  

  
  

  var faFaceSurprise = {
    prefix: 'fasds',
    iconName: 'face-surprise',
    icon: [
      512,
      512,
      [128558,"surprise"],
      'f5c2',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM320 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm48.4-144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faSurprise = faFaceSurprise;
  

  
  

  var faArrowRightToArc = {
    prefix: 'fasds',
    iconName: 'arrow-right-to-arc',
    icon: [
      512,
      512,
      [],
      'e4b2',
      
      ['M256 0l0 64c106 0 192 86 192 192s-86 192-192 192l0 64c141.4 0 256-114.6 256-256S397.4 0 256 0z','M208 98.7l22.6 22.6 112 112L365.3 256l-22.6 22.6-112 112L208 413.3 162.7 368l22.6-22.6L242.7 288 32 288 0 288l0-64 32 0 210.7 0-57.4-57.4L162.7 144 208 98.7z']
      
    ]
  };

  

  
  

  var faUserShakespeare = {
    prefix: 'fasds',
    iconName: 'user-shakespeare',
    icon: [
      448,
      512,
      [],
      'e2c2',
      
      ['M96 288l0 32 0 88 72-40 40 0 0-80L96 288zM128 96l0 64c0 33.4 17 62.8 42.9 80c12.1 8 26 13.4 41.1 15.3l0-31.3 0-12c8 0 16 0 24 0l0 12 0 31.3c15.1-1.9 29-7.2 41.1-15.3C303 222.8 320 193.4 320 160l0-64c0-11.2-1.9-22-5.5-32C301.4 26.7 265.8 0 224 0s-77.4 26.7-90.5 64c-3.5 10-5.5 20.8-5.5 32zm80 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-28 52c4 0 8 0 12 0c2.1 0 12.9-1.9 23.5-12.5L224 159c2.8 2.8 5.7 5.7 8.5 8.5c2 2 6 5.3 10.7 8.1c4.9 2.9 9.4 4.4 12.8 4.4c4 0 8 0 12 0l0 24c-4 0-8 0-12 0c-9.5 0-18.3-3.8-24.8-7.6c-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-4 0-8 0-12 0l0-24zm92-52a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM240 288l0 80 40 0 72 40 0-88 0-32-112 0z','M128 96c0-11.2 1.9-22 5.5-32L104 64l0 72L64 184l0 56 106.9 0C145 222.8 128 193.4 128 160l0-64zm192 0l0 64c0 33.4-17 62.8-42.9 80L384 240l0-56-40-48 0-72-29.5 0c3.5 10 5.5 20.8 5.5 32zM192 144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-36 96l0-12-24 0 0 12 0 32 0 12 24 0 0-12 0-32zm-12-65l-8.5 8.5C204.9 178.1 194.1 180 192 180l-12 0 0 24 12 0c7 0 19.6-3 32.1-12.3c2.2 1.6 4.5 3.2 7.1 4.6c6.5 3.8 15.4 7.6 24.8 7.6l12 0 0-24-12 0c-3.3 0-7.8-1.5-12.8-4.4c-4.8-2.8-8.8-6.1-10.7-8.1L224 159zM96 408l0-88-32 0L0 512l448 0L384 320l-32 0 0 88-72-40-112 0L96 408zm112 8a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faMartiniGlassCitrus = {
    prefix: 'fasds',
    iconName: 'martini-glass-citrus',
    icon: [
      576,
      512,
      ["cocktail"],
      'f561',
      
      ['M0 128l288.9 0 48.4 0 78.7 0 0 32c-17.3 17.3-34.6 34.6-51.9 51.9l-33.9 33.9c-32.7 32.7-65.4 65.4-98.2 98.2l0 120 88 0 0 48-88 0-24 0L96 512l0-48 88 0 0-120L0 160l0-32z','M528 144c0 53-43 96-96 96c-26.5 0-50.5-10.7-67.9-28.1l-33.9 33.9C356.2 271.9 392.2 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0C357.9 0 296.8 56 288.9 128l48.4 0c7.6-45.4 47.1-80 94.7-80c53 0 96 43 96 96z']
      
    ]
  };

  
    var faCocktail = faMartiniGlassCitrus;
  

  
  

  var faBracketsRound = {
    prefix: 'fasds',
    iconName: 'brackets-round',
    icon: [
      512,
      512,
      ["parentheses"],
      'e0c5',
      
      ['M366.2 90.6C391.9 107.7 448 167 448 256s-56.1 148.3-81.8 165.4l35.5 53.3C440.1 449.1 512 371.8 512 256S440.1 63 401.8 37.4L366.2 90.6z','M0 256C0 140.2 71.9 62.9 110.2 37.4l35.5 53.3C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4l-35.5 53.3C71.9 449 0 371.8 0 256z']
      
    ]
  };

  
    var faParentheses = faBracketsRound;
  

  
  

  var faArrowLeftLongToLine = {
    prefix: 'fasds',
    iconName: 'arrow-left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e3d4',
      
      ['M0 64l64 0 0 32 0 320 0 32L0 448l0-32L0 96 0 64z','M150.6 233.4L128 256l22.6 22.6 128 128 22.6 22.6L346.5 384l-22.6-22.6L250.5 288 608 288l32 0 0-64-32 0-357.5 0 73.4-73.4L346.5 128 301.3 82.7l-22.6 22.6-128 128z']
      
    ]
  };

  

  
  

  var faPawSimple = {
    prefix: 'fasds',
    iconName: 'paw-simple',
    icon: [
      448,
      512,
      ["paw-alt"],
      'f701',
      
      ['M0 192a48 48 0 1 0 96 0A48 48 0 1 0 0 192zM96 80a48 48 0 1 0 96 0A48 48 0 1 0 96 80zm160 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm96 112a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M176 160L107.7 283C64.2 293.8 32 333.2 32 380c0 55.2 44.8 100 100 100c24.8 0 47.5-9 65-24l54 0c17.5 15 40.2 24 65 24c55.2 0 100-44.8 100-100c0-46.8-32.2-86.2-75.7-97L272 160l-96 0z']
      
    ]
  };

  
    var faPawAlt = faPawSimple;
  

  
  

  var faHouseCrack = {
    prefix: 'fasds',
    iconName: 'house-crack',
    icon: [
      576,
      512,
      [],
      'e3b1',
      
      ['M64 272l.1 240 166.3 0L192 448l96-80L224 256 384 368l-96 80 38.4 64 186.2 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272z','M0 240L288 0 576 240v32H512L288 88 64 272H0V240z']
      
    ]
  };

  

  
  

  var faLeftToLine = {
    prefix: 'fasds',
    iconName: 'left-to-line',
    icon: [
      448,
      512,
      ["arrow-alt-to-left"],
      'f34b',
      
      ['M0 64L0 96 0 416l0 32 64 0 0-32L64 96l0-32L0 64z','M96 256L256 416l32 0 0-96 160 0 0-128-160 0 0-96-32 0L96 256z']
      
    ]
  };

  
    var faArrowAltToLeft = faLeftToLine;
  

  
  

  var faHexagonMinus = {
    prefix: 'fasds',
    iconName: 'hexagon-minus',
    icon: [
      512,
      512,
      ["minus-hexagon"],
      'f307',
      
      ['M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm160-24l0 48 24 0 144 0 24 0 0-48-24 0-144 0-24 0z','M160 232l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  
    var faMinusHexagon = faHexagonMinus;
  

  
  

  var faDumpsterFire = {
    prefix: 'fasds',
    iconName: 'dumpster-fire',
    icon: [
      640,
      512,
      [],
      'f794',
      
      ['M0 160l114.9 0L140.5 32 32 32 0 160zm0 64l0 64 44 0L64 448l0 32 64 0 0-32 209 0c-30.5-34-49-78.9-49-128.2c0-49.2 20.9-93.1 46.1-127.8L32 192l4 32L0 224zm147.5-64L272 160l0-128-98.9 0L147.5 160zM304 32l0 128 56.5 0c19.7-21.2 40.4-38.5 57.8-50.8L402.9 32 304 32zm131.5 0l11.7 58.6 5.4-3.4L512 146.6l30-30 22.5 18.7c2.3 1.9 4.6 3.8 6.8 5.8L544 32 435.5 32z','M320 320c0-89.6 85.3-165.3 128-192l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160zM480 432.2c35.3 0 64-28.7 64-64c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faCircleArrowDownLeft = {
    prefix: 'fasds',
    iconName: 'circle-arrow-down-left',
    icon: [
      512,
      512,
      [],
      'e0f9',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-96l48 0 0 24 0 102.1L327 151l17-17L377.9 168l-17 17-135 135 94.1 0 24 0 0 48-24 0-152 0-24 0 0-24 0-160 0-24z','M144 368l24 0 152 0 24 0 0-48-24 0-94.1 0L361 185l17-17L344 134.1l-17 17-135 135L192 184l0-24-48 0 0 24 0 160 0 24z']
      
    ]
  };

  

  
  

  var faHouseUser = {
    prefix: 'fasds',
    iconName: 'house-user',
    icon: [
      576,
      512,
      ["home-user"],
      'e1b0',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.7 64 272zM176 448l32-96 160 0 32 96-224 0zM352 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M0 240L288 0 576 240l0 32-64 0L288 88 64 272 0 272l0-32zm224 16a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM400 448l-224 0 32-96 160 0 32 96z']
      
    ]
  };

  
    var faHomeUser = faHouseUser;
  

  
  

  var faMarsAndVenus = {
    prefix: 'fasds',
    iconName: 'mars-and-venus',
    icon: [
      512,
      512,
      [9893],
      'f224',
      
      ['M192 224a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M368 0L496 0l0 128-32 32-47-47-25.6 25.6C407 163.3 416 192.6 416 224c0 80.2-59 146.6-136 158.2l0 1.8 0 24 24 0 24 0 0 48-24 0-24 0 0 32 0 24-48 0 0-24 0-32-24 0-24 0 0-48 24 0 24 0 0-24 0-1.8C155 370.6 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L383 79 336 32 368 0zM352 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z']
      
    ]
  };

  

  
  

  var faFileChartPie = {
    prefix: 'fasds',
    iconName: 'file-chart-pie',
    icon: [
      384,
      512,
      [],
      'f65a',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM64 328c0 66.3 53.7 120 120 120c58.1 0 106.5-41.2 117.6-96L160 352l0-141.6C105.2 221.5 64 269.9 64 328zM192 200l0 120 120 0c0-66.3-53.7-120-120-120z','M384 160l-160 0L224 0 384 160zM64 328c0-58.1 41.2-106.5 96-117.6L160 352l141.6 0c-11.1 54.8-59.5 96-117.6 96c-66.3 0-120-53.7-120-120z']
      
    ]
  };

  

  
  

  var faHeart = {
    prefix: 'fasds',
    iconName: 'heart',
    icon: [
      512,
      512,
      [9829,10084,61578,128153,128154,128155,128156,128420,129293,129294,129505],
      'f004',
      
      ['M64 288L39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c25.5-25.5 60-39.8 96-39.8C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 256 480 64 288z','']
      
    ]
  };

  

  
  

  var faFaceNauseated = {
    prefix: 'fasds',
    iconName: 'face-nauseated',
    icon: [
      512,
      512,
      [],
      'e381',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM77.6 146.8l15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c3.8-3.8 7.5-7.5 11.3-11.3L206.6 112c-3.8 3.8-7.5 7.5-11.3 11.3c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7c-.8 .1-1.7 .3-2.5 .4c-5.3 .9-10.5 1.8-15.8 2.6c-1.8-10.5-3.5-21-5.3-31.6zm60.6 155.6l16-27.7 13.8 8c19.5 11.3 33.8 30.5 38.4 53.3l99.2 0c4.6-22.8 18.9-42 38.4-53.3l13.8-8 16 27.7-13.8 8c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6l13.8 8-16 27.7-13.8-8c-19.5-11.3-33.8-30.5-38.4-53.3l-99.2 0c-4.6 22.8-18.9 42-38.4 53.3l-13.8 8-16-27.7 13.8-8c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6l-13.8-8zm5.5-94.4c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .8 .1 1.6 .1 1.6l0 1.7c0 1.1 0 1.4 0 1.7c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-62.3-96c7.5-7.5 15.1-15.1 22.6-22.6l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-3.8-3.8-7.5-7.5-11.3-11.3z','M206.6 112l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L184 89.4 206.6 112zm-31 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-18.9-52.7L305.4 112 328 89.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z']
      
    ]
  };

  

  
  

  var faBookCircleArrowUp = {
    prefix: 'fasds',
    iconName: 'book-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e0bd',
      
      ['M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 198.6C374.1 219.5 320 287.4 320 368c0 5.4 .2 10.7 .7 16L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l243.2 0c13.1 25.6 32.2 47.6 55.6 64L384 512 96 512c-53 0-96-43-96-96L0 96z','M640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 348.7l56-56L496 281.4l11.3 11.3 56 56L574.6 360 552 382.6l-11.3-11.3L512 342.6l0 89.4 0 16-32 0 0-16 0-89.4-28.7 28.7L440 382.6 417.4 360l11.3-11.3z']
      
    ]
  };

  

  
  

  var faShirtRunning = {
    prefix: 'fasds',
    iconName: 'shirt-running',
    icon: [
      384,
      512,
      [],
      'e3c8',
      
      ['M0 256L0 393.8 343.6 148.4 336 128l0-48 0-16 0-32 0-32L272 0l0 32 0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48 0-32L48 0l0 32 0 32 0 16 0 48L0 256zM0 472.5L0 512l384 0 0-256c-5.7-15.2-11.4-30.4-17.1-45.6C244.6 297.7 122.3 385.1 0 472.5z','M343.6 148.4L0 393.8l0 78.6L366.9 210.4l-23.3-62z']
      
    ]
  };

  

  
  

  var faSignPostsWrench = {
    prefix: 'fasds',
    iconName: 'sign-posts-wrench',
    icon: [
      640,
      512,
      [],
      'e626',
      
      ['M0 32L0 416l384 0c-20.1-26.7-32-60-32-96c0-47.8 21-90.7 54.2-120l9.1-8 12.1 0 20.7 0 32 0 0 32 0 64 32 24 32-24 0-64 0-32 32 0 0-160-64 0 0-32L448 0l0 32L128 32l0-32L64 0l0 32L0 32zM64 448l0 64 64 0 0-64-64 0z','M448 224l-20.7 0c-26.6 23.5-43.3 57.8-43.3 96c0 40.4 18.7 76.5 48 99.9l0 92.1 160 0 0-92.1c29.3-23.5 48-59.5 48-99.9c0-38.2-16.8-72.5-43.3-96L576 224l0 80-64 48-64-48 0-80z']
      
    ]
  };

  

  
  

  var faGridRound4 = {
    prefix: 'fasds',
    iconName: 'grid-round-4',
    icon: [
      448,
      512,
      [],
      'e5dd',
      
      ['M0 196.3a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 196.3zM0 435.2a44.8 44.8 0 1 0 89.6 0A44.8 44.8 0 1 0 0 435.2zM119.5 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm0 238.9a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM238.9 196.3a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm0 238.9a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zM358.4 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm0 238.9a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0z','M44.8 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 238.9a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm74.7-74.7a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zM238.9 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm74.7-74.7a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0 -89.6 0zm44.8 194.1a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6z']
      
    ]
  };

  

  
  

  var faFaceThermometer = {
    prefix: 'fasds',
    iconName: 'face-thermometer',
    icon: [
      576,
      512,
      [],
      'e39a',
      
      ['M32 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-3.2-.1-6.4-.2-9.6c-4.5 4.3-9 8.7-13.5 13c-5.1 4.9-10.2 9.8-15.3 14.8c-5.8 5.6-11.5 11.1-17.3 16.7l-15.3 14.8c-5.8 5.6-11.5 11.1-17.3 16.7c-5.1 4.9-10.2 9.8-15.3 14.8c-5.8 5.6-11.5 11.1-17.3 16.7c-8.6 8.2-17.1 16.5-25.7 24.8c2.3 6.1 .7 13.2-4.5 17.7c-6.7 5.8-16.8 5.1-22.6-1.6c-18-20.7-48.5-42.5-91.9-42.5s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5c18.6 0 35.3 3.2 50.2 8.4c50.3-48.7 100.5-97.3 150.8-146c8.2-7.9 18.7-11.9 29.3-11.9c2 0 4 .1 5.9 .4s3.9 .7 5.8 1.2C495.2 72 400 0 288 0C146.6 0 32 114.6 32 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M548 182.8c-16.2-16.2-42.5-16.5-59-.5l-150.8 146c29.2 10.2 51.2 28.2 65.9 45.2c1.3 1.5 2.2 3.1 2.9 4.8l25.7-24.7-25.1-25.1L399 320l17-17 8.5 8.5 25.4 25.4 15.3-14.8-25.7-25.7L431 288l17-17 8.5 8.5 26 26 15.3-14.8-26.3-26.3L463 256l17-17 8.5 8.5 26.6 26.6 15.3-14.8-26.9-26.9L495 224l17-17 8.5 8.5 27.2 27.2c16.7-16.4 16.9-43.3 .3-59.8zM240.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z']
      
    ]
  };

  

  
  

  var faPlugCircleBolt = {
    prefix: 'fasds',
    iconName: 'plug-circle-bolt',
    icon: [
      576,
      512,
      [],
      'e55b',
      
      ['M0 160l32 0 320 0 32 0 0 38.6C310.1 219.5 256 287.4 256 368c0 11.4 1.1 22.5 3.1 33.3c-11.1 5.1-22.9 9-35.1 11.5l0 99.2-64 0 0-99.2C87 398 32 333.4 32 256l0-32L0 224l0-64zM64 0l64 0 0 32 0 96-64 0 0-96L64 0zM256 0l64 0 0 32 0 96-64 0 0-96 0-32z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm64 16l66.7 0L408 448l104-96-66.7 0L456 288 352 384z']
      
    ]
  };

  

  
  

  var faTrophyStar = {
    prefix: 'fasds',
    iconName: 'trophy-star',
    icon: [
      576,
      512,
      ["trophy-alt"],
      'f2eb',
      
      ['M0 64L0 88C0 222.5 70.4 295.7 140.5 334.1c34.5 18.9 68.8 29.3 94.3 35c5.8 1.3 11.3 2.4 16.2 3.3c-19.5-10.6-43.9-30.9-65.7-69.7c-7.2-3.2-14.4-6.7-21.7-10.7C109.8 262.6 56.4 209.9 48.9 112l84.4 0c-1.5-15.1-2.8-31.1-3.6-48L24 64 0 64zm196.7 74.3l45.7 44.5-10.8 62.8L288 216l56.4 29.7-10.8-62.8 45.7-44.5-63.1-9.2L288 72l-28.2 57.2-63.1 9.2zm128.4 234c4.9-.9 10.3-1.9 16.2-3.3c25.5-5.7 59.8-16.1 94.3-35C505.6 295.7 576 222.5 576 88l0-24-24 0L446.4 64c-.9 16.9-2.1 32.9-3.6 48l84.4 0c-7.5 97.9-60.9 150.6-114.6 179.9c-7.2 4-14.5 7.5-21.7 10.7c-21.9 38.8-46.2 59.1-65.7 69.7z','M128 0c0 273.7 81.3 352.3 128 374.9l0 73.1-72 0-24 0 0 24 0 16 0 24 24 0 208 0 24 0 0-24 0-16 0-24-24 0-72 0 0-73.1C366.7 352.3 448 273.7 448 0L128 0zM316.2 129.2l63.1 9.2-45.7 44.5 10.8 62.8L288 216l-56.4 29.7 10.8-62.8-45.7-44.5 63.1-9.2L288 72l28.2 57.2z']
      
    ]
  };

  
    var faTrophyAlt = faTrophyStar;
  

  
  

  var faCircleThreeQuarters = {
    prefix: 'fasds',
    iconName: 'circle-three-quarters',
    icon: [
      512,
      512,
      [],
      'e125',
      
      ['M256 0l0 256 256 0C512 114.6 397.4 0 256 0z','M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H256V0z']
      
    ]
  };

  

  
  

  var faArrowsToEye = {
    prefix: 'fasds',
    iconName: 'arrows-to-eye',
    icon: [
      640,
      512,
      [],
      'e4bf',
      
      ['M0 33.9L78.1 112 40 112l-24 0 0 48 24 0 96 0 24 0 0-24 0-96 0-24-48 0 0 24 0 38.1L33.9 0 0 33.9zM0 478.1L33.9 512 112 433.9l0 38.1 0 24 48 0 0-24 0-96 0-24-24 0-96 0-24 0 0 48 24 0 38.1 0L0 478.1zM480 16l0 24 0 96 0 24 24 0 96 0 24 0 0-48-24 0-38.1 0L640 33.9 606.1 0 528 78.1 528 40l0-24-48 0zm0 336l0 24 0 96 0 24 48 0 0-24 0-38.1L606.1 512 640 478.1 561.9 400l38.1 0 24 0 0-48-24 0-96 0-24 0z','M128 256c20-48 86.4-144 192-144s172 96 192 144c-20 48-86.4 144-192 144s-172-96-192-144zm192 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faScrewdriverWrench = {
    prefix: 'fasds',
    iconName: 'screwdriver-wrench',
    icon: [
      512,
      512,
      ["tools"],
      'f7d9',
      
      ['M0 416l96 96L233.4 374.6 210.7 352l22.6-22.6 8.4-8.4-73.4-73.4L0 416zm70.1-8L104 374.1 137.9 408 104 441.9 70.1 408zM224 144c0 .3 0 .5 0 .8l97 97 8.4-8.4L352 210.7l22.6 22.6 45.1 45.1c54-20.8 92.3-73.1 92.3-134.4c0-19-3.7-37.1-10.3-53.7L416 176l-80 0 0-80 85.7-85.7C405.1 3.7 387 0 368 0C288.5 0 224 64.5 224 144z','M158.1 192L287 321l-31 31L416 512l96-96L352 256l-31 31-129-129L192 96 64 0 0 64 96 192l62.1 0z']
      
    ]
  };

  
    var faTools = faScrewdriverWrench;
  

  
  

  var faHandHorns = {
    prefix: 'fasds',
    iconName: 'hand-horns',
    icon: [
      384,
      512,
      [],
      'e1a9',
      
      ['M0 272l0 91c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l0-32 0-128 0-128-64 0 0 128 0 128-96 0 0 48 0 16-16 0L96 384l-16 0 0-32 16 0 96 0 0-32 0-48-8 0L0 272zM32 0l0 240 64 0L96 0 32 0z','M192 128l-64 0 0 112 64 0 0-112zm96 32l-64 0 0 128 64 0 0-128z']
      
    ]
  };

  

  
  

  var faFaceSleepy = {
    prefix: 'fasds',
    iconName: 'face-sleepy',
    icon: [
      512,
      512,
      [],
      'e38e',
      
      ['M0 256C0 397.4 114.6 512 256 512c47.1 0 91.2-12.7 129.1-34.9c-.7-4.3-1.1-8.7-1.1-13.1c0-22.9-.7-52.8-14.9-74.8l-13.9-21.7 18.2-18.2 20-20 15.4-15.4 19.9 8.6c20.7 8.9 42.4 21.3 61.4 37.3C504.2 328.1 512 293 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm91.2 5.6c8.6-6.4 17.1-12.8 25.6-19.2c21.6 28.8 64.8 28.8 86.4 0c8.5 6.4 17.1 12.8 25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0zM165 419c4.1-39.8 43.1-71 90.6-71s86.5 31.2 90.6 71c-25.4-14.5-56.8-23-90.6-23s-65.2 8.5-90.6 23zM283.2 261.6c8.6-6.4 17.1-12.8 25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0z','M203.2 242.4c-21.6 28.8-64.8 28.8-86.4 0L91.2 261.6c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2zm192 0c-21.6 28.8-64.8 28.8-86.4 0l-25.6 19.2c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2zM512 464c0-52.9-49-91.8-96-112.1l-20 20c20 31.1 20 70.4 20 92.1c0 26.5 21.5 48 48 48s48-21.5 48-48z']
      
    ]
  };

  

  
  

  var faTarp = {
    prefix: 'fasds',
    iconName: 'tarp',
    icon: [
      576,
      512,
      [],
      'e57b',
      
      ['M0 64L0 448l416 0 0-160 160 0 0-224L0 64zm128 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M576 288L416 448l0-160 160 0z']
      
    ]
  };

  

  
  

  var faHammerBrush = {
    prefix: 'fasds',
    iconName: 'hammer-brush',
    icon: [
      640,
      512,
      [],
      'e620',
      
      ['M0 144l0 16 80-32 32 32 96 0 48 0 0-32 32 0 0 32 64 0L352 0 288 0l0 32-32 0 0-32L144 0C64.5 0 0 64.5 0 144zM352 320l0 192 64 0 32-96 32 96 160 0 0-192-288 0z','M352 256l0 64 288 0 0-64-96-64L544 0 448 0l0 192-96 64zM496 64a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM112 160L96 512l128 0L208 160l-96 0z']
      
    ]
  };

  

  
  

  var faClockNine = {
    prefix: 'fasds',
    iconName: 'clock-nine',
    icon: [
      512,
      512,
      [],
      'e34c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-24l24 0 80 0 0-112 0-24 48 0 0 24 0 136 0 24-24 0-104 0-24 0 0-48z','M280 96l0 24 0 136 0 24-24 0-104 0-24 0 0-48 24 0 80 0 0-112 0-24 48 0z']
      
    ]
  };

  

  
  

  var faHandsHoldingHeart = {
    prefix: 'fasds',
    iconName: 'hands-holding-heart',
    icon: [
      640,
      512,
      ["hands-heart"],
      'f4c3',
      
      ['M0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40L0 64zM352 338.7l0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0 0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4z','M224 159.9l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56l0-3.6C176 33.8 209.9-.1 251.6-.1c23 0 44.7 10.4 59.1 28.4L320 39.9l9.3-11.6C343.6 10.4 365.4-.1 388.4-.1C430.1-.1 464 33.8 464 75.6l0 3.6c0 21-8.3 41.1-23.2 56L416 159.9l-96 96-96-96z']
      
    ]
  };

  
    var faHandsHeart = faHandsHoldingHeart;
  

  
  

  var faBasketShoppingSimple = {
    prefix: 'fasds',
    iconName: 'basket-shopping-simple',
    icon: [
      576,
      512,
      ["shopping-basket-alt"],
      'e0af',
      
      ['M0 192l0 64 32 0L96 512l384 0 64-256 32 0 0-64-130.2 0c8 18.1 16.1 36.2 24.1 54.3c3.3 7.3 6.5 14.6 9.8 21.9l-43.9 19.5-9.7-21.9L393.3 192l-210.6 0-32.8 73.7c-3.2 7.3-6.5 14.6-9.7 21.9c-14.6-6.5-29.2-13-43.9-19.5l9.7-21.9c8-18.1 16.1-36.2 24.1-54.3L0 192z','M245.9 49.7l9.7-21.9L211.8 8.3l-9.7 21.9-96 216-9.7 21.9 43.9 19.5 9.7-21.9 96-216zm84.1 0l96 216 9.7 21.9 43.9-19.5-9.7-21.9-96-216L364.2 8.3 320.3 27.8l9.7 21.9z']
      
    ]
  };

  
    var faShoppingBasketAlt = faBasketShoppingSimple;
  

  
  

  var faH = {
    prefix: 'fasds',
    iconName: 'h',
    icon: [
      384,
      512,
      [104],
      '48',
      
      ['M320 256l0 192 0 32 64 0 0-32 0-192 0-32 0-32 0-128 0-32-64 0 0 32 0 128L64 192 64 64l0-32L0 32 0 64 0 192l0 64L0 448l0 32 64 0 0-32 0-192 256 0z','']
      
    ]
  };

  

  
  

  var faLeftFromLine = {
    prefix: 'fasds',
    iconName: 'left-from-line',
    icon: [
      448,
      512,
      ["arrow-alt-from-right"],
      'f348',
      
      ['M384 64l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M0 256L160 416l32 0 0-96 160 0 0-128-160 0 0-96-32 0L0 256z']
      
    ]
  };

  
    var faArrowAltFromRight = faLeftFromLine;
  

  
  

  var faCupStraw = {
    prefix: 'fasds',
    iconName: 'cup-straw',
    icon: [
      384,
      512,
      [129380],
      'e363',
      
      ['M32 192l320 0L320 512 64 512 32 192z','M224 0L205 0l-4.4 18.5L174.9 128 32 128 0 128l0 64 32 0 320 0 32 0 0-64-32 0-127.8 0L243 48l37 0 24 0 0-48L280 0 224 0z']
      
    ]
  };

  

  
  

  var faMessageSmile = {
    prefix: 'fasds',
    iconName: 'message-smile',
    icon: [
      512,
      512,
      ["comment-alt-smile"],
      'f4aa',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM132.7 254.1l16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32l-16-17.9-35.8 32zM160 144a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M224 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 240l-16-17.9-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z']
      
    ]
  };

  
    var faCommentAltSmile = faMessageSmile;
  

  
  

  var faSpaceStationMoon = {
    prefix: 'fasds',
    iconName: 'space-station-moon',
    icon: [
      512,
      512,
      [],
      'e033',
      
      ['M0 256c0 7.8 .3 15.5 1 23.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c.7-7.6 1-15.3 1-23.1C512 114.6 397.4 0 256 0S0 114.6 0 256zm6.8 58.8C33.4 427.9 134.9 512 256 512s222.6-84.1 249.2-197.2C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2zM272 160a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M224 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM6.8 314.8C4.1 303.2 2.1 291.3 1 279.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c-1.1 12.2-3 24.1-5.8 35.8C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2z']
      
    ]
  };

  

  
  

  var faMelonSlice = {
    prefix: 'fasds',
    iconName: 'melon-slice',
    icon: [
      512,
      512,
      [],
      'e311',
      
      ['M34.6 384.6c2.1 2.1 4.3 4.3 6.4 6.4c72.9 72.9 179.6 91.1 269.3 54.4c3.6-1.5 7.2-3.1 10.8-4.7c3.6-1.7 7.1-3.5 10.7-5.3c1.7-.9 3.3-1.8 5-2.7c.5-.3 1-.6 1.5-.9c.7-.4 1.5-.8 2.2-1.3c11.2-6.5 22-13.9 32.3-22.3c3.2-2.6 6.4-5.3 9.5-8.2c3.1-2.8 6.2-5.7 9.2-8.7c3-3 5.9-6 8.7-9.2c2.8-3.1 5.5-6.3 8.2-9.5c.1-.1 .2-.2 .3-.4c2.5-3.1 5-6.3 7.4-9.5c2.6-3.5 5-7 7.4-10.6c2.2-3.3 4.3-6.6 6.2-10c2-3.4 4-7 5.9-10.5c.9-1.7 1.8-3.4 2.6-5.1c.8-1.7 1.7-3.4 2.5-5.1C483.5 229.6 467 116.9 391 41c-2.1-2.1-4.3-4.3-6.2-6.6c-22.4 22.4-44.6 44.5-66.7 66.7c1.2 8.8 1.9 17.8 1.9 26.9c0 106-86 192-192 192c-9.1 0-18.1-.6-26.9-1.9c-22.2 22.2-44.3 44.3-66.5 66.5z','M34.6 384.6L41 391s0 0 0 0c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4l-6.4-6.4L418.6 .6 425 7c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c0 0 0 0 0 0L.6 418.6l33.9-33.9z']
      
    ]
  };

  

  
  

  var faPersonCircleQuestion = {
    prefix: 'fasds',
    iconName: 'person-circle-question',
    icon: [
      576,
      512,
      [],
      'e542',
      
      ['M.2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 2.3-1.4c8.4-21.4 20.8-40.7 36.3-57L238 142.8 228.6 128l-17.5 0-102.2 0-17.5 0L82 142.8 .2 270.8zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm80-46.4l0 6.4 32 0 0-6.4c0-5.3 4.3-9.6 9.6-9.6l40.5 0c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8-8.6 4.5 0 9.7 0 6.8 0 16 32 0 0-13.1 23.5-12.3c10.2-5.4 17.8-14.2 21.7-24.6l2.9 0 0-16c0-25.4-20.6-45.9-45.9-45.9l-40.5 0c-23 0-41.6 18.6-41.6 41.6zM448 448l0-32-32 0 0 32 32 0z']
      
    ]
  };

  

  
  

  var faCashRegister = {
    prefix: 'fasds',
    iconName: 'cash-register',
    icon: [
      512,
      512,
      [],
      'f788',
      
      ['M32 0l0 128 112 0 0 32 64 0 0-32 112 0L320 0 32 0zM80 48l16 0 160 0 16 0 0 32-16 0L96 80 80 80l0-32zm8 168l0 48 48 0 0-48-48 0zm48 80l0 48 48 0 0-48-48 0zm48-80l0 48 48 0 0-48-48 0zm48 80l0 48 48 0 0-48-48 0zm48-80l0 48 48 0 0-48-48 0zm48 80l0 48 48 0 0-48-48 0zm48-80l0 48 48 0 0-48-48 0z','M0 512L0 371.2 32 160l448 0 32 211.2L512 512 0 512zm64-96l0 32 16 0 352 0 16 0 0-32-16 0L80 416l-16 0zm72-200l-48 0 0 48 48 0 0-48zm48 0l0 48 48 0 0-48-48 0zm0 80l-48 0 0 48 48 0 0-48zm96-80l0 48 48 0 0-48-48 0zm0 80l-48 0 0 48 48 0 0-48zm96-80l0 48 48 0 0-48-48 0zm0 80l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faOctagonPlus = {
    prefix: 'fasds',
    iconName: 'octagon-plus',
    icon: [
      512,
      512,
      ["plus-octagon"],
      'f301',
      
      ['M0 160L160 0 352 0 512 160l0 192L352 512l-192 0L0 352 0 160zm144 72l0 48 24 0 64 0 0 64 0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0z','M232 344l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  
    var faPlusOctagon = faOctagonPlus;
  

  
  

  var faSignsPost = {
    prefix: 'fasds',
    iconName: 'signs-post',
    icon: [
      512,
      512,
      ["map-signs"],
      'f277',
      
      ['M224 0l64 0 0 64-64 0 0-64zm0 192l64 0 0 32-64 0 0-32zm0 160l64 0 0 160-64 0 0-160z','M448 64L32 64l0 128 416 0 64-64L448 64zM64 224L0 288l64 64 416 0 0-128L64 224z']
      
    ]
  };

  
    var faMapSigns = faSignsPost;
  

  
  

  var faArrowRight = {
    prefix: 'fasds',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      ['M0 224l0 64 32 0 290.7 0 32-32c-10.7-10.7-21.3-21.3-32-32L32 224 0 224z','M445.3 256l-22.6 22.6-144 144L256 445.3 210.7 400l22.6-22.6L354.7 256 233.4 134.6 210.7 112 256 66.8l22.6 22.6 144 144L445.3 256z']
      
    ]
  };

  

  
  

  var faSignatureLock = {
    prefix: 'fasds',
    iconName: 'signature-lock',
    icon: [
      640,
      512,
      [],
      'e3ca',
      
      ['M0 264.2L0 288 0 448l0 32 32 0 64 0 18.6 0 9.2-16.1 25.5-44.7c26.8-47 46.5-97.7 58.4-150.5L288 244.6l0 43.4 0 32 32 0 32 0 32 0 0-32 0-32-32 0 0-54.4 0-43-41.2 12.4-90.4 27.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32 0 32 64 0 0-32 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5l-130 39L0 264.2zm64 47.6l71.8-21.5c-10.4 33.8-24.5 66.4-42.1 97.2L77.4 416 64 416l0-104.2zM187.5 416L384 416l0-48-174.1 0c-6.7 16.3-14.2 32.3-22.3 48z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faTickets = {
    prefix: 'fasds',
    iconName: 'tickets',
    icon: [
      640,
      512,
      [],
      'e658',
      
      ['M96 32l0 128c26.5 0 48 21.5 48 48s-21.5 48-48 48l0 128 544 0 0-128c-26.5 0-48-21.5-48-48s21.5-48 48-48l0-128L96 32zm96 64l32 0 288 0 32 0 0 32 0 160 0 32-32 0-288 0-32 0 0-32 0-160 0-32zm32 32l0 160 288 0 0-160-288 0z','M48 120l0-24L0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312zm176 8l288 0 0 160-288 0 0-160zM192 96l0 32 0 160 0 32 32 0 288 0 32 0 0-32 0-160 0-32-32 0L224 96l-32 0z']
      
    ]
  };

  

  
  

  var faMaskVentilator = {
    prefix: 'fasds',
    iconName: 'mask-ventilator',
    icon: [
      640,
      512,
      [],
      'e524',
      
      ['M0 128l0 24L0 344l0 18.7 18.2 4.5 144.1 36c-12.6-16.9-22.1-36-27.9-56.5L48 325.3 48 176l111.1 0c7.5-16.5 16.2-32.8 26-48L24 128 0 128zM288 288l0 224 64 0 0-224-64 0zM454.5 128c9.8 15.2 18.6 31.5 26.1 48L592 176l0 149.3-86.4 21.6c-5.8 20.6-15.5 39.6-28.2 56.5l144.4-36.1 18.2-4.5 0-18.7 0-192 0-24-24 0-161.5 0z','M384 469.8l0-76.6c19.6-16.3 32-40.1 32-66.8c0-26.5-12.5-63.2-32.2-91.6L352 192l-32 0-32 0-32 42.8c-19.6 28.4-32 65.1-32 91.6c0 26.6 12.3 50.5 32 66.9l0 76.6c-75-24.5-128-91-128-169.1c0-53 24.7-126.5 64-183.2L256 32l128 0 63.6 85.6C487 174.3 512 247.8 512 300.8c0 78.6-53.9 144.5-128 169z']
      
    ]
  };

  

  
  

  var faSendBack = {
    prefix: 'fasds',
    iconName: 'send-back',
    icon: [
      640,
      512,
      [],
      'f87e',
      
      ['M0 0L64 0 192 0l64 0 0 64 0 32 0 96 0 64-64 0-32 0-96 0L0 256l0-64L0 64 0 0zM64 64l0 128 128 0 0-128L64 64zM384 256l64 0 32 0 96 0 64 0 0 64 0 128 0 64-64 0-128 0-64 0 0-64 0-32 0-96 0-64zm64 64l0 128 128 0 0-128-128 0z','M160 416l0-160 96 0 0-160 224 0 0 160-96 0 0 160-224 0z']
      
    ]
  };

  

  
  

  var faCalendarArrowDown = {
    prefix: 'fasds',
    iconName: 'calendar-arrow-down',
    icon: [
      448,
      512,
      ["calendar-download"],
      'e0d0',
      
      ['M0 192L0 512l448 0 0-320L0 192zM110.1 344L144 310.1l17 17 39 39L200 264l0-24 48 0 0 24 0 102.1 39-39 17-17L337.9 344l-17 17-80 80-17 17-17-17-80-80-17-17z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zm88 264l0-24-48 0 0 24 0 102.1-39-39-17-17L110.1 344l17 17 80 80 17 17 17-17 80-80 17-17L304 310.1l-17 17-39 39L248 264z']
      
    ]
  };

  
    var faCalendarDownload = faCalendarArrowDown;
  

  
  

  var faChartLine = {
    prefix: 'fasds',
    iconName: 'chart-line',
    icon: [
      512,
      512,
      ["line-chart"],
      'f201',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M470.6 150.6l-128 128L320 301.3l-22.6-22.6L240 221.3l-89.4 89.4-45.3-45.3 112-112L240 130.7l22.6 22.6L320 210.7 425.4 105.4l45.3 45.3z']
      
    ]
  };

  
    var faLineChart = faChartLine;
  

  
  

  var faFrenchFries = {
    prefix: 'fasds',
    iconName: 'french-fries',
    icon: [
      384,
      512,
      [127839],
      'f803',
      
      ['M0 80L41.8 90.5 59.7 192l-41.1 0L0 80zM64 32L112 0l16 90.7L128 272l-10.3 0L97.4 221.4 64 32zM160 0l64 32 0 208 0 32-64 0L160 0zm96 48l64-16L289.8 213.4 266.3 272 256 272l0-224zm69.8 144L342.7 90.3 384 80 365.3 192l-39.6 0z','M64 512L0 224H64l32 80H288l32-80h64L320 512H64z']
      
    ]
  };

  

  
  

  var faObjectGroup = {
    prefix: 'fasds',
    iconName: 'object-group',
    icon: [
      576,
      512,
      [],
      'f247',
      
      ['M0 0L0 128l32 0 0 256L0 384 0 512l128 0 0-32 320 0 0 32 128 0 0-128-32 0 0-256 32 0L576 0 448 0l0 32L128 32l0-32L0 0zM96 96l384 0 0 320L96 416 96 96z','M320 128l-192 0 0 160 192 0 0-160zM256 384l192 0 0-160-96 0 0 64 0 32-32 0-64 0 0 64z']
      
    ]
  };

  

  
  

  var faRingsWedding = {
    prefix: 'fasds',
    iconName: 'rings-wedding',
    icon: [
      512,
      512,
      [],
      'f81b',
      
      ['M94.1 48l3.6-7.2 16-32L118.1 0 128 0l96 0 9.9 0 4.4 8.8 16 32 3.6 7.2-3.6 7.2-24.6 49.2c-8.5-2.7-17.2-4.8-26.2-6.2c-4.5-.7-9-1.2-13.6-1.6c-2.3-.2-4.6-.3-6.9-.4c-1.2 0-2.3-.1-3.5-.1s-2.3 0-3.5 0c-18.7 0-36.8 2.9-53.7 8.3L97.7 55.2 94.1 48zM160 336c0-64.4 34.5-120.7 86.1-151.3c16.8 13.5 29.7 31.8 36.5 52.9c-34.9 19-58.6 56-58.6 98.5c0 61.9 50.1 112 112 112s112-50.1 112-112c0-46.1-27.8-85.7-67.6-102.9c-5-26.2-14.8-50.7-28.6-72.4C441.6 168.7 512 244.1 512 336c0 97.2-78.8 176-176 176c-55.3 0-104.7-25.5-137-65.5c-14.8-18.3-26-39.6-32.5-62.9c-4.3-15.3-6.5-31.2-6.5-47.6z','M176 160c-61.9 0-112 50.1-112 112c0 58.7 45.1 106.8 102.5 111.6c6.5 23.3 17.7 44.6 32.5 62.9c-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272S78.8 96 176 96s176 78.8 176 176c0 52.3-22.8 99.2-59 131.5c-18.7-11.9-32.1-31.5-35.9-54.2C276.2 329.2 288 302 288 272c0-61.9-50.1-112-112-112z']
      
    ]
  };

  

  
  

  var faBreadLoaf = {
    prefix: 'fasds',
    iconName: 'bread-loaf',
    icon: [
      640,
      512,
      [127838],
      'f7eb',
      
      ['M0 192c0 35.3 28.7 64 64 64l0 224c117.4 0 234.7 0 352 0l0-224c35.3 0 64-28.7 64-64C480 64 304 32 240 32S0 64 0 192z','M640 192C640 64 464 32 400 32L240 32c64 0 240 32 240 160c0 35.3-28.7 64-64 64l0 224 160 0 0-224c35.3 0 64-28.7 64-64z']
      
    ]
  };

  

  
  

  var faFaceRollingEyes = {
    prefix: 'fasds',
    iconName: 'face-rolling-eyes',
    icon: [
      512,
      512,
      [128580,"meh-rolling-eyes"],
      'f5a5',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-32c0-32.9 24.8-60 56.8-63.6c2.4-.2 4.8-.4 7.2-.4s4.9 .2 7.2 .4C199.2 164 224 191.1 224 224c0 35.3-28.7 64-64 64s-64-28.7-64-64zm80 144l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zM416 224.1A64 64 0 1 1 288 224a64 64 0 1 1 128 .1z','M195.6 180.4c0 19.6-15.9 35.6-35.6 35.6s-35.6-15.9-35.6-35.6c0-3 .4-6 1.1-8.8c9.6-7.3 21.5-11.6 34.5-11.6s24.9 4.3 34.5 11.6c.7 2.8 1.1 5.8 1.1 8.8zM384 184c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-6.9 2.2-13.2 5.8-18.4c8-3.6 16.8-5.6 26.2-5.6s18.2 2 26.2 5.6c3.7 5.2 5.8 11.6 5.8 18.4z']
      
    ]
  };

  
    var faMehRollingEyes = faFaceRollingEyes;
  

  
  

  var faHexagonVerticalNft = {
    prefix: 'fasds',
    iconName: 'hexagon-vertical-nft',
    icon: [
      448,
      512,
      [],
      'e505',
      
      ['M0 128L224 0 448 128l0 256L224 512 0 384 0 128zm64 32l0 16 0 160 0 16 32 0 0-16 0-77.7 24.7 82.3 3.4 11.4 11.9 0 8 0 16 0 0-16 0-160 0-16-32 0 0 16 0 77.7-24.7-82.2L99.9 160 88 160l-8 0-16 0zm128 0l0 16 0 80 0 80 0 16 32 0 0-16 0-64 32 0 16 0 0-32-16 0-32 0 0-48 32 0 16 0 0-32-16 0-48 0-16 0zm96 0l0 32 16 0 16 0 0 144 0 16 32 0 0-16 0-144 16 0 16 0 0-32-16 0-32 0-32 0-16 0z','M64 160l16 0 8 0 11.9 0 3.4 11.4L128 253.7l0-77.7 0-16 32 0 0 16 0 160 0 16-16 0-8 0-11.9 0-3.4-11.4L96 258.3 96 336l0 16-32 0 0-16 0-160 0-16zm128 0l16 0 48 0 16 0 0 32-16 0-32 0 0 48 32 0 16 0 0 32-16 0-32 0 0 64 0 16-32 0 0-16 0-80 0-80 0-16zm96 0l16 0 32 0 32 0 16 0 0 32-16 0-16 0 0 144 0 16-32 0 0-16 0-144-16 0-16 0 0-32z']
      
    ]
  };

  

  
  

  var faUserCowboy = {
    prefix: 'fasds',
    iconName: 'user-cowboy',
    icon: [
      448,
      512,
      [],
      'f8ea',
      
      ['M96 221.7c17.4 10.1 36.9 18.7 58.3 24.7c10.7 3 21.9 5.4 33.5 7.1c5.8 .8 11.7 1.4 17.8 1.9c3 .2 6.1 .4 9.1 .5c1.5 .1 3.1 .1 4.6 .1s3.1 0 4.7 0c50 0 93.2-14.1 128-34.3c0 .8 0 1.5 0 2.3c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-.8 0-1.5 0-2.3z','M110 112.4L160 0l64 32L288 0l50 112.4c-27.2 8.7-64.7 15.6-114 15.6s-86.7-6.9-114-15.6zm-81.2-10c5.6 7.5 22.7 22 55 34.7C115.8 149.6 161.8 160 224 160s108.2-10.4 140.2-22.9c32.4-12.7 49.4-27.2 55-34.7l28 14.7c-9.3 27.9-35 62.4-72.5 89.9C336.7 234.6 285.4 256 224 256s-112.7-21.4-150.6-49.1C35.8 179.5 10.1 145 .8 117.1l28-14.7zM400 384l48 128L0 512 48 384l352 0z']
      
    ]
  };

  

  
  

  var faSeal = {
    prefix: 'fasds',
    iconName: 'seal',
    icon: [
      512,
      512,
      [],
      'e241',
      
      ['M331 75L256 0 181 75 75 75l0 106L0 256l75 75 0 106 106 0 75 75 75-75 106 0 0-106 75-75-75-75 0-106L331 75z','']
      
    ]
  };

  

  
  

  var faPlaneCircleCheck = {
    prefix: 'fasds',
    iconName: 'plane-circle-check',
    icon: [
      640,
      512,
      [],
      'e555',
      
      ['M0 288l0 96 192-64 0 80-64 48 0 64 128-32 128 32 0-8.2c-39.1-32.3-64-81.1-64-135.8c0-64.1 34.3-120.2 85.5-151L320 160l0-66.3C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 66.3L0 288z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faCircleRight = {
    prefix: 'fasds',
    iconName: 'circle-right',
    icon: [
      512,
      512,
      [61838,"arrow-alt-circle-right"],
      'f35a',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM128 208l0 96 128 0 0 80 32 0L416 256 288 128l-32 0 0 80-128 0z','M256 304l0 80 32 0L416 256 288 128l-32 0 0 80-128 0 0 96 128 0z']
      
    ]
  };

  
    var faArrowAltCircleRight = faCircleRight;
  

  
  

  var faEject = {
    prefix: 'fasds',
    iconName: 'eject',
    icon: [
      448,
      512,
      [9167],
      'f052',
      
      ['M0 384l448 0 0 96L0 480l0-96z','M0 272v48H448V272L224 32 0 272z']
      
    ]
  };

  

  
  

  var faStarship = {
    prefix: 'fasds',
    iconName: 'starship',
    icon: [
      640,
      512,
      [],
      'e039',
      
      ['M0 96l32 0 176 0 32 0 0 64-32 0-71 0-72.9 0L32 160 0 160 0 96zM0 352l32 0 32.1 0 72.9 0 71 0 32 0 0 64-32 0L32 416 0 416l0-64zm256-96c0-24.6 4.6-48 13-69.6C296.9 114.8 366.5 64 448 64c106 0 192 86 192 192s-86 192-192 192c-81.5 0-151.1-50.8-179-122.4c-8.4-21.6-13-45.1-13-69.6zm128 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M129.1 216.8L64.1 160l72.9 0 50.4 44.1L269 186.4c-8.4 21.6-13 45.1-13 69.6s4.6 48 13 69.6l-81.6-17.7L137 352l-72.9 0 64.9-56.8L96 288l0-64 33.1-7.2zM384 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faSimCards = {
    prefix: 'fasds',
    iconName: 'sim-cards',
    icon: [
      448,
      512,
      [],
      'e251',
      
      ['M96 0l32 0L320 0l13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 256 0 32-32 0-288 0-32 0 0-32L96 32 96 0zm64 144l0 48 0 32 0 48 0 32 0 48 48 0 32 0 64 0 32 0 48 0 0-48 0-32 0-48 0-32 0-48-48 0-32 0-64 0-32 0-48 0z','M48 120l0-24L0 96l0 24L0 488l0 24 24 0 336 0 24 0 0-48-24 0L48 464l0-344zm112 24l0 48 48 0 0-48-48 0zm0 128l64 0 96 0 64 0 0-48-64 0-96 0-64 0 0 48zM384 144l-48 0 0 48 48 0 0-48zm-144 0l0 48 64 0 0-48-64 0zm96 160l0 48 48 0 0-48-48 0zm-32 0l-64 0 0 48 64 0 0-48zm-96 0l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faCommentCode = {
    prefix: 'fasds',
    iconName: 'comment-code',
    icon: [
      512,
      512,
      [],
      'e147',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm102.1 0l17-17 64-64 17-17L233.9 176l-17 17-47 47 47 47 17 17L200 337.9l-17-17-64-64-17-17zm176-64L312 142.1l17 17 64 64 17 17-17 17-64 64-17 17L278.1 304l17-17 47-47-47-47-17-17z','M233.9 176l-17 17-47 47 47 47 17 17L200 337.9l-17-17-64-64-17-17 17-17 64-64 17-17L233.9 176zM312 142.1l17 17 64 64 17 17-17 17-64 64-17 17L278.1 304l17-17 47-47-47-47-17-17L312 142.1z']
      
    ]
  };

  

  
  

  var faHelmetSafety = {
    prefix: 'fasds',
    iconName: 'helmet-safety',
    icon: [
      576,
      512,
      ["hard-hat","hat-hard"],
      'f807',
      
      ['M0 384l32 0 512 0 32 0 0 24s-80 72-288 72S0 408 0 408l0-24z','M224 32l128 0 0 34.3L352 176l64.5-90.2C491.2 121.5 543 197.4 544 285.6l0 98.4L32 384l0-96c0-89.2 52.1-166.2 127.6-202.2L224 176l0-109.7L224 32z']
      
    ]
  };

  
    var faHardHat = faHelmetSafety;
  
    var faHatHard = faHelmetSafety;
  

  
  

  var faToiletPaper = {
    prefix: 'fasds',
    iconName: 'toilet-paper',
    icon: [
      640,
      512,
      [129531],
      'f71e',
      
      ['M8 512l357.3 0 8.2-19.7c14.1-34.1 23.6-70.7 29.9-108.3C414.3 320.1 416 253.4 416 192c0-79.2 24-147.2 58.2-176.5C485.8 5.5 498.6 0 512 0L160 0C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8L8 512zM160 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M403.5 384C414.3 320.1 416 253.4 416 192c0 0 0 0 0 0c0-79.2 24-147.2 58.2-176.5C485.8 5.5 498.6 0 512 0c53 0 96 86 96 192s-43 192-96 192l-108.5 0zM512 256c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM128 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z']
      
    ]
  };

  

  
  

  var faKaaba = {
    prefix: 'fasds',
    iconName: 'kaaba',
    icon: [
      576,
      512,
      [128331],
      'f66b',
      
      ['M0 223.1l0 33.7c21.3 7.1 42.7 14.2 64 21.3c0-11.2 0-22.5 0-33.7c-19.6-6.5-39.3-13.1-58.9-19.6L0 223.1zM79.8 120L288 189.4c69.4-23.1 138.8-46.3 208.2-69.4C426.8 96.9 357.4 73.7 288 50.6C218.6 73.7 149.2 96.9 79.8 120zM96 255.1c0 11.2 0 22.5 0 33.7l96 32c0-11.2 0-22.5 0-33.7c-32-10.7-64-21.3-96-32zm128 42.7c0 11.2 0 22.5 0 33.7l58.9 19.6c1.7 .6 3.4 1.1 5.1 1.7c1.7-.6 3.4-1.1 5.1-1.7c19.6-6.5 39.3-13.1 58.9-19.6l0-33.7-64 21.3-64-21.3zm160-10.7l0 33.7 96-32 0-33.7-96 32zm128-42.7l0 33.7 64-21.3 0-33.7c-1.7 .6-3.4 1.1-5.1 1.7L512 244.5z','M288 0L0 96l0 32 0 15.1 0 .9 288 96 288-96 0-.9 0-15.1 0-32L288 0zm0 189.4L79.8 120 288 50.6 496.2 120 288 189.4zM0 176.9l0 46.3 5.1 1.7L64 244.5l0 33.7L0 256.9 0 416l288 96 288-96 0-159.1-64 21.3 0-33.7 58.9-19.6 5.1-1.7 0-46.3L293.1 271.2l-5.1 1.7-5.1-1.7L0 176.9zm96 112l0-33.7 96 32 0 33.7-96-32zm128 42.7l0-33.7 64 21.3 64-21.3 0 33.7-58.9 19.6-5.1 1.7-5.1-1.7L224 331.5zm160-44.4l96-32 0 33.7-96 32 0-33.7z']
      
    ]
  };

  

  
  

  var faSquareList = {
    prefix: 'fasds',
    iconName: 'square-list',
    icon: [
      448,
      512,
      [],
      'e489',
      
      ['M0 32l448 0 0 448L0 480 0 32zm64 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zM168 136l0 48 24 0 160 0 24 0 0-48-24 0-160 0-24 0zm0 96l0 48 24 0 160 0 24 0 0-48-24 0-160 0-24 0zm0 96l0 48 24 0 160 0 24 0 0-48-24 0-160 0-24 0z','M168 136l24 0 160 0 24 0 0 48-24 0-160 0-24 0 0-48zm0 192l24 0 160 0 24 0 0 48-24 0-160 0-24 0 0-48zm24-96l160 0 24 0 0 48-24 0-160 0-24 0 0-48 24 0z']
      
    ]
  };

  

  
  

  var faLocationPin = {
    prefix: 'fasds',
    iconName: 'location-pin',
    icon: [
      384,
      512,
      ["map-marker"],
      'f041',
      
      ['M384 192c0 112-192 320-192 320S0 304 0 192C0 86 86 0 192 0S384 86 384 192z','']
      
    ]
  };

  
    var faMapMarker = faLocationPin;
  

  
  

  var faTelescope = {
    prefix: 'fasds',
    iconName: 'telescope',
    icon: [
      576,
      512,
      [128301],
      'e03e',
      
      ['M0 350.5l49.9 86.4 55.9-32.3 16.3 28.2 115.7-62.1c1.9-4.7 3.9-9.5 5.8-14.2c-.8-.9-1.5-1.8-2.2-2.7c-.7-.9-1.5-1.9-2.1-2.8c-1.4-1.9-2.7-3.8-3.9-5.8c-2.4-4-4.5-8.3-6.2-12.7s-3-9-3.9-13.8c-.4-2.4-.8-4.8-1-7.3c-.1-1.2-.2-2.5-.3-3.7c-.1-1.2-.1-2.4-.1-3.7c0-1.4 0-2.8 .1-4.2c.1-1.3 .2-2.7 .3-4c.3-2.7 .7-5.3 1.2-7.9c1.1-5.2 2.6-10.2 4.7-15c4-9.6 9.9-18.2 17.1-25.4C261.9 233 281.9 224 304 224c1.3 0 2.5 0 3.8 .1s2.5 .1 3.7 .3c2.5 .2 4.9 .6 7.3 1c4.8 .9 9.4 2.2 13.9 3.9c8.9 3.4 17 8.4 24.1 14.5c14.1 12.3 23.8 29.5 26.5 49l77.5-41.6c-33.5-58-67-116-100.5-174.1L36.7 284.9l19.2 33.3L0 350.5z','M476 277.7l97-56L445 0 348 56 476 277.7zM364.3 356.5C376.6 342.5 384 324.1 384 304c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 20.1 7.4 38.5 19.7 52.5L180.3 512l51.8 0 53.1-130.2c6 1.5 12.3 2.2 18.8 2.2s12.8-.8 18.8-2.2L375.9 512l51.8 0L364.3 356.5zM272 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z']
      
    ]
  };

  

  
  

  var faObjectExclude = {
    prefix: 'fasds',
    iconName: 'object-exclude',
    icon: [
      512,
      512,
      [],
      'e49c',
      
      ['M352 160l-192 0 0 192 192 0 0-192zm-48 48l0 96-96 0 0-96 96 0z','M352 0L0 0 0 352l160 0 0 160 352 0 0-352-160 0L352 0zm0 160l0 192-192 0 0-192 192 0z']
      
    ]
  };

  

  
  

  var faPoop = {
    prefix: 'fasds',
    iconName: 'poop',
    icon: [
      512,
      512,
      [],
      'f619',
      
      ['M0 440l0 40 512 0 0-40c0-35.7-25.9-65.3-60-71c.4-.3 .8-.7 1.3-1L58.7 368c.4 .3 .8 .7 1.3 1c-34.1 5.7-60 35.3-60 71zM32 312c0 8.4 1.4 16.5 4.1 24l439.8 0c2.7-7.5 4.1-15.6 4.1-24c0-39.8-32.2-72-72-72l-13.7 0-276.7 0L104 240c-39.8 0-72 32.2-72 72zM96 192c0 5.5 .7 10.9 2 16l316 0c1.3-5.1 2-10.5 2-16c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96c-5.1 0-10.2 .4-15.1 1.2C250.4 14.3 256 30.5 256 48c0 44.2-35.8 80-80 80l-10.5 0-5.5 0c-35.3 0-64 28.7-64 64z','M58.7 368l394.5 0c10.2-8.3 18.2-19.3 22.6-32L36.1 336c4.5 12.7 12.4 23.7 22.6 32zM0 480l0 32 512 0 0-32L0 480zM414 208L98 208c3.2 12.6 10.2 23.7 19.7 32l276.7 0c9.4-8.3 16.4-19.4 19.7-32z']
      
    ]
  };

  

  
  

  var faHandPointRibbon = {
    prefix: 'fasds',
    iconName: 'hand-point-ribbon',
    icon: [
      448,
      512,
      [],
      'e1a6',
      
      ['M32 272l0 91c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l-96 0 0-32-64 0 0 48 0 16-16 0-112 0-16 0 0-32 16 0 96 0 0-32 0-48L32 272zM64 0l0 32 64 0 0-32L64 0zm0 160l0 80 64 0 0-80-64 0zm96-32l0 32 0 80 64 0 0-112-64 0zm96 32l0 128 64 0 0-128-64 0zm96 32l0 128 64 0 0-128-64 0z','M160 128V32H0L43.6 80 0 128H160z']
      
    ]
  };

  

  
  

  var faAlien8bit = {
    prefix: 'fasds',
    iconName: 'alien-8bit',
    icon: [
      576,
      512,
      [128126,"alien-monster"],
      'f8f6',
      
      ['M0 128L0 288l64 0 0 96 64 0 0 96 64 0 64 0 0-64-64 0 0-32 192 0 0 32-64 0 0 64 64 0 64 0 0-96 64 0 0-96 64 0 0-160-64 0 0 96-32 0 0-64-64 0 0-32 0-32 64 0 0-64-64 0 0 32-64 0 0 64-128 0 0-64-64 0 0-32L96 32l0 64 64 0 0 32 0 32-64 0 0 64-32 0 0-96L0 128zm160 96l64 0 0 96-64 0 0-96zm192 0l64 0 0 96-64 0 0-96z','M224 224l-64 0 0 96 64 0 0-96zm192 0l-64 0 0 96 64 0 0-96z']
      
    ]
  };

  
    var faAlienMonster = faAlien8bit;
  

  
  

  var faCircleArrowDownRight = {
    prefix: 'fasds',
    iconName: 'circle-arrow-down-right',
    icon: [
      512,
      512,
      [],
      'e0fa',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm134.1-88L168 134.1l17 17 135 135L320 184l0-24 48 0 0 24 0 160 0 24-24 0-152 0-24 0 0-48 24 0 94.1 0L151 185l-17-17z','M368 368l-24 0-152 0-24 0 0-48 24 0 94.1 0L151 185l-17-17L168 134.1l17 17 135 135L320 184l0-24 48 0 0 24 0 160 0 24z']
      
    ]
  };

  

  
  

  var faFaceDisguise = {
    prefix: 'fasds',
    iconName: 'face-disguise',
    icon: [
      512,
      512,
      [],
      'e370',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-16.4-1.5-32.5-4.5-48L440 208c0 49.4-37.4 90.1-85.4 95.4l4.5 2.3 8.8 4.4 0 9.9 0 32 0 9.9-8.8 4.4-14.3 7.1L364.5 398l10 12.5-25 20-10-12.5-23.9-29.9-7.3 3.6 10.5 26.3 5.9 14.9-29.7 11.9-5.9-14.9-9.5-23.9-7.6 3.8 0 22.1 0 16-32 0 0-16 0-22.1-7.6-3.8-9.5 23.9-5.9 14.9-29.7-11.9 5.9-14.9 10.5-26.3-7.3-3.6L172.5 418l-10 12.5-25-20 10-12.5 19.6-24.5-14.3-7.1-8.8-4.4 0-9.9 0-32 0-9.9 8.8-4.4 4.5-2.3c-48-5.3-85.4-46-85.4-95.4L4.5 208C1.5 223.5 0 239.6 0 256zm12.7-80l64.7 0c5.3-14.9 14.1-28 25.4-38.5l-5.2-10.3-7.2-14.3 28.6-14.3 7.2 14.3 3.5 7c4.6-2 9.3-3.6 14.2-4.9l0-19 0-16 32 0 0 16 0 16.3c4.4 .4 8.7 1 13 2l4.7-9.5 7.2-14.3 28.6 14.3-7.2 14.3-3.6 7.3c16.4 10.2 29.5 25.3 37.3 43.1c7.8-17.9 20.9-32.9 37.3-43.1l-3.6-7.3-7.2-14.3 28.6-14.3 7.2 14.3 4.7 9.5c4.2-.9 8.6-1.6 13-2L336 96l0-16 32 0 0 16 0 19c4.9 1.3 9.6 2.9 14.2 4.9l3.5-7 7.2-14.3 28.6 14.3-7.2 14.3-5.2 10.3c11.3 10.5 20.1 23.7 25.4 38.5l64.7 0C465.7 73.8 369.4 0 256 0S46.3 73.8 12.7 176z','M176 96l0-16-32 0 0 16 0 19c-4.9 1.3-9.6 2.9-14.2 4.9l-3.5-7-7.2-14.3L90.5 112.8l7.2 14.3 5.2 10.3C91.5 148 82.7 161.1 77.5 176L0 176l0 32 72 0c0 49.4 37.4 90.1 85.4 95.4l-4.5 2.3-8.8 4.4 0 9.9 0 32 0 9.9 8.8 4.4 14.3 7.1L147.5 398l-10 12.5 25 20 10-12.5 23.9-29.9 7.3 3.6-10.5 26.3-5.9 14.9 29.7 11.9 5.9-14.9 9.5-23.9 7.6 3.8 0 22.1 0 16 32 0 0-16 0-22.1 7.6-3.8 9.5 23.9 5.9 14.9 29.7-11.9-5.9-14.9-10.5-26.3 7.3-3.6L339.5 418l10 12.5 25-20-10-12.5-19.6-24.5 14.3-7.1 8.8-4.4 0-9.9 0-32 0-9.9-8.8-4.4-4.5-2.3c48-5.3 85.4-46 85.4-95.4l72 0 0-32-77.5 0c-5.3-14.9-14.1-28-25.4-38.5l5.2-10.3 7.2-14.3L392.8 98.5l-7.2 14.3-3.5 7c-4.6-2-9.3-3.6-14.2-4.9l0-19 0-16-32 0 0 16 0 16.3c-4.4 .4-8.7 1-13 2l-4.7-9.5-7.2-14.3-28.6 14.3 7.2 14.3 3.6 7.3c-16.4 10.2-29.5 25.3-37.3 43.1c-7.8-17.9-20.9-32.9-37.3-43.1l3.6-7.3 7.2-14.3L200.8 90.5l-7.2 14.3-4.7 9.5c-4.2-.9-8.6-1.6-13-2L176 96zM310.9 263.1l-29.6-42.3c-.8-4.1-1.3-8.4-1.3-12.8c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5c-1.4-.6-3.9-2-6.8-3.8l-.2 .4zm-80.2-42.3l-29.6 42.3-.2-.4c-2.9 1.8-5.4 3.2-6.8 3.8c-7.9 3.5-16.8 5.5-26.1 5.5c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64c0 4.4-.4 8.7-1.3 12.8zM168 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM205.1 313.2L256 240.5l50.9 72.7 2.3 3.3 3.6 1.8L336 329.9l0 12.2-80 40-80-40 0-12.2 23.2-11.6 3.6-1.8 2.3-3.3z']
      
    ]
  };

  

  
  

  var faObjectUngroup = {
    prefix: 'fasds',
    iconName: 'object-ungroup',
    icon: [
      640,
      512,
      [],
      'f248',
      
      ['M192 384l0 128 128 0 0-32 192 0 0 32 128 0 0-128-32 0 0-96 32 0 0-128-128 0 0 32-96 0 0 32 32 0 0 32 64 0 32 0 0 32 0 96 0 32-32 0-192 0-32 0 0-32 0-64-64 0 0 64-32 0z','M0 0L128 0l0 32 192 0 0-32L448 0l0 128-32 0 0 96 32 0 0 128-128 0 0-32-192 0 0 32L0 352 0 224l32 0 0-96L0 128 0 0zM352 128l0-32-32 0L128 96 96 96l0 32 0 96 0 32 32 0 192 0 32 0 0-32 0-96z']
      
    ]
  };

  

  
  

  var faFaceGrinBeam = {
    prefix: 'fasds',
    iconName: 'face-grin-beam',
    icon: [
      512,
      512,
      [128516,"grin-beam"],
      'f582',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 46.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zM120 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M120 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z']
      
    ]
  };

  
    var faGrinBeam = faFaceGrinBeam;
  

  
  

  var faBuildingFlag = {
    prefix: 'fasds',
    iconName: 'building-flag',
    icon: [
      640,
      512,
      [],
      'e4d5',
      
      ['M0 0L384 0l0 512-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M480 32l0-32L416 0l0 32 0 480 64 0 0-320 160 0 0-160L480 32z']
      
    ]
  };

  

  
  

  var faCircleQ = {
    prefix: 'fasds',
    iconName: 'circle-q',
    icon: [
      512,
      512,
      [],
      'e11e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-70.7 57.3-128 128-128s128 57.3 128 128c0 28.1-9 54-24.4 75.1L401.9 384l-61.5 0-15.9-19.9C304.7 376.7 281.2 384 256 384c-70.7 0-128-57.3-128-128zm48 0c0 44.2 35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L238.1 256l61.5 0 28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3c0-44.2-35.8-80-80-80s-80 35.8-80 80z','M176 256c0 44.2 35.8 80 80 80c13.9 0 26.9-3.5 38.3-9.7L238.1 256l61.5 0 28.3 35.3c5.3-10.7 8.2-22.6 8.2-35.3c0-44.2-35.8-80-80-80s-80 35.8-80 80zM324.6 364.1C304.7 376.7 281.2 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 28.1-9 54-24.4 75.1L401.9 384l-61.5 0-15.9-19.9z']
      
    ]
  };

  

  
  

  var faFishFins = {
    prefix: 'fasds',
    iconName: 'fish-fins',
    icon: [
      576,
      512,
      [],
      'e4f2',
      
      ['M0 160l48 96L0 352l32 32 114.9-57.5c22.6 24.4 52.8 50 90.6 67.6C266 407.4 298.8 416 336 416c3.1 0 6.3-.1 9.4-.2C499.1 409.8 576 256 576 256s-76.9-153.8-230.6-159.8c-3.1-.1-6.2-.2-9.4-.2c-37.2 0-70 8.6-98.5 21.9c-37.7 17.5-67.9 43.1-90.6 67.6L32 128 0 160zm448 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M237.5 394.1C266 407.4 298.8 416 336 416c3.1 0 6.3-.1 9.4-.2L272 480l-48-32 13.5-53.9zM345.4 96.2c-3.1-.1-6.2-.2-9.4-.2c-37.2 0-70 8.6-98.5 21.9L224 64l48-32 73.4 64.2z']
      
    ]
  };

  

  
  

  var faFileContract = {
    prefix: 'fasds',
    iconName: 'file-contract',
    icon: [
      384,
      512,
      [],
      'f56c',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM64 64l0 32 16 0 64 0 16 0 0-32-16 0L80 64 64 64zm0 64l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm0 256l0 32 16 0 32 0 11.9 0 3.4-11.4L144 349l16.7 55.6c1.1 3.8 2.3 7.6 3.4 11.4l11.9 0 8 0 9.9 0 4.4-8.8L209.9 384l12.2 0 11.6 23.2 4.4 8.8 9.9 0 56 0 16 0 0-32-16 0-46.1 0-11.6-23.2-4.4-8.8-9.9 0-32 0-9.9 0-4.4 8.8-3 5.9-15.4-51.4c-1.1-3.8-2.3-7.6-3.4-11.4L152 304l-16 0-11.9 0-3.4 11.4L100.1 384 80 384l-16 0z','M384 160L224 0l0 160 160 0zM136 304l-11.9 0-3.4 11.4L100.1 384 80 384l-16 0 0 32 16 0 32 0 11.9 0 3.4-11.4L144 349l16.7 55.6 3.4 11.4 11.9 0 8 0 9.9 0 4.4-8.8L209.9 384l12.2 0 11.6 23.2 4.4 8.8 9.9 0 56 0 16 0 0-32-16 0-46.1 0-11.6-23.2-4.4-8.8-9.9 0-32 0-9.9 0-4.4 8.8-3 5.9-15.4-51.4L163.9 304 152 304l-16 0z']
      
    ]
  };

  

  
  

  var faFileExcel = {
    prefix: 'fasds',
    iconName: 'file-excel',
    icon: [
      384,
      512,
      [],
      'f1c3',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM97.7 240l65.9 104L97.7 448l56.8 0L192 388.9 229.5 448l56.8 0L220.4 344l65.9-104-56.8 0L192 299.1 154.5 240l-56.8 0z','M384 160L224 0l0 160 160 0zM97.7 240l65.9 104L97.7 448l56.8 0L192 388.9 229.5 448l56.8 0L220.4 344l65.9-104-56.8 0L192 299.1 154.5 240l-56.8 0z']
      
    ]
  };

  

  
  

  var faFileXls = {
    prefix: 'fasds',
    iconName: 'file-xls',
    icon: [
      512,
      512,
      [],
      'e64d',
      
      ['M0 0L224 0l0 160 160 0 0 144-240 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM224 368l0-16-32 0 0 16c0 13.6 4 26.9 11.6 38.2L220.8 432l-17.2 25.8C196 469.1 192 482.4 192 496l0 16 32 0 0-16c0-7.3 2.2-14.4 6.2-20.4l9.8-14.7 9.8 14.7c4 6.1 6.2 13.2 6.2 20.4l0 16 32 0 0-16c0-13.6-4-26.9-11.6-38.2L259.2 432l17.2-25.8C284 394.9 288 381.6 288 368l0-16-32 0 0 16c0 7.3-2.2 14.4-6.2 20.4L240 403.2l-9.8-14.7c-4-6.1-6.2-13.2-6.2-20.4zm96 144l16 0 40 0 16 0 0-32-16 0-24 0 0-112 0-16-32 0 0 16 0 128 0 16zm88-114.3c0 17.3 9.8 33.1 25.2 40.8l31.2 15.6c4.6 2.3 7.6 7 7.6 12.2c0 7.5-6.1 13.7-13.7 13.7L432 480l-16 0 0 32 16 0 26.3 0c25.2 0 45.7-20.4 45.7-45.7c0-17.3-9.8-33.1-25.2-40.8l-31.2-15.6c-4.6-2.3-7.6-7-7.6-12.2c0-7.5 6.1-13.7 13.7-13.7l26.3 0 16 0 0-32-16 0-26.3 0c-25.2 0-45.7 20.4-45.7 45.7z']
      
    ]
  };

  

  
  

  var faSackXmark = {
    prefix: 'fasds',
    iconName: 'sack-xmark',
    icon: [
      512,
      512,
      [],
      'e56a',
      
      ['M0 416l0 96 512 0 0-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4l-128 0c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416zM128 0c21.3 32 42.7 64 64 96l128 0L384 0 128 0zm30.1 256L192 222.1c5.7 5.7 11.3 11.3 17 17l47 47 47-47c5.7-5.7 11.3-11.3 17-17L353.9 256l-17 17-47 47 47 47 17 17L320 417.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c-15.7 15.7-31.4 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9l17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17z','M192 96l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0zM158.1 384l17-17 47-47-47-47-17-17L192 222.1l17 17 47 47 47-47 17-17L353.9 256l-17 17-47 47 47 47 17 17L320 417.9l-17-17-47-47-47 47-17 17L158.1 384z']
      
    ]
  };

  

  
  

  var faClockEight = {
    prefix: 'fasds',
    iconName: 'clock-eight',
    icon: [
      512,
      512,
      [],
      'e345',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm126.7 57.3c6.7-4.4 13.3-8.9 20-13.3c28.4-19 56.9-37.9 85.3-56.9c0-41.1 0-82.1 0-123.2c0-8 0-16 0-24l48 0c0 8 0 16 0 24c0 45.3 0 90.7 0 136c0 4.3 0 8.6 0 12.8L269.3 276c-32 21.3-64 42.7-96 64c-6.7 4.4-13.3 8.9-20 13.3l-26.6-39.9z','M280 96l0 24 0 136 0 12.8L269.3 276l-96 64-20 13.3-26.6-39.9 20-13.3L232 243.2 232 120l0-24 48 0z']
      
    ]
  };

  

  
  

  var faBoltLightning = {
    prefix: 'fasds',
    iconName: 'bolt-lightning',
    icon: [
      384,
      512,
      [],
      'e0b7',
      
      ['M0 288L32 0H256L208 160H384v48L128 512l48-224H0z','']
      
    ]
  };

  

  
  

  var faChartPie = {
    prefix: 'fasds',
    iconName: 'chart-pie',
    icon: [
      576,
      512,
      ["pie-chart"],
      'f200',
      
      ['M32 272C32 144.8 130.9 40.8 256 32.5L256 288 425 457c-41.5 34.4-94.8 55-153 55C139.5 512 32 404.6 32 272z','M543.4 240L304 240 304 .6c5.3-.4 10.6-.6 16-.6C443.7 0 544 100.3 544 224c0 5.4-.2 10.7-.6 16zM320 288l255.5 0C571 355.9 538.3 416.1 489 457L320 288z']
      
    ]
  };

  
    var faPieChart = faChartPie;
  

  
  

  var faPersonCirclePlus = {
    prefix: 'fasds',
    iconName: 'person-circle-plus',
    icon: [
      576,
      512,
      [],
      'e541',
      
      ['M.2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 2.3-1.4c8.4-21.4 20.8-40.7 36.3-57L238 142.8 228.6 128l-17.5 0-102.2 0-17.5 0L82 142.8 .2 270.8zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faTaxi = {
    prefix: 'fasds',
    iconName: 'taxi',
    icon: [
      512,
      512,
      [128662,"cab"],
      'f1ba',
      
      ['M0 432l96 0 0 80L0 512l0-80zM109.1 224c11.2-32 22.4-64 33.6-96l226.6 0 33.6 96-293.8 0zM160 0L352 0l0 64L160 64l0-64zM416 432l96 0 0 80-96 0 0-80z','M120 64L97.3 64 89.8 85.4 41.3 224 0 224 0 432l512 0 0-208-41.3 0L422.2 85.4 414.7 64 392 64 120 64zM402.9 224l-293.8 0 33.6-96 226.6 0 33.6 96zM64 320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  
    var faCab = faTaxi;
  

  
  

  var faRoad = {
    prefix: 'fasds',
    iconName: 'road',
    icon: [
      576,
      512,
      [128739],
      'f018',
      
      ['M256 32l0 64 0 32 64 0 0-32 0-64-64 0zm0 160l0 32 0 64 0 32 64 0 0-32 0-64 0-32-64 0zm0 192l0 32 0 64 64 0 0-64 0-32-64 0z','M256 32L128 32 0 480l256 0 0-64 0-32 64 0 0 32 0 64 256 0L448 32 320 32l0 64 0 32-64 0 0-32 0-64zm64 192l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32z']
      
    ]
  };

  

  
  

  var faBedBunk = {
    prefix: 'fasds',
    iconName: 'bed-bunk',
    icon: [
      576,
      512,
      [],
      'f8f8',
      
      ['M96 48a48 48 0 1 0 96 0A48 48 0 1 0 96 48zm0 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM224 0l0 128 32 0 256 0 32 0 32 0C576 57.3 518.7 0 448 0L224 0zm0 256l0 128 32 0 256 0 0-128-288 0z','M64 32L64 0 0 0 0 32 0 480l0 32 64 0 0-32 0-32 192 0 256 0 0 32 0 32 64 0 0-32 0-320 0-32-32 0-32 0-256 0L64 128l0-96zM512 384l-256 0L64 384l0-192 192 0 256 0 0 192z']
      
    ]
  };

  

  
  

  var faLeaf = {
    prefix: 'fasds',
    iconName: 'leaf',
    icon: [
      512,
      512,
      [],
      'f06c',
      
      ['M96.4 260.1C130.6 237.3 171.8 224 216 224c24 0 48 0 72 0c8 0 16 0 24 0c0 16 0 32 0 48c-8 0-16 0-24 0c-24 0-48 0-72 0c-.1 0-.2 0-.3 0c-1.2 0-2.5 0-3.7 0c-1.5 0-2.8 .1-4.2 .1c-2.8 .1-5.5 .3-8.2 .6c-5.4 .5-10.7 1.3-15.9 2.3c-10.4 2-20.5 5-30.2 8.9c-19.3 7.7-36.8 18.9-51.8 32.8C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-50.4-10.5-97.8-29.1-139.1C468.7 63 426.2 96 376 96L272 96c-93.2 0-169.5 72.5-175.6 164.1z','M216 272c-92.8 0-168 75.2-168 168l0 16 0 24L0 480l0-24 0-16C0 320.7 96.7 224 216 224l72 0 24 0 0 48-24 0-72 0z']
      
    ]
  };

  

  
  

  var faF = {
    prefix: 'fasds',
    iconName: 'f',
    icon: [
      320,
      512,
      [102],
      '46',
      
      ['M32 32L0 32 0 64 0 224l0 32 0 32L0 448l0 32 64 0 0-32 0-160 160 0 32 0 0-64-32 0L64 224 64 96l224 0 32 0 0-64-32 0L32 32z','']
      
    ]
  };

  

  
  

  var faCloudPlus = {
    prefix: 'fasds',
    iconName: 'cloud-plus',
    icon: [
      640,
      512,
      [],
      'e35e',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zm208-72l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M296 376l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  

  
  

  var faAustralSign = {
    prefix: 'fasds',
    iconName: 'austral-sign',
    icon: [
      448,
      512,
      [],
      'e0a9',
      
      ['M0 224l32 0 85.5 0c-8.5 21.3-17.1 42.7-25.6 64L32 288 0 288l0-64zm0 96l32 0 47.1 0L53.5 384 32 384 0 384l0-64zm122.5 64l25.6-64 151.9 0c8.5 21.3 17.1 42.7 25.6 64l-203.1 0zm38.4-96l25.6-64 75.1 0c8.5 21.3 17.1 42.7 25.6 64l-126.3 0zm169.6-64l85.5 0 32 0 0 64-32 0-59.9 0c-8.5-21.3-17.1-42.7-25.6-64zm38.4 96l47.1 0 32 0 0 64-32 0-21.5 0c-8.5-21.3-17.1-42.7-25.6-64z','M216 32l-21.7 0-8 20.1-160 400L15.1 480l68.9 0 1.6-4.1L224 130.2 362.3 475.9l1.6 4.1 68.9 0-11.2-27.9-160-400-8-20.1L232 32l-16 0z']
      
    ]
  };

  

  
  

  var faChessKnightPiece = {
    prefix: 'fasds',
    iconName: 'chess-knight-piece',
    icon: [
      320,
      512,
      ["chess-knight-alt"],
      'f442',
      
      ['M0 477.4L0 512l320 0 0-34.6L272 416 48 416 0 477.4z','M32 128l25.6-25.6L32 89.6 32 64l98.6 0C226.4 64 304 141.6 304 237.4c0 11.3-1.1 22.6-3.3 33.7L272 416 48 416l0-78.4 112-83.2 0-32L70.4 280 32 248l0-120zm60.8 44.8a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  
    var faChessKnightAlt = faChessKnightPiece;
  

  
  

  var faPie = {
    prefix: 'fasds',
    iconName: 'pie',
    icon: [
      576,
      512,
      [129383],
      'f705',
      
      ['M47.1 301.2c19.4-9.2 38.7-18.4 58.1-27.6c2-1 4-1.9 6-2.9c2.1 .8 4.2 1.5 6.3 2.3c27.5 10 55 20 82.5 30c27.5-10 55-20 82.5-30c1.8-.7 3.6-1.3 5.5-2c1.8 .7 3.6 1.3 5.5 2c27.5 10 55 20 82.5 30c27.5-10 55-20 82.5-30c2.1-.8 4.2-1.5 6.3-2.3c2 1 4 1.9 6.1 2.9c19.3 9.2 38.7 18.4 58.1 27.6L480 448 96 448 47.1 301.2z','M288 64C174.6 64 78.3 137.8 44.7 240L32 240 0 240l0 64 32 0 .5 0 8.7 0 63.9-30.4 6-2.9 6.3 2.3L200 303l82.5-30 5.5-2 5.5 2L376 303l82.5-30 6.3-2.3 6.1 2.9L534.8 304l8.7 0 .5 0 32 0 0-64-32 0-12.7 0C497.7 137.8 401.4 64 288 64zm-81.7 87.2l-16 32-7.2 14.3-28.6-14.3 7.2-14.3 16-32 7.2-14.3 28.6 14.3-7.2 14.3zm192-14.3l16 32 7.2 14.3-28.6 14.3-7.2-14.3-16-32-7.2-14.3 28.6-14.3 7.2 14.3zM304 144l0 32 0 16-32 0 0-16 0-32 0-16 32 0 0 16z']
      
    ]
  };

  

  
  

  var faSquareEllipsis = {
    prefix: 'fasds',
    iconName: 'square-ellipsis',
    icon: [
      448,
      512,
      [],
      'e26e',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 224l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M352 288l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zM96 288l0-64 64 0 0 64-64 0z']
      
    ]
  };

  

  
  

  var faVirusCovid = {
    prefix: 'fasds',
    iconName: 'virus-covid',
    icon: [
      512,
      512,
      [],
      'e4a8',
      
      ['M0 192l0 24 0 80 0 24 48 0 0-24 0-16 25.6 0c4.3 32.9 17.2 63 36.5 88L92 386.1 80.6 374.8l-17-17L29.7 391.8l17 17 56.6 56.6 17 17 33.9-33.9-17-17L125.9 420 144 402c25 19.2 55.2 32.2 88 36.5l0 25.6-16 0-24 0 0 48 24 0 80 0 24 0 0-48-24 0-16 0 0-25.6c32.9-4.3 63-17.2 88-36.5L386.1 420l-11.3 11.3-17 17 33.9 33.9 17-17 56.6-56.6 17-17-33.9-33.9-17 17L420 386.1 402 368c19.2-25 32.2-55.2 36.5-88l25.6 0 0 16 0 24 48 0 0-24 0-80 0-24-48 0 0 24 0 16-25.6 0c-4.3-32.9-17.2-63-36.5-88L420 125.9l11.3 11.3 17 17 33.9-33.9-17-17L408.7 46.7l-17-17L357.8 63.7l17 17L386.1 92 368 110c-25-19.2-55.2-32.2-88-36.5L280 48l16 0 24 0 0-48L296 0 216 0 192 0l0 48 24 0 16 0 0 25.6c-32.9 4.3-63 17.2-88 36.5L125.9 92l11.3-11.3 17-17L120.2 29.7l-17 17L46.7 103.3l-17 17 33.9 33.9 17-17L92 125.9 110 144c-19.2 25-32.2 55.2-36.5 88L48 232l0-16 0-24L0 192zm240 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm88 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M192 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96z']
      
    ]
  };

  

  
  

  var faImagePolaroidUser = {
    prefix: 'fasds',
    iconName: 'image-polaroid-user',
    icon: [
      448,
      512,
      [],
      'e1b6',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 96l320 0 0 256-56 0-208 0-56 0L64 96z','M384 96L64 96l0 256 56 0 24-64 160 0 24 64 56 0 0-256zM160 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z']
      
    ]
  };

  

  
  

  var faWonSign = {
    prefix: 'fasds',
    iconName: 'won-sign',
    icon: [
      512,
      512,
      [8361,"krw","won"],
      'f159',
      
      ['M0 224l0 64 32 0 42.3 0L56.6 224 32 224 0 224zm123 0c5.9 21.3 11.9 42.7 17.8 64l24.7 0 15.3-64L123 224zm108.2 64l49.5 0c-5.1-21.3-10.2-42.7-15.3-64l-18.9 0-15.3 64zm100-64c5.1 21.3 10.2 42.7 15.3 64l24.7 0c5.9-21.3 11.9-42.7 17.8-64l-57.8 0zm106.4 64l42.3 0 32 0 0-64-32 0-24.6 0-17.8 64z','M3.2 32L121.2 456.6l6.5 23.4 24.3 0 8 0 25.2 0 5.9-24.5L256 184.7l64.9 270.8 5.9 24.5 25.2 0 8 0 24.3 0 6.5-23.4L508.8 32l-66.4 0L358 335.7 291.1 56.5 285.2 32 260 32l-8 0-25.2 0-5.9 24.5L154 335.7 69.7 32 3.2 32z']
      
    ]
  };

  
    var faKrw = faWonSign;
  
    var faWon = faWonSign;
  

  
  

  var faImagesUser = {
    prefix: 'fasds',
    iconName: 'images-user',
    icon: [
      576,
      512,
      [],
      'e1b9',
      
      ['M96 32l0 352 480 0 0-352L96 32zM232 320l24-64 160 0 24 64-208 0zM400 160a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M48 120l0-24L0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312zm352 40a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm16 96l-160 0-24 64 208 0-24-64z']
      
    ]
  };

  

  
  

  var faCubesStacked = {
    prefix: 'fasds',
    iconName: 'cubes-stacked',
    icon: [
      448,
      512,
      [],
      'e4e6',
      
      ['M0 352l128 0 0 128L0 480 0 352zM55 223l110.9-64 64 110.9L119 333.8 55 223zM320 352l128 0 0 128-128 0 0-128z','M320 32L192 32l0 128 128 0 0-128zM256 320l128 0 0-128-128 0 0 128zm-96 32l0 128 128 0 0-128-128 0z']
      
    ]
  };

  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fasds',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      ['M0 32l32 0 128 0 32 0 0 64-32 0L64 96l0 352 352 0 0-96 0-32 64 0 0 32 0 128 0 32-32 0L32 512 0 512l0-32L0 64 0 32z','M288 0l32 0L480 0l32 0 0 32 0 160 0 32-64 0 0-32 0-82.7L246.6 310.6 224 333.3 178.7 288l22.6-22.6L402.7 64 320 64l-32 0 0-64z']
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faMagnifyingGlassChart = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-chart',
    icon: [
      512,
      512,
      [],
      'e522',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm104-16l48 0 0 24 0 64 0 24-48 0 0-24 0-64 0-24zm80-96l48 0 0 24 0 160 0 24-48 0 0-24 0-160 0-24zm80 64l48 0 0 24 0 96 0 24-48 0 0-24 0-96 0-24z','M104 216l0-24 48 0 0 24 0 64 0 24-48 0 0-24 0-64zm80-96l0-24 48 0 0 24 0 160 0 24-48 0 0-24 0-160zm80 64l0-24 48 0 0 24 0 96 0 24-48 0 0-24 0-96zM441.4 486.6L330.7 376C348 363.3 363.3 348 376 330.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6z']
      
    ]
  };

  

  
  

  var faMobileNotch = {
    prefix: 'fasds',
    iconName: 'mobile-notch',
    icon: [
      384,
      512,
      ["mobile-iphone"],
      'e1ee',
      
      ['M16 0L80 0 304 0l64 0 0 64 0 384 0 64-64 0L80 512l-64 0 0-64L16 64 16 0zM80 64l0 384 224 0 0-384-48 0 0 32L128 96l0-32L80 64z','M80 64V448H304V64H256V96H128V64H80z']
      
    ]
  };

  
    var faMobileIphone = faMobileNotch;
  

  
  

  var faClothesHanger = {
    prefix: 'fasds',
    iconName: 'clothes-hanger',
    icon: [
      640,
      512,
      [],
      'e136',
      
      ['M209.8 84.8C222.3 35 267.1 0 318.5 0L320 0c61.9 0 112 50.1 112 112l0 6.3c0 36.5-17.8 70.8-47.8 91.8l-8.3 5.8L626.3 389.7l13.7 9.5 0 16.7 0 64 0 32-32 0L32 512 0 512l0-32 0-64 0-16.7 13.7-9.5L301.6 189.8l.1-.1 45.8-32c12.8-9 20.5-23.7 20.5-39.3l0-6.3c0-26.5-21.5-48-48-48l-1.5 0c-22 0-41.2 15-46.6 36.4l-.9 3.4-7.8 31-62.1-15.5 7.8-31 .9-3.4zM320 255L64 432.7 64 448l512 0 0-15.3L320 255z','']
      
    ]
  };

  

  
  

  var faBuildingCircleExclamation = {
    prefix: 'fasds',
    iconName: 'building-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4d3',
      
      ['M0 0L384 0l0 232.2c-39.1 32.3-64 81.1-64 135.8s24.9 103.5 64 135.8l0 8.2-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faMoonStars = {
    prefix: 'fasds',
    iconName: 'moon-stars',
    icon: [
      512,
      512,
      [],
      'f755',
      
      ['M240 80l48 16 16 48 16-48 48-16L320 64 304 16 288 64 240 80zm80 144l72 24 24 72 24-72 72-24-72-24-24-72-24 72-72 24z','M242.2 134.6C176.2 154.3 128 215.5 128 288c0 88.4 71.6 160 160 160c19.5 0 38.1-3.5 55.3-9.8C308.2 483.1 253.5 512 192 512C86 512 0 426 0 320S86 128 192 128c17.4 0 34.2 2.3 50.2 6.6z']
      
    ]
  };

  

  
  

  var faWhiskeyGlass = {
    prefix: 'fasds',
    iconName: 'whiskey-glass',
    icon: [
      512,
      512,
      [129347,"glass-whiskey"],
      'f7a0',
      
      ['M0 32L9.1 96 64 480l384 0L502.9 96 512 32l-64.6 0L64.6 32 0 32zM73.8 96l364.4 0c-6.1 42.7-12.2 85.3-18.3 128L392.5 416l-273 0c-9.1-64-18.3-128-27.4-192C86 181.3 79.9 138.7 73.8 96z','M92.1 224l27.4 192 273 0 27.4-192L92.1 224z']
      
    ]
  };

  
    var faGlassWhiskey = faWhiskeyGlass;
  

  
  

  var faCode = {
    prefix: 'fasds',
    iconName: 'code',
    icon: [
      640,
      512,
      [],
      'f121',
      
      ['M216 485.2L277.2 504l9.4-30.6 128-416L424 26.8 362.8 8l-9.4 30.6-128 416L216 485.2z','M434.7 144l22.6 22.6L546.7 256l-89.4 89.4L434.7 368 480 413.3l22.6-22.6 112-112L637.3 256l-22.6-22.6-112-112L480 98.7 434.7 144zM160 98.7l-22.6 22.6-112 112L2.7 256l22.6 22.6 112 112L160 413.3 205.3 368l-22.6-22.6L93.3 256l89.4-89.4L205.3 144 160 98.7z']
      
    ]
  };

  

  
  

  var faFileExclamation = {
    prefix: 'fasds',
    iconName: 'file-exclamation',
    icon: [
      384,
      512,
      [],
      'f31a',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM168 192l0 24 0 112 0 24 48 0 0-24 0-112 0-24-48 0zm0 192l0 48 48 0 0-48-48 0z','M384 160L224 0l0 160 160 0zM216 192l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM168 384l0 48 48 0 0-48-48 0z']
      
    ]
  };

  

  
  

  var faStarHalfStroke = {
    prefix: 'fasds',
    iconName: 'star-half-stroke',
    icon: [
      576,
      512,
      ["star-half-alt"],
      'f5c0',
      
      ['M288 .1c0 40.1 0 80.1 0 120.1c12.4 23.3 24.7 46.6 37 70l12.9 24.4 27.1 4.7 78.1 13.5-55.2 56.8-19.2 19.7 3.9 27.3 11.3 78.4-71.1-35-24.7-12.1c-.1 20.8-.1 41.6-.1 62.3c35.2 17.4 70.4 34.7 105.5 51.9L454.4 512l-9.7-67.2L428 328.5l81.9-84.3 47.3-48.7L490.4 184 374.6 164 319.7 60C309.2 40 298.6 20 288 .1z','M121.7 512L288 430.2 288 .1 201.5 164 18.9 195.6 148.1 328.5 121.7 512z']
      
    ]
  };

  
    var faStarHalfAlt = faStarHalfStroke;
  

  
  

  var faMoneyCheck = {
    prefix: 'fasds',
    iconName: 'money-check',
    icon: [
      576,
      512,
      [],
      'f53c',
      
      ['M0 64L0 448l576 0 0-384L0 64zM96 224l224 0 0 32L96 256l0-32zm0 96l384 0 0 32L96 352l0-32zM384 160l96 0 0 96-96 0 0-96z','M480 160l-96 0 0 96 96 0 0-96zM320 224L96 224l0 32 224 0 0-32z']
      
    ]
  };

  

  
  

  var faPuzzlePiece = {
    prefix: 'fasds',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      ['M192 89.6c-19.1-8.3-32-23.8-32-41.6c0-26.5 28.7-48 64-48s64 21.5 64 48c0 17.8-12.9 33.3-32 41.6l0 38.4 128 0 0 128 38.4 0c8.3-19.1 23.8-32 41.6-32c26.5 0 48 28.7 48 64s-21.5 64-48 64c-17.8 0-33.3-12.9-41.6-32L384 320l0 192-128 0 0-38.4c19.1-8.3 32-23.8 32-41.6c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 17.8 12.9 33.3 32 41.6l0 38.4L0 512 0 320l38.4 0c8.3 19.1 23.8 32 41.6 32c26.5 0 48-28.7 48-64s-21.5-64-48-64c-17.8 0-33.3 12.9-41.6 32L0 256 0 128l192 0 0-38.4z','']
      
    ]
  };

  

  
  

  var faTrainTrack = {
    prefix: 'fasds',
    iconName: 'train-track',
    icon: [
      576,
      512,
      [],
      'e453',
      
      ['M0 352l32 0 30.3 0L40.9 416 32 416 0 416l0-64zM40 224l32 0 32.9 0L83.6 288 72 288l-32 0 0-64zM80 96l32 0 35.6 0c-7.1 21.3-14.2 42.7-21.3 64L112 160l-32 0 0-64zm28.4 320c7.1-21.3 14.2-42.7 21.3-64l316.5 0c7.1 21.3 14.2 42.7 21.3 64l-359.2 0zm42.7-128c7.1-21.3 14.2-42.7 21.3-64l231.2 0c7.1 21.3 14.2 42.7 21.3 64l-273.9 0zm42.7-128c7.1-21.3 14.2-42.7 21.3-64l145.9 0c7.1 21.3 14.2 42.7 21.3 64l-188.5 0zM428.4 96L464 96l32 0 0 64-32 0-14.3 0c-7.1-21.3-14.2-42.7-21.3-64zm42.7 128l32.9 0 32 0 0 64-32 0-11.6 0c-7.1-21.3-14.2-42.7-21.3-64zm42.7 128l30.3 0 32 0 0 64-32 0-8.9 0c-7.1-21.3-14.2-42.7-21.3-64z','M339.6 32l67.5 0L556.4 480l-67.5 0L339.6 32zM168.9 32l67.5 0L87.1 480l-67.5 0L168.9 32z']
      
    ]
  };

  

  
  

  var faArrowUpSmallBig = {
    prefix: 'fasds',
    iconName: 'arrow-up-small-big',
    icon: [
      576,
      512,
      ["sort-size-up-alt"],
      'f88f',
      
      ['M320 32l0 160 160 0 0-160L320 32zm0 224l0 224 224 0 0-224-224 0z','M160 32.4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L192 162.8 192 448l0 32-64 0 0-32 0-285.2-24.3 26.8L82.2 213.2 34.8 170.2l21.5-23.7 80-88 23.7-26z']
      
    ]
  };

  
    var faSortSizeUpAlt = faArrowUpSmallBig;
  

  
  

  var faHandHoldingHeart = {
    prefix: 'fasds',
    iconName: 'hand-holding-heart',
    icon: [
      576,
      512,
      [],
      'f4be',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M192 160l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56l0-3.6C144 33.9 177.9 0 219.6 0c23 0 44.7 10.4 59.1 28.4L288 40l9.3-11.6C311.6 10.4 333.4 0 356.4 0C398.1 0 432 33.9 432 75.6l0 3.6c0 21-8.3 41.1-23.2 56L384 160l-96 96-96-96z']
      
    ]
  };

  

  
  

  var faHouseChimneyUser = {
    prefix: 'fasds',
    iconName: 'house-chimney-user',
    icon: [
      576,
      512,
      [],
      'e065',
      
      ['M64 272l.1 240 448.5 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272zM176 448l32-96 160 0 32 96-224 0zM352 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M288 0L0 240l0 32 64 0L288 88 512 272l64 0 0-32-64-53.3L512 32l-96 0 0 74.7L288 0zm64 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm48 192l-32-96-160 0-32 96 224 0z']
      
    ]
  };

  

  
  

  var faDryerHeat = {
    prefix: 'fasds',
    iconName: 'dryer-heat',
    icon: [
      448,
      512,
      ["dryer-alt"],
      'f862',
      
      ['M148.7 227.3L177.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l28.7 28.7 22.6-22.6L190.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-28.7-28.7-22.6 22.6zM160 88a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm68.7 139.3L257.4 256c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16l-9.4 9.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6l28.7 28.7 22.6-22.6L270.6 352c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l9.4-9.4c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6l-28.7-28.7-22.6 22.6z','M448 0L0 0 0 512l448 0L448 0zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  
    var faDryerAlt = faDryerHeat;
  

  
  

  var faUpDownLeftRight = {
    prefix: 'fasds',
    iconName: 'up-down-left-right',
    icon: [
      512,
      512,
      ["arrows-alt"],
      'f0b2',
      
      ['M160 96l0 32 64 0 0 96 64 0 0-96 64 0 0-32L256 0 160 96zm0 288l0 32 96 96 96-96 0-32-64 0 0-96-64 0 0 96-64 0z','M96 352L0 256l96-96 32 0 0 64 256 0 0-64 32 0 96 96-96 96-32 0 0-64-256 0 0 64-32 0z']
      
    ]
  };

  
    var faArrowsAlt = faUpDownLeftRight;
  

  
  

  var faToggleLargeOn = {
    prefix: 'fasds',
    iconName: 'toggle-large-on',
    icon: [
      576,
      512,
      [],
      'e5b1',
      
      ['M0 64L0 448l576 0 0-384L0 64zm256 64l256 0 0 256-256 0 0-256z','M256 128h256v256H256V128z']
      
    ]
  };

  

  
  

  var faFileSignature = {
    prefix: 'fasds',
    iconName: 'file-signature',
    icon: [
      576,
      512,
      [],
      'f573',
      
      ['M0 0L224 0l0 160 160 0 0 88.9c-28 28-56.1 56.1-84.1 84.1l-7.3 51-4.6 0-8 0-22.1 0-11.6-23.2-4.4-8.8-9.9 0-32 0-9.9 0-4.4 8.8-3 5.9-15.4-51.4L163.9 304 152 304l-16 0-11.9 0-3.4 11.4L100.1 384 80 384l-16 0 0 32 16 0 32 0 11.9 0 3.4-11.4L144 349l16.7 55.6 3.4 11.4 11.9 0 8 0 9.9 0 4.4-8.8L209.9 384l12.2 0 11.6 23.2 4.4 8.8 9.9 0 32 0c2.6 0 5.3 0 8.1-.1c27.6-4 55.2-7.9 82.8-11.9L384 390.8 384 512 0 512 0 0z','M384 160l-160 0L224 0 384 160zm121-32.2l71 71-41.3 41.3-71-71L505 127.8zm-63.9 63.9l71 71L370.9 404 288 415.9 299.9 333 441.1 191.8z']
      
    ]
  };

  

  
  

  var faQuestion = {
    prefix: 'fasds',
    iconName: 'question',
    icon: [
      320,
      512,
      [10067,10068,61736],
      '3f',
      
      ['M120 440a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M144 96c-35.3 0-64 28.7-64 64l0 16-64 0 0-16C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 9.3c0 39.3-18 76.4-48.9 100.6L192 319.6l0 32.4-64 0 0-48 0-15.6 12.2-9.6 75.3-59.2C231 207.5 240 189 240 169.3l0-9.3c0-35.3-28.7-64-64-64l-32 0z']
      
    ]
  };

  

  
  

  var faUserNurseHair = {
    prefix: 'fasds',
    iconName: 'user-nurse-hair',
    icon: [
      448,
      512,
      [],
      'e45d',
      
      ['M97 176l127 0 64-32 32 16 32 0c0 70.7-57.3 128-128 128c-65.3 0-119.1-48.9-127-112z','M224 176l64-32 32 16 32 0 0-112L224 0 96 48l0 128 128 0zM208 64l0-24 32 0 0 24 24 0 0 32-24 0 0 24-32 0 0-24-24 0 0-32 24 0zm16 360L126.1 320 64 320 0 512l448 0L384 320l-62.1 0L224 424z']
      
    ]
  };

  

  
  

  var faClipboardPrescription = {
    prefix: 'fasds',
    iconName: 'clipboard-prescription',
    icon: [
      384,
      512,
      [],
      'f5e8',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-72 0-24 80 0 0 448L0 512 0 64zM84 196l0 20 0 80 0 64 0 20 40 0 0-20 0-44 19.6 0 2.8 2.6 64.8 60.8-32.6 29.9-14.7 13.5 27 29.5 14.7-13.5 34.9-32 33.9 31.8 14.6 13.7 27.4-29.2-14.6-13.7L270 379.7l31.6-28.9 14.7-13.5-27-29.5-14.7 13.5-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60l-72 0-20 0zm40 40l52 0c11 0 20 9 20 20s-9 20-20 20l-16.6 0-.3-.3-.3 .3L124 276l0-40z','M270.4 64C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L80 64l0 96 112 0 112 0 0-96-33.6 0zM168 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM104 196l-20 0 0 20 0 80 0 64 0 20 40 0 0-20 0-44 19.6 0 2.8 2.6 64.8 60.8-32.6 29.9-14.7 13.5 27 29.5 14.7-13.5 34.9-32 33.9 31.8 14.6 13.7 27.4-29.2-14.6-13.7L270 379.7l31.6-28.9 14.7-13.5-27-29.5-14.7 13.5-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60l-72 0zm55.1 79.7l-.3 .3L124 276l0-40 52 0c11 0 20 9 20 20s-9 20-20 20l-16.6 0-.3-.3z']
      
    ]
  };

  

  
  

  var faCirclePhone = {
    prefix: 'fasds',
    iconName: 'circle-phone',
    icon: [
      512,
      512,
      ["phone-circle"],
      'e11b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 144l72-16 40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L312 272l72 40-16 72-16 0c-123.7 0-224-100.3-224-224l0-16z','M128 144l72-16 40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L312 272l72 40-16 72H352c-123.7 0-224-100.3-224-224l0-16z']
      
    ]
  };

  
    var faPhoneCircle = faCirclePhone;
  

  
  

  var faSquareG = {
    prefix: 'fasds',
    iconName: 'square-g',
    icon: [
      448,
      512,
      [],
      'e271',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 256c0-70.7 57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C263.2 183.7 244.5 176 224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280l-24 0 0-48 24 0 80 0 24 0 0 24c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M224 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c35.8 0 66.1-23.5 76.3-56L248 280l-24 0 0-48 24 0 80 0 24 0 0 24c0 70.7-57.3 128-128 128s-128-57.3-128-128s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6l-32 35.8C263.2 183.7 244.5 176 224 176z']
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fasds',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'f0b0',
      
      ['M192 416V320L0 96V32H512V96L320 320V512L192 416z','']
      
    ]
  };

  

  
  

  var faDownToLine = {
    prefix: 'fasds',
    iconName: 'down-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-bottom"],
      'f34a',
      
      ['M0 416l32 0 320 0 32 0 0 64-32 0L32 480 0 480l0-64z','M192 384L352 224l0-32-96 0 0-160L128 32l0 160-96 0 0 32L192 384z']
      
    ]
  };

  
    var faArrowAltToBottom = faDownToLine;
  

  
  

  var faRouteHighway = {
    prefix: 'fasds',
    iconName: 'route-highway',
    icon: [
      448,
      512,
      [],
      'f61a',
      
      ['M0 322.5c0 50 29.1 95.4 74.6 116.3l136.1 62.4 13.3 6.1 13.3-6.1 136.1-62.4c45.5-20.8 74.6-66.3 74.6-116.3c0-16.3-3.1-32.4-9.1-47.5l-15.8-39.5c-4.7-11.7-7.1-24.1-7.1-36.6c0-2.3 .1-4.6 .2-6.8L31.8 192c.2 2.3 .2 4.6 .2 6.8c0 12.5-2.4 25-7.1 36.6L9.1 275C3.1 290.1 0 306.2 0 322.5z','M224 2.7l16.5 9.9 4.7 2.8c37.5 22.5 84 24.3 123.1 4.7l1.4-.7L396.8 5.8l15 26.3 32 56 8.5 14.9-7.7 15.3-18.2 36.4c-5.8 11.7-9.3 24.3-10.2 37.3L31.8 192c-.9-13-4.4-25.6-10.2-37.3L3.4 118.3-4.3 103 4.2 88.1l32-56 15-26.3L78.3 19.4l1.4 .7c39.1 19.6 85.6 17.8 123.1-4.7l4.7-2.8L224 2.7z']
      
    ]
  };

  

  
  

  var faMemoCircleCheck = {
    prefix: 'fasds',
    iconName: 'memo-circle-check',
    icon: [
      576,
      512,
      [],
      'e1d9',
      
      ['M0 0L384 0l0 198.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM64 128l0 32 16 0 224 0 16 0 0-32-16 0L80 128l-16 0zm0 96l0 32 16 0 160 0 16 0 0-32-16 0L80 224l-16 0zm0 96l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faDiamonds4 = {
    prefix: 'fasds',
    iconName: 'diamonds-4',
    icon: [
      512,
      512,
      [],
      'e68b',
      
      ['M139.3 116.7L256 0 372.7 116.7 256 233.4 139.3 116.7zm0 278.6L256 278.6 372.7 395.3 256 512 139.3 395.3z','M116.7 139.3L0 256 116.7 372.7 233.4 256 116.7 139.3zm278.6 0L278.6 256 395.3 372.7 512 256 395.3 139.3z']
      
    ]
  };

  

  
  

  var faPodium = {
    prefix: 'fasds',
    iconName: 'podium',
    icon: [
      448,
      512,
      [],
      'f680',
      
      ['M44.4 192L80 512l288 0 35.6-320L44.4 192z','M288 0L176 0l0 24-8 0c-48.6 0-88 39.4-88 88l0 32-56 0L0 144l0 48 24 0 400 0 24 0 0-48-24 0-296 0 0-32c0-22.1 17.9-40 40-40l8 0 0 24 112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48z']
      
    ]
  };

  

  
  

  var faDagger = {
    prefix: 'fasds',
    iconName: 'dagger',
    icon: [
      384,
      512,
      [],
      'f6cb',
      
      ['M128 192l64 0 64 0 0 240-64 80-64-80 0-240z','M224 32l0-32L160 0l0 32 0 96-80 0-32 0L0 128l0 48c0 26.5 21.5 48 48 48c20.9 0 38.7-13.4 45.3-32l98.7 0 98.7 0c6.6 18.6 24.4 32 45.3 32c26.5 0 48-21.5 48-48l0-48-48 0-32 0-80 0 0-96z']
      
    ]
  };

  

  
  

  var faFaceKissWinkHeart = {
    prefix: 'fasds',
    iconName: 'face-kiss-wink-heart',
    icon: [
      512,
      512,
      [128536,"kiss-wink-heart"],
      'f598',
      
      ['M0 256C0 397.4 114.6 512 256 512c33.5 0 65.6-6.4 94.9-18.2l-1.5-5.9-27-105.1c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm75.7 95l3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-1.3-5-2.6-10-3.7-15.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4c-.1-.1-.2-.1-.6-.3c0-4.6 0-9.3 .3-14.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7zm47.1-84.6c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2z','M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm170.8 29.6l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l27 105.1 100.7-28.2c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z']
      
    ]
  };

  
    var faKissWinkHeart = faFaceKissWinkHeart;
  

  
  

  var faWheatAwnSlash = {
    prefix: 'fasds',
    iconName: 'wheat-awn-slash',
    icon: [
      640,
      512,
      [],
      'e338',
      
      ['M66.7 464l22.6-22.6 52.9-52.9L131.9 378c-37.5-37.5-37.5-98.3 0-135.8l22.6-22.6 22.6 22.6c21 21 33.2 47.5 36.5 74.8l29.5-29.5 50.6 39.9-36.3 36.3c28.5 2.8 56.2 15.1 78.1 36.9l22.6 22.6-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-52.9 52.9L112 509.3 66.7 464zM224.3 151.4c2.8-3.8 5.9-7.5 9.4-10.9l22.6-22.6 22.6 22.6c21 21 33.2 47.5 36.5 74.8l30.5-30.5-10.4-10.4c-37.5-37.5-37.5-98.3 0-135.8L358.1 16l22.6 22.6c4.5 4.5 8.6 9.3 12.4 14.3L423 23l17-17L473.9 40 457 57 414.7 99.2c5.1 21.5 4.7 44-1.4 65.3c20.3-5.8 41.8-6.5 62.3-2.1L519 119l17-17L569.9 136l-17 17-30.2 30.2c5.7 4.1 11.2 8.7 16.4 13.9l22.6 22.6-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0l-12.2-12.2-28.6 28.6c-46.1-35.8-92.2-71.6-138.3-107.3zM430 112l17-17 72-72 17-17L569.9 40 553 57l-72 72-17 17L430 112z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faLanguage = {
    prefix: 'fasds',
    iconName: 'language',
    icon: [
      640,
      512,
      [],
      'f1ab',
      
      ['M0 64L0 448l320 0 0-384L0 64zM68.1 352l1.4-3.4L93.3 289c.1-.3 .2-.6 .4-.9l47.8-119.6 3.4-8.6 30.3 0 3.4 8.6 47.8 119.6c.1 .3 .2 .6 .3 .9l23.8 59.6 1.4 3.4-43.1 0-14.4-36-68.9 0-14.4 36-43.1 0zm73.5-76l36.9 0L160 229.9 141.5 276z','M640 64L320 64l0 384 320 0 0-384zM500 184l0 4 44 0 16 0 20 0 0 40-20 0-2 0-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3 17.1 10.3-20.6 34.3-17.2-10.3-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6-18.3 8.1-16.2-36.6 18.3-8.1 3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2L427.7 272 456 243.7l14.1 14.1 14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45L480 228l-72 0-20 0 0-40 20 0 52 0 0-4 0-20 40 0 0 20zM175.1 160l-30.3 0-3.4 8.6L93.6 288.1c-.1 .3-.2 .6-.4 .9L69.4 348.6 68.1 352l43.1 0 14.4-36 68.9 0 14.4 36 43.1 0-1.4-3.4L226.7 289c-.1-.3-.2-.6-.3-.9L178.6 168.6l-3.4-8.6zm3.3 116l-36.9 0L160 229.9 178.5 276z']
      
    ]
  };

  

  
  

  var faBreadSlice = {
    prefix: 'fasds',
    iconName: 'bread-slice',
    icon: [
      512,
      512,
      [],
      'f7ec',
      
      ['M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64l0 224L64 480l0-224c-35.3 0-64-28.7-64-64zm128 96l0 32 32 0 0-32-32 0zm0 96l0 32 32 0 0-32-32 0zm96 0l0 32 32 0 0-32-32 0z','M128 288l32 0 0 32-32 0 0-32zm0 96l32 0 0 32-32 0 0-32zm128 0l0 32-32 0 0-32 32 0z']
      
    ]
  };

  

  
  

  var faVectorSquare = {
    prefix: 'fasds',
    iconName: 'vector-square',
    icon: [
      448,
      512,
      [],
      'f5cb',
      
      ['M32 160l16 0 32 0 16 0 0 192-16 0-32 0-16 0 0-192zm96-96l192 0 0 16 0 32 0 16-192 0 0-16 0-32 0-16zm0 320l192 0 0 16 0 32 0 16-192 0 0-16 0-32 0-16zM352 160l16 0 32 0 16 0 0 192-16 0-32 0-16 0 0-192z','M400 80l0 32-32 0 0-32 32 0zM368 32l-48 0 0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0zM48 400l32 0 0 32-32 0 0-32zM0 352l0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0L0 352zm368 48l32 0 0 32-32 0 0-32zm-48-48l0 48 0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48-48 0-32 0-48 0zM48 80l32 0 0 32-32 0 0-32zM0 32L0 80l0 32 0 48 48 0 32 0 48 0 0-48 0-32 0-48L80 32 48 32 0 32z']
      
    ]
  };

  

  
  

  var faMoneyCheckDollar = {
    prefix: 'fasds',
    iconName: 'money-check-dollar',
    icon: [
      576,
      512,
      ["money-check-alt"],
      'f53d',
      
      ['M0 64L0 448l576 0 0-384L0 64zM70.7 328.7c4.2-12.6 8.4-25.3 12.6-38c6.3 2.1 12.6 4.2 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7c-.7-.2-1.5-.4-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3zM256 192l256 0 0 32-256 0 0-32zm0 96l256 0 0 32-256 0 0-32z','M164 160l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3zm348 32l-256 0 0 32 256 0 0-32z']
      
    ]
  };

  
    var faMoneyCheckAlt = faMoneyCheckDollar;
  

  
  

  var faDiceD4 = {
    prefix: 'fasds',
    iconName: 'dice-d4',
    icon: [
      512,
      512,
      [],
      'f6d0',
      
      ['M0 320L240 512 240 0 0 320z','M272 512V0L512 320 272 512z']
      
    ]
  };

  

  
  

  var faPersonDressBurst = {
    prefix: 'fasds',
    iconName: 'person-dress-burst',
    icon: [
      640,
      512,
      [],
      'e544',
      
      ['M4.4 215.2L100 236.6l-.4 98L176 273.2l76.4 61.4-.4-98 95.6-21.4-76.9-60.8 42.9-88.1L218.2 88.5 176 0 133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2z','M432 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-20.6 80l17.5 0 102.2 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-42-65.8L592 384l-40 0 0 96 0 32-64 0 0-32 0-96-16 0 0 96 0 32-64 0 0-32 0-96-40 0 48.2-144.6-42 65.8-53.9-34.4 81.7-128 9.4-14.8z']
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fasds',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      ['M128 272l0 64 67.6 0c14.6 64.1 71.9 112 140.4 112c43.5 0 82.4-19.3 108.8-49.7L512 434.1l0-50.1 42 0-79-42.1c3.3-12.1 5-24.8 5-37.9c0-20.3-4.2-39.7-11.8-57.2L542.8 192c-10.3 0-20.6 0-30.8 0l0-56.7-81.7 59.9C405 173.3 372.1 160 336 160c-10.4 0-20.6 1.1-30.4 3.2L288 125.5l0 2.5c-23.1 0-46.3 0-69.4 0l29.1 62.3C221.8 210.4 203 239 195.6 272L128 272zm256 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M288 0L160 0l0 128 128 0L288 0zM128 240L0 240 0 368l128 0 0-128zM512 64l0 128 128 0 0-128L512 64zM640 384l-128 0 0 128 128 0 0-128z']
      
    ]
  };

  

  
  

  var faWifiExclamation = {
    prefix: 'fasds',
    iconName: 'wifi-exclamation',
    icon: [
      640,
      512,
      [],
      'e2cf',
      
      ['M9.8 156.7l44.3 46.2c52-49.9 118.1-85.4 191.7-99.7L240.5 39C151.8 54.9 72.2 96.9 9.8 156.7zM129.5 264l42.4 48c24.9-21.9 54.6-38.4 87.4-47.7l-5.4-64.7c-46.9 11-89.4 33.5-124.4 64.4zm251.3 .3c32.8 9.2 62.5 25.7 87.4 47.7l42.4-48c-34.9-30.8-77.4-53.3-124.4-64.4l-5.4 64.7zm13.4-161.2c73.6 14.4 139.6 49.8 191.7 99.7l44.3-46.2C567.8 96.9 488.2 54.9 399.5 39l-5.3 64.1z','M296 320L272 32l96 0L344 320l-48 0zm24 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128z']
      
    ]
  };

  

  
  

  var faKidneys = {
    prefix: 'fasds',
    iconName: 'kidneys',
    icon: [
      640,
      512,
      [],
      'f5fb',
      
      ['M193.2 202.8l15.4-17.3 82.1 41.1 13.3 6.6 0 14.8 0 240 0 24-48 0 0-24 0-225.2L196.3 233c-1-10.1-2-20.1-3-30.2zM336 233.2l13.3-6.6 82.1-41.1c5.1 5.8 10.2 11.5 15.4 17.3l-3 30.2L384 262.8 384 488l0 24-48 0 0-24 0-240 0-14.8z','M87.7 23.8C106.5 6.3 130.5 0 152 0l3.2 0c19.9 0 39.4 5.9 55.9 16.9l3.4 2.3C240.4 36.5 256 65.6 256 96.7c0 22.8-8.4 44.8-23.5 61.9l-39.2 44.1 7.3 72.7c5.8 58.1-39.8 108.5-98.2 108.5c-46.5 0-88.2-32.9-95.3-80.9C3.5 278.7 0 248.9 0 224C0 119.6 56.4 52.8 87.7 23.8zm464.6 0C583.6 52.8 640 119.6 640 224c0 24.9-3.5 54.7-7.1 79.1c-7.1 48-48.8 80.9-95.3 80.9c-58.4 0-104-50.4-98.2-108.5l7.3-72.7-39.2-44.1C392.4 141.6 384 119.6 384 96.7c0-31.2 15.6-60.2 41.5-77.5l3.4-2.3C445.5 5.9 464.9 0 484.8 0L488 0c21.5 0 45.5 6.3 64.3 23.8z']
      
    ]
  };

  

  
  

  var faFaceParty = {
    prefix: 'fasds',
    iconName: 'face-party',
    icon: [
      640,
      512,
      [],
      'e383',
      
      ['M64 256c0 141.4 114.6 256 256 256c88 0 165.6-44.4 211.7-112L432 400l-19.1 0c-1.2 2.3-2.6 4.4-4.2 6.3c-4.3 5.2-10.1 9.7-16.7 13.4C378.7 427.1 361.4 432 344 432l-3.9-15c.5-.3 .8-.5 1.2-.7c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5c-.3-4.8-.3-9.4-.3-14.1c.5-.3 .8-.5 1.2-.7c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5c1-5.1 2.4-10.1 3.7-15.1c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c1.6 2 3.1 4.1 4.2 6.3l19.1 0 48 0 0-16 0-64 0-48 48 0 35.3 0C529.7 73.8 433.4 0 320 0C178.6 0 64 114.6 64 256zm107.2-37.6c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2zm160 0c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2zm52 133.6c.3 .1 .5 .2 .8 .3l0-.7c-.3 .1-.5 .2-.8 .3z','M54.3 144.7c17.8-42.4 45.4-79.7 80.1-108.9L88.5 23.6C67.7 44.3 49.7 67.8 35 93.5l19.2 51.3zm-1-130.5L0 0 20.9 55.6C30.7 41 41.5 27.2 53.3 14.2zM528 208l-16 0 0 16 0 64 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-32 64 0 0 96-208 0-16 0 0 32 16 0 224 0 16 0 0-16 0-128 0-16-16 0-96 0zM283.2 237.6l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2c21.6-28.8 64.8-28.8 86.4 0zm73.6 0c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2z']
      
    ]
  };

  

  
  

  var faSparkle = {
    prefix: 'fasds',
    iconName: 'sparkle',
    icon: [
      448,
      512,
      [],
      'e5d6',
      
      ['M149.3 181.3L224 32l74.7 149.3L448 256 298.7 330.7 224 480 149.3 330.7 0 256l149.3-74.7z','']
      
    ]
  };

  

  
  

  var faChartWaterfall = {
    prefix: 'fasds',
    iconName: 'chart-waterfall',
    icon: [
      512,
      512,
      [],
      'e0eb',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M384 64l-64 0 0 32 0 64 0 32 64 0 0-32 0-64 0-32zm-96 96l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64zm-96 96l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64zM480 96l0-32-64 0 0 32 0 224 0 32 64 0 0-32 0-224z']
      
    ]
  };

  

  
  

  var faListOl = {
    prefix: 'fasds',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      ['M192 64l32 0 256 0 32 0 0 64-32 0-256 0-32 0 0-64zm0 160l32 0 264 0 32 0 0 64-32 0-264 0-32 0 0-64zm0 160l32 0 256 0 32 0 0 64-32 0-256 0-32 0 0-64z','M56 32L32 32l0 48 24 0 0 96-8 0-24 0 0 48 24 0 8 0 48 0 8 0 24 0 0-48-24 0-8 0 0-120 0-24L80 32 56 32zM72 288c-35.3 0-64 28.7-64 64l48 0c0-8.8 7.2-16 16-16l17.2 0c8.2 0 14.8 6.6 14.8 14.8c0 4.2-1.8 8.2-4.8 11L15.8 437.7 8 444.8l0 10.6 0 .6 0 24 24 0 96 0 24 0 0-48-24 0-34.6 0 38.1-34.7c13.1-11.9 20.5-28.8 20.5-46.5c0-34.7-28.1-62.8-62.8-62.8L72 288z']
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faSort = {
    prefix: 'fasds',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      ['M0 288l0 48L160 480 320 336l0-48L0 288z','M0 176L160 32 320 176v48H0V176z']
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faLocust = {
    prefix: 'fasds',
    iconName: 'locust',
    icon: [
      576,
      512,
      [],
      'e520',
      
      ['M288 32l0 48 24 0 48 0c90.1 0 163.6 70.9 167.8 160c16 0 32 0 48.1 0C571.6 124.4 476.6 32 360 32l-48 0-24 0z','M397.7 104.3l16.4 38.2L455.8 240 576 240l0 80c0 44.2-35.8 80-80 80l-12.4 0 45.7 80-55.3 0-45.7-80L348 400l-55.4 80-58.4 0 55.4-80-53 0-59.8 80-59.9 0 65-86.9-41.2-15.7L59.6 480l-61.2 0L269.2 137.1l25-31.7 15.9 37.1 21.5 50.2 41.2-55.1 24.9-33.3zM249.1 240l47.2 0 2.1-2.8-16.6-38.6L249.1 240zm107.1 0l47.4 0-17.3-40.3L356.2 240zm-205.5 0L64.1 348.2 32 336l0-96 118.7 0zM512 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faFilterCircleXmark = {
    prefix: 'fasds',
    iconName: 'filter-circle-xmark',
    icon: [
      576,
      512,
      [],
      'e17b',
      
      ['M0 0L0 64 192 288l0 96 81.9 61.4C262.4 422.1 256 395.8 256 368c0-86.2 62-157.9 143.8-173.1L512 64l0-64L0 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L480 297.4l-11.3 11.3L432 345.4l-36.7-36.7L384 297.4 361.4 320l11.3 11.3L409.4 368l-36.7 36.7L361.4 416 384 438.6l11.3-11.3L432 390.6l36.7 36.7L480 438.6 502.6 416l-11.3-11.3L454.6 368l36.7-36.7L502.6 320z']
      
    ]
  };

  

  
  

  var faToiletPaperCheck = {
    prefix: 'fasds',
    iconName: 'toilet-paper-check',
    icon: [
      640,
      512,
      [],
      'e5b2',
      
      ['M8 512l357.3 0 8.2-19.7c14.1-34.1 23.6-70.7 29.9-108.3C414.3 320.1 416 253.4 416 192c0-79.2 24-147.2 58.2-176.5C485.8 5.5 498.6 0 512 0L160 0C107 0 64 86 64 192c0 89.9-3.9 190.6-37.6 275.8L8 512zM150.1 208L184 174.1l17 17 23 23 55-55 17-17L329.9 176l-17 17-72 72-17 17-17-17-40-40-17-17z','M416 192c0 61.4-1.7 128.1-12.5 192L512 384c53 0 96-86 96-192S565 0 512 0c-13.4 0-26.2 5.5-37.8 15.5C440 44.8 416 112.8 416 192c0 0 0 0 0 0zm128 0c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z']
      
    ]
  };

  

  
  

  var faCircleI = {
    prefix: 'fasds',
    iconName: 'circle-i',
    icon: [
      512,
      512,
      [],
      'e111',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 72 0 72 0 24 0 0 48-24 0-48 0 0 160 48 0 24 0 0 48-24 0-48 0-48 0-48 0-24 0 0-48 24 0 48 0 0-160-48 0-24 0 0-48z','M160 128l24 0 72 0 72 0 24 0 0 48-24 0-48 0 0 160 48 0 24 0 0 48-24 0-48 0-48 0-48 0-24 0 0-48 24 0 48 0 0-160-48 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faUserGroupCrown = {
    prefix: 'fasds',
    iconName: 'user-group-crown',
    icon: [
      640,
      512,
      ["users-crown"],
      'f6a5',
      
      ['M96 128l0 16c0 70.7 57.3 128 128 128s128-57.3 128-128l0-16-32 0-16 0-160 0-16 0-32 0zM359.4 229.3C379 245.9 404.3 256 432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-17.2 0-33.5 3.9-48 10.8l0 10.9 0 90.3c0 31.4-9 60.6-24.6 85.3zm63 90.7l56.2 182.6 2.9 9.4L640 512 576 320l-153.6 0z','M96 53.7L96 0l48 24 16 8L224 0l64 32 16-8L352 0l0 53.7L352 80l0 48-32 0-16 0-160 0-16 0-32 0 0-48 0-26.3zM384 304l64 208L0 512 64 304l320 0z']
      
    ]
  };

  
    var faUsersCrown = faUserGroupCrown;
  

  
  

  var faCircleArrowRight = {
    prefix: 'fasds',
    iconName: 'circle-arrow-right',
    icon: [
      512,
      512,
      ["arrow-circle-right"],
      'f0a9',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM112 232c0 16 0 32 0 48c8 0 16 0 24 0c60.7 0 121.4 0 182.1 0c-23.7 23.7-47.3 47.3-71 71c-5.7 5.7-11.3 11.3-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c37.3-37.3 74.7-74.7 112-112c5.7-5.7 11.3-11.3 17-17c-5.7-5.7-11.3-11.3-17-17c-37.3-37.3-74.7-74.7-112-112c-5.7-5.7-11.3-11.3-17-17L230.1 144c5.7 5.7 11.3 11.3 17 17c23.7 23.7 47.3 47.3 71 71c-60.7 0-121.4 0-182.1 0c-8 0-16 0-24 0z','M409.9 256l-17 17L281 385l-17 17L230.1 368l17-17 71-71L136 280l-24 0 0-48 24 0 182.1 0-71-71-17-17L264 110.1l17 17L393 239l17 17z']
      
    ]
  };

  
    var faArrowCircleRight = faCircleArrowRight;
  

  
  

  var faBreadSliceButter = {
    prefix: 'fasds',
    iconName: 'bread-slice-butter',
    icon: [
      512,
      512,
      [],
      'e3e1',
      
      ['M168 288l88 88 88-88-88-88-88 88z','M0 192C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64l0 224L64 480l0-224c-35.3 0-64-28.7-64-64zM256 376l88-88-88-88-88 88 88 88z']
      
    ]
  };

  

  
  

  var faMoonCloud = {
    prefix: 'fasds',
    iconName: 'moon-cloud',
    icon: [
      640,
      512,
      [],
      'f754',
      
      ['M256.5 240.3C310 244.7 352 289.4 352 344l0 95.9c36.3 25.3 80.4 40.1 128 40.1c62.6 0 119.2-25.7 159.8-67c-15.5 4.1-31.8 6.2-48.6 6.2c-105.8 0-191.5-86-191.5-192c0-89.6 61.2-164.8 144-186c-20.2-6-41.5-9.2-63.6-9.2c-118.4 0-215.4 91.9-223.5 208.3z','M248 416L64 416 0 416l0-64c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0c7.4-36.5 39.7-64 78.4-64c35 0 64.8 22.5 75.6 53.8c8.7-3.7 18.3-5.8 28.4-5.8c39.8 0 72 32.2 72 72l0 72-72 0z']
      
    ]
  };

  

  
  

  var faArrowTurnDownRight = {
    prefix: 'fasds',
    iconName: 'arrow-turn-down-right',
    icon: [
      512,
      512,
      [],
      'e3d6',
      
      ['M0 32L0 64 0 288l0 32 32 0 354.7 0 32-32c-10.7-10.7-21.3-21.3-32-32L64 256 64 64l0-32L0 32z','M336 114.7l22.6 22.6 128 128L509.3 288l-22.6 22.6-128 128L336 461.3 290.7 416l22.6-22.6L418.7 288 313.4 182.6 290.7 160 336 114.7z']
      
    ]
  };

  

  
  

  var faGuitarElectric = {
    prefix: 'fasds',
    iconName: 'guitar-electric',
    icon: [
      512,
      512,
      [127928],
      'f8be',
      
      ['M0 353.2c0 19.8 7.6 39.7 22.7 54.8l80.5 81.3C118.8 505 139.5 512.5 160 512c19.2-.5 38.2-8.1 52.8-22.7c10.8-10.8 18-24.5 22.4-39c7.5-25.1 22.7-66.2 47.6-91.2c7.7-7.7 15.4-12.9 22.3-16.4c3.3-1.7 6.6-3.3 10-4.9c12.2-5.8 24.6-11.8 34-21.2l28.8-28.8L354 264.1s-26.5 26.5-64.2 3.4c-6-3.7-12.4-8.7-18.9-15.2c-4-4-7.9-7.9-11.9-11.9c-6.2-6.2-10.8-12.4-14.1-18.5c-21.9-40.6 14.1-76.5 14.1-76.5l-23.8-23.8-40.7 40.7c-9.4 9.4-15.4 21.8-21.2 34c-1.6 3.4-3.2 6.7-4.9 10c-3.5 6.9-8.7 14.6-16.4 22.3c-24.9 24.9-65.2 40-90.3 47.6c-14.6 4.4-28.3 11.6-39 22.4C7.6 313.6 0 333.4 0 353.2zM97.4 344c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c16 16 32 32 48 48c3.8 3.8 7.5 7.5 11.3 11.3L168 414.6l-11.3-11.3c-16-16-32-32-48-48c-3.8-3.8-7.5-7.5-11.3-11.3zm64-64c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3c16 16 32 32 48 48c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-48-48c-3.8-3.8-7.5-7.5-11.3-11.3z','M352 114.7L352 64 448 0l39.2 31.4c21.7 17.4 23.5 49.8 3.8 69.5c-12.4 12.4-30.3 16.6-46.5 11.7L289.8 267.5c-6-3.7-12.4-8.7-18.9-15.2l-11.9-11.9c-6.2-6.2-10.8-12.4-14.1-18.5L352 114.7zM184 257.4l11.3 11.3 48 48L254.6 328 232 350.6l-11.3-11.3-48-48L161.4 280 184 257.4zm-64 64l11.3 11.3 48 48L190.6 392 168 414.6l-11.3-11.3-48-48L97.4 344 120 321.4z']
      
    ]
  };

  

  
  

  var faRectangleAd = {
    prefix: 'fasds',
    iconName: 'rectangle-ad',
    icon: [
      576,
      512,
      ["ad"],
      'f641',
      
      ['M0 32L0 480l576 0 0-448L0 32zM108.8 352L186 174.4l6.3-14.4 15.7 0 4 0 16.1 0 6.1 14.8L307.4 352l-51.9 0-9.9-24-73.9 0-10.4 24-52.3 0zm83.6-72l33.3 0-16.2-39.2L192.4 280zM320 280c0-39.8 32.2-72 72-72c8.4 0 16.5 1.4 24 4.1l0-28.1 0-24 48 0 0 24 0 96 0 48 0 24-48 0 0-4.1c-7.5 2.7-15.6 4.1-24 4.1c-39.8 0-72-32.2-72-72zm48 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M192.3 160l15.7 0 4 0 16.1 0 6.1 14.8L307.4 352l-51.9 0-9.9-24-73.9 0-10.4 24-52.3 0L186 174.4l6.3-14.4zm.2 120l33.3 0-16.2-39.2L192.4 280zM464 160l0 24 0 96 0 48 0 24-48 0 0-4.1c-7.5 2.7-15.6 4.1-24 4.1c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1l0-28.1 0-24 48 0zm-72 96a24 24 0 1 0 0 48 24 24 0 1 0 0-48z']
      
    ]
  };

  
    var faAd = faRectangleAd;
  

  
  

  var faNewspaper = {
    prefix: 'fasds',
    iconName: 'newspaper',
    icon: [
      512,
      512,
      [128240],
      'f1ea',
      
      ['M96 32l0 64 0 384 416 0 0-448L96 32zm64 64l160 0 0 128-160 0 0-128zm0 192l16 0 256 0 16 0 0 32-16 0-256 0-16 0 0-32zm0 96l16 0 256 0 16 0 0 32-16 0-256 0-16 0 0-32zM368 96l16 0 48 0 16 0 0 32-16 0-48 0-16 0 0-32zm0 96l16 0 48 0 16 0 0 32-16 0-48 0-16 0 0-32z','M0 96L0 480l96 0L96 96 0 96zm384 0l-16 0 0 32 16 0 48 0 16 0 0-32-16 0-48 0zm0 96l-16 0 0 32 16 0 48 0 16 0 0-32-16 0-48 0zM176 288l-16 0 0 32 16 0 256 0 16 0 0-32-16 0-256 0zm0 96l-16 0 0 32 16 0 256 0 16 0 0-32-16 0-256 0z']
      
    ]
  };

  

  
  

  var faStomach = {
    prefix: 'fasds',
    iconName: 'stomach',
    icon: [
      512,
      512,
      [],
      'f623',
      
      ['M214.8 414l1.7 1.4c11.4 9.5 21.6 17.1 34.4 22.8c12.6 5.5 29.1 9.8 53.1 9.8c69.7 0 127.9-49.5 141.1-115.3c-7.3 1.9-14.6 3.3-21.1 3.3c-16.8 .2-28.4-7.9-40-16s-23.2-16.3-40-16c-7.9 .1-17.1 2.1-25.6 4.6c-8.6 53.5-50.4 95.8-103.6 105.4z','M192 0l0 32 0 128 81.1 0c22.1-38.3 63.5-64 110.9-64c70.7 0 128 57.3 128 128l0 80c0 114.9-93.1 208-208 208c-32 0-57.5-5.8-78.9-15.2c-21.2-9.3-36.9-21.7-49.6-32.2c-1.8-1.5-3.6-3-5.3-4.4c0 0 0 0 0 0C148 441.5 136.6 432 112 432l-48 0 0 48 0 32L0 512l0-32 0-80 0-16 0-32 32 0 160 0c35.3 0 64-28.7 64-64l0-64-96 0-32 0 0-32 0-160 0-32 64 0zm22.8 414c.6 .5 1.1 1 1.7 1.4c11.4 9.5 21.6 17.1 34.4 22.8c12.6 5.5 29.1 9.8 53.1 9.8c79.5 0 144-64.5 144-144l0-80c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 64c0 62.9-45.4 115.2-105.2 126z']
      
    ]
  };

  

  
  

  var faSnowflake = {
    prefix: 'fasds',
    iconName: 'snowflake',
    icon: [
      448,
      512,
      [10052,10054],
      'f2dc',
      
      ['M5.1 196.1l12.4 46.4 23.2-6.2 58.2-15.6L40 186.7l-11.8 3.2L5.1 196.1zm0 119.8l23.2 6.2L40 325.3c19.6-11.3 39.2-22.6 58.8-33.9L40.7 275.7l-23.2-6.2L5.1 315.9zM62.7 96.3l6.2 23.2L72 131.3c19.6 11.3 39.2 22.6 58.8 33.9l-15.6-58.2L109 83.9 62.7 96.3zm0 319.3L109 428.1l6.2-23.2 15.6-58.2c-19.6 11.3-39.2 22.6-58.8 33.9l-3.2 11.8-6.2 23.2zM132.5 70.4l17 17L192 129.9c0 23.5 0 47.1 0 70.6c0-56.2 0-112.4 0-168.6c0 10 0 20 0 30.1l-8.6-8.6-17-17L132.5 70.4zm0 371.2l33.9 33.9 17-17 8.6-8.6c0 10 0 20 0 30.1c0-56.2 0-112.4 0-168.6l0 70.6-42.6 42.6-17 17zM256 62.1c0 22.6 0 45.3 0 67.9l42.6-42.6 17-17L281.6 36.5l-17 17L256 62.1zm0 320c0 22.6 0 45.3 0 67.9l8.6 8.6 17 17 33.9-33.9-17-17L256 382.1zm61.2-216.8L376 131.3l3.2-11.8 6.2-23.2L339 83.9l-6.2 23.2-15.6 58.2zm0 181.5l15.6 58.2 6.2 23.2 46.4-12.4-6.2-23.2L376 380.7c-19.6-11.3-39.2-22.6-58.8-33.9zm32-126.1l58.2 15.6 23.2 6.2 12.4-46.4-23.2-6.2L408 186.7c-19.6 11.3-39.2 22.6-58.8 33.9zm0 70.6c19.6 11.3 39.2 22.6 58.8 33.9l11.8-3.2 23.2-6.2-12.4-46.4-23.2 6.2-58.2 15.6z','M256 0l0 32 0 168.6 132.1-76.3 27.7-16 32 55.4-27.7 16L288 256l132.1 76.3 27.7 16-32 55.4-27.7-16L256 311.4 256 480l0 32-64 0 0-32 0-168.6L59.9 387.7l-27.7 16L.2 348.3l27.7-16L160 256 27.9 179.7 .2 163.7l32-55.4 27.7 16L192 200.6 192 32l0-32 64 0z']
      
    ]
  };

  

  
  

  var faBroomWide = {
    prefix: 'fasds',
    iconName: 'broom-wide',
    icon: [
      512,
      512,
      [],
      'e5d1',
      
      ['M328 136L464 0l48 48L376 184l-48-48z','M288 96l-61.9 37.8L378.2 285.9 416 224 288 96zM240 512L356.7 321 191 155.3 0 272l68 68 60-20-20 60L240 512z']
      
    ]
  };

  

  
  

  var faP = {
    prefix: 'fasds',
    iconName: 'p',
    icon: [
      320,
      512,
      [112],
      '50',
      
      ['M64 288l96 0c53 0 96-43 96-96s-43-96-96-96L64 96l0 192zM0 352l0-32 0-32L0 96 0 64 0 32l32 0 32 0 96 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-96 0 0 96 0 32L0 480l0-32 0-96z','']
      
    ]
  };

  

  
  

  var faTrashCanClock = {
    prefix: 'fasds',
    iconName: 'trash-can-clock',
    icon: [
      576,
      512,
      [],
      'e2aa',
      
      ['M32 96l384 0 0 96.7c-29.3 2.6-56.6 12.5-80 27.7l0-44.5 0-16-32 0 0 16 0 71.2c-29.8 31.5-48 74-48 120.8c0 59.5 29.6 112.1 74.8 144L32 512 32 96zm80 64l0 16 0 224 0 16 32 0 0-16 0-224 0-16-32 0zm96 0l0 16 0 224 0 16 32 0 0-16 0-224 0-16-32 0z','M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 64 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faSausage = {
    prefix: 'fasds',
    iconName: 'sausage',
    icon: [
      512,
      512,
      [],
      'f820',
      
      ['M0 360L0 472l69.2-24.7c13 37.7 48.7 64.7 90.8 64.7c194.4 0 352-157.6 352-352c0-42.1-27.1-77.8-64.7-90.8L472 0 360 0l24.7 69.2C347.1 82.2 320 117.9 320 160c0 88.4-71.6 160-160 160c-42.1 0-77.8 27.1-90.8 64.7L0 360zm160 8c114.9 0 208-93.1 208-208l32 0c0 132.5-107.5 240-240 240l0-32z','M400 160c0 132.5-107.5 240-240 240l0-32c114.9 0 208-93.1 208-208l32 0z']
      
    ]
  };

  

  
  

  var faFeatherPointed = {
    prefix: 'fasds',
    iconName: 'feather-pointed',
    icon: [
      512,
      512,
      ["feather-alt"],
      'f56b',
      
      ['M63 303.1c0 30.7 7.7 60.6 25.7 86.2L271.9 206.1l17-17c11.3 11.3 22.6 22.6 33.9 33.9l-17 17L122.7 423.3c25.6 18 55.5 25.7 86.2 25.7c58 0 119.3-27.5 161.5-65L304 384l0-16 108.1-32.4c9.9-14.7 18.9-30.7 27.1-47.6L368 288l0-16 89.6-26.9C492.2 155.2 507.6 53.7 512 0C428.3 6.9 228.5 40.5 137.4 131.6C95.2 173.9 63 240.4 63 303.1z','M6.1 472l17-17L271.9 206.1l17-17 33.9 33.9-17 17L57 489l-17 17L6.1 472z']
      
    ]
  };

  
    var faFeatherAlt = faFeatherPointed;
  

  
  

  var faMace = {
    prefix: 'fasds',
    iconName: 'mace',
    icon: [
      512,
      512,
      [],
      'f6f8',
      
      ['M2.7 464L48 509.3l22.6-22.6L217.1 340.1c-18.4-11.3-34-26.8-45.3-45.3L25.4 441.4 2.7 464z','M328.3 94.1c42.7 13.2 76.4 46.9 89.6 89.6L512 224l-94.1 40.3c-13.2 42.7-46.9 76.4-89.6 89.6L288 448l-40.3-94.1c-42.7-13.2-76.4-46.9-89.6-89.6L64 224l94.1-40.3c13.2-42.7 46.9-76.4 89.6-89.6L288 0l40.3 94.1zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faTemperatureArrowDown = {
    prefix: 'fasds',
    iconName: 'temperature-arrow-down',
    icon: [
      576,
      512,
      ["temperature-down"],
      'e03f',
      
      ['M32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L288 64l0-64L224 0 128 0 64 0l0 64 0 213.5C44 302.2 32 333.7 32 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L128 300.2l0-22.7L128 64l96 0 0 213.5 0 22.7 14.2 17.6C249.4 331.5 256 348.9 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M480 352l64 0 0 32-96 96-96-96 0-32 64 0 0-288 0-32 64 0 0 32 0 288zM224 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-50.7 0-16 32 0 0 16 0 50.7c18.6 6.6 32 24.4 32 45.3z']
      
    ]
  };

  
    var faTemperatureDown = faTemperatureArrowDown;
  

  
  

  var faBookmarkSlash = {
    prefix: 'fasds',
    iconName: 'bookmark-slash',
    icon: [
      640,
      512,
      [],
      'e0c2',
      
      ['M128 0l0 76.6C256 176 384 275.4 512 374.7L512 0 128 0zm0 196.8L128 512 320 400 512 512l0-12.6L128 196.8z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faA = {
    prefix: 'fasds',
    iconName: 'a',
    icon: [
      384,
      512,
      [97],
      '41',
      
      ['M169.9 32l44.2 0 7.8 20.6 109.3 288L384.2 480l-68.5 0-36.4-96-174.5 0L68.3 480-.2 480 52.7 340.6l109.3-288L169.9 32zm85 288L192 154.2 129 320 255 320z','']
      
    ]
  };

  

  
  

  var faRoadLock = {
    prefix: 'fasds',
    iconName: 'road-lock',
    icon: [
      640,
      512,
      [],
      'e567',
      
      ['M32 480l256 0 0-64 0-32 64 0 0 32 0 64 32 0 0-192 32 0 0-16c0-58.1 44.2-105.8 100.7-111.4L480 32 352 32l0 64 0 32-64 0 0-32 0-64L160 32 32 480zM288 192l64 0 0 32 0 64 0 32-64 0 0-32 0-64 0-32z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faInputPipe = {
    prefix: 'fasds',
    iconName: 'input-pipe',
    icon: [
      640,
      512,
      [],
      'e1be',
      
      ['M0 64l0 64L0 384l0 64 64 0 512 0 64 0 0-64 0-256 0-64-64 0L64 64 0 64zm64 64l512 0 0 256L64 384l0-256z','M104 160h48V352H104V160z']
      
    ]
  };

  

  
  

  var faDeer = {
    prefix: 'fasds',
    iconName: 'deer',
    icon: [
      512,
      512,
      [129420],
      'f78e',
      
      ['M224 0l0 16 0 24c0 30.9 25.1 56 56 56l16 0 24 0 7 0 25 0 16 0 0-31.2 0-.8-16 0-5.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24 0-16L320 0l0 16 0 24c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24 0-16L224 0zM377.2 64c1.5 0 3 0 4.5 .1s3 .2 4.5 .3c3 .3 5.9 .7 8.8 1.3c5.8 1.1 11.5 2.8 17 5c10.9 4.4 21.1 10.8 29.7 19.1C459.7 80.4 472 61.7 472 40l0-24 0-16L440 0l0 16 0 24c0 13.3-10.7 24-24 24l-24 0-14.8 0z','M320 96l-64 16 0 32 56 0-9.6 32L224 176l-96 0-14.1 0-7.9 0C51.7 176 6.6 217.8 2.4 272L.1 302.2l-1.8 23.9 47.9 3.7 1.8-23.3c2.4 3.3 5.2 6.5 8.1 9.5L72.1 332 46.1 358.1 24.7 379.4 34.7 408 71.5 512l101.8 0L135.3 404.6l26.6-26.6L176 363.9l0-19.9 0-3.4L240 368l48 0 0 144 96 0 0-144 0-64 26.7-80 5.3 0 96 0 0-64L443.4 91.4C425.9 73.9 402.1 64 377.2 64c-3.1 0-6.2 .3-9.2 .8L368 96l-16 0-25 0-7 0zm64 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z']
      
    ]
  };

  

  
  

  var faPersonSkiing = {
    prefix: 'fasds',
    iconName: 'person-skiing',
    icon: [
      512,
      512,
      [9975,"skiing"],
      'f7c9',
      
      ['M-8.4 290.2l21.3 11.1 392 203.5 10.9 5.6 10.9-5.5 48-24 21.5-10.7-21.5-42.9-21.5 10.7-37.1 18.5c-42.1-21.9-84.3-43.8-126.4-65.6l-57.1-29.7c-65.9-34.2-131.7-68.4-197.6-102.6L13.8 247.6-8.4 290.2zM90.8 87.9l14.6 6.6 17.5 7.9-9.2 18.3-7.2 14.3 28.6 14.3 7.2-14.3 9.7-19.4c71.9 32.7 143.8 65.4 215.7 98c-1.1-1.9-2.2-3.8-3.3-5.7c-6.5-11.1-13-22.2-19.4-33.3l-5.2-8.9C300.2 148 260.7 130 221.1 112c-18.3-8.3-36.5-16.6-54.8-24.9l8-16 7.2-14.3L152.8 42.5l-7.2 14.3-8.5 17-18.6-8.4-14.6-6.6L90.8 87.9z','M428.7 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-60 215.5l-1-1.7-3.3-5.7-19.4-33.3-5.2-8.9L221.1 112l.4-.2L323 66.8l26.2-11.6 14.4 24.8 51.7 88.6 48.6 27.7 27.8 15.9-31.8 55.6-27.8-15.9-56-32-7.4-4.3zM289.8 391l-57.1-29.7 46.2-69.2-76.5-76.5c-14.8-14.8-20.5-34.3-18.3-52.8l103.8 47.8 54.8 54.8 18.6 18.6-14.6 21.8L289.8 391z']
      
    ]
  };

  
    var faSkiing = faPersonSkiing;
  

  
  

  var faZ = {
    prefix: 'fasds',
    iconName: 'z',
    icon: [
      384,
      512,
      [122],
      '5a',
      
      ['M384 32l0 43.6-7.4 8.9L100.3 416 352 416l32 0 0 64-32 0L32 480 0 480l0-43.6 7.4-8.9L283.7 96 32 96 0 96 0 32l32 0 320 0 32 0z','']
      
    ]
  };

  

  
  

  var faPinball = {
    prefix: 'fasds',
    iconName: 'pinball',
    icon: [
      448,
      512,
      [],
      'e229',
      
      ['M256 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M66.3 379.3c-12.1-3.9-22.8-10-32-17.7c-40.6-34.1-46-94.7-11.9-135.3s94.6-45.9 135.2-11.8l246 208.3-29.6 55.7L66.3 379.3zM96 320a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faFaceConfused = {
    prefix: 'fasds',
    iconName: 'face-confused',
    icon: [
      512,
      512,
      [],
      'e36d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM137.5 381.5l12.5-10 1.1-.9C205 327.5 272 304 341 304l11 0 16 0 0 32-16 0-11 0c-61.8 0-121.7 21-169.9 59.6l-1.1 .9-12.5 10-20-25zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faDemocrat = {
    prefix: 'fasds',
    iconName: 'democrat',
    icon: [
      640,
      512,
      [],
      'f747',
      
      ['M192 320c117.4 0 234.7 0 352 0l0 32 0 64 0 96-96 0 0-96-160 0 0 96-96 0 0-96 0-64 0-32z','M64 32C64 12.1 80 0 80 0l48 45.7L176 0s16 12.1 16 32c0 26.5-21.9 42-29.5 46.6L248 160l232 0 64 0 14.3 0 9.5 10.6 72 80-47.6 42.8-49.4-54.9L544 240l0 80-352 0L144 208 72 256 0 184 87.6 74.6C78.1 67.4 64 53.2 64 32zM269.3 234.7L256.1 208 243 234.7l-30.2 3.9 22.1 20.4L229.4 288l26.8-14.1L282.9 288l-5.5-29.1 22.1-20.4-30.2-3.9zM368.1 208L355 234.7l-30.2 3.9 22.1 20.4L341.4 288l26.8-14.1L394.9 288l-5.5-29.1 22.1-20.4-30.2-3.9L368.1 208zm125.1 26.7L480.1 208 467 234.7l-30.2 3.9 22.1 20.4L453.4 288l26.8-14.1L506.9 288l-5.5-29.1 22.1-20.4-30.2-3.9z']
      
    ]
  };

  

  
  

  var faLinkSimpleSlash = {
    prefix: 'fasds',
    iconName: 'link-simple-slash',
    icon: [
      640,
      512,
      [],
      'e1ce',
      
      ['M32 256c0 88.4 71.6 160 160 160l64 0 32 0 0-64-32 0-64 0c-53 0-96-43-96-96c0-24.9 9.5-47.6 25-64.6L70.7 151.7C46.6 179.7 32 216.1 32 256zM157.7 99.7c25.9 20.1 51.8 40.2 77.7 60.3l20.6 0 32 0 0-64-32 0-64 0c-11.8 0-23.2 1.3-34.3 3.7zM317.9 224c27.5 21.3 55 42.7 82.4 64l15.7 0 32 0 0-64-32 0-98.1 0zM352 96l0 64 32 0 64 0c53 0 96 43 96 96c0 42.9-28.2 79.3-67 91.5c18.8 14.6 37.6 29.2 56.4 43.8C578.2 363 608 313 608 256c0-88.4-71.6-160-160-160l-64 0-32 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faPickaxe = {
    prefix: 'fasds',
    iconName: 'pickaxe',
    icon: [
      512,
      512,
      [],
      'e5bf',
      
      ['M0 472l40 40L357.6 205.9c-7.8-8.9-16.1-17.8-24.9-26.6c-2.2-2.2-4.4-4.4-6.6-6.5s-4.4-4.2-6.6-6.3c-4.4-4.2-8.9-8.2-13.3-12.1L0 472zM402.8 54c20.9 15.7 39.5 34.3 55.2 55.2L480 88 424 32 402.8 54z','M462.4 373.5s0 0 0 0s0 0 0 0s0 0 0 0l14.3 38.8L492.2 374C505 342.5 512 308 512 272C512 121.8 390.2 0 240 0c-36 0-70.5 7-102 19.8L99.6 35.3l38.8 14.3s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l.2 .1 .8 .3c.7 .3 1.8 .7 3.3 1.3c2.9 1.2 7.2 3 12.7 5.5c11 5 26.7 12.6 45.3 23.1c37.3 21 86 53.6 132 99.5s78.5 94.7 99.5 132c10.5 18.6 18.1 34.3 23.1 45.3c2.5 5.5 4.3 9.8 5.5 12.7c.6 1.4 1 2.5 1.3 3.3l.3 .8 .1 .2z']
      
    ]
  };

  

  
  

  var faTicketsSimple = {
    prefix: 'fasds',
    iconName: 'tickets-simple',
    icon: [
      640,
      512,
      [],
      'e659',
      
      ['M96 32l544 0 0 128c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 128L96 384l0-128c26.5 0 48-21.5 48-48s-21.5-48-48-48L96 32z','M48 96l0 24 0 312 472 0 24 0 0 48-24 0L24 480 0 480l0-24L0 120 0 96l48 0z']
      
    ]
  };

  

  
  

  var faCommentsDollar = {
    prefix: 'fasds',
    iconName: 'comments-dollar',
    icon: [
      640,
      512,
      [],
      'f653',
      
      ['M0 176c0 37.5 13.9 72.3 37.6 100.9L0 352l108.1-21.6C137.7 344.2 171.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zm134.7 72.7c4.2-12.6 8.4-25.3 12.6-38c6.3 2.1 12.6 4.2 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1c0-2 0-4 0-6c0-6.7 0-13.3 0-20l40 0c0 6.7 0 13.3 0 20c0 2.1 0 4.2 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4c6.4 1.7 12.9 3.4 19.3 5.1c-3.4 12.9-6.9 25.8-10.3 38.7c-6.4-1.7-12.9-3.4-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6c0 1.8 0 3.7 0 5.5c0 6.7 0 13.3 0 20l-40 0c0-6.7 0-13.3 0-20c0-2.1 0-4.3 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c-1.7-.6-3.2-1.1-4.4-1.5c-6.3-2.1-12.6-4.2-19-6.3z','M228 80l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0s0 0 0 0s0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3zm220 96c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c36.2 0 70.3-7.8 99.9-21.6L640 512l-37.6-75.1C626.1 408.3 640 373.5 640 336c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z']
      
    ]
  };

  

  
  

  var faFaceHushed = {
    prefix: 'fasds',
    iconName: 'face-hushed',
    icon: [
      512,
      512,
      [],
      'e37b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm89.4-80.8c3.9-3.6 7.8-7.3 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0c0 10.7 0 21.3 0 32l-16 0c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2zm55.2 77.5c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6zM304 384a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm0-256l16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9l-16 0c0-10.7 0-21.3 0-32zm.5 124.7c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6z','M192 160c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 175.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 160.9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z']
      
    ]
  };

  

  
  

  var faPersonSnowmobiling = {
    prefix: 'fasds',
    iconName: 'person-snowmobiling',
    icon: [
      640,
      512,
      ["snowmobile"],
      'f7d1',
      
      ['M0 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 416c-26.5 0-48 21.5-48 48zM106.7 220.6c-11.4 21.6-9.4 47.8 5.3 67.4l152 0-72-32 32-48 48 48 40 0 48-64-56 0-80-72-64 0L106.7 220.6zM192 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM416 464l0 48 24 0 128 0 9.9 0 7-7 32-32 17-17L600 422.1l-17 17-25 25L546 464l-46-61.3L480 416l-30 0 36 48-46 0-24 0z','M373.5 85.3L362.7 63.8 319.8 85.3l10.7 21.5 37.4 74.7L288 288 80 288 31.1 385.8c5.4-1.2 11.1-1.8 16.9-1.8l224 0c26.2 0 49.4 12.6 64 32l144 0 96-64 0-96L419.8 177.9 373.5 85.3z']
      
    ]
  };

  
    var faSnowmobile = faPersonSnowmobiling;
  

  
  

  var faChurch = {
    prefix: 'fasds',
    iconName: 'church',
    icon: [
      640,
      512,
      [9962],
      'f51d',
      
      ['M0 352L0 512l160 0 0-240L0 352zm480-80l0 240 160 0 0-160L480 272z','M344 0l0 24 0 24 32 0 24 0 0 48-24 0-32 0 0 46.4L480 224l0 288-96 0 0-96c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 96-96 0 0-288 136-81.6L296 96l-32 0-24 0 0-48 24 0 32 0 0-24 0-24 48 0z']
      
    ]
  };

  

  
  

  var faTableCellsColumnLock = {
    prefix: 'fasds',
    iconName: 'table-cells-column-lock',
    icon: [
      640,
      512,
      [],
      'e678',
      
      ['M0 32L0 480l384 0 0-64-24 0 0-64 24 0 0-64-24 0 0-64 66.8 0c15.8-33.2 47.5-57.5 85.2-62.9L512 32 0 32zM208 96l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64zm0 128l88 0 0 64-88 0 0-64zM360 96l88 0 0 64-88 0 0-64z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faCalendarLinesPen = {
    prefix: 'fasds',
    iconName: 'calendar-lines-pen',
    icon: [
      576,
      512,
      [],
      'e472',
      
      ['M0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0l0 64L0 64zM0 192L0 512l253.4 0L267 417.4l181-181 0-44.4L0 192zm96 80l192 0 0 48L96 320l0-48zm0 96l128 0 0 48L96 416l0-48z','M576 294.8l-71-71-41.3 41.3 71 71L576 294.8zm-63.9 63.9l-71-71L299.9 429 288 511.9 370.9 500 512.1 358.7z']
      
    ]
  };

  

  
  

  var faGlassCitrus = {
    prefix: 'fasds',
    iconName: 'glass-citrus',
    icon: [
      512,
      512,
      [],
      'f869',
      
      ['M0 128l6.7 64L40 512l272 0c7.9-75.9 15.8-151.7 23.7-227.6l6.7-64.5c1-9.3 1.9-18.6 2.9-27.8l6.7-64-62.4 0-1.9 0-62.8 0L64.3 128 0 128zm71 64l210 0c-2.2 21.3-4.4 42.7-6.7 64c-6.7 64-13.3 128-20 192L97.7 448l-20-192c-2.2-21.3-4.4-42.7-6.7-64z','M368 224c44.2 0 80-35.8 80-80s-35.8-80-80-80c-38.7 0-71 27.5-78.4 64l-64.7 0c8-72 69-128 143.1-128c79.5 0 144 64.5 144 144s-64.5 144-144 144c-11.1 0-21.9-1.3-32.3-3.6l6.7-64.5c8 2.7 16.6 4.2 25.6 4.2zM97.7 448l-20-192 196.6 0-20 192L97.7 448z']
      
    ]
  };

  

  
  

  var faItalic = {
    prefix: 'fasds',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      ['M128 32l32 0 192 0 32 0 0 64-32 0-58.7 0L160 416l64 0 32 0 0 64-32 0L32 480 0 480l0-64 32 0 58.7 0L224 96l-64 0-32 0 0-64z','']
      
    ]
  };

  

  
  

  var faCediSign = {
    prefix: 'fasds',
    iconName: 'cedi-sign',
    icon: [
      384,
      512,
      [],
      'e0df',
      
      ['M192 0l64 0 0 32 0 34.7c-5.2-.9-10.5-1.5-15.8-2c-2.7-.2-5.4-.4-8-.5c-1.3-.1-2.7-.1-4.1-.1s-2.7 0-4.1 0c-10.9 0-21.6 .9-32 2.7L192 32l0-32zm0 132c5.1-1.3 10.3-2.3 15.7-3c2.7-.3 5.4-.6 8.1-.8c1.4-.1 2.7-.2 4.1-.2s2.7-.1 4.1-.1c11 0 21.8 1.4 32 4L256 380c-5.1 1.3-10.4 2.3-15.7 3c-2.7 .3-5.4 .6-8.1 .8c-1.4 .1-2.7 .2-4.1 .2s-2.7 .1-4.1 .1c-11 0-21.8-1.4-32-4L192 132zm0 313.3c5.2 .9 10.5 1.5 15.8 2c2.7 .2 5.4 .4 8.1 .5c1.3 .1 2.7 .1 4.1 .1s2.7 0 4.1 0c10.9 0 21.6-.9 32-2.7l0 34.7 0 32-64 0 0-32 0-34.7z','M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c41.9 0 79-20.1 102.4-51.2l51.2 38.4C342.6 417.8 286.8 448 224 448C118 448 32 362 32 256S118 64 224 64c62.8 0 118.6 30.2 153.6 76.8l-51.2 38.4C303 148.1 265.9 128 224 128z']
      
    ]
  };

  

  
  

  var faCouch = {
    prefix: 'fasds',
    iconName: 'couch',
    icon: [
      640,
      512,
      [],
      'f4b8',
      
      ['M64 32l0 192 32 0 0 128 448 0 0-128 32 0 0-192L64 32z','M96 224L0 224 0 480l96 0 0-32 448 0 0 32 96 0 0-256-96 0 0 128L96 352l0-128z']
      
    ]
  };

  

  
  

  var faMartiniGlassEmpty = {
    prefix: 'fasds',
    iconName: 'martini-glass-empty',
    icon: [
      512,
      512,
      ["glass-martini"],
      'f000',
      
      ['M0 48L16 64 210.7 258.7 224 272l0 176-64 0-32 0 0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-176 13.3-13.3L496 64l16-16 0-48L448 0 64 0 0 0 0 48zM106.5 64l299 0L256 213.5 106.5 64z','']
      
    ]
  };

  
    var faGlassMartini = faMartiniGlassEmpty;
  

  
  

  var faMemo = {
    prefix: 'fasds',
    iconName: 'memo',
    icon: [
      384,
      512,
      [],
      'e1d8',
      
      ['M0 0L0 512l384 0L384 0 0 0zM64 128l16 0 224 0 16 0 0 32-16 0L80 160l-16 0 0-32zm0 96l16 0 224 0 16 0 0 32-16 0L80 256l-16 0 0-32zm0 96l16 0 128 0 16 0 0 32-16 0L80 352l-16 0 0-32z','M64 128l16 0 224 0 16 0 0 32-16 0L80 160l-16 0 0-32zm0 96l16 0 224 0 16 0 0 32-16 0L80 256l-16 0 0-32zm0 96l16 0 128 0 16 0 0 32-16 0L80 352l-16 0 0-32z']
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'fasds',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      ['M0 32H448V480H0V32z','']
      
    ]
  };

  

  
  

  var faCommentCheck = {
    prefix: 'fasds',
    iconName: 'comment-check',
    icon: [
      512,
      512,
      [],
      'f4ac',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm126.1 0L160 206.1l1 1 16 16c15.7 15.7 31.4 31.4 47 47c37-37 74-74 111-111c5.3-5.3 10.7-10.7 16-16c.3-.3 .6-.6 1-1L385.9 176c-.3 .3-.6 .6-1 1c-5.3 5.3-10.7 10.7-16 16c-42.7 42.7-85.3 85.3-128 128l-17 17-17-17-64-64c-5.3-5.3-10.7-10.7-16-16l-1-1z','M385 177L241 321l-17 17-17-17-80-80L161 207l63 63L351 143 385 177z']
      
    ]
  };

  

  
  

  var faHeartHalf = {
    prefix: 'fasds',
    iconName: 'heart-half',
    icon: [
      512,
      512,
      [],
      'e1ab',
      
      ['M256 96l0 384L472.2 263.8c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96z','M39.8 263.8L256 480V96L231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96z']
      
    ]
  };

  

  
  

  var faTicketPerforated = {
    prefix: 'fasds',
    iconName: 'ticket-perforated',
    icon: [
      640,
      512,
      [],
      'e63e',
      
      ['M0 64l640 0 0 144c-26.5 0-48 21.5-48 48s21.5 48 48 48l0 144L0 448 0 64zm416 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M416 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faFileZipper = {
    prefix: 'fasds',
    iconName: 'file-zipper',
    icon: [
      384,
      512,
      ["file-archive"],
      'f1c6',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM64 344l0 72 128 0 0-72L160 224l-64 0L64 344zM96 32l0 32 16 0 32 0 16 0 0-32-16 0-32 0L96 32zm0 64l0 32 16 0 32 0 16 0 0-32-16 0-32 0L96 96zm0 64l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0z','M384 160L224 0l0 160 160 0zM96 32l0 32 16 0 32 0 16 0 0-32-16 0-32 0L96 32zm0 64l0 32 16 0 32 0 16 0 0-32-16 0-32 0L96 96zm0 64l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zM64 416l128 0 0-72L160 224l-64 0L64 344l0 72zm48-80l32 0 16 0 0 32-16 0-32 0-16 0 0-32 16 0z']
      
    ]
  };

  
    var faFileArchive = faFileZipper;
  

  
  

  var faHouseChimneyCrack = {
    prefix: 'fasds',
    iconName: 'house-chimney-crack',
    icon: [
      576,
      512,
      ["house-damage"],
      'f6f1',
      
      ['M64 272l.1 240 166.3 0L192 448l96-80L224 256 384 368l-96 80 38.4 64 186.2 0-.5-224c-.1-5.3-.1-10.7-.1-16C437.3 210.7 362.7 149.3 288 88C213.3 149.3 138.7 210.6 64 272z','M288 0L0 240l0 32 64 0L288 88 512 272l64 0 0-32-64-53.3L512 32l-96 0 0 74.7L288 0z']
      
    ]
  };

  
    var faHouseDamage = faHouseChimneyCrack;
  

  
  

  var faHeartCircleCheck = {
    prefix: 'fasds',
    iconName: 'heart-circle-check',
    icon: [
      576,
      512,
      [],
      'e4fd',
      
      ['M0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480l23.7-23.7c-15.1-26-23.7-56.1-23.7-88.3c0-97.2 78.8-176 176-176c26.4 0 51.4 5.8 73.8 16.2c4-13 6.2-26.6 6.2-40.4C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L416 430.6l-11.3-11.3-40-40L353.4 368 376 345.4l11.3 11.3L416 385.4l60.7-60.7L488 313.4 510.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faArchway = {
    prefix: 'fasds',
    iconName: 'archway',
    icon: [
      512,
      512,
      [],
      'f557',
      
      ['M0 416l0 64 32 0 96 0 32 0 0-64 0-64c0-53 43-96 96-96s96 43 96 96l0 64 0 64 32 0 96 0 32 0 0-64-32 0 0-224L32 192l0 224L0 416zM32 96l0 64 448 0 0-64L32 96z','M32 32L0 32 0 96l32 0 448 0 32 0 0-64-32 0L32 32zM480 160L32 160l0 32 448 0 0-32z']
      
    ]
  };

  

  
  

  var faClockTwoThirty = {
    prefix: 'fasds',
    iconName: 'clock-two-thirty',
    icon: [
      512,
      512,
      [],
      'e35b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232-12.8l10.7-7.1 96-64 20-13.3 26.6 39.9c-6.7 4.4-13.3 8.9-20 13.3c-28.4 19-56.9 37.9-85.3 56.9c0 41.1 0 82.1 0 123.2c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-45.3 0-90.7 0-136c0-4.3 0-8.6 0-12.8z','M232 416l0-24 0-136 0-12.8 10.7-7.1 96-64 20-13.3 26.6 39.9-20 13.3L280 268.8 280 392l0 24-48 0z']
      
    ]
  };

  

  
  

  var faHashtagLock = {
    prefix: 'fasds',
    iconName: 'hashtag-lock',
    icon: [
      576,
      512,
      [],
      'e415',
      
      ['M3.1 384L16 384l74.2 0-16 96 64.9 0 16-96 95.1 0-16 96 64.9 0 16-96 4.9 0 0-96 11.1 0 16-96 38.5 0c14.5-14.2 32.9-24.6 53.5-29.2l5.8-34.8L432 128l-74.2 0 16-96-64.9 0-16 96-95.1 0 16-96-64.9 0-16 96L48 128l-2.2 0L35.1 192 48 192l74.2 0L100.9 320 16 320l-2.2 0L3.1 384zm162.7-64l21.3-128 95.1 0L260.9 320l-95.1 0z','M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faBorderOuter = {
    prefix: 'fasds',
    iconName: 'border-outer',
    icon: [
      448,
      512,
      [],
      'f851',
      
      ['M96 224l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64z','M384 96l0 320L64 416 64 96l320 0zM64 32L0 32 0 96 0 416l0 64 64 0 320 0 64 0 0-64 0-320 0-64-64 0L64 32z']
      
    ]
  };

  

  
  

  var faArrowsToDot = {
    prefix: 'fasds',
    iconName: 'arrows-to-dot',
    icon: [
      512,
      512,
      [],
      'e4be',
      
      ['M224 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M288 32l0-32L224 0l0 32 0 50.7-9.4-9.4L192 50.7 146.7 96l22.6 22.6 64 64L256 205.3l22.6-22.6 64-64L365.3 96 320 50.7 297.4 73.4 288 82.7 288 32zM393.4 342.6L416 365.3 461.3 320l-22.6-22.6-9.4-9.4 50.7 0 32 0 0-64-32 0-50.7 0 9.4-9.4L461.3 192 416 146.7l-22.6 22.6-64 64L306.7 256l22.6 22.6 64 64zM118.6 169.4L96 146.7 50.7 192l22.6 22.6 9.4 9.4L32 224 0 224l0 64 32 0 50.7 0-9.4 9.4L50.7 320 96 365.3l22.6-22.6 64-64L205.3 256l-22.6-22.6-64-64zM146.7 416L192 461.3l22.6-22.6 9.4-9.4 0 50.7 0 32 64 0 0-32 0-50.7 9.4 9.4L320 461.3 365.3 416l-22.6-22.6-64-64L256 306.7l-22.6 22.6-64 64L146.7 416z']
      
    ]
  };

  

  
  

  var faRestroomSimple = {
    prefix: 'fasds',
    iconName: 'restroom-simple',
    icon: [
      640,
      512,
      [],
      'e23a',
      
      ['M24 352l40 0 0 160 128 0 0-160 40 0-8-192L32 160 24 352zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM384 384l64 0 0 128 128 0 0-128 64 0L576 160l-128 0L384 384zM448 64a64 64 0 1 0 128 0A64 64 0 1 0 448 64z','M344 0l0 24 0 464 0 24-48 0 0-24 0-464 0-24 48 0z']
      
    ]
  };

  

  
  

  var faLayerGroup = {
    prefix: 'fasds',
    iconName: 'layer-group',
    icon: [
      576,
      512,
      [],
      'f5fd',
      
      ['M0 256L288 384 576 256 471.4 209.5 288 291 104.6 209.5 0 256z','M288 256L0 128 288 0 576 128 288 256zm0 163l183.4-81.5L576 384 288 512 0 384l104.6-46.5L288 419z']
      
    ]
  };

  

  
  

  var faEnvelopeCircleCheck = {
    prefix: 'fasds',
    iconName: 'envelope-circle-check',
    icon: [
      640,
      512,
      [],
      'e4e8',
      
      ['M0 64l0 80L256 320l78.4-53.9c26.1-60.2 84.9-103 154.1-105.9L512 144l0-80L0 64zM0 182.8L0 448l360.2 0C335.1 417.6 320 378.5 320 336c0-7.5 .5-14.9 1.4-22.1l-47.2 32.5L256 358.8l-18.1-12.5L0 182.8z','M496 480a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 398.6l-11.3-11.3-40-40L417.4 336 440 313.4l11.3 11.3L480 353.4l60.7-60.7L552 281.4 574.6 304l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faWave = {
    prefix: 'fasds',
    iconName: 'wave',
    icon: [
      576,
      512,
      [],
      'e65b',
      
      ['M0 410.6c35 0 66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c20.9 9.5 52 20.3 87.1 20.3s66.1-10.8 87.1-20.3c3.2-1.4 6.1-2.9 8.9-4.3c2.8 1.4 5.8 2.8 8.9 4.3c21 9.5 52 20.3 87.1 20.3l0 69.4c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.6-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.6-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.6-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 470.1 31.9 480 0 480l0-69.4z','M0 304H32c35.3 0 64-28.7 64-64C96 125.1 189.1 32 304 32c84.7 0 157.6 50.7 190 123.2l-38.6 27.1C441 168.5 421.5 160 400 160c-44.2 0-80 35.8-80 80c0 35.3 28.7 64 64 64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7l2.1-1.5 2.1 1.5c13.1 9.3 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1v74.6c-28.7 0-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2l-7.6-4.1-7.6 4.1c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2l-7.6-4.1-7.6 4.1c-4.2 2.3-9.1 4.8-14.5 7.2c-18.7 8.5-45.1 17.4-73.8 17.4s-55.1-8.9-73.8-17.4c-5.5-2.5-10.3-5-14.5-7.2L96 349.8l-7.6 4.1c-4.2 2.3-9.1 4.8-14.5 7.2C55.1 369.7 28.7 378.6 0 378.6V304z']
      
    ]
  };

  

  
  

  var faCommentMiddleTop = {
    prefix: 'fasds',
    iconName: 'comment-middle-top',
    icon: [
      512,
      512,
      [],
      'e14a',
      
      ['M320.1 102.6C430.5 125.7 512 207.1 512 304c0 114.9-114.6 208-256 208S0 418.9 0 304c0-96.9 81.5-178.3 191.9-201.4L256 0l64.1 102.6z','']
      
    ]
  };

  

  
  

  var faGridRound2 = {
    prefix: 'fasds',
    iconName: 'grid-round-2',
    icon: [
      512,
      512,
      [],
      'e5db',
      
      ['M32 384a96 96 0 1 0 192 0A96 96 0 1 0 32 384zM288 128a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M128 32a96 96 0 1 0 0 192 96 96 0 1 0 0-192zM384 288a96 96 0 1 0 0 192 96 96 0 1 0 0-192z']
      
    ]
  };

  

  
  

  var faVirus = {
    prefix: 'fasds',
    iconName: 'virus',
    icon: [
      512,
      512,
      [],
      'e074',
      
      ['M0 224l0 32 0 32 32 0 11.5 0c49.9 0 74.9 60.3 39.6 95.6L75 391.8 52.4 414.4 75 437c7.5 7.5 15.1 15.1 22.6 22.6L120.2 437l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6l0 11.5 0 32 32 0 32 0 0-32 0-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2 22.6 22.6L437 437l22.6-22.6L437 391.8l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6l11.5 0 32 0 0-32 0-32-32 0-11.5 0c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2 22.6-22.6L437 75 414.4 52.4 391.8 75l-8.2 8.2C348.3 118.4 288 93.4 288 43.5L288 32l0-32L256 0 224 0l0 32 0 11.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75 97.6 52.4 75 75 52.4 97.6 75 120.2l8.2 8.2C118.4 163.7 93.4 224 43.5 224L32 224 0 224zm272 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm56 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M224 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96z']
      
    ]
  };

  

  
  

  var faBookAtlas = {
    prefix: 'fasds',
    iconName: 'book-atlas',
    icon: [
      448,
      512,
      ["atlas"],
      'f558',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l288 0 32 0 32 0 0-64-32 0-64 0-96 0L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 96 0 64 0 32 0L448 0 416 0 384 0 96 0zM247.4 283.8c3.8-3.7 8-10 11.8-18.9c6.2-14.5 10.8-34.3 12.2-56.9l-63 0c1.5 22.6 6 42.4 12.2 56.9c3.8 8.9 8 15.2 11.8 18.9c3.7 3.7 6.2 4.2 7.4 4.2s3.7-.5 7.4-4.2zm42.7-9.9c23.2-14.2 39.9-38 44.5-65.9l-31.1 0c-1.4 24.7-6.1 47.5-13.4 65.9zm0-163.8c7.3 18.3 12 41.1 13.4 65.9l31.1 0c-4.7-27.9-21.4-51.7-44.5-65.9zM112 192a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm33.3 16c4.7 27.9 21.4 51.7 44.5 65.9c-7.3-18.3-12-41.1-13.4-65.9l-31.1 0zm31.1-32c1.4-24.7 6.1-47.5 13.4-65.9c-23.2 14.2-39.9 38-44.5 65.9l31.1 0zm56.1-75.8c-3.8 3.7-8 10-11.8 18.9c-6.2 14.5-10.8 34.3-12.2 56.9l63 0c-1.5-22.6-6-42.4-12.2-56.9c-3.8-8.9-8-15.2-11.8-18.9c-3.7-3.7-6.2-4.2-7.4-4.2s-3.7 .5-7.4 4.2z']
      
    ]
  };

  
    var faAtlas = faBookAtlas;
  

  
  

  var faTruckPlow = {
    prefix: 'fasds',
    iconName: 'truck-plow',
    icon: [
      640,
      512,
      [],
      'f7de',
      
      ['M48 400a80 80 0 1 0 160 0A80 80 0 1 0 48 400zm224 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M160 32l-32 0 0 32 0 128L0 192 0 352l26.8 0c18-37.8 56.5-64 101.2-64s83.2 26.2 101.2 64l21.6 0c18-37.8 56.5-64 101.2-64s83.2 26.2 101.2 64l58.8 0 0 16 0 8.9 4.6 7.6 48 80L581 491.9 635.9 459l-16.5-27.4L576 359.1l0-7.1 0-64 0-103.1 43.4-72.4L635.9 85 581 52.1 564.6 79.5l-48 80-4.6 7.6 0 8.9 0 112-32 0 0-96-77.9 0L315.4 47.5 306.1 32 288 32 160 32zM327.5 192L192 192l0-96 77.9 0 57.6 96z']
      
    ]
  };

  

  
  

  var faShieldHalved = {
    prefix: 'fasds',
    iconName: 'shield-halved',
    icon: [
      512,
      512,
      ["shield-alt"],
      'f3ed',
      
      ['M256.7 0c3.9 1.5 7.7 3 11.6 4.5L475.8 85 495 92.5l1.2 20.5c.4 6.3 .6 13 .6 20.1c0 49.1-9.5 115.6-37.9 180.8c-32.7 75.3-91 150-189.4 192.6c-4.2 1.8-8.5 3.7-12.7 5.5l0-512z','M256 0s0 0 0 0L244.4 4.5 36.9 85 17.8 92.5 16.6 113c-2.9 49.9 4.9 126.3 37.3 200.9c32.7 75.3 91 150 189.4 192.6L256 512s0 0 0 0L256 0z']
      
    ]
  };

  
    var faShieldAlt = faShieldHalved;
  

  
  

  var faFaceConfounded = {
    prefix: 'fasds',
    iconName: 'face-confounded',
    icon: [
      512,
      512,
      [],
      'e36c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM106.5 391.2l14.3-28.6 14.3 7.2 23.7 11.8 40.3-26.8 8.9-5.9 8.9 5.9L256 380.8l39.1-26.1 8.9-5.9 8.9 5.9 40.3 26.8 23.7-11.8 14.3-7.2 14.3 28.6-14.3 7.2-32 16-8.3 4.2-7.7-5.2L304 387.2l-39.1 26.1-8.9 5.9-8.9-5.9L208 387.2l-39.1 26.1-7.7 5.2-8.3-4.2-32-16-14.3-7.2zM112 192l118.9 64L112 320l45.7-64L112 192zm169.1 64L400 192l-45.7 64L400 320 281.1 256z','M230.9 256L112 192l45.7 64L112 320l118.9-64zm50.3 0L400 320l-45.7-64L400 192 281.1 256z']
      
    ]
  };

  

  
  

  var faPalletBox = {
    prefix: 'fasds',
    iconName: 'pallet-box',
    icon: [
      640,
      512,
      [],
      'e208',
      
      ['M0 320l0 64 32 0 32 0 0 64-32 0L0 448l0 64 32 0 64 0 224 0 224 0 64 0 32 0 0-64-32 0-32 0 0-64 32 0 32 0 0-64-32 0-64 0-224 0L96 320l-64 0L0 320zm128 64l160 0 0 64-160 0 0-64zM256 0l0 128 64-48 64 48L384 0 256 0zm96 384l160 0 0 64-160 0 0-64z','M256 0L128 0l0 256 384 0L512 0 384 0l0 128L320 80l-64 48L256 0z']
      
    ]
  };

  

  
  

  var faGreaterThanEqual = {
    prefix: 'fasds',
    iconName: 'greater-than-equal',
    icon: [
      448,
      512,
      [],
      'f532',
      
      ['M32 32.9l2.7 1 360 128 21.3 7.6 0 45.2-21.3 7.6-360 128-2.7 1 0-67.9L288.5 192 32 100.8l0-67.9z','M448 416l-32 0L32 416 0 416l0 64 32 0 384 0 32 0 0-64z']
      
    ]
  };

  

  
  

  var faSquareArrowUp = {
    prefix: 'fasds',
    iconName: 'square-arrow-up',
    icon: [
      448,
      512,
      ["arrow-square-up"],
      'f33c',
      
      ['M0 32L0 480l448 0 0-448L0 32zM78.1 248c5.7-5.7 11.3-11.3 17-17L207 119l17-17 17 17c37.3 37.3 74.7 74.7 112 112c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-23.7-23.7-47.4-47.4-71-71c0 60.7 0 121.4 0 182.1c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-60.7 0-121.4 0-182.1c-23.7 23.7-47.4 47.4-71 71c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9z','M224 102.1l17 17L353 231l17 17L336 281.9l-17-17-71-71L248 376l0 24-48 0 0-24 0-182.1-71 71-17 17L78.1 248l17-17L207 119l17-17z']
      
    ]
  };

  
    var faArrowSquareUp = faSquareArrowUp;
  

  
  

  var faBurgerSoda = {
    prefix: 'fasds',
    iconName: 'burger-soda',
    icon: [
      640,
      512,
      [],
      'f858',
      
      ['M0 128l0 64 32 0 301.1 0c14.5-8.5 31.3-16 50.9-21.6l0-42.4-32 0-127.8 0L243 48l37 0 24 0 0-48L280 0 224 0 205 0l-4.4 18.5L174.9 128 32 128 0 128zm40 96L64 512l192 0 0-229.4c3-9.1 6.7-17.5 11.6-25.9c5.4-9.3 13.4-20.8 24.8-32.7L40 224z','M640 319.8l0-32s-32-96-176-96s-176 96-176 96l0 32 352 0zm-272-64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 160l352 0 0-64-352 0 0 64zm0 96l352 0 0-64-352 0 0 64z']
      
    ]
  };

  

  
  

  var faCabinetFiling = {
    prefix: 'fasds',
    iconName: 'cabinet-filing',
    icon: [
      448,
      512,
      [128452],
      'f64b',
      
      ['M0 0L448 0l0 240L0 240 0 0zM0 272l448 0 0 240L0 512 0 272zM128 96l0 16 0 16 0 16 0 16 16 0 16 0 0-16 0-16 128 0 0 16 0 16 16 0 16 0 0-16 0-16 0-16 0-16-16 0-16 0L160 96l-16 0-16 0zm0 256l0 16 0 16 0 16 0 16 32 0 0-16 0-16 128 0 0 16 0 16 16 0 16 0 0-16 0-16 0-16 0-16-16 0-16 0-144 0-16 0z','M144 96l-16 0 0 16 0 32 0 16 32 0 0-16 0-16 128 0 0 16 0 16 32 0 0-16 0-32 0-16-16 0L144 96zm0 256l-16 0 0 16 0 32 0 16 32 0 0-16 0-16 128 0 0 16 0 16 32 0 0-16 0-32 0-16-16 0-160 0zM0 272l448 0 0-32L0 240l0 32z']
      
    ]
  };

  

  
  

  var faListDropdown = {
    prefix: 'fasds',
    iconName: 'list-dropdown',
    icon: [
      512,
      512,
      [],
      'e1cf',
      
      ['M104 232l0 48 24 0 256 0 24 0 0-48-24 0-256 0-24 0zm0 88l0 48 24 0 256 0 24 0 0-48-24 0-256 0-24 0z','M0 32l512 0 0 448L0 480 0 32zM64 192l0 224 384 0 0-224L64 192zm336-48l48-48-96 0 48 48z']
      
    ]
  };

  

  
  

  var faWatchCalculator = {
    prefix: 'fasds',
    iconName: 'watch-calculator',
    icon: [
      384,
      512,
      [],
      'f8f0',
      
      ['M0 64l64 0 256 0 64 0 0 384-64 0L64 448 0 448 0 64zm64 64l0 64 256 0 0-64L64 128zm0 120l0 48 48 0 0-48-48 0zm0 88l0 48 48 0 0-48-48 0zm104-88l0 48 48 0 0-48-48 0zm0 88l0 48 48 0 0-48-48 0zm104-88l0 48 48 0 0-48-48 0zm0 88l0 48 48 0 0-48-48 0z','M64 0L320 0l0 64L64 64 64 0zm48 248l0 48-48 0 0-48 48 0zm104 0l0 48-48 0 0-48 48 0zm56 0l48 0 0 48-48 0 0-48zM112 336l0 48-48 0 0-48 48 0zm56 0l48 0 0 48-48 0 0-48zm152 0l0 48-48 0 0-48 48 0zm0 176L64 512l0-64 256 0 0 64z']
      
    ]
  };

  

  
  

  var faWatchApple = {
    prefix: 'fasds',
    iconName: 'watch-apple',
    icon: [
      384,
      512,
      [],
      'e2cb',
      
      ['M0 64l64 0 256 0 64 0 0 384-64 0L64 448 0 448 0 64zM64 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm42.7-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm42.7-96a42.7 42.7 0 1 0 85.3 0 42.7 42.7 0 1 0 -85.3 0zm64-96c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4c2.9-2.9 5.2-6.3 6.9-10.2c.8-1.9 1.4-3.9 1.9-6c.2-1 .4-2.1 .5-3.2c.1-.6 .1-1.1 .1-1.6c0-.5 0-1 0-1.5c0-.8 0-1.3 0-1.8s-.1-1.1-.1-1.6c-.1-1.1-.3-2.1-.5-3.2c-.4-2.1-1.1-4.1-1.9-6c-1.6-3.8-4-7.3-6.9-10.2c-5.8-5.8-13.8-9.4-22.6-9.4c-17.7 0-32 14.3-32 32zm0 192c0 17.7 14.3 32 32 32c8.8 0 16.8-3.6 22.6-9.4c2.9-2.9 5.2-6.3 6.9-10.2c.8-1.9 1.4-3.9 1.9-6c.2-1 .4-2.1 .5-3.2c.1-.6 .1-1.1 .1-1.6c0-.5 0-1 0-1.5c0-.8 0-1.3 0-1.8s-.1-1.1-.1-1.6c-.1-1.1-.3-2.1-.5-3.2c-.4-2.1-1.1-4.1-1.9-6c-1.6-3.8-4-7.3-6.9-10.2c-5.8-5.8-13.8-9.4-22.6-9.4c-17.7 0-32 14.3-32 32zM256 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M64 0L320 0l0 64L64 64 64 0zM213.3 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 512L64 512l0-64 256 0 0 64z']
      
    ]
  };

  

  
  

  var faCruzeiroSign = {
    prefix: 'fasds',
    iconName: 'cruzeiro-sign',
    icon: [
      448,
      512,
      [],
      'e152',
      
      ['M192 224l0 94.6 0 1.4 0 82.7c19.6 8.6 41.2 13.3 64 13.3l0-96 0-1.4c0-16.9 13.7-30.6 30.6-30.6c5.6 0 11 1.5 15.8 4.4l25.1 15.1 32.9-54.9-25.1-15.1c-14.7-8.8-31.5-13.5-48.7-13.5c-10.7 0-21 1.8-30.6 5.1l0-5.1-64 0z','M256 96C167.6 96 96 167.6 96 256s71.6 160 160 160c47.8 0 90.6-20.9 120-54.2l48 42.4C383 450.6 322.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c66.9 0 127 29.4 168 75.8l-48 42.4C346.6 116.9 303.8 96 256 96z']
      
    ]
  };

  

  
  

  var faShelvesEmpty = {
    prefix: 'fasds',
    iconName: 'shelves-empty',
    icon: [
      640,
      512,
      [],
      'e246',
      
      ['M64 32L64 0 0 0 0 32 0 160l0 32 0 32L0 416l0 32 0 32 0 32 64 0 0-32 512 0 0 32 64 0 0-32 0-32 0-32 0-192 0-32 0-32 0-128 0-32L576 0l0 32 0 128L64 160 64 32zm0 192l512 0 0 192L64 416l0-192z','']
      
    ]
  };

  

  
  

  var faGarageOpen = {
    prefix: 'fasds',
    iconName: 'garage-open',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      ['M160 363.5l0 4.5 0 24 0 24 0 64 0 32 64 0 0-32 0-16 192 0 0 16 0 32 64 0 0-32 0-64 0-24 0-25.8 0-4.5-1.7-4.2L463.7 320l-51.5 0 6.3 16L222 336l6.2-16-51.4 0-15.1 39.4-1.6 4.2zM264 400a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm160 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M0 512L0 128 320 0 640 128l0 384-96 0 0-320L96 192l0 320L0 512zM512 288l-384 0 0-64 384 0 0 64z']
      
    ]
  };

  

  
  

  var faMagnifyingGlassArrowsRotate = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e65e',
      
      ['M2.4 176l65.1 0C82.1 111.9 139.5 64 208 64c35.7 0 68.4 13 93.5 34.5c15.1-15.1 30.2-30.2 45.3-45.4C310 20.1 261.4 0 208 0C104 0 17.8 76.3 2.4 176zM69.1 362.9C106 395.9 154.6 416 208 416c45.9 0 88.3-14.9 122.7-40L441.4 486.6 464 509.3 509.3 464l-22.6-22.6L376 330.7c19.2-26.2 32.4-57.2 37.6-90.7l-65.1 0C333.9 304.1 276.5 352 208 352c-35.7 0-68.4-13-93.5-34.5L69.1 362.9z','M248 152l24 24 144 0 0-144L392 8 248 152zM168 264l-24-24L0 240 0 384l24 24L168 264z']
      
    ]
  };

  

  
  

  var faFireExtinguisher = {
    prefix: 'fasds',
    iconName: 'fire-extinguisher',
    icon: [
      512,
      512,
      [129519],
      'f134',
      
      ['M2.5 159.5C26.7 109.8 72.7 72.6 128 60.4c0 16.5 0 33.1 0 49.6c-36.2 11.1-66 36.9-82.3 70.5l-43.1-21zM64 416l224 0 0 96L64 512c0-32 0-64 0-96zM224 56l64 0 0 48-64 0 0-48z','M512 160L512 0 288 32l0 96 224 32zM224 0L128 0l0 138.8c-37.8 18-64 56.5-64 101.2l0 176 224 0 0-176c0-44.7-26.2-83.2-64-101.2L224 0zM176 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faArrowsToDottedLine = {
    prefix: 'fasds',
    iconName: 'arrows-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e0a6',
      
      ['M0 224l64 0 0 64L0 288l0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M256 0l0 32 0 32 64 0 0 32-96 96L128 96l0-32 64 0 0-32 0-32 64 0zm0 448l0 32 0 32-64 0 0-32 0-32-64 0 0-32 96-96 96 96 0 32-64 0z']
      
    ]
  };

  

  
  

  var faCircleBookOpen = {
    prefix: 'fasds',
    iconName: 'circle-book-open',
    icon: [
      512,
      512,
      ["book-circle"],
      'e0ff',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-80s28.2-16 56-16s56 16 56 16l0 176s-28.2-16-56-16s-56 16-56 16l0-176zm144 0s28.2-16 56-16s56 16 56 16l0 176s-28.2-16-56-16s-56 16-56 16l0-176z','M240 352s-28.2-16-56-16s-56 16-56 16l0-176s28.2-16 56-16s56 16 56 16l0 176zm144 0s-28.2-16-56-16s-56 16-56 16l0-176s28.2-16 56-16s56 16 56 16l0 176z']
      
    ]
  };

  
    var faBookCircle = faCircleBookOpen;
  

  
  

  var faArrowsRotate = {
    prefix: 'fasds',
    iconName: 'arrows-rotate',
    icon: [
      512,
      512,
      [128472,"refresh","sync"],
      'f021',
      
      ['M16 288l0 32 0 128 0 32 64 0 0-32 0-51.1 17.6 17.5c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7l-60.4-21.3c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0c-5.8-5.8-11.5-11.4-17.2-17.1l50.4 0 32 0 0-64-32 0L48 288l-32 0z','M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 336 160l-32 0 0 64 32 0 128 0 32 0 0-32 0-128 0-32-64 0 0 32 0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4l60.4 21.3z']
      
    ]
  };

  
    var faRefresh = faArrowsRotate;
  
    var faSync = faArrowsRotate;
  

  
  

  var faBorderTop = {
    prefix: 'fasds',
    iconName: 'border-top',
    icon: [
      448,
      512,
      [],
      'f855',
      
      ['M0 128l0 64 64 0 0-64L0 128zm0 96l0 64 64 0 0-64L0 224zm0 96l0 64 64 0 0-64L0 320zm0 96l0 64 64 0 0-64L0 416zM96 224l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm96-288l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm96-192l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm96-288l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M0 32H448V96H0V32z']
      
    ]
  };

  

  
  

  var faMugTea = {
    prefix: 'fasds',
    iconName: 'mug-tea',
    icon: [
      576,
      512,
      [],
      'f875',
      
      ['M96 176l0 112 128 0 0-112-48-48 0-64-32 0 0 64L96 176z','M144 64l0 64L96 176l0 112 128 0 0-112-48-48 0-64 208 0 32 0 32 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-32 0 0 128L32 448 32 64l112 0zM416 256l32 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0 0 128z']
      
    ]
  };

  

  
  

  var faBurgerFries = {
    prefix: 'fasds',
    iconName: 'burger-fries',
    icon: [
      640,
      512,
      [],
      'e0cd',
      
      ['M0 80L18.7 192l41.1 0L41.8 90.5 0 80zM0 224L64 512l192 0 0-208L96 304 64 224 0 224zM64 32L97.4 221.4 117.7 272l10.3 0 0-181.3L112 0 64 32zM160 0l0 272 64 0 0-32 0-208L160 0zm96 48l0 224 4 0c2.2-5.2 4.7-10.3 7.6-15.3c3.1-5.3 7-11.3 11.9-17.7l10.2-25.5L320 32 256 48zm69.8 144l7.3 0c10.4-6.1 22-11.7 35-16.5L384 80 342.7 90.3 325.8 192z','M640 319.8l0-32s-32-96-176-96s-176 96-176 96l0 32 352 0zm-272-64a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm96-32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm64 32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-240 160l352 0 0-64-352 0 0 64zm0 96l352 0 0-64-352 0 0 64z']
      
    ]
  };

  

  
  

  var faGuaraniSign = {
    prefix: 'fasds',
    iconName: 'guarani-sign',
    icon: [
      384,
      512,
      [],
      'e19a',
      
      ['M160 0l64 0 0 66.7c-5.2-.9-10.5-1.5-15.8-2c-2.7-.2-5.4-.4-8.1-.5c-1.3-.1-2.7-.1-4.1-.1s-2.7 0-4.1 0c-10.9 0-21.6 .9-32 2.7L160 0zm0 132c5.1-1.3 10.3-2.3 15.7-3c2.7-.3 5.4-.6 8.1-.8c1.4-.1 2.7-.2 4.1-.2s2.7-.1 4.1-.1c11.1 0 21.8 1.4 32 4l0 92 0 64 0 92c-5.1 1.3-10.4 2.3-15.7 3c-2.7 .3-5.4 .6-8.1 .8c-1.4 .1-2.7 .2-4.1 .2s-2.7 .1-4.1 .1c-11 0-21.8-1.4-32-4L160 132zm0 313.3c5.2 .9 10.5 1.5 15.8 2c2.7 .2 5.4 .4 8.1 .5c1.3 .1 2.7 .1 4.1 .1s2.7 0 4.1 0c10.9 0 21.6-.9 32-2.7l0 66.7-64 0 0-66.7z','M192 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c59.6 0 109.8-40.8 124-96l-92 0 0-64 128 0 32 0 0 32c0 106-86 192-192 192S0 362 0 256S86 64 192 64c52.3 0 99.8 21 134.4 54.9l-44.8 45.7C258.5 141.9 226.9 128 192 128z']
      
    ]
  };

  

  
  

  var faGingerbreadMan = {
    prefix: 'fasds',
    iconName: 'gingerbread-man',
    icon: [
      448,
      512,
      [],
      'f79d',
      
      ['M16 176l0 128 64 0 48 0 0 24.8-80 96L48 512l94 0 82-98.4L306 512l94 0 0-87.2-80-96 0-24.8 48 0 64 0 0-128-64 0-90.9 0C303 158.8 320 129.4 320 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L80 176l-64 0zM208 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm32 144a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 64a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM272 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M208 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm16-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faCommentQuestion = {
    prefix: 'fasds',
    iconName: 'comment-question',
    icon: [
      512,
      512,
      [],
      'e14b',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm168-72c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8c-10.8 6.2-21.5 12.3-32.3 18.5c0 2.5 0 5 0 7.6c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-7.2 0-14.3 0-21.5c0-4.6 0-9.3 0-13.9l12.1-6.9c14.8-8.5 29.6-17 44.3-25.4c2.4-1.4 4.3-3.3 5.6-5.5c.7-1.1 1.2-2.4 1.5-3.6c.2-.6 .3-1.3 .4-2c0-.3 .1-.7 .1-1s0-.6 0-1.1c0-.5 0-1-.1-1.5s-.1-1-.2-1.5c-.2-1-.5-1.9-.9-2.8c-.8-1.8-1.9-3.4-3.2-4.8c-2.7-2.7-6.5-4.4-10.7-4.4L224 160c-4.4 0-8 3.6-8 8c0 2.2 0 4.4 0 6.5l-48 0c0-2.2 0-4.4 0-6.5zm64 152l48 0c0 16 0 32 0 48l-48 0c0-16 0-32 0-48z','M224 112c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 220.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 112zm56 208l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faAlicorn = {
    prefix: 'fasds',
    iconName: 'alicorn',
    icon: [
      640,
      512,
      [],
      'f6b0',
      
      ['M0 256l0 56 0 24 48 0 0-24 0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256zM544 48l16 16 0 26.7L640 64l0-16-96 0z','M448 238.1l0-78.1 32 64 80-32 0-128L528 32l16 0 16 0 0-32L544 0 480 0 448 0C377.3 0 320 57.3 320 128L160 32s-20.2 141.7 68.1 199.7c-8.7-2.7-16.7-6.1-24.2-10.1c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43C96 134.3 64 169.8 64 212.8c0 16.8 5 33.1 14.2 47.1l42.4 63.6L94.1 350.1l-21 21 9.4 28.1L120.1 512l101.2 0L182.9 397l27-27L224 355.9l0-19.9 0-16 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8L320 512l96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faAlarmPlus = {
    prefix: 'fasds',
    iconName: 'alarm-plus',
    icon: [
      512,
      512,
      [],
      'f844',
      
      ['M32 288c0 50.3 16.6 96.8 44.6 134.2L57.4 441.4 34.7 464 80 509.3l22.6-22.6 19.2-19.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l19.2 19.2L432 509.3 477.3 464l-22.6-22.6-19.2-19.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zm112-24l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M14.9 147.2C5.5 132.3 0 114.7 0 95.8C0 42.9 42.9 0 95.8 0c25.1 0 48 9.7 65.1 25.5L14.9 147.2zm482.1 0L351.1 25.5C368.2 9.7 391.1 0 416.2 0C469.1 0 512 42.9 512 95.8c0 18.9-5.5 36.5-14.9 51.4zM280 176l0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0z']
      
    ]
  };

  

  
  

  var faMattressPillow = {
    prefix: 'fasds',
    iconName: 'mattress-pillow',
    icon: [
      640,
      512,
      [],
      'e525',
      
      ['M0 64L0 448l256 0 0-384L0 64zm64 64l128 0 0 256L64 384l0-256z','M256 64H640V448H256V64z']
      
    ]
  };

  

  
  

  var faMemoPad = {
    prefix: 'fasds',
    iconName: 'memo-pad',
    icon: [
      448,
      512,
      [],
      'e1da',
      
      ['M0 128l448 0 0 384L0 512 0 128zm96 80l0 32 16 0 224 0 16 0 0-32-16 0-224 0-16 0zm0 96l0 32 16 0 224 0 16 0 0-32-16 0-224 0-16 0zm0 96l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z','M448 128L0 128 0 0 448 0l0 128zM112 208l224 0 16 0 0 32-16 0-224 0-16 0 0-32 16 0zm0 96l224 0 16 0 0 32-16 0-224 0-16 0 0-32 16 0zm0 96l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faRabbitRunning = {
    prefix: 'fasds',
    iconName: 'rabbit-running',
    icon: [
      576,
      512,
      ["rabbit-fast"],
      'f709',
      
      ['M78.6 254.9c4.9 17.2 14.5 33.1 28.4 45.9L258.4 439.6l9.2 8.4 12.4 0 128 0 32 0 0-64-32 0-64 0-16.8 0L312 384l0-43.5c0-42.9-28.4-80.5-69.6-92.3l-30.8-8.8 8.8-30.8 30.8 8.8c55 15.7 92.8 65.9 92.8 123.1l0 15.7 56-32.4 6.4-3.7L568 320l0-88.9-71-57.9c8-48.9-7.6-99.1-42.8-135L448 32l-24 0-4.7 16.5c-3.2 11.2-5 22.5-5.6 33.8c23.5 20.8 41.5 47.4 51.9 77.7l-25.6 0c-18-44.5-55.4-79-102.1-93L328 64 296 80l7.1 19.7c13.5 37.5 39.5 68.4 72.9 88.2l0 26.8L271.7 154.9C240.8 137.3 205.8 128 170.2 128c-32.3 0-62.2 16.8-78.9 44.4l-.3 .4c-.7 1.1-1.4 2.3-2.1 3.4c-14.6 24.3-17.7 52.8-10.3 78.6zm46.7 171l35 53.6L187.1 462l28.2-18.4-48.7-44.6-14.5 9.5-26.8 17.5zM504 240a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M48 152c17.4 0 33 7.9 43.2 20.4l-.3 .4-2.1 3.4c-14.6 24.3-17.7 52.8-10.3 78.6C69.8 260.7 59.3 264 48 264c-30.9 0-56-25.1-56-56s25.1-56 56-56zm440 72a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  
    var faRabbitFast = faRabbitRunning;
  

  
  

  var faHandshakeSimpleSlash = {
    prefix: 'fasds',
    iconName: 'handshake-simple-slash',
    icon: [
      640,
      512,
      ["handshake-alt-slash"],
      'e05f',
      
      ['M0 128L0 352l156.2 0 73.9 67.4 35.4 32.4 47.7-52.2 22.3 20.5 35.4 32.4 34.2-37.3L40.6 128 0 128zm163.6-23.7c14.5 11.3 29.1 22.6 43.6 33.9L298.8 64 224 64l-60.4 40.3zm69.6 54c21.2 16.4 42.4 32.9 63.5 49.3l77.4-60.2 12.6-9.8 19.6 25.3-12.6 9.8-20.9 16.2L550.2 352l89.8 0 0-224-48 0-76 0-4 0-1.4 0-4.3-3.3L426.6 64l-76.9 0L233.2 158.3zm89.6 69.6C384.9 276.1 447 324.2 509 372.4l6.8-7.4-35.4-32.4-134.2-123-23.4 18.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faHandshakeAltSlash = faHandshakeSimpleSlash;
  

  
  

  var faCatSpace = {
    prefix: 'fasds',
    iconName: 'cat-space',
    icon: [
      640,
      512,
      [],
      'e001',
      
      ['M241.3 46.7L288 64 241.3 81.3 224 128 206.7 81.3 160 64l46.7-17.3L224 0l17.3 46.7zM288 160a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zM352 32l0 128c0 53 43 96 96 96s96-43 96-96l0-128L480 96l-64 0L352 32z','M416 96l64 0 64-64 0 128c0 53-43 96-96 96s-96-43-96-96l0-128 64 64zm0 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM160 277.8c29.4-44.3 76.8-75.6 131.6-83.8C307.3 266.1 371.3 320 448 320c11 0 21.7-1.1 32-3.2L480 480l0 32-64 0 0-32 0-140.8L280 448l56 0 32 0 0 64-32 0-208 0-32 0 0-32 0-288c0-17.7-14.3-32-32-32l-32 0 0-64 32 0c53 0 96 43 96 96l0 85.8z']
      
    ]
  };

  

  
  

  var faDrawCircle = {
    prefix: 'fasds',
    iconName: 'draw-circle',
    icon: [
      512,
      512,
      [],
      'f5ed',
      
      ['M39.9 196.7c7.4-3 15.5-4.7 24.1-4.7c1.9 0 3.8 .1 5.6 .2s3.7 .4 5.5 .7c3.6 .6 7.1 1.6 10.5 2.8c6.7 2.4 12.9 5.9 18.4 10.3C119.8 158 157.7 120 205.7 104.1c.3-.1 .3-.1 .3-.1c-4.4-5.5-7.9-11.7-10.3-18.4c-1.2-3.4-2.1-6.9-2.8-10.5c-.3-1.8-.6-3.6-.7-5.5c-.1-.9-.1-1.9-.2-2.8s-.1-1.9-.1-2.8c0-1.2 0-2.2 .1-3.2c.1-1.1 .1-2.1 .2-3.1c.2-2.1 .5-4.1 .9-6.1c.8-4 2-7.9 3.5-11.6c-76 20.8-135.9 80.7-156.7 156.7zm0 118.6c20.8 76 80.7 135.9 156.7 156.7c-1.5-3.7-2.7-7.6-3.5-11.6c-.4-2-.7-4.1-.9-6.1c-.1-1-.2-2.1-.2-3.1s-.1-2.1-.1-3.2s0-2 .1-2.8c0-.9 .1-1.9 .2-2.8c.2-1.9 .4-3.7 .7-5.5c.6-3.6 1.6-7.1 2.8-10.5c2.4-6.7 5.9-12.9 10.3-18.4C158 392.2 120 354.3 104.1 306.3C93 314.8 79.1 320 64 320c-1.1 0-2.1 0-3.2-.1s-2.1-.1-3.1-.2c-2.1-.2-4.1-.5-6.1-.9c-4-.8-7.9-2-11.6-3.5zM306.3 104.1C354.3 120 392.2 158 408 206c11-8.8 24.8-14 40-14c2.2 0 4.3 .1 6.3 .3s4.1 .5 6.1 .9c4 .8 7.9 2 11.6 3.5c-20.8-76-80.7-135.9-156.7-156.7c3 7.4 4.7 15.5 4.7 24.1c0 .5 0 1 0 1.4l0 1.4c0 .9-.1 1.9-.2 2.8c-.2 1.8-.4 3.7-.7 5.5c-.6 3.6-1.6 7.1-2.8 10.5c-2.4 6.7-5.9 12.9-10 18.5zM306 408c8.7 10.9 14 24.7 14 40c0 .5 0 1.1 0 1.6l-.1 1.6c-.1 1-.1 2.1-.2 3.1c-.2 2.1-.5 4.1-.9 6.1c-.8 4-2 7.9-3.5 11.6c75.5-20.7 135.1-79.9 156.3-155.2l.4-1.5c-7.4 3-15.6 4.7-24.1 4.7c-.9 0-1.9 0-2.8-.1s-1.9-.1-2.8-.2c-1.8-.2-3.7-.4-5.5-.7c-3.6-.6-7.1-1.6-10.5-2.8c-6.7-2.4-12.9-5.9-18.5-10C392 354.3 354 392.2 306 408z','M256 128A64 64 0 1 0 256 0a64 64 0 1 0 0 128zm0 384a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM128 256A64 64 0 1 0 0 256a64 64 0 1 0 128 0zm320 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faEnvelopeOpen = {
    prefix: 'fasds',
    iconName: 'envelope-open',
    icon: [
      512,
      512,
      [62135],
      'f2b6',
      
      ['M64 224L256 80 448 224l0 22.9L256 384 64 246.9 64 224z','M64 246.9L256 384 448 246.9l0-22.9L256 80 64 224l0 22.9zM0 192L256 0 512 192l0 256 0 64-64 0L64 512 0 512l0-64L0 192z']
      
    ]
  };

  

  
  

  var faListTree = {
    prefix: 'fasds',
    iconName: 'list-tree',
    icon: [
      512,
      512,
      [],
      'e1d2',
      
      ['M160 64l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zM288 224l32 0 160 0 32 0 0 64-32 0-160 0-32 0 0-64zm0 160l32 0 160 0 32 0 0 64-32 0-160 0-32 0 0-64z','M96 48L0 48l0 96 24 0 0 112 0 160 0 24 24 0 80 0 0 24 96 0 0-96-96 0 0 24-56 0 0-112 56 0 0 24 96 0 0-96-96 0 0 24-56 0 0-88 24 0 0-96z']
      
    ]
  };

  

  
  

  var faLollipop = {
    prefix: 'fasds',
    iconName: 'lollipop',
    icon: [
      512,
      512,
      [127853,"lollypop"],
      'e424',
      
      ['M303.2 348.5c17.5-12.5 32.8-27.8 45.3-45.3L510.6 465.4l-45.3 45.3L303.2 348.5z','M48 192c0 57.4 46.6 104 104 104l8 0c53 0 96-43 96-96l0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 48 0 0 16c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8c0 61.6-38.7 114.2-93.2 134.8C281.4 325.6 336 265.2 336 192c0-79.5-64.5-144-144-144S48 112.5 48 192zM0 192a192 192 0 1 1 384 0A192 192 0 1 1 0 192z']
      
    ]
  };

  
    var faLollypop = faLollipop;
  

  
  

  var faSignalStrong = {
    prefix: 'fasds',
    iconName: 'signal-strong',
    icon: [
      640,
      512,
      ["signal-4"],
      'f68f',
      
      ['M544 0l0 32 0 448 0 32 64 0 0-32 0-448 0-32L544 0z','M480 128l0-32-64 0 0 32 0 352 0 32 64 0 0-32 0-352zM352 224l0-32-64 0 0 32 0 256 0 32 64 0 0-32 0-256zM224 288l-64 0 0 32 0 160 0 32 64 0 0-32 0-160 0-32zM96 416l0-32-64 0 0 32 0 64 0 32 64 0 0-32 0-64z']
      
    ]
  };

  
    var faSignal4 = faSignalStrong;
  

  
  

  var faUserLargeSlash = {
    prefix: 'fasds',
    iconName: 'user-large-slash',
    icon: [
      640,
      512,
      ["user-alt-slash"],
      'f4fa',
      
      ['M64 512l512 0-48 0L284.3 320 144 320 64 512zM178.7 116L382.2 273.9C430.6 250.7 464 201.3 464 144C464 64.5 399.5 0 320 0C250.1 0 191.8 49.9 178.7 116z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faUserAltSlash = faUserLargeSlash;
  

  
  

  var faChalkboard = {
    prefix: 'fasds',
    iconName: 'chalkboard',
    icon: [
      576,
      512,
      ["blackboard"],
      'f51b',
      
      ['M0 416l0 64 32 0 512 0 32 0 0-64-32 0 0-352 0-32-32 0L64 32 32 32l0 32 0 352L0 416zM96 96l384 0 0 320-64 0-192 0L96 416 96 96z','M480 96L96 96l0 320 128 0 0-64 192 0 0 64 64 0 0-320z']
      
    ]
  };

  
    var faBlackboard = faChalkboard;
  

  
  

  var faMeterDroplet = {
    prefix: 'fasds',
    iconName: 'meter-droplet',
    icon: [
      640,
      512,
      [],
      'e1ea',
      
      ['M0 256C0 397.4 114.6 512 256 512c53.7 0 103.5-16.5 144.6-44.7C390 447.2 384 424.3 384 400l0-2.1c0-28.3 8.2-56 23.7-79.7L499.6 177C466.3 74.3 369.8 0 256 0C114.6 0 0 114.6 0 256zM128 128l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32zm96 0l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32zm96 0l64 0 0 32 0 32 0 32-64 0 0-32 0-32 0-32z','M434.5 335.6L528 192l93.5 143.6c12.1 18.5 18.5 40.2 18.5 62.3V400c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3z']
      
    ]
  };

  

  
  

  var faChildren = {
    prefix: 'fasds',
    iconName: 'children',
    icon: [
      640,
      512,
      [],
      'e4e1',
      
      ['M323.3 294.9l51.6 37.9 18.9-25.8L408 287.6 408 480l0 32 64 0 0-32 0-96 16 0 0 96 0 32 64 0 0-32 0-192.4 14.2 19.3 18.9 25.8 51.6-37.9-18.9-25.8-70.5-96L537.7 160l-16.2 0-83 0-16.2 0-9.6 13.1-70.5 96-18.9 25.8zM416 64a64 64 0 1 0 128 0A64 64 0 1 0 416 64z','M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm6.3 96l16.2 0 83 0 16.2 0 9.6 13.1 70.5 96 18.9 25.8-51.6 37.9-18.9-25.8L232 287.6l0 .4 0 2.3L264 400l-32 0 0 80 0 32-64 0 0-32 0-80-16 0 0 80 0 32-64 0 0-32 0-80-32 0L88 290.3l0-2.3 0-.4L73.8 306.9 54.9 332.7 3.3 294.9l18.9-25.8 70.5-96 9.6-13.1z']
      
    ]
  };

  

  
  

  var faWreath = {
    prefix: 'fasds',
    iconName: 'wreath',
    icon: [
      448,
      512,
      [],
      'f7e2',
      
      ['M0 182.6c0 15.8 5.7 30.2 15.2 41.4C5.7 235.2 0 249.6 0 265.4c0 27.9 17.8 51.6 42.6 60.3C40.9 331.5 40 337.7 40 344c0 35.3 28.7 64 64 64c6.3 0 12.5-.9 18.2-2.6c1.5 4.2 3.4 8.3 5.8 12.1l0-33.4 96 32 96-32 0 33.4c2.3-3.8 4.3-7.8 5.8-12.1c5.8 1.7 11.9 2.6 18.2 2.6c35.3 0 64-28.7 64-64c0-6.3-.9-12.5-2.6-18.2c24.8-8.8 42.6-32.5 42.6-60.3c0-15.8-5.7-30.2-15.2-41.4c9.5-11.2 15.2-25.6 15.2-41.4c0-27.9-17.8-51.6-42.6-60.3c1.7-5.8 2.6-11.9 2.6-18.2c0-35.3-28.7-64-64-64c-6.3 0-12.5 .9-18.2 2.6C317 17.8 293.3 0 265.4 0C249.6 0 235.2 5.7 224 15.2C212.8 5.7 198.4 0 182.6 0C154.7 0 131 17.8 122.2 42.6C116.5 40.9 110.3 40 104 40c-35.3 0-64 28.7-64 64c0 6.3 .9 12.5 2.6 18.2C17.8 131 0 154.7 0 182.6zM120 224l31.9-29.8-1.5-43.7 43.7 1.5L224 120l29.8 31.9 43.7-1.5-1.5 43.7L328 224l-31.9 29.8 1.5 43.7-43.7-1.5L224 328l-29.8-31.9-43.7 1.5 1.5-43.7L120 224z','M128 512V384l96 32 96-32V512l-96-32-96 32z']
      
    ]
  };

  

  
  

  var faCloudArrowDown = {
    prefix: 'fasds',
    iconName: 'cloud-arrow-down',
    icon: [
      640,
      512,
      [62337,"cloud-download","cloud-download-alt"],
      'f0ed',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zm206.1-40L240 262.1l17 17 39 39L296 184l0-24 48 0 0 24 0 134.1 39-39 17-17L433.9 296l-17 17-80 80-17 17-17-17-80-80-17-17z','M206.1 296l17 17 80 80 17 17 17-17 80-80 17-17L400 262.1l-17 17-39 39L344 184l0-24-48 0 0 24 0 134.1-39-39-17-17L206.1 296z']
      
    ]
  };

  
    var faCloudDownload = faCloudArrowDown;
  
    var faCloudDownloadAlt = faCloudArrowDown;
  

  
  

  var faHouseLock = {
    prefix: 'fasds',
    iconName: 'house-lock',
    icon: [
      640,
      512,
      [],
      'e510',
      
      ['M0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 128 0 0 160 32 0 0-224 32 0 0-16c0-48 30.2-89 72.7-104.9L288.4 0 0 240z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faArrowsLeftRight = {
    prefix: 'fasds',
    iconName: 'arrows-left-right',
    icon: [
      512,
      512,
      ["arrows-h"],
      'f07e',
      
      ['M256.1 223.9c0 21.3 0 42.7 0 64l130.6 0-41.4 41.4-22.6 22.6 45.3 45.3 22.6-22.6 96-96 22.6-22.6-22.6-22.6-96-96-22.6-22.6-45.3 45.3 22.6 22.6 41.4 41.4-130.6 0z','M25.4 233.3L2.8 255.9l22.6 22.6 96 96 22.6 22.6 45.3-45.3-22.6-22.6-41.4-41.4 130.7 0 0-64-130.7 0 41.4-41.4 22.6-22.6-45.3-45.3-22.6 22.6-96 96z']
      
    ]
  };

  
    var faArrowsH = faArrowsLeftRight;
  

  
  

  var faObjectsAlignCenterVertical = {
    prefix: 'fasds',
    iconName: 'objects-align-center-vertical',
    icon: [
      512,
      512,
      [],
      'e3bd',
      
      ['M64 32l160 0 0 200 0 48 0 200L64 480l0-200 0-48L64 32zM288 96l160 0 0 136 0 48 0 136-160 0 0-136 0-48 0-136z','M0 280l0-48 64 0 0 48L0 280zm224 0l0-48 64 0 0 48-64 0zm224 0l0-48 64 0 0 48-64 0z']
      
    ]
  };

  

  
  

  var faSquareDown = {
    prefix: 'fasds',
    iconName: 'square-down',
    icon: [
      448,
      512,
      [11015,"arrow-alt-square-down"],
      'f350',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 256l80 0 0-128 96 0c0 42.7 0 85.3 0 128l80 0 0 32L224 416 96 288l0-32z','M272 256l80 0 0 32L224 416 96 288l0-32 80 0 0-128 96 0 0 128z']
      
    ]
  };

  
    var faArrowAltSquareDown = faSquareDown;
  

  
  

  var faFilePowerpoint = {
    prefix: 'fasds',
    iconName: 'file-powerpoint',
    icon: [
      384,
      512,
      [],
      'f1c4',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM112 240l0 24 0 104 0 56 0 24 48 0 0-24 0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0-24 0zm48 48l44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-44 0 0-56z','M384 160L224 0l0 160 160 0zM136 240l-24 0 0 24 0 104 0 56 0 24 48 0 0-24 0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z']
      
    ]
  };

  

  
  

  var faFileWord = {
    prefix: 'fasds',
    iconName: 'file-word',
    icon: [
      384,
      512,
      [],
      'f1c2',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM57.7 240L113 430.7l5 17.3 18 0 8 0 18.4 0 4.8-17.7 24.8-92 24.8 92 4.8 17.7 18.4 0 8 0 18 0 5-17.3L326.3 240l-50 0L244.7 349.3 220 257.7 215.2 240l-18.4 0-9.6 0-18.4 0L164 257.7l-24.7 91.5L107.6 240l-50 0z','M384 160L224 0l0 160 160 0zM107.6 240l-50 0L113 430.7l5 17.3 18 0 8 0 18.4 0 4.8-17.7 24.8-92 24.8 92 4.8 17.7 18.4 0 8 0 18 0 5-17.3L326.3 240l-50 0L244.7 349.3 220 257.7 215.2 240l-18.4 0-9.6 0-18.4 0L164 257.7l-24.7 91.5L107.6 240z']
      
    ]
  };

  

  
  

  var faLeft = {
    prefix: 'fasds',
    iconName: 'left',
    icon: [
      448,
      512,
      ["arrow-alt-left"],
      'f355',
      
      ['M224 192l224 0 0 128-224 0 0-128z','M224 64l-32 0L0 256 192 448l32 0 0-128 0-128 0-128z']
      
    ]
  };

  
    var faArrowAltLeft = faLeft;
  

  
  

  var faWavesSine = {
    prefix: 'fasds',
    iconName: 'waves-sine',
    icon: [
      640,
      512,
      [],
      'e65d',
      
      ['M0 416l0 64 32 0c56.7 0 93.7-34.4 118.6-75.4c9.5-15.7 17.9-33.3 25.4-51.7c-11.3-27.6-20.8-57-29.7-84.8l-.7-2.3c-1.1-3.3-2.1-6.6-3.2-9.8c-14.6 45.1-28.3 85.4-46.5 115.4C77 402.4 57.4 416 32 416L0 416zM176 159.1c11.3 27.6 20.8 57 29.7 84.8l.7 2.3c1.1 3.3 2.1 6.6 3.2 9.8c14.6-45.1 28.3-85.4 46.5-115.4C275 109.6 294.6 96 320 96s45 13.6 63.8 44.6c18.2 30 31.9 70.3 46.5 115.4c1 3.2 2.1 6.5 3.2 9.8l.7 2.3c8.9 27.8 18.4 57.2 29.7 84.8c7.5 18.4 15.9 36 25.4 51.7c24.9 41 61.8 75.4 118.6 75.4l32 0 0-64-32 0c-25.4 0-45-13.6-63.8-44.6c-18.2-30-31.9-70.3-46.5-115.4c-1-3.2-2.1-6.5-3.2-9.8l-.7-2.3c-8.9-27.8-18.4-57.2-29.7-84.8c-7.5-18.4-15.9-36-25.4-51.7C413.7 66.4 376.7 32 320 32s-93.7 34.4-118.6 75.4c-9.5 15.7-17.9 33.3-25.4 51.7z','M320 480c-56.7 0-93.7-34.4-118.6-75.4c-23.8-39.2-40.3-90.2-55.2-136.5c0 0 0 0 0 0l-.7-2.3c-15.8-49.1-30.2-93.1-49.7-125.2C77 109.6 57.4 96 32 96L0 96 0 32l32 0c56.7 0 93.7 34.4 118.6 75.4c23.8 39.2 40.3 90.2 55.2 136.5l.7 2.3c15.8 49.1 30.2 93.1 49.7 125.2C275 402.4 294.6 416 320 416s45-13.6 63.8-44.6c18.2-30 31.9-70.3 46.5-115.4c1 3.2 2.1 6.5 3.2 9.8l.7 2.3c8.9 27.8 18.4 57.2 29.7 84.8c-7.5 18.4-15.9 36-25.4 51.7C413.7 445.6 376.7 480 320 480zM497.6 256c-1-3.2-2.1-6.5-3.2-9.8l-.7-2.3c-8.9-27.8-18.4-57.2-29.7-84.8c7.5-18.4 15.9-36 25.4-51.7C514.3 66.4 551.3 32 608 32l32 0 0 64-32 0c-25.4 0-45 13.6-63.8 44.6c-18.2 30-31.9 70.3-46.5 115.4z']
      
    ]
  };

  

  
  

  var faCircle6 = {
    prefix: 'fasds',
    iconName: 'circle-6',
    icon: [
      512,
      512,
      [],
      'e0f3',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 32c0-31.7 11.9-62.3 33.3-85.7L261.4 128l65.1 0-14.9 16.2-44.4 48.4C315 198.2 352 238.8 352 288c0 53-43 96-96 96s-96-43-96-96zm48 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M193.3 202.3L261.4 128l65.1 0-14.9 16.2-44.4 48.4C315 198.2 352 238.8 352 288c0 53-43 96-96 96s-96-43-96-96c0-31.7 11.9-62.3 33.3-85.7zM208 288a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z']
      
    ]
  };

  

  
  

  var faChessKingPiece = {
    prefix: 'fasds',
    iconName: 'chess-king-piece',
    icon: [
      256,
      512,
      ["chess-king-alt"],
      'f440',
      
      ['M0 480l0 32 256 0 0-32-48-64L48 416 0 480z','M144 0l0 16 0 16 16 0 16 0 0 32-16 0-16 0 0 32 72 0 0 24-25.9 88 17.9 0 0 48-24 0-8 0 32 160L48 416 80 256l-8 0-24 0 0-48 17.9 0L40 120l0-24 72 0 0-32L96 64 80 64l0-32 16 0 16 0 0-16 0-16 32 0z']
      
    ]
  };

  
    var faChessKingAlt = faChessKingPiece;
  

  
  

  var faTombstoneBlank = {
    prefix: 'fasds',
    iconName: 'tombstone-blank',
    icon: [
      448,
      512,
      [129702,"tombstone-alt"],
      'f721',
      
      ['M32 192C32 86 118 0 224 0S416 86 416 192l0 256L32 448l0-256z','M0 448l448 0 0 64L0 512l0-64z']
      
    ]
  };

  
    var faTombstoneAlt = faTombstoneBlank;
  

  
  

  var faFaceSmileWink = {
    prefix: 'fasds',
    iconName: 'face-smile-wink',
    icon: [
      512,
      512,
      [128521,"smile-wink"],
      'f4da',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm129.7 71.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm122.8 10.4c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0c-8.5-6.4-17.1-12.8-25.6-19.2z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm116.4-2.4c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2z']
      
    ]
  };

  
    var faSmileWink = faFaceSmileWink;
  

  
  

  var faProjector = {
    prefix: 'fasds',
    iconName: 'projector',
    icon: [
      640,
      512,
      [],
      'f8d6',
      
      ['M0 192L0 448l64 0 16 64 64 0 16-64 160 0c-38.9-29.2-64-75.7-64-128c0-1.6 0-3.3 .1-4.9s.1-3.2 .2-4.9c.2-3.2 .5-6.4 .9-9.6c.8-6.3 1.9-12.6 3.4-18.6c3-12.2 7.3-23.8 12.9-34.7c.7-1.4 1.4-2.7 2.1-4.1c.7-1.4 1.5-2.7 2.3-4c1.5-2.6 3.2-5.2 4.8-7.7c3.4-5.1 7-9.9 10.9-14.6c7.8-9.3 16.7-17.7 26.4-25L0 192zM128 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm6.1-264l17 17 56 56 17 17L353.9 112 337 95 281 39l-17-17L230.1 56zM392 0l0 24 0 80 0 24 48 0 0-24 0-80 0-24L392 0zm86.1 112L512 145.9l17-17 56-56 17-17L568 22.1 551 39 495 95l-17 17zm6.1 352.8L496 512l64 0 16-64 64 0 0-256-128 0c38.9 29.2 64 75.7 64 128c0 2 0 4-.1 6s-.2 4-.3 5.9c-.3 3.9-.7 7.8-1.3 11.7c-1.1 7.7-2.8 15.2-5 22.5c-4.4 14.6-10.8 28.3-18.8 40.8c-16.2 25-39.1 45.2-66.2 58z','M512 320a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-256 0a160 160 0 1 1 320 0 160 160 0 1 1 -320 0zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faText = {
    prefix: 'fasds',
    iconName: 'text',
    icon: [
      448,
      512,
      [],
      'f893',
      
      ['M0 32l32 0 160 0 64 0 160 0 32 0 0 32 0 64 0 32-64 0 0-32 0-32L256 96l0 320 48 0 32 0 0 64-32 0-160 0-32 0 0-64 32 0 48 0 0-320L64 96l0 32 0 32L0 160l0-32L0 64 0 32z','']
      
    ]
  };

  

  
  

  var faCircleDownLeft = {
    prefix: 'fasds',
    iconName: 'circle-down-left',
    icon: [
      512,
      512,
      [],
      'e107',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-64l24-24 52 52 76-76 56 56-76 76 52 52-24 24-160 0 0-160z','M184 168l-24 24 0 160 160 0 24-24-52-52 76-76-56-56-76 76-52-52z']
      
    ]
  };

  

  
  

  var faWatch = {
    prefix: 'fasds',
    iconName: 'watch',
    icon: [
      384,
      512,
      [8986],
      'f2e1',
      
      ['M384 256A192 192 0 1 1 0 256a192 192 0 1 1 384 0zM168 152l0 24 0 80 0 12.8 10.7 7.1 48 32 20 13.3 26.6-39.9-20-13.3L216 243.2l0-67.2 0-24-48 0z','M64 0L320 0l0 112.9C286 82.5 241.2 64 192 64s-94 18.5-128 48.9L64 0zM192 448c49.2 0 94-18.5 128-48.9L320 512 64 512l0-112.9C98 429.5 142.8 448 192 448zm24-272l0 67.2L253.3 268l20 13.3-26.6 39.9-20-13.3-48-32L168 268.8l0-12.8 0-80 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faTextSlash = {
    prefix: 'fasds',
    iconName: 'text-slash',
    icon: [
      640,
      512,
      ["remove-format"],
      'f87d',
      
      ['M151.3 94.7c18.4 14.3 36.8 28.6 55.2 42.9l.5-1.9L217 96l116.7 0L301.2 211.1c18.2 14.1 36.4 28.2 54.5 42.3L400.2 96 503 96 497 120.2 487 160l66 0 6.1-24.2 16-64L585 32l-41 0L192 32l-25 0L161 56.2l-9.6 38.5zM160 416l0 64 32 0 160 0 32 0 0-64-32 0-42.2 0 17.6-62.1L272.9 311 243.3 416 192 416l-32 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faRemoveFormat = faTextSlash;
  

  
  

  var faChartLineUpDown = {
    prefix: 'fasds',
    iconName: 'chart-line-up-down',
    icon: [
      512,
      512,
      [],
      'e5d7',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M352 64l128 0 0 128-16 16-41.4-41.4-112 112L288 301.3l-22.6-22.6L208 221.3l-65.4 65.4L97.4 241.4l88-88L208 130.7l22.6 22.6L288 210.7l89.4-89.4L336 80l16-16zm0 320l-16-16 41.4-41.4-34.7-34.7 45.3-45.3 34.7 34.7L464 240l16 16 0 128-128 0z']
      
    ]
  };

  

  
  

  var faCloudBolt = {
    prefix: 'fasds',
    iconName: 'cloud-bolt',
    icon: [
      512,
      512,
      [127785,"thunderstorm"],
      'f76c',
      
      ['M144 360l0 24 88 0L192 512 368 376l0-24-88 0 40-128L144 360z','M96 320L0 320l0-96c0-41.8 26.7-77.4 64-90.5L64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80l0 16c53 0 96 43 96 96l0 96-96 0-16 0-76.5 0 40-128-51 0L144 320l-48 0z']
      
    ]
  };

  
    var faThunderstorm = faCloudBolt;
  

  
  

  var faMessageCheck = {
    prefix: 'fasds',
    iconName: 'message-check',
    icon: [
      512,
      512,
      ["comment-alt-check"],
      'f4a2',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM126.1 200c.3 .3 .6 .6 1 1c5.3 5.3 10.7 10.7 16 16c21.3 21.3 42.7 42.7 64 64l17 17 17-17c42.7-42.7 85.3-85.3 128-128c5.3-5.3 10.7-10.7 16-16c.3-.3 .6-.6 1-1L352 102.1c-.3 .3-.6 .6-1 1c-5.3 5.3-10.7 10.7-16 16c-37 37-74 74-111 111c-15.7-15.7-31.4-31.4-47-47c-5.3-5.3-10.7-10.7-16-16c-.3-.3-.6-.6-1-1L126.1 200z','M385 137L241 281l-17 17-17-17-80-80L161 167l63 63L351 103 385 137z']
      
    ]
  };

  
    var faCommentAltCheck = faMessageCheck;
  

  
  

  var faHandHoldingSeedling = {
    prefix: 'fasds',
    iconName: 'hand-holding-seedling',
    icon: [
      576,
      512,
      [],
      'f4bf',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M160 0L96 0c0 88.4 71.6 160 160 160l0 96 0 32 64 0 0-32 0-96C320 71.6 248.4 0 160 0zM352 156.8C425 142 480 77.4 480 0L416 0c-40.7 0-77.8 15.2-106 40.1c25.7 32.1 41.3 72.6 42 116.7z']
      
    ]
  };

  

  
  

  var faPhoneArrowRight = {
    prefix: 'fasds',
    iconName: 'phone-arrow-right',
    icon: [
      512,
      512,
      [],
      'e5be',
      
      ['M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512l-32 0C200.6 512 0 311.4 0 64L0 32z','M396.8 6.1l17 17 80 80 17 17-17 17-80 80-17 17L362.9 200l17-17 39-39L312 144l-24 0 0-48 24 0 106.9 0-39-39-17-17L396.8 6.1z']
      
    ]
  };

  

  
  

  var faSquareDollar = {
    prefix: 'fasds',
    iconName: 'square-dollar',
    icon: [
      448,
      512,
      ["dollar-square","usd-square"],
      'f2e9',
      
      ['M0 32L0 480l448 0 0-448L0 32zM137.9 342.1l12.9-41.2c2.2 .7 4.4 1.4 6.6 2.1c7.3 2.3 14.6 4.6 21.9 6.9c12.1 3.9 26.4 8.4 34.5 9.7c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-10.1-6.9-22.6-10.3-34.5-13.5c-2.3-.6-4.5-1.2-6.8-1.9c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c3.9-21.5 19.9-35.8 37.8-43.5c5.8-2.5 12.1-4.4 18.6-5.7l0-38.3 43.2 0 0 37.4c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6c-16.4-2.4-30.1-.5-39.3 3.5c-11 4.7-18 16.2-6.3 23.7c8.5 5.4 21.5 9.2 39.4 14.3l.8 .2c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2l0 36.8L201 400l0-38.9c-11.7-2.6-26.7-7.4-36.6-10.6c-6.6-2.1-13.1-4.2-19.7-6.2c-2.3-.7-4.5-1.4-6.8-2.1z','M244.2 112v37.4c18.3 2.6 36.2 7 54.1 11.5l-10.5 41.9c-16.3-4.1-32.5-8.1-49.1-10.6c-16.4-2.4-30.1-.5-39.3 3.5c-11 4.7-18 16.2-6.3 23.7c8.5 5.4 21.5 9.2 39.4 14.3l.8 .2c15.6 4.4 35.5 10.1 50.4 20.3c19.4 13.3 28.5 34.9 24.2 58.1c-4.1 22.4-19.7 37.1-38.4 44.7c-7.8 3.2-16.3 5.2-25.2 6.2V400H201V361.1c-11.7-2.6-26.7-7.4-36.6-10.6c-8.8-2.8-17.6-5.6-26.5-8.3l12.9-41.2c9.5 3 19 5.9 28.5 9c12.1 3.9 26.4 8.4 34.5 9.7c17 2.5 30.6 1 39.5-2.6c12-4.8 17.7-19.1 5.9-27.1c-12-8.2-27.5-11.5-41.3-15.4c-15.1-4.3-34-9.6-48.2-18.7c-19.5-12.5-29.4-33.3-25.2-56.4c3.9-21.5 19.9-35.8 37.8-43.5c5.8-2.5 12.1-4.4 18.6-5.7V112h43.2z']
      
    ]
  };

  
    var faDollarSquare = faSquareDollar;
  
    var faUsdSquare = faSquareDollar;
  

  
  

  var faArrowDownWideShort = {
    prefix: 'fasds',
    iconName: 'arrow-down-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-asc","sort-amount-down"],
      'f160',
      
      ['M288 32l0 64 32 0 224 0 32 0 0-64-32 0L320 32l-32 0zm0 128l0 64 32 0 160 0 32 0 0-64-32 0-160 0-32 0zm0 128l0 64 32 0 96 0 32 0 0-64-32 0-96 0-32 0zm0 128l0 64 32 0 32 0 32 0 0-64-32 0-32 0-32 0z','M128 479.6l23.7-26 80-88 21.5-23.7-47.4-43.1-21.5 23.7L160 349.2 160 64l0-32L96 32l0 32 0 285.2L71.7 322.5 50.2 298.8 2.8 341.8l21.5 23.7 80 88 23.7 26z']
      
    ]
  };

  
    var faSortAmountAsc = faArrowDownWideShort;
  
    var faSortAmountDown = faArrowDownWideShort;
  

  
  

  var faCandyCane = {
    prefix: 'fasds',
    iconName: 'candy-cane',
    icon: [
      512,
      512,
      [],
      'f786',
      
      ['M14.5 403.5L82.4 512l97.3-60.8C139.4 426 99.2 400.9 58.9 375.7L14.5 403.5zm74.6-46.6c37.1 23.2 74.2 46.4 111.4 69.6c3.1 2 6.3 3.9 9.4 5.9c24.3-15.2 48.7-30.4 73-45.6L162.1 311.2c-24.3 15.2-48.7 30.4-73 45.6zm103.2-64.5c37.4 23.4 74.8 46.7 112.2 70.1c2.9 1.8 5.7 3.6 8.6 5.4c25.7-16 51.3-32.1 77-48.1L271.5 245.6c-.7-.5-1.5-.9-2.2-1.4c-25.7 16-51.3 32.1-77 48.1zm8.1-219.1l67.8 108.5 61.4-38.4c-.3-.8-.5-1.6-.8-2.4c-13.3-40-26.7-80-40-120l-.8-2.3c-2.4 1.3-4.8 2.7-7.1 4.2L200.4 73.3zm99.1 152.1c39 24.4 78 48.7 117 73.1c1.3 .8 2.5 1.6 3.8 2.4c6-3.8 12.1-7.5 18.1-11.3c26.1-16.3 46.4-39.7 59-66.8L378.9 183.2l-7.8-2.6c-.2 .1-.4 .3-.6 .4c-23.7 14.8-47.3 29.6-71 44.4zm18.1-219c.5 1.5 1 3.1 1.5 4.6l39.1 117.2c.9-.1 1.8-.2 2.7-.2c.3 0 .3 0 .4 0c3.8-3.8 7.5-7.5 11.3-11.3c26.7-26.7 53.3-53.3 80-80c1.1-1.1 2.1-2.1 3.2-3.2C429.9 12.6 396.9 0 361 0c-14.7 0-29.3 2.2-43.3 6.3zM384 150.6c0 .1 0 .3 0 .5c1.7 .6 3.4 1.2 5.1 1.7c39.6 13.2 79.2 26.4 118.8 39.6c2.7-11.6 4.1-23.6 4.1-35.8l0-5.6c0-35.9-12.6-69-33.5-94.9l-3.2 3.2-80 80c-3.8 3.8-7.5 7.5-11.3 11.3z','M329.6 143.5l-.8-2.4-40-120-.8-2.3c9.4-5.2 19.3-9.4 29.6-12.4l1.5 4.6 39.1 117.2c-3.4 .4-6.6 1.5-9.5 3.3l-19.1 12zm54.4 7.2c-.2-12.4-10.2-22.4-22.6-22.6c0 0 0 0 0 0l11.3-11.3 80-80 3.2-3.2c8.3 6.7 15.9 14.3 22.6 22.6l-3.2 3.2-80 80L384 150.6s0 0 0 0zm-12.9 29.9c8-5.3 12.9-14.3 12.9-23.9l0-5.5 5.1 1.7 118.8 39.6c-2.5 10.5-6 20.6-10.5 30.2L378.9 183.2l-7.8-2.6zM269.3 244.2l30.2-18.9 117 73.1 3.8 2.4-30.2 18.9L271.5 245.6l-2.2-1.4zm-107.2 67l30.2-18.9 112.2 70.1 8.6 5.4-30.2 18.9L162.1 311.2zM58.9 375.7l30.2-18.9 111.4 69.6 9.4 5.9-30.2 18.9L58.9 375.7z']
      
    ]
  };

  

  
  

  var faSquare9 = {
    prefix: 'fasds',
    iconName: 'square-9',
    icon: [
      448,
      512,
      [],
      'e25e',
      
      ['M0 32l448 0 0 448L0 480 0 32zM128 224c0 49.2 37 89.8 84.7 95.3l-44.4 48.4L153.4 384l65.1 0 68.1-74.3c21.4-23.4 33.3-54 33.3-85.7c0-53-43-96-96-96s-96 43-96 96zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M272 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-59.3 95.3l-44.4 48.4L153.4 384l65.1 0 68.1-74.3c21.4-23.4 33.3-54 33.3-85.7c0-53-43-96-96-96s-96 43-96 96c0 49.2 37 89.8 84.7 95.3z']
      
    ]
  };

  

  
  

  var faBowlFood = {
    prefix: 'fasds',
    iconName: 'bowl-food',
    icon: [
      512,
      512,
      [],
      'e4c6',
      
      ['M0 192c0 11.7 3.1 22.6 8.6 32l494.9 0c5.4-9.4 8.6-20.3 8.6-32c0-35.3-28.7-64-64-64c-.5 0-1.1 0-1.6 0C439 91.5 406.7 64 368 64c-15 0-29 4.1-40.9 11.2C313.8 49.6 286.9 32 256 32s-57.8 17.6-71.1 43.2C173 68.1 159 64 144 64c-38.7 0-71 27.5-78.4 64c-.5 0-1.1 0-1.6 0c-35.3 0-64 28.7-64 64z','M512 256L0 256l0 24c0 67 39.2 124.9 96 151.8L96 480l320 0 0-48.2c56.8-27 96-84.8 96-151.8l0-24z']
      
    ]
  };

  

  
  

  var faGroupArrowsRotate = {
    prefix: 'fasds',
    iconName: 'group-arrows-rotate',
    icon: [
      512,
      512,
      [],
      'e4f6',
      
      ['M2.6 219.5l63.4 9.1c3.5-24.8 11.8-48 23.9-68.8c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c20.8-12.1 44-20.4 68.8-23.9L219.5 2.6c-35.2 5-68.1 17.2-97.2 35.1C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-17.8 29.1-30 61.9-35 97.2zm0 73.1c5 35.2 17.2 68.1 35.1 97.2C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c29.1 17.8 61.9 30 97.2 35l9.1-63.4c-24.8-3.5-48-11.8-68.8-23.9c.2-2 .3-4.1 .3-6.1c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3c-12.1-20.8-20.4-44-23.9-68.8L2.6 292.5zM283.5 65.9c24.8 3.5 48 11.8 68.8 23.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.1-.3c12.1 20.8 20.4 44 23.9 68.8l63.4-9.1c-5-35.2-17.2-68.1-35-97.2c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-29.1-17.8-61.9-30-97.2-35.1l-9.1 63.4zm0 380.1l9.1 63.4c35.2-5 68.1-17.2 97.2-35c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c17.8-29.1 30-61.9 35-97.2l-63.4-9.1c-3.5 24.8-11.8 48-23.9 68.8c-2-.2-4.1-.3-6.1-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.1c-20.8 12.1-44 20.4-68.8 23.9z','M227.7 313.8c-20.8-10.6-34.9-32.2-34.9-57c0-15.6 5.6-29.9 14.9-41.1l25.9 25.9 0-81.6L152 160l21.7 21.7c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8l21.8-42.7zm93.1-58.6c0 15.6-5.6 29.9-14.9 41.1L280 270.4l0 81.6 81.6 0-21.7-21.7c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8l-21.8 42.7c20.8 10.6 34.9 32.2 34.9 57z']
      
    ]
  };

  

  
  

  var faFileJpg = {
    prefix: 'fasds',
    iconName: 'file-jpg',
    icon: [
      512,
      512,
      [],
      'e646',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM208 512c26.5 0 48-21.5 48-48l0-96 0-16-32 0 0 16 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-16 0-16-32 0 0 16 0 16c0 26.5 21.5 48 48 48zM456 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24 0-16-16 0-16 0-16 0 0 32 16 0 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 32 0 0-16c0-22.1-17.9-40-40-40l-16 0zm-168 0l0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0-16 0zm32 80l0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0z']
      
    ]
  };

  

  
  

  var faFlashlight = {
    prefix: 'fasds',
    iconName: 'flashlight',
    icon: [
      640,
      512,
      [128294],
      'f8b8',
      
      ['M224 224l0 64 96 0 0-64-96 0zM576 96l0 320 32 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-32 0z','M384 352s80 64 192 64l0-320c-112 0-192 64-192 64L0 160 0 352l384 0zM320 224l0 64-96 0 0-64 96 0z']
      
    ]
  };

  

  
  

  var faCircleArrowLeft = {
    prefix: 'fasds',
    iconName: 'circle-arrow-left',
    icon: [
      512,
      512,
      ["arrow-circle-left"],
      'f0a8',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm102.1 0l17-17L231 127l17-17c11.3 11.3 22.6 22.6 33.9 33.9l-17 17c-23.7 23.7-47.4 47.4-71 71c60.7 0 121.4 0 182.1 0c8 0 16 0 24 0l0 48c-8 0-16 0-24 0c-60.7 0-121.4 0-182.1 0c23.7 23.7 47.4 47.4 71 71c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-37.3-37.3-74.7-74.7-112-112c-5.7-5.7-11.3-11.3-17-17z','M102.1 256l17-17L231 127l17-17L281.9 144l-17 17-71 71L376 232l24 0 0 48-24 0-182.1 0 71 71 17 17L248 401.9l-17-17L119 273l-17-17z']
      
    ]
  };

  
    var faArrowCircleLeft = faCircleArrowLeft;
  

  
  

  var faBoxesPacking = {
    prefix: 'fasds',
    iconName: 'boxes-packing',
    icon: [
      640,
      512,
      [],
      'e4c7',
      
      ['M256 0L640 0l0 512-256 0 0-256 32 0 0-128-160 0L256 0zM420.7 324.7l22.6 22.6L480 310.6 480 432l0 16 32 0 0-16 0-121.4 36.7 36.7 22.6-22.6-64-64L496 249.4l-11.3 11.3-64 64z','M384 160l0 64L0 224l0-64 384 0zM32 256l320 0 0 256L32 512l0-256zm96 64l0 32 128 0 0-32-128 0z']
      
    ]
  };

  

  
  

  var faLeftRight = {
    prefix: 'fasds',
    iconName: 'left-right',
    icon: [
      512,
      512,
      [8596,"arrows-alt-h"],
      'f337',
      
      ['M256 208l0 96 96 0 0 80 32 0L512 256 384 128l-32 0 0 80-96 0z','M0 256L128 384l32 0 0-80 96 0 0-96-96 0 0-80-32 0L0 256z']
      
    ]
  };

  
    var faArrowsAltH = faLeftRight;
  

  
  

  var faClockSeven = {
    prefix: 'fasds',
    iconName: 'clock-seven',
    icon: [
      512,
      512,
      [],
      'e350',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM158.7 358.7l13.3-20 60-90L232 120l0-24 48 0 0 24 0 136 0 7.3-4 6-64 96-13.3 20-39.9-26.6z','M232 96l0 24 0 128.7-60 90-13.3 20 39.9 26.6 13.3-20 64-96 4-6 0-7.3 0-136 0-24-48 0z']
      
    ]
  };

  

  
  

  var faSeedling = {
    prefix: 'fasds',
    iconName: 'seedling',
    icon: [
      512,
      512,
      [127793,"sprout"],
      'f4d8',
      
      ['M237.7 146.6c25.1 30.7 42.1 68.3 48 109.4l2.3 0c123.7 0 224-100.3 224-224l0-32L448 0C351.5 0 269.2 61 237.7 146.6z','M64 64L0 64 0 96C0 219.7 100.3 320 224 320l0 160 0 32 64 0 0-32 0-160 0-32C288 164.3 187.7 64 64 64z']
      
    ]
  };

  
    var faSprout = faSeedling;
  

  
  

  var faArrowsDownToPeople = {
    prefix: 'fasds',
    iconName: 'arrows-down-to-people',
    icon: [
      640,
      512,
      [],
      'e4b9',
      
      ['M7.4 486.1l42 23.3 11.7-21 27-48.6L88 512l112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21-35.2-63.4 3.4-6.3L264 345.5l0 86.5 112 0 0-86.5 26.9 49.9 3.4 6.3L371 465.1l-11.7 21 42 23.3 11.7-21 27-48.6 0 72.2 112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21L565 364.3 558.1 352 544 352l-96 0-14 0-44.9-83.4L382.3 256 368 256l-96 0-14.3 0-6.8 12.6L206 352l-14 0-96 0-14.1 0L75 364.3 19 465.1l-11.7 21zM104 296a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176-96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176 96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M120 0l0 24 0 118.1L97 119l-17-17L46.1 136l17 17 64 64 17 17 17-17 64-64 17-17L208 102.1l-17 17-23 23L168 24l0-24L120 0zM415 153l64 64 17 17 17-17 64-64 17-17L560 102.1l-17 17-23 23L520 24l0-24L472 0l0 24 0 118.1-23-23-17-17L398.1 136l17 17z']
      
    ]
  };

  

  
  

  var faBullseyeArrow = {
    prefix: 'fasds',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5l-43.1 43.1-9.3 9.3c1.8 10.4 2.7 21.1 2.7 32.1c0 106-86 192-192 192S64 362 64 256S150 64 256 64c10.9 0 21.6 .9 32.1 2.7l9.3-9.3 43.1-43.1C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256zm112 0c0 79.5 64.5 144 144 144s144-64.5 144-144c0-13.1-1.7-25.7-5-37.7l-28.6-4.8-31.2 31.2c.5 3.7 .8 7.5 .8 11.3c0 44.2-35.8 80-80 80s-80-35.8-80-80s35.8-80 80-80c3.8 0 7.6 .3 11.3 .8l31.2-31.2L293.7 117c-12-3.3-24.7-5-37.7-5c-79.5 0-144 64.5-144 144z','M331.2 146.9L320 80 400 0l32 80 80 32-80 80-66.9-11.2L265 281 231 247 331.2 146.9z']
      
    ]
  };

  

  
  

  var faFerry = {
    prefix: 'fasds',
    iconName: 'ferry',
    icon: [
      576,
      512,
      [],
      'e4ea',
      
      ['M0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.6 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2C38.6 441.9 19.3 448 0 448z','M192 0l0 32-48 0L96 32l0 32 12 16 12 16 336 0 12-16 12-16 0-32-48 0-48 0 0-32L352 0 224 0 192 0zM512 128L64 128l0 176 60.2 84.3c9.7 6.9 17.7 12.1 27.1 16.4c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0l1.1-.8L288 368l19.7 14.2s0 0 0 0s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c9.4-4.3 17.4-9.5 27.1-16.4L512 304l0-176zm-64 64l0 96-320 0 0-96 320 0z']
      
    ]
  };

  

  
  

  var faTrianglePersonDigging = {
    prefix: 'fasds',
    iconName: 'triangle-person-digging',
    icon: [
      640,
      512,
      ["construction"],
      'f85d',
      
      ['M64 480l512 0L320 32 64 480zm119.1-64l2.6-5.1 43.7-87.7c2.6-5.3 5.2-10.5 7.9-15.8c5 3.1 10 6.2 14.9 9.3c20.1 12.6 40.2 25.1 60.3 37.7l7.5 4.7 0 8.9 0 32 0 16-16 0-16 0 0-16 0-23.1c-12.6-7.9-25.3-15.8-37.9-23.7c-10.4 20.9-20.8 41.9-31.3 62.8l-35.7 0zm58.3-146.9c3.1-4.7 6.2-9.3 9.3-14c5.3-8 10.7-16 16-24c2.4-3.6 4.8-7.2 7.2-10.8c4 1.6 8 3.2 12.1 4.8c13.3 5.3 26.7 10.7 40 16c1.9 .8 3.8 1.5 5.6 2.3c.9 1.8 1.8 3.6 2.7 5.4c9.2 18.4 18.4 36.8 27.6 55.3c17.4 10.4 34.8 20.9 52.1 31.3c6-10.5 12-20.9 17.9-31.4c21.3 37.3 42.7 74.7 64 112l-128 0 30.2-52.8-56.7-34c-28.6-17.1-57.1-34.3-85.7-51.4c-4.8-2.9-9.6-5.8-14.4-8.6zM336 184a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-14.1 36.3l12.1 4.8 40 16 5.6 2.3 2.7 5.4 27.6 55.3 52.1 31.3L432 304l64 112-128 0 30.2-52.8-56.7-34-85.7-51.4-14.4-8.6 9.3-14 16-24 7.2-10.8zm-36.7 87.1l14.9 9.3 60.3 37.7 7.5 4.7 0 8.9 0 32 0 16-16 0-16 0 0-16 0-23.1-37.9-23.7L218.9 416l-35.7 0 2.6-5.1 43.7-87.7 7.9-15.8z']
      
    ]
  };

  
    var faConstruction = faTrianglePersonDigging;
  

  
  

  var faCircleEnvelope = {
    prefix: 'fasds',
    iconName: 'circle-envelope',
    icon: [
      512,
      512,
      ["envelope-circle"],
      'e10c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-96l256 0 0 44.1L256 254.8 128 204.1l0-44.1zm0 78.5l122.1 48.4 5.9 2.3 5.9-2.3L384 238.5 384 352l-256 0 0-113.5z','M384 160l-256 0 0 44.1 128 50.7 128-50.7 0-44.1zm0 78.5L261.9 286.9l-5.9 2.3-5.9-2.3L128 238.5 128 352l256 0 0-113.5z']
      
    ]
  };

  
    var faEnvelopeCircle = faCircleEnvelope;
  

  
  

  var faInboxFull = {
    prefix: 'fasds',
    iconName: 'inbox-full',
    icon: [
      512,
      512,
      [],
      'e1ba',
      
      ['M73 288c16-64 32-128 48-192l270 0 48 192-71 0-32 64-160 0c-10.7-21.3-21.3-42.7-32-64l-71 0zm55-64l0 32 16 0 224 0 16 0 0-32-16 0-224 0-16 0zm32-80l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0z','M96 32L71 32 65 56.2 1 312.2l-1 3.8L0 320 0 448l0 32 32 0 448 0 32 0 0-32 0-128 0-3.9-1-3.8-64-256L441 32l-25 0L96 32zM73 288L121 96l270 0 48 192-71 0-32 64-160 0-32-64-71 0z']
      
    ]
  };

  

  
  

  var faPig = {
    prefix: 'fasds',
    iconName: 'pig',
    icon: [
      640,
      512,
      [128022],
      'f706',
      
      ['M80 240l0 16c0 54.5 30.3 102 75 126.4L182.9 480l89.1 0 0-64 48 0 64 0 0 64 89.1 0 19.6-68.7c30.1-7.1 57.6-22.1 79.8-43.3l67.5 0 0-144-32 0-5.8-2.9C585 212.5 570 200 558.4 184.6l-6.8-9c31.7-3.8 56.3-30.8 56.3-63.5l0-32-16 0-40 0c-.6 24.8-11.4 47.5-29 63.3c-5.9-5.6-12.2-10.8-18.6-15.7C519 115.8 528 97.8 528 78l0-46L453.1 46c-21.7 4.1-39.2 18.7-47.7 37.9c-14.1-2.6-28.5-4-43.1-4L240 80C162.6 80 98 135 83.2 208c-2.1 10.3-3.2 21-3.2 32zm408-4a20 20 0 1 1 -40 0 20 20 0 1 1 40 0z','M80 240c0-11 1.1-21.7 3.2-32l-35.8 0c-8.5 0-15.4-6.9-15.4-15.4c0-7.1 4.8-13.3 11.7-15l8.2-2-7.8-31-8.2 2C14.8 151.8 0 170.8 0 192.6C0 218.8 21.2 240 47.4 240L80 240zm388 16a20 20 0 1 0 0-40 20 20 0 1 0 0 40z']
      
    ]
  };

  

  
  

  var faVest = {
    prefix: 'fasds',
    iconName: 'vest',
    icon: [
      448,
      512,
      [],
      'e085',
      
      ['M41.4 416c3.8-3.8 7.5-7.5 11.3-11.3c16-16 32-32 48-48L112 345.4 134.6 368c-3.8 3.8-7.5 7.5-11.3 11.3c-16 16-32 32-48 48c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6zM128 0l7 0 13.3 0 6.9 11.1 .3 .4c.4 .6 1.2 1.5 2.3 2.8c2.3 2.6 6.1 6.3 11.5 10.1C179.9 31.8 197.4 40 224 40s44.1-8.2 54.7-15.6c5.4-3.8 9.2-7.5 11.5-10.1c1.1-1.3 1.9-2.3 2.3-2.8l.3-.4L299.6 0 313 0l7 0L296.8 69.7C279.3 79.8 255.3 88 224 88s-55.3-8.3-72.8-18.3C143.5 46.5 135.7 23.2 128 0zM313.4 368L336 345.4l11.3 11.3 48 48L406.6 416 384 438.6c-3.8-3.8-7.5-7.5-11.3-11.3c-16-16-32-32-48-48c-3.8-3.8-7.5-7.5-11.3-11.3z','M128 0L64 0l0 160L0 256 0 512l192 0 0-224 0-5.2 1.6-4.9 13.5-40.5L128 0zm96 288l0 224 224 0 0-256-64-96L384 0 320 0 224 288zm112 57.4l11.3 11.3 48 48L406.6 416 384 438.6l-11.3-11.3-48-48L313.4 368 336 345.4zM100.7 356.7L112 345.4 134.6 368l-11.3 11.3-48 48L64 438.6 41.4 416l11.3-11.3 48-48z']
      
    ]
  };

  

  
  

  var faArrowsTurnRight = {
    prefix: 'fasds',
    iconName: 'arrows-turn-right',
    icon: [
      448,
      512,
      [],
      'e4c0',
      
      ['M0 352l0 32 0 96 0 32 64 0 0-32 0-64 178.7 0-25.4 25.4L194.7 464 240 509.3l22.6-22.6 80-80L365.3 384l-22.6-22.6-80-80L240 258.7 194.7 304l22.6 22.6L242.7 352 32 352 0 352z','M320 2.7l22.6 22.6 80 80L445.3 128l-22.6 22.6-80 80L320 253.3 274.7 208l22.6-22.6L322.7 160 64 160l0 96 0 32L0 288l0-32L0 128 0 96l32 0 290.7 0L297.4 70.6 274.7 48 320 2.7z']
      
    ]
  };

  

  
  

  var faObjectsAlignRight = {
    prefix: 'fasds',
    iconName: 'objects-align-right',
    icon: [
      512,
      512,
      [],
      'e3bf',
      
      ['M0 64L0 224l384 0 0-160L0 64zM128 288l0 160 256 0 0-160-256 0z','M512 0l0 512-48 0L464 0l48 0z']
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fasds',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      ['M12 199l40 50L192.6 136.5l108.2 81.1 19.3 14.5c4.4-3.6 9-7.1 13.8-10.3l6-4.8L480 105l0 39 0 32 64 0 0-32 0-112 0-32L512 0 400 0 368 0l0 64 32 0 28.8 0L319.4 151.5 211.2 70.4 191.4 55.5 172 71 12 199zM32 320l0 160 64 0 0-160-64 0zm128-96l0 256 64 0 0-256-64 0z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM396.7 426l-25.3 25.3-22.6-22.6L374 403.3c-13.2-21.6-13.2-49.1 0-70.7l-25.3-25.3 22.6-22.6L396.7 310c21.6-13.2 49.1-13.2 70.7 0l25.3-25.3 22.6 22.6L490 332.7c13.2 21.6 13.2 49.1 0 70.7l25.3 25.3-22.6 22.6L467.3 426c-21.6 13.2-49.1 13.2-70.7 0z']
      
    ]
  };

  

  
  

  var faTransporter4 = {
    prefix: 'fasds',
    iconName: 'transporter-4',
    icon: [
      512,
      512,
      [],
      'e2a5',
      
      ['M0 400l32-16 16-32 16 32 32 16L64 416 48 448 32 416 0 400zM96 256l16 0 288 0 16 0 0 32-16 0-288 0-16 0 0-32zm32-64l16 0 224 0 16 0 0 32-16 0-224 0-16 0 0-32zm32-64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 192l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zM208 0l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zm0 64l16 0 64 0 16 0 0 32-16 0-64 0-16 0 0-32zM416 176l32-16 16-32 16 32 32 16-32 16-16 32-16-32-32-16z','M296 512l120 0 0-64L96 448l0 64 120 0 80 0z']
      
    ]
  };

  

  
  

  var faPalette = {
    prefix: 'fasds',
    iconName: 'palette',
    icon: [
      512,
      512,
      [127912],
      'f53f',
      
      ['M0 256C0 397.4 114.6 512 256 512l64-64-12.1-12.1c-12.7-12.7-19.9-30-19.9-48c0-37.5 30.4-67.9 67.9-67.9L512 320l0-64C512 114.6 397.4 0 256 0S0 114.6 0 256zm128 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-96 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faCloudArrowUp = {
    prefix: 'fasds',
    iconName: 'cloud-arrow-up',
    icon: [
      640,
      512,
      [62338,"cloud-upload","cloud-upload-alt"],
      'f0ee',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zm206.1-56l17-17 80-80 17-17 17 17 80 80 17 17L400 313.9l-17-17-39-39L344 392l0 24-48 0 0-24 0-134.1-39 39-17 17L206.1 280z','M206.1 280l17-17 80-80 17-17 17 17 80 80 17 17L400 313.9l-17-17-39-39L344 392l0 24-48 0 0-24 0-134.1-39 39-17 17L206.1 280z']
      
    ]
  };

  
    var faCloudUpload = faCloudArrowUp;
  
    var faCloudUploadAlt = faCloudArrowUp;
  

  
  

  var faFontAwesome = {
    prefix: 'fasds',
    iconName: 'font-awesome',
    icon: [
      512,
      512,
      [62501,62694,"font-awesome-flag","font-awesome-logo-full"],
      'f2b4',
      
      ['M96 96l0 352 400 0 0-32L432 272l64-144 0-32L96 96z','M96 93c12.2-9.5 20-24.3 20-41C116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 419 64 0L96 93z']
      
    ]
  };

  
    var faFontAwesomeFlag = faFontAwesome;
  
    var faFontAwesomeLogoFull = faFontAwesome;
  

  
  

  var faGasPumpSlash = {
    prefix: 'fasds',
    iconName: 'gas-pump-slash',
    icon: [
      640,
      512,
      [],
      'f5f4',
      
      ['M64 448l352 0 0 32 0 32L64 512l0-64zM96 0L384 0l0 275.4L96 51.8 96 0zm0 171.6L384 398.5l0 17.5L96 416l0-244.4zM432 48l32-32L576 128l0 40 0 24 0 32 0 136c0 19.2-6.2 37-16.6 51.5c-12.7-9.8-25.3-19.7-38-29.5c4.2-6.3 6.6-13.9 6.6-22l0-138c-27.6-7.1-48-32.2-48-62l0-64L432 48z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faCrutch = {
    prefix: 'fasds',
    iconName: 'crutch',
    icon: [
      512,
      512,
      [],
      'f7f7',
      
      ['M289.1 46.4c5.9 5.9 11.7 11.7 17.6 17.6c1.7 1.7 3.4 3.4 5 5L352 109.3c16.9 16.9 33.8 33.8 50.7 50.7c13.4 13.4 26.8 26.8 40.2 40.2l5 5 17.6 17.6 45.3-45.3L488.2 155 357 23.8 334.4 1.1 289.1 46.4z','M209.5 161.3L306.7 64 352 109.3 277.3 184 328 234.7 402.7 160 448 205.3l-97.4 97.4-56 56-6.3 6.3-8.6 2.1L160.4 396.9l-41.7 41.7-73 73L.4 466.3l72.9-72.9c0 0 0 0 .1-.1l41.7-41.7L145 232.2l2.1-8.6 6.3-6.3 55.9-55.9 .1-.1 .1-.1zm22.5 68l-27.1 27.1L188 324l67.7-16.9L282.7 280 232 229.3z']
      
    ]
  };

  

  
  

  var faSquareALock = {
    prefix: 'fasds',
    iconName: 'square-a-lock',
    icon: [
      576,
      512,
      [],
      'e44d',
      
      ['M0 32L0 480l320 0 0-96-13.6 0-22.5-48-119.7 0-22.5 48-53 0L202.3 141.8l6.5-13.8 30.5 0 6.5 13.8L314.3 288l5.7 0 32 0 0-16c0-56.4 41.7-103.1 96-110.9L448 32 0 32zM186.7 288l74.6 0L224 208.5 186.7 288z','M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faUserVneckHairLong = {
    prefix: 'fasds',
    iconName: 'user-vneck-hair-long',
    icon: [
      448,
      512,
      [],
      'e463',
      
      ['M128 128l0 16c0 53 43 96 96 96s96-43 96-96l0-16c0-11.2-1.9-22-5.5-32L256 96 240 80l-32 32-78.7 0c-.9 5.2-1.3 10.5-1.3 16z','M320 144c0 53-43 96-96 96s-96-43-96-96l0-16c0-5.5 .5-10.8 1.3-16l78.7 0 32-32 16 16 58.5 0c3.5 10 5.5 20.8 5.5 32l0 16zM224 0C153.3 0 96 57.3 96 128l0 16 0 48L48 240l0 32 176 0 176 0 0-32-48-48 0-48 0-16C352 57.3 294.7 0 224 0zm0 416l-72-96-88 0L0 512l448 0L384 320l-88 0-72 96z']
      
    ]
  };

  

  
  

  var faCircleCaretUp = {
    prefix: 'fasds',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 16L256 144 384 272l0 32-256 0 0-32z','M128 304V272L256 144 384 272v32H128z']
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faHydra = {
    prefix: 'fasds',
    iconName: 'hydra',
    icon: [
      640,
      512,
      [],
      'e686',
      
      ['M0 208.6L0 256l32 0 64 0 0 64c0 59.6 40.8 109.8 96 124l0 68 96 0 10.7-64 74.7 0L384 512l96 0 0-64 32 0c70.7 0 128-57.3 128-128c0-40.3-19-78.2-51.2-102.4l-25.6-19.2-45.4 44 33.1 47.2c18.4 26.3-.4 62.4-32.5 62.4c-13.3 0-25.6-6.6-33-17.7l-10.7-16.1C448.7 279.4 405.1 256 358.4 256l-9.4 0-5.3 0c-5.6 0-11.1-.5-16.4-1.5c-32-6.1-57.9-29.5-67.4-59.7c-2.4-7.6-3.7-15.7-3.9-24c0-.5 0-.9 0-1.4l0-.6 0-4.5 0-1.3 0-34.9 0-16 0-28.8C256 37.2 218.8 0 172.8 0L168 0 156.8 0 148 7 108 39 96 48.6 96 96l32 0 32 0 16 0 16 0 0 16 0 16 0 .4 0 .4L184.3 283l20.5 27.4 9.6 12.8-25.6 19.2-9.6-12.8-24-32-3.5-4.6 .3-5.8 3.7-73.2c-10.8-31.4-40.6-54-75.7-54l-8 0-11.2 0L52 167 12 199 0 208.6z','M327.3 254.5L346.2 160l69.8 0 32 0 0-47.4L436 103 396 71l-8.8-7L376 64l-7.1 0c-43.3 0-81.2 29-92.6 70.7l-16.4 60c9.5 30.2 35.5 53.6 67.4 59.7z']
      
    ]
  };

  

  
  

  var faUfoBeam = {
    prefix: 'fasds',
    iconName: 'ufo-beam',
    icon: [
      576,
      512,
      [],
      'e048',
      
      ['M.3 492.2l9.7-21.9L90.4 289.5c14.2 5.2 29.7 9.8 46.4 13.9L53.9 489.7l-9.7 21.9L.3 492.2zM144 138.7c0-9.3 1-18.8 2.9-28.3C158.5 54.5 204.4 0 288 0s129.5 54.5 141.1 110.3c2 9.5 2.9 19 2.9 28.3c0 0-33.2 53.3-144 53.3s-144-53.3-144-53.3zM439.2 303.3c16.7-4 32.2-8.7 46.4-13.9l80.3 180.8 9.7 21.9-43.9 19.5-9.7-21.9L439.2 303.3z','M432 138.7s-33.2 53.3-144 53.3s-144-53.3-144-53.3c0-9.3 1-18.8 2.9-28.3C59.2 129.5 0 166.1 0 208c0 61.9 128.9 112 288 112s288-50.1 288-112c0-41.9-59.2-78.5-146.9-97.7c2 9.5 2.9 19 2.9 28.3zM288 224l32 32-32 32-32-32 32-32zM64 208l32-32 32 32L96 240 64 208zm416-32l32 32-32 32-32-32 32-32z']
      
    ]
  };

  

  
  

  var faSmog = {
    prefix: 'fasds',
    iconName: 'smog',
    icon: [
      640,
      512,
      [],
      'f75f',
      
      ['M0 464l0 48 24 0 336 0 24 0 0-48-24 0L24 464 0 464zm72-96l0 48 24 0 104 0 24 0 0-48-24 0L96 368l-24 0zm184 0l0 48 24 0 336 0 24 0 0-48-24 0-336 0-24 0zm160 96l0 48 24 0 112 0 24 0 0-48-24 0-112 0-24 0z','M176 288c5.4 0 10.7-.3 16-.9l0 .9 107.3 0c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32l27.3 0 112 0 0-112c0-61.9-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144l0 144 144 0z']
      
    ]
  };

  

  
  

  var faBlindsRaised = {
    prefix: 'fasds',
    iconName: 'blinds-raised',
    icon: [
      512,
      512,
      [],
      'f8fd',
      
      ['M0 128L16 64l16 0 96 0 0 64L0 128zm0 96l16-64 112 0 0 64L0 224zM160 64l320 0 16 0 16 64-352 0 0-64zm0 96l336 0 16 64-352 0 0-64z','M0 0L32 0 480 0l32 0 0 64-32 0L160 64l0 354.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L128 64 32 64 0 64 0 0z']
      
    ]
  };

  

  
  

  var faMoneyBills = {
    prefix: 'fasds',
    iconName: 'money-bills',
    icon: [
      640,
      512,
      [],
      'e1f3',
      
      ['M0 96l0 24L0 456l0 24 24 0 496 0 24 0 0-48-24 0L48 432l0-312 0-24L0 96zm160 64l0 96c35.3 0 64 28.7 64 64l288 0c0-35.3 28.7-64 64-64l0-96c-35.3 0-64-28.7-64-64L224 96c0 35.3-28.7 64-64 64zm288 48a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M640 32L96 32l0 352 544 0 0-352zM512 96c0 35.3 28.7 64 64 64l0 96c-35.3 0-64 28.7-64 64l-288 0c0-35.3-28.7-64-64-64l0-96c35.3 0 64-28.7 64-64l288 0z']
      
    ]
  };

  

  
  

  var faFaceTired = {
    prefix: 'fasds',
    iconName: 'face-tired',
    icon: [
      512,
      512,
      [128555,"tired"],
      'f5c8',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM112 144l118.9 64L112 272l45.7-64L112 144zm16 272c0-70.7 57.3-128 128-128s128 57.3 128 128c0 4.2-.2 8.3-.6 12.3C349.5 400.8 304.9 384 256 384s-93.5 16.8-127.4 44.3c-.4-4.1-.6-8.2-.6-12.3zM281.1 208L400 144l-45.7 64L400 272 281.1 208z','M230.9 208L112 144l45.7 64L112 272l118.9-64zm50.3 0L400 272l-45.7-64L400 144 281.1 208z']
      
    ]
  };

  
    var faTired = faFaceTired;
  

  
  

  var faHouseLaptop = {
    prefix: 'fasds',
    iconName: 'house-laptop',
    icon: [
      640,
      512,
      ["laptop-house"],
      'e066',
      
      ['M0 208l0 48 64 0 0 160 208 0 0-128-80 0 0-96 96 0 0 32 192 0 0-16L240 0 0 208z','M352 304l0 144 192 0 0-144-192 0zM304 448l0-144 0-48 48 0 192 0 48 0 0 48 0 144 48 0 0 32-32 32-16 0-48 0-192 0-48 0-16 0-32-32 0-32 48 0z']
      
    ]
  };

  
    var faLaptopHouse = faHouseLaptop;
  

  
  

  var faBurst = {
    prefix: 'fasds',
    iconName: 'burst',
    icon: [
      512,
      512,
      [],
      'e4dc',
      
      ['M0 0L51.8 86.8l42.4 71 24.7 41.4L75.3 220l-19.7 9.4L0 256l55.6 26.6 63.2 30.2-23.3 66L75 437l58.1-20.5 66-23.3 30.2 63.2L256 512l26.6-55.6 30.2-63.2 66 23.3L437 437l-20.5-58.2-23.3-66 63.2-30.2L512 256l-55.6-26.6-63.2-30.2 23.3-66L437 75 378.9 95.5l-66 23.3L282.6 55.6 256 0 229.4 55.6 220 75.3l-20.8 43.5L157.8 94.1l-71-42.4L0 0zM111.3 256c9.4-4.5 18.8-9 28.3-13.5c15.8-7.6 31.7-15.1 47.5-22.7c-9-15.1-18-30.1-27-45.2c-7.2-12-14.3-24-21.5-36c12 7.2 24 14.3 36 21.5c15.1 9 30.1 18 45.2 27c7.6-15.8 15.1-31.6 22.7-47.5c4.5-9.4 9-18.8 13.5-28.3c4.5 9.4 9 18.8 13.5 28.3c6.2 13 12.4 25.9 18.6 38.9c13.6-4.8 27.1-9.6 40.7-14.4c9.9-3.5 19.7-7 29.5-10.4c-3.5 9.9-7 19.7-10.4 29.5c-4.8 13.6-9.6 27.1-14.4 40.7c13 6.2 25.9 12.4 38.9 18.6c9.4 4.5 18.8 9 28.3 13.5c-9.4 4.5-18.8 9-28.3 13.5c-13 6.2-25.9 12.4-38.9 18.6c4.8 13.6 9.6 27.1 14.4 40.7c3.5 9.9 7 19.7 10.4 29.5c-9.9-3.5-19.7-7-29.5-10.4c-13.6-4.8-27.1-9.6-40.7-14.4c-6.2 13-12.4 25.9-18.6 38.9c-4.5 9.4-9 18.8-13.5 28.3l-13.5-28.3-18.6-38.9c-13.6 4.8-27.1 9.6-40.7 14.4c-9.8 3.5-19.7 7-29.5 10.4c3.5-9.9 7-19.7 10.4-29.5c4.8-13.6 9.6-27.1 14.4-40.7l-38.9-18.6c-9.4-4.5-18.8-9-28.3-13.5z','M328.8 164.1l29.5-10.4-10.4 29.5-14.4 40.7 38.9 18.6L400.7 256l-28.3 13.5-38.9 18.6 14.4 40.7 10.4 29.5-29.5-10.4-40.7-14.4-18.6 38.9L256 400.7l-13.5-28.3-18.6-38.9-40.7 14.4-29.5 10.4 10.4-29.5 14.4-40.7-38.9-18.6L111.3 256l28.3-13.5L187 219.8l-27-45.2-21.5-36 36 21.5 45.2 27 22.7-47.5L256 111.3l13.5 28.3 18.6 38.9 40.7-14.4z']
      
    ]
  };

  

  
  

  var faIntegral = {
    prefix: 'fasds',
    iconName: 'integral',
    icon: [
      320,
      512,
      [],
      'f667',
      
      ['M128 0l32 0L272 0l32 0 0 32 0 64 0 32-64 0 0-32 0-32-48 0 0 416 0 32-32 0L48 512l-32 0 0-32 0-64 0-32 64 0 0 32 0 32 48 0 0-416 0-32z','']
      
    ]
  };

  

  
  

  var faDiamondTurnRight = {
    prefix: 'fasds',
    iconName: 'diamond-turn-right',
    icon: [
      512,
      512,
      ["directions"],
      'f5eb',
      
      ['M0 256L256 512 512 256 256 0 0 256zm160-40l24 0 104 0 0-72 16 0 96 96-96 96-16 0 0-72-80 0 0 64 0 24-48 0 0-24 0-88 0-24z','M288 336l16 0 96-96-96-96-16 0 0 72-104 0-24 0 0 24 0 88 0 24 48 0 0-24 0-64 80 0 0 72z']
      
    ]
  };

  
    var faDirections = faDiamondTurnRight;
  

  
  

  var faSubscript = {
    prefix: 'fasds',
    iconName: 'subscript',
    icon: [
      512,
      512,
      [],
      'f12c',
      
      ['M0 64l32 0 32 0 16.7 0 9.6 13.6L176 200.2 261.8 77.6 271.3 64 288 64l32 0 32 0 0 64-32 0-15.3 0L215.1 256l89.6 128 15.3 0 32 0 0 64-32 0-32 0-16.7 0-9.6-13.6L176 311.8 90.2 434.4 80.7 448 64 448l-32 0L0 448l0-64 32 0 15.3 0 89.6-128L47.3 128 32 128 0 128 0 64z','M416 288l-32 0 0 64 32 0 0 96-32 0 0 64 32 0 64 0 32 0 0-64-32 0 0-128 0-32-32 0-32 0z']
      
    ]
  };

  

  
  

  var faGlobeSnow = {
    prefix: 'fasds',
    iconName: 'globe-snow',
    icon: [
      448,
      512,
      [],
      'f7a3',
      
      ['M0 224c0 71.4 33.4 135 85.4 176L192 400l0-48-80 0 0-16 80-80-48 0 0-16 80-80 80 80 0 16-48 0 80 80 0 16-80 0 0 48 106.6 0c52-41 85.4-104.6 85.4-176C448 100.3 347.7 0 224 0S0 100.3 0 224zm96-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM256 80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm96 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M304 256l-48 0 80 80 0 16-80 0 0 48 106.6 0L448 512 0 512 85.4 400 192 400l0-48-80 0 0-16 80-80-48 0 0-16 80-80 80 80 0 16z']
      
    ]
  };

  

  
  

  var faScaleUnbalancedFlip = {
    prefix: 'fasds',
    iconName: 'scale-unbalanced-flip',
    icon: [
      640,
      512,
      ["balance-scale-right"],
      'f516',
      
      ['M96 448l0 64 32 0 192 0 32 0 0-32 0-326.7c5.1-2.2 9.9-5 14.4-8.2l135.5 45.2 30.4 10.1 20.2-60.7-30.4-10.1L399.5 88.8c.3-2.9 .5-5.8 .5-8.8c0-44.2-35.8-80-80-80c-29.3 0-55 15.8-68.9 39.3L138.1 1.6 117.9 62.4l125.9 42c7 22 23.3 39.9 44.2 49L288 448l-160 0-32 0z','M158.5 96L144 96l-32 0L97.5 96l-6.7 12.9-88 168L0 282.1 0 288l0 32 0 9.9 7 7 40 40 7 7 9.9 0 128 0 9.9 0 7-7 40-40 7-7 0-9.9 0-32 0-5.9-2.7-5.2-88-168L158.5 96zm-29 48l75.4 144L51.1 288l75.4-144 3 0zm413 80L528 224l-32 0-14.5 0-6.7 12.9-88 168-2.7 5.2 0 5.9 0 32 0 9.9 7 7 40 40 7 7 9.9 0 128 0 9.9 0 7-7 40-40 7-7 0-9.9 0-32 0-5.9-2.7-5.2-88-168L542.5 224zm-29 48l75.4 144-153.8 0 75.4-144 3 0z']
      
    ]
  };

  
    var faBalanceScaleRight = faScaleUnbalancedFlip;
  

  
  

  var faAddressCard = {
    prefix: 'fasds',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      ['M0 32L0 480l576 0 0-448L0 32zM64 384l32-96 160 0 32 96L64 384zM240 192a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm112-32l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zm0 64l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zm0 64l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32z','M176 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM64 384l32-96 160 0 32 96L64 384z']
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faTrashCanPlus = {
    prefix: 'fasds',
    iconName: 'trash-can-plus',
    icon: [
      448,
      512,
      [],
      'e2ac',
      
      ['M32 96l0 416 384 0 0-416L32 96zm80 168l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zm56 400l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z']
      
    ]
  };

  

  
  

  var faRegistered = {
    prefix: 'fasds',
    iconName: 'registered',
    icon: [
      512,
      512,
      [174],
      'f25d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 104 0c44.2 0 80 35.8 80 80c0 37.8-26.3 69.5-61.6 77.9L369.1 384l-57 0-61.3-96L208 288l0 72 0 24-48 0 0-24 0-96 0-112 0-24zm48 48l0 64 56 0 24 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0z','M184 128l-24 0 0 24 0 112 0 96 0 24 48 0 0-24 0-72 42.9 0 61.3 96 57 0-62.7-98.1c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80l-104 0zm80 112l-56 0 0-64 80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0z']
      
    ]
  };

  

  
  

  var faGaugeLow = {
    prefix: 'fasds',
    iconName: 'gauge-low',
    icon: [
      512,
      512,
      ["tachometer-alt-slow"],
      'f627',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm8.4-116.3c14.6-6.4 29.3-12.9 43.9-19.3c3.2 7.3 6.4 14.6 9.7 22c21.4 48.6 42.7 97.1 64.1 145.7c.6 0 1.3 0 1.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64c-17.7 0-33.7-7.2-45.3-18.7c-5.8-5.8-10.5-12.7-13.7-20.3c-1.6-3.8-2.9-7.8-3.7-12c-.4-2.1-.8-4.2-1-6.4c-.1-1.1-.2-2.2-.2-3.2c-.1-1.1-.1-2.2-.1-3.3c0-1.1 0-2.2 .1-3.3c.1-1.1 .1-2.1 .2-3.2c.2-2.1 .5-4.2 .9-6.2c.8-4.1 2-8.1 3.6-11.8c3.1-7.5 7.7-14.4 13.3-20.1c-21.4-48.6-42.7-97.1-64.1-145.7c-3.2-7.3-6.4-14.6-9.7-22zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm112 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M190 142.3l-9.7-22-43.9 19.3 9.7 22 64.1 145.7C198.9 318.9 192 334.6 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-.6 0-1.3 0-1.9 0L190 142.3z']
      
    ]
  };

  
    var faTachometerAltSlow = faGaugeLow;
  

  
  

  var faBomb = {
    prefix: 'fasds',
    iconName: 'bomb',
    icon: [
      512,
      512,
      [128163],
      'f1e2',
      
      ['M352 80l53.3 26.7L432 160l26.7-53.3L512 80 458.7 53.3 432 0 405.3 53.3 352 80z','M304 82.7l22.6 22.6 80 80L429.3 208l-22.6 22.6-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5c0 114.9-93.1 208-208 208S0 418.9 0 304S93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3l2.9-2.9L304 82.7zM96 296c0-57.4 46.6-104 104-104l8 0 0-32-8 0c-75.1 0-136 60.9-136 136l0 8 32 0 0-8z']
      
    ]
  };

  

  
  

  var faTemperatureEmpty = {
    prefix: 'fasds',
    iconName: 'temperature-empty',
    icon: [
      320,
      512,
      ["temperature-0","thermometer-0","thermometer-empty"],
      'f2cb',
      
      ['M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L272 64l0-64L208 0 112 0 48 0l0 64 0 213.5C28 302.2 16 333.7 16 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L112 300.2l0-22.7L112 64l96 0 0 213.5 0 22.7 14.2 17.6C233.4 331.5 240 348.9 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M112 368a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z']
      
    ]
  };

  
    var faTemperature0 = faTemperatureEmpty;
  
    var faThermometer0 = faTemperatureEmpty;
  
    var faThermometerEmpty = faTemperatureEmpty;
  

  
  

  var faHillAvalanche = {
    prefix: 'fasds',
    iconName: 'hill-avalanche',
    icon: [
      576,
      512,
      [],
      'e507',
      
      ['M128 80c0 4 .5 7.9 1.4 11.6L439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c17.2-17.2 25.8-39.7 25.8-62.2s-8.6-45-25.8-62.2c-34.4-34.4-90.1-34.4-124.5 0l33.9 33.9c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48zM416 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M480 512H0V32L480 512z']
      
    ]
  };

  

  
  

  var faPlaneEngines = {
    prefix: 'fasds',
    iconName: 'plane-engines',
    icon: [
      576,
      512,
      [9992,"plane-alt"],
      'f3de',
      
      ['M160 0l54.9 192 150.9 0c-12.2-21.3-24.4-42.7-36.6-64s-24.4-42.7-36.6-64L256 0 160 0zm0 512l96 0c12.2-21.3 24.4-42.7 36.6-64l36.6-64c12.2-21.3 24.4-42.7 36.6-64l-150.9 0L160 512z','M292.6 64L352 64l0 64-22.9 0L292.6 64zM352 448l-59.4 0 36.6-64 22.9 0 0 64zM482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64L112 320 64 384 0 384l24.2-96.9C10.3 283.6 0 271 0 256s10.3-27.6 24.2-31.1L0 128l64 0 48 64 370.3 0z']
      
    ]
  };

  
    var faPlaneAlt = faPlaneEngines;
  

  
  

  var faClockEightThirty = {
    prefix: 'fasds',
    iconName: 'clock-eight-thirty',
    icon: [
      512,
      512,
      [],
      'e346',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm126.7 57.3l20-13.3 96-64L280 211.2l0 44.8 0 136 0 24-48 0 0-24 0-91.2L173.3 340l-20 13.3-26.6-39.9z','M232 416l0-24 0-91.2L173.3 340l-20 13.3-26.6-39.9 20-13.3 96-64L280 211.2l0 44.8 0 136 0 24-48 0z']
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fasds',
    iconName: 'pause',
    icon: [
      320,
      512,
      [9208],
      'f04c',
      
      ['M128 64L0 64 0 448l128 0 0-384zm192 0L192 64l0 384 128 0 0-384z','']
      
    ]
  };

  

  
  

  var faLocationPinLock = {
    prefix: 'fasds',
    iconName: 'location-pin-lock',
    icon: [
      512,
      512,
      [],
      'e51f',
      
      ['M0 192C0 304 192 512 192 512s28.8-31.1 64-75.8L256 288l32 0 0-16c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192zm256 0a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M368 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faStrawberry = {
    prefix: 'fasds',
    iconName: 'strawberry',
    icon: [
      512,
      512,
      [],
      'e32b',
      
      ['M0 336L0 512l176 0c176 0 272-96 272-192c0-32.8-12.5-65.5-37.5-90.5l-128-128C257.6 76.6 224.9 64.1 192.2 64C96.2 64 0 160 0 336zm73.6 38.4s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6c0 .1 0 .4 .1 1c0 .7 .1 1.7 .1 2.9c0 .6 0 1.3 0 1.9c0 .7 0 1.4-.1 2.1c-.1 1.6-.2 3.3-.4 5.2c-.9 7.3-3.3 16.1-9.2 22.1s-14.7 8.3-22 9.2c-3.7 .5-6.9 .5-9.3 .5c-1.2 0-2.1-.1-2.8-.1s-1-.1-1-.1zm31.9-104c.1-1.6 .2-3.3 .4-5.2c.9-7.3 3.3-16.1 9.2-22s14.7-8.3 22-9.2c3.7-.5 7-.5 9.3-.5c1.2 0 2.1 .1 2.8 .1c.6 0 1 .1 1 .1c0 .1 0 .5 .1 1c0 .7 .1 1.7 .1 2.9c0 .6 0 1.3 0 1.9c0 .7 0 1.4-.1 2.1c-.1 1.6-.2 3.3-.4 5.2c-.9 7.3-3.3 16.1-9.2 22.1s-14.7 8.3-22 9.2c-3.7 .5-7 .5-9.3 .5c-1.2 0-2.1-.1-2.8-.1c-.6 0-1-.1-1-.1c0-.1 0-.4-.1-1c0-.7-.1-1.7-.1-2.9c0-.6 0-1.2 0-2c0-.6 0-1.3 .1-2.1zm32.1-88c-.1-.6-2.1-23.5 9.6-35.2c5.9-5.9 14.7-8.3 22-9.2c3.7-.5 7-.5 9.3-.5c1.2 0 2.1 .1 2.8 .1c.6 0 1 .1 1 .1c0 .1 0 .5 .1 1c0 .7 .1 1.7 .1 2.9c0 .6 0 1.3 0 1.9c0 .7 0 1.4-.1 2.1c-.1 1.6-.2 3.3-.4 5.2c-.9 7.3-3.3 16.1-9.2 22.1s-14.7 8.3-22 9.2c-3.7 .5-7 .5-9.3 .5c-1.2 0-2.1-.1-2.8-.1c-.6 0-1-.1-1-.1zm0 256c-.1-.6-2.1-23.5 9.6-35.2c11.9-11.9 35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2c-8.6 8.6-23.2 9.8-30.6 9.8c-1.4 0-2.6 0-3.3-.1s-1.2-.1-1.2-.1zm32-96c-.1-.6-2.1-23.5 9.6-35.2c5.9-5.9 14.7-8.3 22-9.2c3.7-.5 7-.5 9.3-.5c1.2 0 2.1 .1 2.8 .1c.6 0 1 .1 1 .1c0 .1 0 .5 .1 1c0 .7 .1 1.7 .1 2.9c0 .6 0 1.3 0 1.9c0 .7 0 1.4-.1 2.1c-.1 1.6-.2 3.3-.4 5.2c-.9 7.3-3.3 16.1-9.2 22.1s-14.7 8.3-22 9.2c-3.7 .5-6.9 .5-9.3 .5c-1.2 0-2.1-.1-2.8-.1s-1-.1-1-.1zm32-96c-.1-.6-2.1-23.5 9.6-35.2c5.9-5.9 14.7-8.3 22-9.2c3.7-.5 7-.5 9.3-.5c1.2 0 2.1 .1 2.8 .1c.6 0 1 .1 1 .1c0 .1 0 .5 .1 1c0 .7 .1 1.7 .1 2.9c0 .6 0 1.3 0 1.9c0 .7 0 1.4-.1 2.1c-.1 1.6-.2 3.3-.4 5.2c-.9 7.3-3.3 16.1-9.2 22.1s-14.7 8.3-22 9.2c-3.7 .5-7 .5-9.3 .5c-1.2 0-2.1-.1-2.8-.1c-.6 0-1-.1-1-.1zm32 160s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6c0 .1 0 .5 .1 1c0 .7 .1 1.7 .1 2.9c0 .6 0 1.3 0 1.9c0 .7 0 1.4-.1 2.1c-.1 1.6-.2 3.3-.4 5.2c-.9 7.3-3.3 16.1-9.2 22.1s-14.7 8.3-22 9.2c-3.7 .5-6.9 .5-9.3 .5c-1.2 0-2.1-.1-2.8-.1s-1-.1-1-.1zm31.9-104c.1-1.6 .2-3.3 .4-5.2c.9-7.3 3.3-16.1 9.2-22s14.7-8.3 22-9.2c3.7-.5 7-.5 9.3-.5c1.2 0 2.1 .1 2.8 .1c.6 0 1 .1 1 .1c0 .1 0 .5 .1 1c0 .7 .1 1.7 .1 2.9c0 .6 0 1.3 0 1.9c0 .7 0 1.4-.1 2.1c-.1 1.6-.2 3.3-.4 5.2c-.9 7.3-3.3 16.1-9.2 22.1s-14.7 8.3-22 9.2c-3.7 .5-7 .5-9.3 .5c-1.2 0-2.1-.1-2.8-.1c-.6 0-1-.1-1-.1c0-.1 0-.4-.1-1c0-.7-.1-1.7-.1-2.9c0-.6 0-1.3 0-2c0-.7 0-1.4 .1-2.1zm64.1 72s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6z','M320 80c0-40 40-80 40-80s40 32 40 80c0 .7 0 1.3 0 2c2-1.9 4-3.9 6-5.9c20.5-20.5 41.8-45.8 51.9-69.5l44.1 18.9c-13.9 32.4-40.6 63-62.1 84.5c-.7 .7-1.5 1.5-2.2 2.2c44.8 3 74.3 39.8 74.3 39.8s-40 40-80 40c-33.9 0-44.3-11-61.7-29.4c0 0 0 0 0 0c-3.1-3.3-6.5-6.9-10.3-10.6s-7.3-7.1-10.6-10.3c0 0 0 0 0 0C331 124.3 320 113.9 320 80zM182.4 137.6s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm-32 96s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm54.4 99.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6 28.8s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm-169.6 3.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6 28.8s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm54.4-156.8c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2zm73.6 28.8s2.3 23.3-9.6 35.2s-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6zm54.4 99.2c-11.9 11.9-35.2 9.6-35.2 9.6s-2.3-23.3 9.6-35.2s35.2-9.6 35.2-9.6s2.3 23.3-9.6 35.2z']
      
    ]
  };

  

  
  

  var faArrowLeftFromLine = {
    prefix: 'fasds',
    iconName: 'arrow-left-from-line',
    icon: [
      448,
      512,
      [8612,"arrow-from-right"],
      'f344',
      
      ['M384 65.4l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M1.4 257.4L24 234.7l128-128 22.6-22.6 45.3 45.3L197.3 152l-73.4 73.4 162.7 0 32 0 0 64-32 0-162.7 0 73.4 73.4 22.6 22.6-45.3 45.3L152 408 24 280 1.4 257.4z']
      
    ]
  };

  
    var faArrowFromRight = faArrowLeftFromLine;
  

  
  

  var faSpa = {
    prefix: 'fasds',
    iconName: 'spa',
    icon: [
      576,
      512,
      [],
      'f5bb',
      
      ['M183.6 235.6C208.9 99.8 288 32 288 32s79.2 67.9 104.4 203.6c-21.9 13.5-41.9 29.9-59.4 48.6c-8.8 9.3-17 19.3-24.5 29.8c-3.8 5.2-7.3 10.6-10.8 16.1s-6.7 11.1-9.7 16.9c-24.4-45.9-60.7-84.2-104.4-111.3z','M30 192L0 192C0 351.1 128.9 480 288 480s288-128.9 288-288l-30 0c-110.8 0-208.5 62-258 154.9C238.5 254 140.8 192 30 192z']
      
    ]
  };

  

  
  

  var faScroll = {
    prefix: 'fasds',
    iconName: 'scroll',
    icon: [
      576,
      512,
      [128220],
      'f70e',
      
      ['M64 32l352 0c35.3 0 64 28.7 64 64l0 256-192 0 0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-240 0-64c0-35.3-28.7-64-64-64z','M128 96l0 64L0 160 0 96C0 60.7 28.7 32 64 32s64 28.7 64 64zM288 400l0-48 288 0 0 32c0 53-43 96-96 96l-272 0c44.2 0 80-35.8 80-80z']
      
    ]
  };

  

  
  

  var faSquareF = {
    prefix: 'fasds',
    iconName: 'square-f',
    icon: [
      448,
      512,
      [],
      'e270',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 144 0 24 0 0 48-24 0-120 0 0 64 88 0 24 0 0 48-24 0-88 0 0 72 0 24-48 0 0-24 0-96 0-112 0-24z','M128 128l24 0 144 0 24 0 0 48-24 0-120 0 0 64 88 0 24 0 0 48-24 0-88 0 0 72 0 24-48 0 0-24 0-96 0-112 0-24z']
      
    ]
  };

  

  
  

  var faBoxOpen = {
    prefix: 'fasds',
    iconName: 'box-open',
    icon: [
      640,
      512,
      [],
      'f49e',
      
      ['M0 160L64 32 320 64 224 224 64 178.3C42.7 172.2 21.3 166.1 0 160zM320 64L576 32l64 128c-21.3 6.1-42.7 12.2-64 18.3c-53.3 15.2-106.7 30.5-160 45.7L320 64z','M320 64L224 224 64 178.3 64 416l256 64 256-64 0-237.7L416 224 320 64z']
      
    ]
  };

  

  
  

  var faKerning = {
    prefix: 'fasds',
    iconName: 'kerning',
    icon: [
      640,
      512,
      [],
      'f86f',
      
      ['M2.8 96L130.5 396.5l8.3 19.5 42.3 0 8.3-19.5L317.2 96l-69.5 0L160 302.2 72.4 96 2.8 96zm320 320l69.5 0 27.2-64 120.9 0 27.2 64 69.5 0L509.4 115.5 501.2 96l-42.3 0-8.3 19.5L322.8 416zM446.8 288L480 209.8 513.2 288l-66.5 0z','M201.3 489.6l208-480 29.4 12.7-208 480-29.4-12.7z']
      
    ]
  };

  

  
  

  var faLightEmergencyOn = {
    prefix: 'fasds',
    iconName: 'light-emergency-on',
    icon: [
      640,
      512,
      [],
      'e420',
      
      ['M160 192l0 160 320 0 0-160c0-88.4-71.6-160-160-160s-160 71.6-160 160zm48 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80l-32 0z','M69.3 36l-20-13.3L22.7 62.7 42.7 76l48 32 20 13.3 26.6-39.9L117.3 68l-48-32zM597.3 76l20-13.3L590.7 22.7 570.7 36l-48 32-20 13.3 26.6 39.9 20-13.3 48-32zM24 192L0 192l0 48 24 0 64 0 24 0 0-48-24 0-64 0zm528 0l-24 0 0 48 24 0 64 0 24 0 0-48-24 0-64 0zm-8 160L96 352l0 128 448 0 0-128z']
      
    ]
  };

  

  
  

  var faSquareArrowUpRight = {
    prefix: 'fasds',
    iconName: 'square-arrow-up-right',
    icon: [
      448,
      512,
      ["external-link-square"],
      'f14c',
      
      ['M0 32l448 0 0 448L0 480 0 32zM102.1 344L136 377.9l17-17 135-135L288 328l0 24 48 0 0-24 0-160 0-24-24 0-152 0-24 0 0 48 24 0 94.1 0L119 327l-17 17z','M336 144l-24 0-152 0-24 0 0 48 24 0 94.1 0L119 327l-17 17L136 377.9l17-17 135-135L288 328l0 24 48 0 0-24 0-160 0-24z']
      
    ]
  };

  
    var faExternalLinkSquare = faSquareArrowUpRight;
  

  
  

  var faBanjo = {
    prefix: 'fasds',
    iconName: 'banjo',
    icon: [
      512,
      512,
      [129685],
      'f8a3',
      
      ['M24.1 313.9c.1-2 .2-4 .3-6c.3-4 .7-8 1.3-11.9c4.1-28.5 15.3-54.6 31.7-76.6c9.6-12.9 21.1-24.3 33.9-33.9c22-16.5 48.2-27.7 76.6-31.7c7.8-1.1 15.9-1.7 24-1.7s16.2 .6 24 1.7c25.7 3.7 49.5 13.1 70 27c17.8 12.1 33.2 27.4 45.3 45.3c13.9 20.5 23.4 44.3 27 70c1.1 7.8 1.7 15.9 1.7 24s-.6 16.2-1.7 24c-4.1 28.5-15.3 54.6-31.7 76.6c-9.6 12.9-21.1 24.3-33.9 33.9c-22 16.5-48.2 27.7-76.6 31.7c-7.8 1.1-15.9 1.7-24 1.7s-16.2-.6-24-1.7c-28.5-4.1-54.6-15.3-76.6-31.7c-12.9-9.6-24.3-21.1-33.9-33.9C41 398.6 29.8 372.5 25.7 344c-1.1-7.8-1.7-15.9-1.7-24c0-2 0-4.1 .1-6.1zM80 320a112 112 0 1 0 224 0A112 112 0 1 0 80 320z','M376 64l-8.9 35.7L286 180.7c17.8 12.1 33.2 27.4 45.3 45.3l81.1-81.1L448 136l64-72L448 0 376 64zM358.3 296c1.1 7.8 1.7 15.9 1.7 24s-.6 16.2-1.7 24l1.7 0 24 0 0-48-24 0-1.7 0zM326.6 420.6c-9.6 12.9-21.1 24.3-33.9 33.9l1.2 1.2 17 17 33.9-33.9-17-17-1.2-1.2zM216 486.3c-7.8 1.1-15.9 1.7-24 1.7s-16.2-.6-24-1.7l0 1.7 0 24 48 0 0-24 0-1.7zM91.4 454.6c-12.9-9.6-24.3-21.1-33.9-33.9l-1.2 1.2-17 17 33.9 33.9 17-17 1.2-1.2zM25.7 344c-1.1-7.8-1.7-15.9-1.7-24s.6-16.2 1.7-24L24 296 0 296l0 48 24 0 1.7 0zM57.4 219.4c9.6-12.9 21.1-24.3 33.9-33.9l-1.2-1.2-17-17L39.3 201.2l17 17 1.2 1.2zM168 153.7c7.8-1.1 15.9-1.7 24-1.7s16.2 .6 24 1.7l0-1.7 0-24-48 0 0 24 0 1.7zm-12.7 155L144 297.4 121.4 320l11.3 11.3 48 48L192 390.6 214.6 368l-11.3-11.3-48-48z']
      
    ]
  };

  

  
  

  var faFileImport = {
    prefix: 'fasds',
    iconName: 'file-import',
    icon: [
      512,
      512,
      ["arrow-right-to-file"],
      'f56f',
      
      ['M128 0L352 0l0 160 160 0 0 352-384 0 0-176 174.1 0-39 39-17 17L280 425.9l17-17 80-80 17-17-17-17-80-80-17-17L246.1 232l17 17 39 39L128 288 128 0z','M512 160L352 0l0 160 160 0zM297 215l-17-17L246.1 232l17 17 39 39L24 288 0 288l0 48 24 0 278.1 0-39 39-17 17L280 425.9l17-17 80-80 17-17-17-17-80-80z']
      
    ]
  };

  
    var faArrowRightToFile = faFileImport;
  

  
  

  var faCommentPen = {
    prefix: 'fasds',
    iconName: 'comment-pen',
    icon: [
      512,
      512,
      ["comment-edit"],
      'f4ae',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160 96.1l7.9-55.3 85.2-85.2L300.4 243l-85.2 85.2L160 336.1zM275.7 173.1L304.8 144l47.3 47.3L323 220.4l-47.3-47.3z','M352.1 191.4L304.8 144l-29.1 29.1L323 220.4l29.1-29.1zM300.4 243l-47.3-47.3-85.2 85.2L160 336.1l55.3-7.9L300.4 243z']
      
    ]
  };

  
    var faCommentEdit = faCommentPen;
  

  
  

  var faCircleArrowDown = {
    prefix: 'fasds',
    iconName: 'circle-arrow-down',
    icon: [
      512,
      512,
      ["arrow-circle-down"],
      'f0ab',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm110.1 8c11.3-11.3 22.6-22.6 33.9-33.9l17 17 71 71c0-60.7 0-121.4 0-182.1c0-8 0-16 0-24c16 0 32 0 48 0c0 8 0 16 0 24c0 60.7 0 121.4 0 182.1c23.7-23.7 47.3-47.3 71-71c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-37.3 37.3-74.7 74.7-112 112c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-37.3-37.3-74.7-74.7-112-112c-5.7-5.7-11.3-11.3-17-17z','M256 409.9l17-17L385 281l17-17L368 230.1l-17 17-71 71L280 136l0-24-48 0 0 24 0 182.1-71-71-17-17L110.1 264l17 17L239 393l17 17z']
      
    ]
  };

  
    var faArrowCircleDown = faCircleArrowDown;
  

  
  

  var faCameraRetro = {
    prefix: 'fasds',
    iconName: 'camera-retro',
    icon: [
      512,
      512,
      [128247],
      'f083',
      
      ['M0 64l64 0 96 0 32 0 64-32 256 0 0 128-256 0L0 160 0 64z','M64 32l96 0 0 32L64 64l0-32zM0 480L0 160l512 0 0 320L0 480zm256-80a96 96 0 1 0 0-192 96 96 0 1 0 0 192z']
      
    ]
  };

  

  
  

  var faFilterCircleDollar = {
    prefix: 'fasds',
    iconName: 'filter-circle-dollar',
    icon: [
      576,
      512,
      ["funnel-dollar"],
      'f662',
      
      ['M0 0L0 64 192 288l0 96 81.9 61.4C262.4 422.1 256 395.8 256 368c0-86.2 62-157.9 143.8-173.1L512 64l0-64L0 0z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L372 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z']
      
    ]
  };

  
    var faFunnelDollar = faFilterCircleDollar;
  

  
  

  var faBinaryLock = {
    prefix: 'fasds',
    iconName: 'binary-lock',
    icon: [
      640,
      512,
      [],
      'e33d',
      
      ['M0 0L32 0 160 0l32 0 0 32 0 160 0 32-32 0L32 224 0 224l0-32L0 32 0 0zM0 288l32 0 48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0L0 512l0-64 32 0 16 0 0-96-16 0L0 352l0-64zM64 64l0 96 64 0 0-96L64 64zM192 288l32 0 128 0 32 0 0 32 0 160 0 32-32 0-128 0-32 0 0-32 0-160 0-32zM224 0l32 0 48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-96-16 0-32 0 0-64zm32 352l0 96 64 0 0-96-64 0z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fasds',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      ['M214.1 72L248 105.9l17-17 32-32 17-17L280 6.1 263 23 231 55l-17 17zm96 96L344 201.9l17-17L489 57l17-17L472 6.1 455 23 327 151l-17 17zm96 96L440 297.9l17-17 32-32 17-17L472 198.1l-17 17-32 32-17 17z','M193.5 144l59.8 121.1 133.7 19.4-96.7 94.3L313 512 193.5 449.1 73.9 512 96.7 378.9 0 284.6l133.7-19.4L193.5 144z']
      
    ]
  };

  

  
  

  var faPersonSkating = {
    prefix: 'fasds',
    iconName: 'person-skating',
    icon: [
      448,
      512,
      ["skating"],
      'f7c5',
      
      ['M1.4 408l11.3 11.3 72 72 8.2 8.2 10.3-5.2 32-16 14.3-7.2-14.3-28.6-14.3 7.2L99.2 460.5 35.3 396.7 24 385.4 1.4 408zM272 480l0 32 16 0 104 0 12.5 0 3-12.1 8-32 3.9-15.5-31-7.8-3.9 15.5-5 19.9L288 480l-16 0z','M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 96l32 0 160 0 13.3 0 9.4 9.4 19.3 19.3 23.4 23.4-24.2 22.6-83.4 77.8 64.9 64.9 9.4 9.4 0 13.3 0 80 0 32-64 0 0-32 0-66.7-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17L160 160l-32 0 0-64zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7L104 421.3 58.7 376l22.6-22.6z']
      
    ]
  };

  
    var faSkating = faPersonSkating;
  

  
  

  var faSuitcase = {
    prefix: 'fasds',
    iconName: 'suitcase',
    icon: [
      512,
      512,
      [129523],
      'f0f2',
      
      ['M96 96l32 0 0 32 0 352-32 0L96 96zm288 0l32 0 0 384-32 0 0-352 0-32z','M152 0L128 0l0 24 0 72 0 32 0 352 256 0 0-352 0-32 0-72 0-24L360 0 152 0zM336 96L176 96l0-48 160 0 0 48zM0 96L0 480l96 0L96 96 0 96zM512 480l0-384-96 0 0 384 96 0z']
      
    ]
  };

  

  
  

  var faReplyAll = {
    prefix: 'fasds',
    iconName: 'reply-all',
    icon: [
      576,
      512,
      ["mail-reply-all"],
      'f122',
      
      ['M0 208L192 32l32 0 0 88-96 88 96 88 0 88-32 0L0 208z','M128 208L320 384l32 0 0-96 16 0c61.9 0 112 50.1 112 112c0 48-32 80-32 80s128-48 128-176c0-97.2-78.8-176-176-176l-48 0 0-96-32 0L128 208z']
      
    ]
  };

  
    var faMailReplyAll = faReplyAll;
  

  
  

  var faCrystalBall = {
    prefix: 'fasds',
    iconName: 'crystal-ball',
    icon: [
      448,
      512,
      [],
      'e362',
      
      ['M0 224c0 71.4 33.4 135 85.4 176l277.2 0c52-41 85.4-104.6 85.4-176C448 100.3 347.7 0 224 0S0 100.3 0 224zm96-96l46.7-17.3L160 64l17.3 46.7L224 128l-46.7 17.3L160 192l-17.3-46.7L96 128zm112 80l70.1-25.9L304 112l25.9 70.1L400 208l-70.1 25.9L304 304l-25.9-70.1L208 208z','M362.6 400H85.4L0 512H448L362.6 400z']
      
    ]
  };

  

  
  

  var faCertificate = {
    prefix: 'fasds',
    iconName: 'certificate',
    icon: [
      512,
      512,
      [],
      'f0a3',
      
      ['M187.4 0L256 57.2 324.6 0l30.8 83.9 88-15.3-15.3 88L512 187.4 454.8 256 512 324.6l-83.9 30.8 15.3 88-88-15.3L324.6 512 256 454.8 187.4 512l-30.8-83.9-88 15.3 15.3-88L0 324.6 57.2 256 0 187.4l83.9-30.8-15.3-88 88 15.3L187.4 0z','']
      
    ]
  };

  

  
  

  var faTentArrowDownToLine = {
    prefix: 'fasds',
    iconName: 'tent-arrow-down-to-line',
    icon: [
      640,
      512,
      [],
      'e57e',
      
      ['M164.6 448L192 256 384 128 576 256l27.4 192-142.6 0L384 320l0 128-219.4 0z','M225 153l17-17L208 102.1l-17 17-23 23L168 24l0-24L120 0l0 24 0 118.1L97 119l-17-17L46.1 136l17 17 64 64 17 17 17-17 64-64zM32 448L0 448l0 64 32 0 576 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  

  
  

  var faArrowDownLong = {
    prefix: 'fasds',
    iconName: 'arrow-down-long',
    icon: [
      384,
      512,
      ["long-arrow-down"],
      'f175',
      
      ['M160 0l0 32 0 357.5 32 32 32-32L224 32l0-32L160 0z','M192 512l-22.6-22.6-128-128L18.7 338.7 64 293.5l22.6 22.6L192 421.5 297.4 316.1 320 293.5l45.3 45.3-22.6 22.6-128 128L192 512z']
      
    ]
  };

  
    var faLongArrowDown = faArrowDownLong;
  

  
  

  var faUpToBracket = {
    prefix: 'fasds',
    iconName: 'up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66e',
      
      ['M0 0L0 32 0 160l0 32 64 0 0-32 0-96 320 0 0 96 0 32 64 0 0-32 0-128 0-32L416 0 32 0 0 0z','M224 160L64 320l0 32 96 0 0 160 128 0 0-160 96 0 0-32L224 160z']
      
    ]
  };

  

  
  

  var faUserTie = {
    prefix: 'fasds',
    iconName: 'user-tie',
    icon: [
      448,
      512,
      [],
      'f508',
      
      ['M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z','M176 304l33.1 55.2L175.8 483.1 135.8 320 64 320 0 512l168 0 14.9 0 82.3 0 14.9 0 168 0L384 320l-71.8 0L272.2 483.1 238.9 359.2 272 304l-48 0-48 0z']
      
    ]
  };

  

  
  

  var faSquarePersonConfined = {
    prefix: 'fasds',
    iconName: 'square-person-confined',
    icon: [
      448,
      512,
      [],
      'e577',
      
      ['M0 32l448 0 0 448L0 480 0 32zM76.2 416l71.6 0 8.8-17.7 12-24 12-24 4.1-8.3 54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9L352 224l0-32-32 0-32 0-13.3 0-9.4 9.4-16 16-9.4 9.4 0 13.3 0 66.7-41.4-41.4-51.2 8.3-24 48-12 24-12 24-12 24L76.2 416zM256 144c0 .8 0 .4 0 0z','M208 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm66.7 96l13.3 0 32 0 32 0 0 32 0 126.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-4.1 8.3-12 24-12 24L147.8 416l-71.6 0 11.2-22.3 12-24 12-24 12-24 24-48 51.2-8.3L240 306.7l0-66.7 0-13.3 9.4-9.4 16-16 9.4-9.4z']
      
    ]
  };

  

  
  

  var faViruses = {
    prefix: 'fasds',
    iconName: 'viruses',
    icon: [
      640,
      512,
      [],
      'e076',
      
      ['M0 168l0 24 0 24 24 0 13.5 0c35.6 0 53.5 43.1 28.3 68.3l-9.5 9.5-17 17 17 17 17 17 17-17 9.5-9.5c25.2-25.2 68.3-7.4 68.3 28.3l0 13.5 0 24 24 0 24 0 0-24 0-13.5c0-35.6 43.1-53.5 68.3-28.3l9.5 9.5 17 17 17-17 17-17-17-17-9.5-9.5C293 259.1 310.9 216 346.5 216l13.5 0 24 0 0-24 0-24-24 0-13.5 0c-35.6 0-53.5-43.1-28.3-68.3l9.5-9.5 17-17-17-17c-5.7-5.7-11.3-11.3-17-17l-17 17-9.5 9.5C259.1 91 216 73.1 216 37.5L216 24l0-24L192 0 168 0l0 24 0 13.5c0 35.6-43.1 53.5-68.3 28.3c-3.2-3.2-6.4-6.4-9.6-9.6l-17-17-17 17-17 17 17 17 9.5 9.5C91 124.9 73.1 168 37.5 168L24 168 0 168zm192-8a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64 48a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM448 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M160 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm437.8 74.2l-11.3-11.3-11.3 11.3C551.9 289.5 512 273 512 240l0-16-16 0-16 0 0 16c0 33-39.9 49.5-63.2 26.2l-11.3-11.3-11.3 11.3s0 0 0 0l-11.3 11.3 11.3 11.3C417.5 312.1 401 352 368 352l-16 0 0 16 0 16 16 0c33 0 49.5 39.9 26.2 63.2l-11.3 11.3 11.3 11.3s0 0 0 0l11.3 11.3 11.3-11.3C440.1 446.5 480 463 480 496l0 16 16 0 16 0 0-16c0-33 39.9-49.5 63.2-26.2l11.3 11.3 11.3-11.3 11.3-11.3-11.3-11.3C574.5 423.9 591 384 624 384l16 0 0-16 0-16-16 0c-33 0-49.5-39.9-26.2-63.2l11.3-11.3-11.3-11.3zM448 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z']
      
    ]
  };

  

  
  

  var faBatteryExclamation = {
    prefix: 'fasds',
    iconName: 'battery-exclamation',
    icon: [
      576,
      512,
      [],
      'e0b0',
      
      ['M0 96l0 64L0 352l0 64 64 0 128 0 0-64L64 352l0-192 144 0 0-64L64 96 0 96zm336 0l0 64 144 0 0 192-128 0 0 64 128 0 64 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L336 96z','M296 120l0-24-48 0 0 24 0 176 0 24 48 0 0-24 0-176zm8 232l-64 0 0 64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faSterlingSign = {
    prefix: 'fasds',
    iconName: 'sterling-sign',
    icon: [
      320,
      512,
      [163,"gbp","pound-sign"],
      'f154',
      
      ['M0 224l0 64 48 0 0-64L0 224zm112 0l0 64 144 0 0-64-144 0z','M173.9 96c-34.2 0-61.9 27.7-61.9 61.9L112 344l0 7.6-3.4 6.8L79.8 416 288 416l32 0 0 64-32 0L32 480 0 480l0-32 0-8 0-7.6 3.4-6.8L48 336.4l0-178.5C48 88.4 104.4 32 173.9 32c16 0 31.9 3.1 46.8 9l63.2 25.3 29.7 11.9-23.8 59.4-29.7-11.9-63.2-25.3c-7.3-2.9-15.1-4.4-23-4.4z']
      
    ]
  };

  
    var faGbp = faSterlingSign;
  
    var faPoundSign = faSterlingSign;
  

  
  

  var faSmoke = {
    prefix: 'fasds',
    iconName: 'smoke',
    icon: [
      640,
      512,
      [],
      'f760',
      
      ['M32 128c0 32 11.7 61.2 31.1 83.6C87.3 199.1 114.8 192 144 192c9.6 0 19.1 .8 28.3 2.3C196.5 136.6 253.5 96 320 96c27.2 0 52.7 6.8 75.1 18.7c9.3-9.9 19.8-18.6 31.2-25.9C403.4 54.5 364.3 32 320 32c-22 0-42.6 5.5-60.7 15.3C235.9 18.4 200.1 0 160 0C89.3 0 32 57.3 32 128zm171.7 74.4c10.7 3.9 20.9 8.7 30.5 14.5C259.1 201.1 288.5 192 320 192c52.7 0 99.5 25.5 128.6 64.8c5.1-.5 10.2-.8 15.4-.8c52.9 0 99.1 28.5 124.1 70.9C619.6 303.6 640 266.2 640 224c0-70.7-57.3-128-128-128c-46.5 0-87.3 24.8-109.7 62c-22.3-18.7-51-30-82.3-30c-51.6 0-96 30.5-116.3 74.4z','M0 512l144 0 320 0 112 0 0-112c0-61.9-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C411.8 251.7 369.1 224 320 224c-32.6 0-62.4 12.2-85.1 32.3C210.1 236.1 178.5 224 144 224C64.5 224 0 288.5 0 368L0 512z']
      
    ]
  };

  

  
  

  var faMaskSnorkel = {
    prefix: 'fasds',
    iconName: 'mask-snorkel',
    icon: [
      576,
      512,
      [],
      'e3b7',
      
      ['M304 352l0 32c0 70.7 57.3 128 128 128l8 0c75.1 0 136-60.9 136-136l0-184-64 0 0 184c0 39.8-32.2 72-72 72l-8 0c-35.3 0-64-28.7-64-64l0-32-64 0zM512 32l0 32 0 96 64 0 0-96 0-32-64 0z','M0 64L0 288l176 0 32-64 32 0 32 64 176 0 0-224L0 64zm576 96l-64 0 0 32 64 0 0-32z']
      
    ]
  };

  

  
  

  var faImageSlash = {
    prefix: 'fasds',
    iconName: 'image-slash',
    icon: [
      640,
      512,
      [],
      'e1b7',
      
      ['M64 146.4L64 480l423.4 0-81.2-64-113.3 0L280 416l-32 0-24 0-72 0-24 0 0-24 0-8 0-9.3 6.2-6.9 80-88 8-8.8L64 146.4zM70.5 32l87.1 67.6c5.7-2.3 11.8-3.6 18.3-3.6c26.5 0 48 21.5 48 48c0 2.3-.2 4.6-.5 6.8c34.6 26.9 69.3 53.8 103.9 80.7l21-29.4L368 174.7l19.5 27.3 120 168 1.9 2.7c22.2 17.2 44.4 34.4 66.5 51.7L576 32 70.5 32z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faPersonWalkingDashedLineArrowRight = {
    prefix: 'fasds',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
      640,
      512,
      [],
      'e553',
      
      ['M2.7 464L48 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 15.7-39.3-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6L68.7 398 25.4 441.4 2.7 464zM7.5 260.2l60.7 20.2 10.1-30.4 11.5-34.6 36.7-16.3-17 63.6c-5.6 21.1-.1 43.6 14.7 59.7l70.9 77.4 22 80.5 8.4 30.9 61.7-16.8-8.4-30.9-24-88-2-7.5-5.2-5.7-52.3-57 18.4-62.4 13.7 27.4 4.8 9.5 9.5 4.8 48 24 28.6-57.2-38.5-19.2-35.2-70.5-7-14-15.3-3.1-80-16-10-2-9.3 4.1-72 32-12.9 5.7-4.5 13.4-16 48L7.5 260.2zM160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M416 0l0 24 0 48 0 24-48 0 0-24 0-48 0-24 48 0zm96 130.7l22.6 22.6 80 80L637.3 256l-22.6 22.6-80 80L512 381.3 466.7 336l22.6-22.6L514.7 288 384 288l-32 0 0-64 32 0 130.7 0-25.4-25.4L466.7 176 512 130.7zM416 152l0 16 0 24-48 0 0-24 0-16 0-24 48 0 0 24zm0 168l0 24 0 16 0 24-48 0 0-24 0-16 0-24 48 0zm0 120l0 48 0 24-48 0 0-24 0-48 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faStocking = {
    prefix: 'fasds',
    iconName: 'stocking',
    icon: [
      384,
      512,
      [],
      'f7d5',
      
      ['M0 386.9l0 2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6l66-44c-20.4-20.3-33-48.3-33-79.4c0-61.9 50.1-112 112-112c5.4 0 10.8 .4 16 1.1L352 96 96 96l0 160L55.7 282.9C20.9 306.1 0 345.1 0 386.9z','M384 0L64 0l0 96 320 0 0-96zM352 384l0-126.9c-5.2-.7-10.6-1.1-16-1.1c-61.9 0-112 50.1-112 112c0 31 12.6 59.1 33 79.4L352 384z']
      
    ]
  };

  

  
  

  var faTeddyBear = {
    prefix: 'fasds',
    iconName: 'teddy-bear',
    icon: [
      576,
      512,
      [],
      'e3cf',
      
      ['M128 56c0 21.8 12.5 40.7 30.7 49.9l77.5-70.4C228 14.7 207.7 0 184 0c-30.9 0-56 25.1-56 56zm64 328c0 10.7 0 21.3 0 32l192 0 0-32-32-32-128 0c-10.7 10.7-21.3 21.3-32 32zm32-208c0 26.5 28.7 48 64 48s64-21.5 64-48s-28.7-48-64-48s-64 21.5-64 48zm32-8c0-13.3 14.3-24 32-24c8.8 0 16.8 2.7 22.6 7c2.9 2.2 5.2 4.8 6.9 7.6c.8 1.4 1.4 2.9 1.9 4.5c.2 .8 .4 1.6 .5 2.4c.1 .4 .1 .8 .1 1.2s0 .8 0 1.3c0 .4 0 .8 0 1.2s-.1 .8-.1 1.2c-.1 .8-.3 1.6-.5 2.4c-.4 1.6-1.1 3.1-1.9 4.5c-1.6 2.9-4 5.5-6.9 7.6c-5.8 4.3-13.8 7-22.6 7c-17.7 0-32-10.7-32-24zM339.9 35.5c25.8 23.5 51.7 47 77.5 70.4C435.5 96.7 448 77.8 448 56c0-30.9-25.1-56-56-56c-23.7 0-44 14.7-52.1 35.5z','M424 128c0 70.7-60.9 128-136 128s-136-57.3-136-128l0-16 88-80 48 0 48 0 88 80 0 16zm-184 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 64c0-26.5-28.7-48-64-48s-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48zm-32-8c0 13.3-14.3 24-32 24s-32-10.7-32-24s14.3-24 32-24s32 10.7 32 24zM88 148.6l29.7 37.7L143.5 219c73.7 93.5 215.4 93.5 289.1 0l25.8-32.7L488 148.6 563.4 208l-29.7 37.7-25.8 32.7c-17.7 22.4-37.9 41.3-59.9 56.7l0 64.9 40 0 8-48 80 16L552 512l-40 0-32 0L96 512l-32 0-40 0L0 368l80-16 8 48 40 0 0-64.9c-22-15.4-42.3-34.3-59.9-56.7L42.3 245.7 12.6 208 88 148.6zM384 384l-32-32-128 0-32 32 0 32 192 0 0-32z']
      
    ]
  };

  

  
  

  var faVolcano = {
    prefix: 'fasds',
    iconName: 'volcano',
    icon: [
      512,
      512,
      [127755],
      'f770',
      
      ['M0 440l0 72 512 0 0-72L418.5 334.8 320 384l-80-64L128 352 96.7 331.2 0 440z','M160 144l48 0 32 48 32 0 32-48 48 0c35.3 0 64-28.7 64-64s-28.7-64-64-64c-15.7 0-30 5.6-41.2 15C299.6 12.4 279.3 0 256 0s-43.6 12.4-54.8 31C190 21.6 175.7 16 160 16c-35.3 0-64 28.7-64 64s28.7 64 64 64zm80 176l80 64 98.5-49.2L320 224l-128 0L96.7 331.2 128 352l112-32z']
      
    ]
  };

  

  
  

  var faLariSign = {
    prefix: 'fasds',
    iconName: 'lari-sign',
    icon: [
      384,
      512,
      [],
      'e1c8',
      
      ['M112 32l0 81.4c19.8-9.1 41.3-14.9 64-16.8L176 32l-64 0zm0 156.1l0 99.9 64 0 0-127c-24 3-46 12.7-64 27.1zM208 32l0 64.7c22.7 1.9 44.2 7.7 64 16.8L272 32l-64 0zm0 129l0 127 64 0 0-99.9c-18-14.4-40-24.1-64-27.1z','M64 288c0-70.7 57.3-128 128-128s128 57.3 128 128l64 0c0-106-86-192-192-192S0 182 0 288c0 49.2 18.5 94 48.9 128L0 416l0 64 192 0 192 0 0-64-192 0c-70.7 0-128-57.3-128-128z']
      
    ]
  };

  

  
  

  var faUserPolice = {
    prefix: 'fasds',
    iconName: 'user-police',
    icon: [
      448,
      512,
      [],
      'e333',
      
      ['M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M80 99.2L80 144c16 10.7 67.2 32 144 32s128-21.3 144-32l0-44.8L400 80l0-32L224 0 48 48l0 32L80 99.2zM227 48.6l32 12.8 5 2 0 5.4c0 17.2-7 46.1-36.9 58.6l-3.1 1.3-3.1-1.3C191 114.9 184 86 184 68.8l0-5.4 5-2 32-12.8 3-1.2 3 1.2zM224 416l-85.3-64L48 352 0 512l448 0L400 352l-90.7 0L224 416zm132.6-1.5l6.1 18.8 19.8 0 14.9 0L385.2 442l-16 11.6 6.2 18.8 4.6 14.1-12-8.8-16-11.7-16 11.7-12 8.8 4.6-14.1 6.2-18.8-16-11.6-12.1-8.7 14.9 0 19.8 0 6.1-18.8 4.6-14.2 4.6 14.2z']
      
    ]
  };

  

  
  

  var faCircleChevronUp = {
    prefix: 'fasds',
    iconName: 'circle-chevron-up',
    icon: [
      512,
      512,
      ["chevron-circle-up"],
      'f139',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm118.1 32c5.7-5.7 11.3-11.3 17-17c34.7-34.7 69.3-69.3 104-104l17-17 17 17c34.7 34.7 69.3 69.3 104 104c5.7 5.7 11.3 11.3 17 17L360 321.9c-5.7-5.7-11.3-11.3-17-17c-29-29-58-58-87-87c-29 29-58 58-87 87c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9z','M256 150.1l17 17L377 271l17 17L360 321.9l-17-17-87-87-87 87-17 17L118.1 288l17-17L239 167l17-17z']
      
    ]
  };

  
    var faChevronCircleUp = faCircleChevronUp;
  

  
  

  var faUpRight = {
    prefix: 'fasds',
    iconName: 'up-right',
    icon: [
      384,
      512,
      [],
      'e2be',
      
      ['M0 368l80 80L232 296l-80-80L0 368z','M368 80V368l-32 32L48 112 80 80H368z']
      
    ]
  };

  

  
  

  var faFileMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'file-magnifying-glass',
    icon: [
      384,
      512,
      ["file-search"],
      'f865',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM80 304c0 53 43 96 96 96c17.8 0 34.4-4.8 48.7-13.2L263 425.1l17 17 33.9-33.9-17-17-38.3-38.3c8.5-14.3 13.3-31 13.3-48.9c0-53-43-96-96-96s-96 43-96 96zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M384 160l-160 0L224 0 384 160zM272 304c0 17.8-4.9 34.5-13.3 48.9L297 391.2l17 17L280 442.1l-17-17-38.4-38.4C210.4 395.2 193.8 400 176 400c-53 0-96-43-96-96s43-96 96-96s96 43 96 96zm-96 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z']
      
    ]
  };

  
    var faFileSearch = faFileMagnifyingGlass;
  

  
  

  var faGearComplex = {
    prefix: 'fasds',
    iconName: 'gear-complex',
    icon: [
      512,
      512,
      [],
      'e5e9',
      
      ['M192 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M302.7 0l-96 0-7 55.7c-16.8 4.7-32.7 11.5-47.5 20L107.6 41 39.7 108.9l35 45c-8.3 14.7-14.8 30.4-19.4 47L-1.3 208l0 96 56.7 7.1c3.9 14.4 9.4 28.2 16.2 41.1L34.1 397.4l79.2 79.2L158 439.5c11.2 6 23 11 35.3 14.9l5.4 57.6 112 0 5.3-56.8c12.7-3.8 24.8-8.8 36.4-14.8l43.7 36.2 79.2-79.2-35.9-43.3c6.3-11.7 11.4-24 15.4-36.9l55.9-5.2 0-112-55.9-5.2c-4.6-15.1-10.9-29.4-18.7-42.8l33.5-43.1L401.8 41 358.3 74.9c-15.2-8.6-31.5-15.3-48.7-19.9L302.7 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z']
      
    ]
  };

  

  
  

  var faUniversalAccess = {
    prefix: 'fasds',
    iconName: 'universal-access',
    icon: [
      512,
      512,
      [],
      'f29a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm121.1-50c5.6-15 11.2-30 16.9-44.9c7.5 2.8 15 5.6 22.5 8.4c20 7.5 39.9 15 59.9 22.5c23.8 0 47.5 0 71.3 0c20-7.5 39.9-15 59.9-22.5c7.5-2.8 15-5.6 22.5-8.4L390.9 206l-22.5 8.4-64 24-.4 .2c0 17.8 0 35.6 0 53.5c10.3 30.8 20.5 61.5 30.8 92.3l7.6 22.8-45.5 15.2-7.6-22.8c-8.8-26.5-17.7-53.1-26.5-79.6c-4.5 0-8.9 0-13.4 0l-26.5 79.6c-2.5 7.6-5.1 15.2-7.6 22.8l-45.5-15.2c2.5-7.6 5.1-15.2 7.6-22.8c10.3-30.8 20.5-61.5 30.8-92.3c0-17.8 0-35.6 0-53.5l-.4-.2-64-24L121.1 206zm95.1-90.1c.1-1.3 .3-2.7 .6-4c.5-2.6 1.3-5.1 2.3-7.5c2-4.8 5-9.1 8.6-12.7C235 84.5 245 80 256 80c22.1 0 40 17.9 40 40s-17.9 40-40 40c-11 0-21-4.5-28.3-11.7c-3.6-3.6-6.5-7.9-8.6-12.7c-1-2.4-1.8-4.9-2.3-7.5c-.3-1.3-.5-2.6-.6-4c-.1-1-.2-2-.2-2L216 120c0-1.4 0-1.7 .1-2.1c0-.7 .1-1.3 .2-2z','M256 80a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM138 161.1l22.5 8.4L220.4 192l71.3 0 59.9-22.5 22.5-8.4L390.9 206l-22.5 8.4-64 24-.4 .2 0 53.5 30.8 92.3 7.6 22.8-45.5 15.2-7.6-22.8L262.7 320l-13.4 0-26.5 79.6-7.6 22.8-45.5-15.2 7.6-22.8L208 292.1l0-53.5-.4-.2-64-24L121.1 206 138 161.1z']
      
    ]
  };

  

  
  

  var faAperture = {
    prefix: 'fasds',
    iconName: 'aperture',
    icon: [
      512,
      512,
      [],
      'e2df',
      
      ['M0 256c0 22.1 2.8 43.5 8.1 64l174 0L54.2 98.5C20.2 141.9 0 196.6 0 256zM220.5 509.6c11.6 1.6 23.5 2.4 35.5 2.4c69.9 0 133.2-28 179.4-73.3L348.4 288 220.5 509.6zM237.5 160l255.9 0C463.8 86.9 401.4 30.6 324.5 9.3L237.5 160z','M256 0c12.1 0 23.9 .8 35.5 2.4L163.6 224 76.6 73.3C122.8 28 186.1 0 256 0zM187.5 502.7C110.6 481.4 48.2 425.1 18.6 352l255.9 0-87 150.7zm270.3-89.2L329.9 192l174 0c5.3 20.5 8.1 41.9 8.1 64c0 59.4-20.2 114.1-54.2 157.5z']
      
    ]
  };

  

  
  

  var faHelicopterSymbol = {
    prefix: 'fasds',
    iconName: 'helicopter-symbol',
    icon: [
      512,
      512,
      [],
      'e502',
      
      ['M2 224l64.7 0C80.1 143.6 143.6 80.1 224 66.7L224 2C108.2 16.4 16.4 108.2 2 224zm0 64C16.4 403.8 108.2 495.6 224 510l0-64.7C143.6 431.9 80.1 368.4 66.7 288L2 288zM288 2l0 64.7C368.4 80.1 431.9 143.6 445.3 224l64.7 0C495.6 108.2 403.8 16.4 288 2zm0 443.4l0 64.7c115.8-14.4 207.6-106.2 222-222l-64.7 0C431.9 368.4 368.4 431.9 288 445.3z','M208 128l0 32 0 64 96 0 0-64 0-32 64 0 0 32 0 192 0 32-64 0 0-32 0-64-96 0 0 64 0 32-64 0 0-32 0-192 0-32 64 0z']
      
    ]
  };

  

  
  

  var faTreeLarge = {
    prefix: 'fasds',
    iconName: 'tree-large',
    icon: [
      448,
      512,
      [],
      'f7dd',
      
      ['M0 480l0 32 192 0 0-288 0-32 64 0 0 32 0 288 192 0 0-32L368 352l56 0 0-32L344 208l48 0 0-32L224 0 56 176l0 32 48 0L24 320l0 32 56 0L0 480z','M256 192l0 32 0 288-64 0 0-288 0-32 64 0z']
      
    ]
  };

  

  
  

  var faBatteryBolt = {
    prefix: 'fasds',
    iconName: 'battery-bolt',
    icon: [
      576,
      512,
      [],
      'f376',
      
      ['M0 96l0 64L0 352l0 64 64 0 105.5 0 20-64L64 352l0-192 159.2 0 84.3-64L64 96 0 96zM236.5 416L480 416l64 0 0-64 0-32 32 0 0-128-32 0 0-32 0-64-64 0L374.5 96l-20 64L480 160l0 192-159.2 0-84.3 64z','M384 264L208 400l40-128H160V248L336 112 296 240h88v24z']
      
    ]
  };

  

  
  

  var faSquareArrowDownLeft = {
    prefix: 'fasds',
    iconName: 'square-arrow-down-left',
    icon: [
      448,
      512,
      [],
      'e261',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 160l48 0 0 24 0 102.1L295 151l17-17L345.9 168l-17 17-135 135 94.1 0 24 0 0 48-24 0-152 0-24 0 0-24 0-160 0-24z','M112 368l24 0 152 0 24 0 0-48-24 0-94.1 0L329 185l17-17L312 134.1l-17 17-135 135L160 184l0-24-48 0 0 24 0 160 0 24z']
      
    ]
  };

  

  
  

  var faFaceLaughBeam = {
    prefix: 'fasds',
    iconName: 'face-laugh-beam',
    icon: [
      512,
      512,
      [128513,"laugh-beam"],
      'f59a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 32l318.4 0c-8 80.9-76.2 144-159.2 144s-151.2-63.1-159.2-144zM120 216c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M120 216c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z']
      
    ]
  };

  
    var faLaughBeam = faFaceLaughBeam;
  

  
  

  var faBinBottles = {
    prefix: 'fasds',
    iconName: 'bin-bottles',
    icon: [
      640,
      512,
      [],
      'e5f5',
      
      ['M32 144l0 48 320 0 0-48-32.4-16.2L256 96 128 96 32 144zM112 32l0 32 16 0 128 0 16 0 0-32-16 0 0-32L128 0l0 32-16 0zM321.8 93.1l44.5 22.3 17.7 8.8 0 19.8 0 48 191.6 0 0-56 0-41.9-64-30 0-64.1-128 0 0 64.1-61.8 29z','M640 224L0 224l0 64 32 0L64 512l512 0 32-224 32 0 0-64z']
      
    ]
  };

  

  
  

  var faMarker = {
    prefix: 'fasds',
    iconName: 'marker',
    icon: [
      512,
      512,
      [],
      'f5a1',
      
      ['M0 512l160-32L304 336c-42.7-42.7-85.3-85.3-128-128L32 352 0 512z','M318.2 65.8l39.3-39.3c17-17 40-26.5 64-26.5c50 0 90.5 40.5 90.5 90.5c0 24-9.5 47-26.5 64L304 336 176 208 284.3 99.7 253 69 145 177l-17 17L94.1 160l17-17L235.8 18.2 252.6 1.4l17 16.7 48.6 47.7z']
      
    ]
  };

  

  
  

  var faKazoo = {
    prefix: 'fasds',
    iconName: 'kazoo',
    icon: [
      640,
      512,
      [],
      'f8c7',
      
      ['M0 192L0 320l219.4 64L382 384c-46.3-23.9-78-72.3-78-128c0-1.7 0-3.5 .1-5.2s.2-3.4 .3-5.2c.2-3.4 .6-6.8 1.1-10.2c1-6.7 2.4-13.3 4.2-19.6c3.7-12.7 9.1-24.8 15.9-35.8C339.3 158 358.8 140 382 128l-162.5 0L0 192zm393.4 32l11.3 11.3L425.4 256l-20.7 20.7L393.4 288 416 310.6l11.3-11.3L448 278.6l20.7 20.7L480 310.6 502.6 288l-11.3-11.3L470.6 256l20.7-20.7L502.6 224 480 201.4l-11.3 11.3L448 233.4l-20.7-20.7L416 201.4 393.4 224zM514 128c46.3 23.9 78 72.3 78 128c0 1.7 0 3.5-.1 5.2s-.2 3.4-.3 5.2c-.2 3.4-.6 6.8-1.1 10.2c-1 6.7-2.4 13.3-4.2 19.6c-3.7 12.7-9.1 24.8-15.9 35.8C556.7 354 537.2 372 514 384l126 0 0-256-126 0z','M448 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-240a96 96 0 1 1 0 192 96 96 0 1 1 0-192z']
      
    ]
  };

  

  
  

  var faIdBadge = {
    prefix: 'fasds',
    iconName: 'id-badge',
    icon: [
      384,
      512,
      [],
      'f2c1',
      
      ['M0 0L0 512l384 0L384 0 0 0zM80 416l32-96 160 0 32 96L80 416zM128 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zM256 224a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M192 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416l32-96 160 0 32 96L80 416z']
      
    ]
  };

  

  
  

  var faNeuter = {
    prefix: 'fasds',
    iconName: 'neuter',
    icon: [
      384,
      512,
      [9906],
      'f22c',
      
      ['M112 176a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1L160 480l0 32 64 0 0-32 0-130.9z']
      
    ]
  };

  

  
  

  var faPersonShelter = {
    prefix: 'fasds',
    iconName: 'person-shelter',
    icon: [
      512,
      512,
      [],
      'e54f',
      
      ['M119.5 361.8l42.3 22.8 11.4-21.1L200 313.5 200 488l0 24 48 0 0-24 0-88 16 0 0 88 0 24 48 0 0-24 0-174.5 26.9 49.9 11.4 21.1 42.3-22.8-11.4-21.1-56-104L318.3 224 304 224l-96 0-14.3 0-6.8 12.6-56 104-11.4 21.1zM216 168a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M64 512l0-330.6 192-108 192 108L448 512l64 0 0-368L256 0 0 144 0 512l64 0z']
      
    ]
  };

  

  
  

  var faIcicles = {
    prefix: 'fasds',
    iconName: 'icicles',
    icon: [
      512,
      512,
      [],
      'f7ad',
      
      ['M336 160c13.3-53.3 26.7-106.7 40-160L512 0 416 512 336 160z','M96 352L0 0H376L288 352 240 192 192 416 144 192 96 352z']
      
    ]
  };

  

  
  

  var faCarWrench = {
    prefix: 'fasds',
    iconName: 'car-wrench',
    icon: [
      512,
      512,
      ["car-mechanic"],
      'f5e3',
      
      ['M3.7 56L80 56l0 48L3.7 104c10.2 32.5 40.5 56 76.3 56c32.8 0 61-19.7 73.3-48l205.3 0c12.3 28.3 40.5 48 73.3 48c35.8 0 66.1-23.5 76.3-56L432 104l0-48 76.3 0C498.1 23.5 467.8 0 432 0c-32.8 0-61 19.7-73.3 48L153.3 48C141 19.7 112.8 0 80 0C44.2 0 13.9 23.5 3.7 56z','M152 160l-22.6 0-7.6 21.2L83.7 288 48 288l0 96 0 64 0 64 80 0 0-64 256 0 0 64 80 0 0-64 0-64 0-96-35.7 0L390.1 181.2 382.6 160 360 160l-208 0zM360.3 288l-208.6 0 22.9-64 162.9 0 22.9 64zM104 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  
    var faCarMechanic = faCarWrench;
  

  
  

  var faChopsticks = {
    prefix: 'fasds',
    iconName: 'chopsticks',
    icon: [
      640,
      512,
      [],
      'e3f7',
      
      ['M0 491l24.6 19.4c90.6-102.9 181.1-205.7 271.7-308.5c-20.2-16.1-40.3-32.3-60.5-48.4C157.2 266 78.6 378.5 0 491zm129-2.8L149.4 512C257 429.4 364.7 346.8 472.3 264.3c-17.8-17.8-35.5-35.5-53.2-53.2c-96.7 92.4-193.4 184.8-290 277.2z','M296.3 201.9l-60.5-48.4L343.1 0l77.5 60.9-124.2 141zm175.9 62.4L419 211 576 61l64 74.6L472.3 264.3z']
      
    ]
  };

  

  
  

  var faCalendarCircleMinus = {
    prefix: 'fasds',
    iconName: 'calendar-circle-minus',
    icon: [
      576,
      512,
      [],
      'e46f',
      
      ['M0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0l0 64L0 64zM0 192L0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0-16 0 0-32 16 0 128 0 16 0 0 32-16 0z']
      
    ]
  };

  

  
  

  var faPlateWheat = {
    prefix: 'fasds',
    iconName: 'plate-wheat',
    icon: [
      512,
      512,
      [],
      'e55a',
      
      ['M0 136l24 0 112 0 24 0 0 48-24 0L24 184 0 184l0-48zM32 64l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm0 144l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zM160 32l16 0c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32zm0 224c0-44.2 35.8-80 80-80l16 0 0 32c0 44.2-35.8 80-80 80l-16 0 0-32zM272 32l16 0c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32zm0 224c0-44.2 35.8-80 80-80l16 0 0 32c0 44.2-35.8 80-80 80l-16 0 0-32zM384 32l16 0c44.2 0 80 35.8 80 80l0 32-16 0c-44.2 0-80-35.8-80-80l0-32zm0 224c0-44.2 35.8-80 80-80l16 0 0 32c0 44.2-35.8 80-80 80l-16 0 0-32z','M512 320L0 320c0 59.6 40.8 109.8 96 124l0 36 320 0 0-36c55.2-14.2 96-64.3 96-124z']
      
    ]
  };

  

  
  

  var faCompassDrafting = {
    prefix: 'fasds',
    iconName: 'compass-drafting',
    icon: [
      512,
      512,
      ["drafting-compass"],
      'f568',
      
      ['M6.6 240l55.4-32c9.8 17 21.9 32.6 35.7 46.4C86.4 273.2 75.2 291.9 64 310.7C41.3 290.4 21.9 266.5 6.6 240zM155.3 365.9L188 309.5c21.5 6.8 44.3 10.5 68 10.5s46.6-3.7 68-10.5c34.5-11 65.4-30.1 90.3-55.1c13.8-13.8 25.8-29.4 35.7-46.4l55.4 32c-15.3 26.5-34.8 50.3-57.5 70.6c-26.5 23.7-57.4 42.6-91.3 55.2C325.4 377.6 291.4 384 256 384s-69.4-6.4-100.7-18.1z','M343.4 135.7c5.5-12.1 8.6-25.5 8.6-39.7c0-53-43-96-96-96s-96 43-96 96c0 14.1 3.1 27.6 8.5 39.7L0 417.8 0 512l91.4-35.8L256 192l68 117.5c34.5-11 65.3-30.1 90.3-55.1L343.4 135.7zM448 310.7c-26.5 23.7-57.4 42.6-91.3 55.2l63.9 110.3L512 512l0-94.2L448 310.7zM224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z']
      
    ]
  };

  
    var faDraftingCompass = faCompassDrafting;
  

  
  

  var faArrowUpToBracket = {
    prefix: 'fasds',
    iconName: 'arrow-up-to-bracket',
    icon: [
      448,
      512,
      [],
      'e66a',
      
      ['M0 0L0 32 0 160l0 32 64 0 0-32 0-96 320 0 0 96 0 32 64 0 0-32 0-128 0-32L416 0 32 0 0 0z','M224 146.7l-22.6 22.6-128 128L50.7 320 96 365.3l22.6-22.6L192 269.3 192 480l0 32 64 0 0-32 0-210.7 73.4 73.4L352 365.3 397.3 320l-22.6-22.6-128-128L224 146.7z']
      
    ]
  };

  

  
  

  var faPhoneRotary = {
    prefix: 'fasds',
    iconName: 'phone-rotary',
    icon: [
      512,
      512,
      [9742],
      'f8d3',
      
      ['M0 128s96-96 256-96s256 96 256 96l0 80-96 0-32-80s-48-24-128-24s-128 24-128 24L96 208 0 208l0-80zM328 312a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z','M32 384l0 96 448 0 0-96L352 160l-192 0L32 384zM256 240a72 72 0 1 1 0 144 72 72 0 1 1 0-144z']
      
    ]
  };

  

  
  

  var faHeadSideHeadphones = {
    prefix: 'fasds',
    iconName: 'head-side-headphones',
    icon: [
      512,
      512,
      [],
      'f8c2',
      
      ['M224.3 0C100.4 0 0 100.4 0 224.3c0 58.7 23 115 64 156.9L64 480l0 32 32 0 192 0 32 0 0-32 0-32 96 0 32 0 0-32 0-96 32 0 32 0 0-32 0-16 0-11.2-7-8.8-57.3-71.7C441.6 79.7 358.1 0 256 0L224.3 0zm0 0L256 0l0 32 0 74.8c37.8 18 64 56.5 64 101.2c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-44.7 26.2-83.2 64-101.2L160 32l0-22.6C180.4 3.3 202 0 224.3 0z','M224.3 0L256 0l0 32 0 74.8c37.8 18 64 56.5 64 101.2c0 61.9-50.1 112-112 112s-112-50.1-112-112c0-44.7 26.2-83.2 64-101.2L160 32l0-22.6C180.4 3.3 202 0 224.3 0zM272 208a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z']
      
    ]
  };

  

  
  

  var faCircleStop = {
    prefix: 'fasds',
    iconName: 'circle-stop',
    icon: [
      512,
      512,
      [62094,"stop-circle"],
      'f28d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-96l192 0 0 192-192 0 0-192z','M160 160h192v192H160V160z']
      
    ]
  };

  
    var faStopCircle = faCircleStop;
  

  
  

  var faBat = {
    prefix: 'fasds',
    iconName: 'bat',
    icon: [
      576,
      512,
      [],
      'f6b5',
      
      ['M196.1 159.7c8.2 3.9 16.3 7.8 24.5 11.7c6.4 3.1 13.5 4.7 20.6 4.7l93.5 0c7.1 0 14.2-1.6 20.6-4.7l24.5-11.7L352 48 320 80l-64 0L224 48 196.1 159.7z','M334.8 176H241.2c-7.1 0-14.2-1.6-20.6-4.7L96 112C34.1 184.3 0 276.3 0 371.5V400l96-48 48 80 64-64 80 112 80-112 64 64 48-80 96 48V371.5c0-95.2-34.1-187.2-96-259.5L355.4 171.3c-6.4 3.1-13.5 4.7-20.6 4.7z']
      
    ]
  };

  

  
  

  var faMoneySimpleFromBracket = {
    prefix: 'fasds',
    iconName: 'money-simple-from-bracket',
    icon: [
      640,
      512,
      [],
      'e313',
      
      ['M128 96l0 416 384 0 0-416L128 96zm96 176c0-44.2 43-80 96-80s96 35.8 96 80s-43 80-96 80s-96-35.8-96-80z','M0 0L32 0 608 0l32 0 0 32 0 128 0 32-64 0 0-32 0-96L64 64l0 96 0 32L0 192l0-32L0 32 0 0z']
      
    ]
  };

  

  
  

  var faHandHoldingCircleDollar = {
    prefix: 'fasds',
    iconName: 'hand-holding-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e621',
      
      ['M0 384L0 512l32 0 192 0 160 0 12.4 0 10.2-7 128-88 33-22.7-45.3-65.9-33 22.7-94.5 65L256 416l0-32 32 0 64 0 32 0 0-64-32 0-64 0-64 0-64 0-11.2 0-8.8 7L68.8 384 0 384z','M272 288A144 144 0 1 0 272 0a144 144 0 1 0 0 288zM248.1 115c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L212 201.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.5 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z']
      
    ]
  };

  

  
  

  var faSquareDashedCirclePlus = {
    prefix: 'fasds',
    iconName: 'square-dashed-circle-plus',
    icon: [
      576,
      512,
      [],
      'e5c2',
      
      ['M0 32L0 64l0 96 64 0 0-64 64 0 0-64L32 32 0 32zM0 192L0 320l64 0 0-128L0 192zM0 352l0 96 0 32 32 0 96 0 0-64-64 0 0-64L0 352zM160 32l0 64 128 0 0-64L160 32zm0 384l0 64 128 0 0-10.8c-11.3-16-19.9-33.9-25.4-53.2L160 416zM320 32l0 64 64 0 0 102.6c15.3-4.3 31.4-6.6 48-6.6c5.4 0 10.7 .2 16 .7L448 64l0-32-32 0-96 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fasds',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm126.1 0L160 222.1c.3 .3 .6 .6 1 1c5.3 5.3 10.7 10.7 16 16c15.7 15.7 31.4 31.4 47 47c37-37 74-74 111-111c5.3-5.3 10.7-10.7 16-16c.3-.3 .6-.6 1-1L385.9 192c-.3 .3-.6 .6-1 1l-16 16L241 337l-17 17-17-17-64-64c-5.3-5.3-10.7-10.7-16-16l-1-1z','M385 193L241 337l-17 17-17-17-80-80L161 223l63 63L351 159 385 193z']
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faChair = {
    prefix: 'fasds',
    iconName: 'chair',
    icon: [
      448,
      512,
      [129681],
      'f6c0',
      
      ['M32 384l0 96 0 32 64 0 0-32 0-96-64 0zM64 0l0 48 0 240 48 0 0-240 40 0 0 240 48 0 0-240 48 0 0 240 48 0 0-240 40 0 0 240 48 0 0-240 0-48L336 0 112 0 64 0zM352 384l0 96 0 32 64 0 0-32 0-96-64 0z','M0 352v32H448V352l-32-64H32L0 352z']
      
    ]
  };

  

  
  

  var faEuroSign = {
    prefix: 'fasds',
    iconName: 'euro-sign',
    icon: [
      320,
      512,
      [8364,"eur","euro"],
      'f153',
      
      ['M0 176l60.3 0c-7.1 20.1-11.3 41.6-12.1 64L0 240l0-64zm0 96l48.1 0c.8 22.4 5 43.9 12.1 64L0 336l0-64zm112.2-32c1.2-23.1 7.5-44.8 17.9-64L288 176l0 64-175.8 0zm0 32L288 272l0 64-157.9 0c-10.4-19.2-16.7-40.9-17.9-64z','M48 248C48 128.7 144.7 32 264 32l24 0 32 0 0 64-32 0-24 0c-83.9 0-152 68.1-152 152l0 16c0 83.9 68.1 152 152 152l24 0 32 0 0 64-32 0-24 0C144.7 480 48 383.3 48 264l0-16z']
      
    ]
  };

  
    var faEur = faEuroSign;
  
    var faEuro = faEuroSign;
  

  
  

  var faEthernet = {
    prefix: 'fasds',
    iconName: 'ethernet',
    icon: [
      512,
      512,
      [],
      'f796',
      
      ['M0 192l64 0 0-64 64 0 0-64 256 0 0 64 64 0 0 64 64 0 0 256-96 0 0-112 0-16-32 0 0 16 0 112-64 0 0-112 0-16-32 0 0 16 0 112-64 0 0-112 0-16-32 0 0 16 0 112-64 0 0-112 0-16-32 0 0 16 0 112L0 448 0 192z','M128 320l0 16 0 112-32 0 0-112 0-16 32 0zm96 0l0 16 0 112-32 0 0-112 0-16 32 0zm96 0l0 16 0 112-32 0 0-112 0-16 32 0zm96 0l0 16 0 112-32 0 0-112 0-16 32 0z']
      
    ]
  };

  

  
  

  var fa360Degrees = {
    prefix: 'fasds',
    iconName: '360-degrees',
    icon: [
      640,
      512,
      [],
      'e2dc',
      
      ['M576 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M320 96L305.7 67.4l28.6-14.3 28.6 57.2-28.5 14.2-.1 .1c-.2 .1-.6 .3-1.2 .7c-1.2 .7-3.1 1.8-5.4 3.3c-4.7 3.1-11 7.8-17.1 14C298.1 155.1 288 171.5 288 192l0 1.6c5.2-1 10.5-1.6 16-1.6c44.2 0 80 35.8 80 80l0 96c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48s0 0 0 0l0-32 0-96c0-43.5 21.9-75.1 41.4-94.6c9.8-9.8 19.6-17.1 26.9-22c3.7-2.5 6.8-4.3 9.1-5.7c1.2-.7 2.1-1.2 2.8-1.6l.9-.5 .3-.2 .1-.1c0 0 0 0 .1 0c0 0 0 0 0 0L320 96zM0 64l32 0 128 0 32 0 0 32 0 8 0 11.8-7.7 9-64 74.6C162.2 215.7 192 256.4 192 304l0 48c0 53-43 96-96 96s-96-43-96-96l64 0c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48l-16 0-32 0 0-32 0-8 0-11.8 7.7-9L97.3 128 32 128 0 128 0 64zm496 64c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16s16-7.2 16-16l0-224c0-8.8-7.2-16-16-16zm-80 16c0-44.2 35.8-80 80-80s80 35.8 80 80l0 224c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-224zM288 272l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16z']
      
    ]
  };

  

  
  

  var faTablets = {
    prefix: 'fasds',
    iconName: 'tablets',
    icon: [
      640,
      512,
      [],
      'f490',
      
      ['M320 160c0 88.4 71.6 160 160 160c38.4 0 73.7-13.5 101.3-36.1L356.1 58.7C333.5 86.3 320 121.6 320 160zM378.7 36.1L603.9 261.3C626.5 233.7 640 198.4 640 160C640 71.6 568.4 0 480 0c-38.4 0-73.7 13.5-101.3 36.1z','M319.2 368L.8 368C8.8 448.9 77 512 160 512s151.2-63.1 159.2-144zm0-32c-8-80.9-76.2-144-159.2-144S8.8 255.1 .8 336l318.4 0z']
      
    ]
  };

  

  
  

  var faLocationArrowUp = {
    prefix: 'fasds',
    iconName: 'location-arrow-up',
    icon: [
      448,
      512,
      [],
      'e63a',
      
      ['M80 480L32 448 224 32 416 448l-48 32L224 368 80 480z','']
      
    ]
  };

  

  
  

  var faArrowUpRightAndArrowDownLeftFromCenter = {
    prefix: 'fasds',
    iconName: 'arrow-up-right-and-arrow-down-left-from-center',
    icon: [
      512,
      512,
      [],
      'e0a0',
      
      ['M0 320l0 32L0 480l0 32 32 0 128 0 32 0 0-64-32 0-50.7 0L214.6 342.6 237.3 320 192 274.7l-22.6 22.6L64 402.7 64 352l0-32L0 320z','M320 0l32 0L480 0l32 0 0 32 0 128 0 32-64 0 0-32 0-50.7L342.6 214.6 320 237.3 274.7 192l22.6-22.6L402.7 64 352 64l-32 0 0-64z']
      
    ]
  };

  

  
  

  var faCirclePlay = {
    prefix: 'fasds',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM176 128L384 256 176 384l0-256z','M176 384V128L384 256 176 384z']
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faCannabis = {
    prefix: 'fasds',
    iconName: 'cannabis',
    icon: [
      512,
      512,
      [],
      'f55f',
      
      ['M7 350.3l25.2 14c14.8 8.2 38.4 19.4 65.5 26c18.9 4.6 40.1 7.3 61.4 4.7l-8.3 33.1-8.5 33.7 31.1-15.5L232 417.2l0 70.8 0 24 48 0 0-24 0-136c0 21.8 0 43.5 0 65.2l58.5 29.1 31.1 15.5-8.5-33.7L352.8 395c21.4 2.5 42.6-.1 61.4-4.7c27.1-6.7 50.7-17.8 65.5-26l25.2-14-25.2-14c-13.8-7.7-35.2-17.8-60-24.6c12.9-14.8 23.9-30.9 33.2-47.1c23.4-40.8 37.1-84 42.7-111.7l4.7-23.5L476.9 134c-27.9 5.5-71.2 19.2-112.2 42.5c-11.8 6.7-23.6 14.3-34.8 22.8C332.9 83.9 256 0 256 0s-76.9 83.9-73.9 199.3c-11.2-8.5-23-16.1-34.8-22.8C106.3 153.2 63 139.6 35.1 134l-23.5-4.7 4.7 23.5c5.6 27.7 19.3 70.9 42.7 111.7c9.3 16.2 20.3 32.4 33.2 47.1c-24.8 6.7-46.2 16.9-60 24.6L7 350.3z','M232 488l0-136 48 0 0 136 0 24-48 0 0-24z']
      
    ]
  };

  

  
  

  var faTruckRampCouch = {
    prefix: 'fasds',
    iconName: 'truck-ramp-couch',
    icon: [
      640,
      512,
      ["truck-couch"],
      'f4dd',
      
      ['M8 252.8l1.7 6.4c8.4-6.7 18.2-11.8 29.2-14.7c37.4-10 75.7 8.2 92.3 41.5L227 260.4c-2.3-37.2 21.8-72.1 59.2-82.1c11-2.9 22.1-3.5 32.6-1.9l-1.7-6.4c-7.7-28.6-33.5-47.5-61.8-47.5c-5.5 0-11.1 .7-16.6 2.2L53.3 174.4C19.1 183.5-1.1 218.6 8 252.8zm5.3 81.4L34 411.5l92.7-24.8 154.5-41.4L320 334.8l0-125.5c-8.1-2.3-16.8-2.5-25.5-.2c-25.6 6.9-40.8 33.2-33.9 58.8l4.1 15.5L110.1 324.8 106 309.3c-6.9-25.6-33.2-40.8-58.8-33.9s-40.8 33.2-33.9 58.8zM448 416a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M416.7 402.5C423.4 338.2 477.9 288 544 288c38.2 0 72.5 16.8 96 43.3L640 0 352 0l0 353.8L31.6 441.1 .7 449.5l16.8 61.7 30.9-8.4L416.7 402.5z']
      
    ]
  };

  
    var faTruckCouch = faTruckRampCouch;
  

  
  

  var faAnglesRight = {
    prefix: 'fasds',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      ['M50.7 96l22.6 22.6L210.7 256 73.4 393.4 50.7 416 96 461.3l22.6-22.6 160-160L301.3 256l-22.6-22.6-160-160L96 50.7 50.7 96z','M493.3 256l-22.6 22.6-160 160L288 461.3 242.7 416l22.6-22.6L402.7 256 265.4 118.6 242.7 96 288 50.7l22.6 22.6 160 160L493.3 256z']
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faSnowplow = {
    prefix: 'fasds',
    iconName: 'snowplow',
    icon: [
      640,
      512,
      [],
      'f7d2',
      
      ['M0 400c0-44.7 26.2-83.2 64-101.2c14.5-6.9 30.8-10.8 48-10.8l256 0c44.7 0 83.2 26.2 101.2 64c6.9 14.5 10.8 30.8 10.8 48c0 61.9-50.1 112-112 112l-256 0C50.1 512 0 461.9 0 400zm64 0c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-256 0c-26.5 0-48 21.5-48 48z','M160 0L128 0l0 32 0 128-64 0 0 138.8c14.5-6.9 30.8-10.8 48-10.8l256 0c44.7 0 83.2 26.2 101.2 64l42.8 0 0 64 0 13.3 9.4 9.4 64 64 45.3-45.3L576 402.7l0-50.7 0-64 0-52.8L633 164l-50-40-64 80-7 8.8 0 11.2 0 64-64 0 0-32 0-32 0-7.6-3.4-6.8-96-192L339.8 0 320 0 160 0zM380.2 224L256 224l-64-64 0-96 108.2 0 80 160zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faAlignSlash = {
    prefix: 'fasds',
    iconName: 'align-slash',
    icon: [
      640,
      512,
      [],
      'f846',
      
      ['M96 32l0 19.8L153 96l391 0 0-64L96 32zm0 139.6L96 224l66.5 0L96 171.6zM96 288l0 64 228.9 0-81.2-64L96 288zm0 128l0 64 391.4 0-81.2-64L96 416zM235.4 160l82.4 64L544 224l0-64-308.6 0zM400.3 288l82.4 64 61.3 0 0-64-143.7 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faOctagonXmark = {
    prefix: 'fasds',
    iconName: 'octagon-xmark',
    icon: [
      512,
      512,
      ["times-octagon","xmark-octagon"],
      'f2f0',
      
      ['M0 160L160 0 352 0 512 160l0 192L352 512l-192 0L0 352 0 160zm158.1 32c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.4 31.4 47 47c-15.7 15.7-31.4 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47l47 47 17 17L353.9 320c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c15.7-15.7 31.4-31.4 47-47c5.7-5.7 11.3-11.3 17-17c-11.3-11.3-22.6-22.6-33.9-33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.4 31.4-47 47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17c-11.3 11.3-22.6 22.6-33.9 33.9z','M337 209l17-17L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faTimesOctagon = faOctagonXmark;
  
    var faXmarkOctagon = faOctagonXmark;
  

  
  

  var faMonument = {
    prefix: 'fasds',
    iconName: 'monument',
    icon: [
      384,
      512,
      [],
      'f5a6',
      
      ['M0 448l32 0 20 0 280 0 20 0 32 0 0 64-32 0L32 512 0 512l0-64z','M96 96L192 0l96 96 44 352L52 448 96 96zM256 272l-128 0 0 48 128 0 0-48z']
      
    ]
  };

  

  
  

  var faRefrigerator = {
    prefix: 'fasds',
    iconName: 'refrigerator',
    icon: [
      384,
      512,
      [],
      'e026',
      
      ['M0 160l0 32 288 0 0-32L0 160zm320 0l0 32 64 0 0-32-64 0z','M384 0L0 0 0 160l288 0 0-48 0-16 32 0 0 16 0 48 64 0L384 0zm0 192l-64 0 0 176 0 16-32 0 0-16 0-176L0 192 0 512l384 0 0-320z']
      
    ]
  };

  

  
  

  var faMinimize = {
    prefix: 'fasds',
    iconName: 'minimize',
    icon: [
      512,
      512,
      ["compress-arrows-alt"],
      'f78c',
      
      ['M0 456l56 56 84-84 52 52 32-32 0-160L64 288 32 320l52 52L0 456zM288 64l0 160 160 0 32-32-52-52 84-84L456 0 372 84 320 32 288 64z','M224 64L192 32 140 84 56 0 0 56l84 84L32 192l32 32 160 0 0-160zm64 384l32 32 52-52 84 84 56-56-84-84 52-52-32-32-160 0 0 160z']
      
    ]
  };

  
    var faCompressArrowsAlt = faMinimize;
  

  
  

  var faSmoking = {
    prefix: 'fasds',
    iconName: 'smoking',
    icon: [
      640,
      512,
      [128684],
      'f48d',
      
      ['M384 0l0 43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9l0 43 64 0 0-43c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43l0-43L384 0zm96 0l0 43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8l0 43 64 0 0-43c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9l0-43L480 0z','M32 352L0 352l0 32 0 96 0 32 32 0 384 0 32 0 0-32 0-96 0-32-32 0L32 352zm192 96l0-32 160 0 0 32-160 0zm320-64l0-32-64 0 0 32 0 96 0 32 64 0 0-32 0-96zm96 0l0-32-64 0 0 32 0 96 0 32 64 0 0-32 0-96z']
      
    ]
  };

  

  
  

  var faDolly = {
    prefix: 'fasds',
    iconName: 'dolly',
    icon: [
      576,
      512,
      ["dolly-box"],
      'f472',
      
      ['M160 416a96 96 0 1 0 191.9 0A96 96 0 1 0 160 416zm74.9-311.9l61.9 190.5c10.9 3.6 21.1 8.7 30.4 15l189.9-61.7-69.2-213L371.8 59.6c6.6 20.3 13.2 40.6 19.8 60.9c-20.3 6.6-40.6 13.2-60.9 19.8L311 79.4c-25.4 8.2-50.7 16.5-76.1 24.7z','M0 0L32 0l96 0 23.1 0 7.3 21.9L257.7 320c-.6 0-1.2 0-1.7 0c-22.2 0-42.7 7.6-59 20.2L104.9 64 32 64 0 64 0 0zM352 416c0-22.2-7.6-42.7-20.2-59l202.1-67.4 30.4-10.1 20.2 60.7-30.4 10.1L352 417.7c0-.6 0-1.2 0-1.7zM371.8 59.6l19.8 60.9-60.9 19.8L311 79.4l60.9-19.8z']
      
    ]
  };

  
    var faDollyBox = faDolly;
  

  
  

  var faGem = {
    prefix: 'fasds',
    iconName: 'gem',
    icon: [
      512,
      512,
      [128142],
      'f3a5',
      
      ['M0 208L112 32l288 0L512 208 256 480 0 208zm48 0l208 24 208-24L299.6 189 376 64 256 177.7 136 64l76.4 125L48 208z','M256 177.7L376 64 299.6 189 464 208 256 232 48 208l164.4-19L136 64 256 177.7z']
      
    ]
  };

  

  
  

  var faHandshake = {
    prefix: 'fasds',
    iconName: 'handshake',
    icon: [
      640,
      512,
      [],
      'f2b5',
      
      ['M189 180.8c18.6 26 37.2 52.1 55.8 78.1l39.1-27.9 57.2-40.8L496.4 332.6 512 346.9 512 128l-1.5 0L426.6 72.1 414.5 64 400 64l-32 0-15.4 0-12.5 8.9c-7.6 5.4-15.2 10.8-22.7 16.2l-89.3 63.8c-13 9.3-26 18.6-39.1 27.9zM544 128l0 256 96 0 0-256-96 0zm64 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M156.2 352L128 352l0-224 96-64 64 0 29.4 25.2-89.3 63.8L189 180.8 244.8 259l39.1-27.9 57.2-40.8L496.4 332.6l18.6 17-63.8 70.2-19.4-17.7-52.9 57.7-35.4-32.4-12.8-11.8-47.7 52.2-35.4-32.4L156.2 352zM0 128l96 0 0 256L0 384 0 128zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faHeadSideMask = {
    prefix: 'fasds',
    iconName: 'head-side-mask',
    icon: [
      576,
      512,
      [],
      'e063',
      
      ['M32 224.3c0-20.3 2.7-39.9 7.7-58.6c77.4 57.5 154.8 115 232.3 172.5c0 57.9 0 115.8 0 173.8l-144 0-32 0 0-32 0-98.8C55 339.3 32 283 32 224.3zM58 119.5C95.6 48.4 170.3 0 256.3 0L288 0C390.1 0 473.6 79.7 479.7 180.3L537 252l7 8.8 0 11.2 0 16-259.1 0C209.2 231.8 133.6 175.6 58 119.5zM352 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M35 102.4l19.3 14.3L284.9 288 544 288l0 32-16 48-160 0-16 0 0 32 16 0 149.3 0-10.7 32L368 432l-16 0 0 32 16 0 128 0-16 48-208 0 0-173.8L25.7 155.3 6.4 141 35 102.4z']
      
    ]
  };

  

  
  

  var faLemon = {
    prefix: 'fasds',
    iconName: 'lemon',
    icon: [
      448,
      512,
      [127819],
      'f094',
      
      ['M0 432l48 48 72.3-24.1c83.7 39.8 181.4 9.9 247.4-56.1s96-163.7 56.1-247.4L448 80 400 32 327.7 56.1C244 16.3 146.2 46.2 80.2 112.2s-96 163.7-56.1 247.4L0 432zM60.1 250.9c1.5-5.1 3-10.2 4.5-15.4c19.1-65.1 73.7-119.8 138.9-138.9c5.1-1.5 10.2-3 15.4-4.5l9 30.7c-5.1 1.5-10.2 3-15.4 4.5c-54.6 16-101.1 62.5-117.1 117.1c-1.5 5.1-3 10.2-4.5 15.4c-10.2-3-20.5-6-30.7-9z','M227.9 122.9l-15.4 4.5c-54.6 16-101.1 62.5-117.1 117.1l-4.5 15.4-30.7-9 4.5-15.4c19.1-65.1 73.7-119.8 138.9-138.9l15.4-4.5 9 30.7z']
      
    ]
  };

  

  
  

  var faTick = {
    prefix: 'fasds',
    iconName: 'tick',
    icon: [
      192,
      512,
      [],
      'e32f',
      
      ['M64 288L32 32H160L128 288H64z','']
      
    ]
  };

  

  
  

  var faSquareA = {
    prefix: 'fasds',
    iconName: 'square-a',
    icon: [
      448,
      512,
      [],
      'e25f',
      
      ['M0 32L0 480l448 0 0-448L0 32zM88.6 384c37.9-80.7 75.8-161.5 113.6-242.2c2.2-4.6 4.3-9.2 6.5-13.8l30.5 0c2.2 4.6 4.3 9.2 6.5 13.8c37.9 80.7 75.8 161.4 113.6 242.2l-53 0-22.5-48-119.7 0-22.5 48-53 0zm98.1-96l74.6 0c-12.4-26.5-24.9-53-37.3-79.5c-12.4 26.5-24.9 53-37.3 79.5z','M239.2 128l-30.5 0-6.5 13.8L88.6 384l53 0 22.5-48 119.7 0 22.5 48 53 0L245.7 141.8 239.2 128zm22.1 160l-74.6 0L224 208.5 261.3 288z']
      
    ]
  };

  

  
  

  var faTableColumns = {
    prefix: 'fasds',
    iconName: 'table-columns',
    icon: [
      512,
      512,
      ["columns"],
      'f0db',
      
      ['M224 160l64 0 0 256-64 0 0-256z','M64 160l0 256 384 0 0-256L64 160zM0 480l0-64L0 96 0 32l64 0 384 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480z']
      
    ]
  };

  
    var faColumns = faTableColumns;
  

  
  

  var faRotateLeft = {
    prefix: 'fasds',
    iconName: 'rotate-left',
    icon: [
      512,
      512,
      ["rotate-back","rotate-backward","undo-alt"],
      'f2ea',
      
      ['M97.6 97.6c87.5-87.5 229.3-87.5 316.8 0C458.1 141.3 480 198.7 480 256s-21.9 114.7-65.6 158.4c-87.5 87.5-229.3 87.5-316.8 0l45.3-45.3c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L97.6 97.6z','M176 224l24-24L40 40 16 64l0 160H176z']
      
    ]
  };

  
    var faRotateBack = faRotateLeft;
  
    var faRotateBackward = faRotateLeft;
  
    var faUndoAlt = faRotateLeft;
  

  
  

  var faMartiniGlass = {
    prefix: 'fasds',
    iconName: 'martini-glass',
    icon: [
      512,
      512,
      [127864,"glass-martini-alt"],
      'f57b',
      
      ['M0 0L0 48 16 64 210.7 258.7 224 272l0 176-64 0-32 0 0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-176 13.3-13.3L496 64l16-16 0-48L448 0 64 0 0 0zM106.5 64l299 0c-21.3 21.3-42.7 42.7-64 64L256 213.5c-28.5-28.5-57-57-85.5-85.5l-64-64z','M341.5 128l-171 0L256 213.5 341.5 128z']
      
    ]
  };

  
    var faGlassMartiniAlt = faMartiniGlass;
  

  
  

  var faBracketSquareRight = {
    prefix: 'fasds',
    iconName: 'bracket-square-right',
    icon: [
      192,
      512,
      [],
      '5d',
      
      ['M192 32l-32 0L64 32 32 32l0 64 32 0 64 0 0 320-64 0-32 0 0 64 32 0 96 0 32 0 0-32 0-384 0-32z','']
      
    ]
  };

  

  
  

  var faArrowUpFromGroundWater = {
    prefix: 'fasds',
    iconName: 'arrow-up-from-ground-water',
    icon: [
      576,
      512,
      [],
      'e4b5',
      
      ['M0 192l192 0 0 223c-13 0-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5l-1.1-.8L96 368 77.4 381.4l-1.1 .8c-13.9 10-23.6 17-35.5 22.5C27.6 410.7 13 415 0 415L0 192zm384 0l192 0 0 223c-13 0-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5L480 368l-19.7 14.2c-13.9 10-23.6 17-35.5 22.5C411.6 410.7 397 415 384 415l0-223z','M320 320l0 32-64 0 0-32 0-194.7-25.4 25.4L208 173.3 162.7 128l22.6-22.6 80-80L288 2.7l22.6 22.6 80 80L413.3 128 368 173.3l-22.6-22.6L320 125.3 320 320zM272.4 493.1c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.6-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7C60.6 502.1 31.9 512 0 512l0-64c19.3 0 38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.3 25.1 17.9 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.4 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1s38.6-6.1 54-13.1c14.9-6.8 26.9-15.4 40-24.7c.7-.5 1.4-1 2.1-1.5c.7 .5 1.4 1 2.1 1.5c13.1 9.4 25.1 18 40 24.7c15.4 7 34.7 13.1 54 13.1l0 64c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.6-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9s-60.6-9.9-80.4-18.9c-5.8-2.6-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7z']
      
    ]
  };

  

  
  

  var faForklift = {
    prefix: 'fasds',
    iconName: 'forklift',
    icon: [
      640,
      512,
      [],
      'f47a',
      
      ['M0 432a80 80 0 1 0 160 0A80 80 0 1 0 0 432zm256 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM480 0l0 32 0 384 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-352 0-32L480 0z','M128 0L96 0l0 32 0 128L0 160 0 353.6C20.3 332.9 48.7 320 80 320c56.4 0 103.1 41.7 110.9 96l34.3 0c7.8-54.3 54.4-96 110.9-96c31.3 0 59.7 12.9 80 33.6l0-97.6 0-5.5-1.9-5.2-80-224L326.6 0 304 0 128 0zM281.4 64L350 256l-94 0-96-96 0-96 121.4 0z']
      
    ]
  };

  

  
  

  var faSquareNfi = {
    prefix: 'fasds',
    iconName: 'square-nfi',
    icon: [
      448,
      512,
      [],
      'e576',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 160l16 0 8 0 9.9 0 4.4 8.8L160 284.2 160 176l0-16 32 0 0 16 0 160 0 16-16 0-8 0-9.9 0-4.4-8.8L96 227.8 96 336l0 16-32 0 0-16 0-160 0-16zm160 0l16 0 64 0 16 0 0 32-16 0-48 0 0 32 48 0 16 0 0 32-16 0-48 0 0 80 0 16-32 0 0-16 0-96 0-64 0-16zm128 0l32 0 0 16 0 160 0 16-32 0 0-16 0-160 0-16z','M80 160l-16 0 0 16 0 160 0 16 32 0 0-16 0-108.2 57.7 115.4 4.4 8.8 9.9 0 8 0 16 0 0-16 0-160 0-16-32 0 0 16 0 108.2L102.3 168.8 97.9 160 88 160l-8 0zm160 0l-16 0 0 16 0 64 0 96 0 16 32 0 0-16 0-80 48 0 16 0 0-32-16 0-48 0 0-32 48 0 16 0 0-32-16 0-64 0zm144 16l0-16-32 0 0 16 0 160 0 16 32 0 0-16 0-160z']
      
    ]
  };

  

  
  

  var faHouseTsunami = {
    prefix: 'fasds',
    iconName: 'house-tsunami',
    icon: [
      576,
      512,
      [],
      'e515',
      
      ['M0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c2.5 0 5 0 7.6 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3l27.1-58C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7l20.1-60.8C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200zM0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7L96 408.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448z','M448 32L320 128l0 134.9c8.1 5.6 15.2 10 23.3 13.7c13.1 6 27.7 10.3 40.7 10.3s27.6-4.3 40.7-10.3c12-5.5 21.7-12.5 35.5-22.5c0 0 0 0 0 0L480 240l19.7 14.2s0 0 0 0c13.9 10 23.6 17 35.5 22.5c13.1 6 27.6 10.3 40.5 10.3l-.4-159L448 32z']
      
    ]
  };

  

  
  

  var faFolderClosed = {
    prefix: 'fasds',
    iconName: 'folder-closed',
    icon: [
      512,
      512,
      [],
      'e185',
      
      ['M0 32L0 192l512 0 0-96L272 96 224 32 0 32z','M0 192L0 480l512 0 0-288L0 192z']
      
    ]
  };

  

  
  

  var faCircleSortDown = {
    prefix: 'fasds',
    iconName: 'circle-sort-down',
    icon: [
      512,
      512,
      ["sort-circle-down"],
      'e031',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-64L256 96l112 96 0 32-224 0 0-32zm0 96l224 0 0 32L256 416 144 320l0-32z','M144 320l112 96 112-96V288H144v32z']
      
    ]
  };

  
    var faSortCircleDown = faCircleSortDown;
  

  
  

  var faScrewdriver = {
    prefix: 'fasds',
    iconName: 'screwdriver',
    icon: [
      512,
      512,
      [129691],
      'f54a',
      
      ['M215 263L249 297l105-105 62.1 0L512 64 448 0 320 96l0 62.1L215 263z','M0 416l96 96L280 328l-96-96L0 416z']
      
    ]
  };

  

  
  

  var faShieldXmark = {
    prefix: 'fasds',
    iconName: 'shield-xmark',
    icon: [
      512,
      512,
      ["shield-times"],
      'e24c',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM158.1 192c11.3-11.3 22.6-22.6 33.9-33.9l17 17 47 47 47-47c5.6-5.7 11.3-11.3 17-17L353.9 192c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.3 31.4-47 47c15.7 15.7 31.3 31.4 47 47c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.3-47-47c-15.7 15.7-31.3 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17l47-47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17z','M337 209l17-17L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faShieldTimes = faShieldXmark;
  

  
  

  var faCaretUp = {
    prefix: 'fasds',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      ['M160 128L0 272l0 48 320 0 0-48L160 128z','']
      
    ]
  };

  

  
  

  var faDownFromLine = {
    prefix: 'fasds',
    iconName: 'down-from-line',
    icon: [
      384,
      512,
      ["arrow-alt-from-top"],
      'f349',
      
      ['M0 32L0 96l32 0 320 0 32 0 0-64-32 0L32 32 0 32z','M192 480L32 320l0-32 96 0 0-160 128 0 0 160 96 0 0 32L192 480z']
      
    ]
  };

  
    var faArrowAltFromTop = faDownFromLine;
  

  
  

  var faSquareRing = {
    prefix: 'fasds',
    iconName: 'square-ring',
    icon: [
      448,
      512,
      [],
      'e44f',
      
      ['M0 32L0 480l448 0 0-448L0 32zM384 256A160 160 0 1 1 64 256a160 160 0 1 1 320 0z','M224 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192zm160 96A160 160 0 1 1 64 256a160 160 0 1 1 320 0z']
      
    ]
  };

  

  
  

  var fa3 = {
    prefix: 'fasds',
    iconName: '3',
    icon: [
      320,
      512,
      [],
      '33',
      
      ['M304 32l0 46.1-10.4 9.5L162.3 208l21.7 0c75.1 0 136 60.9 136 136l0 32-3.8 0C301.8 435.7 248.1 480 184 480l-72.6 0C64.8 480 23 451 6.6 407.3L2 395.2 62 372.8l4.5 12.1c7 18.7 24.9 31.1 44.9 31.1l72.6 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L80 272l-32 0 0-46.1 10.4-9.5L189.7 96 32 96 0 96 0 32l32 0 240 0 32 0z','']
      
    ]
  };

  

  
  

  var faFileZip = {
    prefix: 'fasds',
    iconName: 'file-zip',
    icon: [
      512,
      512,
      [],
      'e5ee',
      
      ['M0 0L224 0l0 160 160 0 0 144-208 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM240 352l-16 0 0 32 16 0 41 0-54.9 96.1-2.1 3.7 0 4.2 0 8 0 16 16 0 64 0 16 0 0-32-16 0-41 0 54.9-96.1 2.1-3.7 0-4.2 0-8 0-16-16 0-64 0zm144 16l0-16-32 0 0 16 0 128 0 16 32 0 0-16 0-128zm32-16l0 16 0 80 0 48 0 16 32 0 0-16 0-32 8 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-24 0-16 0zm32 80l0-48 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0z']
      
    ]
  };

  

  
  

  var faCow = {
    prefix: 'fasds',
    iconName: 'cow',
    icon: [
      640,
      512,
      [128004],
      'f6c8',
      
      ['M0 288c0-20.2 9.4-38.2 24-50c11-8.8 24.9-14 40-14l8 0 0 32c0 35.3-28.7 64-64 64l-8 0 0-32zm192-16l160 0 0 16 0 39.8c-9.9 6.6-20.6 12-32 16.1l0 24.2 0 16-32 0 0-16 0-16.9c-5.3 .6-10.6 .9-16 .9s-10.7-.3-16-.9l0 16.9 0 16-32 0 0-16 0-24.2c-11.4-4-22.1-9.4-32-16.1l0-39.8 0-16z','M72 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160l0 32 0 64 0 192 96 0 0-32 0-128 0-16 160 0 0 16 0 128 0 32 96 0 0-192 32 32 0 64 64 96 64 0 32-160-16-22.4 0-81.6 0-24-48 0 0 24 0 14.4L480 64 256 64l-64 0-48 0C77.7 64 24 117.7 24 184l0 54c11-8.8 24.9-14 40-14l8 0 0-40zM576 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 160l0-32 224 0 0 32-30.1 30.1C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9L160 160z']
      
    ]
  };

  

  
  

  var faMicrophone = {
    prefix: 'fasds',
    iconName: 'microphone',
    icon: [
      384,
      512,
      [],
      'f130',
      
      ['M16 192l0 24 0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0-24 0 0 48 24 0 72 0 72 0 24 0 0-48-24 0-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40 0-24-48 0 0 24 0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40 0-24-48 0z','M96 0H288V256c0 53-43 96-96 96s-96-43-96-96V0z']
      
    ]
  };

  

  
  

  var faWindowFrame = {
    prefix: 'fasds',
    iconName: 'window-frame',
    icon: [
      512,
      512,
      [129695],
      'e04f',
      
      ['M96 64l0 160 136 0 0-160L96 64zm0 224l0 160 136 0 0-160L96 288zM280 64l0 160 136 0 0-160L280 64zm0 224l0 160 136 0 0-160-136 0z','M32 256L32 64 32 0 96 0 416 0l64 0 0 64 0 192 0 192 32 0 0 64-32 0-64 0L96 512l-64 0L0 512l0-64 32 0 0-192zm384 32l-136 0 0 160 136 0 0-160zm-184 0L96 288l0 160 136 0 0-160zm48-64l136 0 0-160L280 64l0 160zM232 64L96 64l0 160 136 0 0-160z']
      
    ]
  };

  

  
  

  var faImage = {
    prefix: 'fasds',
    iconName: 'image',
    icon: [
      512,
      512,
      [],
      'f03e',
      
      ['M0 32l512 0 0 448L0 480 0 32zM64 144a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm0 230.9c0 3 0 6.1 0 9.1c0 2.7 0 5.3 0 8c0 8 0 16 0 24c8 0 16 0 24 0c24 0 48 0 72 0c8 0 16 0 24 0c10.7 0 21.3 0 32 0c8 0 16 0 24 0c61.3 0 122.7 0 184 0c8 0 16 0 24 0l0-24 0-8 0-7.7-4.5-6.3c-40-56-80-112-120-168c-6.5-9.1-13-18.2-19.5-27.3l-19.5 27.3c-29.4 41.2-58.8 82.4-88.3 123.6c-8.8-9.9-17.5-19.7-26.3-29.6c-6-6.7-12-13.5-17.9-20.2l-17.9 20.2c-21.3 24-42.7 48-64 72L64 374.9z','M323.5 202.1L304 174.7l-19.5 27.3L196.2 325.6l-26.3-29.6L152 275.9l-17.9 20.2-64 72L64 374.9l0 9.1 0 8 0 24 24 0 72 0 24 0 32 0 24 0 184 0 24 0 0-24 0-8 0-7.7-4.5-6.3-120-168z']
      
    ]
  };

  

  
  

  var faFloppyDiskPen = {
    prefix: 'fasds',
    iconName: 'floppy-disk-pen',
    icon: [
      576,
      512,
      [],
      'e182',
      
      ['M0 32L0 64 0 448l0 32 32 0 226 0 9-62.6 181-181 0-76.4 0-13.3-9.4-9.4-96-96L333.3 32 320 32 32 32 0 32zM64 96l256 0 0 128L64 224 64 96zM288 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M576 294.9l-71-71-41.3 41.3 71 71L576 294.9zm-63.9 63.9l-71-71L299.9 429.1 288 512l82.9-11.9L512.1 358.9z']
      
    ]
  };

  

  
  

  var faBucket = {
    prefix: 'fasds',
    iconName: 'bucket',
    icon: [
      448,
      512,
      [],
      'e4cf',
      
      ['M45.2 192l48.6 0L116.5 48l215 0 22.7 144 48.6 0L375.7 20.3 372.5 0 352 0 96 0 75.5 0 72.3 20.3 45.2 192z','M448 192L0 192l0 64 37.1 0L64 512l320 0 26.9-256 37.1 0 0-64z']
      
    ]
  };

  

  
  

  var faFrog = {
    prefix: 'fasds',
    iconName: 'frog',
    icon: [
      576,
      512,
      [],
      'f52e',
      
      ['M0 416l0 32 0 32 32 0 288 0 32 0 0-64-32 0-58.2 0 37.1-37.1c3.4-3.4 6.4-7.1 9-10.9c18.7-28 15.7-66.2-9-90.9c-24.6-24.6-62.6-27.7-90.5-9.2c-4 2.6-7.8 5.7-11.3 9.2c-.2 .2-.2 .2-.3 .3L123 347.6l-11.6 11L89.4 335.4l11.6-11 73.6-70.1c40.6-40.5 106.4-40.4 146.9 .1c28.6 28.6 37.1 69.7 25.4 105.7L457.4 470.6l9.4 9.4 13.3 0 64 0 32 0 0-64-32 0-50.7 0-92.5-92.5L576 224l0-80L447.7 104.5c.2 2.5 .3 5 .3 7.5c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-1.2 0-2.5 .1-3.7s.1-2.5 .3-3.7c.2-2.4 .6-4.8 1-7.2C127 112.9 0 249.6 0 416z','M368 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faMessageLines = {
    prefix: 'fasds',
    iconName: 'message-lines',
    icon: [
      512,
      512,
      ["comment-alt-lines"],
      'f4a6',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM128 144l0 48 24 0 208 0 24 0 0-48-24 0-208 0-24 0zm0 96l0 48 24 0 112 0 24 0 0-48-24 0-112 0-24 0z','M128 144l24 0 208 0 24 0 0 48-24 0-208 0-24 0 0-48zm0 96l24 0 112 0 24 0 0 48-24 0-112 0-24 0 0-48z']
      
    ]
  };

  
    var faCommentAltLines = faMessageLines;
  

  
  

  var faCloudExclamation = {
    prefix: 'fasds',
    iconName: 'cloud-exclamation',
    icon: [
      640,
      512,
      [],
      'e491',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zM296 160l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M344 184l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faToriiGate = {
    prefix: 'fasds',
    iconName: 'torii-gate',
    icon: [
      512,
      512,
      [9961],
      'f6a1',
      
      ['M64 128l64 0 0 96-64 0 0-96zm0 160l64 0 0 192 0 32-64 0 0-32 0-192zM224 128l64 0 0 96-64 0 0-96zm160 0l64 0 0 96-64 0 0-96zm0 160l64 0 0 192 0 32-64 0 0-32 0-192z','M64 128l384 0 64-64 0-64L416 32 96 32 0 0 0 64l64 64zM32 224L0 224l0 64 32 0 448 0 32 0 0-64-32 0L32 224z']
      
    ]
  };

  

  
  

  var faPanelEws = {
    prefix: 'fasds',
    iconName: 'panel-ews',
    icon: [
      512,
      512,
      [],
      'e42e',
      
      ['M0 0L0 288l16 0c44.2 0 80 35.8 80 80l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-32 0 0-96 96 0 0 96-32 0 0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-26.5-21.5-48-48-48L0 320 0 512l512 0L512 0 0 0zM96 64l16 0 96 0 16 0 0 32-16 0-96 0L96 96l0-32zm0 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zM288 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm0 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm0 128l128 0 0 192-128 0 0-192z','M288 256l128 0 0 192-128 0 0-192zM0 288l16 0c44.2 0 80 35.8 80 80l0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32-32 0 0-96 96 0 0 96-32 0 0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-16c0-26.5-21.5-48-48-48L0 320l0-32z']
      
    ]
  };

  

  
  

  var faSubtitles = {
    prefix: 'fasds',
    iconName: 'subtitles',
    icon: [
      576,
      512,
      [],
      'e60f',
      
      ['M0 32L0 480l576 0 0-448L0 32zM96 240l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm0 96l24 0 80 0 24 0 0 48-24 0-80 0-24 0 0-48zm160 0l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm96-96l24 0 80 0 24 0 0 48-24 0-80 0-24 0 0-48z','M96 240l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm256 0l24 0 80 0 24 0 0 48-24 0-80 0-24 0 0-48zM96 336l24 0 80 0 24 0 0 48-24 0-80 0-24 0 0-48zm160 0l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faSunrise = {
    prefix: 'fasds',
    iconName: 'sunrise',
    icon: [
      576,
      512,
      [127749],
      'f766',
      
      ['M32 374l62.1 90 66.9 0c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112l66.9 0L544 374 417.3 350.7 394 224 288 297.1 182 224 158.7 350.7 32 374zm161.3 90l189.3 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80z','M354.5 154.9L320 123.5l0 84.5 0 32-64 0 0-32 0-84.5-34.5 31.3-23.7 21.5L154.8 129l23.7-21.5 88-80L288 8l21.5 19.6 88 80L421.2 129l-43 47.4-23.7-21.5zM24 464l528 0 24 0 0 48-24 0L24 512 0 512l0-48 24 0z']
      
    ]
  };

  

  
  

  var faHockeyMask = {
    prefix: 'fasds',
    iconName: 'hockey-mask',
    icon: [
      448,
      512,
      [],
      'f6ee',
      
      ['M0 0L0 240C0 432 48 512 224 512s224-80 224-272L448 0 224 0 0 0zM64 176l128 0 0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-32zM184 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm16 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm48-320a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm48 192a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 176l128 0 0 32c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-32zm56-96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M136 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM152 320a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM288 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faLacrosseStick = {
    prefix: 'fasds',
    iconName: 'lacrosse-stick',
    icon: [
      512,
      512,
      [],
      'e3b5',
      
      ['M2.7 464L48 509.3l22.6-22.6 120-120c-18.7-11-34.3-26.6-45.3-45.3l-120 120L2.7 464z','M264.8 117.7l-10 35.1L253 159l-4 5-43.2 54c-8.9 11.1-13.8 25-13.8 39.2c0 34.7 28.1 62.8 62.8 62.8c14.3 0 28.1-4.9 39.2-13.8L348 263l5-4 6.2-1.8 35.1-10c31.8-9.1 53.7-38.1 53.7-71.2c0 0 0 0 0 0l0-.3c0-19.9-13.6-48.1-38.6-73.1s-53.2-38.6-73.1-38.6l-.3 0s0 0 0 0c-33.1 0-62.1 21.9-71.2 53.7zM512 176.1c0 61.6-40.9 115.7-100.1 132.7L383 317l-49 39.2c-22.5 18-50.4 27.8-79.2 27.8c-70 0-126.8-56.8-126.8-126.8c0-28.8 9.8-56.7 27.8-79.2L195 129l8.3-28.9C220.2 40.9 274.4 0 336 0c0 0 0 0 0 0l.3 0c43.8 0 87.4 26.4 118.4 57.3s57.3 74.5 57.3 118.4c0 .1 0 .3 0 .4z']
      
    ]
  };

  

  
  

  var faCustard = {
    prefix: 'fasds',
    iconName: 'custard',
    icon: [
      576,
      512,
      [127854],
      'e403',
      
      ['M64 352L96.3 206.8c26.6-7.6 53.1-15.2 79.7-22.8c37.3 10.7 74.7 21.3 112 32c37.3-10.7 74.7-21.3 112-32l79.7 22.8L512 352 64 352z','M128 64l320 0 31.7 142.8L400 184 288 216 176 184 96.3 206.8 128 64zM32 384l512 0 32 0 0 64-32 0L32 448 0 448l0-64 32 0z']
      
    ]
  };

  

  
  

  var faMistletoe = {
    prefix: 'fasds',
    iconName: 'mistletoe',
    icon: [
      576,
      512,
      [],
      'f7b4',
      
      ['M0 341c0 41.4 33.6 75 75 75c50.5 0 94.3-33.5 108.1-81.2c-4.5-6.5-7.1-14.3-7.1-22.8c0-.9 0-1.8 .1-2.6s.1-1.7 .3-2.6c.2-1.7 .6-3.4 1-5c.9-3.3 2.1-6.4 3.7-9.3c3.2-5.8 7.9-10.7 13.4-14.2l5.4-28.2L264 185.9l0 72.4c14.7 13.2 24 32.3 24 53.7c0 39.8-32.2 72-72 72c-7.2 0-14.2-1.1-20.8-3c-2.1 8.4-3.2 17.1-3.2 25.9l0 9.1c0 53 43 96 96 96s96-43 96-96l0-9.1c0-25.1-9-49.4-25.3-68.4L312 284l0-98.1L376.1 250l14.4 74.7C400.6 377.7 447 416 501 416c41.4 0 75-33.6 75-75c0-54-38.3-100.3-91.3-110.5L410 216.1l-98-98L312 24l0-24L264 0l0 24 0 94.1-98 98L91.3 230.4C38.3 240.6 0 287 0 341z','M376 112a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM216 352a40 40 0 1 0 0-80 40 40 0 1 0 0 80z']
      
    ]
  };

  

  
  

  var faBowlScoops = {
    prefix: 'fasds',
    iconName: 'bowl-scoops',
    icon: [
      448,
      512,
      [127813],
      'e3df',
      
      ['M0 208c0 17.2 3.9 33.5 10.8 48l189.4 0c-5.3-15-8.2-31.2-8.2-48c0-22 4.9-42.8 13.7-61.4c-19.8-30.2-53.8-50.2-92.6-50.6L112 96C50.1 96 0 146.1 0 208zM122.6 64.4c40.9 3 77.1 23 101.4 53.1c24.3-30.1 60.5-50.1 101.4-53.1C307.5 26.3 268.8 0 224 0s-83.5 26.3-101.4 64.4zM224 208c0 17.2 3.9 33.5 10.8 48l202.4 0c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112l-1.1 0c-38.7 .4-72.7 20.4-92.6 50.6C230.7 164.2 224 185.3 224 208z','M448 256L0 256l4.5 44.7C11 366.2 66.1 416 131.8 416l60.2 0-80 72 0 24 224 0 0-24-80-72 60.2 0c65.8 0 120.8-49.8 127.4-115.3L448 256z']
      
    ]
  };

  

  
  

  var faSquarePlus = {
    prefix: 'fasds',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 232l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M200 344l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faCircleV = {
    prefix: 'fasds',
    iconName: 'circle-v',
    icon: [
      512,
      512,
      [],
      'e12a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128.1 144l52.4 0L256 316.2 331.5 144l52.4 0L278 385.6 271.7 400l-31.4 0c-2.1-4.8-4.2-9.6-6.3-14.4C198.7 305.1 163.4 224.5 128.1 144z','M331.5 144l52.4 0L278 385.6 271.7 400l-31.4 0L234 385.6 128.1 144l52.4 0L256 316.2 331.5 144z']
      
    ]
  };

  

  
  

  var faFileBinary = {
    prefix: 'fasds',
    iconName: 'file-binary',
    icon: [
      384,
      512,
      [],
      'e175',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM64 256l0 16 0 128 0 16 16 0 96 0 16 0 0-16 0-128 0-16-16 0-96 0-16 0zm32 32l64 0 0 96-64 0 0-96zm128-32l0 32 16 0 16 0 0 96-16 0-16 0 0 32 16 0 32 0 32 0 16 0 0-32-16 0-16 0 0-112 0-16-16 0-32 0-16 0z','M384 160L224 0l0 160 160 0zM80 256l-16 0 0 16 0 128 0 16 16 0 96 0 16 0 0-16 0-128 0-16-16 0-96 0zM96 384l0-96 64 0 0 96-64 0zM240 256l-16 0 0 32 16 0 16 0 0 96-16 0-16 0 0 32 16 0 32 0 32 0 16 0 0-32-16 0-16 0 0-112 0-16-16 0-32 0z']
      
    ]
  };

  

  
  

  var faNfcMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'nfc-magnifying-glass',
    icon: [
      640,
      512,
      [],
      'e1f9',
      
      ['M0 32L0 480l448 0c-52.3 0-98.8-25.1-128-64L80 416l-16 0 0-16 0-288 0-16 16 0 64 0 16 0 0 32-16 0-48 0 0 256 205.3 0c-8.6-19.6-13.3-41.2-13.3-64c0-52.3 25.1-98.8 64-128l0-64-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-98.7 0-16 16 0 144 0 16 0 0 16 0 61.3c19.6-8.6 41.2-13.3 64-13.3l0-128L0 32z','M528 320.1a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM520 426c-20.5 14-45.3 22.1-72 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426z']
      
    ]
  };

  

  
  

  var faWindowRestore = {
    prefix: 'fasds',
    iconName: 'window-restore',
    icon: [
      512,
      512,
      [],
      'f2d2',
      
      ['M128 0l0 64 0 32 64 0 0-32 256 0 0 256-32 0 0 64 32 0 64 0 0-64 0-256 0-64L448 0 192 0 128 0z','M384 128L0 128 0 512l384 0 0-384zm-64 64l0 64L64 256l0-64 256 0z']
      
    ]
  };

  

  
  

  var faSailboat = {
    prefix: 'fasds',
    iconName: 'sailboat',
    icon: [
      576,
      512,
      [],
      'e445',
      
      ['M48 352L224 64l0 288L48 352zM256 0L528 352l-272 0L256 0z','M0 384H576L480 512H96L0 384z']
      
    ]
  };

  

  
  

  var faCassetteBetamax = {
    prefix: 'fasds',
    iconName: 'cassette-betamax',
    icon: [
      576,
      512,
      ["betamax"],
      'f8a4',
      
      ['M0 160l576 0 0 320L0 480 0 160zM64 320a96 96 0 1 0 192 0A96 96 0 1 0 64 320zm256-96l0 192 192 0 0-192-192 0z','M576 32L0 32 0 160l576 0 0-128zM192 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96a96 96 0 1 0 0 192 96 96 0 1 0 0-192z']
      
    ]
  };

  
    var faBetamax = faCassetteBetamax;
  

  
  

  var faCrow = {
    prefix: 'fasds',
    iconName: 'crow',
    icon: [
      640,
      512,
      [],
      'f520',
      
      ['M259.2 384l18.6 45.1 14 34 14 34 6.1 14.9 51.9 0-13.6-33.1-14-34-14-34L311.1 384l-51.9 0zm96 0l46.6 113.2 6.1 14.9 51.9 0-13.6-33.1-42-102c-15.6 4.4-32 6.9-49 7.1zM523.9 32C536.5 47.2 544 66.7 544 88l0 32 96-24 0-32L592 32l-68.1 0z','M456 0c-48.6 0-88 39.4-88 88l0 29.2L.3 400l39 50.7L126.1 384 352 384c106 0 192-86 192-192l0-64 0-40c0-48.6-39.4-88-88-88zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var fa00 = {
    prefix: 'fasds',
    iconName: '00',
    icon: [
      640,
      512,
      [],
      'e467',
      
      ['M352 176c0-79.5 64.5-144 144-144s144 64.5 144 144l0 160c0 79.5-64.5 144-144 144s-144-64.5-144-144l0-160zm64 0l0 160c0 44.2 35.8 80 80 80s80-35.8 80-80l0-160c0-44.2-35.8-80-80-80s-80 35.8-80 80z','M0 176C0 96.5 64.5 32 144 32s144 64.5 144 144l0 160c0 79.5-64.5 144-144 144S0 415.5 0 336L0 176zM144 96c-44.2 0-80 35.8-80 80l0 160c0 44.2 35.8 80 80 80s80-35.8 80-80l0-160c0-44.2-35.8-80-80-80z']
      
    ]
  };

  

  
  

  var faHexagonDivide = {
    prefix: 'fasds',
    iconName: 'hexagon-divide',
    icon: [
      512,
      512,
      [],
      'e1ad',
      
      ['M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm144-24l0 48 24 0 176 0 24 0 0-48-24 0-176 0-24 0zm80-104l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0z','M224 128l64 0 0 64-64 0 0-64zM144 232l24 0 176 0 24 0 0 48-24 0-176 0-24 0 0-48zm144 88l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faUserUnlock = {
    prefix: 'fasds',
    iconName: 'user-unlock',
    icon: [
      640,
      512,
      [],
      'e058',
      
      ['M0 512l384 0 0-208L64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M528 240c-17.7 0-32 14.3-32 32l0 48 16 0 48 0 48 0 32 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z']
      
    ]
  };

  

  
  

  var faSensorFire = {
    prefix: 'fasds',
    iconName: 'sensor-fire',
    icon: [
      640,
      512,
      [],
      'e02a',
      
      ['M0 32l448 0 0 90.1-17 10.6c-24.1 15-58.9 43-88.1 79.6c-29 36.4-55 84.6-55 139.5c0 49.2 18.5 94.2 49 128.2L0 480 0 32zM64 96l0 24 0 144 0 24 48 0 0-24 0-144 0-24L64 96zm80 0l0 24 0 144 0 24 48 0 0-24 0-144 0-24-48 0zm80 0l0 24 0 144 0 24 48 0 0-24 0-144 0-24-48 0z','M448 160s32.6 26.4 65 64c17.2-19.5 31-32 31-32s96 86.4 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160s128-192 128-192zm33 287.8c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z']
      
    ]
  };

  

  
  

  var faFaceExhaling = {
    prefix: 'fasds',
    iconName: 'face-exhaling',
    icon: [
      576,
      512,
      [],
      'e480',
      
      ['M0 256C0 397.4 114.6 512 256 512c55.8 0 107.4-17.9 149.5-48.2c-10.5-9.3-17.9-22.1-20.5-36.5l-42.2-12.7L320 407.8l0-47.6 22.8-6.8L385 340.7c5.3-30 31.5-52.7 63-52.7c.7 0 1.4 0 2.1 0c13.2-14.7 32.3-24 53.7-24c2.7 0 5.4 .2 8.1 .5c.1-2.8 .1-5.6 .1-8.5C512 114.6 397.4 0 256 0S0 114.6 0 256zm91.2-2.4l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0zM296 384a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM283.2 253.6l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0z','M543.5 336c0 .8 0 1.7-.1 2.5c19 6.4 32.6 24.4 32.6 45.5s-13.6 39.1-32.6 45.5c.1 .8 .1 1.7 .1 2.5c0 22.1-17.9 40-39.9 40c-14.2 0-26.6-7.4-33.7-18.5c-4.4 1.6-9.1 2.5-14 2.5c-22.1 0-39.9-17.9-39.9-40c0-4.3 .7-8.4 1.9-12.2L352 384l64.2-19.3c-.2-1.5-.3-3.1-.3-4.7c0-22.1 17.9-40 39.9-40c3.6 0 7.2 .5 10.5 1.4c5.8-14.9 20.3-25.4 37.2-25.4c22.1 0 39.9 17.9 39.9 40z']
      
    ]
  };

  

  
  

  var faTrafficLightGo = {
    prefix: 'fasds',
    iconName: 'traffic-light-go',
    icon: [
      320,
      512,
      [],
      'f638',
      
      ['M112 368a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M320 0L0 0 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160L320 0zM160 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z']
      
    ]
  };

  

  
  

  var faEyeLowVision = {
    prefix: 'fasds',
    iconName: 'eye-low-vision',
    icon: [
      640,
      512,
      ["low-vision"],
      'f2a8',
      
      ['M151.7 95l70.9 55c51.7-47.6 131.8-51.4 188-5.9c54.7 44.3 68.5 120.3 36.3 180.1L524 384.1c41.9-44 70.2-93.9 84-128.1C578 181.3 478.4 32 320 32c-66.9 0-123.2 26.6-168.3 63zm149.5 66.9l11.6 58.2c31.8 24.7 63.5 49.3 95.3 74c5.1-11.7 7.9-24.6 7.9-38.1c0-53-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8z','M48.4 14.8L29.4 .1 0 38 19 52.7 591.5 497.2l19 14.7L639.9 474l-19-14.7L48.4 14.8zM34.9 249.2c-1 2.3-2 4.6-2.9 6.8c30 74.7 129.6 224 288 224c3.1 0 6.1-.1 9.2-.2L34.9 249.2zM393.1 469c18.3-5.7 35.6-13.3 51.8-22.4L85.7 163.5c-10.9 14.3-20.4 28.6-28.5 42.2L393.1 469z']
      
    ]
  };

  
    var faLowVision = faEyeLowVision;
  

  
  

  var faUpFromDottedLine = {
    prefix: 'fasds',
    iconName: 'up-from-dotted-line',
    icon: [
      448,
      512,
      [],
      'e456',
      
      ['M0 416l64 0 0 64L0 480l0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M224 32L64 192l0 32 96 0 0 160 128 0 0-160 96 0 0-32L224 32z']
      
    ]
  };

  

  
  

  var faTrain = {
    prefix: 'fasds',
    iconName: 'train',
    icon: [
      448,
      512,
      [128646],
      'f238',
      
      ['M2.8 512l90.5 0 64-64-90.5 0L25.4 489.4 2.8 512zM64 64l0 160 320 0 0-160L64 64zM290.7 448l64 64 90.5 0-22.6-22.6L381.3 448l-90.5 0z','M0 0L448 0l0 448L0 448 0 0zM64 64l0 160 320 0 0-160L64 64zM224 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96z']
      
    ]
  };

  

  
  

  var faLessThanEqual = {
    prefix: 'fasds',
    iconName: 'less-than-equal',
    icon: [
      448,
      512,
      [],
      'f537',
      
      ['M32 169.4l0 45.2 21.3 7.6 360 128 2.7 1 0-67.9L159.5 192 416 100.8l0-67.9-2.7 1-360 128L32 169.4z','M0 416l32 0 384 0 32 0 0 64-32 0L32 480 0 480l0-64z']
      
    ]
  };

  

  
  

  var faHandsBubbles = {
    prefix: 'fasds',
    iconName: 'hands-bubbles',
    icon: [
      576,
      512,
      ["hands-wash"],
      'e05e',
      
      ['M32 128l0 32 .1 99.1c0 47.6 24.9 91.1 64.5 115.6c-.4-4.9-.6-9.8-.6-14.7l0-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6 27.1-17 7.1-4.4 39-67.5 12-20.8L297.8 4l-12 20.8L215.5 146.5l-20.8-12 49.5-85.7 12-20.8L214.6 4l-12 20.8-49.5 85.7c-19 32.9-38.1 65.9-57.1 98.8L96 160l0-32L32 128zM64 464a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM316.1 116.2l9.2 14.7 19.6 31.4 28.7-49.8 12-20.8-41.6-24-12 20.8-16 27.7zm43.2 69.1L373.5 208l28.2 0L420 176.2l12-20.8-41.6-24-12 20.8-19.1 33.1zM384 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M298.2 147.9l-27.1 17-60.2 37.6C159.3 234.7 128 291.2 128 352c0 0 0 0 0 0l0 8s0 0 0 0c0 8.9 .8 17.6 2.2 26.1c35.4 8.3 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512l176 0 24 0 0-48-24 0-104 0 0-24 136 0 24 0 0-48-24 0-136 0 0-24 168 0 24 0 0-48-24 0-168 0 0-24 136 0 24 0 0-48-24 0-136 0s0 0 0 0l-93.2 0L305 219.1l27.1-17-33.9-54.3z']
      
    ]
  };

  
    var faHandsWash = faHandsBubbles;
  

  
  

  var faChartBar = {
    prefix: 'fasds',
    iconName: 'chart-bar',
    icon: [
      512,
      512,
      ["bar-chart"],
      'f080',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M160 96l-32 0 0 64 32 0 192 0 32 0 0-64-32 0L160 96zm0 96l-32 0 0 64 32 0 128 0 32 0 0-64-32 0-128 0zm0 96l-32 0 0 64 32 0 256 0 32 0 0-64-32 0-256 0z']
      
    ]
  };

  
    var faBarChart = faChartBar;
  

  
  

  var faCloudShowersWater = {
    prefix: 'fasds',
    iconName: 'cloud-showers-water',
    icon: [
      576,
      512,
      [],
      'e4e4',
      
      ['M0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7l-2.1-1.5-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7L96 408.7l-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448zm32-64l48 0 72-128-48 0L32 384zm112 0l48 0 72-128-48 0L144 384zm112 0l48 0 72-128-48 0L256 384zm112 0l48 0 72-128-48 0L368 384z','M311.2 55.7C295.9 22.8 262.6 0 224 0c-53 0-96 43-96 96c-35.3 0-64 28.7-64 64l0 64 448 0 0-64c0-35.3-28.7-64-64-64l-1.6 0C439 59.5 406.7 32 368 32c-22.2 0-42.3 9.1-56.8 23.7z']
      
    ]
  };

  

  
  

  var faSquareCaretUp = {
    prefix: 'fasds',
    iconName: 'square-caret-up',
    icon: [
      448,
      512,
      ["caret-square-up"],
      'f151',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 288L224 160 352 288l0 32L96 320l0-32z','M96 320V288L224 160 352 288v32H96z']
      
    ]
  };

  
    var faCaretSquareUp = faSquareCaretUp;
  

  
  

  var faTally = {
    prefix: 'fasds',
    iconName: 'tally',
    icon: [
      640,
      512,
      ["tally-5"],
      'f69c',
      
      ['M96 32l64 0 0 32 0 214.5c-21.3 7.5-42.7 15.1-64 22.6L96 64l0-32zm0 337l64-22.6L160 448l0 32-64 0 0-32 0-79zM224 32l64 0 0 32 0 169.4-64 22.6L224 64l0-32zm0 291.8c21.3-7.5 42.7-15.1 64-22.6L288 448l0 32-64 0 0-32 0-124.2zM352 32l64 0 0 32 0 124.2c-21.3 7.5-42.7 15.1-64 22.6L352 64l0-32zm0 246.6c21.3-7.5 42.7-15.1 64-22.6L416 448l0 32-64 0 0-32 0-169.4zM480 32l64 0 0 32 0 79c-21.3 7.5-42.7 15.1-64 22.6L480 64l0-32zm0 201.5c21.3-7.5 42.7-15.1 64-22.6L544 448l0 32-64 0 0-32 0-214.5z','M632.8 179.5l-30.2 10.7-544 192L28.5 392.8 7.2 332.5l30.2-10.6 544-192 30.2-10.7 21.3 60.4z']
      
    ]
  };

  
    var faTally5 = faTally;
  

  
  

  var faGridRound5 = {
    prefix: 'fasds',
    iconName: 'grid-round-5',
    icon: [
      448,
      512,
      [],
      'e5de',
      
      ['M0 160a32 32 0 1 0 64 0A32 32 0 1 0 0 160zM0 352a32 32 0 1 0 64 0A32 32 0 1 0 0 352zM96 64a32 32 0 1 0 64 0A32 32 0 1 0 96 64zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M64 64A32 32 0 1 1 0 64a32 32 0 1 1 64 0zm0 192A32 32 0 1 1 0 256a32 32 0 1 1 64 0zM32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM160 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM128 384a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM256 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM224 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM416 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64z']
      
    ]
  };

  

  
  

  var faHandBackFist = {
    prefix: 'fasds',
    iconName: 'hand-back-fist',
    icon: [
      448,
      512,
      ["hand-rock"],
      'f255',
      
      ['M192 0L96 0l0 80 0 16 0 32 0 48 0 16-32 0 0-16 0-48-32 0 0 105.5c0 44.7 19.8 87 54.1 115.6c12.6 10.5 26.8 18.8 41.9 24.7L128 512l224 0 0-137.3c46.9-19 80-65 80-118.7l0-32 0-96 0-32-80 0 0-32-80 0 0-32-80 0 0-32z','']
      
    ]
  };

  
    var faHandRock = faHandBackFist;
  

  
  

  var faMarsStrokeRight = {
    prefix: 'fasds',
    iconName: 'mars-stroke-right',
    icon: [
      640,
      512,
      [9897,"mars-stroke-h"],
      'f22b',
      
      ['M128 256a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M320 256A112 112 0 1 0 96 256a112 112 0 1 0 224 0zm62.4 24C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152l33.6 0 0-48 0-24 48 0 0 24 0 48 32 0 0-72 32 0 96 96-96 96-32 0 0-72-32 0 0 48 0 24-48 0 0-24 0-48-33.6 0z']
      
    ]
  };

  
    var faMarsStrokeH = faMarsStrokeRight;
  

  
  

  var faPersonChalkboard = {
    prefix: 'fasds',
    iconName: 'person-chalkboard',
    icon: [
      640,
      512,
      [],
      'e53d',
      
      ['M32.4 278.5l54.9 33L103.7 284 120 256.9 120 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-288 56 0 64 0 16 0 32 0 0-64-32 0-16 0-64 0-76.9 0-102.2 0-18.1 0-9.3 15.5L48.9 251.1 32.4 278.5zM144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M384 64l192 0 0 192-192 0 0-64-64 0 0 64 0 64 64 0 192 0 64 0 0-64 0-192 0-64L576 0 384 0 320 0l0 64 0 64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faRightLongToLine = {
    prefix: 'fasds',
    iconName: 'right-long-to-line',
    icon: [
      640,
      512,
      [],
      'e444',
      
      ['M576 64l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M512 256L352 416l-32 0 0-96L0 320 0 192l320 0 0-96 32 0L512 256z']
      
    ]
  };

  

  
  

  var faSwapArrows = {
    prefix: 'fasds',
    iconName: 'swap-arrows',
    icon: [
      640,
      512,
      [],
      'e60a',
      
      ['M288 32l0 32c0 64 0 128 0 192c21.3 0 42.7 0 64 0l0-160 128 0 0 290.7-25.4-25.4L432 338.7 386.7 384l22.6 22.6 80 80L512 509.3l22.6-22.6 80-80L637.3 384 592 338.7l-22.6 22.6L544 386.7 544 64l0-32-32 0L320 32l-32 0z','M150.6 25.4L128 2.7 105.4 25.4l-80 80L2.7 128 48 173.3l22.6-22.6L96 125.3 96 448l0 32 32 0 192 0 32 0 0-32 0-192-64 0 0 160-128 0 0-290.7 25.4 25.4L208 173.3 253.3 128l-22.6-22.6-80-80z']
      
    ]
  };

  

  
  

  var faGrid5 = {
    prefix: 'fasds',
    iconName: 'grid-5',
    icon: [
      448,
      512,
      [],
      'e199',
      
      ['M0 128l0 64 64 0 0-64L0 128zM0 320l0 64 64 0 0-64L0 320zM96 32l0 64 64 0 0-64L96 32zm0 192l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm96-288l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zM288 32l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm96-288l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0z','M0 32l64 0 0 64L0 96 0 32zM0 224l64 0 0 64L0 288l0-64zM64 416l0 64L0 480l0-64 64 0zM96 128l64 0 0 64-64 0 0-64zm64 192l0 64-64 0 0-64 64 0zM192 32l64 0 0 64-64 0 0-64zm64 192l0 64-64 0 0-64 64 0zM192 416l64 0 0 64-64 0 0-64zM352 128l0 64-64 0 0-64 64 0zM288 320l64 0 0 64-64 0 0-64zM448 32l0 64-64 0 0-64 64 0zM384 224l64 0 0 64-64 0 0-64zm64 192l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faArrowDownToLine = {
    prefix: 'fasds',
    iconName: 'arrow-down-to-line',
    icon: [
      384,
      512,
      ["arrow-to-bottom"],
      'f33d',
      
      ['M0 416l0 64 32 0 320 0 32 0 0-64-32 0L32 416 0 416z','M192 365.3l22.6-22.6 128-128L365.3 192 320 146.7l-22.6 22.6L224 242.7 224 64l0-32-64 0 0 32 0 178.7L86.6 169.4 64 146.7 18.7 192l22.6 22.6 128 128L192 365.3z']
      
    ]
  };

  
    var faArrowToBottom = faArrowDownToLine;
  

  
  

  var faRepeat1 = {
    prefix: 'fasds',
    iconName: 'repeat-1',
    icon: [
      512,
      512,
      [128258],
      'f365',
      
      ['M0 64L0 96 0 224l0 32 64 0 0-32 0-96 256 0 0 64 32 0 96-96L352 0 320 0l0 64L32 64 0 64zM64 416l96 96 32 0 0-64 288 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96-256 0 0-64-32 0L64 416z','M216 192l24 0 24 0 24 0 0 24 0 80 0 24-48 0 0-24 0-56-24 0 0-48z']
      
    ]
  };

  

  
  

  var faBuildingCircleCheck = {
    prefix: 'fasds',
    iconName: 'building-circle-check',
    icon: [
      640,
      512,
      [],
      'e4d2',
      
      ['M0 0L384 0l0 232.2c-39.1 32.3-64 81.1-64 135.8s24.9 103.5 64 135.8l0 8.2-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faBurgerCheese = {
    prefix: 'fasds',
    iconName: 'burger-cheese',
    icon: [
      512,
      512,
      [127828,"cheeseburger"],
      'f7f1',
      
      ['M32 192s0-160 224-160s224 160 224 160l0 32L32 224l0-32zm0 192l448 0 0 96L32 480l0-96zm80-256a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zM224 256c64 0 128 0 192 0c-32 21.3-64 42.7-96 64c-32-21.3-64-42.7-96-64zM240 96a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm128 32a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M320 320l-96-64-32 0s0 0 0 0L16 256l0 96 480 0 0-96-48 0s0 0 0 0l-32 0-96 64z']
      
    ]
  };

  
    var faCheeseburger = faBurgerCheese;
  

  
  

  var faChessBoard = {
    prefix: 'fasds',
    iconName: 'chess-board',
    icon: [
      448,
      512,
      [],
      'f43c',
      
      ['M448 32L0 32 0 480l448 0 0-448zM384 96l0 320L64 416 64 96l320 0z','M192 96l-64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0 0-64zm0 128l-64 0 0-64 64 0 0 64zm64 0l0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64 64 0zm0 0l0-64 64 0 0 64-64 0z']
      
    ]
  };

  

  
  

  var faBringFront = {
    prefix: 'fasds',
    iconName: 'bring-front',
    icon: [
      640,
      512,
      [],
      'f857',
      
      ['M0 0L0 64 0 192l0 64 64 0 96 0 0-64-96 0L64 64l128 0 0 32 64 0 0-32 0-64L192 0 64 0 0 0zM384 416l0 32 0 64 64 0 128 0 64 0 0-64 0-128 0-64-64 0-96 0 0 64 96 0 0 128-128 0 0-32-64 0z','M480 96L160 96l0 320 320 0 0-320z']
      
    ]
  };

  

  
  

  var faUpLeft = {
    prefix: 'fasds',
    iconName: 'up-left',
    icon: [
      384,
      512,
      [],
      'e2bd',
      
      ['M152 296l80-80L384 368l-80 80L152 296z','M16 80V368l32 32L336 112 304 80H16z']
      
    ]
  };

  

  
  

  var faSquareQuote = {
    prefix: 'fasds',
    iconName: 'square-quote',
    icon: [
      448,
      512,
      [],
      'e329',
      
      ['M0 32l448 0 0 448L0 480 0 32zM96 160l0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-8 0-56 0-24 0-32L96 160zm144 0l0 112 64 0 0 8c0 13.3-10.7 24-24 24l-24 0 0 48 24 0c39.8 0 72-32.2 72-72l0-8 0-56 0-24 0-32-112 0z','M96 160l112 0 0 32 0 24 0 56 0 8c0 39.8-32.2 72-72 72l-24 0 0-48 24 0c13.3 0 24-10.7 24-24l0-8-64 0 0-112zm144 0l112 0 0 32 0 24 0 56 0 8c0 39.8-32.2 72-72 72l-24 0 0-48 24 0c13.3 0 24-10.7 24-24l0-8-64 0 0-112z']
      
    ]
  };

  

  
  

  var faHoodCloak = {
    prefix: 'fasds',
    iconName: 'hood-cloak',
    icon: [
      576,
      512,
      [],
      'f6ef',
      
      ['M160 320l0 192 256 0 0-192c0-70.7-57.3-128-128-128s-128 57.3-128 128z','M0 464l0 48 160 0 0-192c0-70.7 57.3-128 128-128s128 57.3 128 128l0 192 160 0 0-48-64-80 0-96c0-98.4-42.4-172.6-104.8-215.2L480 0 288 0C160 0 64 128 64 288l0 96L0 464z']
      
    ]
  };

  

  
  

  var faGlasses = {
    prefix: 'fasds',
    iconName: 'glasses',
    icon: [
      576,
      512,
      [],
      'f530',
      
      ['M48 320l0 32 0 24 0 56 160 0 0-96 0-16L48 320zm320 0l0 16 0 96 160 0 0-56 0-24 0-32-160 0z','M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6c0 0 0 0 0 0l-.3 1c-8.1 29-16.1 57.8-26.2 100.6L232 272l24 0 0 24 0 8 64 0 0-8 0-24 24 0 183.3 0c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1s0 0 0 0s0 0 0 0s0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7 0 2.8s0 0 0 0l0 24 0 56 0 24 0 80 0 24-24 0-208 0-24 0 0-24 0-88-64 0 0 88 0 24-24 0L24 480 0 480l0-24 0-80 0-24 0-56 0-24s0 0 0 0l0-2.8 .6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM528 320l-160 0 0 16 0 96 160 0 0-56 0-24 0-32zM48 352l0 24 0 56 160 0 0-96 0-16L48 320l0 32z']
      
    ]
  };

  

  
  

  var faPaintbrushFine = {
    prefix: 'fasds',
    iconName: 'paintbrush-fine',
    icon: [
      576,
      512,
      ["paint-brush-alt","paint-brush-fine","paintbrush-alt"],
      'f5a9',
      
      ['','M575.2 80l-39.6 39.6L306.9 348.3l-79.2-79.2L456.4 40.4 496 .8 575.2 80zM205.1 291.7l79.2 79.2-.1 .1c2.5 9.3 3.8 19 3.8 29c0 61.9-50.1 112-112 112L0 512l0-64 64 0 0-48c0-61.9 50.1-112 112-112c10 0 19.8 1.3 29 3.8l.1-.1z']
      
    ]
  };

  
    var faPaintBrushAlt = faPaintbrushFine;
  
    var faPaintBrushFine = faPaintbrushFine;
  
    var faPaintbrushAlt = faPaintbrushFine;
  

  
  

  var faChessQueen = {
    prefix: 'fasds',
    iconName: 'chess-queen',
    icon: [
      512,
      512,
      [9819],
      'f445',
      
      ['M64 480l48-48 288 0 48 48 0 32L64 512l0-32z','M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM424 192c20.6 0 39-9.7 50.7-24.9L512 192 400 432l-288 0L0 192l37.3-24.9C49 182.3 67.4 192 88 192c35.3 0 64-28.7 64-64l42 0c6.2 24 26 42.6 50.7 47c3.4 .6 7.2 1 11.3 1s7.8-.3 11.3-1c24.7-4.4 44.5-23 50.7-47l42 0c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faTreasureChest = {
    prefix: 'fasds',
    iconName: 'treasure-chest',
    icon: [
      576,
      512,
      [],
      'f723',
      
      ['M0 160l0 96 96 0L96 36C40.8 50.2 0 100.4 0 160zM0 288L0 480l96 0 0-192L0 288zM160 32l0 224 64 0 0-64 128 0 0 64 64 0 0-224L160 32zm0 256l0 192 256 0 0-192-64 0 0 64-128 0 0-64-64 0zM480 36l0 220 96 0 0-96c0-59.6-40.8-109.8-96-124zm0 252l0 192 96 0 0-192-96 0z','M160 32l0 224-64 0L96 36c10.2-2.6 21-4 32-4l32 0zM416 256l0-224 32 0c11 0 21.8 1.4 32 4l0 220-64 0zM224 192l128 0 0 160-128 0 0-160zm80 32l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16zM160 480l-64 0 0-192 64 0 0 192zm256 0l0-192 64 0 0 192-64 0z']
      
    ]
  };

  

  
  

  var faMessageArrowUpRight = {
    prefix: 'fasds',
    iconName: 'message-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e1dd',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM150.1 280L184 313.9l17-17 87-87 0 54.1 0 24 48 0 0-24 0-112 0-24-24 0-112 0-24 0 0 48 24 0 54.1 0-87 87-17 17z','M176 128l24 0 112 0 24 0 0 24 0 112 0 24-48 0 0-24 0-54.1-87 87-17 17L150.1 280l17-17 87-87L200 176l-24 0 0-48z']
      
    ]
  };

  

  
  

  var faFileSlash = {
    prefix: 'fasds',
    iconName: 'file-slash',
    icon: [
      640,
      512,
      [],
      'e3a7',
      
      ['M128 0L352 0l0 160 160 0 0 214.7C384 275.4 256 176 128 76.6L128 0zm0 196.8L512 499.4l0 12.6-384 0 0-315.2zM384 0L512 128l-128 0L384 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faCoinFront = {
    prefix: 'fasds',
    iconName: 'coin-front',
    icon: [
      512,
      512,
      [],
      'e3fc',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm448 0A192 192 0 1 1 64 256a192 192 0 1 1 384 0zM96 256a160 160 0 1 0 320 0A160 160 0 1 0 96 256zm136-96l48 0 0 24 0 144 0 24-48 0 0-24 0-144 0-24z','M256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384z']
      
    ]
  };

  

  
  

  var faGaugeCircleBolt = {
    prefix: 'fasds',
    iconName: 'gauge-circle-bolt',
    icon: [
      640,
      512,
      [],
      'e496',
      
      ['M0 256C0 397.4 114.6 512 256 512c39.5 0 77-9 110.4-25C337.6 455.7 320 413.9 320 368c0-97.2 78.8-176 176-176c2.7 0 5.3 .1 8 .2C475.6 81.7 375.4 0 256 0C114.6 0 0 114.6 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm64 16l66.7 0L472 448l104-96-66.7 0L520 288 416 384z']
      
    ]
  };

  

  
  

  var faTransporter5 = {
    prefix: 'fasds',
    iconName: 'transporter-5',
    icon: [
      512,
      512,
      [],
      'e2a6',
      
      ['M0 176l32 16 16 32 16-32 32-16L64 160 48 128 32 160 0 176zm96 80l0 32 16 0 288 0 16 0 0-32-16 0-288 0-16 0zm64-128l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zm0 256l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zM208 0l0 32 16 0 64 0 16 0 0-32L288 0 224 0 208 0zM416 48l32 16 16 32 16-32 32-16L480 32 464 0 448 32 416 48z','M96 448H416v64H96V448z']
      
    ]
  };

  

  
  

  var faVolume = {
    prefix: 'fasds',
    iconName: 'volume',
    icon: [
      576,
      512,
      [128265,"volume-medium"],
      'f6a8',
      
      ['M412.8 217.6c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4C464.9 315.3 480 287.4 480 256s-15.1-59.3-38.4-76.8l-28.8 38.4zm57.6-76.8c35 26.3 57.6 68.1 57.6 115.2s-22.6 88.9-57.6 115.2l28.8 38.4c46.6-35 76.8-90.8 76.8-153.6s-30.2-118.6-76.8-153.6l-28.8 38.4z','M32 352V160H160L304 32h48V480H304L160 352H32z']
      
    ]
  };

  
    var faVolumeMedium = faVolume;
  

  
  

  var faDiceTwo = {
    prefix: 'fasds',
    iconName: 'dice-two',
    icon: [
      448,
      512,
      [9857],
      'f528',
      
      ['M0 32l448 0 0 448L0 480 0 32zM96 160a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM288 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faGift = {
    prefix: 'fasds',
    iconName: 'gift',
    icon: [
      512,
      512,
      [127873],
      'f06b',
      
      ['M0 128l73.6 0c7.3 14.2 18.3 26.2 31.8 34.7c6.8 4.2 14.1 7.5 21.9 9.8c3.9 1.1 7.9 2 12 2.6c2.1 .3 4.1 .5 6.2 .7c1 .1 2.1 .1 3.2 .2s2.1 .1 3.2 .1l64 0 8 0 0 80L0 256 0 128zM32 288l192 0 0 224L32 512l0-224zM288 176l72 0c34.2 0 63.8-19.5 78.4-48l73.6 0 0 128-224 0 0-80zm0 112l192 0 0 224-192 0 0-224z','M190.5 68.8L225.3 128l-1.3 0-8 0-64 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88s39.4 88 88 88l64 0 8 0 0 80 64 0 0-80 72 0c48.6 0 88-39.4 88-88s-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5zm65.5-16.7C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zM288 512l0-224-64 0 0 224 64 0z']
      
    ]
  };

  

  
  

  var faMemoCircleInfo = {
    prefix: 'fasds',
    iconName: 'memo-circle-info',
    icon: [
      576,
      512,
      [],
      'e49a',
      
      ['M0 0L384 0l0 198.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0zM64 128l0 32 16 0 224 0 16 0 0-32-16 0L80 128l-16 0zm0 96l0 32 16 0 160 0 16 0 0-32-16 0L80 224l-16 0zm0 96l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm127.3-80l0 32 32 0 0-32-32 0zm33.2 80l0-16-16 0L416 352l-16 0 0 32 16 0 .5 0 0 48-.5 0-16 0 0 32 16 0 32 0 .5 0 15.5 0 0-32-15.5 0 0-64z']
      
    ]
  };

  

  
  

  var faMailboxFlagUp = {
    prefix: 'fasds',
    iconName: 'mailbox-flag-up',
    icon: [
      576,
      512,
      [],
      'e5bb',
      
      ['M144 64c79.5 0 144 64.5 144 144l0 240 288 0 0-240c0-56.5-32.6-105.5-80-129l0 17 0 16-16 0-64 0 0 96 0 16-32 0 0-16 0-112 0-32L144 64z','M384 224l0-16 0-112 0-48 0-16 16 0 80 0 16 0 0 16 0 48 0 16-16 0-64 0 0 96 0 16-32 0zM0 208C0 128.5 64.5 64 144 64s144 64.5 144 144l0 240L0 448 0 208zm64-16l0 32 16 0 128 0 16 0 0-32-16 0L80 192l-16 0z']
      
    ]
  };

  

  
  

  var faFaceDowncastSweat = {
    prefix: 'fasds',
    iconName: 'face-downcast-sweat',
    icon: [
      512,
      512,
      [],
      'e371',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0c-51 0-98.5 14.9-138.4 40.6C124.4 52.6 128 66.1 128 80c0 44.2-35.8 80-80 80c-9.6 0-18.8-1.7-27.4-4.8C7.3 186.1 0 220.2 0 256zm96 0l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm65.4 145.2l10.7-11.9C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4zM288 256l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z','M48 0L9.6 51.2C3.4 59.5 0 69.6 0 80c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L48 0zM96 256l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm192 0l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z']
      
    ]
  };

  

  
  

  var faCarBattery = {
    prefix: 'fasds',
    iconName: 'car-battery',
    icon: [
      512,
      512,
      ["battery-car"],
      'f5df',
      
      ['M0 96l80 0 128 0 96 0 128 0 80 0 0 352L0 448 0 96zM80 224l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm224 0l0 32 16 0 32 0 0 32 0 16 32 0 0-16 0-32 32 0 16 0 0-32-16 0-32 0 0-32 0-16-32 0 0 16 0 32-32 0-16 0z','M80 64H208V96H80V64zm224 0H432V96H304V64z']
      
    ]
  };

  
    var faBatteryCar = faCarBattery;
  

  
  

  var faDogLeashed = {
    prefix: 'fasds',
    iconName: 'dog-leashed',
    icon: [
      576,
      512,
      [129454],
      'f6d4',
      
      ['M97.4 23.8l11 11.6L256 190.4 256 384l0 16 32 0 0-16c0-2.2 0-4.4 0-6.6c0-56.4 0-112.8 0-169.3c42.7 18 85.3 35.9 128 53.9c.6 .3 1.2 .5 1.8 .8l14.7 6.2L445 239.5l-14.7-6.2c-3.2-1.4-6.5-2.7-9.7-4.1c-38.2-16.1-76.4-32.2-114.6-48.3l-24.6-10.3L131.6 13.3l-11-11.6L97.4 23.8z','M256 192l-80 0-16 0-16 0-39.5 0c-16.1 0-29.8-12-31.8-28l-1-7.9-4-31.8L4.3 132.2l4 31.8 1 7.9c4.2 33.7 25.6 61.6 54.8 75.1L64 512l96 0 0-147.2c24 12.3 51.2 19.2 80 19.2c5.4 0 10.7-.2 16-.7L256 192zm32 185.4c11.2-3.2 21.9-7.4 32-12.6L320 512l96 0 0-250L288 208.1l0 169.3zM420.5 229.2l6.2-37.2 21.3 0 16 0 32 0c44.2 0 80-35.8 80-80l0-48-80 0L464 32l-72 0L368 0 336 0 305.9 180.9l114.6 48.3zM432 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z']
      
    ]
  };

  

  
  

  var faMugHot = {
    prefix: 'fasds',
    iconName: 'mug-hot',
    icon: [
      512,
      512,
      [9749],
      'f7b6',
      
      ['M64 0l0 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136l0 24 48 0 0-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24l0-24L64 0zM176 0l0 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136l0 24 48 0 0-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24l0-24L176 0z','M352 192L0 192 0 512l384 0 0-96 16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-16 0-32 0zm32 64l16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0-96z']
      
    ]
  };

  

  
  

  var faArrowDownSquareTriangle = {
    prefix: 'fasds',
    iconName: 'arrow-down-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-down-alt"],
      'f889',
      
      ['M304 480L416 288 528 480l-224 0zM320 32l192 0 0 192-192 0 0-192z','M160 480l23.7-26 80-88 21.5-23.7-47.4-43.1-21.5 23.7L192 349.7l0-285.2 0-32-64 0 0 32 0 285.2-24.3-26.8L82.2 299.2 34.8 342.3 56.3 366l80 88L160 480z']
      
    ]
  };

  
    var faSortShapesDownAlt = faArrowDownSquareTriangle;
  

  
  

  var faSquarePollVertical = {
    prefix: 'fasds',
    iconName: 'square-poll-vertical',
    icon: [
      448,
      512,
      ["poll"],
      'f681',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 224l64 0 0 160-64 0 0-160zm96-96l64 0 0 256-64 0 0-256zm96 160l64 0 0 96-64 0 0-96z','M192 128l64 0 0 256-64 0 0-256zM96 224l64 0 0 160-64 0 0-160zm256 64l0 96-64 0 0-96 64 0z']
      
    ]
  };

  
    var faPoll = faSquarePollVertical;
  

  
  

  var faJedi = {
    prefix: 'fasds',
    iconName: 'jedi',
    icon: [
      576,
      512,
      [],
      'f669',
      
      ['M192 336l53.2 17.7-25.1 50.2 47.2-23.6L265.1 446c7.4 1.3 15.1 2 22.9 2c1 0 1.9 0 2.9 0s1.9-.1 2.9-.1c1.9-.1 3.9-.2 5.8-.4c3.8-.3 7.6-.9 11.3-1.5l-2.2-65.7 47.2 23.6-25.1-50.2L384 336l-53.2-17.7 25.1-50.2-50.1 25.1L296 0 280 0l-9.8 293.2-50.1-25.1 25.1 50.2L192 336z','M448 88c0 57.3-30.2 107.6-75.5 135.9C399.2 247.3 416 281.7 416 320c0 70.7-57.3 128-128 128s-128-57.3-128-128c0-38.3 16.8-72.7 43.5-96.1C158.2 195.6 128 145.3 128 88c0-30.5 8.5-59 23.3-83.2C86.4 42.6 38.5 106.5 22.2 182.2L64 224l-47.5 0c-.3 5.3-.5 10.6-.5 16c0 18.2 1.8 36 5.2 53.2L80 352l-39.9 0C82.7 446.4 177.7 512 288 512s205.3-65.6 247.9-160L496 352l58.8-58.8c3.4-17.2 5.2-35 5.2-53.2c0-5.4-.2-10.7-.5-16L512 224l41.8-41.8C537.5 106.5 489.6 42.6 424.7 4.8C439.5 29 448 57.5 448 88z']
      
    ]
  };

  

  
  

  var faTilde = {
    prefix: 'fasds',
    iconName: 'tilde',
    icon: [
      448,
      512,
      [63135],
      '7e',
      
      ['M0 128l32 0 96 0 13.3 0 9.4 9.4L333.3 320l50.7 0 0-128 0-32 64 0 0 32 0 160 0 32-32 0-96 0-13.3 0-9.4-9.4L114.7 192 64 192l0 128 0 32L0 352l0-32L0 160l0-32z','']
      
    ]
  };

  

  
  

  var faMapLocationDot = {
    prefix: 'fasds',
    iconName: 'map-location-dot',
    icon: [
      576,
      512,
      ["map-marked-alt"],
      'f5a0',
      
      ['M0 192l133-53.2c5.5 19.4 15.1 40.6 27 62.1L160 448 0 512 0 192zm192 60.3c44.5 65.3 96 121 96 121s51.4-55.7 96-121L384 512 192 448l0-195.7zm224-51.5c2.1-3.8 4.1-7.5 6-11.3L576 128l0 320L416 512l0-311.1z','M288 320s120-130 120-200C408 53.7 354.3 0 288 0S168 53.7 168 120c0 70 120 200 120 200zm0-248a40 40 0 1 1 0 80 40 40 0 1 1 0-80z']
      
    ]
  };

  
    var faMapMarkedAlt = faMapLocationDot;
  

  
  

  var faBorderTopLeft = {
    prefix: 'fasds',
    iconName: 'border-top-left',
    icon: [
      448,
      512,
      ["border-style"],
      'f853',
      
      ['M96 416l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0zm96-288l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M0 480l0-32L0 64 0 32l32 0 384 0 32 0 0 64-32 0L64 96l0 352 0 32L0 480z']
      
    ]
  };

  
    var faBorderStyle = faBorderTopLeft;
  

  
  

  var faNotEqual = {
    prefix: 'fasds',
    iconName: 'not-equal',
    icon: [
      448,
      512,
      [],
      'f53e',
      
      ['M16 144l32 0 209.1 0c-13.5 21.3-27 42.7-40.5 64L48 208l-32 0 0-64zm0 160l32 0 107.7 0c-13.5 21.3-27 42.7-40.5 64L48 368l-32 0 0-64zm174.9 64c13.5-21.3 27-42.7 40.5-64L400 304l32 0 0 64-32 0-209.1 0zM292.3 208c13.5-21.3 27-42.7 40.5-64l67.2 0 32 0 0 64-32 0-107.7 0z','M328 32l75.8 0-.7 1.1L120 480l-75.8 0 .7-1.1L328 32z']
      
    ]
  };

  

  
  

  var faMoneyCheckPen = {
    prefix: 'fasds',
    iconName: 'money-check-pen',
    icon: [
      640,
      512,
      ["money-check-edit"],
      'f872',
      
      ['M0 64L0 448l326.6 0 4.4-30.6L564.4 184c3.9-3.9 7.7-7.7 11.6-11.6L576 64 0 64zM96 192l352 0 0 32L96 224l0-32zm0 96l256 0 0 32L96 320l0-32z','M640 294.8l-71-71-41.3 41.3 71 71L640 294.8zm-63.9 63.9l-71-71L363.9 429 352 511.9 434.9 500 576.1 358.7z']
      
    ]
  };

  
    var faMoneyCheckEdit = faMoneyCheckPen;
  

  
  

  var faManatSign = {
    prefix: 'fasds',
    iconName: 'manat-sign',
    icon: [
      384,
      512,
      [],
      'e1d5',
      
      ['M160 32l64 0 0 66.7c-5.2-.9-10.5-1.5-15.8-2c-2.7-.2-5.4-.4-8-.5c-1.3-.1-2.7-.1-4.1-.1s-2.7 0-4.1 0c-10.9 0-21.6 .9-32 2.7L160 32zm0 132c5.1-1.3 10.3-2.3 15.7-3c2.7-.3 5.4-.6 8.1-.8c1.4-.1 2.7-.2 4.1-.2s2.7-.1 4.1-.1c11 0 21.8 1.4 32 4l0 316-64 0 0-316z','M0 288C0 182 86 96 192 96s192 86 192 192l0 160 0 32-64 0 0-32 0-160c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 160 0 32L0 480l0-32L0 288z']
      
    ]
  };

  

  
  

  var faSquareK = {
    prefix: 'fasds',
    iconName: 'square-k',
    icon: [
      448,
      512,
      [],
      'e274',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l48 0 0 24 0 83.8L190.1 220l82.5-92 64.5 0-1 1.1L238.3 238.3 330 376.7l4.8 7.3-57.6 0L205.1 275.2 176 307.7l0 52.3 0 24-48 0 0-24 0-61.5L128 152l0-24z','M272.6 128l64.5 0-1 1.1L238.3 238.3 330 376.7l4.8 7.3-57.6 0L205.1 275.2 176 307.7l0 52.3 0 24-48 0 0-24 0-61.5L128 152l0-24 48 0 0 24 0 83.8L190.1 220l82.5-92z']
      
    ]
  };

  

  
  

  var faCircleDownRight = {
    prefix: 'fasds',
    iconName: 'circle-down-right',
    icon: [
      512,
      512,
      [],
      'e108',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144-56l56-56 76 76 52-52 24 24 0 160-160 0-24-24 52-52-76-76z','M328 168l24 24 0 160-160 0-24-24 52-52-76-76 56-56 76 76 52-52z']
      
    ]
  };

  

  
  

  var faEngineWarning = {
    prefix: 'fasds',
    iconName: 'engine-warning',
    icon: [
      640,
      512,
      ["engine-exclamation"],
      'f5f2',
      
      ['M0 136l0 24L0 352l0 24 48 0 0-24 0-72 48 0 0-48-48 0 0-72 0-24L0 136zM184 64l0 48 24 0 72 0 0 32 48 0 0-32 72 0 24 0 0-48-24 0L208 64l-24 0zM544 192l0 256 96 0 0-256-96 0z','M160 144l-64 0 0 240 76.8 0L224 448l288 0 0-240-80-64-224 0-48 0zm164 64l0 88 0 20-40 0 0-20 0-88 0-20 40 0 0 20zm4 144l0 48-48 0 0-48 48 0z']
      
    ]
  };

  
    var faEngineExclamation = faEngineWarning;
  

  
  

  var faTransporter3 = {
    prefix: 'fasds',
    iconName: 'transporter-3',
    icon: [
      512,
      512,
      [],
      'e045',
      
      ['M0 144l32-16L48 96l16 32 32 16L64 160 48 192 32 160 0 144zM96 255.5c0 .2 0 .3 0 .5c5.3 0 10.7 0 16 0l288 0 16 0 0 32-16 0-288 0-16 0 0-31.5 0-1zM128 192l16 0 224 0 16 0 0 32-16 0-224 0-16 0 0-32zm32-64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 192l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm0 64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zM416 48l32-16L464 0l16 32 32 16L480 64 464 96 448 64 416 48z','M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm8 464L96 512l0-64 320 0 0 64-120 0-80 0zM96 256.5l0-1c0 .3 0 .7 0 1z']
      
    ]
  };

  

  
  

  var faBuildingNgo = {
    prefix: 'fasds',
    iconName: 'building-ngo',
    icon: [
      384,
      512,
      [],
      'e4d7',
      
      ['M0 0L0 512l144 0 0-128 96 0 0 128 144 0L384 0 0 0zM32 64l16 0 8 0 9.9 0 4.4 8.8L96 124.2 96 80l0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L64 131.8 64 176l0 16-32 0 0-16 0-96 0-16zM64 224l64 0 0 64-64 0 0-64zM152 64l16 0 48 0 16 0 0 32-16 0-32 0 0 64 16 0 0-16 0-16 32 0 0 16 0 32 0 16-16 0-48 0-16 0 0-16 0-96 0-16zm8 160l64 0 0 64-64 0 0-64zm96-112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zm0 112l64 0 0 64-64 0 0-64zm32-112l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z','M48 64L32 64l0 16 0 96 0 16 32 0 0-16 0-44.2 25.7 51.4 4.4 8.8 9.9 0 8 0 16 0 0-16 0-96 0-16L96 64l0 16 0 44.2L70.3 72.8 65.9 64 56 64l-8 0zm104 0l0 16 0 96 0 16 16 0 48 0 16 0 0-16 0-32 0-16-32 0 0 16 0 16-16 0 0-64 32 0 16 0 0-32-16 0-48 0-16 0zM304 96c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm-48 16l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z']
      
    ]
  };

  

  
  

  var faAnchorLock = {
    prefix: 'fasds',
    iconName: 'anchor-lock',
    icon: [
      640,
      512,
      [],
      'e4ad',
      
      ['M0 352l64 0 0 128 0 32 32 0 192 0 96 0 0-64-64 0 0-208 32 0 32 0 0-64-32 0-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faBold = {
    prefix: 'fasds',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      ['M0 32l32 0 48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0L0 480l0-64 32 0 16 0 0-160L48 96 32 96 0 96 0 32zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z','']
      
    ]
  };

  

  
  

  var faStroopwafel = {
    prefix: 'fasds',
    iconName: 'stroopwafel',
    icon: [
      512,
      512,
      [],
      'f551',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm52.4-45.3L75 188.1c3.8 3.8 7.5 7.5 11.3 11.3c11.3 11.3 22.6 22.6 33.9 33.9c15.1-15.1 30.2-30.2 45.3-45.3c-18.9-18.9-37.7-37.7-56.6-56.6c-3.8-3.8-7.5-7.5-11.3-11.3c7.5-7.5 15.1-15.1 22.6-22.6l11.3 11.3c18.9 18.9 37.7 37.7 56.6 56.6c15.1-15.1 30.2-30.2 45.3-45.3L199.4 86.3 188.1 75c7.5-7.5 15.1-15.1 22.6-22.6c3.8 3.8 7.5 7.5 11.3 11.3C233.4 75 244.7 86.3 256 97.6c11.3-11.3 22.6-22.6 33.9-33.9c3.8-3.8 7.5-7.5 11.3-11.3L323.9 75c-3.8 3.8-7.5 7.5-11.3 11.3c-11.3 11.3-22.6 22.6-33.9 33.9l45.3 45.3c18.9-18.9 37.7-37.7 56.6-56.6c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-18.9 18.9-37.7 37.7-56.6 56.6c15.1 15.1 30.2 30.2 45.3 45.3c11.3-11.3 22.6-22.6 33.9-33.9c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-11.3 11.3-22.6 22.6-33.9 33.9c11.3 11.3 22.6 22.6 33.9 33.9c3.8 3.8 7.5 7.5 11.3 11.3L437 323.9c-3.8-3.8-7.5-7.5-11.3-11.3c-11.3-11.3-22.6-22.6-33.9-33.9c-15.1 15.1-30.2 30.2-45.3 45.3c18.9 18.9 37.7 37.7 56.6 56.6l11.3 11.3-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-18.9-18.9-37.7-37.7-56.6-56.6c-15.1 15.1-30.2 30.2-45.3 45.3c11.3 11.3 22.6 22.6 33.9 33.9L323.9 437c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-11.3-11.3-22.6-22.6-33.9-33.9c-11.3 11.3-22.6 22.6-33.9 33.9c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6l11.3-11.3 33.9-33.9c-15.1-15.1-30.2-30.2-45.3-45.3c-18.9 18.9-37.7 37.7-56.6 56.6c-3.8 3.8-7.5 7.5-11.3 11.3L97.6 391.8c3.8-3.8 7.5-7.5 11.3-11.3c18.9-18.9 37.7-37.7 56.6-56.6c-15.1-15.1-30.2-30.2-45.3-45.3c-11.3 11.3-22.6 22.6-33.9 33.9c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6l11.3-11.3L97.6 256C86.3 244.7 75 233.4 63.7 222.1c-3.8-3.8-7.5-7.5-11.3-11.3zM142.9 256c15.1 15.1 30.2 30.2 45.3 45.3L233.4 256l-45.3-45.3L142.9 256zm67.9-67.9c15.1 15.1 30.2 30.2 45.3 45.3l45.3-45.3L256 142.9l-45.3 45.3zm0 135.8c15.1 15.1 30.2 30.2 45.3 45.3c15.1-15.1 30.2-30.2 45.3-45.3c-15.1-15.1-30.2-30.2-45.3-45.3l-45.3 45.3zM278.6 256l45.3 45.3C339 286.2 354 271.1 369.1 256c-15.1-15.1-30.2-30.2-45.3-45.3c-15.1 15.1-30.2 30.2-45.3 45.3z','M312.6 86.3L323.9 75 301.3 52.4 289.9 63.7 256 97.6 222.1 63.7 210.7 52.4 188.1 75l11.3 11.3 33.9 33.9-45.3 45.3-56.6-56.6L120.2 97.6 97.6 120.2l11.3 11.3 56.6 56.6-45.3 45.3L86.3 199.4 75 188.1 52.4 210.7l11.3 11.3L97.6 256 63.7 289.9 52.4 301.3 75 323.9l11.3-11.3 33.9-33.9 45.3 45.3-56.6 56.6L97.6 391.8l22.6 22.6 11.3-11.3 56.6-56.6 45.3 45.3-33.9 33.9L188.1 437l22.6 22.6 11.3-11.3L256 414.4l33.9 33.9 11.3 11.3L323.9 437l-11.3-11.3-33.9-33.9 45.3-45.3 56.6 56.6 11.3 11.3 22.6-22.6-11.3-11.3-56.6-56.6 45.3-45.3 33.9 33.9L437 323.9l22.6-22.6-11.3-11.3L414.4 256l33.9-33.9 11.3-11.3L437 188.1l-11.3 11.3-33.9 33.9-45.3-45.3 56.6-56.6 11.3-11.3L391.8 97.6l-11.3 11.3-56.6 56.6-45.3-45.3 33.9-33.9zM369.1 256l-45.3 45.3L278.6 256l45.3-45.3L369.1 256zm-67.9 67.9L256 369.1l-45.3-45.3L256 278.6l45.3 45.3zM233.4 256l-45.3 45.3L142.9 256l45.3-45.3L233.4 256zm67.9-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z']
      
    ]
  };

  

  
  

  var faSignature = {
    prefix: 'fasds',
    iconName: 'signature',
    icon: [
      640,
      512,
      [],
      'f5b7',
      
      ['M0 368l24 0 40 0 0 39.5c0 2.9 .1 5.7 .3 8.5L24 416 0 416l0-48zm283.5 48c8.2-15.7 15.6-31.7 22.3-48L616 368l24 0 0 48-24 0-332.5 0z','M224 96c-17.7 0-32 14.3-32 32l0 32 0 32-64 0 0-32 0-32c0-53 43-96 96-96s96 43 96 96l0 7.8c0 20.8-1.2 41.6-3.6 62.3l122.4-36.7 59-17.7-19.5 58.5-18 53.9 83.6 0 32 0 0 64-32 0-128 0-44.4 0 14-42.1 12.5-37.5-94.4 28.3c-11.9 52.8-31.6 103.5-58.4 150.5l-25.5 44.7L210.6 480 192 480l-64 0-32 0 0-32 0-160 0-23.8 22.8-6.8 130-39c4.8-27.2 7.1-54.9 7.1-82.5l0-7.8c0-17.7-14.3-32-32-32zm7.8 194.3L160 311.8 160 416l13.4 0 16.3-28.6c17.6-30.8 31.7-63.4 42.1-97.2z']
      
    ]
  };

  

  
  

  var faCaduceus = {
    prefix: 'fasds',
    iconName: 'caduceus',
    icon: [
      512,
      512,
      [],
      'e681',
      
      ['M0 224l138.7 0c33.5 0 66.2-10.5 93.3-30l0-78L128 64 0 224zm144 32l0 24 0 3.8c0 30.9 16.2 59.6 42.7 75.5l22.6 13.6-6.6 4c-26.5 15.9-42.7 44.5-42.7 75.5l0 3.8 0 24 48 0 0-24 0-3.8c0-14.1 7.4-27.1 19.4-34.3l4.6-2.7 24-14.4 24-14.4 0 28.8 4.6 2.7c12 7.2 19.4 20.2 19.4 34.3l0 3.8 0 24 48 0 0-24 0-3.8c0-30.9-16.2-59.6-42.7-75.5l-6.6-4 22.6-13.6c26.5-15.9 42.7-44.5 42.7-75.5l0-3.8 0-24-48 0 0 24 0 3.8c0 14.1-7.4 27.1-19.4 34.3L280 330.4l-24 14.4-24 14.4 0-28.8-20.6-12.3c-12-7.2-19.4-20.2-19.4-34.3l0-3.8 0-24-48 0zM280 116l0 78c27.2 19.5 59.8 30 93.3 30L512 224 384 64 280 116z','M304 48c0 17.8-9.7 33.3-24 41.6l0 6.4 0 234.4-48 28.8L232 96l0-6.4c-14.3-8.3-24-23.8-24-41.6c0-26.5 21.5-48 48-48s48 21.5 48 48zM232 415.2l48-28.8 0 61.6 0 64-48 0 0-64 0-32.8z']
      
    ]
  };

  

  
  

  var faSquareO = {
    prefix: 'fasds',
    iconName: 'square-o',
    icon: [
      448,
      512,
      [],
      'e278',
      
      ['M0 32L0 480l448 0 0-448L0 32zM352 256A128 128 0 1 1 96 256a128 128 0 1 1 256 0zm-208 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M224 176a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm128 80A128 128 0 1 1 96 256a128 128 0 1 1 256 0z']
      
    ]
  };

  

  
  

  var faBinarySlash = {
    prefix: 'fasds',
    iconName: 'binary-slash',
    icon: [
      640,
      512,
      [],
      'e33e',
      
      ['M128 0l0 32 0 44.6c21.3 16.6 42.7 33.1 64 49.7L192 64l64 0 0 96-20.6 0 82.4 64 2.1 0 0-32 0-160 0-32L288 0 160 0 128 0zm0 288l0 64 32 0 16 0 0 96-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32-32 0-48 0-32 0zm32-65.9l0 1.9 2.5 0-2.5-1.9zM320 348.1L320 480l0 32 32 0 128 0 32 0 0-12.6L446.8 448 384 448l0-49.5-64-50.4zM352 0l0 64 32 0 16 0 0 96-16 0-32 0 0 64 32 0 48 0 48 0 32 0 0-64-32 0-16 0 0-128 0-32L432 0 384 0 352 0zm48.3 288c37.2 28.9 74.5 57.8 111.7 86.7l0-54.7 0-32-32 0-79.7 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faUserPen = {
    prefix: 'fasds',
    iconName: 'user-pen',
    icon: [
      640,
      512,
      ["user-edit"],
      'f4ff',
      
      ['M0 512l317.4 0L331 417.4l67.2-67.2L384 304 64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M640 294.8l-71-71-41.3 41.3 71 71L640 294.8zm-63.9 63.9l-71-71L363.9 429 352 511.9 434.9 500 576.1 358.7z']
      
    ]
  };

  
    var faUserEdit = faUserPen;
  

  
  

  var faPrescriptionBottlePill = {
    prefix: 'fasds',
    iconName: 'prescription-bottle-pill',
    icon: [
      576,
      512,
      [],
      'e5c0',
      
      ['M0 0L0 96l384 0 0-96L0 0zM32 128l0 64 112 0 16 0 0 32-16 0L32 224l0 64 112 0 16 0 0 32-16 0L32 320l0 64 112 0 16 0 0 32-16 0L32 416l0 96 298.8 0C285.6 480.1 256 427.5 256 368c0-68.4 39-127.7 96-156.8l0-83.2L32 128z','M319.5 278.1C299.8 302.8 288 334 288 368c0 79.5 64.5 144 144 144c34 0 65.2-11.8 89.9-31.5L319.5 278.1zm225 179.8C564.2 433.2 576 402 576 368c0-79.5-64.5-144-144-144c-34 0-65.2 11.8-89.9 31.5L544.5 457.9z']
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fasds',
    iconName: 'underline',
    icon: [
      448,
      512,
      [],
      'f0cd',
      
      ['M16 32l0 64 32 0 16 0 0 128c0 88.4 71.6 160 160 160s160-71.6 160-160l0-128 16 0 32 0 0-64-32 0-96 0-32 0 0 64 32 0 16 0 0 128c0 53-43 96-96 96s-96-43-96-96l0-128 16 0 32 0 0-64-32 0L48 32 16 32z','M0 416l32 0 384 0 32 0 0 64-32 0L32 480 0 480l0-64z']
      
    ]
  };

  

  
  

  var faRectangleHistoryCirclePlus = {
    prefix: 'fasds',
    iconName: 'rectangle-history-circle-plus',
    icon: [
      640,
      512,
      [],
      'e4a3',
      
      ['M0 160L0 512l394.8 0C349.5 480.1 320 427.5 320 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7l0-32.7L0 160zM48 80l0 48 416 0 0-48L48 80zM96 0l0 48 320 0 0-48L96 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faUmbrellaSimple = {
    prefix: 'fasds',
    iconName: 'umbrella-simple',
    icon: [
      512,
      512,
      ["umbrella-alt"],
      'e2bc',
      
      ['M117.1 433.7l14.3 28.6 2.3 4.7c13.8 27.6 42 45 72.8 45c45 0 81.4-36.5 81.4-81.4L288 288l-64 0 0 142.6c0 9.6-7.8 17.4-17.4 17.4c-6.6 0-12.6-3.7-15.6-9.6l-2.3-4.7-14.3-28.6-57.2 28.6z','M288 32l0-32L224 0l0 32 0 2C97.7 49.7 0 157.5 0 288l512 0c0-130.5-97.7-238.3-224-254l0-2z']
      
    ]
  };

  
    var faUmbrellaAlt = faUmbrellaSimple;
  

  
  

  var faBath = {
    prefix: 'fasds',
    iconName: 'bath',
    icon: [
      512,
      512,
      [128705,"bathtub"],
      'f2cd',
      
      ['M32 0L64 0l64 0 13.3 0 9.4 9.4 28.1 28.1C187.8 34 197.7 32 208 32c19.6 0 37.5 7 51.4 18.7L272 38.1 305.9 72 289 89 185 193l-17 17L134.1 176l12.6-12.6C135 149.5 128 131.6 128 112c0-10.3 2-20.2 5.5-29.2L114.7 64 96 64l0 192-64 0L32 32 32 0z','M32 256L0 256l0 64 32 0 448 0 32 0 0-64-32 0L32 256zm448 96L32 352l0 16c0 28.4 12.4 54 32 71.6L64 480l0 32 64 0 0-32 0-16 256 0 0 16 0 32 64 0 0-32 0-40.4c19.6-17.6 32-43.1 32-71.6l0-16z']
      
    ]
  };

  
    var faBathtub = faBath;
  

  
  

  var faMessages = {
    prefix: 'fasds',
    iconName: 'messages',
    icon: [
      640,
      512,
      ["comments-alt"],
      'f4b6',
      
      ['M256 352l0 96 181.3 0L544 512l0-64 96 0 0-320-192 0 0 224-192 0z','M416 0L0 0 0 320l96 0 0 64 106.7-64L416 320 416 0z']
      
    ]
  };

  
    var faCommentsAlt = faMessages;
  

  
  

  var faWifi = {
    prefix: 'fasds',
    iconName: 'wifi',
    icon: [
      640,
      512,
      ["wifi-3","wifi-strong"],
      'f1eb',
      
      ['','M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9l44.3-46.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7l44.3 46.2zM320 256c56.8 0 108.6 21.1 148.2 56l42.4-48C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72l42.4 48c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z']
      
    ]
  };

  
    var faWifi3 = faWifi;
  
    var faWifiStrong = faWifi;
  

  
  

  var faFileArrowUp = {
    prefix: 'fasds',
    iconName: 'file-arrow-up',
    icon: [
      384,
      512,
      ["file-upload"],
      'f574',
      
      ['M0 0C74.7 0 149.3 0 224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM86.1 304c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c10.3-10.3 20.7-20.7 31-31c0 34 0 68 0 102.1c0 8 0 16 0 24l48 0c0-8 0-16 0-24c0-34 0-68 0-102.1c10.3 10.3 20.7 20.7 31 31c5.7 5.7 11.3 11.3 17 17c11.3-11.3 22.6-22.6 33.9-33.9c-5.7-5.7-11.3-11.3-17-17c-24-24-48-48-72-72l-17-17-17 17c-24 24-48 48-72 72l-17 17z','M384 160l-160 0L224 0 384 160zM216 392l0 24-48 0 0-24 0-102.1-31 31-17 17L86.1 304l17-17 72-72 17-17 17 17 72 72 17 17L264 337.9l-17-17-31-31L216 392z']
      
    ]
  };

  
    var faFileUpload = faFileArrowUp;
  

  
  

  var faHouseCircleExclamation = {
    prefix: 'fasds',
    iconName: 'house-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e50a',
      
      ['M0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 96.7 0c8.1-89.7 83.5-160 175.3-160c8.3 0 16.5 .6 24.5 1.7L288.4 0 0 240z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faClipboard = {
    prefix: 'fasds',
    iconName: 'clipboard',
    icon: [
      384,
      512,
      [128203],
      'f328',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-72 0-24 80 0 0 448L0 512 0 64z','M304 64l-33.6 0C263 27.5 230.7 0 192 0s-71 27.5-78.4 64L80 64l0 96 112 0 112 0 0-96zM192 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faHexagonPlus = {
    prefix: 'fasds',
    iconName: 'hexagon-plus',
    icon: [
      512,
      512,
      ["plus-hexagon"],
      'f300',
      
      ['M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm144-24l0 48 24 0 64 0 0 64 0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0z','M232 344l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  
    var faPlusHexagon = faHexagonPlus;
  

  
  

  var faTaco = {
    prefix: 'fasds',
    iconName: 'taco',
    icon: [
      512,
      512,
      [127790],
      'f826',
      
      ['M0 448c0-47.7 13-92.3 35.7-130.5C80.4 242.3 162.3 192 256 192s175.6 50.3 220.3 125.5C499 355.7 512 400.3 512 448l0 32L0 480l0-32zm96-48a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64-64a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M256 32l69.9 54.1 88.3-2.7 24.7 84.9L512 218l-35.7 99.5C431.6 242.3 349.7 192 256 192s-175.6 50.3-220.3 125.5L0 218l73.1-49.7L97.8 83.4l88.3 2.7L256 32z']
      
    ]
  };

  

  
  

  var faChampagneGlasses = {
    prefix: 'fasds',
    iconName: 'champagne-glasses',
    icon: [
      640,
      512,
      [129346,"glass-cheers"],
      'f79f',
      
      ['M0 439.6l30.1 10.9 69.2 25.2L168.6 501l30.1 10.9 21.9-60.1-30.1-10.9-39.2-14.3 30.9-84.9c55.7 3.9 108.6-33.3 121.2-91L320 173.8l16.7 76.9c12.5 57.7 65.4 94.9 121.2 91l30.9 84.9-39.2 14.3-30.1 10.9 21.9 60.1L471.4 501l69.2-25.2 69.2-25.2L640 439.6l-21.9-60.1L588 390.4l-39.2 14.3L518 319.8c45.2-32.8 61.8-95.4 34.3-147.6L461.6 0 320 51.5 178.4 0 87.7 172.2C60.2 224.4 76.8 287 122 319.8L91.1 404.7 52 390.4 21.9 379.5 0 439.6zM139.2 216.9c.2-1 .4-2 .6-3c1-4 2.5-8 4.5-11.9c13.1-24.9 26.2-49.7 39.3-74.6c8.4-16.1 16.9-32.1 25.3-48.1l61.2 22.3c-3.8 17.7-7.7 35.4-11.5 53.2c-6 27.5-11.9 54.9-17.9 82.4c-6.7 30.7-38.8 48.4-68.3 37.7c-10.6-3.9-19.2-10.8-25-19.4c-2.9-4.3-5.2-9.1-6.8-14c-.4-1.2-.7-2.5-1-3.7c-1.5-6.7-1.8-13.8-.5-20.8zM369.8 101.5L431 79.2c8.4 16 16.9 32.1 25.3 48.1c13.1 24.9 26.2 49.7 39.3 74.6c4.1 7.7 6 16 6 24.1c0 21-12.8 41-34.1 48.7c-29.5 10.7-61.7-7-68.3-37.7c-6-27.5-11.9-54.9-17.9-82.4c-3.8-17.7-7.7-35.4-11.5-53.2z','M183.6 127.4l75 27.3-17.9 82.4c-6.6 30.7-38.8 48.4-68.3 37.7s-42.7-45-28.1-72.8l39.3-74.6zm272.7 0L495.6 202c14.6 27.8 1.4 62-28.1 72.8s-61.7-7-68.3-37.7l-17.9-82.4 75-27.3z']
      
    ]
  };

  
    var faGlassCheers = faChampagneGlasses;
  

  
  

  var faMarsStrokeUp = {
    prefix: 'fasds',
    iconName: 'mars-stroke-up',
    icon: [
      320,
      512,
      [9896,"mars-stroke-v"],
      'f22a',
      
      ['M96 352a64 64 0 1 0 128 0A64 64 0 1 0 96 352z','M160 0L80 80l0 16 56 0 0 24-32 0-24 0 0 48 24 0 32 0 0 24c0 .6 0 1.2 .1 1.8C59.1 205.3 0 271.8 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-80.2-59.1-146.7-136.1-158.2c0-.6 .1-1.2 .1-1.8l0-24 32 0 24 0 0-48-24 0-32 0 0-24 56 0 0-16L160 0zM64 352a96 96 0 1 1 192 0A96 96 0 1 1 64 352z']
      
    ]
  };

  
    var faMarsStrokeV = faMarsStrokeUp;
  

  
  

  var faUserMinus = {
    prefix: 'fasds',
    iconName: 'user-minus',
    icon: [
      640,
      512,
      [],
      'f503',
      
      ['M0 512l448 0L384 304 64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M448 200l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faSignalSlash = {
    prefix: 'fasds',
    iconName: 'signal-slash',
    icon: [
      640,
      512,
      [],
      'f695',
      
      ['M32 384l0 32 0 64 0 32 64 0 0-32 0-64 0-32-64 0zm128-96l0 32 0 160 0 32 64 0 0-32 0-160 0-32-64 0zm128-96l0 8.8c21.3 16.6 42.7 33.1 64 49.7l0-26.5 0-32-64 0zm0 130.9L288 480l0 32 64 0 0-32 0-106.7-64-50.4zM416 96l0 32 0 172.2c21.3 16.6 42.7 33.1 64 49.7L480 128l0-32-64 0zm0 327.8l0 56.2 0 32 64 0 0-32 0-5.8-64-50.4zM544 0l0 32 0 367.6 64 49.7L608 32l0-32L544 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faRoadCircleXmark = {
    prefix: 'fasds',
    iconName: 'road-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e566',
      
      ['M32 480l256 0 0-64 0-32 32.7 0c-.5-5.3-.7-10.6-.7-16c0-16.6 2.3-32.7 6.6-48L288 320l0-32 0-64 0-32 64 0 0 32 0 42.8c31.9-45.2 84.5-74.8 144-74.8c10.4 0 20.6 .9 30.5 2.6L480 32 352 32l0 64 0 32-64 0 0-32 0-64L160 32 32 480z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faStoreSlash = {
    prefix: 'fasds',
    iconName: 'store-slash',
    icon: [
      640,
      512,
      [],
      'e071',
      
      ['M48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5zM94.8 50.9l206.1 160c7.1-4.4 13.5-9.7 19-15.8c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c39.7-5.3 64.5-40.1 64.5-76.7c0-14.5-3.9-29.4-12.4-42.7L512 0 128 0 94.8 50.9zM96 252.6L96 384l0 128 448 0-16 0L365.5 384 160 384l0-133.4c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1c-4.2-.6-8.2-1.3-12.1-2.3zm384-2l0 99.2c21.3 16.6 42.7 33.1 64 49.7l0-15.6 0-131.4c-4 1-8 1.8-12.3 2.3c-5.4 .7-10.7 1.1-16.3 1.1c-12.4 0-24.3-1.9-35.4-5.3z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faH4 = {
    prefix: 'fasds',
    iconName: 'h4',
    icon: [
      640,
      512,
      [],
      'f86a',
      
      ['M0 64L0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96l0-32L0 64z','M384.5 282.2L424.5 64l65.1 0L454.4 256 576 256l0-160 0-32 64 0 0 32 0 320 0 32-64 0 0-32 0-96-160 0-38.4 0 6.9-37.8z']
      
    ]
  };

  

  
  

  var faBadgerHoney = {
    prefix: 'fasds',
    iconName: 'badger-honey',
    icon: [
      640,
      512,
      [129441],
      'f6b4',
      
      ['M83.5 171.7C95.8 220.2 139.7 256 192 256l80 0c53.3-32 106.7-64 160-96l41.4 0 45.3 0 51.3 0-86.4-48-40.2 0c-18 9-35.9 18-53.9 26.9c-3.4 1.7-6.8 3.4-10.1 5.1L368 144l-224 0c-24.2 0-45.9 10.7-60.5 27.7zm453.6 79.6L560 288l29.5-47.2c-18.1 1.6-35.6 5.3-52.4 10.6z','M180.6 352L160 400l24 80-96 0L64 400l20.7-72.5C70.3 317 58.1 303.5 49.1 288L0 288l0-32 0-32C0 153.3 57.3 96 128 96l32 0 32 0 176 0 64-32 64 0 144 80 0 64-32 32c-94 0-177.2 62.9-215 102.1L416 480l-96 0L298.7 352l-118.1 0zM368 144l-224 0c-24.2 0-45.9 10.7-60.5 27.7C95.8 220.2 139.7 256 192 256l80 0 160-96 41.4 0c-.9 2.5-1.4 5.2-1.4 8c0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.8-.5-5.5-1.4-8l51.3 0-86.4-48-40.2 0-53.9 26.9L379.3 144 368 144z']
      
    ]
  };

  

  
  

  var faHeadset = {
    prefix: 'fasds',
    iconName: 'headset',
    icon: [
      512,
      512,
      [],
      'f590',
      
      ['M0 256l0 40 0 24 48 0 0-24 0-40C48 141.1 141.1 48 256 48s208 93.1 208 208l0 184.1L320 440l0-24-80 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l80 0 0-24 168 .1 24 0 0-24L512 256C512 114.6 397.4 0 256 0S0 114.6 0 256z','M192 224L80 224l0 160 112 0 0-160zm240 0l-112 0 0 160 112 0 0-160z']
      
    ]
  };

  

  
  

  var faColonSign = {
    prefix: 'fasds',
    iconName: 'colon-sign',
    icon: [
      384,
      512,
      [],
      'e140',
      
      ['M80.8 488.7l62.3 14.5 15.6-66.7c-21.3-7.7-40.9-19.1-57.9-33.4L80.8 488.7zm37.5-160.5c13.6 19.9 32.7 35.8 55.1 45.4l57.3-245.4c-2.2-.1-4.4-.2-6.7-.2c-1.6 0-2.9 0-4.2 .1c-1.5 .1-2.9 .1-4.3 .2c-2.9 .2-5.6 .5-8.4 .8c-5.5 .7-10.9 1.8-16.2 3.2c-10.5 2.8-20.5 6.9-29.8 12.2L118.3 328.2zm58.5 160.5l62.3 14.5 13.4-57.4c-9.3 1.4-18.8 2.1-28.6 2.1c-6.4 0-12.6-.3-18.7-.9s-12.2-1.5-18.1-2.6l-10.3 44.3zm1.8-419.3C193.2 65.9 208.4 64 224 64c1.9 0 3.6 0 5.3 .1c1.9 .1 3.7 .1 5.4 .2c3.6 .2 7.2 .5 10.7 .9l9.8-41.9L192.8 8.7 178.7 69.4zm23 312.7c7.2 1.3 14.7 1.9 22.3 1.9c4 0 7.9-.2 11.8-.5s7.6-.9 11.4-1.5c7.5-1.4 14.8-3.4 21.7-6l48.4-207.5c-15.5-16.5-35.2-28.8-57.5-35.3l-58.1 249zM274.4 70.7c21.5 5.8 41.5 15.3 59.3 27.7l17.5-75.1L288.8 8.7l-14.5 62z','M224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c41.9 0 79-20.1 102.4-51.2l51.2 38.4C342.6 417.8 286.8 448 224 448C118 448 32 362 32 256S118 64 224 64c62.8 0 118.6 30.2 153.6 76.8l-51.2 38.4C303 148.1 265.9 128 224 128z']
      
    ]
  };

  

  
  

  var faUnlock = {
    prefix: 'fasds',
    iconName: 'unlock',
    icon: [
      448,
      512,
      [128275],
      'f09c',
      
      ['M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7l57.8-27.5C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144z','M0 192H448V512H0V192z']
      
    ]
  };

  

  
  

  var faSheep = {
    prefix: 'fasds',
    iconName: 'sheep',
    icon: [
      640,
      512,
      [128017],
      'f711',
      
      ['M0 256c0 24.5 13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0c2.8-.1 5.6-.3 8.3-.7c6.8 28 32.1 48.7 62.2 48.7c7.5 0 14.7-1.3 21.3-3.6c6.8-2.4 13-5.9 18.5-10.2C219.7 439.6 236.9 448 256 448c19.2 0 36.5-8.5 48.2-21.9C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c2.7 .4 5.5 .7 8.3 .7c.5 0 1 0 1.5 0c35.3 0 64-28.7 64-64c0-2.7-.2-5.4-.5-8L352 320l0-135.6-21.4 9.2L286.5 90.6l15.8-6.8C290.6 71.6 274.2 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256z','M576 288l-192 0 0-152.2-14.5 6.2-22.1 9.5-18.9-44.1 22.1-9.5 55.1-23.6L448 32l64 0 42.3 42.3 55.1 23.6 22.1 9.5-18.9 44.1-22.1-9.5L576 135.8 576 288zM464 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM304.2 426.1C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c2.7 .4 5.5 .7 8.3 .7L392 512l-88 0 0-85.7 .2-.2zM105.8 391.3c6.8 28 32.1 48.7 62.2 48.7c15 0 28.9-5.2 39.8-13.9l.2 .2 0 85.7-88 0L97.5 392c2.8-.1 5.6-.3 8.3-.7z']
      
    ]
  };

  

  
  

  var faCitrusSlice = {
    prefix: 'fasds',
    iconName: 'citrus-slice',
    icon: [
      512,
      512,
      [],
      'e2f5',
      
      ['M34.6 384.6c2.1 2.1 4.3 4.3 6.4 6.4c38.2 38.2 85.6 61.3 135 69.8l0-12.8 0-194c-2.8-.7-5.5-1.6-8.1-2.7C123.5 295.7 79 340.2 34.6 384.6zM208 254l0 194 0 15.7c36.8 1.3 73.8-5.7 108.1-20.7c3.2-1.4 6.3-2.9 9.4-4.4l.4-.2c1.4-.7 2.8-1.4 4.1-2.1c1.5-.8 3-1.6 4.5-2.4c3.2-1.7 6.3-3.5 9.4-5.4c.4-.2 .8-.5 1.2-.7c3-1.8 5.9-3.7 8.8-5.6c6-4 11.7-8.2 17.3-12.7c2.7-2.2 5.4-4.4 8-6.7c.1-.1 .3-.2 .4-.4l-7-7L224.5 247.1c-5.1 3-10.6 5.3-16.5 6.8zm39.1-29.5L395.3 372.7l7 7 .3-.4c2.3-2.6 4.6-5.3 6.8-8s4.3-5.5 6.4-8.3l.3-.4c2.1-2.8 4.1-5.7 6-8.6s3.8-5.9 5.7-8.8c.2-.4 .5-.8 .7-1.1c1.8-3 3.5-6 5.2-9.1s3.3-6.1 4.8-9.3c18.1-36.9 26.5-77.4 25.3-117.6L448 208l-194 0c-1.5 5.9-3.8 11.4-6.8 16.5zm4.2-56.6c1.1 2.6 2 5.3 2.7 8.1l194 0 12.5 0c-8.1-49.4-31.3-96.9-69.5-135c-2.1-2.1-4.3-4.3-6.2-6.6C340.2 79 295.8 123.4 251.3 167.9z','M34.6 384.6L41 391s0 0 0 0c96.9 96.9 253.6 97.1 350.4 .3s96.6-253.5-.3-350.4l-6.4-6.4L418.6 .6 425 7c115.6 115.6 116 302.6 .3 418.3S122.6 540.5 7 425c0 0 0 0 0 0L.6 418.6l33.9-33.9z']
      
    ]
  };

  

  
  

  var faPepperHot = {
    prefix: 'fasds',
    iconName: 'pepper-hot',
    icon: [
      512,
      512,
      [127798],
      'f816',
      
      ['M0 432l0 80 103.2 0c153.9 0 292.3-81 369.5-206.7c-8.2-16.4-16.4-32.9-24.6-49.3c-37.3 0-74.7 0-112 0c-5.3-37.3-10.7-74.7-16-112c-15.2-1.7-30.3-3.4-45.5-5.1L171.2 345.5C154 380 122.2 404.9 84.5 413.2L0 432z','M419 35.7l4.8 8.7c9.7 17.5 11.5 37.6 6 55.8C406.8 87.3 380.3 80 352 80c-47.8 0-90.7 21-120 54.2l88 9.8 16 112 112 0 36.7 73.4C501.9 303.9 512 273.1 512 240c0-42.1-16.2-80.4-42.8-108.9c16.4-34.3 15.9-75.4-3.4-110L461 12.3 419 35.7z']
      
    ]
  };

  

  
  

  var faClockTwelve = {
    prefix: 'fasds',
    iconName: 'clock-twelve',
    icon: [
      512,
      512,
      [],
      'e358',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 96l48 0 0 24 0 136 0 24-48 0 0-24 0-136 0-24z','M280 96l0 24 0 136 0 24-48 0 0-24 0-136 0-24 48 0z']
      
    ]
  };

  

  
  

  var faMicrophoneLines = {
    prefix: 'fasds',
    iconName: 'microphone-lines',
    icon: [
      384,
      512,
      [127897,"microphone-alt"],
      'f3c9',
      
      ['M16 192l0 24 0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0-24 0 0 48 24 0 72 0 72 0 24 0 0-48-24 0-48 0 0-33.6c85.8-11.7 152-85.3 152-174.4l0-40 0-24-48 0 0 24 0 40c0 70.7-57.3 128-128 128s-128-57.3-128-128l0-40 0-24-48 0zM192 96l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm0 64l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm0 64l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0z','M288 0L96 0l0 256c0 53 43 96 96 96s96-43 96-96l-80 0-16 0 0-32 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-96z']
      
    ]
  };

  
    var faMicrophoneAlt = faMicrophoneLines;
  

  
  

  var faSignalBarsWeak = {
    prefix: 'fasds',
    iconName: 'signal-bars-weak',
    icon: [
      640,
      512,
      ["signal-alt-1"],
      'f691',
      
      ['M192 256l0 256 96 0 0-256-96 0zM352 128l0 384 96 0 0-384-96 0zM512 0l0 512 96 0L608 0 512 0z','M32 384h96V512H32V384z']
      
    ]
  };

  
    var faSignalAlt1 = faSignalBarsWeak;
  

  
  

  var faCity = {
    prefix: 'fasds',
    iconName: 'city',
    icon: [
      640,
      512,
      [127961],
      'f64f',
      
      ['M0 96l64 0 48 0 64 0 48 0 64 0 0-96L480 0l0 192 160 0 0 320-160 0-128 0-64 0L0 512 0 192 0 96zm64 64l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zM192 160l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zM352 64l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm160 0l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M112 24l0-24L64 0l0 24 0 72 48 0 0-72zm112 0l0-24L176 0l0 24 0 72 48 0 0-72zM192 224l64 0 0-64-64 0 0 64zm384 32l-64 0 0 64 64 0 0-64zM64 416l64 0 0-64-64 0 0 64zm192-64l-64 0 0 64 64 0 0-64zm320 0l-64 0 0 64 64 0 0-64zM128 160l-64 0 0 64 64 0 0-64zm64 96l0 64 64 0 0-64-64 0zm-64 64l0-64-64 0 0 64 64 0z']
      
    ]
  };

  

  
  

  var faCodeFork = {
    prefix: 'fasds',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      ['M48 160l8 0 48 0 8 0 0 32c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-32 8 0 48 0 8 0 0 32c0 53-43 96-96 96l-48 0 0 64-8 0-48 0-8 0 0-64-48 0c-53 0-96-43-96-96l0-32z','M104 56l0 48-48 0 0-48 48 0zM56 0L0 0 0 56l0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56L104 0 56 0zM392 56l0 48-48 0 0-48 48 0zM344 0L288 0l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56L392 0 344 0zM200 408l48 0 0 48-48 0 0-48zm-56-56l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0z']
      
    ]
  };

  

  
  

  var faHeartCirclePlus = {
    prefix: 'fasds',
    iconName: 'heart-circle-plus',
    icon: [
      576,
      512,
      [],
      'e500',
      
      ['M0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480l23.7-23.7c-15.1-26-23.7-56.1-23.7-88.3c0-97.2 78.8-176 176-176c26.4 0 51.4 5.8 73.8 16.2c4-13 6.2-26.6 6.2-40.4C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faFlatbread = {
    prefix: 'fasds',
    iconName: 'flatbread',
    icon: [
      512,
      512,
      [129747],
      'e40b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm100.7-27.3c42.7-42.7 85.3-85.3 128-128l22.6 22.6c-42.7 42.7-85.3 85.3-128 128l-22.6-22.6zm48 112l192-192 22.6 22.6c-64 64-128 128-192 192c-7.5-7.5-15.1-15.1-22.6-22.6zm112 48l128-128 22.6 22.6c-42.7 42.7-85.3 85.3-128 128c-7.5-7.5-15.1-15.1-22.6-22.6z','M251.3 123.3l-128 128-22.6-22.6 128-128 22.6 22.6zm112 48l-192 192-22.6-22.6 192-192 22.6 22.6zm-80 240l-22.6-22.6 128-128 22.6 22.6-128 128z']
      
    ]
  };

  

  
  

  var faBowlHot = {
    prefix: 'fasds',
    iconName: 'bowl-hot',
    icon: [
      512,
      512,
      ["soup"],
      'f823',
      
      ['M128 0l0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C181.5 129.3 192 141.5 192 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C186.5 62.7 176 50.5 176 24l0-24L128 0zM256 0l0 24c0 45.1 21.2 69 37.7 87.5l.4 .4C309.5 129.3 320 141.5 320 168l0 24 48 0 0-24c0-45.1-21.2-69-37.7-87.5l-.4-.4C314.5 62.7 304 50.5 304 24l0-24L256 0z','M512 224L0 224l3.6 61.2C8.5 368.1 58 438.2 128 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7L512 224z']
      
    ]
  };

  
    var faSoup = faBowlHot;
  

  
  

  var faCandy = {
    prefix: 'fasds',
    iconName: 'candy',
    icon: [
      640,
      512,
      [127852],
      'e3e7',
      
      ['M0 233l0 46 42.6 12.5L7 327l28.2 38.2 101-53.5c-5.3-17.6-8.2-36.4-8.2-55.7c0-1.2 0-2.4 0-3.6s.1-2.4 .1-3.6c.1-2.4 .2-4.8 .4-7.2c.4-4.8 .9-9.5 1.6-14.1c1.4-9.3 3.4-18.4 6.1-27.2l-101-53.5L7 185l35.6 35.6L0 233zm503.8-32.8c5.3 17.6 8.2 36.4 8.2 55.7c0 1.2 0 2.4 0 3.6s-.1 2.4-.1 3.6c-.1 2.4-.2 4.8-.4 7.2c-.4 4.8-.9 9.5-1.6 14.1c-1.4 9.3-3.4 18.4-6.1 27.2l101 53.5L633 327l-35.6-35.6L640 279l0-46-42.6-12.5L633 185l-28.2-38.2-101 53.5z','M318.1 64c-24.5 .2-47.9 5.1-69.4 13.7L419.9 420c20.3-12.4 38.1-28.5 52.6-47.3L318.1 64zM492.3 340.8C504.9 315.2 512 286.4 512 256c0-93.9-67.4-172.1-156.5-188.7L492.3 340.8zm-101 93.5L220.1 92c-20.3 12.4-38.2 28.5-52.6 47.3L321.9 448c24.5-.2 47.9-5.1 69.4-13.7zM284.5 444.7L147.7 171.2C135.1 196.8 128 225.6 128 256c0 93.9 67.4 172.1 156.5 188.7z']
      
    ]
  };

  

  
  

  var faAlbumCollectionCircleUser = {
    prefix: 'fasds',
    iconName: 'album-collection-circle-user',
    icon: [
      640,
      512,
      [],
      'e48f',
      
      ['M0 160l512 0-3.7 32.4c-4.1-.3-8.2-.4-12.3-.4c-33.4 0-64.7 9.3-91.3 25.5c-26.2-6.1-54.8-9.5-84.7-9.5C193 208 90 268.9 90 344s103 136 230 136c13.2 0 26.1-.7 38.7-1.9C369 491 381.2 502.4 394.8 512L40 512 0 160zM16 80l24 0 432 0 24 0 0 48-24 0L40 128l-24 0 0-48zM32 0L56 0 456 0l24 0 0 48-24 0L56 48 32 48 32 0zM224 352c0-13.3 14.3-24 32-24s32 10.7 32 24s-14.3 24-32 24s-32-10.7-32-24z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-31.7 0-60.3-13.2-80.7-34.3L440 416l112 0 24.7 29.7c-20.4 21.2-49 34.3-80.7 34.3zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faFolderOpen = {
    prefix: 'fasds',
    iconName: 'folder-open',
    icon: [
      576,
      512,
      [61717,128194,128449],
      'f07c',
      
      ['M0 32L0 480 128 224l352 0 0-128L272 96 208 32 0 32z','M128 224L0 480H448L576 224H128z']
      
    ]
  };

  

  
  

  var faFaceLaugh = {
    prefix: 'fasds',
    iconName: 'face-laugh',
    icon: [
      512,
      512,
      ["laugh"],
      'f599',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 32l318.4 0c-8 80.9-76.2 144-159.2 144s-151.2-63.1-159.2-144zm47.6-96c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faLaugh = faFaceLaugh;
  

  
  

  var faChartPieSimple = {
    prefix: 'fasds',
    iconName: 'chart-pie-simple',
    icon: [
      512,
      512,
      ["chart-pie-alt"],
      'f64e',
      
      ['M0 272C0 404.6 107.5 512 240 512c127.2 0 231.2-98.9 239.5-224L224 288l0-255.5C98.9 40.8 0 144.8 0 272z','M272 240H511.4c.4-5.3 .6-10.6 .6-16C512 100.3 411.7 0 288 0c-5.4 0-10.7 .2-16 .6V240z']
      
    ]
  };

  
    var faChartPieAlt = faChartPieSimple;
  

  
  

  var faShirtLongSleeve = {
    prefix: 'fasds',
    iconName: 'shirt-long-sleeve',
    icon: [
      640,
      512,
      [],
      'e3c7',
      
      ['M0 195.7L0 208 0 368l0 48 96 0 0-48 0-147.7 48-87.3L144 512l352 0 0-378.9 48 87.3L544 368l0 48 96 0 0-48 0-160 0-12.3-5.9-10.8-88-160L532.4 0 504 0l-8 0L460 0 432 0c0 61.9-50.1 112-112 112S208 61.9 208 0L180 0 144 0l-8 0L107.6 0 93.9 24.9l-88 160L0 195.7z','M208 0c0 61.9 50.1 112 112 112s112-50.1 112-112L400 0c0 44.2-35.8 80-80 80s-80-35.8-80-80L208 0z']
      
    ]
  };

  

  
  

  var faShuttleSpace = {
    prefix: 'fasds',
    iconName: 'shuttle-space',
    icon: [
      640,
      512,
      ["space-shuttle"],
      'f197',
      
      ['M32 32l0 96 52 0 5.9 0 5.2 2.8 .8 .4L96 32 32 32zm0 352l0 96 64 0 0-99.2-.8 .4L89.9 384 84 384l-52 0zM128 32l0 116 22.7 12 254.6 0L192 32l-64 0zm0 332l0 116 64 0L405.3 352l-254.6 0L128 364z','M0 128l24 0 60 0 5.9 0 5.2 2.8L150.7 160 456 160c70.4 0 127.6 23.5 171.2 81.6L638 256l-10.8 14.4C583.6 328.5 526.4 352 456 352l-305.3 0L95.2 381.2 89.9 384 84 384l-60 0L0 384l0-24 0-32L0 184l0-32 0-24zM512 264l0-16c0-22.1-17.9-40-40-40l0 96c22.1 0 40-17.9 40-40z']
      
    ]
  };

  
    var faSpaceShuttle = faShuttleSpace;
  

  
  

  var faHouseDay = {
    prefix: 'fasds',
    iconName: 'house-day',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      ['M0 160l62.4 40.4L46.9 273.1l72.7-15.6 16.2 25.1 3.2-2.8 52.1-45.1c-9.6 4-20.1 6.3-31.1 6.3c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80c0 15.1-4.2 29.3-11.5 41.3l67-58.1-38-24.6 15.6-72.7L200.4 62.4 160 0 119.6 62.4 46.9 46.9l15.6 72.7L0 160zm112 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M160 304L400 96 640 304l0 48-64 0 0 160-352 0 0-160-64 0 0-48zm288-16l-96 0 0 96 96 0 0-96z']
      
    ]
  };

  

  
  

  var faBedPulse = {
    prefix: 'fasds',
    iconName: 'bed-pulse',
    icon: [
      640,
      512,
      ["procedures"],
      'f487',
      
      ['M96 240a80 80 0 1 0 160 0A80 80 0 1 0 96 240zm192-80l0 32 0 128 0 32 32 0 288 0 32 0 0-32 0-64c0-53-43-96-96-96l-74.1 0-11.2 23.8L443.5 216 408 216l-16 0-36.4 0-14.8-33.3L330.7 160 320 160l-32 0z','M472 0L456.8 0l-6.5 13.8-49.9 106L381.9 78.3 375.6 64 360 64 216 64l-24 0 0 48 24 0 128.4 0 25.7 57.7 6.3 14.3 15.6 0 16 0 15.2 0 6.5-13.8L480.4 62.5l18.1 36.2 6.6 13.3 14.8 0 96 0 24 0 0-48-24 0-81.2 0L509.5 13.3 502.8 0 488 0 472 0zM64 96l0-32L0 64 0 96 0 352l0 64 0 64 0 32 64 0 0-32 0-32 512 0 0 32 0 32 64 0 0-32 0-96 0-32-32 0L64 352 64 96z']
      
    ]
  };

  
    var faProcedures = faBedPulse;
  

  
  

  var faFire = {
    prefix: 'fasds',
    iconName: 'fire',
    icon: [
      448,
      512,
      [128293],
      'f06d',
      
      ['M0 276.5C0 144 176 0 176 0s64.5 59.3 88.6 89.4c11-14.4 47.4-42.9 47.4-42.9s136 113.4 136 229.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5zm112 30.3C112 375.4 162.6 416 225.7 416c25.3 0 47.7-7 68.8-21c27.1-18.9 41.5-50.1 41.5-82.2c0-17.7-4.4-35.8-13.4-52.2c-2.8-5.6-5.6-11.2-9.8-16.8l-50.6 58.8s-81.4-103.6-87.1-110.6C133.1 243.8 112 273.2 112 306.8z','M294.5 395c-21.1 14-43.5 21-68.8 21C162.6 416 112 375.4 112 306.8c0-33.6 21.1-63 63.2-114.8c5.6 7 87.1 110.6 87.1 110.6l50.6-58.8c4.2 5.6 7 11.2 9.8 16.8c25.3 46.2 14 105-28.1 134.4z']
      
    ]
  };

  

  
  

  var faStars = {
    prefix: 'fasds',
    iconName: 'stars',
    icon: [
      512,
      512,
      [],
      'f762',
      
      ['M256 80l60 20 20 60 20-60 60-20L356 60 336 0 316 60 256 80zM384 224l48 16 16 48 16-48 48-16-48-16-16-48-16 48-48 16z','M193.5 144l59.8 121.1 133.7 19.4-96.7 94.3L313 512 193.5 449.1 73.9 512 96.7 378.9 0 284.6l133.7-19.4L193.5 144z']
      
    ]
  };

  

  
  

  var faCircleZ = {
    prefix: 'fasds',
    iconName: 'circle-z',
    icon: [
      512,
      512,
      [],
      'e130',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 144 0 24 0 0 31.5-4.3 6.2L229.8 336l98.2 0 24 0 0 48-24 0-144 0-24 0 0-31.5 4.3-6.2L282.2 176 184 176l-24 0 0-48z','M352 128l0 31.5-4.3 6.2L229.8 336l98.2 0 24 0 0 48-24 0-144 0-24 0 0-31.5 4.3-6.2L282.2 176 184 176l-24 0 0-48 24 0 144 0 24 0z']
      
    ]
  };

  

  
  

  var faDownToBracket = {
    prefix: 'fasds',
    iconName: 'down-to-bracket',
    icon: [
      448,
      512,
      [],
      'e4e7',
      
      ['M0 320l0 32L0 480l0 32 32 0 384 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448l0-96 0-32L0 320z','M224 352L384 192l0-32-96 0L288 0 160 0l0 160-96 0 0 32L224 352z']
      
    ]
  };

  

  
  

  var faSignalStream = {
    prefix: 'fasds',
    iconName: 'signal-stream',
    icon: [
      576,
      512,
      [],
      'f8dd',
      
      ['M0 256c0 67.4 23.2 129.4 61.9 178.5l50.2-39.7C82 356.6 64 308.5 64 256s18-100.6 48.2-138.8L61.9 77.5C23.2 126.6 0 188.6 0 256zm112 0c0 41.2 14.2 79.1 37.9 109.1l50.2-39.7C185 306.3 176 282.2 176 256s9-50.3 24.1-69.4l-50.2-39.7C126.2 176.9 112 214.8 112 256zm263.9-69.4C391 205.7 400 229.8 400 256s-9 50.3-24.1 69.4l50.2 39.7c23.7-30 37.9-67.9 37.9-109.1s-14.2-79.1-37.9-109.1l-50.2 39.7zm87.9-69.4C494 155.4 512 203.5 512 256s-18 100.6-48.2 138.8l50.2 39.7C552.8 385.4 576 323.4 576 256s-23.2-129.4-61.9-178.5l-50.2 39.7z','M232 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z']
      
    ]
  };

  

  
  

  var faL = {
    prefix: 'fasds',
    iconName: 'l',
    icon: [
      320,
      512,
      [108],
      '4c',
      
      ['M96 32l0 32 0 352 192 0 32 0 0 64-32 0L64 480l-32 0 0-32L32 64l0-32 64 0z','']
      
    ]
  };

  

  
  

  var faPersonWalking = {
    prefix: 'fasds',
    iconName: 'person-walking',
    icon: [
      320,
      512,
      [128694,"walking"],
      'f554',
      
      ['M2.7 464L48 509.3l22.6-22.6 48-48 4.6-4.6 2.4-6.1 28.9-72.2c-10.1-11-20.2-22.1-30.3-33.1c-1.8-2-3.4-4-4.9-6.1s-2.9-4.3-4.1-6.5c-2.4-4.5-4.3-9.2-5.6-14.1L68.7 398 25.4 441.4 2.7 464z','M208 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM132.3 126.6l10 2 80 16 15.3 3.1 7 14 35.2 70.5 38.5 19.2-28.6 57.2-48-24-9.5-4.8-4.8-9.5-13.7-27.4-18.4 62.4 52.3 57 5.2 5.7 2 7.5 24 88 8.4 30.9-61.7 16.8-8.4-30.9-22-80.5-70.9-77.4c-14.8-16.1-20.3-38.6-14.7-59.7l17-63.6L89.9 215.5 78.4 250.1 68.2 280.5 7.5 260.2l10.1-30.4 16-48 4.5-13.4L51 162.8l72-32 9.3-4.1z']
      
    ]
  };

  
    var faWalking = faPersonWalking;
  

  
  

  var faRectangleVertical = {
    prefix: 'fasds',
    iconName: 'rectangle-vertical',
    icon: [
      384,
      512,
      ["rectangle-portrait"],
      'f2fb',
      
      ['M384 0l0 512L0 512 0 0 384 0z','']
      
    ]
  };

  
    var faRectanglePortrait = faRectangleVertical;
  

  
  

  var faToggleOn = {
    prefix: 'fasds',
    iconName: 'toggle-on',
    icon: [
      576,
      512,
      [],
      'f205',
      
      ['M0 64L0 448l576 0 0-384L0 64zm288 96l192 0 0 192-192 0 0-192z','M480 160H288V352H480V160z']
      
    ]
  };

  

  
  

  var faCircleArrowUp = {
    prefix: 'fasds',
    iconName: 'circle-arrow-up',
    icon: [
      512,
      512,
      ["arrow-circle-up"],
      'f0aa',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm110.1-8c5.7-5.7 11.3-11.3 17-17c37.3-37.3 74.7-74.7 112-112l17-17 17 17c37.3 37.3 74.7 74.7 112 112c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-23.7-23.7-47.4-47.4-71-71c0 60.7 0 121.4 0 182.1c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-60.7 0-121.4 0-182.1c-23.7 23.7-47.4 47.4-71 71c-5.7 5.7-11.3 11.3-17 17L110.1 248z','M256 102.1l17 17L385 231l17 17L368 281.9l-17-17-71-71L280 376l0 24-48 0 0-24 0-182.1-71 71-17 17L110.1 248l17-17L239 119l17-17z']
      
    ]
  };

  
    var faArrowCircleUp = faCircleArrowUp;
  

  
  

  var faBedEmpty = {
    prefix: 'fasds',
    iconName: 'bed-empty',
    icon: [
      640,
      512,
      [128719],
      'f8f9',
      
      ['M64 224l32 0 512 0 32 0 0 32 0 64-32 0L64 320l0-64 0-32z','M64 32l0 32 0 256 544 0 32 0 0 32 0 96 0 32-64 0 0-32 0-32L64 416l0 32 0 32L0 480l0-32 0-64 0-64L0 64 0 32l64 0z']
      
    ]
  };

  

  
  

  var faPianoKeyboard = {
    prefix: 'fasds',
    iconName: 'piano-keyboard',
    icon: [
      576,
      512,
      [127929],
      'f8d5',
      
      ['M0 224l64 0 0 160 80 0 0-64 32 0 0 64 96 0 0-64 32 0 0 64 96 0 0-64 32 0 0 64 80 0 0-160 64 0 0 192 0 32-32 0L32 448 0 448l0-32L0 224z','M576 64L0 64 0 224l128 0 0 64 0 32 64 0 0-32 0-64 64 0 0 64 0 32 64 0 0-32 0-64 64 0 0 64 0 32 64 0 0-32 0-64 128 0 0-160z']
      
    ]
  };

  

  
  

  var faUserPilotTie = {
    prefix: 'fasds',
    iconName: 'user-pilot-tie',
    icon: [
      448,
      512,
      [],
      'e2c1',
      
      ['M96 192c0-13 1.9-25.5 5.5-37.2c23.9 9.6 62.8 20.1 113.9 21.1c2.7 .1 5.5 .1 8.2 .1l.4 0 .4 0c2.7 0 5.5 0 8.2-.1c51.1-1.1 90.1-11.5 113.9-21.1c3.6 11.8 5.5 24.3 5.5 37.2c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M80 99.2L48 80l0-32L224 0 400 48l0 32L368 99.2l0 44.8c-16 10.7-67.2 32-144 32s-128-21.3-144-32l0-44.8zm88.8-40.7L154.5 87.2l14.3 7.2 48 24 7.2 3.6 7.2-3.6 48-24 14.3-7.2L279.2 58.5l-14.3 7.2L224 86.1 183.2 65.7l-14.3-7.2zM448 512l-192 0-64 0L0 512 48 352l80 0 67.8 112.9L208 416l-32-64 96 0-32 64 12.2 48.9L320 352l80 0 48 160zM336 416l-16 0 0 32 16 0 32 0 16 0 0-32-16 0-32 0z']
      
    ]
  };

  

  
  

  var faWheelchair = {
    prefix: 'fasds',
    iconName: 'wheelchair',
    icon: [
      512,
      512,
      [],
      'f193',
      
      ['M0 352c0 88.4 71.6 160 160 160s160-71.6 160-160l-48 0c0 61.9-50.1 112-112 112S48 413.9 48 352s50.1-112 112-112c5.3 0 10.5 .4 15.6 1.1c-3.3-16.3-6.5-32.6-9.8-49c-1.9-.1-3.8-.1-5.8-.1C71.6 192 0 263.6 0 352z','M144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm9 80l39 0 32 0 26.2 0 5.1 25.7 4.5 22.3 76.2 0 32 0 0 64-32 0-63.4 0 9.6 48L384 288l22.2 0 7.8 20.8 37.1 99 10.7-3.6 30.3-10.2 20.5 60.6-30.3 10.2-40 13.5-29.3 9.9-10.9-29L361.8 352l-105.2 0c-.4 0-.8 0-1.3 0L224 352l-26.2 0-5.1-25.7-32-160L153 128z']
      
    ]
  };

  

  
  

  var faTriangleInstrument = {
    prefix: 'fasds',
    iconName: 'triangle-instrument',
    icon: [
      576,
      512,
      ["triangle-music"],
      'f8e2',
      
      ['M0 512l74.6 0 426.7 0 74.6 0-38.4-64L420.7 253.2l-46.6 46.6L463 448 113 448 288 156.4l60.6 101c15.5-15.5 31.1-31.1 46.6-46.6l-70-116.6L320 85.3 320 32l0-32L256 0l0 32 0 53.3-5.3 8.9L38.4 448 0 512z','M537 137l17-17L520 86.1l-17 17L306.8 299.2c-5.9-2.1-12.2-3.2-18.8-3.2c-30.9 0-56 25.1-56 56s25.1 56 56 56s56-25.1 56-56c0-6.6-1.1-12.9-3.2-18.8L537 137z']
      
    ]
  };

  
    var faTriangleMusic = faTriangleInstrument;
  

  
  

  var faCommentPlus = {
    prefix: 'fasds',
    iconName: 'comment-plus',
    icon: [
      512,
      512,
      [],
      'f4b2',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm144-24l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M232 328l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  

  
  

  var faSquareChevronDown = {
    prefix: 'fasds',
    iconName: 'square-chevron-down',
    icon: [
      448,
      512,
      ["chevron-square-down"],
      'f329',
      
      ['M0 32L0 480l448 0 0-448L0 32zM86.1 224L120 190.1l17 17 87 87c29-29 58-58 87-87c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-34.7 34.7-69.3 69.3-104 104c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-34.7-34.7-69.3-69.3-104-104c-5.7-5.7-11.3-11.3-17-17z','M224 361.9l17-17L345 241l17-17L328 190.1l-17 17-87 87-87-87-17-17L86.1 224l17 17L207 345l17 17z']
      
    ]
  };

  
    var faChevronSquareDown = faSquareChevronDown;
  

  
  

  var faObjectsColumn = {
    prefix: 'fasds',
    iconName: 'objects-column',
    icon: [
      448,
      512,
      [],
      'e3c1',
      
      ['M256 32l0 128 192 0 0-128L256 32zm0 192l0 256 192 0 0-256-192 0z','M192 32L0 32 0 288l192 0 0-256zm0 320L0 352 0 480l192 0 0-128z']
      
    ]
  };

  

  
  

  var faViolin = {
    prefix: 'fasds',
    iconName: 'violin',
    icon: [
      640,
      512,
      [127931],
      'f8ed',
      
      ['M128 368c0 28.6 8.4 55.3 22.8 77.8c19.1-15.3 38.1-30.5 57.2-45.8c10.7 10.7 21.3 21.3 32 32l-23.1 28.9c-7.6 9.4-15.1 18.9-22.7 28.3C216.7 503.6 243.4 512 272 512c35.9 0 68.7-13.1 93.9-34.9C357.1 464.3 352 448.7 352 432c0-44.2 35.8-80 80-80c9.8 0 19.2 1.8 27.8 5c12.8-19.9 20.2-43.6 20.2-69c0-23.7-6.5-46-17.7-65c-7.9 7.9-15.8 15.8-23.7 23.6c-7.5 7.5-15.1 15.1-22.6 22.6c-15.1-15.1-30.2-30.2-45.3-45.3c7.5-7.5 15.1-15.1 22.6-22.6c7.9-7.9 15.8-15.8 23.7-23.6C398 166.5 375.7 160 352 160c-25.4 0-49.1 7.4-69 20.2c3.2 8.7 5 18.1 5 27.8c0 44.2-35.8 80-80 80c-16.7 0-32.3-5.1-45.1-13.9c-21.7 25.2-34.9 58-34.9 93.9zM448 72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-48a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48 144a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-48a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M350.7 35.2l-17 17L52.2 333.8l-17 17L1.3 316.8l17-17L299.8 18.2l17-17 33.9 33.9zM128 464l80-64 32 32-64 80-48-48zM614.6 70.6l-176 176L416 269.3 370.7 224l22.6-22.6 176-176L592 2.7 637.3 48 614.6 70.6z']
      
    ]
  };

  

  
  

  var faBurrito = {
    prefix: 'fasds',
    iconName: 'burrito',
    icon: [
      512,
      512,
      [127791],
      'f7ed',
      
      ['M0 335.3L0 400 112 512l96 0L459.4 260.6C429.7 237.6 392.4 224 352 224c-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-41.2 0-79.7-12-112-32.7zm4.6-35.9C34.3 322.4 71.6 336 112 336c79.2 0 146.2-52.3 168.3-124.3c5-16.3 7.7-33.7 7.7-51.7c0-40.4-13.6-77.7-36.6-107.4L4.6 299.4z','M320 160c0-53.6-20.3-102.5-53.6-139.4C280.6 7.8 299.4 0 320 0c11.4 0 22.2 2.4 32 6.7C361.8 2.4 372.6 0 384 0c34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32c4.3 9.8 6.7 20.6 6.7 32c0 20.6-7.8 39.4-20.6 53.6C454.5 212.3 405.6 192 352 192c-11.9 0-23.6 1-34.9 2.9c1.9-11.4 2.9-23 2.9-34.9z']
      
    ]
  };

  

  
  

  var faCommentMinus = {
    prefix: 'fasds',
    iconName: 'comment-minus',
    icon: [
      512,
      512,
      [],
      'f4b1',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160-24l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z','M160 216l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faBinaryCircleCheck = {
    prefix: 'fasds',
    iconName: 'binary-circle-check',
    icon: [
      640,
      512,
      [],
      'e33c',
      
      ['M0 0L32 0 160 0l32 0 0 32 0 160 0 32-32 0L32 224 0 224l0-32L0 32 0 0zM0 288l32 0 48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0L0 512l0-64 32 0 16 0 0-96-16 0L0 352l0-64zM64 64l0 96 64 0 0-96L64 64zM192 288l32 0 115.2 0c-12.3 24-19.2 51.2-19.2 80l0-16-64 0 0 96 32 0 32 0 19.2 0c11 21.5 26.3 40.5 44.8 55.8l0 8.2-32 0-128 0-32 0 0-32 0-160 0-32zM224 0l32 0 48 0 32 0 0 32 0 128 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-96-16 0-32 0 0-64zm96 368c0 5.4 .2 10.7 .7 16l-.7 0 0-16z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faPanelFire = {
    prefix: 'fasds',
    iconName: 'panel-fire',
    icon: [
      640,
      512,
      [],
      'e42f',
      
      ['M0 32L0 480l337 0c-30.5-34-49-78.9-49-128.2c0-2.6 .1-5.2 .2-7.8L264 344l0-48 32.8 0c8.4-26.8 22-51 37.2-72L64 224 64 96l320 0 0 72.8c17.1-15.5 33.7-27.8 47-36.1l17-10.6L448 32 0 32zM72 296l48 0 0 48-48 0 0-48zm96 0l48 0 0 48-48 0 0-48z','M320 352c0-89.6 85.3-165.3 128-192l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160zM480 464.2c35.3 0 64-28.7 64-64c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faBoltSlash = {
    prefix: 'fasds',
    iconName: 'bolt-slash',
    icon: [
      640,
      512,
      [],
      'e0b8',
      
      ['M112 288l59.8-56.6 103.9 81.8L112 288zM224 512l58.1-193.7 79.9 63L224 512zm17.8-347L416 0 356.7 197.6 528 224l-94.6 89.7C369.5 264.1 305.7 214.6 241.8 165z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faCodeSimple = {
    prefix: 'fasds',
    iconName: 'code-simple',
    icon: [
      576,
      512,
      [],
      'e13d',
      
      ['M354.8 109.3l47.8-42.5 21.3 23.9 128 144L570.8 256l-18.9 21.3-128 144-21.3 23.9-47.8-42.5 21.3-23.9L485.2 256 376.1 133.3l-21.3-23.9z','M221.2 109.3l-21.3 23.9L90.8 256 199.9 378.7l21.3 23.9-47.8 42.5-21.3-23.9-128-144L5.2 256l18.9-21.3 128-144 21.3-23.9 47.8 42.5z']
      
    ]
  };

  

  
  

  var faFaceLaughSquint = {
    prefix: 'fasds',
    iconName: 'face-laugh-squint',
    icon: [
      512,
      512,
      ["laugh-squint"],
      'f59b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96.8 32l318.4 0c-8 80.9-76.2 144-159.2 144s-151.2-63.1-159.2-144zM112 112l118.9 64L112 240l45.7-64L112 112zm169.1 64L400 112l-45.7 64L400 240 281.1 176z','M230.9 176L112 112l45.7 64L112 240l118.9-64zm50.3 0L400 240l-45.7-64L400 112 281.1 176z']
      
    ]
  };

  
    var faLaughSquint = faFaceLaughSquint;
  

  
  

  var faPalletBoxes = {
    prefix: 'fasds',
    iconName: 'pallet-boxes',
    icon: [
      640,
      512,
      [57863,"palette-boxes","pallet-alt"],
      'f483',
      
      ['M0 320l0 64 32 0 32 0 0 64-32 0L0 448l0 64 32 0 32 0 32 0 32 0 160 0 32 0 32 0 160 0 32 0 32 0 32 0 32 0 0-64-32 0-32 0 0-64 32 0 32 0 0-64-32 0-32 0-32 0-32 0-160 0-32 0-32 0-160 0-32 0-32 0-32 0L0 320zm128 64l160 0 0 64-160 0 0-64zm224 0l160 0 0 64-160 0 0-64z','M320 0L64 0l0 256 256 0L320 0zM576 64L384 64l0 192 192 0 0-192z']
      
    ]
  };

  
    var faPaletteBoxes = faPalletBoxes;
  
    var faPalletAlt = faPalletBoxes;
  

  
  

  var faBarsSort = {
    prefix: 'fasds',
    iconName: 'bars-sort',
    icon: [
      448,
      512,
      [],
      'e0ae',
      
      ['','M448 64L0 64l0 64 448 0 0-64zM192 384L0 384l0 64 192 0 0-64z']
      
    ]
  };

  

  
  

  var faChessKnight = {
    prefix: 'fasds',
    iconName: 'chess-knight',
    icon: [
      448,
      512,
      [9822],
      'f441',
      
      ['M16 480l48-48 320 0 48 48 0 32L16 512l0-32z','M64 80L96 48 64 32 64 0 207.9 0C322.8 0 416 93.2 416 208.1c0 10.6-.8 21.2-2.4 31.6L384 432 64 432l0-80L224 248l0-40L112 280 64 240 64 80zm76 56a20 20 0 1 0 0-40 20 20 0 1 0 0 40z']
      
    ]
  };

  

  
  

  var faFarm = {
    prefix: 'fasds',
    iconName: 'farm',
    icon: [
      576,
      512,
      ["barn-silo"],
      'f864',
      
      ['M160 264l56-136L368 64l152 64 56 136 0 248-144 0 0-112-128 0 0 112-144 0 0-248zm160-40l0 96c32 0 64 0 96 0l0-96c-32 0-64 0-96 0z','M0 96C0 43 43 0 96 0s96 43 96 96L0 96zM0 512L0 128l181.4 0-51 123.8c-1.6 3.9-2.4 8-2.4 12.2l0 248L0 512zM416 224l0 96-96 0 0-96 96 0z']
      
    ]
  };

  
    var faBarnSilo = faFarm;
  

  
  

  var faSquareT = {
    prefix: 'fasds',
    iconName: 'square-t',
    icon: [
      448,
      512,
      [],
      'e280',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 144l24 0 104 0 104 0 24 0 0 48-24 0-80 0 0 168 0 24-48 0 0-24 0-168-80 0-24 0 0-48z','M96 144l24 0 104 0 104 0 24 0 0 48-24 0-80 0 0 168 0 24-48 0 0-24 0-168-80 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faTvRetro = {
    prefix: 'fasds',
    iconName: 'tv-retro',
    icon: [
      512,
      512,
      [128250],
      'f401',
      
      ['M0 96L0 512l512 0 0-416L321.9 96l39-39 17-17L344 6.1 327 23l-71 71L185 23l-17-17L134.1 40l17 17 39 39L0 96zm64 64c106.7 0 213.3 0 320 0l0 288L64 448l0-288zm408 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 80a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M64 160H384V448H64V160z']
      
    ]
  };

  

  
  

  var faScannerImage = {
    prefix: 'fasds',
    iconName: 'scanner-image',
    icon: [
      576,
      512,
      [],
      'f8f3',
      
      ['M0 288L0 480l576 0 0-179.6c-8.1-4.1-16.2-8.3-24.3-12.4c-47 0-93.9 0-140.9 0c-137 0-273.9 0-410.8 0zm64 64l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M50 32.2L78.5 46.7 551.7 288l-140.9 0L49.5 103.7 21 89.2 50 32.2zM128 352l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faSnooze = {
    prefix: 'fasds',
    iconName: 'snooze',
    icon: [
      448,
      512,
      [128164,"zzz"],
      'f880',
      
      ['M160 0l32 0 96 0 32 0 0 32 0 8 0 11.8-7.7 9L254.7 128l33.3 0 32 0 0 64-32 0-96 0-32 0 0-32 0-8 0-11.8 7.7-9L225.3 64 192 64l-32 0 0-64zM288 224l32 0 96 0 32 0 0 32 0 8 0 11.8-7.7 9L382.7 352l33.3 0 32 0 0 64-32 0-96 0-32 0 0-32 0-8 0-11.8 7.7-9L353.3 288 320 288l-32 0 0-64z','M0 256l32 0 160 0 32 0 0 32 0 16 0 13.3-9.4 9.4L93.3 448l98.7 0 32 0 0 64-32 0L32 512 0 512l0-32 0-16 0-13.3 9.4-9.4L130.7 320 32 320 0 320l0-64z']
      
    ]
  };

  
    var faZzz = faSnooze;
  

  
  

  var faBlockQuestion = {
    prefix: 'fasds',
    iconName: 'block-question',
    icon: [
      448,
      512,
      [],
      'e3dd',
      
      ['M0 32L0 480l448 0 0-448L0 32zm96 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm40-208c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 280.4l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L192 192c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152l48 0 0 48-48 0 0-48zM400 104a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M48 104a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm304 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM72 384a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 200c0-30.9 25.1-56 56-56l56.9 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L248 280.4l0 7.6 0 24-48 0 0-24 0-21.5 0-13.9 12.1-6.9 44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1L192 192c-4.4 0-8 3.6-8 8l0 6.5-48 0 0-6.5zm64 152l48 0 0 48-48 0 0-48z']
      
    ]
  };

  

  
  

  var faPlayPause = {
    prefix: 'fasds',
    iconName: 'play-pause',
    icon: [
      640,
      512,
      [],
      'e22f',
      
      ['M384 64l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0zm128 0l0 32 0 320 0 32 64 0 0-32 0-320 0-32-64 0z','M64 64V448L320 256 64 64z']
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fasds',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      ['M0 256L288 384 576 256 288 128 0 256zM0 384L288 512 576 384 471.4 337.5 288 419 104.6 337.5 0 384z','M488 24l0-24L440 0l0 24 0 32-32 0-24 0 0 48 24 0 32 0 0 32 0 24 48 0 0-24 0-32 32 0 24 0 0-48-24 0-32 0 0-32z']
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  

  
  

  var faArrowUpAZ = {
    prefix: 'fasds',
    iconName: 'arrow-up-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-up"],
      'f15e',
      
      ['M292.8 256l70.4 0 14.7-32 76.3 0 14.7 32 70.4 0-6.1-13.3-88-192L436.5 32l-41.1 0-8.6 18.7-88 192L292.8 256zM320 288l0 64 32 0 52 0-73 63.9L320 425.5l0 14.5 0 8 0 32 32 0 128 0 32 0 0-64-32 0-52 0 73-63.9 10.9-9.6 0-14.5 0-8 0-32-32 0-128 0-32 0zm79.9-112L416 140.8 432.1 176l-32.3 0z','M160 32.6l23.6 25.7 88 96L293.2 178 246 221.2l-21.6-23.6L192 162.3 192 448l0 32-64 0 0-32 0-285.7L95.6 197.6 74 221.2 26.8 178l21.6-23.6 88-96L160 32.6z']
      
    ]
  };

  
    var faSortAlphaUp = faArrowUpAZ;
  

  
  

  var faUserGroup = {
    prefix: 'fasds',
    iconName: 'user-group',
    icon: [
      640,
      512,
      [128101,"user-friends"],
      'f500',
      
      ['M352.7 223.1C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112c-31 0-59-12.6-79.3-32.9zM422.4 320L576 320l64 192-158.5 0-2.9-9.4L422.4 320z','M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zM448 512L384 304 64 304 0 512l448 0z']
      
    ]
  };

  
    var faUserFriends = faUserGroup;
  

  
  

  var faBooks = {
    prefix: 'fasds',
    iconName: 'books',
    icon: [
      512,
      512,
      [128218],
      'f5db',
      
      ['M0 0L128 0l0 96L0 96 0 0zM0 128l128 0 0 256L0 384 0 128zM0 416l128 0 0 96L0 512l0-96zM160 0L288 0l0 24.7c0 23.8 0 47.5 0 71.3L160 96l0-96zm0 128l128 0c0-3.3 0-6.5 0-9.8c39.1-10.5 78.2-21 117.3-31.4c2.8 10.3 5.6 20.6 8.4 30.9c-41.8 11.2-83.7 22.4-125.5 33.6l-.2-.6L288 384l-128 0 0-256zm0 288l128 0 0 96-128 0 0-96zm195.4-17.7l125.5-33.6 8.4 30.9L363.8 429.2l-8.4-30.9z','M405.3 86.8L381.7 0 288 24.7 288 96 160 96l0 32 128 0 0-9.8L405.3 86.8zm8.4 30.9L288.2 151.3l67.2 247 125.5-33.6-67.2-247zM386.3 512L512 478.9l-22.7-83.3L363.8 429.2 386.3 512zM0 96l0 32 128 0 0-32L0 96zM128 384L0 384l0 32 128 0 0-32zm160 0l-128 0 0 32 128 0 0-32z']
      
    ]
  };

  

  
  

  var faStarExclamation = {
    prefix: 'fasds',
    iconName: 'star-exclamation',
    icon: [
      576,
      512,
      [],
      'f2f3',
      
      ['M18.9 195.6L148.1 328.5 121.7 512l166.4-81.8L454.4 512 428 328.5 557.2 195.6 374.6 164 288.1 0 201.5 164 18.9 195.6zM264 160l48 0 0 24 0 80 0 24-48 0 0-24 0-80 0-24zm0 160l48 0 0 48-48 0 0-48z','M312 184l0-24-48 0 0 24 0 80 0 24 48 0 0-24 0-80zm0 136l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faArrowUpToArc = {
    prefix: 'fasds',
    iconName: 'arrow-up-to-arc',
    icon: [
      512,
      512,
      [],
      'e617',
      
      ['M0 256l64 0C64 150 150 64 256 64s192 86 192 192l64 0C512 114.6 397.4 0 256 0S0 114.6 0 256z','M413.3 304l-22.6-22.6-112-112L256 146.7l-22.6 22.6-112 112L98.7 304 144 349.3l22.6-22.6L224 269.3 224 480l0 32 64 0 0-32 0-210.7 57.4 57.4L368 349.3 413.3 304z']
      
    ]
  };

  

  
  

  var faWeightScale = {
    prefix: 'fasds',
    iconName: 'weight-scale',
    icon: [
      512,
      512,
      ["weight"],
      'f496',
      
      ['M80 176a176 176 0 1 0 352 0A176 176 0 1 0 80 176zm136 48c0-22 17.8-39.9 39.7-40l33.6-78.3L295.6 91 325 103.6l-6.3 14.7-33.6 78.3c6.7 7.2 10.9 16.8 10.9 27.4c0 22.1-17.9 40-40 40s-40-17.9-40-40z','M256 352c97.2 0 176-78.8 176-176c0-42.5-15.1-81.6-40.2-112L512 64l0 448L0 512 0 64l120.2 0C95.1 94.4 80 133.5 80 176c0 97.2 78.8 176 176 176zm40-128c0 22.1-17.9 40-40 40s-40-17.9-40-40c0-22 17.8-39.9 39.7-40l33.6-78.3L295.6 91 325 103.6l-6.3 14.7-33.6 78.3c6.7 7.2 10.9 16.8 10.9 27.4z']
      
    ]
  };

  
    var faWeight = faWeightScale;
  

  
  

  var faHandBackPointUp = {
    prefix: 'fasds',
    iconName: 'hand-back-point-up',
    icon: [
      448,
      512,
      [],
      'e1a2',
      
      ['M176 0L96 0l0 224 0 13.3 0 2.7 0 80 0 16-32 0 0-16 0-56L16 304l0 68c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L288 512c70.7 0 128-57.3 128-128l0-16 0-48 0-80-80 0 0-32-80 0 0-32-80 0L176 0z','']
      
    ]
  };

  

  
  

  var faFlowerDaffodil = {
    prefix: 'fasds',
    iconName: 'flower-daffodil',
    icon: [
      512,
      512,
      [9880],
      'f800',
      
      ['M0 320l0 16c0 97.2 78.8 176 176 176l48 0 32 0 32 0 48 0c97.2 0 176-78.8 176-176l0-16-80 0c-59.5 0-112.1 29.6-144 74.8l0-113.4c-12.7-5.6-23.8-14.4-32-25.3c-.5 .7-1 1.4-1.6 2s-1.1 1.3-1.6 2c-1.1 1.3-2.3 2.6-3.5 3.8c-2.4 2.5-4.9 4.8-7.6 6.9c-5.4 4.3-11.3 7.9-17.7 10.6l0 113.4C192.1 349.6 139.5 320 80 320L0 320z','M320 288c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80c0-26.2 12.6-49.4 32-64c-19.4-14.6-32-37.8-32-64c0-44.2 35.8-80 80-80c26.2 0 49.4 12.6 64 32c14.6-19.4 37.8-32 64-32c44.2 0 80 35.8 80 80c0 26.2-12.6 49.4-32 64c19.4 14.6 32 37.8 32 64c0 44.2-35.8 80-80 80zm-64-88l56-56L256 88l-56 56 56 56z']
      
    ]
  };

  

  
  

  var faCalendarRange = {
    prefix: 'fasds',
    iconName: 'calendar-range',
    icon: [
      448,
      512,
      [],
      'e0d6',
      
      ['M0 192l448 0 0 320L0 512 0 192zm64 64l0 64 64 0 0-64-64 0zm0 136l0 48 192 0 0-48L64 392zM192 264l0 48 192 0 0-48-192 0zM320 384l0 64 64 0 0-64-64 0z','M96 0l64 0 0 64 128 0 0-64 64 0 0 64 96 0 0 128L0 192 0 64l96 0L96 0zm32 256l0 64-64 0 0-64 64 0zM320 448l0-64 64 0 0 64-64 0zm64-184l0 48-192 0 0-48 192 0zM64 392l192 0 0 48L64 440l0-48z']
      
    ]
  };

  

  
  

  var faTableCellsLock = {
    prefix: 'fasds',
    iconName: 'table-cells-lock',
    icon: [
      640,
      512,
      [],
      'e679',
      
      ['M0 32l512 0 0 129.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 24 0 0 64-24 0 0 64 24 0 0 64L0 480 0 32zM64 96l0 64 88 0 0-64L64 96zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM208 96l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM360 96l0 64 88 0 0-64-88 0z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faFilePrescription = {
    prefix: 'fasds',
    iconName: 'file-prescription',
    icon: [
      384,
      512,
      [],
      'f572',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM84 196l0 20 0 80 0 64 0 20 40 0 0-20 0-44 19.6 0 2.8 2.6 64.8 60.8-32.6 29.9-14.7 13.5 27 29.5 14.7-13.5 34.9-32 33.9 31.8 14.6 13.7 27.4-29.2-14.6-13.7L270 379.7l31.6-28.9 14.7-13.5-27-29.5-14.7 13.5-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60l-72 0-20 0zm40 40l52 0c11 0 20 9 20 20s-9 20-20 20l-16.6 0-.3-.3-.3 .3L124 276l0-40z','M384 160L224 0l0 160 160 0zM104 196l-20 0 0 20 0 80 0 64 0 20 40 0 0-20 0-44 19.6 0 2.8 2.6 64.8 60.8-32.6 29.9-14.7 13.5 27 29.5 14.7-13.5 34.9-32 33.9 31.8 14.6 13.7 27.4-29.2-14.6-13.7L270 379.7l31.6-28.9 14.7-13.5-27-29.5-14.7 13.5-33.8 31-43-40.3c22.4-8.7 38.3-30.5 38.3-55.9c0-33.1-26.9-60-60-60l-72 0zm55.1 79.7l-.3 .3L124 276l0-40 52 0c11 0 20 9 20 20s-9 20-20 20l-16.6 0-.3-.3z']
      
    ]
  };

  

  
  

  var faXmarksLines = {
    prefix: 'fasds',
    iconName: 'xmarks-lines',
    icon: [
      640,
      512,
      [],
      'e59a',
      
      ['M0 32L0 96l32 0 576 0 32 0 0-64-32 0L32 32 0 32zM0 416l0 64 32 0 576 0 32 0 0-64-32 0L32 416 0 416z','M57 183l-17-17L6.1 200l17 17 39 39L23 295l-17 17L40 345.9l17-17 39-39 39 39 17 17L185.9 312l-17-17-39-39 39-39 17-17L152 166.1l-17 17-39 39L57 183zm448 0l-17-17L454.1 200l17 17 39 39-39 39-17 17L488 345.9l17-17 39-39 39 39 17 17L633.9 312l-17-17-39-39 39-39 17-17L600 166.1l-17 17-39 39-39-39zm-224 0l-17-17L230.1 200l17 17 39 39-39 39-17 17L264 345.9l17-17 39-39 39 39 17 17L409.9 312l-17-17-39-39 39-39 17-17L376 166.1l-17 17-39 39-39-39z']
      
    ]
  };

  

  
  

  var faWeightHanging = {
    prefix: 'fasds',
    iconName: 'weight-hanging',
    icon: [
      512,
      512,
      [],
      'f5cd',
      
      ['M160 96c0 11.2 1.9 22 5.5 32l81 0c-12.7-4.4-22-17-22.4-31c0-.3 0-.7 0-1c0-17.7 14.3-32 32-32s32 14.3 32 32c0 .3 0 .6 0 .8c-.4 14-9.7 26.8-22.4 31.2l81 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96z','M0 512L88 128H424l88 384H0z']
      
    ]
  };

  

  
  

  var faCrown = {
    prefix: 'fasds',
    iconName: 'crown',
    icon: [
      576,
      512,
      [128081],
      'f521',
      
      ['M0 136a40 40 0 1 0 80 0A40 40 0 1 0 0 136zM248 72a40 40 0 1 0 80-.1A40 40 0 1 0 248 72zm248 64a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M504 160L384 256 309 106c-6.1 3.8-13.3 6-21 6s-14.9-2.2-21-6L192 256 72 160c-7.2 9.5-18.5 15.8-31.3 16L96 480l384 0 55.3-304c-12.8-.2-24.1-6.5-31.3-16z']
      
    ]
  };

  

  
  

  var faLeftLongToLine = {
    prefix: 'fasds',
    iconName: 'left-long-to-line',
    icon: [
      640,
      512,
      [],
      'e41e',
      
      ['M0 64l64 0 0 32 0 320 0 32L0 448l0-32L0 96 0 64z','M128 256L288 96l32 0 0 96 320 0 0 128-320 0 0 96-32 0L128 256z']
      
    ]
  };

  

  
  

  var faMicrochip = {
    prefix: 'fasds',
    iconName: 'microchip',
    icon: [
      512,
      512,
      [],
      'f2db',
      
      ['M0 128l0 48 24 0 40 0 0-48-40 0L0 128zM0 232l0 48 24 0 40 0 0-48-40 0L0 232zM0 336l0 48 24 0 40 0 0-48-40 0L0 336zM128 0l0 24 0 40 48 0 0-40 0-24L128 0zm0 448l0 40 0 24 48 0 0-24 0-40-48 0zm32-288l0 192 192 0 0-192-192 0zM232 0l0 24 0 40 48 0 0-40 0-24L232 0zm0 448l0 40 0 24 48 0 0-24 0-40-48 0zM336 0l0 24 0 40 48 0 0-40 0-24L336 0zm0 448l0 40 0 24 48 0 0-24 0-40-48 0zM448 128l0 48 40 0 24 0 0-48-24 0-40 0zm0 104l0 48 40 0 24 0 0-48-24 0-40 0zm0 104l0 48 40 0 24 0 0-48-24 0-40 0z','M448 64L64 64l0 384 384 0 0-384zm-64 64l0 256-256 0 0-256 256 0z']
      
    ]
  };

  

  
  

  var faTemperatureHigh = {
    prefix: 'fasds',
    iconName: 'temperature-high',
    icon: [
      512,
      512,
      [],
      'f769',
      
      ['M0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L256 64l0-64L192 0 96 0 32 0l0 64 0 213.5C12 302.2 0 333.7 0 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L96 300.2l0-22.7L96 64l96 0 0 213.5 0 22.7 14.2 17.6C217.4 331.5 224 348.9 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM160 96l-32 0 0 16 0 210.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 112l0-16z']
      
    ]
  };

  

  
  

  var faTrashCanXmark = {
    prefix: 'fasds',
    iconName: 'trash-can-xmark',
    icon: [
      448,
      512,
      [],
      'e2ae',
      
      ['M32 96l0 416 384 0 0-416L32 96zm94.1 128L160 190.1l17 17 47 47 47-47 17-17L321.9 224l-17 17-47 47 47 47 17 17L288 385.9l-17-17-47-47-47 47-17 17L126.1 352l17-17 47-47-47-47-17-17z','M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zM321.9 224l-17 17-47 47 47 47 17 17L288 385.9l-17-17-47-47-47 47-17 17L126.1 352l17-17 47-47-47-47-17-17L160 190.1l17 17 47 47 47-47 17-17L321.9 224z']
      
    ]
  };

  

  
  

  var faFolderUser = {
    prefix: 'fasds',
    iconName: 'folder-user',
    icon: [
      512,
      512,
      [],
      'e18e',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM152 416l24-64 160 0 24 64-208 0zM320 256a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M256 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm104 96l-24-64-160 0-24 64 208 0z']
      
    ]
  };

  

  
  

  var faPeopleCarryBox = {
    prefix: 'fasds',
    iconName: 'people-carry-box',
    icon: [
      640,
      512,
      ["people-carry"],
      'f4ce',
      
      ['M224 128l0 110.6 0 76.2 0 5.3 192 0 0-5.4 0-76.2L416 128l-192 0z','M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm0 80l48 0 17.1 0 9.5 14.3 60.3 90.5 9.1 5.8 0 76.2-49.3-31.8-5.6-3.6-3.7-5.5L144 241.7l0 65.1 54.6 54.6 7.3 7.3 1.7 10.1 8 48 8 48 4 24 2.2 13.3-64.9 0-.5-2.7-4-24-8-48-6.3-37.9L89.4 342.6 66.7 320C54.7 308 48 291.7 48 274.7L48 160l0-32 32 0zM416 238.4l8.9-5.7 60.3-90.5 9.5-14.3 17.1 0 48 0 32 0 0 32 0 114.7c0 17-6.7 33.3-18.7 45.3l-22.6 22.6-56.8 56.7-6.3 37.9-8 48-4 24-.5 2.7L410 512l2.2-13.3 4-24 8-48 8-48 1.7-10.1 7.3-7.3 54.6-54.6 0-65.1-21.4 32.1-3.7 5.5-5.6 3.6L416 314.6l0-76.2zM52.5 351l51 50.9-33 103.7-2 6.3L1.3 512l8.2-25.7L52.5 351zM559.8 48a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm27.5 303l43 135.2 8.2 25.7-67.2 0-2-6.3L536.3 402l51-50.9z']
      
    ]
  };

  
    var faPeopleCarry = faPeopleCarryBox;
  

  
  

  var faClockTenThirty = {
    prefix: 'fasds',
    iconName: 'clock-ten-thirty',
    icon: [
      512,
      512,
      [],
      'e355',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm126.7-57.3c8.9-13.3 17.7-26.6 26.6-39.9c6.7 4.4 13.3 8.9 20 13.3c32 21.3 64 42.7 96 64c3.6 2.4 7.1 4.7 10.7 7.1c0 4.3 0 8.6 0 12.8c0 45.3 0 90.7 0 136c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-41 0-82.1 0-123.2c-28.4-19-56.9-37.9-85.3-56.9l-20-13.3z','M280 416l0-24 0-136 0-12.8L269.3 236l-96-64-20-13.3-26.6 39.9 20 13.3L232 268.8 232 392l0 24 48 0z']
      
    ]
  };

  

  
  

  var faCloudsMoon = {
    prefix: 'fasds',
    iconName: 'clouds-moon',
    icon: [
      640,
      512,
      [],
      'f745',
      
      ['M352 160c0 11.5 1.2 22.7 3.5 33.5c53.7 8.2 96.5 49.8 106.4 103c14.2 5.4 27.1 13.3 38.4 23.1c3.9 .3 7.8 .4 11.8 .4c51.2 0 96.7-24 126-61.4c-17.5 8.6-37.2 13.4-58 13.4c-72.9 0-132-59.1-132-132C448 72.3 499 16.5 564.7 8.9C548.2 3.1 530.5 0 512 0C423.6 0 352 71.6 352 160z','M208.1 224c12.9 0 25.3 2.2 36.8 6.2c19.6-19.9 45.8-33.5 75-37.2l0-.9c0-35.3-28.6-64-64-64c-7.4 0-14.6 1.3-21.2 3.6c-11.5-30.1-40.6-51.6-74.8-51.6c-38.9 0-71.3 27.8-78.5 64.6c-3.1-.4-6.3-.6-9.5-.6c-39.8 0-72 32.2-72 72l0 72 72 0 34.8 0c18-37.9 56.5-64.1 101.3-64.1zM64 511.9l80 0 271.9 0 96 0 0-96c0-47.6-34.6-87-80-94.6l0-1.3c0-53-43-96-96-96c-34.9 0-65.4 18.6-82.2 46.4C240.8 261.3 225 256 208 256c-44.2 0-80 35.8-80 80c0 5.9 .6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 431.9l0 80z']
      
    ]
  };

  

  
  

  var faCircle8 = {
    prefix: 'fasds',
    iconName: 'circle-8',
    icon: [
      512,
      512,
      [],
      'e0f5',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160 48c0-25 11.5-47.4 29.5-62C181 230.1 176 215.7 176 200c0-39.8 32.2-72 72-72l16 0c39.8 0 72 32.2 72 72c0 15.7-5 30.1-13.5 42c18 14.7 29.5 37 29.5 62c0 44.2-35.8 80-80 80l-32 0c-44.2 0-80-35.8-80-80zm48 0c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-8 0-16 0-8 0c-17.7 0-32 14.3-32 32zm16-104c0 13.2 10.7 24 24 24l16 0c13.3 0 24-10.8 24-24c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24z','M336 200c0-39.8-32.2-72-72-72l-16 0c-39.8 0-72 32.2-72 72c0 15.7 5 30.1 13.5 42c-18 14.7-29.5 37-29.5 62c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80c0-25-11.5-47.4-29.5-62c8.5-11.8 13.5-26.3 13.5-42zm-72 72l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c0 0 0 0 0 0l16 0c0 0 0 0 0 0zm0-48L248 224c-13.2 0-24-10.8-24-24s10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z']
      
    ]
  };

  

  
  

  var faHeartPulse = {
    prefix: 'fasds',
    iconName: 'heart-pulse',
    icon: [
      512,
      512,
      ["heartbeat"],
      'f21e',
      
      ['M0 167.8c0 25.8 7.3 50.8 20.8 72.2c35.7 0 71.5 0 107.2 0c11.3-27.1 22.6-54.1 33.8-81.2c7.1-17 14.2-34.1 21.3-51.1c7.6 16.8 15.2 33.7 22.7 50.5c17.1 38 34.2 75.9 51.3 113.9c13.8-27.6 27.6-55.2 41.4-82.8c7.2-14.3 14.3-28.6 21.5-42.9c7.2 14.3 14.3 28.6 21.5 42.9c8.5 16.9 16.9 33.8 25.4 50.7c41.5 0 82.9 0 124.4 0c13.5-21.5 20.8-46.5 20.8-72.2C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8zM64 288c64 64 128 128 192 192c64-64 128-128 192-192c-32 0-64 0-96 0c-4.9 0-9.9 0-14.8 0c-2.2-4.4-4.4-8.8-6.6-13.3c-3.5-7-7-14-10.5-21.1c-14.2 28.4-28.4 56.7-42.5 85.1l-22.6 45.2-20.7-46.1L184.8 228.4c-6.2 15-12.5 29.9-18.7 44.9c-2.1 4.9-4.1 9.8-6.2 14.8c-5.3 0-10.7 0-16 0c-26.7 0-53.3 0-80 0z','M448 288l-96 0-14.8 0-6.6-13.3L320 253.7l-42.5 85.1-22.6 45.2-20.7-46.1L184.8 228.4l-18.7 44.9L160 288l-16 0-80 0L39.8 263.8c-7.2-7.2-13.6-15.2-19-23.8L128 240l33.8-81.2 21.3-51.1 22.7 50.5 51.3 113.9 41.4-82.8L320 146.3l21.5 42.9L366.8 240l124.4 0c-5.4 8.5-11.7 16.5-19 23.8L448 288z']
      
    ]
  };

  
    var faHeartbeat = faHeartPulse;
  

  
  

  var faInboxIn = {
    prefix: 'fasds',
    iconName: 'inbox-in',
    icon: [
      512,
      512,
      [128229,"inbox-arrow-down"],
      'f310',
      
      ['M0 320L0 512l512 0 0-192-144 0-32 64-160 0-32-64L0 320z','M288 0l0 32 0 178.7 41.4-41.4L352 146.7 397.3 192l-22.6 22.6-96 96L256 333.3l-22.6-22.6-96-96L114.7 192 160 146.7l22.6 22.6L224 210.7 224 32l0-32 64 0z']
      
    ]
  };

  
    var faInboxArrowDown = faInboxIn;
  

  
  

  var faThumbtackSlash = {
    prefix: 'fasds',
    iconName: 'thumbtack-slash',
    icon: [
      640,
      512,
      ["thumb-tack-slash"],
      'e68f',
      
      ['M128 320l0 32 196.9 0L175.8 234.5C142.2 263 128 299.1 128 320zM160 0l0 64 32 0 29.5 0-6.2 80.4L482.7 352l29.3 0 0-32c0-22.5-23.7-76.5-82.1-106.7L418.5 64 448 64l32 0 0-64L448 0 192 0 160 0zM288 384l0 96 0 32 64 0 0-32 0-96-64 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faThumbTackSlash = faThumbtackSlash;
  

  
  

  var faPassport = {
    prefix: 'fasds',
    iconName: 'passport',
    icon: [
      448,
      512,
      [],
      'f5ab',
      
      ['M96 192a128 128 0 1 0 256 0A128 128 0 1 0 96 192zm33.3-16c5.3-31.4 25.8-57.6 53.7-70.8c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0zm0 32l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8c-27.9-13.2-48.4-39.4-53.7-70.8zm71.1-32c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5l.6 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0zm0 32l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5l-.6 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5zM265 105.2c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0c-1.6-30.4-7.7-53.8-14.6-70.8zm0 173.6c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8z','M0 0L448 0l0 512L0 512 0 0zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8l39.1 0c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5l47.1 0c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8l39.1 0c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8l-39.1 0zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5l-47.1 0c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8l-39.1 0c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384l-16 0 0 32 16 0 224 0 16 0 0-32-16 0-224 0z']
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fasds',
    iconName: 'venus',
    icon: [
      384,
      512,
      [9792],
      'f221',
      
      ['M112 176a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1l0 34.9-32 0-32 0 0 64 32 0 32 0 0 32 0 32 64 0 0-32 0-32 32 0 32 0 0-64-32 0-32 0 0-34.9z']
      
    ]
  };

  

  
  

  var faCommentSmile = {
    prefix: 'fasds',
    iconName: 'comment-smile',
    icon: [
      512,
      512,
      [],
      'f4b4',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm132.7 46.1l35.8-32c5.3 6 10.7 11.9 16 17.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c5.3-6 10.7-11.9 16-17.9l35.8 32c-5.3 6-10.7 11.9-16 17.9C337 333.4 298.6 352 256 352s-81-18.6-107.3-48c-5.3-6-10.7-11.9-16-17.9zM160 176c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .6 .1 1.1 .1 1.6s0 1 0 1.2l0 .4 0 .4c0 .3 0 .7 0 1.3c0 .5-.1 1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm192 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M224 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184.4 272l-16-17.9-35.8 32 16 17.9c26.3 29.4 64.7 48 107.3 48s81-18.6 107.3-48l16-17.9-35.8-32-16 17.9c-17.6 19.7-43.1 32-71.6 32s-53.9-12.3-71.6-32z']
      
    ]
  };

  

  
  

  var faSquareRight = {
    prefix: 'fasds',
    iconName: 'square-right',
    icon: [
      448,
      512,
      [10145,"arrow-alt-square-right"],
      'f352',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 208l128 0 0-80 32 0L384 256 256 384l-32 0 0-80L96 304l0-96z','M224 304l0 80 32 0L384 256 256 128l-32 0 0 80L96 208l0 96 128 0z']
      
    ]
  };

  
    var faArrowAltSquareRight = faSquareRight;
  

  
  

  var faVideoPlus = {
    prefix: 'fasds',
    iconName: 'video-plus',
    icon: [
      576,
      512,
      [],
      'f4e1',
      
      ['M0 64L0 448l384 0 0-133L384 197l0-133L0 64zM96 232l24 0 48 0 0-48 0-24 48 0 0 24 0 48 48 0 24 0 0 48-24 0-48 0 0 48 0 24-48 0 0-24 0-48-48 0-24 0 0-48z','M576 448l0-384L384 197 384 315 576 448zM216 184l0-24-48 0 0 24 0 48-48 0-24 0 0 48 24 0 48 0 0 48 0 24 48 0 0-24 0-48 48 0 24 0 0-48-24 0-48 0 0-48z']
      
    ]
  };

  

  
  

  var faRightToBracket = {
    prefix: 'fasds',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      ['M320 32l0 64 32 0 96 0 0 320-96 0-32 0 0 64 32 0 128 0 32 0 0-32 0-384 0-32-32 0L352 32l-32 0z','M352 256L192 96l-32 0 0 96L0 192 0 320l160 0 0 96 32 0L352 256z']
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faFireHydrant = {
    prefix: 'fasds',
    iconName: 'fire-hydrant',
    icon: [
      384,
      512,
      [],
      'e17f',
      
      ['M16 272l0 128 48 0 0-128-48 0zM32 128l0 48 24 0 8 0 256 0 8 0 24 0 0-48-24 0-12 0c-11.6-45-47-80.4-92-92l0-4 0-32L160 0l0 32 0 4c-45 11.6-80.4 47-92 92l-12 0-24 0zM320 272l0 128 48 0 0-128-48 0z','M64 176l256 0 0 288 8 0 24 0 0 48-24 0-8 0L64 512l-8 0-24 0 0-48 24 0 8 0 0-288zM192 400a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faFilePng = {
    prefix: 'fasds',
    iconName: 'file-png',
    icon: [
      512,
      512,
      [],
      'e666',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM176 352l-16 0 0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80l-16 0 0 16 0 128 0 16 32 0 0-16 0-58.9 27.7 65.1 4.1 9.7 10.6 0 5.6 0 16 0 0-16 0-128 0-16-32 0 0 16 0 62.6-29.3-68.9-4.1-9.7L308 352l-4 0zm112 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-24 0-16-16 0-16 0-16 0 0 32 16 0 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 16 32 0 0-16c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40z']
      
    ]
  };

  

  
  

  var faApostrophe = {
    prefix: 'fasds',
    iconName: 'apostrophe',
    icon: [
      192,
      512,
      [],
      '27',
      
      ['M72 352c66.3 0 120-53.7 120-120l0-8 0-96 0-96L0 32 0 224l128 0 0 8c0 30.9-25.1 56-56 56l-8 0-32 0 0 64 32 0 8 0z','']
      
    ]
  };

  

  
  

  var faPersonBreastfeeding = {
    prefix: 'fasds',
    iconName: 'person-breastfeeding',
    icon: [
      448,
      512,
      [],
      'e53a',
      
      ['M128 288l0 44.4 0 8.9 0 26.7c0 .7 0 1.4 .1 2.1l69.2 34.3 43 21.3L213.4 480l107.5 0c-17.2-12.1-34.5-24.1-51.7-36.2c7.7-11 15.3-21.9 23-32.9l-52.8-8.8L192 354.7l0-66.7-24 0-1.9 0L128 288zm104 44a44 44 0 1 0 88 0 44 44 0 1 0 -88 0z','M144 80a80 80 0 1 1 160 0A80 80 0 1 1 144 80zM269.2 443.8l23-32.9-52.8-8.8L192 354.7l0-66.7-24 0-40 0 0 53.3 0 26.7c0 .7 0 1.4 .1 2.1l69.2 34.3 43 21.3-42.6 86-43-21.3L26.7 427 0 413.8 0 384l0-16 0-16 9.6-12.8 96-128L120 192l24 0 176 0 26.2 0 14.2 22 72 112 17.4 27.1-18.5 26.4-56 80-27.5 39.3-78.6-55zM276 376a44 44 0 1 0 0-88 44 44 0 1 0 0 88z']
      
    ]
  };

  

  
  

  var faGaugeMax = {
    prefix: 'fasds',
    iconName: 'gauge-max',
    icon: [
      512,
      512,
      ["tachometer-alt-fastest"],
      'f626',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM64 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm48-112a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm80 208c0 35.3 28.7 64 64 64c17.7 0 33.7-7.2 45.3-18.7c5.8-5.8 10.5-12.7 13.7-20.3c1.6-3.8 2.9-7.8 3.7-12c.4-2.1 .8-4.2 1-6.3c.1-1.1 .2-2.2 .2-3.2c.1-1.1 .1-2.2 .1-3.3c0-.9 0-1.8-.1-2.7s-.1-1.8-.2-2.7c-.2-1.8-.4-3.6-.7-5.4c39.2-24.3 78.4-48.5 117.5-72.8c6.8-4.2 13.6-8.4 20.4-12.6L431.8 215l-20.4 12.6L293.8 300.4C283.2 292.6 270.1 288 256 288c-35.3 0-64 28.7-64 64zM224 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm112 48a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M411.4 227.6L431.8 215 457 255.8l-20.4 12.6L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.5-72.8z']
      
    ]
  };

  
    var faTachometerAltFastest = faGaugeMax;
  

  
  

  var faBuildingWheat = {
    prefix: 'fasds',
    iconName: 'building-wheat',
    icon: [
      640,
      512,
      [],
      'e4db',
      
      ['M0 0L384 0l0 512-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M640 208l0-16-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80zm0 96l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zm0 112l-16 0c-44.2 0-80 35.8-80 80l0 16 16 0c44.2 0 80-35.8 80-80l0-16zM512 512l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zm0-128c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0 0-16zm0-96l0-16c0-44.2-35.8-80-80-80l-16 0 0 16c0 44.2 35.8 80 80 80l16 0zM552 56l0-24-48 0 0 24 0 104 0 24 48 0 0-24 0-104zm72 16l-48 0 0 24 0 32 0 24 48 0 0-24 0-32 0-24zM480 96l0-24-48 0 0 24 0 32 0 24 48 0 0-24 0-32z']
      
    ]
  };

  

  
  

  var faCircleE = {
    prefix: 'fasds',
    iconName: 'circle-e',
    icon: [
      512,
      512,
      [],
      'e109',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 144 0 24 0 0 48-24 0-120 0 0 56 88 0 24 0 0 48-24 0-88 0 0 56 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-104 0-104 0-24z','M160 128l24 0 144 0 24 0 0 48-24 0-120 0 0 56 88 0 24 0 0 48-24 0-88 0 0 56 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-104 0-104 0-24z']
      
    ]
  };

  

  
  

  var faChartPieSimpleCircleCurrency = {
    prefix: 'fasds',
    iconName: 'chart-pie-simple-circle-currency',
    icon: [
      640,
      512,
      [],
      'e604',
      
      ['M0 272C0 404.6 107.5 512 240 512c43.8 0 84.8-11.7 120.1-32.2C335 449.4 320 410.5 320 368c0-28.8 6.9-56 19.2-80L224 288l0-255.5C98.9 40.8 0 144.8 0 272zM272 .6L272 240l103.2 0c31.5-29.8 74-48 120.8-48c4.6 0 9.3 .2 13.8 .5C494.5 83.7 401 0 288 0c-5.4 0-10.7 .2-16 .6z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm25.4-169.4a35.9 35.9 0 1 0 -50.7 50.7 35.9 35.9 0 1 0 50.7-50.7zM460.7 426l-25.3 25.3-22.6-22.6L438 403.3c-13.2-21.6-13.2-49.1 0-70.7l-25.3-25.3 22.6-22.6L460.7 310c21.6-13.2 49.1-13.2 70.7 0l25.3-25.3 22.6 22.6L554 332.7c13.2 21.6 13.2 49.1 0 70.7l25.3 25.3-22.6 22.6L531.3 426c-21.6 13.2-49.1 13.2-70.7 0z']
      
    ]
  };

  

  
  

  var faLayerMinus = {
    prefix: 'fasds',
    iconName: 'layer-minus',
    icon: [
      576,
      512,
      ["layer-group-minus"],
      'f5fe',
      
      ['M0 256L288 384 576 256 288 128 0 256zM0 384L288 512 576 384 471.4 337.5 288 419 104.6 337.5 0 384z','M384 56l24 0 112 0 24 0 0 48-24 0-112 0-24 0 0-48z']
      
    ]
  };

  
    var faLayerGroupMinus = faLayerMinus;
  

  
  

  var faLightbulbExclamation = {
    prefix: 'fasds',
    iconName: 'lightbulb-exclamation',
    icon: [
      384,
      512,
      [],
      'f671',
      
      ['M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176zM168 64l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M112 384V512H272V384H112z']
      
    ]
  };

  

  
  

  var faMessageArrowUp = {
    prefix: 'fasds',
    iconName: 'message-arrow-up',
    icon: [
      512,
      512,
      ["comment-alt-arrow-up"],
      'e1dc',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM150.1 192L184 225.9l17-17 31-31L232 296l0 24 48 0 0-24 0-118.1 31 31 17 17L361.9 192l-17-17-72-72-17-17-17 17-72 72-17 17z','M280 320l0-24 0-118.1 31 31 17 17L361.9 192l-17-17-72-72-17-17-17 17-72 72-17 17L184 225.9l17-17 31-31L232 296l0 24 48 0z']
      
    ]
  };

  
    var faCommentAltArrowUp = faMessageArrowUp;
  

  
  

  var faPaperPlaneTop = {
    prefix: 'fasds',
    iconName: 'paper-plane-top',
    icon: [
      512,
      512,
      ["paper-plane-alt","send"],
      'e20a',
      
      ['M0 32C27.8 96.9 55.6 161.7 83.4 226.6c73.6 9.8 147.1 19.6 220.6 29.4c-73.5 9.8-147.1 19.6-220.6 29.4C55.6 350.3 27.8 415.1 0 480l64 0L512 256 64 32 0 32z','M83.4 226.6L96 256 83.4 285.4 304 256 83.4 226.6z']
      
    ]
  };

  
    var faPaperPlaneAlt = faPaperPlaneTop;
  
    var faSend = faPaperPlaneTop;
  

  
  

  var faPersonSeatReclined = {
    prefix: 'fasds',
    iconName: 'person-seat-reclined',
    icon: [
      512,
      512,
      [],
      'e21f',
      
      ['M26.7 134.4l5.9 31.5 48 256L85.4 448l26.6 0 160 0 32 0 0-64-32 0-133.4 0L95.5 154.1l-5.9-31.5L26.7 134.4z','M128 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm7 80l41 0 32 0 25 0 6.1 24.2L241 192l79 0 32 0 0 64-32 0-63 0 8 32 87 0 22.1 0 7.8 20.7 34.7 91.7 19.2-6 30.5-9.6 19.1 61.1-30.5 9.6-48 15.1-28.8 9-10.7-28.3L329.9 352 240 352l-7 0c-29.4 0-55-20-62.1-48.5L145 199.8 135 160z']
      
    ]
  };

  

  
  

  var faHourglassClock = {
    prefix: 'fasds',
    iconName: 'hourglass-clock',
    icon: [
      576,
      512,
      [],
      'e41b',
      
      ['M0 0L32 0 352 0l32 0 0 64-32 0 0 64 0 13.3-9.4 9.4L237.3 256l36 36c-10.7 22.2-16.8 47.1-17.2 73.3l-64-64-96 96L96 448l179.2 0c13.1 25.6 32.2 47.6 55.6 64L32 512 0 512l0-64 32 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64L0 64 0 0zM96 64l0 50.7 96 96 96-96L288 64 96 64z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0 0 16z']
      
    ]
  };

  

  
  

  var faBlenderPhone = {
    prefix: 'fasds',
    iconName: 'blender-phone',
    icon: [
      576,
      512,
      [],
      'f6b6',
      
      ['M192 0l32 384 256 0 24-96-104 0-16 0 0-32 16 0 112 0 16-64-128 0-16 0 0-32 16 0 136 0 16-64L400 96l-16 0 0-32 16 0 160 0L576 0 192 0z','M153.6 44.8L84.9 0 72.4 12.8c-96.6 99-96.6 259.4 0 358.4L84.9 384l68.7-44.8-25-89.6-58.9 6.7c-12.6-41.8-12.6-86.8 0-128.6l58.9 6.7 25-89.6zM560 64L400 64l-16 0 0 32 16 0 152 0 8-32zm-24 96l-136 0-16 0 0 32 16 0 128 0 8-32zm-24 96l-112 0-16 0 0 32 16 0 104 0 8-32zm32 128l-384 0 0 128 384 0 0-128zM352 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faUserHairBuns = {
    prefix: 'fasds',
    iconName: 'user-hair-buns',
    icon: [
      448,
      512,
      [],
      'e3d3',
      
      ['M128 112l0 64c0 5.5 .5 10.8 1.3 16c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80c.9-5.2 1.3-10.5 1.3-16l0-64-64 0L224 80l-32 32-64 0z','M128 176l0-64 64 0 32-32 32 32 64 0 0 64c0 5.5-.5 10.8-1.3 16l81.3 0 0-128-65.1 0C312.7 25.7 271.4 0 224 0s-88.7 25.7-110.9 64L48 64l0 128 81.3 0c-.9-5.2-1.3-10.5-1.3-16zM448 512L384 320 64 320 0 512l448 0z']
      
    ]
  };

  

  
  

  var faHourglassStart = {
    prefix: 'fasds',
    iconName: 'hourglass-start',
    icon: [
      384,
      512,
      ["hourglass-1"],
      'f251',
      
      ['M32 64c21.3 0 42.7 0 64 0c64 0 128 0 192 0l64 0 0 64 0 13.3-9.4 9.4L237.3 256 342.6 361.4l9.4 9.4 0 13.3 0 64-64 0 0-50.7-96-96-96 96L96 448l-64 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64z','M32 512L0 512l0-64 32 0 320 0 32 0 0 64-32 0L32 512zM32 64L0 64 0 0 32 0 352 0l32 0 0 64-32 0L32 64z']
      
    ]
  };

  
    var faHourglass1 = faHourglassStart;
  

  
  

  var faFamily = {
    prefix: 'fasds',
    iconName: 'family',
    icon: [
      512,
      512,
      [],
      'e300',
      
      ['M24 352l40 0 0 160 112 0 0-64-32 0 0-32 0-160 0-32 32 0 16 0c-10-13.4-16-30-16-48c0-5.5 .6-10.8 1.6-16L32 160 24 352zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zm256 0a64 64 0 1 0 128 0A64 64 0 1 0 320 64zm0 160l16 0 32 0 0 32 0 160 0 32-32 0 0 64 112 0 0-128 64 0L448 160l-113.6 0c1 5.2 1.6 10.5 1.6 16c0 18-6 34.6-16 48z','M208 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 80l0 160-32 0 0 96-96 0 0-96-32 0 0-160 160 0z']
      
    ]
  };

  

  
  

  var faShopLock = {
    prefix: 'fasds',
    iconName: 'shop-lock',
    icon: [
      640,
      512,
      [],
      'e4a5',
      
      ['M0 144l0 48 449.6 0c20.2-19.8 47.9-32 78.4-32s58.2 12.2 78.4 32l33.6 0 0-48L544 0 96 0 0 144zm64 80l0 160 0 128 320 0 0-128 0-96 0-64-64 0 0 160-192 0 0-160-64 0z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faIntersection = {
    prefix: 'fasds',
    iconName: 'intersection',
    icon: [
      384,
      512,
      [8898],
      'f668',
      
      ['M64 480l0-32 0-224c0-70.7 57.3-128 128-128s128 57.3 128 128l0 224 0 32 64 0 0-32 0-224c0-106-86-192-192-192S0 118 0 224L0 448l0 32 64 0z','']
      
    ]
  };

  

  
  

  var faVirusCovidSlash = {
    prefix: 'fasds',
    iconName: 'virus-covid-slash',
    icon: [
      640,
      512,
      [],
      'e4a9',
      
      ['M64 192l48 0 0 24 0 16 33.6 0c.9-6.3 2-12.4 3.5-18.5L401.3 412.2c-17.6 9.2-36.9 15.4-57.3 18.2l0 33.6 16 0 24 0 0 48-24 0-40 0-40 0-24 0 0-48 24 0 16 0 0-33.6c-30.7-4.2-58.8-16.3-82.3-34.1L189.9 420l11.3 11.3 17 17-33.9 33.9-17-17L139 437l-28.3-28.3-17-17 33.9-33.9 17 17L156 386.1l23.8-23.8c-17.9-23.5-29.9-51.7-34.1-82.3L112 280l0 16 0 24-48 0 0-24 0-40 0-40 0-24zM133.3 80.7L139 75l28.3-28.3 17-17 33.9 33.9-17 17-28.3 28.3-1.4 1.4c-12.7-9.9-25.5-19.8-38.2-29.7zM197 130.1c26.3-25.8 60.7-43.3 99-48.5L296 48l-16 0-24 0 0-48 24 0 40 0 40 0 24 0 0 48-24 0-16 0 0 33.6c30.7 4.2 58.8 16.3 82.3 34.1L450.1 92 438.8 80.6l-17-17 33.9-33.9 17 17L501 75l28.3 28.3 17 17-33.9 33.9-17-17L484 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3l33.6 0 0-16 0-24 48 0 0 24 0 40 0 40 0 24-48 0 0-24 0-16-33.6 0c-3.1 23.1-10.8 44.7-21.9 64L197 130.1z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faServer = {
    prefix: 'fasds',
    iconName: 'server',
    icon: [
      512,
      512,
      [],
      'f233',
      
      ['M0 288L0 480l512 0 0-192L0 288zm368 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm24-256a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm56 256a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M512 32L0 32 0 224l512 0 0-192zM344 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm32 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faBadgeSheriff = {
    prefix: 'fasds',
    iconName: 'badge-sheriff',
    icon: [
      448,
      512,
      [],
      'f8a2',
      
      ['M144 256l80 80 80-80-80-80-80 80z','M272 48c0 14.8-6.7 28-17.2 36.8L289 143.5l65.9 .3c6.7-18.5 24.4-31.7 45.2-31.7c26.5 0 48 21.5 48 48s-21.5 48-48 48c-5.9 0-11.6-1.1-16.9-3.1L353.9 256l29.2 51.1c5.3-2 10.9-3.1 16.9-3.1c26.5 0 48 21.5 48 48s-21.5 48-48 48c-20.8 0-38.5-13.2-45.2-31.7l-65.9 .3-34.2 58.7c10.5 8.8 17.2 22 17.2 36.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-14.8 6.7-28 17.2-36.8L159 368.5l-65.9-.3C86.5 386.8 68.8 400 48 400c-26.5 0-48-21.5-48-48s21.5-48 48-48c5.9 0 11.6 1.1 16.9 3.1L94.1 256 64.9 204.9c-5.3 2-10.9 3.1-16.9 3.1c-26.5 0-48-21.5-48-48s21.5-48 48-48c20.8 0 38.5 13.2 45.2 31.7l65.9-.3 34.2-58.7C182.7 76 176 62.8 176 48c0-26.5 21.5-48 48-48s48 21.5 48 48zM224 336l80-80-80-80-80 80 80 80z']
      
    ]
  };

  

  
  

  var faGridRound = {
    prefix: 'fasds',
    iconName: 'grid-round',
    icon: [
      448,
      512,
      [],
      'e5da',
      
      ['M0 256a64 64 0 1 0 128 0A64 64 0 1 0 0 256zM160 96a64 64 0 1 0 128 0A64 64 0 1 0 160 96zm0 320a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM320 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M128 96A64 64 0 1 1 0 96a64 64 0 1 1 128 0zm0 320A64 64 0 1 1 0 416a64 64 0 1 1 128 0zm96-96a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM448 96A64 64 0 1 1 320 96a64 64 0 1 1 128 0zM384 480a64 64 0 1 1 0-128 64 64 0 1 1 0 128z']
      
    ]
  };

  

  
  

  var faSlidersSimple = {
    prefix: 'fasds',
    iconName: 'sliders-simple',
    icon: [
      512,
      512,
      [],
      'e253',
      
      ['M0 128l0 64 32 0 288 0 0-64L32 128 0 128zM192 320l0 64 288 0 32 0 0-64-32 0-288 0z','M64 384l64 0 0-64-64 0 0 64zM0 448l0-64 0-64 0-64 64 0 64 0 64 0 0 64 0 64 0 64-64 0-64 0L0 448zM384 192l64 0 0-64-64 0 0 64zm-64 64l0-64 0-64 0-64 64 0 64 0 64 0 0 64 0 64 0 64-64 0-64 0-64 0z']
      
    ]
  };

  

  
  

  var faWindTurbine = {
    prefix: 'fasds',
    iconName: 'wind-turbine',
    icon: [
      512,
      512,
      [],
      'f89b',
      
      ['M128 464l0 48 24 0 208 0 24 0 0-48-24 0-72 0 0-117.6-64-95.2L224 464l-72 0-24 0z','M317.1 202.8L340.8 425 216.1 239.5 11.8 148.9l223-15.2L415.4 2 317.1 202.8zM256 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faShopSlash = {
    prefix: 'fasds',
    iconName: 'shop-slash',
    icon: [
      640,
      512,
      ["store-alt-slash"],
      'e070',
      
      ['M0 128l15.1-20.1L121.8 192 0 192l0-64zm64 96l64 0 0 160 192 0 0-35.9 64 50.4L384 512 64 512l0-128 0-160zM71.5 32.7L96 0 544 0l96 128 0 64-363.4 0C208.3 138.9 139.9 85.8 71.5 32.7zM320 224l64 0 0 51.4-64-49.7 0-1.7zm192 0l64 0 0 200.4c-21.3-16.6-42.7-33.1-64-49.7L512 224z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faStoreAltSlash = faShopSlash;
  

  
  

  var faSquare6 = {
    prefix: 'fasds',
    iconName: 'square-6',
    icon: [
      448,
      512,
      [],
      'e25b',
      
      ['M0 32l448 0 0 448L0 480 0 32zM128 288c0 53 43 96 96 96s96-43 96-96c0-49.2-37-89.8-84.7-95.3c14.8-16.2 29.6-32.3 44.4-48.4c5-5.4 9.9-10.8 14.9-16.2c-21.7 0-43.4 0-65.1 0c-22.7 24.8-45.4 49.5-68.1 74.3c-21.4 23.4-33.3 54-33.3 85.7zm144 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M161.3 202.3L229.4 128l65.1 0-14.9 16.2-44.4 48.4C283 198.2 320 238.8 320 288c0 53-43 96-96 96s-96-43-96-96c0-31.7 11.9-62.3 33.3-85.7zM176 288a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z']
      
    ]
  };

  

  
  

  var faPersonSkiLift = {
    prefix: 'fasds',
    iconName: 'person-ski-lift',
    icon: [
      512,
      512,
      ["ski-lift"],
      'f7c8',
      
      ['M-8 188.7L2.3 210.4l88 184L99 412.4l19.3-5.3 88-24 23.2-6.3-12.6-46.3-23.2 6.3L125 355.6 45.7 189.6 35.3 168-8 188.7zM113.2 464.9l16.6 45 22.5-8.3 344-127.1C505.7 371 512 362 512 352l0-40 0-24-48 0 0 24 0 23.3c-48 17.7-96 35.5-144 53.2c-21.3 7.9-42.7 15.8-64 23.7L135.7 456.6l-22.5 8.3zM224 0l0 206.8 32-8.5L256 0 224 0z','M64 80a48 48 0 1 1 96 0A48 48 0 1 1 64 80zm103.4 60.7l13.7 30.1 32.7 71.9 65.9-17.6L320 256l0 132.5-64 23.7 0-114.5-66.7 17.8c-22.6 6-46.2-5.1-55.9-26.3L96.9 210.3 83.8 182l27.9-13.8 26.1-12.9 29.6-14.7z']
      
    ]
  };

  
    var faSkiLift = faPersonSkiLift;
  

  
  

  var faNfcLock = {
    prefix: 'fasds',
    iconName: 'nfc-lock',
    icon: [
      576,
      512,
      [],
      'e1f8',
      
      ['M0 32L0 480l320 0 0-64L80 416l-16 0 0-16 0-288 0-16 16 0 64 0 16 0 0 32-16 0-48 0 0 256 224 0 0-96 32 0 0-16 0-144-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-98.7 0-16 16 0 144 0 16 0 0 16 0 81.6c16.8-17.1 39.1-28.9 64-32.5L448 32 0 32z','M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faCannon = {
    prefix: 'fasds',
    iconName: 'cannon',
    icon: [
      640,
      512,
      [],
      'e642',
      
      ['M0 378.3l49.1-24.5c1 7.9 2.6 15.8 5 23.6c1.2 3.9 2.5 7.8 4 11.6c.8 1.9 1.6 3.8 2.4 5.7c.4 .9 .9 1.9 1.3 2.8c.4 .9 .9 1.9 1.4 2.8c7.5 15 17.3 28.2 28.8 39.3L42.9 464.2 0 378.3zM288 368c0-61.9 50.1-112 112-112c40.9 0 76.6 21.9 96.2 54.5C506.2 327.3 512 347 512 368c0 61.9-50.1 112-112 112c-37.4 0-70.6-18.4-90.9-46.6C295.8 415 288 392.4 288 368zm80 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M256.4 464.8c-71.1 35.6-157.6 6.7-193.2-64.4s-6.7-157.6 64.4-193.2C192 176 559 51.3 559 51.3l81 161.9s-65.9 45.1-143.8 97.4C476.6 277.9 440.9 256 400 256c-61.9 0-112 50.1-112 112c0 24.4 7.8 47 21.1 65.4c-23.2 14.6-41.7 25.7-52.7 31.4z']
      
    ]
  };

  

  
  

  var faFilesMedical = {
    prefix: 'fasds',
    iconName: 'files-medical',
    icon: [
      448,
      512,
      [],
      'f7fd',
      
      ['M96 0l0 416 352 0 0-320-96 0 0-96L96 0zm80 224l64 0 0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64z','M352 96l0-96 96 96-96 0zM48 96l0 24 0 344 280 0 24 0 0 48-24 0L24 512 0 512l0-24L0 120 0 96l48 0zm192 64l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faPegasus = {
    prefix: 'fasds',
    iconName: 'pegasus',
    icon: [
      576,
      512,
      [],
      'f703',
      
      ['M0 256l0 56 0 24 48 0 0-24 0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256z','M448 238.1l0-78.1 16 0 32 64 80-32 0-128L544 32l16 0 16 0 0-32L560 0 480 0 448 0C377.3 0 320 57.3 320 128L160 32s-20.2 141.7 68.1 199.7c-8.7-2.7-16.7-6.1-24.2-10.1c-22.5-12.1-38.6-29.4-49.9-49.8c-7.3-13.2-12.7-27.8-16.5-43C96 134.3 64 169.8 64 212.8c0 16.8 5 33.1 14.2 47.1l42.4 63.6L94.1 350.1l-21 21 9.4 28.1L120.1 512l101.2 0L182.9 397l27-27L224 355.9l0-19.9 0-16 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8L320 512l96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faArrowRightToBracket = {
    prefix: 'fasds',
    iconName: 'arrow-right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in"],
      'f090',
      
      ['M320 32l0 64 32 0 96 0 0 320-96 0-32 0 0 64 32 0 128 0 32 0 0-32 0-384 0-32-32 0L352 32l-32 0z','M365.3 256l-22.6 22.6-128 128L192 429.3 146.7 384l22.6-22.6L242.7 288 32 288 0 288l0-64 32 0 210.7 0-73.4-73.4L146.7 128 192 82.7l22.6 22.6 128 128L365.3 256z']
      
    ]
  };

  
    var faSignIn = faArrowRightToBracket;
  

  
  

  var faComputerMouse = {
    prefix: 'fasds',
    iconName: 'computer-mouse',
    icon: [
      384,
      512,
      [128433,"mouse"],
      'f8cc',
      
      ['M0 0L176 0l0 192L0 192 0 0zM0 224l192 0 192 0 0 128c0 88.4-71.6 160-160 160l-64 0C71.6 512 0 440.4 0 352L0 224zM208 0L384 0l0 192-176 0L208 0z','M176 192L0 192l0 32 192 0 192 0 0-32-176 0L208 0 176 0l0 192z']
      
    ]
  };

  
    var faMouse = faComputerMouse;
  

  
  

  var faCalendarStar = {
    prefix: 'fasds',
    iconName: 'calendar-star',
    icon: [
      448,
      512,
      [],
      'f736',
      
      ['M0 192l448 0 0 320L0 512 0 192zM117.5 309.4l58.6 50.2-17.9 75L224 394.4l65.8 40.2-17.9-75 58.6-50.2-76.9-6.2L224 232l-29.6 71.2-76.9 6.2z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zm93.6 303.2L224 232l-29.6 71.2-76.9 6.2 58.6 50.2-17.9 75L224 394.4l65.8 40.2-17.9-75 58.6-50.2-76.9-6.2z']
      
    ]
  };

  

  
  

  var faPersonToPortal = {
    prefix: 'fasds',
    iconName: 'person-to-portal',
    icon: [
      512,
      512,
      ["portal-enter"],
      'e022',
      
      ['M352.6 224l15.4 0 32 0 0 64-32 0-15.4 0c4.9 126.3 38.6 224 79.4 224c44.2 0 80-114.6 80-256S476.2 0 432 0c-40.8 0-74.5 97.7-79.4 224z','M272 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM128 96l-13.3 0-9.4 9.4-48 48L34.7 176 80 221.3l22.6-22.6L141.3 160l27.7 0-31.3 94c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-9.4 32.8-16 56L213.6 512l66.6 0 6.6-23.2 16-56 16-56 6.6-23.2L305 340.9 238 299l29-77.4 24.3 48.6 8.8 17.7 19.8 0 48 0 32 0 0-64-32 0-28.2 0-39.2-78.3-5.4-10.9-11.3-4.5-80-32L198.2 96 192 96l-64 0zM109.5 310.7L91.2 352 32 352 0 352l0 64 32 0 80 0 20.8 0 8.4-19L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9z']
      
    ]
  };

  
    var faPortalEnter = faPersonToPortal;
  

  
  

  var faSlash = {
    prefix: 'fasds',
    iconName: 'slash',
    icon: [
      640,
      512,
      [],
      'f715',
      
      ['M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z','']
      
    ]
  };

  

  
  

  var faLasso = {
    prefix: 'fasds',
    iconName: 'lasso',
    icon: [
      576,
      512,
      [],
      'f8c8',
      
      ['M576 176c0 97.2-128.9 176-288 176c-13.2 0-26.3-.5-39-1.6c4.6 12.8 7 26.5 7 40.6c0 66.8-54.2 121-121 121l-71 0-32 0 0-64 32 0 71 0c31.5 0 57-25.5 57-57c0-21.6-12.2-41.3-31.5-51l-46.8-23.4 .2-.4C44.7 284.1 0 233.2 0 176C0 78.8 128.9 0 288 0S576 78.8 576 176zM288 288c123.7 0 224-50.1 224-112s-100.3-112-224-112S64 114.1 64 176s100.3 112 224 112z','']
      
    ]
  };

  

  
  

  var faCircleQuarterStroke = {
    prefix: 'fasds',
    iconName: 'circle-quarter-stroke',
    icon: [
      512,
      512,
      [],
      'e5d3',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256S397.4 0 256 0l0 64c106 0 192 86 192 192s-86 192-192 192S64 362 64 256L0 256z','M256 0C114.6 0 0 114.6 0 256l256 0L256 0z']
      
    ]
  };

  

  
  

  var faLocationXmark = {
    prefix: 'fasds',
    iconName: 'location-xmark',
    icon: [
      384,
      512,
      ["map-marker-times","map-marker-xmark"],
      'f60e',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm94.1-64c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.3 31.3 47 47c15.7-15.7 31.3-31.3 47-47c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.3 31.3-47 47c15.7 15.7 31.4 31.4 47 47c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9l-17-17-47-47c-15.7 15.7-31.3 31.4-47 47l-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.3-31.3-47-47c-5.7-5.7-11.3-11.3-17-17z','M273 145l17-17L256 94.1l-17 17-47 47-47-47-17-17L94.1 128l17 17 47 47-47 47-17 17L128 289.9l17-17 47-47 47 47 17 17L289.9 256l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faMapMarkerTimes = faLocationXmark;
  
    var faMapMarkerXmark = faLocationXmark;
  

  
  

  var faSpellCheck = {
    prefix: 'fasds',
    iconName: 'spell-check',
    icon: [
      576,
      512,
      [],
      'f891',
      
      ['M0 256l69.3 0 13.3-32 90.7 0 13.3 32 69.3 0c-1.7-4.1-3.4-8.2-5.1-12.3l-93.3-224L149.3 0 106.7 0 98.5 19.7 5.1 243.7 0 256zm109.3-96L128 115.2 146.7 160l-37.3 0zM256 0l0 32 0 96 0 96c0 10.7 0 21.3 0 32l32 0 80 0c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80L288 0 256 0zm64 64l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0-32zm0 96l32 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0-32z','M573.3 272l-22.6 22.6-192 192L336 509.3l-22.6-22.6-96-96L194.7 368 240 322.7l22.6 22.6L336 418.7 505.4 249.4 528 226.8 573.3 272z']
      
    ]
  };

  

  
  

  var faOctopus = {
    prefix: 'fasds',
    iconName: 'octopus',
    icon: [
      640,
      512,
      [],
      'e688',
      
      ['M.5 349l6.8 31.6c12.4 58 63.6 99.4 122.9 99.4c45.1 0 89.1-13.3 126.5-38.3L295.3 416l49.5 0 38.6 25.7c37.4 25 81.4 38.3 126.4 38.3c59.3 0 110.5-41.4 123-99.4l6.8-31.6L592.5 339l-6.8 31.6c-7.7 35.8-39.4 61.5-76 61.5c-41.1 0-74.8-31.9-77.6-72.4c-.1-1.8-.2-3.6-.2-5.4l0-1.4c0-4.5 .4-9.1 1.2-13.6l9.6-55.3c6.3-36.4 12.7-72.9 19-109.3c1.5-8.4 2.2-17 2.2-25.6l0-5.2C464 64.5 399.5 0 320 0S176 64.5 176 144l0 5.2c0 8.6 .7 17.1 2.2 25.6c9.5 54.9 19.1 109.7 28.6 164.6c.2 1.1 .4 2.3 .5 3.4s.3 2.2 .4 3.4c.1 1.2 .2 2.3 .2 3.4s.1 2.2 .1 3.4l0 1.4c0 1.8 0 2.3 0 2.7c0 .9-.1 1.8-.1 2.7c-2.8 40.4-36.4 72.3-77.4 72.4c-36.8 0-68.5-25.6-76.1-61.5L47.5 339 .5 349zM272 272a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M207.8 359.6c.1-1.8 .2-3.6 .2-5.4l0-1.4c0-4.5-.4-9.1-1.2-13.6l-9.6-55.2c3.5 20.2-11.3 39.1-31.8 40.6c-16.3 1.2-31.2-9.2-35.8-24.8L118.8 263c-12.4-42.1-51-71-94.8-71L0 192l0 48 24 0c22.6 0 42.4 14.9 48.8 36.5l10.9 36.9c11 37.3 46.5 62 85.3 59.2c14.4-1 27.7-5.7 38.9-13zm235-75.5l-9.6 55.3c-.8 4.5-1.2 9-1.2 13.6l0 1.4c0 1.8 .1 3.6 .2 5.4c11.3 7.3 24.5 11.9 38.9 13c38.8 2.8 74.3-21.9 85.3-59.2l10.9-36.9c6.4-21.6 26.2-36.5 48.8-36.5l24 0 0-48-24 0c-43.8 0-82.5 28.9-94.8 71l-10.9 36.9c-4.6 15.7-19.5 26-35.8 24.8c-20.5-1.5-35.3-20.3-31.7-40.6zM272 272a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faCoffinCross = {
    prefix: 'fasds',
    iconName: 'coffin-cross',
    icon: [
      384,
      512,
      [],
      'e051',
      
      ['M0 144L104 512l176 0L384 144 272 0 112 0 0 144zm96 16l24 0 48 0 0-40 0-24 48 0 0 24 0 40 48 0 24 0 0 48-24 0-48 0 0 120 0 24-48 0 0-24 0-120-48 0-24 0 0-48z','M216 120l0-24-48 0 0 24 0 40-48 0-24 0 0 48 24 0 48 0 0 120 0 24 48 0 0-24 0-120 48 0 24 0 0-48-24 0-48 0 0-40z']
      
    ]
  };

  

  
  

  var faGoalNet = {
    prefix: 'fasds',
    iconName: 'goal-net',
    icon: [
      640,
      512,
      [],
      'e3ab',
      
      ['M96 192l0 32 64 0 0 64-64 0 0 32 64 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-64 64 0 0-32-64 0 0-64 64 0 0-32-64 0 0-64-32 0 0 64-64 0 0-64-32 0 0 64-64 0 0-64-32 0 0 64-64 0 0-64-32 0 0 64-64 0zm96 32l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M0 32l32 0 576 0 32 0 0 32 0 384 0 32-64 0 0-32 0-352L64 96l0 352 0 32L0 480l0-32L0 64 0 32z']
      
    ]
  };

  

  
  

  var faXRay = {
    prefix: 'fasds',
    iconName: 'x-ray',
    icon: [
      512,
      512,
      [],
      'f497',
      
      ['M32 96l0 320 448 0 0-320L32 96zm80 128l16 0 112 0 0-32-80 0-16 0 0-32 16 0 80 0 0-16 0-16 32 0 0 16 0 16 80 0 16 0 0 32-16 0-80 0 0 32 112 0 16 0 0 32-16 0-112 0 0 54.6L330.7 288l53.3 0 0 41.6L341.3 384l-170.7 0L128 329.6l0-41.6 53.3 0L240 310.6l0-54.6-112 0-16 0 0-32zm80 112a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm96 0a16 16 0 1 0 32 0 16 16 0 1 0 -32 0z','M0 32l32 0 448 0 32 0 0 64-32 0L32 96 0 96 0 32zM0 416l32 0 448 0 32 0 0 64-32 0L32 480 0 480l0-64z']
      
    ]
  };

  

  
  

  var faArrowDownFromBracket = {
    prefix: 'fasds',
    iconName: 'arrow-down-from-bracket',
    icon: [
      448,
      512,
      [],
      'e667',
      
      ['M0 0L0 32 0 160l0 32 64 0 0-32 0-96 320 0 0 96 0 32 64 0 0-32 0-128 0-32L416 0 32 0 0 0z','M224 509.3l-22.6-22.6-128-128L50.7 336 96 290.7l22.6 22.6L192 386.7 192 192l0-32 64 0 0 32 0 194.7 73.4-73.4L352 290.7 397.3 336l-22.6 22.6-128 128L224 509.3z']
      
    ]
  };

  

  
  

  var faDiagramVenn = {
    prefix: 'fasds',
    iconName: 'diagram-venn',
    icon: [
      640,
      512,
      [],
      'e15a',
      
      ['M192 256c0 61 24.4 116.4 64 156.8c23.6-4.8 45.4-14.8 64-28.8c-12.1-9.1-22.9-19.9-32-32c-7.4-9.8-13.7-20.6-18.7-32c-6.5-14.9-10.8-31.1-12.5-48c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16c1.7-16.9 6-33.1 12.5-48c5-11.4 11.3-22.2 18.7-32c9.1-12.1 19.9-22.9 32-32c-18.5-14-40.3-24-63.9-28.8C216.4 139.6 192 195 192 256zM320 53.6c12.2 5.8 23.8 12.7 34.6 20.5c.5 .3 1 .7 1.5 1.1c9.9 7.3 19.3 15.4 27.9 24.1c39.6 40.4 64 95.7 64 156.8c0 1.9 0 3.8-.1 5.7s-.1 3.8-.2 5.7c-.2 3.8-.5 7.5-.8 11.2c-.7 7.4-1.9 14.8-3.3 22c-2.9 14.4-7.2 28.3-12.7 41.6c-11.1 26.5-27.1 50.5-46.9 70.7c-9 9.2-18.8 17.6-29.3 25.2c-10.9 7.8-22.4 14.7-34.6 20.5c29.2 13.8 61.7 21.6 96 21.6c123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6z','M352 352l-64 0c-7.4-9.8-13.7-20.6-18.7-32l101.4 0c6.5-14.9 10.8-31.1 12.5-48l-126.4 0c-.5-5.3-.8-10.6-.8-16s.3-10.7 .8-16l126.4 0c-1.7-16.9-6-33.1-12.5-48l-101.4 0c5-11.4 11.3-22.2 18.7-32l64 0c-29.2-38.9-75.7-64-128-64C135.6 96 64 167.6 64 256s71.6 160 160 160c52.3 0 98.8-25.1 128-64zM0 256a224 224 0 1 1 448 0A224 224 0 1 1 0 256z']
      
    ]
  };

  

  
  

  var faFileLock = {
    prefix: 'fasds',
    iconName: 'file-lock',
    icon: [
      576,
      512,
      [],
      'e3a6',
      
      ['M0 0L224 0l0 160 160 0 0 33.6c-19.8 20.2-32 47.9-32 78.4l0 16-32 0 0 224L0 512 0 0z','M384 160L224 0l0 160 160 0zm80 80c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48-32 0 0 192 224 0 0-192-32 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z']
      
    ]
  };

  

  
  

  var faEar = {
    prefix: 'fasds',
    iconName: 'ear',
    icon: [
      384,
      512,
      [128066],
      'f5f0',
      
      ['M0 192L0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-3.2-.1-6.4-.3-9.5C345.3 325.3 384 263.2 384 192C384 86 298 0 192 0S0 86 0 192zM70.2 324.9c6.1-5.1 12.3-10.2 18.4-15.4c13.1-10.9 26.2-21.9 39.4-32.8c0-2 0-4 0-5.9c-11.6-5.8-23.2-11.6-34.7-17.4c-4.4-2.2-8.8-4.4-13.3-6.6c0-4.9 0-9.9 0-14.8c0-13.3 0-26.7 0-40.1c0-1.9 0-2.4 0-2.9c0-.9 .1-1.9 .1-2.8c.1-1.9 .2-3.8 .4-5.7c.4-3.8 1-7.5 1.7-11.1c1.5-7.3 3.7-14.3 6.5-21c5.7-13.4 13.9-25.5 24-35.6C133.1 92.5 161.1 80 192 80c61.9 0 112 50.1 112 112c0 2.7 0 5.3 0 8c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-2.7 0-5.3 0-8c0-35.3-28.7-64-64-64c-17.7 0-33.7 7.2-45.3 18.7c-5.8 5.8-10.5 12.7-13.7 20.3c-1.6 3.8-2.9 7.8-3.7 12c-.4 2.1-.8 4.2-1 6.4c-.1 1.1-.2 2.1-.2 3.2c-.1 1.1-.1 2.2-.1 3.3c0 8.4 0 16.8 0 25.2c11.6 5.8 23.2 11.6 34.7 17.4c4.4 2.2 8.8 4.4 13.3 6.6c0 4.9 0 9.9 0 14.8c0 10.7 0 21.3 0 32c0 3.7 0 7.5 0 11.2l-8.6 7.2c-16 13.3-32 26.7-48 40c-6.1 5.1-12.3 10.2-18.4 15.4L70.2 324.9z','M192 128c-35.3 0-64 28.7-64 64l0 25.2 34.7 17.4 13.3 6.6 0 14.8 0 32 0 11.2-8.6 7.2-48 40-18.4 15.4L70.2 324.9l18.4-15.4L128 276.8l0-5.9L93.3 253.5 80 246.8 80 232l0-40c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8 0 24-48 0 0-24 0-8c0-35.3-28.7-64-64-64z']
      
    ]
  };

  

  
  

  var faPlaneCircleExclamation = {
    prefix: 'fasds',
    iconName: 'plane-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e556',
      
      ['M0 288l0 96 192-64 0 80-64 48 0 64 128-32 128 32 0-8.2c-39.1-32.3-64-81.1-64-135.8c0-64.1 34.3-120.2 85.5-151L320 160l0-66.3C320 59.5 292 0 256 0c-35 0-64 59.5-64 93.7l0 66.3L0 288z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faWindow = {
    prefix: 'fasds',
    iconName: 'window',
    icon: [
      512,
      512,
      [],
      'f40e',
      
      ['M0 224L0 480l512 0 0-256L0 224zM160 96l0 64 64 0 0-64-64 0zm96 0l0 64 64 0 0-64-64 0z','M512 32L0 32 0 224l512 0 0-192zM128 96l0 64-64 0 0-64 64 0zm32 0l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faFaceAstonished = {
    prefix: 'fasds',
    iconName: 'face-astonished',
    icon: [
      512,
      512,
      [],
      'e36b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM89.4 143.2c3.9-3.6 7.8-7.3 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0c0 10.7 0 21.3 0 32l-16 0c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8c-3.9 3.6-7.8 7.3-11.7 10.9L89.4 143.2zm55.2 77.5c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6zM208 352c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zM304 96l16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9l-16 0c0-10.7 0-21.3 0-32zm.5 124.7c.1-1.1 .3-2.1 .5-3.2c.4-2.1 1.1-4.1 1.9-6c1.6-3.8 4-7.3 6.9-10.2c5.8-5.8 13.8-9.4 22.6-9.4c17.7 0 32 14.3 32 32s-14.3 32-32 32c-8.8 0-16.8-3.6-22.6-9.4c-2.9-2.9-5.2-6.3-6.9-10.2c-.8-1.9-1.4-3.9-1.9-6c-.2-1-.4-2.1-.5-3.2c-.1-.5-.1-1.1-.1-1.6s0-1 0-1.8c0-.4 0-.9 0-1.5s.1-1.1 .1-1.6z','M192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 143.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 128.9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z']
      
    ]
  };

  

  
  

  var faPipeSmoking = {
    prefix: 'fasds',
    iconName: 'pipe-smoking',
    icon: [
      640,
      512,
      [],
      'e3c4',
      
      ['M364 188.2c4.6 3 9.1 6.1 13.7 9.1c8 5.3 16 10.7 24 16c5.2 3.5 10.4 6.9 15.5 10.4L523.8 64 608 64l32 0 0-64L608 0 506.7 0 489.5 0 480 14.2l-116 174z','M377.8 197.4l-26.6-17.8-17.8 26.6L256 322.3l0-66.3 0-32-32 0L32 224 0 224l0 32 0 98.9C0 441.7 70.3 512 157.1 512c52.5 0 101.6-26.2 130.7-69.9L410.6 257.8l17.8-26.6-26.6-17.8-24-16z']
      
    ]
  };

  

  
  

  var faFileInvoiceDollar = {
    prefix: 'fasds',
    iconName: 'file-invoice-dollar',
    icon: [
      384,
      512,
      [],
      'f571',
      
      ['M0 0L224 0c0 53.3 0 106.7 0 160l160 0 0 352L0 512 0 0zM64 64l0 32 16 0 64 0 16 0 0-32-16 0L80 64 64 64zm0 64l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm59.8 278.1l15.2 5.1c1.3 .4 2.8 1 4.6 1.6c8.9 3 23 7.9 32.4 9.6c0 3.2 0 6.4 0 9.6c0 5.3 0 10.7 0 16l32 0c0-5.3 0-10.7 0-16c0-3 0-5.9 0-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.8l-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4c5.2 1.4 10.3 2.7 15.5 4.1l8.2-30.9c-5.2-1.4-10.3-2.7-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9c0-3.2 0-6.4 0-9.6c0-5.3 0-10.7 0-16l-32 0c0 5.3 0 10.7 0 16c0 3.1 0 6.2 0 9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1c-2.2-.7-4.2-1.4-6.2-2.1c-5.1-1.7-10.1-3.4-15.2-5.1c-3.4 10.1-6.7 20.2-10.1 30.4z','M384 160L224 0l0 160 160 0zM208 240l0-16-32 0 0 16 0 9.3c-6.5 1.1-12.7 2.9-18.3 5.4c-14.1 6.4-25.9 18.1-28.8 34.7c-1.6 9.5-.7 18.5 3.1 26.6c3.8 7.9 9.7 13.7 15.9 17.9c11.1 7.5 25.8 11.9 37.7 15.5l2 .6c13.8 4.2 23.9 7.5 30.5 12.3c2.9 2.1 4.3 4 5.1 5.7c.7 1.6 1.3 4.3 .5 9c-.9 5-3.8 9-10.3 11.8c-7 3-17.7 4.3-31 2.2c-6.4-1-17.6-4.8-27.1-8.1c0 0 0 0 0 0s0 0 0 0c-2.2-.7-4.2-1.4-6.1-2.1l-15.2-5.1-10.1 30.4 15.2 5.1c1.3 .4 2.8 1 4.6 1.6c0 0 0 0 0 0s0 0 0 0s0 0 0 0c8.9 3 23 7.9 32.4 9.6l0 9.6 0 16 32 0 0-16 0-8.9c6.3-.9 12.3-2.5 17.9-4.9c14.7-6.3 26.3-18.3 29.3-35.7c1.7-9.7 .9-18.9-2.7-27.2c-3.6-8.2-9.3-14.3-15.6-18.8c-11.6-8.4-27.2-13.1-39.5-16.8l-.6-.2c-13.9-4.2-24.3-7.4-31-12c-3-2-4.3-3.8-5-5.1c-.6-1.2-1.2-3.3-.5-7.4c.6-3.6 3.3-7.8 10.5-11c7.3-3.3 18-4.9 30.9-2.9c4.4 .7 18.1 3.4 22.1 4.4l15.5 4.1 8.2-30.9-15.5-4.1c-5.1-1.4-18.2-3.9-24.1-4.9l0-9.6z']
      
    ]
  };

  

  
  

  var faScalpelLineDashed = {
    prefix: 'fasds',
    iconName: 'scalpel-line-dashed',
    icon: [
      576,
      512,
      ["scalpel-path"],
      'f61e',
      
      ['M0 512L176 320l112 0C288 496 0 512 0 512z','M320 320L495.1 115.7C506 103 512 86.8 512 70.1l0-3.7C512 29.7 482.3 0 445.6 0c-18.8 0-36.8 8-49.4 22L128 320l192 0zM240 480l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zm128 0l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0zm128 0l-16 0 0 32 16 0 64 0 16 0 0-32-16 0-64 0z']
      
    ]
  };

  
    var faScalpelPath = faScalpelLineDashed;
  

  
  

  var faHandsBound = {
    prefix: 'fasds',
    iconName: 'hands-bound',
    icon: [
      640,
      512,
      [],
      'e4f9',
      
      ['M32 0l0 32 0 32 0 32 0 80 0 16 0 32 0 11.8 7.7 9L131.6 352 288 352l0-32 0-88 0-12.2-8.1-9.1-64-72-21.3-23.9-47.8 42.5 21.3 23.9L207.9 226l-35.7 24.2L96 163.9 96 96l0-32 0-32L96 0 32 0zM160 480l0 32 128 0 0-32-128 0zM352 219.8l0 12.2 0 88 0 32 156.4 0 91.9-107.2 7.7-9 0-11.8 0-32 0-16 0-80 0-32 0-32 0-32L544 0l0 32 0 32 0 32 0 67.9-76.2 86.4L432.1 226l39.8-44.8 21.3-23.9-47.8-42.5-21.3 23.9-64 72-8.1 9.1zM352 480l0 32 128 0 0-32-128 0z','M128 352l-24 0 0 48 24 0 384 0 24 0 0-48-24 0-384 0zm0 80l-24 0 0 48 24 0 384 0 24 0 0-48-24 0-384 0z']
      
    ]
  };

  

  
  

  var faClockThree = {
    prefix: 'fasds',
    iconName: 'clock-three',
    icon: [
      512,
      512,
      [],
      'e356',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 96l48 0 0 24 0 112 80 0 24 0 0 48-24 0-104 0-24 0 0-24 0-136 0-24z','M232 96l0 24 0 136 0 24 24 0 104 0 24 0 0-48-24 0-80 0 0-112 0-24-48 0z']
      
    ]
  };

  

  
  

  var faSpider = {
    prefix: 'fasds',
    iconName: 'spider',
    icon: [
      512,
      512,
      [128375],
      'f717',
      
      ['M67.7 133.6L79 145l72.1 72.1c8.3 2.8 16.6 5.5 24.9 8.3c0-17.1 0-34.2 0-51.3l-51.7-51.7 33.8-81.2 9.2-22.2L123.1 .6l-9.2 22.2-40 96-6.2 14.8zM336 174.1l0 51.3c8.3-2.8 16.6-5.5 24.9-8.3L433 145l11.4-11.4-6.2-14.8-40-96L388.9 .6 344.6 19.1l9.2 22.2 33.8 81.2L336 174.1z','M0 139.9l0-21.2 39.2-13.1 7.6 22.8L67 189l109 36.3 0-65.4c0-38.7 27.5-71 64-78.4l0 46.4 32 0 0-46.4c36.5 7.4 64 39.7 64 78.4l0 65.4L445 189l20.2-60.6 7.6-22.8L512 118.7l0 21.2-1.2 3.7-24 72L483 227l-11.4 3.8L395.9 256l75.7 25.2L483 285l3.8 11.4 24 72 1.2 3.7 0 21.2-39.2 13.1-7.6-22.8L445 323l-84.2-28.1L433 367l11.4 11.4-6.2 14.8-40 96-9.2 22.2-44.3-18.5 9.2-22.2 33.8-81.2L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-35.7 35.7 33.8 81.2 9.2 22.2-44.3 18.5-9.2-22.2-40-96-6.2-14.8L79 367l72.1-72.1L67 323 46.8 383.6l-7.6 22.8L0 393.3l0-21.2 1.2-3.7 24-72L29 285l11.4-3.8L116.1 256 40.4 230.8 29 227l-3.8-11.4-24-72L0 139.9z']
      
    ]
  };

  

  
  

  var faBracketCurlyRight = {
    prefix: 'fasds',
    iconName: 'bracket-curly-right',
    icon: [
      256,
      512,
      [],
      '7d',
      
      ['M160 32l32 0 0 32 0 114.7 54.6 54.6 9.4 9.4 0 26.5-9.4 9.4L192 333.3 192 448l0 32-32 0-96 0-32 0 0-64 32 0 64 0 0-96 0-13.3 9.4-9.4L178.7 256l-41.4-41.4-9.4-9.4 0-13.3 0-96L64 96 32 96l0-64 32 0 96 0z','']
      
    ]
  };

  

  
  

  var faFileDashedLine = {
    prefix: 'fasds',
    iconName: 'file-dashed-line',
    icon: [
      640,
      512,
      ["page-break"],
      'f877',
      
      ['M128 0l0 256 384 0 0-96-160 0L352 0 128 0zm0 368l0 144 384 0 0-144-384 0zM384 0l0 128 128 0L384 0z','M32 288l24 0 112 0 24 0 0 48-24 0L56 336l-24 0 0-48zm224 0l24 0 80 0 24 0 0 48-24 0-80 0-24 0 0-48zm192 0l24 0 112 0 24 0 0 48-24 0-112 0-24 0 0-48z']
      
    ]
  };

  
    var faPageBreak = faFileDashedLine;
  

  
  

  var faArrowUpFromSquare = {
    prefix: 'fasds',
    iconName: 'arrow-up-from-square',
    icon: [
      512,
      512,
      [],
      'e09c',
      
      ['M0 32l32 0 64 0 0 64L64 96l0 352 384 0 0-352-32 0 0-64 64 0 32 0 0 32 0 416 0 32-32 0L32 512 0 512l0-32L0 64 0 32z','M256 2.7l22.6 22.6 96 96L397.3 144 352 189.3l-22.6-22.6L288 125.3 288 320l0 32-64 0 0-32 0-194.7-41.4 41.4L160 189.3 114.7 144l22.6-22.6 96-96L256 2.7z']
      
    ]
  };

  

  
  

  var faBinBottlesRecycle = {
    prefix: 'fasds',
    iconName: 'bin-bottles-recycle',
    icon: [
      640,
      512,
      [],
      'e5f6',
      
      ['M32 144l0 48 320 0 0-48-32.4-16.2L256 96 128 96 32 144zM112 32l0 32 16 0 128 0 16 0 0-32-16 0 0-32L128 0l0 32-16 0zM321.8 93.1l44.5 22.3 17.7 8.8 0 19.8 0 48 191.6 0 0-56 0-41.9-64-30 0-64.1-128 0 0 64.1-61.8 29z','M0 224l640 0 0 64-32 0L576 512 64 512 32 288 0 288l0-64zm295.4 64l-4.8 7.1-25.6 38.4 27.1 17L312.6 320l14.8 0 21.2 32.1 27.1-17-26.3-40-4.7-7.2-8.6 0-32 0-8.6 0zm70.7 90.9l17.1 25.9 0 11.2-45.5 0 0 32 61.5 0 16 0 0-16 0-32 0-4.8-2.6-4-19.3-29.3-27.1 17zM256 416l0-11.2 18.5-27.7-27.1-17-20.6 31-2.7 4 0 4.8 0 32 0 16 16 0 65.7 0 0-32L256 416z']
      
    ]
  };

  

  
  

  var faGripLinesVertical = {
    prefix: 'fasds',
    iconName: 'grip-lines-vertical',
    icon: [
      192,
      512,
      [],
      'f7a5',
      
      ['M128 32l64 0 0 448-64 0 0-448z','M0 32H64V480H0V32z']
      
    ]
  };

  

  
  

  var faMobileRetro = {
    prefix: 'fasds',
    iconName: 'mobile-retro',
    icon: [
      320,
      512,
      [],
      'e527',
      
      ['M0 0L320 0l0 512L0 512 0 0zM56 304l0 48 48 0 0-48-48 0zm0 80l0 48 48 0 0-48-48 0zm8-256l0 128 192 0 0-128L64 128zm48-80l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0zm24 256l0 48 48 0 0-48-48 0zm0 80l0 48 48 0 0-48-48 0zm80-80l0 48 48 0 0-48-48 0zm0 80l0 48 48 0 0-48-48 0z','M64 128H256V256H64V128z']
      
    ]
  };

  

  
  

  var faPersonRunning = {
    prefix: 'fasds',
    iconName: 'person-running',
    icon: [
      448,
      512,
      [127939,"running"],
      'f70c',
      
      ['M0 352l0 64 32 0 80 0 20.8 0 8.4-19 28.9-64.9c-1.9-1.2-3.8-2.4-5.7-3.6c-25.1-15.7-36.1-46.5-26.8-74.5c2.8-8.5 5.7-17 8.5-25.6L91.2 352 32 352 0 352z','M224 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM114.7 96L128 96l64 0 6.2 0 5.7 2.3 80 32 11.3 4.5 5.4 10.9L339.8 224l28.2 0 32 0 0 64-32 0-48 0-19.8 0-8.8-17.7-24.3-48.6L238 299 305 340.9l20.4 12.8-6.6 23.2-16 56-16 56L280.1 512l-66.6 0 11.7-40.8 16-56 9.4-32.8-86.2-53.9c-25.1-15.7-36.1-46.5-26.8-74.5l31.3-94-27.7 0-38.6 38.6L80 221.3 34.7 176l22.6-22.6 48-48 9.4-9.4z']
      
    ]
  };

  
    var faRunning = faPersonRunning;
  

  
  

  var faShuffle = {
    prefix: 'fasds',
    iconName: 'shuffle',
    icon: [
      512,
      512,
      [128256,"random"],
      'f074',
      
      ['M0 352l0 64 32 0 96 0 16 0 9.6-12.8L224 309.3c-13.3-17.8-26.7-35.6-40-53.3l-72 96-80 0L0 352zM224 202.7L264 256l72-96 48 0 0 64 32 0 96-96L416 32l-32 0 0 64-64 0-16 0-9.6 12.8L224 202.7z','M320 416l-16 0-9.6-12.8L112 160l-80 0L0 160 0 96l32 0 96 0 16 0 9.6 12.8L336 352l48 0 0-64 32 0 96 96-96 96-32 0 0-64-64 0z']
      
    ]
  };

  
    var faRandom = faShuffle;
  

  
  

  var faPeanuts = {
    prefix: 'fasds',
    iconName: 'peanuts',
    icon: [
      640,
      512,
      [129372],
      'e431',
      
      ['M128 364l0 115.6 0 32.4 148 0c40.5 0 77.1-16.2 103.8-42.5c.6-.6 1.1-1.1 1.7-1.7c13.8-14 24.2-30.1 31.3-47.2c4-9.5 6.9-19.6 8.8-30c4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8c17.3-7.2 33.5-17.7 47.6-31.7l.9-.9C623.6 225.4 640 188.6 640 148L640 0 492 0c-20.1 0-39.2 4-56.7 11.2c-17.4 7.2-33.7 17.8-47.8 32l-.4 .4C373 57.8 362.4 74 355.2 91.4c-4 9.5-6.9 19.6-8.8 30c-4.8 24.5-12.6 49.1-30.3 66.7c-7.2 7.2-15.6 12.8-24.7 17.2c-13.1 6.3-27.5 10.2-42 13.1c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364zm146.8 55.9a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zm64-64a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zm0 64a19.2 19.2 0 1 1 -37.6-7.8 19.2 19.2 0 1 1 37.6 7.8zM499.2 192a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm64-64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0zm0 64a19.2 19.2 0 1 1 -38.4 0 19.2 19.2 0 1 1 38.4 0z','M149.4 45.6L251.9 0l45.6 102.4c12.5 28.1 12.5 58.6 2.4 85.3l-.3 .9c-2.3 5.9-5 11.5-8.1 16.7c-13.1 6.3-27.5 10.2-42 13.1c-10.4 1.9-20.5 4.9-30 8.8c-17.5 7.2-33.9 17.9-48.1 32.1c-14.2 14.2-24.9 30.5-32.1 48C132 324.8 128 343.9 128 364l0 115.6L55.3 512 9.7 409.6C3.5 395.7 .4 381.2 0 366.9c-.4-14.3 2-28.9 7.4-43.1c5.5-14.2 13.5-26.7 23.4-37c5.4-5.7 11.4-10.8 18-15.3c15.4-10.9 30.1-23.9 36.8-41.5s4.6-37.1 .4-55.5c-1.9-7.8-2.9-15.7-3.1-23.5c-.4-14.2 2-28.7 7.3-42.9l.2-.4c5.4-14.1 13.4-26.5 23.3-36.9c9.8-10.4 21.9-19 35.7-25.2zM524.8 128a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm0 64a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-64 0a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zm-224 224a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1 -38.4 0zM320 396.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm0-64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4z']
      
    ]
  };

  

  
  

  var faTransporter1 = {
    prefix: 'fasds',
    iconName: 'transporter-1',
    icon: [
      512,
      512,
      [],
      'e043',
      
      ['M0 368l32 16 16 32 16-32 32-16L64 352 48 320 32 352 0 368zm160-48l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zm0 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zM416 176l32 16 16 32 16-32 32-16-32-16-16-32-16 32-32 16z','M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-18.4 80l15.4 0 102.2 0 15.4 0 9.6 12L409 236l20 25L379 301l-20-25-31-38.7 0 50.7-144 0 0-50.7L153 276l-20 25L83 261l20-25L180 140l9.6-12zM296 512l-80 0L96 512l0-64 320 0 0 64-120 0z']
      
    ]
  };

  

  
  

  var faArrowUpLeft = {
    prefix: 'fasds',
    iconName: 'arrow-up-left',
    icon: [
      384,
      512,
      [],
      'e09d',
      
      ['M96 160l45.3 0L342.6 361.4 365.3 384 320 429.3l-22.6-22.6L96 205.3 96 160z','M32 96l32 0 224 0 32 0 0 64-32 0L96 160l0 192 0 32-64 0 0-32 0-224 0-32z']
      
    ]
  };

  

  
  

  var faSquarePhoneHangup = {
    prefix: 'fasds',
    iconName: 'square-phone-hangup',
    icon: [
      448,
      512,
      ["phone-square-down"],
      'e27a',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 262.8l10.7-10.4C115.9 212.1 169.9 192 224 192s108.1 20.1 149.3 60.4L384 262.8 346.7 320 272 299.2l5.6-49.1c-34.9-10.5-72.3-10.5-107.2 0l5.6 49.1L101.3 320 64 262.8z','M384 262.8L346.7 320 272 299.2l5.6-49.1c-34.9-10.5-72.3-10.5-107.2 0l5.6 49.1L101.3 320 64 262.8l10.7-10.4c82.5-80.5 216.2-80.5 298.7 0L384 262.8z']
      
    ]
  };

  
    var faPhoneSquareDown = faSquarePhoneHangup;
  

  
  

  var faShieldSlash = {
    prefix: 'fasds',
    iconName: 'shield-slash',
    icon: [
      640,
      512,
      [],
      'e24b',
      
      ['M80.9 159.7c2.9 45.2 13.5 100.1 37 154.2c32.7 75.3 91 150 189.4 192.6L320 512l12.7-5.5c40.8-17.7 74.8-40.9 102.8-67.3L80.9 159.7zm45.3-84.5L496.8 363c9.8-16.1 18.2-32.6 25.3-49C550.5 248.7 560 182.1 560 133c0-7.1-.2-13.8-.6-20.1l-1.2-20.5L539.1 85 331.6 4.5 320 0 308.4 4.5 126.2 75.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faCircleU = {
    prefix: 'fasds',
    iconName: 'circle-u',
    icon: [
      512,
      512,
      [],
      'e127',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144 144l48 0 0 24 0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120 0-24 48 0 0 24 0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120 0-24z','M192 144l0 24 0 120c0 35.3 28.7 64 64 64s64-28.7 64-64l0-120 0-24 48 0 0 24 0 120c0 61.9-50.1 112-112 112s-112-50.1-112-112l0-120 0-24 48 0z']
      
    ]
  };

  

  
  

  var faGaugeSimpleMax = {
    prefix: 'fasds',
    iconName: 'gauge-simple-max',
    icon: [
      512,
      512,
      ["tachometer-fastest"],
      'f62b',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM192.3 345.5c-.1 1.1-.2 2.2-.2 3.2c-.1 1.1-.1 2.2-.1 3.3s0 2.2 .1 3.3c.1 1.1 .1 2.2 .2 3.2c.2 2.1 .5 4.3 1 6.4c.9 4.2 2.1 8.2 3.7 12c3.2 7.7 7.9 14.6 13.7 20.3C222.3 408.8 238.3 416 256 416c35.3 0 64-28.7 64-64c0-3.7-.3-7.3-.9-10.8c39.2-24.3 78.4-48.5 117.5-72.8c6.8-4.2 13.6-8.4 20.4-12.6c-8.4-13.6-16.8-27.2-25.3-40.8c-6.8 4.2-13.6 8.4-20.4 12.6c-39.2 24.3-78.4 48.5-117.5 72.8C283.2 292.6 270.1 288 256 288c-17.7 0-33.7 7.2-45.3 18.7c-5.8 5.8-10.5 12.7-13.7 20.3c-1.6 3.8-2.9 7.8-3.7 12c-.4 2.1-.8 4.2-1 6.4z','M411.4 227.6L431.8 215 457 255.8l-20.4 12.6L319.1 341.2c.6 3.5 .9 7.1 .9 10.8c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64c14.1 0 27.2 4.6 37.8 12.4l117.5-72.8z']
      
    ]
  };

  
    var faTachometerFastest = faGaugeSimpleMax;
  

  
  

  var faPlaneTail = {
    prefix: 'fasds',
    iconName: 'plane-tail',
    icon: [
      512,
      512,
      [],
      'e22c',
      
      ['M-8 0L61.5 308.8c62.7-17.3 125.4-34.6 188.1-51.9l3.1-.9 3.2 0 8.7 0L384 256 136 0-8 0z','M252.8 256l3.2 0 232 0 24 0 0 24 0 24 0 160 0 24 0 24-24 0-232 0-4.4 0-4.1-1.6-232-88L0 416.6 0 400l0-56 0-18.3 17.6-4.9 232-64 3.1-.9zM216 352l-24 0 0 48 24 0 144 0 24 0 0-48-24 0-144 0z']
      
    ]
  };

  

  
  

  var faShapes = {
    prefix: 'fasds',
    iconName: 'shapes',
    icon: [
      512,
      512,
      ["triangle-circle-square"],
      'f61f',
      
      ['M0 384a128 128 0 1 0 256 0A128 128 0 1 0 0 384zM160 224l256 0L288 0 160 224z','M288 272H512V496H288V272z']
      
    ]
  };

  
    var faTriangleCircleSquare = faShapes;
  

  
  

  var faChargingStation = {
    prefix: 'fasds',
    iconName: 'charging-station',
    icon: [
      576,
      512,
      [],
      'f5e7',
      
      ['M32 0L320 0l0 256 0 48 0 144L32 448 32 0zM80 224l88 0-24 96L272 192l-88 0 24-96L80 224z','M480 80l0-16-32 0 0 16 0 48-32 0 0 48c0 35.8 23.5 66.1 56 76.3L472 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-16 0 0 48 16 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-123.7c32.5-10.2 56-40.5 56-76.3l0-48-32 0 0-48 0-16-32 0 0 16 0 48-32 0 0-48zM0 448l0 64 352 0 0-64L0 448z']
      
    ]
  };

  

  
  

  var faMaximize = {
    prefix: 'fasds',
    iconName: 'maximize',
    icon: [
      512,
      512,
      ["expand-arrows-alt"],
      'f31e',
      
      ['M32 32l0 160 32 32 52-52 84 84 56-56-84-84 52-52L192 32 32 32zM256 312l84 84-52 52 32 32 160 0 0-160-32-32-52 52-84-84-56 56z','M480 192l-32 32-52-52L172 396l52 52-32 32L32 480l0-160 32-32 52 52L340 116 288 64l32-32 160 0 0 160z']
      
    ]
  };

  
    var faExpandArrowsAlt = faMaximize;
  

  
  

  var faLightbulbGear = {
    prefix: 'fasds',
    iconName: 'lightbulb-gear',
    icon: [
      576,
      512,
      [],
      'e5fd',
      
      ['M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l120.5 0-6.6-11.5L262 351.7l-36.1-20.8 76.9-133.3L340 219.1l0-44.6 28 0C367.1 77.9 288.7 0 192 0C94.8 0 16 78.8 16 176zm64 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80l-32 0zm32 240l0 96 160 0 0-59.7L251 416l-139 0z','M460.1 206.4l-88.1 0 0 42.2c-8 3.4-15.6 7.8-22.5 12.9l-34.9-20.2-44.9 77.8 34.9 20.2c-.4 4.1-.7 8.2-.7 12.4s.2 8.3 .7 12.4l-34.9 20.1 45 77.8 34.9-20.1c6.9 5.1 14.5 9.4 22.5 12.9l0 42.2 88.1 0 0-42.4c7.9-3.4 15.4-7.7 22.3-12.8l35 20.2 45-77.8L527.2 364c.4-4 .7-8.1 .7-12.3s-.2-8.2-.7-12.3l35.2-20.3-45-77.8-35 20.2c-6.9-5.1-14.3-9.4-22.3-12.8l0-42.4zM416 303.7a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faCactus = {
    prefix: 'fasds',
    iconName: 'cactus',
    icon: [
      512,
      512,
      [127797],
      'f8a7',
      
      ['M0 96l0 48L0 272l0 48 48 0 64 0 48 0 0-96-48 0-16 0 0-80 0-48L0 96zM352 352l0 96 48 0 64 0 48 0 0-48 0-128 0-48-96 0 0 48 0 80-16 0-48 0z','M160 96c0-53 43-96 96-96s96 43 96 96l0 416-192 0 0-416zm80 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faSignalBarsGood = {
    prefix: 'fasds',
    iconName: 'signal-bars-good',
    icon: [
      640,
      512,
      ["signal-alt-3"],
      'f693',
      
      ['M512 0l96 0 0 512-96 0L512 0z','M448 128l-96 0 0 384 96 0 0-384zM192 256l0 256 96 0 0-256-96 0zM32 384l0 128 96 0 0-128-96 0z']
      
    ]
  };

  
    var faSignalAlt3 = faSignalBarsGood;
  

  
  

  var faClockFourThirty = {
    prefix: 'fasds',
    iconName: 'clock-four-thirty',
    icon: [
      512,
      512,
      [],
      'e34b',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232-44.8L269.3 236l96 64 20 13.3-26.6 39.9-20-13.3L280 300.8l0 91.2 0 24-48 0 0-24 0-136 0-44.8z','M280 416l0-24 0-91.2L338.7 340l20 13.3 26.6-39.9-20-13.3-96-64L232 211.2l0 44.8 0 136 0 24 48 0z']
      
    ]
  };

  

  
  

  var faArrowPointer = {
    prefix: 'fasds',
    iconName: 'arrow-pointer',
    icon: [
      320,
      512,
      ["mouse-pointer"],
      'f245',
      
      ['M125.1 346.6c7.3-8.9 14.6-17.7 21.8-26.6l36.4 0 47.9 102.2 13.6 29-57.9 27.2-13.6-29L125.1 346.6z','M0 46.9L32 32 319.9 278l.1 42H146.9L29 463.8 0 432V46.9z']
      
    ]
  };

  
    var faMousePointer = faArrowPointer;
  

  
  

  var faClockSevenThirty = {
    prefix: 'fasds',
    iconName: 'clock-seven-thirty',
    icon: [
      512,
      512,
      [],
      'e351',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM158.7 358.7l13.3-20 64-96L280 256l0 136 0 24-48 0 0-24 0-56.7-20 30-13.3 20-39.9-26.6z','M232 416l0-24 0-56.7-20 30-13.3 20-39.9-26.6 13.3-20 64-96L280 256l0 136 0 24-48 0z']
      
    ]
  };

  

  
  

  var faVenusMars = {
    prefix: 'fasds',
    iconName: 'venus-mars',
    icon: [
      640,
      512,
      [9892],
      'f228',
      
      ['M256 176A80 80 0 1 1 96 176a80 80 0 1 1 160 0zm15.9 184.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l21.6-21.6L480 32 512 0 640 0l0 128-32 32-41.4-41.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z','M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1l0 34.9 32 0 32 0 0 64-32 0-32 0 0 32 0 32-64 0 0-32 0-32-32 0-32 0 0-64 32 0 32 0 0-34.9C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zm32 0c0-4.8-.2-9.6-.5-14.3c5.3-1.1 10.8-1.7 16.5-1.7c44.2 0 80 35.8 80 80s-35.8 80-80 80c-21.5 0-41-8.5-55.3-22.2C369.4 263.5 384 221.5 384 176z']
      
    ]
  };

  

  
  

  var faBox = {
    prefix: 'fasds',
    iconName: 'box',
    icon: [
      448,
      512,
      [128230],
      'f466',
      
      ['M0 160l208 0 0-128L64 32 0 160zM240 32l0 128 208 0L384 32 240 32z','M240 160l208 0 0 320L0 480 0 160l208 0 0-128 32 0 0 128z']
      
    ]
  };

  

  
  

  var faPageCaretDown = {
    prefix: 'fasds',
    iconName: 'page-caret-down',
    icon: [
      384,
      512,
      ["file-caret-down"],
      'e429',
      
      ['M0 0L0 512l384 0 0-400L272 0 0 0zM96 224l192 0 0 32-96 96L96 256l0-32z','M96 256V224H288v32l-96 96L96 256z']
      
    ]
  };

  
    var faFileCaretDown = faPageCaretDown;
  

  
  

  var faCross = {
    prefix: 'fasds',
    iconName: 'cross',
    icon: [
      384,
      512,
      [10013,128327],
      'f654',
      
      ['M0 128L0 256l96 0 32 0 128 0 32 0 96 0 0-128-128 0L256 0 128 0l0 128L0 128zM128 288l0 224 128 0 0-224-128 0z','M128 256h128v32H128v-32z']
      
    ]
  };

  

  
  

  var faRepeat = {
    prefix: 'fasds',
    iconName: 'repeat',
    icon: [
      512,
      512,
      [128257],
      'f363',
      
      ['M64 416l96 96 32 0 0-64 288 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96-256 0 0-64-32 0L64 416z','M0 96L0 224l0 32 64 0 0-32 0-96 256 0 0 64 32 0 96-96L352 0 320 0l0 64L32 64 0 64 0 96z']
      
    ]
  };

  

  
  

  var faDialMin = {
    prefix: 'fasds',
    iconName: 'dial-min',
    icon: [
      576,
      512,
      [],
      'e161',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M192.8 416.7c62.6 46.2 151.3 41 208-15.7c62.5-62.5 62.5-163.8 0-226.3s-163.8-62.5-226.3 0c-56.7 56.7-62 145.4-15.7 208L270.7 270.9l17-17 33.9 33.9-17 17L192.8 416.7z']
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fasds',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      ['M288.1 0l86.5 164 182.7 31.6L428 328.5 454.4 512 288.1 430.2 121.7 512l26.4-183.5L18.9 195.6 201.5 164 288.1 0z','']
      
    ]
  };

  

  
  

  var faDiamondExclamation = {
    prefix: 'fasds',
    iconName: 'diamond-exclamation',
    icon: [
      512,
      512,
      [],
      'e405',
      
      ['M0 256L256 512 512 256 256 0 0 256zM232 128l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faSignalBars = {
    prefix: 'fasds',
    iconName: 'signal-bars',
    icon: [
      640,
      512,
      ["signal-alt","signal-alt-4","signal-bars-strong"],
      'f690',
      
      ['','M608 0L512 0l0 512 96 0L608 0zM352 128l0 384 96 0 0-384-96 0zM288 256l-96 0 0 256 96 0 0-256zM128 384l-96 0 0 128 96 0 0-128z']
      
    ]
  };

  
    var faSignalAlt = faSignalBars;
  
    var faSignalAlt4 = faSignalBars;
  
    var faSignalBarsStrong = faSignalBars;
  

  
  

  var faSprayCanSparkles = {
    prefix: 'fasds',
    iconName: 'spray-can-sparkles',
    icon: [
      512,
      512,
      ["air-freshener"],
      'f5d0',
      
      ['M80 336a80 80 0 1 0 160 0A80 80 0 1 0 80 336zM288 48l32 16 16 32 16-32 32-16L352 32 336 0 320 32 288 48zm64 96l32 16 16 32 16-32 32-16-32-16L400 96l-16 32-32 16zm64-96l32 16 16 32 16-32 32-16L480 32 464 0 448 32 416 48zm0 192l32 16 16 32 16-32 32-16-32-16-16-32-16 32-32 16z','M224 0l0 128L96 128 96 0 224 0zM0 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 256L0 512 0 256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0z']
      
    ]
  };

  
    var faAirFreshener = faSprayCanSparkles;
  

  
  

  var faCommentText = {
    prefix: 'fasds',
    iconName: 'comment-text',
    icon: [
      512,
      512,
      [],
      'e14d',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm160-80l24 0 72 0 72 0 24 0 0 48-24 0-48 0 0 104 0 24-48 0 0-24 0-104-48 0-24 0 0-48z','M160 160l24 0 72 0 72 0 24 0 0 48-24 0-48 0 0 104 0 24-48 0 0-24 0-104-48 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faSunDust = {
    prefix: 'fasds',
    iconName: 'sun-dust',
    icon: [
      512,
      512,
      [],
      'f764',
      
      ['M0 150L73.1 256 0 362l126.7 23.3c12.9-12.9 25.9-25.9 38.8-38.8C142.3 323.3 128 291.3 128 256c0-70.7 57.3-128 128-128c35.3 0 67.4 14.3 90.5 37.5l38.8-38.8C377.6 84.5 369.8 42.2 362 0L256 73.1 150 0 126.7 126.7 0 150zM160 256c0 26.5 10.7 50.5 28.1 67.9L323.9 188.1C306.5 170.7 282.5 160 256 160c-53 0-96 43-96 96z','M480 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm112 48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM272 400a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-80 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM400 432a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z']
      
    ]
  };

  

  
  

  var faCameraRotate = {
    prefix: 'fasds',
    iconName: 'camera-rotate',
    icon: [
      640,
      512,
      [],
      'e0d8',
      
      ['M64 96l0 384 512 0 0-384L437.3 96 416 32 224 32 202.7 96 64 96zM192 304l88 0 16 16-27 27c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327 425 361l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-27 27-16-16 0-88zm23-89l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l27-27 16 16 0 88-88 0-16-16 27-27c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249 215 215z','M448 184l0 88-88 0-16-16 27-27c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249 215 215l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l27-27 16 16zM192 392l0-88 88 0 16 16-27 27c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327 425 361l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-27 27-16-16z']
      
    ]
  };

  

  
  

  var faUniformMartialArts = {
    prefix: 'fasds',
    iconName: 'uniform-martial-arts',
    icon: [
      640,
      512,
      [],
      'e3d1',
      
      ['M0 195.7L0 208 0 368l0 48 96 0 0-48 0-147.7 48-87.3L144 288l109 0 54.6-143.3L237.7 0 180 0 144 0l-8 0L107.6 0 93.9 24.9l-88 160L0 195.7zM144 384l0 128 352 0 0-128-86.3 0 9 13.5 26.6 39.9-79.9 53.3-26.6-39.9L320 422.5l-18.8 28.2-26.6 39.9-79.9-53.3 26.6-39.9 9-13.5L144 384zm143.2-96L496 288l0-154.9 48 87.3L544 368l0 48 96 0 0-48 0-160 0-12.3-5.9-10.8-88-160L532.4 0 504 0l-8 0L460 0 396.9 0l-57 149.7L287.2 288z','M496 288l-352 0 0 64 146.1 0L248 415.2l-8.9 13.3 26.6 17.8 8.9-13.3L320 364.8 365.4 433l8.9 13.3 26.6-17.8L392 415.2 349.9 352 496 352l0-64z']
      
    ]
  };

  

  
  

  var faFaceWeary = {
    prefix: 'fasds',
    iconName: 'face-weary',
    icon: [
      512,
      512,
      [],
      'e3a1',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm93.6-45.2l15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c3.8-3.8 7.5-7.5 11.3-11.3L222.6 176c-3.8 3.8-7.5 7.5-11.3 11.3c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4c-5.3 .9-10.5 1.8-15.8 2.6c-1.8-10.5-3.5-21-5.3-31.6zM128 416c0-70.7 57.3-128 128-128s128 57.3 128 128c0 4.2-.2 8.3-.6 12.3C349.5 400.8 304.9 384 256 384s-93.5 16.8-127.4 44.3c-.4-4.1-.6-8.2-.6-12.3zM289.4 176L312 153.4c3.8 3.8 7.5 7.5 11.3 11.3c2.5 2.5 4.9 4.9 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7c.8 .1 1.7 .3 2.5 .4c5.3 .9 10.5 1.8 15.8 2.6c-1.8 10.5-3.5 21-5.3 31.6c-5.3-.9-10.5-1.8-15.8-2.6c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-3.8-3.8-7.5-7.5-11.3-11.3z','M211.3 187.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 153.4 222.6 176l-11.3 11.3zm89.4 0L289.4 176 312 153.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z']
      
    ]
  };

  

  
  

  var faEggFried = {
    prefix: 'fasds',
    iconName: 'egg-fried',
    icon: [
      512,
      512,
      [],
      'f7fc',
      
      ['M0 351.8c0 55.3 28.7 109.1 80 138.7c76.5 44.2 174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c33.9-25.1 51.8-63.8 51.8-102.9c0-26.5-8.2-53.2-25.2-76.1c-18.2-24.6-43.5-40.7-71-47.8c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C6.9 297.2 0 324.7 0 351.8zM336 240a112 112 0 1 1 -224 0 112 112 0 1 1 224 0z','M224 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 240l-32 0c0-44.2 35.8-80 80-80l0 32c-26.5 0-48 21.5-48 48z']
      
    ]
  };

  

  
  

  var faCircleBookmark = {
    prefix: 'fasds',
    iconName: 'circle-bookmark',
    icon: [
      512,
      512,
      ["bookmark-circle"],
      'e100',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l192 0 0 256-96-64-96 64 0-256z','M256 320l-96 64V128H352V384l-96-64z']
      
    ]
  };

  
    var faBookmarkCircle = faCircleBookmark;
  

  
  

  var faBellExclamation = {
    prefix: 'fasds',
    iconName: 'bell-exclamation',
    icon: [
      448,
      512,
      [],
      'f848',
      
      ['M0 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L256 0 192 0l0 51.2C119 66 64 130.6 64 208l0 88L0 368zM200 112l48 0 0 24 0 96 0 24-48 0 0-24 0-96 0-24zm0 184l48 0 0 48-48 0 0-48z','M248 112l0 24 0 96 0 24-48 0 0-24 0-96 0-24 48 0zm40 336c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0 64 0zM248 296l0 48-48 0 0-48 48 0z']
      
    ]
  };

  

  
  

  var faBan = {
    prefix: 'fasds',
    iconName: 'ban',
    icon: [
      512,
      512,
      [128683,"cancel"],
      'f05e',
      
      ['M99.5 144.8c12.5-17.5 27.8-32.8 45.3-45.3L412.5 367.2c-12.5 17.5-27.8 32.8-45.3 45.3L99.5 144.8z','M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z']
      
    ]
  };

  
    var faCancel = faBan;
  

  
  

  var faScalpel = {
    prefix: 'fasds',
    iconName: 'scalpel',
    icon: [
      512,
      512,
      [],
      'f61d',
      
      ['M0 512L176 320l112 0C288 496 0 512 0 512z','M495.1 115.7L320 320H128L396.2 22C408.8 8 426.8 0 445.6 0C482.3 0 512 29.7 512 66.4v3.7c0 16.7-6 32.9-16.9 45.6z']
      
    ]
  };

  

  
  

  var faPersonCircleMinus = {
    prefix: 'fasds',
    iconName: 'person-circle-minus',
    icon: [
      576,
      512,
      [],
      'e540',
      
      ['M.2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 2.3-1.4c8.4-21.4 20.8-40.7 36.3-57L238 142.8 228.6 128l-17.5 0-102.2 0-17.5 0L82 142.8 .2 270.8zM112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faCircleThreeQuartersStroke = {
    prefix: 'fasds',
    iconName: 'circle-three-quarters-stroke',
    icon: [
      512,
      512,
      [],
      'e5d4',
      
      ['M256 0C397.4 0 512 114.6 512 256l-64 0c0-106-86-192-192-192l0-64z','M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256H256V0z']
      
    ]
  };

  

  
  

  var faHouseFlag = {
    prefix: 'fasds',
    iconName: 'house-flag',
    icon: [
      640,
      512,
      [],
      'e50d',
      
      ['M0 240l0 47.6 64.1 0 0 224.4L192 512l0-160 128 0 0 160 96 0 0-346.8L256.4 32 0 240z','M512 32l0-32L448 0l0 32 0 160 0 320 64 0 0-320 128 0 0-160L512 32z']
      
    ]
  };

  

  
  

  var faChartArea = {
    prefix: 'fasds',
    iconName: 'chart-area',
    icon: [
      512,
      512,
      ["area-chart"],
      'f1fe',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M480 352H128V224L240 96l80 96 64-64 96 112V352z']
      
    ]
  };

  
    var faAreaChart = faChartArea;
  

  
  

  var faMoneyBillWave = {
    prefix: 'fasds',
    iconName: 'money-bill-wave',
    icon: [
      576,
      512,
      [],
      'f53a',
      
      ['M64 208c15.7 0 30.1-5.6 41.2-15s19-22.5 21.8-37.4c31-.4 61.2-4.3 90-9.6c13.9-2.6 27.5-5.6 40.7-8.7s26-6.3 38.3-9.4c1.3-.3 2.5-.6 3.8-.9c1.2-.3 2.5-.6 3.7-.9c3.5-.9 7-1.8 10.5-2.6c38.2-9.4 72.3-17.3 104-21c5-.6 10-1.1 14.9-1.4c5.1-.4 10.1-.6 15.2-.8c2.2 33.3 30 59.7 63.9 59.7l0 144c-15.7 0-30.1 5.6-41.2 15s-19 22.5-21.8 37.4c-31 .4-61.2 4.3-89.9 9.6c-13.9 2.6-27.5 5.6-40.7 8.7s-26 6.3-38.3 9.4c-1.3 .3-2.6 .6-3.8 .9c-1.2 .3-2.5 .6-3.7 .9c-3.5 .9-7 1.8-10.5 2.6c-37.9 9.4-71.9 17.2-103.4 20.9c-10.5 1.3-20.7 2-30.7 2.3C125.6 378.3 97.9 352 64 352c0-48 0-96 0-144zm144 48c0 53 35.8 96 80 96s80-43 80-96s-35.8-96-80-96s-80 43-80 96z','M0 60.3L0 451.7c96 48.9 192 24.5 288 0s192-48.9 288 0l0-391.5c-96-48.9-192-24.5-288 0s-192 48.9-288 0zM512 160l0 144c-31.4 0-57.5 22.6-63 52.4c-62.5 .8-121.8 15.7-172.9 28.6c0 0 0 0 0 0c-4.8 1.2-9.5 2.4-14.2 3.6c-50.7 12.6-94.1 22.2-134.2 23.2C125.6 378.3 97.9 352 64 352l0-144c31.4 0 57.5-22.6 63-52.4c62.5-.8 121.8-15.7 172.9-28.6c0 0 0 0 0 0c4.8-1.2 9.5-2.4 14.2-3.6c50.7-12.6 94.1-22.2 134.2-23.2c2.2 33.3 30 59.7 63.9 59.7z']
      
    ]
  };

  

  
  

  var faPizzaSlice = {
    prefix: 'fasds',
    iconName: 'pizza-slice',
    icon: [
      512,
      512,
      [],
      'f818',
      
      ['M0 512L432 404c0-1.3 0-2.7 0-4C432 223.3 288.7 80 112 80c-1.3 0-2.7 0-4 0C72 224 36 368 0 512zM160 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M128 0L108 80c1.3 0 2.7 0 4 0c176.7 0 320 143.3 320 320c0 1.3 0 2.7 0 4l80-20C512 171.9 340.1 0 128 0zm80 240a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faTruckBolt = {
    prefix: 'fasds',
    iconName: 'truck-bolt',
    icon: [
      640,
      512,
      [],
      'e3d0',
      
      ['M96 192L224 64l-24 96 88 0L160 288l24-96-88 0zM256 432A80 80 0 1 1 96 432a80 80 0 1 1 160 0zm288 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M0 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 64 32 0 0 64-32 0-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L0 416 0 0zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM96 192l88 0-24 96L288 160l-88 0 24-96L96 192z']
      
    ]
  };

  

  
  

  var faSignPosts = {
    prefix: 'fasds',
    iconName: 'sign-posts',
    icon: [
      576,
      512,
      [],
      'e625',
      
      ['M64 0l64 0 0 32L64 32 64 0zm0 416l64 0 0 96-64 0 0-96zM448 0l64 0 0 32c-21.3 0-42.7 0-64 0l0-32zm0 416c21.3 0 42.7 0 64 0l0 96-64 0 0-96z','M0 32H576V416H0V32z']
      
    ]
  };

  

  
  

  var faMailbox = {
    prefix: 'fasds',
    iconName: 'mailbox',
    icon: [
      576,
      512,
      [128234],
      'f813',
      
      ['M144 64c79.5 0 144 64.5 144 144l0 240 288 0 0-240c0-79.5-64.5-144-144-144L144 64zM384 192l16 0 64 0 32 0 16 0 0 16 0 64 0 16-16 0-32 0-16 0 0-16 0-48-48 0-16 0 0-32z','M0 208C0 128.5 64.5 64 144 64s144 64.5 144 144l0 240L0 448 0 208zm64-16l0 32 16 0 128 0 16 0 0-32-16 0L80 192l-16 0zm336 0l64 0 32 0 16 0 0 16 0 64 0 16-16 0-32 0-16 0 0-16 0-48-48 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faChartLineUp = {
    prefix: 'fasds',
    iconName: 'chart-line-up',
    icon: [
      512,
      512,
      [],
      'e0e5',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M480 128l-128 0-32 32 41.4 41.4L304 258.7l-73.4-73.4L208 162.7l-22.6 22.6-80 80 45.3 45.3L208 253.3l73.4 73.4L304 349.3l22.6-22.6 80-80L448 288l32-32 0-128z']
      
    ]
  };

  

  
  

  var faBuildingLock = {
    prefix: 'fasds',
    iconName: 'building-lock',
    icon: [
      576,
      512,
      [],
      'e4d6',
      
      ['M0 0L384 0l0 193.6c-19.8 20.2-32 47.9-32 78.4l0 16-32 0 0 224-80 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M432 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faRectangleHistoryCircleUser = {
    prefix: 'fasds',
    iconName: 'rectangle-history-circle-user',
    icon: [
      640,
      512,
      [],
      'e4a4',
      
      ['M0 160L0 512l394.8 0C349.5 480.1 320 427.5 320 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7l0-32.7L0 160zM48 80l0 48 416 0 0-48L48 80zM96 0l0 48 320 0 0-48L96 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-31.7 0-60.3-13.2-80.7-34.3L440 416l112 0 24.7 29.7c-20.4 21.2-49 34.3-80.7 34.3zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faPersonDressFairy = {
    prefix: 'fasds',
    iconName: 'person-dress-fairy',
    icon: [
      640,
      512,
      [],
      'e607',
      
      ['M0 32L0 64l0 48c0 86.7 40.6 163.9 103.7 213.7C78.7 360 64 402.3 64 448l0 32 32 0 16 0c55.9 0 106.6-22 144-57.9l0-38.1-64 0 64-224 16.8 0c-51-77.1-138.6-128-238-128L32 32 0 32zM367.2 160l16.8 0 64 224-64 0 0 38.1C421.4 458 472.1 480 528 480l16 0 32 0 0-32c0-45.7-14.7-88-39.7-122.3C599.4 275.9 640 198.7 640 112l0-48 0-32-32 0-2.9 0c-99.4 0-186.9 50.9-238 128z','M256 64a64 64 0 1 1 128 0A64 64 0 1 1 256 64zm128 96l64 224-64 0 0 128-128 0 0-128-64 0 64-224 128 0z']
      
    ]
  };

  

  
  

  var faTabletButton = {
    prefix: 'fasds',
    iconName: 'tablet-button',
    icon: [
      448,
      512,
      [],
      'f10a',
      
      ['M0 384l448 0 0 128L0 512 0 384zm192 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M0 0H448V384H0V0z']
      
    ]
  };

  

  
  

  var faC = {
    prefix: 'fasds',
    iconName: 'c',
    icon: [
      384,
      512,
      [99],
      '43',
      
      ['M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0l45.3 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0l-45.3 45.3z','']
      
    ]
  };

  

  
  

  var faLocationArrow = {
    prefix: 'fasds',
    iconName: 'location-arrow',
    icon: [
      448,
      512,
      [],
      'f124',
      
      ['M0 256H224V480h48L432 48 0 208v48z','']
      
    ]
  };

  

  
  

  var faMessagePlus = {
    prefix: 'fasds',
    iconName: 'message-plus',
    icon: [
      512,
      512,
      ["comment-alt-plus"],
      'f4a8',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM144 184l0 48 24 0 64 0 0 64 0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0z','M232 296l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  
    var faCommentAltPlus = faMessagePlus;
  

  
  

  var faFaceSmileTear = {
    prefix: 'fasds',
    iconName: 'face-smile-tear',
    icon: [
      512,
      512,
      [],
      'e393',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm129.4 78.4l24.2-21 10.5 12.1C182 346.2 212.6 368 256 368l16 0 0 32-16 0c-55.1 0-93.8-27.9-116.1-53.5l-10.5-12.1zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM304 368c0-10.4 3.4-20.5 9.6-28.8L352 288l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48zm64.4-160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM313.6 339.2L352 288l38.4 51.2c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-10.4 3.4-20.5 9.6-28.8zM336.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faRoadBridge = {
    prefix: 'fasds',
    iconName: 'road-bridge',
    icon: [
      640,
      512,
      [],
      'e563',
      
      ['M0 96l0 64 32 0 40 0 0 64L0 224l0 96c53 0 96 43 96 96l0 96 96 0 0-96c0-53 43-96 96-96l0-96-40 0 0-64 40 0 0-64L32 96 0 96zm120 64l80 0 0 64-80 0 0-64z','M640 0L320 0l0 512 320 0L640 0zM504 224l0 64 0 24-48 0 0-24 0-64 0-24 48 0 0 24zm0 136l0 24 0 64 0 24-48 0 0-24 0-64 0-24 48 0zm0-296l0 64 0 24-48 0 0-24 0-64 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faCalendarPen = {
    prefix: 'fasds',
    iconName: 'calendar-pen',
    icon: [
      448,
      512,
      ["calendar-edit"],
      'f333',
      
      ['M0 192l448 0 0 320L0 512 0 192zM128 448l64-8 88.7-88.7-56-56L136 384l-8 64zM247.3 272.7l56 56L336 296l-56-56-32.7 32.7z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zM280.7 351.3l-56-56L136 384l-8 64 64-8 88.7-88.7zm22.6-22.6L336 296l-56-56-32.7 32.7 56 56z']
      
    ]
  };

  
    var faCalendarEdit = faCalendarPen;
  

  
  

  var faFolderImage = {
    prefix: 'fasds',
    iconName: 'folder-image',
    icon: [
      512,
      512,
      [],
      'e18a',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM96 376.5l6.1-6.8 64-72L184 277.5l17.9 20.2L219.1 317l57.3-81.2L296 208l19.6 27.8 96 136L416 378l0 7.6 0 8 0 24-24 0-120 0-24 0-48 0-24 0-56 0-24 0 0-24 0-8 0-9.1zM176 224a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M296 208l19.6 27.8 96 136L416 378l0 7.6 0 8 0 24-24 0-120 0-24 0-48 0-24 0-56 0-24 0 0-24 0-8 0-9.1 6.1-6.8 64-72L184 277.5l17.9 20.2L219.1 317l57.3-81.2L296 208z']
      
    ]
  };

  

  
  

  var faPersonHalfDress = {
    prefix: 'fasds',
    iconName: 'person-half-dress',
    icon: [
      320,
      512,
      [],
      'e548',
      
      ['M160 0c26.5 0 48 21.5 48 48s-21.5 48-48 48c0-32 0-64 0-96zm0 128l51.1 0 17.5 0 9.4 14.8 81.7 128-53.9 34.4-33.8-53L232 480l0 32-64 0 0-32 0-128-8 0 0-224z','M88 512l64 0 0-32 0-96 8 0 0-256-51.1 0-17.5 0-9.4 14.8L.2 270.8l53.9 34.4 42-65.8L48 384l40 0 0 96 0 32zM160 0s0 0 0 0c-26.5 0-48 21.5-48 48s21.5 48 48 48c0 0 0 0 0 0l0-96z']
      
    ]
  };

  

  
  

  var faFileChartColumn = {
    prefix: 'fasds',
    iconName: 'file-chart-column',
    icon: [
      384,
      512,
      ["file-chart-line"],
      'f659',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM80 352l0 24 0 48 0 24 48 0 0-24 0-48 0-24-48 0zm88-128l0 24 0 176 0 24 48 0 0-24 0-176 0-24-48 0zm88 64l0 24 0 112 0 24 48 0 0-24 0-112 0-24-48 0z','M384 160L224 0l0 160 160 0zM216 248l0-24-48 0 0 24 0 176 0 24 48 0 0-24 0-176zm88 64l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zM128 376l0-24-48 0 0 24 0 48 0 24 48 0 0-24 0-48z']
      
    ]
  };

  
    var faFileChartLine = faFileChartColumn;
  

  
  

  var faSynagogue = {
    prefix: 'fasds',
    iconName: 'synagogue',
    icon: [
      640,
      512,
      [128333],
      'f69b',
      
      ['M0 272L0 512l160 0 0-240L80 192 0 272zm480 0l0 240 160 0 0-240-80-80-80 80z','M160 128L320 0 480 128l0 384-128 0 0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96-128 0 0-384zm160-9.9l-21.3 36.9-42.7 0L277.4 192 256 228.9l42.7 0L320 265.9l21.3-36.9 42.6 0L362.7 192 384 155.1l-42.6 0L320 118.1z']
      
    ]
  };

  

  
  

  var faGlobe = {
    prefix: 'fasds',
    iconName: 'globe',
    icon: [
      512,
      512,
      [127760],
      'f0ac',
      
      ['M0 256c0 22.1 2.8 43.5 8.1 64l125.6 0c-.5-2.7-.9-5.1-1.3-7.6c-.4-2.7-.8-5.3-1.1-7.9c-.7-5.3-1.3-10.6-1.8-15.9c-.2-2.8-.5-5.4-.6-8.1c-.2-2.7-.3-5.4-.5-8c-.1-2.9-.2-5.6-.3-8.3c-.1-2.7-.1-5.4-.1-8.2c0-2.9 0-5.6 .1-8.2c.1-2.8 .2-5.4 .3-8.1c.3-5.5 .6-10.9 1.1-16.3c1-10.7 2.4-21.1 4.2-31.4L8.1 192C2.8 212.5 0 233.9 0 256zm18.6-96l122 0c17-65.6 48.3-120 74-156.7C125.4 17.8 51.6 78.5 18.6 160zm0 192c33 81.5 106.7 142.2 196 156.7c-25.7-36.7-57-91-74-156.7l-122 0zM160.4 239.5c-.1 2.7-.2 5.4-.3 8c-.1 2.8-.1 5.5-.1 8.4c0 3 0 5.7 .1 8.3s.2 5.4 .3 8.1c.3 5.5 .7 10.9 1.2 16.3c1.1 10.7 2.6 21.1 4.5 31.4c59.9 0 119.8 0 179.7 0c3.9-20.5 6.1-41.9 6.1-64s-2.2-43.5-6.1-64l-179.7 0c-2 10.2-3.5 20.7-4.5 31.4c-.5 5.4-.9 10.7-1.2 16.2zM173.7 160l164.6 0c-11.4-40.2-28.4-75.9-45.8-105.4c-13-21.9-25.9-40-36.5-53.5c-10.5 13.5-23.5 31.6-36.5 53.5c-17.4 29.4-34.5 65.1-45.8 105.4zm0 192c11.4 40.2 28.4 75.9 45.8 105.4c13 21.9 25.9 40 36.5 53.5c10.5-13.5 23.5-31.6 36.5-53.5c17.4-29.4 34.5-65.1 45.8-105.4l-164.6 0zM297.4 3.3c25.7 36.7 57 91 74 156.7l122 0c-33-81.5-106.7-142.2-196-156.7zm0 505.3c89.2-14.5 163-75.2 196-156.7l-122 0c-17 65.6-48.3 120-74 156.7zm81-316.7c3.6 20.5 5.6 41.9 5.6 64s-2 43.5-5.6 64l125.6 0c5.3-20.5 8.1-41.9 8.1-64s-2.8-43.5-8.1-64l-125.6 0z','M338.3 352l-164.6 0c11.4 40.2 28.4 75.9 45.8 105.4c13 21.9 25.9 40 36.5 53.5c10.5-13.5 23.5-31.6 36.5-53.5c17.4-29.4 34.5-65.1 45.8-105.4zm165.7-32c-2.8 11-6.4 21.7-10.5 32l-122 0c-17 65.6-48.3 120-74 156.7c-13.5 2.2-27.3 3.3-41.4 3.3s-27.9-1.1-41.4-3.3c-25.7-36.7-57-91-74-156.7l-122 0c-4.2-10.3-7.7-21-10.5-32l125.6 0c-3.6-20.5-5.6-41.9-5.6-64s2-43.5 5.6-64L8.1 192c2.8-11 6.4-21.7 10.5-32l122 0c17-65.6 48.3-120 74-156.7C228.1 1.1 241.9 0 256 0s27.9 1.1 41.4 3.3c25.7 36.7 57 91 74 156.7l122 0c4.2 10.3 7.7 21 10.5 32l-125.6 0c3.6 20.5 5.6 41.9 5.6 64s-2 43.5-5.6 64l125.6 0zM292.5 54.6c-13-21.9-25.9-40-36.5-53.5c-10.5 13.5-23.5 31.6-36.5 53.5c-17.4 29.4-34.5 65.1-45.8 105.4l164.6 0c-11.4-40.2-28.4-75.9-45.8-105.4zM352 256c0-22.1-2.2-43.5-6.1-64l-179.7 0c-3.9 20.5-6.1 41.9-6.1 64s2.2 43.5 6.1 64l179.7 0c3.9-20.5 6.1-41.9 6.1-64z']
      
    ]
  };

  

  
  

  var faPersonDolly = {
    prefix: 'fasds',
    iconName: 'person-dolly',
    icon: [
      512,
      512,
      [],
      'f4d0',
      
      ['M194.9 174.5l5.8 23.3c2.2 8.7 4.4 17.5 6.5 26.2c5.3 21.3 10.7 42.7 16 64l27.1 108.3c-16 11.6-26.3 30.5-26.3 51.7c0 35.3 28.7 64 64 64c32.3 0 59.1-24 63.4-55.1l134.4-33.6 23.3-5.8-11.6-46.6-23.3 5.8L339.7 410.3c-10-13.7-25.3-23.3-42.9-25.7L247.3 186.2l-5.8-23.3-46.6 11.6zM304 448a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM288 230.4L326.4 384 480 345.6 441.6 192 288 230.4z','M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM0 480l0 32 64 0 0-32s0 0 0 0l0-69.5-64-64L0 480zM32 128L0 128l0 32L0 274.7c0 17 6.7 33.3 18.7 45.3l22.6 22.6 56.7 56.7 6.3 37.9 4 24 4 24s0 0 0 0l4 24 .5 2.7 64.9 0-2.2-13.3-4-24s0 0 0 0l-4-24-4-24-8-48-1.7-10.1-7.3-7.3L96 306.7l0-65.1 21.4 32.1 9.5 14.3 17.1 0 79.3 0-16-64-46.1 0-54.5-81.7L97.1 128 80 128l-48 0z']
      
    ]
  };

  

  
  

  var faLocationCrosshairsSlash = {
    prefix: 'fasds',
    iconName: 'location-crosshairs-slash',
    icon: [
      640,
      512,
      ["location-slash"],
      'f603',
      
      ['M64 224l0 64 32 0 34.7 0c13.5 80.4 76.9 143.9 157.3 157.3l0 34.7 0 32 64 0 0-32 0-34.7c22.6-3.8 43.8-11.5 62.9-22.4l-56.8-44.7C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128c0-2.9 .1-5.7 .3-8.5l-56.8-44.7c-2 6.9-3.6 14-4.8 21.3L96 224l-32 0zM184.2 120.3c17.1 13.2 34.1 26.5 51.2 39.7c22.6-19.9 52.2-32 84.6-32c70.7 0 128 57.3 128 128c0 21-5 40.7-14 58.2l51.2 39.7C497 334 505.4 311.7 509.3 288l34.7 0 32 0 0-64-32 0-34.7 0C495.9 143.6 432.4 80.1 352 66.7L352 32l0-32L288 0l0 32 0 34.7c-40.2 6.7-76.2 26-103.8 53.6zm90.2 70c40.2 31.2 80.4 62.4 120.6 93.6c3.2-8.7 5-18.1 5-27.9c0-44.2-35.8-80-80-80c-16.9 0-32.7 5.3-45.6 14.3z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faLocationSlash = faLocationCrosshairsSlash;
  

  
  

  var faSteak = {
    prefix: 'fasds',
    iconName: 'steak',
    icon: [
      576,
      512,
      [129385],
      'f824',
      
      ['M0 360L0 512l240 0c81.7 0 162.1-30.8 222.6-75.8C520.9 392.8 576 323.9 576 240c0-60.4-23.6-117.6-57.5-160C485.7 39 433 0 368 0c-38.3 0-72.3 12.4-99.2 37.4c-23.5 21.9-36.3 48.9-44.1 66.5c-4.4 10.1-8 18.9-11.2 26.6c-10.4 25.1-16.2 39.1-30 52.9c-23.1 23.1-50.4 36.9-77.7 50.7c-21.8 11-43.6 22.1-63.3 37.8C17.8 291.7 0 321.4 0 360zm64 0c0-17.9 6.4-31.2 18.2-41.3c10.2-8.6 24.2-14.5 37.7-20.3l1.8-.8c28.4-12 65.6-27.7 107-69c23.6-23.6 35-51.4 46.4-79.3c2.7-6.6 5.4-13.3 8.3-19.8c7.1-16.3 15.7-32.9 29-45.3c14-13 32-20.3 55.6-20.3c38.6 0 74.7 23.8 100.5 56c26 32.5 43.5 75.9 43.5 120c0 55.2-37.2 107.4-87.6 144.8C373.6 422.6 306.3 448 240 448L64 448l0-88z','M312.4 84.3c14-13 32-20.3 55.6-20.3c38.6 0 74.7 23.8 100.5 56c26 32.5 43.5 75.9 43.5 120c0 55.2-37.2 107.4-87.6 144.8C373.6 422.6 306.3 448 240 448L64 448l0-88c0-17.9 6.4-31.2 18.2-41.3c10.2-8.6 24.2-14.5 37.7-20.3l1.8-.8s0 0 0 0c28.4-12 65.6-27.7 107-69c23.6-23.6 35-51.4 46.4-79.3c2.7-6.6 5.4-13.3 8.3-19.8c7.1-16.3 15.7-32.9 29-45.3zM384 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faBullhorn = {
    prefix: 'fasds',
    iconName: 'bullhorn',
    icon: [
      512,
      512,
      [128226,128363],
      'f0a1',
      
      ['M192 128l0 192 0 32c81.3 0 158.7 35.1 212.3 96.3L432 480l48 0 0-179.6 0-120.7L480 0 432 0 404.3 31.7C350.7 92.9 273.3 128 192 128z','M0 128l192 0 0 192 0 32 0 160L64 512l0-160L0 352 0 128zM512 240c0 27.9-13.4 51.6-32 60.4l0-120.7c18.6 8.8 32 32.5 32 60.4z']
      
    ]
  };

  

  
  

  var faBoxCheck = {
    prefix: 'fasds',
    iconName: 'box-check',
    icon: [
      448,
      512,
      [],
      'f467',
      
      ['M0 160l208 0 0-128L64 32 0 160zM240 32l0 128 208 0L384 32 240 32z','M448 160l-208 0 0-128-32 0 0 128L0 160 0 480l448 0 0-320zM209 409l-17 17-17-17L95 329 129 295l63 63L319 231 353 265 209 409z']
      
    ]
  };

  

  
  

  var faTamale = {
    prefix: 'fasds',
    iconName: 'tamale',
    icon: [
      320,
      512,
      [129748],
      'e451',
      
      ['M0 48L29.5 240l57 0L72 72.7l-.7-8 15.9-1.4 .7 8L102.6 240l49.4 0 0-176 0-8 16 0 0 8 0 176 49.4 0L232 71.3l.7-8 15.9 1.4-.7 8L233.4 240l57 0L320 48s-48-48-160-48S0 48 0 48zM0 464s48 48 160 48s160-48 160-48L290.5 272l-57 0L248 439.3l.7 8-15.9 1.4-.7-8-9.7-111.4-17.5 13.2-9.6-12.8L168 293.3 168 448l0 8-16 0 0-8 0-154.7c-9.1 12.1-18.1 24.2-27.2 36.3l-9.6 12.8L97.7 329.2 88 440.7l-.7 8-15.9-1.4 .7-8L86.6 272l-57 0L0 464zM99.3 310.2c9.6-12.8 19.1-25.5 28.7-38.2l-25.4 0-3.3 38.2zM192 272c9.6 12.8 19.1 25.5 28.8 38.4c-1.2-12.9-2.3-25.6-3.4-38.4L192 272z','M8 240l16 0 136 0 136 0 16 0 0 32-16 0-104 0 28.8 38.4 9.6 12.8-25.6 19.2-9.6-12.8L160 282.7l-35.2 46.9-9.6 12.8L89.6 323.2l9.6-12.8L128 272 24 272 8 272l0-32z']
      
    ]
  };

  

  
  

  var faHatSanta = {
    prefix: 'fasds',
    iconName: 'hat-santa',
    icon: [
      640,
      512,
      [],
      'f7a7',
      
      ['M0 384l48 0 416 0 48 0 0 96L0 480l0-96zM481.3 254.5l19.2-27.2-.7-3.7c-1.9-9.7-3.8-19.3-5.7-29c8-1.4 16-2.8 24-4.1c2.9-.5 5.9-1 8.8-1.5l18.6-27.7 27.2 19.2 32.7-6.4 5.6 32.8 27.7 18.6-19.2 27.2 6.4 32.7L593.1 291l-18.6 27.7-27.2-19.2-32.7 6.4L509 273.1l-27.7-18.6z','M48 384L149 137.1C175 73.5 236.9 32 305.6 32c49.8 0 97 21.9 129.1 59.9l83.4 98.6-24 4.1 5.7 29L384 192l80 192L48 384z']
      
    ]
  };

  

  
  

  var faArrowLeftToBracket = {
    prefix: 'fasds',
    iconName: 'arrow-left-to-bracket',
    icon: [
      512,
      512,
      [],
      'e669',
      
      ['M0 32L0 64 0 448l0 32 32 0 128 0 32 0 0-64-32 0-96 0L64 96l96 0 32 0 0-64-32 0L32 32 0 32z','M146.7 256l22.6-22.6 128-128L320 82.7 365.3 128l-22.6 22.6L269.3 224 480 224l32 0 0 64-32 0-210.7 0 73.4 73.4L365.3 384 320 429.3l-22.6-22.6-128-128L146.7 256z']
      
    ]
  };

  

  
  

  var faKey = {
    prefix: 'fasds',
    iconName: 'key',
    icon: [
      512,
      512,
      [128273],
      'f084',
      
      ['M0 398.1L0 408l0 80 0 24 24 0 80 0 24 0 0-24 0-40 40 0 24 0 0-24 0-40 40 0 9.9 0 7-7c11.1-11.1 22.2-22.2 33.3-33.3c-38-38-76-76-113.9-113.9C114.6 283.5 60.8 337.2 7 391l-7 7z','M168.3 229.7L282.3 343.7s0 0 0 0c16.9 5.4 35 8.3 53.7 8.3c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7c0 0 0 0 0 0zM336 136a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z']
      
    ]
  };

  

  
  

  var faWavePulse = {
    prefix: 'fasds',
    iconName: 'wave-pulse',
    icon: [
      640,
      512,
      ["heart-rate"],
      'f5f8',
      
      ['M285.2 0L312 0l16 0 25.5 0 5.7 24.9 63.9 281.3 27.6-63 8.4-19.2 20.9 0 128 0 32 0 0 64-32 0-107.1 0L453.3 396.8 444.9 416 424 416l-16 0-25.5 0-5.7-24.9-54-237.6L263.5 485.6 258.8 512 232 512l-16 0-25 0L185 487.8 135 288 32 288 0 288l0-64 32 0 128 0 25 0 6.1 24.2 29.1 116.3L280.5 26.4 285.2 0z','']
      
    ]
  };

  
    var faHeartRate = faWavePulse;
  

  
  

  var faHighlighter = {
    prefix: 'fasds',
    iconName: 'highlighter',
    icon: [
      576,
      512,
      [],
      'f591',
      
      ['M48 400c4.2 4.2 8.5 8.5 12.7 12.7c23.5 23.5 47.1 47.1 70.6 70.6c4.2 4.2 8.5 8.5 12.7 12.7l80-80 96 0 40.1-55.9L183.9 183.9 128 224l0 96c-26.7 26.7-53.3 53.3-80 80z','M544 104L360.1 360.1 183.9 183.9 440 0 544 104zM4.7 468.7l56-56 70.6 70.6-24 24-4.7 4.7L96 512l-80 0L0 512l0-16 0-16 0-6.6 4.7-4.7z']
      
    ]
  };

  

  
  

  var faSquareCaretLeft = {
    prefix: 'fasds',
    iconName: 'square-caret-left',
    icon: [
      448,
      512,
      ["caret-square-left"],
      'f191',
      
      ['M0 32l448 0 0 448L0 480 0 32zM128 256L256 384l32 0 0-256-32 0L128 256z','M288 384l-32 0L128 256 256 128l32 0 0 256z']
      
    ]
  };

  
    var faCaretSquareLeft = faSquareCaretLeft;
  

  
  

  var faLightSwitch = {
    prefix: 'fasds',
    iconName: 'light-switch',
    icon: [
      384,
      512,
      [],
      'e017',
      
      ['M96 240l0 32 192 0 0-32L96 240z','M0 0L384 0l0 512L0 512 0 0zM96 416l192 0 0-320L96 96l0 320zM208 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm0 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faBuildingUser = {
    prefix: 'fasds',
    iconName: 'building-user',
    icon: [
      640,
      512,
      [],
      'e4da',
      
      ['M0 0L384 0l0 359L317.1 512 240 512l0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M496 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM640 512L584 384l-176 0L352 512l288 0z']
      
    ]
  };

  

  
  

  var faVanShuttle = {
    prefix: 'fasds',
    iconName: 'van-shuttle',
    icon: [
      640,
      512,
      [128656,"shuttle-van"],
      'f5b6',
      
      ['M80 400a80 80 0 1 0 160 0A80 80 0 1 0 80 400zm320 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M32 32L0 32 0 64 0 352l0 32 32 0 17.1 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l98.3 0c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l17.1 0 32 0 0-32 0-136 0-11.7-7.5-8.9-128-152L494.9 32 480 32 352 32 192 32 32 32zM64 192l0-96 96 0 0 96-96 0zm482 0l-162 0 0-96 81.1 0L546 192zm-226 0l-96 0 0-96 96 0 0 96z']
      
    ]
  };

  
    var faShuttleVan = faVanShuttle;
  

  
  

  var faDumpster = {
    prefix: 'fasds',
    iconName: 'dumpster',
    icon: [
      576,
      512,
      [],
      'f793',
      
      ['M0 160l114.9 0L140.5 32 32 32 0 160zm147.5 0L272 160l0-128-98.9 0L147.5 160zM304 32l0 128 124.5 0L402.9 32 304 32zm131.5 0l25.6 128L576 160 544 32 435.5 32z','M64 448L44 288 0 288l0-64 36 0-4-32 512 0-4 32 36 0 0 64-44 0L512 448l0 32-64 0 0-32-320 0 0 32-64 0 0-32z']
      
    ]
  };

  

  
  

  var faArrowDownToArc = {
    prefix: 'fasds',
    iconName: 'arrow-down-to-arc',
    icon: [
      512,
      512,
      [],
      'e4ae',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256l-64 0c0 106-86 192-192 192S64 362 64 256L0 256z','M413.3 208l-22.6 22.6-112 112L256 365.3l-22.6-22.6-112-112L98.7 208 144 162.7l22.6 22.6L224 242.7 224 32l0-32 64 0 0 32 0 210.7 57.4-57.4L368 162.7 413.3 208z']
      
    ]
  };

  

  
  

  var faLightEmergency = {
    prefix: 'fasds',
    iconName: 'light-emergency',
    icon: [
      448,
      512,
      [],
      'e41f',
      
      ['M64 192l0 160 320 0 0-160c0-88.4-71.6-160-160-160S64 103.6 64 192zm48 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80l-32 0z','M448 352L0 352 0 480l448 0 0-128z']
      
    ]
  };

  

  
  

  var faToiletPaperUnder = {
    prefix: 'fasds',
    iconName: 'toilet-paper-under',
    icon: [
      512,
      512,
      ["toilet-paper-reverse"],
      'e2a0',
      
      ['M0 192C0 298 43 384 96 384l32 0 32 0 256 0c-52.4 0-94.9-83.9-96-188.1c0-1.3 0-2.6 0-3.9C320 86 363 0 416 0L96 0C43 0 0 86 0 192zm80 16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M320 195.9c1 104.2 43.6 188.1 96 188.1l-256 0 0 128 352 0 0-320C512 86 469 0 416 0s-96 86-96 192c0 1.3 0 2.6 0 3.9zM448 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zM80 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  
    var faToiletPaperReverse = faToiletPaperUnder;
  

  
  

  var faSchoolCircleCheck = {
    prefix: 'fasds',
    iconName: 'school-circle-check',
    icon: [
      640,
      512,
      [],
      'e56b',
      
      ['M0 96L0 512l256 0 0-96c0-35.3 28.7-64 64-64l.7 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 96 480 96 320 0 160 96 0 96zm80 96l64 0 0 96-64 0 0-96zm0 128l64 0 0 96-64 0 0-96zM304 128l0 16 0 32 0 16 16 0 32 0 16 0 0-32-16 0-16 0 0-16 0-16-32 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faComma = {
    prefix: 'fasds',
    iconName: 'comma',
    icon: [
      192,
      512,
      [],
      '2c',
      
      ['M48 288L16 512H80l80-224H48z','']
      
    ]
  };

  

  
  

  var faSensor = {
    prefix: 'fasds',
    iconName: 'sensor',
    icon: [
      448,
      512,
      [],
      'e028',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 96l48 0 0 24 0 144 0 24-48 0 0-24 0-144 0-24zm96 0l48 0 0 24 0 144 0 24-48 0 0-24 0-144 0-24z','M112 96l0 24 0 144 0 24-48 0 0-24 0-144 0-24 48 0zm96 0l0 24 0 144 0 24-48 0 0-24 0-144 0-24 48 0z']
      
    ]
  };

  

  
  

  var faUser = {
    prefix: 'fasds',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,128100],
      'f007',
      
      ['M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M64 304H384l64 208H0L64 304z']
      
    ]
  };

  

  
  

  var faRotateReverse = {
    prefix: 'fasds',
    iconName: 'rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e631',
      
      ['M44.5 330.6C55.3 361.3 73 390 97.4 414.4C141.1 458.1 198.4 480 255.8 480c57.3 0 114.6-21.9 158.4-65.6c19.2 19.2 38.4 38.4 57.6 57.6l24-24 0-160-160 0-24 24 57.1 57.1c-62.5 62.5-163.8 62.5-226.3 0c-17.5-17.5-30.1-38-37.8-59.8L44.5 330.6z','M406.6 202.6c-7.7-21.8-20.2-42.3-37.8-59.8c-62.5-62.5-163.8-62.5-226.3 0c0 0 0 0 0 0L199.8 200l-24 24-160 0 0-160 24-24L97.4 97.6s0 0 0 0c87.5-87.5 229.3-87.5 316.8 0c24.4 24.4 42.1 53.1 52.9 83.7l-60.4 21.3z']
      
    ]
  };

  

  
  

  var faBadgePercent = {
    prefix: 'fasds',
    iconName: 'badge-percent',
    icon: [
      512,
      512,
      [],
      'f646',
      
      ['M0 256c0 36.8 20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256zm158.1 64l17-17c42.7-42.7 85.3-85.3 128-128l17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-42.7 42.7-85.3 85.3-128 128c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9zM160 192c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1.1 0 1.6c0 1.1 0 1.4 0 1.7c0 .5-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM352 320a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M337 209l17-17L320 158.1l-17 17L175 303l-17 17L192 353.9l17-17L337 209zM224 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z']
      
    ]
  };

  

  
  

  var faBridgeCircleExclamation = {
    prefix: 'fasds',
    iconName: 'bridge-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e4ca',
      
      ['M32 32l32 0 512 0 32 0 0 64-32 0-40 0 0 64 72 0 0 72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96l0 96-96 0 0-96c0-53-43-96-96-96l0-128 72 0 0-64L64 96 32 96l0-64zM152 96l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faPenClip = {
    prefix: 'fasds',
    iconName: 'pen-clip',
    icon: [
      512,
      512,
      ["pen-alt"],
      'f305',
      
      ['M289 95L417 223c31.7-31.7 63.4-63.4 95-95L384 0 289 95z','M241 47l-17-17L207 47 95 159l-17 17L112 209.9l17-17 95-95 31 31L32 352 0 512l160-32L383 257l33-33 1-1L241 47z']
      
    ]
  };

  
    var faPenAlt = faPenClip;
  

  
  

  var faH3 = {
    prefix: 'fasds',
    iconName: 'h3',
    icon: [
      640,
      512,
      [],
      'f315',
      
      ['M0 64L0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96l0-32L0 64z','M624 64l0 45.3-9.4 9.4-89.5 89.5C589 210.8 640 263.4 640 328l0 32-4.3 0c-14 50.7-60.5 88-115.7 88l-60.3 0c-40.4 0-75.6-27.5-85.4-66.7L369 359.8 431 344.2l5.4 21.6c2.7 10.7 12.3 18.2 23.3 18.2l60.3 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-72 0-16 0 0-61.3L514.7 128 400 128l-32 0 0-64 32 0 192 0 32 0z']
      
    ]
  };

  

  
  

  var faBowlChopsticksNoodles = {
    prefix: 'fasds',
    iconName: 'bowl-chopsticks-noodles',
    icon: [
      512,
      512,
      [],
      'e2ea',
      
      ['M0 96l0 32 64-10 0-34L0 96zm0 48l0 32 64 0 0-34L0 144zM224 54l0 39L512 48l0-48L224 54zm0 83l0 39 288 0 0-48-288 9z','M192 40l0-24-48 0 0 24 0 184-32 0 0-168 0-24L64 32l0 24 0 168L0 224l3.6 61.2C8.5 368.1 58 438.2 128 472.9l0 39.1 256 0 0-39.1c70-34.6 119.5-104.8 124.4-187.7L512 224l-320 0 0-184z']
      
    ]
  };

  

  
  

  var faPizza = {
    prefix: 'fasds',
    iconName: 'pizza',
    icon: [
      576,
      512,
      [127829],
      'f817',
      
      ['M48 256c0-1.6 0-3.3 .1-4.8c0-1.8 .1-3.6 .2-5.4c.1-1.1 .1-2.2 .2-3.3c0-.8 .1-1.6 .2-2.3c.1-.8 .1-1.6 .2-2.4c1.5-17.6 5.3-34.9 11.3-51.7c.3-.9 .6-1.8 1-2.7c.1-.3 .2-.7 .4-1c.6-1.5 1.1-3 1.8-4.6c1.3-3.1 2.6-6.2 4.1-9.5c.6-1.4 1.3-2.8 2-4.2c.7-1.4 1.4-2.8 2.1-4.1c3.3-6.3 6.9-12.4 10.7-18.3c.2-.2 .3-.5 .5-.7c1.8-2.7 3.7-5.4 5.7-8.1c2-2.7 4-5.4 6.3-8.1c2.2-2.7 4.5-5.4 6.9-8c1.2-1.3 2.4-2.6 3.6-3.9s2.5-2.6 3.8-3.8c2.5-2.5 5.1-5 7.8-7.4s5.3-4.7 8.2-7c2.6-2.1 5.3-4.2 8-6.2c8.5-6.3 17.5-11.8 26.7-16.7c3-1.6 6-3 9-4.5s6.1-2.7 9.4-4.1c1.2-.5 2.4-.9 3.5-1.4c.3-.1 .5-.2 .8-.3c1.4-.5 2.8-1 4.2-1.5c.2-.1 .4-.2 .6-.2c3.1-1.1 6.2-2.1 9.3-3l.6-.2c3-.9 6.1-1.7 9.2-2.5s6.1-1.4 9.2-2c3.6-.7 7.3-1.3 10.9-1.9c3.2-.5 6.4-.8 9.5-1.1l.4 0c3.3-.3 6.7-.5 10-.7c1.6-.1 3.2-.1 4.8-.2s3.2-.1 4.8-.1c3.6 0 7.1 .1 10.6 .3c3.5 .2 6.9 .4 10.3 .8c3.6 .3 7.1 .8 10.6 1.3c3.3 .5 6.6 1.1 9.8 1.7c3.6 .7 7.1 1.5 10.6 2.4c3.2 .8 6.4 1.7 9.6 2.7c1.8 .5 3.5 1.1 5.3 1.7c1.5 .5 2.9 1 4.4 1.5c3.3 1.2 6.5 2.4 9.6 3.8c3.1 1.3 6.2 2.7 9.3 4.2c3 1.4 6 3 8.9 4.6c2.9 1.6 5.7 3.2 8.5 4.9c3.1 1.9 6.1 3.8 9.1 5.9c2.7 1.8 5.3 3.7 7.9 5.6c2.6 2 5.1 4 7.6 6c2.6 2.1 5.1 4.3 7.5 6.5s4.9 4.5 7.2 6.9L256 256 403.1 403.1c-2.4 2.4-4.8 4.6-7.2 6.9s-5 4.4-7.5 6.5c-2.5 2.1-5.1 4.1-7.6 6c-2.6 1.9-5.2 3.8-7.9 5.7c-.3 .2-.6 .4-.8 .6c-2.7 1.8-5.5 3.6-8.3 5.3c-2.8 1.7-5.6 3.3-8.5 4.9c-2.9 1.6-5.9 3.1-9 4.6c-3 1.4-6.1 2.8-9.2 4.2c-3.1 1.3-6.3 2.6-9.4 3.7c-3.1 1.1-6.2 2.2-9.3 3.2c-3.4 1.1-6.7 2-10.2 2.9c-3.2 .8-6.4 1.6-9.6 2.2c-3.6 .8-7.2 1.4-10.8 1.9c-3.4 .5-6.8 .9-10.1 1.3c-.5 .1-1 .1-1.5 .1c-1 .1-1.9 .2-2.9 .3c-.4 0-.8 .1-1.2 .1c-1.7 .1-3.4 .2-5 .3c-3.6 .2-7.2 .3-10.8 .3c-3.3 0-6.6-.1-9.9-.2c-3.3-.2-6.6-.4-9.8-.7c-3.3-.3-6.6-.7-10-1.2c-3.1-.4-6.2-.9-9.2-1.5c-.6-.1-1.1-.2-1.7-.3c-3.1-.6-6.2-1.3-9.2-2s-6.1-1.6-9.2-2.5c-3.3-1-6.6-2-9.9-3.2c-3.1-1.1-6.2-2.3-9.4-3.6c-3.1-1.3-6.2-2.6-9.4-4.1c-1.4-.7-2.8-1.3-4.2-2c-.4-.2-.8-.4-1.2-.6c-.5-.3-1-.5-1.5-.8c-.7-.4-1.5-.8-2.2-1.2c-2.9-1.6-5.8-3.2-8.6-4.8c-3.2-1.9-6.4-3.9-9.5-5.9c-2.8-1.9-5.5-3.8-8.2-5.7c-2.7-2-5.5-4.1-8.1-6.3c-2.7-2.2-5.4-4.5-8-6.9c-1.3-1.2-2.6-2.4-3.9-3.6s-2.6-2.5-3.9-3.8c-2.5-2.5-5-5.1-7.5-7.8c-1.1-1.2-2.2-2.5-3.3-3.7l-.4-.4c-.8-.9-1.5-1.8-2.2-2.7c-.4-.4-.7-.8-1-1.3c-2.1-2.6-4.2-5.3-6.2-8c-2.2-3-4.3-6.1-6.4-9.2c-1.8-2.8-3.6-5.6-5.3-8.5c-1.7-3-3.4-6-5-9c-1.6-3-3-6-4.5-9s-2.7-6.1-4.1-9.4c-.5-1.2-.9-2.3-1.4-3.5c-.1-.3-.2-.6-.3-.9c-.5-1.4-1-2.8-1.5-4.2c-5.9-16.6-9.6-33.8-11.1-51.2c-.1-.8-.1-1.6-.2-2.4c-.1-.7-.1-1.4-.2-2.3c-.1-1.1-.1-2.2-.2-3.3c-.2-3.4-.3-6.9-.3-10.3zm80 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM344 256c44.9-44.9 89.7-89.7 134.6-134.6C509.4 157.7 528 204.7 528 256s-18.6 98.3-49.4 134.6C433.7 345.7 388.9 300.9 344 256zm72 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M403.1 403.1C365.4 440.7 313.4 464 256 464C141.1 464 48 370.9 48 256S141.1 48 256 48c57.4 0 109.4 23.3 147.1 60.9L437 75C390.7 28.7 326.7 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c70.7 0 134.7-28.7 181-75l-33.9-33.9zm75.5-12.5l34 34c39.5-45 63.4-104 63.4-168.6s-23.9-123.6-63.4-168.6l-34 34C509.4 157.7 528 204.7 528 256s-18.6 98.3-49.4 134.6zM256 128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM480 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z']
      
    ]
  };

  

  
  

  var faE = {
    prefix: 'fasds',
    iconName: 'e',
    icon: [
      320,
      512,
      [101],
      '45',
      
      ['M32 32L0 32 0 64 0 224l0 32 0 32L0 448l0 32 32 0 256 0 32 0 0-64-32 0L64 416l0-128 160 0 32 0 0-64-32 0L64 224 64 96l224 0 32 0 0-64-32 0L32 32z','']
      
    ]
  };

  

  
  

  var faLambda = {
    prefix: 'fasds',
    iconName: 'lambda',
    icon: [
      448,
      512,
      [],
      'f66e',
      
      ['M32 32L0 32 0 96l32 0 108.2 0 16.4 32.9L2.2 480l69.9 0L193.8 203.3 323.4 462.3l8.8 17.7 19.8 0 64 0 32 0 0-64-32 0-44.2 0L188.6 49.7 179.8 32 160 32 32 32z','']
      
    ]
  };

  

  
  

  var faWandMagicSparkles = {
    prefix: 'fasds',
    iconName: 'wand-magic-sparkles',
    icon: [
      576,
      512,
      ["magic-wand-sparkles"],
      'e2ca',
      
      ['M0 128L64 96 96 32l32 64 64 32-64 32L96 224 64 160 0 128zM192 64l42.7-21.3L256 0l21.3 42.7L320 64 277.3 85.3 256 128 234.7 85.3 192 64zm120 56l80.4-80.4L432 0l39.6 39.6 32.8 32.8L544 112l-39.6 39.6L424 232l-39.6-39.6L464.8 112 432 79.2l-80.4 80.4c-13.2-13.2-26.4-26.4-39.6-39.6zm40 264l64-32 32-64 32 64 64 32-64 32-32 64-32-64-64-32z','M424 232L312 120 32 400 144 512 424 232z']
      
    ]
  };

  
    var faMagicWandSparkles = faWandMagicSparkles;
  

  
  

  var faGauge = {
    prefix: 'fasds',
    iconName: 'gauge',
    icon: [
      512,
      512,
      ["dashboard","gauge-med","tachometer-alt-average"],
      'f624',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48-112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm16 208c0-26.9 16.5-49.9 40-59.3L232 88l0-24 48 0 0 24 0 204.7c23.5 9.5 40 32.5 40 59.3c0 35.3-28.7 64-64 64s-64-28.7-64-64zM400 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M280 88l0-24-48 0 0 24 0 204.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64c0-26.9-16.5-49.9-40-59.3L280 88z']
      
    ]
  };

  
    var faDashboard = faGauge;
  
    var faGaugeMed = faGauge;
  
    var faTachometerAltAverage = faGauge;
  

  
  

  var faVial = {
    prefix: 'fasds',
    iconName: 'vial',
    icon: [
      512,
      512,
      [129514],
      'f492',
      
      ['M0 410.5L0 416c0 53 43 96 96 96l5.5 0c25.5 0 49.9-10.1 67.9-28.1L448 205.3l18.6 18.6 45.3-45.3-22.6-22.6-18.6-18.6-96-96c-6.2-6.2-12.4-12.4-18.6-18.6L333.4 .2 288.2 45.4 306.7 64 28.1 342.6C10.1 360.6 0 385 0 410.5zm64 0c0-8.5 3.4-16.6 9.4-22.6L205.3 256c48.9-48.9 97.8-97.8 146.7-146.7L402.7 160c-32 32-64 64-96 96C245.9 316.9 185 377.7 124.1 438.6c-6 6-14.1 9.4-22.6 9.4L96 448c-17.7 0-32-14.3-32-32l0-5.5z','M306.7 256l-101.5 0L73.4 387.9c-6 6-9.4 14.1-9.4 22.6l0 5.5c0 17.7 14.3 32 32 32l5.5 0c8.5 0 16.6-3.4 22.6-9.4L306.7 256z']
      
    ]
  };

  

  
  

  var faSquareBolt = {
    prefix: 'fasds',
    iconName: 'square-bolt',
    icon: [
      448,
      512,
      [],
      'e265',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 248L288 112 248 240l88 0 0 24L160 400l40-128-88 0 0-24z','M336 264L160 400l40-128H112V248L288 112 248 240h88v24z']
      
    ]
  };

  

  
  

  var faLeafOak = {
    prefix: 'fasds',
    iconName: 'leaf-oak',
    icon: [
      512,
      512,
      [],
      'f6f7',
      
      ['M32 224l48 96 0 78.1L279.9 198.1c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17C247.2 298.7 180.6 365.4 113.9 432l78.1 0 96 48 64-64-32-48 112 16 48-48-64-64 96-24 0-72-48-32 16-64L432 32 368 48 336 0 264 0 240 96 176 32 128 80l16 112L96 160 32 224z','M6.1 472l17-17L279.9 198.1l17-17 33.9 33.9-17 17L57 489l-17 17L6.1 472z']
      
    ]
  };

  

  
  

  var faMarsStroke = {
    prefix: 'fasds',
    iconName: 'mars-stroke',
    icon: [
      512,
      512,
      [9894],
      'f229',
      
      ['M128 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M512 0L384 0 352 32l41.4 41.4-23 23L345 71l-17-17L294.1 88l17 17 25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201l17 17L457.9 184l-17-17-25.4-25.4 23-23L480 160l32-32L512 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z']
      
    ]
  };

  

  
  

  var faCircleParking = {
    prefix: 'fasds',
    iconName: 'circle-parking',
    icon: [
      512,
      512,
      ["parking-circle"],
      'f615',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm448 0A192 192 0 1 1 64 256a192 192 0 1 1 384 0z','M176 128l32 0 80 0c53 0 96 43 96 96s-43 96-96 96l-48 0 0 32 0 32-64 0 0-32 0-64 0-128 0-32zm64 128l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64z']
      
    ]
  };

  
    var faParkingCircle = faCircleParking;
  

  
  

  var faCrutches = {
    prefix: 'fasds',
    iconName: 'crutches',
    icon: [
      640,
      512,
      [],
      'f7f8',
      
      ['M.4 177.6l45.3 45.3 17.6-17.6L203.8 345.7l10.5-10.5 13.9-55.7L108.5 160l50.7-50.7 92.5 92.5L297 156.5 204.5 64l17.6-17.6L176.9 1.1 154.2 23.8 23 155 .4 177.6zM364.8 410.8l27.9 27.9 73 73 45.3-45.3L438 393.4l-2.4-2.4-2.8 2.8-67.9 17zM416.7 46.4c5.9 5.9 11.7 11.7 17.6 17.6c1.7 1.7 3.4 3.4 5 5l40.2 40.2c16.9 16.9 33.8 33.8 50.7 50.7c13.4 13.4 26.8 26.8 40.2 40.2c1.7 1.7 3.4 3.4 5 5c5.9 5.9 11.7 11.7 17.6 17.6l45.3-45.3L615.8 155 484.6 23.8 462 1.1 416.7 46.4z','M337.1 161.3L434.3 64l45.3 45.3L404.8 184l50.7 50.7L530.3 160l45.3 45.3-97.4 97.4-56 56-6.3 6.3-8.6 2.1L287.9 396.9l-41.7 41.7-73 73L128 466.3l72.9-72.9c0 0 0 0 .1-.1l41.7-41.7 29.9-119.4 2.1-8.6 6.3-6.3 55.9-55.9c0 0 .1-.1 .1-.1s.1-.1 .1-.1zm22.5 68l-27.1 27.1L315.6 324l67.7-16.9L410.3 280l-50.7-50.7z']
      
    ]
  };

  

  
  

  var faChartSimple = {
    prefix: 'fasds',
    iconName: 'chart-simple',
    icon: [
      448,
      512,
      [],
      'e473',
      
      ['M160 32l128 0 0 448-128 0 0-448z','M448 96L320 96l0 384 128 0 0-384zM128 224L0 224 0 480l128 0 0-256z']
      
    ]
  };

  

  
  

  var faBagSeedling = {
    prefix: 'fasds',
    iconName: 'bag-seedling',
    icon: [
      512,
      512,
      [],
      'e5f2',
      
      ['M32 247.2l0 17.7c0 36.6 4.5 73.1 13.4 108.7L64 448l384 0 18.6-74.5c8.9-35.5 13.4-72 13.4-108.7l0-17.7c0-36.6-4.5-73.1-13.4-108.7L448 64 64 64 45.4 138.5C36.5 174 32 210.5 32 247.2zM128 160l32 0c40.7 0 76.4 21.8 96 54.3c19.6-32.5 55.3-54.3 96-54.3l32 0 0 16c0 59.2-45.9 107.6-104 111.7l0 40.3 0 24-48 0 0-24 0-40.3c-58.1-4.1-104-52.6-104-111.7l0-16z','M480 0L32 0 64 64l384 0L480 0zm0 512l-32-64L64 448 32 512l448 0zM160 160l-32 0 0 16c0 59.2 45.9 107.6 104 111.7l0 40.3 0 24 48 0 0-24 0-40.3c58.1-4.1 104-52.6 104-111.7l0-16-32 0c-40.7 0-76.4 21.8-96 54.3c-19.6-32.5-55.3-54.3-96-54.3z']
      
    ]
  };

  

  
  

  var faPenCircle = {
    prefix: 'fasds',
    iconName: 'pen-circle',
    icon: [
      512,
      512,
      [],
      'e20e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 384l16-96L252.7 179.3l80 80L224 368l-96 16zM275.3 156.7L320 112l80 80-44.7 44.7-80-80z','M128 384l16-96L252.7 179.3l80 80L224 368l-96 16zM355.3 236.7l-80-80L320 112l80 80-44.7 44.7z']
      
    ]
  };

  

  
  

  var faRadiation = {
    prefix: 'fasds',
    iconName: 'radiation',
    icon: [
      512,
      512,
      [],
      'f7b9',
      
      ['M208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M176 256c0-29.6 16.1-55.5 40-69.3L128 34.3C51.5 78.5 0 161.3 0 256l176 0zm40 69.3L128 477.7c37.7 21.8 81.4 34.3 128 34.3s90.4-12.5 128-34.3L296 325.3c-11.8 6.8-25.4 10.7-40 10.7s-28.2-3.9-40-10.7zM336 256l176 0c0-94.7-51.5-177.5-128-221.7L296 186.7c23.9 13.8 40 39.7 40 69.3z']
      
    ]
  };

  

  
  

  var faPlaneUpSlash = {
    prefix: 'fasds',
    iconName: 'plane-up-slash',
    icon: [
      640,
      512,
      [],
      'e22e',
      
      ['M64 288l0 96 192-64 0 80-64 48 0 64 128-32 128 32 0-63-25.7-20.2L384 400l0-1.5L161.3 223.1 64 288zM244.9 167.4c80 62.1 159.9 124.1 239.8 186.2L576 384l0-96L384 160l0-66.3C384 59.5 356 0 320 0c-35 0-64 59.5-64 93.7l0 66.3-11.1 7.4z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faMug = {
    prefix: 'fasds',
    iconName: 'mug',
    icon: [
      576,
      512,
      [],
      'f874',
      
      ['M416 64l0 64 32 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-32 0 0 64 32 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-32 0z','M32 64H416V448H32V64z']
      
    ]
  };

  

  
  

  var faMicrochipAi = {
    prefix: 'fasds',
    iconName: 'microchip-ai',
    icon: [
      512,
      512,
      [],
      'e1ec',
      
      ['M0 128l0 48 24 0 40 0 0-48-40 0L0 128zM0 232l0 48 24 0 40 0 0-48-40 0L0 232zM0 336l0 48 24 0 40 0 0-48-40 0L0 336zM128 0l0 24 0 40 48 0 0-40 0-24L128 0zm0 448l0 40 0 24 48 0 0-24 0-40-48 0zM232 0l0 24 0 40 48 0 0-40 0-24L232 0zm0 448l0 40 0 24 48 0 0-24 0-40-48 0zM336 0l0 24 0 40 48 0 0-40 0-24L336 0zm0 448l0 40 0 24 48 0 0-24 0-40-48 0zM448 128l0 48 40 0 24 0 0-48-24 0-40 0zm0 104l0 48 40 0 24 0 0-48-24 0-40 0zm0 104l0 48 40 0 24 0 0-48-24 0-40 0z','M448 64L64 64l0 384 384 0 0-384zM320 176l32 0 0 16 0 128 0 16-32 0 0-16 0-128 0-16zM127.5 336l9.8-22.4 14-32 42-96 4.2-9.6 20.9 0 4.2 9.6 42 96 14 32 9.8 22.4-34.9 0-4.2-9.6L239.5 304l-63.1 0-9.8 22.4-4.2 9.6-34.9 0zm98-64L208 231.9 190.5 272l35.1 0z']
      
    ]
  };

  

  
  

  var faFileWaveform = {
    prefix: 'fasds',
    iconName: 'file-waveform',
    icon: [
      448,
      512,
      ["file-medical-alt"],
      'f478',
      
      ['M64 0L288 0l0 160 160 0 0 352L64 512l0-192 65.2 0 41.4 82.7 23.9 47.8 19.8-49.6 44.2-110.4 8.1 16.2 6.6 13.3 14.8 0 56 0 24 0 0-48-24 0-41.2 0-25.4-50.7-23.9-47.8-19.8 49.6L189.6 333.5l-24.1-48.2L158.8 272 144 272l-80 0L64 0z','M448 160L288 0l0 160 160 0zM277.5 221.3l-23.9-47.8-19.8 49.6L189.6 333.5l-24.1-48.2L158.8 272 144 272 24 272 0 272l0 48 24 0 105.2 0 41.4 82.7 23.9 47.8 19.8-49.6 44.2-110.4 8.1 16.2 6.6 13.3 14.8 0 56 0 24 0 0-48-24 0-41.2 0-25.4-50.7z']
      
    ]
  };

  
    var faFileMedicalAlt = faFileWaveform;
  

  
  

  var faCreditCardBlank = {
    prefix: 'fasds',
    iconName: 'credit-card-blank',
    icon: [
      576,
      512,
      [],
      'f389',
      
      ['M0 32L0 480l576 0 0-448L0 32zM96 352l96 0 0 32-96 0 0-32zm128 0l160 0 0 32-160 0 0-32z','M192 352l-96 0 0 32 96 0 0-32zm192 0l-160 0 0 32 160 0 0-32z']
      
    ]
  };

  

  
  

  var faFaceAnxiousSweat = {
    prefix: 'fasds',
    iconName: 'face-anxious-sweat',
    icon: [
      576,
      512,
      [],
      'e36a',
      
      ['M32 256l16-21.3 25.6 34.1L112 320c10.4 13.8 16 30.7 16 48c0 24.6-11.1 46.5-28.5 61.2C146.3 480.1 213.4 512 288 512c141.4 0 256-114.6 256-256S429.4 0 288 0S32 114.6 32 256zm77.6-61.2l15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L216 137.4 238.6 160l-11.3 11.3-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7c-.8 .1-1.7 .3-2.5 .4l-15.8 2.6-5.3-31.6zm130 77.2a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM208 400c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16-160 0 0-16zM399.6 272a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM337.4 160L360 137.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6c-.8-.1-1.7-.3-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4L337.4 160z','M227.3 171.3L238.6 160 216 137.4l-11.3 11.3-7.4 7.4c-18.9 18.9-43.2 31.4-69.5 35.7l-2.5 .4-15.8 2.6 5.3 31.6 15.8-2.6 2.5-.4c32.9-5.5 63.3-21.1 86.8-44.7l7.4-7.4zM175.6 272a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm160 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm1.7-112l11.3 11.3 7.4 7.4c23.6 23.6 53.9 39.2 86.8 44.7l2.5 .4 15.8 2.6 5.3-31.6-15.8-2.6-2.5-.4c-26.3-4.4-50.6-16.9-69.5-35.7l-7.4-7.4L360 137.4 337.4 160zM48 288L9.6 339.2C3.4 347.5 0 357.6 0 368c0 26.5 21.5 48 48 48s48-21.5 48-48c0-10.4-3.4-20.5-9.6-28.8L48 288z']
      
    ]
  };

  

  
  

  var faFolder = {
    prefix: 'fasds',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716,128193,128447,"folder-blank"],
      'f07b',
      
      ['M0 480H512V96H272L224 32H0V480z','']
      
    ]
  };

  
    var faFolderBlank = faFolder;
  

  
  

  var faObjectsAlignTop = {
    prefix: 'fasds',
    iconName: 'objects-align-top',
    icon: [
      512,
      512,
      [],
      'e3c0',
      
      ['M64 128l0 384 160 0 0-384L64 128zm224 0l0 256 160 0 0-256-160 0z','M0 0H512V48H0V0z']
      
    ]
  };

  

  
  

  var faFileCad = {
    prefix: 'fasds',
    iconName: 'file-cad',
    icon: [
      512,
      512,
      [],
      'e672',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM200 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8 0-16-32 0 0 16 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8 0 16 32 0 0-16 0-8c0-22.1-17.9-40-40-40l-16 0zm232 0l-16 0 0 16 0 128 0 16 16 0 32 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-32 0zm16 32l16 0c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-16 0 0-96zm-160 8l0 56 0 48 0 16 32 0 0-16 0-32 32 0 0 32 0 16 32 0 0-16 0-48 0-56c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm32 40l0-40c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 40-32 0z']
      
    ]
  };

  

  
  

  var faTrashPlus = {
    prefix: 'fasds',
    iconName: 'trash-plus',
    icon: [
      448,
      512,
      [],
      'e2b2',
      
      ['M32 96L56 512l336 0L416 96 32 96zm80 168l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zm56 400l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z']
      
    ]
  };

  

  
  

  var faHeadSideGear = {
    prefix: 'fasds',
    iconName: 'head-side-gear',
    icon: [
      512,
      512,
      [],
      'e611',
      
      ['M0 224.3c0 58.7 23 115 64 156.9L64 480l0 32 32 0 192 0 32 0 0-32 0-32 96 0 32 0 0-32 0-96 32 0 32 0 0-32 0-16 0-11.2-7-8.8-57.3-71.7C441.6 79.7 358.1 0 256 0L224.3 0C100.4 0 0 100.4 0 224.3zm97.1-36.6l32-55.4L161.6 151c8.9-7.6 19.1-13.6 30.4-17.6L192 96l64 0 0 37.5c11.2 4 21.5 10 30.4 17.6l32.5-18.7 32 55.4-32.5 18.7c1.1 5.7 1.6 11.6 1.6 17.6s-.5 11.9-1.6 17.5l32.5 18.7-32 55.4c-10.8-6.2-21.6-12.5-32.5-18.7c-8.9 7.6-19.2 13.6-30.4 17.6l0 37.5-64 0 0-37.5c-11.2-4-21.5-10-30.4-17.6l-32.5 18.7-32-55.4 32.5-18.7c-1.1-5.7-1.6-11.6-1.6-17.5s.5-11.9 1.6-17.6L97.1 187.7z','M192 96l64 0 0 37.5c11.2 4 21.5 10 30.4 17.6l32.5-18.7 32 55.4-32.5 18.7c1.1 5.7 1.6 11.6 1.6 17.6s-.5 11.9-1.6 17.5l32.5 18.7-32 55.4L286.4 297c-8.9 7.6-19.2 13.6-30.4 17.6l0 37.5-64 0 0-37.5c-11.2-4-21.5-10-30.4-17.6l-32.5 18.7-32-55.4 32.5-18.7c-1.1-5.7-1.6-11.6-1.6-17.5s.5-11.9 1.6-17.6L97.1 187.7l32-55.4L161.6 151c8.9-7.6 19.1-13.6 30.4-17.6L192 96zm32 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z']
      
    ]
  };

  

  
  

  var faArrowUpFromBracket = {
    prefix: 'fasds',
    iconName: 'arrow-up-from-bracket',
    icon: [
      448,
      512,
      [],
      'e09a',
      
      ['M0 320l0 32L0 480l0 32 32 0 384 0 32 0 0-32 0-128 0-32-64 0 0 32 0 96L64 448l0-96 0-32L0 320z','M224 2.7l22.6 22.6 128 128L397.3 176 352 221.3l-22.6-22.6L256 125.3 256 320l0 32-64 0 0-32 0-194.7-73.4 73.4L96 221.3 50.7 176l22.6-22.6 128-128L224 2.7z']
      
    ]
  };

  

  
  

  var faHandPointDown = {
    prefix: 'fasds',
    iconName: 'hand-point-down',
    icon: [
      384,
      512,
      [],
      'f0a7',
      
      ['M0 149c0-33.9 13.5-66.5 37.5-90.5L49.1 46.9C79.1 16.9 119.8 0 162.3 0L224 0c88.4 0 160 71.6 160 160l-96 0 0 32-64 0 0-48 0-16-16 0L96 128l-16 0 0 32 16 0 96 0 0 32 0 48L0 240l0-91zM32 272l64 0 0 240-64 0 0-240z','M384 320l-64 0 0-128 64 0 0 128zM224 352l0-128 64 0 0 128-64 0zm-96 32l0-112 64 0 0 112-64 0z']
      
    ]
  };

  

  
  

  var faRaccoon = {
    prefix: 'fasds',
    iconName: 'raccoon',
    icon: [
      512,
      512,
      [],
      'e613',
      
      ['M0 128l0 32 128 0 0-32L0 128zm0 96l0 32 112 0c5-6.7 10.4-13.1 16-19.2l0-12.8L0 224zm0 96l0 80c0 61.9 50.1 112 112 112l128 0 80 0 0-16c0-26.5-21.5-48-48-48l-32 0-16 0 0-32 16 0 32 0c44.2 0 80 35.8 80 80l0 16 24 0 40 0 64 0 0-16.4c-.2-26.3-21.6-47.6-48-47.6l-16 0c0-24 0-48 0-72l-6.4 4.8-12.8 9.6-19.2-25.6 12.8-9.6L448 312l0-9.3c0-19.7-7.2-38.5-20.1-53l-7.3 2.2-42 28L366.5 288 352 288l-32 0-14.5 0-12.1-8.1-42-28-68.9-20.7C130.1 269 96 330.5 96 400l0 16-32 0 0-16c0-28.1 4.8-55 13.7-80L0 320zM190.7 46.8l2.1 6.3 15.3 45.8L194 116.2l86.4-30.1c21.7-7.5 44 1.4 55.6 18.6c11.5-17.3 33.9-26.2 55.6-18.6c28.8 10 57.6 20 86.5 30.1L463.9 98.8l15.3-45.8 2.1-6.3-3-5.9-16-32L457.9 0 448 0 383.6 0 336 0 288.4 0 224 0l-9.9 0-4.4 8.8-16 32-3 5.9zM202 325.5L218.5 298l13.7 8.2 80 48 13.7 8.2L309.5 390l-13.7-8.2-80-48L202 325.5zM225.3 49.2L233.9 32l28.5 0L232 69.4l-6.7-20.2zm15.2 166c8.2 2.5 16.5 4.9 24.7 7.4l50 33.4 20.8 0 20.8 0 50-33.4 24.7-7.4c-26.1-13.9-52.2-27.8-78.2-41.7c-7.1-3.8-13-9.2-17.3-15.7c-4.3 6.5-10.2 11.9-17.3 15.7c-26.1 13.9-52.2 27.8-78.2 41.7zM360 232a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM409.6 32l28.5 0 8.6 17.2L440 69.4 409.6 32zm70.1 263.4l0 .8c.1-.4 0-.6 0-.8z','M128 32L0 32l0 96 128 0 0-96zm0 128L0 160l0 64 128 0 0-64zm-16 96L0 256l0 64 77.7 0c8.2-23.2 19.8-44.7 34.3-64zm64-60.1l64.4 19.3 78.2-41.7c7.1-3.8 13-9.2 17.3-15.7c4.3 6.5 10.2 11.9 17.3 15.7l78.2 41.7L496 195.9l0-57.6-18-22.1L391.6 86.1c-21.7-7.5-44 1.4-55.6 18.6c-11.5-17.3-33.9-26.2-55.6-18.6L194 116.2l-18 22.1 0 57.6zM360 232a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faOption = {
    prefix: 'fasds',
    iconName: 'option',
    icon: [
      640,
      512,
      [],
      'e318',
      
      ['M416 64l0 64 32 0 160 0 32 0 0-64-32 0L448 64l-32 0z','M432.6 448l15.4 0 160 0 32 0 0-64-32 0-144.6 0L217 76l-9.6-12L192 64 32 64 0 64l0 64 32 0 144.6 0L423 436l9.6 12z']
      
    ]
  };

  

  
  

  var faBacon = {
    prefix: 'fasds',
    iconName: 'bacon',
    icon: [
      576,
      512,
      [129363],
      'f7e5',
      
      ['M0 352c157.8-71 183.3-114.8 210.8-162C239.1 141.4 269.6 89.2 448 0c14.9 18.7 29.9 37.4 44.8 56.1c-72.8 38.4-120.4 72.2-154.2 103.4c-38.1 35.3-58.1 66.8-76.2 96.1c-.4 .6-.8 1.3-1.2 1.9c-17.5 28.3-33.5 54-63.5 81.5c-28.5 26.1-70.3 54.3-138.9 86.5C39.2 401 19.6 376.5 0 352zm79.3 99.1c66.6-31.8 109.5-60.6 140-88.6c33.3-30.5 51.3-59.4 68.7-87.6c.5-.8 1-1.7 1.6-2.5c17.8-28.7 35.9-57.2 70.8-89.4c32-29.6 78.6-62.8 152.9-101.5c20.9 26.2 41.9 52.3 62.8 78.5C397.6 249.2 367.1 301.4 338.8 350c-27.5 47.2-53 91-210.8 162L79.3 451.1z','M492.8 56.1c-72.8 38.4-120.4 72.2-154.2 103.4c-38.1 35.3-58.1 66.8-76.2 96.1l-1.2 1.9s0 0 0 0c-17.5 28.3-33.5 54-63.5 81.5c-28.5 26.1-70.3 54.3-138.9 86.5l20.5 25.7c66.6-31.8 109.5-60.6 140-88.6c33.3-30.5 51.3-59.4 68.7-87.6l1.6-2.5c17.8-28.7 35.9-57.2 70.8-89.4c32-29.6 78.6-62.8 152.9-101.5L492.8 56.1z']
      
    ]
  };

  

  
  

  var faTrashList = {
    prefix: 'fasds',
    iconName: 'trash-list',
    icon: [
      640,
      512,
      [],
      'e2b1',
      
      ['M32 96L56 512l304 0L384 96 32 96z','M288 0L128 0 112 32 0 32 0 96l424 0 0-64L304 32 288 0zM448 128l0 64 192 0 0-64-192 0zm0 128l0 64 160 0 0-64-160 0zm96 128l-96 0 0 64 96 0 0-64z']
      
    ]
  };

  

  
  

  var faMessageCaptions = {
    prefix: 'fasds',
    iconName: 'message-captions',
    icon: [
      512,
      512,
      ["comment-alt-captions"],
      'e1de',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM96 192l0 48 24 0 144 0 24 0 0-48-24 0-144 0-24 0zm0 80l0 48 24 0 48 0 24 0 0-48-24 0-48 0-24 0zm128 0l0 48 24 0 144 0 24 0 0-48-24 0-144 0-24 0zm96-80l0 48 24 0 48 0 24 0 0-48-24 0-48 0-24 0z','M96 192l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48zm224 0l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zM96 272l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm128 0l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  
    var faCommentAltCaptions = faMessageCaptions;
  

  
  

  var faSushi = {
    prefix: 'fasds',
    iconName: 'sushi',
    icon: [
      576,
      512,
      [127843,"nigiri"],
      'e48a',
      
      ['M32 374.8l250.1-86.7 261.9 87 0 8.9c0 35.3-28.7 64-64 64c-19.1 0-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7c-11.7 13.3-28.9 21.7-48 21.7s-36.3-8.4-48-21.7C132.3 439.6 115.1 448 96 448c-35.3 0-64-28.7-64-64l0-9.2z','M405.9 295.5L506.3 125.6c24.8 26.7 42.1 60.7 48.5 98.8L576 352 405.9 295.5zm76.2-191.9L374.8 285.2l-92.7-30.8L393.5 66.1c32.9 4.8 63.2 18 88.7 37.5zM246.6 64l110.9 0L235.6 270.4 96.1 318.7 246.6 64zm-37.2 0L49.4 334.9 0 352 21.3 224.4C36.6 132.2 116.1 64.6 209.5 64z']
      
    ]
  };

  
    var faNigiri = faSushi;
  

  
  

  var faBullseye = {
    prefix: 'fasds',
    iconName: 'bullseye',
    icon: [
      512,
      512,
      [],
      'f140',
      
      ['M112 256a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm224 0a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faArrowLeftToLine = {
    prefix: 'fasds',
    iconName: 'arrow-left-to-line',
    icon: [
      448,
      512,
      [8676,"arrow-to-left"],
      'f33e',
      
      ['M0 64L0 96 0 416l0 32 64 0 0-32L64 96l0-32L0 64z','M114.7 256l22.6-22.6 128-128L288 82.7 333.3 128l-22.6 22.6L237.3 224 416 224l32 0 0 64-32 0-178.7 0 73.4 73.4L333.3 384 288 429.3l-22.6-22.6-128-128L114.7 256z']
      
    ]
  };

  
    var faArrowToLeft = faArrowLeftToLine;
  

  
  

  var faLocationSmile = {
    prefix: 'fasds',
    iconName: 'location-smile',
    icon: [
      384,
      512,
      ["map-marker-smile"],
      'f60d',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm95.4 75.1c11.1-7.4 22.2-14.8 33.3-22.2c6.2 9.4 29.1 31.1 63.4 31.1s57.1-21.7 63.4-31.1c11.1 7.4 22.2 14.8 33.3 22.2C277.1 284.4 243.1 316 192 316s-85.1-31.6-96.6-48.9zM96 160c0-.3 0-.6 0 0zm128 0c0-.3 0-.6 0 0z','M160 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM95.4 267.1C106.9 284.4 140.9 316 192 316s85.1-31.6 96.6-48.9l-33.3-22.2c-6.2 9.4-29.1 31.1-63.4 31.1s-57.1-21.7-63.4-31.1L95.4 267.1z']
      
    ]
  };

  
    var faMapMarkerSmile = faLocationSmile;
  

  
  

  var faHelmetUn = {
    prefix: 'fasds',
    iconName: 'helmet-un',
    icon: [
      512,
      512,
      [],
      'e503',
      
      ['M215.7 384l2.7 0c3.1-5.3 6.2-10.6 9.3-15.9L242.3 343 320 416.9 320 288l48 0 0 174.5 1.6 1.5 70.4 0 24 0 0 48-24 0-80 0-9.6 0-6.9-6.6L215.7 384z','M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240L0 352l0 32 32 0 168 0 18.4 0 9.3-15.9L274.4 288 416 288l64 0 32 0 0-64-32 0-.5 0zM160 112l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-16 32 0 0 16 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64 0-16 32 0 0 16zM272 96l8 0 9.9 0 4.4 8.8L320 156.2l0-44.2 0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L288 163.8l0 44.2 0 16-32 0 0-16 0-96 0-16 16 0z']
      
    ]
  };

  

  
  

  var faUmbrellaBeach = {
    prefix: 'fasds',
    iconName: 'umbrella-beach',
    icon: [
      576,
      512,
      [127958],
      'f5ca',
      
      ['M214 448l68.1 0 75.1-206.3c-20-7.3-40.1-14.6-60.1-21.9L214 448z','M434 269.7L223.5 193l3.3-9.1c18.1-49.8 45.6-95.6 80.9-135.1l4-4.5C335 18.3 371.8 8.9 404.8 20.6c.9 .3 1.9 .7 2.8 1.1c31.9 12.6 53.3 43 54.4 77.4l.2 6c1.7 52.9-6.8 105.7-24.9 155.5l-3.3 9.1zM287.8 23.1l-4 4.5c-38 42.5-67.6 91.9-87.1 145.5l-3.3 9.1-105-38.2C131.5 59.7 217 7.7 308.4 4.9C300.9 10 294 16.1 287.8 23.1zM494 98.1c-.3-8.5-1.4-16.8-3.4-24.8c65.5 61 95.9 153.9 75.2 244.3l-101.7-37 3.3-9.1c19.5-53.6 28.6-110.4 26.8-167.4l-.2-6zM32 448l512 0 32 0 0 64-32 0L32 512 0 512l0-64 32 0z']
      
    ]
  };

  

  
  

  var faBrainArrowCurvedRight = {
    prefix: 'fasds',
    iconName: 'brain-arrow-curved-right',
    icon: [
      640,
      512,
      ["mind-share"],
      'f677',
      
      ['M0 304c0 34.2 21.4 63.4 51.6 74.8C49.3 385.4 48 392.6 48 400c0 35.3 28.7 64 64 64c5.6 0 11.1-.7 16.3-2.1c2.9 28.2 26.8 50.1 55.7 50.1l56 0 0-56 0-400 0-56L184 0c-28.9 0-52.7 21.9-55.7 49.9C100.6 56.9 80 82.1 80 112c0 6 .8 11.9 2.4 17.4C53.6 135.7 32 161.3 32 192c0 15 5.1 28.8 13.8 39.7C18.7 244.5 0 272.1 0 304zM272 0l0 56 0 400 0 56 56 0c5.7 0 11.2-.8 16.3-2.4C325.1 490 304 458.7 304 416c0-79.5 64.5-144 144-144l32 0 0-32c-4.3-3.2-8.9-6-13.8-8.3C474.9 220.8 480 207 480 192c0-30.7-21.6-56.3-50.4-62.6c1.6-5.5 2.4-11.4 2.4-17.4c0-29.9-20.6-55.1-48.3-62.1C380.6 21.9 356.9 0 328 0L272 0z','M640 352L528 240l-16 0 0 64-64 0c-61.9 0-112 50.1-112 112c0 64 64 96 64 96l0-48c0-35.3 28.7-64 64-64l48 0 0 64 16 0L640 352z']
      
    ]
  };

  
    var faMindShare = faBrainArrowCurvedRight;
  

  
  

  var fa6 = {
    prefix: 'fasds',
    iconName: '6',
    icon: [
      320,
      512,
      [],
      '36',
      
      ['M160 416a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM253 32L156.5 160c1.2 0 2.3 0 3.5 0c88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-38.1 12.4-75.2 35.3-105.6L172.8 32 253 32z','']
      
    ]
  };

  

  
  

  var faCreditCardFront = {
    prefix: 'fasds',
    iconName: 'credit-card-front',
    icon: [
      576,
      512,
      [],
      'f38a',
      
      ['M96 288l0 32 384 0 0-32L96 288zm0 64l0 32 96 0 0-32-96 0zm128 0l0 32 160 0 0-32-160 0z','M0 32l576 0 0 448L0 480 0 32zM480 288L96 288l0 32 384 0 0-32zM96 352l0 32 96 0 0-32-96 0zm128 0l0 32 160 0 0-32-160 0zM512 96L384 96l0 96 128 0 0-96z']
      
    ]
  };

  

  
  

  var faBatteryLow = {
    prefix: 'fasds',
    iconName: 'battery-low',
    icon: [
      576,
      512,
      ["battery-1"],
      'e0b1',
      
      ['M0 96l64 0 416 0 64 0 0 64 0 32 32 0 0 128-32 0 0 32 0 64-64 0L64 416 0 416l0-64L0 160 0 96zm64 64l0 192 416 0 0-192L64 160z','M96 192h64v128H96V192z']
      
    ]
  };

  
    var faBattery1 = faBatteryLow;
  

  
  

  var faAlignJustify = {
    prefix: 'fasds',
    iconName: 'align-justify',
    icon: [
      448,
      512,
      [],
      'f039',
      
      ['M0 32L0 96l448 0 0-64L0 32zM0 288l0 64 448 0 0-64L0 288z','M448 480L0 480l0-64 448 0 0 64zm0-256L0 224l0-64 448 0 0 64z']
      
    ]
  };

  

  
  

  var faFanTable = {
    prefix: 'fasds',
    iconName: 'fan-table',
    icon: [
      448,
      512,
      [],
      'e004',
      
      ['M16 208c0 104 76.3 190.2 176 205.6l0 34.4 32 0 32 0 0-34.4C355.7 398.2 432 312 432 208C432 93.1 338.9 0 224 0S16 93.1 16 208zm96.9 116.2c24.9-31.8 49.7-63.7 74.6-95.5c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7c4.9-2 9.9-4 14.8-6C194 91.1 209.2 128.6 224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4c-.7 5.3-1.5 10.6-2.2 15.8l-120-16.9c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2l-12.6-9.8z','M178.9 53.7L224.3 166c18.5-25.3 50-39.8 83.3-35.1c48.1 6.8 81.7 51.3 74.9 99.4l-2.2 15.8-120-16.9c12.6 28.7 9.5 63.2-11.2 89.7c-29.9 38.3-85.2 45.1-123.5 15.2l-12.6-9.8 74.6-95.5c-31.2-3.4-59.5-23.4-72.1-54.5C97.2 129.1 119 77.9 164.1 59.7l14.8-6zM240 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM96 448l128 0 128 0 32 0 0 64-32 0-128 0L96 512l-32 0 0-64 32 0z']
      
    ]
  };

  

  
  

  var faBookmark = {
    prefix: 'fasds',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      ['M96 0l0 352 96-64 96 64L288 0 96 0z','M384 0l0 512L192 400 0 512 0 0 96 0l0 352 96-64 96 64L288 0l96 0z']
      
    ]
  };

  

  
  

  var faSemicolon = {
    prefix: 'fasds',
    iconName: 'semicolon',
    icon: [
      192,
      512,
      [],
      '3b',
      
      ['M16 512l64 0 80-224L48 288 16 512z','M32 64H160V192H32V64z']
      
    ]
  };

  

  
  

  var faSquareExclamation = {
    prefix: 'fasds',
    iconName: 'square-exclamation',
    icon: [
      448,
      512,
      ["exclamation-square"],
      'f321',
      
      ['M0 32L0 480l448 0 0-448L0 32zm200 96l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M248 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faExclamationSquare = faSquareExclamation;
  

  
  

  var faTrainSubwayTunnel = {
    prefix: 'fasds',
    iconName: 'train-subway-tunnel',
    icon: [
      512,
      512,
      ["subway-tunnel"],
      'e2a3',
      
      ['M0 256L0 512l105.4 0 64-64L112 448l0-320 288 0 0 320-57.4 0 64 64L512 512l0-256C512 114.6 397.4 0 256 0S0 114.6 0 256zM150.6 512l210.7 0-64-64-82.7 0-64 64zM160 192l0 128 80 0 0-128-80 0zm112 0l0 128 80 0 0-128-80 0z','M112 128l288 0 0 320-288 0 0-320zm48 64l0 128 80 0 0-128-80 0zm112 0l0 128 80 0 0-128-80 0zM184 400a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  
    var faSubwayTunnel = faTrainSubwayTunnel;
  

  
  

  var faSquareUp = {
    prefix: 'fasds',
    iconName: 'square-up',
    icon: [
      448,
      512,
      [11014,"arrow-alt-square-up"],
      'f353',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 224L224 96 352 224l0 32-80 0c0 42.7 0 85.3 0 128l-96 0 0-128-80 0 0-32z','M272 256l80 0 0-32L224 96 96 224l0 32 80 0 0 128 96 0 0-128z']
      
    ]
  };

  
    var faArrowAltSquareUp = faSquareUp;
  

  
  

  var faFaceHoldingBackTears = {
    prefix: 'fasds',
    iconName: 'face-holding-back-tears',
    icon: [
      512,
      512,
      [129401],
      'e482',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm78.1-93.9c5.3-.7 10.6-1.3 15.9-2c3.8-.5 7.7-1 11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9c.5-1.7 1-3.4 1.5-5.2c1.5-5.1 2.9-10.3 4.4-15.4c10.3 2.9 20.5 5.9 30.8 8.8l-4.4 15.4-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6l0 32 0 16 0 16 0 16-32 0 0-16c-13.4 10-30 16-48 16c-11.4 0-22.2-2.4-32-6.7l0 6.7 0 16-32 0 0-16 0-32c-10-13.4-16-30-16-48c0-17.9 5.9-34.5 15.9-47.9c-4.6 .6-9.2 1.1-13.8 1.7c-1.3-10.6-2.6-21.2-4-31.8zm79.6 213l28.6-14.3C192.4 373 215.6 400 256 400s63.6-27 69.7-39.2l28.6 14.3C344.4 395 311.6 432 256 432s-88.4-37-98.3-56.8zM272 240c0-41.4 31.4-75.4 72-79.6c-10-10.8-17.6-24.1-21.9-38.8c-.5-1.7-1-3.4-1.5-5.2c-1.5-5.1-2.9-10.3-4.4-15.4c10.3-2.9 20.5-5.9 30.8-8.8l4.4 15.4 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9c3.8 .5 7.7 1 11.5 1.4c5.3 .7 10.6 1.3 15.9 2l-4 31.8c-4.6-.6-9.2-1.1-13.8-1.7c10 13.3 15.9 29.9 15.9 47.9c0 18-6 34.6-16 48l0 32 0 16-32 0 0-16 0-6.7c-9.8 4.3-20.6 6.7-32 6.7c-44.2 0-80-35.8-80-80z','M191.4 116.4l4.4-15.4L165 92.2l-4.4 15.4-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1l-15.9 2 4 31.8 15.9-2 11.5-1.4c38.2-4.8 69.8-31.9 80.4-68.9l1.5-5.2zm129.2 0l1.5 5.2c10.6 37 42.2 64.1 80.4 68.9l11.5 1.4 15.9 2 4-31.8-15.9-2-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2L347 92.2 316.2 101l4.4 15.4zM128 232c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8c0 17.7-14.3 32-32 32zm224-32c0 17.7-14.3 32-32 32c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8z']
      
    ]
  };

  

  
  

  var faBowlSoftServe = {
    prefix: 'fasds',
    iconName: 'bowl-soft-serve',
    icon: [
      512,
      512,
      [],
      'e46b',
      
      ['M32 240l0 80 16 0 16 0 384 0 16 0 16 0 0-80c0-41.7-32-76-72.8-79.7c5.6-9.5 8.8-20.5 8.8-32.3C416 57.3 358.7 0 288 0L256 0l10.8 16.3c3.4 5 5.2 11 5.2 17c0 17-13.7 30.7-30.7 30.7L160 64c-35.3 0-64 28.7-64 64c0 11.8 3.2 22.8 8.8 32.3C64 164 32 198.3 32 240z','M48 320l16 0 384 0 16 0 0 16 0 8c0 57.4-46.6 104-104 104l-32 0 24 64-192 0 24-64-32 0C94.6 448 48 401.4 48 344l0-8 0-16z']
      
    ]
  };

  

  
  

  var faBaguette = {
    prefix: 'fasds',
    iconName: 'baguette',
    icon: [
      640,
      512,
      [129366],
      'e3d8',
      
      ['M0 384.1c0 24.4 7 49.1 21.5 70.9c24.7 37 65.3 57 106.6 57c24.4 0 49.1-7 70.9-21.5l384-256c58.8-39.2 74.7-118.7 35.5-177.5S499.8-17.7 441 21.5L356.5 77.8c23.6 23.6 47.2 47.2 70.8 70.8c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3L329.3 95.9c-29.4 19.6-58.7 39.1-88 58.7c24.7 24.7 49.4 49.4 74 74c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3-78.6-78.6c-29.4 19.6-58.7 39.1-88 58.7c25.8 25.8 51.5 51.5 77.2 77.2c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6l-11.3-11.3c-27.3-27.3-54.5-54.5-81.8-81.8c-14 9.3-28 18.6-41.9 28C20 302.2 0 342.8 0 384.1z','M356.5 77.8L329.3 95.9l75.4 75.4L416 182.6 438.6 160l-11.3-11.3L356.5 77.8zM126.1 231.4L98.9 249.5l81.8 81.8L192 342.6 214.6 320l-11.3-11.3-77.2-77.2zm115.2-76.8l-27.2 18.1 78.6 78.6L304 262.6 326.6 240l-11.3-11.3-74-74z']
      
    ]
  };

  

  
  

  var faBarcodeRead = {
    prefix: 'fasds',
    iconName: 'barcode-read',
    icon: [
      576,
      512,
      [],
      'f464',
      
      ['M0 0L0 24 0 136l0 24 48 0 0-24 0-88 88 0 24 0 0-48L136 0 24 0 0 0zM0 352l0 24L0 488l0 24 24 0 112 0 24 0 0-48-24 0-88 0 0-88 0-24L0 352zM416 0l0 48 24 0 88 0 0 88 0 24 48 0 0-24 0-112 0-24L552 0 440 0 416 0zm0 464l0 48 24 0 112 0 24 0 0-24 0-112 0-24-48 0 0 24 0 88-88 0-24 0z','M192 128l-64 0 0 256 64 0 0-256zm160 0l-64 0 0 256 64 0 0-256zm32 0l0 256 64 0 0-256-64 0zm-128 0l-32 0 0 256 32 0 0-256z']
      
    ]
  };

  

  
  

  var faArrowUpBigSmall = {
    prefix: 'fasds',
    iconName: 'arrow-up-big-small',
    icon: [
      576,
      512,
      ["sort-size-up"],
      'f88e',
      
      ['M320 32l0 224 224 0 0-224L320 32zm0 288l0 160 160 0 0-160-160 0z','M160 32.4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L192 162.8 192 448l0 32-64 0 0-32 0-285.2-24.3 26.8L82.2 213.2 34.8 170.2l21.5-23.7 80-88 23.7-26z']
      
    ]
  };

  
    var faSortSizeUp = faArrowUpBigSmall;
  

  
  

  var faMoneyBill = {
    prefix: 'fasds',
    iconName: 'money-bill',
    icon: [
      576,
      512,
      [],
      'f0d6',
      
      ['M64 192l0 128c35.3 0 64 28.7 64 64l320 0c0-35.3 28.7-64 64-64l0-128c-35.3 0-64-28.7-64-64l-320 0c0 35.3-28.7 64-64 64zm320 64a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z','M576 64L0 64 0 448l576 0 0-384zM448 128c0 35.3 28.7 64 64 64l0 128c-35.3 0-64 28.7-64 64l-320 0c0-35.3-28.7-64-64-64l0-128c35.3 0 64-28.7 64-64l320 0z']
      
    ]
  };

  

  
  

  var faHandPointUp = {
    prefix: 'fasds',
    iconName: 'hand-point-up',
    icon: [
      384,
      512,
      [9757],
      'f0a6',
      
      ['M0 272l0 91c0 33.9 13.5 66.5 37.5 90.5l11.6 11.6c30 30 70.7 46.9 113.1 46.9l61.7 0c88.4 0 160-71.6 160-160l-96 0 0-32-64 0 0 48 0 16-16 0L96 384l-16 0 0-32 16 0 96 0 0-32 0-48L0 272zM32 0l0 240 64 0L96 0 32 0z','M128 128l64 0 0 112-64 0 0-112zm96 32l64 0 0 128-64 0 0-128zm160 32l0 128-64 0 0-128 64 0z']
      
    ]
  };

  

  
  

  var faSquareJ = {
    prefix: 'fasds',
    iconName: 'square-j',
    icon: [
      448,
      512,
      [],
      'e273',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 256l48 0 0 24 0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136 0-24 48 0 0 24 0 136c0 53-43 96-96 96s-96-43-96-96l0-8 0-24z','M304 128l0 24 0 136c0 53-43 96-96 96s-96-43-96-96l0-8 0-24 48 0 0 24 0 8c0 26.5 21.5 48 48 48s48-21.5 48-48l0-136 0-24 48 0z']
      
    ]
  };

  

  
  

  var faBagShoppingPlus = {
    prefix: 'fasds',
    iconName: 'bag-shopping-plus',
    icon: [
      448,
      512,
      [],
      'e651',
      
      ['M0 160l112 0 48 0 128 0 48 0 112 0 0 352L0 512 0 160zM120 312l0 48 24 0 56 0 0 56 0 24 48 0 0-24 0-56 56 0 24 0 0-48-24 0-56 0 0-56 0-24-48 0 0 24 0 56-56 0-24 0z','M224 48c-35.3 0-64 28.7-64 64l0 48-48 0 0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48-48 0 0-48c0-35.3-28.7-64-64-64zM120 312l24 0 56 0 0-56 0-24 48 0 0 24 0 56 56 0 24 0 0 48-24 0-56 0 0 56 0 24-48 0 0-24 0-56-56 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faSquareDashed = {
    prefix: 'fasds',
    iconName: 'square-dashed',
    icon: [
      448,
      512,
      [],
      'e269',
      
      ['M0 32L0 64l0 96 64 0 0-64 64 0 0-64L32 32 0 32zM0 352l0 96 0 32 32 0 96 0 0-64-64 0 0-64L0 352zM320 32l0 64 64 0 0 64 64 0 0-96 0-32-32 0-96 0zm0 384l0 64 96 0 32 0 0-32 0-96-64 0 0 64-64 0z','M0 192L0 320l64 0 0-128L0 192zm384 0l0 128 64 0 0-128-64 0zM288 480l0-64-128 0 0 64 128 0zM160 96l128 0 0-64L160 32l0 64z']
      
    ]
  };

  

  
  

  var faFaceFrownOpen = {
    prefix: 'fasds',
    iconName: 'face-frown-open',
    icon: [
      512,
      512,
      [128550,"frown-open"],
      'f57a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zM152 398.6c4.7-53 49.3-94.6 103.6-94.6s98.8 41.6 103.6 94.6C330.1 379.4 294.3 368 255.6 368s-74.5 11.4-103.6 30.6zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faFrownOpen = faFaceFrownOpen;
  

  
  

  var faFileVector = {
    prefix: 'fasds',
    iconName: 'file-vector',
    icon: [
      384,
      512,
      [],
      'e64c',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM64 192l0 64 32 0 0 128-32 0 0 64 64 0 0-32 128 0 0 32 64 0 0-64-32 0 0-128 32 0 0-64-64 0 0 32-128 0 0-32-64 0zm64 64l128 0 0 128-128 0 0-128z','M384 160l-160 0L224 0 384 160zM128 192l0 32 128 0 0-32 64 0 0 64-32 0 0 128 32 0 0 64-64 0 0-32-128 0 0 32-64 0 0-64 32 0 0-128-32 0 0-64 64 0zM256 384l0-128-128 0 0 128 128 0z']
      
    ]
  };

  

  
  

  var faTally1 = {
    prefix: 'fasds',
    iconName: 'tally-1',
    icon: [
      640,
      512,
      [],
      'e294',
      
      ['','M160 32l0 32 0 384 0 32-64 0 0-32L96 64l0-32 64 0z']
      
    ]
  };

  

  
  

  var faPooStorm = {
    prefix: 'fasds',
    iconName: 'poo-storm',
    icon: [
      448,
      512,
      ["poo-bolt"],
      'f75a',
      
      ['M96 360l0 24 88 0L144 512 320 376l0-24-88 0 40-128L96 360z','M320 96c0-53-48-96-112-96c0 0 64 96-48 128l-32 0c-35.3 0-64 28.7-64 64c0 12.7 3.7 24.6 10.1 34.5C31.6 236.4 0 274.5 0 320l0 64 64 0 0-39.7L264.6 192l51 0-40 128 76.5 0 0 64 96 0 0-64c0-45.5-31.6-83.6-74.1-93.5c6.4-10 10.1-21.8 10.1-34.5c0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32z']
      
    ]
  };

  
    var faPooBolt = faPooStorm;
  

  
  

  var faCapsules = {
    prefix: 'fasds',
    iconName: 'capsules',
    icon: [
      576,
      512,
      [],
      'f46b',
      
      ['M0 144l0 48 0 64c10.7 0 21.3 0 32 0s21.3 0 32 0c32 0 64 0 96 0c10.7 0 21.3 0 32 0s21.3 0 32 0l0-64 0-48c0-61.9-50.1-112-112-112S0 82.1 0 144zM256 98.3l0 163.9 53.1 77.5c17.5-12.2 35-24.5 52.4-36.7c26.6-18.6 53.3-37.3 79.9-55.9l52.4-36.7c-22.2-32.4-44.4-64.7-66.6-97.1C391.8 61.5 321.9 49 271.3 85.2c-5.6 4-10.7 8.4-15.3 13.1z','M372.3 431.7l-63.1-92L361.6 303s0 0 0 0l79.9-55.9s0 0 0 0l52.4-36.7 61.9 90.2c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1zm116.4-22.4c.8-.5 1.6-1 2.4-1.6c.5-.4 1.1-.8 1.6-1.2l-4 2.8zM0 256l32 0 32 0 96 0 32 0 32 0 0 64 0 48c0 61.9-50.1 112-112 112S0 429.9 0 368l0-48 0-64z']
      
    ]
  };

  

  
  

  var faDonut = {
    prefix: 'fasds',
    iconName: 'donut',
    icon: [
      512,
      512,
      [127849,"doughnut"],
      'e406',
      
      ['M0 296l0 8c0 88.4 114.6 160 256 160s256-71.6 256-160l0-8c-16 8-32 16-48 24l-48 48-80 8-80 24-80-24-80-8L48 320c-16-8-32-16-48-24zM105.4 144c7.5 7.5 15.1 15.1 22.6 22.6c3.8-3.8 7.5-7.5 11.3-11.3c10.7-10.7 21.3-21.3 32-32c3.8-3.8 7.5-7.5 11.3-11.3c-7.5-7.5-15.1-15.1-22.6-22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-10.7 10.7-21.3 21.3-32 32c-3.8 3.8-7.5 7.5-11.3 11.3zm160 160L288 326.6c3.8-3.8 7.5-7.5 11.3-11.3c10.7-10.7 21.3-21.3 32-32c3.8-3.8 7.5-7.5 11.3-11.3L320 249.4c-3.8 3.8-7.5 7.5-11.3 11.3c-10.7 10.7-21.3 21.3-32 32c-3.8 3.8-7.5 7.5-11.3 11.3zm96-160c3.8 3.8 7.5 7.5 11.3 11.3c10.7 10.7 21.3 21.3 32 32c3.8 3.8 7.5 7.5 11.3 11.3c7.5-7.5 15.1-15.1 22.6-22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-10.7-10.7-21.3-21.3-32-32c-3.8-3.8-7.5-7.5-11.3-11.3c-7.5 7.5-15.1 15.1-22.6 22.6z','M96 368L48 320 0 296l0-88C0 119.6 114.6 48 256 48s256 71.6 256 160l0 88-48 24-48 48-80 8-80 24-80-24-80-8zM294.6 96L272 73.4 260.7 84.7l-16 16L233.4 112 256 134.6l11.3-11.3 16-16L294.6 96zm-112 16L160 89.4l-11.3 11.3-32 32L105.4 144 128 166.6l11.3-11.3 32-32L182.6 112zM384 121.4L361.4 144l11.3 11.3 32 32L416 198.6 438.6 176l-11.3-11.3-32-32L384 121.4zM48 192l0 32 16 0 32 0 16 0 0-32-16 0-32 0-16 0zm336 25.4L361.4 240l11.3 11.3 32 32L416 294.6 438.6 272l-11.3-11.3-32-32L384 217.4zm-240 16L121.4 256l11.3 11.3 32 32L176 310.6 198.6 288l-11.3-11.3-32-32L144 233.4zM342.6 272L320 249.4l-11.3 11.3-32 32L265.4 304 288 326.6l11.3-11.3 32-32L342.6 272zM256 224c35.3 0 64-14.3 64-32s-28.7-32-64-32s-64 14.3-64 32s28.7 32 64 32z']
      
    ]
  };

  
    var faDoughnut = faDonut;
  

  
  

  var faDongSign = {
    prefix: 'fasds',
    iconName: 'dong-sign',
    icon: [
      384,
      512,
      [],
      'e169',
      
      ['M0 448l0 64 384 0 0-64L0 448zM192 64l0 64 64 0 0-64-64 0zm128 0l0 64 32 0 0-64-32 0z','M320 32l-64 0 0 145.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c23.3 0 45.2-6.2 64-17.1l0 17.1 64 0 0-128 0-256zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z']
      
    ]
  };

  

  
  

  var faTemperatureHalf = {
    prefix: 'fasds',
    iconName: 'temperature-half',
    icon: [
      320,
      512,
      [127777,"temperature-2","thermometer-2","thermometer-half"],
      'f2c9',
      
      ['M16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L272 64l0-64L208 0 112 0 48 0l0 64 0 213.5C28 302.2 16 333.7 16 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L112 300.2l0-22.7L112 64l96 0 0 213.5 0 22.7 14.2 17.6C233.4 331.5 240 348.9 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M176 208l0-16-32 0 0 16 0 114.8c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L176 208z']
      
    ]
  };

  
    var faTemperature2 = faTemperatureHalf;
  
    var faThermometer2 = faTemperatureHalf;
  
    var faThermometerHalf = faTemperatureHalf;
  

  
  

  var faCommentImage = {
    prefix: 'fasds',
    iconName: 'comment-image',
    icon: [
      512,
      512,
      [],
      'e148',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm96 48l64-64 35.5 40.6L296 144 416 288l0 32L96 320l0-32zm96-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M96 288v32H416V288L296 144 195.5 264.6 160 224 96 288z']
      
    ]
  };

  

  
  

  var faEscalator = {
    prefix: 'fasds',
    iconName: 'escalator',
    icon: [
      640,
      512,
      [],
      'e171',
      
      ['M32 384l0 128 64 0 96 0 24 0 18.1-15.8L472 288l72 0 64 0 0-128-64 0-96 0-24 0-18.1 15.8L168 384l-72 0-64 0z','M256 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm64 128l0 80.4-128 112L192 128l128 0z']
      
    ]
  };

  

  
  

  var faCarWash = {
    prefix: 'fasds',
    iconName: 'car-wash',
    icon: [
      448,
      512,
      [],
      'f5e6',
      
      ['M16 80c0 26.5 21.5 48 48 48s48-16 48-48S64 0 64 0s-48 48-48 80zm160 0c0 26.5 21.5 48 48 48s48-16 48-48s-48-80-48-80s-48 48-48 80zm160 0c0 26.5 21.5 48 48 48s48-16 48-48s-48-80-48-80s-48 48-48 80z','M128 160l-21.1 0-8.3 19.4L52 288l-36 0 0 96 0 64 0 64 80 0 0-64 256 0 0 64 80 0 0-64 0-64 0-96-36 0L349.4 179.4 341.1 160 320 160l-192 0zM326.3 288l-204.7 0 27.4-64 149.8 0 27.4 64zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faNotesMedical = {
    prefix: 'fasds',
    iconName: 'notes-medical',
    icon: [
      512,
      512,
      [],
      'f481',
      
      ['M96 32l384 0 0 288-96 96L96 416 96 32zm96 160l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0z','M296 464l24 0 0 48-24 0L24 512 0 512l0-24L0 152l0-24 48 0 0 24 0 312 248 0zM256 128l64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0 0-64z']
      
    ]
  };

  

  
  

  var faSlotMachine = {
    prefix: 'fasds',
    iconName: 'slot-machine',
    icon: [
      640,
      512,
      [],
      'e3ce',
      
      ['M0 96L0 416l64 0 384 0 64 0 0-320L0 96zm56 80l24 0 72 0 24 0 0 24 0 8 0 5.3-2.2 4.8L119.4 336l-52.9 0 3.7-8.1 48-103.9L80 224l-24 0 0-48zm144 0l24 0 72 0 24 0 0 24 0 8 0 5.3-2.2 4.8L263.4 336l-52.9 0 3.7-8.1 48-103.9L224 224l-24 0 0-48zm144 0l24 0 72 0 24 0 0 24 0 8 0 5.3-2.2 4.8L407.4 336l-52.9 0 3.7-8.1 48-103.9L368 224l-24 0 0-48z','M448 0l0 64L64 64 64 0 448 0zM640 176c0 14.2-6.2 27-16 35.8L624 480l0 32-32 0-144 0-32 0L64 512l0-96 384 0 0 32 112 0 0-236.2c-9.8-8.8-16-21.6-16-35.8c0-26.5 21.5-48 48-48s48 21.5 48 48z']
      
    ]
  };

  

  
  

  var faWineGlassCrack = {
    prefix: 'fasds',
    iconName: 'wine-glass-crack',
    icon: [
      320,
      512,
      ["fragile"],
      'f4bb',
      
      ['M14.5 192.7C20.3 128.4 26.2 64.2 32 0L136 0l32 48L80 104 200 224 160 120l80-56L208 0l80 0 17.5 192.7c.4 4.5 .6 9 .6 13.4c0 68.9-48.4 127.7-114.1 142.4l0 99.5 80 0 0 64-112 0L48 512l0-64 80 0 0-99.5C58 332.9 7.7 267.3 14.5 192.7z','M80 104L200 224 160 120l80-56L208 0H136l32 48L80 104z']
      
    ]
  };

  
    var faFragile = faWineGlassCrack;
  

  
  

  var faG = {
    prefix: 'fasds',
    iconName: 'g',
    icon: [
      448,
      512,
      [103],
      '47',
      
      ['M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128L224 288l0-64 192 0 32 0 0 32c0 123.7-100.3 224-224 224S0 379.7 0 256S100.3 32 224 32c70.8 0 134 32.9 175 84.1l-50 40C319.6 119.4 274.6 96 224 96z','']
      
    ]
  };

  

  
  

  var faWhistle = {
    prefix: 'fasds',
    iconName: 'whistle',
    icon: [
      640,
      512,
      [],
      'f460',
      
      ['M32 256c0-23.6 4.3-46.3 12.1-67.2c6.1-16.3 14.4-31.6 24.4-45.5c3.6-5 7.4-9.7 11.5-14.3c11.4-12.9 24.5-24.3 39-33.8C149.2 75.5 185.2 64 224 64c46.6 0 91.9 15.7 128.5 44.7l78.1 61.8L416 224l32 24 45.9-27.5L640 336 536 448 380.7 367c-34.8 49-92 81-156.7 81C118 448 32 362 32 256zm128 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M0 128c0 28.4 18.5 52.5 44.1 60.8c6.1-16.3 14.4-31.6 24.4-45.5c-1.4 .4-2.9 .6-4.5 .6c-8.8 0-16-7.2-16-16s7.2-16 16-16s16 7.2 16 16c0 .3 0 .7 0 1c11.4-12.9 24.5-24.3 39-33.8C107.8 76.5 87.4 64 64 64C28.7 64 0 92.7 0 128zM224 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fasds',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      ['M160 224l32 0 192 0 32 0 0 64-32 0-192 0-32 0 0-64z','M160 96C71.6 96 0 167.6 0 256s71.6 160 160 160l64 0 32 0 0-64-32 0-64 0c-53 0-96-43-96-96s43-96 96-96l64 0 32 0 0-64-32 0-64 0zm256 0l-64 0-32 0 0 64 32 0 64 0c53 0 96 43 96 96s-43 96-96 96l-64 0-32 0 0 64 32 0 64 0c88.4 0 160-71.6 160-160s-71.6-160-160-160z']
      
    ]
  };

  

  
  

  var faMonitorWaveform = {
    prefix: 'fasds',
    iconName: 'monitor-waveform',
    icon: [
      576,
      512,
      ["monitor-heart-rate"],
      'f611',
      
      ['M64 96l0 160 128 0 9.9 0 4.4 8.8L224 300.2l49.7-99.4L288 172.2l14.3 28.6L329.9 256l70.1 0 16 0 0 32-16 0-80 0-9.9 0-4.4-8.8L288 243.8l-49.7 99.4L224 371.8l-14.3-28.6L182.1 288 64 288l0 128 448 0 0-320L64 96z','M576 32L0 32 0 480l576 0 0-448zM512 96l0 320L64 416 64 96l448 0z']
      
    ]
  };

  
    var faMonitorHeartRate = faMonitorWaveform;
  

  
  

  var faQ = {
    prefix: 'fasds',
    iconName: 'q',
    icon: [
      448,
      512,
      [113],
      '51',
      
      ['M64 256c0 88.4 71.6 160 160 160c25.3 0 49.2-5.9 70.5-16.3L194.9 256l77.9 0 72.4 104.5c24.2-28 38.8-64.5 38.8-104.5c0-88.4-71.6-160-160-160S64 167.6 64 256zM331.3 452.7C299.4 470.1 262.9 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 61.8-25 117.8-65.5 158.3l66.2 95.5 1.5 2.2-77.9 0-41.1-59.3z','']
      
    ]
  };

  

  
  

  var faHorse = {
    prefix: 'fasds',
    iconName: 'horse',
    icon: [
      576,
      512,
      [128014],
      'f6f0',
      
      ['M0 256l0 56 0 24 48 0 0-24 0-56c0-13.4 6.6-25.2 16.7-32.5c-.4-3.5-.7-7.1-.7-10.7c0-1 0-2 .1-3s.1-2 .2-3c.1-2 .3-3.9 .6-5.9c.5-3.9 1.4-7.7 2.4-11.4c2.1-7.4 5.2-14.4 9.1-20.8C33.2 174.5 0 211.4 0 256z','M448 238.1l0-78.1 16 0 32 64 80-32 0-128L544 32l16 0 16 0 0-32L560 0 480 0 448 0C377.3 0 320 57.3 320 128l-64 0-52.8 0-54.4 0C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l42.4 63.6L94.1 350.1l-21 21 9.4 28.1L120.1 512l101.2 0L182.9 397l27-27L224 355.9l0-19.9 0-16 83.7 23.9c4.1 1.2 8.2 2.1 12.3 2.8L320 512l96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faDialMed = {
    prefix: 'fasds',
    iconName: 'dial-med',
    icon: [
      576,
      512,
      [],
      'e15f',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M264 129c-77 11.6-136 78-136 158.2c0 88.4 71.6 160 160 160s160-71.6 160-160C448 207 389 140.6 312 129l0 158.2 0 24-48 0 0-24L264 129z']
      
    ]
  };

  

  
  

  var faAngleRight = {
    prefix: 'fasds',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      ['M301.3 256l-22.6 22.6-160 160L96 461.3 50.7 416l22.6-22.6L210.7 256 73.4 118.6 50.7 96 96 50.7l22.6 22.6 160 160L301.3 256z','']
      
    ]
  };

  

  
  

  var faBellOn = {
    prefix: 'fasds',
    iconName: 'bell-on',
    icon: [
      640,
      512,
      [128365],
      'f8fa',
      
      ['M96 368l0 48 448 0 0-48-64-72 0-88c0-77.4-55-142-128-156.8L352 0 288 0l0 51.2C215 66 160 130.6 160 208l0 88L96 368z','M608.2 50.7L586.7 61.5l-64 32-21.5 10.7L479.8 61.3l21.5-10.7 64-32L586.7 7.8l21.5 42.9zM0 176l24 0 80 0 24 0 0 48-24 0-80 0L0 224l0-48zM384 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0 64 0zM536 176l80 0 24 0 0 48-24 0-80 0-24 0 0-48 24 0zM53.3 61.5L31.8 50.7 53.3 7.8 74.7 18.5l64 32 21.5 10.7-21.5 42.9L117.3 93.5l-64-32z']
      
    ]
  };

  

  
  

  var faFilters = {
    prefix: 'fasds',
    iconName: 'filters',
    icon: [
      640,
      512,
      [],
      'e17e',
      
      ['M0 96l160 0 0 13.3 9.4 9.4L320 269.3l0 18.7-32 32 0 192L160 416l0-96L0 160 0 96z','M352 384V256L192 96V32H640V96L480 256V480L352 384z']
      
    ]
  };

  

  
  

  var faMugMarshmallows = {
    prefix: 'fasds',
    iconName: 'mug-marshmallows',
    icon: [
      512,
      512,
      [],
      'f7b7',
      
      ['M32 32l194.7 0-73.4 73.4L130.7 128 32 128l0-96zM96 160l64 0 0 96-64 0 0-96zm80-32l96-96 96 96-192 0z','M96 160L0 160 0 480l384 0 0-96 16 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-16 0-32 0-192 0 0 96-64 0 0-96zM384 320l0-96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0z']
      
    ]
  };

  

  
  

  var faHorseSaddle = {
    prefix: 'fasds',
    iconName: 'horse-saddle',
    icon: [
      576,
      512,
      [],
      'f8c3',
      
      ['M0 256c0-44.6 33.2-81.5 76.3-87.2c-3.9 6.4-7 13.4-9.1 20.8c-1.1 3.7-1.9 7.5-2.4 11.4c-.3 1.9-.5 3.9-.6 5.9c-.1 1-.1 2-.2 3s-.1 2-.1 3c0 3.6 .2 7.1 .7 10.7C54.6 230.8 48 242.6 48 256l0 56 0 24L0 336l0-24 0-56zM160 128l160 0 0 48c0 38.7-27.5 71-64 78.4l0 73.6 0 1.1 0 14.9-32 0 0-8 0-8 0-8 0-65.6c-36.5-7.4-64-39.7-64-78.4l0-48z','M448 238.1l0-78.1 16 0 32 64 80-32 0-128L544 32l16 0 16 0 0-32L560 0 480 0 448 0C377.3 0 320 57.3 320 128l0 48c0 38.7-27.5 71-64 78.4l0 73.6 0 1.1 51.7 14.8c4.1 1.2 8.2 2.1 12.3 2.8L320 512l96 0 0-196.3c19.2-19.2 31.5-45.7 32-75.7c0 0 0 0 0 0l0-1.9zM224 254.4c-36.5-7.4-64-39.7-64-78.4l0-48-11.2 0C102 128 64 166 64 212.8c0 16.8 5 33.1 14.2 47.1l42.4 63.6L94.1 350.1l-21 21 9.4 28.1L120.1 512l101.2 0L182.9 397l27-27L224 355.9l0-11.9 0-8 0-8 0-8 0-65.6zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faJoint = {
    prefix: 'fasds',
    iconName: 'joint',
    icon: [
      640,
      512,
      [],
      'f595',
      
      ['M384 0l0 43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9l0 43 64 0 0-43c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43l0-43L384 0zm96 0l0 43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8l0 43 64 0 0-43c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9l0-43L480 0z','M234.6 354.5C89.6 368 0 432 0 432s112 80 288 80l77.8 0L234.6 354.5zM407.5 512l56.5 0 61.8 0L392.5 352 336 352l-48 0c-4.6 0-9.2 .1-13.7 .2L407.5 512zM624 512l16 0 0-160-205.8 0L567.5 512l56.5 0z']
      
    ]
  };

  

  
  

  var faBracketRound = {
    prefix: 'fasds',
    iconName: 'bracket-round',
    icon: [
      192,
      512,
      ["parenthesis"],
      '28',
      
      ['M0 256C0 140.2 71.9 62.9 110.2 37.4l35.5 53.3C120.1 107.7 64 167 64 256s56.1 148.3 81.8 165.4l-35.5 53.3C71.9 449 0 371.8 0 256z','']
      
    ]
  };

  
    var faParenthesis = faBracketRound;
  

  
  

  var faIgloo = {
    prefix: 'fasds',
    iconName: 'igloo',
    icon: [
      576,
      512,
      [],
      'f7ae',
      
      ['M0 320l96 0 0-128-66.1 0C10.8 230.6 0 274 0 320zm0 32L0 480l192 0 0-128L0 352zM48.5 160L320 160l0-126.2c-10.5-1.2-21.2-1.8-32-1.8C188.1 32 100.2 82.8 48.5 160zM128 192l0 128 69.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l69.5 0 0-128-320 0zM352 39.1L352 160l175.5 0C487.2 99.8 424.9 55.7 352 39.1zM384 352l0 128 192 0 0-128-192 0zm96-160l0 128 96 0c0-46-10.8-89.4-29.9-128L480 192z','M320 33.8c10.9 1.2 21.5 3 32 5.4L352 160l175.5 0c6.8 10.2 13 20.9 18.6 32L480 192l0 128 96 0 0 32-192 0 0 128-32 0 0-128c0-35.3-28.7-64-64-64s-64 28.7-64 64l0 128-32 0 0-128L0 352l0-32 96 0 0-128-66.1 0c5.5-11.1 11.7-21.8 18.6-32L320 160l0-126.2zM197.5 320c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l69.5 0 0-128-320 0 0 128 69.5 0z']
      
    ]
  };

  

  
  

  var faSchool = {
    prefix: 'fasds',
    iconName: 'school',
    icon: [
      640,
      512,
      [127979],
      'f549',
      
      ['M0 96L0 512l256 0 0-96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 256 0 0-416L480 96 320 0 160 96 0 96zm80 96c21.3 0 42.7 0 64 0l0 96c-21.3 0-42.7 0-64 0l0-96zm0 128l64 0 0 96-64 0 0-96zM408 176a88 88 0 1 1 -176 0 88 88 0 1 1 176 0zm88 16c21.3 0 42.7 0 64 0l0 96c-21.3 0-42.7 0-64 0l0-96zm0 128l64 0 0 96-64 0 0-96z','M336 144l0 16 16 0 16 0 0 32-16 0-32 0-16 0 0-16 0-32 0-16 32 0 0 16zM80 192l64 0 0 96-64 0 0-96zm416 0l64 0 0 96-64 0 0-96zM144 320l0 96-64 0 0-96 64 0zm352 0l64 0 0 96-64 0 0-96z']
      
    ]
  };

  

  
  

  var faBriefcaseBlank = {
    prefix: 'fasds',
    iconName: 'briefcase-blank',
    icon: [
      512,
      512,
      [],
      'e0c8',
      
      ['M128 0l24 0L360 0l24 0 0 24 0 72-48 0 0-48L176 48l0 48-48 0 0-72 0-24z','M512 96L0 96 0 480l512 0 0-384z']
      
    ]
  };

  

  
  

  var faChartCandlestick = {
    prefix: 'fasds',
    iconName: 'chart-candlestick',
    icon: [
      512,
      512,
      [],
      'e0e2',
      
      ['M0 32L0 64 0 448l0 32 32 0 448 0 32 0 0-64-32 0L64 416 64 64l0-32L0 32z','M320 32l0 16 0 48 32 0 0 160-32 0 0 48 0 16-32 0 0-16 0-48-32 0 0-160 32 0 0-48 0-16 32 0zm96 160l0-48 0-16 32 0 0 16 0 48 32 0 0 128-32 0 0 48 0 16-32 0 0-16 0-48-32 0 0-128 32 0zM192 128l32 0 0 192-32 0 0 48 0 16-32 0 0-16 0-48-32 0 0-192 32 0 0-48 0-16 32 0 0 16 0 48z']
      
    ]
  };

  

  
  

  var faRoadBarrier = {
    prefix: 'fasds',
    iconName: 'road-barrier',
    icon: [
      640,
      512,
      [],
      'e562',
      
      ['M64 96l85.2 0L64 266.3 64 96zm42.8 192l90.6-181.3L202.8 96l74.3 0L186.5 277.3 181.2 288l-74.3 0zm128 0l90.6-181.3L330.8 96l74.3 0L314.5 277.3 309.2 288l-74.3 0zm128 0l90.6-181.3L458.8 96l74.3 0L442.5 277.3 437.2 288l-74.3 0zm128 0L576 117.7 576 288l-85.2 0z','M64 32l0 32 0 384 0 32L0 480l0-32L0 64 0 32l64 0zm576 0l0 32 0 384 0 32-64 0 0-32 0-384 0-32 64 0z']
      
    ]
  };

  

  
  

  var faMortarPestle = {
    prefix: 'fasds',
    iconName: 'mortar-pestle',
    icon: [
      512,
      512,
      [],
      'f5a7',
      
      ['M209.3 192c1.4-1.2 2.8-2.4 4.4-3.5L469.5 0l40.6 47.2L365.3 192l-155.9 0z','M0 192l32 0 448 0 32 0 0 64-32 0c0 82.5-43.4 147.7-123.9 176.2C373.6 454.1 384 481.8 384 512l-256 0c0-30.2 10.4-57.9 27.9-79.8C75.4 403.7 32 338.5 32 256L0 256l0-64z']
      
    ]
  };

  

  
  

  var faShieldCheck = {
    prefix: 'fasds',
    iconName: 'shield-check',
    icon: [
      512,
      512,
      [],
      'f2f7',
      
      ['M16 133.1c0 49.1 9.5 115.6 37.9 180.9c32.7 75.2 91 150 189.4 192.6L256 512l12.7-5.5c98.4-42.6 156.7-117.3 189.4-192.6c32.4-74.7 40.2-151 37.3-200.9l-1.2-20.5L475.1 85 267.6 4.5 256 0 244.4 4.5 36.9 85 17.8 92.5 16.6 113c-.4 6.3-.6 13-.6 20.1zM126.1 256L160 222.1l1 1 16 16 47 47c37-37 74-74 111-111c5.3-5.3 10.7-10.7 16-16l1-1L385.9 192l-1 1c-5.3 5.3-10.7 10.7-16 16c-42.7 42.7-85.3 85.3-128 128c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-21.3-21.3-42.7-42.7-64-64c-5.3-5.3-10.7-10.7-16-16l-1-1z','M385 193L241 337l-17 17-17-17-80-80L161 223l63 63L351 159 385 193z']
      
    ]
  };

  

  
  

  var faUserAlien = {
    prefix: 'fasds',
    iconName: 'user-alien',
    icon: [
      448,
      512,
      [],
      'e04a',
      
      ['M0 512L48 352l80 0 96 72 96-72 80 0 48 160L0 512zM64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 119.3-160 217-160 217s-160-97.7-160-217zm48 9l0 16c0 35.3 28.7 64 64 64l16 0 16 0 0-16c0-35.3-28.7-64-64-64l-16 0-16 0zm128 64l0 16 16 0 16 0c35.3 0 64-28.7 64-64l0-16-16 0-16 0c-35.3 0-64 28.7-64 64z','M144 176c35.3 0 64 28.7 64 64l0 16-16 0-16 0c-35.3 0-64-28.7-64-64l0-16 16 0 16 0zm160 0l16 0 16 0 0 16c0 35.3-28.7 64-64 64l-16 0-16 0 0-16c0-35.3 28.7-64 64-64z']
      
    ]
  };

  

  
  

  var faSnowman = {
    prefix: 'fasds',
    iconName: 'snowman',
    icon: [
      512,
      512,
      [9731,9924],
      'f7d0',
      
      ['M96 384c0 52.3 25.1 98.8 64 128l192 0c38.9-29.2 64-75.7 64-128c0-48.2-21.3-91.4-55.1-120.8c3.9-10.5 6.3-21.8 6.9-33.6c0-.8 .1-1.7 .1-2.5c0-2 0-2.6 0-3.1c0-3.8-.2-7.6-.6-11.4c-.4-3.7-.9-7.3-1.6-10.9c-1.4-7.2-3.6-14.1-6.3-20.7c-5.3-12.7-12.8-24.2-22.1-34c9.3-14.8 14.7-32.3 14.7-51c0-53-43-96-96-96s-96 43-96 96c0 18.7 5.4 36.2 14.7 51c-9.3 9.8-16.8 21.3-22.1 34c-5.5 13.2-8.6 27.8-8.6 43c0 1.9 0 3.7 .1 5.6c.6 11.8 3 23.1 6.9 33.6C117.3 292.6 96 335.8 96 384zM208 80c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.8c0 .5 0 1-.1 1.5c-.1 .5-.1 1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16zm32 40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 .3c0 2.9-.8 5.8-2.3 8.3L256 152l-13.7-23.4c-1.5-2.5-2.3-5.4-2.3-8.3l0-.3zm0 88l32 0c0 10.7 0 21.3 0 32l-32 0c0-10.7 0-21.3 0-32zm0 64l32 0c0 10.7 0 21.3 0 32l-32 0c0-10.7 0-21.3 0-32zm0 64l32 0c0 10.7 0 21.3 0 32l-32 0c0-10.7 0-21.3 0-32zM272 80c0-8.8 7.2-16 16-16c4.4 0 8.4 1.8 11.3 4.7c1.4 1.4 2.6 3.2 3.4 5.1c.4 1 .7 2 .9 3c.1 .5 .2 1.1 .2 1.6s.1 1 .1 1.8c0 .5 0 1-.1 1.5c-.1 .5-.1 1-.2 1.6c-.2 1-.5 2-.9 3c-.8 1.9-2 3.6-3.4 5.1c-2.9 2.9-6.9 4.7-11.3 4.7c-8.8 0-16-7.2-16-16z','M224 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 144l0 32-32 0 0-32 32 0zm0 64l0 32-32 0 0-32 32 0zm-32 64l32 0 0 32-32 0 0-32zM272 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM104 96l0 24 0 40.2L152.6 181c-5.5 13.2-8.6 27.8-8.6 43c0 1.9 0 3.7 .1 5.6L70.5 198.1l-56-24-22.1-9.5 18.9-44.1 22.1 9.5L56 139.6 56 120l0-24 48 0zM368 224c0-15.2-3-29.8-8.6-43L408 160.2l0-40.2 0-24 48 0 0 24 0 19.6 22.5-9.7 22.1-9.5 18.9 44.1-22.1 9.5-56 24-73.6 31.5c.1-1.9 .1-3.7 .1-5.6z']
      
    ]
  };

  

  
  

  var faWheatAwnCircleExclamation = {
    prefix: 'fasds',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e598',
      
      ['M2.7 464L48 509.3l22.6-22.6 52.9-52.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.5 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.5c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L489 153l17-17L472 102.1l-17 17-43.4 43.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L393 57l17-17L376 6.1 359 23 329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L294.1 16 271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L90.5 219.6 67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L25.4 441.4 2.7 464zM366 112L400 145.9l17-17 72-72 17-17L472 6.1 455 23 383 95l-17 17z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faGunSquirt = {
    prefix: 'fasds',
    iconName: 'gun-squirt',
    icon: [
      576,
      512,
      [],
      'e19d',
      
      ['M64 160l0 32 416 0 0-32L64 160zM218 376l54 0 0 16 0 24 48 0 0-24 0-40 0-40 0-24-48 0 0 24 0 16-42 0-12 48z','M128 56l0-24L80 32l0 24 0 9.3C34.6 72.9 0 112.4 0 160c0 50.4 38.8 91.7 88.1 95.7L32 480l160 0 56-224 264 0 32 0 0-32 0-32 32 0 0-64-32 0 0-32 0-32-32 0L128 64l0-8zm352 72l0 64L64 192l0-64 416 0z']
      
    ]
  };

  

  
  

  var faPiano = {
    prefix: 'fasds',
    iconName: 'piano',
    icon: [
      512,
      512,
      [],
      'f8d4',
      
      ['M0 352L0 480l0 32 32 0 448 0 32 0 0-32 0-128-64 0 0 96L64 448l0-96L0 352z','M0 192L0 352l96 0 0 48 0 16 32 0 0-16 0-48 32 0 0 48 0 16 32 0 0-16 0-48 32 0 0 48 0 16 32 0 0-16 0-48 64 0 0 48 0 16 32 0 0-16 0-48 32 0 0 48 0 16 32 0 0-16 0-48 96 0 0-64L384 224l0-32C384 86 298 0 192 0S0 86 0 192z']
      
    ]
  };

  

  
  

  var faPepper = {
    prefix: 'fasds',
    iconName: 'pepper',
    icon: [
      512,
      512,
      [129745],
      'e432',
      
      ['M2.9 215.3l56 224c12.9 51.4 65 82.7 116.4 69.8c10.5-2.6 20.1-6.9 28.7-12.4c5.6 3.6 11.7 6.7 18.2 9.1c10.7 4 22.2 6.2 34 6.2c11.6 0 22.9-2.1 33.5-6.1c6.5-2.4 12.7-5.5 18.4-9.2c8.6 5.5 18.2 9.8 28.7 12.4c51.4 12.9 103.6-18.4 116.4-69.8l56-224c2-7.8 2.9-15.6 2.9-23.4c0-43-29.1-82.2-72.7-93.1c-26.8-6.7-53.7-1.4-75.3 12.4c-8.6-5.5-18.3-9.8-28.7-12.4c-19.8-5-39.7-3.4-57.4 3.4c-7.8 3-15.1 6.9-21.8 11.7c-8.4-6-17.7-10.7-27.6-13.8c-4.4-1.4-8.9-2.4-13.5-3.1c-.2 0-.4-.1-.6-.1c-8.4-1.3-17-1.4-25.7-.4c-4 .5-7.9 1.2-11.9 2.2c-51.4 12.9-74.7 65-61.9 116.4l41 163.8-31 7.8L83.8 223c-11.8-47 .4-94.4 31.3-125.2c-6.2-1.3-12.6-1.9-19-1.9c-7.7 0-15.5 .9-23.4 2.9C21.3 111.7-10 163.8 2.9 215.3z','M277.8 102.3c-4.5-26.6-15.2-49-25.5-65.4c-6.8-10.8-13.6-19.4-18.7-25.4c-2.6-3-4.8-5.3-6.4-7c-.8-.8-1.5-1.5-2-2l-.6-.6-.2-.2-.1-.1c0 0 0 0 0 0s0 0 0 0L208 19.2c-16.4 17.5-16.4 17.5-16.4 17.5s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0l.2 .2c.2 .2 .6 .6 1.1 1.1c1 1 2.6 2.7 4.5 4.9c3.9 4.5 9.1 11.1 14.3 19.4c6.6 10.6 12.9 23.4 16.7 37.9c9.9 3.1 19.3 7.7 27.6 13.8c6.7-4.8 14.1-8.8 21.8-11.7z']
      
    ]
  };

  

  
  

  var faTruckMedical = {
    prefix: 'fasds',
    iconName: 'truck-medical',
    icon: [
      640,
      512,
      [128657,"ambulance"],
      'f0f9',
      
      ['M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm16-304l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0zM384 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M0 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 64 32 0 0 64-32 0-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L0 416 0 0zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM176 64l0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0z']
      
    ]
  };

  
    var faAmbulance = faTruckMedical;
  

  
  

  var faApartment = {
    prefix: 'fasds',
    iconName: 'apartment',
    icon: [
      576,
      512,
      [],
      'e468',
      
      ['M0 96L0 512l128 0 32 0 96 0 0-128 64 0 0 128 96 0 32 0 128 0 0-320-128 0L448 0 128 0l0 96L0 96zm64 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zM192 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zM320 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm128 0l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M384 64l-64 0 0 64 64 0 0-64zM64 320l64 0 0-64-64 0 0 64zm320 0l0-64-64 0 0 64 64 0zm128 96l0-64-64 0 0 64 64 0zm-384 0l0-64-64 0 0 64 64 0zm64-96l64 0 0-64-64 0 0 64zm0-256l0 64 64 0 0-64-64 0zM384 224l0-64-64 0 0 64 64 0zm64 96l64 0 0-64-64 0 0 64zM128 224l0-64-64 0 0 64 64 0zm64 0l64 0 0-64-64 0 0 64z']
      
    ]
  };

  

  
  

  var faTriangle = {
    prefix: 'fasds',
    iconName: 'triangle',
    icon: [
      512,
      512,
      [9650],
      'f2ec',
      
      ['M0 480L256 32 512 480H0z','']
      
    ]
  };

  

  
  

  var faFileMov = {
    prefix: 'fasds',
    iconName: 'file-mov',
    icon: [
      512,
      512,
      [],
      'e647',
      
      ['M0 0L224 0l0 160 160 0 0 144L80 304l0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM256 368l0-16-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0 0 16 0 128 0 16 32 0 0-16 0-73 18 32.7 14.3 26 13.9-26.2L224 421.8l0 74.2 0 16 32 0 0-16 0-128zm192 0l0-16-32 0 0 16 0 35c0 21.1 3.8 42 11.2 61.8L441 501.6l3.9 10.4 11.1 0 16 0 11.1 0 3.9-10.4 13.8-36.8C508.2 445 512 424.1 512 403l0-35 0-16-32 0 0 16 0 35c0 17.3-3.1 34.4-9.2 50.6L464 471.8l-6.8-18.2c-6.1-16.2-9.2-33.3-9.2-50.6l0-35zM288 392l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-80c0-22.1-17.9-40-40-40l-16 0c-22.1 0-40 17.9-40 40zm40-8l16 0c4.4 0 8 3.6 8 8l0 80c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8z']
      
    ]
  };

  

  
  

  var faHeadSideCoughSlash = {
    prefix: 'fasds',
    iconName: 'head-side-cough-slash',
    icon: [
      640,
      512,
      [],
      'e062',
      
      ['M0 224.3c0-38.7 9.8-75.2 27.1-107L341.8 365.3 320 368l0 40 82.5 5.2L448 449l0 31-128 0 0 32-32 0-32 0L96 512l-32 0 0-32 0-98.8C23 339.3 0 283 0 224.3zM88.4 45.9C126.1 17.1 173.2 0 224.3 0L256 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 5L88.4 45.9zM576 336a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm64-48a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm0 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faPear = {
    prefix: 'fasds',
    iconName: 'pear',
    icon: [
      512,
      512,
      [],
      'e20c',
      
      ['M0 320C0 426 86 512 192 512s192-86 192-192c0-3.6-.1-7.1-.3-10.7l58.8-58.8c44.2-44.2 49.3-112.6 15.4-162.5c-8.3 8.3-16.6 16.6-24.9 24.9c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c8.3-8.3 16.6-16.6 24.9-24.9C402.3 39.4 377.2 32 352 32c-32.8 0-65.5 12.5-90.5 37.5l-58.8 58.8c-3.5-.2-7.1-.3-10.7-.3C86 128 0 214 0 320zm192 96c53 0 96-43 96-96l32 0c0 70.7-57.3 128-128 128l0-32z','M510.7 35.2l-17 17L433 113l-17 17L382.1 96l17-17 60.8-60.8 17-17 33.9 33.9z']
      
    ]
  };

  

  
  

  var faStaffSnake = {
    prefix: 'fasds',
    iconName: 'staff-snake',
    icon: [
      384,
      512,
      ["rod-asclepius","rod-snake","staff-aesculapius"],
      'e579',
      
      ['M0 96l0 64 86 0c19.8 0 36.3-13.6 40.8-32l37.2 0 56 0 68 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-69 0-2.5 80 71.5 0c53 0 96-43 96-96s-43-96-96-96l-65.5 0-61 0L64 48c-2 .1-4 0-6 0L48 48C21.5 48 0 69.5 0 96zm80 0A16 16 0 1 1 48 96a16 16 0 1 1 32 0zM56 256c0 53 43 96 96 96l19 0 42 0 43 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-44 0-2.1 67.5-.4 12.5 46.5 0c53 0 96-43 96-96s-43-96-96-96l-40.5 0-47 0L152 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l15.5 0L165 160l-13 0c-53 0-96 43-96 96zM96 384l0 80 40 0 38.5 0c-.1-4.2-.3-8.3-.4-12.5c-.7-22.5-1.4-45-2.1-67.5l-36 0-40 0z','M208 511l0 1-32 0 0-1-5-159 42 0-5 159zm7.5-239l-47 0L164 128l56 0-4.5 144zM160 0l64 0-1.5 48-61 0L160 0z']
      
    ]
  };

  
    var faRodAsclepius = faStaffSnake;
  
    var faRodSnake = faStaffSnake;
  
    var faStaffAesculapius = faStaffSnake;
  

  
  

  var faSpiderBlackWidow = {
    prefix: 'fasds',
    iconName: 'spider-black-widow',
    icon: [
      512,
      512,
      [],
      'f718',
      
      ['M67.7 133.6L79 145l72.1 72.1c8.3 2.8 16.6 5.5 24.9 8.3c0-17.1 0-34.2 0-51.3l-51.7-51.7 33.8-81.2 9.2-22.2L123.1 .6l-9.2 22.2-40 96-6.2 14.8zM216 288l0 16 24 32-24 32 0 16 80 0 0-16-24-32 24-32 0-16-80 0zM336 174.1l0 51.3 24.9-8.3L433 145l11.4-11.4-6.2-14.8-40-96L388.9 .6 344.6 19.1l9.2 22.2 33.8 81.2L336 174.1z','M0 139.9l0-21.2 39.2-13.1 7.6 22.8L67 189l109 36.3 0-65.4c0-38.7 27.5-71 64-78.4l0 46.4 32 0 0-46.4c36.5 7.4 64 39.7 64 78.4l0 65.4L445 189l20.2-60.6 7.6-22.8L512 118.7l0 21.2-1.2 3.7-24 72L483 227l-11.4 3.8L395.9 256l75.7 25.2L483 285l3.8 11.4 24 72 1.2 3.7 0 21.2-39.2 13.1-7.6-22.8L445 323l-84.2-28.1L433 367l11.4 11.4-6.2 14.8-40 96-9.2 22.2-44.3-18.5 9.2-22.2 33.8-81.2L352 353.9c-1 52.1-43.6 94.1-96 94.1s-95-41.9-96-94.1l-35.7 35.7 33.8 81.2 9.2 22.2-44.3 18.5-9.2-22.2-40-96-6.2-14.8L79 367l72.1-72.1L67 323 46.8 383.6l-7.6 22.8L0 393.3l0-21.2 1.2-3.7 24-72L29 285l11.4-3.8L116.1 256 40.4 230.8 29 227l-3.8-11.4-24-72L0 139.9zM216 304l24 32-24 32 0 16 80 0 0-16-24-32 24-32 0-16-80 0 0 16z']
      
    ]
  };

  

  
  

  var faCircleD = {
    prefix: 'fasds',
    iconName: 'circle-d',
    icon: [
      512,
      512,
      [],
      'e104',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0-24 0 0-24 0-208 0-24zm48 48l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z','M160 128l24 0 72 0c70.7 0 128 57.3 128 128s-57.3 128-128 128l-72 0-24 0 0-24 0-208 0-24zm48 48l0 160 48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0z']
      
    ]
  };

  

  
  

  var faHammerWar = {
    prefix: 'fasds',
    iconName: 'hammer-war',
    icon: [
      384,
      512,
      [],
      'f6e4',
      
      ['M160 0l0 32 0 24.9c10.7 2.4 21.3 4.7 32 7.1l32-7.1L224 32l0-32L160 0zm0 263.1L160 480l0 32 64 0 0-32 0-216.9L192 256l-32 7.1z','M0 288V32H48L192 64 336 32h48V288H336L192 256 48 288H0z']
      
    ]
  };

  

  
  

  var faBicycle = {
    prefix: 'fasds',
    iconName: 'bicycle',
    icon: [
      640,
      512,
      [128690],
      'f206',
      
      ['M0 352c0 70.7 57.3 128 128 128c65.3 0 119.1-48.9 127-112l-56.8 0c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l26.2-52.3c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352zm384 0c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6c9.2 17 18.3 33.9 27.5 50.9c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3c-9.2-17-18.3-33.9-27.5-50.9C402.4 276.3 384 312 384 352z','M312 32l-24 0 0 48 24 0 25.7 0 34.6 64-149.4 0-27.4-38-7.2-10L176 96l-56 0L96 96l0 48 24 0 43.7 0 22.1 30.7L106.5 333.3 128 368l176 0 13.7 0 7-11.8 84.8-143.5 81.4 150.7 11.4 21.1 42.2-22.8-11.4-21.1-160-296L366.3 32 352 32l-40 0zM166.8 320l50.7-101.3 72.9 101.2-.1 .1-123.5 0zm90.6-128l108.5 0L317 274.8 257.4 192z']
      
    ]
  };

  

  
  

  var faBangladeshiTakaSign = {
    prefix: 'fasds',
    iconName: 'bangladeshi-taka-sign',
    icon: [
      384,
      512,
      [],
      'e2e6',
      
      ['M0 160l0 64 64 0 0-64L0 160zm128 0l0 64 64 0 0-64-64 0z','M32 96L8 96 8 32l24 0c53 0 96 43 96 96l0 256c0 17.7 14.3 32 32 32l32 0c70.7 0 128-57.3 128-128l0-32c0-17.7-14.3-32-32-32l-16 0-32 0 0-64 32 0 16 0c53 0 96 43 96 96l0 32c0 106-86 192-192 192l-32 0c-53 0-96-43-96-96l0-256c0-17.7-14.3-32-32-32z']
      
    ]
  };

  

  
  

  var faCalendars = {
    prefix: 'fasds',
    iconName: 'calendars',
    icon: [
      512,
      512,
      [],
      'e0d7',
      
      ['M96 192l416 0 0 224L96 416l0-224z','M256 0L192 0l0 64L96 64l0 128 416 0 0-128-96 0 0-64L352 0l0 64-96 0 0-64zM48 184l0-24L0 160l0 24L0 488l0 24 24 0 368 0 24 0 0-48-24 0L48 464l0-280z']
      
    ]
  };

  

  
  

  var faCircleArrowUpRight = {
    prefix: 'fasds',
    iconName: 'circle-arrow-up-right',
    icon: [
      512,
      512,
      [],
      'e0fc',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm134.1 88l17-17 135-135L192 192l-24 0 0-48 24 0 152 0 24 0 0 24 0 160 0 24-48 0 0-24 0-102.1L185 361l-17 17L134.1 344z','M368 144l-24 0-152 0-24 0 0 48 24 0 94.1 0L151 327l-17 17L168 377.9l17-17 135-135L320 328l0 24 48 0 0-24 0-160 0-24z']
      
    ]
  };

  

  
  

  var faLeafyGreen = {
    prefix: 'fasds',
    iconName: 'leafy-green',
    icon: [
      576,
      512,
      [129388],
      'e41d',
      
      ['M17.9 206.3l0 72.6L72.1 333l0 86.2 19.7 19.7L128 402.7l0-98.7 48-48 0-96 64.4-64.4c.1-1.2 .2-2.4 .4-3.6s.3-2.4 .5-3.6c.4-2.4 .9-4.7 1.4-7l-.4-.1c-1.8-20.2-10.4-39.8-25.8-55.3C199 8.7 176.2 0 153.3 0s-45.7 8.7-63.2 26.2c-15.4 15.4-24 35.1-25.8 55.3C49 83.9 34.3 91.1 22.4 102.9c-28.3 28.3-29.8 73.3-4.5 103.4zM217.4 336L240 358.6l11.3-11.3 48-48L358.6 240l89.4 0 16 0 0-32-16 0-57.4 0 84.7-84.7L486.6 112 464 89.4l-11.3 11.3-112 112L304 249.4l0-57.4 0-16-32 0 0 16 0 89.4-43.3 43.3L217.4 336z','M576 112c0 27.4-9.8 52.4-26.1 71.9C561.3 199.7 568 219 568 240c0 50.2-38.5 91.4-87.6 95.6L416 400l-96 0-48 48-98.7 0-38.6 38.6L112 509.3 66.7 464l22.6-22.6L128 402.7l0-98.7 48-48 0-96 64.4-64.4C244.6 46.5 285.8 8 336 8c21 0 40.3 6.7 56.1 18.1C411.6 9.8 436.6 0 464 0c61.9 0 112 50.1 112 112zM475.3 123.3L486.6 112 464 89.4l-11.3 11.3-112 112L304 249.4l0-57.4 0-16-32 0 0 16 0 89.4-43.3 43.3L217.4 336 240 358.6l11.3-11.3 48-48L358.6 240l89.4 0 16 0 0-32-16 0-57.4 0 84.7-84.7z']
      
    ]
  };

  

  
  

  var faSquid = {
    prefix: 'fasds',
    iconName: 'squid',
    icon: [
      512,
      512,
      [129425],
      'e450',
      
      ['M261.2 4.7l22.1 3.5L396.3 26c-49.9 14.7-90.2 31.9-122.4 50.5l-8.8-49.7L261.2 4.7zM435.3 238.8c18.9-32.6 36.4-73.6 51.2-124.6l18.2 115.3 3.5 22.1-22.1-3.9-50.8-9z','M157.5 224.5C165.2 149.6 243.2 44.9 512 0C467.2 269.4 362.4 346.9 287.6 354.6l37.2 37.2c6.2 6.2 16.4 6.2 22.6 0l56.1-56.1c19-19 49.9-18.7 68.6 .7l27.5 28.6 9.5 9.9-8.3 10.9-2.5 3.3c-28.3 37-81 40.1-113.6 10.9L370 414.4c-18.7 18.7-49.1 18.7-67.9 0l-45.3-45.3L223 403.1l32.6 32.6c19.5 19.5 18.6 51.5-2.1 69.8l-2.8 2.5L229.4 484l2.8-2.5c6.9-6.1 7.2-16.8 .7-23.3l-56-56c-1.7 6.5-4.7 12.7-8.8 18.4l-20.1 27.3c-2.5 3.5-3.9 7.6-3.9 11.9c0 11.1 9 20.1 20.1 20.1l11.9 0 16 0 0 32-16 0-11.9 0c-28.8 0-52.1-23.3-52.1-52.1c0-11.1 3.6-21.9 10.1-30.9l20.1-27.3c6.8-9.2 5.8-22-2.3-30.1c-8.2-8.2-21.2-9.1-30.4-2.1l-26.2 20c-9 6.9-20.1 10.6-31.4 10.6C23.2 400 0 376.8 0 348.1L0 336l0-16 32 0 0 16 0 12.1c0 11 8.9 19.9 19.9 19.9c4.4 0 8.6-1.4 12-4.1l26.2-20c5.8-4.4 12.3-7.6 19.1-9.4L53.8 279.2c-6.4-6.4-16.7-6.2-22.9 .3L27.6 283 4.4 261l3.3-3.5c18.6-19.6 49.7-20 68.7-.9l33.4 33.4L143.8 256 98.5 210.7c-18.7-18.7-18.7-49.1 0-67.9L113 128.4C83.6 95.6 86.6 42.9 123.4 14.2l3.7-2.9 11-8.6 10 9.8 29 28.4c19.1 18.7 19.3 49.4 .4 68.3l-56.3 56.3c-6.2 6.2-6.2 16.4 0 22.6l36.3 36.3zM200.9 280a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faSparkles = {
    prefix: 'fasds',
    iconName: 'sparkles',
    icon: [
      512,
      512,
      [10024],
      'f890',
      
      ['M320 96l64 32 32 64 32-64 64-32L448 64 416 0 384 64 320 96zm0 320l64 32 32 64 32-64 64-32-64-32-32-64-32 64-64 32z','M128 192L192 64l64 128 128 64L256 320 192 448 128 320 0 256l128-64z']
      
    ]
  };

  

  
  

  var faV = {
    prefix: 'fasds',
    iconName: 'v',
    icon: [
      384,
      512,
      [118],
      '56',
      
      ['M0 32L162.1 459.4l7.8 20.6 44.2 0 7.8-20.6L384 32l-68.4 0L192 357.8 68.4 32 0 32z','']
      
    ]
  };

  

  
  

  var faObjectsAlignBottom = {
    prefix: 'fasds',
    iconName: 'objects-align-bottom',
    icon: [
      512,
      512,
      [],
      'e3bb',
      
      ['M64 0l0 384 160 0L224 0 64 0zM288 128l0 256 160 0 0-256-160 0z','M0 512l512 0 0-48L0 464l0 48z']
      
    ]
  };

  

  
  

  var faBasketballHoop = {
    prefix: 'fasds',
    iconName: 'basketball-hoop',
    icon: [
      640,
      512,
      [],
      'f435',
      
      ['M0 201.1L0 372.8l134.4 59.8L113.8 288 96 288l0-48 64 0 0-16 0-80 0-16 16 0 288 0 16 0 0 16 0 80 0 16 64 0 0 48-17.8 0L505.6 432.6 640 372.8l0-171.7c-21.2-38.5-43.7-73.4-75.9-104.2C513.6 48.5 434 0 320 0S126.4 48.5 75.9 96.9C43.7 127.6 21.2 162.6 0 201.1zM192 160l0 64 0 16 256 0 0-16 0-64-256 0z','M544 240L96 240l0 48 50.1 0 7.2 50.3 22.9 160 2 13.7 13.9 0 8 0 7.2 0 4.8-5.3 44.2-49.5L300 506.6l4.8 5.4 7.2 0 16 0 7.2 0 4.8-5.4 43.9-49.4 44.2 49.5 4.8 5.3 7.2 0 8 0 13.9 0 2-13.7 22.9-160 7.2-50.3 50.1 0 0-48zm-82.4 48l-5.2 36.6-44-36.6 49.2 0zm-99.3 0l1.2 1L320 337.6 276.6 289l1.2-1 84.4 0zm-134.5 0l-44 36.6L178.4 288l49.2 0zM388 309.4l48.5 40.3-52.7 59.3-42.4-47.5L388 309.4zm47.9 158l-30.6-34.3 42.3-47.6-11.7 81.9zM320 385.6l42.4 47.5L320.8 480l-1.6 0-41.6-46.8L320 385.6zm-21.4-24l-42.4 47.5-52.7-59.3L252 309.4l46.6 52.2zM204.1 467.4l-11.7-81.9 42.3 47.6-30.6 34.3z']
      
    ]
  };

  

  
  

  var faTooth = {
    prefix: 'fasds',
    iconName: 'tooth',
    icon: [
      448,
      512,
      [129463],
      'f5c9',
      
      ['M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5l0 6.2c0 15.8 3.7 31.3 10.7 45.5L73 239.6l39.4 220.6 3.5 19.8 20.1 0 8 0 19.9 0 3.7-19.5L195.9 312l56.3 0 28.3 148.5 3.7 19.5 19.9 0 8 0 20.1 0 3.5-19.8L375 239.6l30.2-60.5c7.1-14.1 10.7-29.7 10.7-45.5l0-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 32.1 25-19.6 25.3-37-28.8-37-28.8z','']
      
    ]
  };

  

  
  

  var faFaceGrinWide = {
    prefix: 'fasds',
    iconName: 'face-grin-wide',
    icon: [
      512,
      512,
      [128515,"grin-alt"],
      'f581',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 46.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zM144 192c0-35.3 14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64s-32-28.7-32-64zm160 0c0-35.3 14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64s-32-28.7-32-64z','M176 256c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zm160 0c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64z']
      
    ]
  };

  
    var faGrinAlt = faFaceGrinWide;
  

  
  

  var faPills = {
    prefix: 'fasds',
    iconName: 'pills',
    icon: [
      576,
      512,
      [],
      'f484',
      
      ['M0 144l0 80 0 32 32 0 160 0 32 0 0-32 0-80c0-61.9-50.1-112-112-112S0 82.1 0 144zM256 320c0 88.4 71.6 160 160 160c38.4 0 73.7-13.5 101.3-36.1L292.1 218.7C269.5 246.3 256 281.6 256 320zm58.7-123.9L539.9 421.3C562.5 393.7 576 358.4 576 320c0-88.4-71.6-160-160-160c-38.4 0-73.7 13.5-101.3 36.1z','M32 256L0 256l0 32 0 80c0 61.9 50.1 112 112 112s112-50.1 112-112l0-80 0-32-32 0L32 256z']
      
    ]
  };

  

  
  

  var faArrowDownLeftAndArrowUpRightToCenter = {
    prefix: 'fasds',
    iconName: 'arrow-down-left-and-arrow-up-right-to-center',
    icon: [
      512,
      512,
      [],
      'e092',
      
      ['M9.4 457.4l45.3 45.3L176 381.3l0 50.7 0 32 64 0 0-32 0-128 0-32-32 0L80 272l-32 0 0 64 32 0 50.7 0L9.4 457.4z','M502.6 54.6L381.3 176l50.7 0 32 0 0 64-32 0-128 0-32 0 0-32 0-128 0-32 64 0 0 32 0 50.7L457.4 9.4l45.3 45.3z']
      
    ]
  };

  

  
  

  var faHryvniaSign = {
    prefix: 'fasds',
    iconName: 'hryvnia-sign',
    icon: [
      384,
      512,
      [8372,"hryvnia"],
      'f6f2',
      
      ['M0 176l0 64 155.5 0 91.8-52.5c.7-.4 1.3-.8 2-1.2s1.3-.8 1.9-1.3c1.2-.9 2.4-1.8 3.6-2.8c2.3-1.9 4.4-4.1 6.2-6.4L0 176zm0 96l0 64 52.3 0c7.5-26.1 24.2-49 47.5-64L0 272zm123.1 64L384 336l0-64-155.5 0-91.8 52.5c-.7 .4-1.3 .8-2 1.2s-1.3 .8-1.9 1.3c-1.2 .9-2.4 1.8-3.6 2.8c-2.3 1.9-4.4 4.1-6.2 6.4zm161.1-96l99.8 0 0-64-52.3 0c-7.5 26.1-24.2 49-47.5 64z','M179.5 96c-24.5 0-48 9.7-65.4 27.1l-11.5 11.5L57.4 89.4 68.9 77.8C98.3 48.5 138.1 32 179.5 32L223 32c62.4 0 113 50.6 113 113c0 40.5-21.7 78-56.9 98.1L136.7 324.5c-15.3 8.7-24.7 25-24.7 42.5c0 27.1 21.9 49 49 49l43.5 0c24.5 0 48-9.7 65.4-27.1l11.5-11.5 45.3 45.3-11.5 11.5C285.7 463.5 245.9 480 204.5 480L161 480C98.6 480 48 429.4 48 367c0-40.6 21.7-78 56.9-98.1l142.4-81.4c15.3-8.7 24.7-25 24.7-42.5c0-27.1-21.9-49-49-49l-43.5 0z']
      
    ]
  };

  
    var faHryvnia = faHryvniaSign;
  

  
  

  var faI = {
    prefix: 'fasds',
    iconName: 'i',
    icon: [
      320,
      512,
      [105],
      '49',
      
      ['M32 32L0 32 0 96l32 0 96 0 0 320-96 0L0 416l0 64 32 0 96 0 64 0 96 0 32 0 0-64-32 0-96 0 0-320 96 0 32 0 0-64-32 0-96 0-32 0-32 0L32 32z','']
      
    ]
  };

  

  
  

  var faUserHelmetSafety = {
    prefix: 'fasds',
    iconName: 'user-helmet-safety',
    icon: [
      448,
      512,
      [128119,"user-construction","user-hard-hat"],
      'f82c',
      
      ['M96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-5.4-.3-10.8-1-16L97 176c-.7 5.2-1 10.6-1 16z','M256 0L192 0l0 80L163.6 23.1C125.6 43.5 99 82.6 96.2 128l-.2 0-24 0 0 48 24 0 256 0 24 0 0-48-24 0-.2 0C349 82.6 322.4 43.5 284.4 23.1L256 80l0-80zM400 352L48 352 0 512l448 0L400 352z']
      
    ]
  };

  
    var faUserConstruction = faUserHelmetSafety;
  
    var faUserHardHat = faUserHelmetSafety;
  

  
  

  var faDialHigh = {
    prefix: 'fasds',
    iconName: 'dial-high',
    icon: [
      576,
      512,
      [],
      'e15c',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M446.6 263.6c-11.6-77-78-136-158.2-136c-88.4 0-160 71.6-160 160s71.6 160 160 160c80.2 0 146.6-59 158.2-136l-158.2 0-24 0 0-48 24 0 158.2 0z']
      
    ]
  };

  

  
  

  var faGlassEmpty = {
    prefix: 'fasds',
    iconName: 'glass-empty',
    icon: [
      384,
      512,
      [],
      'e191',
      
      ['M99.2 448l185.6 0 30-384L69.2 64l30 384zM344 512L40 512 5 64 0 0 64.2 0 319.8 0 384 0l-5 64L344 512z','']
      
    ]
  };

  

  
  

  var faDroneFront = {
    prefix: 'fasds',
    iconName: 'drone-front',
    icon: [
      640,
      512,
      ["drone-alt"],
      'f860',
      
      ['M0 112l0 48 24 0 72 0 64 0 104 0 24 0 0-48-24 0-104 0-64 0-72 0L0 112zm352 0l0 48 24 0 104 0 64 0 72 0 24 0 0-48-24 0-72 0-64 0-104 0-24 0z','M160 160l-64 0 0 32 0 64 0 20.8 19 8.4 56.5 25.1-21.9 26.3-5.6 6.7 0 8.7 0 40 0 24 48 0 0-24 0-31.3 25.1-30.1L259 349.2l6.2 2.8 6.8 0 96 0 6.8 0 6.2-2.8 41.9-18.6L448 360.7l0 31.3 0 24 48 0 0-24 0-40 0-8.7-5.6-6.7-21.9-26.3L525 285.2l19-8.4 0-20.8 0-64 0-32-64 0 0 32 0 43.2-17.8 7.9-40.6-23.7C390.7 201.5 355.7 192 320 192s-70.7 9.5-101.6 27.5l-40.6 23.7L160 235.2l0-43.2 0-32zm320-48l64 0 0-16-64 0 0 16zM160 96L96 96l0 16 64 0 0-16z']
      
    ]
  };

  
    var faDroneAlt = faDroneFront;
  

  
  

  var faStairs = {
    prefix: 'fasds',
    iconName: 'stairs',
    icon: [
      576,
      512,
      [],
      'e289',
      
      ['M128 352l0 64 64 0 0-64-64 0zM256 224l0 64 64 0 0-64-64 0zM384 96l0 64 64 0 0-64-64 0z','M416 32l-32 0 0 32 0 32 64 0 96 0 32 0 0-64-32 0L416 32zM384 160l-96 0-32 0 0 32 0 32 64 0 96 0 32 0 0-32 0-32-64 0zM160 288l-32 0 0 32 0 32 64 0 96 0 32 0 0-32 0-32-64 0-96 0zm32 128l-64 0-96 0L0 416l0 64 32 0 128 0 32 0 0-32 0-32z']
      
    ]
  };

  

  
  

  var faToiletPaperUnderSlash = {
    prefix: 'fasds',
    iconName: 'toilet-paper-under-slash',
    icon: [
      640,
      512,
      ["toilet-paper-reverse-slash"],
      'e2a1',
      
      ['M64 192c0-15 .9-29.6 2.5-43.6L365.5 384 160 384c-53 0-96-86-96-192zM94.9 50.9C112 19.3 134.9 0 160 0L412.2 0C400.6 12.2 391 26.9 383.5 41.9C363.5 82 352 135.1 352 192c0 21.4 1.6 42.3 4.7 62.2C269.5 186.4 182.2 118.7 94.9 50.9zM224 416l182.2 0L528 512l48 0-352 0 0-96zM384 192c0-83.6 26.7-154.7 64-181.1C458 3.8 468.8 0 480 0c53 0 96 86 96 192c0 35-4.7 67.8-12.8 96c-11.6 39.9-30.1 70.8-52.3 85.9l-115-89.3c-7.6-27.5-11.9-59-11.9-92.6zm64 0c0 35.3 14.3 64 32 64s32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64zm89 202.2c16.3-13.6 29.3-32 39-51.1l0 81.3c-13-10.1-26-20.2-39-30.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faToiletPaperReverseSlash = faToiletPaperUnderSlash;
  

  
  

  var faDrawSquare = {
    prefix: 'fasds',
    iconName: 'draw-square',
    icon: [
      448,
      512,
      [],
      'f5ef',
      
      ['M32 151.4c4.7 2.7 9.8 4.9 15.2 6.3c2.7 .7 5.4 1.3 8.2 1.7c1.4 .2 2.8 .3 4.3 .4c.7 0 1.4 .1 2.2 .1s1.4 0 2.2 0c11.7 0 22.6-3.1 32-8.6l0 209.1c-4.7-2.7-9.8-4.9-15.2-6.3c-2.7-.7-5.4-1.3-8.2-1.7c-1.4-.2-2.8-.3-4.3-.4c-.7 0-1.4-.1-2.2-.1s-1.4 0-2.2 0c-11.7 0-22.6 3.1-32 8.6l0-209.1zM119.4 64l209.1 0c-2.7 4.7-4.9 9.8-6.3 15.2c-.7 2.7-1.3 5.4-1.7 8.2c-.2 1.4-.3 2.8-.4 4.3c0 .7-.1 1.4-.1 2.2s0 1.4 0 2.2c0 11.7 3.1 22.6 8.6 32l-209.1 0c2.7-4.7 4.9-9.8 6.3-15.2c.7-2.7 1.3-5.4 1.7-8.2c.2-1.4 .3-2.8 .4-4.3c0-.7 .1-1.4 .1-2.2s0-1.4 0-2.2c0-11.7-3.1-22.6-8.6-32zm0 320l209.1 0c-2.7 4.7-4.9 9.8-6.3 15.2c-.7 2.7-1.3 5.4-1.7 8.2c-.2 1.4-.3 2.8-.4 4.3c0 .7-.1 1.4-.1 2.2s0 1.4 0 2.2c0 11.7 3.1 22.6 8.6 32l-209.1 0c2.7-4.7 4.9-9.8 6.3-15.2c.7-2.7 1.3-5.4 1.7-8.2c.2-1.4 .3-2.8 .4-4.3c0-.7 .1-1.4 .1-2.2s0-1.4 0-2.2c0-11.7-3.1-22.6-8.6-32zM352 151.4c4.7 2.7 9.8 4.9 15.2 6.3c2.7 .7 5.4 1.3 8.2 1.7c1.4 .2 2.8 .3 4.3 .4c.7 0 1.4 .1 2.2 .1s1.4 0 2.2 0c11.7 0 22.6-3.1 32-8.6l0 209.1c-4.7-2.7-9.8-4.9-15.2-6.3c-2.7-.7-5.4-1.3-8.2-1.7c-1.4-.2-2.8-.3-4.3-.4c-.7 0-1.4-.1-2.2-.1s-1.4 0-2.2 0c-11.7 0-22.6 3.1-32 8.6l0-209.1z','M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM64 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm320 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0-320a64 64 0 1 1 0 128 64 64 0 1 1 0-128z']
      
    ]
  };

  

  
  

  var faFilePlus = {
    prefix: 'fasds',
    iconName: 'file-plus',
    icon: [
      384,
      512,
      [],
      'f319',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM96 312l0 48 24 0 48 0 0 48 0 24 48 0 0-24 0-48 48 0 24 0 0-48-24 0-48 0 0-48 0-24-48 0 0 24 0 48-48 0-24 0z','M384 160l-160 0L224 0 384 160zM216 240l0 24 0 48 48 0 24 0 0 48-24 0-48 0 0 48 0 24-48 0 0-24 0-48-48 0-24 0 0-48 24 0 48 0 0-48 0-24 48 0z']
      
    ]
  };

  

  
  

  var faStamp = {
    prefix: 'fasds',
    iconName: 'stamp',
    icon: [
      512,
      512,
      [],
      'f5bf',
      
      ['M32 416l64 0 0 32 320 0 0-32 64 0 0 32 0 64-64 0L96 512l-64 0 0-64 0-32z','M352 96c0 28.4-12.4 54-32 71.6l0 88.4 80 0c61.9 0 112 50.1 112 112l0 48L0 416l0-48c0-61.9 50.1-112 112-112l80 0 0-88.4C172.4 150 160 124.4 160 96c0-53 43-96 96-96s96 43 96 96z']
      
    ]
  };

  

  
  

  var faSaltShaker = {
    prefix: 'fasds',
    iconName: 'salt-shaker',
    icon: [
      384,
      512,
      [129474],
      'e446',
      
      ['M0 512l64.5 0 255 0 64.5 0-8-64L344 192l-64.5 0 32 256-239 0 32-256L40 192 8 448 0 512z','M335.9 127l8.1 65-64.5 0-175 0L40 192l8.1-65C57.2 54.5 118.9 0 192 0s134.8 54.5 143.9 127zM192 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM160 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faChartMixedUpCircleDollar = {
    prefix: 'fasds',
    iconName: 'chart-mixed-up-circle-dollar',
    icon: [
      576,
      512,
      [],
      'e5d9',
      
      ['M12 199l40 50L192.6 136.5l108.2 81.1 19.3 14.5c4.4-3.6 9-7.1 13.8-10.3l6-4.8L480 105l0 39 0 32 64 0 0-32 0-112 0-32L512 0 400 0 368 0l0 64 32 0 28.8 0L319.4 151.5 211.2 70.4 191.4 55.5 172 71 12 199zM32 320l0 160 64 0 0-160-64 0zm128-96l0 256 64 0 0-256-64 0z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM408.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L372 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z']
      
    ]
  };

  

  
  

  var faICursor = {
    prefix: 'fasds',
    iconName: 'i-cursor',
    icon: [
      256,
      512,
      [],
      'f246',
      
      ['M32 224l0 64 32 0 32 0 0-64-32 0-32 0zm128 0l0 64 32 0 32 0 0-64-32 0-32 0z','M32 0L0 0 0 64l32 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L0 448l0 64 32 0c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3l32 0 0-64-32 0c-35.3 0-64-28.7-64-64l0-256c0-35.3 28.7-64 64-64l32 0 0-64L224 0c-38.2 0-72.5 16.8-96 43.3C104.5 16.8 70.2 0 32 0z']
      
    ]
  };

  

  
  

  var faSquareArrowUpLeft = {
    prefix: 'fasds',
    iconName: 'square-arrow-up-left',
    icon: [
      448,
      512,
      [],
      'e263',
      
      ['M0 32L0 480l448 0 0-448L0 32zM112 144l24 0 152 0 24 0 0 48-24 0-94.1 0L329 327l17 17L312 377.9l-17-17-135-135L160 328l0 24-48 0 0-24 0-160 0-24z','M112 144l24 0 152 0 24 0 0 48-24 0-94.1 0L329 327l17 17L312 377.9l-17-17-135-135L160 328l0 24-48 0 0-24 0-160 0-24z']
      
    ]
  };

  

  
  

  var fa5 = {
    prefix: 'fasds',
    iconName: '5',
    icon: [
      320,
      512,
      [],
      '35',
      
      ['M36.4 32L64 32l192 0 32 0 0 64-32 0L91.6 96 74.9 208 184 208c75.1 0 136 60.9 136 136s-60.9 136-136 136l-78.1 0c-43.4 0-82.2-26.9-97.4-67.5L2 395.2 62 372.8 68.4 390c5.9 15.6 20.8 26 37.5 26l78.1 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L37.8 272 .6 272l5.5-36.7 26.2-176L36.4 32z','']
      
    ]
  };

  

  
  

  var faLandMineOn = {
    prefix: 'fasds',
    iconName: 'land-mine-on',
    icon: [
      640,
      512,
      [],
      'e51b',
      
      ['M64 512l512 0L512 384l-384 0L64 512zM192 288l0 64 256 0 0-64-256 0z','M344 0l0 24 0 144 0 24-48 0 0-24 0-144 0-24 48 0zM49.9 118.6l19.7 13.7 104 72 19.7 13.7-27.3 39.5-19.7-13.7-104-72L22.6 158.1l27.3-39.5zm567.5 39.5l-19.7 13.7-104 72-19.7 13.7-27.3-39.5 19.7-13.7 104-72 19.7-13.7 27.3 39.5z']
      
    ]
  };

  

  
  

  var faTricycle = {
    prefix: 'fasds',
    iconName: 'tricycle',
    icon: [
      512,
      512,
      [],
      'e5c3',
      
      ['M224 368.1A112 112 0 1 1 0 368a112 112 0 1 1 224 .1zM56 368a56 56 0 1 0 112 0A56 56 0 1 0 56 368zm200-16c0-51.5 30.4-95.9 74.2-116.2c4.7 18.7 9.4 37.4 14 56.1c-19.4 12.9-32.2 35-32.2 60c0 39.8 32.2 72 72 72s72-32.2 72-72c0-37.5-28.6-68.2-65.2-71.7c-4.7-18.7-9.4-37.4-14-56.1c2.4-.1 4.8-.2 7.2-.2c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128z','M256 32l24 0 112 0 24 0 0 24 0 56 0 11-8.4 7.2-44.7 38.3 44.4 177.6 5.8 23.3-46.6 11.6-5.8-23.3L319.3 192l-12.1 0c-57.6 0-110.9 29.5-141.6 77.6c-14.3-7.8-30.5-12.6-47.8-13.5c1.2-2.3 2.5-4.5 3.9-6.7L77.6 176 56 176l-24 0 0-48 24 0 80 0 24 0 0 48-24 0-2.4 0 19.6 32.6c40-40.7 95.3-64.6 154.1-64.6l10.6 0 2.6-2.2L368 101l0-21-88 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faFaceZany = {
    prefix: 'fasds',
    iconName: 'face-zany',
    icon: [
      512,
      512,
      [],
      'e3a4',
      
      ['M34.4 384c36.2 62.7 94.9 104.3 160.1 120.5c-11.5-15.8-18.4-35.4-18.4-56.5l0-44.5c-16-10.5-30.2-24-41.9-40.2L409.9 204.1c29.4 65.1 11.7 141.7-41.9 187.4l0 56.5c0 15.4-3.6 30-10.1 42.9c8.8-3.8 17.5-8.2 26.1-13.2c82.1-47.4 128-133.5 128-221.9c0-43.4-11.1-87.4-34.3-127.8C407.1 5.6 250.5-36.4 128.1 34.3S-36.3 261.6 34.4 384zM192 224A64 64 0 1 1 64 224a64 64 0 1 1 128 0zm192-72a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z','M296 104a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM104 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336 384l0 64c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-64 48 0 0 24 32 0 0-24 48 0z']
      
    ]
  };

  

  
  

  var faSquareRss = {
    prefix: 'fasds',
    iconName: 'square-rss',
    icon: [
      448,
      512,
      ["rss-square"],
      'f143',
      
      ['M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm96 16l0 48c123.7 0 224 100.3 224 224l48 0c0-150.2-121.8-272-272-272zm0 96l0 48c70.7 0 128 57.3 128 128l48 0c0-97.2-78.8-176-176-176zm0 144a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M368 384c0-150.2-121.8-272-272-272l0 48c123.7 0 224 100.3 224 224l48 0zm-96 0c0-97.2-78.8-176-176-176l0 48c70.7 0 128 57.3 128 128l48 0zm-144 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faRssSquare = faSquareRss;
  

  
  

  var faOctagonMinus = {
    prefix: 'fasds',
    iconName: 'octagon-minus',
    icon: [
      512,
      512,
      ["minus-octagon"],
      'f308',
      
      ['M0 160L160 0 352 0 512 160l0 192L352 512l-192 0L0 352 0 160zm160 72l0 48 24 0 144 0 24 0 0-48-24 0-144 0-24 0z','M160 232l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  
    var faMinusOctagon = faOctagonMinus;
  

  
  

  var faDiceFive = {
    prefix: 'fasds',
    iconName: 'dice-five',
    icon: [
      448,
      512,
      [9860],
      'f523',
      
      ['M0 32L0 480l448 0 0-448L0 32zM160 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm0 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm0 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faRoadCircleCheck = {
    prefix: 'fasds',
    iconName: 'road-circle-check',
    icon: [
      640,
      512,
      [],
      'e564',
      
      ['M32 480l256 0 0-64 0-32 32.7 0c-.5-5.3-.7-10.6-.7-16c0-16.6 2.3-32.7 6.6-48L288 320l0-32 0-64 0-32 64 0 0 32 0 42.8c31.9-45.2 84.5-74.8 144-74.8c10.4 0 20.6 .9 30.5 2.6L480 32 352 32l0 64 0 32-64 0 0-32 0-64L160 32 32 480z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faFaceRelieved = {
    prefix: 'fasds',
    iconName: 'face-relieved',
    icon: [
      512,
      512,
      [],
      'e389',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm91.2-2.4l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0zm7.5-118.5c2.5-3.8 5.1-7.6 7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7c2.1-.7 4.2-1.4 6.3-2.1c3.4 10.1 6.7 20.2 10.1 30.4c-2.1 .7-4.2 1.4-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1c-2.5 3.8-5.1 7.6-7.6 11.5L98.7 135.1zm66 244.2l22.6-22.6c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3l22.6 22.6C329.4 397.2 298.9 416 256 416s-73.4-18.8-91.3-36.7zM283.2 253.6l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0zM314.9 95.2l10.1-30.4 6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c-8.9 5.9-17.8 11.8-26.6 17.8c-2.5-3.8-5.1-7.6-7.6-11.5c-13.8-20.7-34.1-36.3-57.8-44.1c-2.1-.7-4.2-1.4-6.3-2.1z','M190.7 97.3c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5L98.7 135.1l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1 10.1 30.4-6.3 2.1zm130.5 0l-6.3-2.1 10.1-30.4 6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5-26.6 17.8L379 141.4c-13.8-20.7-34.1-36.3-57.8-44.1zm73.9 137.1l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0zm-278.4 0c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0l25.6-19.2z']
      
    ]
  };

  

  
  

  var faEclipse = {
    prefix: 'fasds',
    iconName: 'eclipse',
    icon: [
      640,
      512,
      [],
      'f749',
      
      ['M0 150L73.1 256 0 362l126.7 23.3L150 512l106-73.1L362 512l12.5-68.2c-31.6-15.1-58.8-37.9-79.2-66c-12.4 4-25.6 6.2-39.4 6.2c-70.7 0-128-57.3-128-128s57.3-128 128-128c13.7 0 27 2.2 39.4 6.2c20.3-28.1 47.6-50.9 79.2-66L362 0 256 73.1 150 0 126.7 126.7 0 150zM160 256c0 53 43 96 96 96c7.6 0 15-.9 22.1-2.6C264 321.3 256 289.6 256 256s8-65.4 22.1-93.4c-7.1-1.7-14.5-2.6-22.1-2.6c-53 0-96 43-96 96z','M464 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352z']
      
    ]
  };

  

  
  

  var faAlarmClock = {
    prefix: 'fasds',
    iconName: 'alarm-clock',
    icon: [
      512,
      512,
      [9200],
      'f34e',
      
      ['M32 288c0 50.3 16.6 96.8 44.6 134.2L57.4 441.4 34.7 464 80 509.3l22.6-22.6 19.2-19.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l19.2 19.2L432 509.3 477.3 464l-22.6-22.6-19.2-19.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zM232 160l48 0 0 24 0 94.1 41 41 17 17L304 369.9l-17-17-48-48-7-7 0-9.9 0-104 0-24z','M160.9 25.5L14.9 147.2C5.5 132.3 0 114.7 0 95.8C0 42.9 42.9 0 95.8 0c25.1 0 48 9.7 65.1 25.5zm190.3 0C368.2 9.7 391.1 0 416.2 0C469.1 0 512 42.9 512 95.8c0 18.9-5.5 36.5-14.9 51.4L351.1 25.5zM280 184l0 94.1 41 41 17 17L304 369.9l-17-17-48-48-7-7 0-9.9 0-104 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faEarDeaf = {
    prefix: 'fasds',
    iconName: 'ear-deaf',
    icon: [
      512,
      512,
      ["deaf","deafness","hard-of-hearing"],
      'f2a4',
      
      ['M2.7 464L48 509.3l22.6-22.6 112-112L205.3 352 160 306.7l-22.6 22.6-112 112L2.7 464zm392-392L440 117.3l22.6-22.6 24-24L509.3 48 464 2.7 441.4 25.4l-24 24L394.7 72z','M128 240c0-61.9 50.1-112 112-112s112 50.1 112 112c0 38.8-19.7 73-49.8 93.2L288 342.7l0 17.1 0 40.2c0 26.5-21.5 48-48 48l-32 0 0 64 32 0c61.9 0 112-50.1 112-112l0-24.2c39-32.2 64-81.1 64-135.8c0-97.2-78.8-176-176-176S64 142.8 64 240l64 0zm80 0c0-17.7 14.3-32 32-32s32 14.3 32 32l48 0c0-44.2-35.8-80-80-80s-80 35.8-80 80l48 0z']
      
    ]
  };

  
    var faDeaf = faEarDeaf;
  
    var faDeafness = faEarDeaf;
  
    var faHardOfHearing = faEarDeaf;
  

  
  

  var faClockThreeThirty = {
    prefix: 'fasds',
    iconName: 'clock-three-thirty',
    icon: [
      512,
      512,
      [],
      'e357',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232-24l24 0 104 0 24 0 0 48-24 0-80 0 0 112 0 24-48 0 0-24 0-136 0-24z','M232 416l0-24 0-136 0-24 24 0 104 0 24 0 0 48-24 0-80 0 0 112 0 24-48 0z']
      
    ]
  };

  

  
  

  var faFaceGrinWink = {
    prefix: 'fasds',
    iconName: 'face-grin-wink',
    icon: [
      512,
      512,
      ["grin-wink"],
      'f58c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96 46.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zM208.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm58.8 10.4c34.4-45.9 103.2-45.9 137.6 0l-25.6 19.2c-21.6-28.8-64.8-28.8-86.4 0l-25.6-19.2z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm116.4-2.4c21.6-28.8 64.8-28.8 86.4 0l25.6-19.2c-34.4-45.9-103.2-45.9-137.6 0l25.6 19.2z']
      
    ]
  };

  
    var faGrinWink = faFaceGrinWink;
  

  
  

  var faHatWitch = {
    prefix: 'fasds',
    iconName: 'hat-witch',
    icon: [
      576,
      512,
      [],
      'f6e7',
      
      ['M0 416l96 0 128 0 32 0 64 0 32 0 128 0 96 0 0 32L448 512l-320 0L0 448l0-32z','M96 416L224 128 440 0 544 88 512 192l-32-64-64 0-32 64 96 224-128 0 0-80 0-16-16 0-96 0-16 0 0 16 0 80L96 416zm160 0l0-64 64 0 0 64-64 0z']
      
    ]
  };

  

  
  

  var faCoffeeBeans = {
    prefix: 'fasds',
    iconName: 'coffee-beans',
    icon: [
      512,
      512,
      [],
      'e13f',
      
      ['M0 352c0 82.5 50 150.4 114.1 159.1l21.2-63.7c-15.6-62.5-31.2-125-46.9-187.5c-.4-1.5-.8-3-1.1-4.5c.5-1.5 1-2.9 1.5-4.4c6.3-19 12.7-38 19-57C46.7 206.1 0 272.2 0 352zm120.7-95.4l46.9 187.5 1.1 4.5-1.5 4.4-19 57C209.3 497.9 256 431.8 256 352c0-82.5-50-150.4-114.1-159.1c-7.1 21.2-14.2 42.5-21.2 63.7zM243.4 46.4c-35.3 51.7-21.8 132.2 34.6 189c58.7 59 142.8 71.3 193.8 30.3c-9.4-18.8-18.8-37.7-28.3-56.5c-55.2-33.1-110.5-66.3-165.7-99.4c-1.3-.8-2.7-1.6-4-2.4c-.7-1.4-1.4-2.8-2.1-4.2c-9.5-18.9-18.9-37.9-28.4-56.8zm23.5-24.6c10.5 21 21 41.9 31.4 62.9c55.2 33.1 110.5 66.3 165.7 99.4c1.3 .8 2.7 1.6 4 2.4c.7 1.4 1.4 2.8 2.1 4.2c8.2 16.4 16.4 32.8 24.6 49.2c32.5-51.8 18.4-130-36.8-185.6c-57.6-58-139.8-70.9-191-32.5z','M271.8 103.2L243.4 46.4c3.5-5.2 7.6-10.1 12.1-14.7c3.6-3.6 7.4-6.9 11.4-9.9l31.4 62.9 165.7 99.4 4 2.4 2.1 4.2L494.8 240c-4.1 6.5-8.8 12.5-14.3 18c-2.7 2.8-5.6 5.3-8.6 7.7l-28.3-56.5L277.9 109.8l-4-2.4-2.1-4.2zM88.8 250.9l19-57c6.6-1.3 13.3-2 20.2-2c4.7 0 9.3 .3 13.9 .9l-21.2 63.7 46.9 187.5 1.1 4.5-1.5 4.4-19 57c-6.6 1.3-13.3 2-20.2 2c-4.7 0-9.3-.3-13.9-.9l21.2-63.7L88.5 259.9l-1.1-4.5 1.5-4.4z']
      
    ]
  };

  

  
  

  var faMessageSms = {
    prefix: 'fasds',
    iconName: 'message-sms',
    icon: [
      512,
      512,
      [],
      'e1e5',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7c-9.8-6.5-19.6-13.1-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32c-2.7 0-5.3 0-8 0s-5.3 0-8 0l-19.2 0C112.5 144 96 160.5 96 180.8zM192 144l0 16 0 96 0 16 32 0 0-16 0-48 19.2 25.6L256 250.7c4.3-5.7 8.5-11.4 12.8-17.1L288 208l0 48 0 16 32 0 0-16 0-96 0-16-24 0-4.8 6.4L256 197.3l-35.2-46.9L216 144l-24 0zm144 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7c-9.8-6.5-19.6-13.1-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-16 0-8 0c-3.8 0-7.6 0-11.3 0c-20.3 .1-36.7 16.6-36.7 36.8z','M160 144l-8 0-19.2 0C112.5 144 96 160.5 96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-8 0s0 0 0 0zm32 0l0 16 0 96 0 16 32 0 0-16 0-48 19.2 25.6L256 250.7l12.8-17.1L288 208l0 48 0 16 32 0 0-16 0-96 0-16-24 0-4.8 6.4L256 197.3l-35.2-46.9L216 144l-24 0zm180.7 0c-20.3 .1-36.7 16.6-36.7 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240l-16 0 0 32 16 0 27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0 16 0 0-32-16 0-8 0s0 0 0 0l-11.3 0z']
      
    ]
  };

  

  
  

  var faChessBishop = {
    prefix: 'fasds',
    iconName: 'chess-bishop',
    icon: [
      320,
      512,
      [9821],
      'f43a',
      
      ['M0 480l48-48 16 0 192 0 16 0 48 48 0 32L0 512l0-32z','M96 0l32 0 64 0 32 0 0 64-27 0c22.3 21.4 50.8 52.7 73.8 90.6L164.7 260.7 153.4 272 176 294.6l11.3-11.3 99.4-99.4C301.8 215.6 312 250.7 312 288c0 47.4-30.8 72.3-56 84.7l0 59.3L64 432l0-59.3C38.8 360.3 8 335.4 8 288C8 190.2 78.1 107.2 123 64L96 64 96 0z']
      
    ]
  };

  

  
  

  var faSealExclamation = {
    prefix: 'fasds',
    iconName: 'seal-exclamation',
    icon: [
      512,
      512,
      [],
      'e242',
      
      ['M0 256l75 75 0 106 106 0 75 75 75-75 106 0 0-106 75-75-75-75 0-106L331 75 256 0 181 75 75 75l0 106L0 256zM232 128c16 0 32 0 48 0c0 8 0 16 0 24c0 37.3 0 74.7 0 112c0 8 0 16 0 24c-16 0-32 0-48 0c0-8 0-16 0-24c0-37.3 0-74.7 0-112c0-8 0-16 0-24zm0 192l48 0c0 16 0 32 0 48l-48 0c0-16 0-32 0-48z','M280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faGrateDroplet = {
    prefix: 'fasds',
    iconName: 'grate-droplet',
    icon: [
      576,
      512,
      [],
      'e194',
      
      ['M0 32L0 64 0 256 0 448l0 32 32 0 96 0 96 0 96 0 24.2 0c-15.3-22.9-24.2-50.4-24.2-80l0-2.1c0-28.3 8.2-56 23.7-79.7L448 157.9 448 64l0-32-32 0-96 0-96 0-96 0L32 32 0 32zM64 96l32 0 0 128-32 0L64 96zm0 192l32 0 0 128-32 0 0-128zM160 96l32 0 0 128-32 0 0-128zm0 192l32 0 0 128-32 0 0-128zM256 96l32 0 0 128-32 0 0-128zm0 192l32 0 0 128-32 0 0-128zM352 96l32 0 0 128-32 0 0-128z','M370.5 335.6L464 192l93.5 143.6c12.1 18.5 18.5 40.2 18.5 62.3V400c0 61.9-50.1 112-112 112s-112-50.1-112-112v-2.1c0-22.1 6.4-43.7 18.5-62.3z']
      
    ]
  };

  

  
  

  var faVideoArrowUpRight = {
    prefix: 'fasds',
    iconName: 'video-arrow-up-right',
    icon: [
      576,
      512,
      [],
      'e2c9',
      
      ['M0 64L0 448l384 0 0-133L384 197l0-133L0 64zM86.1 328l17-17 103-103L152 208l-24 0c0-16 0-32 0-48l24 0 112 0 24 0c0 8 0 16 0 24c0 37.3 0 74.7 0 112c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-18 0-36 0-54.1c-34.3 34.3-68.7 68.7-103 103c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9z','M576 448l0-384L384 197 384 315 576 448zM152 160l-24 0 0 48 24 0 54.1 0L103 311l-17 17L120 361.9l17-17 103-103 0 54.1 0 24 48 0 0-24 0-112 0-24-24 0-112 0z']
      
    ]
  };

  

  
  

  var faAcorn = {
    prefix: 'fasds',
    iconName: 'acorn',
    icon: [
      448,
      512,
      [],
      'f6ae',
      
      ['M48 192l0 32c0 80 32 208 176 256c144-48 176-176 176-256l0-32c-117.4 0-234.7 0-352 0z','M259.7 48.4l13.7-19.7L233.9 1.4 220.3 21.1c-9 12.9-15.1 27.6-18.1 42.9L96 64C43 64 0 107 0 160l0 32 448 0 0-32c0-53-43-96-96-96L251.8 64c1.9-5.5 4.6-10.7 8-15.6z']
      
    ]
  };

  

  
  

  var faFlute = {
    prefix: 'fasds',
    iconName: 'flute',
    icon: [
      640,
      512,
      [],
      'f8b9',
      
      ['M0 160L0 352l96 0 0-192L0 160zm128 0l0 192 512 0 0-192-512 0zm216 96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M128 160l-32 0 0 192 32 0 0-192zM320 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  

  
  

  var faRaygun = {
    prefix: 'fasds',
    iconName: 'raygun',
    icon: [
      576,
      512,
      [],
      'e025',
      
      ['M64 0l0 74.8C78.5 67.9 94.8 64 112 64l80 0L64 0zM288 32l0 24 0 8 0 192 0 32 0 8 0 24 48 0 0-24 0-240 0-24-48 0zm80 32l0 24 0 176 0 24 48 0 0-24 0-56 0-64 0-56 0-24-48 0z','M0 176C0 114.1 50.1 64 112 64l176 0 0 192 0 32L176 512 48 448l80-160-16 0C50.1 288 0 237.9 0 176zm416-32l64 0 96-48 0 160-96-48-64 0 0-64zM112 200a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  

  
  

  var faSkeletonRibs = {
    prefix: 'fasds',
    iconName: 'skeleton-ribs',
    icon: [
      640,
      512,
      [],
      'e5cb',
      
      ['M0 80l0 32 0 96 0 32L0 480l0 32 64 0 0-32 0-240 0-16 16-12c30.2-22.7 48-58.2 48-96l0-4 0-32L96 80 32 80 0 80zM137.8 199.7l.1 .6 .3-.7-.4 .1zm22.4 173L288 337.9l0 39.9 20.8-7.8 11.2-4.2 11.2 4.2 20.8 7.8 0-38.8 118.8 35.6 9.1 2.7c-.3-11.2-1.4-22.7-3.2-34.4s-4.1-23.6-7-35.5L352 272.2l0-40.3 102 22.7c-6-17.3-12.7-34.1-19.4-50c-3.3-7.7-6.6-15.1-9.8-22.1L352 166.3l0-38.3-64 0 0 38.3-72.7 16.2c-3.2 7-6.5 14.4-9.8 22.1c-6.8 15.8-13.4 32.6-19.4 50l102-22.7 0 39.7L171.3 303.4c-5.9 23.5-9.9 47-11 69.3zM288 0l0 32 0 32 64 0 0-32 0-32L288 0zm0 446.2l0 33.8 0 32 64 0 0-32 0-33.8c-10.7-4-21.3-8-32-12c-10.7 4-21.3 8-32 12zM501.8 199.6c.1 .2 .2 .4 .3 .7l.1-.6-.4-.1zM512 80l0 32 0 4c0 37.8 17.8 73.3 48 96l16 12 0 16 0 240 0 32 64 0 0-32 0-240 0-32 0-96 0-32-32 0-64 0-32 0z','M205.9 64L224 64l192 0 18.1 0 9.3 15.5L416 96c27.4-16.5 27.4-16.5 27.4-16.5s0 0 0 0c0 0 0 0 0 0l.1 .1 .3 .4 .9 1.5c.8 1.3 1.9 3.2 3.2 5.6c2.8 4.9 6.7 11.9 11.3 20.7c9.3 17.6 21.7 42.4 34.1 71.4C517.9 236.4 544 313.3 544 384l0 64 0 32-32 0-64 0-5.8 0-5.4-2L320 434.2 203.2 478l-5.4 2-5.8 0-64 0-32 0 0-32 0-64c0-70.7 26.1-147.6 50.6-204.6c12.4-29 24.8-53.8 34.1-71.4c4.7-8.8 8.6-15.8 11.3-20.7c1.4-2.4 2.5-4.3 3.2-5.6l.9-1.5 .3-.4 .1-.1c0 0 0 0 0 0s0 0 0 0L224 96 196.6 79.5 205.9 64zm36.8 64c-1.6 3-3.4 6.3-5.4 10c-8.7 16.4-20.3 39.6-31.9 66.6C181.9 259.6 160 326.7 160 384l0 32 26.2 0 122.6-46 11.2-4.2 11.2 4.2 122.6 46 26.2 0 0-32c0-57.3-21.9-124.4-45.4-179.4c-11.6-27-23.2-50.2-31.9-66.6c-2-3.7-3.8-7-5.4-10l-154.7 0z']
      
    ]
  };

  

  
  

  var faThoughtBubble = {
    prefix: 'fasds',
    iconName: 'thought-bubble',
    icon: [
      512,
      512,
      [],
      'e32e',
      
      ['M0 448l0 64 64 0 0-64L0 448zm104-56l0 80 80 0 0-80-80 0z','M256 0c-53.7 0-99.7 33.1-118.7 80L128 80C57.3 80 0 137.3 0 208s57.3 128 128 128l44.8 0c16.6 28.7 47.6 48 83.2 48s66.6-19.3 83.2-48l44.8 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-9.3 0c-19-46.9-65-80-118.7-80z']
      
    ]
  };

  

  
  

  var faUpToDottedLine = {
    prefix: 'fasds',
    iconName: 'up-to-dotted-line',
    icon: [
      448,
      512,
      [],
      'e457',
      
      ['M0 32l64 0 0 64L0 96 0 32zm96 0l64 0 0 64L96 96l0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64zm96 0l64 0 0 64-64 0 0-64z','M224 128L64 288l0 32 96 0 0 160 128 0 0-160 96 0 0-32L224 128z']
      
    ]
  };

  

  
  

  var faFaceGrinTongue = {
    prefix: 'fasds',
    iconName: 'face-grin-tongue',
    icon: [
      512,
      512,
      [128539,"grin-tongue"],
      'f589',
      
      ['M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-31.9-23.3-55.2-57.8-64-97.9c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29c-8.8 40.2-32.3 75-64.5 98.3l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M208.4 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 448l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64z']
      
    ]
  };

  
    var faGrinTongue = faFaceGrinTongue;
  

  
  

  var faPeriod = {
    prefix: 'fasds',
    iconName: 'period',
    icon: [
      192,
      512,
      [],
      '2e',
      
      ['M32 352H160V480H32V352z','']
      
    ]
  };

  

  
  

  var faBridgeCircleXmark = {
    prefix: 'fasds',
    iconName: 'bridge-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e4cb',
      
      ['M32 32l32 0 512 0 32 0 0 64-32 0-40 0 0 64 72 0 0 72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96l0 96-96 0 0-96c0-53-43-96-96-96l0-128 72 0 0-64L64 96 32 96l0-64zM152 96l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faFaceKiss = {
    prefix: 'fasds',
    iconName: 'face-kiss',
    icon: [
      512,
      512,
      [128535,"kiss"],
      'f596',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm144.4-48c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm91.7 95l3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-1.3-5-2.6-10-3.7-15.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7c0-4.6 0-9.3 0-14c.1 0 .1-.1 .5-.3l.6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3c-.2-.1-.3-.2-.7-.4zm132.3-95a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  
    var faKiss = faFaceKiss;
  

  
  

  var faWindowFrameOpen = {
    prefix: 'fasds',
    iconName: 'window-frame-open',
    icon: [
      512,
      512,
      [],
      'e050',
      
      ['M96 64l0 160 136 0 0-160L96 64zm184 0l0 160 136 0 0-160L280 64z','M480 64l0 160 0 64-64 0L96 288l-64 0 0-64L32 64 32 0 96 0 416 0l64 0 0 64zM232 64L96 64l0 160 136 0 0-160zm48 0l0 160 136 0 0-160L280 64zM96 448l320 0 0-128 64 0 0 128 32 0 0 64-32 0-32 0L64 512l-32 0L0 512l0-64 32 0 0-128 64 0 0 128z']
      
    ]
  };

  

  
  

  var faLightbulbCfl = {
    prefix: 'fasds',
    iconName: 'lightbulb-cfl',
    icon: [
      320,
      512,
      [],
      'e5a6',
      
      ['M0 32L0 96 160 64l0-64L0 32zm0 96l0 64 320-64 0-64L0 128zm0 96l0 64 320-64 0-64L0 224zm96 77.4L96 384l48 0 0-92.2-48 9.6zm80-16.6l0 35.2 0 28.8 0 35.2 48 0 0-44.8L320 320l0-64L176 284.8z','M256 384L64 384l0 96 64 0 0 32 64 0 0-32 64 0 0-96z']
      
    ]
  };

  

  
  

  var faCommentArrowDown = {
    prefix: 'fasds',
    iconName: 'comment-arrow-down',
    icon: [
      512,
      512,
      [],
      'e143',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm150.1 16L184 222.1l17 17 31 31L232 152l0-24 48 0 0 24 0 118.1 31-31 17-17L361.9 256l-17 17-72 72-17 17-17-17-72-72-17-17z','M280 128l0 24 0 118.1 31-31 17-17L361.9 256l-17 17-72 72-17 17-17-17-72-72-17-17L184 222.1l17 17 31 31L232 152l0-24 48 0z']
      
    ]
  };

  

  
  

  var faCameraWeb = {
    prefix: 'fasds',
    iconName: 'camera-web',
    icon: [
      448,
      512,
      ["webcam"],
      'f832',
      
      ['M96 224a128 128 0 1 0 256 0A128 128 0 1 0 96 224zm48 0c0-44.2 35.8-80 80-80l0 32c-26.5 0-48 21.5-48 48l-32 0z','M448 224c0 81-43 152-107.5 191.4L416 472l0 40L32 512l0-40 75.5-56.6C43 376 0 305 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224zM224 384a160 160 0 1 0 0-320 160 160 0 1 0 0 320z']
      
    ]
  };

  
    var faWebcam = faCameraWeb;
  

  
  

  var faSquareM = {
    prefix: 'fasds',
    iconName: 'square-m',
    icon: [
      448,
      512,
      [],
      'e276',
      
      ['M0 32L0 480l448 0 0-448L0 32zm96 96l36.3 0 7.2 9.9L224 255l84.5-117.1 7.2-9.9 36.3 0 0 24 0 208 0 24-48 0 0-24 0-133.8-60.5 83.8L224 337l-19.5-26.9L144 226.2 144 360l0 24-48 0 0-24 0-208 0-24z','M96 128l0 24 0 208 0 24 48 0 0-24 0-133.8 60.5 83.8L224 337l19.5-26.9L304 226.2 304 360l0 24 48 0 0-24 0-208 0-24-36.3 0-7.2 9.9L224 255 139.5 137.9l-7.2-9.9L96 128z']
      
    ]
  };

  

  
  

  var faFaceScream = {
    prefix: 'fasds',
    iconName: 'face-scream',
    icon: [
      640,
      512,
      [],
      'e38b',
      
      ['M64 256c0 20.6 2.4 40.7 7 59.9L82.3 306l20.6-18 21 17.5c57.5 48 87.8 118 98 187C252.1 505.1 285.2 512 320 512c34.8 0 68-6.9 98.2-19.5c10.2-69 40.4-139 98-187l21-17.5 20.6 18 11.3 9.8c4.6-19.2 7-39.2 7-59.8C576 114.6 461.4 0 320 0S64 114.6 64 256zm110.6-67c22.5-36.9 62.8-54.7 90.1-39.8s31.1 56.9 8.7 93.7s-62.8 54.7-90.1 39.8s-31.1-56.9-8.7-93.7zM272 368c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-32zm94.6-125c-22.5-36.9-18.6-78.8 8.7-93.7c6.5-3.6 13.8-5.3 21.4-5.3c24.1 0 51.6 17 68.7 45c22.5 36.9 18.6 78.8-8.7 93.7s-67.6-2.9-90.1-39.8z','M273.4 243c22.5-36.9 18.6-78.8-8.7-93.7s-67.6 2.9-90.1 39.8s-18.6 78.8 8.7 93.7s67.6-2.9 90.1-39.8zM82.3 512L192 512c-7-68.5-34.8-137-88.7-181.9L39.1 386.3c26.4 40 43.6 75.3 43.2 125.7zm475.5 0c-.4-50.5 16.7-85.7 43.2-125.7l-64.3-56.2C482.8 375 455 443.6 448 512l109.8 0zm-101-229.3c27.3-14.9 31.1-56.9 8.7-93.7s-62.8-54.7-90.1-39.8s-31.1 56.9-8.7 93.7s62.8 54.7 90.1 39.8z']
      
    ]
  };

  

  
  

  var faArrowUpSquareTriangle = {
    prefix: 'fasds',
    iconName: 'arrow-up-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-up-alt"],
      'f88b',
      
      ['M304 480L416 288 528 480l-224 0zM320 32l192 0 0 192-192 0 0-192z','M160 32.4l23.7 26 80 88 21.5 23.7-47.4 43.1-21.5-23.7L192 162.8 192 448l0 32-64 0 0-32 0-285.2-24.3 26.8L82.2 213.2 34.8 170.2l21.5-23.7 80-88 23.7-26z']
      
    ]
  };

  
    var faSortShapesUpAlt = faArrowUpSquareTriangle;
  

  
  

  var faFieldHockeyStickBall = {
    prefix: 'fasds',
    iconName: 'field-hockey-stick-ball',
    icon: [
      512,
      512,
      [127953,"field-hockey"],
      'f44c',
      
      ['M352 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zm8.8-322.3c.1 .1 .3 .2 .4 .3c26.5 17.7 53 35.4 79.5 53l38.9-56.9 27.1-39.6L427.5 12.3 400.4 51.9l-39.6 57.8z','M441 163.3L361.2 110 161.9 400.2c-6.7 9.7-17.6 15.5-29.4 15.5c-19.9 .1-36-16.1-35.9-36l0-2.4c.1-7.3 2.2-14.4 6.2-20.6l17.3-26.5 26.3-40.2L66.1 237.6 39.8 277.7 22.5 304.3C8.4 325.8 .8 350.9 .6 376.7l0 2.4C.1 452.3 59.5 512 132.8 511.8c43.3-.1 83.7-21.5 108.2-57.2L441 163.3z']
      
    ]
  };

  
    var faFieldHockey = faFieldHockeyStickBall;
  

  
  

  var faSquare2 = {
    prefix: 'fasds',
    iconName: 'square-2',
    icon: [
      448,
      512,
      [],
      'e257',
      
      ['M0 32L0 480l448 0 0-448L0 32zM126.4 173.4c6.4-4.8 12.7-9.7 19.1-14.5c5.4-4.1 10.8-8.2 16.2-12.3c15.8-12 35.2-18.4 55.1-18.1c1.2 0 2.3 0 3.4 .1c46.5 .7 83.8 38.6 83.8 85.1c0 23.5-9.7 46-26.9 62.1c-21.5 20.1-42.9 40.3-64.4 60.4c27.8 0 55.5 0 83.3 0c8 0 16 0 24 0l0 48c-8 0-16 0-24 0c-48 0-96 0-144 0c-8 0-16 0-24 0l0-34.4c2.5-2.4 5.1-4.7 7.6-7.1c36.2-34 72.5-67.9 108.7-101.9c7.5-7 11.7-16.8 11.7-27.1c0-20.3-16.3-36.8-36.6-37.1c-1.1 0-2.3 0-3.4-.1c-9.1-.1-18 2.8-25.3 8.3c-5.4 4.1-10.8 8.2-16.2 12.3c-6.4 4.9-12.7 9.7-19.1 14.5c-9.7-12.7-19.4-25.5-29.1-38.2z','M216.7 128.3c-19.9-.3-39.3 6.1-55.1 18.1l-16.2 12.3-19.1 14.5 29.1 38.2L174.5 197l16.2-12.3c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L135.6 342.5l-7.6 7.1 0 34.4 24 0 144 0 24 0 0-48-24 0-83.3 0 64.4-60.4C294.3 259.5 304 237 304 213.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1z']
      
    ]
  };

  

  
  

  var faSaxophone = {
    prefix: 'fasds',
    iconName: 'saxophone',
    icon: [
      640,
      512,
      [127927],
      'f8dc',
      
      ['M0 128l0 48 24 0 4.2 0L4.4 277.4C1.5 289.7 0 302.4 0 315.1l0 3.1C0 407.6 72.4 480 161.8 480c49.4 0 96.1-22.6 126.8-61.4L544 96l96 0 0-32L592 32l-80 0c-21 21-42 42-63 63c-11.3 11.3-22.6 22.6-33.9 33.9c-4.7 4.7-9.4 9.4-14.1 14.1c-11.3 11.3-22.6 22.6-33.9 33.9c-4.7 4.7-9.4 9.4-14.1 14.1c-11.3 11.3-22.6 22.6-33.9 33.9c-37.5 37.5-74.9 74.9-112.4 112.4c-4.2 4.2-10 6.6-16 6.6c-12.5 0-22.6-10.1-22.6-22.6l0-2.6c0-4.4 1.2-8.8 3.4-12.6L246.7 176l17.3 0 24 0 0-48-24 0L24 128 0 128zM120 320a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32-96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M319 225L353 191l-8-8-17-17L294.1 200l17 17 8 8zm48-48L401 143l-8-8-17-17L342.1 152l17 17 8 8zm48-48L449 95l-8-8-17-17L390.1 104l17 17 8 8zM152 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-32 96a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  

  
  

  var faStopwatch = {
    prefix: 'fasds',
    iconName: 'stopwatch',
    icon: [
      448,
      512,
      [9201],
      'f2f2',
      
      ['M16 304C16 200 92.3 113.8 192 98.4c10.4-1.6 21.1-2.4 32-2.4s21.6 .8 32 2.4c37.5 5.8 71.7 21.6 99.7 44.6c16.6 13.6 31 29.7 42.8 47.7C419.7 223.3 432 262.2 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304zM200 168l0 24 0 128 0 24 48 0 0-24 0-128 0-24-48 0z','M144 0l48 0 64 0 48 0 0 64-48 0 0 34.4c-10.4-1.6-21.1-2.4-32-2.4s-21.6 .8-32 2.4L192 64l-48 0 0-64zM355.7 143l21.6-21.6L400 98.7 445.3 144l-22.6 22.6-24.1 24.1c-11.7-18-26.2-34.1-42.8-47.7zM248 192l0 128 0 24-48 0 0-24 0-128 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faBlinds = {
    prefix: 'fasds',
    iconName: 'blinds',
    icon: [
      512,
      512,
      [],
      'f8fb',
      
      ['M0 128l128 0 0-64L32 64 16 64 0 128zM0 256l98.7 0c4.8-13.6 15.6-24.4 29.3-29.3l0-66.7L24 160 0 256zM0 384l512 0-24-96-298.7 0c-6.6 18.6-24.4 32-45.3 32c-.7 0-1.3 0-1.9 0s-1.3-.1-1.9-.1c-1.3-.1-2.5-.3-3.8-.5c-2.5-.4-4.9-1-7.3-1.8c-4.7-1.5-9.1-3.8-13-6.6c-7.9-5.7-14-13.7-17.3-23L24 288 0 384zM0 512l512 0-24-96L24 416 0 512zM160 64l0 64 352 0L496 64l-16 0L160 64zm0 96l0 66.7c.9 .3 1.7 .6 2.5 1s1.6 .7 2.5 1.1c1.6 .8 3.2 1.7 4.7 2.6c3 1.9 5.8 4.1 8.3 6.6c5 5 8.9 11.1 11.3 17.9L512 256l-24-96-328 0z','M32 0L0 0 0 64l32 0 96 0 0 162.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 64l320 0 32 0 0-64L480 0 32 0z']
      
    ]
  };

  

  
  

  var faCommand = {
    prefix: 'fasds',
    iconName: 'command',
    icon: [
      512,
      512,
      [],
      'e142',
      
      ['M0 320l0 32L0 480l0 32 32 0 128 0 32 0 0-32 0-96 0-64 0-128-64 0 0 128-96 0L0 320zm64 64l64 0 0 64-64 0 0-64zM320 0l0 32 0 96 0 64 0 128 64 0 0-128 96 0 32 0 0-32 0-128 0-32L480 0 352 0 320 0zm64 64l64 0 0 64-64 0 0-64z','M0 0L32 0 160 0l32 0 0 32 0 96 128 0 0 64-128 0-64 0-96 0L0 192l0-32L0 32 0 0zM320 320l64 0 96 0 32 0 0 32 0 128 0 32-32 0-128 0-32 0 0-32 0-96-128 0 0-64 128 0zM128 128l0-64L64 64l0 64 64 0zM384 384l0 64 64 0 0-64-64 0z']
      
    ]
  };

  

  
  

  var faPopsicle = {
    prefix: 'fasds',
    iconName: 'popsicle',
    icon: [
      320,
      512,
      [],
      'e43e',
      
      ['M0 160L0 384l128 0 0-224 64 0 0 224 128 0 0-224C320 71.6 248.4 0 160 0S0 71.6 0 160z','M128 160h64V512H128V160z']
      
    ]
  };

  

  
  

  var faBookArrowUp = {
    prefix: 'fasds',
    iconName: 'book-arrow-up',
    icon: [
      448,
      512,
      [],
      'e0ba',
      
      ['M64 416c0 17.7 14.3 32 32 32l120 0 0-64L96 384c-17.7 0-32 14.3-32 32zm200-32l0 64 88 0 64 0 0-64-64 0-88 0z','M96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96l120 0 0-64L96 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l120 0 0-174.1-39 39-17 17L126.1 232l17-17 80-80 17-17 17 17 80 80 17 17L320 265.9l-17-17-39-39L264 384l88 0 64 0 32 0L448 0 416 0 384 0 96 0zM264 448l0 64 120 0 32 0 32 0 0-64-32 0-64 0-88 0z']
      
    ]
  };

  

  
  

  var faCircleMicrophone = {
    prefix: 'fasds',
    iconName: 'circle-microphone',
    icon: [
      512,
      512,
      ["microphone-circle"],
      'e116',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-32l32 0 0 16 0 16c0 53 43 96 96 96s96-43 96-96l0-16 0-16 32 0 0 16 0 16c0 65.3-48.9 119.1-112 127l0 17 0 16-32 0 0-16 0-17c-63.1-7.9-112-61.7-112-127l0-16 0-16zM208 96l96 0 0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160z','M304 96l-96 0 0 160c0 26.5 21.5 48 48 48s48-21.5 48-48l0-160zM160 240l0-16-32 0 0 16 0 16c0 65.3 48.9 119.1 112 127l0 17 0 16 32 0 0-16 0-17c63.1-7.9 112-61.7 112-127l0-16 0-16-32 0 0 16 0 16c0 53-43 96-96 96s-96-43-96-96l0-16z']
      
    ]
  };

  
    var faMicrophoneCircle = faCircleMicrophone;
  

  
  

  var faSpiderWeb = {
    prefix: 'fasds',
    iconName: 'spider-web',
    icon: [
      576,
      512,
      [128376],
      'f719',
      
      ['M68.4 256l23.3 28 44.8 0 31.3 35.8 19.6 55.6-22.2 38.9c4.2 11.3 8.5 22.5 12.7 33.8c12.1-2.3 24.3-4.5 36.4-6.8L235.1 405l52.9-9.4 52.9 9.4 20.8 36.4 36.4 6.8 12.7-33.8-22.2-38.9 19.6-55.6L439.4 284l44.8 0c7.8-9.3 15.6-18.7 23.3-28c-7.8-9.3-15.6-18.7-23.3-28l-44.8 0-31.3-35.8-19.6-55.6 22.2-38.9c-4.2-11.3-8.5-22.5-12.7-33.8c-12.1 2.3-24.3 4.5-36.4 6.8L340.9 107 288 116.5 235.1 107 214.4 70.7c-12.1-2.3-24.3-4.6-36.4-6.8c-4.2 11.3-8.5 22.5-12.7 33.8l22.2 38.9-19.6 55.6L136.6 228l-44.8 0L68.4 256zm131.9-28l6.7-7.6 3-3.5 1.5-4.4 7.4-20.9L239.8 228l-39.4 0zm0 56l39.4 0L219 320.3l-7.4-20.9-1.5-4.4-3-3.5-6.7-7.6zm65.8-122.7l17.6 3.1 4.2 .8 4.2-.8 17.6-3.1L288 199.6l-21.8-38.2zm0 189.3L288 312.4l21.8 38.2-17.6-3.1-4.2-.8-4.2 .8-17.6 3.1zM336.2 228L357 191.7l7.4 20.9 1.5 4.4 3 3.5 6.7 7.6-39.4 0zm0 56l39.4 0-6.7 7.6-3 3.5-1.5 4.4L357 320.3 336.2 284z','M142 .1l23.1 4.3L288 27.5l122.8-23L434 .1l8.3 22 46.3 123.6 77 92.4L580.4 256l-14.9 17.9-77 92.4L442.2 489.8l-8.3 22-23.1-4.3L288 484.5l-122.8 23L142 511.9l-8.3-22L87.4 366.3l-77-92.4L-4.4 256l14.9-17.9 77-92.4L133.8 22.2 142 .1zM178 63.9l-39.7 106-1.7 4.4-3 3.6L68.4 256l65.1 78.1 3 3.6 1.7 4.4 39.7 106 104.9-19.7 5.2-1 5.2 1L398 448.1l39.7-106 1.7-4.4 3-3.6L507.6 256l-65.1-78.1-3-3.6-1.7-4.4L398 63.9 293.2 83.5l-5.2 1-5.2-1L178 63.9z']
      
    ]
  };

  

  
  

  var faHandSpock = {
    prefix: 'fasds',
    iconName: 'hand-spock',
    icon: [
      576,
      512,
      [128406],
      'f259',
      
      ['M31.4 328.5l29 27.6L156.8 448c43.1 41.1 100.4 64 160 64l2.3 0 16.9 0c57 0 106.9-37.3 123-91.7l83.7-283.2 9.1-30.7L490.4 88.2l-9.1 30.7L440.8 256l-24.7 0L455.3 70.6l6.6-31.3L399.3 26.1l-6.6 31.3L350.7 256l-41.5 0L251.2 39.7 242.9 8.8 181.1 25.4l8.3 30.9L242.9 256l-29.6 0L166.6 102.7l-9.3-30.6L96.1 90.7l9.3 30.6 71.7 235.5-61.6-58.6-29-27.6L31.4 328.5zM224 320c5.3 0 10.7 0 16 0c2.7 0 5.3 0 8 0c50.7 0 101.3 0 152 0c5.3 0 10.7 0 16 0l0 32c-5.3 0-10.7 0-16 0c-25.6 0-51.3 0-77 0c17.9 18.7 29 44.1 29 72l0 8 0 16c-10.7 0-21.3 0-32 0l0-16 0-8c0-39.8-32.2-72-72-72c-2.7 0-5.3 0-8 0c-5.3 0-10.7 0-16 0l0-32z','M240 320l-16 0 0 32 16 0 8 0c39.8 0 72 32.2 72 72l0 8 0 16 32 0 0-16 0-8c0-27.9-11-53.3-29-72l77 0 16 0 0-32-16 0-152 0-8 0z']
      
    ]
  };

  

  
  

  var faCircleCamera = {
    prefix: 'fasds',
    iconName: 'circle-camera',
    icon: [
      512,
      512,
      ["camera-circle"],
      'e103',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-96l68 0 12-32 96 0 12 32 68 0 0 192-256 0 0-192z','M208 128l-12 32-68 0 0 192 256 0 0-192-68 0-12-32-96 0zm48 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  
    var faCameraCircle = faCircleCamera;
  

  
  

  var faFacePersevering = {
    prefix: 'fasds',
    iconName: 'face-persevering',
    icon: [
      512,
      512,
      [],
      'e385',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM93.6 146.8l15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 89.4 222.6 112c-3.8 3.8-7.5 7.5-11.3 11.3c-2.5 2.5-4.9 4.9-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7c-.8 .1-1.7 .3-2.5 .4c-5.3 .9-10.5 1.8-15.8 2.6c-1.8-10.5-3.5-21-5.3-31.6zM112 208l118.9 64c-39.6 21.3-79.2 42.7-118.9 64c15.2-21.3 30.5-42.7 45.7-64c-15.2-21.3-30.5-42.7-45.7-64zm49.4 193.2l10.7-11.9C188.2 371.4 216.3 352 256 352s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4zM281.1 272L400 208l-45.7 64L400 336c-39.6-21.3-79.2-42.7-118.9-64zm8.2-160L312 89.4l11.3 11.3c2.5 2.5 4.9 4.9 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7c-2.5-2.5-4.9-4.9-7.4-7.4c-3.8-3.8-7.5-7.5-11.3-11.3z','M211.3 123.3l-7.4 7.4c-23.6 23.6-53.9 39.2-86.8 44.7l-2.5 .4-15.8 2.6-5.3-31.6 15.8-2.6 2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4L200 89.4 222.6 112l-11.3 11.3zm89.4 0L289.4 112 312 89.4l11.3 11.3 7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5 .4 15.8 2.6-5.3 31.6-15.8-2.6-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM112 208l118.9 64L112 336l45.7-64L112 208zm169.1 64L400 208l-45.7 64L400 336 281.1 272z']
      
    ]
  };

  

  
  

  var faGaugeSimpleLow = {
    prefix: 'fasds',
    iconName: 'gauge-simple-low',
    icon: [
      512,
      512,
      ["tachometer-slow"],
      'f62c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM119.6 141.8l42.6-22.1 11.1 21.3 76.6 147.4c2-.2 4-.3 6.1-.3c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.9 5.8-30.4 15.3-41.6L130.7 163.1l-11.1-21.3z','M173.3 140.9c-6.1-11.8-20.6-16.3-32.4-10.2s-16.3 20.6-10.2 32.4l76.6 147.4C197.8 321.6 192 336.1 192 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-2.1 0-4.1 .1-6.1 .3L173.3 140.9z']
      
    ]
  };

  
    var faTachometerSlow = faGaugeSimpleLow;
  

  
  

  var faFaceSaluting = {
    prefix: 'fasds',
    iconName: 'face-saluting',
    icon: [
      640,
      512,
      [129761],
      'e484',
      
      ['M101.7 310C126.5 425.5 229.1 512 352 512c141.4 0 256-114.6 256-256S493.4 0 352 0c-26.5 0-52.1 4-76.1 11.5l16.2 23.9 18 26.5-26.5 18-26.5 18-30 20.4 35.5 48.9 6.6 9.1c1-.1 2.1-.2 3.2-.2c17.7 0 32 14.3 32 32s-14.3 32-32 32c-13.1 0-24.4-7.9-29.3-19.1l-13.4 9.7-82.3 59.9c-13.9 10.1-29.5 16.6-45.6 19.6zm125.8 44l25-20c7.2 9 39.7 34 99.5 34s92.3-25 99.5-34l25 20c-14.1 17.6-56.3 46-124.5 46s-110.4-28.4-124.5-46zM464.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M239.2 71.3l26.5-18L229.7 .4l-26.5 18L35.1 132.5c-44.3 30.1-47.1 94.4-5.6 128.2l1.5 1.2c28.1 22.9 68.2 24 97.5 2.7l82.3-59.9 25.9-18.8-37.6-51.8L173.2 153 128 185.8l0-39.1L239.2 71.3z']
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fasds',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      ['M256 82.7l22.6 22.6 192 192L493.3 320 448 365.3l-22.6-22.6L256 173.3 86.6 342.6 64 365.3 18.7 320l22.6-22.6 192-192L256 82.7z','']
      
    ]
  };

  

  
  

  var faSquareI = {
    prefix: 'fasds',
    iconName: 'square-i',
    icon: [
      448,
      512,
      [],
      'e272',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 72 0 72 0 24 0 0 48-24 0-48 0 0 160 48 0 24 0 0 48-24 0-48 0-48 0-48 0-24 0 0-48 24 0 48 0 0-160-48 0-24 0 0-48z','M128 128l24 0 72 0 72 0 24 0 0 48-24 0-48 0 0 160 48 0 24 0 0 48-24 0-48 0-48 0-48 0-24 0 0-48 24 0 48 0 0-160-48 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faCalendarCircleExclamation = {
    prefix: 'fasds',
    iconName: 'calendar-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e46e',
      
      ['M0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0l0 64L0 64zM0 192L0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z','M288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faPlug = {
    prefix: 'fasds',
    iconName: 'plug',
    icon: [
      384,
      512,
      [128268],
      'f1e6',
      
      ['M64 0l0 32 0 128 64 0 0-128 0-32L64 0zM256 0l0 32 0 128 64 0 0-128 0-32L256 0z','M0 160l32 0 320 0 32 0 0 64-32 0 0 32c0 77.4-55 142-128 156.8l0 99.2-64 0 0-99.2C87 398 32 333.4 32 256l0-32L0 224l0-64z']
      
    ]
  };

  

  
  

  var faHouseCircleXmark = {
    prefix: 'fasds',
    iconName: 'house-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e50b',
      
      ['M0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 96.7 0c8.1-89.7 83.5-160 175.3-160c8.3 0 16.5 .6 24.5 1.7L288.4 0 0 240z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faWorm = {
    prefix: 'fasds',
    iconName: 'worm',
    icon: [
      512,
      512,
      [],
      'e599',
      
      ['M0 312L0 464l0 48 96 0 0-48 0-152c0-30.9 25.1-56 56-56s56 25.1 56 56l0 48c0 83.9 68.1 152 152 152s152-68.1 152-152l0-168 0-16 0-48L512 0 384 0c-53 0-96 43-96 96s43 96 96 96l32 0 0 168c0 30.9-25.1 56-56 56s-56-25.1-56-56l0-48c0-83.9-68.1-152-152-152S0 228.1 0 312zM432 88a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M384 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z']
      
    ]
  };

  

  
  

  var faFaceShush = {
    prefix: 'fasds',
    iconName: 'face-shush',
    icon: [
      512,
      512,
      [],
      'e38c',
      
      ['M0 256C0 357.2 58.7 444.7 144 486.3l0-54.3 0-56 0-24 0-32 32 0 24 0 0-44.1c-14.8-6.9-26.6-15.9-35.3-24.6L153.4 240 176 217.4l11.3 11.3c3.5 3.5 7.7 7.1 12.7 10.5l0-15.2 0-32 32 0 48 0 32 0 0 32 0 15.2c4.9-3.4 9.2-7 12.7-10.5L336 217.4 358.6 240l-11.3 11.3c-8.7 8.7-20.5 17.7-35.3 24.6l0 44.1 8 0 32 0 0 32 0 10.1 .8-1 24.6 20.5 36.9 30.7 24.6 20.5-10 12C480 398 512 330.7 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM176.4 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z','M200 488H176v24h24V488zm0-112V352H176v24h24zm96 0h24V352H296v24zM280 248V224H232v24h48zm98.4 207.4l15.4-18.4-36.9-30.7-15.4 18.4 36.9 30.7zM320 488v24h11.2l7.2-8.6L320 488zm-40-24H200v48h80V464zm-56 24V432H176v56h48zm0-56V376H176v56h48zm48-56v56h48V376H272zm21.8 92.3l-80-56-27.5 39.3 80 56 27.5-39.3zM232 248v72h48V248H232zm48 264h40V464H280v48zm58.4-8.6l40-48-36.9-30.7-40 48 36.9 30.7zM200 400h48V352H200v48zm48 0h48V352H248v48z']
      
    ]
  };

  

  
  

  var faFlaskRoundPotion = {
    prefix: 'fasds',
    iconName: 'flask-round-potion',
    icon: [
      448,
      512,
      ["flask-potion"],
      'f6e1',
      
      ['M16 352c0 64.3 29.2 121.8 75.1 160l265.8 0c45.9-38.2 75.1-95.7 75.1-160c0-80.2-45.4-149.9-112-184.6L320 64l32 0 0-64L320 0 256 0 192 0 128 0 96 0l0 64 32 0 0 103.4C61.4 202.1 16 271.8 16 352zm64 0c0-7.2 .5-14.3 1.5-21.2c6.8-46.4 35.8-85.7 76-106.6L192 206.2l0-38.8L192 64l64 0 0 103.4 0 38.8 34.4 17.9C336.7 248.3 368 296.5 368 352c0 36.9-13.8 70.5-36.7 96l-214.7 0C93.8 422.5 80 388.9 80 352z','M368 352c0 36.9-13.8 70.5-36.7 96l-214.7 0C93.8 422.5 80 388.9 80 352c0-7.2 .5-14.3 1.5-21.2c21-9.6 52.2-18.8 94.5-18.8c39.9 0 60.1 8.2 82.1 17.2c24.5 10 51.3 20.9 109.9 22.6l0 .2z']
      
    ]
  };

  
    var faFlaskPotion = faFlaskRoundPotion;
  

  
  

  var faPi = {
    prefix: 'fasds',
    iconName: 'pi',
    icon: [
      448,
      512,
      [],
      'f67e',
      
      ['M32 64L0 64l0 64 32 0 64 0 0 217.8L66.3 420.1l59.4 23.8 32-80 2.3-5.7 0-6.2 0-224 128 0 0 288 0 32 32 0 80 0 23.1 0 7.3-21.9 16-48-60.7-20.2L376.9 384 352 384l0-256 64 0 32 0 0-64-32 0L32 64z','']
      
    ]
  };

  

  
  

  var faOm = {
    prefix: 'fasds',
    iconName: 'om',
    icon: [
      512,
      512,
      [128329],
      'f679',
      
      ['M256 64s16 96 120 96c72 0 104-32 104-32l0-64s-66.5 32-112 32s-112-32-112-32zm80-32l32 32 32-32L368 0 336 32z','M102.6 183.7C111 169.4 126.4 160 144 160c26.5 0 48 21.5 48 48s-21.5 48-48 48l-56 0 24 64 32 0 16 0c35.3 0 64 28.7 64 64s-28.7 64-64 64C48 448 0 352 0 352s0 160 160 160c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64l49.1 0 13.3 0 9.4-9.4L397.3 256l18.7 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32c-64 0-96-48-96-48l0 64s16 48 96 48c53 0 96-43 96-96l0-96c0-53-43-96-96-96l-32 0-13.3 0-9.4 9.4L306.7 256l-61.5 0c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-41.2 0-77.1 22.2-96.5 55.2l55.1 32.5z']
      
    ]
  };

  

  
  

  var faArrowTurnLeftDown = {
    prefix: 'fasds',
    iconName: 'arrow-turn-left-down',
    icon: [
      384,
      512,
      [],
      'e633',
      
      ['M160 0l0 32 0 357.5c10.7 10.7 21.3 21.3 32 32c10.7-10.7 21.4-21.3 32-32L224 64l128 0 32 0 0-64L352 0 192 0 160 0z','M365.2 338.7l-22.6 22.6-128 128L192 512l-22.6-22.6-128-128L18.7 338.7 64 293.5l22.6 22.6L192 421.5 297.4 316.1 320 293.5l45.3 45.3z']
      
    ]
  };

  

  
  

  var faFolderBookmark = {
    prefix: 'fasds',
    iconName: 'folder-bookmark',
    icon: [
      512,
      512,
      [],
      'e186',
      
      ['M0 32L0 480l512 0 0-384-64 0 0 256-80-56-80 56 0-256-16 0L224 32 0 32z','M288 352V96H448V352l-80-56-80 56z']
      
    ]
  };

  

  
  

  var faTurnRight = {
    prefix: 'fasds',
    iconName: 'turn-right',
    icon: [
      512,
      512,
      [],
      'e639',
      
      ['M0 176l320 0 0 96L96 272l0 208L0 480 0 176z','M352 64L512 224 352 384l-32 0 0-320 32 0z']
      
    ]
  };

  

  
  

  var faPrintMagnifyingGlass = {
    prefix: 'fasds',
    iconName: 'print-magnifying-glass',
    icon: [
      640,
      512,
      ["print-search"],
      'f81a',
      
      ['M64 192l288 0c-38.9 29.2-64 75.7-64 128c0 11 1.1 21.7 3.2 32L192 352l0 16 0 16 0 64 160 0c26.7 20.1 60 32 96 32c17.5 0 34.4-2.8 50.2-8L512 485.8l0 26.2-32 0-320 0-32 0 0-32 0-96-64 0 0-192zM128 0l32 0L432 0l13.3 0 9.4 9.4 48 48 9.4 9.4L512 80l0 80-64 0 0-66.7L418.7 64 192 64l0 96-64 0 0-128 0-32z','M528 320.2a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM520 426c-20.5 14-45.3 22.1-72 22.1c-70.7 0-128-57.3-128-128s57.3-128 128-128s128 57.3 128 128c0 26.7-8.2 51.4-22.1 71.9l63 62.6 17 16.9-33.8 34-17-16.9L520 426z']
      
    ]
  };

  
    var faPrintSearch = faPrintMagnifyingGlass;
  

  
  

  var faUtensilsSlash = {
    prefix: 'fasds',
    iconName: 'utensils-slash',
    icon: [
      640,
      512,
      [],
      'e464',
      
      ['M96.8 172.2c5.3 42 37.8 75.5 79.2 82.4L176 480l0 32 64 0 0-32 0-194.9L96.8 172.2zm18-105.9C129.8 78 144.9 89.7 160 101.4L160 0 128 0 114.7 66.3zm65.5 50.9c41.2 32 82.4 64 123.6 96C314.1 198 320 179.7 320 160L288 0 256 0l0 160-16 0L224 0 192 0 180.3 117.2zM384 176l0 99.4c53.3 41.4 106.7 82.8 160 124.2l0-47.6 0-112 0-32L544 0C512 0 384 32 384 176z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faPersonBikingMountain = {
    prefix: 'fasds',
    iconName: 'person-biking-mountain',
    icon: [
      640,
      512,
      [128693,"biking-mountain"],
      'f84b',
      
      ['M0 352l0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3L14.9 451.9l45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8L96 512l64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l14.6-14.6-45.3-45.3-14.6 14.6c-6.7-3.6-13.8-6.6-21.3-8.8l0-20.6-64 0 0 20.6c-7.4 2.2-14.6 5.2-21.3 8.8L60.1 270.9 14.9 316.1l14.6 14.6c-3.6 6.7-6.6 13.8-8.8 21.3L0 352zm192 32A64 64 0 1 1 64 384a64 64 0 1 1 128 0zm192-32l0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3l-14.6 14.6 45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8l0 20.6 64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l14.6-14.6-45.3-45.3-14.6 14.6c-6.7-3.6-13.8-6.6-21.3-8.8l0-20.6-64 0 0 20.6c-7.4 2.2-14.6 5.2-21.3 8.8l-14.6-14.6-45.3 45.3 14.6 14.6c-3.6 6.7-6.6 13.8-8.8 21.3L384 352zm192 32a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z','M448 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM427.2 160L336 88 223.2 175.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 448l64 0 0-177.1-57-38 60.3-48.5L404.8 224 512 224l0-64-84.8 0zM176 176L304 80 256 20l-42.7 0L112 96l64 80z']
      
    ]
  };

  
    var faBikingMountain = faPersonBikingMountain;
  

  
  

  var faHand = {
    prefix: 'fasds',
    iconName: 'hand',
    icon: [
      512,
      512,
      [9995,129306,"hand-paper"],
      'f256',
      
      ['M.3 329.4l29 27.6 95.5 91c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208 0-32-64 0 0 32 0 128-32 0 0-192 0-32-64 0 0 32 0 192-32 0 0-224 0-32L224 0l0 32 0 224-32 0 0-192 0-32-64 0 0 32 0 272c0 1.5 0 3.1 .1 4.6L84.5 299.1l-29-27.6L.3 329.4zM192 320l16 0 8 0 152 0 16 0 0 32-16 0-77 0c17.9 18.7 29 44.1 29 72l0 8 0 16-32 0 0-16 0-8c0-39.8-32.2-72-72-72l-8 0-16 0 0-32z','M208 320l-16 0 0 32 16 0 8 0c39.8 0 72 32.2 72 72l0 8 0 16 32 0 0-16 0-8c0-27.9-11-53.3-29-72l77 0 16 0 0-32-16 0-152 0-8 0z']
      
    ]
  };

  
    var faHandPaper = faHand;
  

  
  

  var faHeadSideBrain = {
    prefix: 'fasds',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      ['M0 224.2C0 100.6 100.2 0 224 0l32 0C358.1 0 441.6 79.7 447.7 180.3L505 252l7 8.8 0 11.2 0 16 0 32-32 0-32 0 0 96 0 32-32 0-96 0 0 32 0 32-32 0L96 512l-32 0 0-32 0-98.8c-41-41.9-64-98.3-64-157zM64 176c0 20.9 13.4 38.7 32.1 45.3c0 .9-.1 1.8-.1 2.7c0 26.5 21.5 48 48 48l16 0 0 48 64 0 0-48 16 0c26.5 0 48-21.5 48-48l0-16 48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48c-.9 0-1.8 0-2.7 .1C326.7 93.4 308.9 80 288 80c-8.6 0-16.6 2.2-23.5 6.2C255.9 72.8 241 64 224 64s-31.9 8.8-40.5 22.2c-7-3.9-15-6.2-23.5-6.2c-26.5 0-48 21.5-48 48c-26.5 0-48 21.5-48 48z','M336 208l-48 0 0 16c0 26.5-21.5 48-48 48l-16 0 0 48-64 0 0-48-16 0c-26.5 0-48-21.5-48-48c0-.9 0-1.8 .1-2.7C77.4 214.7 64 196.9 64 176c0-26.5 21.5-48 48-48c0-26.5 21.5-48 48-48c8.6 0 16.6 2.2 23.5 6.2C192.1 72.8 207 64 224 64s31.9 8.8 40.5 22.2c7-3.9 15-6.2 23.5-6.2c20.9 0 38.7 13.4 45.3 32.1c.9 0 1.8-.1 2.7-.1c26.5 0 48 21.5 48 48s-21.5 48-48 48zM159.9 178.7c0 0 0 0 .1 0l0-2.7c0 .9 0 1.8-.1 2.7z']
      
    ]
  };

  

  
  

  var faCucumber = {
    prefix: 'fasds',
    iconName: 'cucumber',
    icon: [
      512,
      512,
      [129362],
      'e401',
      
      ['M120 280l48 0 0 48-48 0 0-48zm160-32l48 0 0 48-48 0 0-48zM376 88l48 0 0 48-48 0 0-48z','M37.5 474.5c47.8 47.8 123.9 49.9 174.2 6.4L232 501.3 277.3 456l-20.1-20.1L435.9 257.1 456 277.3 501.3 232l-20.4-20.4c43.5-50.3 41.4-126.4-6.4-174.2c-50-50-131-50-181 0L172.1 158.9 152 138.7 106.7 184l20.1 20.1L37.5 293.5c-50 50-50 131 0 181zM376 88l48 0 0 48-48 0 0-48zM328 248l0 48-48 0 0-48 48 0zM168 280l0 48-48 0 0-48 48 0z']
      
    ]
  };

  

  
  

  var faPoliceBox = {
    prefix: 'fasds',
    iconName: 'police-box',
    icon: [
      384,
      512,
      [],
      'e021',
      
      ['M0 464l32 0 320 0 32 0 0 48L0 512l0-48zM96 128l32 0 0 32-32 0 0-32zm0 48l32 0 0 32-32 0 0-32zm48-48l32 0 0 32-32 0 0-32zm0 48l32 0 0 32-32 0 0-32zM176 0l32 0 0 16 0 16-32 0 0-16 0-16zm32 128l32 0 0 32-32 0 0-32zm0 48l32 0 0 32-32 0 0-32zm48-48l32 0 0 32-32 0 0-32zm0 48l32 0 0 32-32 0 0-32z','M320 32L64 32l0 32L32 64l0 400 320 0 0-400-32 0 0-32zM96 128l32 0 0 32-32 0 0-32zm0 48l32 0 0 32-32 0 0-32zm80-48l0 32-32 0 0-32 32 0zm-32 48l32 0 0 32-32 0 0-32zm96-48l0 32-32 0 0-32 32 0zm0 48l0 32-32 0 0-32 32 0zm16-48l32 0 0 32-32 0 0-32zm32 48l0 32-32 0 0-32 32 0zM96 240l80 0 0 80-80 0 0-80z']
      
    ]
  };

  

  
  

  var faFlaskVial = {
    prefix: 'fasds',
    iconName: 'flask-vial',
    icon: [
      640,
      512,
      [],
      'e4f3',
      
      ['M0 0L0 64l32 0 0 288c0 53 43 96 96 96c11.2 0 22-1.9 32-5.5l0-19.6 0-9.1 4.7-7.7L224 309.9 224 64l32 0 0-64L224 0 160 0 96 0 32 0 0 0zM96 64l64 0 0 96-64 0 0-96z','M480 0L352 0 320 0 288 0l0 64 32 0 0 150.9L196.7 415.2l-4.7 7.7 0 9.1 0 48 0 32 32 0 384 0 32 0 0-32 0-48 0-9.1-4.7-7.7L512 214.9 512 64l32 0 0-64L512 0 480 0zM384 224l0-160 64 0 0 160 0 9.1 4.7 7.7L501.5 320l-171 0 48.8-79.2 4.7-7.7 0-9.1z']
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'fasds',
    iconName: 'eye-slash',
    icon: [
      640,
      512,
      [],
      'f070',
      
      ['M0 256c30 74.7 129.6 224 288 224c54.9 0 102.7-17.9 143-44.4l-70.2-55.3C339.4 392.8 314.6 400 288 400c-79.5 0-144-64.5-144-144c0-14.5 2.1-28.5 6.1-41.7L66.1 148C33.9 186.5 11.7 226.9 0 256zM135.9 82.7l70.5 54.7c23.2-16 51.4-25.4 81.7-25.4c79.5 0 144 64.5 144 144c0 17.5-3.1 34.3-8.8 49.8c27.4 21.2 54.7 42.5 82.1 63.7c34.7-40.1 58.5-83 70.8-113.5C546 181.3 446.4 32 288 32c-59.1 0-110 20.8-152.1 50.7zM192 256c0 53 43 96 96 96c10.7 0 21-1.8 30.6-5L192.4 247.6c-.2 2.8-.4 5.6-.4 8.4zm77.2-94.2l5.8 28.8L382.3 274c1.1-5.8 1.7-11.9 1.7-18c0-53-43-96-96-96c-6.4 0-12.7 .6-18.8 1.8z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faFacePleading = {
    prefix: 'fasds',
    iconName: 'face-pleading',
    icon: [
      512,
      512,
      [],
      'e386',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm78.1-93.9c5.3-.7 10.6-1.3 15.9-2c3.8-.5 7.7-1 11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9c.5-1.7 1-3.4 1.5-5.2c1.5-5.1 2.9-10.3 4.4-15.4c10.3 2.9 20.5 5.9 30.8 8.8l-4.4 15.4-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8c40.4 4 72 38.1 72 79.6c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-17.9 5.9-34.5 15.9-47.9c-4.6 .6-9.2 1.1-13.8 1.7c-1.3-10.6-2.6-21.2-4-31.8zM197.4 417.2l10.7-11.9c9.2-10.2 25.2-21.3 47.9-21.3s38.7 11.1 47.9 21.3l10.7 11.9-23.8 21.4-10.7-11.9c-4.7-5.3-12.7-10.7-24.1-10.7s-19.4 5.4-24.1 10.7l-10.7 11.9-23.8-21.4zM272 240c0-41.4 31.4-75.4 72-79.6c-10-10.8-17.6-24.1-21.9-38.8c-.5-1.7-1-3.4-1.5-5.2c-1.5-5.1-2.9-10.3-4.4-15.4c10.3-2.9 20.5-5.9 30.8-8.8l4.4 15.4 1.5 5.2c7 24.7 28.1 42.7 53.6 45.9c3.8 .5 7.7 1 11.5 1.4c5.3 .7 10.6 1.3 15.9 2l-4 31.8c-4.6-.6-9.2-1.1-13.8-1.7c10 13.3 15.9 29.9 15.9 47.9c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M191.4 116.4l4.4-15.4L165 92.2l-4.4 15.4-1.5 5.2c-7 24.7-28.1 42.7-53.6 45.9L94 160.1l-15.9 2 4 31.8 15.9-2 11.5-1.4c38.2-4.8 69.8-31.9 80.4-68.9l1.5-5.2zM316.2 101l4.4 15.4 1.5 5.2c10.6 37 42.2 64.1 80.4 68.9l11.5 1.4 15.9 2 4-31.8-15.9-2-11.5-1.4c-25.5-3.2-46.6-21.3-53.6-45.9l-1.5-5.2L347 92.2 316.2 101zM160 200c0 17.7-14.3 32-32 32c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8zm192 0c0 17.7-14.3 32-32 32c-8.3 0-15.9-3.2-21.6-8.4c-1.6 5.2-2.4 10.7-2.4 16.4c0 30.9 25.1 56 56 56s56-25.1 56-56s-25.1-56-56-56c-1.4 0-2.8 .1-4.2 .2c2.7 4.7 4.2 10.1 4.2 15.8z']
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fasds',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      ['M0 320L48 192l148 0c-2.6 10.2-4 21-4 32c0 38.2 16.8 72.5 43.3 96L0 320zM224 80A80 80 0 1 1 64 80a80 80 0 1 1 160 0zM404.7 320c26.6-23.5 43.3-57.8 43.3-96c0-11-1.4-21.8-4-32l148 0 48 128-235.3 0zM592 80A80 80 0 1 1 432 80a80 80 0 1 1 160 0z','M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM512 512L464 352l-288 0L128 512l384 0z']
      
    ]
  };

  

  
  

  var faCircleF = {
    prefix: 'fasds',
    iconName: 'circle-f',
    icon: [
      512,
      512,
      [],
      'e10e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l24 0 144 0 24 0 0 48-24 0-120 0 0 64 88 0 24 0 0 48-24 0-88 0 0 72 0 24-48 0 0-24 0-96 0-112 0-24z','M160 128l24 0 144 0 24 0 0 48-24 0-120 0 0 64 88 0 24 0 0 48-24 0-88 0 0 72 0 24-48 0 0-24 0-96 0-112 0-24z']
      
    ]
  };

  

  
  

  var faRight = {
    prefix: 'fasds',
    iconName: 'right',
    icon: [
      448,
      512,
      [11157,"arrow-alt-right"],
      'f356',
      
      ['M0 192L0 320l224 0 0-128L0 192z','M224 448l32 0L448 256 256 64l-32 0 0 128 0 128 0 128z']
      
    ]
  };

  
    var faArrowAltRight = faRight;
  

  
  

  var faPersonRays = {
    prefix: 'fasds',
    iconName: 'person-rays',
    icon: [
      512,
      512,
      [],
      'e54d',
      
      ['M96.2 270.8l53.9 34.4 33.8-53L184 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 53.9-34.4L334 142.8 324.6 128l-17.5 0-102.2 0-17.5 0L178 142.8l-81.7 128zM208 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M40 6.1L57 23l64 64 17 17L104 137.9 87 121 23 57 6.1 40 40 6.1zM505.9 40L489 57l-64 64-17 17L374.1 104l17-17 64-64 17-17L505.9 40zm-368 368l-17 17L57 489l-17 17L6.1 472l17-17 64-64 17-17L137.9 408zM408 374.1l17 17 64 64 17 17L472 505.9l-17-17-64-64-17-17L408 374.1z']
      
    ]
  };

  

  
  

  var faReplyClock = {
    prefix: 'fasds',
    iconName: 'reply-clock',
    icon: [
      640,
      512,
      ["reply-time"],
      'e239',
      
      ['M0 240L192 416l32 0 0-96 80 0c61.9 0 112 50.1 112 112c0 48-32 80-32 80s128-48 128-176c0-5.6-.3-11.2-.8-16.6c-5 .4-10.1 .6-15.2 .6c-91.8 0-167.2-70.3-175.3-160L224 160l0-96-32 0L0 240z','M496 288A144 144 0 1 0 496 0a144 144 0 1 0 0 288zM512 80l0 48 32 0 16 0 0 32-16 0-48 0-16 0 0-16 0-64 0-16 32 0 0 16z']
      
    ]
  };

  
    var faReplyTime = faReplyClock;
  

  
  

  var faMitten = {
    prefix: 'fasds',
    iconName: 'mitten',
    icon: [
      448,
      512,
      [],
      'f7b5',
      
      ['M32 384l32 0 288 0 32 0 0 128L32 512l0-128z','M316.8 243.2L283.2 108.9C267.2 44.9 209.7 0 143.8 0l-3.4 0C62.8 0 0 62.8 0 140.3c0 13 1.8 26 5.4 38.6L64 384l288 0 96-112-80-80-51.2 51.2z']
      
    ]
  };

  

  
  

  var faArrowDownZA = {
    prefix: 'fasds',
    iconName: 'arrow-down-z-a',
    icon: [
      576,
      512,
      ["sort-alpha-desc","sort-alpha-down-alt"],
      'f881',
      
      ['M292.8 480l70.4 0 14.7-32 76.3 0 14.7 32 70.4 0-6.1-13.3-88-192L436.5 256l-41.1 0-8.6 18.7-88 192L292.8 480zM320 32l0 64 32 0 52 0-73 63.9L320 169.5l0 14.5 0 8 0 32 32 0 128 0 32 0 0-64-32 0-52 0 73-63.9L512 86.5 512 72l0-8 0-32-32 0L352 32l-32 0zm79.9 368L416 364.8 432.1 400l-32.3 0z','M160 480l23.6-25.7 88-96 21.6-23.6L246 291.4 224.4 315 192 350.4l0-285.7 0-32-64 0 0 32 0 285.7L95.6 315 74 291.4 26.8 334.7l21.6 23.6 88 96L160 480z']
      
    ]
  };

  
    var faSortAlphaDesc = faArrowDownZA;
  
    var faSortAlphaDownAlt = faArrowDownZA;
  

  
  

  var faBagShopping = {
    prefix: 'fasds',
    iconName: 'bag-shopping',
    icon: [
      448,
      512,
      ["shopping-bag"],
      'f290',
      
      ['M0 160L0 512l448 0 0-352-112 0 0 72 0 24-48 0 0-24 0-72-128 0 0 72 0 24-48 0 0-24 0-72L0 160z','M224 48c-35.3 0-64 28.7-64 64l0 120 0 24-48 0 0-24 0-120C112 50.1 162.1 0 224 0s112 50.1 112 112l0 120 0 24-48 0 0-24 0-120c0-35.3-28.7-64-64-64z']
      
    ]
  };

  
    var faShoppingBag = faBagShopping;
  

  
  

  var faHandHeart = {
    prefix: 'fasds',
    iconName: 'hand-heart',
    icon: [
      512,
      512,
      [],
      'f4bc',
      
      ['M.3 329.4l29 27.6 95.5 91c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208 0-32-64 0 0 32 0 128-32 0 0-192 0-32-64 0 0 32 0 192-32 0 0-224 0-32L224 0l0 32 0 224-32 0 0-192 0-32-64 0 0 32 0 272c0 1.5 0 3.1 .1 4.6L84.5 299.1l-29-27.6L.3 329.4zm213.1 30c0-21.8 17.7-39.5 39.5-39.5l1.6 0c10.6 0 20.8 4.1 28.5 11.5l5.1 4.9c1.7-1.6 3.4-3.3 5.1-4.9c7.7-7.4 17.9-11.5 28.5-11.5l1.6 0c10.9 0 20.8 4.4 27.9 11.6c3.6 3.6 6.5 7.8 8.5 12.5c1 2.4 1.8 4.8 2.3 7.4c.3 1.3 .5 2.7 .6 4c.1 .7 .1 1.3 .1 1.9c0 .6 0 1.2 0 1.4c0 .4 0 .5 0 .6s0 .2 0 .6c0 .3 0 1-.1 1.7c0 .6-.1 1.2-.1 1.8c-.1 1.3-.3 2.6-.6 3.9c-.5 2.6-1.3 5.1-2.3 7.5c-2.1 4.8-5.1 9.3-8.9 13c-18.4 17.7-36.8 35.4-55.2 53.1c-2.5 2.4-4.9 4.7-7.4 7.1c-2.5-2.4-4.9-4.7-7.4-7.1c-18.4-17.7-36.8-35.4-55.2-53.1c-7.7-7.4-12.1-17.7-12.1-28.4z','M252.9 320c-21.8 0-39.5 17.7-39.5 39.5c0 10.7 4.4 21 12.1 28.4L280.7 441l7.4 7.1 7.4-7.1 55.2-53.1c7.7-7.4 12.1-17.7 12.1-28.4c0-21.8-17.7-39.5-39.5-39.5l-1.6 0c-10.6 0-20.8 4.1-28.5 11.5l-5.1 4.9-5.1-4.9c-7.7-7.4-17.9-11.5-28.5-11.5l-1.6 0z']
      
    ]
  };

  

  
  

  var faTruckContainerEmpty = {
    prefix: 'fasds',
    iconName: 'truck-container-empty',
    icon: [
      640,
      512,
      [],
      'e2b5',
      
      ['M32 416a64 64 0 1 0 128 0A64 64 0 1 0 32 416zm160 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm288 0a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M456 144l-24 0 0 24 0 88 0 32 0 16L0 304l0 80 5.5 0c13.2-37.3 48.7-64 90.5-64c33.4 0 62.8 17 80 42.9C193.2 337 222.6 320 256 320c41.8 0 77.4 26.7 90.5 64l85.5 0 21.5 0c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64l5.5 0 0-96 0-32 0-8.6-5.4-6.6-72-88-7.2-8.8L544 144l-88 0zM585 256l-105 0 0-64 52.6 0L585 256z']
      
    ]
  };

  

  
  

  var faCalendarExclamation = {
    prefix: 'fasds',
    iconName: 'calendar-exclamation',
    icon: [
      448,
      512,
      [],
      'f334',
      
      ['M0 192l448 0 0 320L0 512 0 192zm200 48l0 24 0 96 0 24 48 0 0-24 0-96 0-24-48 0zm0 176l0 48 48 0 0-48-48 0z','M96 0l64 0 0 64 128 0 0-64 64 0 0 64 96 0 0 128L0 192 0 64l96 0L96 0zM248 240l0 24 0 96 0 24-48 0 0-24 0-96 0-24 48 0zm0 176l0 48-48 0 0-48 48 0z']
      
    ]
  };

  

  
  

  var faSink = {
    prefix: 'fasds',
    iconName: 'sink',
    icon: [
      512,
      512,
      [],
      'e06d',
      
      ['M0 288l0 64 32 0 448 0 32 0 0-64-32 0-80 0-48 0-64 0-64 0-64 0-48 0-80 0L0 288zm32 96l0 32c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-32L32 384z','M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 64 0 0-32c0-53-43-96-96-96s-96 43-96 96l0 192 64 0 0-192zM56 208l-24 0 0 48 24 0 56 0 0 32 48 0 0-56 0-24-24 0-80 0zm320 0l-24 0 0 24 0 56 48 0 0-32 64 0 24 0 0-48-24 0-88 0z']
      
    ]
  };

  

  
  

  var faSunset = {
    prefix: 'fasds',
    iconName: 'sunset',
    icon: [
      576,
      512,
      [127751],
      'f767',
      
      ['M32 374l62.1 90 66.9 0c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112l66.9 0L544 374 417.3 350.7 394 224 288 297.1 182 224 158.7 350.7 32 374zm161.3 90l189.3 0c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80z','M256 224l0-1.8-77.5-70.5-23.7-21.5 43.1-47.4 23.7 21.5L256 135.7 256 32l0-32 64 0 0 32 0 103.7 34.5-31.3 23.7-21.5 43 47.4-23.7 21.5L320 222.2l0 1.8-2 0-8.4 7.7L288 251.2l-21.5-19.6L258 224l-2 0zM24 464l528 0 24 0 0 48-24 0L24 512 0 512l0-48 24 0z']
      
    ]
  };

  

  
  

  var faMicroscope = {
    prefix: 'fasds',
    iconName: 'microscope',
    icon: [
      512,
      512,
      [128300],
      'f610',
      
      ['M96 384l0 32 16 0 192 0 16 0 0-32-16 0-192 0-16 0zM160 0l0 32 96 0 0-32L160 0z','M128 32l160 0 0 288-32 0 0 32-96 0 0-32-32 0 0-288zM512 320c0 49.2-18.5 94-48.9 128l16.9 0 32 0 0 64-32 0-160 0L32 512 0 512l0-64 32 0 288 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l0-64c106 0 192 86 192 192z']
      
    ]
  };

  

  
  

  var faHourglassHalf = {
    prefix: 'fasds',
    iconName: 'hourglass-half',
    icon: [
      384,
      512,
      ["hourglass-2"],
      'f252',
      
      ['M32 64l64 0 0 50.7L109.3 128l165.5 0L288 114.7 288 64l64 0 0 64 0 13.3-9.4 9.4L237.3 256 342.6 361.4l9.4 9.4 0 13.3 0 64-48 0-16 0L96 448l-32 0-32 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64zm77.3 320l165.5 0L192 301.3 109.3 384z','M32 512L0 512l0-64 32 0 320 0 32 0 0 64-32 0L32 512zM32 64L0 64 0 0 32 0 352 0l32 0 0 64-32 0L32 64z']
      
    ]
  };

  
    var faHourglass2 = faHourglassHalf;
  

  
  

  var faCircleCalendar = {
    prefix: 'fasds',
    iconName: 'circle-calendar',
    icon: [
      512,
      512,
      ["calendar-circle"],
      'e102',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 128l64 0 0-32 32 0 0 32 64 0 0-32 32 0 0 32 64 0 0 96 0 160-256 0 0-160 0-96z','M192 96l32 0 0 32 64 0 0-32 32 0 0 32 64 0 0 96-256 0 0-96 64 0 0-32z']
      
    ]
  };

  
    var faCalendarCircle = faCircleCalendar;
  

  
  

  var faCircleW = {
    prefix: 'fasds',
    iconName: 'circle-w',
    icon: [
      512,
      512,
      [],
      'e12c',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM102.5 152l50 0 40.7 141.5 39.9-124.8 5.3-16.7 35 0 5.3 16.7 39.9 124.8L359.5 152l50 0L343.1 382.6l-5 17.4-35.6 0-5.3-16.7L256 254.7 214.9 383.3 209.5 400l-35.6 0-5-17.4L102.5 152z','M359.5 152l50 0L343.1 382.6l-5 17.4-35.6 0-5.3-16.7L256 254.7 214.9 383.3 209.5 400l-35.6 0-5-17.4L102.5 152l50 0 40.7 141.5 39.9-124.8 5.3-16.7 35 0 5.3 16.7 39.9 124.8L359.5 152z']
      
    ]
  };

  

  
  

  var faHeartCircleMinus = {
    prefix: 'fasds',
    iconName: 'heart-circle-minus',
    icon: [
      576,
      512,
      [],
      'e4ff',
      
      ['M0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480l23.7-23.7c-15.1-26-23.7-56.1-23.7-88.3c0-97.2 78.8-176 176-176c26.4 0 51.4 5.8 73.8 16.2c4-13 6.2-26.6 6.2-40.4C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8L256 96 231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm64-128l-128 0-16 0 0-32 16 0 128 0 16 0 0 32-16 0z']
      
    ]
  };

  

  
  

  var faWaveSine = {
    prefix: 'fasds',
    iconName: 'wave-sine',
    icon: [
      640,
      512,
      [8767],
      'f899',
      
      ['M215.9 106.3c-10-6.6-22.4-10.7-39.3-10.3c-34.9 .7-62.8 27.5-84.3 64.8c-10.2 17.7-17.6 35.6-22.5 49.3c-2.4 6.8-4.2 12.4-5.3 16.2c-.6 1.9-1 3.4-1.2 4.3l-.3 1 0 .2L32 224C.9 216.3 .9 216.3 .9 216.3s0 0 0 0c0 0 0 0 0-.1l0-.2 .1-.5c.1-.4 .2-1 .4-1.6c.4-1.4 .9-3.3 1.6-5.7c1.4-4.8 3.5-11.6 6.4-19.6c5.7-16 14.6-37.7 27.3-59.7C61.2 86.7 105.2 33.5 175.3 32c29-.6 54.3 6.7 75.7 20.8c21.1 13.8 36.8 33 49.1 53.9c23.5 39.9 37.5 91.8 50.1 138.4c.2 .9 .5 1.7 .7 2.6c13.4 49.8 25.5 93.6 44.1 125.2c9 15.3 18.6 26 29 32.8c10 6.6 22.4 10.7 39.3 10.3c34.9-.7 62.8-27.5 84.3-64.8c10.2-17.7 17.6-35.6 22.5-49.3c2.4-6.8 4.2-12.4 5.3-16.2c.6-1.9 1-3.4 1.2-4.3l.3-1 0-.2L608 288c31.1 7.7 31.1 7.7 31.1 7.7s0 0 0 0c0 0 0 0 0 .1l0 .2-.1 .5c-.1 .4-.2 1-.4 1.6c-.4 1.4-.9 3.3-1.6 5.7c-1.4 4.8-3.5 11.6-6.4 19.6c-5.7 16-14.6 37.7-27.3 59.7c-24.3 42.1-68.3 95.4-138.4 96.9c-29 .6-54.3-6.7-75.7-20.8c-21.1-13.8-36.8-33-49.1-53.9c-23.5-39.9-37.5-91.9-50.1-138.4c-.2-.9-.5-1.7-.7-2.6c-13.4-49.8-25.5-93.6-44.1-125.2c-9-15.3-18.6-26-29-32.8z','']
      
    ]
  };

  

  
  

  var faDisplayChartUpCircleDollar = {
    prefix: 'fasds',
    iconName: 'display-chart-up-circle-dollar',
    icon: [
      640,
      512,
      [],
      'e5e6',
      
      ['M0 0L0 416l240 0-10.7 32L160 448l-32 0 0 64 32 0 234.8 0C349.5 480.1 320 427.5 320 368c0-5.4 .2-10.7 .7-16L64 352 64 64l448 0 0 128.7c22.9 2.1 44.5 8.5 64 18.5L576 0 0 0zM103 279L137 313l87-87 63 63 17 17 17-17 111-111 0 22.1 0 4c15.1-5.9 31.2-9.8 48-11.3l0-72.7 0-24-24 0-80 0-24 0 0 48 24 0 22.1 0L304 238.1l-63-63-17-17-17 17L103 279z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM472.1 339c0 0 0 0 0 .1c0 .4 0 1.9 4.8 4.5c5.6 3 13.5 5.2 23.9 8.2l.2 0c9.3 2.6 21.1 6 30.5 11.5c10.2 6 20 16.1 20.5 32.3c.5 18.2-9.7 30.4-21.7 36.9c-5.8 3.1-12.1 5.1-18.3 6.2l0 10.8 0 16-32 0 0-16 0-11.4c-8.6-1.7-16.7-4.3-23.7-6.6c0 0 0 0 0 0c-1.7-.6-3.4-1.1-5-1.6L436 425.2l9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8c11.4 3.6 20.4 6.5 29.9 6.8c6.7 .2 13.8-1.1 18.5-3.6c2.2-1.2 3.4-2.4 4-3.3c.5-.8 1.1-2.1 1-4.5c0-1.4-.2-3-4.7-5.6c-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3c-9.9-5.3-20.6-14.7-21.6-30.7c-1.2-18.8 10-30.9 21.8-37.2c5.7-3.1 12-5.1 18-6.3l0-9.5 0-16 32 0 0 16 0 9.4c6.3 .9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1c-6.2-.1-13.6 1.3-18.7 4c-2.4 1.3-3.6 2.5-4.2 3.4c-.4 .7-.9 1.6-.8 3.6z']
      
    ]
  };

  

  
  

  var faShareNodes = {
    prefix: 'fasds',
    iconName: 'share-nodes',
    icon: [
      448,
      512,
      ["share-alt"],
      'f1e0',
      
      ['M162.6 186.9c15.4 14.9 25.9 34.9 28.6 57.2l94.1-47c-15.4-14.9-25.9-34.9-28.6-57.2l-94.1 47zm0 138.2l94.1 47c2.8-22.4 13.2-42.4 28.6-57.2l-94.1-47c-2.8 22.4-13.2 42.4-28.6 57.2z','M256 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM0 256a96 96 0 1 1 192 0A96 96 0 1 1 0 256zm352 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z']
      
    ]
  };

  
    var faShareAlt = faShareNodes;
  

  
  

  var faKnife = {
    prefix: 'fasds',
    iconName: 'knife',
    icon: [
      512,
      512,
      ["utensil-knife"],
      'f2e4',
      
      ['M209.4 257.4c15.1 15.1 30.2 30.2 45.3 45.3c21.8 21.8 43.6 43.6 65.4 65.4C430.6 257.4 512 184 512 104C512 40 466.7 0 466.7 0L320 146.7c-36.9 36.9-73.8 73.8-110.6 110.6z','M320 146.7a0 0 0 1 1 0 0 0 0 0 1 1 0 0zM209.4 257.4l45.3 45.3-184 184L48 509.3 2.7 464l22.6-22.6 184-184z']
      
    ]
  };

  
    var faUtensilKnife = faKnife;
  

  
  

  var faLightbulbOn = {
    prefix: 'fasds',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      ['M144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176zm64 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80l-32 0z','M87.3 16l6 4 24 16 20 13.3L110.7 89.3 90.7 76l-24-16-6-4-20-13.3L67.3 2.7 87.3 16zM579.3 56l-6 4-24 16-20 13.3L502.7 49.3l20-13.3 24-16 6-4 20-13.3 26.6 39.9L579.3 56zM24 160l50 0 24 0 0 48-24 0-50 0L0 208l0-48 24 0zm542 0l50 0 24 0 0 48-24 0-50 0-24 0 0-48 24 0zM117.3 332l-24 16-6 4-20 13.3L40.7 325.3l20-13.3 6-4 24-16 20-13.3 26.6 39.9-20 13.3zm432-39.9l24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9 20 13.3zM240 512l0-128 160 0 0 128-160 0z']
      
    ]
  };

  

  
  

  var faMessageMiddleTop = {
    prefix: 'fasds',
    iconName: 'message-middle-top',
    icon: [
      512,
      512,
      ["comment-middle-top-alt"],
      'e1e2',
      
      ['M338.3 96L512 96l0 416L0 512 0 96l173.7 0L256 0l82.3 96z','']
      
    ]
  };

  
    var faCommentMiddleTopAlt = faMessageMiddleTop;
  

  
  

  var faCarSide = {
    prefix: 'fasds',
    iconName: 'car-side',
    icon: [
      640,
      512,
      [128663],
      'f5e4',
      
      ['M64 432a80 80 0 1 0 160 0A80 80 0 1 0 64 432zm47.3-208L224 224c0-32 0-64 0-96l-74.3 0c-12.8 32-25.6 64-38.4 96zM272 128c0 32 0 64 0 96l173.4 0-76.8-96L272 128zM416 432a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M106.3 64L128 64l256 0 15.4 0L409 76 527.4 224 640 224l0 208-32 0c0-61.9-50.1-112-112-112s-112 50.1-112 112l-128 0c0-61.9-50.1-112-112-112S32 370.1 32 432L0 432 0 224l42.3 0 56-139.9 8-20.1zm4.9 160L224 224l0-96-74.3 0-38.4 96zM272 224l173.4 0-76.8-96L272 128l0 96z']
      
    ]
  };

  

  
  

  var faSquareSliders = {
    prefix: 'fasds',
    iconName: 'square-sliders',
    icon: [
      448,
      512,
      ["sliders-h-square"],
      'f3f0',
      
      ['M0 32L0 480l448 0 0-448L0 32zM64 144l32 0 32 0 0-16 0-32 64 0 0 32 0 16 160 0 32 0 0 64-32 0-160 0 0 16 0 32-64 0 0-32 0-16-32 0-32 0 0-64zm0 160l32 0 160 0 0-16 0-32 64 0 0 32 0 16 32 0 32 0 0 64-32 0-32 0 0 16 0 32-64 0 0-32 0-16L96 368l-32 0 0-64z','M192 224l0 32-64 0 0-32 0-96 0-32 64 0 0 32 0 96zM320 384l0 32-64 0 0-32 0-96 0-32 64 0 0 32 0 96z']
      
    ]
  };

  
    var faSlidersHSquare = faSquareSliders;
  

  
  

  var faPenToSquare = {
    prefix: 'fasds',
    iconName: 'pen-to-square',
    icon: [
      512,
      512,
      ["edit"],
      'f044',
      
      ['M0 64l32 0 160 0 32 0 0 64-32 0L64 128l0 320 320 0 0-128 0-32 64 0 0 32 0 160 0 32-32 0L32 512 0 512l0-32L0 96 0 64z','M128 384l16-112L340.7 75.3l96 96L240 368 128 384zM459.3 148.7l-96-96L416 0l96 96-52.7 52.7z']
      
    ]
  };

  
    var faEdit = faPenToSquare;
  

  
  

  var faSackDollar = {
    prefix: 'fasds',
    iconName: 'sack-dollar',
    icon: [
      512,
      512,
      [128176],
      'f81d',
      
      ['M0 416l0 96 512 0 0-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4l-128 0c-3.8 2.5-8.1 5.3-13 8.4C122.3 172.7 0 250.9 0 416zM128 0l64 96 128 0L384 0 128 0zm54.7 392.7l12.6-38 19 6.3c2 .7 4.2 1.4 6.4 2.2c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4.1c-5.9-4.3-15.3-7.5-29.3-11.7l-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3z','M192 96l-16 0 0 32 16 0 128 0 16 0 0-32-16 0L192 96zm84 128l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4.1c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c-2.2-.8-4.4-1.5-6.4-2.2l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0s0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3z']
      
    ]
  };

  

  
  

  var faCrosshairsSimple = {
    prefix: 'fasds',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm64 0c0-10.9 .9-21.6 2.7-32C80.1 143.6 143.6 80.1 224 66.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7C368.4 80.1 431.9 143.6 445.3 224c1.7 10.4 2.7 21.1 2.7 32s-.9 21.6-2.7 32C431.9 368.4 368.4 431.9 288 445.3c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7C143.6 431.9 80.1 368.4 66.7 288c-1.7-10.4-2.7-21.1-2.7-32z','M288 445.3c-10.4 1.7-21.1 2.7-32 2.7s-21.6-.9-32-2.7l0-61.3 0-32 64 0 0 32 0 61.3zM445.3 224c1.7 10.4 2.7 21.1 2.7 32s-.9 21.6-2.7 32l-7.3 0L384 288l-32 0 0-64 32 0 54.1 0 7.3 0zM224 66.7c10.4-1.7 21.1-2.7 32-2.7s21.6 .9 32 2.7l0 61.3 0 32-64 0 0-32 0-61.3zM66.7 288c-1.7-10.4-2.7-21.1-2.7-32s.9-21.6 2.7-32l61.3 0 32 0 0 64-32 0-61.3 0z']
      
    ]
  };

  

  
  

  var faBridgeLock = {
    prefix: 'fasds',
    iconName: 'bridge-lock',
    icon: [
      640,
      512,
      [],
      'e4cc',
      
      ['M32 32l0 64 32 0 40 0 0 64-72 0 0 128c53 0 96 43 96 96l0 96 96 0 0-96c0-53 43-96 96-96c24.6 0 47 9.2 64 24.4l0-24.4 32 0 0-16c0-61.9 50.1-112 112-112l8 0 0-64 40 0 32 0 0-64-32 0L64 32 32 32zM152 96l80 0 0 64-80 0 0-64zm128 0l80 0 0 64-80 0 0-64zm128 0l80 0 0 64-80 0 0-64z','M496 272l0 48 64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32zm-48 48l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 32 0 0 192-224 0 0-192 32 0z']
      
    ]
  };

  

  
  

  var faFolderArrowUp = {
    prefix: 'fasds',
    iconName: 'folder-arrow-up',
    icon: [
      512,
      512,
      ["folder-upload"],
      'e054',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM150.1 272c5.7-5.7 11.3-11.3 17-17c24-24 48-48 72-72l17-17 17 17c24 24 48 48 72 72c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-10.3-10.3-20.7-20.7-31-31c0 34 0 68 0 102.1c0 8 0 16 0 24l-48 0c0-8 0-16 0-24c0-34 0-68 0-102.1c-10.3 10.3-20.7 20.7-31 31c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9z','M280 384l0-24 0-102.1 31 31 17 17L361.9 272l-17-17-72-72-17-17-17 17-72 72-17 17L184 305.9l17-17 31-31L232 360l0 24 48 0z']
      
    ]
  };

  
    var faFolderUpload = faFolderArrowUp;
  

  
  

  var faSquareSmall = {
    prefix: 'fasds',
    iconName: 'square-small',
    icon: [
      320,
      512,
      [],
      'e27e',
      
      ['M0 96H320V416H0V96z','']
      
    ]
  };

  

  
  

  var faBackpack = {
    prefix: 'fasds',
    iconName: 'backpack',
    icon: [
      448,
      512,
      [127890],
      'f5d4',
      
      ['M96 384l0 16 0 112 256 0 0-112 0-16L96 384zM136 0l0 24 0 72 48 0 0-48 80 0 0 48 48 0 0-72 0-24L288 0 160 0 136 0z','M0 224C0 153.3 57.3 96 128 96l192 0c70.7 0 128 57.3 128 128l0 288-96 0 0-112 0-112L96 288l0 112 0 112L0 512 0 224zm144-48l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z']
      
    ]
  };

  

  
  

  var faArrowsCross = {
    prefix: 'fasds',
    iconName: 'arrows-cross',
    icon: [
      448,
      512,
      [],
      'e0a2',
      
      ['M2.7 80L48 34.7 70.6 57.4 224 210.7c-15.1 15.1-30.2 30.2-45.3 45.3L25.4 102.6 2.7 80zM224 301.3L269.3 256 384 370.7l0-50.7 0-32 64 0 0 32 0 128 0 32-32 0-128 0-32 0 0-64 32 0 50.7 0L224 301.3z','M256 32l32 0 128 0 32 0 0 32 0 128 0 32-64 0 0-32 0-50.7L70.6 454.6 48 477.3 2.7 432l22.6-22.6L338.7 96 288 96l-32 0 0-64z']
      
    ]
  };

  

  
  

  var faTree = {
    prefix: 'fasds',
    iconName: 'tree',
    icon: [
      448,
      512,
      [127794],
      'f1bb',
      
      ['M0 416l0 32 192 0 0-224 0-32 64 0 0 32 0 224 192 0 0-32-80-96 56 0 0-32-80-80 48 0 0-32L224 0 56 176l0 32 48 0L24 288l0 32 56 0L0 416z','M256 192l0 32 0 256 0 32-64 0 0-32 0-256 0-32 64 0z']
      
    ]
  };

  

  
  

  var faCommentsQuestionCheck = {
    prefix: 'fasds',
    iconName: 'comments-question-check',
    icon: [
      640,
      512,
      [],
      'e14f',
      
      ['M0 176c0 37.5 13.9 72.3 37.6 100.9L0 352l108.1-21.6C137.7 344.2 171.8 352 208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zm134.7-52c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 250.7l40 0 0 40-40 0 0-40z','M134.7 124c0-25.8 20.9-46.7 46.7-46.7l47.4 0c29.1 0 52.6 23.6 52.6 52.6c0 18.8-10.1 36.3-26.4 45.6L228 191l0 6.3 0 20-40 0 0-20 0-17.9 0-11.6 10-5.8L235 140.9c3.9-2.3 6.3-6.4 6.3-10.9c0-7-5.7-12.6-12.6-12.6l-47.4 0c-3.7 0-6.7 3-6.7 6.7l0 5.5-40 0 0-5.5zM188 250.7l40 0 0 40-40 0 0-40zM432 512c-95.6 0-176.2-54.6-200.5-129C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9L640 512 531.9 490.4C502.3 504.2 468.2 512 432 512zM566.1 318.1L580.3 304 552 275.7l-14.1 14.1L472 355.7l-25.9-25.9L432 315.7 403.7 344l14.1 14.1 40 40L472 412.3l14.1-14.1 80-80z']
      
    ]
  };

  

  
  

  var faHouseFloodWater = {
    prefix: 'fasds',
    iconName: 'house-flood-water',
    icon: [
      576,
      512,
      [],
      'e50e',
      
      ['M0 336l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 329.9 19.3 336 0 336zM0 448l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-14.9-6.8-26.9-15.4-40-24.7c-.7-.5-1.4-1-2.1-1.5c-.7 .5-1.4 1-2.1 1.5c-13.1 9.3-25.1 17.9-40 24.7C38.6 441.9 19.3 448 0 448z','M80 144L288 0 496 144l0 48-48.6 0 .3 71.2c-7.9 5.5-14.9 9.8-22.9 13.5C411.6 282.7 397 287 384 287s-27.6-4.3-40.7-10.3c-12-5.5-21.7-12.5-35.5-22.5c0 0 0 0 0 0L288 240l-18.6 13.4-1.1 .8s0 0 0 0c-13.9 10-23.6 17-35.5 22.5C219.6 282.7 205 287 192 287s-27.6-4.3-40.7-10.3c-8.1-3.7-15.2-8.1-23.3-13.7l0-70.9-48 0 0-48z']
      
    ]
  };

  

  
  

  var faMapLocation = {
    prefix: 'fasds',
    iconName: 'map-location',
    icon: [
      576,
      512,
      ["map-marked"],
      'f59f',
      
      ['M0 192l133-53.2c5.5 19.4 15.1 40.6 27 62.1L160 448 0 512 0 192zm192 60.3c44.5 65.3 96 121 96 121s51.4-55.7 96-121L384 512 192 448l0-195.7zm224-51.5c2.1-3.8 4.1-7.5 6-11.3L576 128l0 320L416 512l0-311.1z','M408 120c0 70-120 200-120 200s-120-130-120-200C168 53.7 221.7 0 288 0s120 53.7 120 120z']
      
    ]
  };

  
    var faMapMarked = faMapLocation;
  

  
  

  var faBlanket = {
    prefix: 'fasds',
    iconName: 'blanket',
    icon: [
      448,
      512,
      [],
      'f498',
      
      ['','M0 224l32 0 384 0 32 0 0 32 0 96 0 32-32 0-288 0-32 0 0-64 32 0 256 0 0-32L64 288l0 128 352 0 32 0 0 64-32 0L32 480 0 480l0-32L0 256l0-32z']
      
    ]
  };

  

  
  

  var faGlobePointer = {
    prefix: 'fasds',
    iconName: 'globe-pointer',
    icon: [
      512,
      512,
      [],
      'e60e',
      
      ['M0 256c0 10.2 .6 20.2 1.8 30.1L128.1 249c.4-19.6 2.4-38.7 5.5-57L8.1 192C2.8 212.5 0 233.9 0 256zm18.6-96l122 0c17-65.6 48.3-120 74-156.7C125.4 17.8 51.6 78.5 18.6 160zm141.8 79.5L263 209.3 302.7 249l-20.9 71 64 0c3.9-20.5 6.1-41.9 6.1-64s-2.2-43.5-6.1-64l-179.7 0c-2.9 15.3-4.9 31.2-5.7 47.5zM173.7 160l164.6 0c-11.4-40.2-28.4-75.9-45.8-105.4c-13-21.9-25.9-40-36.5-53.5c-10.5 13.5-23.5 31.6-36.5 53.5c-17.4 29.4-34.5 65.1-45.8 105.4zm60.7 321.1c7.7 11.6 15.1 21.6 21.5 29.8c10.5-13.5 23.5-31.6 36.5-53.5c17.4-29.4 34.5-65.1 45.8-105.4l-65.9 0-38 129.1zm63-477.7c25.7 36.7 57 91 74 156.7l122 0c-33-81.5-106.7-142.2-196-156.7zm0 505.3c89.2-14.5 163-75.2 196-156.7l-122 0c-17 65.6-48.3 120-74 156.7zm81-316.7c3.6 20.5 5.6 41.9 5.6 64s-2 43.5-5.6 64l125.6 0c5.3-20.5 8.1-41.9 8.1-64s-2.8-43.5-8.1-64l-125.6 0z','M254.5 245.1L0 320l96 48 1.4 1.4-96 96 45.3 45.3 96-96L144 416l48 96 74.9-254.5-12.3-12.3z']
      
    ]
  };

  

  
  

  var faHotTubPerson = {
    prefix: 'fasds',
    iconName: 'hot-tub-person',
    icon: [
      512,
      512,
      ["hot-tub"],
      'f593',
      
      ['M0 64a64 64 0 1 0 128 0A64 64 0 1 0 0 64zm0 96l0 96 256 0L128 160 0 160zM224 0l0 24c0 44.2 24.5 76 43.5 100.8l1.4 1.9c20.7 26.9 35 46.7 35 73.4l0 24 48 0 0-24c0-44.2-24.5-76-43.5-100.8L307 97.4C286.3 70.4 272 50.7 272 24l0-24L224 0zM336 0l0 24c0 44.2 24.5 76 43.5 100.8l1.4 1.9c20.7 26.9 35 46.7 35 73.4l0 24 48 0 0-24c0-44.2-24.5-76-43.5-100.8L419 97.4C398.3 70.4 384 50.7 384 24l0-24L336 0z','M512 256L0 256 0 512l512 0 0-256zM128 336l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16zm96 0l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16zm96 0l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16zm96 0l0 96 0 16-32 0 0-16 0-96 0-16 32 0 0 16z']
      
    ]
  };

  
    var faHotTub = faHotTubPerson;
  

  
  

  var faHouseNight = {
    prefix: 'fasds',
    iconName: 'house-night',
    icon: [
      640,
      512,
      [],
      'e010',
      
      ['M0 112c0 61.9 50.1 112 112 112c40.6 0 76.1-21.6 95.8-53.9c-9.9 3.8-20.6 5.9-31.8 5.9c-48.6 0-88-39.4-88-88c0-38.1 24.2-70.5 58-82.7C135.3 1.8 123.8 0 112 0C50.1 0 0 50.1 0 112zM32 384l42.7 21.3L96 448l21.3-42.7L160 384l-42.7-21.3L96 320 74.7 362.7 32 384zM192 64l42.7 21.3L256 128l21.3-42.7L320 64 277.3 42.7 256 0 234.7 42.7 192 64z','M160 304L400 96 640 304l0 48-64 0 0 160-352 0 0-160-64 0 0-48zm288-16l-96 0 0 96 96 0 0-96z']
      
    ]
  };

  

  
  

  var faRectanglePro = {
    prefix: 'fasds',
    iconName: 'rectangle-pro',
    icon: [
      640,
      512,
      ["pro"],
      'e235',
      
      ['M0 32L0 480l640 0 0-448L0 32zM80 160l24 0 56 0c35.3 0 64 28.7 64 64l0 24-4.7 0c-9.5 23.5-32.5 40-59.3 40l-32 0 0 40 0 24-48 0 0-24 0-64 0-80 0-24zm48 48l0 32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm112-48l24 0 56 0c35.3 0 64 28.7 64 64l0 24-4.7 0c-4.7 11.7-12.8 21.7-23.1 28.7l24.1 38.5 23 36.7-56.6 0-7-11.3-33-52.7L288 288l0 40 0 24-48 0 0-24 0-64 0-80 0-24zm48 48l0 32 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0zm112 40c0-48.6 39.4-88 88-88s88 39.4 88 88l0 16c0 48.6-39.4 88-88 88s-88-39.4-88-88l0-16zm48 0l0 16c0 22.1 17.9 40 40 40s40-17.9 40-40l0-16c0-22.1-17.9-40-40-40s-40 17.9-40 40z','M104 160l-24 0 0 24 0 80 0 64 0 24 48 0 0-24 0-40 32 0c26.9 0 49.9-16.5 59.3-40l4.7 0 0-24c0-35.3-28.7-64-64-64l-56 0zm56 80l-32 0 0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16zm328-80c-48.6 0-88 39.4-88 88l0 16c0 48.6 39.4 88 88 88s88-39.4 88-88l0-16c0-48.6-39.4-88-88-88zm-40 88c0-22.1 17.9-40 40-40s40 17.9 40 40l0 16c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-16zM240 160l0 24 0 80 0 64 0 24 48 0 0-24 0-40 18.7 0 33 52.7 7 11.3 56.6 0-23-36.7-24.1-38.5c10.3-7.1 18.3-17 23.1-28.7l4.7 0 0-24c0-35.3-28.7-64-64-64l-56 0-24 0zm48 80l0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0z']
      
    ]
  };

  
    var faPro = faRectanglePro;
  

  
  

  var faMonkey = {
    prefix: 'fasds',
    iconName: 'monkey',
    icon: [
      576,
      512,
      [128018],
      'f6fb',
      
      ['M336 112c0 23.8 17.3 43.5 40 47.3l0 48.7 80 0 0-48.7c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M160 416c0-80.6 49.6-149.6 120-178l0 18 0 32 32 0 135.9 0L566.1 400.9l9.9 9.5 0 13.7 0 56 0 32-64 0 0-32 0-42.3-96-91.6L416 448l32 0 32 0 0 64-32 0-32 0-256 0C71.6 512 0 440.4 0 352L0 32 0 0 32 0 192 0l32 0 0 32 0 128 0 32-32 0-64 0-32 0 0-64 32 0 32 0 0-64L64 64l0 288c0 53 43 96 96 96l0-32zm96-288c0-35.3 28.6-64 64-64c15.7-37.6 52.8-64 96-64s80.4 26.4 96 64c35.3 0 64 28.7 64 64c0 32.6-24.4 59.6-56 63.5l0 64.5-104 0-72 0-32 0 0-27.8 0-36.7c-31.6-3.9-56-30.9-56-63.5zM384 64c-26.5 0-48 21.5-48 48c0 23.8 17.3 43.5 40 47.3l0 48.7 80 0 0-48.7c22.7-3.8 40-23.6 40-47.3c0-26.5-21.5-48-48-48l-64 0z']
      
    ]
  };

  

  
  

  var faSignalBarsSlash = {
    prefix: 'fasds',
    iconName: 'signal-bars-slash',
    icon: [
      640,
      512,
      ["signal-alt-slash"],
      'f694',
      
      ['M32 384l0 128 96 0 0-128-96 0zM192 256l0 256 96 0 0-189.1L203.1 256 192 256zM352 128l0 122.5c32 24.8 64 49.7 96 74.5l0-197-96 0zm0 245.3L352 512l96 0 0-63-96-75.6zM512 0l0 374.7c32 24.8 64 49.7 96 74.5L608 0 512 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faSignalAltSlash = faSignalBarsSlash;
  

  
  

  var faGasPump = {
    prefix: 'fasds',
    iconName: 'gas-pump',
    icon: [
      512,
      512,
      [9981],
      'f52f',
      
      ['M32 0l0 448 288 0 0-144 0-48L320 0 32 0zM96 64l160 0 0 128L96 192 96 64z','M368 48l48 48 0 64c0 29.8 20.4 54.9 48 62l0 154c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32c0-48.6-39.4-88-88-88l-8 0 0 48 8 0c22.1 0 40 17.9 40 40l0 32c0 39.8 32.2 72 72 72s72-32.2 72-72l0-152 0-32 0-24 0-40L400 16 368 48zM0 448l0 64 352 0 0-64L0 448z']
      
    ]
  };

  

  
  

  var faArrowDownFromLine = {
    prefix: 'fasds',
    iconName: 'arrow-down-from-line',
    icon: [
      384,
      512,
      [8615,"arrow-from-top"],
      'f345',
      
      ['M0 32L0 96l32 0 320 0 32 0 0-64-32 0L32 32 0 32z','M192 477.3l22.6-22.6 128-128L365.3 304 320 258.7l-22.6 22.6L224 354.7 224 192l0-32-64 0 0 32 0 162.7L86.6 281.4 64 258.7 18.7 304l22.6 22.6 128 128L192 477.3z']
      
    ]
  };

  
    var faArrowFromTop = faArrowDownFromLine;
  

  
  

  var faLock = {
    prefix: 'fasds',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      ['M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 64 0 0-48C368 64.5 303.5 0 224 0S80 64.5 80 144z','M0 192H448V512H0V192z']
      
    ]
  };

  

  
  

  var faPaintbrush = {
    prefix: 'fasds',
    iconName: 'paintbrush',
    icon: [
      576,
      512,
      [128396,"paint-brush"],
      'f1fc',
      
      ['M0 448l0 64 32 0 144 0c2.7-.1 5.3 0 8 0c66.3 0 120-53.7 120-120c0-2.8-.1-5.5-.2-8.3C271.8 346.5 239.9 309.2 208 272l-24 0c-66.3 0-120 53.7-120 120l0 56-32 0L0 448z','M240 192L512 0l64 64L384 352l-80 32L208 272l32-80z']
      
    ]
  };

  
    var faPaintBrush = faPaintbrush;
  

  
  

  var faSnowBlowing = {
    prefix: 'fasds',
    iconName: 'snow-blowing',
    icon: [
      640,
      512,
      [],
      'f761',
      
      ['M384 176l0 64 32 0 128 0c53 0 96-43 96-96s-43-96-96-96l-32 0-32 0 0 64 32 0 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0-32 0zm0 96l0 64 32 0 120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-24 0-32 0 0 64 32 0 24 0c53 0 96-43 96-96s-43-96-96-96l-120 0-32 0z','M200 64l0 24 0 25.4 12.7-12.7L224 89.4 246.6 112l-11.3 11.3L200 158.6l0 55.8 48.3-27.9 12.9-48.2 4.1-15.5 30.9 8.3-4.1 15.5-4.6 17.3 15-8.7 20.8-12 24 41.6-20.8 12-15 8.7 17.3 4.6 15.5 4.1L336 245.2 320.6 241l-48.2-12.9L224 256l48.3 27.9L320.6 271l15.5-4.1 8.3 30.9-15.5 4.1-17.3 4.6 15 8.7 20.8 12-24 41.6-20.8-12-15-8.7 4.6 17.3 4.1 15.5-30.9 8.3-4.1-15.5-12.9-48.2L200 297.6l0 55.8 35.3 35.3L246.6 400 224 422.6l-11.3-11.3L200 398.6l0 25.4 0 24-48 0 0-24 0-25.4-12.7 12.7L128 422.6 105.4 400l11.3-11.3L152 353.4l0-55.8-48.3 27.9L90.7 373.7l-4.1 15.5-30.9-8.3 4.1-15.5 4.6-17.3-15 8.7-20.8 12-24-41.6 20.8-12 15-8.7-17.3-4.6L7.7 297.7 16 266.8 31.4 271l48.2 12.9L128 256 79.7 228.1 31.4 241 16 245.2 7.7 214.3l15.5-4.1 17.3-4.6-15-8.7-20.8-12 24-41.6 20.8 12 15 8.7-4.6-17.3-4.1-15.5 30.9-8.3 4.1 15.5 12.9 48.2L152 214.4l0-55.8-35.3-35.3L105.4 112 128 89.4l11.3 11.3L152 113.4 152 88l0-24 48 0z']
      
    ]
  };

  

  
  

  var faFutbol = {
    prefix: 'fasds',
    iconName: 'futbol',
    icon: [
      512,
      512,
      [9917,"futbol-ball","soccer-ball"],
      'f1e3',
      
      ['M1 278.9c3.5 39.4 15.9 76.3 35.2 108.5c39.2-2.6 78.4-5.2 117.6-7.8c5.4 3.9 10.8 7.8 16.2 11.8c9.6 38.1 19.3 76.2 28.9 114.3c18.3 4.2 37.4 6.4 57 6.4s38.7-2.2 57-6.4c9.6-38.1 19.3-76.2 28.9-114.3l16.2-11.8c39.2 2.6 78.4 5.2 117.6 7.8c19.3-32.2 31.8-69.1 35.2-108.5l-99.7-62.8c-2.1-6.3-4.1-12.7-6.2-19c14.6-36.5 29.2-72.9 43.8-109.4c-25.1-28.8-56.6-51.9-92.3-67.1C326.4 45.7 296.2 70.8 266 96l-20 0c-30.2-25.2-60.4-50.3-90.6-75.5C119.8 35.8 88.3 58.9 63.1 87.6c14.6 36.5 29.2 72.9 43.8 109.4c-2.1 6.3-4.1 12.7-6.2 19C67.5 237 34.2 257.9 1 278.9zm159.9-53.8L256 156l95.1 69.1L314.8 336.9l-117.6 0c-12.1-37.3-24.2-74.5-36.3-111.8z','M1 278.9c-.7-7.5-1-15.2-1-22.9C0 191.5 23.8 132.6 63.1 87.6L106.9 197l-6.2 19L1 278.9zM199 505.6C130 489.9 71.6 446.4 36.2 387.4l117.6-7.8L170 391.3 199 505.6zM475.8 387.4C440.4 446.4 382 489.9 313 505.6L342 391.3l16.2-11.8 117.6 7.8zM448.9 87.6C488.2 132.6 512 191.5 512 256c0 7.7-.3 15.3-1 22.9l-99.7-62.8-6.2-19L448.9 87.6zM356.6 20.5L266 96l-20 0L155.4 20.5C186.3 7.3 220.3 0 256 0s69.7 7.3 100.6 20.5zM256 156l95.1 69.1L314.8 336.9l-117.6 0L160.9 225.1 256 156z']
      
    ]
  };

  
    var faFutbolBall = faFutbol;
  
    var faSoccerBall = faFutbol;
  

  
  

  var faJug = {
    prefix: 'fasds',
    iconName: 'jug',
    icon: [
      448,
      512,
      [],
      'f8c6',
      
      ['M32 288l384 0 0 128L32 416l0-128zM128 0l32 0L288 0l32 0 0 64-16 0-16 0L160 64l-16 0-16 0 0-64z','M144 64l0 32L32 240l0 48 384 0 0-48-6.4-8.3C432.4 219.7 448 195.6 448 168c0-39.8-32.2-72-72-72c-21.2 0-40.3 9.2-53.5 23.8L304 96l0-32-16 0L160 64l-16 0zM32 512l384 0 0-96L32 416l0 96zM378.6 191.9l-25.1-32.2c3.4-9.1 12.2-15.6 22.5-15.6c13.3 0 24 10.7 24 24c0 12.4-9.4 22.6-21.4 23.9z']
      
    ]
  };

  

  
  

  var faFolderPlus = {
    prefix: 'fasds',
    iconName: 'folder-plus',
    icon: [
      512,
      512,
      [],
      'f65e',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM144 264l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M232 376l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  

  
  

  var faCampground = {
    prefix: 'fasds',
    iconName: 'campground',
    icon: [
      576,
      512,
      [9978],
      'f6bb',
      
      ['','M261 25L241 0 191 40l20 25 36 45L7 410l-7 8.8L0 430l0 18 166.9 0L288 289.7 409.1 448 576 448l0-18 0-11.2-7-8.8L329 110l36-45 20-25L335 0 315 25 288 58.8 261 25z']
      
    ]
  };

  

  
  

  var faClockNineThirty = {
    prefix: 'fasds',
    iconName: 'clock-nine-thirty',
    icon: [
      512,
      512,
      [],
      'e34d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-24l24 0 104 0 24 0 0 24 0 136 0 24-48 0 0-24 0-112-80 0-24 0 0-48z','M280 416l0-24 0-136 0-24-24 0-104 0-24 0 0 48 24 0 80 0 0 112 0 24 48 0z']
      
    ]
  };

  

  
  

  var faWatchFitness = {
    prefix: 'fasds',
    iconName: 'watch-fitness',
    icon: [
      384,
      512,
      [],
      'f63e',
      
      ['M0 64l64 0 256 0 64 0 0 384-64 0L64 448 0 448 0 64zM80 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L192 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0C106.5 160 80 186.5 80 219.2z','M64 0l0 64 256 0 0-64L64 0zm75.2 160C106.5 160 80 186.5 80 219.2c0 16.1 6.6 31.5 18.2 42.7l82.8 79.6L192 352.1l11.1-10.7 82.8-79.6c11.6-11.2 18.2-26.6 18.2-42.7c0-32.7-26.5-59.2-59.2-59.2l-2.4 0c-15.9 0-31.2 6.2-42.7 17.2l-7.7 7.4-7.7-7.4c-11.5-11-26.8-17.2-42.7-17.2l-2.4 0zM320 448L64 448l0 64 256 0 0-64z']
      
    ]
  };

  

  
  

  var faHouseMedicalCircleXmark = {
    prefix: 'fasds',
    iconName: 'house-medical-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e513',
      
      ['M0 240l0 47.6 64.1 0 0 224.4 330.7 0c-45.2-31.8-74.7-84.4-74.8-143.8c-.1 8.7-7.2 15.8-16 15.8l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 48 40.2 0c32.3-39.1 81.1-64 135.8-64c8.3 0 16.5 .6 24.5 1.7L288.4 0 0 240zM320 352l0 15.3c0-5.2 .3-10.3 .7-15.3l-.7 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faUpToLine = {
    prefix: 'fasds',
    iconName: 'up-to-line',
    icon: [
      384,
      512,
      ["arrow-alt-to-top"],
      'f34d',
      
      ['M0 32L0 96l32 0 320 0 32 0 0-64-32 0L32 32 0 32z','M192 128L352 288l0 32-96 0 0 160-128 0 0-160-96 0 0-32L192 128z']
      
    ]
  };

  
    var faArrowAltToTop = faUpToLine;
  

  
  

  var faEgg = {
    prefix: 'fasds',
    iconName: 'egg',
    icon: [
      384,
      512,
      [129370],
      'f7fb',
      
      ['M0 288C0 394 86 496 192 496s192-102 192-208c0-112-64-272-192-272S0 176 0 288zm64 0c0-28.3 5.7-61.9 16.9-93.5c11.2-31.5 28.4-62.4 52.3-84.2L154.8 134c-18.8 17.1-33.6 42.7-43.7 71.2C101 233.6 96 263.5 96 288l0 16-32 0 0-16z','M111.1 205.2C101 233.6 96 263.5 96 288l0 16-32 0 0-16c0-28.3 5.7-61.9 16.9-93.5c11.2-31.5 28.4-62.4 52.3-84.2L154.8 134c-18.8 17.1-33.6 42.7-43.7 71.2z']
      
    ]
  };

  

  
  

  var faFaceDizzy = {
    prefix: 'fasds',
    iconName: 'face-dizzy',
    icon: [
      512,
      512,
      ["dizzy"],
      'f567',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM89.4 144L112 121.4l11.3 11.3c12.2 12.2 24.5 24.5 36.7 36.7l36.7-36.7c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-12.2 12.2-24.5 24.5-36.7 36.7c12.2 12.2 24.5 24.5 36.7 36.7c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-12.2-12.2-24.5-24.5-36.7-36.7c-12.2 12.2-24.5 24.5-36.7 36.7c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6l11.3-11.3L137.4 192c-12.2-12.2-24.5-24.5-36.7-36.7c-3.8-3.8-7.5-7.5-11.3-11.3zM320 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zM281.4 144L304 121.4l11.3 11.3L352 169.4c12.2-12.2 24.5-24.5 36.7-36.7c3.8-3.8 7.5-7.5 11.3-11.3c7.5 7.5 15.1 15.1 22.6 22.6c-3.8 3.8-7.5 7.5-11.3 11.3c-12.2 12.2-24.5 24.5-36.7 36.7c12.2 12.2 24.5 24.5 36.7 36.7c3.8 3.8 7.5 7.5 11.3 11.3c-7.5 7.5-15.1 15.1-22.6 22.6c-3.8-3.8-7.5-7.5-11.3-11.3c-12.2-12.2-24.5-24.5-36.7-36.7c-12.2 12.2-24.5 24.5-36.7 36.7c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6l11.3-11.3c12.2-12.2 24.5-24.5 36.7-36.7c-12.2-12.2-24.5-24.5-36.7-36.7c-3.8-3.8-7.5-7.5-11.3-11.3z','M123.3 132.7L112 121.4 89.4 144l11.3 11.3L137.4 192l-36.7 36.7L89.4 240 112 262.6l11.3-11.3L160 214.6l36.7 36.7L208 262.6 230.6 240l-11.3-11.3L182.6 192l36.7-36.7L230.6 144 208 121.4l-11.3 11.3L160 169.4l-36.7-36.7zm192 0L304 121.4 281.4 144l11.3 11.3L329.4 192l-36.7 36.7L281.4 240 304 262.6l11.3-11.3L352 214.6l36.7 36.7L400 262.6 422.6 240l-11.3-11.3L374.6 192l36.7-36.7L422.6 144 400 121.4l-11.3 11.3L352 169.4l-36.7-36.7z']
      
    ]
  };

  
    var faDizzy = faFaceDizzy;
  

  
  

  var faClipboardMedical = {
    prefix: 'fasds',
    iconName: 'clipboard-medical',
    icon: [
      384,
      512,
      [],
      'e133',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-24 0-48 0-24 80 0 0 448L0 512 0 64zM96 288l0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64-64 0 0 64-64 0z','M270.4 64L304 64l0 96-112 0L80 160l0-96 33.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 288l0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0 0-64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faCircleDot = {
    prefix: 'fasds',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm352 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z','M256 160a96 96 0 1 0 0 192 96 96 0 1 0 0-192z']
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faBorderCenterV = {
    prefix: 'fasds',
    iconName: 'border-center-v',
    icon: [
      448,
      512,
      [],
      'f89d',
      
      ['M0 32L0 96l64 0 0-64L0 32zm0 96l0 64 64 0 0-64L0 128zm0 96l0 64 64 0 0-64L0 224zm0 96l0 64 64 0 0-64L0 320zm0 96l0 64 64 0 0-64L0 416zM96 32l0 64 64 0 0-64L96 32zm0 192l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zM288 32l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zM384 32l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M192 480l0-32 0-384 0-32 64 0 0 32 0 384 0 32-64 0z']
      
    ]
  };

  

  
  

  var faGamepad = {
    prefix: 'fasds',
    iconName: 'gamepad',
    icon: [
      640,
      512,
      [],
      'f11b',
      
      ['M0 64L0 448l640 0 0-384L0 64zM112 232l56 0 0-56 48 0 0 56 56 0 0 48-56 0 0 56-48 0 0-56-56 0 0-48zm360 72a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm64-96a40 40 0 1 1 -80 0 40 40 0 1 1 80 0z','M216 176l-48 0 0 56-56 0 0 48 56 0 0 56 48 0 0-56 56 0 0-48-56 0 0-56z']
      
    ]
  };

  

  
  

  var faCartPlus = {
    prefix: 'fasds',
    iconName: 'cart-plus',
    icon: [
      576,
      512,
      [],
      'f217',
      
      ['M122 32c16.3 85.3 32.5 170.6 48.8 256L496 288 576 32 122 32zM256 140l60 0c0-20 0-40 0-60l40 0c0 20 0 40 0 60l60 0c0 13.3 0 26.7 0 40l-60 0 0 60-40 0c0-20 0-40 0-60l-60 0c0-13.3 0-26.7 0-40z','M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0L119.6 19.5 115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM316 80l0 60-60 0 0 40 60 0 0 60 40 0 0-60 60 0 0-40-60 0 0-60-40 0z']
      
    ]
  };

  

  
  

  var faUserBeardBolt = {
    prefix: 'fasds',
    iconName: 'user-beard-bolt',
    icon: [
      576,
      512,
      [],
      'e689',
      
      ['M0 512l366.5 0 30-96L320 416l0-34.7-2.7 2.7L304 384l-18.7 0-22.6 22.6-9.4 9.4L240 416l-32 0-13.3 0-9.4-9.4L162.7 384 144 384l-13.3 0-9.4-9.4-48-48L66.7 320 64 320 0 512zM64 200l0 40 32 32 0 32 48 48 32 0 32 32 32 0 32-32 32 0 48-48 0-32 32-32 0-40-32-88 0-8C352 46.6 305.4 0 248 0L224 0 200 0C142.6 0 96 46.6 96 104l0 8L64 200zm80-72c0-11.4 2.4-22.2 6.7-32L192 96l32-32 32 32 41.3 0c4.3 9.8 6.7 20.6 6.7 32l0 16c0 12.7-3 24.8-8.3 35.5l-25.6-25.6-5.9-5.9-8.3 0-64 0-8.3 0-5.9 5.9-25.6 25.6C147 168.8 144 156.7 144 144l0-16zm34.5 81.8L200.3 188l47.4 0 21.8 21.8c-1.8 1.2-3.6 2.4-5.5 3.5c-11.8 6.8-25.4 10.7-40 10.7s-28.2-3.9-40-10.7c-1.9-1.1-3.8-2.3-5.5-3.5z','M576 376L400 512l40-128H352V360L528 224 488 352h88v24z']
      
    ]
  };

  

  
  

  var faSquarePhoneFlip = {
    prefix: 'fasds',
    iconName: 'square-phone-flip',
    icon: [
      448,
      512,
      ["phone-square-alt"],
      'f87b',
      
      ['M0 32l448 0 0 448L0 480 0 32zM96 312l16 72 16 0c123.7 0 224-100.3 224-224l0-16-72-16-40 72c14 11.2 27.9 22.3 41.9 33.5c-18.1 34.2-46.2 62.3-80.4 80.4c-11.2-14-22.3-27.9-33.5-41.9L96 312z','M352 144l-72-16-40 72 41.9 33.5c-18.1 34.2-46.2 62.3-80.4 80.4L168 272 96 312l16 72h16c123.7 0 224-100.3 224-224l0-16z']
      
    ]
  };

  
    var faPhoneSquareAlt = faSquarePhoneFlip;
  

  
  

  var faTreePalm = {
    prefix: 'fasds',
    iconName: 'tree-palm',
    icon: [
      576,
      512,
      [127796],
      'f82b',
      
      ['M212.5 512l43.5 0 64 0 28.2 0 3.5-28c3-24 4.4-48.4 4.4-73c0-77-13.8-154.7-36.1-219l-56.7 0c-5 5-9.9 9.9-14.9 14.9c4 10.8 7.8 26.2 9.7 47.2c4.2 46.5-1.6 116.8-32.7 216.4l-13 41.5z','M133.2 141.9L96 80 67.2 128 0 128C0 80 48 0 160 0c88 0 136.5 49.4 153.2 93.8C338.4 76.2 372.3 64 416 64c112 0 160 80 160 128l-67.2 0L480 144l-28.8 48-187.9 0L98.5 356.8c-33.9-33.9-56.6-124.5 22.6-203.6c4-4 8-7.7 12-11.2z']
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fasds',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      ['M160 64l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zm0 160l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64zm0 160l32 0 288 0 32 0 0 64-32 0-288 0-32 0 0-64z','M16 48l96 0 0 96-96 0 0-96zm0 160l96 0 0 96-96 0 0-96zm96 160l0 96-96 0 0-96 96 0z']
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faFilmSimple = {
    prefix: 'fasds',
    iconName: 'film-simple',
    icon: [
      512,
      512,
      ["film-alt"],
      'f3a0',
      
      ['M160 32l192 0 0 448-192 0 0-448z','M160 32l-48 0 0 64L48 96l0-64L0 32 0 480l48 0 0-64 64 0 0 64 48 0 0-448zM352 480l48 0 0-64 64 0 0 64 48 0 0-448-48 0 0 64-64 0 0-64-48 0 0 448zM112 160l0 64-64 0 0-64 64 0zm288 0l64 0 0 64-64 0 0-64zM112 288l0 64-64 0 0-64 64 0zm288 0l64 0 0 64-64 0 0-64z']
      
    ]
  };

  
    var faFilmAlt = faFilmSimple;
  

  
  

  var faAbacus = {
    prefix: 'fasds',
    iconName: 'abacus',
    icon: [
      576,
      512,
      [129518],
      'f640',
      
      ['M0 32L0 96 0 416l0 64 64 0 448 0 64 0 0-64 0-320 0-64-64 0L64 32 0 32zM64 96l64 0 0 32 32 0 0-32 96 0 0 32 32 0 0-32 128 0 0 32 32 0 0-32 64 0 0 112-64 0 0-32-32 0 0 32-128 0 0-32-32 0 0 32-96 0 0-32-32 0 0 32-64 0L64 96zm0 144l64 0 0 24 32 0 0-24 96 0 0 24 32 0 0-24 128 0 0 96 32 0 0-96 64 0 0 176-64 0 0-32-32 0 0 32-128 0 0-32-32 0 0 32-96 0 0-32-32 0 0 32-64 0 0-176zm64 72l0 24 32 0 0-24-32 0zm128 0l0 24 32 0 0-24-32 0z','M96 128l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm128 0l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm160 0l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zM96 264l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm128 0l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zM96 336l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm128 0l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48zm160 0l24 0 48 0 24 0 0 48-24 0-48 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faHockeySticks = {
    prefix: 'fasds',
    iconName: 'hockey-sticks',
    icon: [
      640,
      512,
      [],
      'f454',
      
      ['M0 352l64 0 0 160L0 512 0 352zm96 0c52.1 0 104.1 0 156.2 0L419.4 17.7l57.2 28.6-224 448L243.8 512 224 512l-64 0-32 0c-10.7 0-21.3 0-32 0l0-32 0-128zm448 0l32 0 0 160-32 0 0-32 0-128z','M337.9 395.3l49.5 99 8.8 17.7 19.8 0 64 0s0 0 0 0l64 0 0-32 0-128-156.2 0-14.1-28.2-35.8 71.6zM302.1 180.7l-81.5-163L163.4 46.3l103 205.9 35.8-71.6zM576 352l0 160 64 0 0-160-64 0zM96 352l-32 0 0 160 32 0 0-160z']
      
    ]
  };

  

  
  

  var faFaceAnguished = {
    prefix: 'fasds',
    iconName: 'face-anguished',
    icon: [
      512,
      512,
      [],
      'e369',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM89.4 143.2c3.9-3.6 7.8-7.3 11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0c0 10.7 0 21.3 0 32l-16 0c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 143.2zm119 80.8a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM176 400c0-44.2 35.8-80 80-80s80 35.8 80 80l0 16-160 0 0-16zM304 96l16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8c-4.3-.6-8.6-.9-13-.9l-16 0c0-10.7 0-21.3 0-32zm64.4 128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M192 128c-4.4 0-8.8 .3-13 .9c-21.2 2.8-40.6 12.4-56.1 26.8l-11.7 10.9L89.4 143.2l11.7-10.9c20.1-18.7 45.5-31.5 73.7-35.2c5.6-.7 11.4-1.1 17.2-1.1l16 0 0 32-16 0zm-15.6 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm160 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM333 128.9c-4.3-.6-8.6-.9-13-.9l-16 0 0-32 16 0c5.8 0 11.6 .4 17.2 1.1c28.2 3.7 53.7 16.4 73.7 35.2l11.7 10.9-21.8 23.4-11.7-10.9c-15.5-14.5-34.8-24-56.1-26.8z']
      
    ]
  };

  

  
  

  var faGhost = {
    prefix: 'fasds',
    iconName: 'ghost',
    icon: [
      384,
      512,
      [128123],
      'f6e2',
      
      ['M0 192L0 480l48-32 72 64 72-64 72 64 72-64 48 32 0-288C384 86 298 0 192 0S0 86 0 192zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M128 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faHeading = {
    prefix: 'fasds',
    iconName: 'heading',
    icon: [
      448,
      512,
      ["header"],
      'f1dc',
      
      ['M0 32l32 0 16 0 64 0 16 0 32 0 0 64-32 0-16 0 0 112 224 0 0-112-16 0-32 0 0-64 32 0 16 0 64 0 16 0 32 0 0 64-32 0-16 0 0 144 0 176 16 0 32 0 0 64-32 0-16 0-64 0-16 0-32 0 0-64 32 0 16 0 0-144-224 0 0 144 16 0 32 0 0 64-32 0-16 0-64 0-16 0L0 480l0-64 32 0 16 0 0-176L48 96 32 96 0 96 0 32z','']
      
    ]
  };

  
    var faHeader = faHeading;
  

  
  

  var faTrainTunnel = {
    prefix: 'fasds',
    iconName: 'train-tunnel',
    icon: [
      512,
      512,
      [],
      'e454',
      
      ['M0 256L0 512l105.4 0 64-64L112 448l0-320 288 0 0 320-57.4 0 64 64L512 512l0-256C512 114.6 397.4 0 256 0S0 114.6 0 256zM150.6 512l210.7 0-64-64-82.7 0-64 64zM160 192l0 128 192 0 0-128-192 0z','M112 128l288 0 0 320-288 0 0-320zm48 64l0 128 192 0 0-128-192 0zm96 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faSquareParkingSlash = {
    prefix: 'fasds',
    iconName: 'square-parking-slash',
    icon: [
      640,
      512,
      ["parking-slash"],
      'f617',
      
      ['M96 32l0 19.8 128 99.4 0-23.1 32 0 80 0c53 0 96 43 96 96c0 26.2-10.5 49.9-27.5 67.3c46.5 36.1 93 72.2 139.5 108.3L544 32 96 32zm0 139.6L96 480l391.4 0L288 322.9l0 29.1 0 32-64 0 0-32 0-64 0-15.5L96 171.6zM288 192l0 8.8c21.6 16.8 43.3 33.6 64.9 50.4C362 245.5 368 235.5 368 224c0-17.7-14.3-32-32-32l-48 0z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faParkingSlash = faSquareParkingSlash;
  

  
  

  var faPesetaSign = {
    prefix: 'fasds',
    iconName: 'peseta-sign',
    icon: [
      384,
      512,
      [],
      'e221',
      
      ['M0 160l0 64 32 0 0-64L0 160zm96 0l0 64 186.5 0c3.5-10 5.5-20.8 5.5-32s-1.9-22-5.5-32L96 160zm252.8 0c2.1 10.3 3.2 21 3.2 32c0 1.4 0 2.7-.1 4.1s-.1 2.7-.2 4.1c-.1 2.7-.3 5.4-.6 8.1c-.5 5.3-1.3 10.6-2.4 15.8l35.2 0 0-64-35.2 0z','M32 32l32 0 128 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-96 0 0 128-64 0 0-160L32 64l0-32zM96 288l96 0c53 0 96-43 96-96s-43-96-96-96L96 96l0 192z']
      
    ]
  };

  

  
  

  var faSandwich = {
    prefix: 'fasds',
    iconName: 'sandwich',
    icon: [
      512,
      512,
      [129386],
      'f81f',
      
      ['M1.2 240.7l15.5 62.1 31-7.8 88-22 112 29.9 8.2 2.2 8.2-2.2 112-29.9 88 22 31 7.8 15.5-62.1-31-7.8-96-24-8-2-8 2.1L256 238.9 144.2 209.1l-8-2.1-8 2-96 24-31 7.8zM224 336c32 16 64 32 96 48c32-16 64-32 96-48l-192 0z','M512 64L0 64 0 176l512 0 0-112zM224 336l-32 0L0 336 0 448l512 0 0-112-64 0-32 0-96 48-96-48z']
      
    ]
  };

  

  
  

  var faBookOpenCover = {
    prefix: 'fasds',
    iconName: 'book-open-cover',
    icon: [
      640,
      512,
      ["book-open-alt"],
      'e0c0',
      
      ['M64 0L304 32l0 416L64 400 64 28.8 64 0zM336 32L576 0l0 28.8L576 400c-80 16-160 32-240 48l0-416z','M64 400l256 51.2L576 400l0-371.2L640 16l0 432L320 512 0 448 0 16 64 28.8 64 400z']
      
    ]
  };

  
    var faBookOpenAlt = faBookOpenCover;
  

  
  

  var faShredder = {
    prefix: 'fasds',
    iconName: 'shredder',
    icon: [
      512,
      512,
      [],
      'f68a',
      
      ['M40 384l0 104 0 24 48 0 0-24 0-104-48 0zM64 0l0 192 384 0 0-128L384 0 64 0zm72 384l0 104 0 24 48 0 0-24 0-104-48 0zm96 0l0 104 0 24 48 0 0-24 0-104-48 0zm96 0l0 104 0 24 48 0 0-24 0-104-48 0zm96 0l0 104 0 24 48 0 0-24 0-104-48 0z','M512 192L0 192 0 384l512 0 0-192zm-56 56l0 48-48 0 0-48 48 0z']
      
    ]
  };

  

  
  

  var faSquareCheck = {
    prefix: 'fasds',
    iconName: 'square-check',
    icon: [
      448,
      512,
      [9745,9989,61510,"check-square"],
      'f14a',
      
      ['M0 32L0 480l448 0 0-448L0 32zM94.1 256L128 222.1l1 1 16 16 47 47L303 175l16-16 1-1L353.9 192c-.3 .3-.6 .6-1 1l-16 16L209 337l-17 17-17-17-64-64c-5.3-5.3-10.7-10.7-16-16l-1-1z','M353 193L209 337l-17 17-17-17L95 257 129 223l63 63L319 159 353 193z']
      
    ]
  };

  
    var faCheckSquare = faSquareCheck;
  

  
  

  var faLuchadorMask = {
    prefix: 'fasds',
    iconName: 'luchador-mask',
    icon: [
      448,
      512,
      ["luchador","mask-luchador"],
      'f455',
      
      ['M64 160l0 48c0 44.2 35.8 80 80 80l0 34c-27.6 7.1-48 32.2-48 62c0 35.3 28.7 64 64 64l128 0c35.3 0 64-28.7 64-64c0-29.8-20.4-54.9-48-62l0-34c44.2 0 80-35.8 80-80l0-48-80 0c-44.2 0-80 35.8-80 80c0-44.2-35.8-80-80-80l-80 0zm32 32l48 0c20.9 0 38.7 13.4 45.3 32c1.8 5 2.7 10.4 2.7 16l0 16-48 0c-20.9 0-38.7-13.4-45.3-32C97 219 96 213.6 96 208l0-16zm32 192c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32zm48-80l48-48 48 48 0 16-96 0 0-16zm80-64c0-5.6 1-11 2.7-16c6.6-18.6 24.4-32 45.3-32l48 0 0 16c0 5.6-1 11-2.7 16c-6.6 18.6-24.4 32-45.3 32l-48 0 0-16z','M224 0C100.3 0 0 100.3 0 224L0 512l448 0 0-288C448 100.3 347.7 0 224 0zM352 384c0 35.3-28.7 64-64 64l-128 0c-35.3 0-64-28.7-64-64c0-29.8 20.4-54.9 48-62l0-34c-44.2 0-80-35.8-80-80l0-48 80 0c44.2 0 80 35.8 80 80c0-44.2 35.8-80 80-80l80 0 0 48c0 44.2-35.8 80-80 80l0 34c27.6 7.1 48 32.2 48 62z']
      
    ]
  };

  
    var faLuchador = faLuchadorMask;
  
    var faMaskLuchador = faLuchadorMask;
  

  
  

  var faCommentLines = {
    prefix: 'fasds',
    iconName: 'comment-lines',
    icon: [
      512,
      512,
      [],
      'f4b0',
      
      ['M0 240c0 49.6 21.3 95.1 56.9 130.8L16 480l150.4-45.1c27.9 8.5 58.1 13.1 89.6 13.1c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240zm128-64l24 0 208 0 24 0 0 48-24 0-208 0-24 0 0-48zm0 96l24 0 112 0 24 0 0 48-24 0-112 0-24 0 0-48z','M128 176l24 0 208 0 24 0 0 48-24 0-208 0-24 0 0-48zm0 96l24 0 112 0 24 0 0 48-24 0-112 0-24 0 0-48z']
      
    ]
  };

  

  
  

  var faKeySkeletonLeftRight = {
    prefix: 'fasds',
    iconName: 'key-skeleton-left-right',
    icon: [
      640,
      512,
      [],
      'e3b4',
      
      ['M0 384c0 70.7 57.3 128 128 128c59.6 0 109.8-40.8 124-96l196 0 32 0 0-32 0-64 0-32-64 0 0 32 0 32-32 0 0-32 0-32-64 0 0 32 0 32-68 0c-14.2-55.2-64.3-96-124-96C57.3 256 0 313.3 0 384zm192 0A64 64 0 1 1 64 384a64 64 0 1 1 128 0z','M512 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 64c-59.6 0-109.8-40.8-124-96l-68 0 0 32 0 32-64 0 0-32 0-32-32 0 0 32 0 32-64 0 0-32 0-64 0-32 32 0 196 0C402.2 40.8 452.4 0 512 0c70.7 0 128 57.3 128 128s-57.3 128-128 128z']
      
    ]
  };

  

  
  

  var faAsterisk = {
    prefix: 'fasds',
    iconName: 'asterisk',
    icon: [
      384,
      512,
      [10033,61545],
      '2a',
      
      ['M224 32l0 32 0 135.5 95.5-57.3L347 125.7l32.9 54.9L352.5 197l-98.3 59 98.3 59 27.4 16.5L347 386.3l-27.4-16.5L224 312.5 224 448l0 32-64 0 0-32 0-135.5L64.5 369.8 37 386.3 4.1 331.4 31.5 315l98.3-59L31.5 197 4.1 180.6 37 125.7l27.4 16.5L160 199.5 160 64l0-32 64 0z','']
      
    ]
  };

  

  
  

  var faHandsHoldingChild = {
    prefix: 'fasds',
    iconName: 'hands-holding-child',
    icon: [
      640,
      512,
      [],
      'e4fa',
      
      ['M0 64l0 40 0 24 0 32 0 64L0 352l0 13.3 9.4 9.4 128 128 9.4 9.4 13.3 0 96 0 32 0 0-32 0-32 0-32 0-64 0-13.3-9.4-9.4-64-64L192 242.7l-9.4-9.4L160 210.7 114.7 256l22.6 22.6 9.4 9.4 22.6 22.6L205.8 347l-41.7 27.8L80 290.7 80 224l0-80 0-32 0-8 0-40L0 64zM352 338.7l0 13.3 0 64 0 32 0 32 0 32 32 0 96 0 13.3 0 9.4-9.4 128-128 9.4-9.4 0-13.3 0-128 0-64 0-32 0-24 0-40-80 0 0 40 0 8 0 32 0 80 0 66.7-84.1 84.1L434.2 347l36.4-36.4L493.3 288l9.4-9.4L525.3 256 480 210.7l-22.6 22.6-9.4 9.4-22.6 22.6-64 64-9.4 9.4z','M280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm1.7 56l8.8 0 59.1 0 8.8 0 6.7 5.7 50.5 42.7 18.3 15.5-31 36.7L384.5 181l-19.8-16.7L375.8 253l3 23.8-47.6 6-3-23.8-4.4-35-7.6 0-4.4 35-3 23.8-47.6-6 3-23.8 11.1-88.8L255.5 181l-18.3 15.5-31-36.7 18.3-15.5L275 101.7l6.7-5.7z']
      
    ]
  };

  

  
  

  var faAnkh = {
    prefix: 'fasds',
    iconName: 'ankh',
    icon: [
      320,
      512,
      [9765],
      'f644',
      
      ['M128 320l19.4 0c7.8 5.3 12.6 8 12.6 8s4.8-2.7 12.6-8l19.4 0 0 192-64 0 0-192z','M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128L32 256 0 256l0 64 32 0 115.4 0c7.8 5.3 12.6 8 12.6 8s4.8-2.7 12.6-8L288 320l32 0 0-64-32 0-46.8 0c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z']
      
    ]
  };

  

  
  

  var faWheatAwn = {
    prefix: 'fasds',
    iconName: 'wheat-awn',
    icon: [
      512,
      512,
      ["wheat-alt"],
      'e2cd',
      
      ['M2.7 464L48 509.3l22.6-22.6 52.9-52.9c-3.5-3.5-6.9-6.9-10.4-10.4c-7.5-7.5-15.1-15.1-22.6-22.6L78.8 389l-.5-.5L25.4 441.4 2.7 464zm142.9-95.9c1-.3 1.9-.5 2.9-.8c1-.3 2-.5 2.9-.7c2-.5 3.9-.9 5.9-1.2c4-.7 8-1.3 12-1.7c8-.7 16.1-.7 24.1 .1l31.9-31.9c-3.5-3.5-6.9-6.9-10.4-10.4c-10.7-10.7-21.4-21.4-32.1-32.1c-.9-.9-1.8-1.8-2.7-2.7l-30.4 30.4c2.1 17 .8 34.4-4 51.1zM247.5 266.3c1-.3 2-.5 2.9-.8c1-.3 2-.5 3-.7c2-.5 4-.9 5.9-1.3c4-.7 8-1.3 12-1.7c8-.7 16.1-.7 24.1 .1l31.9-31.9c-3.5-3.5-6.9-6.9-10.4-10.4c-9.8-9.8-19.7-19.7-29.5-29.5c-1.8-1.8-3.5-3.5-5.3-5.3l-30.5 30.5c2.1 17 .8 34.4-4 51zM329.1 52.9c10.5 14.1 17.7 29.9 21.6 46.3L393 57l17-17L376 6.1 359 23 329.1 52.9zM366.1 112L400 145.9l17-17 72-72 17-17L472 6.1 455 23 383 95l-17 17zm45.6 50.4c16.6 3.6 32.7 10.5 47.1 20.8L489 153l17-17L472 102.1l-17 17-43.4 43.4z','M294.2 16L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l45.3 45.3s0 0 0 0l22.6 22.6c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6L475.2 197c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L294.2 16zM215 140.5l-22.6-22.6-22.6 22.6c-37.5 37.5-37.5 98.3 0 135.8L215 321.5s0 0 0 0l22.6 22.6c37.5 37.5 98.3 37.5 135.8 0L396 321.5l-22.6-22.6c-34.1-34.1-82.6-44.9-125.9-32.5C259.9 223 249 174.5 215 140.5zM90.5 219.6L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l22.6 22.6 22.6 22.6 22.6 22.6c37.5 37.5 98.3 37.5 135.8 0l22.6-22.6-22.6-22.6c-34.1-34.1-82.6-44.9-125.9-32.5c12.4-43.3 1.5-91.8-32.5-125.9L90.5 219.6z']
      
    ]
  };

  
    var faWheatAlt = faWheatAwn;
  

  
  

  var faCompress = {
    prefix: 'fasds',
    iconName: 'compress',
    icon: [
      448,
      512,
      [],
      'f066',
      
      ['M0 320l0 64 32 0 64 0 0 64 0 32 64 0 0-32 0-96 0-32-32 0-96 0L0 320zM288 32l0 32 0 96 0 32 32 0 96 0 32 0 0-64-32 0-64 0 0-64 0-32-64 0z','M160 64l0-32L96 32l0 32 0 64-64 0L0 128l0 64 32 0 96 0 32 0 0-32 0-96zM320 320l-32 0 0 32 0 96 0 32 64 0 0-32 0-64 64 0 32 0 0-64-32 0-96 0z']
      
    ]
  };

  

  
  

  var faCircleN = {
    prefix: 'fasds',
    iconName: 'circle-n',
    icon: [
      512,
      512,
      [],
      'e118',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l36.6 0 7.2 10.3L304 283.2 304 152l0-24 48 0 0 24 0 208 0 24-36.6 0-7.2-10.3L208 228.8 208 360l0 24-48 0 0-24 0-208 0-24z','M352 128l-48 0 0 24 0 131.2L203.7 138.3 196.6 128 160 128l0 24 0 208 0 24 48 0 0-24 0-131.2L308.3 373.7l7.2 10.3 36.6 0 0-24 0-208 0-24z']
      
    ]
  };

  

  
  

  var faAlbum = {
    prefix: 'fasds',
    iconName: 'album',
    icon: [
      448,
      512,
      [128189],
      'f89f',
      
      ['M0 32L0 480l448 0 0-448L0 32zM384 256A160 160 0 1 1 64 256a160 160 0 1 1 320 0z','M224 416a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faCloudSunRain = {
    prefix: 'fasds',
    iconName: 'cloud-sun-rain',
    icon: [
      640,
      512,
      [127782],
      'f743',
      
      ['M0 121.3L60.7 208 0 294.7 104 312l17.3 104L160 388.9l0-97.8c-28.7-16.6-48-47.6-48-83.2c0-53 43-96 96-96c18.4 0 35.6 5.2 50.2 14.1c11.9-19.9 29.1-36.2 49.6-47.2L294.7 0 208 60.7 121.3 0 104 104 0 121.3zM144 208c0 18.5 7.8 35.1 20.3 46.8c10.6-39.7 39.9-71.8 77.8-86.4c.8-4.3 1.8-8.5 3-12.6C234.7 148.4 221.8 144 208 144c-35.3 0-64 28.7-64 64zm40 304l56 0 64-96-9.3 0L248 416l-64 96zm96 0l56 0 64-96-56 0-64 96zm96 0l56 0 64-96-56 0-64 96zm96 0l56 0 64-96-56 0-64 96z','M559.9 383.9l80 0 0-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C433.3 114.6 402.8 96 368 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6l0 96 96 0 271.9 0z']
      
    ]
  };

  

  
  

  var faSwords = {
    prefix: 'fasds',
    iconName: 'swords',
    icon: [
      512,
      512,
      [9876],
      'f71d',
      
      ['M0 0L16 96 336 416l80-80L96 16 0 0zM96 336l80 80 57.4-57.4-80-80L96 336zM278.6 153.4l80 80L496 96 512 0 416 16 278.6 153.4z','M48 512l56-56 72 24 32-32L64 304 32 336l24 72L0 464l48 48zm416 0l48-48-56-56 24-72-32-32L304 448l32 32 72-24 56 56z']
      
    ]
  };

  

  
  

  var faCommentSlash = {
    prefix: 'fasds',
    iconName: 'comment-slash',
    icon: [
      640,
      512,
      [],
      'f4b3',
      
      ['M64 240c0-27.8 6.7-54.4 18.9-78.7L424.1 430.1C392.3 441.6 357 448 320 448c-31.5 0-61.7-4.6-89.6-13.1L80 480l40.9-109.2C85.3 335.1 64 289.6 64 240zM144 89c45.9-35.3 107.9-57 176-57c141.4 0 256 93.1 256 208c0 52-23.5 99.6-62.3 136C390.4 280.4 267.2 184.7 144 89z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faBoxTaped = {
    prefix: 'fasds',
    iconName: 'box-taped',
    icon: [
      448,
      512,
      ["box-alt"],
      'f49a',
      
      ['M0 160l160 0L192 32 64 32 0 160zm160 0l128 0 0 128-128 0 0-128zM256 32l32 128 160 0L384 32 256 32z','M160 160L0 160 0 480l448 0 0-320-160 0 0 128-128 0 0-128z']
      
    ]
  };

  
    var faBoxAlt = faBoxTaped;
  

  
  

  var faXmarkToSlot = {
    prefix: 'fasds',
    iconName: 'xmark-to-slot',
    icon: [
      576,
      512,
      ["times-to-slot","vote-nay"],
      'f771',
      
      ['M96 32l0 256 0 80 0 32 384 0 0-32 0-80 0-256L96 32zm94.1 120c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.4 31.4 47 47c15.7-15.7 31.4-31.4 47-47c5.7-5.7 11.3-11.3 17-17L385.9 152c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.4 31.4-47 47c15.7 15.7 31.4 31.4 47 47c5.7 5.7 11.3 11.3 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c-15.7 15.7-31.4 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17z','M385.9 152l-17 17-47 47 47 47 17 17L352 313.9l-17-17-47-47-47 47-17 17L190.1 280l17-17 47-47-47-47-17-17L224 118.1l17 17 47 47 47-47 17-17L385.9 152zM0 288l96 0 0 80-32 0 0 32 448 0 0-32-32 0 0-80 96 0 0 192L0 480 0 288z']
      
    ]
  };

  
    var faTimesToSlot = faXmarkToSlot;
  
    var faVoteNay = faXmarkToSlot;
  

  
  

  var faVolumeLow = {
    prefix: 'fasds',
    iconName: 'volume-low',
    icon: [
      448,
      512,
      [128264,"volume-down"],
      'f027',
      
      ['M380.8 217.6c11.7 8.8 19.2 22.7 19.2 38.4s-7.5 29.6-19.2 38.4l28.8 38.4C432.9 315.3 448 287.4 448 256s-15.1-59.3-38.4-76.8l-28.8 38.4z','M0 352V160H128L272 32h48V480H272L128 352H0z']
      
    ]
  };

  
    var faVolumeDown = faVolumeLow;
  

  
  

  var faFeather = {
    prefix: 'fasds',
    iconName: 'feather',
    icon: [
      512,
      512,
      [129718],
      'f52d',
      
      ['M64 224l0 190.1c69.3-69.3 138.6-138.6 207.9-207.9c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17C236.5 309.4 167.2 378.7 97.9 448L288 448l64-64-48 0 0-16 91.4-27.4L448 288l-80 0 0-16 124.8-37.4C505.3 211.9 512 186.3 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L64 224z','M6.1 472l17-17L271.9 206.1l17-17 33.9 33.9-17 17L57 489l-17 17L6.1 472z']
      
    ]
  };

  

  
  

  var faSquareCode = {
    prefix: 'fasds',
    iconName: 'square-code',
    icon: [
      448,
      512,
      [],
      'e267',
      
      ['M0 32L0 480l448 0 0-448L0 32zM62.1 256c5.7-5.7 11.3-11.3 17-17l64-64c5.7-5.7 11.3-11.3 17-17L193.9 192c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.4 31.4-47 47l47 47 17 17c-11.3 11.3-22.6 22.6-33.9 33.9c-5.7-5.7-11.3-11.3-17-17c-21.3-21.3-42.7-42.7-64-64l-17-17zm192-64c11.3-11.3 22.6-22.6 33.9-33.9l17 17c21.3 21.3 42.7 42.7 64 64c5.7 5.7 11.3 11.3 17 17c-5.7 5.7-11.3 11.3-17 17c-21.3 21.3-42.7 42.7-64 64c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c15.7-15.7 31.4-31.4 47-47c-15.7-15.7-31.4-31.4-47-47l-17-17z','M193.9 192l-17 17-47 47 47 47 17 17L160 353.9l-17-17L79 273l-17-17 17-17 64-64 17-17L193.9 192zM288 158.1l17 17 64 64 17 17-17 17-64 64-17 17L254.1 320l17-17 47-47-47-47-17-17L288 158.1z']
      
    ]
  };

  

  
  

  var faDisplayChartUp = {
    prefix: 'fasds',
    iconName: 'display-chart-up',
    icon: [
      576,
      512,
      [],
      'e5e3',
      
      ['M0 0L0 416l240 0 96 0 240 0L576 0 0 0zM64 64l448 0 0 288L64 352 64 64z','M64 64l448 0 0 288L64 352 64 64zM346.7 448l69.3 0 32 0 0 64-32 0-256 0-32 0 0-64 32 0 69.3 0L240 416l96 0 10.7 32zM344 112l-24 0 0 48 24 0 38.1 0L304 238.1l-63-63-17-17-17 17-96 96L145 305l79-79 63 63 17 17 17-17 95-95 0 38.1 0 24 48 0 0-24 0-96 0-24-24 0-96 0z']
      
    ]
  };

  

  
  

  var faChartScatter3d = {
    prefix: 'fasds',
    iconName: 'chart-scatter-3d',
    icon: [
      512,
      512,
      [],
      'e0e8',
      
      ['M18.9 443.9l41 49.2 24.6-20.5L256 329.7 427.5 472.6l24.6 20.5 41-49.2-24.6-20.5L288 273l0-209 0-32-64 0 0 32 0 209L43.5 423.4 18.9 443.9z','M0 32l64 0 0 64L0 96 0 32zM0 224l64 0 0 64L0 288l0-64zm160-96l0 64-64 0 0-64 64 0zM352 32l64 0 0 64-64 0 0-64zm160 96l0 64-64 0 0-64 64 0zM352 224l64 0 0 64-64 0 0-64zM288 416l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faHanukiah = {
    prefix: 'fasds',
    iconName: 'hanukiah',
    icon: [
      640,
      512,
      [128334],
      'f6e6',
      
      ['M8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C20.8 65.1 8 84.3 8 104zm80 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C100.8 65.1 88 84.3 88 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C164.8 65.1 152 84.3 152 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C228.8 65.1 216 84.3 216 104zm80-48c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C308.8 17.1 296 36.3 296 56zm80 48c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C388.8 65.1 376 84.3 376 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C452.8 65.1 440 84.3 440 104zm64 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C516.8 65.1 504 84.3 504 104zm80 0c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.7-12.8-38.9-20.1-50c-1.6-2.4-3-4.5-3.9-6c-.9 1.6-2.3 3.6-3.9 6C596.8 65.1 584 84.3 584 104z','M352 144l0-32-64 0 0 32 0 176L96 320c-17.7 0-32-14.3-32-32l0-96 0-32L0 160l0 32 0 96c0 53 43 96 96 96l192 0 0 64-128 0-32 0 0 64 32 0 160 0 160 0 32 0 0-64-32 0-128 0 0-64 192 0c53 0 96-43 96-96l0-96 0-32-64 0 0 32 0 96c0 17.7-14.3 32-32 32l-192 0 0-176zM128 176l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96zm64 0l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96zm64 0l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96zm160 0l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96zm64 0l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96zm64 0l0-16-32 0 0 16 0 96 0 16 32 0 0-16 0-96z']
      
    ]
  };

  

  
  

  var faFaceCowboyHat = {
    prefix: 'fasds',
    iconName: 'face-cowboy-hat',
    icon: [
      512,
      512,
      [],
      'e36e',
      
      ['M48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-49.3-17.2-94.6-45.8-130.2C375.4 204.9 318.5 224 256 224l-.3 0c-1.8 0-3.6 0-5.4-.1c-2.1 0-4-.1-5.9-.2c-3.9-.2-7.7-.4-11.5-.7c-7.6-.6-15.2-1.5-22.5-2.6c-14.8-2.3-29.1-5.6-42.8-10c-27.4-8.7-52.3-21.3-73.6-36.9C65.2 209.4 48 254.7 48 304zm88 51.1c34.6 13.8 75.9 21.7 120.2 21.7s85.6-8 120.2-21.7C364.2 410.5 315 452 256.2 452s-108-41.5-120.2-96.9zM216 304a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm128 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M136.6 110.8L192 0l64 32L320 0l55.4 110.8c36.5-11.1 68.9-27.1 95.3-46.8L488 81.3C460.8 163.5 367.2 224 256 224S51.2 163.5 24 81.3L41.3 64c26.4 19.7 58.8 35.7 95.3 46.8zM168 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faFlag = {
    prefix: 'fasds',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      ['M64 48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0L448 16l0 320-55.5 20.8c-20.1 7.6-41.3 11.3-62.3 11.3c-27.3 0-54.5-6.3-79.4-18.7c-37.9-19-81.3-23.7-122.5-13.4L64 352 64 48z','M64 0l0 32 0 448 0 32L0 512l0-32L0 32 0 0 64 0z']
      
    ]
  };

  

  
  

  var faArrowUpToLine = {
    prefix: 'fasds',
    iconName: 'arrow-up-to-line',
    icon: [
      384,
      512,
      ["arrow-to-top"],
      'f341',
      
      ['M0 32l32 0 320 0 32 0 0 64-32 0L32 96 0 96 0 32z','M192 146.7l22.6 22.6 128 128L365.3 320 320 365.3l-22.6-22.6L224 269.3 224 448l0 32-64 0 0-32 0-178.7L86.6 342.6 64 365.3 18.7 320l22.6-22.6 128-128L192 146.7z']
      
    ]
  };

  
    var faArrowToTop = faArrowUpToLine;
  

  
  

  var faSquirrel = {
    prefix: 'fasds',
    iconName: 'squirrel',
    icon: [
      512,
      512,
      [],
      'f71a',
      
      ['M0 144c0 79.5 64.5 144 144 144c5.4 0 10.7-.3 16-.9l0 12.2c-19.9 22.6-32 52.2-32 84.7l0 128 128 0c16 0 32 0 48 0c-62-.6-112-51-112-113.1c0-30 11.9-58.8 33.1-80L288 256l0-112C288 64.5 223.5 0 144 0S0 64.5 0 144z','M416 96l0 1.5c2.9 .9 5.6 2.2 8.1 3.9L512 160l0 32-32 48-64 0 0 58.8c-14.5-6.9-30.8-10.8-48-10.8c-13.1 0-25.6 2.2-37.3 6.4l10.7 30.2c8.3-2.9 17.3-4.5 26.7-4.5c18 0 34.6 6 48 16c19.4 14.6 32 37.8 32 64c0 18-6 34.6-16 48l16 0 32 0 0 64-32 0-72 0-24 0-32 0-14.9 0-1.1 0s0 0 0 0c-62-.6-112-51-112-113.1c0-30 11.9-58.8 33.1-80L320 224l0-41.8 0-54.2 0-32 0-32c20.4 0 38.2 10.9 48 27.1C377.8 74.9 395.6 64 416 64l0 32zm0 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faFireBurner = {
    prefix: 'fasds',
    iconName: 'fire-burner',
    icon: [
      640,
      512,
      [],
      'e4f1',
      
      ['M0 384L0 512l640 0 0-128-32 0 0-104 0-24-24 0-48 0-24 0 0 48 24 0 24 0 0 80L80 384l0-80 24 0 24 0 0-48-24 0-48 0-24 0 0 24 0 104L0 384zm224 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm128 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M160 192c0-89.6 85.3-165.3 128-192l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160zM320 304.2c35.3 0 64-28.7 64-64c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faRoadSpikes = {
    prefix: 'fasds',
    iconName: 'road-spikes',
    icon: [
      640,
      512,
      [],
      'e568',
      
      ['M32 96l0 288 128 0 96 0 32 0 96 0 32 0 96 0 96 0 32 0L448 96l-32 0 0 144L320 96l-32 0 0 144L192 96l-32 0 0 144L64 96 32 96z','M0 384l32 0 576 0 32 0 0 64-32 0L32 448 0 448l0-64z']
      
    ]
  };

  

  
  

  var faFaceSleeping = {
    prefix: 'fasds',
    iconName: 'face-sleeping',
    icon: [
      512,
      512,
      [],
      'e38d',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-46.6-12.5-90.3-34.2-128L432 128l-48 0 0-48 0-8 0-8 0-16 0-13.8C346.3 12.5 302.6 0 256 0C114.6 0 0 114.6 0 256zm91.2-2.4l25.6-19.2c21.6 28.8 64.8 28.8 86.4 0c8.5 6.4 17 12.8 25.6 19.2c-34.4 45.9-103.2 45.9-137.6 0zM296 384a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM256 64l16 0 64 0 16 0 0 16 0 8 0 8-6.4 4.8L309.3 128l26.7 0 16 0 0 32-16 0-64 0-16 0c0-5.3 0-10.7 0-16c0-2.7 0-5.3 0-8s0-5.3 0-8l6.4-4.8c12.1-9.1 24.2-18.1 36.3-27.2L272 96l-16 0c0-10.7 0-21.3 0-32zm27.2 189.6c8.5-6.4 17.1-12.8 25.6-19.2c21.6 28.8 64.8 28.8 86.4 0l25.6 19.2c-17.2 22.9-43 34.4-68.8 34.4s-51.6-11.5-68.8-34.4z','M432 0L416 0l0 32 16 0 26.7 0L422.4 59.2 416 64l0 8 0 8 0 16 16 0 64 0 16 0 0-32-16 0-26.7 0 36.3-27.2L512 32l0-8 0-8 0-16L496 0 432 0zM272 64l-16 0 0 32 16 0 26.7 0-36.3 27.2L256 128l0 8 0 8 0 16 16 0 64 0 16 0 0-32-16 0-26.7 0 36.3-27.2L352 96l0-8 0-8 0-16-16 0-64 0zm36.8 170.4l-25.6 19.2c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2c-21.6 28.8-64.8 28.8-86.4 0zm-192 0L91.2 253.6c34.4 45.9 103.2 45.9 137.6 0l-25.6-19.2c-21.6 28.8-64.8 28.8-86.4 0z']
      
    ]
  };

  

  
  

  var faMemory = {
    prefix: 'fasds',
    iconName: 'memory',
    icon: [
      576,
      512,
      [],
      'f538',
      
      ['M0 64l0 82.7c18.6 6.6 32 24.4 32 45.3s-13.4 38.7-32 45.3L0 320l576 0 0-82.7c-18.6-6.6-32-24.4-32-45.3s13.4-38.7 32-45.3L576 64 0 64zm128 64l64 0 0 32 0 64 0 32-64 0 0-32 0-64 0-32zm128 0l64 0 0 32 0 64 0 32-64 0 0-32 0-64 0-32zm128 0l64 0 0 32 0 64 0 32-64 0 0-32 0-64 0-32z','M192 160l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32zm128 0l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32zm128 0l0 64 0 32-64 0 0-32 0-64 0-32 64 0 0 32zM0 320l576 0 0 128-80 0 0-32 0-16-32 0 0 16 0 32-96 0 0-32 0-16-32 0 0 16 0 32-96 0 0-32 0-16-32 0 0 16 0 32-96 0 0-32 0-16-32 0 0 16 0 32L0 448 0 320z']
      
    ]
  };

  

  
  

  var faCircleDollarToSlot = {
    prefix: 'fasds',
    iconName: 'circle-dollar-to-slot',
    icon: [
      512,
      512,
      ["donate"],
      'f4b9',
      
      ['M48 208a208 208 0 1 0 416 0A208 208 0 1 0 48 208zm134.7 72.7c4.2-12.6 8.4-25.3 12.6-38c6.3 2.1 12.6 4.2 19 6.3c2 .7 4.2 1.4 6.4 2.1c9.5 3.2 20.2 6.9 26.2 7.9c12.8 2 22.7 .7 28.8-1.9c5.5-2.3 7.4-5.3 8-8.8c.7-4 .1-5.9-.2-6.7c-.4-.9-1.3-2.2-3.7-4c-5.9-4.3-15.3-7.5-29.3-11.7c-.7-.2-1.5-.4-2.2-.7c-11.7-3.5-27-8.1-38.6-16c-6.6-4.5-13.2-10.7-17.3-19.5c-4.2-9-5.2-18.8-3.4-29c3.2-18.3 16.2-30.9 31.1-37.7c5-2.3 10.4-4 16-5.1l0-6 0-20 40 0 0 20 0 6.3c6.6 1.2 16.7 3.2 21.1 4.4l19.3 5.1-10.3 38.7-19.3-5.1c-3.8-1-17.4-3.7-21.7-4.3c-12.2-1.9-22.2-.3-28.6 2.6c-6.3 2.9-7.9 6.2-8.2 8.1c-.6 3.4 0 4.7 .1 5c.3 .5 1 1.8 3.6 3.5c6.1 4.2 15.7 7.2 29.9 11.4l.8 .2c12.1 3.7 28.3 8.5 40.4 17.4c6.7 4.9 13 11.4 16.9 20.5c4 9.1 4.8 19.1 3 29.4c-3.3 19-15.9 32-31.6 38.7c-4.9 2.1-10.1 3.6-15.4 4.6l0 5.5 0 20-40 0 0-20 0-6.4c-9.5-2.2-22-6.4-29.9-9.1c-1.7-.6-3.2-1.1-4.4-1.5l-19-6.3z','M276 112l0-20-40 0 0 20 0 6c-5.6 1.2-11 2.9-16 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9c0 0 0 0 0 0c-2.2-.8-4.4-1.5-6.4-2.1l-19-6.3-12.6 38 19 6.3c1.2 .4 2.7 .9 4.4 1.5c0 0 0 0 0 0c7.9 2.7 20.3 7 29.9 9.1l0 6.4 0 20 40 0 0-20 0-5.5c5.4-1 10.6-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4c0 0 0 0 0 0l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3l19.3 5.1 10.3-38.7-19.3-5.1c-4.4-1.2-14.5-3.2-21.1-4.4l0-6.3zM64 352l-32 0L0 352l0 32 0 96 0 32 32 0 448 0 32 0 0-32 0-96 0-32-32 0-32 0c-19.4 25.9-44 47.7-72.2 64l72.2 0 0 32-192 0L64 448l0-32 72.2 0C108 399.7 83.4 377.9 64 352z']
      
    ]
  };

  
    var faDonate = faCircleDollarToSlot;
  

  
  

  var faSpaceStationMoonConstruction = {
    prefix: 'fasds',
    iconName: 'space-station-moon-construction',
    icon: [
      512,
      512,
      ["space-station-moon-alt"],
      'e034',
      
      ['M0 256c0 7.8 .3 15.5 1 23.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c.7-7.6 1-15.3 1-23.1c0-10.8-.7-21.5-2-32l-62 0 0-64-80 0 0-64 48 0 0-39.9C372.2 21 316.5 0 256 0C114.6 0 0 114.6 0 256zm6.8 58.8C33.4 427.9 134.9 512 256 512c76.5 0 145.1-33.5 192-86.7l0-41.3-64 0 0-41.2c-40.7 6-83.7 9.2-128 9.2c-91.3 0-176.6-13.6-249.2-37.2zM272 160a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z','M224 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM6.8 314.8C4.1 303.2 2.1 291.3 1 279.1C73.2 304.7 160.8 320 256 320s182.8-15.3 255-40.9c-1.1 12.2-3 24.1-5.8 35.8C432.6 338.4 347.3 352 256 352s-176.6-13.6-249.2-37.2z']
      
    ]
  };

  
    var faSpaceStationMoonAlt = faSpaceStationMoonConstruction;
  

  
  

  var faPipeSection = {
    prefix: 'fasds',
    iconName: 'pipe-section',
    icon: [
      640,
      512,
      [],
      'e438',
      
      ['M64 128l0 256 512 0 0-256L64 128z','M64 128l0-32L0 96l0 32L0 384l0 32 64 0 0-32 0-256zm576 0l0-32-64 0 0 32 0 256 0 32 64 0 0-32 0-256z']
      
    ]
  };

  

  
  

  var faSitemap = {
    prefix: 'fasds',
    iconName: 'sitemap',
    icon: [
      576,
      512,
      [],
      'f0e8',
      
      ['M56 232l0 24 0 64 48 0 0-40 160 0 0 40 48 0 0-40 160 0 0 40 48 0 0-64 0-24-24 0-184 0 0-40-48 0 0 40L80 232l-24 0z','M208 32l160 0 0 160-160 0 0-160zM160 320l0 160L0 480 0 320l160 0zm208 0l0 160-160 0 0-160 160 0zm208 0l0 160-160 0 0-160 160 0z']
      
    ]
  };

  

  
  

  var faHeadphonesSimple = {
    prefix: 'fasds',
    iconName: 'headphones-simple',
    icon: [
      512,
      512,
      ["headphones-alt"],
      'f58f',
      
      ['M0 288L0 392l0 24 48 0 0-24 0-104C48 173.1 141.1 80 256 80s208 93.1 208 208l0 104 0 24 48 0 0-24 0-104C512 146.6 397.4 32 256 32S0 146.6 0 288z','M192 288L80 288l0 192 112 0 0-192zm128 0l0 192 112 0 0-192-112 0z']
      
    ]
  };

  
    var faHeadphonesAlt = faHeadphonesSimple;
  

  
  

  var faCloudShowersHeavy = {
    prefix: 'fasds',
    iconName: 'cloud-showers-heavy',
    icon: [
      512,
      512,
      [],
      'f740',
      
      ['M0 512l56 0 72-160-56 0L0 512zm120 0l56 0 72-160-56 0L120 512zm112 0l56 0 72-160-56 0L232 512zm120 0l56 0 72-160-56 0L352 512z','M0 320l96 0 320 0 96 0 0-96c0-53-43-96-96-96l0-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112l0 21.5C26.7 146.6 0 182.2 0 224l0 96z']
      
    ]
  };

  

  
  

  var faTemperatureList = {
    prefix: 'fasds',
    iconName: 'temperature-list',
    icon: [
      512,
      512,
      [],
      'e299',
      
      ['M0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34.3-12-65.8-32-90.5L256 64l0-64L192 0 96 0 32 0l0 64 0 213.5C12 302.2 0 333.7 0 368zm64 0c0-19.1 6.6-36.5 17.8-50.3L96 300.2l0-22.7L96 64l96 0 0 213.5 0 22.7 14.2 17.6C217.4 331.5 224 348.9 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80z','M352 32l128 0 32 0 0 64-32 0L352 96l-32 0 0-64 32 0zM160 160l0 16 0 146.8c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3L128 176l0-16 32 0zm160 0l32 0 128 0 32 0 0 64-32 0-128 0-32 0 0-64zm64 128l96 0 32 0 0 64-32 0-96 0-32 0 0-64 32 0z']
      
    ]
  };

  

  
  

  var faUnlockKeyhole = {
    prefix: 'fasds',
    iconName: 'unlock-keyhole',
    icon: [
      448,
      512,
      ["unlock-alt"],
      'f13e',
      
      ['M80 144l0 48 64 0 0-48c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7l57.8-27.5C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144z','M448 192L0 192 0 512l448 0 0-320zM256 384l-64 0-32 0 0-64 32 0 64 0 32 0 0 64-32 0z']
      
    ]
  };

  
    var faUnlockAlt = faUnlockKeyhole;
  

  
  

  var faSidebarFlip = {
    prefix: 'fasds',
    iconName: 'sidebar-flip',
    icon: [
      512,
      512,
      [],
      'e24f',
      
      ['M0 32l288 0 0 448L0 480 0 32z','M288 32l224 0 0 448-224 0 0-448zm64 64l0 48 96 0 0-48-96 0zm96 96l-96 0 0 48 96 0 0-48zm-96 96l0 48 96 0 0-48-96 0z']
      
    ]
  };

  

  
  

  var faCircleChevronDown = {
    prefix: 'fasds',
    iconName: 'circle-chevron-down',
    icon: [
      512,
      512,
      ["chevron-circle-down"],
      'f13a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm118.1-32L152 190.1l17 17 87 87c29-29 58-58 87-87c5.7-5.7 11.3-11.3 17-17c11.3 11.3 22.6 22.6 33.9 33.9c-5.7 5.7-11.3 11.3-17 17c-34.7 34.7-69.3 69.3-104 104c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-34.7-34.7-69.3-69.3-104-104c-5.7-5.7-11.3-11.3-17-17z','M256 361.9l17-17L377 241l17-17L360 190.1l-17 17-87 87-87-87-17-17L118.1 224l17 17L239 345l17 17z']
      
    ]
  };

  
    var faChevronCircleDown = faCircleChevronDown;
  

  
  

  var faFaceFrownSlight = {
    prefix: 'fasds',
    iconName: 'face-frown-slight',
    icon: [
      512,
      512,
      [],
      'e376',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM129.7 392.8C142.3 367.7 184.4 320 256 320s113.7 47.7 126.3 72.8l-28.6 14.3C344.9 389.7 312.4 352 256 352s-88.9 37.7-97.7 55.2l-28.6-14.3zM144.4 208c0-17.7 14.3-32 32-32c8.8 0 16.8 3.6 22.6 9.4c2.9 2.9 5.2 6.3 6.9 10.2c.8 1.9 1.4 3.9 1.9 6c.2 1 .4 2.1 .5 3.2c.1 .5 .1 1.1 .1 1.6s0 1 0 1.8c0 .5 0 1 0 1.5s-.1 1.1-.1 1.6c-.1 1.1-.3 2.1-.5 3.2c-.4 2.1-1.1 4.1-1.9 6c-1.6 3.8-4 7.3-6.9 10.2c-5.8 5.8-13.8 9.4-22.6 9.4c-17.7 0-32-14.3-32-32zm224 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fasds',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      ['M0 32L0 64 0 448l0 32 32 0 128 0 32 0 0-64-32 0-96 0L64 96l96 0 32 0 0-64-32 0L32 32 0 32z','M509.3 256l-22.6 22.6-128 128L336 429.3 290.7 384l22.6-22.6L386.7 288 192 288l-32 0 0-64 32 0 194.7 0-73.4-73.4L290.7 128 336 82.7l22.6 22.6 128 128L509.3 256z']
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faSchoolCircleXmark = {
    prefix: 'fasds',
    iconName: 'school-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e56d',
      
      ['M0 96L0 512l256 0 0-96c0-35.3 28.7-64 64-64l.7 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 96 480 96 320 0 160 96 0 96zm80 96l64 0 0 96-64 0 0-96zm0 128l64 0 0 96-64 0 0-96zM304 128l0 16 0 32 0 16 16 0 32 0 16 0 0-32-16 0-16 0 0-16 0-16-32 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm214.6-48L544 297.4l-11.3 11.3L496 345.4l-36.7-36.7L448 297.4 425.4 320l11.3 11.3L473.4 368l-36.7 36.7L425.4 416 448 438.6l11.3-11.3L496 390.6l36.7 36.7L544 438.6 566.6 416l-11.3-11.3L518.6 368l36.7-36.7L566.6 320z']
      
    ]
  };

  

  
  

  var faCircleExclamation = {
    prefix: 'fasds',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 128l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M280 152l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBlock = {
    prefix: 'fasds',
    iconName: 'block',
    icon: [
      448,
      512,
      [],
      'e46a',
      
      ['M0 32l448 0 0 448L0 480 0 32zm48 72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zM352 104a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 304a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M72 128a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm304 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm280 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faTrashCanList = {
    prefix: 'fasds',
    iconName: 'trash-can-list',
    icon: [
      640,
      512,
      [],
      'e2ab',
      
      ['M32 96l0 416 352 0 0-416L32 96zm96 80l32 0 0 16 0 224 0 16-32 0 0-16 0-224 0-16zm128 0l32 0 0 16 0 224 0 16-32 0 0-16 0-224 0-16z','M128 0L288 0l16 32 112 0 0 64L0 96 0 32l112 0L128 0zM640 128l0 64-192 0 0-64 192 0zM608 256l0 64-160 0 0-64 160 0zM448 384l96 0 0 64-96 0 0-64z']
      
    ]
  };

  

  
  

  var faCommentMiddle = {
    prefix: 'fasds',
    iconName: 'comment-middle',
    icon: [
      512,
      512,
      [],
      'e149',
      
      ['M320.1 409.4C430.5 386.3 512 304.9 512 208C512 93.1 397.4 0 256 0S0 93.1 0 208c0 96.9 81.5 178.3 191.9 201.4L256 512l64.1-102.6z','']
      
    ]
  };

  

  
  

  var faCaretLeft = {
    prefix: 'fasds',
    iconName: 'caret-left',
    icon: [
      256,
      512,
      [],
      'f0d9',
      
      ['M0 256L144 416l48 0 0-320-48 0L0 256z','']
      
    ]
  };

  

  
  

  var faLightbulb = {
    prefix: 'fasds',
    iconName: 'lightbulb',
    icon: [
      384,
      512,
      [128161],
      'f0eb',
      
      ['M16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176zm64 0c0-61.9 50.1-112 112-112l0 32c-44.2 0-80 35.8-80 80l-32 0z','M112 384V512H272V384H112z']
      
    ]
  };

  

  
  

  var faPeopleRobbery = {
    prefix: 'fasds',
    iconName: 'people-robbery',
    icon: [
      576,
      512,
      [],
      'e536',
      
      ['M232.8 17.3l8.2 30.9 32 120 6.3 23.8 24.6 0 24 0 0 288 0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-288 24 0 24.6 0 6.3-23.8 32-120 8.2-30.9L505.3 .8l-8.2 30.9L471.4 128 408 128c-5.3 0-10.7 0-16 0c-21.1 0-42.3 0-63.4 0L302.9 31.8 294.7 .8 232.8 17.3zM352 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM8 128l32 0 91.1 0 17.6 0 9.4 14.9L209.6 224l30.4 0 32 0 0 64-32 0-48 0-17.6 0L165 273.1l-13-20.5L152 480l0 32-64 0 0-32 0-128-16 0 0 128 0 32L8 512l0-32L8 320s0 0 0 0l0-32L8 160l0-32z']
      
    ]
  };

  

  
  

  var faSquareTerminal = {
    prefix: 'fasds',
    iconName: 'square-terminal',
    icon: [
      448,
      512,
      [],
      'e32a',
      
      ['M0 32l448 0 0 448L0 480 0 32zM62.1 176l17 17 63 63L79 319l-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c26.7-26.7 53.3-53.3 80-80c5.7-5.7 11.3-11.3 17-17l-17-17-80-80-17-17C84.7 153.4 73.4 164.7 62.1 176zM192 336c0 16 0 32 0 48l24 0 144 0 24 0 0-48-24 0-144 0-24 0z','M79 193l-17-17L96 142.1l17 17 80 80 17 17-17 17-80 80-17 17L62.1 336l17-17 63-63L79 193zM216 336l144 0 24 0 0 48-24 0-144 0-24 0 0-48 24 0z']
      
    ]
  };

  

  
  

  var faCassetteTape = {
    prefix: 'fasds',
    iconName: 'cassette-tape',
    icon: [
      576,
      512,
      [128429],
      'f8ab',
      
      ['M0 32l576 0 0 448-92.9 0L439 362.4 435.1 352 424 352l-272 0-11.1 0L137 362.4 92.9 480 0 480 0 32zM80 208c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-256 0c-44.2 0-80 35.8-80 80zm47.1 272l36-96 249.8 0 36 96-321.8 0z','M240 208c0 11.4-2.4 22.2-6.7 32l109.3 0c-4.3-9.8-6.7-20.6-6.7-32s2.4-22.2 6.7-32l-109.3 0c4.3 9.8 6.7 20.6 6.7 32zm176 80l-256 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80zM160 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm272-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z']
      
    ]
  };

  

  
  

  var faShieldCross = {
    prefix: 'fasds',
    iconName: 'shield-cross',
    icon: [
      512,
      512,
      [9960],
      'f712',
      
      ['M16.6 113l1.2-20.5L36.9 85 224 12.4c0 49.2 0 98.4 0 147.6c-69 0-138.1 0-207.1 0c-1.1-17.3-1.1-33.2-.3-47zm9 111c66.1 0 132.3 0 198.4 0c0 90.9 0 181.9 0 273.5c-.3-.2-.6-.3-1-.5C136.8 453.4 84.2 383.9 53.9 313.9C40.7 283.6 31.6 253 25.6 224zM288 12.4C350.4 36.6 412.7 60.8 475.1 85l19.2 7.4 1.2 20.5c.8 13.8 .8 29.7-.3 47c-69.1 0-138.1 0-207.1 0c0-49.2 0-98.4 0-147.6zM288 224c66.1 0 132.3 0 198.4 0c-6 29-15.1 59.6-28.3 89.9C427.7 384.1 374.8 453.9 288 497.5c0-91.2 0-182.3 0-273.5z','M288 12.4L267.6 4.5 256 0 244.4 4.5 224 12.4 224 160 16.9 160c1.3 19.8 4 41.4 8.7 64L224 224l0 273.5c6.3 3.1 12.7 6.1 19.3 9L256 512l12.7-5.5c6.6-2.9 13-5.9 19.3-9L288 224l198.4 0c4.7-22.6 7.4-44.2 8.7-64L288 160l0-147.6z']
      
    ]
  };

  

  
  

  var fa8 = {
    prefix: 'fasds',
    iconName: '8',
    icon: [
      320,
      512,
      [],
      '38',
      
      ['M304 160c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288l15.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l15.9 0c0 0 .1 0 .1 0l32 0c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0l-32 0c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z','']
      
    ]
  };

  

  
  

  var faRulerHorizontal = {
    prefix: 'fasds',
    iconName: 'ruler-horizontal',
    icon: [
      640,
      512,
      [],
      'f547',
      
      ['M0 128l112 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 64 0 0 80 0 16 32 0 0-16 0-80 112 0 0 256L0 384 0 128z','M144 208l0-80-32 0 0 80 0 16 32 0 0-16zm96-80l-32 0 0 80 0 16 32 0 0-16 0-80zm96 80l0-80-32 0 0 80 0 16 32 0 0-16zm96-80l-32 0 0 80 0 16 32 0 0-16 0-80zm96 0l-32 0 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faCoconut = {
    prefix: 'fasds',
    iconName: 'coconut',
    icon: [
      512,
      512,
      [],
      'e2f6',
      
      ['M88.8 299c0 10.4 2.8 18.9 8.7 24.9s14.5 8.7 24.8 8.7c33.4 0 85.9-29 133.5-76.6s76.6-100.2 76.6-133.5c0-10.4-2.8-18.9-8.7-24.9c-25-25-95.9 5.4-158.4 67.9C117.8 213.1 88.8 265.7 88.8 299z','M274.5 55.3c42.7-13.2 71.9-7.4 86.7 7.5s20.6 44 7.5 86.7c-12.8 41.5-42.1 89.6-85.8 133.3s-91.8 73-133.3 85.8c-42.7 13.2-71.9 7.4-86.7-7.5s-20.6-44-7.5-86.7c12.8-41.5 42.1-89.6 85.8-133.3s91.8-73 133.3-85.8zM395.1 28.8C361.5-4.8 309.5-5.8 260.3 9.4c-50.4 15.6-105 49.7-153.1 97.8S25 209.9 9.4 260.3C-5.8 309.5-4.8 361.5 28.8 395.1l41 41C118.3 484.7 184.2 512 252.9 512c143.1 0 259-116 259-259c0-68.7-27.3-134.6-75.9-183.2l-41-40.9zm24.1 175.8l32 32L462.6 248l-22.6 22.6-11.3-11.3-32-32L385.3 216l22.6-22.6 11.3 11.3zm-56 136l32 32L406.6 384l-22.6 22.6-11.3-11.3-32-32L329.3 352l22.6-22.6 11.3 11.3zm-136 56l32 32L270.6 440l-22.6 22.6-11.3-11.3-32-32L193.3 408l22.6-22.6 11.3 11.3z']
      
    ]
  };

  

  
  

  var faFilm = {
    prefix: 'fasds',
    iconName: 'film',
    icon: [
      512,
      512,
      [127902],
      'f008',
      
      ['M160 96l0 128 192 0 0-128L160 96zm0 192l0 128 192 0 0-128-192 0z','M0 32l512 0 0 448L0 480 0 32zM48 352l0 64 64 0 0-64-64 0zm416 0l-64 0 0 64 64 0 0-64zM48 224l0 64 64 0 0-64-64 0zm416 0l-64 0 0 64 64 0 0-64zM48 96l0 64 64 0 0-64L48 96zm416 0l-64 0 0 64 64 0 0-64zM160 96l0 128 192 0 0-128L160 96zM352 288l-192 0 0 128 192 0 0-128z']
      
    ]
  };

  

  
  

  var faSickle = {
    prefix: 'fasds',
    iconName: 'sickle',
    icon: [
      512,
      512,
      [],
      'f822',
      
      ['M128 181c0 38 11.9 74.7 33.7 105.2L136 312l64 64 24-24 32-32-5.4-13.6c-7-17.4-10.6-36-10.6-54.8l0-9.8C240 165.7 301.7 104 377.8 104c44.1 0 85.5 21.1 111.5 56.8L512 192C512 86 426 0 320 0L309 0C209 0 128 81 128 181z','M64 512L0 448l88-88L64 336l48-48L224 400l-48 48-24-24L64 512z']
      
    ]
  };

  

  
  

  var faRadar = {
    prefix: 'fasds',
    iconName: 'radar',
    icon: [
      512,
      512,
      [],
      'e024',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256l-64 0c0 89.9-61.7 165.3-145.1 186.2C298.2 463.8 279 480 256 480s-42.2-16.2-46.9-37.8c-65.5-16.5-117.7-66.6-137-130.9C49.3 307.6 32 287.8 32 264c0-22.3 15.2-41.1 35.9-46.4C85.7 129.9 163.1 64 256 64c44.4 0 85.2 15 117.7 40.3l45.5-45.5C374.9 22.1 318.1 0 256 0C114.6 0 0 114.6 0 256zm100-35.7c16.5 7.6 28 24.3 28 43.7c0 17.8-9.7 33.4-24.1 41.7c16.5 50.7 57.7 90.3 109.4 104.6c7.9-15.6 24.1-26.2 42.8-26.2s34.8 10.7 42.8 26.2C366.4 391.5 416 329.5 416 256l-64 0c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c17.8 0 34.5 4.8 48.8 13.3c15.4-15.4 30.7-30.7 46.1-46.1C324.3 107.6 291.5 96 256 96c-76.1 0-139.8 53.1-156 124.3z','M489 57l17-17L472 6.1 455 23l-174 174c-7.7-3.3-16.1-5.1-25-5.1c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64c0-8.9-1.8-17.3-5.1-25L489 57z']
      
    ]
  };

  

  
  

  var faPhotoFilmMusic = {
    prefix: 'fasds',
    iconName: 'photo-film-music',
    icon: [
      640,
      512,
      [],
      'e228',
      
      ['M0 96L0 448l289.9 0c4.4-18.3 15.9-33.2 29.7-43.5c6.7-5 14.2-9.2 22.3-12.5L160 392l0-296L0 96zm56 56l48 0 0 48-48 0 0-48zm0 96l48 0 0 48-48 0 0-48zm0 96l48 0 0 48-48 0 0-48zM288 224l0 32 64 0 16 0 0-48.4L499 164c-17-22.7-34-45.3-51-68l-60 80-28-32-72 80zm32 241.3c0 26.5 28.7 48 64 48s64-21.5 64-48l0-150.7 144-48 0 88.2c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48c0-1.5-.1-3-.3-4.4c.2-1.2 .3-2.4 .3-3.6l0-160 0-48 0-33.3-31.6 10.5-192 64L400 232l0 17.3 0 48 0 121.5c-5.1-1-10.5-1.5-16-1.5c-35.3 0-64 21.5-64 48z','M640 0L192 0l0 320 176 0 0-64-16 0-64 0 0-32 72-80 28 32 60-80 51 68 141-47L640 0zM288 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faRollerCoaster = {
    prefix: 'fasds',
    iconName: 'roller-coaster',
    icon: [
      640,
      512,
      [],
      'e324',
      
      ['M104 40l4.3 0c-1.4 .5-2.9 1-4.3 1.5l0-1.5zm0 73.1c13.7-9.7 30.2-15.8 48-16.9L152 456l0 24-48 0 0-24 0-342.9zm96-7.2c7 3.5 13.5 7.8 19.5 12.9c3 2.6 5.8 5.3 8.4 8.3c1.3 1.5 2.6 3 3.8 4.5c.6 .8 1.2 1.6 1.8 2.4c.6 .8 1.2 1.6 1.7 2.4L248 154.7 248 456l0 24-48 0 0-24 0-350.1zm96 117.9c16 23 32 46.1 48 69.1L344 456l0 24-48 0 0-24 0-232.2zm96 128.2c14.2 11.5 30.5 20.2 48 25.6l0 78.4 0 24-48 0 0-24 0-104.1zM488 384l8 0c13.9 0 27.3-2 40-5.6l0 77.6 0 24-48 0 0-24 0-72z','M158.1 96c-52 0-94.1 42.1-94.1 94.1L64 448l0 32L0 480l0-32L0 190.1C0 102.8 70.8 32 158.1 32c51.8 0 100.3 25.4 129.8 67.9l129 185.7c15 21.5 39.5 34.4 65.7 34.4l13.4 0c44.2 0 80-35.8 80-80c0 0 0 0 0 0c0-32.8-19.7-61-48-73.3l0 109.1c-8.5 7.6-19.7 12.2-32 12.2l-13.4 0c-.9 0-1.7 0-2.6-.1l0-127.3c-14.2 1.5-28 5.8-40.7 12.5l-7.3 3.9 0 74.2L357.6 144.2l51.6-27.5C434.7 103.1 463.1 96 492 96l4 0c79.5 0 144 64.5 144 144c0 0 0 0 0 0l0 208 0 32-64 0 0-32 0-88.2c-22.9 15.3-50.4 24.2-80 24.2l-13.4 0c-47.2 0-91.4-23.1-118.3-61.9l-129-185.7C217.7 111.1 188.9 96 158.1 96z']
      
    ]
  };

  

  
  

  var faCorn = {
    prefix: 'fasds',
    iconName: 'corn',
    icon: [
      512,
      512,
      [127805],
      'f6c7',
      
      ['M207.1 113.3c29.7 47.7 41.1 103.6 34.2 157.5c53.9-6.9 109.8 4.5 157.5 34.2c10.4-7.2 17.3-19.3 17.3-32.9c0-5.7-1.2-11.2-3.4-16.1c1.1 .1 2.2 .1 3.4 .1c22.1 0 40-17.9 40-40c0-6.4-1.5-12.4-4.2-17.8c16.3-5 28.2-20.2 28.2-38.2c0-6.4-1.5-12.4-4.2-17.8c16.3-5 28.2-20.2 28.2-38.2c0-11.4-4.8-21.8-12.5-29.1C503.7 68.1 512 55 512 40c0-22.1-17.9-40-40-40c-15 0-28.1 8.3-34.9 20.5C429.8 12.8 419.4 8 408 8c-18 0-33.2 11.8-38.2 28.2C364.4 33.5 358.4 32 352 32c-18 0-33.2 11.8-38.2 28.2C308.4 57.5 302.4 56 296 56c-22.1 0-40 17.9-40 40c0 1.1 0 2.3 .1 3.4C251.2 97.2 245.7 96 240 96c-13.6 0-25.7 6.8-32.9 17.3z','M139.9 82.5L112 208 0 320v64l28.7 28.7 73.6-73.6c30.4-30.4 66.9-50.9 105.5-61.6c11.8-65-7.4-134.4-57.5-184.6L139.9 82.5zM51.3 435.3L128 512h64L304 400l125.5-27.9-10.4-10.4c-52.6-52.6-126.4-71.2-194-55.6c-36.7 8.5-71.5 27-100.1 55.6L51.3 435.3z']
      
    ]
  };

  

  
  

  var faFaceKissBeam = {
    prefix: 'fasds',
    iconName: 'face-kiss-beam',
    icon: [
      512,
      512,
      [128537,"kiss-beam"],
      'f597',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm120-24c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm116.1 71l3.9-15c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-1.3-5-2.6-10-3.7-15.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-1.2-.7c0-4.6 0-9.3 0-14c.1 0 .1-.1 .5-.3l.6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3c-.2-.1-.3-.2-.7-.4zM280 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M120 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z']
      
    ]
  };

  
    var faKissBeam = faFaceKissBeam;
  

  
  

  var faSquareUpRight = {
    prefix: 'fasds',
    iconName: 'square-up-right',
    icon: [
      448,
      512,
      [8599,"external-link-square-alt"],
      'f360',
      
      ['M0 32l448 0 0 448L0 480 0 32zM112 312l56 56 76-76 52 52 24-24 0-160-160 0-24 24 52 52-76 76z','M296 344l24-24 0-160-160 0-24 24 52 52-76 76 56 56 76-76 52 52z']
      
    ]
  };

  
    var faExternalLinkSquareAlt = faSquareUpRight;
  

  
  

  var faDropletPercent = {
    prefix: 'fasds',
    iconName: 'droplet-percent',
    icon: [
      384,
      512,
      ["humidity"],
      'f750',
      
      ['M0 320C0 426 86 512 192 512s192-86 192-192S192 0 192 0S0 214 0 320zm105.4 64c3.8-3.8 7.5-7.5 11.3-11.3c42.7-42.7 85.3-85.3 128-128L256 233.4 278.6 256c-3.8 3.8-7.5 7.5-11.3 11.3c-42.7 42.7-85.3 85.3-128 128c-3.8 3.8-7.5 7.5-11.3 11.3c-7.5-7.5-15.1-15.1-22.6-22.6zM112 264c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 1.2 .4 2.4 .4 2.4c.1 1.2 .1 1.2 .1 2.6c0 .7 0 1.5-.1 2.3c-.1 .8-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24zM224 376c0-13.3 10.7-24 24-24c6.6 0 12.6 2.7 17 7c2.2 2.2 3.9 4.8 5.1 7.6c.6 1.4 1.1 2.9 1.4 4.5c.2 .8 .3 1.6 .4 2.4s.1 1.6 .1 2.6c0 .7 0 1.5-.1 2.3c-.1 .8-.2 1.6-.4 2.4c-.3 1.6-.8 3.1-1.4 4.5c-1.2 2.9-3 5.5-5.1 7.6c-4.3 4.3-10.3 7-17 7c-13.3 0-24-10.7-24-24z','M267.3 267.3L278.6 256 256 233.4l-11.3 11.3-128 128L105.4 384 128 406.6l11.3-11.3 128-128zM160 264a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM272 376a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z']
      
    ]
  };

  
    var faHumidity = faDropletPercent;
  

  
  

  var faFaceBeamHandOverMouth = {
    prefix: 'fasds',
    iconName: 'face-beam-hand-over-mouth',
    icon: [
      512,
      512,
      [129325],
      'e47c',
      
      ['M0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-82.4 0-32 32 0 40 0 21.7 0 51.7-51.7L280 228.1l22.6 22.6 9.4 9.4 16-16 22.6 22.6 22.6 22.6L395.9 312l-16 16 9.4 9.4L411.9 360l-22.6 22.6-9.4 9.4 9.4 9.4L411.9 424l-22.6 22.6-52.3 52.3C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm120-56c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M176 120c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zm160 0c28 0 56 40 56 80c0 0-28-32-56-32s-56 32-56 32c0-40 28-80 56-80zM302.6 296l-11.3 11.3-56 56 9.4 9.4 72-72L328 289.4 350.6 312l-11.3 11.3-72 72 9.4 9.4 56-56L344 337.4 366.6 360l-11.3 11.3-56 56 9.4 9.4 24-24L344 401.4 366.6 424l-11.3 11.3-48.8 48.8C288.7 502 264.4 512 239.2 512c-52.6 0-95.2-42.6-95.2-95.2l0-12.8 0-20 0-29.6 0-20 40 0 0 20 0 15 84.7-84.7L280 273.4 302.6 296z']
      
    ]
  };

  

  
  

  var faHeartCrack = {
    prefix: 'fasds',
    iconName: 'heart-crack',
    icon: [
      512,
      512,
      [128148,"heart-broken"],
      'f7a9',
      
      ['M0 167.8c0 36 14.3 70.5 39.8 96L64 288 256 480 448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-27.6 0-54.4 8.4-76.8 23.8C306.3 79.9 313.1 104 320 128c-32 26.7-64 53.3-96 80c21.3 37.3 42.7 74.7 64 112c-42.7-37.3-85.3-74.7-128-112c26.7-26.7 53.3-53.3 80-80c-21.4-30-42.8-60-64.3-90c-12.8-4-26.3-6-40-6C60.8 32 0 92.8 0 167.8z','M224 208l64 112L160 208l80-80L175.7 38c21 6.5 40.2 18 56 33.7L256 96l24.2-24.2c5.9-5.9 12.3-11.2 19.2-15.9L320 128l-96 80z']
      
    ]
  };

  
    var faHeartBroken = faHeartCrack;
  

  
  

  var faHourglassEnd = {
    prefix: 'fasds',
    iconName: 'hourglass-end',
    icon: [
      384,
      512,
      [8987,"hourglass-3"],
      'f253',
      
      ['M32 64l64 0 0 50.7 96 96 96-96L288 64l64 0 0 64 0 13.3-9.4 9.4L237.3 256 342.6 361.4l9.4 9.4 0 13.3 0 64c-21.3 0-42.7 0-64 0c-64 0-128 0-192 0l-64 0 0-64 0-13.3 9.4-9.4L146.7 256 41.4 150.6 32 141.3 32 128l0-64z','M32 0L0 0 0 64l32 0 320 0 32 0 0-64L352 0 32 0zm0 448L0 448l0 64 32 0 320 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  
    var faHourglass3 = faHourglassEnd;
  

  
  

  var faPeopleGroup = {
    prefix: 'fasds',
    iconName: 'people-group',
    icon: [
      640,
      512,
      [],
      'e533',
      
      ['M0 280L64 384l0 64 128 0 0-64 0-2.5-42-58.9L138 305.9l10.2-17.8 64-112C154.8 176 97.4 176 40 176L0 280zm53.3-4.9L64 247.3l0 45.1L53.3 275.1zM72 88a56 56 0 1 0 112 0A56 56 0 1 0 72 88zm355.7 88c21.4 37.5 42.7 74.8 64.1 112.1L502 305.9 490 322.6l-42 58.9 0 2.5 0 64 128 0 0-64 64-104L600 176l-172.3 0zM456 88a56 56 0 1 0 112 0A56 56 0 1 0 456 88zM576 247.3l10.7 27.8L576 292.4l0-45.1z','M384 96A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 260.7l0 72.7-23.1-32.3L256 260.7zm128 72.7l0-72.7 23.1 40.4L384 333.4zm0 82.6l80-112L400 192l-160 0L176 304l80 112 0 64 128 0 0-64z']
      
    ]
  };

  

  
  

  var faKeyboardLeft = {
    prefix: 'fasds',
    iconName: 'keyboard-left',
    icon: [
      640,
      512,
      [],
      'e1c3',
      
      ['M160 64l0 384 480 0 0-384L160 64zm64 64l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l160 0 0 64-160 0 0-64zm96-192l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm96-96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64zm0 96l64 0 0 64-64 0 0-64z','M224 128l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm32-192l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm32-96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm32-96l0 64 64 0 0-64-64 0zm64 96l-64 0 0 64 64 0 0-64zm-64 96l0 64 64 0 0-64-64 0zM0 256l96 96 32 0 0-192-32 0L0 256z']
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fasds',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      ['','M448 64L0 64l0 64 448 0 0-64zm0 320L0 384l0 64 448 0 0-64z']
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faPrescriptionBottle = {
    prefix: 'fasds',
    iconName: 'prescription-bottle',
    icon: [
      384,
      512,
      [],
      'f485',
      
      ['M32 96l320 0 0 416L32 512l0-96 112 0 16 0 0-32-16 0L32 384l0-64 112 0 16 0 0-32-16 0L32 288l0-64 112 0 16 0 0-32-16 0L32 192l0-96z','M384 0L0 0 0 96l384 0 0-96zM144 192L32 192l0 32 112 0 16 0 0-32-16 0zm0 96L32 288l0 32 112 0 16 0 0-32-16 0zm0 96L32 384l0 32 112 0 16 0 0-32-16 0z']
      
    ]
  };

  

  
  

  var faSwatchbook = {
    prefix: 'fasds',
    iconName: 'swatchbook',
    icon: [
      512,
      512,
      [],
      'f5c3',
      
      ['M0 416.6l0 .6C0 469.6 42.4 512 94.7 512l1.3 0C46.3 512 5.4 474.2 .5 425.8c-.3-3-.5-6.1-.5-9.2zM64 64l64 0 0 64-64 0 0-64zm0 128l64 0 0 64-64 0 0-64zM96 512c3.3 0 6.6-.2 9.8-.5c24.2-2.5 45.8-13.9 61.2-31c7.7-8.5 14-18.4 18.3-29.3c2.1-5.4 3.8-11.1 4.9-17c.6-2.9 1-5.9 1.3-9c.1-1.5 .3-3 .3-4.6s.1-3.1 .1-4.6l0-230L322 56 457.8 191.8C368.4 281.1 279.1 370.5 189.6 460l-23.5 23.5c-18.2 18.2-43 28.5-68.8 28.5L96 512zm86.8 0l192-192L512 320l0 192-329.2 0z','M192 0L0 0 0 416c0 53 43 96 96 96s96-43 96-96L192 0zM128 64l0 64-64 0 0-64 64 0zM64 192l64 0 0 64-64 0 0-64zM96 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faRectangleVerticalHistory = {
    prefix: 'fasds',
    iconName: 'rectangle-vertical-history',
    icon: [
      576,
      512,
      [],
      'e237',
      
      ['M0 96L0 416l48 0L48 96 0 96zM96 48l0 416 48 0 0-416L96 48z','M192 0H576V512H192V0z']
      
    ]
  };

  

  
  

  var faGrillFire = {
    prefix: 'fasds',
    iconName: 'grill-fire',
    icon: [
      576,
      512,
      [],
      'e5a4',
      
      ['M0 32L0 96c0 89.8 52.9 167.3 129.2 203l-23.1 53.8c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64l74.9 0c-5.4-15.2-8.9-31.3-10.2-48l-72.8 0 22.9-53.4c15.9 3.6 32.3 5.4 49.3 5.4c1.2 0 2.5 0 3.7 0c10.1-44.2 39.2-84.6 68.1-117.9c26.7-30.8 56.6-57.5 88.2-83.1c18.3 14.8 36.2 29.9 53.1 46.1c7.1-21.8 10.9-45 10.9-69.1l0-64L0 32zM120 416a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M256 352c0-89.6 85.3-165.3 128-192l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160zM416 464.2c35.3 0 64-28.7 64-64c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faJoystick = {
    prefix: 'fasds',
    iconName: 'joystick',
    icon: [
      448,
      512,
      [128377],
      'f8c5',
      
      ['M64 320l64 0 0 32-64 0 0-32zM192 219.4c5.1 1.5 10.3 2.7 15.6 3.5c2.7 .4 5.4 .7 8.1 .9s5.5 .3 8.3 .3c11.1 0 21.9-1.6 32-4.6L256 352l-64 0 0-132.6z','M336 112a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM176 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM448 512l0-160L0 352 0 512l448 0z']
      
    ]
  };

  

  
  

  var faLaptopCode = {
    prefix: 'fasds',
    iconName: 'laptop-code',
    icon: [
      640,
      512,
      [],
      'f5fc',
      
      ['M0 384l0 48 48 48 544 0 48-48 0-48L0 384zM64 32l0 32 0 288 64 0 0-256 384 0 0 256 64 0 0-288 0-32-32 0L96 32 64 32z','M512 96L128 96l0 256 384 0 0-256zM281 193l-31 31 31 31 17 17L264 305.9l-17-17-48-48-17-17 17-17 48-48 17-17L297.9 176l-17 17zM393 159l48 48 17 17-17 17-48 48-17 17L342.1 272l17-17 31-31-31-31-17-17L376 142.1l17 17z']
      
    ]
  };

  

  
  

  var faTruckUtensils = {
    prefix: 'fasds',
    iconName: 'truck-utensils',
    icon: [
      640,
      512,
      [],
      'e628',
      
      ['M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M0 0L416 0l0 96 64 0 13.3 0 9.4 9.4 96 96 9.4 9.4 0 13.3 0 32 0 32 0 64 32 0 0 64-32 0-32 0-1.1 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96l-66.3 0c-7.8-54.3-54.4-96-110.9-96s-103.1 41.7-110.9 96L0 416 0 0zM416 256l128 0 0-18.7L466.7 160 416 160l0 96zM81.2 151.7c-.8 4.8-1.2 9.6-1.2 14.5c0 27.9 21 50.9 48 54.2l0 51.6 0 16 32 0 0-16 0-51.6c27-3.2 48-26.3 48-54.2c0-4.9-.4-9.7-1.2-14.5L192 64l-16 0-5.3 94.9-10.7 0L152 64l-16 0-8 94.9-10.7 0L112 64 96 64 81.2 151.7zM320 112l0-48-12 0s-52 20.2-52 90.9l0 69 32 0 0 80 0 16 32 0 0-16 0-80 0-96 0-16z']
      
    ]
  };

  

  
  

  var faFileCircleQuestion = {
    prefix: 'fasds',
    iconName: 'file-circle-question',
    icon: [
      576,
      512,
      [],
      'e4ef',
      
      ['M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0z','M384 160L224 0l0 160 160 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zM409.6 280l40.5 0c25.4 0 45.9 20.6 45.9 45.9c0 17.1-9.5 32.7-24.5 40.6L448 378.9l0 13.1-32 0 0-16 0-6.8 0-9.7 8.6-4.5 32-16.8c4.6-2.4 7.4-7.2 7.4-12.3c0-7.7-6.2-13.9-13.9-13.9l-40.5 0c-5.3 0-9.6 4.3-9.6 9.6l0 6.4-32 0 0-6.4c0-23 18.6-41.6 41.6-41.6zM448 416l0 32-32 0 0-32 32 0z']
      
    ]
  };

  

  
  

  var faHeartHalfStroke = {
    prefix: 'fasds',
    iconName: 'heart-half-stroke',
    icon: [
      512,
      512,
      ["heart-half-alt"],
      'e1ac',
      
      ['M256 96c0 30.2 0 60.4 0 90.5l45.3-45.3L325.5 117c13.5-13.5 31.7-21 50.7-21c39.6 0 71.8 32.1 71.8 71.8c0 19-7.6 37.3-21 50.7l-24.2 24.2L256 389.5c0 30.2 0 60.3 0 90.5c15.1-15.1 30.2-30.2 45.3-45.2L448 288l24.2-24.2c25.5-25.5 39.8-60 39.8-96C512 92.8 451.2 32 376.2 32c-36 0-70.5 14.3-96 39.8C272.2 79.9 264.1 87.9 256 96z','M39.8 263.8L256 480V96L231.8 71.8c-25.5-25.5-60-39.8-96-39.8C60.8 32 0 92.8 0 167.8c0 36 14.3 70.5 39.8 96z']
      
    ]
  };

  
    var faHeartHalfAlt = faHeartHalfStroke;
  

  
  

  var faSquareCaretDown = {
    prefix: 'fasds',
    iconName: 'square-caret-down',
    icon: [
      448,
      512,
      ["caret-square-down"],
      'f150',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96 192l256 0 0 32L224 352 96 224l0-32z','M96 192v32L224 352 352 224V192H96z']
      
    ]
  };

  
    var faCaretSquareDown = faSquareCaretDown;
  

  
  

  var faCompass = {
    prefix: 'fasds',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 384l64-192 192-64L320 320 128 384z','M192 192L128 384l192-64 64-192L192 192zm64 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faBird = {
    prefix: 'fasds',
    iconName: 'bird',
    icon: [
      512,
      512,
      [],
      'e469',
      
      ['M162.1 407.4c18.7 5.4 38.5 8.4 58.9 8.6l50.2 94.8 .7 1.2-54.3 0L162.1 407.4zm99 5.6c16.4-2.7 32.2-7.3 47.2-13.4l58.9 111.2 .7 1.2-54.3 0-52.4-99.1zm186.3-328L512 128l-64 42.7L448 96c0-3.8-.2-7.4-.6-11.1z','M0 160l0 32C0 315.7 100.3 416 224 416s224-100.3 224-224l0-96c0-53-43-96-96-96s-96 43-96 96l0 64L0 160zM352 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faHelicopter = {
    prefix: 'fasds',
    iconName: 'helicopter',
    icon: [
      640,
      512,
      [128641],
      'f533',
      
      ['M128 0l0 64 192 0 0 64 64 0 0-64 192 0 0-64L128 0zm96 448l0 64 384 0 32 0 0-32 0-64-64 0 0 32-352 0z','M384 384l-96 0L192 256 32 192 0 64l64 0 48 64 272 0 32 0c88.4 0 160 71.6 160 160l0 64 0 32-32 0-160 0zm0-64l128 0 0-32c0-53-43-96-96-96l-32 0 0 128z']
      
    ]
  };

  

  
  

  var faSquareMinus = {
    prefix: 'fasds',
    iconName: 'square-minus',
    icon: [
      448,
      512,
      [61767,"minus-square"],
      'f146',
      
      ['M0 32L0 480l448 0 0-448L0 32zM128 232l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z','M128 232l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  
    var faMinusSquare = faSquareMinus;
  

  
  

  var faHouseFire = {
    prefix: 'fasds',
    iconName: 'house-fire',
    icon: [
      640,
      512,
      [],
      'e50c',
      
      ['M0 240l0 47.6 64.1 0 0 224.4L224 512l0-160 32 0 32 0c.1-56.8 36.1-108.7 71.8-149.9c24.3-28 51.2-52.6 79.6-76.1L288.4 0 0 240z','M320 352c0-89.6 85.3-165.3 128-192l64 64 32-32c76.8 64 96 133.3 96 160c0 88.4-71.6 160-160 160s-160-71.6-160-160zM480 464.2c35.3 0 64-28.7 64-64c0-48-64-96-64-96s-64 48-64 96c0 35.3 28.7 64 64 64z']
      
    ]
  };

  

  
  

  var faEmptySet = {
    prefix: 'fasds',
    iconName: 'empty-set',
    icon: [
      512,
      512,
      [216,8709],
      'f656',
      
      ['M32 256c0 50.3 16.6 96.8 44.6 134.1l45.9-45.9C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5c15.3-15.3 30.6-30.6 45.9-45.9C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256zm89.9 179.4c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1l-45.9 45.9C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5c-15.3 15.3-30.6 30.6-45.9 45.9z','M502.6 54.6l-448 448L9.4 457.4l448-448 45.3 45.3z']
      
    ]
  };

  

  
  

  var faStarAndCrescent = {
    prefix: 'fasds',
    iconName: 'star-and-crescent',
    icon: [
      512,
      512,
      [9770],
      'f699',
      
      ['M247 219.5l68.5 66.7-16.2 94.2L384 336l84.6 44.5-16.2-94.2L521 219.5l-94.6-13.8L384 120l-42.3 85.8L247 219.5z','M446.6 85.1C413 61.7 372.1 48 328 48c-114.9 0-208 93.1-208 208s93.1 208 208 208c44.1 0 85-13.7 118.6-37.1C399.8 479.1 331.7 512 256 512C114.6 512 0 397.4 0 256S114.6 0 256 0c75.7 0 143.8 32.9 190.6 85.1z']
      
    ]
  };

  

  
  

  var faReply = {
    prefix: 'fasds',
    iconName: 'reply',
    icon: [
      512,
      512,
      [61714,"mail-reply"],
      'f3e5',
      
      ['M224 128l112 0c97.2 0 176 78.8 176 176c0 128-128 176-128 176s32-32 32-80c0-61.9-50.1-112-112-112l-80 0 0-160z','M192 384L0 208 192 32l32 0 0 352-32 0z']
      
    ]
  };

  
    var faMailReply = faReply;
  

  
  

  var faMeat = {
    prefix: 'fasds',
    iconName: 'meat',
    icon: [
      512,
      512,
      [127830],
      'f814',
      
      ['M0 380c0 33.1 26.9 60 60 60l12 0 0 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-16.2-6.4-30.9-16.8-41.7L201.5 384 176 384l-48-48 0-25.5-26.4 26.3C90.9 326.4 76.2 320 60 320c-33.1 0-60 26.9-60 60zM332.4 124.4c-8.9 8.9-3.8 28.5 11.5 43.8s34.9 20.4 43.8 11.5c3-3 4.4-7.1 4.4-11.9c0-9.6-5.7-21.7-15.9-31.9s-22.3-15.9-31.9-15.9c-4.8 0-8.9 1.4-11.9 4.4z','M243.6 19.6C283.7-20.4 371.9 2.8 440.5 71.5s91.9 156.8 51.8 196.9l-40.5 40.5C403.9 357 338.7 384 270.7 384L176 384l-48-48 0-94.7c0-67.9 27-133 75-181l40.7-40.7zm64 184.8c49.6 49.6 113.3 66.4 142.2 37.4s12.2-92.6-37.4-142.2S299.1 33.2 270.2 62.2s-12.2 92.6 37.4 142.2z']
      
    ]
  };

  

  
  

  var faClover = {
    prefix: 'fasds',
    iconName: 'clover',
    icon: [
      448,
      512,
      [],
      'e139',
      
      ['M120.9 126.9L160 192 94.9 152.9C85.1 147.1 74 144 62.6 144C28 144 0 172 0 206.6V224l32 32L0 288v17.4C0 340 28 368 62.6 368c11.4 0 22.5-3.1 32.2-8.9L160 320l-39.1 65.1c-5.8 9.7-8.9 20.9-8.9 32.2c0 34.6 28 62.6 62.6 62.6H192l32-32 32 32h17.4c34.6 0 62.6-28 62.6-62.6c0-11.4-3.1-22.5-8.9-32.2L288 320l65.1 39.1c9.7 5.8 20.9 8.9 32.2 8.9c34.6 0 62.6-28 62.6-62.6V288l-32-32 32-32V206.6c0-34.6-28-62.6-62.6-62.6c-11.4 0-22.5 3.1-32.2 8.9L288 192l39.1-65.1c5.8-9.7 8.9-20.9 8.9-32.2C336 60 308 32 273.4 32H256L224 64 192 32H174.6C140 32 112 60 112 94.6c0 11.4 3.1 22.5 8.9 32.2z','']
      
    ]
  };

  

  
  

  var faUsersSlash = {
    prefix: 'fasds',
    iconName: 'users-slash',
    icon: [
      640,
      512,
      [],
      'e073',
      
      ['M0 320l235.3 0c-20.6-18.2-35.3-42.8-40.8-70.8L121.8 192 48 192 0 320zM76.7 36.8c42 32.6 83.9 65.2 125.9 97.7C215.9 120.2 224 101.1 224 80c0-44.2-35.8-80-80-80C115.7 0 90.9 14.6 76.7 36.8zM128 512l384 0-5-16.5L324.9 352 176 352 128 512zM243.4 166.2c50.6 39.2 101.1 78.5 151.7 117.7c13.1-16.4 21-37.2 21-59.9c0-53-43-96-96-96c-31.3 0-59.1 15-76.6 38.2zM420.3 303.5c7.1 5.5 14.1 11 21.2 16.5L640 320 592 192l-148 0c2.6 10.2 4 21 4 32c0 30.1-10.4 57.7-27.7 79.5zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faStarSharpHalf = {
    prefix: 'fasds',
    iconName: 'star-sharp-half',
    icon: [
      576,
      512,
      [],
      'e28c',
      
      ['M288 .2l0 391L454.3 512 390.8 316.4 557.1 195.6l-205.6 0L288 .2z','M288 391.2l0-391L224.5 195.6l-205.6 0L185.2 316.4 121.7 512 288 391.2z']
      
    ]
  };

  

  
  

  var faPickleball = {
    prefix: 'fasds',
    iconName: 'pickleball',
    icon: [
      576,
      512,
      [],
      'e435',
      
      ['M304 384a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm64-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm16-80a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm64 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M528 240L288 0 48 240 96 368 16 448l64 64 80-80 128 48 9.4-9.4c-16.1-25-25.4-54.7-25.4-86.6c0-3.3 .1-6.5 .3-9.8L133.1 235.5l-11.3-11.3 22.6-22.7 11.3 11.3L279.3 336.1C299.7 271.1 360.3 224 432 224c31.9 0 61.6 9.3 86.6 25.4L528 240z']
      
    ]
  };

  

  
  

  var faFaceMask = {
    prefix: 'fasds',
    iconName: 'face-mask',
    icon: [
      576,
      512,
      [],
      'e37f',
      
      ['M32 256.1c0 46.6 12.5 90.3 34.2 127.9l93.8 0c0-23.2 0-46.5 0-69.7L32 256.1zM34.2 222c1.5 .7 2.9 1.3 4.4 2L160 279.2c0-7.7 0-15.4 0-23.2l256 0 0 23.2c40.5-18.4 80.9-36.8 121.4-55.2c1.5-.7 2.9-1.3 4.4-2C525.1 96.7 417.9 0 288 0S50.9 96.7 34.2 222zM88.1 416c46.9 58.5 119 96 199.9 96s152.9-37.5 199.9-96L416 416l0 32-256 0c0-10.7 0-21.3 0-32l-71.9 0zm44.5-235.3C146.4 167 184.6 144 240 144l16 0 0 32-16 0c-47 0-77.1 19.7-84.7 27.3l-22.6-22.6zM320 144l16 0c55.4 0 93.6 23 107.3 36.7l-22.6 22.6C413.1 195.7 383 176 336 176l-16 0 0-32zm96 170.3l0 69.7 93.8 0c21.8-37.6 34.2-81.3 34.2-127.9L416 314.3z','M38.6 224l-14.6-6.6L10.8 246.5l14.6 6.6L160 314.3l0 69.7L40 384l0 32 120 0 0 32 256 0 0-32 112 0 0-32-112 0 0-69.7 134.6-61.2 14.6-6.6-13.2-29.1L537.4 224 416 279.2l0-23.2-256 0 0 23.2L38.6 224zM208 304l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0zm0 64l160 0 16 0 0 32-16 0-160 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faTachographDigital = {
    prefix: 'fasds',
    iconName: 'tachograph-digital',
    icon: [
      640,
      512,
      ["digital-tachograph"],
      'f566',
      
      ['M0 64L0 448l640 0 0-384L0 64zm64 64l288 0 0 128L64 256l0-128zm0 160l32 0 0 32-32 0 0-32zm0 64l16 0 256 0 16 0 0 32-16 0L80 384l-16 0 0-32zm64-64l32 0 0 32-32 0 0-32zm64 0l32 0 0 32-32 0 0-32zm64 0l32 0 0 32-32 0 0-32zm64 0l32 0 0 32-32 0 0-32zm64 64l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32z','M352 128L64 128l0 128 288 0 0-128zM80 352l-16 0 0 32 16 0 256 0 16 0 0-32-16 0L80 352zm320 0l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z']
      
    ]
  };

  
    var faDigitalTachograph = faTachographDigital;
  

  
  

  var faMagnifyingGlassArrowRight = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
      512,
      512,
      [],
      'e521',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm96-24c8 0 16 0 24 0c39.4 0 78.7 0 118.1 0c-10.3-10.3-20.7-20.7-31-31c-5.7-5.7-11.3-11.3-17-17c11.3-11.3 22.6-22.6 33.9-33.9c5.7 5.7 11.3 11.3 17 17c24 24 48 48 72 72c5.7 5.7 11.3 11.3 17 17c-5.7 5.7-11.3 11.3-17 17c-24 24-48 48-72 72c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c10.3-10.3 20.7-20.7 31-31c-39.4 0-78.7 0-118.1 0c-8 0-16 0-24 0l0-48z','M241 119l-17-17L190.1 136l17 17 31 31L120 184l-24 0 0 48 24 0 118.1 0-31 31-17 17L224 313.9l17-17 72-72 17-17-17-17-72-72zM441.4 486.6L464 509.3 509.3 464l-22.6-22.6L376 330.7C363.3 348 348 363.3 330.7 376L441.4 486.6z']
      
    ]
  };

  

  
  

  var faSensorTriangleExclamation = {
    prefix: 'fasds',
    iconName: 'sensor-triangle-exclamation',
    icon: [
      640,
      512,
      ["sensor-alert"],
      'e029',
      
      ['M0 32l448 0 0 61.2L237 480 0 480 0 32zM64 96l0 24 0 144 0 24 48 0 0-24 0-144 0-24L64 96zm96 0l0 24 0 144 0 24 48 0 0-24 0-144 0-24-48 0z','M256 512L448 160 640 512l-384 0zM464 288l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16zM432 448l32 0 0-32-32 0 0 32z']
      
    ]
  };

  
    var faSensorAlert = faSensorTriangleExclamation;
  

  
  

  var faUsersMedical = {
    prefix: 'fasds',
    iconName: 'users-medical',
    icon: [
      640,
      512,
      [],
      'f830',
      
      ['M0 320l235.3 0c-26.6-23.5-43.3-57.8-43.3-96c0-11 1.4-21.8 4-32L48 192 0 320zM64 80a80 80 0 1 0 160 0A80 80 0 1 0 64 80zm64 432l352 0 0-32-32 0-32 0 0-32 0-64 0-32-240 0L128 512zm96-288a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm180.7 96l75.3 0 0-32 32 0 64 0 32 0 0 32 32 0L592 192l-148 0c2.6 10.2 4 21 4 32c0 38.2-16.8 72.5-43.3 96zM432 80a80 80 0 1 0 160 0A80 80 0 1 0 432 80z','M576 320l-64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64 64 0 0-64-64 0 0-64z']
      
    ]
  };

  

  
  

  var faMessageImage = {
    prefix: 'fasds',
    iconName: 'message-image',
    icon: [
      512,
      512,
      ["comment-alt-image"],
      'e1e0',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM96 280.5l0 9.1 0 8 0 24 24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136L296 112l-19.6 27.8L219.1 221l-17.1-19.3L184 181.5l-17.9 20.2-64 72L96 280.5zM112 128a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M144 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm171.6-20.2L296 112l-19.6 27.8L219.1 221l-17.1-19.3L184 181.5l-17.9 20.2-64 72L96 280.5l0 9.1 0 8 0 24 24 0 56 0 24 0 48 0 24 0 120 0 24 0 0-24 0-8 0-7.6-4.4-6.2-96-136z']
      
    ]
  };

  
    var faCommentAltImage = faMessageImage;
  

  
  

  var faUserChef = {
    prefix: 'fasds',
    iconName: 'user-chef',
    icon: [
      448,
      512,
      [],
      'e3d2',
      
      ['M96 160l32 0 16 0 160 0 16 0 32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128z','M384 48c0 20.9-13.4 38.7-32 45.3l0 18.7 0 48-32 0-16 0-160 0-16 0-32 0 0-48 0-18.7C77.4 86.7 64 68.9 64 48C64 21.5 85.5 0 112 0c14.3 0 27.2 6.3 36 16.3C156.8 6.3 169.7 0 184 0c16.7 0 31.4 8.5 40 21.5C232.6 8.5 247.3 0 264 0c14.3 0 27.2 6.3 36 16.3C308.8 6.3 321.7 0 336 0c26.5 0 48 21.5 48 48zM128 410.8l224-89.6 0 30.8 48 0 48 160-96 0-224 0 0-101.2zM96 400l0 112L0 512 48 352l48 0 0-32 106.4 26.6-96.4 38.5-10.1 4L96 400zm128 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faTable = {
    prefix: 'fasds',
    iconName: 'table',
    icon: [
      512,
      512,
      [],
      'f0ce',
      
      ['M64 256l0 64 160 0 0 96 64 0 0-96 160 0 0-64-160 0 0-96-64 0 0 96L64 256z','M64 160l0 256 384 0 0-256L64 160zM0 32l64 0 384 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32z']
      
    ]
  };

  

  
  

  var faHyphen = {
    prefix: 'fasds',
    iconName: 'hyphen',
    icon: [
      320,
      512,
      [],
      '2d',
      
      ['M0 224l32 0 256 0 32 0 0 64-32 0L32 288 0 288l0-64z','']
      
    ]
  };

  

  
  

  var faMustache = {
    prefix: 'fasds',
    iconName: 'mustache',
    icon: [
      640,
      512,
      [],
      'e5bc',
      
      ['M36.6 192.4c4.1 12.2 8.1 24.4 12.2 36.6c9.4 28.3 32.9 54.7 58.8 73.8c25.8 19 57.3 33.1 85 33.1c16.4 0 34.4-4.7 50.1-11.2c15.6-6.5 30.6-15.5 40.6-25.5L294.6 288c-7.5-7.5-15.1-15.1-22.6-22.6l-11.3 11.3c-6 6-17 13-30.3 18.5c-13.2 5.5-26.9 8.8-37.8 8.8c-18.2 0-43-9.9-66-26.9c-8.8-6.5-16.8-13.6-23.8-21.1l57.2 0 5.3 0c1.4-1.1 2.8-2.1 4.3-3.2L229.3 208l51 0 27.2 34L320 257.6c4.2-5.2 8.3-10.4 12.5-15.6l27.2-34 51 0 59.7 44.8 4.3 3.2 5.3 0 57.2 0c-7 7.5-15 14.6-23.8 21.1c-23 17-47.9 26.9-66 26.9c-10.9 0-24.6-3.3-37.8-8.8c-13.3-5.5-24.3-12.5-30.3-18.5c-3.8-3.8-7.5-7.5-11.3-11.3L345.4 288l11.3 11.3c10 10 25 19 40.6 25.5C413 331.3 431 336 447.4 336c27.7 0 59.2-14.1 85-33.1c25.9-19.1 49.4-45.6 58.8-73.8c4.1-12.2 8.1-24.4 12.2-36.6l-34.6 17.3c-9.5 4.8-19.1 9.5-28.6 14.3l-54.9 0c-19.9-14.9-39.8-29.9-59.7-44.8c-1.4-1.1-2.8-2.1-4.3-3.2l-5.3 0-64 0-7.7 0c-1.6 2-3.2 4-4.8 6c-6.5 8.1-13 16.3-19.5 24.4c-6.5-8.1-13-16.3-19.5-24.4c-1.6-2-3.2-4-4.8-6l-7.7 0-64 0-5.3 0c-1.4 1.1-2.8 2.1-4.3 3.2c-19.9 14.9-39.8 29.9-59.7 44.8l-54.9 0c-9.5-4.8-19.1-9.5-28.6-14.3c-11.5-5.8-23-11.5-34.5-17.3z','M184 112l8 0 80 0 11 0 7.2 8.4L320 155.1l29.8-34.7L357 112l11 0 80 0 8 0 6.4 4.8 83.6 62.7L604.3 147 640 127.2l0 40.8 0 39.4s0 0 0 0C640 313.8 553.8 400 447.4 400c-46.7 0-91.7-16.9-126.9-47.7l-.5-.4-.5 .4C284.4 383.1 239.3 400 192.6 400C86.2 400 0 313.8 0 207.4c0 0 0 0 0 0L0 168l0-40.8L35.7 147l58.4 32.4 83.5-62.7L184 112zm40 64l-5.3 0-4.3 3.2L154.7 224l-54.9 0L71.2 209.7 36.6 192.4l12.2 36.6c9.4 28.3 32.9 54.7 58.8 73.8c25.8 19 57.3 33.1 85 33.1c16.4 0 34.4-4.7 50.1-11.2c15.6-6.5 30.6-15.5 40.6-25.5L294.6 288 272 265.4l-11.3 11.3c-6 6-17 13-30.3 18.5c-13.2 5.5-26.9 8.8-37.8 8.8c-18.2 0-43-9.9-66-26.9c-8.8-6.5-16.8-13.6-23.8-21.1l57.2 0 5.3 0 4.3-3.2L229.3 208l51 0 27.2 34L320 257.6 332.5 242l27.2-34 51 0 59.7 44.8 4.3 3.2 5.3 0 57.2 0c-7 7.5-15 14.6-23.8 21.1c-23 17-47.9 26.9-66 26.9c-10.9 0-24.6-3.3-37.8-8.8c-13.3-5.5-24.3-12.5-30.3-18.5L368 265.4 345.4 288l11.3 11.3c10 10 25 19 40.6 25.5C413 331.3 431 336 447.4 336c27.7 0 59.2-14.1 85-33.1c25.9-19.1 49.4-45.6 58.8-73.8l12.2-36.6-34.6 17.3L540.2 224l-54.9 0-59.7-44.8-4.3-3.2-5.3 0-64 0-7.7 0-4.8 6L320 206.4 300.5 182l-4.8-6-7.7 0-64 0z']
      
    ]
  };

  

  
  

  var faHockeyPuck = {
    prefix: 'fasds',
    iconName: 'hockey-puck',
    icon: [
      512,
      512,
      [],
      'f453',
      
      ['M0 160c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96S0 107 0 160z','M256 256c141.4 0 256-43 256-96l0 192c0 53-114.6 96-256 96S0 405 0 352L0 160c0 53 114.6 96 256 96z']
      
    ]
  };

  

  
  

  var faToiletsPortable = {
    prefix: 'fasds',
    iconName: 'toilets-portable',
    icon: [
      576,
      512,
      [],
      'e584',
      
      ['M0 64L0 88 0 488l0 24 48 0 0-24 0-8 160 0 0 8 0 24 48 0 0-24 0-400 0-24-24 0L24 64 0 64zM176 224l32 0 0 16 0 64 0 16-32 0 0-16 0-64 0-16zM320 64l0 24 0 400 0 24 48 0 0-24 0-8 160 0 0 8 0 24 48 0 0-24 0-400 0-24-24 0-8 0L352 64l-8 0-24 0zM496 224l32 0 0 16 0 64 0 16-32 0 0-16 0-64 0-16z','M256 0L0 0 0 64l256 0 0-64zM576 0L320 0l0 64 256 0 0-64zM208 224l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16zm320 16l0-16-32 0 0 16 0 64 0 16 32 0 0-16 0-64z']
      
    ]
  };

  

  
  

  var faSunPlantWilt = {
    prefix: 'fasds',
    iconName: 'sun-plant-wilt',
    icon: [
      640,
      512,
      [],
      'e57a',
      
      ['M0 160l76.9 34.4L46.9 273.1l78.7-30.1L160 320l34.4-76.9 78.7 30.1-30.1-78.7L320 160l-76.9-34.4 30.1-78.7L194.4 76.9 160 0 125.6 76.9 46.9 46.9l30.1 78.7L0 160zm224 0A64 64 0 1 1 96 160a64 64 0 1 1 128 0zm-96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M536 144c-17.7 0-32 14.3-32 32l0 96 0 8 0 168 104 0 32 0 0 64-32 0L32 512 0 512l0-64 32 0 424 0 0-168 0-8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 21.4c14.8 7.7 24 23.1 24 44.6c0 19.3-21.5 52.9-48 78c-26.5-25-48-58.4-48-78c0-21.5 9.2-37 24-44.6l0-21.4c0-44.2 35.8-80 80-80c11.4 0 22.2 2.4 32 6.7l0-22.7c0-44.2 35.8-80 80-80s80 35.8 80 80l0 53.4c14.8 7.7 24 23.1 24 44.6c0 19.3-21.5 52.9-48 78c-26.5-25-48-58.4-48-78c0-21.5 9.2-37 24-44.6l0-53.4c0-17.7-14.3-32-32-32z']
      
    ]
  };

  

  
  

  var faListMusic = {
    prefix: 'fasds',
    iconName: 'list-music',
    icon: [
      512,
      512,
      [],
      'f8c9',
      
      ['M0 64l32 0 224 0 32 0 0 64-32 0L32 128 0 128 0 64zM0 192l32 0 224 0 32 0 0 64-32 0L32 256 0 256l0-64zM0 320l32 0 96 0 32 0 0 64-32 0-96 0L0 384l0-64z','M512 44.8L512 .4l-42.1 14-96 32L352 53.7l0 23.1 0 64 0 218.9c-14.5-4.9-30.8-7.7-48-7.7c-61.9 0-112 35.8-112 80s50.1 80 112 80s112-35.8 112-80l0-268.1 74.1-24.7 21.9-7.3 0-23.1 0-64z']
      
    ]
  };

  

  
  

  var faScissors = {
    prefix: 'fasds',
    iconName: 'scissors',
    icon: [
      512,
      512,
      [9984,9986,9988,"cut"],
      'f0c4',
      
      ['M0 112c0 61.9 50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l64-64-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112zm160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm96 208L416 480l64 0 32-32L320 256c-21.3 21.3-42.7 42.7-64 64z','M64 400a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm88.5-104.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L512 64 480 32l-64 0L152.5 295.5z']
      
    ]
  };

  
    var faCut = faScissors;
  

  
  

  var faSquareCaretRight = {
    prefix: 'fasds',
    iconName: 'square-caret-right',
    icon: [
      448,
      512,
      ["caret-square-right"],
      'f152',
      
      ['M0 32L0 480l448 0 0-448L0 32zm160 96l32 0L320 256 192 384l-32 0 0-256z','M160 128l32 0L320 256 192 384l-32 0 0-256z']
      
    ]
  };

  
    var faCaretSquareRight = faSquareCaretRight;
  

  
  

  var faTombstone = {
    prefix: 'fasds',
    iconName: 'tombstone',
    icon: [
      448,
      512,
      [],
      'f720',
      
      ['M32 192l0 256 384 0 0-256C416 86 330 0 224 0S32 86 32 192zm96 0l24 0 48 0 0-40 0-24 48 0 0 24 0 40 48 0 24 0 0 48-24 0-48 0 0 120 0 24-48 0 0-24 0-120-48 0-24 0 0-48z','M248 152l0-24-48 0 0 24 0 40-48 0-24 0 0 48 24 0 48 0 0 120 0 24 48 0 0-24 0-120 48 0 24 0 0-48-24 0-48 0 0-40zM32 448L0 448l0 64 32 0 384 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  

  
  

  var faMarsAndVenusBurst = {
    prefix: 'fasds',
    iconName: 'mars-and-venus-burst',
    icon: [
      640,
      512,
      [],
      'e523',
      
      ['M4.4 215.2L100 236.6l-.4 98L176 273.2l76.4 61.4-.2-49.3C244.3 266.4 240 245.7 240 224c0-3.1 .1-6.1 .3-9.1c.2-3 .4-6 .7-8.9c.7-5.9 1.6-11.7 2.9-17.4c2.6-11.4 6.4-22.3 11.2-32.6c9.7-20.7 23.7-38.9 40.9-53.6l17.6-36.1L218.2 88.5 176 0 133.8 88.5 38.4 66.3l42.9 88.1L4.4 215.2z','M512 0L640 0l0 128-32 32-47-47-25.6 25.6C551 163.3 560 192.6 560 224c0 80.2-59 146.6-136 158.2l0 1.8 0 24 24 0 24 0 0 48-24 0-24 0 0 32 0 24-48 0 0-24 0-32-24 0-24 0 0-48 24 0 24 0 0-24 0-1.8c-77-11.6-136-78-136-158.2c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L527 79 480 32 512 0zM496 224a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z']
      
    ]
  };

  

  
  

  var faFaceAngryHorns = {
    prefix: 'fasds',
    iconName: 'face-angry-horns',
    icon: [
      640,
      512,
      [],
      'e368',
      
      ['M64 256c0-24.8 3.5-48.8 10.1-71.5c16.2-55.9 51-103.9 97.2-136.9C213.2 17.6 264.6 0 320 0s106.8 17.6 148.7 47.6c46.2 33 81 81 97.2 136.9c6.6 22.7 10.1 46.7 10.1 71.5c0 141.4-114.6 256-256 256S64 397.4 64 256zm107.8-21.9c5.1 1.7 10.1 3.4 15.2 5.1c10.3 3.4 20.5 6.8 30.7 10.2c-2.9 2.9-5.2 6.3-6.8 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2c-.1 .6-.1 1.1-.1 1.6c0 .5 0 1 0 1.3l0 .4 0 .4c0 .3 0 .8 0 1.3c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4c3.6 1.2 7.3 2.4 10.9 3.6l15.2 5.1c3.4-10.1 6.7-20.2 10.1-30.4c-5.1-1.7-10.1-3.4-15.2-5.1c-32-10.7-64-21.3-96-32c-5.1-1.7-10.1-3.4-15.2-5.1c-3.4 10.1-6.7 20.2-10.1 30.4zm53.6 167.1l23.8 21.4 10.7-11.9c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7l10.7 11.9 23.8-21.4-10.7-11.9C387.8 371.4 359.7 352 320 352s-67.8 19.4-83.9 37.3l-10.7 11.9zM331.8 245.9l10.1 30.4 15.2-5.1 11.7-3.9c-.1 .8-.2 1.6-.3 2.3s-.1 1.5-.1 2.2c0 .2 0 .3 0 .7c0 .2 0 .6 0 1.1c0 .5 .1 1 .1 1.5c.1 1.1 .3 2.2 .5 3.3c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4c17.7 0 32-14.3 32-32c0-8.9-3.6-17-9.5-22.8c10.1-3.4 20.1-6.7 30.2-10.1l15.2-5.1c-3.4-10.1-6.7-20.2-10.1-30.4l-15.2 5.1-96 32-15.2 5.1z','M0 0C0 80.1 55.6 160.1 74.1 184.5c16.2-55.9 51-103.9 97.2-136.9C57.1 42.8 0 0 0 0zM640 0s-57.1 42.8-171.3 47.6c46.2 33 81 81 97.2 136.9C584.4 160.1 640 80.1 640 0zM240.4 304c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z']
      
    ]
  };

  

  
  

  var faSignPost = {
    prefix: 'fasds',
    iconName: 'sign-post',
    icon: [
      512,
      512,
      [],
      'e624',
      
      ['M224 0l0 64 64 0 0-64L224 0zm0 256l0 256 64 0 0-256-64 0z','M432 64l80 96-80 96H32V64H432z']
      
    ]
  };

  

  
  

  var faPeopleArrows = {
    prefix: 'fasds',
    iconName: 'people-arrows',
    icon: [
      640,
      512,
      ["people-arrows-left-right"],
      'e068',
      
      ['M24 352l40 0 0 160 128 0 0-160 16 0-48-48 67.2-67.2L224 160 32 160 24 352zM64 64a64 64 0 1 0 128 0A64 64 0 1 0 64 64zM412.8 236.8L480 304l-48 48 16 0 0 160 128 0 0-160 40 0-8-192-192 0-3.2 76.8zM448 64a64 64 0 1 0 128 0A64 64 0 1 0 448 64z','M160 304L272 192l0 80 96 0 0-80L480 304 368 416l0-80-96 0 0 80L160 304z']
      
    ]
  };

  
    var faPeopleArrowsLeftRight = faPeopleArrows;
  

  
  

  var faAlbumCollectionCirclePlus = {
    prefix: 'fasds',
    iconName: 'album-collection-circle-plus',
    icon: [
      640,
      512,
      [],
      'e48e',
      
      ['M0 160L40 512l354.8 0c-18.9-13.3-35.1-30.3-47.5-49.9c-26.9 11.4-58 17.9-91.3 17.9C154.4 480 72 419.1 72 344s82.4-136 184-136c45.4 0 86.9 12.1 119 32.2c31.5-29.9 74.2-48.2 121-48.2c4.1 0 8.2 .1 12.3 .4L512 160 0 160zM16 80l0 48 24 0 432 0 24 0 0-48-24 0L40 80 16 80zM32 0l0 48 24 0 400 0 24 0 0-48L456 0 56 0 32 0zM224 352c0 13.3 14.3 24 32 24s32-10.7 32-24s-14.3-24-32-24s-32 10.7-32 24z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 48-48 0-16 0 0 32 16 0 48 0 0 48 0 16 32 0 0-16 0-48 48 0 16 0 0-32-16 0-48 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faSquareRoot = {
    prefix: 'fasds',
    iconName: 'square-root',
    icon: [
      576,
      512,
      [8730],
      'f697',
      
      ['M320 32l-24 0-6.7 23L198.1 367.6 123.6 239.9 114.4 224 96 224l-64 0L0 224l0 64 32 0 45.6 0L180.4 464.1l9.3 15.9 42.4 0 6.7-23L344 96l200 0 32 0 0-64-32 0L320 32z','']
      
    ]
  };

  

  
  

  var faChessRookPiece = {
    prefix: 'fasds',
    iconName: 'chess-rook-piece',
    icon: [
      320,
      512,
      ["chess-rook-alt"],
      'f448',
      
      ['M0 480l48-64 224 0 48 64 0 32L0 512l0-32z','M48 416L72 264 40 224 40 96l56 0 0 48 32 0 0-48 64 0 0 48 32 0 0-48 56 0 0 128-32 40 24 152L48 416zm88-168l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24z']
      
    ]
  };

  
    var faChessRookAlt = faChessRookPiece;
  

  
  

  var faArrowProgress = {
    prefix: 'fasds',
    iconName: 'arrow-progress',
    icon: [
      512,
      512,
      [],
      'e5df',
      
      ['M0 384L0 512l128 0 0-32 32 0 0 32 24 0 72-64-72-64-24 0 0 32-32 0 0-32L0 384zM384 0l0 128 128 0L512 0 384 0z','M256 128l0-32L64 96l0 128 416 0 32 0 0 32 0 192 0 32-32 0-64 0 0 32-128 0 0-128 128 0 0 32 32 0 0-128L32 288 0 288l0-32L0 64 0 32l32 0 224 0 0-32 24 0 72 64-72 64-24 0z']
      
    ]
  };

  

  
  

  var faFileMp3 = {
    prefix: 'fasds',
    iconName: 'file-mp3',
    icon: [
      512,
      512,
      [],
      'e648',
      
      ['M0 0L224 0l0 160 160 0 0 144L80 304l0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM256 368l0-16-16 0-5.6 0-9.6 0-4.5 8.5-28.5 53.8-29.7-54-4.6-8.3-9.5 0-4 0-16 0 0 16 0 128 0 16 32 0 0-16 0-73 18 32.7 14.3 26 13.9-26.2L224 421.8l0 74.2 0 16 32 0 0-16 0-128zm48-16l-16 0 0 16 0 80 0 48 0 16 32 0 0-16 0-32 16 0c30.9 0 56-25.1 56-56s-25.1-56-56-56l-32 0zm32 80l-16 0 0-48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80l-16 0 0 32 16 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0-16 0 0 32 16 0 24 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0-16 0 0 32 16 0 32 0c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32c0-26.5-21.5-48-48-48l-32 0z']
      
    ]
  };

  

  
  

  var faPenRuler = {
    prefix: 'fasds',
    iconName: 'pen-ruler',
    icon: [
      512,
      512,
      ["pencil-ruler"],
      'f5ae',
      
      ['M0 128L105.4 233.4l128-128L195.3 67.3l-56 56L128 134.6 105.4 112l11.3-11.3 56-56L128 0 0 128zM278.6 406.6L384 512 512 384l-44.7-44.7-56 56L400 406.6 377.4 384l11.3-11.3 56-56-38.1-38.1-128 128z','M0 512L32 352 292.7 91.3l128 128L160 480 0 512zM443.3 196.7l-128-128L384 0 512 128l-68.7 68.7z']
      
    ]
  };

  
    var faPencilRuler = faPenRuler;
  

  
  

  var faBellConcierge = {
    prefix: 'fasds',
    iconName: 'bell-concierge',
    icon: [
      512,
      512,
      [128718,"concierge-bell"],
      'f562',
      
      ['M0 400l0 48 24 0 464 0 24 0 0-48-24 0-8 0L32 400l-8 0L0 400zM192 64l0 48 24 0 16 0 0 33.3c7.9-.8 15.9-1.3 24-1.3c2 0 4 0 6.1 .1s4 .1 6 .2c4 .2 8 .5 11.9 1l0-33.3 16 0 24 0 0-48-24 0-40 0-40 0-24 0z','M480 368c0-123.7-100.3-224-224-224S32 244.3 32 368v32H480V368z']
      
    ]
  };

  
    var faConciergeBell = faBellConcierge;
  

  
  

  var faMessagePen = {
    prefix: 'fasds',
    iconName: 'message-pen',
    icon: [
      512,
      512,
      ["comment-alt-edit","message-edit"],
      'f4a4',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM160 304.1l55.3-7.9L300.4 211l-47.3-47.3-85.2 85.2L160 304.1zM275.7 141.1L323 188.4l29.1-29.1L304.8 112l-29.1 29.1z','M352.1 159.4L304.8 112l-29.1 29.1L323 188.4l29.1-29.1zM300.4 211l-47.3-47.3-85.2 85.2L160 304.1l55.3-7.9L300.4 211z']
      
    ]
  };

  
    var faCommentAltEdit = faMessagePen;
  
    var faMessageEdit = faMessagePen;
  

  
  

  var faBadge = {
    prefix: 'fasds',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      ['M340.9 51.1C324.8 20.7 292.8 0 256 0s-68.8 20.7-84.9 51.1C138.2 41 101 49 75 75s-34 63.3-23.9 96.1C20.7 187.2 0 219.2 0 256s20.7 68.8 51.1 84.9C41 373.8 49 411 75 437s63.3 34 96.1 23.9C187.2 491.3 219.2 512 256 512s68.8-20.7 84.9-51.1C373.8 471 411 463 437 437s34-63.3 23.9-96.1C491.3 324.8 512 292.8 512 256s-20.7-68.8-51.1-84.9C471 138.2 463 101 437 75s-63.3-34-96.1-23.9z','']
      
    ]
  };

  

  
  

  var faSunglasses = {
    prefix: 'fasds',
    iconName: 'sunglasses',
    icon: [
      576,
      512,
      [128374],
      'f892',
      
      ['M48 396l152-76 8 0 0 16 0 96L48 432l0-36zm320 0l152-76 8 0 0 32 0 24 0 56-160 0 0-36z','M61 31.9l21.8 3.2 88.7 13.2 23.7 3.5-7 47.5-23.7-3.5L97.6 85.8c-8.4 34.3-15.4 59.6-22.4 84.6c0 0 0 0 0 0l-.3 1c-8.1 29-16.1 57.8-26.2 100.6L232 272l24 0 0 24 0 8 64 0 0-8 0-24 24 0 183.3 0c-10.1-42.8-18.1-71.7-26.2-100.6l-.3-1s0 0 0 0s0 0 0 0s0 0 0 0c-7-25-14-50.3-22.4-84.6l-66.9 9.9-23.7 3.5-7-47.5 23.7-3.5 88.7-13.2L515 31.9l5 21.5c10.5 44.8 18.8 74.3 27.1 104.2l.2 .9c8.5 30.3 17.1 61.2 28 108.1l.6 2.7 0 2.8s0 0 0 0l0 24 0 56 0 24 0 80 0 24-24 0-208 0-24 0 0-24 0-88-64 0 0 88 0 24-24 0L24 480 0 480l0-24 0-80 0-24 0-56 0-24s0 0 0 0l0-2.8 .6-2.7c10.9-46.9 19.5-77.7 28-108.1l.3-.9C37.2 127.7 45.5 98.1 56 53.4l5-21.5zM528 320l-160 0 0 16 0 96 160 0 0-56 0-24 0-32zM48 352l0 24 0 56 160 0 0-96 0-16L48 320l0 32z']
      
    ]
  };

  

  
  

  var faTireFlat = {
    prefix: 'fasds',
    iconName: 'tire-flat',
    icon: [
      512,
      512,
      [],
      'f632',
      
      ['M96 288c0 52.3 25.1 98.8 64 128c26.7 20.1 60 32 96 32c33.1 0 63.9-10.1 89.5-27.3c2.2-1.5 4.4-3.1 6.6-4.7c38.9-29.2 64-75.7 64-128c0-88.4-71.6-160-160-160s-160 71.6-160 160zm32 0c0-36.8 15.5-69.9 40.3-93.3l28.1 38.7 10.1 13.9c-9.1 11-14.5 25.2-14.5 40.6c0 1.4 0 2.7 .1 4l-61.8 20.1c-1.5-7.8-2.3-15.9-2.3-24.2zm12.2 54.6l61.9-20.1c8.6 13.4 22.1 23.4 37.9 27.5l0 65c-44.2-5.5-81.5-33.6-99.8-72.4zm54-166.7C212.5 165.8 233.6 160 256 160s43.5 5.8 61.8 15.9l-38.2 52.6c-7.3-2.9-15.3-4.5-23.6-4.5s-16.3 1.6-23.6 4.5l-10-13.8-28.1-38.8zM288 288a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-16.1 62c15.9-4.1 29.4-14.1 38-27.6l61.9 20.1c-18.3 38.8-55.6 66.9-99.8 72.4l0-65zm33.5-102.6l38.2-52.6C368.5 218.1 384 251.2 384 288c0 8.3-.8 16.3-2.3 24.2L319.9 292c.1-1.3 .1-2.7 .1-4c0-15.4-5.5-29.6-14.5-40.6z','M0 288C0 146.6 114.6 32 256 32s256 114.6 256 256c0 47.9-13.2 92.8-36.1 131.1L512 448l0 64L0 512l0-64 36.1-28.9C13.2 380.8 0 335.9 0 288zm416 0c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 52.3 25.1 98.8 64 128c26.7 20.1 60 32 96 32c33.1 0 63.9-10.1 89.5-27.3c2.2-1.5 4.4-3.1 6.6-4.7c38.9-29.2 64-75.7 64-128zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faTreeChristmas = {
    prefix: 'fasds',
    iconName: 'tree-christmas',
    icon: [
      448,
      512,
      [127876],
      'f7db',
      
      ['M0 480l0 32 448 0 0-32L368 352l56 0 0-32L252.6 105.7c-.6 .3-1.3 .6-1.9 1c-8.9 17.8-17.8 35.6-26.7 53.3c-8.9-17.8-17.8-35.6-26.7-53.3c-.6-.3-1.3-.6-1.9-.9L24 320l0 32 56 0L0 480zM184 288a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 128c0-.4 0-.8 0 0z','M144 81.3l53.3-28L224 0l26.7 53.3L304 80l-53.3 26.7L224 160l-26.7-53.3L144 81.3zM288 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faMotorcycle = {
    prefix: 'fasds',
    iconName: 'motorcycle',
    icon: [
      640,
      512,
      [127949],
      'f21c',
      
      ['M0 352c0-70.7 57.3-128 128-128c62.5 0 114.5 44.8 125.8 104l-66.4 0c-9.5-23.5-32.5-40-59.3-40c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l66.4 0C242.5 435.2 190.5 480 128 480C57.3 480 0 422.7 0 352zm384 0c0-40 18.4-75.7 47.1-99.2c10.5 19.5 21.1 38.9 31.6 58.4C453.5 322.3 448 336.5 448 352c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-2.4 0-4.8 .1-7.1 .4c-10.5-19.5-21.1-39-31.6-58.4c12.2-3.9 25.2-6 38.7-6c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128z','M280 32l-24 0 0 48 24 0 57.7 0 16.4 30.3L256 192l-64-64L32 128l0 64 96 0c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32l70.4 0c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l75.2 139.2 42.2-22.8L418.2 128l93.8 0 0-96-64 0L391.7 78.9 373.1 44.6 366.3 32 352 32l-72 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faChartBullet = {
    prefix: 'fasds',
    iconName: 'chart-bullet',
    icon: [
      512,
      512,
      [],
      'e0e1',
      
      ['M160 64l0 64 80 0 0-64-80 0zm0 96l0 64 80 0 0-64-80 0zm96 128l0 64 80 0 0-64-80 0zm0 96l0 64 80 0 0-64-80 0zM288 64l0 64 160 0 0 32-160 0 0 64 160 0 64 0 0-64 0-32 0-64-64 0L288 64zm96 224l0 64 64 0 0 32-64 0 0 64 64 0 64 0 0-64 0-32 0-64-64 0-64 0z','M288 32l-48 0 0 24 0 176 0 24 48 0 0-24 0-176 0-24zM160 64L0 64 0 224l160 0 0-160zm96 224L0 288 0 448l256 0 0-160zm128-8l0-24-48 0 0 24 0 176 0 24 48 0 0-24 0-176z']
      
    ]
  };

  

  
  

  var faStarChristmas = {
    prefix: 'fasds',
    iconName: 'star-christmas',
    icon: [
      512,
      512,
      [],
      'f7d4',
      
      ['M54.1 88l17 17 48 48 17 17L169.9 136l-17-17L105 71l-17-17L54.1 88zm0 336L88 457.9l17-17 48-48 17-17L136 342.1l-17 17L71 407l-17 17zm288-288L376 169.9l17-17 48-48 17-17L424 54.1 407 71l-48 48-17 17zm0 240l17 17 48 48 17 17L457.9 424l-17-17-48-48-17-17L342.1 376z','M192 320L0 256l192-64L256 0l64 192 192 64L320 320 256 512 192 320z']
      
    ]
  };

  

  
  

  var faCircleC = {
    prefix: 'fasds',
    iconName: 'circle-c',
    icon: [
      512,
      512,
      [],
      'e101',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128 0c0-70.7 57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L324 213.8c-14.2-22.8-39.3-37.8-68-37.8c-44.2 0-80 35.8-80 80s35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C342.2 359.8 301.9 384 256 384c-70.7 0-128-57.3-128-128z','M256 176c-44.2 0-80 35.8-80 80s35.8 80 80 80c28.7 0 53.8-15.1 68-37.8l40.8 25.4C342.2 359.8 301.9 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c45.9 0 86.2 24.2 108.7 60.5L324 213.8c-14.2-22.8-39.3-37.8-68-37.8z']
      
    ]
  };

  

  
  

  var faBoxTissue = {
    prefix: 'fasds',
    iconName: 'box-tissue',
    icon: [
      512,
      512,
      [],
      'e05b',
      
      ['M0 224L0 384l512 0 0-160-106.7 0L384 288l64 0 0 32-74.7 0-238.2 0L64 320l0-32 64 0c-4.7-21.3-9.5-42.7-14.2-64L0 224z','M64 0L208 0c40 0 52 24 64 48s24 48 64 48l112 0L373.3 320l-238.2 0L64 0zM512 384l0 128L0 512 0 384l512 0z']
      
    ]
  };

  

  
  

  var faMicrophoneSlash = {
    prefix: 'fasds',
    iconName: 'microphone-slash',
    icon: [
      640,
      512,
      [],
      'f131',
      
      ['M144 209.5l0 6.5 0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0-24 0 0 48 24 0 72 0 72 0 24 0 0-48-24 0-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7-48-37.8zM224 0l0 151.1 184.1 143c5.1-11.7 7.9-24.6 7.9-38.1L416 0 224 0zM434 314.2c12.8 9.9 25.6 19.9 38.4 29.8c15-25.9 23.6-56 23.6-88l0-40 0-24-48 0 0 24 0 40c0 21-5 40.7-14 58.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faBinoculars = {
    prefix: 'fasds',
    iconName: 'binoculars',
    icon: [
      512,
      512,
      [],
      'f1e5',
      
      ['M96 32l0 64 96 0 0-64L96 32zM224 96l0 160 64 0 0-160-64 0zm96-64l0 64 96 0 0-64-96 0z','M192 480l0-224 32 0 0-160-32 0L64 96 48 256 0 336 0 480l192 0zm128 0l192 0 0-144-48-80L448 96 320 96l-32 0 0 160 32 0 0 224z']
      
    ]
  };

  

  
  

  var faTruckRamp = {
    prefix: 'fasds',
    iconName: 'truck-ramp',
    icon: [
      640,
      512,
      [],
      'f4e0',
      
      ['M448 416a96 96 0 1 0 192 0 96 96 0 1 0 -192 0z','M416.7 402.5C423.4 338.2 477.9 288 544 288c38.2 0 72.5 16.8 96 43.3L640 0 352 0l0 353.8L31.6 441.1 .7 449.5l16.8 61.7 30.9-8.4L416.7 402.5z']
      
    ]
  };

  

  
  

  var faMusicSlash = {
    prefix: 'fasds',
    iconName: 'music-slash',
    icon: [
      640,
      512,
      [],
      'f8d1',
      
      ['M64 432c0 44.2 43 80 96 80s96-35.8 96-80l0-134.3-64-50.4 0 109.3c-10-2.9-20.8-4.6-32-4.6c-53 0-96 35.8-96 80zM192 120.2l0 6.1L315.3 222 512 163l0 129.5c-10-2.9-20.8-4.6-32-4.6c-22 0-42.2 6.2-58.4 16.5L560.1 412.1c10-12.6 15.9-27.8 15.9-44.1l0-248 0-72 0-43L534.8 17.4l-320 96L192 120.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faTableCellsUnlock = {
    prefix: 'fasds',
    iconName: 'table-cells-unlock',
    icon: [
      640,
      512,
      [],
      'e692',
      
      ['M0 32l512 0 0 129.1c-37.8 5.4-69.4 29.6-85.2 62.9L360 224l0 64 24 0 0 64-24 0 0 64 24 0 0 64L0 480 0 32zM64 96l0 64 88 0 0-64L64 96zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM208 96l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zm0 128l0 64 88 0 0-64-88 0zM360 96l0 64 88 0 0-64-88 0z','M528 240c-17.7 0-32 14.3-32 32l0 48 32 0 32 0 48 0 32 0 0 192-224 0 0-192 32 0 0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l-48 0c0-17.7-14.3-32-32-32z']
      
    ]
  };

  

  
  

  var faTrillium = {
    prefix: 'fasds',
    iconName: 'trillium',
    icon: [
      448,
      512,
      [],
      'e588',
      
      ['M-4 120.5s46-28.7 135 14.3c-1 4.2-1.7 8.4-2.2 12.6c-.3 2.1-.4 4.2-.6 6.3c-.1 1.1-.1 2.1-.1 3.2c0 1 0 2 0 3.2l0 .5c0 .5 0 1.4 0 2.2c0 .9 .1 1.8 .1 2.7c.1 1.8 .2 3.6 .4 5.3c.4 3.5 1 7 1.7 10.3c.8 3.4 1.7 6.7 2.8 10c.5 1.6 1.1 3.2 1.8 4.8c.3 .8 .6 1.5 1 2.3s.7 1.5 1.1 2.4c-13.1 1.3-26.1 5.4-38.2 12.4c-8.2 4.8-15.8 10.7-22.7 17.4C-2.3 177.1-4 125.2-4 120.5zM169.1 389.9c4.5-1.3 8.9-2.8 13.2-4.6c2.1-.9 4.2-1.8 6.3-2.9c1-.5 2.1-1 3.1-1.6s2-1.1 3.1-1.7c11.8-6.8 21.7-15.8 29.3-26.1c7.6 10.3 17.4 19.3 29.3 26.1c8 4.6 16.6 8.1 25.7 10.7C271.2 486.9 224 512 224 512s-47.2-25.1-54.9-122.1zm142-189.4c5.7-12.3 8.9-26 8.9-40.5c0-8.1-1-16.3-2.8-24.3C407.4 91.4 454 120.5 454 120.8c0 4.5-1.7 56.9-81.2 110.3c-3.6-3.5-7.3-6.9-11.2-9.9c-2-1.5-4-3-6-4.4s-4.1-2.7-6.3-3.9c-12.1-7-25.1-11.1-38.2-12.4z','M128 160C128 80 224 0 224 0s96 80 96 160c0 14.5-3.2 28.2-8.9 40.5c13.1 1.3 26.1 5.4 38.2 12.4c69.3 40 90.6 163.1 90.6 163.1s-117.3 43.1-186.6 3.1c-11.8-6.8-21.7-15.8-29.3-26.1c-7.6 10.3-17.4 19.3-29.3 26.1C125.4 419.1 8.2 376 8.2 376s21.3-123.1 90.6-163.1c12.1-7 25.1-11.1 38.2-12.4c-5.7-12.3-8.9-26-8.9-40.5zm96 120a40 40 0 1 0 0-80 40 40 0 1 0 0 80z']
      
    ]
  };

  

  
  

  var faBrowsers = {
    prefix: 'fasds',
    iconName: 'browsers',
    icon: [
      576,
      512,
      [],
      'e0cb',
      
      ['M96 192l0 224 480 0 0-224L96 192zM160 64l0 64 64 0 0-64-64 0z','M576 0L96 0l0 192 480 0L576 0zM224 64l0 64-64 0 0-64 64 0zm32 8l256 0 0 48-256 0 0-48zM48 120l0-24L0 96l0 24L0 488l0 24 24 0 432 0 24 0 0-48-24 0L48 464l0-344z']
      
    ]
  };

  

  
  

  var faSprinklerCeiling = {
    prefix: 'fasds',
    iconName: 'sprinkler-ceiling',
    icon: [
      384,
      512,
      [],
      'e44c',
      
      ['M0 472a24 24 0 1 0 48 0A24 24 0 1 0 0 472zm64-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm56-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm56-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 128a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm48-64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm64 64a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z','M0 96l0 26.2 25.7 5.1L128 147.8l0-65.3L64 69.8 64 0 0 0 0 96zm256 51.8l102.3-20.5 25.7-5.1L384 96l0-96L320 0l0 69.8L256 82.6l0 65.3zM224 64l0-32-64 0 0 32 0 128-64 0-32 0 0 64 32 0 96 0 96 0 32 0 0-64-32 0-64 0 0-128z']
      
    ]
  };

  

  
  

  var faGavel = {
    prefix: 'fasds',
    iconName: 'gavel',
    icon: [
      512,
      512,
      ["legal"],
      'f0e3',
      
      ['M0 432l80 80L232 360l-17.4-17.4 88-88c-15.1-15.1-30.2-30.2-45.3-45.3l-88 88L152 280 0 432z','M344 56L320 80 432 192l24-24 56 56L368 368l-56-56 24-24L224 176l-24 24-56-56L288 0l56 56z']
      
    ]
  };

  
    var faLegal = faGavel;
  

  
  

  var faReflectBoth = {
    prefix: 'fasds',
    iconName: 'reflect-both',
    icon: [
      512,
      512,
      [],
      'e66f',
      
      ['M0 96L0 416l32 0L192 256 32 96 0 96zM320 256L480 416l32 0 0-320-32 0L320 256z','M256 192L96 32 96 0 416 0l0 32L256 192zm0 128L416 480l0 32L96 512l0-32L256 320z']
      
    ]
  };

  

  
  

  var faTrashClock = {
    prefix: 'fasds',
    iconName: 'trash-clock',
    icon: [
      576,
      512,
      [],
      'e2b0',
      
      ['M32 96L56 512l274.8 0C285.6 480.1 256 427.5 256 368c0-89.9 67.4-164 154.4-174.7L416 96 32 96z','M144 0L304 0l16 32 128 0 0 64L0 96 0 32l128 0L144 0zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160-80l-32 0 0 16 0 64 0 16 16 0 48 0 16 0 0-32-16 0-32 0 0-48 0-16z']
      
    ]
  };

  

  
  

  var faCartCircleArrowUp = {
    prefix: 'fasds',
    iconName: 'cart-circle-arrow-up',
    icon: [
      640,
      512,
      [],
      'e3f0',
      
      ['M0 0L24 0 96 0l19.9 0 3.7 19.5L122 32l454 0L525.2 194.4c-9.5-1.6-19.3-2.4-29.2-2.4c-68.4 0-127.7 39-156.8 96l-168.5 0 9.1 48 143 0c-1.9 10.4-2.9 21.1-2.9 32c0 5.4 .2 10.7 .7 16L160 384l-19.9 0-3.7-19.5L76.1 48 24 48 0 48 0 0zM224 464a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM428.7 348.7l56-56L496 281.4l11.3 11.3 56 56L574.6 360 552 382.6l-11.3-11.3L512 342.6l0 89.4 0 16-32 0 0-16 0-89.4-28.7 28.7L440 382.6 417.4 360l11.3-11.3z']
      
    ]
  };

  

  
  

  var faTentArrowLeftRight = {
    prefix: 'fasds',
    iconName: 'tent-arrow-left-right',
    icon: [
      576,
      512,
      [],
      'e57f',
      
      ['M64 512l224 0 0-160 96 160 128 0L480 288 288 160 96 288 64 512z','M126.7 35.2l-17 17L89.9 72l396.1 0L466.2 52.2l-17-17L483.2 1.3l17 17L561 79l17 17-17 17-60.8 60.8-17 17-33.9-33.9 17-17L486.1 120 89.9 120l19.8 19.8 17 17L92.8 190.7l-17-17L15 113l-17-17L15 79 75.8 18.2l17-17 33.9 33.9z']
      
    ]
  };

  

  
  

  var faChfSign = {
    prefix: 'fasds',
    iconName: 'chf-sign',
    icon: [
      640,
      512,
      [],
      'e602',
      
      ['M192 32l0 32 0 384 0 32 64 0 0-32 0-160 96 0 0 160 0 32 64 0 0-32 0-384 0-32-64 0 0 32 0 160-96 0 0-160 0-32-64 0z','M80 96c-8.8 0-16 7.2-16 16l0 272 0 16c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16 64 0 0 16c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-16L0 112C0 67.8 35.8 32 80 32s80 35.8 80 80l0 16-64 0 0-16c0-8.8-7.2-16-16-16zM448 32l32 0 128 0 32 0 0 64-32 0-96 0 0 128 64 0 32 0 0 64-32 0-64 0 0 160 0 32-64 0 0-32 0-384 0-32z']
      
    ]
  };

  

  
  

  var faMicrowave = {
    prefix: 'fasds',
    iconName: 'microwave',
    icon: [
      576,
      512,
      [],
      'e01b',
      
      ['M96 128l0 224 320 0 0-224L96 128z','M0 32l576 0 0 416-64 0 0 32-64 0 0-32-320 0 0 32-64 0 0-32L0 448 0 32zm96 96l0 224 320 0 0-224L96 128zm416-16l-32 0 0 256 32 0 0-256z']
      
    ]
  };

  

  
  

  var faHospitalUser = {
    prefix: 'fasds',
    iconName: 'hospital-user',
    icon: [
      576,
      512,
      [],
      'f80d',
      
      ['M0 0L320 0l0 359L253.1 512 0 512 0 384l144 0 16 0 0-32-16 0L0 352l0-64 144 0 16 0 0-32-16 0L0 256 0 0zM96 104l0 48 40 0 0 40 48 0 0-40 40 0 0-48-40 0 0-40-48 0 0 40-40 0z','M432 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM576 512L520 384l-176 0L288 512l288 0z']
      
    ]
  };

  

  
  

  var faFaceFlushed = {
    prefix: 'fasds',
    iconName: 'face-flushed',
    icon: [
      512,
      512,
      [128563,"flushed"],
      'f579',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm232-32A72 72 0 1 1 88 224a72 72 0 1 1 144 0zM176 368l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32zM424 224a72 72 0 1 1 -144 0 72 72 0 1 1 144 0z','M160 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  
    var faFlushed = faFaceFlushed;
  

  
  

  var faSquare3 = {
    prefix: 'fasds',
    iconName: 'square-3',
    icon: [
      448,
      512,
      [],
      'e258',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 128 0 24 0 0 34.6-7.8 7.1-50.8 46.5c41.9 4.8 74.6 40.4 74.6 83.6c0 46.5-37.7 84.2-84.2 84.2l-25.2 0c-32.2 0-61.6-18.2-76-47l-4.2-8.3 42.9-21.5 4.2 8.3c6.3 12.5 19.1 20.4 33 20.4l25.2 0c20 0 36.2-16.2 36.2-36.2c0-20.1-16.3-36.3-36.4-36.2l-51.5 .3-24.1 .1 0-34.7 7.8-7.1L218.3 176 152 176l-24 0 0-48z','M304 128l-24 0-128 0-24 0 0 48 24 0 66.3 0-50.5 46.3-7.8 7.1 0 34.7 24.1-.1 51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2l-25.2 0c-14 0-26.8-7.9-33-20.4l-4.2-8.3-42.9 21.5 4.2 8.3c14.4 28.8 43.8 47 76 47l25.2 0c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5 7.8-7.1 0-34.6z']
      
    ]
  };

  

  
  

  var faTrowelBricks = {
    prefix: 'fasds',
    iconName: 'trowel-bricks',
    icon: [
      512,
      512,
      [],
      'e58a',
      
      ['M0 384l160 0 0 128L0 512 0 384zm192 0l320 0 0 128-320 0 0-128zm96-160l224 0 0 128-224 0 0-128z','M256 256l0-104 88 0 0 24 168 0 0-96L344 80l0 24-88 0L256 0 208 0 0 128 208 256l48 0z']
      
    ]
  };

  

  
  

  var faCloud = {
    prefix: 'fasds',
    iconName: 'cloud',
    icon: [
      640,
      512,
      [9729],
      'f0c2',
      
      ['M0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336L0 480z','']
      
    ]
  };

  

  
  

  var faMessageQuestion = {
    prefix: 'fasds',
    iconName: 'message-question',
    icon: [
      512,
      512,
      [],
      'e1e3',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM168.3 130.3c-.1 .9-.2 1.9-.2 2.8s-.1 1.9-.1 2.5l0 .4c0 2.2 0 4.4 0 6.5l48 0c0-2.2 0-4.4 0-6.5c0-.4 0-.6 0-.8c0-.3 .1-.5 .1-.8c.1-.5 .3-1 .5-1.5c.4-1 1-1.8 1.7-2.5c1.4-1.4 3.4-2.3 5.7-2.3l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1c-14.8 8.5-29.6 17-44.3 25.4c-4 2.3-8 4.6-12.1 6.9c0 4.6 0 9.3 0 13.9c0 7.2 0 14.3 0 21.5c0 8 0 16 0 24l48 0c0-8 0-16 0-24c0-2.5 0-5 0-7.6c10.8-6.2 21.5-12.3 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 80c-15.5 0-29.5 6.3-39.6 16.4c-5.1 5.1-9.2 11.1-12 17.8c-1.4 3.4-2.5 6.9-3.3 10.5c-.4 1.8-.7 3.7-.8 5.5zM232 288c0 16 0 32 0 48l48 0c0-16 0-32 0-48l-48 0z','M224 80c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.9 0c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4L232 188.6l0 13.9 0 21.5 0 24 48 0 0-24 0-7.6 32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1L224 80zm56 208l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faPaw = {
    prefix: 'fasds',
    iconName: 'paw',
    icon: [
      512,
      512,
      [],
      'f1b0',
      
      ['M0 208.4c0 13.2 3.8 27.6 11.6 41.1c18.9 32.4 54 47.3 78.5 33.3s29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3C7.5 173.5 0 189.8 0 208.4zm117.5-77.2c14.3 42.9 52.1 69.1 84.4 58.5s46.9-53.9 32.6-96.8S182.4 23.8 150.1 34.3s-46.9 53.9-32.6 96.8zm160-38.3c-14.3 42.9 .3 86.2 32.6 96.8s70.1-15.6 84.4-58.5s-.3-86.2-32.6-96.8S291.8 50 277.5 92.9zM411.6 198.6c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.8-13.5 11.6-27.8 11.6-41.1c0-18.6-7.5-34.9-21.8-43.1c-24.5-14-59.7 .9-78.5 33.3z','M64 480c0-176 128-256 192-256s192 80 192 256L256 432 64 480z']
      
    ]
  };

  

  
  

  var faTabletScreenButton = {
    prefix: 'fasds',
    iconName: 'tablet-screen-button',
    icon: [
      448,
      512,
      ["tablet-alt"],
      'f3fa',
      
      ['M0 0L448 0l0 512L0 512 0 0zM64 64l0 320 48 0 224 0 48 0 0-320-48 0L112 64 64 64zM192 448a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M64 64H384V384H64V64z']
      
    ]
  };

  
    var faTabletAlt = faTabletScreenButton;
  

  
  

  var faCircleNotch = {
    prefix: 'fasds',
    iconName: 'circle-notch',
    icon: [
      512,
      512,
      [],
      'f1ce',
      
      ['M201.1 71.9C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1l18.3-61.3C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6l18.3 61.3z','']
      
    ]
  };

  

  
  

  var faRainbow = {
    prefix: 'fasds',
    iconName: 'rainbow',
    icon: [
      640,
      512,
      [127752],
      'f75b',
      
      ['M96 352l0 96 0 32 64 0 0-32 0-96c0-88.4 71.6-160 160-160s160 71.6 160 160l0 96 0 32 64 0 0-32 0-96c0-123.7-100.3-224-224-224S96 228.3 96 352z','M64 352C64 210.6 178.6 96 320 96s256 114.6 256 256l0 96 0 32 64 0 0-32 0-96C640 175.3 496.7 32 320 32S0 175.3 0 352l0 96 0 32 64 0 0-32 0-96zm192 0c0-35.3 28.7-64 64-64s64 28.7 64 64l0 96 0 32 64 0 0-32 0-96c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 96 0 32 64 0 0-32 0-96z']
      
    ]
  };

  

  
  

  var faEarthAfrica = {
    prefix: 'fasds',
    iconName: 'earth-africa',
    icon: [
      512,
      512,
      [127757,"globe-africa"],
      'f57c',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-33.2-6.3-65-17.9-94.1c-10 10-20.1 20.1-30.1 30.1c-37.3 0-74.7 0-112 0l0 32c10.7 10.7 21.3 21.3 32 32l0 64-32 0 0 48-48 48-48 0c0-32 0-64 0-96l-96 0c0-29.3 0-58.7 0-88l40-40 88 0c21.3-21.3 42.7-42.7 64-64c-32 0-64 0-96 0l-32 32c-10.7 0-21.3 0-32 0c0-32 0-64 0-96c-13.8-13.8-27.6-27.6-41.4-41.4C61.8 62.8 0 152.2 0 256z','M160 232l0 88 96 0 0 96 48 0 48-48 0-48 32 0 0-64-32-32 0-32 112 0 30.1-30.1C456.6 67.1 364.1 0 256 0c-37.6 0-73.2 8.1-105.4 22.6L192 64l0 96 32 0 32-32 96 0-64 64-88 0-40 40z']
      
    ]
  };

  
    var faGlobeAfrica = faEarthAfrica;
  

  
  

  var faElephant = {
    prefix: 'fasds',
    iconName: 'elephant',
    icon: [
      640,
      512,
      [128024],
      'f6da',
      
      ['M2.1 358.3l43.9 19.5L64 337.1 64 512l128 0 0-102c15.3 3.9 31.4 6 48 6s32.7-2.1 48-6l0 102 128 0 0-171.3c-9.1-10.3-16.6-22.1-22-35c9.8-4.1 19.7-8.3 29.5-12.4C438.1 327.8 472.2 352 512 352c1.4 0 2.8 0 4.2-.1s2.8-.1 4.1-.3c2.7-.2 5.5-.6 8.1-1c5.3-.9 10.5-2.3 15.5-4.1l0-10.5 0-144c0-88.4-71.6-160-160-160l-1.6 0C362.2 12.2 334.5 0 304 0L192 0l0 38 0 74c0 61.9 50.1 112 112 112l16 0 0 32-16 0c-79.5 0-144-64.5-144-144l0-62.6c-13.6 6.3-26.4 14.1-38.1 23.2C67.4 111.8 32 175.8 32 248l0 42.9L2.1 358.3zM480 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 172l0 21.5c0 43.3 35.1 78.5 78.5 78.5c33.8 0 63.8-21.6 74.5-53.7l5.4-16.2-60.7-20.2-5.4 16.2c-2 5.9-7.5 9.9-13.7 9.9c-8 0-14.5-6.5-14.5-14.5l0-21.5c-10.2 2.6-21 4-32 4c-1.4 0-2.8 0-4.1-.1s-2.7-.1-4.1-.2c-2.7-.2-5.4-.4-8.1-.8c-5.3-.7-10.6-1.7-15.7-3zm105.1-18.9c3.3-2.3 6.5-4.7 9.5-7.3c1.5-1.3 3-2.6 4.5-4c.7-.7 1.5-1.4 2.2-2.1c.7-.7 1.4-1.4 2.1-2.1c-5.6 5.7-11.7 10.9-18.3 15.5z','M464 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128c-39.8 0-73.9-24.2-88.5-58.7L394 305.7c19.4 46 64.9 78.3 118 78.3c35.8 0 68.2-14.7 91.4-38.4l11.2-11.4-22.9-22.4-11.2 11.4C563.1 341 538.9 352 512 352z']
      
    ]
  };

  

  
  

  var faSquareB = {
    prefix: 'fasds',
    iconName: 'square-b',
    icon: [
      448,
      512,
      [],
      'e264',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 92 0c42 0 76 34 76 76c0 16.2-5.1 31.3-13.8 43.7C324.3 261.6 336 283.4 336 308c0 42-34 76-76 76l-108 0-24 0 0-24 0-80 0-24 0-24 0-80 0-24zm48 48l0 56 68 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-68 0zm0 104l0 56 84 0c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0-68 0z','M152 128l-24 0 0 24 0 80 0 24 0 24 0 80 0 24 24 0 108 0c42 0 76-34 76-76c0-24.6-11.7-46.4-29.8-60.3c8.7-12.4 13.8-27.4 13.8-43.7c0-42-34-76-76-76l-92 0zm92 104l-68 0 0-56 68 0c15.5 0 28 12.5 28 28s-12.5 28-28 28zm-68 48l68 0 16 0c15.5 0 28 12.5 28 28s-12.5 28-28 28l-84 0 0-56z']
      
    ]
  };

  

  
  

  var faCodePullRequestDraft = {
    prefix: 'fasds',
    iconName: 'code-pull-request-draft',
    icon: [
      448,
      512,
      [],
      'e3fa',
      
      ['M48 160l8 0 48 0 8 0 0 192-8 0-48 0-8 0 0-192zM320 32l96 0 0 96-96 0 0-96zm0 160l96 0 0 96-96 0 0-96z','M104 56l0 48-48 0 0-48 48 0zM56 0L0 0 0 56l0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56L104 0 56 0zm48 408l0 48-48 0 0-48 48 0zM56 352L0 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0zm288 56l48 0 0 48-48 0 0-48zm-56-56l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0z']
      
    ]
  };

  

  
  

  var faW = {
    prefix: 'fasds',
    iconName: 'w',
    icon: [
      576,
      512,
      [119],
      '57',
      
      ['M506.8 32l67.6 0L430.3 458.2 423 480l-47 0-6.7-23L288 178.3 206.7 457 200 480l-47 0-7.4-21.8L1.6 32l67.6 0L173.8 341.4 257.3 55 264 32l48 0 6.7 23 83.5 286.4L506.8 32z','']
      
    ]
  };

  

  
  

  var faGiftCard = {
    prefix: 'fasds',
    iconName: 'gift-card',
    icon: [
      576,
      512,
      [],
      'f663',
      
      ['M0 128L0 320l576 0 0-192-105.6 0c-14.6 28.5-44.2 48-78.4 48l-59.4 0 53.9 64.6 15.4 18.4-36.9 30.7-15.4-18.4L288 197.5l-61.6 73.9-15.4 18.4-36.9-30.7 15.4-18.4L243.4 176 184 176c-1.1 0-2.1 0-3.2-.1s-2.1-.1-3.2-.2c-2.1-.1-4.2-.4-6.2-.7c-4.1-.6-8.1-1.5-12-2.6c-7.8-2.3-15.2-5.6-21.9-9.8c-13.5-8.4-24.6-20.4-31.8-34.7L0 128zM0 416l0 96 576 0 0-96L0 416z','M186.2 48L184 48c-22.1 0-40 17.9-40 40s17.9 40 40 40l73.3 0L222.5 68.8C214.9 55.9 201.1 48 186.2 48zm57.3 128L184 176c-48.6 0-88-39.4-88-88s39.4-88 88-88l2.2 0c31.9 0 61.5 16.9 77.7 44.4l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0L392 0c48.6 0 88 39.4 88 88s-39.4 88-88 88l-59.4 0 53.9 64.6 15.4 18.4-36.9 30.7-15.4-18.4L288 197.5l-61.6 73.9-15.4 18.4-36.9-30.7 15.4-18.4L243.4 176zM392 128c22.1 0 40-17.9 40-40s-17.9-40-40-40l-2.2 0c-14.9 0-28.8 7.9-36.3 20.8L318.7 128l1.3 0 72 0zM576 416L0 416l0-96 576 0 0 96z']
      
    ]
  };

  

  
  

  var faTruckMonster = {
    prefix: 'fasds',
    iconName: 'truck-monster',
    icon: [
      640,
      512,
      [],
      'f63b',
      
      ['M32 352l0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3L46.9 451.9l45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8l0 20.6 64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l14.6-14.6-45.3-45.3-14.6 14.6c-6.7-3.6-13.8-6.6-21.3-8.8l0-20.6-64 0 0 20.6c-7.4 2.2-14.6 5.2-21.3 8.8L92.1 270.9 46.9 316.1l14.6 14.6c-3.6 6.7-6.6 13.8-8.8 21.3L32 352zm176 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm144-32l0 64 20.6 0c2.2 7.4 5.2 14.6 8.8 21.3l-14.6 14.6 45.3 45.3 14.6-14.6c6.7 3.6 13.8 6.6 21.3 8.8l0 20.6 64 0 0-20.6c7.4-2.2 14.6-5.2 21.3-8.8l14.6 14.6 45.3-45.3-14.6-14.6c3.6-6.7 6.6-13.8 8.8-21.3l20.6 0 0-64-20.6 0c-2.2-7.4-5.2-14.6-8.8-21.3l14.6-14.6-45.3-45.3-14.6 14.6c-6.7-3.6-13.8-6.6-21.3-8.8l0-20.6-64 0 0 20.6c-7.4 2.2-14.6 5.2-21.3 8.8l-14.6-14.6-45.3 45.3 14.6 14.6c-3.6 6.7-6.6 13.8-8.8 21.3L352 352zm176 32a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z','M224 0l32 0L384 0l16 0 9.6 12.8L496 128l112 0 0 96 32 0 0 64-32 0c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64l-64 0c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64L0 288l0-64 32 0 0-96 192 0 0-96 0-32zM368 64l-80 0 0 64 128 0L368 64z']
      
    ]
  };

  

  
  

  var faScarecrow = {
    prefix: 'fasds',
    iconName: 'scarecrow',
    icon: [
      448,
      512,
      [],
      'f70d',
      
      ['M128 96c0 11.2 1.9 22 5.5 32c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96zm80-16a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM192 400l0 80 0 32 64 0 0-32 0-80-32 16-32-16zM272 96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M133.5 128L16 128l16 32L0 192l32 32L16 256l112 0L96 416l64-32 64 32 64-32 64 32L320 256l112 0-16-32 32-32-32-32 16-32-117.5 0c-13.2 37.3-48.7 64-90.5 64s-77.4-26.7-90.5-64z']
      
    ]
  };

  

  
  

  var faAlarmSnooze = {
    prefix: 'fasds',
    iconName: 'alarm-snooze',
    icon: [
      512,
      512,
      [],
      'f845',
      
      ['M32 288c0 50.3 16.6 96.8 44.6 134.2L57.4 441.4 34.7 464 80 509.3l22.6-22.6 19.2-19.2c37.4 28 83.8 44.6 134.1 44.6s96.8-16.6 134.2-44.6l19.2 19.2L432 509.3 477.3 464l-22.6-22.6-19.2-19.2c28-37.4 44.6-83.8 44.6-134.2C480 164.3 379.7 64 256 64S32 164.3 32 288zm143.2 96L195 348.3 255.2 240 200 240l-24 0 0-48 24 0 96 0 40.8 0L317 227.7 256.8 336l55.2 0 24 0 0 48-24 0-96 0-40.8 0z','M160.9 25.5C143.8 9.7 120.9 0 95.8 0C42.9 0 0 42.9 0 95.8c0 18.9 5.5 36.5 14.9 51.4L160.9 25.5zm190.3 0L497.1 147.2c9.5-14.8 14.9-32.5 14.9-51.4C512 42.9 469.1 0 416.2 0c-25.1 0-48 9.7-65.1 25.5zM200 192l-24 0 0 48 24 0 55.2 0L195 348.3 175.2 384l40.8 0 96 0 24 0 0-48-24 0-55.2 0L317 227.7 336.8 192 296 192l-96 0z']
      
    ]
  };

  

  
  

  var faSprayCan = {
    prefix: 'fasds',
    iconName: 'spray-can',
    icon: [
      512,
      512,
      [],
      'f5bd',
      
      ['M80 336a80 80 0 1 0 160 0A80 80 0 1 0 80 336zM256 64a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M224 0l0 128L96 128 96 0 224 0zM0 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 256L0 512 0 256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0z']
      
    ]
  };

  

  
  

  var faShishKebab = {
    prefix: 'fasds',
    iconName: 'shish-kebab',
    icon: [
      512,
      512,
      [],
      'f821',
      
      ['M1.4 465.4l45.3 45.3 80-80c-15.1-15.1-30.2-30.2-45.3-45.3l-80 80zm168-168l45.3 45.3 24-24c-15.1-15.1-30.2-30.2-45.3-45.3l-24 24zm112-112l45.3 45.3 66.7-66.7L416 141.3l-22.6-22.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c10.4 10.4 12.2 26.4 5.1 38.6l55.4 32c8.6-14.8 12.8-31.4 12.8-48c0-24.6-9.4-49.1-28.1-67.9c-37.5-37.5-98.3-37.5-135.8 0c-29.6 29.6-35.8 73.6-18.8 109.3l-48 48z','M216 120l-88 88L304 384l88-88L216 120zM104 232L16 320 192 496l88-88L104 232z']
      
    ]
  };

  

  
  

  var faFaceGrinTongueSquint = {
    prefix: 'fasds',
    iconName: 'face-grin-tongue-squint',
    icon: [
      512,
      512,
      [128541,"grin-tongue-squint"],
      'f58a',
      
      ['M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448l0-47.3c-31.9-23.3-55.2-57.8-64-97.9c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29c-8.8 40.2-32.3 75-64.5 98.3l0 46.9c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM112 128l118.9 64L112 256l45.7-64L112 128zm169.1 64L400 128l-45.7 64L400 256 281.1 192z','M112 128l45.7 64L112 256l118.9-64L112 128zm288 0L281.1 192 400 256l-45.7-64L400 128zM320 448l0-64-48 0 0 24-32 0 0-24-48 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64z']
      
    ]
  };

  
    var faGrinTongueSquint = faFaceGrinTongueSquint;
  

  
  

  var faArrowDown91 = {
    prefix: 'fasds',
    iconName: 'arrow-down-9-1',
    icon: [
      576,
      512,
      ["sort-numeric-desc","sort-numeric-down-alt"],
      'f886',
      
      ['M344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 22.6-6.2 44.8-18 64.1L458.3 256l-74.9 0 5.2-8.6 25.1-41.3C373.9 197.7 344 162.3 344 120zm8 168l32 0 48 0 32 0 0 32 0 96 16 0 32 0 0 64-32 0-48 0-48 0-32 0 0-64 32 0 16 0 0-64-16 0-32 0 0-64zm48-168a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M160 480l23.6-25.7 88-96 21.6-23.6L246 291.4 224.4 315 192 350.4l0-285.7 0-32-64 0 0 32 0 285.7L95.6 315 74 291.4 26.8 334.7l21.6 23.6 88 96L160 480z']
      
    ]
  };

  
    var faSortNumericDesc = faArrowDown91;
  
    var faSortNumericDownAlt = faArrowDown91;
  

  
  

  var faCircleCaretDown = {
    prefix: 'fasds',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm128-48l256 0 0 32L256 368 128 240l0-32z','M128 208v32L256 368 384 240V208H128z']
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faCalendarImage = {
    prefix: 'fasds',
    iconName: 'calendar-image',
    icon: [
      448,
      512,
      [],
      'e0d4',
      
      ['M0 192l448 0 0 320L0 512 0 192zM80 448l288 0L256 272 184 376l-24-32L80 448zM96 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M160 0L96 0l0 64L0 64 0 192l448 0 0-128-96 0 0-64L288 0l0 64L160 64l0-64zM80 448l288 0L256 272 184 376l-24-32L80 448z']
      
    ]
  };

  

  
  

  var faCircleM = {
    prefix: 'fasds',
    iconName: 'circle-m',
    icon: [
      512,
      512,
      [],
      'e115',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 128l36.3 0 7.2 9.9L256 255l84.5-117.1 7.2-9.9 36.3 0 0 24 0 208 0 24-48 0 0-24 0-133.8-60.5 83.8L256 337l-19.5-26.9L176 226.2 176 360l0 24-48 0 0-24 0-208 0-24z','M128 128l0 24 0 208 0 24 48 0 0-24 0-133.8 60.5 83.8L256 337l19.5-26.9L336 226.2 336 360l0 24 48 0 0-24 0-208 0-24-36.3 0-7.2 9.9L256 255 171.5 137.9l-7.2-9.9L128 128z']
      
    ]
  };

  

  
  

  var faDialMax = {
    prefix: 'fasds',
    iconName: 'dial-max',
    icon: [
      576,
      512,
      [],
      'e15e',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M417.1 382.8c46.2-62.6 41-151.3-15.7-208c-62.5-62.5-163.8-62.5-226.3 0s-62.5 163.8 0 226.3c56.7 56.7 145.4 62 208 15.7L271.3 304.9l-17-17 33.9-33.9 17 17L417.1 382.8z']
      
    ]
  };

  

  
  

  var faPersonDrowning = {
    prefix: 'fasds',
    iconName: 'person-drowning',
    icon: [
      576,
      512,
      [],
      'e545',
      
      ['M0 423.3l0 64c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9s60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9l0-64c-19.3 0-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1s-38.6-6.1-54-13.1c-15.6-7.1-28.2-16.3-42-26.2c-13.9 9.9-26.4 19.1-42 26.2c-15.4 7-34.7 13.1-54 13.1z','M192 32l0 32 0 120.6 145.4 46.3 167.5-38.1 31.2-7.1 14.2 62.4-31.2 7.1L381.9 286.4l-17.1 94c-7.3-1.8-14.6-4.5-21.5-7.7c-12-5.5-21.7-12.5-35.5-22.5c0 0 0 0 0 0L288 336l-18.6 13.4-1.1 .8s0 0 0 0c-13.9 10-23.6 17-35.5 22.5C219.6 378.7 205 383 192 383c-7.2 0-14.9-1.3-22.5-3.5l18.4-129-37.6-12L128 231.4l0-23.4 0-144 0-32 64 0zm64 96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z']
      
    ]
  };

  

  
  

  var faGrapes = {
    prefix: 'fasds',
    iconName: 'grapes',
    icon: [
      512,
      512,
      [],
      'e306',
      
      ['M320 80c0-40 40-80 40-80s40 32 40 80c0 32-8 40-8 40s8-8 40-8c48 0 80 40 80 40s-40 40-80 40s-55.3-7.3-80-32s-32-40-32-80z','M248 208a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-80-32A56 56 0 1 0 56 176a56 56 0 1 0 112 0zM88 368a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM56 512a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm144-32a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM224 344a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm192-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z']
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fasds',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      ['M32 128l0 352 448 0 0-352L32 128zm128 64l192 0 0 64-192 0 0-64z','M0 32H512v96H0V32z']
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faFaceSmileHorns = {
    prefix: 'fasds',
    iconName: 'face-smile-horns',
    icon: [
      640,
      512,
      [],
      'e391',
      
      ['M64 256c0-24.8 3.5-48.8 10.1-71.5c16.2-55.9 51-103.9 97.2-136.9C213.2 17.6 264.6 0 320 0s106.8 17.6 148.7 47.6c46.2 33 81 81 97.2 136.9c6.6 22.7 10.1 46.7 10.1 71.5c0 141.4-114.6 256-256 256S64 397.4 64 256zm107.8-21.9c5.1 1.7 10.1 3.4 15.2 5.1c10.3 3.4 20.5 6.8 30.7 10.2c-2.9 2.9-5.2 6.3-6.8 10.2c-.8 1.9-1.4 3.9-1.9 6c-.2 1-.4 2.1-.5 3.2c-.1 .5-.1 1.1-.1 1.6c0 .5 0 .9 0 1.5c0 .8 0 1.3 0 1.8c0 .5 .1 1.1 .1 1.6c.1 1.1 .3 2.1 .5 3.2c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4c3.6 1.2 7.3 2.4 10.9 3.6l15.2 5.1c3.4-10.1 6.7-20.2 10.1-30.4c-5.1-1.7-10.1-3.4-15.2-5.1c-32-10.7-64-21.3-96-32c-5.1-1.7-10.1-3.4-15.2-5.1c-3.4 10.1-6.7 20.2-10.1 30.4zm21.9 117C206.3 376.3 248.4 424 320 424s113.7-47.7 126.3-72.8l-28.6-14.3C408.9 354.3 376.4 392 320 392s-88.9-37.7-97.7-55.2l-28.6 14.3zM331.8 245.9l10.1 30.4 15.2-5.1 11.7-3.9c-.1 .8-.2 1.5-.3 2.3s-.1 1.5-.1 2.3c0 .2 0 .3 0 .7c0 .2 0 .6 0 1.1c0 .5 .1 1 .1 1.5c.1 1.1 .3 2.2 .5 3.3c.4 2.1 1.1 4.1 1.9 6c1.6 3.8 4 7.3 6.9 10.2c5.8 5.8 13.8 9.4 22.6 9.4c17.7 0 32-14.3 32-32c0-8.9-3.6-17-9.5-22.8c10.1-3.4 20.1-6.7 30.2-10.1l15.2-5.1c-3.4-10.1-6.7-20.2-10.1-30.4l-15.2 5.1-96 32-15.2 5.1z','M0 0C0 80.1 55.6 160.1 74.1 184.5c16.2-55.9 51-103.9 97.2-136.9C57.1 42.8 0 0 0 0zM640 0s-57.1 42.8-171.3 47.6c46.2 33 81 81 97.2 136.9C584.4 160.1 640 80.1 640 0zM240.4 304c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6 15.2 5.1 10.1-30.4-15.2-5.1-96-32-15.2-5.1-10.1 30.4 15.2 5.1 30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1 15.2-5.1-10.1-30.4-15.2 5.1-96 32-15.2 5.1 10.1 30.4 15.2-5.1 11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z']
      
    ]
  };

  

  
  

  var faToggleOff = {
    prefix: 'fasds',
    iconName: 'toggle-off',
    icon: [
      576,
      512,
      [],
      'f204',
      
      ['M0 64l0 64L0 384l0 64 64 0 448 0 64 0 0-64 0-256 0-64-64 0L64 64 0 64zm64 64l448 0 0 256L64 384l0-256z','M288 160H96V352H288V160z']
      
    ]
  };

  

  
  

  var faDialOff = {
    prefix: 'fasds',
    iconName: 'dial-off',
    icon: [
      576,
      512,
      [],
      'e162',
      
      ['M0 256l0 64 64 0 0-64L0 256zM64 64l0 64 64 0 0-64L64 64zm0 384l0 64 64 0 0-64-64 0zM256 0l0 64 64 0 0-64L256 0zM448 64l0 64 64 0 0-64-64 0zm0 384l0 64 64 0 0-64-64 0zm64-192l0 64 64 0 0-64-64 0z','M312 446.2c77-11.6 136-78 136-158.2c0-88.4-71.6-160-160-160s-160 71.6-160 160c0 80.2 59 146.6 136 158.2L264 288l0-24 48 0 0 24 0 158.2z']
      
    ]
  };

  

  
  

  var faFaceAwesome = {
    prefix: 'fasds',
    iconName: 'face-awesome',
    icon: [
      512,
      512,
      ["gave-dandy"],
      'e409',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm80-72c0-35.3 28.7-64 64-64c3.4 0 6.7 .3 10 .8c22.6 3.5 41.3 18.9 49.5 39.6c2.9 7.3 4.5 15.3 4.5 23.6l0 40L80 224l0-40zM96 288l320 0c-1.4 6.3-2.8 12.7-4.2 19c-5 22.6-14.7 43.2-27.9 60.9C354.5 407.2 307.6 432 256 432c-74.8 0-139.5-51.9-155.8-125L96 288zm176-96c0-39.8 32.2-72 72-72c5.8 0 11.4 .7 16.8 2c22 5.3 40.1 20.6 49.1 40.9c3.9 8.9 6.1 18.8 6.1 29.1l0 32-144 0 0-32z','M154 120.8c22.6 3.5 41.3 18.9 49.5 39.6c-5.6 9.4-15.8 15.6-27.5 15.6c-17.7 0-32-14.3-32-32c0-9.1 3.8-17.4 10-23.2zM360.8 122c22 5.3 40.1 20.6 49.1 40.9c-5.8 8-15.2 13.1-25.9 13.1c-17.7 0-32-14.3-32-32c0-8.5 3.3-16.3 8.8-22zM96 288l320 0-4.2 19c-5 22.6-14.7 43.2-27.9 60.9C370.5 357.9 354 352 336 352c-44.2 0-80 35.8-80 80c-74.8 0-139.5-51.9-155.8-125L96 288z']
      
    ]
  };

  
    var faGaveDandy = faFaceAwesome;
  

  
  

  var faSquareV = {
    prefix: 'fasds',
    iconName: 'square-v',
    icon: [
      448,
      512,
      [],
      'e284',
      
      ['M0 32L0 480l448 0 0-448L0 32zM96.1 144l52.4 0L224 316.2 299.5 144l52.4 0L246 385.6 239.7 400l-31.4 0L202 385.6 96.1 144z','M299.5 144l52.4 0L246 385.6 239.7 400l-31.4 0L202 385.6 96.1 144l52.4 0L224 316.2 299.5 144z']
      
    ]
  };

  

  
  

  var faDrumstick = {
    prefix: 'fasds',
    iconName: 'drumstick',
    icon: [
      512,
      512,
      [127831],
      'f6d6',
      
      ['M0 380c0 33.1 26.9 60 60 60l12 0 0 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-16.2-6.4-30.9-16.8-41.7L233.5 352 208 352l-48-48 0-25.5-58.4 58.3C90.9 326.4 76.2 320 60 320c-33.1 0-60 26.9-60 60z','M160 176V304l48 48H336c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176z']
      
    ]
  };

  

  
  

  var faBroomBall = {
    prefix: 'fasds',
    iconName: 'broom-ball',
    icon: [
      576,
      512,
      ["quidditch","quidditch-broom-ball"],
      'f458',
      
      ['M328 200l48 48L576 48 528 0 328 200zm56 232a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M416 288L288 160l-32 0 0 51.7L364.3 320l51.7 0 0-32zm-74.9 65.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3C79.4 304.6 64 341.8 64 380.5l0 3.5 96-48L0 480l0 32 195.5 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z']
      
    ]
  };

  
    var faQuidditch = faBroomBall;
  
    var faQuidditchBroomBall = faBroomBall;
  

  
  

  var faUp = {
    prefix: 'fasds',
    iconName: 'up',
    icon: [
      384,
      512,
      ["arrow-alt-up"],
      'f357',
      
      ['M128 256l128 0 0 224-128 0 0-224z','M0 224L192 32 384 224l0 32-128 0-128 0L0 256l0-32z']
      
    ]
  };

  
    var faArrowAltUp = faUp;
  

  
  

  var faFence = {
    prefix: 'fasds',
    iconName: 'fence',
    icon: [
      512,
      512,
      [],
      'e303',
      
      ['M128 160l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0zM320 160l0 64 64 0 0-64-64 0zm0 192l0 64 64 0 0-64-64 0z','M64 32L0 96 0 480l128 0 0-384L64 32zM192 96l0 384 128 0 0-384L256 32 192 96zm192 0l0 384 128 0 0-384L448 32 384 96z']
      
    ]
  };

  

  
  

  var faBlindsOpen = {
    prefix: 'fasds',
    iconName: 'blinds-open',
    icon: [
      512,
      512,
      [],
      'f8fc',
      
      ['M0 192l128 0 0-64-88 0L0 192zM0 352l144 0c-26.5 0-48-21.5-48-48c0-.7 0-1.4 0-2.1s.1-1.4 .1-2.1c.1-1.4 .3-2.7 .5-4.1c.5-2.7 1.1-5.3 2-7.8L40 288 0 352zM0 512l512 0-40-64L40 448 0 512zM144 352l368 0-40-64-282.7 0c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48zm16-224l0 64 352 0-40-64-312 0z','M32 0L0 0 0 64l32 0 96 0 0 194.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3L160 64l320 0 32 0 0-64L480 0 32 0z']
      
    ]
  };

  

  
  

  var faWebhook = {
    prefix: 'fasds',
    iconName: 'webhook',
    icon: [
      576,
      512,
      [],
      'e5d5',
      
      ['M0 384c0-63.6 46.3-116.3 107-126.3l7.8 47.4C76.9 311.3 48 344.3 48 384c0 44.2 35.8 80 80 80s80-35.8 80-80l0-24 24 0 174.4 0c-2 3.5-3.6 7.3-4.7 11.4c-.5 2-1 4.1-1.2 6.2c-.1 1.1-.2 2.1-.3 3.2s-.1 2.2-.1 3.3c0 8.7 2.3 16.9 6.4 24l-152.7 0C242.5 467.2 190.5 512 128 512C57.3 512 0 454.7 0 384zm129.7-48L201 221.9c-25.2-23.4-41-56.8-41-93.9C160 57.3 217.3 0 288 0s128 57.3 128 128c0 17-3.3 33.2-9.3 48.1l-44.5-18c3.7-9.2 5.8-19.4 5.8-30c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 28.6 15 53.7 37.6 67.9l20.3 12.7-12.7 20.3L170.4 361.5c-7.8-14.7-23.1-24.8-40.7-25.4zM289.7 176c17.7-.6 32.9-10.7 40.7-25.4l71.3 114.1c14.4-5.6 30-8.6 46.3-8.6c70.7 0 128 57.3 128 128s-57.3 128-128 128c-35.5 0-67.7-14.5-90.8-37.8l34.1-33.8C405.8 455 425.8 464 448 464c44.2 0 80-35.8 80-80s-35.8-80-80-80c-15.6 0-30.1 4.4-42.4 12.1l-20.4 12.8-12.7-20.4L289.7 176z','M288 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM176 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm320 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z']
      
    ]
  };

  

  
  

  var faScrollTorah = {
    prefix: 'fasds',
    iconName: 'scroll-torah',
    icon: [
      640,
      512,
      ["torah"],
      'f6a0',
      
      ['M96 32l0 448 448 0 0-448L96 32zm91.1 148l20.9 0 67.8 0 33.9-58L320 104.2l10.4 17.8 33.9 58 67.8 0 20.9 0-10.5 18-33.8 58 33.8 58 10.5 18L432 332l-67.8 0-33.9 58L320 407.8 309.6 390l-33.9-58L208 332l-20.9 0 10.5-18 33.8-58-33.8-58-10.5-18zm41.8 24l16.4 28.2L261.8 204l-32.9 0zm0 104l32.9 0-16.4-28.2L228.9 308zm30.3-52l30.3 52 60.9 0 30.3-52-30.3-52-60.9 0-30.3 52zm44.3-76l32.9 0L320 151.8 303.6 180zm0 152L320 360.2 336.4 332l-32.9 0zm74.7-128l16.4 28.2L411.1 204l-32.9 0zm0 104l32.9 0-16.4-28.2L378.2 308z','M96 0L0 0 0 512l96 0L96 0zM640 0L544 0l0 512 96 0L640 0z']
      
    ]
  };

  
    var faTorah = faScrollTorah;
  

  
  

  var faDownRight = {
    prefix: 'fasds',
    iconName: 'down-right',
    icon: [
      384,
      512,
      [],
      'e16b',
      
      ['M0 144L152 296l80-80L80 64 0 144z','M368 432V144l-32-32L48 400l32 32H368z']
      
    ]
  };

  

  
  

  var faPersonArrowUpFromLine = {
    prefix: 'fasds',
    iconName: 'person-arrow-up-from-line',
    icon: [
      640,
      512,
      [],
      'e539',
      
      ['M32.2 270.8l53.9 34.4 33.8-53L120 448l64 0 0-96 16 0 0 96 64 0 0-195.8 33.8 53 53.9-34.4L270 142.8 260.6 128l-17.5 0-102.2 0-17.5 0-9.4 14.8-81.7 128zM144 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M621.3 144l-22.6-22.6-80-80L496 18.7 473.4 41.4l-80 80L370.7 144 416 189.3l22.6-22.6L464 141.3 464 384l0 32 64 0 0-32 0-242.7 25.4 25.4L576 189.3 621.3 144zM32 448L0 448l0 64 32 0 576 0 32 0 0-64-32 0L32 448z']
      
    ]
  };

  

  
  

  var faBowlingPins = {
    prefix: 'fasds',
    iconName: 'bowling-pins',
    icon: [
      512,
      512,
      [],
      'f437',
      
      ['M30.5 367.3l2.7 9.5 32 112L71.9 512 96 512l64 0 24.1 0 6.6-23.2 32-112 2.7-9.5-3.1-9.4L173 209.6c-1.9-5.7-3.3-11.6-4.1-17.6l-81.8 0c-.8 6-2.2 11.9-4.1 17.6L33.6 357.9l-3.1 9.4zM64 64l0 1.1c0 7.4 1 14.8 2.9 22l17.7 64.8c.7 2.7 1.3 5.4 1.8 8.1l83.2 0c.5-2.7 1.1-5.4 1.8-8.1L189.1 87c1.9-7.1 2.9-14.5 2.9-21.9l0-1.1c0-35.3-28.7-64-64-64S64 28.7 64 64zM286.5 367.3l2.7 9.5 32 112 6.6 23.2 24.1 0 64 0 24.1 0 6.6-23.2 32-112 2.7-9.5-3.1-9.4L429 209.6c-1.9-5.7-3.3-11.6-4.1-17.6l-81.8 0c-.8 6-2.2 11.9-4.1 17.6L289.6 357.9l-3.1 9.4zM320 64l0 1.1c0 7.4 1 14.8 3 22l17.7 64.8c.7 2.7 1.3 5.4 1.8 8.1l83.2 0c.5-2.7 1.1-5.4 1.8-8.1L445.1 87c1.9-7.1 2.9-14.5 2.9-21.9l0-1.1c0-35.3-28.7-64-64-64s-64 28.7-64 64z','M86.5 160l83.2 0c-1 5.6-1.5 11.3-1.5 17.1l0 2.2c0 4.3 .3 8.5 .8 12.7l-81.8 0c.6-4.2 .9-8.5 .9-12.8l0-2.1c0-5.8-.5-11.5-1.5-17.1zm256 0l83.2 0c-1 5.6-1.5 11.3-1.5 17.1l0 2.2c0 4.3 .3 8.5 .8 12.7l-81.8 0c.6-4.2 .9-8.5 .9-12.8l0-2.1c0-5.8-.5-11.5-1.5-17.1z']
      
    ]
  };

  

  
  

  var faPencilSlash = {
    prefix: 'fasds',
    iconName: 'pencil-slash',
    icon: [
      640,
      512,
      [],
      'e215',
      
      ['M64 512.6l51-10.2 109-21.8L340.1 364.5 263.2 304l-27.9 27.9L224 343.2l-22.6-22.6 11.3-11.3L237.9 284l-41-32.3L96 352.6l-21.8 109L64 512.6zm61.2-61.2l15-75.1 23.7-23.7 12.1 0 0 48 48 0 0 12.1-23.7 23.7-75.1 15zM265.3 183.2l41.3 32.1 50-50L368 153.9l22.6 22.6-11.3 11.3-47.2 47.2 77.3 60 75.2-75.2-16-16-96-96-16-16-91.3 91.3zm114-114l16 16 96 96 16 16 34.7-34.7L576 128.6 542.1 94.6 481.9 34.5 448 .6 414.1 34.5 379.3 69.3z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faUserNinja = {
    prefix: 'fasds',
    iconName: 'user-ninja',
    icon: [
      448,
      512,
      [129399],
      'f504',
      
      ['M144 96l16 0 128 0 16 0 0 32-16 0-128 0-16 0 0-32z','M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0c-49.6 0-92.6 28.2-113.8 69.4c-3-5.8-6.8-11.3-11.7-16.1c-25-25-67.9-22.6-67.9-22.6s-2.4 42.9 22.6 67.9c5.8 5.8 12.6 10.1 19.6 13.4c-7 3.2-13.8 7.6-19.6 13.4c-25 25-22.6 67.9-22.6 67.9s42.9 2.4 67.9-22.6c1.2-1.2 2.4-2.5 3.5-3.8c16.4 51.8 64.8 89.3 122 89.3zM448 512L384 304l-76 0L224 416 140 304l-76 0L0 512l448 0zM160 96l128 0 16 0 0 32-16 0-128 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var fa7 = {
    prefix: 'fasds',
    iconName: '7',
    icon: [
      320,
      512,
      [],
      '37',
      
      ['M320 32l0 39.9-3.7 7L104.6 480l-72.4 0L234.9 96 32 96 0 96 0 32l32 0 256 0 32 0z','']
      
    ]
  };

  

  
  

  var faBlog = {
    prefix: 'fasds',
    iconName: 'blog',
    icon: [
      512,
      512,
      [],
      'f781',
      
      ['M192 0l0 64c141.4 0 256 114.6 256 256l64 0C512 143.3 368.7 0 192 0zm0 96l0 64c88.4 0 160 71.6 160 160l64 0C416 196.3 315.7 96 192 96z','M96 96l0 48 0 224c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48l-16 0 0-96 16 0c79.5 0 144 64.5 144 144s-64.5 144-144 144S0 447.5 0 368L0 144 0 96l96 0z']
      
    ]
  };

  

  
  

  var faCircle9 = {
    prefix: 'fasds',
    iconName: 'circle-9',
    icon: [
      512,
      512,
      [],
      'e0f6',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160.1-37c.1-1.6 .2-3.2 .4-4.9c.3-3.2 .8-6.4 1.5-9.5c1.3-6.2 3.2-12.3 5.6-18c4.9-11.5 11.9-21.8 20.6-30.5C205.5 138.7 229.5 128 256 128c53 0 96 43 96 96c0 31.7-11.9 62.3-33.3 85.7c-22.7 24.8-45.4 49.5-68.1 74.3l-65.1 0c5-5.4 9.9-10.8 14.9-16.2c14.8-16.1 29.6-32.3 44.4-48.4c-23.8-2.8-45-14.3-60.2-31.3c-7.6-8.5-13.7-18.4-17.9-29.2c-2.1-5.4-3.7-11-4.8-16.9c-.6-2.9-1-5.9-1.3-8.9c-.1-1.5-.2-3-.3-4.5c-.1-1.5-.1-3.1-.1-4.6c0-1.7 0-3.3 .1-5zm48.1 0c-.1 .8-.1 1.6-.2 2.4s-.1 1.6-.1 2.5c0 1 0 1.8 .1 2.5c0 .8 .1 1.6 .2 2.4c.2 1.6 .4 3.2 .7 4.8c.6 3.1 1.6 6.1 2.8 9c2.4 5.7 5.9 10.9 10.3 15.3c8.7 8.7 20.7 14.1 33.9 14.1c26.5 0 48-21.5 48-48s-21.5-48-48-48c-13.3 0-25.3 5.4-33.9 14.1c-4.3 4.3-7.9 9.5-10.3 15.3c-1.2 2.9-2.2 5.9-2.8 9c-.3 1.6-.6 3.1-.7 4.8z','M304 224a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-59.3 95.3l-44.4 48.4L185.4 384l65.1 0 68.1-74.3c21.4-23.4 33.3-54 33.3-85.7c0-53-43-96-96-96s-96 43-96 96c0 49.2 37 89.8 84.7 95.3z']
      
    ]
  };

  

  
  

  var faSheetPlastic = {
    prefix: 'fasds',
    iconName: 'sheet-plastic',
    icon: [
      384,
      512,
      [],
      'e571',
      
      ['M0 0L0 512l224 0 0-160 160 0L384 0 0 0zM41.4 160l11.3-11.3 96-96L160 41.4 182.6 64 171.3 75.3l-96 96L64 182.6 41.4 160zm32 96l11.3-11.3 160-160L256 73.4 278.6 96l-11.3 11.3-160 160L96 278.6 73.4 256z','M224 512L384 352H224V512z']
      
    ]
  };

  

  
  

  var faFaceUnamused = {
    prefix: 'fasds',
    iconName: 'face-unamused',
    icon: [
      512,
      512,
      [],
      'e39f',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm96-64l16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0-16 0 0-32zm65.4 193.2l10.7-11.9C188.2 355.4 216.3 336 256 336s67.8 19.4 83.9 37.3l10.7 11.9-23.8 21.4-10.7-11.9c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7l-10.7 11.9-23.8-21.4zM288 192l16 0 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32s-32-14.3-32-32l-32 0-16 0 0-32z','M112 192l-16 0 0 32 16 0 32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0zm192 0l-16 0 0 32 16 0 32 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32l-64 0z']
      
    ]
  };

  

  
  

  var faMessageArrowDown = {
    prefix: 'fasds',
    iconName: 'message-arrow-down',
    icon: [
      512,
      512,
      ["comment-alt-arrow-down"],
      'e1db',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM150.1 224l17 17 72 72 17 17 17-17 72-72 17-17L328 190.1l-17 17-31 31L280 120l0-24-48 0 0 24 0 118.1-31-31-17-17L150.1 224z','M280 96l0 24 0 118.1 31-31 17-17L361.9 224l-17 17-72 72-17 17-17-17-72-72-17-17L184 190.1l17 17 31 31L232 120l0-24 48 0z']
      
    ]
  };

  
    var faCommentAltArrowDown = faMessageArrowDown;
  

  
  

  var faGolfFlagHole = {
    prefix: 'fasds',
    iconName: 'golf-flag-hole',
    icon: [
      512,
      512,
      [],
      'e3ac',
      
      ['M0 416c0 53 114.6 96 256 96s256-43 256-96s-114.6-96-256-96c-27.9 0-54.8 1.7-80 4.8l0 67.2 0 2.8c11.7-6.6 28.9-10.8 48-10.8c35.3 0 64 14.3 64 32s-28.7 32-64 32s-64-14.3-64-32l-32 0 0-24 0-59.2C51.5 349.4 0 380.5 0 416z','M416 128L128 0l0 216 0 24 0 16 0 136 0 24 48 0 0-24 0-152 0-5.3L416 128z']
      
    ]
  };

  

  
  

  var faBookBlank = {
    prefix: 'fasds',
    iconName: 'book-blank',
    icon: [
      448,
      512,
      [128213,128215,128216,128217,"book-alt"],
      'f5d9',
      
      ['M64 416c0-17.7 14.3-32 32-32l160 0 96 0 64 0 0 64-64 0-96 0L96 448c-17.7 0-32-14.3-32-32z','M0 96C0 43 43 0 96 0L384 0l32 0 32 0 0 384-32 0-64 0-96 0L96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 96 0 64 0 32 0 0 64-32 0-32 0L96 512c-53 0-96-43-96-96L0 96z']
      
    ]
  };

  
    var faBookAlt = faBookBlank;
  

  
  

  var faVialVirus = {
    prefix: 'fasds',
    iconName: 'vial-virus',
    icon: [
      512,
      512,
      [],
      'e597',
      
      ['M0 32L0 64 0 96l32 0 0 288c0 53 43 96 96 96c22.6 0 43.3-7.8 59.7-20.8l-11-11 39.6-39.6 .6-.6-.8 0-56 0 0-112 56 0 .8 0-.6-.6-39.6-39.6L224 208.5 224 96l32 0 0-32 0-32-32 0-64 0L96 32 32 32 0 32zM96 96l64 0 0 96-64 0 0-96z','M238.9 431.2c20.4-20.4 5.9-55.2-22.9-55.2c0 0 0 0 0 0l-24 0 0-24 0-24 24 0c0 0 0 0 .1 0c28.8 0 43.2-34.8 22.8-55.2l-17-17 17-17 17-17 17 17c20.4 20.4 55.2 5.9 55.2-22.9l0-.1 0-23.9 24 0 24 0 0 24 0 .2c.1 28.7 34.9 43 55.2 22.7l17-17 17 17 17 17-17 17c-20.4 20.4-6 55.2 22.8 55.2c0 0 0 0 .1 0l24 0 0 24 0 24-24 0c0 0 0 0 0 0c-28.8 0-43.2 34.8-22.9 55.2l17 17-17 17-17 17-17-17c-20.3-20.3-55-6-55.2 22.7l0 .2 0 24-24 0-24 0 0-23.8 0-.2c0-28.8-34.8-43.2-55.2-22.9l-17 17-17-17-17-17 17-17zM352 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faCloudXmark = {
    prefix: 'fasds',
    iconName: 'cloud-xmark',
    icon: [
      640,
      512,
      [],
      'e35f',
      
      ['M0 336L0 480l144 0 368 0 128 0 0-128c0-59.6-40.8-109.8-96-124l0-36c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192l0 8.2C40.1 220 0 273.3 0 336zM222.1 224L256 190.1l17 17 47 47 47-47 17-17L417.9 224l-17 17-47 47 47 47 17 17L384 385.9l-17-17-47-47-47 47-17 17L222.1 352l17-17 47-47-47-47-17-17z','M401 241l17-17L384 190.1l-17 17-47 47-47-47-17-17L222.1 224l17 17 47 47-47 47-17 17L256 385.9l17-17 47-47 47 47 17 17L417.9 352l-17-17-47-47 47-47z']
      
    ]
  };

  

  
  

  var faUserCheck = {
    prefix: 'fasds',
    iconName: 'user-check',
    icon: [
      640,
      512,
      [],
      'f4fc',
      
      ['M0 512l448 0L384 304 64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M633.9 160l-17 17L489 305l-17 17-17-17-64-64-17-17L408 190.1l17 17 47 47L583 143l17-17L633.9 160z']
      
    ]
  };

  

  
  

  var faArrowDownToSquare = {
    prefix: 'fasds',
    iconName: 'arrow-down-to-square',
    icon: [
      512,
      512,
      [],
      'e096',
      
      ['M0 32l32 0 96 0 0 64L64 96l0 352 384 0 0-352-64 0 0-64 96 0 32 0 0 32 0 416 0 32-32 0L32 512 0 512l0-32L0 64 0 32z','M256 365.3l22.6-22.6 96-96L397.3 224 352 178.7l-22.6 22.6L288 242.7 288 32l0-32L224 0l0 32 0 210.7-41.4-41.4L160 178.7 114.7 224l22.6 22.6 96 96L256 365.3z']
      
    ]
  };

  

  
  

  var faNote = {
    prefix: 'fasds',
    iconName: 'note',
    icon: [
      448,
      512,
      [],
      'e1ff',
      
      ['M0 32l448 0 0 288-32 0-32 0-96 0 0 96 0 32 0 32L0 480 0 32zm64 80l0 48 48 0 0-48-48 0zm0 120l0 48 48 0 0-48-48 0zm0 120l0 48 48 0 0-48-48 0z','M288 320l0 96 0 32 0 32 16 0 13.3 0 9.4-9.4 112-112 9.4-9.4 0-13.3 0-16-32 0-32 0-96 0z']
      
    ]
  };

  

  
  

  var faTruckRampBox = {
    prefix: 'fasds',
    iconName: 'truck-ramp-box',
    icon: [
      640,
      512,
      ["truck-loading"],
      'f4de',
      
      ['M14.8 176.8l216.4-58 58 216.4-216.4 58-58-216.4zm77.3-20.7l24.8 92.7 61.8-16.6-24.8-92.7L92.1 156.1zM544 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z','M544 288c-66.1 0-120.6 50.2-127.3 114.5L48.4 502.9l-30.9 8.4L.7 449.5l30.9-8.4L352 353.8 352 0 640 0l0 331.3c-23.5-26.6-57.8-43.3-96-43.3zM153.9 139.5l24.8 92.7-61.8 16.6L92.1 156.1l61.8-16.6z']
      
    ]
  };

  
    var faTruckLoading = faTruckRampBox;
  

  
  

  var faBlueberries = {
    prefix: 'fasds',
    iconName: 'blueberries',
    icon: [
      512,
      512,
      [],
      'e2e8',
      
      ['M112 256l0 32 16 0 32 0 0 32 0 16 32 0 0-16 0-32 32 0 16 0 0-32-16 0-32 0 0-32 0-16-32 0 0 16 0 32-32 0-16 0zm48.7-95.3c5.1-.4 10.2-.7 15.3-.7c97.2 0 176 78.8 176 176c0 1.3 0 2.6 0 3.9s-.1 2.6-.1 3.8c-.1 2.6-.3 5.1-.5 7.6C441.4 343.6 512 268 512 176C512 78.8 433.2 0 336 0C244 0 168.4 70.6 160.7 160.7zM304 96l16 0 32 0 0-32 0-16 32 0 0 16 0 32 32 0 16 0 0 32-16 0-32 0 0 32 0 16-32 0 0-16 0-32-32 0-16 0 0-32z','M384 64l0 32 32 0 16 0 0 32-16 0-32 0 0 32 0 16-32 0 0-16 0-32-32 0-16 0 0-32 16 0 32 0 0-32 0-16 32 0 0 16zM0 336a176 176 0 1 1 352 0A176 176 0 1 1 0 336zM192 208l-32 0 0 16 0 32-32 0-16 0 0 32 16 0 32 0 0 32 0 16 32 0 0-16 0-32 32 0 16 0 0-32-16 0-32 0 0-32 0-16z']
      
    ]
  };

  

  
  

  var faPenField = {
    prefix: 'fasds',
    iconName: 'pen-field',
    icon: [
      640,
      512,
      [],
      'e211',
      
      ['M0 128l32 0 224 0 32 0 0 64-32 0L64 192l0 256 448 0 0-128 0-32 64 0 0 32 0 160 0 32-32 0L32 512 0 512l0-32L0 160l0-32z','M288 352l16-112L468.7 75.3l96 96L400 336 288 352zM587.3 148.7l-96-96L544 0l96 96-52.7 52.7zM96 288l64 0 0 64-64 0 0-64zm160 0l0 64-64 0 0-64 64 0z']
      
    ]
  };

  

  
  

  var faClipboardList = {
    prefix: 'fasds',
    iconName: 'clipboard-list',
    icon: [
      384,
      512,
      [],
      'f46d',
      
      ['M0 64l80 0 0 72 0 24 112 0 88 0 24 0 0-24 0-48 0-24 80 0 0 448L0 512 0 64zM72 272a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 96a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm88-112l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0zm0 96l0 32 16 0 128 0 16 0 0-32-16 0-128 0-16 0z','M270.4 64L304 64l0 96-112 0L80 160l0-96 33.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z']
      
    ]
  };

  

  
  

  var faPumpkin = {
    prefix: 'fasds',
    iconName: 'pumpkin',
    icon: [
      576,
      512,
      [],
      'f707',
      
      ['M0 320C0 426 68.1 512 152 512c24.4 0 47.5-7.3 68-20.2c20.5 12.9 43.6 20.2 68 20.2s47.5-7.3 68-20.2c20.5 12.9 43.6 20.2 68 20.2c83.9 0 152-86 152-192s-68.1-192-152-192c-10.2 0-20.1 1.3-29.8 3.7c15.4 11.7 28.9 25.9 39.8 42C392.6 144.9 342.3 128 288 128s-104.6 16.9-146 45.7c10.9-16.1 24.3-30.3 39.8-42c-9.6-2.4-19.6-3.7-29.8-3.7C68.1 128 0 214 0 320z','M288 0L236.1 103.8C252.5 98.7 269.9 96 288 96c22.6 0 44.2 4.3 64 12l0-76L288 0z']
      
    ]
  };

  

  
  

  var faCodePullRequest = {
    prefix: 'fasds',
    iconName: 'code-pull-request',
    icon: [
      512,
      512,
      [],
      'e13c',
      
      ['M48 160l8 0 48 0 8 0 0 192-8 0-48 0-8 0 0-192zM192 96L288 0l32 0 0 64 16 0c70.7 0 128 57.3 128 128l0 160-8 0-48 0-8 0 0-160c0-35.3-28.7-64-64-64l-16 0 0 64-32 0L192 96z','M104 56l0 48-48 0 0-48 48 0zM56 0L0 0 0 56l0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56L104 0 56 0zm48 408l0 48-48 0 0-48 48 0zM56 352L0 352l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0zm352 56l48 0 0 48-48 0 0-48zm-56-56l0 56 0 48 0 56 56 0 48 0 56 0 0-56 0-48 0-56-56 0-48 0-56 0z']
      
    ]
  };

  

  
  

  var faDesktopArrowDown = {
    prefix: 'fasds',
    iconName: 'desktop-arrow-down',
    icon: [
      576,
      512,
      [],
      'e155',
      
      ['M0 0L0 416l240 0 96 0 240 0L576 0 312 0l0 24 0 40 200 0 0 224L64 288 64 64l200 0 0-40 0-24L0 0z','M264 64L64 64l0 224 448 0 0-224L312 64l0 102.1 39-39 17-17L401.9 144l-17 17-80 80-17 17-17-17-80-80-17-17L208 110.1l17 17 39 39L264 64zm82.7 384L336 416l-96 0-10.7 32L160 448l-32 0 0 64 32 0 256 0 32 0 0-64-32 0-69.3 0z']
      
    ]
  };

  

  
  

  var faPaste = {
    prefix: 'fasds',
    iconName: 'paste',
    icon: [
      512,
      512,
      ["file-clipboard"],
      'f0ea',
      
      ['M224 128l192 0 96 96 0 288-288 0 0-384z','M160 0c-23.7 0-44.4 12.9-55.4 32L0 32 0 448l192 0 0-320 0-32 32 0 96 0 0-64L215.4 32C204.4 12.9 183.7 0 160 0zm0 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  
    var faFileClipboard = faPaste;
  

  
  

  var faComments = {
    prefix: 'fasds',
    iconName: 'comments',
    icon: [
      640,
      512,
      [61670,128490],
      'f086',
      
      ['M231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 37.5-13.9 72.3-37.6 100.9L640 512 531.9 490.4C502.3 504.2 468.2 512 432 512c-95.6 0-176.2-54.6-200.5-129z','M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 37.5 13.9 72.3 37.6 100.9L0 352l108.1-21.6C137.7 344.2 171.8 352 208 352z']
      
    ]
  };

  

  
  

  var faCaretRight = {
    prefix: 'fasds',
    iconName: 'caret-right',
    icon: [
      256,
      512,
      [],
      'f0da',
      
      ['M256 256L112 96 64 96l0 320 48 0L256 256z','']
      
    ]
  };

  

  
  

  var faBackward = {
    prefix: 'fasds',
    iconName: 'backward',
    icon: [
      512,
      512,
      [9194],
      'f04a',
      
      ['M256 256L512 448l0-384L256 256z','M256 64V448L0 256 256 64z']
      
    ]
  };

  

  
  

  var faPencil = {
    prefix: 'fasds',
    iconName: 'pencil',
    icon: [
      512,
      512,
      [9999,61504,"pencil-alt"],
      'f303',
      
      ['M137.7 319.7L160 342.1l11.3-11.3 144-144 11-11L304 153.4l-11.3 11.3-144 144-11 11zM304 80L432 208c15.4-15.4 30.7-30.7 46.1-46.1L512 128 478.1 94.1 417.9 33.9 384 0 350.1 33.9C334.7 49.3 319.4 64.6 304 80z','M432 208L304 80 32 352 10.2 461 0 512l51-10.2L160 480 432 208zM136.3 435.8l-75.1 15 15-75.1 24.2-24.2 11.5 0 0 48 48 0 0 12.7-23.7 23.7zM326.6 175.4l-11.3 11.3-144 144L160 342.1l-22.6-22.6 11.3-11.3 144-144L304 152.8l22.6 22.6z']
      
    ]
  };

  
    var faPencilAlt = faPencil;
  

  
  

  var faLips = {
    prefix: 'fasds',
    iconName: 'lips',
    icon: [
      576,
      512,
      [128068,128482],
      'f600',
      
      ['M0 224l64 0s80 96 224 96s224-96 224-96l64 0s-80 224-240 224l-96 0C80 448 0 224 0 224z','M192 64L0 224l64 0 144-32s48.1 16 80 16s80-16 80-16l144 32 64 0L384 64l-96 48L192 64z']
      
    ]
  };

  

  
  

  var faLandmarkFlag = {
    prefix: 'fasds',
    iconName: 'landmark-flag',
    icon: [
      512,
      512,
      [],
      'e51c',
      
      ['M0 464l0 48 512 0 0-48-64-48 0-224-64 0 0 224-40 0 0-224-64 0 0 224-48 0 0-224-64 0 0 224-40 0 0-224-64 0 0 224L0 464z','M272 0l96 0 0 96-96 0 0 32 192 0 32 0 0 64-32 0L48 192l-32 0 0-64 32 0 192 0L240 0l32 0z']
      
    ]
  };

  

  
  

  var faRam = {
    prefix: 'fasds',
    iconName: 'ram',
    icon: [
      640,
      512,
      [128015],
      'f70a',
      
      ['M0 256c0 24.5 13.7 45.7 33.9 56.5c-1.2 5-1.9 10.2-1.9 15.5c0 35.3 28.7 64 64 64c.5 0 1 0 1.5 0c2.8-.1 5.6-.3 8.3-.7c6.8 28 32.1 48.7 62.2 48.7c7.5 0 14.7-1.3 21.3-3.6c6.8-2.4 13-5.9 18.5-10.2C219.7 439.6 236.9 448 256 448c19.2 0 36.5-8.5 48.2-21.9C315.1 434.8 329 440 344 440c30.1 0 55.3-20.8 62.2-48.7c2.7 .4 5.5 .7 8.3 .7c.5 0 1 0 1.5 0c26.9 0 49.9-16.5 59.3-40L352 352l0-135.6-21.4 9.2L286.5 122.6l30.8-13.2C309.3 83.1 284.9 64 256 64c-19.2 0-36.5 8.5-48.2 21.9C196.9 77.2 183 72 168 72c-30.1 0-55.3 20.8-62.2 48.8c-3.2-.5-6.5-.8-9.8-.8c-35.3 0-64 28.7-64 64c0 5.3 .7 10.5 1.9 15.5C13.7 210.3 0 231.5 0 256z','M400 0c-35.3 0-64 28.7-64 64l0 8 0 24 48 0 0-24 0-8c0-8.8 7.2-16 16-16s16 7.2 16 16l0 32-10.3 10.3-55.1 23.6-22.1 9.5 18.9 44.1 22.1-9.5 14.5-6.2L384 320l192 0 0-152.2 14.5 6.2 22.1 9.5 18.9-44.1-22.1-9.5-55.1-23.6L544 96l0-32c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8 0 24 48 0 0-24 0-8c0-35.3-28.7-64-64-64s-64 28.7-64 64l-32 0c0-35.3-28.7-64-64-64zm64 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM304.2 426.1l-.2 .2 0 85.7 88 0 22.5-120c-2.8-.1-5.6-.3-8.3-.7c-6.8 28-32.1 48.7-62.2 48.7c-15 0-28.9-5.2-39.8-13.9zM105.8 391.3c-2.7 .4-5.5 .7-8.3 .7L120 512l88 0 0-85.7-.2-.2C196.9 434.8 183 440 168 440c-30.1 0-55.3-20.8-62.2-48.7z']
      
    ]
  };

  

  
  

  var faExcavator = {
    prefix: 'fasds',
    iconName: 'excavator',
    icon: [
      640,
      512,
      [],
      'e656',
      
      ['M0 432c0-44.2 35.8-80 80-80l256 0c44.2 0 80 35.8 80 80s-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80zm64 0c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 416c-8.8 0-16 7.2-16 16zM416 160L576 0l64 0 0 320 0 64 0 48c0 44.2-35.8 80-80 80l-112 0 0-48L576 336l0-208L416 288l0-128z','M128 0L96 0l0 32 0 128L0 160 0 320l384 0 0-96 0-56 0-8 0-2.2-5.9-8.3-96-136L272.6 0 256 0 128 0zM307.2 160L160 160l0-96 79.4 0 67.8 96z']
      
    ]
  };

  

  
  

  var faEggplant = {
    prefix: 'fasds',
    iconName: 'eggplant',
    icon: [
      512,
      512,
      [],
      'e16c',
      
      ['M0 336c1.4 95.3 79.8 175.9 176.4 176c141.3 .1 243.8-164.1 287.4-293.5c-10.6-3.5-21.2-7.1-31.7-10.6c-5.3-16-10.7-32-16-48c-16-5.3-32-10.7-48-16c-5.3-16-10.7-32-16-48c-16-5.3-32-10.7-48-16c-2.2-6.7-4.5-13.4-6.7-20.2c-34.2 34.2-81 56.9-127.4 79.4C83.4 181.3-1.6 222.5 0 336z','M480 65.9l31.4-31.4L477.4 .6 446.1 32 288 32l16 48 48 16 16 48 48 16 16 48 48 16 0-158.1z']
      
    ]
  };

  

  
  

  var faFolderGrid = {
    prefix: 'fasds',
    iconName: 'folder-grid',
    icon: [
      512,
      512,
      [],
      'e188',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM80 240l96 0 0 96-96 0 0-96zm128 0l96 0 0 96-96 0 0-96zm128 0l96 0 0 96-96 0 0-96z','M80 240l96 0 0 96-96 0 0-96zm128 0l96 0 0 96-96 0 0-96zm224 0l0 96-96 0 0-96 96 0z']
      
    ]
  };

  

  
  

  var faGaugeMin = {
    prefix: 'fasds',
    iconName: 'gauge-min',
    icon: [
      512,
      512,
      ["tachometer-alt-slowest"],
      'f628',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm55-.2c8.4-13.6 16.8-27.2 25.3-40.8c6.8 4.2 13.6 8.4 20.4 12.6c39.2 24.3 78.4 48.5 117.6 72.8c10.6-7.8 23.7-12.4 37.8-12.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-3.7 .3-7.3 .9-10.8c-39.2-24.3-78.4-48.5-117.5-72.8c-6.8-4.2-13.6-8.4-20.4-12.6zM176 144a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm112 48a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm48 112a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M100.6 227.6L80.2 215 55 255.8l20.4 12.6 117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6z']
      
    ]
  };

  
    var faTachometerAltSlowest = faGaugeMin;
  

  
  

  var faDiagramPrevious = {
    prefix: 'fasds',
    iconName: 'diagram-previous',
    icon: [
      512,
      512,
      [],
      'e478',
      
      ['M0 32L0 224l128 0 0-32 0-13.3 9.4-9.4 96-96L256 50.7l22.6 22.6 96 96 9.4 9.4 0 13.3 0 32 128 0 0-192L0 32z','M512 288l0 192L0 480 0 288l232 0 0-64-72 0 0-32 96-96 96 96 0 32-72 0 0 64 232 0z']
      
    ]
  };

  

  
  

  var faK = {
    prefix: 'fasds',
    iconName: 'k',
    icon: [
      320,
      512,
      [107],
      '4b',
      
      ['M236.5 32l83.2 0L309.4 44.5 166.8 215.9 317.9 480l-73.7 0L123.1 268.5 64 339.6 64 448l0 32L0 480l0-32L0 328 0 64 0 32l64 0 0 32 0 175.5 39.4-47.4L236.5 32z','']
      
    ]
  };

  

  
  

  var faPage = {
    prefix: 'fasds',
    iconName: 'page',
    icon: [
      384,
      512,
      [],
      'e428',
      
      ['M0 512H384V112L272 0H0V512z','']
      
    ]
  };

  

  
  

  var faStrikethrough = {
    prefix: 'fasds',
    iconName: 'strikethrough',
    icon: [
      512,
      512,
      [],
      'f0cc',
      
      ['M87.5 436.3l30.4 10.1c3.6 1.2 7.9 2.7 12.8 4.3c24.9 8.5 63.6 21.7 87.6 25.6c15.5 2.4 30.7 3.7 45.5 3.7c28.3 0 55.2-4.6 78.4-14.6c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1l-75.7 0c7 5.6 11.4 11.2 13.9 17.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4l-30.4-10.1L87.5 436.3zM98.1 133.9c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9l145.5 0-.4-.1-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12l30.9 8.2 16.5-61.8-30.9-8.2c-14.3-3.8-53.6-11.4-66.6-13.4c-15.3-2.4-30.5-3.6-45.3-3.6c-28.3 0-55.2 4.6-78.4 14.6c-36.5 15.6-64.4 44.8-71.8 87.3z','M0 224l32 0 448 0 32 0 0 64-32 0L32 288 0 288l0-64z']
      
    ]
  };

  

  
  

  var faTrees = {
    prefix: 'fasds',
    iconName: 'trees',
    icon: [
      640,
      512,
      [],
      'f724',
      
      ['M0 384l0 32 160 0 0-200 0-32 64 0 0 32 0 200 160 0 0-32-80-96 48 0 0-32-80-96 48 0 0-32L192 0 64 128l0 32 48 0L32 256l0 32 48 0L0 384zM340.3 192l36.3 43.5 7.4 8.9 0 11.6 0 32 0 32-11.7 0 36.3 43.5 7.4 8.9L416 216l0-32 64 0 0 32 0 200 160 0 0-32-80-96 48 0 0-32-80-96 48 0 0-32L448 0 342.6 105.4l9.4 9.4 0 13.3 0 32 0 32-11.7 0z','M224 216l0-32-64 0 0 32 0 264 0 32 64 0 0-32 0-264zm256 0l0-32-64 0 0 32 0 264 0 32 64 0 0-32 0-264z']
      
    ]
  };

  

  
  

  var faHandLove = {
    prefix: 'fasds',
    iconName: 'hand-love',
    icon: [
      512,
      512,
      [],
      'e1a5',
      
      ['M-.6 328.5l29 27.6L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-240 0-32-64 0 0 32 0 160 0 96-96 0-32 0-96 0 0-224 0-96 0-32L128 0l0 32 0 304c0 1.5 0 3.1 .1 4.6L83.5 298.2l-29-27.6L-.6 328.5z','M288 160l-64 0 0 160 64 0 0-160zm96 32l-64 0 0 128 64 0 0-128z']
      
    ]
  };

  

  
  

  var faFootballHelmet = {
    prefix: 'fasds',
    iconName: 'football-helmet',
    icon: [
      512,
      512,
      [],
      'f44f',
      
      ['M280 320l41.7 0-13.2-70.6c10.6-1.3 21.2-2.7 31.8-4l14 74.5L496 320l16 0 0 16 0 72 0 72 0 16-16 0-128 0-13.3 0-2.4-13-13.5-72-11.1-59L292 352c-4-10.7-8-21.3-12-32zm80.3 32l7.5 40L480 392l0-40-119.7 0zm13.5 72l7.5 40 98.7 0 0-40-106.2 0z','M256 256l238.2-29.8C479.5 107.7 378.5 16 256 16C123.5 16 16 123.5 16 256c0 61.5 23.1 117.5 61.1 160l34.9 0 99.5 42.6c8.3 3.5 17.2 5.4 26.1 5.4c36.7 0 66.4-29.7 66.4-66.4l0-1.3c0-8.1-1.5-16.2-4.3-23.8L256 256zm-80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faGrid = {
    prefix: 'fasds',
    iconName: 'grid',
    icon: [
      448,
      512,
      ["grid-3"],
      'e195',
      
      ['M0 192L0 320l128 0 0-128L0 192zM160 32l0 128 128 0 0-128L160 32zm0 320l0 128 128 0 0-128-128 0zM320 192l0 128 128 0 0-128-128 0z','M0 32l128 0 0 128L0 160 0 32zM0 352l128 0 0 128L0 480 0 352zM288 192l0 128-128 0 0-128 128 0zM320 32l128 0 0 128-128 0 0-128zM448 352l0 128-128 0 0-128 128 0z']
      
    ]
  };

  
    var faGrid3 = faGrid;
  

  
  

  var faPanFrying = {
    prefix: 'fasds',
    iconName: 'pan-frying',
    icon: [
      576,
      512,
      [127859],
      'e42c',
      
      ['M176 224a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M427.6 317.6C440.7 289.1 448 257.4 448 224C448 100.3 347.7 0 224 0S0 100.3 0 224S100.3 448 224 448c53.3 0 102.3-18.6 140.8-49.7L487.2 512l80.7-103.8L427.6 317.6zM254.1 115.6c15.2 15.8 44.5 32.9 65.8 38.4c13.7 3.5 26.4 11.6 35.5 23.9c21 28.4 15.1 68.5-13.3 89.5c-8.9 6.6-18.9 10.5-29.2 12c-18.6 2.6-42.2 16.3-51.6 32.6c-22.1 38.3-71 51.4-109.3 29.3s-51.4-71-29.3-109.3c12.4-21.4 19.4-53 21.5-77.6c1.3-14.9 7.8-29.4 19.4-40.5c25.5-24.5 66-23.7 90.5 1.8zM488 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z']
      
    ]
  };

  

  
  

  var faAddressBook = {
    prefix: 'fasds',
    iconName: 'address-book',
    icon: [
      512,
      512,
      [62138,"contact-book"],
      'f2b9',
      
      ['M32 0L448 0l0 512L32 512 32 0zm96 384l224 0-32-96-160 0-32 96zm48-192a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M512 64l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16zm0 128l-32 0 0 16 0 64 0 16 32 0 0-16 0-64 0-16zm0 144l0-16-32 0 0 16 0 64 0 16 32 0 0-16 0-64zM320 288l-160 0-32 96 224 0-32-96zm-80-32a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  
    var faContactBook = faAddressBook;
  

  
  

  var faCartMinus = {
    prefix: 'fasds',
    iconName: 'cart-minus',
    icon: [
      576,
      512,
      [],
      'e0db',
      
      ['M122 32c16.3 85.3 32.5 170.7 48.8 256L496 288 576 32 122 32zM256 140l160 0 0 40-160 0 0-40z','M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0L119.6 19.5 115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM256 180l160 0 0-40-160 0 0 40z']
      
    ]
  };

  

  
  

  var faPager = {
    prefix: 'fasds',
    iconName: 'pager',
    icon: [
      512,
      512,
      [128223],
      'f815',
      
      ['M0 64l512 0 0 384L0 448 0 64zM56 320l0 48 24 0 56 0 24 0 0-48-24 0-56 0-24 0zm8-192l0 128 384 0 0-128L64 128zM192 320l0 48 24 0 48 0 24 0 0-48-24 0-48 0-24 0z','M64 128H448V256H64V128z']
      
    ]
  };

  

  
  

  var faMerge = {
    prefix: 'fasds',
    iconName: 'merge',
    icon: [
      512,
      512,
      [],
      'e526',
      
      ['M0 384l0 64 32 0 128 0 15.4 0 9.6-12L303.4 288 288 288l-15.4 0L263 276c-5.3-6.7-10.7-13.3-16-20L144.6 384 32 384 0 384z','M160 64l15.4 0L185 76 303.4 224l80.6 0 0-64 32 0 96 96-96 96-32 0 0-64-96 0-15.4 0L263 276 144.6 128 32 128 0 128 0 64l32 0 128 0z']
      
    ]
  };

  

  
  

  var faCircleH = {
    prefix: 'fasds',
    iconName: 'circle-h',
    icon: [
      512,
      512,
      [9405,"hospital-symbol"],
      'f47e',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM144 128l48 0 0 24 0 80 128 0 0-80 0-24 48 0 0 24 0 104 0 104 0 24-48 0 0-24 0-80-128 0 0 80 0 24-48 0 0-24 0-80 0-48 0-80 0-24z','M368 128l0 24 0 104 0 104 0 24-48 0 0-24 0-80-128 0 0 80 0 24-48 0 0-24 0-80 0-48 0-80 0-24 48 0 0 24 0 80 128 0 0-80 0-24 48 0z']
      
    ]
  };

  
    var faHospitalSymbol = faCircleH;
  

  
  

  var faHexagonXmark = {
    prefix: 'fasds',
    iconName: 'hexagon-xmark',
    icon: [
      512,
      512,
      ["times-hexagon","xmark-hexagon"],
      'f2ee',
      
      ['M0 256L128 32l256 0L512 256 384 480l-256 0L0 256zm158.1-64c5.7 5.7 11.3 11.3 17 17c15.7 15.7 31.4 31.4 47 47c-15.7 15.7-31.4 31.4-47 47c-5.7 5.7-11.3 11.3-17 17c11.3 11.3 22.6 22.6 33.9 33.9l17-17c15.7-15.7 31.4-31.4 47-47l47 47 17 17L353.9 320c-5.7-5.7-11.3-11.3-17-17c-15.7-15.7-31.4-31.4-47-47c15.7-15.7 31.4-31.4 47-47c5.7-5.7 11.3-11.3 17-17c-11.3-11.3-22.6-22.6-33.9-33.9c-5.7 5.7-11.3 11.3-17 17c-15.7 15.7-31.4 31.4-47 47c-15.7-15.7-31.4-31.4-47-47c-5.7-5.7-11.3-11.3-17-17c-11.3 11.3-22.6 22.6-33.9 33.9z','M337 209l17-17L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faTimesHexagon = faHexagonXmark;
  
    var faXmarkHexagon = faHexagonXmark;
  

  
  

  var faCartXmark = {
    prefix: 'fasds',
    iconName: 'cart-xmark',
    icon: [
      576,
      512,
      [],
      'e0dd',
      
      ['M122 32l48.8 256L496 288 576 32 122 32zm143.3 85.6l28.3-28.3L336 131.7l42.4-42.4 28.3 28.3L364.3 160l42.4 42.4-28.3 28.3L336 188.3l-42.4 42.4-28.3-28.3L307.7 160l-42.4-42.4z','M24 0L0 0 0 48l24 0 52.1 0 60.3 316.5 3.7 19.5 19.9 0 328 0 24 0 0-48-24 0-308.1 0L119.6 19.5 115.9 0 96 0 24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM378.4 89.3L336 131.7 293.6 89.3l-28.3 28.3L307.7 160l-42.4 42.4 28.3 28.3L336 188.3l42.4 42.4 28.3-28.3L364.3 160l42.4-42.4L378.4 89.3z']
      
    ]
  };

  

  
  

  var faBowArrow = {
    prefix: 'fasds',
    iconName: 'bow-arrow',
    icon: [
      512,
      512,
      [127993],
      'f6b9',
      
      ['M2.7 144l22.6 22.6c47.7 47.7 95.4 95.4 143 143c11.3 11.3 22.6 22.6 33.9 33.9l143 143L368 509.3 413.3 464 401 451.7c28.1-38 47-81.6 47-131.7c0-58-19.6-116-58.8-163.3c-15.2 15.2-30.3 30.3-45.5 45.5C370.6 236.8 384 278.4 384 320c0 29.9-10.2 58.3-28.9 85.8c-35.8-35.8-71.6-71.6-107.5-107.5c-11.3-11.3-22.6-22.6-33.9-33.9L106.2 156.9C133.7 138.2 162.1 128 192 128c41.6 0 83.2 13.4 117.7 40.3l45.5-45.5C308 83.6 250 64 192 64c-50.1 0-93.7 18.9-131.7 47L48 98.7 2.7 144z','M512 0L352 32l47 47s0 0 0 0L213.7 264.4l33.9 33.9L433 113s0 0 0 0l47 47L512 0zM202.3 343.6l-33.9-33.9-18.5 18.5L96 312 0 408l80 24 24 80 96-96-16.2-53.9 18.5-18.5z']
      
    ]
  };

  

  
  

  var faFileCircleExclamation = {
    prefix: 'fasds',
    iconName: 'file-circle-exclamation',
    icon: [
      576,
      512,
      [],
      'e4eb',
      
      ['M0 0L224 0l0 160 160 0 0 38.6C310.1 219.5 256 287.4 256 368c0 59.5 29.6 112.1 74.8 144L0 512 0 0z','M384 160L224 0l0 160 160 0zm48 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-64l-32 0 0-32 32 0 0 32zm0-176l0 16 0 80 0 16-32 0 0-16 0-80 0-16 32 0z']
      
    ]
  };

  

  
  

  var faEnvelopesBulk = {
    prefix: 'fasds',
    iconName: 'envelopes-bulk',
    icon: [
      640,
      512,
      ["mail-bulk"],
      'f674',
      
      ['M32 306.1c53.3 38.1 106.7 76.2 160 114.3L352 306.1l0 39.3C301.8 381.3 251.5 417.1 201.3 453c-3.1 2.2-6.2 4.4-9.3 6.6c-3.1-2.2-6.2-4.4-9.3-6.6C132.5 417.1 82.2 381.3 32 345.4l0-39.3zM96 0L480 0l0 128-256 0-32 0 0 32 0 64-96 0L96 0zM224 160l32 0 352 0 0 256-224 0 0-160 0-32-32 0-128 0 0-32 0-32zm256 64l0 64 64 0 0-64-64 0z','M544 224l0 64-64 0 0-64 64 0zM32 256l320 0 0 50.1L192 420.3 32 306.1 32 256zM201.3 453L352 345.4 352 512 32 512l0-166.6L182.7 453l9.3 6.6 9.3-6.6z']
      
    ]
  };

  
    var faMailBulk = faEnvelopesBulk;
  

  
  

  var faJarWheat = {
    prefix: 'fasds',
    iconName: 'jar-wheat',
    icon: [
      320,
      512,
      [],
      'e517',
      
      ['M0 64l32 0 256 0 32 0 0 448L0 512 0 64zm64 96c0 35.3 28.7 64 64 64l16 0 32 0 16 0c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0zm0 96c0 35.3 28.7 64 64 64l16 0 32 0 16 0c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0zm0 96c0 35.3 28.7 64 64 64l16 0 0 32 0 16 32 0 0-16 0-32 16 0c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0z','M288 0L32 0l0 64 256 0 0-64zM192 320c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l16 0 32 0 16 0zm0-96c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l16 0 32 0 16 0zm0 192c35.3 0 64-28.7 64-64l-48 0c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7l-48 0c0 35.3 28.7 64 64 64l16 0 0 32 0 16 32 0 0-16 0-32 16 0z']
      
    ]
  };

  

  
  

  var faSpoon = {
    prefix: 'fasds',
    iconName: 'spoon',
    icon: [
      512,
      512,
      [61873,129348,"utensil-spoon"],
      'f2e5',
      
      ['M224 160.2l0 39.6c7.2 7.2 14.3 14.3 21.5 21.5c2.2 2.2 4.4 4.4 6.6 6.6c10.7 10.7 21.3 21.3 32 32c2.2 2.2 4.4 4.4 6.6 6.6L312.2 288l39.6 0C432 288 512 192 512 96c0-53-43-96-96-96C320 0 224 80 224 160.2z','M245.5 221.3l6.6 6.6 32 32 6.6 6.6L70.6 486.6 48 509.3 2.7 464l22.6-22.6L245.5 221.3z']
      
    ]
  };

  
    var faUtensilSpoon = faSpoon;
  

  
  

  var faCheeseSwiss = {
    prefix: 'fasds',
    iconName: 'cheese-swiss',
    icon: [
      512,
      512,
      [129472],
      'f7f0',
      
      ['M0 256l332.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48s48-21.5 48-48c0-12.3-4.6-23.5-12.2-32L512 256C512 132.3 411.7 32 288 32L217.1 87.2c4.4 7.2 6.9 15.7 6.9 24.8c0 26.5-21.5 48-48 48c-13.4 0-25.5-5.5-34.2-14.3L0 256zM128 384a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M368 336c26.5 0 48-21.5 48-48c0-12.3-4.6-23.5-12.2-32L512 256l0 224L0 480 0 256l332.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 26.5 21.5 48 48 48zM224 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z']
      
    ]
  };

  

  
  

  var faHouseBuilding = {
    prefix: 'fasds',
    iconName: 'house-building',
    icon: [
      640,
      512,
      [],
      'e1b1',
      
      ['M320 0L640 0l0 512-224 0 0-160 32 0 0-64-32 0 0-32 32 0 0-64-64 0 0 22.3L320 161 320 0zm64 96l0 64 64 0 0-64-64 0zm128 0l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0zm0 96l0 64 64 0 0-64-64 0z','M0 512L0 256 192 96 384 256l0 256L0 512zM240 368l0-96-96 0 0 96 96 0z']
      
    ]
  };

  

  
  

  var faLeafHeart = {
    prefix: 'fasds',
    iconName: 'leaf-heart',
    icon: [
      512,
      512,
      [],
      'f4cb',
      
      ['M0 440l0 16 0 24 48 0 0-24 0-16c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-50.4-10.5-97.8-29.1-139.1C468.7 63 426.2 96 376 96L272 96c-93.2 0-169.5 72.5-175.6 164.1C38.3 298.8 0 364.9 0 440zM190 235.8c.2-1.7 .4-3.4 .8-5.1c.7-3.4 1.7-6.6 3-9.7c2.6-6.2 6.4-11.8 11.1-16.5c9.4-9.4 22.3-15.2 36.6-15.2c1.2 0 2.4 0 3.5 0c14 0 27.5 5.3 37.8 14.9l5.2 4.8c1.7-1.6 3.4-3.2 5.2-4.8c10.2-9.6 23.8-14.9 37.8-14.9c1.2 0 2.4 0 3.5 0c28.6 0 51.8 23.2 51.8 51.8c0 14.3-5.9 28-16.4 37.8c-23.6 22.1-47.3 44.2-70.9 66.4L288 355.5l-10.9-10.2c-23.6-22.1-47.3-44.2-70.9-66.4c-5.2-4.9-9.3-10.8-12.1-17.2c-1.4-3.2-2.5-6.6-3.2-10c-.4-1.7-.6-3.5-.8-5.2c-.1-1.3-.2-2.6-.2-2.6c-.1-1.3-.1-1.3-.1-2.9c0-.9 0-1.7 .1-2.5c0-.9 .1-1.7 .2-2.6z','M241.5 189.3c-28.6 0-51.8 23.2-51.8 51.8c0 14.3 5.9 28 16.4 37.8l70.9 66.4L288 355.5l10.9-10.2 70.9-66.4c10.5-9.8 16.4-23.5 16.4-37.8c0-28.6-23.2-51.8-51.8-51.8l-3.5 0c-14 0-27.5 5.3-37.8 14.9l-5.2 4.8-5.2-4.8c-10.3-9.6-23.8-14.9-37.8-14.9l-3.5 0z']
      
    ]
  };

  

  
  

  var faArrowsRotateReverse = {
    prefix: 'fasds',
    iconName: 'arrows-rotate-reverse',
    icon: [
      512,
      512,
      [],
      'e630',
      
      ['M44.5 330.6C55.3 361.3 73 390 97.4 414.4C141.1 458.1 198.4 480 255.8 480c57.3 0 114.6-21.9 158.4-65.6l17.6-17.5 0 35.1 0 32 64 0 0-32 0-112 0-32-32 0-112 0-32 0 0 64 32 0 34.4 0L369 369.1c-62.6 62.6-163.9 62.6-226.3 .1c-17.5-17.5-30.1-38-37.8-59.8L44.5 330.6z','M406.7 202.6c-7.7-21.8-20.2-42.3-37.8-59.8c-62.5-62.5-163.8-62.5-226.3 0L125.5 160l34.3 0 32 0 0 64-32 0-112 0-32 0 0-32 0-112 0-32 64 0 0 32 0 35.2L97.4 97.6c87.5-87.5 229.3-87.5 316.8 0c24.4 24.4 42.1 53.1 52.9 83.7l-60.4 21.3z']
      
    ]
  };

  

  
  

  var faArrowDownUpAcrossLine = {
    prefix: 'fasds',
    iconName: 'arrow-down-up-across-line',
    icon: [
      576,
      512,
      [],
      'e4af',
      
      ['','M160 509.3l22.6-22.6 96-96L301.3 368 256 322.7l-22.6 22.6L192 386.7l0-98.7-64 0 0 98.7L86.6 345.4 64 322.7 18.7 368l22.6 22.6 96 96L160 509.3zM128 64l0 160 64 0 0-160 0-32-64 0 0 32zM416 2.7L393.4 25.4l-96 96L274.7 144 320 189.3l22.6-22.6L384 125.3l0 98.7 64 0 0-98.7 41.4 41.4L512 189.3 557.3 144l-22.6-22.6-96-96L416 2.7zM384 448l0 32 64 0 0-32 0-160-64 0 0 160z']
      
    ]
  };

  

  
  

  var faSpaghettiMonsterFlying = {
    prefix: 'fasds',
    iconName: 'spaghetti-monster-flying',
    icon: [
      640,
      512,
      ["pastafarianism"],
      'f67b',
      
      ['M0 200l0 48 24 0c2.5 0 4.3 .6 7.1 3.3c3.7 3.5 7.1 8.8 12.5 17.4l.6 .9c4.6 7.4 11 17.6 19.4 25.7C73.3 304.6 86.5 312 104 312c18.5 0 32.9-8.5 44.3-18.6c3.1 4 6.6 8.3 10.5 12.7c-1.4 4.3-2.8 8.5-4 12.5c-.9 3-1.8 5.8-2.6 8.6c-3 9.8-5.5 18.2-8.6 25.9c-3.9 9.8-7.4 15.4-10.8 18.5c-2.6 2.4-5.9 4.3-12.8 4.3c-8.7 0-16.9-4.2-33.7-13.2c-15-8-35.7-18.8-62.3-18.8L0 344l0 48 24 0c13.4 0 24.7 5.2 39.7 13.2c1 .6 2.1 1.1 3.2 1.7C80.1 414 98.6 424 120 424c18.4 0 33.6-6.1 45.5-17.2c11.1-10.3 17.9-23.7 22.7-36c3.6-9 6.7-19.1 9.5-28.5c16.4 12.3 36.1 23.6 58.9 31.3c-3.6 10.8-8.4 23.5-14.4 36.2c-7.5 15.9-16.2 30.4-25.8 40.5C207 460.5 198.8 464 192 464l-24 0 0 48 24 0c25.2 0 45-13.5 59.5-28.8c14.5-15.4 25.7-34.9 34.2-53c8-17 14.1-33.8 18.3-46.9c5.2 .4 10.6 .6 16 .6s10.8-.2 16-.6c4.2 13 10.3 29.9 18.3 46.9c8.5 18.1 19.8 37.6 34.2 53C403 498.5 422.8 512 448 512l24 0 0-48-24 0c-6.8 0-15-3.5-24.5-13.7c-9.5-10.1-18.3-24.6-25.8-40.5c-5.9-12.6-10.7-25.4-14.4-36.2c22.8-7.7 42.5-19 58.9-31.3c2.9 9.4 6 19.5 9.5 28.5c4.8 12.2 11.6 25.6 22.7 36C486.4 417.9 501.6 424 520 424c21.4 0 39.9-10 53.1-17.1c1.1-.6 2.2-1.2 3.2-1.7c15-8 26.3-13.2 39.7-13.2l24 0 0-48-24 0c-26.6 0-47.3 10.8-62.3 18.8c-16.8 9-25 13.2-33.7 13.2c-6.8 0-10.2-1.9-12.8-4.3c-3.4-3.2-7-8.8-10.8-18.5c-3-7.7-5.6-16.1-8.6-25.9c-.8-2.7-1.7-5.6-2.6-8.6c-1.2-4-2.6-8.2-4-12.5c3.9-4.5 7.4-8.8 10.5-12.7C503.1 303.5 517.5 312 536 312c17.5 0 30.7-7.4 40.4-16.7c8.4-8.1 14.8-18.3 19.4-25.7l.6-.9c5.4-8.6 8.8-13.9 12.5-17.4c2.8-2.7 4.6-3.3 7.1-3.3l24 0 0-48-24 0c-17.5 0-30.7 7.4-40.4 16.7c-8.4 8.1-14.8 18.3-19.4 25.7l-.6 .9c-5.4 8.6-8.8 13.9-12.5 17.4c-2.8 2.7-4.6 3.3-7.1 3.3c-3.3 0-8.7-1.7-19.4-13.4c-5.1-5.6-10.4-12.3-16.7-20.4l-1.4-1.8c-5.8-7.4-12.2-15.7-19.3-24c-13.8-16.2-30.4-32.8-51.4-46.4l15.1-30.2c-17.1-1.3-32.3-9.4-42.9-21.5l-15.6 31.2c-18.7-6-39.9-9.5-64.4-9.5s-45.8 3.5-64.4 9.5L240 106.3c-10.7 12.1-25.9 20.1-42.9 21.5L212.2 158c-21.1 13.6-37.7 30.2-51.4 46.4c-7.1 8.3-13.5 16.6-19.3 24l-1.4 1.8c-6.3 8.1-11.6 14.8-16.7 20.4C112.7 262.3 107.3 264 104 264c-2.5 0-4.3-.6-7.1-3.3c-3.7-3.5-7.1-8.8-12.5-17.4l-.6-.9c-4.6-7.4-11-17.6-19.4-25.7C54.7 207.4 41.5 200 24 200L0 200z','M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 128 64zm336 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 384 64z']
      
    ]
  };

  
    var faPastafarianism = faSpaghettiMonsterFlying;
  

  
  

  var faTruckFlatbed = {
    prefix: 'fasds',
    iconName: 'truck-flatbed',
    icon: [
      640,
      512,
      [],
      'e2b6',
      
      ['M96 432a80 80 0 1 0 160 0A80 80 0 1 0 96 432zm288 0a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z','M353.1 416c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96l33.1 0 32 0 0-64-32 0 0-64 0-32 0-32 0-13.3-9.4-9.4-96-96L493.3 96 480 96l-64 0-16 0-48 0 0 256-97.6 0c17.1 16.8 28.9 39.1 32.5 64l65.1 0 1.1 0zM97.6 352L0 352l0 64 65.1 0c3.6-24.9 15.3-47.2 32.5-64zM544 256l-128 0 0-96 50.7 0L544 237.3l0 18.7z']
      
    ]
  };

  

  
  

  var faClarinet = {
    prefix: 'fasds',
    iconName: 'clarinet',
    icon: [
      640,
      512,
      [],
      'f8ad',
      
      ['M0 229.2L0 240l0 64 0 10.8 10.1 4 80 32 2.9 1.1 3.1 0 475.2 0 44 29.3L640 397.9l0-29.9 0-192 0-29.9-24.9 16.6-44 29.3c-30.4 0-60.8 0-91.2 0c-10.7 0-21.3 0-32 0c-21.3 0-42.7 0-64 0c-10.7 0-21.3 0-32 0c-21.3 0-42.7 0-64 0c-10.7 0-21.3 0-32 0L96 192l-3.1 0-2.9 1.1-80 32L0 229.2zM296 272a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z','M240 128l-16 0 0 32 16 0 16 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 64 0 0 32 32 0 0-32 16 0 16 0 0-32-16 0-32 0-96 0-96 0-32 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faBong = {
    prefix: 'fasds',
    iconName: 'bong',
    icon: [
      448,
      512,
      [],
      'f55c',
      
      ['M0 384c0 49.2 18.5 94 48.9 128l286.2 0c30.4-34 48.9-78.8 48.9-128c0-36.1-10-69.9-27.3-98.8L400 241.9l7 7 17 17L457.9 232l-17-17-24-24-24-24-17-17L342.1 184l17 17 7 7-39.3 39.3c-11.6-11.4-24.6-21.4-38.8-29.6L288 64l32 0 0-64L288 0 224 0 160 0 96 0 64 0l0 64 32 0 0 153.7C38.6 250.9 0 312.9 0 384zm64 0c0-23.3 6.2-45.2 17.1-64c11.2-19.4 27.4-35.6 46.9-46.9l32-18.5 0-36.9L160 64l64 0 0 153.7 0 36.9 32 18.5c19.5 11.3 35.7 27.5 46.9 46.9c10.9 18.8 17.1 40.7 17.1 64c0 23.4-6.2 45.2-17.1 64L81.1 448C70.2 429.2 64 407.4 64 384z','M302.9 320L81.1 320C70.2 338.8 64 360.7 64 384c0 23.4 6.2 45.2 17.1 64l221.8 0c10.9-18.8 17.1-40.6 17.1-64c0-23.3-6.2-45.2-17.1-64z']
      
    ]
  };

  

  
  

  var faCameraMovie = {
    prefix: 'fasds',
    iconName: 'camera-movie',
    icon: [
      576,
      512,
      [127909,127910],
      'f8a9',
      
      ['M0 256l0 64 32 0 32 0 0 192 384 0 0-64 0-128 0-64-96 0-192 0-32 0-64 0-32 0L0 256z','M128 64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM352 256l-224 0C57.3 256 0 198.7 0 128S57.3 0 128 0c48.2 0 90.2 26.6 112 66C261.8 26.6 303.8 0 352 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zm0-192a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM576 256l0 256L448 448l0-128 128-64z']
      
    ]
  };

  

  
  

  var faSigma = {
    prefix: 'fasds',
    iconName: 'sigma',
    icon: [
      384,
      512,
      [8721],
      'f68b',
      
      ['M0 480l32 0 320 0 32 0 0-32 0-64 0-32-64 0 0 32 0 32-210.7 0L246.6 278.6 269.3 256l-22.6-22.6L109.3 96 320 96l0 32 0 32 64 0 0-32 0-64 0-32-32 0L32 32 0 32 0 77.3l9.4 9.4L178.7 256 9.4 425.4 0 434.7 0 480z','']
      
    ]
  };

  

  
  

  var faFaceGrinStars = {
    prefix: 'fasds',
    iconName: 'face-grin-stars',
    icon: [
      512,
      512,
      [129321,"grin-stars"],
      'f587',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm81.5-89.5l16.6-2.2 38.1-5 16.6-34.7 7.2-15.1c2.4 5 4.8 10.1 7.2 15.1l16.6 34.7c12.7 1.7 25.4 3.4 38.1 5c5.5 .7 11.1 1.5 16.6 2.2c-4.1 3.8-8.1 7.7-12.2 11.5c-9.3 8.8-18.6 17.7-27.9 26.5l7 37.8 3.1 16.5c-4.9-2.7-9.8-5.3-14.7-8c-11.3-6.1-22.5-12.2-33.8-18.3c-11.3 6.1-22.5 12.2-33.8 18.3c-4.9 2.7-9.8 5.3-14.7 8c1-5.5 2-11 3.1-16.5l7-37.8c-9.3-8.8-18.6-17.7-27.9-26.5c-4.1-3.8-8.1-7.7-12.2-11.5zM96 302.8c46.2 18.3 101.2 29 160.2 29s114.1-10.6 160.2-29C400.3 376.7 334.7 432 256.3 432s-144-55.3-160.2-129.2zM273.5 166.5l16.6-2.2c12.7-1.7 25.4-3.4 38.1-5l16.6-34.7 7.2-15.1 7.2 15.1 16.6 34.7 38.1 5 16.6 2.2L418.4 178l-27.9 26.5 7 37.8 3.1 16.5-14.7-8L352 232.5l-33.8 18.3-14.7 8c1-5.5 2-11 3.1-16.5l7-37.8c-9.3-8.8-18.6-17.7-27.9-26.5c-4.1-3.8-8.1-7.7-12.2-11.5z','M167.2 124.6L160 109.4l-7.2 15.1-16.6 34.7-38.1 5-16.6 2.2L93.6 178l27.9 26.5-7 37.8-3.1 16.5 14.7-8L160 232.5l33.8 18.3 14.7 8-3.1-16.5-7-37.8L226.4 178l12.2-11.5-16.6-2.2-38.1-5-16.6-34.7zm192 0L352 109.4l-7.2 15.1-16.6 34.7-38.1 5-16.6 2.2L285.6 178l27.9 26.5-7 37.8-3.1 16.5 14.7-8L352 232.5l33.8 18.3 14.7 8-3.1-16.5-7-37.8L418.4 178l12.2-11.5-16.6-2.2-38.1-5-16.6-34.7z']
      
    ]
  };

  
    var faGrinStars = faFaceGrinStars;
  

  
  

  var faSquareP = {
    prefix: 'fasds',
    iconName: 'square-p',
    icon: [
      448,
      512,
      [],
      'e279',
      
      ['M0 32L0 480l448 0 0-448L0 32zm128 96l24 0 92 0c50.8 0 92 41.2 92 92l0 24-3.2 0c-10.6 39.2-46.3 68-88.8 68l-68 0 0 48 0 24-48 0 0-24 0-72 0-136 0-24zm48 48l0 88 68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0z','M128 128l24 0 92 0c50.8 0 92 41.2 92 92l0 24-3.2 0c-10.6 39.2-46.3 68-88.8 68l-68 0 0 48 0 24-48 0 0-24 0-72 0-136 0-24zm48 136l68 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-68 0 0 88z']
      
    ]
  };

  

  
  

  var faBringForward = {
    prefix: 'fasds',
    iconName: 'bring-forward',
    icon: [
      512,
      512,
      [],
      'f856',
      
      ['M160 352l0 96 0 64 64 0 224 0 64 0 0-64 0-224 0-64-64 0-96 0 0 64 96 0 0 224-224 0 0-96-64 0z','M0 352H352V0H0V352z']
      
    ]
  };

  

  
  

  var faRecordVinyl = {
    prefix: 'fasds',
    iconName: 'record-vinyl',
    icon: [
      512,
      512,
      [],
      'f8d9',
      
      ['M128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384a128 128 0 1 1 0 256 128 128 0 1 1 0-256z']
      
    ]
  };

  

  
  

  var faTruckPlane = {
    prefix: 'fasds',
    iconName: 'truck-plane',
    icon: [
      640,
      512,
      [],
      'e58f',
      
      ['M0 288l0 80 144-37.7 0 81.2L88 456l0 56 112-31.1 56 19.8L256 96l0-9.9C256 54.7 231.5 0 200 0c-30.6 0-56 54.7-56 86.1l0 106.5L0 288z','M640 128l-352 0 0 320 32 0 0 64 64 0 0-64 160 0 0 64 64 0 0-64 32 0 0-320zM376 240l176 0 24 64-224 0 24-64zM544 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM360 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48z']
      
    ]
  };

  

  
  

  var faCircleHeart = {
    prefix: 'fasds',
    iconName: 'circle-heart',
    icon: [
      512,
      512,
      ["heart-circle"],
      'f4c7',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm112-28.4c0-41.8 33.9-75.6 75.6-75.6c23 0 44.7 10.4 59.1 28.4l9.3 11.6 9.3-11.6c14.4-17.9 36.1-28.4 59.1-28.4c41.8 0 75.6 33.9 75.6 75.6l0 3.6c0 21-8.3 41.1-23.2 56L352 311.9l-96 96-96-96-24.8-24.8c-14.9-14.9-23.2-35-23.2-56l0-3.6z','M160 311.9l-24.8-24.8c-14.9-14.9-23.2-35-23.2-56l0-3.6c0-41.8 33.9-75.6 75.6-75.6c23 0 44.7 10.4 59.1 28.4l9.3 11.6 9.3-11.6c14.4-17.9 36.1-28.4 59.1-28.4c41.8 0 75.6 33.9 75.6 75.6l0 3.6c0 21-8.3 41.1-23.2 56L352 311.9l-96 96-96-96z']
      
    ]
  };

  
    var faHeartCircle = faCircleHeart;
  

  
  

  var faChevronsLeft = {
    prefix: 'fasds',
    iconName: 'chevrons-left',
    icon: [
      512,
      512,
      ["chevron-double-left"],
      'f323',
      
      ['M210.7 256l22.6-22.6 192-192L448 18.7 493.3 64 470.6 86.6 301.3 256 470.6 425.4 493.3 448 448 493.3l-22.6-22.6-192-192L210.7 256z','M18.7 256l22.6-22.6 192-192L256 18.7 301.3 64 278.6 86.6 109.3 256 278.6 425.4 301.3 448 256 493.3l-22.6-22.6-192-192L18.7 256z']
      
    ]
  };

  
    var faChevronDoubleLeft = faChevronsLeft;
  

  
  

  var faUnion = {
    prefix: 'fasds',
    iconName: 'union',
    icon: [
      384,
      512,
      [8899],
      'f6a2',
      
      ['M64 32l0 32 0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224 0-32 64 0 0 32 0 224c0 106-86 192-192 192S0 394 0 288L0 64 0 32l64 0z','']
      
    ]
  };

  

  
  

  var faMenorah = {
    prefix: 'fasds',
    iconName: 'menorah',
    icon: [
      640,
      512,
      [],
      'f676',
      
      ['M0 64.4C0 81.8 14.2 96 31.6 96l.8 0C49.8 96 64 81.8 64 64.4c0-5.5-1.4-10.9-4.2-15.7L32 0 4.2 48.7C1.4 53.5 0 58.9 0 64.4zm96 0C96 81.8 110.2 96 127.6 96l.8 0C145.8 96 160 81.8 160 64.4c0-5.5-1.4-10.9-4.2-15.7L128 0 100.2 48.7C97.4 53.5 96 58.9 96 64.4zm96 0C192 81.8 206.2 96 223.6 96l.8 0C241.8 96 256 81.8 256 64.4c0-5.5-1.4-10.9-4.2-15.7L224 0 196.2 48.7c-2.7 4.8-4.2 10.2-4.2 15.7zm96 0C288 81.8 302.2 96 319.6 96l.8 0C337.8 96 352 81.8 352 64.4c0-5.5-1.4-10.9-4.2-15.7L320 0 292.2 48.7c-2.7 4.8-4.2 10.2-4.2 15.7zm96 0C384 81.8 398.2 96 415.6 96l.8 0C433.8 96 448 81.8 448 64.4c0-5.5-1.4-10.9-4.2-15.7L416 0 388.2 48.7c-2.7 4.8-4.2 10.2-4.2 15.7zm96 0C480 81.8 494.2 96 511.6 96l.8 0C529.8 96 544 81.8 544 64.4c0-5.5-1.4-10.9-4.2-15.7L512 0 484.2 48.7c-2.7 4.8-4.2 10.2-4.2 15.7zm96 0C576 81.8 590.2 96 607.6 96l.8 0C625.8 96 640 81.8 640 64.4c0-5.5-1.4-10.9-4.2-15.7L608 0 580.2 48.7c-2.7 4.8-4.2 10.2-4.2 15.7z','M64 160l0-32L0 128l0 32L0 288c0 53 43 96 96 96l192 0 0 64-128 0-32 0 0 64 32 0 160 0 160 0 32 0 0-64-32 0-128 0 0-64 192 0c53 0 96-43 96-96l0-128 0-32-64 0 0 32 0 128c0 17.7-14.3 32-32 32l-192 0 0-160 0-32-64 0 0 32 0 160L96 320c-17.7 0-32-14.3-32-32l0-128zm96 0l0-32-64 0 0 32 0 128 64 0 0-128zm96 0l0-32-64 0 0 32 0 128 64 0 0-128zm192 0l0-32-64 0 0 32 0 128 64 0 0-128zm96 0l0-32-64 0 0 32 0 128 64 0 0-128z']
      
    ]
  };

  

  
  

  var faFileCsv = {
    prefix: 'fasds',
    iconName: 'file-csv',
    icon: [
      512,
      512,
      [],
      'f6dd',
      
      ['M0 0L224 0l0 160 160 0 0 144-272 0 0 208L0 512 0 0z','M384 160L224 0l0 160 160 0zM200 352c-22.1 0-40 17.9-40 40l0 80c0 22.1 17.9 40 40 40l16 0c22.1 0 40-17.9 40-40l0-8 0-16-32 0 0 16 0 8c0 4.4-3.6 8-8 8l-16 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l16 0c4.4 0 8 3.6 8 8l0 8 0 16 32 0 0-16 0-8c0-22.1-17.9-40-40-40l-16 0zm133.1 0c-24.9 0-45.1 20.2-45.1 45.1c0 17.8 10.5 34 26.8 41.2l37.4 16.6c4.7 2.1 7.8 6.8 7.8 12c0 7.2-5.9 13.1-13.1 13.1L304 480l-16 0 0 32 16 0 42.9 0c24.9 0 45.1-20.2 45.1-45.1c0-17.8-10.5-34-26.8-41.2l-37.4-16.6c-4.7-2.1-7.8-6.8-7.8-12c0-7.2 5.9-13.1 13.1-13.1l34.9 0 16 0 0-32-16 0-34.9 0zM448 352l-32 0 0 16 0 35c0 21.1 3.8 42 11.2 61.8L441 501.6l3.9 10.4 11.1 0 16 0 11.1 0 3.9-10.4 13.8-36.8C508.2 445 512 424.1 512 403l0-35 0-16-32 0 0 16 0 35c0 17.3-3.1 34.4-9.2 50.6L464 471.8l-6.8-18.2c-6.1-16.2-9.2-33.3-9.2-50.6l0-35 0-16z']
      
    ]
  };

  

  
  

  var faLaptop = {
    prefix: 'fasds',
    iconName: 'laptop',
    icon: [
      640,
      512,
      [128187],
      'f109',
      
      ['M0 384l0 48 48 48 544 0 48-48 0-48L0 384zM64 32l0 32 0 288 64 0 0-256 384 0 0 256 64 0 0-288 0-32-32 0L96 32 64 32z','M128 96H512V352H128V96z']
      
    ]
  };

  

  
  

  var faPerson = {
    prefix: 'fasds',
    iconName: 'person',
    icon: [
      320,
      512,
      [129485,"male"],
      'f183',
      
      ['M112 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0z','M108.9 128l-17.5 0L82 142.8 .2 270.8l53.9 34.4 33.8-53L88 480l0 32 64 0 0-32 0-128 16 0 0 128 0 32 64 0 0-32 0-227.8 33.8 53 53.9-34.4L238 142.8 228.6 128l-17.5 0-102.2 0z']
      
    ]
  };

  
    var faMale = faPerson;
  

  
  

  var faFireFlameSimple = {
    prefix: 'fasds',
    iconName: 'fire-flame-simple',
    icon: [
      384,
      512,
      ["burn"],
      'f46a',
      
      ['M0 320.2C0 425.4 86.8 512 192 512s192-86.6 192-191.8c0-21.1-3.7-42.3-10.9-62.2c-34.8-95.8-93.3-181.2-170-248.3L192 0 180.9 9.7C104.2 76.8 45.7 162.2 10.9 258C3.7 277.8 0 299 0 320.2zm96 15.3c0-10.1 2.1-20.3 6.2-29.5l.9-2.1c16.4-36.8 40.5-69.6 70.8-96.1L192 192l18 15.7c30.3 26.5 54.5 59.3 70.8 96.1l.9 2.1c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5z','M280.8 303.9l.9 2.1c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l.9-2.1c16.4-36.8 40.5-69.6 70.8-96.1L192 192l18 15.7c30.3 26.5 54.5 59.3 70.8 96.1z']
      
    ]
  };

  
    var faBurn = faFireFlameSimple;
  

  
  

  var faPersonCarryBox = {
    prefix: 'fasds',
    iconName: 'person-carry-box',
    icon: [
      384,
      512,
      ["person-carry"],
      'f4cf',
      
      ['M192 96l0 128 32 0 32 0 0 64 128 0 0-192L192 96z','M32 48a48 48 0 1 1 96 0A48 48 0 1 1 32 48zM0 346.5l64 64L64 480s0 0 0 0l0 32L0 512l0-32L0 346.5zM0 128l32 0 48 0 17.1 0 9.5 14.3L161.1 224l62.9 0 32 0 0 64-32 0-80 0-17.1 0-9.5-14.3L96 241.7l0 65.1 54.6 54.6 7.3 7.3 1.7 10.1 8 48 4 24 4 24s0 0 0 0l4 24 2.2 13.3-64.9 0-.5-2.7-4-24s0 0 0 0l-4-24-4-24-6.3-37.9L41.4 342.6 18.7 320C6.7 308 0 291.7 0 274.7L0 160l0-32z']
      
    ]
  };

  
    var faPersonCarry = faPersonCarryBox;
  

  
  

  var faArrowUpLong = {
    prefix: 'fasds',
    iconName: 'arrow-up-long',
    icon: [
      384,
      512,
      ["long-arrow-up"],
      'f176',
      
      ['M160 122.5c10.7-10.7 21.3-21.3 32-32c10.7 10.7 21.3 21.3 32 32L224 480l0 32-64 0 0-32 0-357.5z','M192 0L169.4 22.6l-128 128L18.7 173.3 64 218.5l22.6-22.6L192 90.5 297.4 195.9 320 218.5l45.3-45.3-22.6-22.6-128-128L192 0z']
      
    ]
  };

  
    var faLongArrowUp = faArrowUpLong;
  

  
  

  var faCalendarCircleUser = {
    prefix: 'fasds',
    iconName: 'calendar-circle-user',
    icon: [
      576,
      512,
      [],
      'e471',
      
      ['M0 64l0 96 448 0 0-96-96 0 0-64L288 0l0 64L160 64l0-64L96 0l0 64L0 64zM0 192L0 512l330.8 0C285.6 480.1 256 427.5 256 368c0-91.8 70.3-167.2 160-175.3l0-.7L0 192z','M432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-32c-31.7 0-60.3-13.2-80.7-34.3L376 416l112 0 24.7 29.7c-20.4 21.2-49 34.3-80.7 34.3zm0-192a48 48 0 1 1 0 96 48 48 0 1 1 0-96z']
      
    ]
  };

  

  
  

  var faTransporter = {
    prefix: 'fasds',
    iconName: 'transporter',
    icon: [
      512,
      512,
      [],
      'e042',
      
      ['M0 112l32 16 16 32 16-32 32-16L64 96 48 64 32 96 0 112zM416 48l32 16 16 32 16-32 32-16L480 32 464 0 448 32 416 48z','M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm-18.4 80l15.4 0 102.2 0 15.4 0 9.6 12L409 236l20 25L379 301l-20-25-31-38.7L328 416l-64 0 0-96-16 0 0 96-64 0 0-178.7L153 276l-20 25L83 261l20-25L180 140l9.6-12zM296 512l-80 0L96 512l0-64 320 0 0 64-120 0z']
      
    ]
  };

  

  
  

  var faDiagramPredecessor = {
    prefix: 'fasds',
    iconName: 'diagram-predecessor',
    icon: [
      512,
      512,
      [],
      'e477',
      
      ['M0 288L0 480l512 0 0-192L0 288z','M288 224l0-128 96 0 0 32-64 0 0 32 96 96 96-96 0-32-64 0 0-64 0-32-32 0L288 32l-80 0L0 32 0 224l288 0z']
      
    ]
  };

  

  
  

  var faCrateEmpty = {
    prefix: 'fasds',
    iconName: 'crate-empty',
    icon: [
      512,
      512,
      [],
      'e151',
      
      ['M0 224L0 352l512 0 0-128L0 224zM0 384L0 512l512 0 0-128L0 384zm80-96a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM464 288a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm0 160a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z','M64 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0 160a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM464 288a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM448 464a16 16 0 1 0 0-32 16 16 0 1 0 0 32z']
      
    ]
  };

  

  
  

  var faBeerMugEmpty = {
    prefix: 'fasds',
    iconName: 'beer-mug-empty',
    icon: [
      512,
      512,
      ["beer"],
      'f0fc',
      
      ['M32 32l352 0 0 64 96 0 32 0 0 32 0 176 0 20.8-19 8.4L384 381.7l0 98.3L32 480 32 32zm96 96l0 16 0 224 0 16 32 0 0-16 0-224 0-16-32 0zm64 0l0 16 0 224 0 16 32 0 0-16 0-224 0-16-32 0zm64 0l0 16 0 224 0 16 32 0 0-16 0-224 0-16-32 0zm128 32l0 151.6 64-28.4L448 160l-64 0z','M160 128l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0zm64 0l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0zm64 0l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0z']
      
    ]
  };

  
    var faBeer = faBeerMugEmpty;
  

  
  

  var faPeopleLine = {
    prefix: 'fasds',
    iconName: 'people-line',
    icon: [
      640,
      512,
      [],
      'e534',
      
      ['M7.4 358.1l42 23.3 11.7-21 27-48.6L88 384l112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21-35.2-63.5 3.4-6.3L264 217.5l0 86.5 112 0 0-86.5 26.9 49.9 3.4 6.3L371 337.1l-11.7 21 42 23.3 11.7-21 27-48.6 0 72.2 112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21L565 236.3 558.1 224 544 224l-96 0-14 0-44.9-83.4L382.3 128 368 128l-96 0-14.3 0-6.8 12.6L206 224l-14 0-96 0-14.1 0L75 236.3 19 337.1l-11.7 21zM104 168a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM280 72a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176 96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M0 416l32 0 576 0 32 0 0 64-32 0L32 480 0 480l0-64z']
      
    ]
  };

  

  
  

  var faLightbulbExclamationOn = {
    prefix: 'fasds',
    iconName: 'lightbulb-exclamation-on',
    icon: [
      640,
      512,
      [],
      'e1ca',
      
      ['M144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c19.8 27.1 39.7 54.4 49.2 86.2l160 0c9.6-31.9 29.5-59.1 49.2-86.2c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176zM296 64l48 0 0 24 0 112 0 24-48 0 0-24 0-112 0-24zm0 192l48 0 0 48-48 0 0-48z','M87.3 16l6 4 24 16 20 13.3L110.7 89.3 90.7 76l-24-16-6-4-20-13.3L67.3 2.7 87.3 16zM579.3 56l-6 4-24 16-20 13.3L502.7 49.3l20-13.3 24-16 6-4 20-13.3 26.6 39.9L579.3 56zM24 160l50 0 24 0 0 48-24 0-50 0L0 208l0-48 24 0zm542 0l50 0 24 0 0 48-24 0-50 0-24 0 0-48 24 0zM117.3 332l-24 16-6 4-20 13.3L40.7 325.3l20-13.3 6-4 24-16 20-13.3 26.6 39.9-20 13.3zm432-39.9l24 16 6 4 20 13.3-26.6 39.9-20-13.3-6-4-24-16-20-13.3 26.6-39.9 20 13.3zM240 512l0-128 160 0 0 128-160 0z']
      
    ]
  };

  

  
  

  var faLocationPlus = {
    prefix: 'fasds',
    iconName: 'location-plus',
    icon: [
      384,
      512,
      ["map-marker-plus"],
      'f60a',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm80-24l24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0 0-24 0-64-64 0-24 0 0-48z','M168 280l0 24 48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64z']
      
    ]
  };

  
    var faMapMarkerPlus = faLocationPlus;
  

  
  

  var faSquareArrowRight = {
    prefix: 'fasds',
    iconName: 'square-arrow-right',
    icon: [
      448,
      512,
      ["arrow-square-right"],
      'f33b',
      
      ['M0 32L0 480l448 0 0-448L0 32zM80 232c8 0 16 0 24 0c60.7 0 121.4 0 182.1 0c-23.7-23.7-47.4-47.4-71-71c-5.7-5.7-11.3-11.3-17-17L232 110.1c5.7 5.7 11.3 11.3 17 17c37.3 37.3 74.7 74.7 112 112c5.7 5.7 11.3 11.3 17 17c-5.7 5.7-11.3 11.3-17 17c-37.3 37.3-74.7 74.7-112 112c-5.7 5.7-11.3 11.3-17 17c-11.3-11.3-22.6-22.6-33.9-33.9c5.7-5.7 11.3-11.3 17-17c23.7-23.7 47.4-47.4 71-71c-60.7 0-121.4 0-182.1 0c-8 0-16 0-24 0c0-16 0-32 0-48z','M377.9 256l-17 17L249 385l-17 17L198.1 368l17-17 71-71L104 280l-24 0 0-48 24 0 182.1 0-71-71-17-17L232 110.1l17 17L361 239l17 17z']
      
    ]
  };

  
    var faArrowSquareRight = faSquareArrowRight;
  

  
  

  var faPeopleRoof = {
    prefix: 'fasds',
    iconName: 'people-roof',
    icon: [
      640,
      512,
      [],
      'e537',
      
      ['M7.4 486.1l42 23.3 11.7-21 27-48.6L88 512l112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21-35.2-63.4 3.4-6.3L264 345.5l0 86.5 112 0 0-86.5 26.9 49.9 3.4 6.3L371 465.1l-11.7 21 42 23.3 11.7-21 27-48.6 0 72.2 112 0 0-72.2 27 48.6 11.7 21 42-23.3-11.7-21L565 364.3 558.1 352 544 352l-96 0-14 0-44.9-83.4L382.3 256 368 256l-96 0-14.3 0-6.8 12.6L206 352l-14 0-96 0-14.1 0L75 364.3 19 465.1l-11.7 21zM104 296a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176-96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm176 96a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z','M320 3.3l15.6 8.7 272 152 27.9 15.6-31.2 55.9-27.9-15.6L320 76.7 63.6 219.9 35.7 235.5 4.5 179.7l27.9-15.6 272-152L320 3.3z']
      
    ]
  };

  

  
  

  var faUsersRectangle = {
    prefix: 'fasds',
    iconName: 'users-rectangle',
    icon: [
      640,
      512,
      [],
      'e594',
      
      ['M96 336l94.3 0 19.4-58.1 7.3-21.9L120 256 96 336zm31.8-160a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM208 384l224 0-16-48-16-48-17.6 0-124.8 0L240 288l-16 48-16 48zm48-192a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zm160-16a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm7.1 80l7.3 21.9L449.7 336l94.3 0-24-80-96.9 0z','M0 0L32 0 608 0l32 0 0 32 0 448 0 32-32 0L32 512 0 512l0-32L0 32 0 0zM64 64l0 384 512 0 0-384L64 64z']
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fasds',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      ['M18.7 96l22.6 22.6 160 160L224 301.3l22.6-22.6 160-160L429.3 96 384 50.7 361.4 73.4 224 210.7 86.6 73.4 64 50.7 18.7 96z','M224 493.3l22.6-22.6 160-160L429.3 288 384 242.7l-22.6 22.6L224 402.7 86.6 265.4 64 242.7 18.7 288l22.6 22.6 160 160L224 493.3z']
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faCrop = {
    prefix: 'fasds',
    iconName: 'crop',
    icon: [
      512,
      512,
      [],
      'f125',
      
      ['M64 0l0 32 0 32 0 64 0 288 0 32 32 0 288 0 0-64-210.7 0L384 173.3l0-45.3-45.3 0L128 338.7 128 128l0-64 0-32 0-32L64 0zM402.7 64L416 64l32 0 0 32 0 13.3 62.6-62.6L465.4 1.4 402.7 64zM448 384l0 64 32 0 32 0 0-64-32 0-32 0z','M32 64L0 64l0 64 32 0 32 0 0-64L32 64zM384 480l0 32 64 0 0-32 0-384 0-32-32 0L128 64l0 64 256 0 0 352z']
      
    ]
  };

  

  
  

  var faSchoolCircleExclamation = {
    prefix: 'fasds',
    iconName: 'school-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e56c',
      
      ['M0 96L0 512l256 0 0-96c0-35.3 28.7-64 64-64l.7 0c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8L640 96 480 96 320 0 160 96 0 96zm80 96l64 0 0 96-64 0 0-96zm0 128l64 0 0 96-64 0 0-96zM304 128l0 16 0 32 0 16 16 0 32 0 16 0 0-32-16 0-16 0 0-16 0-16-32 0z','M352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm160 48l-32 0 0 32 32 0 0-32zm0-128l0-16-32 0 0 16 0 80 0 16 32 0 0-16 0-80z']
      
    ]
  };

  

  
  

  var faUserVneck = {
    prefix: 'fasds',
    iconName: 'user-vneck',
    icon: [
      448,
      512,
      [],
      'e461',
      
      ['M352 128A128 128 0 1 1 96 128a128 128 0 1 1 256 0z','M138.7 304L224 432l85.3-128 74.7 0 64 208L0 512 64 304l74.7 0z']
      
    ]
  };

  

  
  

  var faFootball = {
    prefix: 'fasds',
    iconName: 'football',
    icon: [
      512,
      512,
      [127944,"football-ball"],
      'f44e',
      
      ['M16.8 306.7c2.1-19.2 5.4-38.6 10.1-57.8L264.5 486.6c-18.3 4.4-37.7 7.6-58.4 9.5L16.8 306.7zM247.5 25.4c18.3-4.4 37.7-7.6 58.4-9.5C369 79.1 432.1 142.2 495.2 205.3c-2.1 19.2-5.4 38.6-10.1 57.8C405.9 183.8 326.7 104.6 247.5 25.4z','M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6C47.8 183.4 35.1 215.9 26.9 249L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4l-4.4-21.5-21.6-3.6c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4l4.4 21.5 21.6 3.6c58.2 9.7 109.9 12 155.6 7.9zM272 153.4l11.3 11.3 64 64L358.6 240 336 262.6l-11.3-11.3-64-64L249.4 176 272 153.4zm-48 48l11.3 11.3 64 64L310.6 288 288 310.6l-11.3-11.3-64-64L201.4 224 224 201.4zm-48 48l11.3 11.3 64 64L262.6 336 240 358.6l-11.3-11.3-64-64L153.4 272 176 249.4z']
      
    ]
  };

  
    var faFootballBall = faFootball;
  

  
  

  var faChevronsUp = {
    prefix: 'fasds',
    iconName: 'chevrons-up',
    icon: [
      512,
      512,
      ["chevron-double-up"],
      'f325',
      
      ['M18.7 448L64 493.3l22.6-22.6L256 301.3 425.4 470.6 448 493.3 493.3 448l-22.6-22.6-192-192L256 210.7l-22.6 22.6-192 192L18.7 448z','M256 18.7l22.6 22.6 192 192L493.3 256 448 301.3l-22.6-22.6L256 109.3 86.6 278.6 64 301.3 18.7 256l22.6-22.6 192-192L256 18.7z']
      
    ]
  };

  
    var faChevronDoubleUp = faChevronsUp;
  

  
  

  var faFlagCheckered = {
    prefix: 'fasds',
    iconName: 'flag-checkered',
    icon: [
      448,
      512,
      [127937],
      'f11e',
      
      ['M64 150.2l69-17.2c19.4-4.9 39.4-6.1 59-3.8l0 96c-19.6-2.3-39.6-1.1-59 3.8L64 246.2l0-96zM192 27c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 102.2c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3L192 27zm0 198.2c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 109.1c-23.9-1.4-47.4-7.5-69.3-18.5c-18.6-9.3-38.5-15.2-58.7-17.5l0-106.7zm128-62.4c25.2 0 50.4-5.8 73.6-17.4c18.1-9.1 36.3-18.1 54.4-27.2l0 96c-18.1 9.1-36.3 18.1-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4l0-96z','M64 32L64 0 0 0 0 32 0 480l0 32 64 0 0-32 0-128 64.3-16.1c21-5.2 42.6-6.6 63.7-4.1l0-106.7c-19.6-2.3-39.6-1.1-59 3.8L64 246.2l0-96 69-17.2c19.4-4.9 39.4-6.1 59-3.8l0 96c18.8 2.2 37.2 7.7 54.4 16.3c23.2 11.6 48.4 17.4 73.6 17.4l0 109.1c24.4 1.4 49.1-2.2 72.5-11L448 336l0-121.8-54.4 27.2c-23.2 11.6-48.4 17.4-73.6 17.4l0-96c25.2 0 50.4-5.8 73.6-17.4L448 118.2 448 16 393.6 43.2C370.4 54.8 345.2 60.6 320 60.6l0 102.2c-25.2 0-50.4-5.8-73.6-17.4c-17.2-8.6-35.6-14-54.4-16.3L192 27c-19.6-2.3-39.6-1.1-59 3.8L64 48l0-16z']
      
    ]
  };

  

  
  

  var faUtilityPoleDouble = {
    prefix: 'fasds',
    iconName: 'utility-pole-double',
    icon: [
      512,
      512,
      [],
      'e2c4',
      
      ['M0 32l48 0 0 24 0 8L0 64l0-8L0 32zM0 224l48 0 0 24 0 8L0 256l0-8 0-24zM80 32l48 0 0 24 0 8L80 64l0-8 0-24zm0 192l48 0 0 24 0 8-48 0 0-8 0-24zm3.2-96l57.7 0L224 183.4l0 38.5L83.2 128zm0 192l57.7 0L224 375.4l0 38.5L83.2 320zM288 183.4L371.2 128l57.7 0L288 221.9l0-38.5zm0 192L371.2 320l57.7 0L288 413.9l0-38.5zM384 32l48 0 0 24 0 8-48 0 0-8 0-24zm0 192l48 0 0 24 0 8-48 0 0-8 0-24zM464 32l48 0 0 24 0 8-48 0 0-8 0-24zm0 192l48 0 0 24 0 8-48 0 0-8 0-24z','M288 0V64H512v64H288V256H512v64H288V512H224V320H0V256H224V128H0V64H224V0h64z']
      
    ]
  };

  

  
  

  var faBuildingMemo = {
    prefix: 'fasds',
    iconName: 'building-memo',
    icon: [
      640,
      512,
      [],
      'e61e',
      
      ['M0 0L384 0l0 64-96 0 0 32-32 0 0 64 32 0 0 64-32 0 0 64 32 0 0 224-48 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M320 96l320 0 0 416-320 0 0-416zM424 208a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM400 328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-208l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0zm-16 96l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm16 96l-16 0 0 32 16 0 96 0 16 0 0-32-16 0-96 0z']
      
    ]
  };

  

  
  

  var faSquareX = {
    prefix: 'fasds',
    iconName: 'square-x',
    icon: [
      448,
      512,
      [],
      'e286',
      
      ['M0 32L0 480l448 0 0-448L0 32zm98.9 96l59.8 0L224 215.8 289.3 128l59.8 0L253.9 256l95.2 128-59.8 0L224 296.2 158.7 384l-59.8 0 95.2-128L98.9 128z','M289.3 128l59.8 0L253.9 256l95.2 128-59.8 0L224 296.2 158.7 384l-59.8 0 95.2-128L98.9 128l59.8 0L224 215.8 289.3 128z']
      
    ]
  };

  

  
  

  var faBowlScoop = {
    prefix: 'fasds',
    iconName: 'bowl-scoop',
    icon: [
      448,
      512,
      [127847,"bowl-shaved-ice"],
      'e3de',
      
      ['M32 224c0 10.9 .9 21.6 2.7 32l378.7 0c1.7-10.4 2.7-21.1 2.7-32c0-106-86-192-192-192S32 118 32 224z','M448 256L0 256l4.5 44.7C11 366.2 66.1 416 131.8 416l60.2 0-80 72 0 24 224 0 0-24-80-72 60.2 0c65.8 0 120.8-49.8 127.4-115.3L448 256z']
      
    ]
  };

  
    var faBowlShavedIce = faBowlScoop;
  

  
  

  var faMessageExclamation = {
    prefix: 'fasds',
    iconName: 'message-exclamation',
    icon: [
      512,
      512,
      ["comment-alt-exclamation"],
      'f4a5',
      
      ['M0 0L512 0l0 416-208 0L160 512l0-96L0 416 0 0zM232 80l0 24 0 112 0 24 48 0 0-24 0-112 0-24-48 0zm0 192l0 48 48 0 0-48-48 0z','M280 104l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  
    var faCommentAltExclamation = faMessageExclamation;
  

  
  

  var faLightCeiling = {
    prefix: 'fasds',
    iconName: 'light-ceiling',
    icon: [
      512,
      512,
      [],
      'e016',
      
      ['M192 448c0 35.3 28.7 64 64 64s64-28.7 64-64l-128 0zM224 0l0 32 0 160 32 0 32 0 0-160 0-32L224 0z','M256 192C114.6 192 0 306.6 0 448H512c0-141.4-114.6-256-256-256z']
      
    ]
  };

  

  
  

  var faFaceSmileBeam = {
    prefix: 'fasds',
    iconName: 'face-smile-beam',
    icon: [
      512,
      512,
      [128522,"smile-beam"],
      'f5b8',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm120-24c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm9.7 95.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 352.3 327.6 400 256 400s-113.7-47.7-126.3-72.8zM280 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z','M120 232c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32zm160 0c0-40 28-80 56-80s56 40 56 80c0 0-28-32-56-32s-56 32-56 32z']
      
    ]
  };

  
    var faSmileBeam = faFaceSmileBeam;
  

  
  

  var faForwardStep = {
    prefix: 'fasds',
    iconName: 'forward-step',
    icon: [
      320,
      512,
      ["step-forward"],
      'f051',
      
      ['M256 64l64 0 0 32 0 320 0 32-64 0 0-32 0-160 0-160 0-32z','M0 64V448L256 256 0 64z']
      
    ]
  };

  
    var faStepForward = faForwardStep;
  

  
  

  var faMessageBot = {
    prefix: 'fasds',
    iconName: 'message-bot',
    icon: [
      640,
      512,
      [],
      'e3b8',
      
      ['M96 0L544 0l0 176 0 32 0 208-176 0L224 512l0-96L96 416l0-208 0-32L96 0zm64 96l0 192 320 0 0-192L160 96z','M64 160L0 160l0 64 64 0 0-16 32 0 0-32-32 0 0-16zm192 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 16l32 0 0 16 64 0 0-64-64 0 0 16-32 0 0 32z']
      
    ]
  };

  

  
  

  var faMagnifyingGlassLocation = {
    prefix: 'fasds',
    iconName: 'magnifying-glass-location',
    icon: [
      512,
      512,
      ["search-location"],
      'f689',
      
      ['M0 208a208 208 0 1 0 416 0A208 208 0 1 0 0 208zm128-32c0-44.2 35.8-80 80-80s80 35.8 80 80c0 64-80 144-80 144s-80-80-80-144z','M288 176c0 64-80 144-80 144s-80-80-80-144c0-44.2 35.8-80 80-80s80 35.8 80 80zm-48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM441.4 486.6L330.7 376C348 363.3 363.3 348 376 330.7L486.6 441.4 509.3 464 464 509.3l-22.6-22.6z']
      
    ]
  };

  
    var faSearchLocation = faMagnifyingGlassLocation;
  

  
  

  var faHandPointRight = {
    prefix: 'fasds',
    iconName: 'hand-point-right',
    icon: [
      512,
      512,
      [],
      'f0a4',
      
      ['M0 226.3L0 288c0 88.4 71.6 160 160 160l0-96 32 0 0-64-48 0-16 0 0-16 0-112 0-16 32 0 0 16 0 96 32 0 48 0 0-192-91 0c-33.9 0-66.5 13.5-90.5 37.5L46.9 113.1C16.9 143.1 0 183.8 0 226.3zM272 96l0 64 240 0 0-64L272 96z','M384 192l0 64-112 0 0-64 112 0zm-32 96l0 64-128 0 0-64 128 0zM320 448l-128 0 0-64 128 0 0 64z']
      
    ]
  };

  

  
  

  var faH1 = {
    prefix: 'fasds',
    iconName: 'h1',
    icon: [
      576,
      512,
      [],
      'f313',
      
      ['M0 64L0 96 0 256 0 416l0 32 64 0 0-32 0-128 192 0 0 128 0 32 64 0 0-32 0-160 0-160 0-32-64 0 0 32 0 128L64 224 64 96l0-32L0 64z','M384 166.6l21-9.3 43-19.1L448 384l-32 0-32 0 0 64 32 0 64 0 64 0 32 0 0-64-32 0-32 0 0-288 0-32-32 0-16 0-6.8 0L451 66.8 384 96.5l0 70z']
      
    ]
  };

  

  
  

  var faStandardDefinition = {
    prefix: 'fasds',
    iconName: 'standard-definition',
    icon: [
      576,
      512,
      ["rectangle-sd"],
      'e28a',
      
      ['M0 32L0 480l576 0 0-448L0 32zM304 160l24 0 56 0c53 0 96 43 96 96s-43 96-96 96l-56 0-24 0c0-8 0-16 0-24c0-48 0-96 0-144c0-8 0-16 0-24zm48 48l0 96 32 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z','M328 160l-24 0 0 24 0 144 0 24 24 0 56 0c53 0 96-43 96-96s-43-96-96-96l-56 0zm24 144l0-96 32 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-32 0zM167.1 208.1c7.4-2.4 19.5-2.9 36.2-.7c5.1 .7 21.1 3.4 25.7 4.4l21.8 5 10-43.7-21.8-5c-6.5-1.5-23.9-4.4-29.7-5.1c-18.9-2.5-38.9-3.1-56 2.5c-18.8 6.1-33.9 19.7-38.5 42.3c-.1 .4-.1 .8-.2 1.2c-1.7 11.4-.2 22.4 5 32.3c5.1 9.6 12.9 16.1 20.5 20.7c13.7 8.2 31.5 12.3 45.1 15.5l1.7 .4c16 3.7 27.1 6.5 34.1 10.7c3 1.8 3.8 3 3.9 3.3c0 0 0 0 0 0c.1 .1 .7 1.2 .2 4.7c-.4 2.7-1.2 3.8-1.7 4.3c-.7 .7-2.3 2-5.8 3.1c-7.7 2.4-20.1 2.9-36.9 .6c-7.4-1-20.3-4.8-31.4-8c-2.5-.7-5-1.4-7.2-2.1l-21.5-6.1-12.3 43.1 21.5 6.1c1.5 .4 3.3 1 5.3 1.6c0 0 0 0 0 0s0 0 0 0c10.8 3.2 28.4 8.3 39.4 9.9c0 0 0 0 0 0l.1 0c18.9 2.5 39.2 3.1 56.4-2.3c8.9-2.8 17.8-7.5 24.9-15.2c7.3-7.8 11.8-17.6 13.4-28.5c1.7-11.4 .2-22.4-5-32.3c-5.1-9.6-12.9-16.1-20.5-20.7c-13.7-8.2-31.5-12.3-45.1-15.5c0 0 0 0 0 0l-1.7-.4c-16-3.7-27.1-6.5-34.1-10.7c-3-1.8-3.8-3-3.9-3.3c0 0 0 0 0 0c-.1-.1-.6-1.1-.3-4.1c.9-4 2.8-6.2 8.3-8z']
      
    ]
  };

  
    var faRectangleSd = faStandardDefinition;
  

  
  

  var faSkiBoot = {
    prefix: 'fasds',
    iconName: 'ski-boot',
    icon: [
      512,
      512,
      [],
      'e3cc',
      
      ['M0 512l12.8-64L480 448l32 0 0 64L0 512zM44.8 288C61.9 202.7 78.9 117.4 96 32l128 0c-17.1 85.3-34.1 170.7-51.2 256l-128 0z','M12.8 448L480 448l0-96L326.4 288 272 288l-16 0 0-32 16 0 60.8 0 12.8-64L288 192l-16 0 0-32 16 0 64 0L384 0 320 0l-6.4 32L224 32 172.8 288l-128 0-32 160z']
      
    ]
  };

  

  
  

  var faFingerprint = {
    prefix: 'fasds',
    iconName: 'fingerprint',
    icon: [
      512,
      512,
      [],
      'f577',
      
      ['M63.8 384l50.1 0c9.3-33.5 14.1-68.2 14.1-103.1l0-24.9c0-31.1 11.1-59.7 29.6-81.9l-31.6-36.8C97.5 168.6 80 210.3 80 256l0 24.9c0 35-5.5 69.8-16.2 103.1zM163 106.6l31.7 37c18.2-9.9 39.1-15.6 61.3-15.6c70.7 0 128 57.3 128 128l0 24.9c0 34.6-2.8 69.1-8.4 103.1l48.6 0c5.2-34 7.8-68.5 7.8-103.1l0-24.9c0-97.2-78.8-176-176-176c-34.2 0-66 9.7-93 26.6zM190.3 480l51.4 0 2.6-6.7C267.9 411.9 280 346.7 280 280.9l0-24.9-48 0 0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3-3.3 8.6z','M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5l15.6 18.2 36.4-31.3L450.2 89.2C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256l0 40 0 24 48 0 0-24 0-40zm458.5-52.9l-4.9-23.5-47 9.9 4.9 23.5c2.9 13.9 4.5 28.3 4.5 43.1l0 40 0 24 48 0 0-24 0-40c0-18.1-1.9-35.8-5.5-52.9zM352 256c0-53-43-96-96-96s-96 43-96 96l0 24.9c0 46-7.6 91.6-22.5 135.1l46.3 0c13.4-43.7 20.3-89.2 20.3-135.1l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 45.6-5.5 91-16.4 135.1l45.2 0c10.1-44.2 15.2-89.5 15.2-135.1l0-24.9z']
      
    ]
  };

  

  
  

  var faPumpMedical = {
    prefix: 'fasds',
    iconName: 'pump-medical',
    icon: [
      448,
      512,
      [],
      'e06a',
      
      ['M32 512L56 160l72 0 128 0 72 0 24 352L32 512zm80-200l0 48 24 0 32 0 0 32 0 24 48 0 0-24 0-32 32 0 24 0 0-48-24 0-32 0 0-32 0-24-48 0 0 24 0 32-32 0-24 0z','M128 0L256 0l0 32 96 0 13.3 0 9.4 9.4 48 48L445.3 112 400 157.3l-22.6-22.6L338.7 96 256 96l0 64-128 0L128 0zm88 280l0 32 32 0 24 0 0 48-24 0-32 0 0 32 0 24-48 0 0-24 0-32-32 0-24 0 0-48 24 0 32 0 0-32 0-24 48 0 0 24z']
      
    ]
  };

  

  
  

  var faLocationMinus = {
    prefix: 'fasds',
    iconName: 'location-minus',
    icon: [
      384,
      512,
      ["map-marker-minus"],
      'f609',
      
      ['M0 192C0 304 192 512 192 512s192-208 192-320C384 86 298 0 192 0S0 86 0 192zm96-24l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z','M96 168l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  
    var faMapMarkerMinus = faLocationMinus;
  

  
  

  var faSlidersUp = {
    prefix: 'fasds',
    iconName: 'sliders-up',
    icon: [
      512,
      512,
      ["sliders-v"],
      'f3f1',
      
      ['M64 0l64 0 0 32 0 32L64 64l0-32L64 0zm0 224l64 0 0 256 0 32-64 0 0-32 0-256zM224 0l64 0 0 32 0 256-64 0 0-256 0-32zm0 448l64 0 0 32 0 32-64 0 0-32 0-32zM384 0l64 0 0 32 0 64-64 0 0-64 0-32zm0 256l64 0 0 224 0 32-64 0 0-32 0-224z','M128 112l0 64-64 0 0-64 64 0zM64 64L16 64l0 48 0 64 0 48 48 0 64 0 48 0 0-48 0-64 0-48-48 0L64 64zM288 336l0 64-64 0 0-64 64 0zm-64-48l-48 0 0 48 0 64 0 48 48 0 64 0 48 0 0-48 0-64 0-48-48 0-64 0zM384 144l64 0 0 64-64 0 0-64zM336 96l0 48 0 64 0 48 48 0 64 0 48 0 0-48 0-64 0-48-48 0-64 0-48 0z']
      
    ]
  };

  
    var faSlidersV = faSlidersUp;
  

  
  

  var faBridgeCircleCheck = {
    prefix: 'fasds',
    iconName: 'bridge-circle-check',
    icon: [
      640,
      512,
      [],
      'e4c9',
      
      ['M32 32l32 0 512 0 32 0 0 64-32 0-40 0 0 64 72 0 0 72.2C577.6 207.1 538.5 192 496 192c-69.1 0-128.9 39.8-157.7 97.7c-5.9-1.1-12-1.7-18.3-1.7c-53 0-96 43-96 96l0 96-96 0 0-96c0-53-43-96-96-96l0-128 72 0 0-64L64 96 32 96l0-64zM152 96l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0zm128 0l0 64 80 0 0-64-80 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faCalculatorSimple = {
    prefix: 'fasds',
    iconName: 'calculator-simple',
    icon: [
      512,
      512,
      ["calculator-alt"],
      'f64c',
      
      ['M0 0L0 224l224 0L224 0 0 0zM0 288L0 512l224 0 0-224L0 288zM48 96l16 0 96 0 16 0 0 16 0 16-16 0-96 0-16 0 0-16 0-16zm1.4 264c3.7-3.7 7.5-7.5 11.4-11.4c3.8-3.8 7.5-7.5 11.2-11.2l11.3 11.3L112 377.4l28.7-28.7L152 337.4c3.7 3.7 7.5 7.5 11.4 11.4c3.8 3.8 7.5 7.5 11.2 11.2l-11.3 11.3L134.6 400l28.7 28.7L174.6 440c-3.7 3.7-7.5 7.5-11.4 11.4c-3.8 3.8-7.5 7.5-11.2 11.2l-11.3-11.3L112 422.6 83.3 451.3 72 462.6c-3.7-3.7-7.5-7.5-11.4-11.4c-3.8-3.8-7.5-7.5-11.3-11.3l11.3-11.3L89.4 400 60.7 371.3 49.4 360zM288 0l0 224 224 0L512 0 288 0zm48 96l16 0 32 0 0-32 0-16 32 0 0 16 0 32 32 0 16 0 0 16 0 16-16 0-32 0 0 32 0 16-16 0-16 0 0-16 0-32-32 0-16 0 0-16 0-16z','M416 64l0 32 32 0 16 0 0 32-16 0-32 0 0 32 0 16-32 0 0-16 0-32-32 0-16 0 0-32 16 0 32 0 0-32 0-16 32 0 0 16zM64 96l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zM83.3 348.7L112 377.4l28.7-28.7L152 337.4 174.6 360l-11.3 11.3L134.6 400l28.7 28.7L174.6 440 152 462.6l-11.3-11.3L112 422.6 83.3 451.3 72 462.6 49.4 440l11.3-11.3L89.4 400 60.7 371.3 49.4 360 72 337.4l11.3 11.3zM288 288l224 0 0 224-224 0 0-224zm48 64l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0zm0 64l0 32 16 0 96 0 16 0 0-32-16 0-96 0-16 0z']
      
    ]
  };

  
    var faCalculatorAlt = faCalculatorSimple;
  

  
  

  var faClosedCaptioningSlash = {
    prefix: 'fasds',
    iconName: 'closed-captioning-slash',
    icon: [
      640,
      512,
      [],
      'e135',
      
      ['M32 121.2L32 480l455.4 0L295 328.4c-16.8 14.7-38.9 23.6-63 23.6c-53 0-96-43-96-96c0-16 3.9-31.1 10.8-44.3L32 121.2zM70.5 32l165 128.1c32.7 1.2 61.2 18.7 77.6 44.6L302 211.7c9.5 7.4 19.1 14.8 28.6 22.2c10-42.3 48-73.9 93.4-73.9c34.2 0 64.1 17.8 81.1 44.6l-40.5 25.7C456 216.9 441 208 424 208c-26.5 0-48 21.5-48 48c0 5.2 .8 10.3 2.4 15l42.4 32.9c1.1 .1 2.2 .1 3.2 .1c17 0 32-8.9 40.6-22.3l40.5 25.7c-9 14.1-21.6 25.8-36.5 33.6L608 449.3 608 32 70.5 32zM184 256c0 26.5 21.5 48 48 48c8.7 0 16.9-2.3 23.9-6.4l-70-55.1c-1.3 4.3-1.9 8.8-1.9 13.5z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L19 52.7 0 38 29.4 .1z']
      
    ]
  };

  

  
  

  var faMicrophoneLinesSlash = {
    prefix: 'fasds',
    iconName: 'microphone-lines-slash',
    icon: [
      640,
      512,
      ["microphone-alt-slash"],
      'f539',
      
      ['M144 209.5l0 6.5 0 40c0 89.1 66.2 162.7 152 174.4l0 33.6-48 0-24 0 0 48 24 0 72 0 72 0 24 0 0-48-24 0-48 0 0-33.6c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128l0-8.7-48-37.8zM224 0l0 151.1c32 24.8 64 49.7 96 73.7l0-.8 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-32-80 0-16 0 0-32 16 0 80 0 0-96L224 0zM359.1 256l49.1 38.1c5.1-11.7 7.9-24.6 7.9-38.1l-56.9 0zm75 58.2c12.8 9.9 25.6 19.9 38.4 29.8c15-25.9 23.6-56 23.6-88l0-40 0-24-48 0 0 24 0 8 0 32c0 21-5 40.7-14 58.2z','M29.4 .1l19 14.7L620.9 459.3l19 14.7-29.4 37.9-19-14.7L18.9 52.7 0 38 29.4 .1z']
      
    ]
  };

  
    var faMicrophoneAltSlash = faMicrophoneLinesSlash;
  

  
  

  var faIcons = {
    prefix: 'fasds',
    iconName: 'icons',
    icon: [
      512,
      512,
      ["heart-music-camera-bolt"],
      'f86d',
      
      ['M0 67.9c0 18 7.2 35.3 19.9 48L128 224 236.1 115.9c12.7-12.7 19.9-30 19.9-48C256 30.4 225.6 0 188.1 0c-18 0-35.3 7.2-48 19.9L128 32 115.9 19.9C103.2 7.2 85.9 0 67.9 0C30.4 0 0 30.4 0 67.9zM320 400l72.2 10.5L374.9 512 512 368l-72.2-10.5L457.1 256 320 400z','M512 40l0-39L473.7 8.6l-160 32L288 45.8 288 72l0 88c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-109.8L448 79l0 49c-35.3 0-64 21.5-64 48s28.7 48 64 48s64-21.5 64-48l0-136zM74.7 304L0 304 0 512l288 0 0-208-74.7 0L192 272l-96 0L74.7 304zM96 408a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z']
      
    ]
  };

  
    var faHeartMusicCameraBolt = faIcons;
  

  
  

  var faSoap = {
    prefix: 'fasds',
    iconName: 'soap',
    icon: [
      512,
      512,
      [129532],
      'e06e',
      
      ['M160 48a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm96 144a64 64 0 1 0 128 0 64 64 0 1 0 -128 0zM352 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z','M391.6 256c15.2-17 24.4-39.4 24.4-64l96 0 0 320L0 512 0 192l224 0c0 24.6 9.2 47 24.4 64L96 256l-32 0 0 32 0 128 0 32 32 0 320 0 32 0 0-32 0-128 0-32-32 0-24.4 0zM320 288l96 0 0 128L96 416l0-128 224 0z']
      
    ]
  };

  

  
  

  var faAtom = {
    prefix: 'fasds',
    iconName: 'atom',
    icon: [
      512,
      512,
      [9883],
      'f5d2',
      
      ['M42.4 128C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128c20.2 36.3 62.5 49.3 115.2 43.2c22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2c7.1-12.7 10.4-26.4 10.4-40.8c0-27.6-12.3-57.5-34-87.2c21.7-29.8 34-59.7 34-87.2c0-14.3-3.3-28.1-10.4-40.8c-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2zm55.9 31.1c1.6-2.9 8.4-13 40.2-11.7c-2.8 13.1-5 26.9-6.7 41.2c-7.6 6.1-14.8 12.3-21.6 18.6C91.4 177 96 163.3 98.3 159.1zm0 193.8c-2.3-4.2-7-17.9 11.9-48.1c6.8 6.3 14 12.5 21.6 18.6c1.7 14.2 3.9 28 6.7 41.2c-31.8 1.4-38.6-8.7-40.2-11.7zM192 256c0-11.5 .4-22.7 1-33.6c10.6-7.6 22.1-15.1 34.2-22.4c9.7-5.8 19.3-11.2 28.8-16c9.4 4.8 19 10.2 28.8 16c12.1 7.3 23.6 14.8 34.2 22.4c.7 10.8 1 22 1 33.6s-.4 22.7-1 33.6c-10.6 7.6-22.1 15.1-34.2 22.4c-9.7 5.8-19.3 11.2-28.8 16c-9.4-4.8-19-10.2-28.8-16c-12.1-7.3-23.6-14.8-34.2-22.4c-.7-10.8-1-22-1-33.6zM221.1 99.7C237.9 65.9 252.1 64 256 64s18.1 1.9 34.9 35.7c-11.4 3.9-23.1 8.4-34.9 13.5c-11.8-5.1-23.4-9.7-34.9-13.5zm0 312.6c11.4-3.9 23.1-8.4 34.9-13.5c11.8 5.1 23.4 9.7 34.9 13.5c-16.7 33.8-31 35.7-34.9 35.7s-18.1-1.9-34.9-35.7zM373.5 147.5c31.8-1.4 38.6 8.7 40.2 11.7c2.3 4.2 7 17.9-11.9 48.1c-6.8-6.3-14-12.5-21.6-18.6c-1.7-14.3-3.9-28-6.7-41.2zm0 217.1c2.8-13.1 5-26.9 6.7-41.2c7.6-6.1 14.8-12.3 21.6-18.6c18.9 30.2 14.2 44 11.9 48.1c-1.6 2.9-8.4 13-40.2 11.7z','M256 296l-40-40 40-40 40 40-40 40z']
      
    ]
  };

  

  
  

  var faNfc = {
    prefix: 'fasds',
    iconName: 'nfc',
    icon: [
      448,
      512,
      [],
      'e1f7',
      
      ['M96 128l0 256 256 0 0-256-112 0 0 82.7c18.6 6.6 32 24.4 32 45.3c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3l0-82.7-48 0-16 0-48 0z','M448 32L0 32 0 480l448 0 0-448zM80 96l64 0 16 0 0 32 48 0 0-16 0-16 16 0 144 0 16 0 0 16 0 288 0 16-16 0L80 416l-16 0 0-16 0-288 0-16 16 0z']
      
    ]
  };

  

  
  

  var faFaceGlasses = {
    prefix: 'fasds',
    iconName: 'face-glasses',
    icon: [
      512,
      512,
      [],
      'e377',
      
      ['M0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.1-2.8-43.5-8.1-64l-7.9 0-32 0 0 96 0 16-16 0-160 0-16 0 0-16 0-96-32 0 0 96 0 16-16 0L64 304l-16 0 0-16 0-96-32 0-7.9 0C2.8 212.5 0 233.9 0 256zm18.6-96L48 160l0-16 0-16 16 0 160 0 16 0 0 16 0 16 32 0 0-16 0-16 16 0 160 0 16 0 0 16 0 16 29.4 0C455.4 66.2 363.4 0 256 0S56.6 66.2 18.6 160zM129.7 343.2l28.6-14.3c8.7 17.5 41.3 55.2 97.7 55.2s88.9-37.7 97.7-55.2l28.6 14.3C369.7 368.3 327.6 416 256 416s-113.7-47.7-126.3-72.8z','M64 128l-16 0 0 16 0 16-32 0L0 160l0 32 16 0 32 0 0 96 0 16 16 0 160 0 16 0 0-16 0-96 32 0 0 96 0 16 16 0 160 0 16 0 0-16 0-96 32 0 16 0 0-32-16 0-32 0 0-16 0-16-16 0-160 0-16 0 0 16 0 16-32 0 0-16 0-16-16 0L64 128zm16 64l0-32 128 0 0 112L80 272l0-80zm352-32l0 32 0 80-128 0 0-112 128 0zM184.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z']
      
    ]
  };

  

  
  

  var faRightFromBracket = {
    prefix: 'fasds',
    iconName: 'right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out-alt"],
      'f2f5',
      
      ['M0 32L0 64 0 448l0 32 32 0 128 0 32 0 0-64-32 0-96 0L64 96l96 0 32 0 0-64-32 0L32 32 0 32z','M512 256L352 96l-32 0 0 96-160 0 0 128 160 0 0 96 32 0L512 256z']
      
    ]
  };

  
    var faSignOutAlt = faRightFromBracket;
  

  
  

  var faFilms = {
    prefix: 'fasds',
    iconName: 'films',
    icon: [
      576,
      512,
      [],
      'e17a',
      
      ['M0 96l0 24L0 456l0 24 24 0 432 0 24 0 0-48-24 0L48 432l0-312 0-24L0 96zM256 80l0 112 160 0 0-112L256 80zm0 144l0 112 160 0 0-112-160 0z','M96 32l480 0 0 352L96 384 96 32zm56 48l0 48 48 0 0-48-48 0zm368 0l-48 0 0 48 48 0 0-48zM152 184l0 48 48 0 0-48-48 0zm368 0l-48 0 0 48 48 0 0-48zM152 288l0 48 48 0 0-48-48 0zm368 0l-48 0 0 48 48 0 0-48zM256 80l0 112 160 0 0-112L256 80zM416 224l-160 0 0 112 160 0 0-112z']
      
    ]
  };

  

  
  

  var faDoorOpen = {
    prefix: 'fasds',
    iconName: 'door-open',
    icon: [
      576,
      512,
      [],
      'f52b',
      
      ['M64 64l0 384 0 64 256 0 0-384 0-64 0-64L64 64zM208 256c0-17.7 10.7-32 24-32s24 14.3 24 32s-10.7 32-24 32s-24-14.3-24-32z','M320 128l128 0 0 352 0 32 32 0 64 0 32 0 0-64-32 0-32 0 0-352 0-32-32 0L320 64l0 64zM32 448L0 448l0 64 32 0 32 0 0-64-32 0zM232 288c13.3 0 24-14.3 24-32s-10.7-32-24-32s-24 14.3-24 32s10.7 32 24 32z']
      
    ]
  };

  

  
  

  var faShovel = {
    prefix: 'fasds',
    iconName: 'shovel',
    icon: [
      512,
      512,
      [],
      'f713',
      
      ['M193.4 273.4c15.1 15.1 30.2 30.2 45.3 45.3L341.3 216c11.4 5.1 24 8 37.3 8c24 0 47-9.5 64-26.5l24.2-24.2L512 128 466.7 82.7 429.3 45.3 384 0 338.7 45.3 314.5 69.5c-17 17-26.5 40-26.5 64c0 13.3 2.9 25.9 8 37.3L193.4 273.4zM352 133.5c0-7 2.8-13.8 7.8-18.7L384 90.5 421.5 128l-24.2 24.2c-5 5-11.7 7.8-18.7 7.8c-14.6 0-26.5-11.9-26.5-26.5z','M304 384L128 208 0 336V512H176L304 384z']
      
    ]
  };

  

  
  

  var faFaceIcicles = {
    prefix: 'fasds',
    iconName: 'face-icicles',
    icon: [
      512,
      512,
      [],
      'e37c',
      
      ['M0 256c0 19.7 2.2 38.9 6.5 57.4l18 107.9L28.9 448l54.2 0 .5-2.8C129.1 486.7 189.6 512 256 512c33.3 0 65.1-6.3 94.2-17.9l7.8 17.9 27.9 0 15.4-35.2 6.4-14.6c8.3-6.1 16.2-12.7 23.7-19.8l.7 8.3 5.3 61.2 53.1 0 5.3-61.2 14.2-163.2c1.3-10.4 1.9-20.9 1.9-31.6C512 114.6 397.4 0 256 0S0 114.6 0 256zm32 16l48 0c-8 47.9-16 95.9-24 143.8L32 272zm80 32l56 0 0 40-56 0 0-40zm0 56l56 0 0 40-56 0 0-40zm96.4-152a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM184 304l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-64 0 0-40zm80-56l64 0 0 40-64 0 0-40zm0 56l64 0 0 40-32 48-32-48 0-40zM368.4 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM344 304l56 0 0 40-56 0 0-40zm0 56l56 0 0 40-28 64-28-64 0-40zm96-136l48 0L464 448 440 224z','M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z']
      
    ]
  };

  

  
  

  var faCircleMinus = {
    prefix: 'fasds',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm160-24l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z','M160 232l24 0 144 0 24 0 0 48-24 0-144 0-24 0 0-48z']
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  

  
  

  var faFolderArrowDown = {
    prefix: 'fasds',
    iconName: 'folder-arrow-down',
    icon: [
      512,
      512,
      ["folder-download"],
      'e053',
      
      ['M0 32L0 480l512 0 0-384L272 96 224 32 0 32zM150.1 288c11.3-11.3 22.6-22.6 33.9-33.9l17 17 31 31c0-34 0-68 0-102.1c0-8 0-16 0-24l48 0c0 8 0 16 0 24c0 34 0 68 0 102.1l31-31 17-17L361.9 288l-17 17c-24 24-48 48-72 72c-5.7 5.7-11.3 11.3-17 17c-5.7-5.7-11.3-11.3-17-17c-24-24-48-48-72-72c-5.7-5.7-11.3-11.3-17-17z','M280 176l0 24 0 102.1 31-31 17-17L361.9 288l-17 17-72 72-17 17-17-17-72-72-17-17L184 254.1l17 17 31 31L232 200l0-24 48 0z']
      
    ]
  };

  
    var faFolderDownload = faFolderArrowDown;
  

  
  

  var faSortDown = {
    prefix: 'fasds',
    iconName: 'sort-down',
    icon: [
      320,
      512,
      ["sort-desc"],
      'f0dd',
      
      ['M0 176l0 48 64 0 192 0 64 0 0-48-17.8-16L160 32 17.8 160 0 176zm113.4-16L160 118.1 206.6 160l-93.1 0z','M0 336L160 480 320 336V288H0v48z']
      
    ]
  };

  
    var faSortDesc = faSortDown;
  

  
  

  var faBarcodeScan = {
    prefix: 'fasds',
    iconName: 'barcode-scan',
    icon: [
      640,
      512,
      [],
      'f465',
      
      ['M0 232l24 0 592 0 24 0 0 48-24 0L24 280 0 280l0-48z','M64 32l64 0 0 160-64 0L64 32zm0 288l64 0 0 160-64 0 0-160zm96 0l32 0 0 160-32 0 0-160zm64 0l64 0 0 160-64 0 0-160zm64-128l-64 0 0-160 64 0 0 160zm32 128l64 0 0 160-64 0 0-160zm64-128l-64 0 0-160 64 0 0 160zm64 128l32 0 0 160-32 0 0-160zm32-128l-32 0 0-160 32 0 0 160zm32 128l64 0 0 160-64 0 0-160zm64-128l-64 0 0-160 64 0 0 160zm-384 0l-32 0 0-160 32 0 0 160z']
      
    ]
  };

  

  
  

  var faMobileSignal = {
    prefix: 'fasds',
    iconName: 'mobile-signal',
    icon: [
      512,
      512,
      [],
      'e1ef',
      
      ['M0 0L0 64 0 448l0 64 64 0 160 0c0-22 2.5-43.4 7.1-64L64 448 64 64l224 0 0 267c18.2-22.6 39.8-42.3 64-58.5L352 64l0-64L288 0 64 0 0 0zM128 384l0 32 16 0 64 0 16 0 0-32-16 0-64 0-16 0z','M304 512c0-114.9 93.1-208 208-208l0-48c-141.4 0-256 114.6-256 256l48 0zm144-32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm64-80l0-48c-88.4 0-160 71.6-160 160l48 0c0-61.9 50.1-112 112-112z']
      
    ]
  };

  

  
  

  var faArrowsUpToLine = {
    prefix: 'fasds',
    iconName: 'arrows-up-to-line',
    icon: [
      576,
      512,
      [],
      'e4c2',
      
      ['M0 32L0 96l32 0 512 0 32 0 0-64-32 0L32 32 0 32z','M70.6 262.6L48 285.3 2.7 240l22.6-22.6 80-80L128 114.7l22.6 22.6 80 80L253.3 240 208 285.3l-22.6-22.6L160 237.3 160 448l0 32-64 0 0-32 0-210.7L70.6 262.6zm320 0L368 285.3 322.7 240l22.6-22.6 80-80L448 114.7l22.6 22.6 80 80L573.3 240 528 285.3l-22.6-22.6L480 237.3 480 448l0 32-64 0 0-32 0-210.7-25.4 25.4z']
      
    ]
  };

  

  
  

  var faFork = {
    prefix: 'fasds',
    iconName: 'fork',
    icon: [
      512,
      512,
      ["utensil-fork"],
      'f2e3',
      
      ['M240 155.3c0 19.4 6.4 38.1 18 53.4c2.4 3.2 5.1 6.3 8 9.1c9.4 9.4 18.8 18.8 28.2 28.2c2.9 2.9 5.9 5.5 9.1 8c15.3 11.6 34 18 53.4 18c31.8 0 61.1-17 76.8-44.6L504 104 488 88 384 192l-16-16L464 64 448 48 336 144l-16-16L424 24 408 8 284.6 78.5C257 94.3 240 123.6 240 155.3z','M258 208.8c2.4 3.2 5.1 6.3 8 9.1l28.2 28.2c2.9 2.9 5.9 5.5 9.1 8L70.6 486.6 48 509.3 2.7 464l22.6-22.6L258 208.8z']
      
    ]
  };

  
    var faUtensilFork = faFork;
  

  
  

  var faUfo = {
    prefix: 'fasds',
    iconName: 'ufo',
    icon: [
      640,
      512,
      [128760],
      'e047',
      
      ['M144 237.1s51.8 50.9 176 50.9s176-50.9 176-50.9c0-8.3-.6-16.5-1.7-24.5C482.2 128.6 408.8 64 320 64s-162.2 64.6-174.3 148.6c-1.2 8-1.7 16.2-1.7 24.5z','M320 288c124.2 0 176-50.9 176-50.9c0-8.3-.6-16.5-1.7-24.5C582 235.5 640 275 640 320c0 70.7-143.3 128-320 128S0 390.7 0 320c0-45 58-84.5 145.7-107.4c-1.2 8-1.7 16.2-1.7 24.5c0 0 51.8 50.9 176 50.9zm-32 88l32 32 32-32-32-32-32 32zM128 296L96 328l32 32 32-32-32-32zm416 32l-32-32-32 32 32 32 32-32z']
      
    ]
  };

  

  
  

  var faTextSize = {
    prefix: 'fasds',
    iconName: 'text-size',
    icon: [
      640,
      512,
      [],
      'f894',
      
      ['M0 32l32 0 128 0 64 0 128 0 32 0 0 32 0 64 0 32-64 0 0-32 0-32-96 0 0 320 32 0 32 0 0 64-32 0-128 0-32 0 0-64 32 0 32 0 0-320L64 96l0 32 0 32L0 160l0-32L0 64 0 32z','M320 224l32 0 256 0 32 0 0 32 0 32 0 32-64 0 0-32-64 0 0 128 16 0 32 0 0 64-32 0-96 0-32 0 0-64 32 0 16 0 0-128-64 0 0 32-64 0 0-32 0-32 0-32z']
      
    ]
  };

  

  
  

  var faSunHaze = {
    prefix: 'fasds',
    iconName: 'sun-haze',
    icon: [
      640,
      512,
      [],
      'f765',
      
      ['M64 150l73.1 106c18.3 0 36.6 0 54.9 0c0-70.7 57.3-128 128-128s128 57.3 128 128c18.3 0 36.6 0 54.9 0c24.4-35.4 48.7-70.7 73.1-106L449.3 126.7 426 0 320 73.1 214 0 190.7 126.7 64 150zM224 256c64 0 128 0 192 0c0-53-43-96-96-96s-96 43-96 96z','M640 288l-24 0-112 0-24 0 0 48 24 0 112 0 24 0 0-48zm-208 0l-24 0L88 288l-24 0 0 48 24 0 320 0 24 0 0-48zm144 88l-24 0L24 376 0 376l0 48 24 0 528 0 24 0 0-48zM88 464l-24 0 0 48 24 0 112 0 24 0 0-48-24 0L88 464zm208 0l-24 0 0 48 24 0 320 0 24 0 0-48-24 0-320 0z']
      
    ]
  };

  

  
  

  var faVolleyball = {
    prefix: 'fasds',
    iconName: 'volleyball',
    icon: [
      512,
      512,
      [127952,"volleyball-ball"],
      'f45f',
      
      ['M0 256c0 49.4 14 95.6 38.3 134.7l.3 .5c5.7-35.1 11.5-70.1 17.2-105.2c.2-1.3 .4-2.6 .6-4c.8-1.1 1.6-2.1 2.4-3.2c38.8-50.7 77.5-101.4 116.3-152.2c-29.4-21-58.7-42-88.1-63C33.7 110.6 0 179.4 0 256zM65.2 426.7C87 451 113.4 471.2 143 485.8l11.2-114.6c.1-1.5 .3-2.9 .4-4.4c.9-1.2 1.7-2.4 2.6-3.5c26.8-36.4 53.6-72.8 80.4-109.3l-43.5-99.4c-35.8 46.9-71.6 93.7-107.4 140.5C79.5 339 72.4 382.8 65.2 426.7zM113.5 43.3c31.2 22.3 62.4 44.7 93.7 67c1.2 .9 2.4 1.7 3.6 2.6c.6 1.3 1.2 2.7 1.8 4c18.2 41.4 36.3 82.8 54.4 124.2c36 4 71.9 8 107.8 12c-22.7-54.4-45.4-108.8-68-163.3L203.5 5.4c-32.7 6.8-63.2 19.9-90 37.9zm60.4 455.3c25.8 8.7 53.4 13.4 82.1 13.4c97.7 0 182.7-54.8 225.8-135.3c-33.3 12.6-66.5 25.1-99.7 37.7c-1.2 .5-2.5 .9-3.7 1.4l-4-.5L184.5 390.7c-3.5 36-7 71.9-10.5 107.9zm25.2-138.2c58.5 7.6 116.9 15.1 175.4 22.7c41.6-15.7 83.2-31.5 124.8-47.2c8.2-25.1 12.7-52 12.7-79.9c0-5.7-.2-11.4-.6-17c-35 15.9-69.9 31.7-104.8 47.6c-1.3 .6-2.7 1.2-4 1.8c-1.5-.2-2.9-.3-4.4-.5c-44.9-5-89.9-10-134.8-15c-21.4 29.1-42.9 58.3-64.3 87.4zM247.7 .1c27.5 22.5 55 45 82.5 67.5c1 .8 2.1 1.7 3.1 2.5c.5 1.2 1 2.5 1.5 3.7c24.6 58.9 49.1 117.8 73.7 176.8c32.9-14.9 65.8-29.9 98.7-44.8C483.7 88.4 380.2 0 256 0c-2.8 0-5.6 0-8.3 .1z','M38.6 391.2L55.8 286l.6-4 2.4-3.2L175.1 126.7 87 63.7c8.4-7.4 17.2-14.2 26.5-20.4l93.7 67 3.6 2.6 1.8 4 54.4 124.2 107.8 12-68-163.3L203.5 5.4c14.3-3 29-4.8 44.1-5.2l82.5 67.5 3.1 2.5 1.5 3.7 73.7 176.8 98.7-44.8c2.2 10.8 3.6 21.9 4.4 33.2L406.6 286.6l-4 1.8-4.4-.5-134.8-15-64.3 87.4L374.5 383l124.8-47.2c-4.7 14.2-10.5 27.8-17.5 40.8l-99.7 37.7-3.7 1.4-4-.5L184.5 390.7 173.9 498.6c-10.6-3.6-21-7.9-30.9-12.8l11.2-114.6 .4-4.4 2.6-3.5L237.6 254l-43.5-99.4L86.7 295.1 65.2 426.7c-9.9-11-18.8-22.9-26.6-35.5z']
      
    ]
  };

  
    var faVolleyballBall = faVolleyball;
  

  
  

  var faBuildingCircleArrowRight = {
    prefix: 'fasds',
    iconName: 'building-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e4d1',
      
      ['M0 0L384 0l0 232.2c-39.1 32.3-64 81.1-64 135.8s24.9 103.5 64 135.8l0 8.2-144 0 0-128-96 0 0 128L0 512 0 0zM64 96l0 64 64 0 0-64L64 96zm0 128l0 64 64 0 0-64-64 0zM160 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM256 96l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm19.3-211.3l56 56L582.6 368l-11.3 11.3-56 56L504 446.6 481.4 424l11.3-11.3L521.4 384 432 384l-16 0 0-32 16 0 89.4 0-28.7-28.7L481.4 312 504 289.4l11.3 11.3z']
      
    ]
  };

  

  
  

  var faRectangleHistory = {
    prefix: 'fasds',
    iconName: 'rectangle-history',
    icon: [
      512,
      512,
      [],
      'e4a2',
      
      ['M48 80l0 48 416 0 0-48L48 80zM96 0l0 48 320 0 0-48L96 0z','M512 160l0 352L0 512 0 160l512 0z']
      
    ]
  };

  

  
  

  var faTally4 = {
    prefix: 'fasds',
    iconName: 'tally-4',
    icon: [
      640,
      512,
      [],
      'e297',
      
      ['M96 32l0 32 0 384 0 32 64 0 0-32 0-384 0-32L96 32zm128 0l0 32 0 384 0 32 64 0 0-32 0-384 0-32-64 0zm128 0l0 32 0 384 0 32 64 0 0-32 0-384 0-32-64 0z','M544 32l0 32 0 384 0 32-64 0 0-32 0-384 0-32 64 0z']
      
    ]
  };

  

  
  

  var faAnchorCircleCheck = {
    prefix: 'fasds',
    iconName: 'anchor-circle-check',
    icon: [
      640,
      512,
      [],
      'e4aa',
      
      ['M0 352l64 0 0 128 0 32 32 0 192 0 106.8 0c-23.3-16.4-42.5-38.4-55.6-64L320 448l0-79.5 0-.5 0-.5L320 240l32 0 23.2 0c2.8-2.7 5.8-5.3 8.8-7.8l0-56.2-32 0-10.9 0C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80L224 176l-32 0 0 64 32 0 32 0 0 208-128 0 0-96 64 0L96 256 0 352zM320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-164.7l-72 72L480 430.6l-11.3-11.3-40-40L417.4 368 440 345.4l11.3 11.3L480 385.4l60.7-60.7L552 313.4 574.6 336l-11.3 11.3z']
      
    ]
  };

  

  
  

  var faMp3Player = {
    prefix: 'fasds',
    iconName: 'mp3-player',
    icon: [
      384,
      512,
      [],
      'f8ce',
      
      ['M0 0L384 0l0 512L0 512 0 0zM64 64l0 128 256 0 0-128L64 64zM96 352a96 96 0 1 0 192 0A96 96 0 1 0 96 352z','M320 64l0 128L64 192 64 64l256 0zM224 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 352a96 96 0 1 1 192 0A96 96 0 1 1 96 352z']
      
    ]
  };

  

  
  

  var faCalendarDays = {
    prefix: 'fasds',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      ['M0 192l448 0 0 320L0 512 0 192zm64 64l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM192 256l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0zM320 256l0 64 64 0 0-64-64 0zm0 128l0 64 64 0 0-64-64 0z','M160 32l0-32L96 0l0 32 0 32L0 64 0 192l448 0 0-128-96 0 0-32 0-32L288 0l0 32 0 32L160 64l0-32z']
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faWifiFair = {
    prefix: 'fasds',
    iconName: 'wifi-fair',
    icon: [
      640,
      512,
      ["wifi-2"],
      'f6ab',
      
      ['M9.8 156.7l44.3 46.2C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9l44.3-46.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7z','M171.8 312c39.5-34.9 91.3-56 148.2-56s108.6 21.1 148.2 56l42.4-48C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72l42.4 48zM320 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128z']
      
    ]
  };

  
    var faWifi2 = faWifiFair;
  

  
  

  var faTirePressureWarning = {
    prefix: 'fasds',
    iconName: 'tire-pressure-warning',
    icon: [
      512,
      512,
      [],
      'f633',
      
      ['M3.2 313.3C8.6 361.9 31.3 412.3 80 462l0 50 64 0 0-24 32 0 0 24 64 0 0-24 32 0 0 24 64 0 0-24 32 0 0 24 64 0 0-50c48.7-49.7 71.4-100.1 76.8-148.7c5.9-53.6-9.9-100.6-27.5-136.2c-7.8-15.8-14.5-30-19.3-44.4l-2.5-7.4C451.9 102.5 448 78.5 448 54.5L448 32l0-32L384 0l0 32 0 22.5c0 31 5 61.7 14.8 91.1l2.5 7.4c6.3 19 14.8 36.6 22.6 52.5c14.7 29.7 25.3 64 21.3 100.9c-3.7 34-20.4 74.1-65.7 117.7l-246.8 0c-45.3-43.6-62-83.7-65.7-117.7c-4.1-36.9 6.6-71.1 21.3-100.9c7.8-15.8 16.3-33.5 22.6-52.5l2.5-7.4C123 116.2 128 85.4 128 54.5L128 32l0-32L64 0l0 32 0 22.5c0 24.1-3.9 48-11.5 70.8L50 132.7c-4.8 14.4-11.5 28.6-19.3 44.4C13.2 212.7-2.7 259.7 3.2 313.3z','M280 120l0-24-48 0 0 24 0 112 0 24 48 0 0-24 0-112zm0 168l-48 0 0 48 48 0 0-48z']
      
    ]
  };

  

  
  

  var faDiceThree = {
    prefix: 'fasds',
    iconName: 'dice-three',
    icon: [
      448,
      512,
      [9858],
      'f527',
      
      ['M0 32L0 480l448 0 0-448L0 32zM160 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z','M96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z']
      
    ]
  };

  

  
  

  var faBuildingUn = {
    prefix: 'fasds',
    iconName: 'building-un',
    icon: [
      384,
      512,
      [],
      'e4d9',
      
      ['M0 0L0 512l144 0 0-128 96 0 0 128 144 0L384 0 0 0zM64 224l64 0 0 64-64 0 0-64zM80 64l32 0 0 16 0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64 0-16 32 0 0 16 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64 0-16zm80 160l64 0 0 64-64 0 0-64zM208 64l16 0 8 0 9.9 0 4.4 8.8L272 124.2 272 80l0-16 32 0 0 16 0 96 0 16-16 0-8 0-9.9 0-4.4-8.8L240 131.8l0 44.2 0 16-32 0 0-16 0-96 0-16zm48 160l64 0 0 64-64 0 0-64z','M112 80l0-16L80 64l0 16 0 64c0 26.5 21.5 48 48 48s48-21.5 48-48l0-64 0-16-32 0 0 16 0 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64zM224 64l-16 0 0 16 0 96 0 16 32 0 0-16 0-44.2 25.7 51.4 4.4 8.8 9.9 0 8 0 16 0 0-16 0-96 0-16-32 0 0 16 0 44.2L246.3 72.8 241.9 64 232 64l-8 0z']
      
    ]
  };

  

  
  

  var faRing = {
    prefix: 'fasds',
    iconName: 'ring',
    icon: [
      512,
      512,
      [],
      'f70b',
      
      ['M64 189c.5-.5 1.1-1 1.7-1.5c6.9-6.1 18.1-14.7 33.9-23.5c31.4-17.4 82.1-36 156.5-36s125.1 18.5 156.5 36c15.8 8.8 26.9 17.4 33.9 23.5c.6 .5 1.1 1 1.7 1.5l0 19 0 19c-.5 .5-1.1 1-1.7 1.5c-6.9 6.1-18.1 14.7-33.9 23.5c-1.2 .7-2.5 1.4-3.7 2C368.7 235.4 315 224 256 224s-112.7 11.4-152.7 30.1c-1.3-.7-2.5-1.4-3.7-2c-15.8-8.8-26.9-17.4-33.9-23.5c-.6-.5-1.1-1-1.7-1.5l0-19 0-19z','M64 208l0 19c.5 .5 1.1 1 1.7 1.5c6.9 6.1 18.1 14.7 33.9 23.5c31.4 17.4 82.1 36 156.5 36s125.1-18.5 156.5-36c15.8-8.8 26.9-17.4 33.9-23.5c.6-.5 1.1-1 1.7-1.5l0-19 0-19c-.5-.5-1.1-1-1.7-1.5c-6.9-6.1-18.1-14.7-33.9-23.5c-31.4-17.4-82.1-36-156.5-36s-125.1 18.5-156.5 36c-15.8 8.8-26.9 17.4-33.9 23.5c-.6 .5-1.1 1-1.7 1.5l0 19zm448-32l0 32 0 32 0 11.2 0 84.8 0 11.2-7 8.8-25-20c25 20 25 20 25 20s0 0 0 0c0 0 0 0-.1 .1l-.1 .2-.3 .4c-.3 .3-.6 .7-1 1.2c-.8 .9-1.9 2.1-3.2 3.5c-2.7 2.9-6.5 6.7-11.5 11.1c-10.1 8.9-24.9 20.3-45.1 31.5c-40.6 22.6-101.9 44-187.5 44s-146.9-21.5-187.5-44c-20.2-11.2-35.1-22.6-45.1-31.5c-5-4.4-8.9-8.2-11.5-11.1c-1.3-1.4-2.4-2.6-3.2-3.5c-.4-.5-.7-.8-1-1.2l-.3-.4-.1-.2c0 0 0 0-.1-.1c0 0 0 0 0 0l25-20L7 356l-7-8.8L0 336l0-84.8L0 240l0-32 0-32 0-11.2L7 156l25 20C7 156 7 156 7 156s0 0 0 0c0 0 0 0 .1-.1l.1-.2 .3-.4c.3-.3 .6-.7 1-1.2c.8-.9 1.9-2.1 3.2-3.5c2.7-2.9 6.5-6.7 11.5-11.1c10.1-8.9 24.9-20.3 45.1-31.5C109.1 85.5 170.4 64 256 64s146.9 21.5 187.5 44c20.2 11.2 35.1 22.6 45.1 31.5c5 4.4 8.9 8.2 11.5 11.1c1.3 1.4 2.4 2.6 3.2 3.5c.4 .5 .7 .8 1 1.2l.3 .4 .1 .2c0 0 0 0 .1 .1c0 0 0 0 0 0l-25 20 25-20 7 8.8 0 11.2z']
      
    ]
  };

  

  
  

  var faWaveSquare = {
    prefix: 'fasds',
    iconName: 'wave-square',
    icon: [
      640,
      512,
      [],
      'f83e',
      
      ['M128 32l32 0 160 0 32 0 0 32 0 352 96 0 0-160 0-32 32 0 128 0 32 0 0 64-32 0-96 0 0 160 0 32-32 0-160 0-32 0 0-32 0-352-96 0 0 160 0 32-32 0L32 288 0 288l0-64 32 0 96 0 0-160 0-32z','']
      
    ]
  };

  

  
  

  var faFileLines = {
    prefix: 'fasds',
    iconName: 'file-lines',
    icon: [
      384,
      512,
      [61686,128441,128462,"file-alt","file-text"],
      'f15c',
      
      ['M0 0L224 0l0 160 160 0 0 352L0 512 0 0zM96 256l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zm0 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0zm0 64l0 32 16 0 160 0 16 0 0-32-16 0-160 0-16 0z','M384 160L224 0l0 160 160 0zM112 256l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0zm0 64l-16 0 0 32 16 0 160 0 16 0 0-32-16 0-160 0z']
      
    ]
  };

  
    var faFileAlt = faFileLines;
  
    var faFileText = faFileLines;
  

  
  

  var faExplosion = {
    prefix: 'fasds',
    iconName: 'explosion',
    icon: [
      576,
      512,
      [],
      'e4e9',
      
      ['M0 320l144 48L96 192 240 304l24-176 48 0 24 168L544 0 432 368l144-48L466.3 448 384 448c0-53-43-96-96-96s-96 43-96 96l-82.3 0L0 320zM264 0l48 0 0 24 0 48 0 24-48 0 0-24 0-48 0-24z','M0 448l32 0 512 0 32 0 0 64-32 0L32 512 0 512l0-64z']
      
    ]
  };

  

  
  

  var faDownLeftAndUpRightToCenter = {
    prefix: 'fasds',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
      512,
      512,
      ["compress-alt"],
      'f422',
      
      ['M0 456l56 56L156 412l52 52 32-32 0-160L80 272 48 304l52 52L0 456z','M304 48L272 80l0 160 160 0 32-32-52-52L512 56 456 0 356 100 304 48z']
      
    ]
  };

  
    var faCompressAlt = faDownLeftAndUpRightToCenter;
  

  
  

  var faSquareUser = {
    prefix: 'fasds',
    iconName: 'square-user',
    icon: [
      448,
      512,
      [],
      'e283',
      
      ['M0 32l64 0 320 0 64 0 0 64 0 320 0 64-64 0L64 480 0 480l0-64L0 96 0 32zM80 416l288 0-32-96-224 0L80 416zm72-216a72 72 0 1 0 144 0 72 72 0 1 0 -144 0z','M224 128a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM80 416l32-96 224 0 32 96L80 416z']
      
    ]
  };

  

  
  

  var faFaceHandPeeking = {
    prefix: 'fasds',
    iconName: 'face-hand-peeking',
    icon: [
      640,
      512,
      [129763],
      'e481',
      
      ['M84.3 356C123.2 447.7 214.1 512 320 512c87.8 0 165.3-44.2 211.4-111.5c-3.5 .3-7 .4-10.6 .4l-64.8 0-32 0 0-32 0-8.9-16 0-32 0 0-32 0-17.5c-41-7.5-72-43.4-72-86.5c0-48.6 39.4-88 88-88c6.8 0 13.3 .8 19.7 2.2l13.8-19.4 25.9 17.8 42.1 28.9 26.9-26.8 17.4-17.4C492.6 48.5 412 0 320 0C246.5 0 180.2 31 133.5 80.6l2.1 2.1L163.9 111l22.6 22.6L176.1 144l63.9 0 32 0 0 32 0 8 0 24 0 8 0 8 0 16 0 8 0 8 0 24 0 8 0 32-32 0-16 0 0 8.9 0 32-32 0-72.8 0c-11.9 0-23.7-1.7-34.9-4.9zM240 216c0 10.7 0 21.3 0 32c0-2.7 0-5.3 0-8l0-16c0-2.7 0-5.3 0-8zm16 184c0-26.5 28.7-48 64-48s64 21.5 64 48s-28.7 48-64 48s-64-21.5-64-48zM368.4 224c0 6.1 2.3 11.8 6.1 16l35.8 0c3.8-4.2 6.1-9.9 6.1-16c0-13.3-10.7-24-24-24s-24 10.7-24 24z','M118.2 176L240 176l0 32-80 0 0 8 80 0 0 32-80 0 0 8 80 0 .3 32L160 288l0 8.9 32 0 0 32-72.8 0c-25.2 0-49.5-10-67.3-27.9c-36.9-36.9-37.2-96.6-.8-133.8l.8-.8L113 105.3l28.3 28.3-28.8 28.8L98.8 176l19.3 0zm427.4 44.4l-30.8-30.8L543 161.3l45.1 45.1 .8 .8c36.4 37.2 36.1 96.9-.8 133.8c-17.9 17.9-42.1 27.9-67.3 27.9l-72.8 0 0-32 32 0 0-8.9-72 0 0-32 72 0 0-8-72 0 0-32 58.6 0 24.9 0 0-12.2-17-12.2L414.7 189l18.6-26 112.2 77 0-19.6z']
      
    ]
  };

  

  
  

  var faTheta = {
    prefix: 'fasds',
    iconName: 'theta',
    icon: [
      384,
      512,
      [],
      'f69e',
      
      ['M96 224l32 0 128 0 32 0 0 64-32 0-128 0-32 0 0-64z','M104.2 128.4C79.9 160 64 205 64 256s15.9 96 40.2 127.6C128.5 415.1 159.8 432 192 432s63.5-16.9 87.8-48.4C304.1 352 320 307 320 256s-15.9-96-40.2-127.6C255.5 96.9 224.2 80 192 80s-63.5 16.9-87.8 48.4zm-50.7-39C87.1 45.7 135.8 16 192 16s104.9 29.7 138.5 73.4C364.1 133.1 384 192.1 384 256s-19.9 122.9-53.5 166.6C296.9 466.3 248.2 496 192 496s-104.9-29.7-138.5-73.4C19.9 378.9 0 319.9 0 256S19.9 133.1 53.5 89.4z']
      
    ]
  };

  

  
  

  var faFonduePot = {
    prefix: 'fasds',
    iconName: 'fondue-pot',
    icon: [
      512,
      512,
      [129749],
      'e40d',
      
      ['M64 224l0 16 0 64 0 16 32 0 0-16 0-48 32 0 0 16 0 16 32 0 0-16 0-32 0-16-16 0-64 0-16 0zm160 0l32.5 0 15.3-61.1 15.5 3.9L325.1 15.5 263 0 225.2 151.3l15.5 3.9-16.2 65c-.3 1.3-.5 2.6-.5 3.9zm80 0l35.2 0 40.3-60.5 13.3 8.9L484.1 35.5 430.9 0 339.6 136.9l13.3 8.9-46.3 69.4c-1.8 2.7-2.7 5.8-2.7 8.9z','M64 224L0 224l0 96c0 52.3 25.1 98.8 64 128l0 32 0 32 64 0 0-32 0-3.2c10.3 2.1 21 3.2 32 3.2l128 0c11 0 21.7-1.1 32-3.2l0 3.2 0 32 64 0 0-32 0-32c38.9-29.2 64-75.7 64-128l0-32 32 0 32 0 0-64-32 0-32 0-64 0-32 0-192 0 0 16 0 32 0 16-32 0 0-16 0-16-32 0 0 48 0 16-32 0 0-16 0-64 0-16z']
      
    ]
  };

  

  
  

  var faRingDiamond = {
    prefix: 'fasds',
    iconName: 'ring-diamond',
    icon: [
      384,
      512,
      [],
      'e5ab',
      
      ['M92.9 72.6L99 83.7l30.4 54.8c19.6-6.8 40.7-10.4 62.6-10.4c1.4 0 2.7 0 4.1 0s2.7 .1 4.1 .1c2.7 .1 5.4 .3 8.1 .5c5.4 .4 10.7 1.1 15.9 2c10.4 1.8 20.6 4.4 30.4 7.7L285 83.7l6.1-11.1-5.7-11.3-24-48L254.8 0 240 0 144 0 129.2 0l-6.6 13.3-24 48L92.9 72.6z','M192 192a128 128 0 1 0 0 256 128 128 0 1 0 0-256zM384 320A192 192 0 1 1 0 320a192 192 0 1 1 384 0z']
      
    ]
  };

  

  
  

  var faRobotAstromech = {
    prefix: 'fasds',
    iconName: 'robot-astromech',
    icon: [
      512,
      512,
      [],
      'e2d2',
      
      ['M0 480l0 32 128 0 0-128 64 64 128 0 64-64 0 128 128 0 0-32-48-64 0-224-80 0-256 0-80 0 0 224L0 480zM192 256l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32zm0 64l16 0 96 0 16 0 0 32-16 0-96 0-16 0 0-32z','M128 128C128 57.3 185.3 0 256 0s128 57.3 128 128l0 64-256 0 0-64zm96 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM208 256l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0zm0 64l96 0 16 0 0 32-16 0-96 0-16 0 0-32 16 0z']
      
    ]
  };

  

  
  

  var faInfo = {
    prefix: 'fasds',
    iconName: 'info',
    icon: [
      192,
      512,
      [],
      'f129',
      
      ['M48 32l80 0 0 80-80 0 0-80z','M32 192L0 192l0 64 32 0 32 0 0 192-32 0L0 448l0 64 32 0 32 0 64 0 32 0 32 0 0-64-32 0-32 0 0-224 0-32-32 0-64 0z']
      
    ]
  };

  

  
  

  var faSalad = {
    prefix: 'fasds',
    iconName: 'salad',
    icon: [
      512,
      512,
      [129367,"bowl-salad"],
      'f81e',
      
      ['M0 160c0 53 43 96 96 96l73.4 0L84.7 171.3 73.4 160 96 137.4l11.3 11.3L208 249.4 208 112l0-16 32 0 0 16 0 144 52 0c-2.6-10.2-4-21-4-32c0-70.7 57.3-128 128-128c2.6 0 5.2 .1 7.8 .2C406.2 76.5 380.5 64 352 64c-8.7 0-17.2 1.2-25.3 3.4C309.5 27.7 270 0 224 0s-85.5 27.7-102.7 67.4c-8-2.2-16.5-3.4-25.3-3.4C43 64 0 107 0 160zm320 64c0 11.2 1.9 22 5.5 32l181.1 0c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96z','M512 288L0 288l0 24c0 67 39.2 124.9 96 151.8L96 512l320 0 0-48.2c56.8-27 96-84.8 96-151.8l0-24z']
      
    ]
  };

  
    var faBowlSalad = faSalad;
  

  
  

  var faMessage = {
    prefix: 'fasds',
    iconName: 'message',
    icon: [
      512,
      512,
      ["comment-alt"],
      'f27a',
      
      ['M512 0L0 0 0 416l160 0 0 96 144-96 208 0L512 0z','']
      
    ]
  };

  
    var faCommentAlt = faMessage;
  

  
  

  var faCoffin = {
    prefix: 'fasds',
    iconName: 'coffin',
    icon: [
      384,
      512,
      [9904],
      'f6c6',
      
      ['M0 144L104 512H280L384 144 272 0H112L0 144z','']
      
    ]
  };

  

  
  

  var faStethoscope = {
    prefix: 'fasds',
    iconName: 'stethoscope',
    icon: [
      576,
      512,
      [129658],
      'f0f1',
      
      ['M160.5 348.9c5.1 1 10.3 1.8 15.5 2.3c2.6 .3 5.3 .5 7.9 .6c1.3 .1 2.7 .1 4 .1s2.7 0 4 0c11.2 0 22.1-1.2 32.7-3.3C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112l0-70.7c4.9 2.1 10.1 3.8 15.4 4.9c2.7 .6 5.4 1 8.2 1.3s5.6 .4 8.4 .4c11.4 0 22.2-2.4 32-6.7l0 70.7c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1z','M134.8 63.3L119.3 1.2 88.2 9l-32 8L32 23l0 25 0 144c0 88.4 71.6 160 160 160s160-71.6 160-160l0-144 0-25L327.8 17l-32-8-31-7.8L249.2 63.3l31 7.8L288 73l0 119c0 53-43 96-96 96s-96-43-96-96L96 73l7.8-1.9 31-7.8zM512 192a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z']
      
    ]
  };

  

  
  

  var faGaugeSimpleMin = {
    prefix: 'fasds',
    iconName: 'gauge-simple-min',
    icon: [
      512,
      512,
      ["tachometer-slowest"],
      'f62d',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm55-.2c8.4-13.6 16.8-27.2 25.3-40.8c6.8 4.2 13.6 8.4 20.4 12.6c39.2 24.3 78.4 48.5 117.6 72.8c10.6-7.8 23.7-12.4 37.8-12.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-3.7 .3-7.3 .9-10.8c-39.2-24.3-78.4-48.5-117.5-72.8c-6.8-4.2-13.6-8.4-20.4-12.6z','M100.6 227.6L80.2 215 55 255.8l20.4 12.6 117.5 72.8c-.6 3.5-.9 7.1-.9 10.8c0 35.3 28.7 64 64 64s64-28.7 64-64s-28.7-64-64-64c-14.1 0-27.2 4.6-37.8 12.4L100.6 227.6z']
      
    ]
  };

  
    var faTachometerSlowest = faGaugeSimpleMin;
  

  
  

  var faFaceHandYawn = {
    prefix: 'fasds',
    iconName: 'face-hand-yawn',
    icon: [
      512,
      512,
      [],
      'e379',
      
      ['M0 256c0 94.5 51.2 177 127.3 221.4c-9.8-18-15.3-38.6-15.3-60.5l0-82.4 0-32 32 0 17.6 0C169.9 257.8 209 224 256 224c25.5 0 48.7 10 65.9 26.2l6.1-6.1 22.6 22.6 22.6 22.6L395.9 312l-16 16 9.4 9.4L411.9 360l-22.6 22.6-9.4 9.4 9.4 9.4L411.9 424l-22.6 22.6-52.3 52.3C438.7 465.1 512 369.1 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm89.5-82.5c4.2-3.3 8.3-6.7 12.5-10c26.7-21.3 53.3-42.7 80-64c4.2-3.3 8.3-6.7 12.5-10c6.7 8.3 13.3 16.7 20 25c-4.2 3.3-8.3 6.7-12.5 10l-80 64c-4.2 3.3-8.3 6.7-12.5 10c-6.7-8.3-13.3-16.7-20-25zm208-59c6.7-8.3 13.3-16.7 20-25c4.2 3.3 8.3 6.7 12.5 10c26.7 21.3 53.3 42.7 80 64c4.2 3.3 8.3 6.7 12.5 10c-6.7 8.3-13.3 16.7-20 25c-4.2-3.3-8.3-6.7-12.5-10l-80-64c-4.2-3.3-8.3-6.7-12.5-10z','M214.5 114.5l-20-25L182 99.5l-80 64-12.5 10 20 25 12.5-10 80-64 12.5-10zm76.8 192.8L302.6 296 280 273.4l-11.3 11.3L184 369.4l0-15 0-20-40 0 0 20 0 29.6 0 20 0 12.8c0 52.6 42.6 95.2 95.2 95.2c25.2 0 49.5-10 67.3-27.9l48.8-48.8L366.6 424 344 401.4l-11.3 11.3-24 24-9.4-9.4 56-56L366.6 360 344 337.4l-11.3 11.3-56 56-9.4-9.4 72-72L350.6 312 328 289.4l-11.3 11.3-72 72-9.4-9.4 56-56zM310 124.5l80 64 12.5 10 20-25-12.5-10-80-64-12.5-10-20 25 12.5 10z']
      
    ]
  };

  

  
  

  var faUserXmark = {
    prefix: 'fasds',
    iconName: 'user-xmark',
    icon: [
      640,
      512,
      ["user-times"],
      'f235',
      
      ['M0 512l448 0L384 304 64 304 0 512zM96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128z','M617 177l17-17L600 126.1l-17 17-47 47-47-47-17-17L438.1 160l17 17 47 47-47 47-17 17L472 321.9l17-17 47-47 47 47 17 17L633.9 288l-17-17-47-47 47-47z']
      
    ]
  };

  
    var faUserTimes = faUserXmark;
  

  
  

  var faTextHeight = {
    prefix: 'fasds',
    iconName: 'text-height',
    icon: [
      576,
      512,
      [],
      'f034',
      
      ['M0 32l32 0 96 0 64 0 96 0 32 0 0 32 0 64 0 32-64 0 0-32 0-32-64 0 0 320 32 0 32 0 0 64-32 0L96 480l-32 0 0-64 32 0 32 0 0-320L64 96l0 32 0 32L0 160l0-32L0 64 0 32z','M384 128l96-96 96 96 0 32-64 0 0 192 64 0 0 32-96 96-96-96 0-32 64 0 0-192-64 0 0-32z']
      
    ]
  };

  

  
  

  var faHeadSideGoggles = {
    prefix: 'fasds',
    iconName: 'head-side-goggles',
    icon: [
      512,
      512,
      ["head-vr"],
      'f6ea',
      
      ['M32 192c.1 3.2 0 6.5 0 9.7c0 53.5 21.3 104.8 59.1 142.6l4.9 4.9L96 480l0 32 32 0 160 0 32 0 0-32 0-32 96 0 32 0 0-32 0-96 32 0 32 0 0-32 0-16 0-11.2-7-8.8-22.4-28-2.6 0-32 0-32 0-64 0-48 0c-26.2 0-49.4-12.6-64-32L32 192zm13.9-64l179.7 0C233 91.5 265.3 64 304 64l48 0 47.1 0C364 24.7 312.9 0 256 0L233.7 0C148.3 0 75.3 53.1 45.9 128z','M304 64l112 0 0 160-112 0c-26.2 0-49.4-12.6-64-32L32 192 0 192l0-64 32 0 193.6 0C233 91.5 265.3 64 304 64zM512 224l-64 0 0-160 64 0 0 160z']
      
    ]
  };

  
    var faHeadVr = faHeadSideGoggles;
  

  
  

  var faCircleL = {
    prefix: 'fasds',
    iconName: 'circle-l',
    icon: [
      512,
      512,
      [],
      'e114',
      
      ['M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM160 128l48 0 0 24 0 184 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-208 0-24z','M208 128l0 24 0 184 120 0 24 0 0 48-24 0-144 0-24 0 0-24 0-208 0-24 48 0z']
      
    ]
  };

  

  
  

  var faTrashCan = {
    prefix: 'fasds',
    iconName: 'trash-can',
    icon: [
      448,
      512,
      [61460,"trash-alt"],
      'f2ed',
      
      ['M32 96l0 416 384 0 0-416L32 96zm80 64l32 0 0 16 0 224 0 16-32 0 0-16 0-224 0-16zm96 0l32 0 0 16 0 224 0 16-32 0 0-16 0-224 0-16zm96 0l32 0 0 16 0 224 0 16-32 0 0-16 0-224 0-16z','M304 0L144 0 128 32 0 32 0 96l448 0 0-64L320 32 304 0z']
      
    ]
  };

  
    var faTrashAlt = faTrashCan;
  

  
  

  var faPhoneArrowUpRight = {
    prefix: 'fasds',
    iconName: 'phone-arrow-up-right',
    icon: [
      512,
      512,
      ["phone-arrow-up","phone-outgoing"],
      'e224',
      
      ['M0 32L144 0l80 144-83.8 67c36.1 68.4 92.3 124.6 160.8 160.8L368 288l144 80L480 512l-32 0C200.6 512 0 311.4 0 64L0 32z','M288 190.1l17-17 119-119-54.1 0-24 0 0-48 24 0 112 0 24 0 0 24 0 112 0 24-48 0 0-24 0-54.1-119 119-17 17L288 190.1z']
      
    ]
  };

  
    var faPhoneArrowUp = faPhoneArrowUpRight;
  
    var faPhoneOutgoing = faPhoneArrowUpRight;
  

  
  

  var faRectanglesMixed = {
    prefix: 'fasds',
    iconName: 'rectangles-mixed',
    icon: [
      576,
      512,
      [],
      'e323',
      
      ['M64 304l0 176 272 0 0-176L64 304zM384 32l0 352 192 0 0-352L384 32z','M0 32H320V256H0V32z']
      
    ]
  };

  

  
  

  var faAt = {
    prefix: 'fasds',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      ['M256 64C150 64 64 150 64 256s86 192 192 192l32 0 0 64-32 0C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 96 0 32-32 0-40 0c-36 0-68.2-15.8-90.2-40.9C326.4 368.3 293 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c32.5 0 62.1 12.1 84.7 32l43.3 0 0 32 0 64 0 8c0 30.9 25.1 56 56 56l8 0 0-64c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z','']
      
    ]
  };

  

  
  

  var faTransporter7 = {
    prefix: 'fasds',
    iconName: 'transporter-7',
    icon: [
      512,
      512,
      [],
      'e2a8',
      
      ['M0 304l32 16 16 32 16-32 32-16L64 288 48 256 32 288 0 304zM416 80l32 16 16 32 16-32 32-16L480 64 464 32 448 64 416 80z','M96 448H416v64H96V448z']
      
    ]
  };

  

  
  

  var faBagel = {
    prefix: 'fasds',
    iconName: 'bagel',
    icon: [
      640,
      512,
      [129391],
      'e3d7',
      
      ['M319.4 91.4c29.8 15.7 56 37.4 76.8 63.6c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64c0 30.6-21.5 56.3-50.3 62.5c1.5 10.9 2.3 22.1 2.3 33.5c0 27.3-4.5 53.5-12.9 77.9L478.8 352l56.7-1.6 19-53.4 44.9-34.6-16-54.4 16-54.4L554.5 119l-19-53.4L478.8 64 432 32 385.2 64l-56.7 1.6-9.2 25.7z','M640 208c0 114.9-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3c5.7-10.8 10.6-22.1 14.6-33.8L478.8 352l56.7-1.6 19-53.4 44.9-34.6-16-54.4 16-54.4L554.5 119l-19-53.4L478.8 64 432 32 385.2 64l-56.7 1.6-9.2 25.7c-14.4-7.6-29.7-13.7-45.7-18.3C311.8 28.4 368.6 0 432 0C546.9 0 640 93.1 640 208zm-144 0c0 30.6-21.5 56.3-50.3 62.5c-6-43.3-23.6-82.9-49.5-115.6c10.2-6.9 22.6-11 35.9-11c35.3 0 64 28.7 64 64zM0 304a208 208 0 1 1 416 0A208 208 0 1 1 0 304zm256 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM120 208l24 24 24-24-24-24-24 24zM80 296l24-24L80 248 56 272l24 24zm32 128l24-24-24-24L88 400l24 24zM304 264l24-24-24-24-24 24 24 24zM216 432l24 24 24-24-24-24-24 24zm88-8l24-24-24-24-24 24 24 24z']
      
    ]
  };

  

  
  

  var faLineHeight = {
    prefix: 'fasds',
    iconName: 'line-height',
    icon: [
      576,
      512,
      [],
      'f871',
      
      ['M256 64l320 0 0 64-320 0 0-64zm0 160l320 0 0 64-320 0 0-64zm0 160l320 0 0 64-320 0 0-64z','M96 32l96 96-64 0 0 256 64 0L96 480 0 384l64 0 0-256L0 128 96 32z']
      
    ]
  };

  

  
  

  var faWagonCovered = {
    prefix: 'fasds',
    iconName: 'wagon-covered',
    icon: [
      640,
      512,
      [],
      'f8ee',
      
      ['M0 0L224 16l0 208L64 224 0 0zM288 400.2A112 112 0 1 1 64 400a112 112 0 1 1 224 .2zM114 384l46 0 0-46c-22.5 5.8-40.2 23.5-46 46zm0 32c5.8 22.5 23.5 40.2 46 46l0-46-46 0zm78-78l0 46 46 0c-5.8-22.5-23.5-40.2-46-46zm0 78l0 46c22.5-5.8 40.2-23.5 46-46l-46 0zM256 16l128 0 0 208-128 0 0-208zM576 400.2A112 112 0 1 1 352 400a112 112 0 1 1 224 .2zM402 384l46 0 0-46c-22.5 5.8-40.2 23.5-46 46zm0 32c5.8 22.5 23.5 40.2 46 46l0-46-46 0zM416 16L640 0 576 224l-160 0 0-208zm64 322l0 46 46 0c-5.8-22.5-23.5-40.2-46-46zm0 78l0 46c22.5-5.8 40.2-23.5 46-46l-46 0z','M576 256L64 256l0 64 33.6 0c20.2-19.8 47.9-32 78.4-32c61.9 0 112 50.1 112 112c0 5.4-.4 10.8-1.1 16l66.3 0c-.7-5.2-1.1-10.6-1.1-16c0-61.9 50.1-112 112-112c30.5 0 58.2 12.2 78.4 32l33.6 0 0-64z']
      
    ]
  };

  

  
  

  var faCircleChevronRight = {
    prefix: 'fasds',
    iconName: 'circle-chevron-right',
    icon: [
      512,
      512,
      ["chevron-circle-right"],
      'f138',
      
      ['M512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM190.1 152c5.7 5.7 11.3 11.3 17 17c29 29 58 58 87 87c-29 29-58 58-87 87c-5.7 5.7-11.3 11.3-17 17c11.3 11.3 22.6 22.6 33.9 33.9c5.7-5.7 11.3-11.3 17-17c34.7-34.7 69.3-69.3 104-104c5.7-5.7 11.3-11.3 17-17c-5.7-5.7-11.3-11.3-17-17c-34.7-34.7-69.3-69.3-104-104c-5.7-5.7-11.3-11.3-17-17L190.1 152z','M361.9 256l-17 17L241 377l-17 17L190.1 360l17-17 87-87-87-87-17-17L224 118.1l17 17L345 239l17 17z']
      
    ]
  };

  
    var faChevronCircleRight = faCircleChevronRight;
  

  
  

  var faArrowsToCircle = {
    prefix: 'fasds',
    iconName: 'arrows-to-circle',
    icon: [
      640,
      512,
      [],
      'e4bd',
      
      ['M256 256a64 64 0 1 0 128 0 64 64 0 1 0 -128 0z','M48 2.7L70.6 25.4 160 114.7 160 96l0-32 64 0 0 32 0 96 0 32-32 0-96 0-32 0 0-64 32 0 18.7 0L25.4 70.6 2.7 48 48 2.7zM224 416l0 32-64 0 0-32 0-18.7L70.6 486.6 48 509.3 2.7 464l22.6-22.6L114.7 352 96 352l-32 0 0-64 32 0 96 0 32 0 0 32 0 96zM416 64l64 0 0 32 0 18.7 89.4-89.4L592 2.7 637.3 48 614.6 70.6 525.3 160l18.7 0 32 0 0 64-32 0-96 0-32 0 0-32 0-96 0-32zm0 352l0-96 0-32 32 0 96 0 32 0 0 64-32 0-18.7 0 89.4 89.4L637.3 464 592 509.3l-22.6-22.6L480 397.3l0 18.7 0 32-64 0 0-32z']
      
    ]
  };

  

  
  

  var faFillDrip = {
    prefix: 'fasds',
    iconName: 'fill-drip',
    icon: [
      576,
      512,
      [],
      'f576',
      
      ['M106.5 288c44.5 44.5 89 89 133.5 133.5L373.5 288l-267 0zM448 448.8c0 34.9 28.3 63.2 63.2 63.2l1.6 0c34.9 0 63.2-28.3 63.2-63.2c0-11-2.9-21.8-8.3-31.4L512 320l-55.7 97.4c-5.5 9.6-8.3 20.4-8.3 31.4z','M0 272l45.3 45.3L194.7 466.7 240 512l45.3-45.3L466.7 285.3 512 240l-45.3-45.3L317.3 45.3 272 0 226.7 45.3l-60.1 60.1-80-80L64 2.7 18.7 48 41.4 70.6l80 80L45.3 226.7 0 272zm166.6-76.1l18.7 18.7L208 237.3 253.3 192l-22.6-22.6-18.7-18.7L272 90.5 421.5 240 240 421.5 90.5 272l76.1-76.1z']
      
    ]
  };

  



export {

  faTurnUp,
  
  faLevelUpAlt,
  

  faMessageText,
  
  faCommentAltText,
  

  faSquareZ,
  

  faPersonCircleCheck,
  

  faHandHoldingMedical,
  

  faGraduationCap,
  
  faMortarBoard,
  

  faMessageMiddle,
  
  faCommentMiddleAlt,
  

  faVideo,
  
  faVideoCamera,
  

  faSquareSlidersVertical,
  
  faSlidersVSquare,
  

  faPlusMinus,
  

  faBulldozer,
  

  faBarcode,
  

  faFileMp4,
  

  faShieldKeyhole,
  

  faReflectVertical,
  

  faSquareShareNodes,
  
  faShareAltSquare,
  

  faComet,
  

  faJetFighter,
  
  faFighterJet,
  

  faPageCaretUp,
  
  faFileCaretUp,
  

  faHandshakeSimple,
  
  faHandshakeAlt,
  

  faEyes,
  

  faCircleJ,
  

  faGalleryThumbnails,
  

  faHandPointLeft,
  

  faPineapple,
  

  faCloudQuestion,
  

  faFaceWoozy,
  

  faKipSign,
  

  faFileGif,
  

  faMasksTheater,
  
  faTheaterMasks,
  

  faStapler,
  

  faD,
  

  faBedFront,
  
  faBedAlt,
  

  faHorizontalRule,
  

  faTrowel,
  

  faUmbrella,
  

  faCameraCctv,
  
  faCctv,
  

  faGrid2,
  

  faSack,
  

  faCircleT,
  

  faBuildingColumns,
  
  faBank,
  
  faInstitution,
  
  faMuseum,
  
  faUniversity,
  

  faPersonMilitaryPointing,
  

  faUsersGear,
  
  faUsersCog,
  

  faMagnifyingGlassDollar,
  
  faSearchDollar,
  

  faX,
  

  faSkullCow,
  

  faComputerSpeaker,
  

  faFerrisWheel,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faCircleWaveformLines,
  
  faWaveformCircle,
  

  faFaceNoseSteam,
  

  faTurkishLiraSign,
  
  faTry,
  
  faTurkishLira,
  

  faPrint,
  

  faCommentXmark,
  
  faCommentTimes,
  

  faFaceSmileRelaxed,
  

  faArrowsSpin,
  

  faExclamation,
  

  faTentArrowsDown,
  

  faPlane,
  

  faFaceSadTear,
  
  faSadTear,
  

  faBlockBrickFire,
  
  faFirewall,
  

  faUserInjured,
  

  faTableCellsRowUnlock,
  

  faBrainCircuit,
  

  faSkiBootSki,
  

  faKeyboardBrightnessLow,
  

  faBenchTree,
  

  faCircle3,
  

  faCardsBlank,
  

  faBone,
  

  faFileCheck,
  

  faArrowUpFromWaterPump,
  

  faBoot,
  

  faTruckContainer,
  

  faPenFancySlash,
  

  faToggleLargeOff,
  

  faLightSwitchOff,
  

  faCupcake,
  

  faBugSlash,
  

  faFaceSadSweat,
  

  faLocationPinSlash,
  
  faMapMarkerSlash,
  

  faWindWarning,
  
  faWindCircleExclamation,
  

  faPaperclipVertical,
  

  faHundredPoints,
  
  fa100,
  

  faDown,
  
  faArrowAltDown,
  

  faNoteSticky,
  
  faStickyNote,
  

  faDiceD12,
  

  faGramophone,
  

  faJar,
  

  faMagnet,
  

  faCircle2,
  

  fa1,
  

  faFalafel,
  

  faPenSwirl,
  

  faCommentExclamation,
  

  faGripDots,
  

  faSquareFull,
  

  faStopwatch20,
  

  faShieldExclamation,
  

  faCloudSun,
  

  faSyringe,
  

  faBoombox,
  

  faUserNurse,
  

  faTrashCheck,
  

  faBridgeSuspension,
  

  faTrainTram,
  

  faStarshipFreighter,
  

  faUserLarge,
  
  faUserAlt,
  

  faCirclesOverlap,
  

  faRulerVertical,
  

  faRightLeftLarge,
  

  faArrowDownFromArc,
  

  faFlower,
  

  faMagnifyingGlassMinus,
  
  faSearchMinus,
  

  faCalendarHeart,
  

  faMask,
  

  faTreeDecorated,
  

  faBrush,
  

  faMugSaucer,
  
  faCoffee,
  

  faGarlic,
  

  faCommentArrowUp,
  

  faRectangleWide,
  

  faWindowMinimize,
  

  faFileInvoice,
  

  faHandDots,
  
  faAllergies,
  

  faArrowDownToDottedLine,
  

  faClockTwelveThirty,
  

  faOnion,
  

  faUserClock,
  

  faCloudShowers,
  

  faThumbsUp,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faIdCardClip,
  
  faIdCardAlt,
  

  faEarthAsia,
  
  faGlobeAsia,
  

  faHotel,
  

  fa9,
  

  faAlbumCollection,
  

  faGifts,
  

  faCircle4,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faCalendarMinus,
  

  faBandage,
  
  faBandAid,
  

  faClapperboardPlay,
  

  faSensorCloud,
  
  faSensorSmoke,
  

  faBookUser,
  

  faWatchSmart,
  

  faBrain,
  

  faPompebled,
  

  faBowlingBall,
  

  faUnicorn,
  

  faDice,
  

  faSquareEnvelope,
  
  faEnvelopeSquare,
  

  faPersonWalkingArrowRight,
  

  faRectangleBarcode,
  
  faBarcodeAlt,
  

  faSquareS,
  

  faTurnDown,
  
  faLevelDownAlt,
  

  faWheelchairMove,
  
  faWheelchairAlt,
  

  faFaceGrimace,
  
  faGrimace,
  

  faChessPawnPiece,
  
  faChessPawnAlt,
  

  faArrowsUpDown,
  
  faArrowsV,
  

  faWaterLadder,
  
  faLadderWater,
  
  faSwimmingPool,
  

  faCalendarDay,
  

  faBellRing,
  

  faAudioDescriptionSlash,
  

  faFileSpreadsheet,
  

  faWheat,
  

  faTurnLeft,
  

  faCircleCaretRight,
  
  faCaretCircleRight,
  

  faHands,
  
  faSignLanguage,
  
  faSigning,
  

  faLifeRing,
  

  faMoneyBill1Wave,
  
  faMoneyBillWaveAlt,
  

  faEngine,
  

  faTire,
  

  faScannerGun,
  
  faScanner,
  

  faAlignRight,
  

  faWindowFlip,
  
  faWindowAlt,
  

  faInputText,
  

  faHandHoldingBox,
  

  faDungeon,
  

  faRoadCircleExclamation,
  

  faPaperPlane,
  

  faColumns3,
  

  faRightLeft,
  
  faExchangeAlt,
  

  faMessageDollar,
  
  faCommentAltDollar,
  

  faGridHorizontal,
  

  faCircleO,
  

  faScannerKeyboard,
  

  faHillRockslide,
  

  faMaskFace,
  

  faBottleDroplet,
  

  faTurnDownRight,
  

  faFaceThinking,
  

  faShare,
  
  faMailForward,
  

  faDownLeft,
  

  faDatabase,
  

  faNoteMedical,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faSnake,
  

  faHandcuffs,
  

  faInhaler,
  

  faBookJournalWhills,
  
  faJournalWhills,
  

  faBookOpen,
  

  faChevronsRight,
  
  faChevronDoubleRight,
  

  faCorner,
  

  faBahtSign,
  

  faCowbell,
  

  faLightbulbDollar,
  

  faTireRugged,
  

  faRectangleXmark,
  
  faRectangleTimes,
  
  faTimesRectangle,
  
  faWindowClose,
  

  faHandBackPointRibbon,
  

  faCartFlatbedSuitcase,
  
  faLuggageCart,
  

  faEarthEurope,
  
  faGlobeEurope,
  

  faPrintSlash,
  

  faRug,
  

  faUserTag,
  

  faImagePortrait,
  
  faPortrait,
  

  faPersonFalling,
  

  faBriefcase,
  

  faPotFood,
  

  faCloudMoon,
  

  faLocationPen,
  
  faMapMarkerEdit,
  

  faSlashForward,
  

  faShieldQuartered,
  

  faHandFist,
  
  faFistRaised,
  

  faAirplay,
  

  faLamp,
  

  faArrowsSplitUpAndLeft,
  

  faSquareW,
  

  faTruckArrowRight,
  

  faDiagramSuccessor,
  

  faCartFlatbedBoxes,
  
  faDollyFlatbedAlt,
  

  faAngleLeft,
  

  faBuildings,
  

  faHouseCircleCheck,
  

  faSwordLaser,
  

  faTomato,
  

  faBatteryThreeQuarters,
  
  faBattery4,
  

  faCheck,
  

  faIceSkate,
  

  faUserPlus,
  

  faBook,
  

  faTurkey,
  

  faClipboardListCheck,
  

  faRectangle,
  
  faRectangleLandscape,
  

  faCommentSms,
  
  faSms,
  

  faBasketShoppingMinus,
  

  faTableList,
  
  faThList,
  

  faHandBackPointDown,
  

  faH5,
  

  fa4,
  

  faSoftServe,
  
  faCreemee,
  

  faFaceViewfinder,
  

  faGripDotsVertical,
  

  faSpinnerScale,
  

  faM,
  

  faDesktop,
  
  faDesktopAlt,
  

  faDiceD8,
  

  faShower,
  

  faDoNotEnter,
  

  faGaugeSimpleHigh,
  
  faTachometer,
  
  faTachometerFast,
  

  faArrowDownBigSmall,
  
  faSortSizeDown,
  

  faCalendarLines,
  
  faCalendarNote,
  

  faScaleBalanced,
  
  faBalanceScale,
  

  faDrawPolygon,
  

  faFaceMonocle,
  

  faRss,
  
  faFeed,
  

  faArrowTrendDown,
  

  faCookieBite,
  

  faPeopleSimple,
  

  faFaceAngry,
  
  faAngry,
  

  faFunction,
  

  faBorderAll,
  

  faAnchor,
  

  faCircleQuarter,
  

  faBookQuran,
  
  faQuran,
  

  faDeleteRight,
  

  faFileCirclePlus,
  

  faTornado,
  

  faFireFlameCurved,
  
  faFireAlt,
  

  faArrowUpZA,
  
  faSortAlphaUpAlt,
  

  faPersonWalkingArrowLoopLeft,
  

  faClone,
  

  faLinkSlash,
  
  faChainBroken,
  
  faChainSlash,
  
  faUnlink,
  

  faPlugCircleExclamation,
  

  faHandHolding,
  

  faFaceGrinTongueWink,
  
  faGrinTongueWink,
  

  faCirclePlus,
  
  faPlusCircle,
  

  faShoePrints,
  

  faDragon,
  

  faWifiWeak,
  
  faWifi1,
  

  faBorderBottom,
  

  faVolumeSlash,
  

  faSdCard,
  

  faAmpGuitar,
  

  faLighthouse,
  

  faBahai,
  
  faHaykal,
  

  faUserDoctorMessage,
  
  faUserMdChat,
  

  faTrailer,
  

  faBoxHeart,
  

  faCalendar,
  

  faBoothCurtain,
  

  faCloudMoonRain,
  

  faUpDown,
  
  faArrowsAltV,
  

  faPencilMechanical,
  

  faTurtle,
  

  faCaravanSimple,
  
  faCaravanAlt,
  

  faPersonWalkingLuggage,
  

  faParagraphLeft,
  
  faParagraphRtl,
  

  faBagsShopping,
  

  faFan,
  

  faBlockBrick,
  
  faWallBrick,
  

  faVoicemail,
  

  faPersonArrowDownToLine,
  

  faObjectIntersect,
  

  faChimney,
  

  faVialCircleCheck,
  

  faInfinity,
  

  faCassetteVhs,
  
  faVhs,
  

  faChartColumn,
  

  faHippo,
  

  faTransformerBolt,
  

  faT,
  

  faOilCan,
  

  faUpRightAndDownLeftFromCenter,
  
  faExpandAlt,
  

  faHashtag,
  

  faFaceExplode,
  
  faExplodingHead,
  

  faSquareXmark,
  
  faTimesSquare,
  
  faXmarkSquare,
  

  faFacePouting,
  

  faContainerStorage,
  

  faEarthOceania,
  
  faGlobeOceania,
  

  faGopuram,
  

  faMelon,
  

  faLightbulbCflOn,
  

  faCardHeart,
  

  faShieldHeart,
  

  faVacuum,
  

  faBroom,
  

  faCoinBlank,
  

  faCircleArrowUpLeft,
  

  faCircleG,
  

  faSkeleton,
  

  faDisplayChartUpCircleCurrency,
  

  faPersonBiking,
  
  faBiking,
  

  faTemperatureLow,
  

  faCodeCommit,
  

  faFileMusic,
  

  faClockOne,
  

  faCompassSlash,
  

  faMusic,
  

  faYinYang,
  

  faSendBackward,
  

  faCheese,
  

  faSquareStar,
  

  faWineGlassEmpty,
  
  faWineGlassAlt,
  

  faPenSlash,
  

  faMoon,
  

  faArrowUpFromLine,
  
  faArrowFromBottom,
  

  faCarrot,
  

  faAmpersand,
  

  faAtomSimple,
  
  faAtomAlt,
  

  faPenLine,
  

  faDog,
  

  faWandMagic,
  
  faMagic,
  

  faTents,
  

  faCricketBatBall,
  
  faCricket,
  

  faDiagramCells,
  

  faFaceDiagonalMouth,
  

  faTentArrowTurnLeft,
  

  faBanParking,
  
  faParkingCircleSlash,
  

  faPenNib,
  

  faScythe,
  

  faHouseChimneyWindow,
  

  faCircleChevronLeft,
  
  faChevronCircleLeft,
  

  faGolfBallTee,
  
  faGolfBall,
  

  faHouseMedical,
  

  faPersonSeat,
  

  faDitto,
  

  faPhonePlus,
  

  faGlassesRound,
  
  faGlassesAlt,
  

  faBinary,
  

  faAvocado,
  

  faGunSlash,
  

  faArrowsRepeat1,
  
  faRepeat1Alt,
  

  faArrowUpShortWide,
  
  faSortAmountUpAlt,
  

  faShield,
  
  faShieldBlank,
  

  faFileExport,
  
  faArrowRightFromFile,
  

  faPhoneMissed,
  

  faFireSmoke,
  

  faFaceGrinBeamSweat,
  
  faGrinBeamSweat,
  

  faTrumpet,
  

  faClockRotateLeft,
  
  faHistory,
  

  faNestingDolls,
  

  faMagnifyingGlassMusic,
  

  faChairOffice,
  

  faFishCooked,
  

  faPenPaintbrush,
  
  faPencilPaintbrush,
  

  faBrowser,
  

  faFireplace,
  

  faDiceD10,
  

  faQrcode,
  

  faSubtitlesSlash,
  

  faAlbumCircleUser,
  

  faPancakes,
  

  faCamcorder,
  
  faVideoHandheld,
  

  faAnglesLeft,
  
  faAngleDoubleLeft,
  

  faBuilding,
  

  faTicketSimple,
  
  faTicketAlt,
  

  faAward,
  

  faUserGroupSimple,
  

  faConveyorBeltEmpty,
  

  faFlagPennant,
  
  faPennant,
  

  faPersonFallingBurst,
  

  faArrowRightToLine,
  
  faArrowToRight,
  

  faAnt,
  

  faLineColumns,
  

  faCardSpade,
  

  faSpade,
  

  faArrowTurnDown,
  
  faLevelDown,
  

  faBorderRight,
  

  faKnifeKitchen,
  

  faUpFromBracket,
  

  faMercury,
  

  faTransgender,
  
  faTransgenderAlt,
  

  faSimCard,
  

  faDiceFour,
  

  faMandolin,
  

  faMeter,
  

  faFaceGrinHearts,
  
  faGrinHearts,
  

  faSplotch,
  

  faSquareN,
  

  faArrowUpRightDots,
  

  faSquareFragile,
  
  faBoxFragile,
  
  faSquareWineGlassCrack,
  

  faLockKeyholeOpen,
  
  faLockOpenAlt,
  

  faConveyorBeltArm,
  

  faWarehouse,
  

  faSunBright,
  
  faSunAlt,
  

  faGears,
  
  faCogs,
  

  faPartyHorn,
  

  faPeace,
  

  faRobot,
  

  faWhale,
  

  faArrowUpTriangleSquare,
  
  faSortShapesUp,
  

  faTowerControl,
  

  faSpinner,
  

  faCircleQuarters,
  

  faRotate,
  
  faSyncAlt,
  

  faCircleTrash,
  
  faTrashCircle,
  

  faHandPeace,
  

  faDial,
  
  faDialMedHigh,
  

  faAlt,
  

  faDiagramLeanCanvas,
  

  faMugTeaSaucer,
  

  faTtyAnswer,
  
  faTeletypeAnswer,
  

  faSpeakers,
  

  faFaceVomit,
  

  faHammer,
  

  faPersonPraying,
  
  faPray,
  

  faCloudsSun,
  

  faTrophy,
  

  faWheatSlash,
  

  faThumbtack,
  
  faThumbTack,
  

  faSignatureSlash,
  

  faPhoneHangup,
  

  faFaceSmile,
  
  faSmile,
  

  faPersonSign,
  

  faDisplay,
  

  faCoinVertical,
  

  faLocationCheck,
  
  faMapMarkerCheck,
  

  faConveyorBelt,
  

  faGlassWaterDroplet,
  

  faTruckMoving,
  

  faPercent,
  
  faPercentage,
  

  faHandMiddleFinger,
  

  faBrightnessLow,
  

  faGaugeCircleMinus,
  

  faCarTilt,
  

  faVrCardboard,
  

  faShieldMinus,
  

  faThermometer,
  

  faCloudMinus,
  

  faTrafficLight,
  

  faCloudMusic,
  

  faDownToDottedLine,
  

  faFaceExpressionless,
  

  faBabyCarriage,
  
  faCarriageBaby,
  

  faRadio,
  

  faEllipsisStroke,
  
  faEllipsisHAlt,
  

  faBatteryQuarter,
  
  faBattery2,
  

  faVideoSlash,
  

  faFrame,
  

  faComputerClassic,
  

  faPumpSoap,
  

  faCarRear,
  
  faCarAlt,
  

  faRetweet,
  

  faClockFive,
  

  faSignalWeak,
  
  faSignal1,
  

  faChevronRight,
  

  faGenderless,
  

  faBriefcaseMedical,
  

  faTurntable,
  

  faPersonToDoor,
  

  faDisease,
  

  faNotdef,
  

  faTrashCanUndo,
  
  faTrashCanArrowTurnLeft,
  
  faTrashUndoAlt,
  

  faFilterSlash,
  

  faTablePivot,
  

  faHandLizard,
  

  faMoneyBillSimple,
  

  faClouds,
  

  faBacteria,
  

  faChevronLeft,
  

  faArrowLeftToArc,
  

  faNose,
  

  faHollyBerry,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faDrumstickBite,
  

  faDinosaur,
  

  faAngleUp,
  

  faMessageMinus,
  
  faCommentAltMinus,
  

  faFill,
  

  faGlassHalf,
  
  faGlassHalfEmpty,
  
  faGlassHalfFull,
  

  faMessageCode,
  

  faSchoolFlag,
  

  faTablet,
  
  faTabletAndroid,
  

  faCommentQuote,
  

  faCameraSlash,
  

  faCloudBoltSun,
  
  faThunderstormSun,
  

  faBellSlash,
  

  faStoreLock,
  

  faEyeDropperHalf,
  

  faBezierCurve,
  

  faSignalStreamSlash,
  

  faFolderCheck,
  

  faSquareDivide,
  

  faSignHanging,
  
  faSign,
  

  faVacuumRobot,
  

  faAngle,
  

  faOliveBranch,
  

  faPlugCircleMinus,
  

  faArrowTrendUp,
  

  faStore,
  

  faDisplayArrowDown,
  

  faCircleGf,
  

  faChartScatter,
  

  faFaceEyesXmarks,
  

  faPlanetMoon,
  

  faFolderMinus,
  

  faFloppyDiskCircleArrowRight,
  
  faSaveCircleArrowRight,
  

  faPhotoFilm,
  
  faPhotoVideo,
  

  faVideoArrowDownLeft,
  

  faCandleHolder,
  

  faClockTen,
  

  faSirenOn,
  

  faRocket,
  

  faClockEleven,
  

  faLassoSparkles,
  

  faFaceDisappointed,
  

  faFileCircleInfo,
  

  faArrowLeftFromArc,
  

  faMap,
  

  faUserHairLong,
  

  faAxeBattle,
  

  faCars,
  

  faShekelSign,
  
  faIls,
  
  faShekel,
  
  faSheqel,
  
  faSheqelSign,
  

  faTally2,
  

  faTeeth,
  

  faBlender,
  

  faWrenchSimple,
  

  faPeanut,
  

  faBuildingMagnifyingGlass,
  

  faCakeSlice,
  
  faShortcake,
  

  faEquals,
  

  faH2,
  

  faArrowRightFromLine,
  
  faArrowFromLeft,
  

  faIslandTropical,
  
  faIslandTreePalm,
  

  faBracketSquare,
  
  faBracket,
  
  faBracketLeft,
  

  faHighlighterLine,
  

  faFlaskGear,
  

  faCopyright,
  

  faSymbols,
  
  faIconsAlt,
  

  faRulerCombined,
  

  faSquareQ,
  

  faLinesLeaning,
  

  faArrowDownToBracket,
  

  faArrowDownUpLock,
  

  faTrashArrowUp,
  
  faTrashRestore,
  

  faKeySkeleton,
  

  faDownFromBracket,
  

  faTractor,
  

  faQuoteLeft,
  
  faQuoteLeftAlt,
  

  faUsersLine,
  

  faBaby,
  

  faCirclePhoneFlip,
  
  faPhoneCircleAlt,
  

  faBuildingShield,
  

  faCartCircleXmark,
  

  faFaceSmileTongue,
  

  faPesoSign,
  

  faClawMarks,
  

  faRhombus,
  

  faChalkboardUser,
  
  faChalkboardTeacher,
  

  faArrowsUpDownLeftRight,
  
  faArrows,
  

  faFaceSmirking,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faCloudCheck,
  

  faFort,
  

  faComputer,
  

  faExpand,
  

  faPlus,
  
  faAdd,
  

  faHatBeach,
  

  faSquarePhone,
  
  faPhoneSquare,
  

  fa2,
  

  faGun,
  

  faChildCombatant,
  
  faChildRifle,
  

  faKeynote,
  

  faShareFromSquare,
  
  faShareSquare,
  

  faGrip,
  
  faGripHorizontal,
  

  faJackOLantern,
  

  faUserVneckHair,
  

  faPartyBell,
  

  faPaintbrushPencil,
  

  faBarsFilter,
  

  faHandSparkles,
  

  faVolumeXmark,
  
  faVolumeMute,
  
  faVolumeTimes,
  

  faBurgerGlass,
  

  faCopy,
  

  faSnowmanHead,
  
  faFrostyHead,
  

  faSidebar,
  

  faChartPyramid,
  

  faPedestal,
  

  faDiagramProject,
  
  faProjectDiagram,
  

  faJetFighterUp,
  

  faAwardSimple,
  

  faCircleP,
  

  faBaseball,
  
  faBaseballBall,
  

  faGlobeStand,
  

  faFaceTongueSweat,
  

  faCircleRadiation,
  
  faRadiationAlt,
  

  faMusicNoteSlash,
  
  faMusicAltSlash,
  

  faMango,
  

  faLinkHorizontal,
  
  faChainHorizontal,
  

  faPhoneIntercom,
  

  faSquareChevronLeft,
  
  faChevronSquareLeft,
  

  faClapperboard,
  

  faDiamondHalfStroke,
  

  faSquareArrowDown,
  
  faArrowSquareDown,
  

  faArrowRightLongToLine,
  

  faCircleHalfStroke,
  
  faAdjust,
  

  faStarfighter,
  

  faUserGraduate,
  

  faObjectUnion,
  

  faCartShoppingFast,
  

  faHexagonExclamation,
  

  faMusicNote,
  
  faMusicAlt,
  

  faWaffle,
  

  faCloudFog,
  
  faFog,
  

  faFish,
  

  faCircleStar,
  
  faStarCircle,
  

  faCircle1,
  

  faCommentHeart,
  

  faStarSharp,
  

  faUserMagnifyingGlass,
  

  faTruckFast,
  
  faShippingFast,
  

  faLacrosseStickBall,
  

  faSquareChevronRight,
  
  faChevronSquareRight,
  

  faPersonSnowboarding,
  
  faSnowboarding,
  

  faArrowsRetweet,
  
  faRetweetAlt,
  

  faUserHeadset,
  

  faY,
  

  faCarBurst,
  
  faCarCrash,
  

  faBoxDollar,
  
  faBoxUsd,
  

  faWind,
  

  faCircleExclamationCheck,
  

  faWreathLaurel,
  

  faMegaphone,
  

  faUserShield,
  

  faMushroom,
  

  faPlanetRinged,
  

  faUserDoctorHair,
  

  faSquareY,
  

  faCircleUser,
  
  faUserCircle,
  

  faJugDetergent,
  

  faDiagramSubtask,
  

  faListCheck,
  
  faTasks,
  

  faShrimp,
  

  faCircleDivide,
  

  faBorderLeft,
  

  faTv,
  
  faTelevision,
  
  faTvAlt,
  

  faDownFromDottedLine,
  

  faArrowUp,
  

  faBoneBreak,
  

  faLandmarkDome,
  
  faLandmarkAlt,
  

  faBrazilianRealSign,
  

  faHatWinter,
  

  faMagnifyingGlassPlay,
  

  faPersonHarassing,
  

  faNfcPen,
  

  faChessKing,
  

  faRankingStar,
  

  faPhoneOffice,
  

  faEnvelopes,
  

  faDownLong,
  
  faLongArrowAltDown,
  

  faJugBottle,
  

  faSdCards,
  

  faTowerCell,
  

  faSchoolLock,
  

  faCircleEllipsis,
  

  faWatermelonSlice,
  

  faHandHoldingMagic,
  

  faListUl,
  
  faListDots,
  

  faCodeCompare,
  

  faDropletDegree,
  
  faDewpoint,
  

  faSkullCrossbones,
  

  faClub,
  

  faHospitals,
  

  faBookArrowRight,
  

  faBellPlus,
  

  faBatteryFull,
  
  faBattery,
  
  faBattery5,
  

  faChevronDown,
  

  faMoneyBillSimpleWave,
  

  faHandsHoldingDiamond,
  
  faHandReceiving,
  

  faUserHoodie,
  

  faTransporter2,
  

  faPersonCircleExclamation,
  

  faSuitcaseRolling,
  

  faDisplaySlash,
  
  faDesktopSlash,
  

  faCircleMicrophoneLines,
  
  faMicrophoneCircleAlt,
  

  faSquarePen,
  
  faPenSquare,
  
  faPencilSquare,
  

  faTablePicnic,
  

  faReceipt,
  

  faFilePen,
  
  faFileEdit,
  

  faWalkieTalkie,
  

  faWand,
  

  faCartArrowDown,
  

  faColon,
  

  faCartFlatbedEmpty,
  
  faDollyFlatbedEmpty,
  

  faLobster,
  

  faBracketCurly,
  
  faBracketCurlyLeft,
  

  faTaxiBus,
  

  faPeach,
  

  faNairaSign,
  

  faFloppyDiskCircleXmark,
  
  faFloppyDiskTimes,
  
  faSaveCircleXmark,
  
  faSaveTimes,
  

  faLocationQuestion,
  
  faMapMarkerQuestion,
  

  faSignalGood,
  
  faSignal3,
  

  faTrashCanArrowUp,
  
  faTrashRestoreAlt,
  

  faChevronsDown,
  
  faChevronDoubleDown,
  

  faPersonDotsFromLine,
  
  faDiagnoses,
  

  faTableTennisPaddleBall,
  
  faPingPongPaddleBall,
  
  faTableTennis,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faRupiahSign,
  

  faTableCellsRowLock,
  

  faBurgerLettuce,
  

  faSquareDownLeft,
  

  faCupTogo,
  
  faCoffeeTogo,
  

  faFont,
  

  faPlay,
  

  faTreeCity,
  

  faFileMinus,
  

  faEarListen,
  
  faAssistiveListeningSystems,
  

  faLink,
  
  faChain,
  

  faBallotCheck,
  

  faGrillHot,
  

  faLandmarkMagnifyingGlass,
  

  faBoxesStacked,
  
  faBoxes,
  
  faBoxesAlt,
  

  faTimer,
  

  faSpeaker,
  

  faCarBus,
  

  faStarHalf,
  

  faMoneyFromBracket,
  

  faCheckToSlot,
  
  faVoteYea,
  

  faCloudHail,
  

  faMeterFire,
  

  faSquareE,
  

  faHeadSideHeart,
  

  faParagraph,
  

  faFax,
  

  faDeerRudolph,
  

  faFishBones,
  

  faHeartCircleBolt,
  

  faIceCream,
  

  faScrubber,
  

  faDrum,
  

  faKite,
  

  faRectangleTerminal,
  

  faAngle90,
  

  faPersonWalkingWithCane,
  
  faBlind,
  

  faTransporterEmpty,
  

  faHotdog,
  

  faEarMuffs,
  

  faRouteInterstate,
  

  faBroccoli,
  

  faFaceSmilingHands,
  

  faOilCanDrip,
  

  faObjectsAlignLeft,
  

  faDharmachakra,
  

  faCircleUpLeft,
  

  faCloudHailMixed,
  

  faDiagramSankey,
  

  faBarsStaggered,
  
  faReorder,
  
  faStream,
  

  faUserBountyHunter,
  

  faChessRook,
  

  faWineBottle,
  

  faWhiskeyGlassIce,
  
  faGlassWhiskeyRocks,
  

  faPollPeople,
  

  faHospital,
  
  faHospitalAlt,
  
  faHospitalWide,
  

  faLampDesk,
  

  faEnvelopeOpenText,
  

  faSquareAmpersand,
  

  faGaugeHigh,
  
  faTachometerAlt,
  
  faTachometerAltFast,
  

  faSquareThisWayUp,
  
  faBoxUp,
  

  faSection,
  

  faSquare0,
  

  faInbox,
  

  faFaceSunglasses,
  

  faSocks,
  

  faGrid4,
  

  faBatteryEmpty,
  
  faBattery0,
  

  faSnowflakeDroplets,
  

  faDove,
  

  faHandBackPointRight,
  

  faHatChef,
  

  faGameBoard,
  

  faPersonBurst,
  

  faCrateApple,
  
  faAppleCrate,
  

  faFileSvg,
  

  faEarthAmericas,
  
  faEarth,
  
  faEarthAmerica,
  
  faGlobeAmericas,
  

  faHexagonImage,
  

  faEraser,
  

  faBullseyePointer,
  

  faDroplet,
  
  faTint,
  

  faCircleWifi,
  

  faNotebook,
  

  faFolderMagnifyingGlass,
  
  faFolderSearch,
  

  faCandyCorn,
  

  faMessageQuote,
  
  faCommentAltQuote,
  

  faUserRobotXmarks,
  

  faArrowDown,
  

  faPersonSwimming,
  
  faSwimmer,
  

  faTRex,
  

  faPretzel,
  

  faQuotes,
  

  faGreaterThan,
  

  faFile,
  

  faBoxOpenFull,
  
  faBoxFull,
  

  faCrab,
  

  faLocationDot,
  
  faMapMarkerAlt,
  

  faDialMedLow,
  

  faCircle0,
  

  faHandshakeAngle,
  
  faHandsHelping,
  

  faAccentGrave,
  

  faPaintRoller,
  

  faTrafficLightStop,
  

  faPhoneSlash,
  

  faStarOfLife,
  

  faPlugCircleXmark,
  

  faHexagonCheck,
  

  faBowlSpoon,
  

  faSuperscript,
  

  faArrowsFromLine,
  

  faFilePpt,
  

  faPinata,
  

  faXmarkLarge,
  

  faCandyBar,
  
  faChocolateBar,
  

  faBell,
  

  faTemperatureFull,
  
  faTemperature4,
  
  faThermometer4,
  
  faThermometerFull,
  

  faBee,
  

  faPodcast,
  

  faCalendarUsers,
  

  faSquareEllipsisVertical,
  

  faClockTwo,
  

  faSquareC,
  

  faSquareH,
  
  faHSquare,
  

  faBookCopy,
  

  faBed,
  

  faPersonFairy,
  

  faMedal,
  

  faTemperatureArrowUp,
  
  faTemperatureUp,
  

  faFileCircleXmark,
  

  faTruckDroplet,
  

  faDrone,
  

  faDiceD20,
  

  faBeerMug,
  
  faBeerFoam,
  

  faFileHeart,
  

  faMessageDots,
  
  faCommentAltDots,
  
  faMessaging,
  

  faHandBackPointLeft,
  

  faArrowsLeftRightToLine,
  

  faBluetooth,
  

  faChartSimpleHorizontal,
  

  faMountainSun,
  

  faCabin,
  

  faCircleX,
  

  faFamilyDress,
  

  faBookOpenReader,
  
  faBookReader,
  

  faMicrophoneStand,
  

  faUserHairMullet,
  
  faBusinessFront,
  
  faPartyBack,
  
  faTrianBalbot,
  

  faPodiumStar,
  

  faUserTieHair,
  

  faHandHoldingHand,
  

  faCar,
  
  faAutomobile,
  

  faBoxBallot,
  

  faCircleS,
  

  faCreditCard,
  
  faCreditCardAlt,
  

  faBowlChopsticks,
  

  faBug,
  

  faHandsHoldingCircle,
  

  faMagnifyingGlassWaveform,
  

  faEnvelopeDot,
  
  faEnvelopeBadge,
  

  faGlobeWifi,
  

  faToolbox,
  

  faPersonThroughWindow,
  

  faBells,
  

  faGrid2Plus,
  

  faKitMedical,
  
  faFirstAid,
  

  faChessPawn,
  

  faNfcSlash,
  

  faEllipsis,
  
  faEllipsisH,
  

  faAnchorCircleXmark,
  

  faTentDoublePeak,
  

  faTicketsAirline,
  
  faTicketsPerforatedPlane,
  
  faTicketsPlane,
  

  faArrowRightLong,
  
  faLongArrowRight,
  

  faUserLock,
  

  faThumbsDown,
  

  faGripLines,
  

  faHeadSideCough,
  

  faPanFood,
  

  faPersonDollyEmpty,
  

  faCarTunnel,
  

  faOmega,
  

  faMountains,
  

  faAngleDown,
  

  faAirConditioner,
  

  faSquareQuestion,
  
  faQuestionSquare,
  

  faOilTemperature,
  
  faOilTemp,
  

  faFaceDrooling,
  

  faDisplayCode,
  
  faDesktopCode,
  

  faLessThan,
  

  faArrowDownShortWide,
  
  faSortAmountDesc,
  
  faSortAmountDownAlt,
  

  faFlorinSign,
  

  faChartMixed,
  
  faAnalytics,
  

  faArrowsTurnToDots,
  

  faGrill,
  

  faCircleDown,
  
  faArrowAltCircleDown,
  

  faPersonRunningFast,
  

  faTurnLeftDown,
  

  faWaveTriangle,
  

  faImagePolaroid,
  

  faIndustry,
  

  faBoreHole,
  

  faArrowsRepeat,
  
  faRepeatAlt,
  

  faHorseHead,
  

  faCircleDollar,
  
  faDollarCircle,
  
  faUsdCircle,
  

  faFaceLaughWink,
  
  faLaughWink,
  

  faSignalFair,
  
  faSignal2,
  

  faHouseTree,
  

  faHockeyStickPuck,
  

  faLaptopArrowDown,
  

  faBracketsSquare,
  
  faBrackets,
  

  faFaceSmileHearts,
  

  faSquare8,
  

  faSquareArrowLeft,
  
  faArrowSquareLeft,
  

  faGuitar,
  

  faScreenUsers,
  
  faUsersClass,
  

  faTrashCanSlash,
  
  faTrashAltSlash,
  

  faSun,
  

  faObjectsAlignCenterHorizontal,
  

  faChampagneGlass,
  
  faGlassChampagne,
  

  faTrashUndo,
  
  faTrashArrowTurnLeft,
  

  faRubleSign,
  
  faRouble,
  
  faRub,
  
  faRuble,
  

  faNotes,
  

  faGearCode,
  

  faYenSign,
  
  faCny,
  
  faJpy,
  
  faRmb,
  
  faYen,
  

  faPlaneCircleXmark,
  

  faToilet,
  

  faMars,
  

  faVault,
  

  faArrowTurnLeftUp,
  

  faPersonSimple,
  

  faTableCellsColumnUnlock,
  

  faOilWell,
  

  faGlassWater,
  

  faTrashCanCheck,
  

  faBolt,
  
  faZap,
  

  faMessageSlash,
  
  faCommentAltSlash,
  

  faShieldCat,
  

  faCaravan,
  

  faArrowUpArrowDown,
  
  faSortUpDown,
  

  faHandWave,
  

  faFolderGear,
  
  faFolderCog,
  

  faFolderMedical,
  

  faCameraWebSlash,
  
  faWebcamSlash,
  

  faSaxophoneFire,
  
  faSaxHot,
  

  faFileArrowDown,
  
  faFileDownload,
  

  faCompactDisc,
  

  faToiletPortable,
  

  faBrakeWarning,
  

  faCircleHalf,
  

  faWindsock,
  

  faMound,
  

  faPeoplePants,
  

  faGridRound2Plus,
  

  faHurricane,
  

  faUpload,
  

  faUpFromLine,
  
  faArrowAltFromBottom,
  

  faMoneyCheckDollarPen,
  
  faMoneyCheckEditAlt,
  

  faCodeMerge,
  

  faStop,
  

  faUpLong,
  
  faLongArrowAltUp,
  

  faBlockQuote,
  

  faTruckPickup,
  

  faTowerBroadcast,
  
  faBroadcastTower,
  

  faLoveseat,
  
  faCouchSmall,
  

  faPeopleDress,
  

  faHandHoldingSkull,
  

  faBanana,
  

  faHouseTurret,
  

  faChartScatterBubble,
  

  faCircleVideo,
  
  faVideoCircle,
  

  faGameBoardSimple,
  
  faGameBoardAlt,
  

  faSkull,
  

  faTimelineArrow,
  

  faBowlRice,
  

  faMillSign,
  

  faBalloons,
  

  faChartPieSimpleCircleDollar,
  

  faArrowUpWideShort,
  
  faSortAmountUp,
  

  faUtensils,
  
  faCutlery,
  

  faRotateRight,
  
  faRedoAlt,
  
  faRotateForward,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faGolfClub,
  

  faCastle,
  

  faKiwiBird,
  

  faBlanketFire,
  

  faButter,
  

  faHelmetBattle,
  

  faCircleA,
  

  faDiceOne,
  

  faPotato,
  

  faFileMedical,
  

  faPipe,
  

  faMoonOverSun,
  
  faEclipseAlt,
  

  faSeatAirline,
  

  faB,
  

  faSquareDownRight,
  

  faLaptopMedical,
  

  faFlyingDisc,
  

  faCalendarWeek,
  

  faCarCircleBolt,
  

  faVectorCircle,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faHeartCircleExclamation,
  

  faCourtSport,
  

  faOutdent,
  
  faDedent,
  

  faFaceWorried,
  

  faFaceDotted,
  

  faIdCard,
  
  faDriversLicense,
  

  faBookSkull,
  
  faBookDead,
  

  faAlignCenter,
  

  faFaceMeh,
  
  faMeh,
  

  faCodePullRequestClosed,
  

  faMobile,
  
  faMobileAndroid,
  
  faMobilePhone,
  

  faUserPilot,
  

  faForward,
  

  faLoader,
  

  faGlass,
  

  faFileCircleCheck,
  

  faRotateExclamation,
  

  faScribble,
  

  faCommentsQuestion,
  

  faCommentCaptions,
  

  faEyeDropper,
  
  faEyeDropperEmpty,
  
  faEyedropper,
  

  faCloudBinary,
  

  faOven,
  

  faDeleteLeft,
  
  faBackspace,
  

  faFaceGrin,
  
  faGrin,
  

  faCloudSnow,
  

  faShelves,
  
  faInventory,
  

  faAnglesUpDown,
  

  faDownload,
  

  faArrowsDownToLine,
  

  faTugrikSign,
  

  faBatterySlash,
  

  faClockSixThirty,
  

  faShip,
  

  faGameConsoleHandheld,
  

  faPersonSledding,
  
  faSledding,
  

  faBuildingCircleXmark,
  

  faSprinkler,
  

  faFaceLying,
  

  faCloudRain,
  

  faShovelSnow,
  

  faCableCar,
  
  faTram,
  

  faGarage,
  

  faSwap,
  

  faN,
  

  faPeoplePulling,
  

  faEyeEvil,
  

  faUserHair,
  

  faShuttlecock,
  

  faCalculator,
  

  faImages,
  

  faVenusDouble,
  

  faRightFromLine,
  
  faArrowAltFromLeft,
  

  faPersonHiking,
  
  faHiking,
  

  faClosedCaptioning,
  

  faBadminton,
  

  faHouseMedicalCircleExclamation,
  

  faGearComplexCode,
  

  faCirclePhoneHangup,
  
  faPhoneCircleDown,
  

  faCompressWide,
  

  faFaceSpiralEyes,
  

  faArrowUpFromArc,
  

  faLightbulbMessage,
  

  faPipeValve,
  

  faClockFiveThirty,
  

  faPersonRifle,
  

  faDiagramNext,
  

  faChartTreeMap,
  

  faTty,
  
  faTeletype,
  

  faLaptopFile,
  

  faFlagUsa,
  

  faCitrus,
  

  faLightsHoliday,
  

  faPipeCollar,
  

  faPersonDressSimple,
  

  faCircleB,
  

  faRightLong,
  
  faLongArrowAltRight,
  

  faLaptopSlash,
  

  faCoin,
  

  faPowerOff,
  

  faTicket,
  

  faSwordLaserAlt,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faRouter,
  

  faWandSparkles,
  

  faSquareU,
  

  faPersonPregnant,
  

  faFlask,
  

  faSwordsLaser,
  

  faCentSign,
  

  faHamsa,
  

  faMapPin,
  

  faCroissant,
  

  faNetworkWired,
  

  faFolderTree,
  

  faPeople,
  

  faCauldron,
  

  faSliders,
  
  faSlidersH,
  

  faOutlet,
  

  faFilterList,
  

  faKhanda,
  

  faOlive,
  

  faHoneyPot,
  

  faCoins,
  

  faMountainCity,
  

  faFluxCapacitor,
  

  faBatteryHalf,
  
  faBattery3,
  

  faBoltAuto,
  

  faIndustryWindows,
  
  faIndustryAlt,
  

  faCarMirrors,
  

  faRacquet,
  

  faPiggyBank,
  

  faCarBump,
  

  faSushiRoll,
  
  faMakiRoll,
  
  faMakizushi,
  

  faFaceHeadBandage,
  

  faCircleLocationArrow,
  
  faLocationCircle,
  

  faFolderHeart,
  

  faPlaneUp,
  

  faMobileScreen,
  
  faMobileAndroidAlt,
  

  faBellSchool,
  

  faTemperatureThreeQuarters,
  
  faTemperature3,
  
  faThermometer3,
  
  faThermometerThreeQuarters,
  

  faBoxingGlove,
  
  faGloveBoxing,
  

  faHouseChimneyMedical,
  
  faClinicMedical,
  

  faCards,
  

  faLocationDotSlash,
  
  faMapMarkerAltSlash,
  

  faCaretDown,
  

  faBallot,
  

  faUsbDrive,
  

  faArrowsFromDottedLine,
  

  faKeyboard,
  

  faTimeline,
  

  faS,
  

  faOverline,
  

  faSquareUpLeft,
  

  faBaseballBatBall,
  

  faPenNibSlash,
  

  faListRadio,
  

  faLampStreet,
  

  faCloudSleet,
  

  faFaucet,
  

  faArrowsMaximize,
  
  faExpandArrows,
  

  faCarBolt,
  

  faPallet,
  

  faBackwardStep,
  
  faStepBackward,
  

  faTruckTow,
  

  faInputNumeric,
  

  faClock,
  
  faClockFour,
  

  faDash,
  
  faMinusLarge,
  

  faRaindrops,
  

  faArrowDownArrowUp,
  
  faSortAlt,
  

  faLightSwitchOn,
  

  faSquareRootVariable,
  
  faSquareRootAlt,
  

  faArrowUpFromDottedLine,
  

  faU,
  

  faArrowTurnUp,
  
  faLevelUp,
  

  faMobileSignalOut,
  

  faGripVertical,
  

  faSquareD,
  

  faAxe,
  

  faChessClock,
  

  faPeapod,
  

  faShareAll,
  

  faDisplayMedical,
  
  faDesktopMedical,
  

  faFolderMusic,
  

  faHexagonVerticalNftSlanted,
  

  faTabletScreen,
  
  faTabletAndroidAlt,
  

  faToiletPaperBlank,
  
  faToiletPaperAlt,
  

  faFolderXmark,
  
  faFolderTimes,
  

  faFilmCanister,
  
  faFilmCannister,
  

  faSplit,
  

  faWaveformLines,
  
  faWaveformPath,
  

  faWaterArrowUp,
  
  faWaterRise,
  

  faPlaceOfWorship,
  

  faPersonSkiJumping,
  
  faSkiJump,
  

  faPlugCirclePlus,
  

  faCircle7,
  

  faScannerTouchscreen,
  

  faWaterArrowDown,
  
  faWaterLower,
  

  faFaceSwear,
  

  faRadioTuner,
  
  faRadioAlt,
  

  faFaceSmilePlus,
  
  faSmilePlus,
  

  faMoped,
  

  faTemperatureSnow,
  
  faTemperatureFrigid,
  

  faTabletRugged,
  

  faDistributeSpacingHorizontal,
  

  faEyeDropperFull,
  

  faVials,
  

  faShieldPlus,
  

  faBookFont,
  

  faCartShopping,
  
  faShoppingCart,
  

  faCarGarage,
  

  faPersonMilitaryRifle,
  

  faFlagSwallowtail,
  
  faFlagAlt,
  

  faStarOfDavid,
  

  faMosquito,
  

  faDuck,
  

  faMosque,
  

  faBookHeart,
  

  faDropletSlash,
  
  faTintSlash,
  

  faGear,
  
  faCog,
  

  faCameraSecurity,
  
  faCameraHome,
  

  faUserDoctorHairLong,
  

  faFileCertificate,
  
  faFileAward,
  

  faMessageXmark,
  
  faCommentAltTimes,
  
  faMessageTimes,
  

  faHousePersonReturn,
  
  faHousePersonArrive,
  
  faHouseReturn,
  

  faCartCircleArrowDown,
  

  faFaceSmileHalo,
  

  faCircleBolt,
  

  faPresentationScreen,
  
  faPresentation,
  

  faHandsAslInterpreting,
  
  faAmericanSignLanguageInterpreting,
  
  faAslInterpreting,
  
  faHandsAmericanSignLanguageInterpreting,
  

  faChartUser,
  
  faUserChart,
  

  faBookCircleArrowRight,
  

  faVolumeOff,
  

  faFlaskRoundPoison,
  
  faFlaskPoison,
  

  faFrancSign,
  

  faArrowDownLeft,
  

  faStreetView,
  

  faFontCase,
  

  faPlugCircleCheck,
  

  faArrowLeftLong,
  
  faLongArrowLeft,
  

  faTrashSlash,
  

  faChess,
  

  faGif,
  

  faRightToLine,
  
  faArrowAltToRight,
  

  faFireFlame,
  
  faFlame,
  

  faMinus,
  
  faSubtract,
  

  faCircle5,
  

  faCircleSterling,
  

  faBracketRoundRight,
  

  faVirusSlash,
  

  faDna,
  

  faTurnLeftUp,
  

  faCloudBoltMoon,
  
  faThunderstormMoon,
  

  faCircleUpRight,
  

  faKeyboardDown,
  

  faLeftLong,
  
  faLongArrowAltLeft,
  

  faMoneyBill1,
  
  faMoneyBillAlt,
  

  faCropSimple,
  
  faCropAlt,
  

  faIndianRupeeSign,
  
  faIndianRupee,
  
  faInr,
  

  faListTimeline,
  

  faMoneyBillsSimple,
  
  faMoneyBillsAlt,
  

  faBadgeDollar,
  

  faBallPile,
  

  faFaceSmileUpsideDown,
  

  faChartGantt,
  

  faTrainSubway,
  
  faSubway,
  

  faGameConsoleHandheldCrank,
  

  faSportsball,
  

  faSignalBarsFair,
  
  faSignalAlt2,
  

  faDistributeSpacingVertical,
  

  faCircleLeft,
  
  faArrowAltCircleLeft,
  

  faCowbellCirclePlus,
  
  faCowbellMore,
  

  faPlaneArrival,
  

  faPersonFromPortal,
  
  faPortalExit,
  

  faCalendarPlus,
  

  faPersonSkiingNordic,
  
  faSkiingNordic,
  

  faArrowDownRight,
  

  faGrate,
  

  faTrafficCone,
  

  faHouseMedicalCircleCheck,
  

  faAlarmExclamation,
  

  faTarpDroplet,
  

  faRectangleList,
  
  faListAlt,
  

  faDumbbell,
  

  faFaceGrinSquintTears,
  
  faGrinSquintTears,
  

  faReel,
  

  faHardDrive,
  
  faHdd,
  

  faTvMusic,
  

  faArrowRotateLeft,
  
  faArrowLeftRotate,
  
  faArrowRotateBack,
  
  faArrowRotateBackward,
  
  faUndo,
  

  faCookie,
  

  faOctagonDivide,
  

  faCommentArrowUpRight,
  

  faOctagon,
  

  faBorderBottomRight,
  
  faBorderStyleAlt,
  

  faCarBuilding,
  

  faMessageMusic,
  
  faCommentAltMusic,
  

  faCameraViewfinder,
  
  faScreenshot,
  

  faMoneyBillWheat,
  

  faPlusLarge,
  

  faBellSchoolSlash,
  

  faBowlingBallPin,
  

  faArrowDownAZ,
  
  faSortAlphaAsc,
  
  faSortAlphaDown,
  

  faCheckDouble,
  

  faPeopleDressSimple,
  

  faVestPatches,
  

  faLaptopBinary,
  

  faTent,
  

  faAlien,
  

  faPersonCane,
  

  faCloudRainbow,
  

  faCrosshairs,
  

  faMusicMagnifyingGlass,
  

  faTruck,
  

  faLandmark,
  

  faHouseWindow,
  

  faHoseReel,
  

  faFamilyPants,
  

  faPlateUtensils,
  

  faPrescriptionBottleMedical,
  
  faPrescriptionBottleAlt,
  

  faBraille,
  

  faCalendarClock,
  
  faCalendarTime,
  

  faClockDesk,
  

  faCalendarCheck,
  

  faPlaneProp,
  

  faNfcSignal,
  

  faStarSharpHalfStroke,
  
  faStarSharpHalfAlt,
  

  faWater,
  

  faWaveform,
  

  faTricycleAdult,
  

  faFileEps,
  

  faHandHoldingDroplet,
  
  faHandHoldingWater,
  

  faSquare4,
  

  faBuoyMooring,
  

  faArrowDown19,
  
  faSortNumericAsc,
  
  faSortNumericDown,
  

  faSleigh,
  

  faCarOn,
  

  faMeteor,
  

  faCartArrowUp,
  

  faSquareVirus,
  

  faCamera,
  
  faCameraAlt,
  

  faCameraPolaroid,
  

  faCloudMeatball,
  

  faMessageHeart,
  

  faHammerCrash,
  

  faFishingRod,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faSlashBack,
  

  faUserDoctor,
  
  faUserMd,
  

  faMeterBolt,
  

  faHouseChimneyBlank,
  

  faHouseHeart,
  
  faHomeHeart,
  

  faFileXmark,
  
  faFileTimes,
  

  faMountain,
  

  faHourglass,
  
  faHourglassEmpty,
  

  faNfcTrash,
  

  faTruckFieldUn,
  

  faPuzzlePieceSimple,
  
  faPuzzlePieceAlt,
  

  faTreeDeciduous,
  
  faTreeAlt,
  

  faIndent,
  

  faCommentMusic,
  

  faRugbyBall,
  

  faMessageMedical,
  
  faCommentAltMedical,
  

  faReflectHorizontal,
  

  faParachuteBox,
  

  faCircleNodes,
  

  faCircleWifiCircleWifi,
  
  faCircleWifiGroup,
  

  faArrowTurnDownLeft,
  

  faBorderNone,
  

  faCircleSmall,
  

  faBottleBaby,
  

  faLitecoinSign,
  

  faH6,
  

  faCircleY,
  

  faAppleCore,
  

  faArrowUp91,
  
  faSortNumericUpAlt,
  

  faPersonPinball,
  

  faLungs,
  

  faRibbon,
  

  faLockA,
  

  faArrowRightToCity,
  

  faChartLineDown,
  

  faPaperclip,
  

  faBinRecycle,
  

  faAnglesUp,
  
  faAngleDoubleUp,
  

  faFaceTissue,
  

  faDollyEmpty,
  

  faEnvelope,
  

  faTruckLadder,
  

  faHeadSide,
  

  faCakeCandles,
  
  faBirthdayCake,
  
  faCake,
  

  faSquare1,
  

  faComment,
  

  faEllipsisStrokeVertical,
  
  faEllipsisVAlt,
  

  faBracketsCurly,
  

  faCircleYen,
  

  faCoffeeBean,
  

  faInboxes,
  

  faBookSection,
  
  faBookLaw,
  

  faStretcher,
  

  faTag,
  

  faSteeringWheel,
  

  faPlaneLock,
  

  faTruckFire,
  

  faSatellite,
  

  faChessClockFlip,
  
  faChessClockAlt,
  

  faFilePlusMinus,
  

  faUserVisor,
  

  faLiraSign,
  

  faChild,
  

  faWashingMachine,
  
  faWasher,
  

  faBookSparkles,
  
  faBookSpells,
  

  faSquareArrowDownRight,
  

  faFilmSlash,
  

  faBusSchool,
  

  faClipboardUser,
  

  faFaceFearful,
  

  faLocationExclamation,
  
  faMapMarkerExclamation,
  

  faTableRows,
  
  faRows,
  

  faHatCowboySide,
  

  faDiscDrive,
  

  faPhoneVolume,
  
  faVolumeControlPhone,
  

  faSealQuestion,
  

  faSolarSystem,
  

  faBookTanakh,
  
  faTanakh,
  

  faTableCellsLarge,
  
  faThLarge,
  

  faCloudDrizzle,
  

  faPeoplePantsSimple,
  

  faFlowerTulip,
  

  faBusinessTime,
  
  faBriefcaseClock,
  

  faCommentDollar,
  

  faPersonDress,
  
  faFemale,
  

  faDreidel,
  

  faOtter,
  

  faUserSecret,
  

  faRv,
  

  faClockElevenThirty,
  

  faExpandWide,
  

  faBriefcaseArrowRight,
  

  faSuitcaseMedical,
  
  faMedkit,
  

  faO,
  

  faBookBible,
  
  faBible,
  

  faMessagesQuestion,
  

  faGamepadModern,
  
  faGamepadAlt,
  

  faCurlingStone,
  
  faCurling,
  

  faTankWater,
  

  faImageLandscape,
  
  faLandscape,
  

  faArrowUpToDottedLine,
  

  faSiren,
  

  faFilePdf,
  

  faBagShoppingMinus,
  

  faTableCells,
  
  faTh,
  

  faCircleSort,
  
  faSortCircle,
  

  faUpRightFromSquare,
  
  faExternalLinkAlt,
  

  faCherries,
  

  faFileVideo,
  

  faUsersViewfinder,
  

  faGalaxy,
  

  faJ,
  

  faHighDefinition,
  
  faRectangleHd,
  

  faRestroom,
  

  faDiceD6,
  

  faAlignLeft,
  

  faTemperatureSun,
  
  faTemperatureHot,
  

  faCupStrawSwoosh,
  

  faArrowLeftFromBracket,
  

  faRuler,
  

  faPersonCircleXmark,
  

  faArrowLeft,
  

  faLeafMaple,
  

  faRepublican,
  

  faHandsClapping,
  

  faSnowflakes,
  

  faCircleAmpersand,
  

  faCampfire,
  

  faHandsHolding,
  

  faHeadphones,
  

  faTengeSign,
  
  faTenge,
  

  faSquare7,
  

  faLampFloor,
  

  faSunCloud,
  

  faDivide,
  

  faEnvelopeOpenDollar,
  

  faCubes,
  

  faSquareR,
  

  faBillboard,
  

  fa0,
  

  faShirt,
  
  faTShirt,
  
  faTshirt,
  

  faClockSix,
  

  faHose,
  

  faPhoneXmark,
  

  faGuitars,
  

  faScrollOld,
  

  faQuoteRight,
  
  faQuoteRightAlt,
  

  faPenClipSlash,
  
  faPenAltSlash,
  

  faPoo,
  

  faFaceMelting,
  

  faBookMedical,
  

  faArrowDownSmallBig,
  
  faSortSizeDownAlt,
  

  faGaugeSimple,
  
  faGaugeSimpleMed,
  
  faTachometerAverage,
  

  faTrash,
  

  faHandFingersCrossed,
  

  faCloudWord,
  

  faPhoneArrowDownLeft,
  
  faPhoneArrowDown,
  
  faPhoneIncoming,
  

  faOrnament,
  

  faFileXml,
  

  faCarSideBolt,
  

  faBrightness,
  

  faBoxCircleCheck,
  

  faShowerDown,
  
  faShowerAlt,
  

  faPersonDigging,
  
  faDigging,
  

  faMouseField,
  

  faCoffeePot,
  

  faPenFancy,
  

  faChartKanban,
  

  faHatWizard,
  

  faSquareKanban,
  

  faGarageCar,
  

  faTextWidth,
  

  faPersonBooth,
  

  faBanBug,
  
  faDebug,
  

  faBridgeWater,
  

  faVentDamper,
  

  faMosquitoNet,
  

  faRocketLaunch,
  

  faStarfighterTwinIonEngine,
  
  faStarfighterAlt,
  

  faDiceSix,
  

  faStarfighterTwinIonEngineAdvanced,
  
  faStarfighterAltAdvanced,
  

  faShieldVirus,
  

  faConveyorBeltBoxes,
  
  faConveyorBeltAlt,
  

  faLaptopMobile,
  
  faPhoneLaptop,
  

  faDoorClosed,
  

  faDialLow,
  

  faOctagonExclamation,
  

  faArrowUp19,
  
  faSortNumericUp,
  

  faPipeCircleCheck,
  

  faUserGear,
  
  faUserCog,
  

  faPuzzle,
  

  faSquareHeart,
  
  faHeartSquare,
  

  faSquare5,
  

  faHouseBlank,
  
  faHomeBlank,
  

  faLightbulbSlash,
  

  faBooksMedical,
  

  faKeyboardBrightness,
  

  faHeadSideVirus,
  

  faRectangleCode,
  

  faTrafficLightSlow,
  

  faKiwiFruit,
  

  faPawClaws,
  

  faBorderInner,
  

  faToothbrush,
  

  faCalendarCirclePlus,
  

  faRampLoading,
  

  faNarwhal,
  

  faTableLayout,
  

  faChildReaching,
  

  faCalendarXmark,
  
  faCalendarTimes,
  

  faComputerMouseScrollwheel,
  
  faMouseAlt,
  

  faPhone,
  

  faFaceGrinTears,
  
  faGrinTears,
  

  faSpinnerThird,
  

  faLungsVirus,
  

  faUsersBetweenLines,
  

  faChildDress,
  

  faCardClub,
  

  faRulerTriangle,
  

  faHousePersonLeave,
  
  faHouseLeave,
  
  faHousePersonDepart,
  

  faLeftFromBracket,
  

  faMarsDouble,
  

  faLocationCrosshairs,
  
  faLocation,
  

  faChessQueenPiece,
  
  faChessQueenAlt,
  

  faBiohazard,
  

  faWebAwesome,
  

  faBalloon,
  

  faSensorOn,
  

  faMessagesDollar,
  
  faCommentsAltDollar,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faUserMusic,
  

  faFacePensive,
  

  faHandsPraying,
  
  faPrayingHands,
  

  faHandScissors,
  

  faDrumSteelpan,
  

  faHandPointer,
  

  faBacterium,
  

  faGridDividers,
  

  faHandHoldingDollar,
  
  faHandHoldingUsd,
  

  faCircleEllipsisVertical,
  

  faFaceGrinSquint,
  
  faGrinSquint,
  

  faSquareLeft,
  
  faArrowAltSquareLeft,
  

  faDiamond,
  

  faUserNurseHairLong,
  

  faAlbumCirclePlus,
  

  faScarf,
  

  faPlantWilt,
  

  faCommentDots,
  
  faCommenting,
  

  faCalendarArrowUp,
  
  faCalendarUpload,
  

  faSortUp,
  
  faSortAsc,
  

  faSquareL,
  

  faTennisBall,
  

  faFaceTongueMoney,
  

  faUserPoliceTie,
  

  faFileUser,
  

  faScaleUnbalanced,
  
  faBalanceScaleLeft,
  

  faFaceKissClosedEyes,
  

  faVihara,
  

  faFloppyDisk,
  
  faSave,
  

  faShop,
  
  faStoreAlt,
  

  faPrescription,
  

  faWalker,
  

  faScreencast,
  

  faDiploma,
  
  faScrollRibbon,
  

  faShirtTankTop,
  

  faChessBishopPiece,
  
  faChessBishopAlt,
  

  faFaceFrown,
  
  faFrown,
  

  faDryer,
  

  faWindowMaximize,
  

  faHouseChimney,
  
  faHomeLg,
  

  faArrowUpLeftFromCircle,
  

  faHeartCircleXmark,
  

  faBus,
  

  faPump,
  

  faSignal,
  
  faSignal5,
  
  faSignalPerfect,
  

  faFileCode,
  

  faToiletPaperBlankUnder,
  
  faToiletPaperReverseAlt,
  

  faFloppyDisks,
  

  faTowerObservation,
  

  faPen,
  

  faUserSlash,
  

  faManhole,
  

  faHexagon,
  

  faFileShield,
  

  faPersonMilitaryToPerson,
  

  faAudioDescription,
  

  faArrowsMinimize,
  
  faCompressArrows,
  

  faBootHeeled,
  

  faTicketAirline,
  
  faTicketPerforatedPlane,
  
  faTicketPlane,
  

  faHeat,
  

  faFaceSadCry,
  
  faSadCry,
  

  faEye,
  

  faBusSimple,
  
  faBusAlt,
  

  faChestnut,
  

  faTape,
  

  faBasketShopping,
  
  faShoppingBasket,
  

  faHouseMedicalFlag,
  

  faMobileButton,
  

  faTerminal,
  

  faCircleSortUp,
  
  faSortCircleUp,
  

  faBanSmoking,
  
  faSmokingBan,
  

  faCartFlatbed,
  
  faDollyFlatbed,
  

  faCircleR,
  

  faArrowUpRight,
  

  faDolphin,
  

  faArrowsToLine,
  

  faFaucetDrip,
  

  faBarsProgress,
  
  faTasksAlt,
  

  faNfcSymbol,
  

  faSquareChevronUp,
  
  faChevronSquareUp,
  

  faHouseSignal,
  

  faFaceRaisedEyebrow,
  

  faFaceZipper,
  

  faCardDiamond,
  

  faSquareParking,
  
  faParking,
  

  faUserRobot,
  

  faFaceMehBlank,
  
  faMehBlank,
  

  faForwardFast,
  
  faFastForward,
  

  faWineGlass,
  

  faTags,
  

  faArrowTurnRight,
  

  faHeadSideMedical,
  

  faFileCircleMinus,
  

  faUserTieHairLong,
  

  faTeethOpen,
  

  faCommentMedical,
  

  faPanorama,
  

  faClipboardQuestion,
  

  faCartCircleCheck,
  

  faRoute,
  

  faTruckField,
  

  faBasketShoppingPlus,
  

  faUserCrown,
  

  faFaceClouds,
  

  faAnchorCircleExclamation,
  

  faFiles,
  

  faCircleCaretLeft,
  
  faCaretCircleLeft,
  

  faTrashXmark,
  

  faCat,
  

  faTruckFront,
  

  faSquareQuarters,
  

  faFileDoc,
  

  faArrowDownFromDottedLine,
  

  faPhoneFlip,
  
  faPhoneAlt,
  

  faBridge,
  

  faHatCowboy,
  

  faWarehouseFull,
  
  faWarehouseAlt,
  

  faCodeBranch,
  

  faObjectSubtract,
  

  faHouseWater,
  
  faHouseFlood,
  

  faPopcorn,
  

  faFaceHandOverMouth,
  

  faCircleK,
  

  faArrowRightFromArc,
  

  faTypewriter,
  

  faCanFood,
  

  faBorderCenterH,
  

  faBookBookmark,
  

  faHandshakeSlash,
  

  faPlaneDeparture,
  

  faBuoy,
  

  faImageUser,
  

  faTicketsPerforated,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faFileImage,
  

  faRupeeSign,
  
  faRupee,
  

  faDiagramNested,
  

  faVectorPolygon,
  

  faBugs,
  

  faWrench,
  

  faArrowTurnLeft,
  

  faTransporter6,
  

  faUtilityPole,
  

  faBurger,
  
  faHamburger,
  

  faStaff,
  

  faChartRadar,
  

  faLockHashtag,
  

  faTurnDownLeft,
  

  faFileAudio,
  

  faPool8Ball,
  

  faTruckClock,
  
  faShippingTimed,
  

  faCartCirclePlus,
  

  faClipboardCheck,
  

  faFlatbreadStuffed,
  

  faOctagonCheck,
  

  faWallet,
  

  faUsersRays,
  

  faVolumeHigh,
  
  faVolumeUp,
  

  faCloudSlash,
  

  faInboxOut,
  
  faInboxArrowUp,
  

  faClockOneThirty,
  

  faMobileScreenButton,
  
  faMobileAlt,
  

  faSlider,
  

  faCircleUp,
  
  faArrowAltCircleUp,
  

  faBadgeCheck,
  

  faSatelliteDish,
  

  faForkKnife,
  
  faUtensilsAlt,
  

  faBasketball,
  
  faBasketballBall,
  

  faTrademark,
  

  faCircleDashed,
  

  faPlaneSlash,
  

  faInterrobang,
  

  faUserAstronaut,
  

  faRecycle,
  

  faBackwardFast,
  
  faFastBackward,
  

  faSword,
  

  faCartCircleExclamation,
  

  faLeftToBracket,
  

  faCircle,
  

  faSquarePollHorizontal,
  
  faPollH,
  

  faHouseFloodWaterCircleArrowRight,
  

  faMoneyBillTrendUp,
  

  faMoneyBillTransfer,
  

  faElevator,
  

  faTally3,
  

  faHouseChimneyHeart,
  

  faTableTree,
  

  faLockOpen,
  

  faSolarPanel,
  

  faShieldDog,
  

  faShutters,
  

  faBitcoinSign,
  

  faArrowDownTriangleSquare,
  
  faSortShapesDown,
  

  faCube,
  

  faHandsHoldingDollar,
  
  faHandsUsd,
  

  faToiletPaperXmark,
  

  faWifiSlash,
  

  faSquareInfo,
  
  faInfoSquare,
  

  faTemperatureQuarter,
  
  faTemperature1,
  
  faThermometer1,
  
  faThermometerQuarter,
  

  faR,
  

  faLockKeyhole,
  
  faLockAlt,
  

  faDiamondHalf,
  

  faKitchenSet,
  

  faAppleWhole,
  
  faAppleAlt,
  

  faCircleEuro,
  

  faToiletPaperSlash,
  

  faRabbit,
  

  faValueAbsolute,
  

  faAngel,
  

  faFolders,
  

  faGaugeCirclePlus,
  

  faCirclePause,
  
  faPauseCircle,
  

  faBottleWater,
  

  faFaceSurprise,
  
  faSurprise,
  

  faArrowRightToArc,
  

  faUserShakespeare,
  

  faMartiniGlassCitrus,
  
  faCocktail,
  

  faBracketsRound,
  
  faParentheses,
  

  faArrowLeftLongToLine,
  

  faPawSimple,
  
  faPawAlt,
  

  faHouseCrack,
  

  faLeftToLine,
  
  faArrowAltToLeft,
  

  faHexagonMinus,
  
  faMinusHexagon,
  

  faDumpsterFire,
  

  faCircleArrowDownLeft,
  

  faHouseUser,
  
  faHomeUser,
  

  faMarsAndVenus,
  

  faFileChartPie,
  

  faHeart,
  

  faFaceNauseated,
  

  faBookCircleArrowUp,
  

  faShirtRunning,
  

  faSignPostsWrench,
  

  faGridRound4,
  

  faFaceThermometer,
  

  faPlugCircleBolt,
  

  faTrophyStar,
  
  faTrophyAlt,
  

  faCircleThreeQuarters,
  

  faArrowsToEye,
  

  faScrewdriverWrench,
  
  faTools,
  

  faHandHorns,
  

  faFaceSleepy,
  

  faTarp,
  

  faHammerBrush,
  

  faClockNine,
  

  faHandsHoldingHeart,
  
  faHandsHeart,
  

  faBasketShoppingSimple,
  
  faShoppingBasketAlt,
  

  faH,
  

  faLeftFromLine,
  
  faArrowAltFromRight,
  

  faCupStraw,
  

  faMessageSmile,
  
  faCommentAltSmile,
  

  faSpaceStationMoon,
  

  faMelonSlice,
  

  faPersonCircleQuestion,
  

  faCashRegister,
  

  faOctagonPlus,
  
  faPlusOctagon,
  

  faSignsPost,
  
  faMapSigns,
  

  faArrowRight,
  

  faSignatureLock,
  

  faTickets,
  

  faMaskVentilator,
  

  faSendBack,
  

  faCalendarArrowDown,
  
  faCalendarDownload,
  

  faChartLine,
  
  faLineChart,
  

  faFrenchFries,
  

  faObjectGroup,
  

  faRingsWedding,
  

  faBreadLoaf,
  

  faFaceRollingEyes,
  
  faMehRollingEyes,
  

  faHexagonVerticalNft,
  

  faUserCowboy,
  

  faSeal,
  

  faPlaneCircleCheck,
  

  faCircleRight,
  
  faArrowAltCircleRight,
  

  faEject,
  

  faStarship,
  

  faSimCards,
  

  faCommentCode,
  

  faHelmetSafety,
  
  faHardHat,
  
  faHatHard,
  

  faToiletPaper,
  

  faKaaba,
  

  faSquareList,
  

  faLocationPin,
  
  faMapMarker,
  

  faTelescope,
  

  faObjectExclude,
  

  faPoop,
  

  faHandPointRibbon,
  

  faAlien8bit,
  
  faAlienMonster,
  

  faCircleArrowDownRight,
  

  faFaceDisguise,
  

  faObjectUngroup,
  

  faFaceGrinBeam,
  
  faGrinBeam,
  

  faBuildingFlag,
  

  faCircleQ,
  

  faFishFins,
  

  faFileContract,
  

  faFileExcel,
  

  faFileXls,
  

  faSackXmark,
  

  faClockEight,
  

  faBoltLightning,
  

  faChartPie,
  
  faPieChart,
  

  faPersonCirclePlus,
  

  faTaxi,
  
  faCab,
  

  faRoad,
  

  faBedBunk,
  

  faLeaf,
  

  faF,
  

  faCloudPlus,
  

  faAustralSign,
  

  faChessKnightPiece,
  
  faChessKnightAlt,
  

  faPie,
  

  faSquareEllipsis,
  

  faVirusCovid,
  

  faImagePolaroidUser,
  

  faWonSign,
  
  faKrw,
  
  faWon,
  

  faImagesUser,
  

  faCubesStacked,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faMagnifyingGlassChart,
  

  faMobileNotch,
  
  faMobileIphone,
  

  faClothesHanger,
  

  faBuildingCircleExclamation,
  

  faMoonStars,
  

  faWhiskeyGlass,
  
  faGlassWhiskey,
  

  faCode,
  

  faFileExclamation,
  

  faStarHalfStroke,
  
  faStarHalfAlt,
  

  faMoneyCheck,
  

  faPuzzlePiece,
  

  faTrainTrack,
  

  faArrowUpSmallBig,
  
  faSortSizeUpAlt,
  

  faHandHoldingHeart,
  

  faHouseChimneyUser,
  

  faDryerHeat,
  
  faDryerAlt,
  

  faUpDownLeftRight,
  
  faArrowsAlt,
  

  faToggleLargeOn,
  

  faFileSignature,
  

  faQuestion,
  

  faUserNurseHair,
  

  faClipboardPrescription,
  

  faCirclePhone,
  
  faPhoneCircle,
  

  faSquareG,
  

  faFilter,
  

  faDownToLine,
  
  faArrowAltToBottom,
  

  faRouteHighway,
  

  faMemoCircleCheck,
  

  faDiamonds4,
  

  faPodium,
  

  faDagger,
  

  faFaceKissWinkHeart,
  
  faKissWinkHeart,
  

  faWheatAwnSlash,
  

  faLanguage,
  

  faBreadSlice,
  

  faVectorSquare,
  

  faMoneyCheckDollar,
  
  faMoneyCheckAlt,
  

  faDiceD4,
  

  faPersonDressBurst,
  

  faChartNetwork,
  

  faWifiExclamation,
  

  faKidneys,
  

  faFaceParty,
  

  faSparkle,
  

  faChartWaterfall,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faSort,
  
  faUnsorted,
  

  faLocust,
  

  faFilterCircleXmark,
  

  faToiletPaperCheck,
  

  faCircleI,
  

  faUserGroupCrown,
  
  faUsersCrown,
  

  faCircleArrowRight,
  
  faArrowCircleRight,
  

  faBreadSliceButter,
  

  faMoonCloud,
  

  faArrowTurnDownRight,
  

  faGuitarElectric,
  

  faRectangleAd,
  
  faAd,
  

  faNewspaper,
  

  faStomach,
  

  faSnowflake,
  

  faBroomWide,
  

  faP,
  

  faTrashCanClock,
  

  faSausage,
  

  faFeatherPointed,
  
  faFeatherAlt,
  

  faMace,
  

  faTemperatureArrowDown,
  
  faTemperatureDown,
  

  faBookmarkSlash,
  

  faA,
  

  faRoadLock,
  

  faInputPipe,
  

  faDeer,
  

  faPersonSkiing,
  
  faSkiing,
  

  faZ,
  

  faPinball,
  

  faFaceConfused,
  

  faDemocrat,
  

  faLinkSimpleSlash,
  

  faPickaxe,
  

  faTicketsSimple,
  

  faCommentsDollar,
  

  faFaceHushed,
  

  faPersonSnowmobiling,
  
  faSnowmobile,
  

  faChurch,
  

  faTableCellsColumnLock,
  

  faCalendarLinesPen,
  

  faGlassCitrus,
  

  faItalic,
  

  faCediSign,
  

  faCouch,
  

  faMartiniGlassEmpty,
  
  faGlassMartini,
  

  faMemo,
  

  faSquare,
  

  faCommentCheck,
  

  faHeartHalf,
  

  faTicketPerforated,
  

  faFileZipper,
  
  faFileArchive,
  

  faHouseChimneyCrack,
  
  faHouseDamage,
  

  faHeartCircleCheck,
  

  faArchway,
  

  faClockTwoThirty,
  

  faHashtagLock,
  

  faBorderOuter,
  

  faArrowsToDot,
  

  faRestroomSimple,
  

  faLayerGroup,
  

  faEnvelopeCircleCheck,
  

  faWave,
  

  faCommentMiddleTop,
  

  faGridRound2,
  

  faVirus,
  

  faBookAtlas,
  
  faAtlas,
  

  faTruckPlow,
  

  faShieldHalved,
  
  faShieldAlt,
  

  faFaceConfounded,
  

  faPalletBox,
  

  faGreaterThanEqual,
  

  faSquareArrowUp,
  
  faArrowSquareUp,
  

  faBurgerSoda,
  

  faCabinetFiling,
  

  faListDropdown,
  

  faWatchCalculator,
  

  faWatchApple,
  

  faCruzeiroSign,
  

  faShelvesEmpty,
  

  faGarageOpen,
  

  faMagnifyingGlassArrowsRotate,
  

  faFireExtinguisher,
  

  faArrowsToDottedLine,
  

  faCircleBookOpen,
  
  faBookCircle,
  

  faArrowsRotate,
  
  faRefresh,
  
  faSync,
  

  faBorderTop,
  

  faMugTea,
  

  faBurgerFries,
  

  faGuaraniSign,
  

  faGingerbreadMan,
  

  faCommentQuestion,
  

  faAlicorn,
  

  faAlarmPlus,
  

  faMattressPillow,
  

  faMemoPad,
  

  faRabbitRunning,
  
  faRabbitFast,
  

  faHandshakeSimpleSlash,
  
  faHandshakeAltSlash,
  

  faCatSpace,
  

  faDrawCircle,
  

  faEnvelopeOpen,
  

  faListTree,
  

  faLollipop,
  
  faLollypop,
  

  faSignalStrong,
  
  faSignal4,
  

  faUserLargeSlash,
  
  faUserAltSlash,
  

  faChalkboard,
  
  faBlackboard,
  

  faMeterDroplet,
  

  faChildren,
  

  faWreath,
  

  faCloudArrowDown,
  
  faCloudDownload,
  
  faCloudDownloadAlt,
  

  faHouseLock,
  

  faArrowsLeftRight,
  
  faArrowsH,
  

  faObjectsAlignCenterVertical,
  

  faSquareDown,
  
  faArrowAltSquareDown,
  

  faFilePowerpoint,
  

  faFileWord,
  

  faLeft,
  
  faArrowAltLeft,
  

  faWavesSine,
  

  faCircle6,
  

  faChessKingPiece,
  
  faChessKingAlt,
  

  faTombstoneBlank,
  
  faTombstoneAlt,
  

  faFaceSmileWink,
  
  faSmileWink,
  

  faProjector,
  

  faText,
  

  faCircleDownLeft,
  

  faWatch,
  

  faTextSlash,
  
  faRemoveFormat,
  

  faChartLineUpDown,
  

  faCloudBolt,
  
  faThunderstorm,
  

  faMessageCheck,
  
  faCommentAltCheck,
  

  faHandHoldingSeedling,
  

  faPhoneArrowRight,
  

  faSquareDollar,
  
  faDollarSquare,
  
  faUsdSquare,
  

  faArrowDownWideShort,
  
  faSortAmountAsc,
  
  faSortAmountDown,
  

  faCandyCane,
  

  faSquare9,
  

  faBowlFood,
  

  faGroupArrowsRotate,
  

  faFileJpg,
  

  faFlashlight,
  

  faCircleArrowLeft,
  
  faArrowCircleLeft,
  

  faBoxesPacking,
  

  faLeftRight,
  
  faArrowsAltH,
  

  faClockSeven,
  

  faSeedling,
  
  faSprout,
  

  faArrowsDownToPeople,
  

  faBullseyeArrow,
  

  faFerry,
  

  faTrianglePersonDigging,
  
  faConstruction,
  

  faCircleEnvelope,
  
  faEnvelopeCircle,
  

  faInboxFull,
  

  faPig,
  

  faVest,
  

  faArrowsTurnRight,
  

  faObjectsAlignRight,
  

  faChartMixedUpCircleCurrency,
  

  faTransporter4,
  

  faPalette,
  

  faCloudArrowUp,
  
  faCloudUpload,
  
  faCloudUploadAlt,
  

  faFontAwesome,
  
  faFontAwesomeFlag,
  
  faFontAwesomeLogoFull,
  

  faGasPumpSlash,
  

  faCrutch,
  

  faSquareALock,
  

  faUserVneckHairLong,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faHydra,
  

  faUfoBeam,
  

  faSmog,
  

  faBlindsRaised,
  

  faMoneyBills,
  

  faFaceTired,
  
  faTired,
  

  faHouseLaptop,
  
  faLaptopHouse,
  

  faBurst,
  

  faIntegral,
  

  faDiamondTurnRight,
  
  faDirections,
  

  faSubscript,
  

  faGlobeSnow,
  

  faScaleUnbalancedFlip,
  
  faBalanceScaleRight,
  

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faTrashCanPlus,
  

  faRegistered,
  

  faGaugeLow,
  
  faTachometerAltSlow,
  

  faBomb,
  

  faTemperatureEmpty,
  
  faTemperature0,
  
  faThermometer0,
  
  faThermometerEmpty,
  

  faHillAvalanche,
  

  faPlaneEngines,
  
  faPlaneAlt,
  

  faClockEightThirty,
  

  faPause,
  

  faLocationPinLock,
  

  faStrawberry,
  

  faArrowLeftFromLine,
  
  faArrowFromRight,
  

  faSpa,
  

  faScroll,
  

  faSquareF,
  

  faBoxOpen,
  

  faKerning,
  

  faLightEmergencyOn,
  

  faSquareArrowUpRight,
  
  faExternalLinkSquare,
  

  faBanjo,
  

  faFileImport,
  
  faArrowRightToFile,
  

  faCommentPen,
  
  faCommentEdit,
  

  faCircleArrowDown,
  
  faArrowCircleDown,
  

  faCameraRetro,
  

  faFilterCircleDollar,
  
  faFunnelDollar,
  

  faBinaryLock,
  

  faStarShooting,
  

  faPersonSkating,
  
  faSkating,
  

  faSuitcase,
  

  faReplyAll,
  
  faMailReplyAll,
  

  faCrystalBall,
  

  faCertificate,
  

  faTentArrowDownToLine,
  

  faArrowDownLong,
  
  faLongArrowDown,
  

  faUpToBracket,
  

  faUserTie,
  

  faSquarePersonConfined,
  

  faViruses,
  

  faBatteryExclamation,
  

  faSterlingSign,
  
  faGbp,
  
  faPoundSign,
  

  faSmoke,
  

  faMaskSnorkel,
  

  faImageSlash,
  

  faPersonWalkingDashedLineArrowRight,
  

  faStocking,
  

  faTeddyBear,
  

  faVolcano,
  

  faLariSign,
  

  faUserPolice,
  

  faCircleChevronUp,
  
  faChevronCircleUp,
  

  faUpRight,
  

  faFileMagnifyingGlass,
  
  faFileSearch,
  

  faGearComplex,
  

  faUniversalAccess,
  

  faAperture,
  

  faHelicopterSymbol,
  

  faTreeLarge,
  

  faBatteryBolt,
  

  faSquareArrowDownLeft,
  

  faFaceLaughBeam,
  
  faLaughBeam,
  

  faBinBottles,
  

  faMarker,
  

  faKazoo,
  

  faIdBadge,
  

  faNeuter,
  

  faPersonShelter,
  

  faIcicles,
  

  faCarWrench,
  
  faCarMechanic,
  

  faChopsticks,
  

  faCalendarCircleMinus,
  

  faPlateWheat,
  

  faCompassDrafting,
  
  faDraftingCompass,
  

  faArrowUpToBracket,
  

  faPhoneRotary,
  

  faHeadSideHeadphones,
  

  faCircleStop,
  
  faStopCircle,
  

  faBat,
  

  faMoneySimpleFromBracket,
  

  faHandHoldingCircleDollar,
  

  faSquareDashedCirclePlus,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faChair,
  

  faEuroSign,
  
  faEur,
  
  faEuro,
  

  faEthernet,
  

  fa360Degrees,
  

  faTablets,
  

  faLocationArrowUp,
  

  faArrowUpRightAndArrowDownLeftFromCenter,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faCannabis,
  

  faTruckRampCouch,
  
  faTruckCouch,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faSnowplow,
  

  faAlignSlash,
  

  faOctagonXmark,
  
  faTimesOctagon,
  
  faXmarkOctagon,
  

  faMonument,
  

  faRefrigerator,
  

  faMinimize,
  
  faCompressArrowsAlt,
  

  faSmoking,
  

  faDolly,
  
  faDollyBox,
  

  faGem,
  

  faHandshake,
  

  faHeadSideMask,
  

  faLemon,
  

  faTick,
  

  faSquareA,
  

  faTableColumns,
  
  faColumns,
  

  faRotateLeft,
  
  faRotateBack,
  
  faRotateBackward,
  
  faUndoAlt,
  

  faMartiniGlass,
  
  faGlassMartiniAlt,
  

  faBracketSquareRight,
  

  faArrowUpFromGroundWater,
  

  faForklift,
  

  faSquareNfi,
  

  faHouseTsunami,
  

  faFolderClosed,
  

  faCircleSortDown,
  
  faSortCircleDown,
  

  faScrewdriver,
  

  faShieldXmark,
  
  faShieldTimes,
  

  faCaretUp,
  

  faDownFromLine,
  
  faArrowAltFromTop,
  

  faSquareRing,
  

  fa3,
  

  faFileZip,
  

  faCow,
  

  faMicrophone,
  

  faWindowFrame,
  

  faImage,
  

  faFloppyDiskPen,
  

  faBucket,
  

  faFrog,
  

  faMessageLines,
  
  faCommentAltLines,
  

  faCloudExclamation,
  

  faToriiGate,
  

  faPanelEws,
  

  faSubtitles,
  

  faSunrise,
  

  faHockeyMask,
  

  faLacrosseStick,
  

  faCustard,
  

  faMistletoe,
  

  faBowlScoops,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faCircleV,
  

  faFileBinary,
  

  faNfcMagnifyingGlass,
  

  faWindowRestore,
  

  faSailboat,
  

  faCassetteBetamax,
  
  faBetamax,
  

  faCrow,
  

  fa00,
  

  faHexagonDivide,
  

  faUserUnlock,
  

  faSensorFire,
  

  faFaceExhaling,
  

  faTrafficLightGo,
  

  faEyeLowVision,
  
  faLowVision,
  

  faUpFromDottedLine,
  

  faTrain,
  

  faLessThanEqual,
  

  faHandsBubbles,
  
  faHandsWash,
  

  faChartBar,
  
  faBarChart,
  

  faCloudShowersWater,
  

  faSquareCaretUp,
  
  faCaretSquareUp,
  

  faTally,
  
  faTally5,
  

  faGridRound5,
  

  faHandBackFist,
  
  faHandRock,
  

  faMarsStrokeRight,
  
  faMarsStrokeH,
  

  faPersonChalkboard,
  

  faRightLongToLine,
  

  faSwapArrows,
  

  faGrid5,
  

  faArrowDownToLine,
  
  faArrowToBottom,
  

  faRepeat1,
  

  faBuildingCircleCheck,
  

  faBurgerCheese,
  
  faCheeseburger,
  

  faChessBoard,
  

  faBringFront,
  

  faUpLeft,
  

  faSquareQuote,
  

  faHoodCloak,
  

  faGlasses,
  

  faPaintbrushFine,
  
  faPaintBrushAlt,
  
  faPaintBrushFine,
  
  faPaintbrushAlt,
  

  faChessQueen,
  

  faTreasureChest,
  

  faMessageArrowUpRight,
  

  faFileSlash,
  

  faCoinFront,
  

  faGaugeCircleBolt,
  

  faTransporter5,
  

  faVolume,
  
  faVolumeMedium,
  

  faDiceTwo,
  

  faGift,
  

  faMemoCircleInfo,
  

  faMailboxFlagUp,
  

  faFaceDowncastSweat,
  

  faCarBattery,
  
  faBatteryCar,
  

  faDogLeashed,
  

  faMugHot,
  

  faArrowDownSquareTriangle,
  
  faSortShapesDownAlt,
  

  faSquarePollVertical,
  
  faPoll,
  

  faJedi,
  

  faTilde,
  

  faMapLocationDot,
  
  faMapMarkedAlt,
  

  faBorderTopLeft,
  
  faBorderStyle,
  

  faNotEqual,
  

  faMoneyCheckPen,
  
  faMoneyCheckEdit,
  

  faManatSign,
  

  faSquareK,
  

  faCircleDownRight,
  

  faEngineWarning,
  
  faEngineExclamation,
  

  faTransporter3,
  

  faBuildingNgo,
  

  faAnchorLock,
  

  faBold,
  

  faStroopwafel,
  

  faSignature,
  

  faCaduceus,
  

  faSquareO,
  

  faBinarySlash,
  

  faUserPen,
  
  faUserEdit,
  

  faPrescriptionBottlePill,
  

  faUnderline,
  

  faRectangleHistoryCirclePlus,
  

  faUmbrellaSimple,
  
  faUmbrellaAlt,
  

  faBath,
  
  faBathtub,
  

  faMessages,
  
  faCommentsAlt,
  

  faWifi,
  
  faWifi3,
  
  faWifiStrong,
  

  faFileArrowUp,
  
  faFileUpload,
  

  faHouseCircleExclamation,
  

  faClipboard,
  

  faHexagonPlus,
  
  faPlusHexagon,
  

  faTaco,
  

  faChampagneGlasses,
  
  faGlassCheers,
  

  faMarsStrokeUp,
  
  faMarsStrokeV,
  

  faUserMinus,
  

  faSignalSlash,
  

  faRoadCircleXmark,
  

  faStoreSlash,
  

  faH4,
  

  faBadgerHoney,
  

  faHeadset,
  

  faColonSign,
  

  faUnlock,
  

  faSheep,
  

  faCitrusSlice,
  

  faPepperHot,
  

  faClockTwelve,
  

  faMicrophoneLines,
  
  faMicrophoneAlt,
  

  faSignalBarsWeak,
  
  faSignalAlt1,
  

  faCity,
  

  faCodeFork,
  

  faHeartCirclePlus,
  

  faFlatbread,
  

  faBowlHot,
  
  faSoup,
  

  faCandy,
  

  faAlbumCollectionCircleUser,
  

  faFolderOpen,
  

  faFaceLaugh,
  
  faLaugh,
  

  faChartPieSimple,
  
  faChartPieAlt,
  

  faShirtLongSleeve,
  

  faShuttleSpace,
  
  faSpaceShuttle,
  

  faHouseDay,
  

  faBedPulse,
  
  faProcedures,
  

  faFire,
  

  faStars,
  

  faCircleZ,
  

  faDownToBracket,
  

  faSignalStream,
  

  faL,
  

  faPersonWalking,
  
  faWalking,
  

  faRectangleVertical,
  
  faRectanglePortrait,
  

  faToggleOn,
  

  faCircleArrowUp,
  
  faArrowCircleUp,
  

  faBedEmpty,
  

  faPianoKeyboard,
  

  faUserPilotTie,
  

  faWheelchair,
  

  faTriangleInstrument,
  
  faTriangleMusic,
  

  faCommentPlus,
  

  faSquareChevronDown,
  
  faChevronSquareDown,
  

  faObjectsColumn,
  

  faViolin,
  

  faBurrito,
  

  faCommentMinus,
  

  faBinaryCircleCheck,
  

  faPanelFire,
  

  faBoltSlash,
  

  faCodeSimple,
  

  faFaceLaughSquint,
  
  faLaughSquint,
  

  faPalletBoxes,
  
  faPaletteBoxes,
  
  faPalletAlt,
  

  faBarsSort,
  

  faChessKnight,
  

  faFarm,
  
  faBarnSilo,
  

  faSquareT,
  

  faTvRetro,
  

  faScannerImage,
  

  faSnooze,
  
  faZzz,
  

  faBlockQuestion,
  

  faPlayPause,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

  faArrowUpAZ,
  
  faSortAlphaUp,
  

  faUserGroup,
  
  faUserFriends,
  

  faBooks,
  

  faStarExclamation,
  

  faArrowUpToArc,
  

  faWeightScale,
  
  faWeight,
  

  faHandBackPointUp,
  

  faFlowerDaffodil,
  

  faCalendarRange,
  

  faTableCellsLock,
  

  faFilePrescription,
  

  faXmarksLines,
  

  faWeightHanging,
  

  faCrown,
  

  faLeftLongToLine,
  

  faMicrochip,
  

  faTemperatureHigh,
  

  faTrashCanXmark,
  

  faFolderUser,
  

  faPeopleCarryBox,
  
  faPeopleCarry,
  

  faClockTenThirty,
  

  faCloudsMoon,
  

  faCircle8,
  

  faHeartPulse,
  
  faHeartbeat,
  

  faInboxIn,
  
  faInboxArrowDown,
  

  faThumbtackSlash,
  
  faThumbTackSlash,
  

  faPassport,
  

  faVenus,
  

  faCommentSmile,
  

  faSquareRight,
  
  faArrowAltSquareRight,
  

  faVideoPlus,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faFireHydrant,
  

  faFilePng,
  

  faApostrophe,
  

  faPersonBreastfeeding,
  

  faGaugeMax,
  
  faTachometerAltFastest,
  

  faBuildingWheat,
  

  faCircleE,
  

  faChartPieSimpleCircleCurrency,
  

  faLayerMinus,
  
  faLayerGroupMinus,
  

  faLightbulbExclamation,
  

  faMessageArrowUp,
  
  faCommentAltArrowUp,
  

  faPaperPlaneTop,
  
  faPaperPlaneAlt,
  
  faSend,
  

  faPersonSeatReclined,
  

  faHourglassClock,
  

  faBlenderPhone,
  

  faUserHairBuns,
  

  faHourglassStart,
  
  faHourglass1,
  

  faFamily,
  

  faShopLock,
  

  faIntersection,
  

  faVirusCovidSlash,
  

  faServer,
  

  faBadgeSheriff,
  

  faGridRound,
  

  faSlidersSimple,
  

  faWindTurbine,
  

  faShopSlash,
  
  faStoreAltSlash,
  

  faSquare6,
  

  faPersonSkiLift,
  
  faSkiLift,
  

  faNfcLock,
  

  faCannon,
  

  faFilesMedical,
  

  faPegasus,
  

  faArrowRightToBracket,
  
  faSignIn,
  

  faComputerMouse,
  
  faMouse,
  

  faCalendarStar,
  

  faPersonToPortal,
  
  faPortalEnter,
  

  faSlash,
  

  faLasso,
  

  faCircleQuarterStroke,
  

  faLocationXmark,
  
  faMapMarkerTimes,
  
  faMapMarkerXmark,
  

  faSpellCheck,
  

  faOctopus,
  

  faCoffinCross,
  

  faGoalNet,
  

  faXRay,
  

  faArrowDownFromBracket,
  

  faDiagramVenn,
  

  faFileLock,
  

  faEar,
  

  faPlaneCircleExclamation,
  

  faWindow,
  

  faFaceAstonished,
  

  faPipeSmoking,
  

  faFileInvoiceDollar,
  

  faScalpelLineDashed,
  
  faScalpelPath,
  

  faHandsBound,
  

  faClockThree,
  

  faSpider,
  

  faBracketCurlyRight,
  

  faFileDashedLine,
  
  faPageBreak,
  

  faArrowUpFromSquare,
  

  faBinBottlesRecycle,
  

  faGripLinesVertical,
  

  faMobileRetro,
  

  faPersonRunning,
  
  faRunning,
  

  faShuffle,
  
  faRandom,
  

  faPeanuts,
  

  faTransporter1,
  

  faArrowUpLeft,
  

  faSquarePhoneHangup,
  
  faPhoneSquareDown,
  

  faShieldSlash,
  

  faCircleU,
  

  faGaugeSimpleMax,
  
  faTachometerFastest,
  

  faPlaneTail,
  

  faShapes,
  
  faTriangleCircleSquare,
  

  faChargingStation,
  

  faMaximize,
  
  faExpandArrowsAlt,
  

  faLightbulbGear,
  

  faCactus,
  

  faSignalBarsGood,
  
  faSignalAlt3,
  

  faClockFourThirty,
  

  faArrowPointer,
  
  faMousePointer,
  

  faClockSevenThirty,
  

  faVenusMars,
  

  faBox,
  

  faPageCaretDown,
  
  faFileCaretDown,
  

  faCross,
  

  faRepeat,
  

  faDialMin,
  

  faStar,
  

  faDiamondExclamation,
  

  faSignalBars,
  
  faSignalAlt,
  
  faSignalAlt4,
  
  faSignalBarsStrong,
  

  faSprayCanSparkles,
  
  faAirFreshener,
  

  faCommentText,
  

  faSunDust,
  

  faCameraRotate,
  

  faUniformMartialArts,
  

  faFaceWeary,
  

  faEggFried,
  

  faCircleBookmark,
  
  faBookmarkCircle,
  

  faBellExclamation,
  

  faBan,
  
  faCancel,
  

  faScalpel,
  

  faPersonCircleMinus,
  

  faCircleThreeQuartersStroke,
  

  faHouseFlag,
  

  faChartArea,
  
  faAreaChart,
  

  faMoneyBillWave,
  

  faPizzaSlice,
  

  faTruckBolt,
  

  faSignPosts,
  

  faMailbox,
  

  faChartLineUp,
  

  faBuildingLock,
  

  faRectangleHistoryCircleUser,
  

  faPersonDressFairy,
  

  faTabletButton,
  

  faC,
  

  faLocationArrow,
  

  faMessagePlus,
  
  faCommentAltPlus,
  

  faFaceSmileTear,
  

  faRoadBridge,
  

  faCalendarPen,
  
  faCalendarEdit,
  

  faFolderImage,
  

  faPersonHalfDress,
  

  faFileChartColumn,
  
  faFileChartLine,
  

  faSynagogue,
  

  faGlobe,
  

  faPersonDolly,
  

  faLocationCrosshairsSlash,
  
  faLocationSlash,
  

  faSteak,
  

  faBullhorn,
  

  faBoxCheck,
  

  faTamale,
  

  faHatSanta,
  

  faArrowLeftToBracket,
  

  faKey,
  

  faWavePulse,
  
  faHeartRate,
  

  faHighlighter,
  

  faSquareCaretLeft,
  
  faCaretSquareLeft,
  

  faLightSwitch,
  

  faBuildingUser,
  

  faVanShuttle,
  
  faShuttleVan,
  

  faDumpster,
  

  faArrowDownToArc,
  

  faLightEmergency,
  

  faToiletPaperUnder,
  
  faToiletPaperReverse,
  

  faSchoolCircleCheck,
  

  faComma,
  

  faSensor,
  

  faUser,
  

  faRotateReverse,
  

  faBadgePercent,
  

  faBridgeCircleExclamation,
  

  faPenClip,
  
  faPenAlt,
  

  faH3,
  

  faBowlChopsticksNoodles,
  

  faPizza,
  

  faE,
  

  faLambda,
  

  faWandMagicSparkles,
  
  faMagicWandSparkles,
  

  faGauge,
  
  faDashboard,
  
  faGaugeMed,
  
  faTachometerAltAverage,
  

  faVial,
  

  faSquareBolt,
  

  faLeafOak,
  

  faMarsStroke,
  

  faCircleParking,
  
  faParkingCircle,
  

  faCrutches,
  

  faChartSimple,
  

  faBagSeedling,
  

  faPenCircle,
  

  faRadiation,
  

  faPlaneUpSlash,
  

  faMug,
  

  faMicrochipAi,
  

  faFileWaveform,
  
  faFileMedicalAlt,
  

  faCreditCardBlank,
  

  faFaceAnxiousSweat,
  

  faFolder,
  
  faFolderBlank,
  

  faObjectsAlignTop,
  

  faFileCad,
  

  faTrashPlus,
  

  faHeadSideGear,
  

  faArrowUpFromBracket,
  

  faHandPointDown,
  

  faRaccoon,
  

  faOption,
  

  faBacon,
  

  faTrashList,
  

  faMessageCaptions,
  
  faCommentAltCaptions,
  

  faSushi,
  
  faNigiri,
  

  faBullseye,
  

  faArrowLeftToLine,
  
  faArrowToLeft,
  

  faLocationSmile,
  
  faMapMarkerSmile,
  

  faHelmetUn,
  

  faUmbrellaBeach,
  

  faBrainArrowCurvedRight,
  
  faMindShare,
  

  fa6,
  

  faCreditCardFront,
  

  faBatteryLow,
  
  faBattery1,
  

  faAlignJustify,
  

  faFanTable,
  

  faBookmark,
  

  faSemicolon,
  

  faSquareExclamation,
  
  faExclamationSquare,
  

  faTrainSubwayTunnel,
  
  faSubwayTunnel,
  

  faSquareUp,
  
  faArrowAltSquareUp,
  

  faFaceHoldingBackTears,
  

  faBowlSoftServe,
  

  faBaguette,
  

  faBarcodeRead,
  

  faArrowUpBigSmall,
  
  faSortSizeUp,
  

  faMoneyBill,
  

  faHandPointUp,
  

  faSquareJ,
  

  faBagShoppingPlus,
  

  faSquareDashed,
  

  faFaceFrownOpen,
  
  faFrownOpen,
  

  faFileVector,
  

  faTally1,
  

  faPooStorm,
  
  faPooBolt,
  

  faCapsules,
  

  faDonut,
  
  faDoughnut,
  

  faDongSign,
  

  faTemperatureHalf,
  
  faTemperature2,
  
  faThermometer2,
  
  faThermometerHalf,
  

  faCommentImage,
  

  faEscalator,
  

  faCarWash,
  

  faNotesMedical,
  

  faSlotMachine,
  

  faWineGlassCrack,
  
  faFragile,
  

  faG,
  

  faWhistle,
  

  faLinkSimple,
  

  faMonitorWaveform,
  
  faMonitorHeartRate,
  

  faQ,
  

  faHorse,
  

  faDialMed,
  

  faAngleRight,
  

  faBellOn,
  

  faFilters,
  

  faMugMarshmallows,
  

  faHorseSaddle,
  

  faJoint,
  

  faBracketRound,
  
  faParenthesis,
  

  faIgloo,
  

  faSchool,
  

  faBriefcaseBlank,
  

  faChartCandlestick,
  

  faRoadBarrier,
  

  faMortarPestle,
  

  faShieldCheck,
  

  faUserAlien,
  

  faSnowman,
  

  faWheatAwnCircleExclamation,
  

  faGunSquirt,
  

  faPiano,
  

  faPepper,
  

  faTruckMedical,
  
  faAmbulance,
  

  faApartment,
  

  faTriangle,
  

  faFileMov,
  

  faHeadSideCoughSlash,
  

  faPear,
  

  faStaffSnake,
  
  faRodAsclepius,
  
  faRodSnake,
  
  faStaffAesculapius,
  

  faSpiderBlackWidow,
  

  faCircleD,
  

  faHammerWar,
  

  faBicycle,
  

  faBangladeshiTakaSign,
  

  faCalendars,
  

  faCircleArrowUpRight,
  

  faLeafyGreen,
  

  faSquid,
  

  faSparkles,
  

  faV,
  

  faObjectsAlignBottom,
  

  faBasketballHoop,
  

  faTooth,
  

  faFaceGrinWide,
  
  faGrinAlt,
  

  faPills,
  

  faArrowDownLeftAndArrowUpRightToCenter,
  

  faHryvniaSign,
  
  faHryvnia,
  

  faI,
  

  faUserHelmetSafety,
  
  faUserConstruction,
  
  faUserHardHat,
  

  faDialHigh,
  

  faGlassEmpty,
  

  faDroneFront,
  
  faDroneAlt,
  

  faStairs,
  

  faToiletPaperUnderSlash,
  
  faToiletPaperReverseSlash,
  

  faDrawSquare,
  

  faFilePlus,
  

  faStamp,
  

  faSaltShaker,
  

  faChartMixedUpCircleDollar,
  

  faICursor,
  

  faSquareArrowUpLeft,
  

  fa5,
  

  faLandMineOn,
  

  faTricycle,
  

  faFaceZany,
  

  faSquareRss,
  
  faRssSquare,
  

  faOctagonMinus,
  
  faMinusOctagon,
  

  faDiceFive,
  

  faRoadCircleCheck,
  

  faFaceRelieved,
  

  faEclipse,
  

  faAlarmClock,
  

  faEarDeaf,
  
  faDeaf,
  
  faDeafness,
  
  faHardOfHearing,
  

  faClockThreeThirty,
  

  faFaceGrinWink,
  
  faGrinWink,
  

  faHatWitch,
  

  faCoffeeBeans,
  

  faMessageSms,
  

  faChessBishop,
  

  faSealExclamation,
  

  faGrateDroplet,
  

  faVideoArrowUpRight,
  

  faAcorn,
  

  faFlute,
  

  faRaygun,
  

  faSkeletonRibs,
  

  faThoughtBubble,
  

  faUpToDottedLine,
  

  faFaceGrinTongue,
  
  faGrinTongue,
  

  faPeriod,
  

  faBridgeCircleXmark,
  

  faFaceKiss,
  
  faKiss,
  

  faWindowFrameOpen,
  

  faLightbulbCfl,
  

  faCommentArrowDown,
  

  faCameraWeb,
  
  faWebcam,
  

  faSquareM,
  

  faFaceScream,
  

  faArrowUpSquareTriangle,
  
  faSortShapesUpAlt,
  

  faFieldHockeyStickBall,
  
  faFieldHockey,
  

  faSquare2,
  

  faSaxophone,
  

  faStopwatch,
  

  faBlinds,
  

  faCommand,
  

  faPopsicle,
  

  faBookArrowUp,
  

  faCircleMicrophone,
  
  faMicrophoneCircle,
  

  faSpiderWeb,
  

  faHandSpock,
  

  faCircleCamera,
  
  faCameraCircle,
  

  faFacePersevering,
  

  faGaugeSimpleLow,
  
  faTachometerSlow,
  

  faFaceSaluting,
  

  faChevronUp,
  

  faSquareI,
  

  faCalendarCircleExclamation,
  

  faPlug,
  

  faHouseCircleXmark,
  

  faWorm,
  

  faFaceShush,
  

  faFlaskRoundPotion,
  
  faFlaskPotion,
  

  faPi,
  

  faOm,
  

  faArrowTurnLeftDown,
  

  faFolderBookmark,
  

  faTurnRight,
  

  faPrintMagnifyingGlass,
  
  faPrintSearch,
  

  faUtensilsSlash,
  

  faPersonBikingMountain,
  
  faBikingMountain,
  

  faHand,
  
  faHandPaper,
  

  faHeadSideBrain,
  

  faCucumber,
  

  faPoliceBox,
  

  faFlaskVial,
  

  faEyeSlash,
  

  faFacePleading,
  

  faUsers,
  

  faCircleF,
  

  faRight,
  
  faArrowAltRight,
  

  faPersonRays,
  

  faReplyClock,
  
  faReplyTime,
  

  faMitten,
  

  faArrowDownZA,
  
  faSortAlphaDesc,
  
  faSortAlphaDownAlt,
  

  faBagShopping,
  
  faShoppingBag,
  

  faHandHeart,
  

  faTruckContainerEmpty,
  

  faCalendarExclamation,
  

  faSink,
  

  faSunset,
  

  faMicroscope,
  

  faHourglassHalf,
  
  faHourglass2,
  

  faCircleCalendar,
  
  faCalendarCircle,
  

  faCircleW,
  

  faHeartCircleMinus,
  

  faWaveSine,
  

  faDisplayChartUpCircleDollar,
  

  faShareNodes,
  
  faShareAlt,
  

  faKnife,
  
  faUtensilKnife,
  

  faLightbulbOn,
  

  faMessageMiddleTop,
  
  faCommentMiddleTopAlt,
  

  faCarSide,
  

  faSquareSliders,
  
  faSlidersHSquare,
  

  faPenToSquare,
  
  faEdit,
  

  faSackDollar,
  

  faCrosshairsSimple,
  

  faBridgeLock,
  

  faFolderArrowUp,
  
  faFolderUpload,
  

  faSquareSmall,
  

  faBackpack,
  

  faArrowsCross,
  

  faTree,
  

  faCommentsQuestionCheck,
  

  faHouseFloodWater,
  

  faMapLocation,
  
  faMapMarked,
  

  faBlanket,
  

  faGlobePointer,
  

  faHotTubPerson,
  
  faHotTub,
  

  faHouseNight,
  

  faRectanglePro,
  
  faPro,
  

  faMonkey,
  

  faSignalBarsSlash,
  
  faSignalAltSlash,
  

  faGasPump,
  

  faArrowDownFromLine,
  
  faArrowFromTop,
  

  faLock,
  

  faPaintbrush,
  
  faPaintBrush,
  

  faSnowBlowing,
  

  faFutbol,
  
  faFutbolBall,
  
  faSoccerBall,
  

  faJug,
  

  faFolderPlus,
  

  faCampground,
  

  faClockNineThirty,
  

  faWatchFitness,
  

  faHouseMedicalCircleXmark,
  

  faUpToLine,
  
  faArrowAltToTop,
  

  faEgg,
  

  faFaceDizzy,
  
  faDizzy,
  

  faClipboardMedical,
  

  faCircleDot,
  
  faDotCircle,
  

  faBorderCenterV,
  

  faGamepad,
  

  faCartPlus,
  

  faUserBeardBolt,
  

  faSquarePhoneFlip,
  
  faPhoneSquareAlt,
  

  faTreePalm,
  

  faList,
  
  faListSquares,
  

  faFilmSimple,
  
  faFilmAlt,
  

  faAbacus,
  

  faHockeySticks,
  

  faFaceAnguished,
  

  faGhost,
  

  faHeading,
  
  faHeader,
  

  faTrainTunnel,
  

  faSquareParkingSlash,
  
  faParkingSlash,
  

  faPesetaSign,
  

  faSandwich,
  

  faBookOpenCover,
  
  faBookOpenAlt,
  

  faShredder,
  

  faSquareCheck,
  
  faCheckSquare,
  

  faLuchadorMask,
  
  faLuchador,
  
  faMaskLuchador,
  

  faCommentLines,
  

  faKeySkeletonLeftRight,
  

  faAsterisk,
  

  faHandsHoldingChild,
  

  faAnkh,
  

  faWheatAwn,
  
  faWheatAlt,
  

  faCompress,
  

  faCircleN,
  

  faAlbum,
  

  faCloudSunRain,
  

  faSwords,
  

  faCommentSlash,
  

  faBoxTaped,
  
  faBoxAlt,
  

  faXmarkToSlot,
  
  faTimesToSlot,
  
  faVoteNay,
  

  faVolumeLow,
  
  faVolumeDown,
  

  faFeather,
  

  faSquareCode,
  

  faDisplayChartUp,
  

  faChartScatter3d,
  

  faHanukiah,
  

  faFaceCowboyHat,
  

  faFlag,
  

  faArrowUpToLine,
  
  faArrowToTop,
  

  faSquirrel,
  

  faFireBurner,
  

  faRoadSpikes,
  

  faFaceSleeping,
  

  faMemory,
  

  faCircleDollarToSlot,
  
  faDonate,
  

  faSpaceStationMoonConstruction,
  
  faSpaceStationMoonAlt,
  

  faPipeSection,
  

  faSitemap,
  

  faHeadphonesSimple,
  
  faHeadphonesAlt,
  

  faCloudShowersHeavy,
  

  faTemperatureList,
  

  faUnlockKeyhole,
  
  faUnlockAlt,
  

  faSidebarFlip,
  

  faCircleChevronDown,
  
  faChevronCircleDown,
  

  faFaceFrownSlight,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faSchoolCircleXmark,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBlock,
  

  faTrashCanList,
  

  faCommentMiddle,
  

  faCaretLeft,
  

  faLightbulb,
  

  faPeopleRobbery,
  

  faSquareTerminal,
  

  faCassetteTape,
  

  faShieldCross,
  

  fa8,
  

  faRulerHorizontal,
  

  faCoconut,
  

  faFilm,
  

  faSickle,
  

  faRadar,
  

  faPhotoFilmMusic,
  

  faRollerCoaster,
  

  faCorn,
  

  faFaceKissBeam,
  
  faKissBeam,
  

  faSquareUpRight,
  
  faExternalLinkSquareAlt,
  

  faDropletPercent,
  
  faHumidity,
  

  faFaceBeamHandOverMouth,
  

  faHeartCrack,
  
  faHeartBroken,
  

  faHourglassEnd,
  
  faHourglass3,
  

  faPeopleGroup,
  

  faKeyboardLeft,
  

  faBars,
  
  faNavicon,
  

  faPrescriptionBottle,
  

  faSwatchbook,
  

  faRectangleVerticalHistory,
  

  faGrillFire,
  

  faJoystick,
  

  faLaptopCode,
  

  faTruckUtensils,
  

  faFileCircleQuestion,
  

  faHeartHalfStroke,
  
  faHeartHalfAlt,
  

  faSquareCaretDown,
  
  faCaretSquareDown,
  

  faCompass,
  

  faBird,
  

  faHelicopter,
  

  faSquareMinus,
  
  faMinusSquare,
  

  faHouseFire,
  

  faEmptySet,
  

  faStarAndCrescent,
  

  faReply,
  
  faMailReply,
  

  faMeat,
  

  faClover,
  

  faUsersSlash,
  

  faStarSharpHalf,
  

  faPickleball,
  

  faFaceMask,
  

  faTachographDigital,
  
  faDigitalTachograph,
  

  faMagnifyingGlassArrowRight,
  

  faSensorTriangleExclamation,
  
  faSensorAlert,
  

  faUsersMedical,
  

  faMessageImage,
  
  faCommentAltImage,
  

  faUserChef,
  

  faTable,
  

  faHyphen,
  

  faMustache,
  

  faHockeyPuck,
  

  faToiletsPortable,
  

  faSunPlantWilt,
  

  faListMusic,
  

  faScissors,
  
  faCut,
  

  faSquareCaretRight,
  
  faCaretSquareRight,
  

  faTombstone,
  

  faMarsAndVenusBurst,
  

  faFaceAngryHorns,
  

  faSignPost,
  

  faPeopleArrows,
  
  faPeopleArrowsLeftRight,
  

  faAlbumCollectionCirclePlus,
  

  faSquareRoot,
  

  faChessRookPiece,
  
  faChessRookAlt,
  

  faArrowProgress,
  

  faFileMp3,
  

  faPenRuler,
  
  faPencilRuler,
  

  faBellConcierge,
  
  faConciergeBell,
  

  faMessagePen,
  
  faCommentAltEdit,
  
  faMessageEdit,
  

  faBadge,
  

  faSunglasses,
  

  faTireFlat,
  

  faTreeChristmas,
  

  faMotorcycle,
  

  faChartBullet,
  

  faStarChristmas,
  

  faCircleC,
  

  faBoxTissue,
  

  faMicrophoneSlash,
  

  faBinoculars,
  

  faTruckRamp,
  

  faMusicSlash,
  

  faTableCellsUnlock,
  

  faTrillium,
  

  faBrowsers,
  

  faSprinklerCeiling,
  

  faGavel,
  
  faLegal,
  

  faReflectBoth,
  

  faTrashClock,
  

  faCartCircleArrowUp,
  

  faTentArrowLeftRight,
  

  faChfSign,
  

  faMicrowave,
  

  faHospitalUser,
  

  faFaceFlushed,
  
  faFlushed,
  

  faSquare3,
  

  faTrowelBricks,
  

  faCloud,
  

  faMessageQuestion,
  

  faPaw,
  

  faTabletScreenButton,
  
  faTabletAlt,
  

  faCircleNotch,
  

  faRainbow,
  

  faEarthAfrica,
  
  faGlobeAfrica,
  

  faElephant,
  

  faSquareB,
  

  faCodePullRequestDraft,
  

  faW,
  

  faGiftCard,
  

  faTruckMonster,
  

  faScarecrow,
  

  faAlarmSnooze,
  

  faSprayCan,
  

  faShishKebab,
  

  faFaceGrinTongueSquint,
  
  faGrinTongueSquint,
  

  faArrowDown91,
  
  faSortNumericDesc,
  
  faSortNumericDownAlt,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faCalendarImage,
  

  faCircleM,
  

  faDialMax,
  

  faPersonDrowning,
  

  faGrapes,
  

  faBoxArchive,
  
  faArchive,
  

  faFaceSmileHorns,
  

  faToggleOff,
  

  faDialOff,
  

  faFaceAwesome,
  
  faGaveDandy,
  

  faSquareV,
  

  faDrumstick,
  

  faBroomBall,
  
  faQuidditch,
  
  faQuidditchBroomBall,
  

  faUp,
  
  faArrowAltUp,
  

  faFence,
  

  faBlindsOpen,
  

  faWebhook,
  

  faScrollTorah,
  
  faTorah,
  

  faDownRight,
  

  faPersonArrowUpFromLine,
  

  faBowlingPins,
  

  faPencilSlash,
  

  faUserNinja,
  

  fa7,
  

  faBlog,
  

  faCircle9,
  

  faSheetPlastic,
  

  faFaceUnamused,
  

  faMessageArrowDown,
  
  faCommentAltArrowDown,
  

  faGolfFlagHole,
  

  faBookBlank,
  
  faBookAlt,
  

  faVialVirus,
  

  faCloudXmark,
  

  faUserCheck,
  

  faArrowDownToSquare,
  

  faNote,
  

  faTruckRampBox,
  
  faTruckLoading,
  

  faBlueberries,
  

  faPenField,
  

  faClipboardList,
  

  faPumpkin,
  

  faCodePullRequest,
  

  faDesktopArrowDown,
  

  faPaste,
  
  faFileClipboard,
  

  faComments,
  

  faCaretRight,
  

  faBackward,
  

  faPencil,
  
  faPencilAlt,
  

  faLips,
  

  faLandmarkFlag,
  

  faRam,
  

  faExcavator,
  

  faEggplant,
  

  faFolderGrid,
  

  faGaugeMin,
  
  faTachometerAltSlowest,
  

  faDiagramPrevious,
  

  faK,
  

  faPage,
  

  faStrikethrough,
  

  faTrees,
  

  faHandLove,
  

  faFootballHelmet,
  

  faGrid,
  
  faGrid3,
  

  faPanFrying,
  

  faAddressBook,
  
  faContactBook,
  

  faCartMinus,
  

  faPager,
  

  faMerge,
  

  faCircleH,
  
  faHospitalSymbol,
  

  faHexagonXmark,
  
  faTimesHexagon,
  
  faXmarkHexagon,
  

  faCartXmark,
  

  faBowArrow,
  

  faFileCircleExclamation,
  

  faEnvelopesBulk,
  
  faMailBulk,
  

  faJarWheat,
  

  faSpoon,
  
  faUtensilSpoon,
  

  faCheeseSwiss,
  

  faHouseBuilding,
  

  faLeafHeart,
  

  faArrowsRotateReverse,
  

  faArrowDownUpAcrossLine,
  

  faSpaghettiMonsterFlying,
  
  faPastafarianism,
  

  faTruckFlatbed,
  

  faClarinet,
  

  faBong,
  

  faCameraMovie,
  

  faSigma,
  

  faFaceGrinStars,
  
  faGrinStars,
  

  faSquareP,
  

  faBringForward,
  

  faRecordVinyl,
  

  faTruckPlane,
  

  faCircleHeart,
  
  faHeartCircle,
  

  faChevronsLeft,
  
  faChevronDoubleLeft,
  

  faUnion,
  

  faMenorah,
  

  faFileCsv,
  

  faLaptop,
  

  faPerson,
  
  faMale,
  

  faFireFlameSimple,
  
  faBurn,
  

  faPersonCarryBox,
  
  faPersonCarry,
  

  faArrowUpLong,
  
  faLongArrowUp,
  

  faCalendarCircleUser,
  

  faTransporter,
  

  faDiagramPredecessor,
  

  faCrateEmpty,
  

  faBeerMugEmpty,
  
  faBeer,
  

  faPeopleLine,
  

  faLightbulbExclamationOn,
  

  faLocationPlus,
  
  faMapMarkerPlus,
  

  faSquareArrowRight,
  
  faArrowSquareRight,
  

  faPeopleRoof,
  

  faUsersRectangle,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faCrop,
  

  faSchoolCircleExclamation,
  

  faUserVneck,
  

  faFootball,
  
  faFootballBall,
  

  faChevronsUp,
  
  faChevronDoubleUp,
  

  faFlagCheckered,
  

  faUtilityPoleDouble,
  

  faBuildingMemo,
  

  faSquareX,
  

  faBowlScoop,
  
  faBowlShavedIce,
  

  faMessageExclamation,
  
  faCommentAltExclamation,
  

  faLightCeiling,
  

  faFaceSmileBeam,
  
  faSmileBeam,
  

  faForwardStep,
  
  faStepForward,
  

  faMessageBot,
  

  faMagnifyingGlassLocation,
  
  faSearchLocation,
  

  faHandPointRight,
  

  faH1,
  

  faStandardDefinition,
  
  faRectangleSd,
  

  faSkiBoot,
  

  faFingerprint,
  

  faPumpMedical,
  

  faLocationMinus,
  
  faMapMarkerMinus,
  

  faSlidersUp,
  
  faSlidersV,
  

  faBridgeCircleCheck,
  

  faCalculatorSimple,
  
  faCalculatorAlt,
  

  faClosedCaptioningSlash,
  

  faMicrophoneLinesSlash,
  
  faMicrophoneAltSlash,
  

  faIcons,
  
  faHeartMusicCameraBolt,
  

  faSoap,
  

  faAtom,
  

  faNfc,
  

  faFaceGlasses,
  

  faRightFromBracket,
  
  faSignOutAlt,
  

  faFilms,
  

  faDoorOpen,
  

  faShovel,
  

  faFaceIcicles,
  

  faCircleMinus,
  
  faMinusCircle,
  

  faFolderArrowDown,
  
  faFolderDownload,
  

  faSortDown,
  
  faSortDesc,
  

  faBarcodeScan,
  

  faMobileSignal,
  

  faArrowsUpToLine,
  

  faFork,
  
  faUtensilFork,
  

  faUfo,
  

  faTextSize,
  

  faSunHaze,
  

  faVolleyball,
  
  faVolleyballBall,
  

  faBuildingCircleArrowRight,
  

  faRectangleHistory,
  

  faTally4,
  

  faAnchorCircleCheck,
  

  faMp3Player,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faWifiFair,
  
  faWifi2,
  

  faTirePressureWarning,
  

  faDiceThree,
  

  faBuildingUn,
  

  faRing,
  

  faWaveSquare,
  

  faFileLines,
  
  faFileAlt,
  
  faFileText,
  

  faExplosion,
  

  faDownLeftAndUpRightToCenter,
  
  faCompressAlt,
  

  faSquareUser,
  

  faFaceHandPeeking,
  

  faTheta,
  

  faFonduePot,
  

  faRingDiamond,
  

  faRobotAstromech,
  

  faInfo,
  

  faSalad,
  
  faBowlSalad,
  

  faMessage,
  
  faCommentAlt,
  

  faCoffin,
  

  faStethoscope,
  

  faGaugeSimpleMin,
  
  faTachometerSlowest,
  

  faFaceHandYawn,
  

  faUserXmark,
  
  faUserTimes,
  

  faTextHeight,
  

  faHeadSideGoggles,
  
  faHeadVr,
  

  faCircleL,
  

  faTrashCan,
  
  faTrashAlt,
  

  faPhoneArrowUpRight,
  
  faPhoneArrowUp,
  
  faPhoneOutgoing,
  

  faRectanglesMixed,
  

  faAt,
  

  faTransporter7,
  

  faBagel,
  

  faLineHeight,
  

  faWagonCovered,
  

  faCircleChevronRight,
  
  faChevronCircleRight,
  

  faArrowsToCircle,
  

  faFillDrip,
  

};
